webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1664), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(681);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

exports.formatTime = formatTime;
exports.formatDecimal = formatDecimal;
exports.negativeCurrencyFormatter = negativeCurrencyFormatter;
exports.currencyFormatter = currencyFormatter;
exports.currencyFormatterWithoutFloat = currencyFormatterWithoutFloat;
exports.rupiahWithNegative = rupiahWithNegative;
exports.percentWithNegative = percentWithNegative;
exports.rupiahWithNegativeNumber = rupiahWithNegativeNumber;
exports.rupiahWithNegativeWithoutBracket = rupiahWithNegativeWithoutBracket;
exports.rupiah = rupiah;
exports.invoiceReceiptDateTime = invoiceReceiptDateTime;
exports.dateFormatter = dateFormatter;
exports.limitTo = limitTo;
exports.phoneNumberFormatter = phoneNumberFormatter;

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = {
  currencyFormatter: function currencyFormatter(_data) {
    if (isNaN(_data)) return 'Rp. 0';

    var currency = 'Rp. ';
    var result = '';
    var data = _data || 0;
    if (data < 0) {
      data *= -1;
      result = '(' + currency + data.toString() + ')';
    } else {
      result = currency + data.toString();
    }
    return result.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  },
  formatTime: function formatTime(date) {
    var newDate = new Date(date);
    var dateHours = ('00' + newDate.getHours()).slice(-2);
    var dateMinutes = ('00' + newDate.getMinutes()).slice(-2);
    return dateHours + ':' + dateMinutes;
  },
  rupiah: function rupiah(text) {
    if (!text) {
      text = 0;
    }
    text = text.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
    var t = 'Rp. ' + text + '';
    return t;
  },
  formatDecimal: function formatDecimal(data) {
    return data.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  },
  invoiceDateTimeFormatter: function invoiceDateTimeFormatter(datetime, string) {
    if (string === 'date') {
      return (0, _moment2.default)(datetime).format('DD MMM YYYY');
    } else if (string === 'time') {
      return (0, _moment2.default)(datetime).format('HH:mm');
    } else if (string === 'datetime') {
      return (0, _moment2.default)(datetime).format('DD MMM YYYY HH:mm');
    }
  }
};

function formatTime(text) {
  return util.formatTime(text);
}

function formatDecimal(text) {
  return util.formatDecimal(text);
}

function negativeCurrencyFormatter(text) {
  var resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0) * -1);
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0';
  }

  return resultPrice;
}

function currencyFormatter(text) {
  var resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0));
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0';
  }

  return resultPrice;
}

function currencyFormatterWithoutFloat(text) {
  var resultPrice = void 0;
  if (text) {
    resultPrice = util.currencyFormatter(parseFloat(text).toFixed(0));
    if (resultPrice === 'Rp. -0') {
      resultPrice = 'Rp. 0';
    }
  } else {
    resultPrice = text;
  }
  return resultPrice;
}

function rupiahWithNegative(text) {
  if (!text && text !== 0) return '';
  var resultPrice = parseFloat(text).toFixed(0);
  var absPrice = Math.abs(resultPrice);
  if (resultPrice < 0) {
    return '(' + rupiah(absPrice) + ')';
  } else {
    return rupiah(absPrice);
  }
}

function percentWithNegative(text) {
  if (!text && text !== 0) return '';
  var resultPrice = parseFloat(text).toFixed(0);
  var absPrice = Math.abs(resultPrice);
  if (resultPrice < 0) {
    return '(' + absPrice + '%)';
  } else {
    return absPrice + '%';
  }
}

function rupiahWithNegativeNumber(text) {
  if (!text && text !== 0) return '';
  var resultPrice = parseFloat(text).toFixed(0);
  var absPrice = Math.abs(resultPrice);
  return '(' + rupiah(absPrice) + ')';
}

function rupiahWithNegativeWithoutBracket(text) {
  if (!text && text !== 0) return '';
  var resultPrice = parseFloat(text);
  var absPrice = Math.abs(resultPrice);
  if (resultPrice < 0) {
    return '(' + rupiah(absPrice) + ')';
  } else {
    return rupiah(absPrice);
  }
}

function rupiah(text) {
  if (!text && text !== 0) return '';
  var resultPrice = util.rupiah(parseFloat(text).toFixed(0));
  if (resultPrice === 'Rp. -0') {
    resultPrice = 'Rp. 0';
  }
  return resultPrice;
}

function invoiceReceiptDateTime(datetime, string) {
  return util.invoiceDateTimeFormatter(datetime, string);
}

function dateFormatter(datetime) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

  return (0, _moment2.default)(datetime).format(format);
}

function limitTo(foo, limit) {
  if (typeof foo === 'string') {
    return foo.substr(0, limit);
  } else if (Array.isArray(foo)) {
    return foo.slice(0, limit);
  } else {
    throw new Error('first parameter of \'limitTo\' must be string or array, instead get ' + (0, _stringify2.default)(foo));
  }
}

function phoneNumberFormatter(phone) {
  var phoneNumber = phone.replace(/-/g, '');
  var phoneNumberFormatted = void 0;
  if (phoneNumber.match(/^62/)) {
    phoneNumberFormatted = phoneNumber.replace(/^62/, '');
  } else if (phoneNumber.match(/^0/)) {
    phoneNumberFormatted = phoneNumber.replace(/^0/, '');
  }
  return phoneNumberFormatted;
}

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showProgressBar = showProgressBar;
exports.showLoadingSpinner = showLoadingSpinner;
exports.hideProgressBar = hideProgressBar;
exports.changeForm = changeForm;
exports.showModalOutletMobile = showModalOutletMobile;
exports.changeFormRegister = changeFormRegister;
exports.changeFormForgot = changeFormForgot;
exports.changeFormBusiness = changeFormBusiness;
exports.setAuthState = setAuthState;
exports.sendingRequest = sendingRequest;
exports.loginRequest = loginRequest;
exports.logout = logout;
exports.resendVerificationEmail = resendVerificationEmail;
exports.registerRequest = registerRequest;
exports.requestError = requestError;
exports.forgotPassword = forgotPassword;
exports.businessTypes = businessTypes;
exports.changeBusinessTypesData = changeBusinessTypesData;
exports.businessCategories = businessCategories;
exports.changeBusinessCategoriesData = changeBusinessCategoriesData;
exports.registerBusinessRequest = registerBusinessRequest;
exports.clearError = clearError;
exports.setAuthFromLocal = setAuthFromLocal;
exports.setAuthFromApi = setAuthFromApi;
exports.getFilteredDate = getFilteredDate;
exports.redirectTo = redirectTo;
exports.loadResetPassword = loadResetPassword;
exports.changeFormResetPassword = changeFormResetPassword;
exports.resetPassword = resetPassword;
exports.loadPrepareEncryption = loadPrepareEncryption;
exports.setPrepareEncryption = setPrepareEncryption;
exports.getProfileRequest = getProfileRequest;
exports.setProfile = setProfile;
exports.clearRegisterForm = clearRegisterForm;
exports.setIsRegistered = setIsRegistered;
exports.setResendEmailVerificationState = setResendEmailVerificationState;
exports.toLoginPage = toLoginPage;
exports.toSignUpPage = toSignUpPage;

var _constants = __webpack_require__(91);

/**
 * Show the progress bar
 * @returns {{type, payload: {}}}
 */
function showProgressBar() {
  return { type: _constants.SHOW_PROGRESS_BAR };
} /*
   * Actions describe changes of state in your application
   */

// We import constants to name our actions' type
function showLoadingSpinner(showLoadingSpinner) {
  return { type: _constants.SHOW_LOADING_SPINNER, payload: { showLoadingSpinner: showLoadingSpinner } };
}

function hideProgressBar() {
  return { type: _constants.HIDE_PROGRESS_BAR };
}

/**
 * Sets the form state
 * @param  {object} newFormState          The new state of the form
 * @param  {string} newFormState.email   The new text of the email input field of the form
 * @param  {string} newFormState.password The new text of the password input field of the form
 */
function changeForm(newFormState) {
  return { type: _constants.CHANGE_FORM, payload: { newFormState: newFormState } };
}
function showModalOutletMobile(value) {
  return { type: _constants.DASHBOARD_SHOW_MODAL_OUTLET_MOBILE, payload: { showModalOutletMobile: value } };
}
/**
 * Sets the form state
 * @param  {object} newFormRegState          The new state of the form
 * @param  {string} newFormRegState.email The new text of the email input field of the form
 * @param  {string} newFormRegState.password The new text of the password input field of the form
 * @param  {string} newFormRegState.confpassword The new text of the confirm password input field of the form
 */
function changeFormRegister(newFormRegState) {
  return { type: _constants.CHANGE_FORM_REGISTER, payload: { newFormRegState: newFormRegState } };
}

/**
 * Sets the form forgot state
 * @param  {object} newForgotState          The new state of the form
 * @param  {string} newForgotState.email The new text of the email input field of the form
 */
function changeFormForgot(newForgotState) {
  return { type: _constants.CHANGE_FORM_FORGOT, payload: { newForgotState: newForgotState } };
}

/**
 * Sets the form forgot state
 * @param  {object} newBusinessState          The new state of the form
 * @param  {string} newBusinessState.types The new text of the email input field of the form
 */
function changeFormBusiness(newBusinessState) {
  return { type: _constants.CHANGE_FORM_BUSINESS, payload: { newBusinessState: newBusinessState } };
}

/**
 * Sets the authentication state of the application
 * @param  {boolean} newAuthState True means a user is logged in, false means no user is logged in
 * @param  {object} user object. null if auth fails.
 */
function setAuthState(newAuthState, user) {
  return { type: _constants.SET_AUTH, payload: { newAuthState: newAuthState, user: user } };
}

/**
 * Sets the `currentlySending` state, which displays a loading indicator during requests
 * @param  {boolean} sending True means we're sending a request, false means we're not
 */
function sendingRequest(sending) {
  return { type: _constants.SENDING_REQUEST, payload: { sending: sending } };
}

/**
 * Tells the app we want to log in a user
 * @param  {object} data          The data we're sending for log in
 * @param next
 * @param  {string} data.email The username of the user to log in
 * @param  {string} data.password The password of the user to log in
 */
function loginRequest(data) {
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return { type: _constants.LOGIN_REQUEST, payload: { data: data, next: next } };
}

/**
 * Tells the app we want to log out a user
 */
function logout() {
  return { type: _constants.LOGOUT };
}

function resendVerificationEmail(email) {
  return { type: _constants.RESEND_VERIFICATION_EMAIL, payload: { email: email } };
}

/**
 * Tells the app we want to register a user
 * @param  {object} data          The data we're sending for registration
 * @param  {string} data.username The username of the user to register
 * @param  {string} data.password The password of the user to register
 * @param  {string} data.confpassword The confirm password of the user to register
 */
function registerRequest(data) {
  return { type: _constants.REGISTER_REQUEST, payload: { data: data } };
}

/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
function requestError(error) {
  return { type: _constants.REQUEST_ERROR, payload: { error: error } };
}

function forgotPassword(data) {
  return { type: _constants.FORGOT_PASSWORD, payload: { data: data } };
}

function businessTypes() {
  return { type: _constants.BUSINESS_TYPES_REQUEST };
}

function changeBusinessTypesData(newBusinessTypes) {
  return { type: _constants.CHANGE_BUSINESS_TYPES_DATA, payload: { newBusinessTypes: newBusinessTypes } };
}

function businessCategories(data) {
  return { type: _constants.BUSINESS_CATEGORIES_REQUEST, payload: { data: data } };
}

function changeBusinessCategoriesData(newBusinessCategories) {
  return { type: _constants.CHANGE_BUSINESS_CATEGORIES_DATA, payload: { newBusinessCategories: newBusinessCategories } };
}

function registerBusinessRequest(data) {
  return { type: _constants.REGISTER_BUSINESS_REQUEST, payload: { data: data } };
}

/**
 * Sets the `error` state as empty
 */
function clearError() {
  return { type: _constants.CLEAR_ERROR };
}

function setAuthFromLocal() {
  return { type: _constants.SET_AUTH_FROM_LOCAL };
}

function setAuthFromApi(data) {
  return { type: _constants.SET_AUTH_FROM_API, payload: { data: data } };
}

function getFilteredDate(data) {
  return { type: _constants.GET_FILTERED_DATE, payload: { filteredDate: data } };
}

function redirectTo(data) {
  return { type: _constants.REDIRECT_TO, payload: { url: data } };
}

function loadResetPassword(data) {
  return { type: _constants.LOAD_RESET_PASSWORD, payload: { token: data } };
}

function changeFormResetPassword(data) {
  return { type: _constants.CHANGE_FORM_RESET_PASSWORD, payload: { resetPasswordState: data } };
}

function resetPassword(data, token, key) {
  return { type: _constants.SEND_RESET_PASSWORD, payload: { data: data, access_token: token } };
}

function loadPrepareEncryption() {
  return { type: _constants.LOAD_PREPARE_ENCRYPTION };
}

function setPrepareEncryption(data) {
  return { type: _constants.SET_PREPARE_ENCRYPTION, payload: { encryption: { public_modulus: data.responseData.public_modulus, public_exponent: data.responseData.public_exponent, key: data.responseData.public_exponent } } };
}

function getProfileRequest(query) {
  return { type: _constants.GET_PROFILE_REQUEST, payload: { query: query } };
}

function setProfile(profile) {
  return { type: _constants.SET_PROFILE, payload: { profile: profile } };
}

function clearRegisterForm() {
  return { type: _constants.CLEAR_REGISTER_FORM };
}

function setIsRegistered(isRegistered) {
  return { type: _constants.SET_IS_REGISTERED, payload: { isRegistered: isRegistered } };
}

function setResendEmailVerificationState(data) {
  return { type: _constants.SET_RESEND_VERIFICATION_EMAIL_STATE, payload: { resendVerificationEmail: { isModalShow: data.isModalShow, headerMessage: data.headerMessage, bodyMessage: data.bodyMessage, modalStatus: data.modalStatus } } };
}

function toLoginPage() {
  return { type: _constants.TO_LOGIN_PAGE };
}

function toSignUpPage() {
  return { type: _constants.TO_SIGNUP_PAGE };
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1668), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2830);


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.error = error;
exports.success = success;
exports.warning = warning;
exports.reset = reset;
exports.onClickNotif = onClickNotif;

var _constants = __webpack_require__(411);

/**
 * Create notification error
 * @param {string} message
 * @returns {{type: *, payload: {error: *}}}
 */
function error(message) {
  return { type: _constants.NOTIFICATION_ERROR, payload: { message: message } };
}

/**
 * Create notification success action
 * @param {string} message
 * @returns {{type, payload: {message: *}}}
 */
function success(message) {
  return { type: _constants.NOTIFICATION_SUCCESS, payload: { message: message } };
}

/**
 * Create notification warning action
 * @param {string} message
 * @returns {{type, payload: {message: *}}}
 */
function warning(message) {
  return { type: _constants.NOTIFICATION_WARNING, payload: { message: message } };
}

/**
 * Clear all notification
 * @returns {{type: *}}
 */
function reset() {
  return { type: _constants.NOTIFICATION_RESET };
}

function onClickNotif(notificationClicked) {
  return { type: _constants.NOTIFICATION_CLICKED, payload: { notificationClicked: notificationClicked } };
}

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1659), __esModule: true };

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showConfirmActionModal = showConfirmActionModal;
exports.hideConfirmActionModal = hideConfirmActionModal;
exports.confirmAction = confirmAction;
exports.askConfirmAction = askConfirmAction;
exports.cancelAction = cancelAction;
exports.setNextAction = setNextAction;

var _constants = __webpack_require__(384);

/****************************************************************************************************
 * Action Confirmation
 ****************************************************************************************************/

function showConfirmActionModal() {
  return { type: _constants.CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL, payload: {} };
}

function hideConfirmActionModal() {
  return { type: _constants.CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL, payload: {} };
}

function confirmAction(nextAction) {
  return { type: _constants.CONFIRM_ACTION_CONFIRM_ACTION, payload: { nextAction: nextAction } };
}

function askConfirmAction(nextAction) {
  return { type: _constants.CONFIRM_ACTION_ASK_CONFIRM_ACTION, payload: { nextAction: nextAction } };
}

function cancelAction() {
  return { type: _constants.CONFIRM_ACTION_CANCEL_ACTION, payload: {} };
}

function setNextAction(nextAction) {
  return { type: _constants.CONFIRM_ACTION_SET_NEXT_ACTION, payload: { nextAction: nextAction } };
}

/****************************************************************************************************
 * End Action Confirmation
 ****************************************************************************************************/

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CASH_DRAWER_SHIFT_DETAILS = CASH_DRAWER_SHIFT_DETAILS;
exports.REPORT_TRANSACTION_DETAIL = REPORT_TRANSACTION_DETAIL;
exports.RECEIPT_INVOICES_URL = RECEIPT_INVOICES_URL;
exports.RESEND_EMAIL_URL = RESEND_EMAIL_URL;
exports.PRINT_RECEIPT_INVOICE_PDF = PRINT_RECEIPT_INVOICE_PDF;
exports.SETTING_PUBLIC_PROFILE = SETTING_PUBLIC_PROFILE;
exports.FEEDBACK_MESSAGES = FEEDBACK_MESSAGES;
var BACKEND_HOST = "https://experiment-taxitem.mokapos.com";
var BACKEND_PORT = "443";
var MOKA_SERVICE_HOST = "https://service-dev.mokapos.com";
var HOST = BACKEND_HOST + ':' + BACKEND_PORT;

var HOST_URL = exports.HOST_URL = '' + HOST;
var API_URL = exports.API_URL = HOST + '/api';
var MOKA_SERVICE_URL = exports.MOKA_SERVICE_URL = '' + MOKA_SERVICE_HOST;
var LOGIN_URL = exports.LOGIN_URL = API_URL + '/v2/login';
var LOGOUT_URL = exports.LOGOUT_URL = API_URL + '/v2/logout';
var REGISTER_URL = exports.REGISTER_URL = HOST + '/validate_email?email=';
var FORGOT_PASSWORD_URL = exports.FORGOT_PASSWORD_URL = API_URL + '/v1/users/forgot_password';
var BUSINESS_TYPES = exports.BUSINESS_TYPES = HOST + '/business_types';
var RESEND_VERIFICATION_EMAIL_URL = exports.RESEND_VERIFICATION_EMAIL_URL = HOST + '/resend_verification_email';
var BUSINESS_CATEGORIES = exports.BUSINESS_CATEGORIES = HOST + '/business_categories?business_type_id=$id';
var BUSINESS_TYPES_URL = exports.BUSINESS_TYPES_URL = HOST + '/business_types';
var BUSINESS_CATEGORIES_URL = exports.BUSINESS_CATEGORIES_URL = HOST + '/business_categories';
var REGISTER_BUSINESS_URL = exports.REGISTER_BUSINESS_URL = HOST + '/create_user';
var UPDATE_SELECTED_OUTLET = exports.UPDATE_SELECTED_OUTLET = API_URL + '/v2/login/outlets';
var GET_PROFILE = exports.GET_PROFILE = API_URL + '/v1/profile';
var GET_DASHBOARD = exports.GET_DASHBOARD = API_URL + '/v1/dashboard';
var REFERRAL_URL = exports.REFERRAL_URL = HOST + '/referral';
var SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_STATUS = API_URL + '/v1/feature/get_subscription_status';

/**
 * Category endpoints
 */
var LIST_CATEGORY_URL = exports.LIST_CATEGORY_URL = API_URL + '/v1/categories';
var LIST_CATEGORY_WITH_UNCATEGORIZED_URL = exports.LIST_CATEGORY_WITH_UNCATEGORIZED_URL = API_URL + '/v1/categories/with_uncategorized';

/**
 * Sales endpoints
 */
var SALES_SUMMARY_URL = exports.SALES_SUMMARY_URL = API_URL + '/v1/reports/sales_summary';
var GROSS_PROFIT_URL = exports.GROSS_PROFIT_URL = API_URL + '/v1/reports/gross_profit';
var PAYMENT_METHODS_URL = exports.PAYMENT_METHODS_URL = API_URL + '/v1/reports/payment_methods';
var ITEM_SALES_URL = exports.ITEM_SALES_URL = API_URL + '/v2/reports/item_sales';
var CATEGORY_SALES_URL = exports.CATEGORY_SALES_URL = API_URL + '/v1/reports/category_sales';
var MODIFIER_SALES_URL = exports.MODIFIER_SALES_URL = API_URL + '/v1/reports/modifiers';
var DISCOUNTS_URL = exports.DISCOUNTS_URL = MOKA_SERVICE_URL + '/report/v1/discounts';
var TAXES_URL = exports.TAXES_URL = API_URL + '/v1/reports/taxes';
var GRATUITY_URL = exports.GRATUITY_URL = API_URL + '/v1/reports/gratuities';
var COLLECTEDBY_URL = exports.COLLECTEDBY_URL = API_URL + '/v1/reports/staff_report';
var SERVEDBY_URL = exports.SERVEDBY_URL = API_URL + '/v1/reports/servers';

/****
 * Cash drawer - shifts endpoints
 */
var CASH_DRAWER_SHIFT_SUMMARY = exports.CASH_DRAWER_SHIFT_SUMMARY = API_URL + '/v1/cash_drawer/shifts/summary';
var CASH_DRAWER_LIST_SHIFT = exports.CASH_DRAWER_LIST_SHIFT = API_URL + '/v1/cash_drawer/shifts';
var CASH_DRAWER_EXPORT_SHIFT = exports.CASH_DRAWER_EXPORT_SHIFT = API_URL + '/v1/cash_drawer/shifts/export';

/**
 * @return {string}
 */
function CASH_DRAWER_SHIFT_DETAILS(shiftId) {
  return API_URL + '/v1/cash_drawer/shifts/' + shiftId;
}
var UPDATE_FILTERED_DATE = exports.UPDATE_FILTERED_DATE = API_URL + '/v1/update_filtered_date';
var GET_FILTERED_DATE = exports.GET_FILTERED_DATE = API_URL + '/v1/get_filtered_date';
var GET_RESET_PASSWORD_URL = exports.GET_RESET_PASSWORD_URL = API_URL + '/v1/users/reset_password';
var RESET_PASSWORD_URL = exports.RESET_PASSWORD_URL = API_URL + '/v1/users/update_password';
var LOAD_PREPARE_ENCRYPTION_URL = exports.LOAD_PREPARE_ENCRYPTION_URL = API_URL + '/v1/users/prepare_encryption';

/************************************************
 * Transactions endpoint
 ************************************************/
var REPORT_TRANSACTION = exports.REPORT_TRANSACTION = API_URL + '/v1/reports/transactions';
/**
 * @return {string}
 */
function REPORT_TRANSACTION_DETAIL(transactionId) {
  return API_URL + '/v1/reports/' + transactionId + '/transaction_detail';
}
/**
  * Invoices endpoints
  */
var INVOICES_URL = exports.INVOICES_URL = API_URL + '/v1/reports/invoices';
function RECEIPT_INVOICES_URL(id) {
  return API_URL + '/v1/invoices/' + id + '.json';
}

var RECORD_PAYMENT_URL = exports.RECORD_PAYMENT_URL = API_URL + '/v1/invoices/payment_records';
function RESEND_EMAIL_URL(invoiceId) {
  return API_URL + '/v1/invoices/' + invoiceId + '/resend_email';
}

/***
 * Email receipt endpoint
 */
var EMAIL_RECEIPT = exports.EMAIL_RECEIPT = API_URL + '/v1/email_receipt';

/************************************************
 * Refund endpoint
 ************************************************/
var REFUNDS = exports.REFUNDS = API_URL + '/v2/refunds';
var OLD_REFUNDS = exports.OLD_REFUNDS = API_URL + '/v1/refunds';

/************************************************************************************************
 * End Refund Endpoint
 ************************************************************************************************/

/************************************************************************************************
 * Outlets endpoint
 ************************************************************************************************/
var OUTLETS_URL = exports.OUTLETS_URL = API_URL + '/v1/outlets';

/************************************************************************************************
 * End outlets endpoint
 ************************************************************************************************/
function PRINT_RECEIPT_INVOICE_PDF(invoiceId) {
  return API_URL + '/v1/invoices/' + invoiceId + '.pdf';
}
var SETTING_ACCOUNT = exports.SETTING_ACCOUNT = API_URL + '/v1/users/settings';
var EXPORT_INVOICES = exports.EXPORT_INVOICES = API_URL + '/v1/invoices/export';
function SETTING_PUBLIC_PROFILE(businessId) {
  return API_URL + '/v1/businesses/' + businessId;
}
var GET_NEW_IMAGE_URL = exports.GET_NEW_IMAGE_URL = API_URL + '/v1/s3/new';
var GET_LOADING_IMAGE = exports.GET_LOADING_IMAGE = HOST + '/assets/item-image-loading.gif';
var UPLOAD_IMAGE = exports.UPLOAD_IMAGE = 'https://mokapos-development.s3.amazonaws.com/';
var CHECKOUT_SETTING = exports.CHECKOUT_SETTING = API_URL + '/v1/checkout_setting';

/************************************************************************************************
 * Export endpoint
 ************************************************************************************************/
var EXPORT_TRANSACTION = exports.EXPORT_TRANSACTION = API_URL + '/v1/reports/export_transactions';
var EXPORT_SUMMARY = exports.EXPORT_SUMMARY = API_URL + '/v1/reports/export_sales_summary';
var EXPORT_GROSS_PROFIT = exports.EXPORT_GROSS_PROFIT = API_URL + '/v1/reports/export_gross_profit';
var EXPORT_PAYMENT_METHOD = exports.EXPORT_PAYMENT_METHOD = API_URL + '/v1/reports/export_payment_methods';
var EXPORT_ITEM_SALES = exports.EXPORT_ITEM_SALES = API_URL + '/v1/reports/export_item_sales';
var EXPORT_CATEGORY_SALES = exports.EXPORT_CATEGORY_SALES = API_URL + '/v1/reports/export_category_sales';
var EXPORT_MODIFIER_SALES = exports.EXPORT_MODIFIER_SALES = API_URL + '/v1/reports/export_modifiers';
var EXPORT_DISCOUNT = exports.EXPORT_DISCOUNT = MOKA_SERVICE_URL + '/report/v1/discounts/export';
var EXPORT_TAXES = exports.EXPORT_TAXES = API_URL + '/v1/reports/export_taxes';
var EXPORT_GRATUITY = exports.EXPORT_GRATUITY = API_URL + '/v1/reports/export_gratuities';
var EXPORT_COLLECTEDBY = exports.EXPORT_COLLECTEDBY = API_URL + '/v1/reports/export_staff_report';
var EXPORT_SERVEDBY = exports.EXPORT_SERVEDBY = API_URL + '/v1/reports/export_servers';
/************************************************************************************************
 * End Export endpoint
 ************************************************************************************************/

/************************************************************************************************
 * Customers feedback endpoint
 ************************************************************************************************/
var LIST_CUSTOMER_FEEDBACK_URL = exports.LIST_CUSTOMER_FEEDBACK_URL = API_URL + '/v1/customer_feedbacks';
function FEEDBACK_MESSAGES(feedbackId) {
  return API_URL + '/v1/customer_feedbacks/' + feedbackId + '/feedback_messages';
}
var SUBMIT_REPLY_URL = exports.SUBMIT_REPLY_URL = API_URL + '/v1/customer_feedbacks/submit_reply';
/************************************************************************************************
 * End customers feedback endpoint
 ************************************************************************************************/

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (true) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingField = function (_React$Component) {
  (0, _inherits3.default)(SettingField, _React$Component);

  function SettingField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SettingField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SettingField.__proto__ || (0, _getPrototypeOf2.default)(SettingField)).call.apply(_ref, [this].concat(args))), _this), _this._onKeyPress = function (e) {
      var _this$props = _this.props,
          positiveNumberOnly = _this$props.positiveNumberOnly,
          maxFractionDigits = _this$props.maxFractionDigits;
      // allow only specific chars
      // whether the input is not valid (e.g. 123, or 1.234.1234) should be handled on onChange

      if (positiveNumberOnly) {
        var numberRegex = void 0;
        if (maxFractionDigits === 0) {
          numberRegex = /[0-9]/;
        } else {
          numberRegex = /[0-9.]/;
        }

        if (!numberRegex.test(e.key)) {
          e.preventDefault();
        }
      }
    }, _this._onChange = function (e) {
      var nextVal = e.target.value;
      var _this$props2 = _this.props,
          positiveNumberOnly = _this$props2.positiveNumberOnly,
          onChange = _this$props2.input.onChange,
          maxFractionDigits = _this$props2.maxFractionDigits;

      if (isNaN(nextVal) && positiveNumberOnly) {
        // case if one digit < 0 integer
        if (nextVal === '-') {
          onChange(e, '');
        } else {
          // no op. invalid change
        }
      } else if (maxFractionDigits !== undefined) {
        // we must check also if == 0, so we check using undefined instead of comparing zero values (!maxFractionDigits
        var dotPosition = nextVal.indexOf('.');
        if (dotPosition !== -1 && nextVal.length - dotPosition - 1 > maxFractionDigits) {
          // no op. invalid change
        } else {
          onChange(e, nextVal);
        }
      } else {
        onChange(e, nextVal);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SettingField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          maxLength = _props.maxLength,
          _props$dis = _props.dis,
          dis = _props$dis === undefined ? false : _props$dis,
          inputClassName = _props.inputClassName,
          feedbackClassName = _props.feedbackClassName,
          prefixText = _props.prefixText,
          prefixTextClassName = _props.prefixTextClassName,
          prefixTextClassNameError = _props.prefixTextClassNameError;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        { className: touched ? error ? 'has-feedback has-error' : 'has-feedback has-success' : '' },
        prefixText && React.createElement(
          'div',
          { className: touched ? error ? prefixTextClassNameError : prefixTextClassName : prefixTextClassName },
          prefixText
        ),
        React.createElement('input', (0, _extends3.default)({}, input, {
          type: type,
          readOnly: readOnly,
          maxLength: maxLength,
          className: 'form-control ' + inputClassName,
          placeholder: placeholder,
          onChange: this._onChange,
          onKeyPress: this._onKeyPress,
          disabled: dis })),
        touched ? error ? React.createElement(
          _reactBootstrap.OverlayTrigger,
          { placement: 'top', overlay: React.createElement(
              _reactBootstrap.Tooltip,
              { id: 'tooltip' },
              error
            ) },
          React.createElement('span', {
            className: 'form-control-feedback glyphicon glyphicon-remove ' + feedbackClassName,
            style: { 'pointer-events': 'auto', 'cursor': 'pointer' }
          })
        ) : React.createElement('span', { className: 'form-control-feedback glyphicon glyphicon-ok ' + feedbackClassName }) : ''
      );
    }
  }]);
  return SettingField;
}(React.Component);

exports.default = SettingField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapper = exports.ActionBarWrapper = exports.RightColumnWrapper = exports.LeftColumnWrapper = exports.PageWrapper = undefined;

var _ContentWrapper = __webpack_require__(1198);

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _LeftColumnWrapper = __webpack_require__(1199);

var _LeftColumnWrapper2 = _interopRequireDefault(_LeftColumnWrapper);

var _RightColumnWrapper = __webpack_require__(1200);

var _RightColumnWrapper2 = _interopRequireDefault(_RightColumnWrapper);

var _PageWrapper = __webpack_require__(296);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _ActionBarWrapper = __webpack_require__(1197);

var _ActionBarWrapper2 = _interopRequireDefault(_ActionBarWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PageWrapper = _PageWrapper2.default;
exports.LeftColumnWrapper = _LeftColumnWrapper2.default;
exports.RightColumnWrapper = _RightColumnWrapper2.default;
exports.ActionBarWrapper = _ActionBarWrapper2.default;
exports.ContentWrapper = _ContentWrapper2.default;

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showPageLoadingSpinner = showPageLoadingSpinner;

var _constants = __webpack_require__(616);

function showPageLoadingSpinner(showLoadingSpinnerPage) {
  return { type: _constants.PAGE_SHOW_LOADING_SPINNER, payload: { showLoadingSpinnerPage: showLoadingSpinnerPage } };
}

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getProfile = getProfile;

var _constants = __webpack_require__(1110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/users_controller.rb#L25
 * @return {Axios.IPromise<U>}
 */
function getProfile() {
  return axios.get(_constants.GET_PROFILE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getOutletById = getOutletById;
exports.postOutlet = postOutlet;
exports.putOutletById = putOutletById;
exports.patchOutletById = patchOutletById;
exports.outlets = outlets;
exports.search = search;
exports.getNew = getNew;
exports.patchLogin = patchLogin;
exports.getOutletPrice = getOutletPrice;

var _constants = __webpack_require__(1109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L20
 * @param outletId
 * @param query
 * @return {Axios.IPromise<U>}
 */
function getOutletById(outletId, query) {
  return axios.get((0, _constants.OUTLET_BY_ID)(outletId), { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L26
 * @param data
 * @param params
 * @return {Axios.IPromise<U>}
 */
function postOutlet(data, params) {
  return axios.post(_constants.OUTLETS_URL, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data = error.response.data;

      if (_data.errors) {
        eobj = new Error(_data.errors);
      } else if (_data.message) {
        eobj = new Error(_data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L68
 * @param outletId
 * @param data
 * @param queryParams
 * @return {Axios.IPromise<U>}
 */
function putOutletById(outletId, data, queryParams) {
  return axios.put((0, _constants.OUTLET_BY_ID)(outletId), data, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.data.errors);
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

/**
 * TODO add link
 * @param outletId
 * @param data
 * @param queryParams
 * @return {Axios.IPromise<U>}
 */
function patchOutletById(outletId, data, queryParams) {
  return axios.patch((0, _constants.OUTLET_BY_ID)(outletId), data, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data2 = error.response.data;

      if (_data2.errors) {
        eobj = new Error(_data2.errors);
      } else if (_data2.message) {
        eobj = new Error(_data2.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L8
 * @return {Axios.IPromise<U>}
 */
function outlets(params) {
  return axios.get(_constants.OUTLETS_URL, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L113
 * @param params
 * @return {Axios.IPromise<U>}
 */
function search(params) {
  return axios.get(_constants.OUTLETS_SEARCH, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _error$response$data = error.response.data,
          errors = _error$response$data.errors,
          message = _error$response$data.message;

      if (errors) {
        return new Error(errors);
      } else {
        return new Error(message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L124-L124
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getNew(params) {
  return axios.get(_constants.OUTLET_NEW, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _error$response$data2 = error.response.data,
          errors = _error$response$data2.errors,
          message = _error$response$data2.message;

      if (errors) {
        return new Error(errors);
      } else {
        return new Error(message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/sessions_controller.rb#L65
 * @param data
 * @return {Axios.IPromise<U>}
 */
function patchLogin(data, params) {
  return axios.patch(_constants.UPDATE_SELECTED_OUTLET, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(true);
  }).catch(function (error) {
    if (error.response && error.response.data.error) {
      return _promise2.default.reject(new Error(error.response.data.error));
    } else {
      return _promise2.default.reject(error);
    }
  });
}

function getOutletPrice() {
  return axios.get(_constants.OUTLET_PRICE, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    if (error.response && error.response.data.error) {
      return _promise2.default.reject(new Error(error.response.data.error));
    } else {
      return _promise2.default.reject(error);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(142);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (true) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Modal = __webpack_require__(505);

var _Modal2 = _interopRequireDefault(_Modal);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = function (_React$Component) {
  (0, _inherits3.default)(ModalHeader, _React$Component);

  function ModalHeader() {
    (0, _classCallCheck3.default)(this, ModalHeader);
    return (0, _possibleConstructorReturn3.default)(this, (ModalHeader.__proto__ || (0, _getPrototypeOf2.default)(ModalHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalHeader, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        _reactBootstrap.Modal.Header,
        null,
        React.createElement(
          _reactBootstrap.Modal.Title,
          { bsClass: 'modal-title ' + _Modal2.default['modal-title'] },
          this.props.title
        )
      );
    }
  }]);
  return ModalHeader;
}(React.Component);

ModalHeader.propTypes = {
  title: React.PropTypes.string
};

exports.default = ModalHeader;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NoDataAndLoading = __webpack_require__(1982);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoDataAndLoading = function (_React$Component) {
  (0, _inherits3.default)(NoDataAndLoading, _React$Component);

  function NoDataAndLoading() {
    (0, _classCallCheck3.default)(this, NoDataAndLoading);
    return (0, _possibleConstructorReturn3.default)(this, (NoDataAndLoading.__proto__ || (0, _getPrototypeOf2.default)(NoDataAndLoading)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoDataAndLoading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showLoadingSpinner = _props.showLoadingSpinner,
          noDataToDisplay = _props.noDataToDisplay,
          title = _props.title,
          description = _props.description;

      return React.createElement(
        'div',
        { className: (showLoadingSpinner || noDataToDisplay ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding ' + _NoDataAndLoading2.default['parent-box-data-display'] : '') + ' ' },
        showLoadingSpinner && React.createElement(
          'div',
          { className: '' + _NoDataAndLoading2.default['full-height-no-data-display'] },
          React.createElement(
            'div',
            { className: _NoDataAndLoading2.default['loading-container'] + ' box-spinner' },
            React.createElement(
              'div',
              { className: '' + _NoDataAndLoading2.default['content-loading-spinner'] },
              React.createElement('img', { src: __webpack_require__(591), alt: 'mokapos spinner', className: _NoDataAndLoading2.default['loading-spinner'] })
            )
          )
        ),
        noDataToDisplay && !showLoadingSpinner && React.createElement(
          'div',
          { className: '' + _NoDataAndLoading2.default['full-height-no-data-display'] },
          React.createElement(
            'div',
            { className: _NoDataAndLoading2.default['no-data-container'] + ' box-spinner' },
            React.createElement(
              'div',
              { className: '' + _NoDataAndLoading2.default['content-no-data-display'] },
              React.createElement(
                'div',
                null,
                React.createElement('img', { src: __webpack_require__(948),
                  className: _NoDataAndLoading2.default.img,
                  alt: 'no sales',
                  width: '110px'
                })
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'h3',
                  { className: _NoDataAndLoading2.default['title'] },
                  title
                )
              ),
              React.createElement(
                'div',
                { className: _NoDataAndLoading2.default.description },
                React.createElement(
                  'p',
                  null,
                  description
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NoDataAndLoading;
}(React.Component);

NoDataAndLoading.propTypes = {
  showLoadingSpinner: React.PropTypes.bool,
  noDataToDisplay: React.PropTypes.bool,
  title: React.PropTypes.string,
  description: React.PropTypes.string
};

exports.default = NoDataAndLoading;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _confirmAction = __webpack_require__(29);

var actConfirmAction = _interopRequireWildcard(_confirmAction);

var _ConfirmActionModal = __webpack_require__(1944);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmActionModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmActionModal, _React$Component);

  function ConfirmActionModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmActionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmActionModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmActionModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch(actConfirmAction.cancelAction());
    }, _this._onConfirm = function () {
      var nextAction = _this.props.data.confirmAction.nextAction;

      _this.props.dispatch(actConfirmAction.confirmAction(nextAction));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmActionModal, [{
    key: 'render',
    value: function render() {
      var showConfirmActionModal = this.props.data.confirmAction.showConfirmActionModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { onHide: this._onHide, show: showConfirmActionModal, dialogClassName: _ConfirmActionModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _ConfirmActionModal2.default['title-modal'] },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Are you sure you want to leave screen and discard your changes ?'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-default', onClick: this._onHide },
              'Cancel'
            ),
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary', onClick: this._onConfirm },
              'Ok'
            )
          )
        )
      );
    }
  }]);
  return ConfirmActionModal;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      confirmAction: state.confirmAction
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConfirmActionModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatDate;

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDate(date) {
  return (0, _moment2.default)(date).toISOString();
}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _icon = __webpack_require__(2876);

var _icon2 = _interopRequireDefault(_icon);

var _DropdownOutlet = __webpack_require__(1958);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _tickedOutlet = __webpack_require__(2877);

var _tickedOutlet2 = _interopRequireDefault(_tickedOutlet);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toggle = function (_React$Component) {
  (0, _inherits3.default)(Toggle, _React$Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this._onClick = function (e) {
      e.preventDefault();
      _this.props.onClick(e);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Toggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outletName = _props.outletName,
          withCaret = _props.withCaret;

      return React.createElement(
        'div',
        { className: _DropdownOutlet2.default.dropdown },
        React.createElement(
          _reactBootstrap.Button,
          { onClick: this._onClick, bsClass: 'btn btn-default ' + _DropdownOutlet2.default['button-toggle'] },
          React.createElement(
            'div',
            { className: _DropdownOutlet2.default['outlet-name-wrapper'] },
            React.createElement('img', { alt: 'Outlet icon', className: _DropdownOutlet2.default['outlet-icon'], src: _icon2.default }),
            outletName
          ),
          withCaret && React.createElement('span', { className: 'caret' })
        )
      );
    }
  }]);
  return Toggle;
}(React.Component);

var DropdownOutlet = function (_React$Component2) {
  (0, _inherits3.default)(DropdownOutlet, _React$Component2);

  function DropdownOutlet() {
    var _ref2;

    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DropdownOutlet);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DropdownOutlet.__proto__ || (0, _getPrototypeOf2.default)(DropdownOutlet)).call.apply(_ref2, [this].concat(args))), _this2), _this2._onSelect = function (outletIds) {
      _this2.props.onChangeOutletIds(outletIds);
    }, _this2._onClickToggle = function () {}, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(DropdownOutlet, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          outlets = _props2.outlets,
          allOutletOption = _props2.allOutletOption,
          input = _props2.input;
      var value = input.value;


      var allOutlet = {
        id: outlets.map(function (outlet) {
          return outlet.id;
        }),
        name: 'All Outlets'
      };

      var loadingOutlet = {
        id: [],
        name: 'Loading...'
      };

      var activeOutlet = { id: [], name: '' };
      if (value.length > 1) {
        activeOutlet = allOutlet;
      } else if (value.length === 1) {
        outlets.forEach(function (outlet) {
          if (outlet.id === value[0] && value.length === 1) {
            activeOutlet = { id: [outlet.id], name: outlet.name };
          }
        });
      } else {
        activeOutlet = loadingOutlet;
      }

      if (outlets.length > 1) {
        return React.createElement(
          _reactBootstrap.Dropdown,
          { id: 'dropdown-custom-1' },
          React.createElement(Toggle, {
            outletName: activeOutlet.name,
            bsRole: 'toggle',
            onClick: this._onClickToggle,
            withCaret: outlets.length > 1
          }),
          React.createElement(
            _reactBootstrap.Dropdown.Menu,
            { className: _DropdownOutlet2.default.menu, bsRole: 'menu' },
            allOutletOption && outlets.length > 1 && React.createElement(
              _reactBootstrap.MenuItem,
              {
                onSelect: this._onSelect, eventKey: allOutlet.id,
                className: _DropdownOutlet2.default['menu-item']
              },
              React.createElement(
                'span',
                null,
                activeOutlet.id.length > 1 && React.createElement('img', { alt: 'Ticked outlet', className: _DropdownOutlet2.default['list-outlet-selected-icon'], src: _tickedOutlet2.default })
              ),
              React.createElement(
                'span',
                { className: _DropdownOutlet2.default['list-outlet-name'] },
                allOutlet.name
              )
            ),
            outlets.map(function (outlet, idx) {
              var outletIds = [outlet.id];
              return React.createElement(
                _reactBootstrap.MenuItem,
                { onSelect: _this3._onSelect, eventKey: outletIds, className: _DropdownOutlet2.default['menu-item'] },
                outlet.id === activeOutlet.id[0] && activeOutlet.id.length === 1 && React.createElement(
                  'span',
                  null,
                  React.createElement('img', { alt: 'Ticked outlet', className: _DropdownOutlet2.default['list-outlet-selected-icon'], src: _tickedOutlet2.default })
                ),
                React.createElement(
                  'span',
                  { className: _DropdownOutlet2.default['list-outlet-name'] },
                  outlet.name
                )
              );
            })
          )
        );
      } else {
        return React.createElement(
          _reactBootstrap.Button,
          { bsClass: 'btn btn-default ' + _DropdownOutlet2.default['button-toggle'], disabled: true },
          React.createElement(
            'div',
            { className: _DropdownOutlet2.default['outlet-name-wrapper'] },
            React.createElement('img', { alt: 'Outlet icon', className: _DropdownOutlet2.default['outlet-icon'], src: _icon2.default }),
            activeOutlet.name
          )
        );
      }
    }
  }]);
  return DropdownOutlet;
}(React.Component);

DropdownOutlet.propTypes = {
  outlets: React.PropTypes.array,
  name: React.PropTypes.string,
  allOutletOption: React.PropTypes.bool
};

exports.default = DropdownOutlet;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LoadingSpinner = __webpack_require__(1976);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSpinner = function (_React$Component) {
  (0, _inherits3.default)(LoadingSpinner, _React$Component);

  function LoadingSpinner() {
    (0, _classCallCheck3.default)(this, LoadingSpinner);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingSpinner.__proto__ || (0, _getPrototypeOf2.default)(LoadingSpinner)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingSpinner, [{
    key: 'render',
    value: function render() {
      var showLoadingSpinner = this.props.showLoadingSpinner;

      return showLoadingSpinner && React.createElement(
        'div',
        { className: _LoadingSpinner2.default['loading-container'] },
        React.createElement('img', { src: __webpack_require__(591), alt: 'mokapos spinner', className: 'loading-spinner' })
      );
    }
  }]);
  return LoadingSpinner;
}(React.Component);

LoadingSpinner.propTypes = {
  showLoadingSpinner: React.PropTypes.bool
};

exports.default = LoadingSpinner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var DOMProperty = __webpack_require__(273);
var ReactDOMComponentFlags = __webpack_require__(869);

var invariant = __webpack_require__(35);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  true ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  true ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setCustomers = setCustomers;
exports.customersRequest = customersRequest;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.setKeyword = setKeyword;
exports.setType = setType;
exports.setSummary = setSummary;
exports.setHasLoyalty = setHasLoyalty;
exports.customerDetailRequest = customerDetailRequest;
exports.closeCustomerDetail = closeCustomerDetail;
exports.setCustomerDetail = setCustomerDetail;
exports.receiptCustomerRequest = receiptCustomerRequest;
exports.setReceiptCustomer = setReceiptCustomer;
exports.downloadCustomerTemplate = downloadCustomerTemplate;
exports.customerExportRequest = customerExportRequest;
exports.showImportingModeModal = showImportingModeModal;
exports.hideImportingModeModal = hideImportingModeModal;
exports.changeModalVisibility = changeModalVisibility;
exports.setRedemptionHistories = setRedemptionHistories;
exports.customerRedemptionHistoriesRequest = customerRedemptionHistoriesRequest;
exports.setPointActivities = setPointActivities;
exports.customerPointActivitiesRequest = customerPointActivitiesRequest;

var _constants = __webpack_require__(387);

function pageRequest() {
  return { type: _constants.CUSTOMER_LIST_PAGE_REQUEST, payload: {} };
}

/******************************************************************************************
 * Customer List
 ******************************************************************************************/

function setCustomers(customers) {
  return { type: _constants.CUSTOMER_LIST_SET_CUSTOMERS, payload: { customers: customers } };
}

/**
 *
 * @param {object} query. must contain key 'page'
 * @param {Array} previousCustomers We need it to append to the pagination
 * @return {{type, payload: {query: *, previousCustomers: *}}}
 */
function customersRequest(query, previousCustomers) {
  return { type: _constants.CUSTOMER_LIST_CUSTOMERS_REQUEST, payload: { query: query, previousCustomers: previousCustomers } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.CUSTOMER_LIST_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.CUSTOMER_LIST_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function setKeyword(keyword) {
  return { type: _constants.CUSTOMER_LIST_SET_KEYWORD, payload: { keyword: keyword } };
}

function setType(type) {
  return { type: _constants.CUSTOMER_LIST_SET_TYPE, payload: { type: type } };
}

function setSummary(summary) {
  return { type: _constants.CUSTOMER_LIST_SET_SUMMARY, payload: { summary: summary } };
}

function setHasLoyalty(hasLoyalty) {
  return { type: _constants.CUSTOMER_LIST_SET_HAS_LOYALTY, payload: { hasLoyalty: hasLoyalty } };
}
/******************************************************************************************
 * End Customer List
 ******************************************************************************************/

/******************************************************************************************
 * Customer Details
 ******************************************************************************************/

function customerDetailRequest(customer, query) {
  return { type: _constants.CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST, payload: { customer: customer, query: query } };
}

function closeCustomerDetail() {
  return { type: _constants.CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL, payload: {} };
}

function setCustomerDetail(customer) {
  return { type: _constants.CUSTOMER_LIST_SET_CUSTOMER_DETAIL, payload: { customer: customer } };
}

function receiptCustomerRequest(payment, customer) {
  return { type: _constants.CUSTOMER_LIST_RECEIPT_REQUEST, payload: { payment: payment, customer: customer } };
}

function setReceiptCustomer(receiptData) {
  return { type: _constants.CUSTOMER_LIST_SET_RECEIPT, payload: { receiptData: receiptData } };
}

/******************************************************************************************
 * End Customer Details
 ******************************************************************************************/

function downloadCustomerTemplate(filename) {
  return { type: _constants.CUSTOMERS_DOWNLOAD_TEMPLATE, payload: { filename: filename } };
}

function customerExportRequest(fileName) {
  var hasLoyalty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return { type: _constants.CUSTOMER_LIST_EXPORT, payload: { fileName: fileName, hasLoyalty: hasLoyalty } };
}

function showImportingModeModal() {
  return { type: _constants.CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL, payload: {} };
}
function hideImportingModeModal() {
  return { type: _constants.CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL, payload: {} };
}

function changeModalVisibility(modalVisibility) {
  return { type: _constants.CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY, payload: { modalVisibility: modalVisibility } };
}

function setRedemptionHistories(redemptionHistories) {
  return { type: _constants.CUSTOMER_LIST_SET_REDEMPTION_HISTORIES, payload: { redemptionHistories: redemptionHistories } };
}

function customerRedemptionHistoriesRequest(query) {
  return { type: _constants.CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST, payload: { query: query } };
}

function setPointActivities(pointActivities) {
  return { type: _constants.CUSTOMER_LIST_SET_POINT_ACTIVITIES, payload: { pointActivities: pointActivities } };
}

function customerPointActivitiesRequest(query) {
  return { type: _constants.CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST, payload: { query: query } };
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setMustScrollTop = setMustScrollTop;
exports.itemsRequest = itemsRequest;
exports.listCategoryRequest = listCategoryRequest;
exports.listCategoryWithUncategorizedRequest = listCategoryWithUncategorizedRequest;
exports.itemSummaryRequest = itemSummaryRequest;
exports.changeCategoryIdDropdown = changeCategoryIdDropdown;
exports.changeInventoryIdDropdown = changeInventoryIdDropdown;
exports.setItems = setItems;
exports.setCategories = setCategories;
exports.setCurrentCategoryId = setCurrentCategoryId;
exports.setCurrentInventoryId = setCurrentInventoryId;
exports.setItemSummary = setItemSummary;
exports.setOutlets = setOutlets;
exports.setFilterState = setFilterState;
exports.unSetFilterState = unSetFilterState;
exports.setFilterItem = setFilterItem;
exports.onChangeOutletIds = onChangeOutletIds;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.itemExportRequest = itemExportRequest;
exports.setImportType = setImportType;
exports.showSectionUploader = showSectionUploader;
exports.downloadItemTemplate = downloadItemTemplate;
exports.onClickCreateItem = onClickCreateItem;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.setItemDetail = setItemDetail;
exports.onClickCancel = onClickCancel;
exports.onClickRow = onClickRow;
exports.onDropImage = onDropImage;
exports.onDeleteImage = onDeleteImage;
exports.onClickBtnItemVariant = onClickBtnItemVariant;
exports.showItemVariantModal = showItemVariantModal;
exports.hideItemVariantModal = hideItemVariantModal;
exports.showItemInventoryAleryModal = showItemInventoryAleryModal;
exports.hideCOGSModal = hideCOGSModal;
exports.showCOGSModal = showCOGSModal;
exports.hideItemInventoryAlertModal = hideItemInventoryAlertModal;
exports.showSaveToAllOutletsModal = showSaveToAllOutletsModal;
exports.hideSaveToAllOutletsModal = hideSaveToAllOutletsModal;
exports.setPreviousItemForm = setPreviousItemForm;
exports.onCancelItemVariantModal = onCancelItemVariantModal;
exports.onConfirmItemVariantModal = onConfirmItemVariantModal;
exports.onClickBtnStartTracking = onClickBtnStartTracking;
exports.onClickBtnStartTrackingCOGS = onClickBtnStartTrackingCOGS;
exports.onCancelItemInventoryAlertModal = onCancelItemInventoryAlertModal;
exports.onCancelCOGSModal = onCancelCOGSModal;
exports.onConfirmItemInventoryAlertModal = onConfirmItemInventoryAlertModal;
exports.onConfirmCOGSModal = onConfirmCOGSModal;
exports.fillFormDetailItem = fillFormDetailItem;
exports.getModifiersforItem = getModifiersforItem;
exports.setModifiers = setModifiers;
exports.setManageItemInventoryIds = setManageItemInventoryIds;
exports.setActiveModifierIds = setActiveModifierIds;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.deleteItem = deleteItem;
exports.onClickCreateNewCategory = onClickCreateNewCategory;
exports.showNewCategoryModal = showNewCategoryModal;
exports.hideNewCategoryModal = hideNewCategoryModal;
exports.setNewCategory = setNewCategory;
exports.onConfirmCreateNewCategory = onConfirmCreateNewCategory;
exports.onCancelCreateNewCategory = onCancelCreateNewCategory;
exports.setPreviousCategories = setPreviousCategories;
exports.setPreviousCategoryId = setPreviousCategoryId;
exports.showImportModal = showImportModal;
exports.hideImportModal = hideImportModal;
exports.onSuccessImport = onSuccessImport;
exports.setIsSubmittingForm = setIsSubmittingForm;
exports.setTaxes = setTaxes;

var _constants = __webpack_require__(408);

function pageRequest() {
  return { type: _constants.LIBRARY_ITEM_PAGE_REQUEST, payload: {} };
}

function setMustScrollTop(mustScrollTop) {
  return { type: _constants.LIBRARY_ITEM_SET_MUST_SCROLL_TOP, payload: { mustScrollTop: mustScrollTop } };
}

function itemsRequest(query, previousItems) {
  return { type: _constants.LIBRARY_ITEM_LIST_ITEM_REQUEST, payload: { query: query, previousItems: previousItems } };
}

function listCategoryRequest() {
  return { type: _constants.LIBRARY_ITEM_LIST_CATEGORY_REQUEST, payload: {} };
}

function listCategoryWithUncategorizedRequest() {
  return { type: _constants.LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST, payload: {} };
}

function itemSummaryRequest(query) {
  return { type: _constants.LIBRARY_ITEM_ITEM_SUMMARY_REQUEST, payload: query };
}

function changeCategoryIdDropdown(categoryId) {
  return { type: _constants.LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN, payload: { categoryId: categoryId } };
}

function changeInventoryIdDropdown(inventoryId) {
  return { type: _constants.LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN, payload: { inventoryId: inventoryId } };
}

function setItems(items) {
  return { type: _constants.LIBRARY_ITEM_SET_ITEM_LIST, payload: { items: items } };
}

function setCategories(categories) {
  return { type: _constants.LIBRARY_ITEM_SET_CATEGORY_LIST, payload: { categories: categories } };
}

function setCurrentCategoryId(categoryId) {
  return { type: _constants.LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID, payload: { categoryId: categoryId } };
}

function setCurrentInventoryId(inventoryId) {
  return { type: _constants.LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID, payload: { inventoryId: inventoryId } };
}

function setItemSummary(itemSummary) {
  return { type: _constants.LIBRARY_ITEM_SET_ITEM_SUMMARY, payload: { itemSummary: itemSummary } };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_ITEM_SET_OUTLETS, payload: { outlets: outlets } };
}

function setFilterState(categoryId, typeInventoryId, keyword) {
  return { type: _constants.LIBRARY_ITEM_SET_FILTER_STATE, payload: { categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword } };
}

function unSetFilterState() {
  return { type: _constants.LIBRARY_ITEM_UNSET_FILTER_STATE };
}

function setFilterItem(categoryId, typeInventoryId, keyword) {
  return { type: _constants.LIBRARY_ITEM_SET_FILTER_ITEM, payload: { categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_ITEM_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_ITEM_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function itemExportRequest(prefix, email, outlets) {
  return { type: _constants.LIBRARY_ITEM_ITEM_LIST_EXPORT, payload: { prefix: prefix, email: email, outlets: outlets } };
}

function setImportType(importType) {
  return { type: _constants.LIBRARY_ITEM_SET_TYPE_IMPORT, payload: { importType: importType } };
}

function showSectionUploader(showSectionUploader) {
  return { type: _constants.LIBRARY_ITEM_SHOW_SECTION_UPLOADER, payload: { showSectionUploader: showSectionUploader } };
}

function downloadItemTemplate(prefix, email, outlets) {
  return { type: _constants.LIBRARY_ITEM_ITEM_LIST_TEMPLATE, payload: { prefix: prefix, email: email, outlets: outlets } };
}

function onClickCreateItem() {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_CREATE_ITEM, payload: {} };
}

function openRightColumn() {
  return { type: _constants.LIBRARY_ITEM_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.LIBRARY_ITEM_CLOSE_RIGHT_COLUMN, payload: {} };
}

function setItemDetail(item) {
  return { type: _constants.LIBRARY_ITEM_SET_ITEM_DETAIL, payload: { item: item } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_CANCEL, payload: {} };
}

function onClickRow(item) {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_ROW, payload: { item: item } };
}

function onDropImage(filesState) {
  return { type: _constants.LIBRARY_ITEM_ON_DROP_IMAGE, payload: { filesState: filesState } };
}

function onDeleteImage(filesState) {
  return { type: _constants.LIBRARY_ITEM_ON_DELETE_IMAGE, payload: { filesState: filesState } };
}

function onClickBtnItemVariant(itemForm) {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT, payload: { itemForm: itemForm } };
}

function showItemVariantModal() {
  return { type: _constants.LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL, payload: {} };
}

function hideItemVariantModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL, payload: {} };
}

function showItemInventoryAleryModal() {
  return { type: _constants.LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

function hideCOGSModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_COGS_MODAL, payload: {} };
}

function showCOGSModal(isTrack) {
  return { type: _constants.LIBRARY_ITEM_SHOW_COGS_MODAL, payload: { isTrack: isTrack } };
}

function hideItemInventoryAlertModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

function showSaveToAllOutletsModal() {
  return { type: _constants.LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function hideSaveToAllOutletsModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function setPreviousItemForm(previousItemForm) {
  return { type: _constants.LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM, payload: { previousItemForm: previousItemForm } };
}

function onCancelItemVariantModal(previousItemForm) {
  return { type: _constants.LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL, payload: { previousItemForm: previousItemForm } };
}

function onConfirmItemVariantModal(value) {
  return { type: _constants.LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL, payload: { value: value } };
}

function onClickBtnStartTracking(itemForm, isTrack) {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING, payload: { itemForm: itemForm, isTrack: isTrack } };
}

function onClickBtnStartTrackingCOGS(itemForm, isTrack) {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING, payload: { itemForm: itemForm, isTrack: isTrack } };
}

function onCancelItemInventoryAlertModal(previousItemForm) {
  return { type: _constants.LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, payload: { previousItemForm: previousItemForm } };
}

function onCancelCOGSModal(previousItemForm) {
  return { type: _constants.LIBRARY_ITEM_ON_CANCEL_COGS_MODAL, payload: { previousItemForm: previousItemForm } };
}

function onConfirmItemInventoryAlertModal(value, itemForm) {
  return { type: _constants.LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, payload: { value: value, itemForm: itemForm } };
}

function onConfirmCOGSModal(value, isTrack) {
  return { type: _constants.LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL, payload: { value: value, isTrack: isTrack } };
}

function fillFormDetailItem(formatFormDetail) {
  return { type: _constants.LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM, payload: { formatFormDetail: formatFormDetail } };
}

function getModifiersforItem(item) {
  return { type: _constants.LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM, payload: { item: item } };
}

function setModifiers(modifiers) {
  return { type: _constants.LIBRARY_ITEM_SET_MODIFIERS, payload: { modifiers: modifiers } };
}

function setManageItemInventoryIds(itemVariant) {
  return { type: _constants.LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY, payload: { itemVariant: itemVariant } };
}

function setActiveModifierIds(modifierIds) {
  return { type: _constants.LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS, payload: { modifierIds: modifierIds } };
}

function submitFormCreate(values, allOutlet, items, search) {
  return { type: _constants.LIBRARY_ITEM_SUBMIT_FORM_CREATE, payload: { values: values, allOutlet: allOutlet, items: items, search: search } };
}

function submitFormUpdate(itemId, values, allOutlet, items) {
  return { type: _constants.LIBRARY_ITEM_SUBMIT_FORM_UPDATE, payload: { itemId: itemId, values: values, allOutlet: allOutlet, items: items } };
}

function showDeleteModal() {
  return { type: _constants.LIBRARY_ITEM_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_DELETE_MODAL, payload: {} };
}

function deleteItem(item, previousItems, search) {
  return { type: _constants.LIBRARY_ITEM_DELETE_ITEM, payload: { item: item, previousItems: previousItems, search: search } };
}

function onClickCreateNewCategory(category, previousCategories, previousCategoryId) {
  return { type: _constants.LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY, payload: { category: category, previousCategories: previousCategories, previousCategoryId: previousCategoryId } };
}

function showNewCategoryModal() {
  return { type: _constants.LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL, payload: {} };
}

function hideNewCategoryModal() {
  return { type: _constants.LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL, payload: {} };
}

function setNewCategory(category) {
  return { type: _constants.LIBRARY_ITEM_SET_NEW_CATEGORY, payload: { category: category } };
}

function onConfirmCreateNewCategory(category) {
  return { type: _constants.LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY, payload: { category: category } };
}

function onCancelCreateNewCategory(previousCategories, previousCategoryId) {
  return { type: _constants.LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY, payload: { previousCategories: previousCategories, previousCategoryId: previousCategoryId } };
}

function setPreviousCategories(categories) {
  return { type: _constants.LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES, payload: { categories: categories } };
}

function setPreviousCategoryId(categoryId) {
  return { type: _constants.LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID, payload: { categoryId: categoryId } };
}

function showImportModal() {
  return { type: _constants.LIBRARY_ITEM_SHOW_IMPORT_MODAL, payload: {} };
}

function hideImportModal() {
  return { type: _constants.LIBRARY_ITEM_HIDE_IMPORT_MODAL, payload: {} };
}

function onSuccessImport() {
  return { type: _constants.LIBRARY_ITEM_ON_SUCCESS_IMPORT, payload: {} };
}

function setIsSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_ITEM_SET_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

function setTaxes(taxes) {
  return { type: _constants.LIBRARY_ITEM_SET_TAXES, payload: { taxes: taxes } };
}

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSelectedOutletIds = setSelectedOutletIds;
exports.setOutlets = setOutlets;

var _constants = __webpack_require__(604);

/**
 *
 * @param {Array} selectedOutletIds array of outlet id
 * @return {{type, payload: {selectedOutletIds: *}}}
 */
function setSelectedOutletIds(selectedOutletIds) {
  return { type: _constants.ACTION_BAR_SET_SELECTED_OUTLET_IDS, payload: { selectedOutletIds: selectedOutletIds } };
}

/**
 *
 * @param {Array} outlets array of outlets
 * @return {{type, payload: {outlets: *}}}
 */
function setOutlets(outlets) {
  return { type: _constants.ACTION_BAR_SET_OUTLETS, payload: { outlets: outlets } };
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAMESPACE_ITEMS = exports.NAMESPACE_ITEMS = 'items';
var NAMESPACE_INGREDIENTS = exports.NAMESPACE_INGREDIENTS = 'ingredients';
var INGREDIENT_FEATURE = exports.INGREDIENT_FEATURE = 'Ingredient Inventory';

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SearchBar = __webpack_require__(1962);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = function (_React$Component) {
  (0, _inherits3.default)(SearchBar, _React$Component);

  function SearchBar() {
    (0, _classCallCheck3.default)(this, SearchBar);
    return (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          placeholder = _props.placeholder,
          className = _props.className;

      return React.createElement(
        'div',
        { className: _SearchBar2.default['right-inner-addon'] + ' ' + className || '', onClick: this.props.onClick },
        React.createElement('i', { className: 'fa fa-search search-items' }),
        React.createElement('input', (0, _extends3.default)({}, input, {
          className: 'form-control ' + _SearchBar2.default.rounded,
          placeholder: placeholder,
          type: 'text'
        }))
      );
    }
  }]);
  return SearchBar;
}(React.Component);

SearchBar.propTypes = {
  placeholder: React.PropTypes.string
};

exports.default = SearchBar;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LabelSection = __webpack_require__(2030);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelSection = function (_React$Component) {
  (0, _inherits3.default)(LabelSection, _React$Component);

  function LabelSection() {
    (0, _classCallCheck3.default)(this, LabelSection);
    return (0, _possibleConstructorReturn3.default)(this, (LabelSection.__proto__ || (0, _getPrototypeOf2.default)(LabelSection)).apply(this, arguments));
  }

  (0, _createClass3.default)(LabelSection, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _LabelSection2.default.wrapper },
        this.props.title
      );
    }
  }]);
  return LabelSection;
}(React.Component);

LabelSection.propTypes = {
  title: React.PropTypes.string
};

exports.default = LabelSection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(679);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */

var CHANGE_FORM = exports.CHANGE_FORM = 'CHANGE_FORM';
var SET_AUTH = exports.SET_AUTH = 'SET_AUTH';
var SENDING_REQUEST = exports.SENDING_REQUEST = 'SENDING_REQUEST';
var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
var CHANGE_FORM_REGISTER = exports.CHANGE_FORM_REGISTER = 'CHANGE_FORM_REGISTER';
var REGISTER_REQUEST = exports.REGISTER_REQUEST = 'REGISTER_REQUEST';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var REQUEST_ERROR = exports.REQUEST_ERROR = 'REQUEST_ERROR';
var CLEAR_ERROR = exports.CLEAR_ERROR = 'CLEAR_ERROR';
var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
var CHANGE_FORM_FORGOT = exports.CHANGE_FORM_FORGOT = 'CHANGE_FORM_FORGOT';
var SHOW_PROGRESS_BAR = exports.SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
var HIDE_PROGRESS_BAR = exports.HIDE_PROGRESS_BAR = 'HIDE_PROGRESS_BAR';
var REGISTER_BUSINESS_REQUEST = exports.REGISTER_BUSINESS_REQUEST = 'REGISTER_BUSINESS_REQUEST';
var CHANGE_FORM_BUSINESS = exports.CHANGE_FORM_BUSINESS = 'CHANGE_FORM_BUSINESS';
var BUSINESS_TYPES_REQUEST = exports.BUSINESS_TYPES_REQUEST = 'BUSINESS_TYPES_REQUEST';
var CHANGE_BUSINESS_TYPES_DATA = exports.CHANGE_BUSINESS_TYPES_DATA = 'CHANGE_BUSINESS_TYPES_DATA';
var BUSINESS_CATEGORIES_REQUEST = exports.BUSINESS_CATEGORIES_REQUEST = 'BUSINESS_CATEGORIES_REQUEST';
var CHANGE_BUSINESS_CATEGORIES_DATA = exports.CHANGE_BUSINESS_CATEGORIES_DATA = 'CHANGE_BUSINESS_CATEGORIES_DATA';
var SET_AUTH_FROM_LOCAL = exports.SET_AUTH_FROM_LOCAL = 'SET_AUTH_FROM_LOCAL';
var SET_AUTH_FROM_API = exports.SET_AUTH_FROM_API = 'SET_AUTH_FROM_API';
var RESEND_VERIFICATION_EMAIL = exports.RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL';
var GET_DASHBOARD = exports.GET_DASHBOARD = 'dashboard/GET_DASHBOARD';
var SET_DASHBOARD = exports.SET_DASHBOARD = 'SET_DASHBOARD';
var GET_FILTERED_DATE = exports.GET_FILTERED_DATE = 'GET_FILTERED_DATE';
var REDIRECT_TO = exports.REDIRECT_TO = 'REDIRECT_TO';
var LOAD_RESET_PASSWORD = exports.LOAD_RESET_PASSWORD = 'LOAD_RESET_PASSWORD';
var CHANGE_FORM_RESET_PASSWORD = exports.CHANGE_FORM_RESET_PASSWORD = 'CHANGE_FORM_RESET_PASSWORD';
var SEND_RESET_PASSWORD = exports.SEND_RESET_PASSWORD = 'SEND_RESET_PASSWORD';
var LOAD_PREPARE_ENCRYPTION = exports.LOAD_PREPARE_ENCRYPTION = 'LOAD_PREPARE_ENCRYPTION';
var SET_PREPARE_ENCRYPTION = exports.SET_PREPARE_ENCRYPTION = 'SET_PREPARE_ENCRYPTION';
var SET_PROFILE = exports.SET_PROFILE = 'SET_PROFILE';
var GET_PROFILE_REQUEST = exports.GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
var CLEAR_REGISTER_FORM = exports.CLEAR_REGISTER_FORM = 'CLEAR_REGISTER_FORM';
var SHOW_LOADING_SPINNER = exports.SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
var SET_IS_REGISTERED = exports.SET_IS_REGISTERED = 'SET_IS_REGISTERED';
var SET_RESEND_VERIFICATION_EMAIL_STATE = exports.SET_RESEND_VERIFICATION_EMAIL_STATE = 'SET_RESEND_VERIFICATION_EMAIL_STATE';
var TO_LOGIN_PAGE = exports.TO_LOGIN_PAGE = 'TO_LOGIN_PAGE';
var TO_SIGNUP_PAGE = exports.TO_SIGNUP_PAGE = 'TO_SIGNUP_PAGE';
var DASHBOARD_SHOW_MODAL_OUTLET_MOBILE = exports.DASHBOARD_SHOW_MODAL_OUTLET_MOBILE = 'DASHBOARD_SHOW_MODAL_OUTLET_MOBILE';

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExportedFile = getExportedFile;
exports.getExportedWithoutOutlet = getExportedWithoutOutlet;

var _constants = __webpack_require__(613);

/**
 * Export file
 * @param {string} filename prefix to be matched against
 * @param {int} outletId current outlet id export
 * @param {string} currentPage name of current page that will be displayed when export fails
 * @return {{type, payload: {filename: *, outletId: *, currentPage: *}}}
 */
function getExportedFile(filename, outletId, currentPage) {
  return { type: _constants.GET_EXPORTED_FILE, payload: { filename: filename, outletId: outletId, currentPage: currentPage } };
}

function getExportedWithoutOutlet(filename) {
  return { type: _constants.GET_EXPORTED_FILE_TEMPLATE, payload: { filename: filename } };
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setUnits = setUnits;
exports.setUncategorized = setUncategorized;
exports.storeUncategorized = storeUncategorized;
exports.librariesRequest = librariesRequest;
exports.listCategoryRequest = listCategoryRequest;
exports.listCategoryWithUncategorizedRequest = listCategoryWithUncategorizedRequest;
exports.changeCategoryIdDropdown = changeCategoryIdDropdown;
exports.changeInventoryIdDropdown = changeInventoryIdDropdown;
exports.setLibraries = setLibraries;
exports.setCategories = setCategories;
exports.setCurrentCategoryId = setCurrentCategoryId;
exports.setCurrentInventoryId = setCurrentInventoryId;
exports.setLibrarySummary = setLibrarySummary;
exports.setOutlets = setOutlets;
exports.setFilterState = setFilterState;
exports.unSetFilterState = unSetFilterState;
exports.setFilterLibrary = setFilterLibrary;
exports.onChangeOutletIds = onChangeOutletIds;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.libraryExportRequest = libraryExportRequest;
exports.setImportType = setImportType;
exports.showSectionUploader = showSectionUploader;
exports.downloadLibraryTemplate = downloadLibraryTemplate;
exports.onClickCreateLibrary = onClickCreateLibrary;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.setLibraryDetail = setLibraryDetail;
exports.onClickCancel = onClickCancel;
exports.onClickRow = onClickRow;
exports.onDropImage = onDropImage;
exports.onDeleteImage = onDeleteImage;
exports.onClickBtnLibraryVariant = onClickBtnLibraryVariant;
exports.showLibraryVariantModal = showLibraryVariantModal;
exports.hideLibraryVariantModal = hideLibraryVariantModal;
exports.showLibraryInventoryAleryModal = showLibraryInventoryAleryModal;
exports.hideLibraryInventoryAleryModal = hideLibraryInventoryAleryModal;
exports.setPreviousLibraryForm = setPreviousLibraryForm;
exports.onCancelLibraryVariantModal = onCancelLibraryVariantModal;
exports.onConfirmLibraryVariantModal = onConfirmLibraryVariantModal;
exports.onClickBtnStartTracking = onClickBtnStartTracking;
exports.onCancelLibraryInventoryAlertModal = onCancelLibraryInventoryAlertModal;
exports.onConfirmLibraryInventoryAlertModal = onConfirmLibraryInventoryAlertModal;
exports.fillFormDetailLibrary = fillFormDetailLibrary;
exports.getModifiersforLibrary = getModifiersforLibrary;
exports.setModifiers = setModifiers;
exports.setManageLibraryInventoryIds = setManageLibraryInventoryIds;
exports.setActiveModifierIds = setActiveModifierIds;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.deleteLibrary = deleteLibrary;
exports.onClickCreateNewCategory = onClickCreateNewCategory;
exports.showNewCategoryModal = showNewCategoryModal;
exports.hideNewCategoryModal = hideNewCategoryModal;
exports.setNewCategory = setNewCategory;
exports.onConfirmCreateNewCategory = onConfirmCreateNewCategory;
exports.onCancelCreateNewCategory = onCancelCreateNewCategory;
exports.setPreviousCategories = setPreviousCategories;
exports.setPreviousCategoryId = setPreviousCategoryId;
exports.showImportModal = showImportModal;
exports.hideImportModal = hideImportModal;
exports.onSuccessImport = onSuccessImport;
exports.showTrackingCOGSModal = showTrackingCOGSModal;
exports.hideTrackingCOGSModal = hideTrackingCOGSModal;
exports.onClickBtnTrackingCOGS = onClickBtnTrackingCOGS;
exports.onCancelCOGSModal = onCancelCOGSModal;
exports.onConfirmCOGSModal = onConfirmCOGSModal;
exports.showSaveToAllOutletsModal = showSaveToAllOutletsModal;
exports.hideSaveToAllOutletsModal = hideSaveToAllOutletsModal;
exports.setCreatedOutlets = setCreatedOutlets;
exports.showColInputCOGS = showColInputCOGS;
exports.showColInputInventory = showColInputInventory;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(397);

function pageRequest() {
  return { type: _constants.INGREDIENT_LIBRARY_PAGE_REQUEST, payload: {} };
}

function setUnits(units) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_UNITS, payload: { units: units } };
}

function setUncategorized(categories) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_UNCATEGORIZED, payload: { categories: categories } };
}

function storeUncategorized(uncategorized) {
  return { type: _constants.INGREDIENT_LIBRARY_STORE_UNCATEGORIZED, payload: { uncategorized: uncategorized } };
}

function librariesRequest(query, previousLibraries) {
  return { type: _constants.INGREDIENT_LIBRARY_LIST_ITEM_REQUEST, payload: { query: query, previousLibraries: previousLibraries } };
}

function listCategoryRequest() {
  return { type: _constants.INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST, payload: {} };
}

function listCategoryWithUncategorizedRequest() {
  return { type: _constants.INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST, payload: {} };
}

function changeCategoryIdDropdown(categoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN, payload: { categoryId: categoryId } };
}

function changeInventoryIdDropdown(inventoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN, payload: { inventoryId: inventoryId } };
}

function setLibraries(libraries) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_ITEM_LIST, payload: { libraries: libraries } };
}

function setCategories(categories) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_CATEGORY_LIST, payload: { categories: categories } };
}

function setCurrentCategoryId(categoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID, payload: { categoryId: categoryId } };
}

function setCurrentInventoryId(inventoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID, payload: { inventoryId: inventoryId } };
}

function setLibrarySummary(librarySummary) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_ITEM_SUMMARY, payload: { librarySummary: librarySummary } };
}

function setOutlets(outlets) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_OUTLETS, payload: { outlets: outlets } };
}

function setFilterState(categoryId, typeInventoryId, keyword) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_FILTER_STATE, payload: { categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword } };
}

function unSetFilterState() {
  return { type: _constants.INGREDIENT_LIBRARY_UNSET_FILTER_STATE };
}

function setFilterLibrary(categoryId, typeInventoryId, keyword, outletIds) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_FILTER_ITEM, payload: { categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword, outletIds: outletIds } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function libraryExportRequest(prefix, email, outlets, categoryId, inventoryId, keyword) {
  return { type: _constants.INGREDIENT_LIBRARY_ITEM_LIST_EXPORT, payload: { prefix: prefix, email: email, outlets: outlets, categoryId: categoryId, inventoryId: inventoryId, keyword: keyword } };
}

function setImportType(importType) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_TYPE_IMPORT, payload: { importType: importType } };
}

function showSectionUploader(showSectionUploader) {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER, payload: { showSectionUploader: showSectionUploader } };
}

function downloadLibraryTemplate(prefix, email, outlets) {
  return { type: _constants.INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE, payload: { prefix: prefix, email: email, outlets: outlets } };
}

function onClickCreateLibrary(uncategorized) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM, payload: { uncategorized: uncategorized } };
}

function openRightColumn() {
  return { type: _constants.INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN, payload: {} };
}

function setLibraryDetail(library) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_ITEM_DETAIL, payload: { library: library } };
}

function onClickCancel() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_CANCEL, payload: {} };
}

function onClickRow(library) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_ROW, payload: { library: library } };
}

function onDropImage(filesState) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_DROP_IMAGE, payload: { filesState: filesState } };
}

function onDeleteImage(filesState) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_DELETE_IMAGE, payload: { filesState: filesState } };
}

function onClickBtnLibraryVariant(previousLibraryForm) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT, payload: { previousLibraryForm: previousLibraryForm } };
}

function showLibraryVariantModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL, payload: {} };
}

function hideLibraryVariantModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL, payload: {} };
}

function showLibraryInventoryAleryModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

function hideLibraryInventoryAleryModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

function setPreviousLibraryForm(previousLibraryForm) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM, payload: { previousLibraryForm: previousLibraryForm } };
}

function onCancelLibraryVariantModal() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL, payload: {} };
}

function onConfirmLibraryVariantModal() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL, payload: {} };
}

function onClickBtnStartTracking(previousLibraryForm) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING, payload: { previousLibraryForm: previousLibraryForm } };
}

function onCancelLibraryInventoryAlertModal() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

function onConfirmLibraryInventoryAlertModal(libraryInventoryForm, libraryForm) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, payload: { libraryInventoryForm: libraryInventoryForm, libraryForm: libraryForm } };
}

function fillFormDetailLibrary(formatFormDetail) {
  return { type: _constants.INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM, payload: { formatFormDetail: formatFormDetail } };
}

function getModifiersforLibrary(library) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM, payload: { library: library } };
}

function setModifiers(modifiers) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_MODIFIERS, payload: { modifiers: modifiers } };
}

function setManageLibraryInventoryIds(libraryVariant) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY, payload: { libraryVariant: libraryVariant } };
}

function setActiveModifierIds(modifierIds) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS, payload: { modifierIds: modifierIds } };
}

function submitFormCreate(values, allOutlet, libraries, outletId, summary) {
  return { type: _constants.INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE, payload: { values: values, allOutlet: allOutlet, libraries: libraries, outletId: outletId, summary: summary } };
}

function submitFormUpdate(libraryId, values, allOutlet, libraries) {
  return { type: _constants.INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE, payload: { libraryId: libraryId, values: values, allOutlet: allOutlet, libraries: libraries } };
}

function showDeleteModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_DELETE_MODAL, payload: {} };
}

function deleteLibrary(library, previousLibraries, summary) {
  return { type: _constants.INGREDIENT_LIBRARY_DELETE_ITEM, payload: { library: library, previousLibraries: previousLibraries, summary: summary } };
}

function onClickCreateNewCategory(category, previousCategories, previousCategoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY, payload: { category: category, previousCategories: previousCategories, previousCategoryId: previousCategoryId } };
}

function showNewCategoryModal() {
  return { type: _constants.INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL, payload: {} };
}

function hideNewCategoryModal() {
  return { type: _constants.INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL, payload: {} };
}

function setNewCategory(category) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_NEW_CATEGORY, payload: { category: category } };
}

function onConfirmCreateNewCategory(category) {
  return { type: _constants.INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY, payload: { category: category } };
}

function onCancelCreateNewCategory(previousCategories, previousCategoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY, payload: { previousCategories: previousCategories, previousCategoryId: previousCategoryId } };
}

function setPreviousCategories(categories) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES, payload: { categories: categories } };
}

function setPreviousCategoryId(categoryId) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID, payload: { categoryId: categoryId } };
}

function showImportModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL, payload: {} };
}

function hideImportModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL, payload: {} };
}

function onSuccessImport() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT, payload: {} };
}

function showTrackingCOGSModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_COGS_MODAL, payload: {} };
}

function hideTrackingCOGSModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_COGS_MODAL, payload: {} };
}

function onClickBtnTrackingCOGS(previousLibraryForm) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS, payload: { previousLibraryForm: previousLibraryForm } };
}

function onCancelCOGSModal() {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL, payload: {} };
}

function onConfirmCOGSModal(libraryCOGSForm, previousLibraryForm, showInputCOGS) {
  return { type: _constants.INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL, payload: { libraryCOGSForm: libraryCOGSForm, previousLibraryForm: previousLibraryForm, showInputCOGS: showInputCOGS } };
}

function showSaveToAllOutletsModal() {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function hideSaveToAllOutletsModal() {
  return { type: _constants.INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function setCreatedOutlets(createdOutlets) {
  return { type: _constants.INGREDIENT_LIBRARY_SET_CREATED_OUTLETS, payload: { createdOutlets: createdOutlets } };
}

function showColInputCOGS(showInputCOGS) {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_INPUT_COGS, payload: { showInputCOGS: showInputCOGS } };
}

function showColInputInventory(showInputInventory) {
  return { type: _constants.INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY, payload: { showInputInventory: showInputInventory } };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.INGREDIENT_LIBRARY_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.salesPageRequest = salesPageRequest;
exports.salesSummaryRequest = salesSummaryRequest;
exports.setSalesSummary = setSalesSummary;
exports.grossProfitPageRequest = grossProfitPageRequest;
exports.grossProfitRequest = grossProfitRequest;
exports.setGrossProfit = setGrossProfit;
exports.paymentMethodsPageRequest = paymentMethodsPageRequest;
exports.paymentMethodsRequest = paymentMethodsRequest;
exports.setPaymentMethods = setPaymentMethods;
exports.itemSalesPageRequest = itemSalesPageRequest;
exports.itemSalesRequest = itemSalesRequest;
exports.setItemSales = setItemSales;
exports.categorySalesPageRequest = categorySalesPageRequest;
exports.categorySalesRequest = categorySalesRequest;
exports.setCategorySales = setCategorySales;
exports.modifierSalesPageRequest = modifierSalesPageRequest;
exports.modifierSalesRequest = modifierSalesRequest;
exports.setModifierSales = setModifierSales;
exports.discountsPageRequest = discountsPageRequest;
exports.discountsRequest = discountsRequest;
exports.setDiscounts = setDiscounts;
exports.taxesPageRequest = taxesPageRequest;
exports.taxesRequest = taxesRequest;
exports.setTaxes = setTaxes;
exports.gratuityPageRequest = gratuityPageRequest;
exports.gratuityRequest = gratuityRequest;
exports.setGratuity = setGratuity;
exports.collectedByPageRequest = collectedByPageRequest;
exports.collectedByRequest = collectedByRequest;
exports.setCollectedBy = setCollectedBy;
exports.servedByPageRequest = servedByPageRequest;
exports.servedByRequest = servedByRequest;
exports.setServedBy = setServedBy;
exports.changeDateSalesSummary = changeDateSalesSummary;
exports.setStartEndDate = setStartEndDate;
exports.changeDateGrossProfit = changeDateGrossProfit;
exports.setStartEndDateGrossProfit = setStartEndDateGrossProfit;
exports.changeDatePaymentMethods = changeDatePaymentMethods;
exports.setStartEndDatePaymentMethods = setStartEndDatePaymentMethods;
exports.changeDateItemSales = changeDateItemSales;
exports.setStartEndDateItemSales = setStartEndDateItemSales;
exports.changeDateCategorySales = changeDateCategorySales;
exports.setStartEndDateCategorySales = setStartEndDateCategorySales;
exports.changeDateModifierSales = changeDateModifierSales;
exports.setStartEndDateModifierSales = setStartEndDateModifierSales;
exports.changeDateDiscounts = changeDateDiscounts;
exports.setStartEndDateDiscounts = setStartEndDateDiscounts;
exports.changeDateTaxes = changeDateTaxes;
exports.setStartEndDateTaxes = setStartEndDateTaxes;
exports.changeDateGratuity = changeDateGratuity;
exports.setStartEndDateGratuity = setStartEndDateGratuity;
exports.changeDateCollectedBy = changeDateCollectedBy;
exports.setStartEndDateCollectedBy = setStartEndDateCollectedBy;
exports.changeDateServedBy = changeDateServedBy;
exports.setStartEndDateServedBy = setStartEndDateServedBy;
exports.changeOutletSalesSummary = changeOutletSalesSummary;
exports.changeOutletGrossProfit = changeOutletGrossProfit;
exports.changeOutletPaymentMethods = changeOutletPaymentMethods;
exports.changeOutletItemSales = changeOutletItemSales;
exports.changeOutletCategorySales = changeOutletCategorySales;
exports.changeOutletModifierSales = changeOutletModifierSales;
exports.changeOutletDiscounts = changeOutletDiscounts;
exports.changeOutletTaxes = changeOutletTaxes;
exports.changeOutletGratuity = changeOutletGratuity;
exports.changeOutletCollectedBy = changeOutletCollectedBy;
exports.changeOutletServedBy = changeOutletServedBy;
exports.exportSummary = exportSummary;
exports.exportGrossProfit = exportGrossProfit;
exports.exportPaymentMethod = exportPaymentMethod;
exports.exportItemSales = exportItemSales;
exports.exportCategorySales = exportCategorySales;
exports.exportModifierSales = exportModifierSales;
exports.exportDiscount = exportDiscount;
exports.exportTaxes = exportTaxes;
exports.exportGratuity = exportGratuity;
exports.exportCollectedBy = exportCollectedBy;
exports.exportServedBy = exportServedBy;
exports.setOutlets = setOutlets;
exports.reportsShowLoadingSpinner = reportsShowLoadingSpinner;

var _constants = __webpack_require__(415);

function salesPageRequest() {
  return { type: _constants.REPORTS_SALES_PAGE_REQUEST, payload: {} };
}

/**
 *
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function salesSummaryRequest(query) {
  return { type: _constants.REPORTS_SALES_SUMMARY_REQUEST, payload: query };
}

function setSalesSummary(sales) {
  return { type: _constants.REPORTS_SET_LIST_SALES_SUMMARY, payload: { sales: sales } };
}

function grossProfitPageRequest() {
  return { type: _constants.REPORTS_GROSS_PROFIT_PAGE_REQUEST, payload: {} };
}

function grossProfitRequest(query) {
  return { type: _constants.REPORTS_GROSS_PROFIT_REQUEST, payload: query };
}

function setGrossProfit(grossProfit) {
  return { type: _constants.REPORTS_SET_LIST_GROSS_PROFIT, payload: { grossProfit: grossProfit } };
}

function paymentMethodsPageRequest() {
  return { type: _constants.REPORTS_PAYMENT_METHODS_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function paymentMethodsRequest(query) {
  return { type: _constants.REPORTS_PAYMENT_METHODS_REQUEST, payload: query };
}

function setPaymentMethods(paymentMethods) {
  return { type: _constants.REPORTS_SET_PAYMENT_METHODS, payload: { paymentMethods: paymentMethods } };
}

function itemSalesPageRequest() {
  return { type: _constants.REPORTS_ITEM_SALES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function itemSalesRequest(query) {
  return { type: _constants.REPORTS_ITEM_SALES_REQUEST, payload: query };
}

function setItemSales(itemSales) {
  return { type: _constants.REPORTS_SET_ITEM_SALES, payload: { itemSales: itemSales } };
}

function categorySalesPageRequest() {
  return { type: _constants.REPORTS_CATEGORY_SALES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function categorySalesRequest(query) {
  return { type: _constants.REPORTS_CATEGORY_SALES_REQUEST, payload: query };
}

function setCategorySales(categorySales) {
  return { type: _constants.REPORTS_SET_CATEGORY_SALES, payload: { categorySales: categorySales } };
}

function modifierSalesPageRequest() {
  return { type: _constants.REPORTS_MODIFIER_SALES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function modifierSalesRequest(query) {
  return { type: _constants.REPORTS_MODIFIER_SALES_REQUEST, payload: query };
}

function setModifierSales(modifierSales) {
  return { type: _constants.REPORTS_SET_MODIFIER_SALES, payload: { modifierSales: modifierSales } };
}

function discountsPageRequest() {
  return { type: _constants.REPORTS_DISCOUNTS_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function discountsRequest(query) {
  return { type: _constants.REPORTS_DISCOUNTS_REQUEST, payload: query };
}

function setDiscounts(discounts) {
  return { type: _constants.REPORTS_SET_DISCOUNTS, payload: { discounts: discounts } };
}

function taxesPageRequest() {
  return { type: _constants.REPORTS_TAXES_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function taxesRequest(query) {
  return { type: _constants.REPORTS_TAXES_REQUEST, payload: query };
}

function setTaxes(taxes) {
  return { type: _constants.REPORTS_SET_TAXES, payload: { taxes: taxes } };
}

function gratuityPageRequest() {
  return { type: _constants.REPORTS_GRATUITY_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function gratuityRequest(query) {
  return { type: _constants.REPORTS_GRATUITY_REQUEST, payload: query };
}

function setGratuity(gratuities) {
  return { type: _constants.REPORTS_SET_GRATUITY, payload: { gratuities: gratuities } };
}

function collectedByPageRequest() {
  return { type: _constants.REPORTS_COLLECTEDBY_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function collectedByRequest(query) {
  return { type: _constants.REPORTS_COLLECTEDBY_REQUEST, payload: query };
}

function setCollectedBy(staffs) {
  return { type: _constants.REPORTS_SET_COLLECTEDBY, payload: { staffs: staffs } };
}

function servedByPageRequest() {
  return { type: _constants.REPORTS_SERVEDBY_PAGE_REQUEST, payload: {} };
}

/**
 * @param {startDate, endDate} query
 * @returns {{type, payload: *}}
 */
function servedByRequest(query) {
  return { type: _constants.REPORTS_SERVEDBY_REQUEST, payload: query };
}

function setServedBy(servers) {
  return { type: _constants.REPORTS_SET_SERVEDBY, payload: { servers: servers } };
}

function changeDateSalesSummary(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_SUMMARY_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDate(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_SUMMARY_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateGrossProfit(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateGrossProfit(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDatePaymentMethods(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDatePaymentMethods(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateItemSales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_ITEM_SALES_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateItemSales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_ITEM_SALES_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateCategorySales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateCategorySales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateModifierSales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateModifierSales(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateDiscounts(startDate, endDate, outletIds) {
  return { type: _constants.REPORTS_SALES_DISCOUNTS_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, outletIds: outletIds } };
}

function setStartEndDateDiscounts(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_DISCOUNTS_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateTaxes(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_TAXES_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateTaxes(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_TAXES_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateGratuity(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_GRATUITY_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateGratuity(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_GRATUITY_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateCollectedBy(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_COLLECTEDBY_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateCollectedBy(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeDateServedBy(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_SERVEDBY_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setStartEndDateServedBy(startDate, endDate) {
  return { type: _constants.REPORTS_SALES_SERVEDBY_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function changeOutletSalesSummary(filter) {
  return { type: _constants.REPORTS_SALES_SUMMARY_CHANGE_OUTLET, payload: filter };
}

function changeOutletGrossProfit(filter) {
  return { type: _constants.REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET, payload: filter };
}

function changeOutletPaymentMethods(filter) {
  return { type: _constants.REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET, payload: filter };
}

function changeOutletItemSales(filter) {
  return { type: _constants.REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET, payload: filter };
}

function changeOutletCategorySales(filter) {
  return { type: _constants.REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET, payload: filter };
}

function changeOutletModifierSales(filter) {
  return { type: _constants.REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET, payload: filter };
}

function changeOutletDiscounts(filter) {
  return { type: _constants.REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET, payload: filter };
}

function changeOutletTaxes(filter) {
  return { type: _constants.REPORTS_SALES_TAXES_CHANGE_OUTLET, payload: filter };
}

function changeOutletGratuity(filter) {
  return { type: _constants.REPORTS_SALES_GRATUITY_CHANGE_OUTLET, payload: filter };
}

function changeOutletCollectedBy(filter) {
  return { type: _constants.REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET, payload: filter };
}

function changeOutletServedBy(filter) {
  return { type: _constants.REPORTS_SALES_SERVEDBY_CHANGE_OUTLET, payload: filter };
}

function exportSummary(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_SUMMARY, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportGrossProfit(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_GROSS_PROFIT, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportPaymentMethod(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_PAYMENT_METHODS, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportItemSales(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_ITEM_SALES, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportCategorySales(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_CATEGORY_SALES, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportModifierSales(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_MODIFIER_SALES, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportDiscount(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_DISCOUNTS, payload: { query: query, filename: filename } };
}

function exportTaxes(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_TAXES, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportGratuity(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_GRATUITY, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportCollectedBy(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_COLECTEDBY, payload: { query: query, filename: filename, outletId: outletId } };
}

function exportServedBy(query, filename, outletId) {
  return { type: _constants.REPORTS_SALES_EXPORT_SERVEDBY, payload: { query: query, filename: filename, outletId: outletId } };
}

function setOutlets(outlets) {
  return { type: _constants.REPORTS_SALES_SET_OUTLETS, payload: { outlets: outlets } };
}

function reportsShowLoadingSpinner(showLoadingSpinnerReport) {
  return { type: _constants.REPORTS_SALES_SHOW_LOADING_SPINNER, payload: { showLoadingSpinnerReport: showLoadingSpinnerReport } };
}

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setOutlets = setOutlets;
exports.outletsRequest = outletsRequest;
exports.modifiersRequest = modifiersRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onClickCreateModifier = onClickCreateModifier;
exports.onClickRow = onClickRow;
exports.onClickCancel = onClickCancel;
exports.setModifiers = setModifiers;
exports.setModifierDetail = setModifierDetail;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteModifier = deleteModifier;
exports.cancelDeleteModifier = cancelDeleteModifier;
exports.showDeleteModifierModal = showDeleteModifierModal;
exports.hideDeleteModifierModal = hideDeleteModifierModal;
exports.setDeletedModifier = setDeletedModifier;
exports.askDeleteModifier = askDeleteModifier;
exports.onClickApplySetItem = onClickApplySetItem;
exports.cancelApplySetItem = cancelApplySetItem;
exports.confirmApplySetItem = confirmApplySetItem;
exports.showApplySetItem = showApplySetItem;
exports.hideApplySetItemModal = hideApplySetItemModal;
exports.applySetItemSetItems = applySetItemSetItems;
exports.applySetItemFillForm = applySetItemFillForm;
exports.applySetItemSetCurrentPage = applySetItemSetCurrentPage;
exports.applySetItemSetTotalPage = applySetItemSetTotalPage;
exports.applySetItemItemsRequest = applySetItemItemsRequest;
exports.fillModifierForm = fillModifierForm;
exports.emptyModifierForm = emptyModifierForm;
exports.showModifierOptionsModal = showModifierOptionsModal;
exports.hideModifierOptionsModal = hideModifierOptionsModal;
exports.onClickManageModifierOptions = onClickManageModifierOptions;
exports.onCancelManageModifierOptions = onCancelManageModifierOptions;
exports.onConfirmManageModifierOptions = onConfirmManageModifierOptions;
exports.setPreviousModifierForm = setPreviousModifierForm;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(409);

function pageRequest() {
  return { type: _constants.LIBRARY_MODIFIER_PAGE_REQUEST, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_MODIFIER_SET_OUTLETS, payload: { outlets: outlets } };
}

function outletsRequest(params) {
  return { type: _constants.LIBRARY_MODIFIER_OUTLETS_REQUEST, payload: { params: params } };
}

function modifiersRequest(params, previousModifiers) {
  return { type: _constants.LIBRARY_MODIFIER_MODIFIERS_REQUEST, payload: { params: params, previousModifiers: previousModifiers } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function onClickCreateModifier() {
  return { type: _constants.LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER, payload: {} };
}

function onClickRow(modifier) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CLICK_ROW, payload: { modifier: modifier } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_MODIFIER_ON_CLICK_CANCEL, payload: {} };
}

function setModifiers(modifiers) {
  return { type: _constants.LIBRARY_MODIFIER_SET_MODIFIERS, payload: { modifiers: modifiers } };
}

function setModifierDetail(modifier) {
  return { type: _constants.LIBRARY_MODIFIER_SET_MODIFIER_DETAIL, payload: { modifier: modifier } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_MODIFIER_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_MODIFIER_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function submitFormCreate(data, previousModifiers) {
  return { type: _constants.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE, payload: { data: data, previousModifiers: previousModifiers } };
}

function submitFormCreateAllOutlet(data, previousModifiers) {
  return { type: _constants.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET, payload: { data: data, previousModifiers: previousModifiers } };
}

function submitFormUpdate(modifierId, data, previousModifiers) {
  return { type: _constants.LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE, payload: { modifierId: modifierId, data: data, previousModifiers: previousModifiers } };
}

function deleteModifier(modifierId, previousModifiers) {
  return { type: _constants.LIBRARY_MODIFIER_DELETE_MODIFIER, payload: { modifierId: modifierId, previousModifiers: previousModifiers } };
}

function cancelDeleteModifier() {
  return { type: _constants.LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER, payload: {} };
}

function showDeleteModifierModal() {
  return { type: _constants.LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL, payload: {} };
}

function hideDeleteModifierModal() {
  return { type: _constants.LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL, payload: {} };
}

function setDeletedModifier(deletedModifier) {
  return { type: _constants.LIBRARY_MODIFIER_SET_DELETED_MODIFIER, payload: { deletedModifier: deletedModifier } };
}

function askDeleteModifier(deletedModifier) {
  return { type: _constants.LIBRARY_MODIFIER_ASK_DELETE_MODIFIER, payload: { deletedModifier: deletedModifier } };
}

function onClickApplySetItem(modifier) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM, payload: { modifier: modifier } };
}

function cancelApplySetItem() {
  return { type: _constants.LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM, payload: {} };
}

function confirmApplySetItem(data, modifierId) {
  return { type: _constants.LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM, payload: { data: data, modifierId: modifierId } };
}

function showApplySetItem() {
  return { type: _constants.LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL, payload: {} };
}

function hideApplySetItemModal() {
  return { type: _constants.LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL, payload: {} };
}

function applySetItemSetItems(items) {
  return { type: _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS, payload: { items: items } };
}

function applySetItemFillForm(modifier) {
  return { type: _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM, payload: { modifier: modifier } };
}

function applySetItemSetCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function applySetItemSetTotalPage(totalPage) {
  return { type: _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function applySetItemItemsRequest(params, previousItems) {
  return { type: _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST, payload: { params: params, previousItems: previousItems } };
}

function fillModifierForm(modifier) {
  return { type: _constants.LIBRARY_MODIFIER_FILL_MODIFIER_FORM, payload: { modifier: modifier } };
}

function emptyModifierForm() {
  return { type: _constants.LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM, payload: {} };
}

function showModifierOptionsModal() {
  return { type: _constants.LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL, payload: {} };
}

function hideModifierOptionsModal() {
  return { type: _constants.LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL, payload: {} };
}

function onClickManageModifierOptions(previousModifierForm) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS, payload: { previousModifierForm: previousModifierForm } };
}

function onCancelManageModifierOptions(previousModifierForm) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS, payload: { previousModifierForm: previousModifierForm } };
}

function onConfirmManageModifierOptions(options) {
  return { type: _constants.LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS, payload: { options: options } };
}

function setPreviousModifierForm(previousModifierForm) {
  return { type: _constants.LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM, payload: { previousModifierForm: previousModifierForm } };
}

function openRightColumn() {
  return { type: _constants.LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_MODIFIER_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(1986);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarReports = function (_React$Component) {
  (0, _inherits3.default)(SidebarReports, _React$Component);

  function SidebarReports() {
    (0, _classCallCheck3.default)(this, SidebarReports);
    return (0, _possibleConstructorReturn3.default)(this, (SidebarReports.__proto__ || (0, _getPrototypeOf2.default)(SidebarReports)).apply(this, arguments));
  }

  (0, _createClass3.default)(SidebarReports, [{
    key: 'render',
    value: function render() {
      var path = this.props.location.pathname;
      var statusLabelNew = Cookies.get('labelNew') === undefined || Cookies.get('labelNew') === 'true';
      return React.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 ' + _style2.default['slideMenu'] + ' ' + this.props.elementClass, id: 'sideMenu' },
        React.createElement(
          'div',
          { className: _style2.default.hide },
          React.createElement(
            'div',
            { className: 'mk-sidebar-box' },
            React.createElement(
              'ul',
              { className: 'mk-side-nav ' + _style2.default['side-list'] },
              React.createElement(
                'li',
                { className: 'head visible-sm visible-xs text-bold', onClick: this.props.onToggle },
                'Side Menu',
                React.createElement('i', { className: 'fa fa-close pull-right', id: 'close-menu' })
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/summary') || path === '/reports' ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/summary' },
                  'Sales Summary'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/gross_profit') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/gross_profit' },
                  'Gross Profit ',
                  statusLabelNew && React.createElement(
                    'span',
                    { className: _style2.default.box_center },
                    'NEW'
                  )
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/payment_methods') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/payment_methods' },
                  'Payment Methods'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/item_sales') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/item_sales' },
                  'Item Sales'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/category_sales') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/category_sales' },
                  'Category Sales'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/modifier_sales') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/modifier_sales' },
                  'Modifier Sales'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/discounts') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/discounts' },
                  'Discounts'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/taxes') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/taxes' },
                  'Taxes'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/gratuity') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/gratuity' },
                  'Gratuity'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/staff') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/staff' },
                  'Collected By'
                )
              ),
              React.createElement(
                'li',
                { className: path.startsWith('/reports/server') ? 'active' : '' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/reports/server' },
                  'Served By'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SidebarReports;
}(React.Component);

exports.default = SidebarReports;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _ActionBar = __webpack_require__(2212);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _OutletModal = __webpack_require__(241);

var _OutletModal2 = _interopRequireDefault(_OutletModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function (outletIds) {
      _this.props.onChangeOutlet(outletIds);
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      _this.props.onChangeDate({ startDate: startDate, endDate: endDate });
    }, _this._onClickExportButton = function () {
      _this.props.onExport();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          showModalOutletMobileState = _props.showModalOutletMobileState;

      return React.createElement(
        'div',
        { className: 'mk-action-bar' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-12 col-md-9' },
            React.createElement(
              'div',
              { className: 'visible-md visible-lg pull-left mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutlet,
                name: 'outlet',
                allOutletOption: true
              })
            ),
            React.createElement(
              'div',
              { className: 'pull-left' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                onChange: this._onChangeDate,
                updateServerOnChange: true
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-3 col-xs-2 visible-md visible-lg' },
            React.createElement(
              'a',
              { className: 'pull-right btn btn-primary export-button', onClick: this._onClickExportButton, id: _ActionBar2.default.export },
              'Export'
            )
          ),
          React.createElement(_reduxForm.Field, {
            component: _OutletModal2.default,
            name: 'outlet',
            outlets: outlets || [],
            onChangeOutletIds: this._onChangeOutlet,
            allOutletOption: true,
            show: showModalOutletMobileState
          })
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  return {
    outlets: state.reports.sales.outlets,
    showModalOutletMobileState: state.moka.showModalOutletMobile
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func,
  onChangeDate: React.PropTypes.func,
  onExport: React.PropTypes.func
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1665), __esModule: true };

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (true) {
  var ReactDebugTool = __webpack_require__(871);
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showTaxAssignToItemModal = showTaxAssignToItemModal;
exports.hideTaxAssignToItemModal = hideTaxAssignToItemModal;
exports.onClickTaxAssignToItem = onClickTaxAssignToItem;
exports.taxAssignToItemFillForm = taxAssignToItemFillForm;
exports.taxAssignToItemSetItems = taxAssignToItemSetItems;
exports.taxAssignToItemSetCurrentPage = taxAssignToItemSetCurrentPage;
exports.taxAssignToItemSetTotalPage = taxAssignToItemSetTotalPage;
exports.taxAssignToItemSetTotalCount = taxAssignToItemSetTotalCount;
exports.taxAssignToItemItemsRequest = taxAssignToItemItemsRequest;
exports.cancelTaxAssignToItem = cancelTaxAssignToItem;
exports.confirmTaxAssignToItem = confirmTaxAssignToItem;
exports.taxAssignToItemSelectAllNone = taxAssignToItemSelectAllNone;
exports.taxAssignToItemToggleOne = taxAssignToItemToggleOne;
exports.setSetting = setSetting;
exports.showSaveToAllOutletsModal = showSaveToAllOutletsModal;
exports.hideSaveToAllOutletsModal = hideSaveToAllOutletsModal;
exports.checkSelectAllTaxItems = checkSelectAllTaxItems;
exports.uncheckSelectAllTaxItems = uncheckSelectAllTaxItems;
exports.setCategories = setCategories;
exports.setCreatedOutlets = setCreatedOutlets;
exports.taxesPageRequest = taxesPageRequest;
exports.taxesRequest = taxesRequest;
exports.setListTaxes = setListTaxes;
exports.onChangeOutletIds = onChangeOutletIds;
exports.setOutlets = setOutlets;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.onClickCreateTax = onClickCreateTax;
exports.onClickRow = onClickRow;
exports.setTaxDetail = setTaxDetail;
exports.onClickCancel = onClickCancel;
exports.submitFormUpdate = submitFormUpdate;
exports.submitFormCreate = submitFormCreate;
exports.setDeletedTax = setDeletedTax;
exports.deleteTaxRequest = deleteTaxRequest;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.cancelDelete = cancelDelete;
exports.deleteTax = deleteTax;
exports.submitFormCreateAllOutlets = submitFormCreateAllOutlets;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(410);

function showTaxAssignToItemModal() {
  return { type: _constants.LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

function hideTaxAssignToItemModal() {
  return { type: _constants.LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

function onClickTaxAssignToItem(tax, categoryId) {
  return { type: _constants.LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM, payload: { tax: tax, categoryId: categoryId } };
}

function taxAssignToItemFillForm(tax, categoryId) {
  if (!categoryId) {
    categoryId = 0;
  }
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM, payload: { tax: tax, categoryId: categoryId } };
}

function taxAssignToItemSetItems(items) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS, payload: { items: items } };
}

function taxAssignToItemSetCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function taxAssignToItemSetTotalPage(totalPage) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function taxAssignToItemSetTotalCount(totalCount) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT, payload: { totalCount: totalCount } };
}

function taxAssignToItemItemsRequest(params, previousItems) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST, payload: { params: params, previousItems: previousItems } };
}

function cancelTaxAssignToItem(taxDetail, url) {
  return { type: _constants.LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM, payload: { taxDetail: taxDetail, url: url } };
}

function confirmTaxAssignToItem(taxDetail, tax) {
  return { type: _constants.LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM, payload: { taxDetail: taxDetail, tax: tax } };
}

function taxAssignToItemSelectAllNone(businessId, outletId, taxDetail, itemIds, categoryId, keyword, selectAll) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE, payload: { businessId: businessId, outletId: outletId, taxDetail: taxDetail, itemIds: itemIds, categoryId: categoryId, keyword: keyword, selectAll: selectAll } };
}

function taxAssignToItemToggleOne(taxDetail, item, add) {
  return { type: _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE, payload: { taxDetail: taxDetail, item: item, add: add } };
}

function setSetting(setting) {
  return { type: _constants.LIBRARY_TAXES_SET_SETTING, payload: { setting: setting } };
}

function showSaveToAllOutletsModal() {
  return { type: _constants.LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function hideSaveToAllOutletsModal() {
  return { type: _constants.LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function checkSelectAllTaxItems() {
  return { type: _constants.LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS, payload: {} };
}

function uncheckSelectAllTaxItems() {
  return { type: _constants.LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS, payload: {} };
}

function setCategories(categories) {
  return { type: _constants.LIBRARY_TAXES_SET_CATEGORY_LIST, payload: { categories: categories } };
}

function setCreatedOutlets(createdOutlets) {
  return { type: _constants.LIBRARY_TAXES_SET_CREATED_OUTLETS, payload: { createdOutlets: createdOutlets } };
}

function taxesPageRequest() {
  return { type: _constants.LIBRARY_TAXES_PAGE_REQUEST, payload: {} };
}

function taxesRequest(params, previousTaxes) {
  return { type: _constants.LIBRARY_TAXES_LIST_REQUEST, payload: { params: params, previousTaxes: previousTaxes } };
}

function setListTaxes(taxes) {
  return { type: _constants.LIBRARY_TAXES_SET_LIST_TAXES, payload: { taxes: taxes } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_TAXES_SET_OUTLETS, payload: { outlets: outlets } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_TAXES_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_TAXES_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function onClickCreateTax() {
  return { type: _constants.LIBRARY_TAXES_ON_CLICK_CREATE_TAX, payload: {} };
}

function onClickRow(tax) {
  return { type: _constants.LIBRARY_TAXES_ON_CLICK_ROW, payload: { tax: tax } };
}

function setTaxDetail(tax) {
  return { type: _constants.LIBRARY_TAXES_SET_TAX_DETAIL, payload: { tax: tax } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_TAXES_ON_CLICK_CANCEL, payload: {} };
}

function submitFormUpdate(id, data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return { type: _constants.LIBRARY_TAXES_SUBMIT_FORM_UPDATE, payload: { id: id, data: data, previousTaxes: previousTaxes, itemIds: itemIds, selectedOutletIds: selectedOutletIds, outlets: outlets } };
}

function submitFormCreate(data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return { type: _constants.LIBRARY_TAXES_SUBMIT_FORM_CREATE, payload: { data: data, previousTaxes: previousTaxes, itemIds: itemIds, selectedOutletIds: selectedOutletIds, outlets: outlets } };
}

function setDeletedTax(deletedTax) {
  return { type: _constants.LIBRARY_TAXES_SET_DELETED_TAX, payload: { deletedTax: deletedTax } };
}

function deleteTaxRequest(deletedTax) {
  return { type: _constants.LIBRARY_TAXES_DELETE_TAX_REQUEST, payload: { deletedTax: deletedTax } };
}

function showDeleteModal() {
  return { type: _constants.LIBRARY_TAXES_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.LIBRARY_TAXES_HIDE_DELETE_MODAL, payload: {} };
}

function cancelDelete() {
  return { type: _constants.LIBRARY_TAXES_CANCEL_DELETE, payload: {} };
}

function deleteTax(id, previousTaxes, taxDetail, categories) {
  return { type: _constants.LIBRARY_TAXES_DELETE_TAX, payload: { id: id, previousTaxes: previousTaxes, taxDetail: taxDetail, categories: categories } };
}

function submitFormCreateAllOutlets(data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return { type: _constants.LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS, payload: { data: data, previousTaxes: previousTaxes, itemIds: itemIds, selectedOutletIds: selectedOutletIds, outlets: outlets } };
}

function openRightColumn() {
  return { type: _constants.LIBRARY_TAXES_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.LIBRARY_TAXES_CLOSE_RIGHT_COLUMN, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_TAXES_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _Toggle = __webpack_require__(1135);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _MonthSelectBox = __webpack_require__(1133);

var _MonthSelectBox2 = _interopRequireDefault(_MonthSelectBox);

var _RangeBox = __webpack_require__(1134);

var _RangeBox2 = _interopRequireDefault(_RangeBox);

var _DateBox = __webpack_require__(1132);

var _DateBox2 = _interopRequireDefault(_DateBox);

var _ApplyBox = __webpack_require__(1131);

var _ApplyBox2 = _interopRequireDefault(_ApplyBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _DropdownCalendar = __webpack_require__(1954);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _updateFilteredDate = __webpack_require__(240);

var apiUpdateFilteredDate = _interopRequireWildcard(_updateFilteredDate);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownCalendar = function (_React$Component) {
  (0, _inherits3.default)(DropdownCalendar, _React$Component);

  function DropdownCalendar(props) {
    (0, _classCallCheck3.default)(this, DropdownCalendar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DropdownCalendar.__proto__ || (0, _getPrototypeOf2.default)(DropdownCalendar)).call(this, props));

    _this._onClickToggle = function () {
      var open = _this.state.open;

      _this.setState({ open: !open });
    };

    _this._onToggleDropdown = function (newValue) {
      if (_this._forceOpen) {
        _this.setState({ open: true });
        _this._forceOpen = false;
      } else {
        _this.setState({ open: newValue });
      }
    };

    _this._onClickPrevButton = function (e) {
      var diff = Math.abs(_this.state.startDate.diff(_this.state.endDate, 'days'));
      var newStartDate = void 0;
      var newEndDate = void 0;
      // if same, it means the startdate and enddate is same, and adjust it to -1
      if (diff === 0) {
        newStartDate = (0, _moment2.default)(_this.state.startDate).add(-1, 'days');
        newEndDate = (0, _moment2.default)(_this.state.endDate).add(-1, 'days');
      } else {
        newEndDate = (0, _moment2.default)(_this.state.startDate);
        newStartDate = (0, _moment2.default)(_this.state.startDate).add(-diff, 'days');
      }
      newStartDate.startOf('days');
      newEndDate.startOf('days');
      _this._reduxFormOnChange({ startDate: newStartDate, endDate: newEndDate });
    };

    _this._onClickNextButton = function (e) {
      if (_this._disableNextButton()) {
        return false;
      }
      // get difference
      var diff = Math.abs(_this.state.startDate.diff(_this.state.endDate, 'days'));
      var newStartDate = void 0;
      var newEndDate = void 0;
      if (diff === 0) {
        newStartDate = (0, _moment2.default)(_this.state.startDate).add(1, 'days');
        newEndDate = (0, _moment2.default)(_this.state.endDate).add(1, 'days');
      } else {
        newStartDate = (0, _moment2.default)(_this.state.endDate);
        newEndDate = (0, _moment2.default)(_this.state.endDate).add(diff, 'days');
      }
      // avoid out of range value
      if (newEndDate.isAfter((0, _moment2.default)(), 'day')) {
        newEndDate = (0, _moment2.default)();
      }
      if (newStartDate.isAfter(newEndDate, 'day')) {
        newStartDate = (0, _moment2.default)(newEndDate).add(-1, 'days');
      }
      newStartDate.startOf('days');
      newEndDate.startOf('days');
      _this._reduxFormOnChange({ startDate: newStartDate, endDate: newEndDate });
    };

    _this._onClickApply = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      _this.setState({ open: false });
      _this._forceOpen = false;
      _this._reduxFormOnChange({ startDate: startDate, endDate: endDate });
    };

    _this._onClickRangeBox = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      _this.setState({ open: false });
      _this._forceOpen = false;
      _this._reduxFormOnChange({ startDate: startDate, endDate: endDate });
    };

    _this._onChangeDateBox = function (_ref3) {
      var startDate = _ref3.startDate,
          endDate = _ref3.endDate;

      _this.setState({ startDate: startDate, endDate: endDate });
    };

    _this._onChangeMonthSelectBox = function (_ref4) {
      var year = _ref4.year,
          month = _ref4.month;

      _this.setState({ year: year, month: month });
    };

    _this._disableNextButton = function () {
      return !(0, _moment2.default)(_this.state.endDate).isBefore((0, _moment2.default)(), 'days');
    };

    _this._reduxFormOnChange = function (_ref5) {
      var startDate = _ref5.startDate,
          endDate = _ref5.endDate;
      var _this$props = _this.props,
          onChange = _this$props.input.onChange,
          updateServerOnChange = _this$props.updateServerOnChange,
          onDirtyFormCallback = _this$props.onDirtyFormCallback,
          isDirtyForm = _this$props.isDirtyForm;

      if (updateServerOnChange) {
        // call api without worry about its result
        var apiFunction = apiUpdateFilteredDate.updateFilteredDate;
        apiFunction({ from: (0, _moment2.default)(startDate).format('D/M/YYYY'), to: (0, _moment2.default)(endDate).format('D/M/YYYY') });
      }
      if (isDirtyForm) {
        onDirtyFormCallback({ startDate: startDate, endDate: endDate });
      } else {
        onChange({ startDate: startDate, endDate: endDate });
      }
    };

    _this.state = {
      open: false,
      startDate: null,
      endDate: null,
      month: null,
      year: null
    };
    return _this;
  }

  (0, _createClass3.default)(DropdownCalendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = nextProps.input;

      if (input) {
        var value = input.value;
        var _state = this.state,
            startDate = _state.startDate,
            endDate = _state.endDate;

        if (!startDate || !(0, _moment2.default)(value.startDate).isSame(startDate)) {
          startDate = (0, _moment2.default)(value.startDate).startOf('days');
          this.setState({
            month: startDate.month(),
            year: startDate.year()
          });
        }
        if (!endDate || !(0, _moment2.default)(value.endDate).isSame(endDate)) {
          endDate = (0, _moment2.default)(value.endDate).startOf('days');
        }
        this.setState({
          startDate: startDate,
          endDate: endDate
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Don't remove this code, this code for https://mokapos.atlassian.net/browse/FD-38#comment-34124 (first comment)
      $('div#dropdown-box-calendar ul.dropdown-menu li a[role="menuitem"]').removeAttr('href');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: _DropdownCalendar2.default.wrapper, id: 'dropdown-box-calendar' },
        React.createElement(
          _reactBootstrap.Dropdown,
          { id: 'dropdown-group', open: this.state.open, onToggle: this._onToggleDropdown },
          React.createElement(
            'div',
            { className: 'btn-group' },
            React.createElement(
              'a',
              { className: 'btn btn-default ' + _DropdownCalendar2.default['btn-prev-day'], onClick: this._onClickPrevButton },
              React.createElement('i', { className: 'fa fa-angle-left' })
            ),
            React.createElement(_Toggle2.default, {
              bsRole: 'toggle',
              startDate: this.state.startDate,
              endDate: this.state.endDate,
              onClick: this._onClickToggle
            })
          ),
          React.createElement(
            'a',
            {
              disabled: this._disableNextButton(),
              className: 'btn btn-default ' + _DropdownCalendar2.default['btn-next-day'],
              onClick: this._onClickNextButton,
              type: 'button' },
            React.createElement('i', { className: 'fa fa-angle-right' })
          ),
          React.createElement(
            _reactBootstrap.Dropdown.Menu,
            { bsRole: 'menu' },
            React.createElement(
              _reactBootstrap.MenuItem,
              { bsClass: 'menu-item dropdown', onClick: function onClick() {
                  _this2._forceOpen = true;
                } },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-sm-12' },
                  React.createElement(
                    'div',
                    { className: 'col-sm-8 element-non-mobi' },
                    React.createElement(_ApplyBox2.default, { onApply: this._onClickApply, startDate: this.state.startDate, endDate: this.state.endDate }),
                    React.createElement(_MonthSelectBox2.default, { month: this.state.month, year: this.state.year, onChange: this._onChangeMonthSelectBox }),
                    React.createElement(_DateBox2.default, { startDate: this.state.startDate,
                      endDate: this.state.endDate,
                      month: this.state.month,
                      year: this.state.year,
                      onChange: this._onChangeDateBox })
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-sm-4 element-non-mobi' },
                    React.createElement(_RangeBox2.default, { onChange: this._onClickRangeBox })
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-sm-12 element-mobi' },
                    React.createElement(_RangeBox2.default, { onChange: this._onClickRangeBox })
                  )
                )
              )
            )
          )
        )
      );
    }

    /**
     * Wrapper for redux form on change
     * place before and after action in this method
     * @private
     */

  }]);
  return DropdownCalendar;
}(React.Component);

DropdownCalendar.propTypes = {
  input: React.PropTypes.object,
  updateServerOnChange: React.PropTypes.bool
};

exports.default = DropdownCalendar;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getProfile = getProfile;

var _auth = __webpack_require__(237);

var auth = _interopRequireWildcard(_auth);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getProfile].map(_regenerator2.default.mark);

function getProfile() {
  var response;
  return _regenerator2.default.wrap(function getProfile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(auth.getProfile);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          _context.prev = 15;
          _context.next = 18;
          return (0, _effects.put)(action.sendingRequest(false));

        case 18:
          _context.next = 20;
          return (0, _effects.put)(action.hideProgressBar());

        case 20:
          return _context.finish(15);

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 15, 21]]);
}

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(223);

var ReactCurrentOwner = __webpack_require__(163);

var invariant = __webpack_require__(195);
var warning = __webpack_require__(196);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   true ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  true ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  true ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  true ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  true ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  true ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  true ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.categoriesRequest = categoriesRequest;
exports.setCategories = setCategories;
exports.setOutlets = setOutlets;
exports.setCategoryDetail = setCategoryDetail;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeKeyword = onChangeKeyword;
exports.onClickCreateCategory = onClickCreateCategory;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.onClickRow = onClickRow;
exports.onClickCancel = onClickCancel;
exports.submitForm = submitForm;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.deleteCategory = deleteCategory;
exports.onClickAssignToIngredient = onClickAssignToIngredient;
exports.showAssignToIngredientModal = showAssignToIngredientModal;
exports.hideAssignToIngredientModal = hideAssignToIngredientModal;
exports.cancelAssignToIngredient = cancelAssignToIngredient;
exports.assignToIngredientSetIngredients = assignToIngredientSetIngredients;
exports.assignToIngredientSetCurrentPage = assignToIngredientSetCurrentPage;
exports.assignToIngredientSetTotalPage = assignToIngredientSetTotalPage;
exports.assignToIngredientGetIngredientsRequest = assignToIngredientGetIngredientsRequest;
exports.submitAssignToIngredient = submitAssignToIngredient;
exports.assignToIngredientFillForm = assignToIngredientFillForm;
exports.assignToIngredientSetCategory = assignToIngredientSetCategory;
exports.setIsSubmitting = setIsSubmitting;

var _constants = __webpack_require__(395);

function pageRequest() {
  return { type: _constants.INGREDIENT_CATEGORY_PAGE_REQUEST, payload: {} };
}

function categoriesRequest(query, previousCategories) {
  return { type: _constants.INGREDIENT_CATEGORY_CATEGORIES_REQUEST, payload: { query: query, previousCategories: previousCategories } };
}

function setCategories(categories) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_CATEGORIES, payload: { categories: categories } };
}

function setOutlets(outlets) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_OUTLETS, payload: { outlets: outlets } };
}

function setCategoryDetail(category) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL, payload: { category: category } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function onChangeKeyword(keyword) {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD, payload: { keyword: keyword } };
}

function onClickCreateCategory() {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY, payload: {} };
}

function openRightColumn() {
  return { type: _constants.INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN, payload: {} };
}

function setCurrentPage(page) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_CURRENT_PAGE, payload: { page: page } };
}

function setTotalPage(page) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_TOTAL_PAGE, payload: { page: page } };
}

function onClickRow(category) {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CLICK_ROW, payload: { category: category } };
}

function onClickCancel() {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CLICK_CANCEL, payload: {} };
}

function submitForm(category, createAllOutlet, previousCategories, outletIds) {
  return { type: _constants.INGREDIENT_CATEGORY_SUBMIT_FORM, payload: { category: category, createAllOutlet: createAllOutlet, previousCategories: previousCategories, outletIds: outletIds } };
}

function showDeleteModal() {
  return { type: _constants.INGREDIENT_CATEGORY_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.INGREDIENT_CATEGORY_HIDE_DELETE_MODAL, payload: {} };
}

function deleteCategory(category, categories) {
  return { type: _constants.INGREDIENT_CATEGORY_DELETE_CATEGORY, payload: { category: category, categories: categories } };
}

function onClickAssignToIngredient(category) {
  return { type: _constants.INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT, payload: { category: category } };
}

function showAssignToIngredientModal() {
  return { type: _constants.INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL, payload: {} };
}

function hideAssignToIngredientModal() {
  return { type: _constants.INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL, payload: {} };
}

function cancelAssignToIngredient() {
  return { type: _constants.INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT, payload: {} };
}

function assignToIngredientSetIngredients(ingredients) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS, payload: { ingredients: ingredients } };
}

function assignToIngredientSetCurrentPage(currentPage) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function assignToIngredientSetTotalPage(totalPage) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function assignToIngredientGetIngredientsRequest(params, previousIngredients) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST, payload: { params: params, previousIngredients: previousIngredients } };
}

function submitAssignToIngredient(data, category) {
  return { type: _constants.INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT, payload: { data: data, category: category } };
}

function assignToIngredientFillForm(category, ingredients) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM, payload: { category: category, ingredients: ingredients } };
}

function assignToIngredientSetCategory(category) {
  return { type: _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY, payload: { category: category } };
}

function setIsSubmitting(isSubmitting) {
  return { type: _constants.INGREDIENT_CATEGORY_SET_IS_SUBMITTING, payload: { isSubmitting: isSubmitting } };
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.recipesRequest = recipesRequest;
exports.setOutlets = setOutlets;
exports.setRecipes = setRecipes;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.submitFormCreate = submitFormCreate;
exports.onClickRow = onClickRow;
exports.setRecipesDetail = setRecipesDetail;
exports.exportRecipes = exportRecipes;
exports.onClickDone = onClickDone;
exports.onClickCreateRecipes = onClickCreateRecipes;
exports.recipesFormOnChangeOutlet = recipesFormOnChangeOutlet;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.onChangeOutletIds = onChangeOutletIds;
exports.showAddItemsModal = showAddItemsModal;
exports.hideAddIngredientsModal = hideAddIngredientsModal;
exports.onClickAddIngredients = onClickAddIngredients;
exports.setFilterRecipes = setFilterRecipes;
exports.addIngredientsConfirmAddItems = addIngredientsConfirmAddItems;
exports.addIngredientsSetItems = addIngredientsSetItems;
exports.addIngredientsShowLoading = addIngredientsShowLoading;
exports.addIngredientsHideLoading = addIngredientsHideLoading;
exports.setRecipesDetailPage = setRecipesDetailPage;
exports.recipesFormOnClickCancel = recipesFormOnClickCancel;
exports.showConfirmSubmitModal = showConfirmSubmitModal;
exports.hideConfirmSubmitModal = hideConfirmSubmitModal;
exports.confirmSubmit = confirmSubmit;
exports.setFilterState = setFilterState;
exports.addIngredientsShowAlreadyAddedAlert = addIngredientsShowAlreadyAddedAlert;
exports.unSetFilterState = unSetFilterState;
exports.setItemDropdown = setItemDropdown;
exports.setItemVariant = setItemVariant;
exports.addIngredientsGetingredientRequest = addIngredientsGetingredientRequest;
exports.setIngredientGetingredientRequest = setIngredientGetingredientRequest;
exports.addItemVariantOnChangeItems = addItemVariantOnChangeItems;
exports.addIngredientsOnChangeSelectModal = addIngredientsOnChangeSelectModal;
exports.addIngredientsOnSearchModal = addIngredientsOnSearchModal;
exports.cancelAddIngredientsModal = cancelAddIngredientsModal;
exports.addIngredientsHideAlreadyAddedAlertModal = addIngredientsHideAlreadyAddedAlertModal;
exports.addIngredientsGetIngredientsRequestModal = addIngredientsGetIngredientsRequestModal;
exports.addIngredientsSetIngredient = addIngredientsSetIngredient;
exports.addIngredientsHideAlreadyAddedAlert = addIngredientsHideAlreadyAddedAlert;
exports.addIngredientsSetKeyword = addIngredientsSetKeyword;
exports.addIngredientRecipesDetail = addIngredientRecipesDetail;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.deleteRecipes = deleteRecipes;
exports.onSaveRecipes = onSaveRecipes;
exports.onSaveRecipesAllOutlet = onSaveRecipesAllOutlet;
exports.onUpdateRecipes = onUpdateRecipes;
exports.onUpdateRecipesAllOutlet = onUpdateRecipesAllOutlet;
exports.setRecipesForm = setRecipesForm;
exports.showSaveToAllOutletsModal = showSaveToAllOutletsModal;
exports.hideSaveToAllOutletsModal = hideSaveToAllOutletsModal;
exports.setCreatedOutlets = setCreatedOutlets;
exports.setIngredientByItemVariant = setIngredientByItemVariant;
exports.unSetIngredientByItemVariant = unSetIngredientByItemVariant;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(398);

function pageRequest() {
  return { type: _constants.INGREDIENT_RECIPES_PAGE_REQUEST, payload: {} };
}

function recipesRequest(params, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_RECIPES_REQUEST, payload: { params: params, previousRecipes: previousRecipes } };
}

function setOutlets(outlets) {
  return { type: _constants.INGREDIENT_RECIPES_SET_OUTLETS, payload: { outlets: outlets } };
}

function setRecipes(recipes) {
  return { type: _constants.INGREDIENT_RECIPES_SET_RECIPES, payload: { recipes: recipes } };
}

function openRightColumn() {
  return { type: _constants.INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN, payload: {} };
}

function submitFormCreate(data, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_SUBMIT_FORM_CREATE, payload: { data: data, previousRecipes: previousRecipes } };
}

function onClickRow(recipes) {
  return { type: _constants.INGREDIENT_RECIPES_ON_CLICK_ROW, payload: { recipes: recipes } };
}
function setRecipesDetail(recipes) {
  return { type: _constants.INGREDIENT_RECIPES_SET_RECIPES_DETAIL, payload: { recipes: recipes } };
}

function exportRecipes(params, filename, outletId) {
  return { type: _constants.INGREDIENT_RECIPES_EXPORT_RECIPES, payload: { params: params, filename: filename, outletId: outletId } };
}

function onClickDone() {
  return { type: _constants.INGREDIENT_RECIPES_ON_CLICK_DONE, payload: {} };
}

function onClickCreateRecipes(outletId) {
  return { type: _constants.INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES, payload: { outletId: outletId } };
}

function recipesFormOnChangeOutlet(outletId) {
  return { type: _constants.INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET, payload: { outletId: outletId } };
}

function setCurrentPage(page) {
  return { type: _constants.INGREDIENT_RECIPES_SET_CURRENT_PAGE, payload: { page: page } };
}

function setTotalPage(page) {
  return { type: _constants.INGREDIENT_RECIPES_SET_TOTAL_PAGE, payload: { page: page } };
}

function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return { type: _constants.INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, namespace: namespace } };
}

function showAddItemsModal() {
  return { type: _constants.INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL, payload: {} };
}

function hideAddIngredientsModal() {
  return { type: _constants.INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL, payload: {} };
}

function onClickAddIngredients() {
  return { type: _constants.INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS, payload: {} };
}

function setFilterRecipes(keyword) {
  return { type: _constants.INGREDIENT_RECIPES_SET_FILTER_ITEM, payload: { keyword: keyword } };
}

function addIngredientsConfirmAddItems(addIngredientsFormValues, recipes) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_CONFIRM_ADD_ITEMS, payload: { addIngredientsFormValues: addIngredientsFormValues, recipes: recipes } };
}

function addIngredientsSetItems(ingredients) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS, payload: { ingredients: ingredients } };
}

function addIngredientsShowLoading() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING, payload: {} };
}

function addIngredientsHideLoading() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING, payload: {} };
}

function setRecipesDetailPage(page) {
  return { type: _constants.INGREDIENT_RECIPES_RECIPES_DETAIL_PAGE, payload: { page: page } };
}

function recipesFormOnClickCancel() {
  return { type: _constants.INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL, payload: {} };
}

function showConfirmSubmitModal() {
  return { type: _constants.INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL, payload: {} };
}

function hideConfirmSubmitModal() {
  return { type: _constants.INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL, payload: {} };
}

function confirmSubmit(values, namespace, date) {
  return { type: _constants.INGREDIENT_RECIPES_CONFIRM_SUBMIT, payload: { values: values, namespace: namespace, date: date } };
}

function setFilterState(keyword) {
  return { type: _constants.INGREDIENT_RECIPES_SET_FILTER_STATE, payload: { keyword: keyword } };
}

function addIngredientsShowAlreadyAddedAlert() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT, payload: {} };
}

function unSetFilterState() {
  return { type: _constants.INGREDIENT_RECIPES_UNSET_FILTER_STATE };
}

function setItemDropdown(itemsDropdowns) {
  return { type: _constants.INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN, payload: { itemsDropdowns: itemsDropdowns } };
}

function setItemVariant(itemVariant) {
  return { type: _constants.INGREDIENT_RECIPES_SET_ITEM_VARIANT, payload: { itemVariant: itemVariant } };
}

function addIngredientsGetingredientRequest(params) {
  return { type: _constants.INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST, payload: { params: params } };
}

function setIngredientGetingredientRequest(params) {
  return { type: _constants.INGREDIENT_RECIPES_SET_INGREDIENT_REQUEST, payload: { params: params } };
}

function addItemVariantOnChangeItems(selectedItem, recipesForm) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS, payload: { selectedItem: selectedItem, recipesForm: recipesForm } };
}

// Modal
function addIngredientsOnChangeSelectModal(ingredient, recipesForm) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS, payload: { ingredient: ingredient, recipesForm: recipesForm } };
}

function addIngredientsOnSearchModal(keyword) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS, payload: { keyword: keyword } };
}

function cancelAddIngredientsModal() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS, payload: {} };
}

function addIngredientsHideAlreadyAddedAlertModal() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT, payload: {} };
}

function addIngredientsGetIngredientsRequestModal(params) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST, payload: { params: params } };
}

function addIngredientsSetIngredient(ingredient) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT, payload: { ingredient: ingredient } };
}

function addIngredientsHideAlreadyAddedAlert() {
  return { type: _constants.INGREDIENT_RECIPES_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT, payload: {} };
}

function addIngredientsSetKeyword(keyword) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD, payload: { keyword: keyword } };
}

function addIngredientRecipesDetail(values, recipesForm) {
  return { type: _constants.INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES, payload: { values: values, recipesForm: recipesForm } };
}

function showDeleteModal() {
  return { type: _constants.INGREDIENT_RECIPES_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.INGREDIENT_RECIPES_HIDE_DELETE_MODAL, payload: {} };
}

function deleteRecipes(recipe, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_DELETE_ITEM, payload: { recipe: recipe, previousRecipes: previousRecipes } };
}

function onSaveRecipes(values, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_SAVE_RECIPES, payload: { recipe: values, previousRecipes: previousRecipes } };
}

function onSaveRecipesAllOutlet(values, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET, payload: { recipe: values, previousRecipes: previousRecipes } };
}

function onUpdateRecipes(values, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_UPDATE_RECIPES, payload: { recipe: values, previousRecipes: previousRecipes } };
}

function onUpdateRecipesAllOutlet(values, previousRecipes) {
  return { type: _constants.INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET, payload: { recipe: values, previousRecipes: previousRecipes } };
}

function setRecipesForm(recipesForm) {
  return { type: _constants.INGREDIENT_RECIPES_SET_RECIPES_FORM, payload: { recipesForm: recipesForm } };
}

function showSaveToAllOutletsModal() {
  return { type: _constants.INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function hideSaveToAllOutletsModal() {
  return { type: _constants.INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

function setCreatedOutlets(createdOutlets) {
  return { type: _constants.INGREDIENT_RECIPES_SET_CREATED_OUTLETS, payload: { createdOutlets: createdOutlets } };
}

function setIngredientByItemVariant(itemVariant, recipesForm, selectedVariant) {
  return { type: _constants.INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID, payload: { itemVariant: itemVariant, recipesForm: recipesForm, selectedVariant: selectedVariant } };
}

function unSetIngredientByItemVariant() {
  return { type: _constants.INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.INGREDIENT_RECIPES_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoriesPageRequest = categoriesPageRequest;
exports.categoriesRequest = categoriesRequest;
exports.setListCategories = setListCategories;
exports.onChangeOutletIds = onChangeOutletIds;
exports.setOutlets = setOutlets;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.setKeyword = setKeyword;
exports.onClickRow = onClickRow;
exports.setCategoryDetail = setCategoryDetail;
exports.onClickCancel = onClickCancel;
exports.onClickCreateCategory = onClickCreateCategory;
exports.submitFormUpdate = submitFormUpdate;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlets = submitFormCreateAllOutlets;
exports.setDeletedCategory = setDeletedCategory;
exports.deleteCategoryRequest = deleteCategoryRequest;
exports.showDeleteModal = showDeleteModal;
exports.hideDeleteModal = hideDeleteModal;
exports.cancelDelete = cancelDelete;
exports.deleteCategory = deleteCategory;
exports.onClickAssignToItem = onClickAssignToItem;
exports.showAssignToItemModal = showAssignToItemModal;
exports.hideAssignToItemModal = hideAssignToItemModal;
exports.cancelAssignToItem = cancelAssignToItem;
exports.assignToItemSetItems = assignToItemSetItems;
exports.assignToItemSetCurrentPage = assignToItemSetCurrentPage;
exports.assignToItemSetTotalPage = assignToItemSetTotalPage;
exports.assignToItemGetItemsRequest = assignToItemGetItemsRequest;
exports.submitAssignToItem = submitAssignToItem;
exports.assignToItemFillForm = assignToItemFillForm;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(405);

function categoriesPageRequest() {
  return { type: _constants.LIBRARY_CATEGORIES_PAGE_REQUEST, payload: {} };
}

function categoriesRequest(params, previousCategories) {
  return { type: _constants.LIBRARY_CATEGORIES_LIST_REQUEST, payload: { params: params, previousCategories: previousCategories } };
}

function setListCategories(categories) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_LIST_CATEGORIES, payload: { categories: categories } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_OUTLETS, payload: { outlets: outlets } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function setKeyword(keyword) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_KEYWORD, payload: { keyword: keyword } };
}

function onClickRow(category) {
  return { type: _constants.LIBRARY_CATEGORIES_ON_CLICK_ROW, payload: { category: category } };
}

function setCategoryDetail(category) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL, payload: { category: category } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_CATEGORIES_ON_CLICK_CANCEL, payload: {} };
}

function onClickCreateCategory() {
  return { type: _constants.LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY, payload: {} };
}

function submitFormUpdate(id, data, previousCategories) {
  return { type: _constants.LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE, payload: { id: id, data: data, previousCategories: previousCategories } };
}

function submitFormCreate(data, previousCategories) {
  return { type: _constants.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE, payload: { data: data, previousCategories: previousCategories } };
}

function submitFormCreateAllOutlets(data, previousCategories) {
  return { type: _constants.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS, payload: { data: data, previousCategories: previousCategories } };
}

function setDeletedCategory(deletedCategory) {
  return { type: _constants.LIBRARY_CATEGORIES_SET_DELETED_CATEGORY, payload: { deletedCategory: deletedCategory } };
}

function deleteCategoryRequest(deletedCategory) {
  return { type: _constants.LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST, payload: { deletedCategory: deletedCategory } };
}

function showDeleteModal() {
  return { type: _constants.LIBRARY_CATEGORIES_SHOW_DELETE_MODAL, payload: {} };
}

function hideDeleteModal() {
  return { type: _constants.LIBRARY_CATEGORIES_HIDE_DELETE_MODAL, payload: {} };
}

function cancelDelete() {
  return { type: _constants.LIBRARY_CATEGORIES_CANCEL_DELETE, payload: {} };
}

function deleteCategory(id, previousCategories) {
  return { type: _constants.LIBRARY_CATEGORIES_DELETE_CATEGORY, payload: { id: id, previousCategories: previousCategories } };
}

function onClickAssignToItem(category) {
  return { type: _constants.LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM, payload: { category: category } };
}

function showAssignToItemModal() {
  return { type: _constants.LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

function hideAssignToItemModal() {
  return { type: _constants.LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL, payload: {} };
}

function cancelAssignToItem() {
  return { type: _constants.LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM, payload: {} };
}

function assignToItemSetItems(items) {
  return { type: _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS, payload: { items: items } };
}

function assignToItemSetCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function assignToItemSetTotalPage(totalPage) {
  return { type: _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function assignToItemGetItemsRequest(params, previousItems) {
  return { type: _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST, payload: { params: params, previousItems: previousItems } };
}

function submitAssignToItem(data, categoryId) {
  return { type: _constants.LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM, payload: { data: data, categoryId: categoryId } };
}

function assignToItemFillForm(category) {
  return { type: _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM, payload: { category: category } };
}

function openRightColumn() {
  return { type: _constants.LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_CATEGORIES_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setProfile = setProfile;
exports.setOutlets = setOutlets;
exports.setOutletDetail = setOutletDetail;
exports.search = search;
exports.clickOutletRow = clickOutletRow;
exports.clickCancel = clickCancel;
exports.clickCreateOutlet = clickCreateOutlet;
exports.clickAddOutlet = clickAddOutlet;
exports.setOutletSlots = setOutletSlots;
exports.setUsedOutletSlots = setUsedOutletSlots;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.showConfirmReactivateOutletModal = showConfirmReactivateOutletModal;
exports.hideConfirmReactivateOutletModal = hideConfirmReactivateOutletModal;
exports.askReactivateOutlet = askReactivateOutlet;
exports.cancelReactivateOutlet = cancelReactivateOutlet;
exports.confirmReactivateOutlet = confirmReactivateOutlet;
exports.setReactivatedOutlet = setReactivatedOutlet;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.showAddOutletModal = showAddOutletModal;
exports.hideAddOutletModal = hideAddOutletModal;
exports.getOutletPrice = getOutletPrice;
exports.setOutletPrice = setOutletPrice;
exports.getFeatureSubscriptionStatus = getFeatureSubscriptionStatus;
exports.setFeatureSubscriptionStatus = setFeatureSubscriptionStatus;
exports.verifyAddOutletBilling = verifyAddOutletBilling;
exports.showPaymentGatewayError = showPaymentGatewayError;
exports.hidePaymentGatewayError = hidePaymentGatewayError;
exports.setPaymentButtonMessage = setPaymentButtonMessage;
exports.enablePayButton = enablePayButton;
exports.disablePayButton = disablePayButton;
exports.setPendingPaymentMessage = setPendingPaymentMessage;
exports.getBilling = getBilling;
exports.setOnLoading = setOnLoading;
exports.setDisableSaveOutletButton = setDisableSaveOutletButton;
exports.askReactivateOutletWithoutPay = askReactivateOutletWithoutPay;
exports.confirmReactivateOutletWithoutPay = confirmReactivateOutletWithoutPay;
exports.showReactivateOutletWithoutPay = showReactivateOutletWithoutPay;
exports.hideReactivateOutletWithoutPay = hideReactivateOutletWithoutPay;
exports.setOnLoadingReactivateOutletWithoutPay = setOnLoadingReactivateOutletWithoutPay;

var _constants = __webpack_require__(413);

function pageRequest(billingNotification) {
  return { type: _constants.OUTLET_PAGE_LIST_PAGE_REQUEST, payload: { billingNotification: billingNotification } };
}

function setProfile(profile) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_PROFILE, payload: { profile: profile } };
}

/**
 *
 * @param {Array} outlets
 * @return {{type, payload: {outlets: *}}}
 */
function setOutlets(outlets) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_OUTLETS, payload: { outlets: outlets } };
}

/**
 *
 * @param {object} outletDetail
 * @return {{type, payload: {outletDetail: *}}}
 */
function setOutletDetail(outletDetail) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_OUTLET_DETAIL, payload: { outletDetail: outletDetail } };
}

function search(query) {
  return { type: _constants.OUTLET_PAGE_LIST_SEARCH, payload: { query: query } };
}

function clickOutletRow(outletId) {
  return { type: _constants.OUTLET_PAGE_LIST_CLICK_OUTLET_ROW, payload: { outletId: outletId } };
}

function clickCancel() {
  return { type: _constants.OUTLET_PAGE_LIST_CLICK_CANCEL, payload: {} };
}

function clickCreateOutlet() {
  return { type: _constants.OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET, payload: {} };
}

function clickAddOutlet() {
  return { type: _constants.OUTLET_PAGE_LIST_CLICK_ADD_OUTLET, payload: {} };
}

function setOutletSlots(slots) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_OUTLET_SLOTS, payload: { slots: slots } };
}

function setUsedOutletSlots(slots) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS, payload: { slots: slots } };
}

function submitFormCreate(data, params, previousOutlets) {
  return { type: _constants.OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE, payload: { data: data, params: params, previousOutlets: previousOutlets } };
}

function submitFormUpdate(outletId, data, params, previousOutlets) {
  return { type: _constants.OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE, payload: { outletId: outletId, data: data, params: params, previousOutlets: previousOutlets } };
}

function showConfirmReactivateOutletModal() {
  return { type: _constants.OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL, payload: {} };
}

function hideConfirmReactivateOutletModal() {
  return { type: _constants.OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL, payload: {} };
}

function askReactivateOutlet(outlet) {
  return { type: _constants.OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET, payload: { outlet: outlet } };
}

function cancelReactivateOutlet() {
  return { type: _constants.OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET, payload: {} };
}

function confirmReactivateOutlet(billingData) {
  return { type: _constants.OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET, payload: { billingData: billingData } };
}

function setReactivatedOutlet(outlet) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET, payload: { outlet: outlet } };
}

function openRightColumn() {
  return { type: _constants.OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN, payload: {} };
}

function showAddOutletModal() {
  return { type: _constants.OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL };
}

function hideAddOutletModal() {
  return { type: _constants.OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL };
}

function getOutletPrice() {
  return { type: _constants.OUTLET_PAGE_LIST_GET_OUTLET_PRICE };
}

function setOutletPrice(outletPrice) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_OUTLET_PRICE, payload: { outletPrice: outletPrice } };
}

function getFeatureSubscriptionStatus() {
  return { type: _constants.OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS };
}

function setFeatureSubscriptionStatus(featureSubscriptions) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS, payload: { featureSubscriptions: featureSubscriptions } };
}

function verifyAddOutletBilling(billingData) {
  return { type: _constants.OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA, payload: { billingData: billingData } };
}

function showPaymentGatewayError() {
  return { type: _constants.OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL };
}

function hidePaymentGatewayError() {
  return { type: _constants.OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL };
}

function setPaymentButtonMessage(buttonMessage) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE, payload: { buttonMessage: buttonMessage } };
}

function enablePayButton() {
  return { type: _constants.OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON };
}

function disablePayButton() {
  return { type: _constants.OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON };
}

function setPendingPaymentMessage(pendingMessage) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE, payload: { pendingMessage: pendingMessage } };
}

function getBilling() {
  return { type: _constants.OUTLET_PAGE_LIST_GET_BILLING };
}

function setOnLoading(onLoading) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_ON_LOADING, payload: { onLoading: onLoading } };
}

function setDisableSaveOutletButton(disabled) {
  return { type: _constants.OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON, payload: { disabled: disabled } };
}

function askReactivateOutletWithoutPay(outlet) {
  return { type: _constants.OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY, payload: { outlet: outlet } };
}

function confirmReactivateOutletWithoutPay(outlet, previousOutlets) {
  return { type: _constants.OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY, payload: { outlet: outlet, previousOutlets: previousOutlets } };
}

function showReactivateOutletWithoutPay() {
  return { type: _constants.OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY };
}

function hideReactivateOutletWithoutPay() {
  return { type: _constants.OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY };
}

function setOnLoadingReactivateOutletWithoutPay(isOnLoading) {
  return { type: _constants.OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL, payload: { isOnLoading: isOnLoading } };
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.getTransactionsRequest = getTransactionsRequest;
exports.setTransactions = setTransactions;
exports.changeOutlet = changeOutlet;
exports.changeDate = changeDate;
exports.changeKeyword = changeKeyword;
exports.showTransactionDetailRequestNonMobile = showTransactionDetailRequestNonMobile;
exports.showTransactionDetailRequestMobile = showTransactionDetailRequestMobile;
exports.hideTransactionDetail = hideTransactionDetail;
exports.setTransactionDetail = setTransactionDetail;
exports.showTransactionDetailModal = showTransactionDetailModal;
exports.hideTransactionDetailModal = hideTransactionDetailModal;
exports.showResendEmailModal = showResendEmailModal;
exports.hideResendEmailModal = hideResendEmailModal;
exports.sendEmailReceipt = sendEmailReceipt;
exports.showRefundBreakdownModal = showRefundBreakdownModal;
exports.hideRefundBreakdownModal = hideRefundBreakdownModal;
exports.setRefundItems = setRefundItems;
exports.issueRefundRequest = issueRefundRequest;
exports.showSetQuantityModal = showSetQuantityModal;
exports.hideSetQuantityModal = hideSetQuantityModal;
exports.askSetQuantity = askSetQuantity;
exports.confirmSetQuantity = confirmSetQuantity;
exports.cancelSetQuantity = cancelSetQuantity;
exports.showOldRefundModal = showOldRefundModal;
exports.hideOldRefundModal = hideOldRefundModal;
exports.issueOldRefundRequest = issueOldRefundRequest;
exports.exportTransaction = exportTransaction;
exports.setOutlets = setOutlets;
exports.cancelResendEmail = cancelResendEmail;
exports.cancelRefundBreakdown = cancelRefundBreakdown;
exports.transactionShowLoadingSpinner = transactionShowLoadingSpinner;

var _constants = __webpack_require__(418);

/********************************************************************************
 * Transactions
 ********************************************************************************/

/**
 * @return {{type, payload: {}}}
 */
function pageRequest() {
  return { type: _constants.REPORTS_TRANSACTIONS_PAGE_REQUEST, payload: {} };
}

/**
 * @param {object} query additional query params
 * @return {{type, payload: {query: *}}}
 */
function getTransactionsRequest(query) {
  return { type: _constants.REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST, payload: { query: query } };
}

/**
 * @return {{type, payload: {transactions: *}}}
 */
function setTransactions(transactions) {
  return { type: _constants.REPORTS_TRANSACTIONS_SET_TRANSACTIONS, payload: { transactions: transactions } };
}

/********************************************************************************
 * End Transactions
 ********************************************************************************/

/********************************************************************************
 * Change handler
 ********************************************************************************/

/**
 * @param {Array} outletIds
 */
function changeOutlet(outletIds) {
  return { type: _constants.REPORTS_TRANSACTIONS_CHANGE_OUTLET, payload: { outletIds: outletIds } };
}

/**
 * @param {Date} startDate
 * @param {Date} endDate
 */
function changeDate(startDate, endDate) {
  return { type: _constants.REPORTS_TRANSACTIONS_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

/**
 *
 * @param keyword
 * @param startDate
 * @param endDate
 * @return {{type, payload: {keyword: *, startDate: *, endDate: *}}}
 */
function changeKeyword(_ref) {
  var keyword = _ref.keyword,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  return { type: _constants.REPORTS_TRANSACTIONS_CHANGE_KEYWORD, payload: { keyword: keyword, startDate: startDate, endDate: endDate } };
}
/********************************************************************************
 * End Change handler
 ********************************************************************************/

/********************************************************************************
 * Transaction Detail
 ********************************************************************************/

/**
 * @param {int} id transaction detail id
 * @param {object} query additional query params
 * @return {{type, payload: {id: *, query: *}}}
 */
function showTransactionDetailRequestNonMobile(id, query) {
  return { type: _constants.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE, payload: { id: id, query: query } };
}

/**
 * @param {int} id transaction detail id
 * @param {object} query additional query params
 * @return {{type, payload: {id: *, query: *}}}
 */
function showTransactionDetailRequestMobile(id, query) {
  return { type: _constants.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE, payload: { id: id, query: query } };
}

function hideTransactionDetail() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL, payload: {} };
}

/**
 *
 * @param {object} transactionDetail
 * @return {{type, payload: {transactionDetail: *}}}
 */
function setTransactionDetail(transactionDetail) {
  return { type: _constants.REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL, payload: { transactionDetail: transactionDetail } };
}

function showTransactionDetailModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL, payload: {} };
}

function hideTransactionDetailModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL, payload: {} };
}

/********************************************************************************
 * End Transaction Detail
 ********************************************************************************/

/********************************************************************************
 * Resend Email
 ********************************************************************************/

function showResendEmailModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL, payload: {} };
}

function hideResendEmailModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL, payload: {} };
}

function sendEmailReceipt(data) {
  return { type: _constants.REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT, payload: { data: data } };
}

/********************************************************************************
 * End Resend Email
 ********************************************************************************/

/********************************************************************************
 * Refund Breakdown
 ********************************************************************************/

function showRefundBreakdownModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL, payload: {} };
}

function hideRefundBreakdownModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL, payload: {} };
}

/**
 *
 * @param {object} items key-value object where key is item_id and value is extracted from
 * @see {@link transactionDetailNonMobileFlow}
 * @return {{type, payload: {items: *}}}
 */
function setRefundItems(items) {
  return { type: _constants.REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS, payload: { items: items } };
}

function issueRefundRequest(data) {
  return { type: _constants.REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST, payload: { data: data } };
}

function showSetQuantityModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL, payload: {} };
}

function hideSetQuantityModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL, payload: {} };
}

function askSetQuantity(refundItemsIdx, refundAmount) {
  return { type: _constants.REPORTS_TRANSACTIONS_ASK_SET_QUANTITY, payload: { refundItemsIdx: refundItemsIdx, refundAmount: refundAmount } };
}

/**
 * @return {{type, payload: {refundItems: *}}}
 */
function confirmSetQuantity(refundItems) {
  return { type: _constants.REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY, payload: { refundItems: refundItems } };
}

function cancelSetQuantity() {
  return { type: _constants.REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY, payload: {} };
}
/********************************************************************************
 * End Refund Breakdown
 ********************************************************************************/

/********************************************************************************
 * Old Refund
 ********************************************************************************/

function showOldRefundModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL, payload: {} };
}

function hideOldRefundModal() {
  return { type: _constants.REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL, payload: {} };
}

function issueOldRefundRequest(data) {
  return { type: _constants.REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST, payload: { data: data } };
}

/********************************************************************************
 * End Old Refund
 ********************************************************************************/

/********************************************************************************
 * Export Transaction
 ********************************************************************************/

/**
 * @param {object} query query params sent to the api call of export_transactions
 * @param {string} filename the filename that will be fetched after invocation of export_transactions api call
 * @param {int} outletId the outlet id that will be checked if export is already finished
 */
function exportTransaction(query, filename, outletId) {
  return { type: _constants.REPORTS_TRANSACTIONS_EXPORT_TRANSACTION, payload: { query: query, filename: filename, outletId: outletId } };
}

/********************************************************************************
 * End Export Transaction
 ********************************************************************************/

function setOutlets(outlets) {
  return { type: _constants.REPORTS_TRANSACTIONS_SET_OUTLETS, payload: { outlets: outlets } };
}

function cancelResendEmail(transactionDetail) {
  return { type: _constants.REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL, payload: { transactionDetail: transactionDetail } };
}

function cancelRefundBreakdown(transactionDetail) {
  return { type: _constants.REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN, payload: { transactionDetail: transactionDetail } };
}

function transactionShowLoadingSpinner(showLoadingSpinnerTransaction) {
  return { type: _constants.REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER, payload: { showLoadingSpinnerTransaction: showLoadingSpinnerTransaction } };
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(1983);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoDataDisplay = function (_React$Component) {
  (0, _inherits3.default)(NoDataDisplay, _React$Component);

  function NoDataDisplay() {
    (0, _classCallCheck3.default)(this, NoDataDisplay);
    return (0, _possibleConstructorReturn3.default)(this, (NoDataDisplay.__proto__ || (0, _getPrototypeOf2.default)(NoDataDisplay)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoDataDisplay, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center wrapper-container ' + _style2.default.wrapper + ' ' + this.props.classPath },
        React.createElement(
          'div',
          { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _style2.default['img-wrapper'] },
          React.createElement('img', { src: __webpack_require__(948),
            className: _style2.default.img,
            alt: 'no sales',
            width: '110px'
          })
        ),
        React.createElement(
          'div',
          { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _style2.default['title-wrapper'] },
          React.createElement(
            'h3',
            { className: _style2.default['title'] },
            this.props.title
          )
        ),
        React.createElement(
          'div',
          { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ' + _style2.default.description },
          React.createElement(
            'p',
            null,
            this.props.description
          )
        )
      );
    }
  }]);
  return NoDataDisplay;
}(React.Component);

NoDataDisplay.propTypes = {
  className: React.PropTypes.string
};

exports.default = NoDataDisplay;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1634);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1633);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var CallbackQueue = __webpack_require__(867);
var PooledClass = __webpack_require__(193);
var ReactFeatureFlags = __webpack_require__(2625);
var ReactReconciler = __webpack_require__(276);
var Transaction = __webpack_require__(360);

var invariant = __webpack_require__(35);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  true ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  true ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  true ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  true ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  true ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  true ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  true ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var PooledClass = __webpack_require__(193);

var emptyFunction = __webpack_require__(142);
var warning = __webpack_require__(52);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (true) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (true) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (true) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (true) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (true) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
               true ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     true ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.adjustmentsRequest = adjustmentsRequest;
exports.ingredientAdjustmentsRequest = ingredientAdjustmentsRequest;
exports.setOutlets = setOutlets;
exports.setAdjustments = setAdjustments;
exports.setIngredientAdjustments = setIngredientAdjustments;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.submitFormCreate = submitFormCreate;
exports.onClickRow = onClickRow;
exports.onClickRowIngredientAdjustment = onClickRowIngredientAdjustment;
exports.setAdjustmentDetail = setAdjustmentDetail;
exports.setIngredientAdjustmentDetail = setIngredientAdjustmentDetail;
exports.exportAdjustment = exportAdjustment;
exports.exportIngredientAdjustment = exportIngredientAdjustment;
exports.onClickDone = onClickDone;
exports.onClickCreateAdjustment = onClickCreateAdjustment;
exports.adjustmentFormOnChangeOutlet = adjustmentFormOnChangeOutlet;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeDate = onChangeDate;
exports.onChangeNamespace = onChangeNamespace;
exports.showAddItemsModal = showAddItemsModal;
exports.hideAddItemsModal = hideAddItemsModal;
exports.onClickAddItems = onClickAddItems;
exports.cancelAddItems = cancelAddItems;
exports.addItemsConfirmAddItems = addItemsConfirmAddItems;
exports.addItemsGetItemsRequest = addItemsGetItemsRequest;
exports.addItemsSetKeyword = addItemsSetKeyword;
exports.addItemsGetIngredientsRequest = addItemsGetIngredientsRequest;
exports.addItemsSetItems = addItemsSetItems;
exports.addItemsSetSelectedId = addItemsSetSelectedId;
exports.addItemsSetIngredients = addItemsSetIngredients;
exports.addItemsShowLoading = addItemsShowLoading;
exports.addItemsHideLoading = addItemsHideLoading;
exports.addItemsOnSearch = addItemsOnSearch;
exports.addItemsOnChangeSelect = addItemsOnChangeSelect;
exports.addItemsSetCurrentPage = addItemsSetCurrentPage;
exports.addItemsSetTotalPage = addItemsSetTotalPage;
exports.setAdjustmentDetailPage = setAdjustmentDetailPage;
exports.adjustmentFormOnClickCancel = adjustmentFormOnClickCancel;
exports.showConfirmSubmitModal = showConfirmSubmitModal;
exports.hideConfirmSubmitModal = hideConfirmSubmitModal;
exports.confirmSubmit = confirmSubmit;
exports.addItemsShowAlreadyAddedAlert = addItemsShowAlreadyAddedAlert;
exports.addItemsHideAlreadyAddedAlert = addItemsHideAlreadyAddedAlert;
exports.showImportModal = showImportModal;
exports.hideImportModal = hideImportModal;
exports.onSuccessImport = onSuccessImport;
exports.setSummaryAdjustment = setSummaryAdjustment;
exports.setSummaryIngredientAdjustment = setSummaryIngredientAdjustment;
exports.addItemsSetItemHasRecipe = addItemsSetItemHasRecipe;

var _constants = __webpack_require__(399);

function pageRequest() {
  return { type: _constants.INVENTORY_ADJUSTMENT_PAGE_REQUEST, payload: {} };
}

function adjustmentsRequest(params, previousAdjustments) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST, payload: { params: params, previousAdjustments: previousAdjustments } };
}

function ingredientAdjustmentsRequest(params, previousIngredientAdjustments) {
  return { type: _constants.INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST, payload: { params: params, previousIngredientAdjustments: previousIngredientAdjustments } };
}

function setOutlets(outlets) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_OUTLETS, payload: { outlets: outlets } };
}

function setAdjustments(adjustments) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS, payload: { adjustments: adjustments } };
}

function setIngredientAdjustments(ingredientAdjustments) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS, payload: { ingredientAdjustments: ingredientAdjustments } };
}

function openRightColumn() {
  return { type: _constants.INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN, payload: {} };
}

function submitFormCreate(data, previousAdjustments) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE, payload: { data: data, previousAdjustments: previousAdjustments } };
}

function onClickRow(adjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CLICK_ROW, payload: { adjustment: adjustment } };
}

function onClickRowIngredientAdjustment(ingredientAdjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT, payload: { ingredientAdjustment: ingredientAdjustment } };
}

function setAdjustmentDetail(adjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL, payload: { adjustment: adjustment } };
}

function setIngredientAdjustmentDetail(ingredientAdjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL, payload: { ingredientAdjustment: ingredientAdjustment } };
}

function exportAdjustment(params, filename, outletId) {
  return { type: _constants.INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT, payload: { params: params, filename: filename, outletId: outletId } };
}

function exportIngredientAdjustment(params, filename, outletId) {
  return { type: _constants.INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT, payload: { params: params, filename: filename, outletId: outletId } };
}

function onClickDone() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CLICK_DONE, payload: {} };
}

function onClickCreateAdjustment(outletId) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT, payload: { outletId: outletId } };
}

function adjustmentFormOnChangeOutlet(outletId) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET, payload: { outletId: outletId } };
}

function setCurrentPage(page) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE, payload: { page: page } };
}

function setTotalPage(page) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE, payload: { page: page } };
}

function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, namespace: namespace } };
}

/**
 * @param startDate
 * @param endDate
 * @param namespace
 * @param outletIds needed for mixpanel (maybe other stuff)
 * @return {{type, payload: {startDate: *, endDate: *, namespace: *, outletIds: *}}}
 */
function onChangeDate(startDate, endDate, namespace, outletIds) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, namespace: namespace, outletIds: outletIds } };
}

function onChangeNamespace(namespace, params, outletIds, startDate, endDate) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE, payload: { namespace: namespace, params: params, outletIds: outletIds, startDate: startDate, endDate: endDate } };
}

function showAddItemsModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL, payload: {} };
}

function hideAddItemsModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL, payload: {} };
}

function onClickAddItems(outletId, namespace) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS, payload: { outletId: outletId, namespace: namespace } };
}

function cancelAddItems() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS, payload: {} };
}

function addItemsConfirmAddItems(addItemsFormValues, adjustments, namespace) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS, payload: { addItemsFormValues: addItemsFormValues, adjustments: adjustments, namespace: namespace } };
}

function addItemsGetItemsRequest(params, previousItems) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST, payload: { params: params, previousItems: previousItems } };
}

function addItemsSetKeyword(keyword) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD, payload: { keyword: keyword } };
}

function addItemsGetIngredientsRequest(params, previousIngredients) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST, payload: { params: params, previousIngredients: previousIngredients } };
}

function addItemsSetItems(items) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS, payload: { items: items } };
}

function addItemsSetSelectedId(id) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID, payload: { id: id } };
}

function addItemsSetIngredients(ingredients) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS, payload: { ingredients: ingredients } };
}

function addItemsShowLoading() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING, payload: {} };
}

function addItemsHideLoading() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING, payload: {} };
}

function addItemsOnSearch(keyword, outletId, namespace) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS, payload: { keyword: keyword, outletId: outletId, namespace: namespace } };
}

function addItemsOnChangeSelect(item, namespace, adjustmentForm) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS, payload: { item: item, namespace: namespace, adjustmentForm: adjustmentForm } };
}

function addItemsSetCurrentPage(page) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE, payload: { page: page } };
}

function addItemsSetTotalPage(page) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE, payload: { page: page } };
}

function setAdjustmentDetailPage(page) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE, payload: { page: page } };
}

function adjustmentFormOnClickCancel() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL, payload: {} };
}

function showConfirmSubmitModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL, payload: {} };
}

function hideConfirmSubmitModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL, payload: {} };
}

function confirmSubmit(values, namespace, date, outlet) {
  return { type: _constants.INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT, payload: { values: values, namespace: namespace, date: date, outlet: outlet } };
}

function addItemsShowAlreadyAddedAlert() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT, payload: {} };
}

function addItemsHideAlreadyAddedAlert() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT, payload: {} };
}

function showImportModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL, payload: {} };
}

function hideImportModal() {
  return { type: _constants.INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL, payload: {} };
}

function onSuccessImport() {
  return { type: _constants.INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT, payload: {} };
}

function setSummaryAdjustment(summaryAdjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT, payload: { summaryAdjustment: summaryAdjustment } };
}

function setSummaryIngredientAdjustment(summaryIngredientAdjustment) {
  return { type: _constants.INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT, payload: { summaryIngredientAdjustment: summaryIngredientAdjustment } };
}

function addItemsSetItemHasRecipe(itemHasRecipe) {
  return { type: _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE, payload: { itemHasRecipe: itemHasRecipe } };
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPurchaseOrders = setPurchaseOrders;
exports.pageRequest = pageRequest;
exports.setOutlets = setOutlets;
exports.purchaseOrderRequest = purchaseOrderRequest;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.openRightColumnAsForm = openRightColumnAsForm;
exports.openRightColumnAsDetail = openRightColumnAsDetail;
exports.onClickRow = onClickRow;
exports.setTotalPage = setTotalPage;
exports.setCurrentPage = setCurrentPage;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeDate = onChangeDate;
exports.onChangeNamespace = onChangeNamespace;
exports.onChangeKeyword = onChangeKeyword;
exports.onChangeStatus = onChangeStatus;
exports.exportPurchaseOrder = exportPurchaseOrder;
exports.onClickDone = onClickDone;
exports.onClickPrint = onClickPrint;
exports.setPurchaseOrderDetail = setPurchaseOrderDetail;
exports.onClickResendEmail = onClickResendEmail;
exports.setSuppliers = setSuppliers;
exports.onClickCreatePO = onClickCreatePO;
exports.onClickCancel = onClickCancel;
exports.updatePurchaseOrders = updatePurchaseOrders;
exports.showModalItemPurchase = showModalItemPurchase;
exports.closeModalItemPurchase = closeModalItemPurchase;
exports.isLoadingItem = isLoadingItem;
exports.setDataSearch = setDataSearch;
exports.getItemsFromAPI = getItemsFromAPI;
exports.setSelectedOutlet = setSelectedOutlet;
exports.setAddedItem = setAddedItem;
exports.setModalDataForm = setModalDataForm;
exports.addItemtoPOForm = addItemtoPOForm;
exports.onCancelModalAddItem = onCancelModalAddItem;
exports.createPO = createPO;
exports.createAndFulfilledPO = createAndFulfilledPO;
exports.onClickEdit = onClickEdit;
exports.editPO = editPO;
exports.onChangeOutletForm = onChangeOutletForm;
exports.showConfirmSubmitModal = showConfirmSubmitModal;
exports.hideConfirmSubmitModal = hideConfirmSubmitModal;
exports.setIsItemAdded = setIsItemAdded;
exports.setFirstItems = setFirstItems;

var _constants = __webpack_require__(401);

function setPurchaseOrders(purchaseOrders) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER, payload: { purchaseOrders: purchaseOrders } };
}

function pageRequest() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_PAGE_REQUEST, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_OUTLETS, payload: { outlets: outlets } };
}

function purchaseOrderRequest(namespace, params, previousPurchaseOrders) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST, payload: { namespace: namespace, params: params, previousPurchaseOrders: previousPurchaseOrders } };
}

function openRightColumn() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN, payload: {} };
}

function openRightColumnAsForm() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: { rightColumnState: 'form' } };
}

function openRightColumnAsDetail() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN, payload: { rightColumnState: 'detail' } };
}

function onClickRow(purchaseOrder, namespace) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW, payload: { purchaseOrder: purchaseOrder, namespace: namespace } };
}

function setTotalPage(page) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE, payload: { page: page } };
}

function setCurrentPage(page) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE, payload: { page: page } };
}

function onChangeOutletIds(outletIds, namespace, params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds, params: params, namespace: namespace } };
}

function onChangeDate(startDate, endDate, namespace, params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, params: params, namespace: namespace } };
}

function onChangeNamespace(namespace, params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE, payload: { namespace: namespace, params: params } };
}

function onChangeKeyword(keyword, namespace, params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD, payload: { keyword: keyword, namespace: namespace, params: params } };
}

function onChangeStatus(status, namespace, params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS, payload: { status: status, namespace: namespace, params: params } };
}

function exportPurchaseOrder(params, filename, outletId) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER, payload: { params: params, filename: filename, outletId: outletId } };
}

function onClickDone() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE, payload: {} };
}

function onClickPrint(purchaseOrder) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT, payload: { purchaseOrder: purchaseOrder } };
}

function setPurchaseOrderDetail(purchaseOrder) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL, payload: { purchaseOrder: purchaseOrder } };
}

function onClickResendEmail(purchaseOrder) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL, payload: { purchaseOrder: purchaseOrder } };
}

function setSuppliers(suppliers) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS, payload: { suppliers: suppliers } };
}

function onClickCreatePO(outletIds) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO, payload: { outletIds: outletIds } };
}

function onClickCancel() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL, payload: {} };
}

function updatePurchaseOrders(purchaseOrder, status) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER, payload: { purchaseOrder: purchaseOrder, status: status } };
}

function showModalItemPurchase() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM, payload: {} };
}

function closeModalItemPurchase() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM, payload: {} };
}

function isLoadingItem(isLoading) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_IS_LOADING, payload: { isLoading: isLoading } };
}

function setDataSearch(items) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH, payload: { items: items } };
}

function getItemsFromAPI(params) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API, payload: { params: params } };
}

function setSelectedOutlet(outletId) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET, payload: { outletId: outletId } };
}

function setAddedItem(item) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM, payload: { item: item } };
}

function setModalDataForm(namespace, data, itemPurchase) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM, payload: { namespace: namespace, data: data, itemPurchase: itemPurchase } };
}

function addItemtoPOForm(itemVariantValue, formPO, namespace) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM, payload: { itemVariantValue: itemVariantValue, formPO: formPO, namespace: namespace } };
}

function onCancelModalAddItem() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM, payload: {} };
}

function createPO(namespace, data, date) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER, payload: { namespace: namespace, data: data, date: date } };
}

function createAndFulfilledPO(namespace, data, date) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER, payload: { namespace: namespace, data: data, date: date } };
}

function onClickEdit(purchaseOrder) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT, payload: { purchaseOrder: purchaseOrder } };
}

function editPO(namespace, data) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER, payload: { namespace: namespace, data: data } };
}

function onChangeOutletForm() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM, payload: {} };
}

function showConfirmSubmitModal(action) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL, payload: { action: action } };
}

function hideConfirmSubmitModal() {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL, payload: {} };
}

function setIsItemAdded(isAdded) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED, payload: { isAdded: isAdded } };
}

function setFirstItems(firstItems) {
  return { type: _constants.INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS, payload: { firstItems: firstItems } };
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _style = __webpack_require__(1975);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryDeleteModal = function (_React$Component) {
  (0, _inherits3.default)(LibraryDeleteModal, _React$Component);

  function LibraryDeleteModal() {
    (0, _classCallCheck3.default)(this, LibraryDeleteModal);
    return (0, _possibleConstructorReturn3.default)(this, (LibraryDeleteModal.__proto__ || (0, _getPrototypeOf2.default)(LibraryDeleteModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(LibraryDeleteModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onHide = _props.onHide,
          showDeleteModal = _props.showDeleteModal,
          disableHideOnOuterModal = _props.disableHideOnOuterModal,
          title = _props.title,
          name = _props.name,
          onDelete = _props.onDelete;


      return React.createElement(
        _reactBootstrap.Modal,
        {
          onHide: disableHideOnOuterModal ? function () {/* no op */} : onHide,
          show: showDeleteModal,
          dialogClassName: _style2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { id: _style2.default['header-delete'] },
          React.createElement(
            'button',
            { onClick: onHide,
              type: 'button',
              className: 'close',
              'data-dismiss': 'modal',
              'aria-label': 'Close' },
            React.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _style2.default['title-modal'] },
            'Delete ',
            title
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Are you sure to delete ',
            React.createElement(
              'b',
              null,
              name
            ),
            ' ? this action cannot be undone'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default',
                onClick: onHide },
              'Cancel'
            ),
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-danger',
                onClick: onDelete },
              'Delete'
            )
          )
        )
      );
    }
  }]);
  return LibraryDeleteModal;
}(React.Component);

LibraryDeleteModal.propTypes = {
  onHide: React.PropTypes.func,
  disableHideOnOuterModal: React.PropTypes.bool,
  showDeleteModal: React.PropTypes.bool,
  title: React.PropTypes.string,
  name: React.PropTypes.string,
  onDelete: React.PropTypes.func
};

exports.default = LibraryDeleteModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

__webpack_require__(1987);

var _BillingReminder = __webpack_require__(291);

var _BillingReminder2 = _interopRequireDefault(_BillingReminder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNav = function (_React$Component) {
  (0, _inherits3.default)(SubNav, _React$Component);

  function SubNav() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubNav.__proto__ || (0, _getPrototypeOf2.default)(SubNav)).call.apply(_ref, [this].concat(args))), _this), _this._isUrl = function (url) {
      return url.indexOf('http') >= 0;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SubNav, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var path = this.props.location.pathname;
      var _props = this.props,
          user = _props.user,
          subscriptionExpired = _props.subscriptionExpired;

      return React.createElement(
        'div',
        { className: 'mk-sub-navbar' },
        React.createElement(
          'div',
          { className: 'container' },
          React.createElement(
            'ul',
            { className: 'mk-subnav' },
            React.createElement(
              'li',
              { className: 'sub-nav-li ' + (path.startsWith('/reports') && path !== '/reports/transactions' && path !== '/reports/invoices' && path !== '/reports/shifts' ? 'active' : '') },
              React.createElement(
                _reactRouter.Link,
                { to: '/reports/summary', className: path.startsWith('/reports') ? '' : 'hideSales' },
                'Sales'
              )
            ),
            this.props.links.map(function (link, index) {
              return React.createElement(
                'li',
                { key: index, className: 'sub-nav-li ' + (path.startsWith(link.href) ? 'active' : '') },
                _this2._isUrl(link.href) ? React.createElement(
                  'a',
                  { href: link.href },
                  link.label
                ) : React.createElement(
                  _reactRouter.Link,
                  { to: link.href },
                  link.label,
                  ' ',
                  link.isNew && React.createElement(
                    'span',
                    { className: 'new-label' },
                    'NEW'
                  )
                )
              );
            }),
            React.createElement(
              'div',
              { className: 'visible-lg visible-md' },
              React.createElement(_BillingReminder2.default, { user: user, subscriptionExpired: subscriptionExpired })
            )
          )
        )
      );
    }
  }]);
  return SubNav;
}(React.Component);

exports.default = SubNav;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___3Wnn1","scrolled-area":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___jMTTJ","mk-col-right-action-box-bottom":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___2Hinj","no-hover":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___2GMCR","col-right-inner":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___30ulW","col-outlet":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___3sxUk","col-sale":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___1dZ2-","header-name":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___2jSOP","address":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___37z6N","email":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___9U8pW","receipt-trx-container":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___1dfpA","no-redeem-histories":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___23wyx","no-point-activity":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___1zsIX","no-purchase-history":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___1CdZw","no-loyalty-membership":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___3MfAD","see-more":"app-pages-Customers-CustomerList-ListLoyalty-CustomerDetail-__style___137-Y"};

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setOutlets = setOutlets;
exports.outletsRequest = outletsRequest;
exports.discountsRequest = discountsRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onClickCreateDiscount = onClickCreateDiscount;
exports.setNewDiscount = setNewDiscount;
exports.onClickRow = onClickRow;
exports.setDiscounts = setDiscounts;
exports.setDiscountDetail = setDiscountDetail;
exports.unSetDiscountDetail = unSetDiscountDetail;
exports.clearAmountField = clearAmountField;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteDiscount = deleteDiscount;
exports.cancelDeleteDiscount = cancelDeleteDiscount;
exports.showDeleteDiscountModal = showDeleteDiscountModal;
exports.hideDeleteDiscountModal = hideDeleteDiscountModal;
exports.setDeletedDiscount = setDeletedDiscount;
exports.askDeleteDiscount = askDeleteDiscount;
exports.onClickCancel = onClickCancel;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(406);

function pageRequest() {
  return { type: _constants.LIBRARY_DISCOUNT_PAGE_REQUEST, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_OUTLETS, payload: { outlets: outlets } };
}

function outletsRequest(params) {
  return { type: _constants.LIBRARY_DISCOUNT_OUTLETS_REQUEST, payload: { params: params } };
}

function discountsRequest(params, previousDiscounts) {
  return { type: _constants.LIBRARY_DISCOUNT_DISCOUNTS_REQUEST, payload: { params: params, previousDiscounts: previousDiscounts } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function onClickCreateDiscount() {
  return { type: _constants.LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT };
}

function setNewDiscount() {
  return { type: _constants.LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT };
}

function onClickRow(discount) {
  return { type: _constants.LIBRARY_DISCOUNT_ON_CLICK_ROW, payload: { discount: discount } };
}

function setDiscounts(discounts) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_DISCOUNTS, payload: { discounts: discounts } };
}

function setDiscountDetail(discount) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL, payload: { discount: discount } };
}

function unSetDiscountDetail() {
  return { type: _constants.LIBRARY_DISCOUNT_UNSET_DISCOUNT, payload: {} };
}

function clearAmountField() {
  return { type: _constants.LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD, payload: {} };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function submitFormCreate(data, previousDiscounts) {
  return { type: _constants.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE, payload: { data: data, previousDiscounts: previousDiscounts } };
}

function submitFormCreateAllOutlet(data, previousDiscounts) {
  return { type: _constants.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET, payload: { data: data, previousDiscounts: previousDiscounts } };
}

function submitFormUpdate(discountId, data, previousDiscounts) {
  return { type: _constants.LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE, payload: { discountId: discountId, data: data, previousDiscounts: previousDiscounts } };
}

function deleteDiscount(discountId, previousDiscounts) {
  return { type: _constants.LIBRARY_DISCOUNT_DELETE_DISCOUNT, payload: { discountId: discountId, previousDiscounts: previousDiscounts } };
}

function cancelDeleteDiscount() {
  return { type: _constants.LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT, payload: {} };
}

function showDeleteDiscountModal() {
  return { type: _constants.LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL, payload: {} };
}

function hideDeleteDiscountModal() {
  return { type: _constants.LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL, payload: {} };
}

function setDeletedDiscount(deletedDiscount) {
  return { type: _constants.LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT, payload: { deletedDiscount: deletedDiscount } };
}

function askDeleteDiscount(deletedDiscount) {
  return { type: _constants.LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT, payload: { deletedDiscount: deletedDiscount } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_DISCOUNT_ON_CLICK_CANCEL, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_DISCOUNT_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setOutlets = setOutlets;
exports.outletsRequest = outletsRequest;
exports.gratuitiesRequest = gratuitiesRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onClickCreateGratuity = onClickCreateGratuity;
exports.onClickRow = onClickRow;
exports.onClickCancel = onClickCancel;
exports.setGratuities = setGratuities;
exports.setGratuityDetail = setGratuityDetail;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteGratuity = deleteGratuity;
exports.cancelDeleteGratuity = cancelDeleteGratuity;
exports.showDeleteGratuityModal = showDeleteGratuityModal;
exports.hideDeleteGratuityModal = hideDeleteGratuityModal;
exports.setDeletedGratuity = setDeletedGratuity;
exports.askDeleteGratuity = askDeleteGratuity;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(407);

function pageRequest() {
  return { type: _constants.LIBRARY_GRATUITY_PAGE_REQUEST, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.LIBRARY_GRATUITY_SET_OUTLETS, payload: { outlets: outlets } };
}

function outletsRequest(params) {
  return { type: _constants.LIBRARY_GRATUITY_OUTLETS_REQUEST, payload: { params: params } };
}

function gratuitiesRequest(params, previousGratuities) {
  return { type: _constants.LIBRARY_GRATUITY_GRATUITIES_REQUEST, payload: { params: params, previousGratuities: previousGratuities } };
}

function onChangeOutletIds(outletIds) {
  return { type: _constants.LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds } };
}

function onClickCreateGratuity() {
  return { type: _constants.LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY, payload: {} };
}

function onClickRow(gratuity) {
  return { type: _constants.LIBRARY_GRATUITY_ON_CLICK_ROW, payload: { gratuity: gratuity } };
}

function onClickCancel() {
  return { type: _constants.LIBRARY_GRATUITY_ON_CLICK_CANCEL, payload: {} };
}

function setGratuities(gratuities) {
  return { type: _constants.LIBRARY_GRATUITY_SET_GRATUITIES, payload: { gratuities: gratuities } };
}

function setGratuityDetail(gratuity) {
  return { type: _constants.LIBRARY_GRATUITY_SET_GRATUITY_DETAIL, payload: { gratuity: gratuity } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.LIBRARY_GRATUITY_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.LIBRARY_GRATUITY_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function submitFormCreate(data, previousGratuities) {
  return { type: _constants.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE, payload: { data: data, previousGratuities: previousGratuities } };
}

function submitFormCreateAllOutlet(data, previousGratuities) {
  return { type: _constants.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET, payload: { data: data, previousGratuities: previousGratuities } };
}

function submitFormUpdate(gratuityId, data, previousGratuities) {
  return { type: _constants.LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE, payload: { gratuityId: gratuityId, data: data, previousGratuities: previousGratuities } };
}

function deleteGratuity(gratuityId, previousGratuities) {
  return { type: _constants.LIBRARY_GRATUITY_DELETE_GRATUITY, payload: { gratuityId: gratuityId, previousGratuities: previousGratuities } };
}

function cancelDeleteGratuity() {
  return { type: _constants.LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY, payload: {} };
}

function showDeleteGratuityModal() {
  return { type: _constants.LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL, payload: {} };
}

function hideDeleteGratuityModal() {
  return { type: _constants.LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL, payload: {} };
}

function setDeletedGratuity(deletedGratuity) {
  return { type: _constants.LIBRARY_GRATUITY_SET_DELETED_GRATUITY, payload: { deletedGratuity: deletedGratuity } };
}

function askDeleteGratuity(deletedGratuity) {
  return { type: _constants.LIBRARY_GRATUITY_ASK_DELETE_GRATUITY, payload: { deletedGratuity: deletedGratuity } };
}

function openRightColumn() {
  return { type: _constants.LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.LIBRARY_GRATUITY_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invoicesPageRequest = invoicesPageRequest;
exports.listInvoiceRequest = listInvoiceRequest;
exports.setListInvoice = setListInvoice;
exports.changeDateInvoices = changeDateInvoices;
exports.changeOutletInvoices = changeOutletInvoices;
exports.changeStatusInvoices = changeStatusInvoices;
exports.receiptInvoicesRequest = receiptInvoicesRequest;
exports.setReceiptInvoices = setReceiptInvoices;
exports.hideReceiptInvoice = hideReceiptInvoice;
exports.changeFormRecordPayment = changeFormRecordPayment;
exports.recordPaymentRequest = recordPaymentRequest;
exports.resendEmail = resendEmail;
exports.showRecordPaymentModal = showRecordPaymentModal;
exports.hideRecordPaymentModal = hideRecordPaymentModal;
exports.printReceiptInvoicePdf = printReceiptInvoicePdf;
exports.showCancelInvoiceModal = showCancelInvoiceModal;
exports.hideCancelInvoiceModal = hideCancelInvoiceModal;
exports.issueRefundRequest = issueRefundRequest;
exports.showOldCancelInvoiceModal = showOldCancelInvoiceModal;
exports.hideOldCancelInvoiceModal = hideOldCancelInvoiceModal;
exports.issueOldRefundRequest = issueOldRefundRequest;
exports.exportInvoices = exportInvoices;
exports.setOutlets = setOutlets;
exports.onClickRecordPayment = onClickRecordPayment;
exports.onCancelRecordPayment = onCancelRecordPayment;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;

var _constants = __webpack_require__(414);

function invoicesPageRequest() {
  return { type: _constants.REPORTS_INVOICES_PAGE_REQUEST, payload: {} };
}

function listInvoiceRequest(query, previousInvoices) {
  return { type: _constants.REPORTS_INVOICES_LIST_INVOICE_REQUEST, payload: { query: query, previousInvoices: previousInvoices } };
}

function setListInvoice(invoices) {
  return { type: _constants.REPORTS_INVOICES_SET_LIST_INVOICE, payload: { invoices: invoices } };
}

/**
 *
 * @param {Date} startDate new start
 * @param {Date} endDate new end
 * @param {array} statuses
 * @param {string} keyword
 * @return {{type, payload: {startDate: *, endDate: *, statuses: *}}}
 */
function changeDateInvoices(startDate, endDate, statuses, keyword) {
  return { type: _constants.REPORTS_INVOICES_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, statuses: statuses, keyword: keyword } };
}

function changeOutletInvoices(outletIds, startDate, endDate, statuses, keyword) {
  return { type: _constants.REPORTS_INVOICES_CHANGE_OUTLET, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, statuses: statuses, keyword: keyword } };
}

function changeStatusInvoices(statuses, startDate, endDate, keyword) {
  return { type: _constants.REPORTS_INVOICES_CHANGE_STATUS, payload: { statuses: statuses, startDate: startDate, endDate: endDate, keyword: keyword } };
}

function receiptInvoicesRequest(id, isMobile) {
  return { type: _constants.REPORTS_INVOICES_RECEIPT_REQUEST, payload: { id: id, isMobile: isMobile } };
}

function setReceiptInvoices(receiptInvoices) {
  return { type: _constants.REPORTS_INVOICES_SET_RECEIPT, payload: { receiptInvoices: receiptInvoices } };
}

function hideReceiptInvoice(isMobile) {
  return { type: _constants.REPORTS_INVOICES_HIDE_RECEIPT, payload: { isMobile: isMobile } };
}

function changeFormRecordPayment(recordPayment) {
  return { type: _constants.REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT, payload: { recordPayment: recordPayment } };
}

function recordPaymentRequest(data) {
  return { type: _constants.REPORTS_INVOICES_RECORD_PAYMENT_REQUEST, payload: { data: data } };
}

function resendEmail(invoiceId) {
  return { type: _constants.REPORTS_INVOICES_RESEND_EMAIL, payload: { invoiceId: invoiceId } };
}

function showRecordPaymentModal() {
  return { type: _constants.REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL, payload: {} };
}

function hideRecordPaymentModal() {
  return { type: _constants.REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL, payload: {} };
}

function printReceiptInvoicePdf(invoiceId) {
  return { type: _constants.REPORTS_INVOICES_PRINT_RECEIPT_PDF, payload: { invoiceId: invoiceId } };
}

function showCancelInvoiceModal() {
  return { type: _constants.REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL, payload: {} };
}

function hideCancelInvoiceModal() {
  return { type: _constants.REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL, payload: {} };
}

function issueRefundRequest(data) {
  return { type: _constants.REPORTS_INVOICES_ISSUE_REFUND_REQUEST, payload: { data: data } };
}

function showOldCancelInvoiceModal() {
  return { type: _constants.REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL, payload: {} };
}

function hideOldCancelInvoiceModal() {
  return { type: _constants.REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL, payload: {} };
}

function issueOldRefundRequest(data) {
  return { type: _constants.REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST, payload: { data: data } };
}

function exportInvoices(query, filename, outletId) {
  return { type: _constants.REPORTS_INVOICES_EXPORT_INVOICES, payload: { query: query, filename: filename, outletId: outletId } };
}

function setOutlets(outlets) {
  return { type: _constants.REPORTS_INVOICES_SET_OUTLETS, payload: { outlets: outlets } };
}

function onClickRecordPayment() {
  return { type: _constants.REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT, payload: {} };
}

function onCancelRecordPayment() {
  return { type: _constants.REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT, payload: {} };
}

function setCurrentPage(currentPage) {
  return { type: _constants.REPORTS_INVOICES_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.REPORTS_INVOICES_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getFilteredDate = getFilteredDate;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFilteredDate(query) {
  return axios.get(api.GET_FILTERED_DATE, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(106);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(1990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableWithChild = function (_React$Component) {
  (0, _inherits3.default)(TableWithChild, _React$Component);

  function TableWithChild() {
    (0, _classCallCheck3.default)(this, TableWithChild);
    return (0, _possibleConstructorReturn3.default)(this, (TableWithChild.__proto__ || (0, _getPrototypeOf2.default)(TableWithChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableWithChild, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerBody = _props.headerBody,
          childBody = _props.childBody,
          footBody = _props.footBody,
          tableClass = _props.tableClass,
          headerBodyClassName = _props.headerBodyClassName,
          childBodyClassName = _props.childBodyClassName,
          footBodyClassName = _props.footBodyClassName;

      return React.createElement(
        'table',
        { className: 'table mk-table-summary mk-table-fixed-hf report-table ' + tableClass },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            headerBody && headerBody.map(function (val, pidx) {
              return React.createElement(
                'th',
                { className: headerBodyClassName[pidx] },
                val
              );
            })
          )
        ),
        React.createElement(
          'tbody',
          null,
          childBody && childBody.map(function (val, pidx) {
            var valObj = (0, _values2.default)(val);
            return React.createElement(
              'tr',
              null,
              valObj.map(function (value, pidx) {
                return React.createElement(
                  'td',
                  { className: '' + childBodyClassName[pidx] },
                  value
                );
              })
            );
          })
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'divider text-total' },
            footBody && (0, _values2.default)(footBody).map(function (value, pidx) {
              return React.createElement(
                'td',
                { className: footBodyClassName[pidx] },
                React.createElement(
                  'b',
                  null,
                  value
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TableWithChild;
}(React.Component);

exports.default = TableWithChild;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BrandImage = __webpack_require__(445);

var _BrandImage2 = _interopRequireDefault(_BrandImage);

var _RefundInfoBox = __webpack_require__(1187);

var _RefundInfoBox2 = _interopRequireDefault(_RefundInfoBox);

var _RefundReason = __webpack_require__(1190);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

var _RefundListItemBox = __webpack_require__(1189);

var _RefundListItemBox2 = _interopRequireDefault(_RefundListItemBox);

var _ListItemBox = __webpack_require__(1188);

var _ListItemBox2 = _interopRequireDefault(_ListItemBox);

var _RefundCountingBox = __webpack_require__(1185);

var _RefundCountingBox2 = _interopRequireDefault(_RefundCountingBox);

var _CountingBox = __webpack_require__(1184);

var _CountingBox2 = _interopRequireDefault(_CountingBox);

var _RefundTotal = __webpack_require__(1194);

var _RefundTotal2 = _interopRequireDefault(_RefundTotal);

var _Total = __webpack_require__(1195);

var _Total2 = _interopRequireDefault(_Total);

var _InfoBox = __webpack_require__(1186);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

var _LoyaltyInfo = __webpack_require__(639);

var _LoyaltyInfo2 = _interopRequireDefault(_LoyaltyInfo);

var _RefundedLoyaltyInfo = __webpack_require__(640);

var _RefundedLoyaltyInfo2 = _interopRequireDefault(_RefundedLoyaltyInfo);

var _TransactionDetailReceipt = __webpack_require__(2029);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionDetailReceipt = function (_React$Component) {
  (0, _inherits3.default)(TransactionDetailReceipt, _React$Component);

  function TransactionDetailReceipt() {
    (0, _classCallCheck3.default)(this, TransactionDetailReceipt);
    return (0, _possibleConstructorReturn3.default)(this, (TransactionDetailReceipt.__proto__ || (0, _getPrototypeOf2.default)(TransactionDetailReceipt)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransactionDetailReceipt, [{
    key: 'render',
    value: function render() {
      var paymentDetail = this.props.paymentDetail;


      return paymentDetail != null && React.createElement(
        'div',
        { className: _TransactionDetailReceipt2.default['receipt-scrolled-area'], id: 'receipt' },
        paymentDetail.receipt_count && paymentDetail.receipt_count > 0 ? React.createElement(
          'i',
          { className: 'glyphicon glyphicon-info-sign ' + _TransactionDetailReceipt2.default['reprinted-receipt'] },
          React.createElement(
            'span',
            { className: '' + _TransactionDetailReceipt2.default['reprinted-text'] },
            'This receipt has been reprinted'
          )
        ) : '',
        paymentDetail.payment_refunds.map(function (paymentRefund, i) {
          return React.createElement(
            'div',
            { key: i },
            paymentDetail.payment_refunds.length > 0 && React.createElement(
              'div',
              { className: _TransactionDetailReceipt2.default['receipt-inner-box'] },
              React.createElement(
                'div',
                { className: _TransactionDetailReceipt2.default['refund-title'] },
                'Refund'
              ),
              React.createElement(
                'div',
                { id: 'show-transaction-page' },
                React.createElement(_BrandImage2.default, { businessLogo: paymentDetail.business_logo,
                  businessName: paymentDetail.business_name,
                  outletAddress: paymentDetail.outlet_address,
                  outletPhone: paymentDetail.outlet_phone }),
                React.createElement(_RefundInfoBox2.default, { paymentDetail: paymentDetail, paymentRefund: paymentRefund }),
                React.createElement(_RefundReason2.default, { paymentRefund: paymentRefund }),
                React.createElement(_RefundListItemBox2.default, { paymentRefund: paymentRefund }),
                React.createElement(_RefundCountingBox2.default, { paymentDetail: paymentDetail, paymentRefund: paymentRefund }),
                React.createElement(_RefundTotal2.default, { amount: paymentRefund.refund_amount }),
                paymentRefund.loyalty && (0, _keys2.default)(paymentRefund.loyalty).length && React.createElement(_RefundedLoyaltyInfo2.default, { loyalty: paymentRefund.loyalty, memberPhone: paymentDetail.customer_phone })
              )
            )
          );
        }),
        React.createElement(
          'div',
          { className: _TransactionDetailReceipt2.default['receipt-inner-box'] + ' ' + (paymentDetail.payment_refunds.length === 0 ? _TransactionDetailReceipt2.default['remove-padding'] : '') },
          React.createElement(_BrandImage2.default, { businessLogo: paymentDetail.business_logo,
            businessName: paymentDetail.business_name,
            outletAddress: paymentDetail.outlet_address,
            outletPhone: paymentDetail.outlet_phone }),
          React.createElement(_InfoBox2.default, { paymentDetail: paymentDetail }),
          React.createElement(_ListItemBox2.default, { paymentDetail: paymentDetail }),
          React.createElement(_CountingBox2.default, { paymentDetail: paymentDetail }),
          React.createElement(_Total2.default, { paymentDetail: paymentDetail }),
          paymentDetail.loyalty && (0, _keys2.default)(paymentDetail.loyalty).length && React.createElement(_LoyaltyInfo2.default, { loyalty: paymentDetail.loyalty, memberPhone: paymentDetail.customer_phone, isUnpaidInvoice: false })
        ),
        React.createElement('div', { className: ['receipt-header-status', paymentDetail.total_collected > paymentDetail.total_amount_received ? 'header-status-red' : 'header-status-orange'].join(' ') })
      );
    }
  }]);
  return TransactionDetailReceipt;
}(React.Component);

TransactionDetailReceipt.propTypes = {
  paymentDetail: React.PropTypes.object
};
exports.default = TransactionDetailReceipt;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2411),
    getValue = __webpack_require__(2438);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(188),
    baseIteratee = __webpack_require__(540),
    baseMap = __webpack_require__(811),
    isArray = __webpack_require__(98);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  true ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var ReactCurrentOwner = __webpack_require__(163);

var warning = __webpack_require__(196);
var canDefineProperty = __webpack_require__(365);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(915);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (true) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (true) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       true ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       true ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (true) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (true) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (true) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (true) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(919);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (true) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.submitForm = submitForm;
exports.setEmployees = setEmployees;
exports.resendInvitation = resendInvitation;
exports.setDeletedEmployee = setDeletedEmployee;
exports.showDeleteEmployeeModal = showDeleteEmployeeModal;
exports.hideDeleteEmployeeModal = hideDeleteEmployeeModal;
exports.askDeleteEmployee = askDeleteEmployee;
exports.confirmDeleteEmployee = confirmDeleteEmployee;
exports.cancelDeleteEmployee = cancelDeleteEmployee;
exports.showAssignOutletModal = showAssignOutletModal;
exports.hideAssignOutletModal = hideAssignOutletModal;
exports.setOutlets = setOutlets;
exports.checkAllOutlets = checkAllOutlets;
exports.uncheckAllOutlets = uncheckAllOutlets;
exports.searchOutlet = searchOutlet;
exports.setCheckedOutlets = setCheckedOutlets;
exports.assignOutlets = assignOutlets;
exports.confirmAssignOutlets = confirmAssignOutlets;
exports.cancelAssignOutlets = cancelAssignOutlets;
exports.setProfile = setProfile;

var _constants = __webpack_require__(391);

function pageRequest() {
  return { type: _constants.EMPLOYEE_LIST_PAGE_REQUEST, payload: {} };
}

function submitForm(data, params) {
  return { type: _constants.EMPLOYEE_LIST_SUBMIT_FORM, payload: { data: data, params: params } };
}

function setEmployees(employees) {
  return { type: _constants.EMPLOYEE_LIST_SET_EMPLOYEES, payload: { employees: employees } };
}

function resendInvitation(email) {
  return { type: _constants.EMPLOYEE_LIST_RESEND_INVITATION, payload: { email: email } };
}

function setDeletedEmployee(deletedEmployee) {
  return { type: _constants.EMPLOYEE_LIST_SET_DELETED_EMPLOYEE, payload: { deletedEmployee: deletedEmployee } };
}

function showDeleteEmployeeModal() {
  return { type: _constants.EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL, payload: {} };
}

function hideDeleteEmployeeModal() {
  return { type: _constants.EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL, payload: {} };
}

function askDeleteEmployee(deletedEmployee) {
  return { type: _constants.EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE, payload: { deletedEmployee: deletedEmployee } };
}

function confirmDeleteEmployee(deletedEmployee) {
  return { type: _constants.EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE, payload: { deletedEmployee: deletedEmployee } };
}

function cancelDeleteEmployee(deletedEmployee) {
  return { type: _constants.EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE, payload: {} };
}

function showAssignOutletModal() {
  return { type: _constants.EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL, payload: {} };
}

function hideAssignOutletModal() {
  return { type: _constants.EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.EMPLOYEE_LIST_SET_OUTLETS, payload: { outlets: outlets } };
}

/**
 *
 * @param fields
 * @param formName
 * @param fieldName
 * @return {{type, payload: {outlets: *, formName: *, fieldName: *}}}
 */
function checkAllOutlets(fields, formName, fieldName) {
  return { type: _constants.EMPLOYEE_LIST_CHECK_ALL_OUTLETS, payload: { fields: fields, formName: formName, fieldName: fieldName } };
}

function uncheckAllOutlets(fields, formName, fieldName) {
  return { type: _constants.EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS, payload: { fields: fields, formName: formName, fieldName: fieldName } };
}

function searchOutlet(outlets, formName, fieldName, keyword) {
  return { type: _constants.EMPLOYEE_LIST_SEARCH_OUTLET, payload: { outlets: outlets, formName: formName, fieldName: fieldName, keyword: keyword } };
}

function setCheckedOutlets(outlets) {
  return { type: _constants.EMPLOYEE_LIST_SET_CHECKED_OUTLETS, payload: { outlets: outlets } };
}

function assignOutlets(previousOutlets, inviteForm) {
  return { type: _constants.EMPLOYEE_LIST_ASSIGN_OUTLETS, payload: { previousOutlets: previousOutlets, inviteForm: inviteForm } };
}

function confirmAssignOutlets(outlets) {
  return { type: _constants.EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS, payload: { outlets: outlets } };
}

function cancelAssignOutlets(previousOutlets, formName, fieldName) {
  return { type: _constants.EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS, payload: { previousOutlets: previousOutlets, formName: formName, fieldName: fieldName } };
}

function setProfile(profile) {
  return { type: _constants.EMPLOYEE_LIST_SET_PROFILE, payload: { profile: profile } };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.suppliersRequest = suppliersRequest;
exports.setOutlets = setOutlets;
exports.onChangeKeyword = onChangeKeyword;
exports.setSuppliers = setSuppliers;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.askDeleteSupplier = askDeleteSupplier;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.onClickRow = onClickRow;
exports.setSupplierDetail = setSupplierDetail;
exports.exportSupplier = exportSupplier;
exports.setProfile = setProfile;
exports.onClickCancel = onClickCancel;
exports.deleteSupplier = deleteSupplier;
exports.cancelDeleteSupplier = cancelDeleteSupplier;
exports.openDeleteSupplierModal = openDeleteSupplierModal;
exports.closeDeleteSupplierModal = closeDeleteSupplierModal;
exports.onClickCreateSupplier = onClickCreateSupplier;
exports.isSubmittingForm = isSubmittingForm;

var _constants = __webpack_require__(403);

function pageRequest() {
  return { type: _constants.INVENTORY_SUPPLIER_PAGE_REQUEST, payload: {} };
}

function suppliersRequest(params) {
  return { type: _constants.INVENTORY_SUPPLIER_SUPPLIERS_REQUEST, payload: { params: params } };
}

function setOutlets(outlets) {
  return { type: _constants.INVENTORY_SUPPLIER_SET_OUTLETS, payload: { outlets: outlets } };
}

function onChangeKeyword(keyword) {
  return { type: _constants.INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD, payload: { keyword: keyword } };
}

function setSuppliers(suppliers) {
  return { type: _constants.INVENTORY_SUPPLIER_SET_SUPPLIERS, payload: { suppliers: suppliers } };
}

function openRightColumn() {
  return { type: _constants.INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN, payload: {} };
}

function closeRightColumn() {
  return { type: _constants.INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN, payload: {} };
}

function askDeleteSupplier(supplier) {
  return { type: _constants.INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER, payload: { supplier: supplier } };
}

function submitFormCreate(data, previousSuppliers) {
  return { type: _constants.INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE, payload: { data: data, previousSuppliers: previousSuppliers } };
}

function submitFormUpdate(supplierId, data, previousSuppliers) {
  return { type: _constants.INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE, payload: { supplierId: supplierId, data: data, previousSuppliers: previousSuppliers } };
}

function onClickRow(supplier) {
  return { type: _constants.INVENTORY_SUPPLIER_ON_CLICK_ROW, payload: { supplier: supplier } };
}

function setSupplierDetail(supplier) {
  return { type: _constants.INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL, payload: { supplier: supplier } };
}

function exportSupplier(params, filename) {
  return { type: _constants.INVENTORY_SUPPLIER_EXPORT_SUPPLIER, payload: { params: params, filename: filename } };
}

function setProfile(profile) {
  return { type: _constants.INVENTORY_SUPPLIER_SET_PROFILE, payload: { profile: profile } };
}

function onClickCancel() {
  return { type: _constants.INVENTORY_SUPPLIER_ON_CLICK_CANCEL, payload: {} };
}

function deleteSupplier(supplier, suppliers) {
  return { type: _constants.INVENTORY_SUPPLIER_DELETE_SUPPLIER, payload: { supplier: supplier, suppliers: suppliers } };
}

function cancelDeleteSupplier() {
  return { type: _constants.INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER, payload: {} };
}

function openDeleteSupplierModal() {
  return { type: _constants.INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL, payload: {} };
}

function closeDeleteSupplierModal() {
  return { type: _constants.INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL, payload: {} };
}

function onClickCreateSupplier() {
  return { type: _constants.INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER, payload: {} };
}

function isSubmittingForm(isSubmittingForm) {
  return { type: _constants.INVENTORY_SUPPLIER_IS_SUBMITTING_FORM, payload: { isSubmittingForm: isSubmittingForm } };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingPageRequest = billingPageRequest;
exports.rulesOutletsSubscriptionStatus = rulesOutletsSubscriptionStatus;
exports.billings = billings;
exports.setBillings = setBillings;
exports.setOutlets = setOutlets;
exports.setRules = setRules;
exports.setSubscriptionStatus = setSubscriptionStatus;
exports.onChangeSubscriptionRules = onChangeSubscriptionRules;
exports.setCurrentSubscriptionRules = setCurrentSubscriptionRules;
exports.payMokaSubscription = payMokaSubscription;
exports.isClickedPayButton = isClickedPayButton;
exports.payButtonMessage = payButtonMessage;
exports.showPaymentGatewayErrorModal = showPaymentGatewayErrorModal;
exports.hidePaymentGatewayErrorModal = hidePaymentGatewayErrorModal;
exports.setTotalBillingPrice = setTotalBillingPrice;
exports.setPendingPaymentMessage = setPendingPaymentMessage;
exports.setUnusedOutletMessage = setUnusedOutletMessage;
exports.setCurrentSubscriptionPlanName = setCurrentSubscriptionPlanName;
exports.setCountFeatureSubscription = setCountFeatureSubscription;
exports.onClickCancelSubscriptionModal = onClickCancelSubscriptionModal;
exports.setCancelSubsciptionModalData = setCancelSubsciptionModalData;
exports.showCancelSubscriptionModal = showCancelSubscriptionModal;
exports.hideCancelSubscriptionModal = hideCancelSubscriptionModal;
exports.featureSubscriptionPrice = featureSubscriptionPrice;
exports.setFeatureSubscriptionPrice = setFeatureSubscriptionPrice;
exports.cancelFeatureSubscription = cancelFeatureSubscription;
exports.setMinMaxDate = setMinMaxDate;
exports.onClickTurnButton = onClickTurnButton;
exports.setIsDeletedOutlet = setIsDeletedOutlet;

var _constant = __webpack_require__(419);

function billingPageRequest(currentPlan, expired, isOwner, billingNotification) {
  return {
    type: _constant.SETTING_BILLING_PAGE_REQUEST,
    payload: { currentPlan: currentPlan, expired: expired, isOwner: isOwner, billingNotification: billingNotification }
  };
} /**
   * Created by alvinoktavianus on 5/9/17.
   */

function rulesOutletsSubscriptionStatus(currentPlan, expired, isTrial, outletSlot) {
  return {
    type: _constant.SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
    payload: { currentPlan: currentPlan, expired: expired, isTrial: isTrial, outletSlot: outletSlot }
  };
}

function billings() {
  return {
    type: _constant.SETTING_BILLING_BILLINGS
  };
}

function setBillings(data) {
  return {
    type: _constant.SETTING_BILLING_SET_BILLINGS,
    payload: { data: data }
  };
}

function setOutlets(data) {
  return {
    type: _constant.SETTING_BILLING_SET_OUTLETS,
    payload: { data: data }
  };
}

function setRules(data) {
  return {
    type: _constant.SETTING_BILLING_SET_RULES,
    payload: { data: data }
  };
}

function setSubscriptionStatus(data) {
  return {
    type: _constant.SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
    payload: { data: data }
  };
}

function onChangeSubscriptionRules(subscriptionRules) {
  return {
    type: _constant.SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
    payload: { subscriptionRules: subscriptionRules }
  };
}

function setCurrentSubscriptionRules(newSubscriptionRules) {
  return {
    type: _constant.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
    payload: { newSubscriptionRules: newSubscriptionRules }
  };
}

function payMokaSubscription(totalPrice, subscriptionPlan, purchasedOutlets, activatedFeatures) {
  return {
    type: _constant.SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
    payload: { totalPrice: totalPrice, subscriptionPlan: subscriptionPlan, purchasedOutlets: purchasedOutlets, activatedFeatures: activatedFeatures }
  };
}

function isClickedPayButton(payButtonClicked) {
  return {
    type: _constant.SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
    payload: { payButtonClicked: payButtonClicked }
  };
}

function payButtonMessage(payButtonMessage) {
  return {
    type: _constant.SETTING_BILLING_PAY_BUTTON_MESSAGE,
    payload: { payButtonMessage: payButtonMessage }
  };
}

function showPaymentGatewayErrorModal() {
  return {
    type: _constant.SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
  };
}

function hidePaymentGatewayErrorModal() {
  return {
    type: _constant.SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL
  };
}

function setTotalBillingPrice(totalBillingPrice) {
  return {
    type: _constant.SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
    payload: { totalBillingPrice: totalBillingPrice }
  };
}

function setPendingPaymentMessage(pendingPaymentMessage) {
  return {
    type: _constant.SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingPaymentMessage: pendingPaymentMessage }
  };
}

function setUnusedOutletMessage(unusedOutletMessage) {
  return {
    type: _constant.SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
    payload: { unusedOutletMessage: unusedOutletMessage }
  };
}

function setCurrentSubscriptionPlanName(planName) {
  return {
    type: _constant.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
    payload: { planName: planName }
  };
}

function setCountFeatureSubscription(countFeatureSubscription) {
  return {
    type: _constant.SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
    payload: { countFeatureSubscription: countFeatureSubscription }
  };
}

function onClickCancelSubscriptionModal(featureSubscriptionModalData) {
  return {
    type: _constant.SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: { featureSubscriptionModalData: featureSubscriptionModalData }
  };
}

function setCancelSubsciptionModalData(featureSubscriptionModalData) {
  return {
    type: _constant.SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: { featureSubscriptionModalData: featureSubscriptionModalData }
  };
}

function showCancelSubscriptionModal() {
  return {
    type: _constant.SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL
  };
}

function hideCancelSubscriptionModal() {
  return {
    type: _constant.SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL
  };
}

function featureSubscriptionPrice() {
  return {
    type: _constant.SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE
  };
}

function setFeatureSubscriptionPrice(featureSubscriptionPrice) {
  return {
    type: _constant.SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
    payload: { featureSubscriptionPrice: featureSubscriptionPrice }
  };
}

function cancelFeatureSubscription(featureName, featureSubscriptionStatus, outletMinMaxDate) {
  return {
    type: _constant.SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
    payload: { featureName: featureName, featureSubscriptionStatus: featureSubscriptionStatus, outletMinMaxDate: outletMinMaxDate }
  };
}

function setMinMaxDate(minMaxDate) {
  return {
    type: _constant.SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
    payload: { minMaxDate: minMaxDate }
  };
}

function onClickTurnButton(id, prevIsDeleted) {
  return {
    type: _constant.SETTING_BILLING_ON_CLICK_TURN_BUTTON,
    payload: { id: id, prevIsDeleted: prevIsDeleted }
  };
}

function setIsDeletedOutlet(isDeleted) {
  return {
    type: _constant.SETTING_BILLING_SET_IS_DELETED_OUTLET,
    payload: { isDeleted: isDeleted }
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.submitForm = submitForm;
exports.setProfile = setProfile;
exports.showRecipientModal = showRecipientModal;
exports.hideRecipientModal = hideRecipientModal;
exports.changePage = changePage;
exports.setPreviousEmailNotificationForm = setPreviousEmailNotificationForm;
exports.onCancelManageRecipients = onCancelManageRecipients;
exports.onConfirmManageRecipients = onConfirmManageRecipients;
exports.onClickManageRecipients = onClickManageRecipients;
exports.showSettingAlertRecipientsErrors = showSettingAlertRecipientsErrors;
exports.hideSettingAlertRecipientsErrors = hideSettingAlertRecipientsErrors;
exports.onClickDelete = onClickDelete;
exports.showDeleteRecipientModal = showDeleteRecipientModal;
exports.hideDeleteRecipientModal = hideDeleteRecipientModal;
exports.cancelDeleteRecipient = cancelDeleteRecipient;
exports.onDeleteRecipient = onDeleteRecipient;
exports.setDeletedRecipient = setDeletedRecipient;

var _constants = __webpack_require__(421);

function pageRequest() {
  return { type: _constants.SETTING_EMAIL_PAGE_REQUEST, payload: {} };
}

function submitForm(data) {
  return { type: _constants.SETTING_EMAIL_SUBMIT_FORM, payload: { data: data } };
}

function setProfile(profile) {
  return { type: _constants.SETTING_EMAIL_SET_PROFILE, payload: { profile: profile } };
}

function showRecipientModal() {
  return { type: _constants.SETTING_EMAIL_SHOW_RECIPIENT_MODAL, payload: {} };
}

function hideRecipientModal() {
  return { type: _constants.SETTING_EMAIL_HIDE_RECIPIENT_MODAL, payload: {} };
}

function changePage(location) {
  return { type: _constants.SETTING_EMAIL_CHANGE_PAGE, payload: { location: location } };
}

function setPreviousEmailNotificationForm(previousEmailNotificationForm) {
  return { type: _constants.SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM, payload: { previousEmailNotificationForm: previousEmailNotificationForm } };
}

function onCancelManageRecipients(previousEmailNotificationForm) {
  return { type: _constants.SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS, payload: { previousEmailNotificationForm: previousEmailNotificationForm } };
}

function onConfirmManageRecipients(emailNotificationForm, previousEmailNotificationForm) {
  return { type: _constants.SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS, payload: { emailNotificationForm: emailNotificationForm, previousEmailNotificationForm: previousEmailNotificationForm } };
}

function onClickManageRecipients(previousEmailNotificationForm) {
  return { type: _constants.SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS, payload: { previousEmailNotificationForm: previousEmailNotificationForm } };
}

function showSettingAlertRecipientsErrors() {
  return { type: _constants.SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS, payload: {} };
}

function hideSettingAlertRecipientsErrors() {
  return { type: _constants.SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS, payload: {} };
}

function onClickDelete(deletedRecipient) {
  return { type: _constants.SETTING_EMAIL_ON_CLICK_DELETE_ICON, payload: { deletedRecipient: deletedRecipient } };
}

function showDeleteRecipientModal() {
  return { type: _constants.SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL, payload: {} };
}

function hideDeleteRecipientModal() {
  return { type: _constants.SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL, payload: {} };
}

function cancelDeleteRecipient(deletedRecipient) {
  return { type: _constants.SETTING_EMAIL_CANCEL_DELETE_RECIPIENT, payload: { deletedRecipient: deletedRecipient } };
}

function onDeleteRecipient(deletedRecipient, emailNotificationForm) {
  return { type: _constants.SETTING_EMAIL_DELETE_RECIPIENT, payload: { deletedRecipient: deletedRecipient, emailNotificationForm: emailNotificationForm } };
}

function setDeletedRecipient(deletedRecipient) {
  return { type: _constants.SETTING_EMAIL_SET_DELETED_RECIPIENT, payload: { deletedRecipient: deletedRecipient } };
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSubscriptionExpiredModal = showSubscriptionExpiredModal;
exports.hideSubscriptionExpiredModal = hideSubscriptionExpiredModal;
exports.isSubscriptionExpired = isSubscriptionExpired;
exports.askShowSubscriptionExpired = askShowSubscriptionExpired;
exports.setNextActionExpired = setNextActionExpired;
exports.closeModal = closeModal;

var _constants = __webpack_require__(424);

function showSubscriptionExpiredModal() {
  return {
    type: _constants.SUBSCRIPTION_EXPIRED_SHOW_MODAL,
    payload: {}
  };
}

function hideSubscriptionExpiredModal() {
  return {
    type: _constants.SUBSCRIPTION_EXPIRED_HIDE_MODAL,
    payload: {}
  };
}

function isSubscriptionExpired(expired) {
  return {
    type: _constants.IS_SUBSCRIPTION_EXPIRED,
    payload: { expired: expired }
  };
}

function askShowSubscriptionExpired(nextActionExpired) {
  return {
    type: _constants.ASK_SHOW_SUBSCRIPTION_EXPIRED,
    payload: { nextActionExpired: nextActionExpired }
  };
}

function setNextActionExpired(nextActionExpired) {
  return {
    type: _constants.SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION,
    payload: { nextActionExpired: nextActionExpired }
  };
}

function closeModal() {
  return {
    type: _constants.SUBSCRIPTION_EXPIRED_CLOSE_MODAL,
    payload: {}
  };
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getAll = getAll;
exports.getIngredients = getIngredients;
exports.getHaveRecipe = getHaveRecipe;

var _constants = __webpack_require__(1093);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getAll(params) {
  return axios.get(_constants.V1_ALL, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getIngredients(params) {
  return axios.get(_constants.V1_URL, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getHaveRecipe(params) {
  return axios.get(_constants.V1_HAVE_RECIPE, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loyaltyStart = loyaltyStart;
exports.loyaltyVideoStart = loyaltyVideoStart;
exports.createProgramShowProgramType = createProgramShowProgramType;
exports.createProgramShowPointRule = createProgramShowPointRule;
exports.createProgramShowReward = createProgramShowReward;
exports.createProgramShowConfiguration = createProgramShowConfiguration;
exports.createProgramShowSubscribeFreeTrial = createProgramShowSubscribeFreeTrial;
exports.createProgramShowReview = createProgramShowReview;
exports.createLoyalty = createLoyalty;
exports.createLoyaltySuccess = createLoyaltySuccess;
exports.createLoyaltyFail = createLoyaltyFail;
exports.showManageLoyalty = showManageLoyalty;
exports.editProgramStart = editProgramStart;
exports.resetProgramStart = resetProgramStart;
exports.reactivateLoyalty = reactivateLoyalty;
exports.deactivateLoyalty = deactivateLoyalty;
exports.resetLoyalty = resetLoyalty;
exports.editLoyalty = editLoyalty;

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loyaltyStart() {
  mixpanel.track('Loyalty Start');
} /* global mixpanel */
function loyaltyVideoStart() {
  mixpanel.track('Loyalty Video');
}

function createProgramShowProgramType() {
  mixpanel.track('Loyalty Create 1. Program Type');
}

function createProgramShowPointRule() {
  mixpanel.track('Loyalty Create 2. Point Rule');
}

function createProgramShowReward() {
  mixpanel.track('Loyalty Create 3. Reward');
}

function createProgramShowConfiguration() {
  mixpanel.track('Loyalty Create 4. Configuration');
}

function createProgramShowSubscribeFreeTrial(expiredDate) {
  mixpanel.track('Loyalty Create 6. Subscribe Free Trial', { 'Subscribe Expired Date': expiredDate });
}

function createProgramShowReview() {
  mixpanel.track('Loyalty Create 5. Review');
}

function createLoyalty(data) {
  mixpanel.track('Loyalty Create 7. Subscribe and Submit', loyaltyProgramInfoToMixPanelInfo(data));
}

function createLoyaltySuccess() {
  mixpanel.track('Loyalty Create 8.1 Success');
}

function createLoyaltyFail(displayErrorMessage, error) {
  mixpanel.track('Loyalty Create 8.1 Failed', {
    'Error Message Display': displayErrorMessage,
    'Error Message Detail': error
  });
}

function loyaltyProgramInfoToMixPanelInfo(programInfo) {
  var rewards = _lodash2.default.map(programInfo.rewards, function (reward) {
    return {
      'Reward Type': 'Discount of Total Sale',
      'Redeem Points': reward.redeem_point,
      'Discount Amount': reward.discount_type === 'percentage' ? reward.discount + '%' : 'Rp. ' + reward.discount,
      'Discount For': 'Total Sale'
    };
  });

  return {
    'Program Type': 'Rp X = Y Point',
    'Transaction Value': programInfo.earning_rule.amount,
    'Transaction Point Amount': programInfo.earning_rule.point,
    'New Member Point Amount': programInfo.new_member_point,
    'Rewards': rewards,
    'Send Validation Code': programInfo.is_sent_validation_code
  };
}

//* ***************  MANAGE EXISTING LOYALTY *************************

function showManageLoyalty() {
  mixpanel.track('Loyalty Manage');
}

function editProgramStart() {
  mixpanel.track('Loyalty Edit 1. Start');
}

function resetProgramStart() {
  mixpanel.track('Loyalty Reset 1. Start');
}

function reactivateLoyalty(data) {
  mixpanel.track('Loyalty Reactivate', loyaltyProgramInfoToMixPanelInfo(data));
}

function deactivateLoyalty(data) {
  mixpanel.track('Loyalty Deactivate', loyaltyProgramInfoToMixPanelInfo(data));
}

function resetLoyalty(data) {
  mixpanel.track('Loyalty Reset 2. Submit', loyaltyProgramInfoToMixPanelInfo(data));
}

function editLoyalty(data) {
  mixpanel.track('Loyalty Edit 2. Submit', loyaltyProgramInfoToMixPanelInfo(data));
}

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-Customers-Loyalty-Components-Review-__Review___3JGyK","section-label":"app-pages-Customers-Loyalty-Components-Review-__Review___3KZVp","program-info":"app-pages-Customers-Loyalty-Components-Review-__Review___K08ZP","program-info-chosen":"app-pages-Customers-Loyalty-Components-Review-__Review___3ktfn","review-button-revise":"app-pages-Customers-Loyalty-Components-Review-__Review___GjOdI","splash-page":"app-pages-Customers-Loyalty-Components-Review-__Review___1SaDm","review-button-confirm":"app-pages-Customers-Loyalty-Components-Review-__Review___vwAnF","modal-header-danger":"app-pages-Customers-Loyalty-Components-Review-__Review___2F1rC","modal-body":"app-pages-Customers-Loyalty-Components-Review-__Review___279QV","modal-dialog":"app-pages-Customers-Loyalty-Components-Review-__Review___3ad4q","modal-highlighted-message":"app-pages-Customers-Loyalty-Components-Review-__Review___1kkrc","button-fixed-position":"app-pages-Customers-Loyalty-Components-Review-__Review___2gvbL"};

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentStatus = updatePaymentStatus;
exports.setNotificationMessage = setNotificationMessage;
exports.setNotificationType = setNotificationType;

var _constant = __webpack_require__(382);

function updatePaymentStatus(orderId, statusCode, transactionStatus) {
  return {
    type: _constant.BILLING_REDIRECT_UPDATE_PAYMENT_STATUS,
    payload: { orderId: orderId, statusCode: statusCode, transactionStatus: transactionStatus }
  };
} /**
   * Created by alvinoktavianus on 6/21/17.
   */

function setNotificationMessage(notifMessage) {
  return {
    type: _constant.BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE,
    payload: { notifMessage: notifMessage }
  };
}

function setNotificationType(notifType) {
  return {
    type: _constant.BILLING_REDIRECT_SET_NOTIFICATION_TYPE,
    payload: { notifType: notifType }
  };
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionStatus = subscriptionStatus;
exports.setSubscriptionStatus = setSubscriptionStatus;

var _constant = __webpack_require__(400);

function subscriptionStatus() {
  return { type: _constant.INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS };
}

function setSubscriptionStatus(status) {
  return { type: _constant.INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS, payload: { status: status } };
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setOutlets = setOutlets;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeDate = onChangeDate;
exports.onChangeKeyword = onChangeKeyword;
exports.summaryRequest = summaryRequest;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.setItems = setItems;
exports.setRowItems = setRowItems;
exports.exportSummary = exportSummary;
exports.onChangeNamespace = onChangeNamespace;
exports.ingInvSummaryRequest = ingInvSummaryRequest;
exports.setIngredients = setIngredients;

var _constants = __webpack_require__(402);

function pageRequest() {
  return { type: _constants.INVENTORY_SUMMARY_PAGE_REQUEST, payload: {} };
}

function setOutlets(outlets) {
  return { type: _constants.INVENTORY_SUMMARY_SET_OUTLETS, payload: { outlets: outlets } };
}

function onChangeOutletIds(outletIds, _ref, namespace) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;

  return { type: _constants.INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, namespace: namespace } };
}

function onChangeDate(_ref2, keyword, namespace) {
  var startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  return { type: _constants.INVENTORY_SUMMARY_ON_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, keyword: keyword, namespace: namespace } };
}

function onChangeKeyword(keyword, _ref3, namespace) {
  var startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  return { type: _constants.INVENTORY_SUMMARY_ON_CHANGE_KEYWORD, payload: { keyword: keyword, startDate: startDate, endDate: endDate, namespace: namespace } };
}

function summaryRequest(params, previousItems, previousRowItems, namespace) {
  return { type: _constants.INVENTORY_SUMMARY_SUMMARY_REQUEST, payload: { namespace: namespace, params: params, previousItems: previousItems, previousRowItems: previousRowItems } };
}

function setCurrentPage(page) {
  return { type: _constants.INVENTORY_SUMMARY_SET_CURRENT_PAGE, payload: { page: page } };
}

function setTotalPage(page) {
  return { type: _constants.INVENTORY_SUMMARY_SET_TOTAL_PAGE, payload: { page: page } };
}

function setItems(items) {
  return { type: _constants.INVENTORY_SUMMARY_SET_ITEMS, payload: { items: items } };
}

function setRowItems(items) {
  return { type: _constants.INVENTORY_SUMMARY_SET_ROW_ITEMS, payload: { items: items } };
}

function exportSummary(params, filename, outletId) {
  return { type: _constants.INVENTORY_SUMMARY_EXPORT_SUMMARY, payload: { params: params, filename: filename, outletId: outletId } };
}

function onChangeNamespace(namespace, params) {
  return { type: _constants.INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE, payload: { namespace: namespace, params: params } };
}

function ingInvSummaryRequest(params, previousIngredients, namespace) {
  return { type: _constants.INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST, payload: { params: params, previousIngredients: previousIngredients, namespace: namespace } };
}

function setIngredients(ingredients) {
  return { type: _constants.INVENTORY_SUMMARY_SET_INGREDIENTS, payload: { ingredients: ingredients } };
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOutlets = setOutlets;
exports.outletsRequest = outletsRequest;
exports.setCurrentOutlet = setCurrentOutlet;

var _constants = __webpack_require__(412);

function setOutlets(outlets) {
  return { type: _constants.SET_OUTLETS, payload: { outlets: outlets } };
}

function outletsRequest() {
  return { type: _constants.OUTLETS_REQUEST, payload: {} };
}

function setCurrentOutlet(data) {
  return { type: _constants.SET_CURRENT_OUTLET, payload: { data: data } };
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doImportCustomer = doImportCustomer;
exports.doImportItem = doImportItem;
exports.showModalImport = showModalImport;
exports.showModalErrorImport = showModalErrorImport;
exports.setImportingStatus = setImportingStatus;

var _constants = __webpack_require__(425);

// export function for import csv
function doImportCustomer(file, hasLoyalty) {
  return { type: _constants.DO_IMPORT_CUSTOMER, payload: { file: file, hasLoyalty: hasLoyalty } };
}

function doImportItem(file, importType) {
  return { type: _constants.DO_IMPORT_ITEM, payload: { file: file, importType: importType } };
}

function showModalImport(showModalImport) {
  return { type: _constants.SHOW_MODAL_IMPORT, payload: { showModalImport: showModalImport } };
}

function showModalErrorImport(status, message) {
  return { type: _constants.SHOW_MODAL_ERROR_IMPORT, payload: { showModalErrorImport: status, messageError: message } };
}

function setImportingStatus(status) {
  return { type: _constants.SET_IMPORTING_STATUS, payload: { importingStatus: status } };
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.login = login;
exports.referral = referral;
exports.resendVerificationEmail = resendVerificationEmail;
exports.outlets = outlets;
exports.loggedIn = loggedIn;
exports.logout = logout;
exports.registered = registered;
exports.registerBusiness = registerBusiness;
exports.getBusinessTypes = getBusinessTypes;
exports.selectOutlet = selectOutlet;
exports.getProfile = getProfile;
exports.getBusinessCategories = getBusinessCategories;
exports.getResetPassword = getResetPassword;
exports.resetPassword = resetPassword;
exports.loadPrepareEncryption = loadPrepareEncryption;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = __webpack_require__(199);
// TODO:
// Make interceptor request for any request with `withCredentials: true` config

function login(email, password) {
  return axios.post(api.LOGIN_URL, { 'session': { email: email, password: password } }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}

function referral(ref) {
  return axios.get(api.REFERRAL_URL, { params: { ref: ref } }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var obj = new Error(error.response.data.error);
      obj.status = error.response.status;
      return _promise2.default.reject(obj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function resendVerificationEmail(email) {
  return axios.post(api.RESEND_VERIFICATION_EMAIL_URL, { email: email }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      // The request was made, but the server responded with a status code
      // that falls out of the range of 2xx
      var eobj = new Error(error.response.data.message);
      eobj.status = error.response.data.status;
      return _promise2.default.reject(eobj);
    } else {
      // Something happened in setting up the request that triggered an Error
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function outlets() {
  if (!loggedIn()) return _promise2.default.reject(new Error('Not logged in'));

  return axios.get(api.OUTLETS_URL, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function resetLoggedIn() {
  Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' });
  store.clearAll();
}

function loggedIn() {
  var loggedInData = store.get('response:login');
  var cookiesData = Cookies.get('remember_token');

  if (isLocalStorageNameSupported()) {
    if (!loggedInData || !cookiesData) {
      resetLoggedIn();
      return false;
    }

    try {
      JSON.parse(loggedInData).user;
      return true;
    } catch (e) {
      resetLoggedIn();
      return false;
    }
  } else {
    if (!cookiesData) {
      resetLoggedIn();
      return false;
    } else {
      return true;
    }
  }
}

function logout() {
  if (!loggedIn()) {
    return _promise2.default.resolve(false);
  }

  var successLogout = function successLogout() {
    resetLoggedIn();
    return _promise2.default.resolve(true);
  };

  return axios.delete(api.LOGOUT_URL, { withCredentials: true }).then(function (response) {
    return successLogout();
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}

function registered(email) {
  return axios.get(api.REGISTER_URL + email, { email: email }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}

function registerBusiness(data) {
  return axios.post(api.REGISTER_BUSINESS_URL, data).then(function (response) {
    return _promise2.default.resolve(response);
  });
}

function getBusinessTypes() {
  return axios.get(api.BUSINESS_TYPES_URL).then(function (response) {
    return _promise2.default.resolve(response);
  });
}

function selectOutlet(outletIds) {
  return axios.patch(api.UPDATE_SELECTED_OUTLET, { id: outletIds }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(true);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function getProfile() {
  return axios.get(api.GET_PROFILE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function getBusinessCategories(businessTypeId) {
  return axios.get(api.BUSINESS_CATEGORIES_URL, {
    params: {
      business_type_id: businessTypeId
    }
  }).then(function (response) {
    return _promise2.default.resolve(response);
  });
}
function getResetPassword(query) {
  return axios.get(api.GET_RESET_PASSWORD_URL, {
    params: query,
    withCredentials: true
  }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}
function resetPassword(query) {
  return axios.post(api.RESET_PASSWORD_URL, { access_token: query.access_token, password: query.newPassword, password_confirmation: query.confPassword }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function loadPrepareEncryption() {
  return axios.get(api.LOAD_PREPARE_ENCRYPTION_URL, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function isLocalStorageNameSupported() {
  var testKey = 'test';
  var storage = window.localStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(65)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVATE_TRIAL = exports.END_TUTORIAL = exports.GET_FEATURE_PRICE = exports.GET_FEATURE_PRICE_PER_MONTHS = exports.GET_SUBSCRIPTION_STATUS = undefined;

var _constants = __webpack_require__(30);

var GET_SUBSCRIPTION_STATUS = exports.GET_SUBSCRIPTION_STATUS = _constants.API_URL + '/v1/feature/get_subscription_status';
var GET_FEATURE_PRICE_PER_MONTHS = exports.GET_FEATURE_PRICE_PER_MONTHS = _constants.API_URL + '/v1/feature/get_feature_price_per_months';
var GET_FEATURE_PRICE = exports.GET_FEATURE_PRICE = _constants.API_URL + '/v1/billings/feature_price';
var END_TUTORIAL = exports.END_TUTORIAL = _constants.API_URL + '/v1/feature/finish_tutorial';
var ACTIVATE_TRIAL = exports.ACTIVATE_TRIAL = _constants.API_URL + '/v1/feature/activate_trial';

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getItemByIdV1 = getItemByIdV1;
exports.getItems = getItems;
exports.getItemsV2 = getItemsV2;
exports.getItemsV1 = getItemsV1;

var _constants = __webpack_require__(433);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getItemByIdV1(id, params) {
  return axios.get(api.V1_ITEM_BY_ID(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

/**
 * Get list item from server
 * TODO change to getItemsV2
 */
function getItems(params) {
  return axios.get('' + api.ITEMS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getItemsV2(params) {
  return axios.get('' + api.V2_ITEMS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getItemsV1(params) {
  return axios.get('' + api.V1_ITEMS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.updateFilteredDate = updateFilteredDate;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateFilteredDate(query) {
  return axios.get(api.UPDATE_FILTERED_DATE, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(1960);

var _style2 = _interopRequireDefault(_style);

var _reactBootstrap = __webpack_require__(10);

var _outletIcon = __webpack_require__(2875);

var _outletIcon2 = _interopRequireDefault(_outletIcon);

var _actionBar = __webpack_require__(80);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutletModal = function (_React$Component) {
  (0, _inherits3.default)(OutletModal, _React$Component);

  function OutletModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OutletModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OutletModal.__proto__ || (0, _getPrototypeOf2.default)(OutletModal)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function (outletIds) {
      var _this$props = _this.props,
          onChange = _this$props.input.onChange,
          dispatch = _this$props.meta.dispatch;

      dispatch((0, _actionBar.setSelectedOutletIds)(outletIds));
      onChange(outletIds);
    }, _this._onChangeOutletIds = function (outletIds) {
      _this.props.onChangeOutletIds(outletIds);
    }, _this._onHideOutletModal = function () {
      var dispatch = _this.props.meta.dispatch;

      dispatch((0, _actions.showModalOutletMobile)(false));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OutletModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          outlets = _props.outlets,
          allOutletOption = _props.allOutletOption,
          value = _props.input.value;

      var allOutlet = {
        id: outlets.map(function (outlet) {
          return outlet.id;
        }),
        name: 'All'
      };
      var countOfOutlet = 6;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: this.props.show, onHide: this._onHideOutletModal, id: 'outletModal', bsClass: outlets.length >= countOfOutlet ? _style2.default['setAutoHeight'] + ' outlet-modal modal' : _style2.default['unSetHeight'] + ' outlet-modal modal', backdrop: true },
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'li',
            { className: 'list-group-item all-item ' + _style2.default['outlet-hover'] },
            React.createElement(
              'span',
              { className: 'select-outlet' },
              React.createElement('img', { alt: 'Outlet icon', className: _style2.default['outlet-icon'], src: _outletIcon2.default }),
              React.createElement(
                'span',
                null,
                'Select Outlet'
              )
            )
          ),
          React.createElement(
            'ul',
            { className: 'list-group text-center' },
            allOutletOption && outlets.length > 1 && React.createElement(
              'li',
              { key: 0, className: 'list-group-item ' + _style2.default['outlet-hover'], role: 'presentation' },
              React.createElement(
                _reactRouter.Link,
                { className: value.length > 1 ? _style2.default['outlet-link-selected'] : _style2.default['outlet-link'], onClick: function onClick() {
                    _this2._onChangeOutlet(allOutlet.id);_this2._onChangeOutletIds(allOutlet.id);_this2._onHideOutletModal();
                  }, 'data-dismiss': 'modal' },
                'All Outlet'
              )
            ),
            outlets.map(function (outlet) {
              return React.createElement(
                'li',
                { key: outlet.id, className: 'list-group-item ' + _style2.default['outlet-hover'], role: 'presentation' },
                React.createElement(
                  _reactRouter.Link,
                  { className: value[0] === outlet.id && value.length < 2 ? _style2.default['outlet-link-selected'] : _style2.default['outlet-link'], onClick: function onClick() {
                      _this2._onChangeOutlet([outlet.id]);_this2._onChangeOutletIds([outlet.id]);_this2._onHideOutletModal();
                    }, 'data-dismiss': 'modal' },
                  outlet.name
                )
              );
            })
          )
        )
      );
    }
  }]);
  return OutletModal;
}(React.Component);

OutletModal.propTypes = {
  outlets: React.PropTypes.array
};

exports.default = OutletModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _PhoneNumberField = __webpack_require__(1961);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhoneNumberField = function (_React$Component) {
  (0, _inherits3.default)(PhoneNumberField, _React$Component);

  function PhoneNumberField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PhoneNumberField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PhoneNumberField.__proto__ || (0, _getPrototypeOf2.default)(PhoneNumberField)).call.apply(_ref, [this].concat(args))), _this), _this._onChange = function (e) {
      var nextVal = e.target.value;
      var onChange = _this.props.input.onChange;

      if (!isNaN(nextVal) && nextVal[0] !== '0' && nextVal[0] !== '6' && nextVal[0] !== '+' && nextVal[0] !== '-' && !/\s/g.test(nextVal) && !/\./g.test(nextVal)) {
        onChange(e, nextVal);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PhoneNumberField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          showTextError = _props.showTextError;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        { className: _PhoneNumberField2.default['field-wrapper'], id: 'phone-number-field' },
        React.createElement(
          'div',
          { className: _PhoneNumberField2.default['input-icon'] },
          React.createElement('img', { src: __webpack_require__(2873), className: _PhoneNumberField2.default.flag }),
          '+62'
        ),
        React.createElement('input', (0, _extends3.default)({}, input, {
          type: type,
          placeholder: placeholder,
          className: !touched ? 'form-control ' + _PhoneNumberField2.default['input-field'] : error ? 'form-control ' + _PhoneNumberField2.default['input-field'] + ' ' + (!showTextError && '' + _PhoneNumberField2.default['has-error']) : 'form-control ' + _PhoneNumberField2.default['input-field'] + ' ' + (!showTextError && '' + _PhoneNumberField2.default['has-success']),
          maxLength: '12',
          onChange: this._onChange })),
        showTextError && React.createElement(
          'small',
          { className: 'error' },
          touched ? error : ''
        ),
        !showTextError && touched && error && React.createElement(
          _reactBootstrap.OverlayTrigger,
          { placement: 'top', overlay: React.createElement(
              _reactBootstrap.Tooltip,
              { id: 'tooltip' },
              error
            ) },
          React.createElement('span', {
            className: 'form-control-feedback glyphicon glyphicon-remove',
            style: { 'pointer-events': 'auto', 'cursor': 'pointer' }
          })
        ),
        !showTextError && touched && !error && React.createElement('span', { className: 'form-control-feedback glyphicon glyphicon-ok' })
      );
    }
  }]);
  return PhoneNumberField;
}(React.Component);

exports.default = PhoneNumberField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compare = function compare(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

var orderingGratuities = function orderingGratuities(gratuities) {
  return gratuities.sort(compare);
};

var Gratuity = function (_React$Component) {
  (0, _inherits3.default)(Gratuity, _React$Component);

  function Gratuity() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Gratuity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Gratuity.__proto__ || (0, _getPrototypeOf2.default)(Gratuity)).call.apply(_ref, [this].concat(args))), _this), _this._format = function (price) {
      if (price > 0) {
        return (0, _formatter.rupiah)(price);
      } else {
        return '(' + (0, _formatter.rupiah)(-1 * price) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Gratuity, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          gratuities = _props.gratuities,
          includeGratuityTax = _props.includeGratuityTax;

      return React.createElement(
        'div',
        null,
        orderingGratuities(gratuities).map(function (gratuity, key) {
          return React.createElement(
            'div',
            { key: key },
            React.createElement(
              'div',
              { className: 'pull-left' },
              (0, _formatter.limitTo)(gratuity.name, 25),
              ' ',
              gratuity.name.length > 25 ? '...' : '',
              includeGratuityTax && React.createElement(
                'span',
                null,
                '(Included)'
              ),
              !includeGratuityTax && React.createElement(
                'span',
                null,
                '(',
                gratuity.amount,
                ' %)'
              )
            ),
            React.createElement(
              'div',
              { className: 'pull-right text-pre-wrap' },
              includeGratuityTax ? '' : _this2._format(gratuity.total)
            ),
            React.createElement('div', { className: 'clearfix' })
          );
        })
      );
    }
  }]);
  return Gratuity;
}(React.Component);

Gratuity.propTypes = {
  gratuities: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool
};

exports.default = Gratuity;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compare = function compare(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

var orderingTaxes = function orderingTaxes(taxes) {
  return taxes.sort(compare);
};

var ReceiptTax = function (_React$Component) {
  (0, _inherits3.default)(ReceiptTax, _React$Component);

  function ReceiptTax() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptTax);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptTax.__proto__ || (0, _getPrototypeOf2.default)(ReceiptTax)).call.apply(_ref, [this].concat(args))), _this), _this._format = function (price) {
      if (price > 0) {
        return (0, _formatter.rupiah)(price);
      } else {
        return '(' + (0, _formatter.rupiah)(-1 * price) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptTax, [{
    key: 'render',
    // Aaron - here is where we display (used in both normal & refund receipts)
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          taxes = _props.taxes,
          includeGratuityTax = _props.includeGratuityTax;

      return React.createElement(
        'div',
        null,
        orderingTaxes(taxes).map(function (tax, i) {
          return React.createElement(
            'div',
            { key: i },
            React.createElement(
              'div',
              { className: 'pull-left' },
              (0, _formatter.limitTo)(tax.name, 25),
              ' ',
              tax.name.length > 25 ? '...' : '',
              includeGratuityTax && React.createElement(
                'span',
                null,
                '(Included)'
              ),
              !includeGratuityTax && React.createElement(
                'span',
                null,
                '(',
                tax.amount,
                ' %)'
              )
            ),
            React.createElement(
              'div',
              { className: 'pull-right text-pre-wrap' },
              includeGratuityTax ? '' : _this2._format(tax.total)
            ),
            React.createElement('div', { className: 'clearfix' })
          );
        })
      );
    }
  }]);
  return ReceiptTax;
}(React.Component);

ReceiptTax.propTypes = {
  taxes: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool
};

exports.default = ReceiptTax;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _DiscountTable = __webpack_require__(1997);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountTable = function (_React$Component) {
  (0, _inherits3.default)(DiscountTable, _React$Component);

  function DiscountTable() {
    (0, _classCallCheck3.default)(this, DiscountTable);
    return (0, _possibleConstructorReturn3.default)(this, (DiscountTable.__proto__ || (0, _getPrototypeOf2.default)(DiscountTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(DiscountTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          discounts = _props.discounts,
          isRefunded = _props.isRefunded;

      return React.createElement(
        'div',
        null,
        discounts ? discounts.length > 0 && React.createElement(
          'table',
          { className: 'table table-responsive ' + _DiscountTable2.default['discount-table'] },
          React.createElement(
            'tbody',
            null,
            discounts.map(function (paymentDiscount, i) {
              return React.createElement(
                'tr',
                { key: i },
                React.createElement(
                  'td',
                  { className: _DiscountTable2.default['discount-cell'] },
                  React.createElement(
                    'div',
                    { className: _DiscountTable2.default['discount'] },
                    React.createElement(
                      'div',
                      { className: _DiscountTable2.default['text-left'] },
                      (0, _formatter.limitTo)(paymentDiscount.discount_name, 25),
                      ' ',
                      paymentDiscount.discount_name.length > 25 ? '...' : '',
                      '(Rp)'
                    ),
                    React.createElement(
                      'div',
                      { className: _DiscountTable2.default['text-center'] },
                      '\xA0'
                    ),
                    React.createElement(
                      'div',
                      { className: _DiscountTable2.default['text-right'] },
                      isRefunded ? (0, _formatter.rupiah)(Math.abs(paymentDiscount.discount_amount)) : '(' + (0, _formatter.rupiah)(Math.abs(paymentDiscount.discount_amount)) + ')'
                    )
                  )
                )
              );
            })
          )
        ) : ''
      );
    }
  }]);
  return DiscountTable;
}(React.Component);

DiscountTable.propTypes = {
  discounts: React.PropTypes.array,
  isRefunded: React.PropTypes.bool
};

exports.default = DiscountTable;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateInventoryCode = translateInventoryCode;
exports.libraryItemStart = libraryItemStart;
exports.libraryItemChangeFilter = libraryItemChangeFilter;
exports.libraryItemCreate = libraryItemCreate;
exports.libraryItemUpdate = libraryItemUpdate;
exports.libraryItemImport = libraryItemImport;
exports.libraryItemDelete = libraryItemDelete;
exports.libraryItemExport = libraryItemExport;
exports.cogsTrackingItem = cogsTrackingItem;

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function translateInventoryCode(inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert';
    case 2:
    case '2':
      return 'Out of Stock Alert';
    default:
      return 'All';
  }
} /* global mixpanel */
function libraryItemStart(_ref) {
  var outletIds = _ref.outletIds,
      category = _ref.category,
      inventory = _ref.inventory;

  mixpanel.track('Library Item Start', {
    'Current Selected Outlet': outletIds,
    'Current Category Filter': category || 'All',
    'Current Inventory Filter': translateInventoryCode(inventory)
  });
}

function libraryItemChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      category = _ref2.category,
      inventory = _ref2.inventory;

  var mixpanelData = {
    'Current Selected Outlet': outletIds,
    'Current Category Filter': category || 'All',
    'Current Inventory Filter': translateInventoryCode(inventory)
  };
  mixpanel.track('Library Item Change Filter', mixpanelData);
}

function libraryItemCreate(_ref3) {
  var item = _ref3.item,
      allOutlet = _ref3.allOutlet;

  var eventName = allOutlet ? 'Library Item Create All Outlet' : 'Library Item Create One Outlet';
  mixpanel.track(eventName, {
    'Name': item.name,
    'Category': item.category_id,
    'Variants': _lodash2.default.map(item.item_variants, 'id'),
    'Trackings': _lodash2.default.map(item.item_variants, 'track_stock'),
    'Modifiers': item.modifier_ids,
    'Taxes': _lodash2.default.map(item.taxes, 'id')
  });
}

function libraryItemUpdate(_ref4) {
  var item = _ref4.item;

  mixpanel.track('Library Item Update One Outlet', {
    'New Name': item.name,
    'New Category': item.category_id,
    'New Variants': _lodash2.default.map(item.item_variants, 'id'),
    'New Trackings': _lodash2.default.map(item.item_variants, 'track_stock'),
    'New Modifiers': item.modifier_ids,
    'New Taxes': _lodash2.default.map(item.taxes, 'id')
  });
}

/**
 * @param eventName 'modify' or 'replace'
 */
function libraryItemImport(_ref5) {
  var eventName = _ref5.eventName;

  mixpanel.track('Library Item Import ' + eventName);
}

function libraryItemDelete(_ref6) {
  var item = _ref6.item;

  mixpanel.track('Library Item Delete', {
    'Name': item.name,
    'Category': item.category_id,
    'Variants': _lodash2.default.map(item.item_variants, 'id'),
    'Trackings': _lodash2.default.map(item.item_variants, 'track_stock'),
    'Modifiers': _lodash2.default.map(item.active_modifiers, 'id')
  });
}

function libraryItemExport() {
  mixpanel.track('Library Item Export');
}

function cogsTrackingItem(_ref7) {
  var itemVariant = _ref7.itemVariant,
      cogsTrack = _ref7.cogsTrack;

  var eventName = !cogsTrack ? 'COGS Tracking Start Item' : 'COGS Tracking Manage Item';
  mixpanel.track(eventName, {
    'Item Variant [List]': itemVariant,
    'Name': _lodash2.default.map(itemVariant, 'name'),
    'Average Cost': _lodash2.default.map(itemVariant, 'cogs')
  });
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryTaxStart = libraryTaxStart;
exports.libraryChangeOutlet = libraryChangeOutlet;
exports.libraryCreateTax = libraryCreateTax;
exports.libraryUpdateOneOutlet = libraryUpdateOneOutlet;
exports.libraryDeleteTax = libraryDeleteTax;
exports.libraryTaxCreateAssignItemCancel = libraryTaxCreateAssignItemCancel;
exports.libraryTaxEditAssignItemCancel = libraryTaxEditAssignItemCancel;
exports.libraryTaxCreateAssignItemStart = libraryTaxCreateAssignItemStart;
exports.libraryTaxEditAssignItemStart = libraryTaxEditAssignItemStart;
exports.libraryTaxCreateAssignItemApply = libraryTaxCreateAssignItemApply;
exports.libraryTaxEditAssignItemApply = libraryTaxEditAssignItemApply;
exports.libraryTaxCreateAssignItemAssignAll = libraryTaxCreateAssignItemAssignAll;
exports.libraryTaxEditAssignItemAssignAll = libraryTaxEditAssignItemAssignAll;

var _groupBy2 = __webpack_require__(821);

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _values2 = __webpack_require__(828);

var _values3 = _interopRequireDefault(_values2);

var _keyBy2 = __webpack_require__(827);

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

var _without2 = __webpack_require__(269);

var _without3 = _interopRequireDefault(_without2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeCategoryCount(items, categories) {
  // helper function to create categories count summary
  var result = {};
  var groupedObj = (0, _groupBy3.default)(items, 'category_id');
  var groupedArr = (0, _values3.default)(groupedObj);
  var categoriesMap = (0, _keyBy3.default)(categories, 'id');
  groupedArr.map(function (item) {
    var categoryId = item[0].category_id;
    var categoryName = !categoriesMap[categoryId] ? categoryId : categoriesMap[categoryId].name;
    result[categoryName] = item.length;
  });
  return result;
} /* global mixpanel */
function libraryTaxStart(_ref) {
  var currOutlet = _ref.currOutlet;

  mixpanel.track('Library Tax Start', {
    'Current Selected Outlet': currOutlet
  });
}

function libraryChangeOutlet(_ref2) {
  var currOutlet = _ref2.currOutlet;

  mixpanel.track('Library Tax Change Outlet', {
    'Current Selected Outlet': currOutlet
  });
}

function libraryCreateTax(_ref3) {
  var tax = _ref3.tax,
      isAllOutlet = _ref3.isAllOutlet,
      taxDetail = _ref3.taxDetail,
      categories = _ref3.categories;
  // to modify for item tax
  var eventName = isAllOutlet ? 'Library Tax Create All Outlet' : 'Library Tax Create One Outlet';
  var countAssigned = makeCategoryCount(taxDetail.items, categories);
  mixpanel.track(eventName, {
    'Name': tax.name,
    'Value': tax.amount,
    'Summary Assigned Items': countAssigned
  });
}

function libraryUpdateOneOutlet(_ref4, taxDetail, categories) {
  var newName = _ref4.newName;

  var newCountAssigned = makeCategoryCount(taxDetail.items, categories);
  var oldCountAssigned = makeCategoryCount(taxDetail.org_items, categories);
  mixpanel.track('Library Tax Update One Outlet', {
    'Old Name': taxDetail.name,
    'Old Value': taxDetail.amount,
    'New Name': newName.name,
    'New Value': newName.amount,
    'Old Summary Assigned Items': oldCountAssigned,
    'New Summary Assigned Items': newCountAssigned
  });
}

function libraryDeleteTax(_ref5) {
  var tax = _ref5.tax,
      taxDetail = _ref5.taxDetail,
      categories = _ref5.categories;

  var countAssigned = makeCategoryCount(taxDetail.items, categories);
  mixpanel.track('Library Tax Delete', {
    'Name': tax.name,
    'Value': tax.amount,
    'Summary Assigned Items': countAssigned
  });
}

function libraryTaxCreateAssignItemCancel() {
  mixpanel.track('Library Tax Create Assign Item Cancel');
}

function libraryTaxEditAssignItemCancel() {
  mixpanel.track('Library Tax Edit Assign Item Cancel');
}

function libraryTaxCreateAssignItemStart(outletId) {
  mixpanel.track('Library Tax Create Assign Item Start', {
    'outlet_id': outletId
  });
}

function libraryTaxEditAssignItemStart(outletId) {
  mixpanel.track('Library Tax Edit Assign Item Start', {
    'outlet_id': outletId
  });
}

function libraryTaxCreateAssignItemApply(taxDetail) {
  var itemIds = (0, _without3.default)((0, _map3.default)(taxDetail.items, 'item_id'), undefined);
  mixpanel.track('Library Tax Create Assign Item Apply', {
    'Count': itemIds.length
  });
}

function libraryTaxEditAssignItemApply(taxDetail) {
  var itemIds = (0, _without3.default)((0, _map3.default)(taxDetail.items, 'item_id'), undefined);
  mixpanel.track('Library Tax Edit Assign Item Apply', {
    'Count': itemIds.length
  });
}

function libraryTaxCreateAssignItemAssignAll(taxDetail, categoryId, keyword) {
  var itemIds = (0, _without3.default)((0, _map3.default)(taxDetail.items, 'item_id'), undefined);
  mixpanel.track('Library Tax Create Assign Item Assign All', {
    'Category': categoryId,
    'Keyword': keyword,
    'Count': itemIds.length
  });
}

function libraryTaxEditAssignItemAssignAll(taxDetail, categoryId, keyword) {
  var itemIds = (0, _without3.default)((0, _map3.default)(taxDetail.items, 'item_id'), undefined);
  mixpanel.track('Library Tax Edit Assign Item Assign All', {
    'Category': categoryId,
    'Keyword': keyword,
    'Count': itemIds.length
  });
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Header = __webpack_require__(2044);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/9/17.
 */

var Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Header2.default['wrapper'] },
        this.props.title
      );
    }
  }]);
  return Header;
}(_react.Component);

Header.propTypes = {
  title: _react2.default.PropTypes.string
};

exports.default = Header;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getFilteredDate = getFilteredDate;
exports.getFilteredDateAsMoment = getFilteredDateAsMoment;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getFilteredDate = __webpack_require__(171);

var api = _interopRequireWildcard(_getFilteredDate);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getFilteredDate, getFilteredDateAsMoment].map(_regenerator2.default.mark);

function getFilteredDate(query) {
  var response;
  return _regenerator2.default.wrap(function getFilteredDate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getFilteredDate, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * @param query
 * @return {{startDate: (Moment), endDate: (Moment)} | boolean}
 */
function getFilteredDateAsMoment(query) {
  var data, startDate, endDate;
  return _regenerator2.default.wrap(function getFilteredDateAsMoment$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(getFilteredDate, query);

        case 2:
          data = _context2.sent;

          if (data) {
            _context2.next = 7;
            break;
          }

          return _context2.abrupt('return', false);

        case 7:
          startDate = (0, _moment2.default)(data.start_date, 'YYYY-MM-DD');
          endDate = (0, _moment2.default)(data.end_date, 'YYYY-MM-DD');
          return _context2.abrupt('return', { startDate: startDate, endDate: endDate });

        case 10:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.loginOutlet = loginOutlet;

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _login = __webpack_require__(630);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [loginOutlet].map(_regenerator2.default.mark);

function loginOutlet(payload) {
  return _regenerator2.default.wrap(function loginOutlet$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(_login.loginOutlet, payload);

        case 7:
          return _context.abrupt('return', true);

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](4);
          _context.next = 14;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 14:
          return _context.abrupt('return', false);

        case 15:
          _context.prev = 15;
          _context.next = 18;
          return (0, _effects.put)(action.sendingRequest(false));

        case 18:
          _context.next = 20;
          return (0, _effects.put)(action.hideProgressBar());

        case 20:
          return _context.finish(15);

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 10, 15, 21]]);
}

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(824),
    isLength = __webpack_require__(548);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(2398),
    baseRest = __webpack_require__(541),
    isArrayLikeObject = __webpack_require__(822);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(558);
var setInnerHTML = __webpack_require__(572);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(567);
var setTextContent = __webpack_require__(886);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  true ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  true ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (true) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (true) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  true ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var EventPluginRegistry = __webpack_require__(559);
var EventPluginUtils = __webpack_require__(560);
var ReactErrorUtils = __webpack_require__(565);

var accumulateInto = __webpack_require__(880);
var forEachAccumulated = __webpack_require__(881);
var invariant = __webpack_require__(35);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  true ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  true ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(274);
var EventPluginUtils = __webpack_require__(560);

var accumulateInto = __webpack_require__(880);
var forEachAccumulated = __webpack_require__(881);
var warning = __webpack_require__(52);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (true) {
     true ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(2636);
var ReactInstrumentation = __webpack_require__(111);

var warning = __webpack_require__(52);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       true ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (true) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

var getEventTarget = __webpack_require__(570);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var ReactBaseClasses = __webpack_require__(914);
var ReactChildren = __webpack_require__(2735);
var ReactDOMFactories = __webpack_require__(2736);
var ReactElement = __webpack_require__(194);
var ReactPropTypes = __webpack_require__(2738);
var ReactVersion = __webpack_require__(2740);

var createReactClass = __webpack_require__(2742);
var onlyChild = __webpack_require__(2744);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (true) {
  var lowPriorityWarning = __webpack_require__(583);
  var canDefineProperty = __webpack_require__(365);
  var ReactElementValidator = __webpack_require__(916);
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (true) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (true) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackPageRequest = feedbackPageRequest;
exports.listFeedbackRequest = listFeedbackRequest;
exports.setListFeedback = setListFeedback;
exports.changeDateFeedback = changeDateFeedback;
exports.feedbackMessagesRequest = feedbackMessagesRequest;
exports.setFeedbackMessages = setFeedbackMessages;
exports.changeFormReply = changeFormReply;
exports.submitReplyRequest = submitReplyRequest;
exports.feedbackReceiptRequest = feedbackReceiptRequest;
exports.onClickRow = onClickRow;
exports.setReceiptFeedback = setReceiptFeedback;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;

var _constants = __webpack_require__(386);

function feedbackPageRequest() {
  return { type: _constants.CUSTOMERS_FEEDBACK_PAGE_REQUEST, payload: {} };
}

function listFeedbackRequest(query, previousFeedback) {
  return { type: _constants.CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST, payload: { query: query, previousFeedback: previousFeedback } };
}

function setListFeedback(feedbacks) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK, payload: { feedbacks: feedbacks } };
}

function changeDateFeedback(startDate, endDate) {
  return { type: _constants.CUSTOMERS_FEEDBACK_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function feedbackMessagesRequest(id) {
  return { type: _constants.CUSTOMERS_FEEDBACK_MESSAGES_REQUEST, payload: { id: id } };
}

function setFeedbackMessages(feedbackMessages) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES, payload: { feedbackMessages: feedbackMessages } };
}

function changeFormReply(message) {
  return { type: _constants.CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY, payload: { message: message } };
}

function submitReplyRequest(data) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST, payload: { data: data } };
}

function feedbackReceiptRequest(id) {
  return { type: _constants.CUSTOMERS_FEEDBACK_RECEIPT_REQUEST, payload: { id: id } };
}

function onClickRow(feedback) {
  return { type: _constants.CUSTOMERS_FEEDBACK_ON_CLICK_ROW, payload: { feedback: feedback } };
}

function setReceiptFeedback(transactionDetail) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SET_RECEIPT, payload: { transactionDetail: transactionDetail } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Upload Image action constants
var GET_NEW_IMAGE_REQUEST = exports.GET_NEW_IMAGE_REQUEST = 'GET_NEW_IMAGE_REQUEST';
var SET_UPLOAD_IMAGE = exports.SET_UPLOAD_IMAGE = 'SET_UPLOAD_IMAGE';
var SAVE_UPLOAD_IMAGE = exports.SAVE_UPLOAD_IMAGE = 'SAVE_UPLOAD_IMAGE';
var GET_LOADING_IMAGE = exports.GET_LOADING_IMAGE = 'GET_LOADING_IMAGE';
var UPLOAD_IMAGE_REQUEST = exports.UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
var SET_TEMP_IMG = exports.SET_TEMP_IMG = 'SET_TEMP_IMG';
var DELETE_IMAGE = exports.DELETE_IMAGE = 'DELETE_IMAGE';

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCurrentInventoryDropdown = getCurrentInventoryDropdown;
exports.putCurrentInventoryDropdown = putCurrentInventoryDropdown;

var _constants = __webpack_require__(1068);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getCurrentInventoryDropdown(params) {
  return axios.get(_constants.CURRENT_INVENTORY_DROPDOWN, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function putCurrentInventoryDropdown(data, params) {
  return axios.put(_constants.CURRENT_INVENTORY_DROPDOWN, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSubscriptionStatus = getSubscriptionStatus;

var _constants = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSubscriptionStatus(data, params) {
  return axios.post(_constants.GET_SUBSCRIPTION_STATUS, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.putUpdateSetting = putUpdateSetting;
exports.getSettings = getSettings;

var _constants = __webpack_require__(1115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/settings_controller.rb#L13
 * @return {Axios.IPromise<U>}
 */
function putUpdateSetting(data) {
  return axios.put(_constants.UPDATE_SETTING, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var p = void 0;
    if (error.response) {
      // handle different json from api... wkwkwk
      if (error.response.data.error) {
        p = _promise2.default.reject(new Error(error.response.data.error));
      } else if (error.response.data.message) {
        p = _promise2.default.reject(new Error(error.response.data.message));
      } else {
        p = _promise2.default.reject(error);
      }
    } else {
      p = _promise2.default.reject(error);
    }
    return p;
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/settings_controller.rb#L8
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
function getSettings(params) {
  return axios.get(_constants.GET_SETTING, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (err) {
    var eobj = new Error(err.message);
    return _promise2.default.reject(eobj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _BillingReminder = __webpack_require__(1942);

var _BillingReminder2 = _interopRequireDefault(_BillingReminder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingReminder = function (_React$Component) {
  (0, _inherits3.default)(BillingReminder, _React$Component);

  function BillingReminder() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BillingReminder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BillingReminder.__proto__ || (0, _getPrototypeOf2.default)(BillingReminder)).call.apply(_ref, [this].concat(args))), _this), _this.isExpired = function (user) {
      var subscriptionExpired = _this.props.subscriptionExpired;

      var expired = _this.calculateDaysLeft(user) <= 0;
      if (expired) {
        subscriptionExpired.expired = true;
      }
      return expired;
    }, _this.isTrial = function (user) {
      return user.business.is_trial;
    }, _this.isAlreadySubscribed = function (user) {
      return user.already_subscribed;
    }, _this.calculateDaysLeft = function (user) {
      var calculatedDaysLeft = Math.ceil((0, _moment2.default)(user.business.expired_at).diff((0, _moment2.default)(), 'hours') / 24);
      var currentDaysInMonth = (0, _moment2.default)().daysInMonth();
      var daysLeft = 0;
      if (calculatedDaysLeft > currentDaysInMonth) {
        daysLeft = currentDaysInMonth;
      } else {
        daysLeft = calculatedDaysLeft;
      }
      return daysLeft;
    }, _this.billingReminder = function (user) {
      var daysLeft = _this.calculateDaysLeft(user);
      var reminder = null;
      if (_this.isExpired(user)) {
        reminder = 'Your subscription has expired';
      } else {
        if (_this.isTrial(user) && !_this.isAlreadySubscribed(user)) {
          reminder = daysLeft + ' day(s) left in trial';
        } else if (!_this.isTrial(user) && daysLeft <= 14) {
          reminder = 'Your subscription will expire in ' + daysLeft + ' day(s)';
        }
      }
      return reminder;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BillingReminder, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;


      return user && React.createElement(
        'div',
        { className: _BillingReminder2.default['billing-reminder'] },
        React.createElement(
          'div',
          { className: _BillingReminder2.default['notification-expire'] },
          React.createElement(
            'em',
            null,
            React.createElement(
              _reactRouter.Link,
              { to: user.is_owner && '/settings/billing', className: user.is_owner ? _BillingReminder2.default['text-notif'] : _BillingReminder2.default['disable-link'] },
              React.createElement(
                'span',
                null,
                this.billingReminder(user)
              )
            )
          )
        )
      );
    }
  }]);
  return BillingReminder;
}(React.Component);

BillingReminder.propTypes = {
  user: React.PropTypes.object,
  subscriptionExpired: React.PropTypes.object
};

exports.default = BillingReminder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _DropdownButtonSelectIcon = __webpack_require__(1951);

var _DropdownButtonSelectIcon2 = _interopRequireDefault(_DropdownButtonSelectIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownButtonSelectIcon = function (_React$Component) {
  (0, _inherits3.default)(DropdownButtonSelectIcon, _React$Component);

  function DropdownButtonSelectIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropdownButtonSelectIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownButtonSelectIcon.__proto__ || (0, _getPrototypeOf2.default)(DropdownButtonSelectIcon)).call.apply(_ref, [this].concat(args))), _this), _this._onSelect = function (eventKey, event) {
      var _this$props = _this.props,
          _this$props$input = _this$props.input,
          onChange = _this$props$input.onChange,
          value = _this$props$input.value,
          isDirtyForm = _this$props.isDirtyForm,
          onDirtyFormCallback = _this$props.onDirtyFormCallback;

      if (isDirtyForm) {
        onDirtyFormCallback(event, eventKey, value);
      } else {
        onChange(eventKey);
      }
    }, _this._label = function () {
      var _this$props2 = _this.props,
          value = _this$props2.input.value,
          options = _this$props2.options;

      var res = 'Loading...';
      options.forEach(function (o) {
        if (o.id === value) {
          res = o.name;
        }
      });
      return res;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DropdownButtonSelectIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          disabled = _props.disabled;

      return React.createElement(
        _reactBootstrap.DropdownButton,
        { title: this._label(), onSelect: this._onSelect, disabled: disabled },
        options.map(function (o) {
          return React.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: o.id },
            React.createElement('i', { className: o.icon + ' ' + _DropdownButtonSelectIcon2.default.icon }),
            React.createElement(
              'span',
              { className: _DropdownButtonSelectIcon2.default.status },
              ' ',
              o.name
            )
          );
        })
      );
    }
  }]);
  return DropdownButtonSelectIcon;
}(React.Component);

exports.default = DropdownButtonSelectIcon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SearchModal = __webpack_require__(1963);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_UP = 38;
var ARROW_DOWN = 40;
var ENTER_KEY = 13;
var ESC_KEY = 27;

var SearchModal = function (_React$Component) {
  (0, _inherits3.default)(SearchModal, _React$Component);

  function SearchModal(props) {
    (0, _classCallCheck3.default)(this, SearchModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchModal.__proto__ || (0, _getPrototypeOf2.default)(SearchModal)).call(this, props));

    _this._onBlur = function (e) {
      if (_this.state.mouseLeave) {
        _this.setState({ isShow: false, optionId: 0 });
      }
    };

    _this._onChange = function (e) {
      var nextVal = e.target.value;
      _this.pagination = false;
      _this.setState({ isShow: true, value: nextVal, optionId: 0 });
      if (_this.scrollDOM) {
        _this.scrollDOM.scrollTop = 0;
      }
      var onInputChange = _this.props.onInputChange;

      onInputChange(nextVal);
      _this.inputValue = nextVal;
    };

    _this._onKeyDown = function (e) {
      var optionId = _this.state.optionId;
      var _this$props = _this.props,
          onClickItem = _this$props.onClickItem,
          onChange = _this$props.input.onChange;

      if (e.keyCode === ARROW_DOWN && _this.optionsDOM.length > 0 && optionId === 0) {
        _this.setState({ isShow: true, optionId: _this.optionsDOM[0].value, value: _this.optionsDOM[0].value });
        _this.optionDOM = _this.optionsDOM[0];
      } else {
        _this.optionsDOM.forEach(function (opt, idx) {
          if (opt.value === optionId) {
            if (idx + 1 < _this.optionsDOM.length && e.keyCode === ARROW_DOWN) {
              _this.setState({ isShow: true, optionId: _this.optionsDOM[idx + 1].value, value: _this.optionsDOM[idx + 1].value });
              _this.optionDOM = _this.optionsDOM[idx + 1];
            } else if (idx - 1 >= 0 && e.keyCode === ARROW_UP) {
              _this.setState({ isShow: true, optionId: _this.optionsDOM[idx - 1].value, value: _this.optionsDOM[idx - 1].value });
              _this.optionDOM = _this.optionsDOM[idx - 1];
            }
          }
        });
      }
      if (_this.optionDOM && _this.optionDOM.dom && _this.scrollDOM) {
        var optionDOM = _this.optionDOM;
        var optionRect = optionDOM.dom.getBoundingClientRect();
        var scrollRect = _this.scrollDOM.getBoundingClientRect();
        if (e.keyCode === ARROW_DOWN) {
          if (optionRect.bottom + 31 >= scrollRect.bottom) {
            _this.scrollDOM.scrollTop = _this.scrollDOM.scrollTop + 31;
          }
        } else if (e.keyCode === ARROW_UP) {
          if (optionRect.bottom - 62 <= scrollRect.top) {
            _this.scrollDOM.scrollTop = _this.scrollDOM.scrollTop === 0 ? 0 : _this.scrollDOM.scrollTop - 31;
          }
        } else if (e.keyCode === ENTER_KEY) {
          onClickItem(optionDOM);
          e.preventDefault();
          onChange(optionDOM.value);
          _this.setState({ isShow: false, value: optionDOM.value, optionId: optionDOM.value });
        } else if (e.keyCode === ESC_KEY) {
          _this.setState({ value: _this.inputValue, isShow: false, optionId: 0 });
        }
      }
    };

    _this.pagination = false;
    _this.inputValue = '';
    _this.state = {
      isShow: false,
      value: '',
      optionId: 0,
      mouseLeave: true
    };
    return _this;
  }

  (0, _createClass3.default)(SearchModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          input = _props.input,
          options = _props.options,
          type = _props.type,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          _props$dis = _props.dis,
          dis = _props$dis === undefined ? false : _props$dis,
          inputClassName = _props.inputClassName,
          onClickItem = _props.onClickItem,
          onMenuScrollToBottom = _props.onMenuScrollToBottom,
          isHasMore = _props.isHasMore,
          isLoading = _props.isLoading;
      var _state = this.state,
          value = _state.value,
          optionId = _state.optionId;
      var onChange = input.onChange;

      var keyOpt = _lodash2.default.mapKeys(options, 'value');
      this.optionsDOM = [];
      if (options.length !== 0) {
        this.options = options;
      }
      if (this.pagination) {
        isLoading = false;
        if (options.length === 0) {
          options = this.options;
        }
      }
      return React.createElement(
        'div',
        { className: _SearchModal2.default['search-wrapper'] },
        React.createElement('input', (0, _extends3.default)({}, input, {
          type: type,
          readOnly: readOnly,
          className: 'form-control ' + inputClassName,
          placeholder: placeholder,
          onChange: this._onChange,
          disabled: dis,
          onBlur: this._onBlur,
          value: keyOpt[value] ? keyOpt[value].label : value,
          onKeyDown: this._onKeyDown,
          ref: function ref(a) {
            _this2.inputDOM = a;
          },
          autoComplete: 'off'
        })),
        this.state.isShow && React.createElement(
          'div',
          {
            className: _SearchModal2.default['option-list'],
            ref: function ref(a) {
              _this2.scrollDOM = a;
            },
            onMouseLeave: function onMouseLeave() {
              _this2.setState({ mouseLeave: true });
            },
            onMouseOver: function onMouseOver() {
              _this2.setState({ mouseLeave: false });
            },
            onScroll: function onScroll() {
              _this2.inputDOM.focus();
              _this2.setState({ isShow: true });
            },
            onMouseDown: function onMouseDown() {
              _this2.inputDOM.focus();
            },
            onMouseUp: function onMouseUp() {
              _this2.inputDOM.focus();
            }
          },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: function loadMore() {
                _this2.pagination = true;
                onMenuScrollToBottom();
              },
              useWindow: false,
              hasMore: isHasMore,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'ul',
              { className: _SearchModal2.default['list-item'] },
              options.length === 0 && !isLoading && React.createElement(
                'li',
                {
                  ref: function ref(a) {
                    var item = { value: 0, dom: a };_this2.optionDOM = item;
                  },
                  className: _SearchModal2.default['item-label'] + ' ' + _SearchModal2.default['grey-text'], value: null },
                'No results found'
              ),
              isLoading && React.createElement(
                'li',
                {
                  ref: function ref(a) {
                    var item = { value: 0, dom: a };_this2.optionDOM = item;
                  },
                  className: _SearchModal2.default['item-label'] + ' ' + _SearchModal2.default['grey-text'], value: null
                },
                'Searching...'
              ),
              !isLoading && options.map(function (option, idx) {
                return React.createElement(
                  'a',
                  {
                    className: _SearchModal2.default['item-label'] + ' ' + (optionId === option.value ? _SearchModal2.default['selected'] : ''),
                    onClick: function onClick(e) {
                      onClickItem(option);
                      _this2.setState({ isShow: false, value: option.value, optionId: option.value });
                      onChange(option.value);
                    },
                    onMouseOver: function onMouseOver() {
                      _this2.setState({ optionId: option.value });
                    },
                    ref: function ref(a) {
                      var item = { value: option.value, dom: a };
                      if (_this2.optionsDOM.length < options.length) {
                        if (a) {
                          _this2.optionsDOM.push(item);
                        }
                      }
                      if (optionId === option.value) {
                        _this2.optionDOM = item;
                      }
                    } },
                  React.createElement(
                    'li',
                    { value: option.value },
                    option.label
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return SearchModal;
}(React.Component);

exports.default = SearchModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subtotal = function (_React$Component) {
  (0, _inherits3.default)(Subtotal, _React$Component);

  function Subtotal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Subtotal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Subtotal.__proto__ || (0, _getPrototypeOf2.default)(Subtotal)).call.apply(_ref, [this].concat(args))), _this), _this._formatSubtotal = function (subtotal) {
      if (subtotal > 0) {
        return (0, _formatter.rupiah)(subtotal);
      } else {
        return '(' + (0, _formatter.rupiah)(-1 * subtotal) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Subtotal, [{
    key: 'render',
    value: function render() {
      var subtotal = this.props.subtotal;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'pull-left' },
          'Subtotal'
        ),
        React.createElement(
          'div',
          { className: 'pull-right' },
          this._formatSubtotal(subtotal)
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);
  return Subtotal;
}(React.Component);

Subtotal.propTypes = {
  subtotal: React.PropTypes.number
};

exports.default = Subtotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardRedemptionInfo = function (_Component) {
  (0, _inherits3.default)(RewardRedemptionInfo, _Component);

  function RewardRedemptionInfo() {
    (0, _classCallCheck3.default)(this, RewardRedemptionInfo);
    return (0, _possibleConstructorReturn3.default)(this, (RewardRedemptionInfo.__proto__ || (0, _getPrototypeOf2.default)(RewardRedemptionInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(RewardRedemptionInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          redeemReward = _props.redeemReward,
          totalRedeemAmount = _props.totalRedeemAmount,
          isRefunded = _props.isRefunded;

      return _react2.default.createElement(
        'div',
        { style: { color: '#444' }, className: 'top10 row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-6' },
          _react2.default.createElement(
            'div',
            { className: 'pull-left' },
            'Redeemed Reward'
          ),
          _react2.default.createElement(
            'div',
            { className: 'pull-left' },
            redeemReward
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-6 pull-right' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            isRefunded ? (0, _formatter.rupiah)(Math.abs(totalRedeemAmount)) : '(' + (0, _formatter.rupiah)(Math.abs(totalRedeemAmount)) + ')'
          )
        )
      );
    }
  }]);
  return RewardRedemptionInfo;
}(_react.Component);

RewardRedemptionInfo.propTypes = {
  isRefunded: _react.PropTypes.bool,
  totalRedeemAmount: _react.PropTypes.number,
  redeemReward: _react.PropTypes.string
};

exports.default = RewardRedemptionInfo;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _PageWrapper = __webpack_require__(2035);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageWrapper = function (_React$Component) {
  (0, _inherits3.default)(PageWrapper, _React$Component);

  function PageWrapper() {
    (0, _classCallCheck3.default)(this, PageWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (PageWrapper.__proto__ || (0, _getPrototypeOf2.default)(PageWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageWrapper, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: '' + _PageWrapper2.default.wrapper },
        this.props.children
      );
    }
  }]);
  return PageWrapper;
}(React.Component);

exports.default = PageWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryModifierStart = libraryModifierStart;
exports.libraryModifierChangeOutlet = libraryModifierChangeOutlet;
exports.libraryModifierCreate = libraryModifierCreate;
exports.libraryModifierUpdateOneOutlet = libraryModifierUpdateOneOutlet;
exports.libraryModifierApplyToItems = libraryModifierApplyToItems;
exports.libraryModifierDelete = libraryModifierDelete;

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function libraryModifierStart(_ref) {
  var current_outlet = _ref.current_outlet;

  mixpanel.track('Library Modifier Start', {
    'Current Selected Outlet': current_outlet
  });
} /* global mixpanel */
function libraryModifierChangeOutlet(_ref2) {
  var prevOutlet = _ref2.prevOutlet,
      currOutlet = _ref2.currOutlet;

  mixpanel.track('Library Modifier Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet
  });
}

function libraryModifierCreate(_ref3) {
  var modifier = _ref3.modifier,
      allOutlet = _ref3.allOutlet;

  var eventName = allOutlet ? 'Library Modifier Create All Outlet' : 'Library Modifier Create One Outlet';
  mixpanel.track(eventName, {
    'Name': modifier.name,
    'Options': modifier.options
  });
}

function libraryModifierUpdateOneOutlet(_ref4) {
  var prevName = _ref4.prevName,
      prevOptions = _ref4.prevOptions,
      newName = _ref4.newName,
      newOptions = _ref4.newOptions;

  mixpanel.track('Library Modifier Update One Outlet', {
    'Old Name': prevName,
    'Old Options': prevOptions,
    'New Name': newName,
    'New Options': newOptions
  });
}

function libraryModifierApplyToItems(_ref5) {
  var name = _ref5.name,
      options = _ref5.options,
      itemNames = _ref5.itemNames;

  mixpanel.track('Library Modifier Apply To Items', {
    'Name': name,
    'Options': options,
    'Item Names': itemNames
  });
}

function libraryModifierDelete(_ref6) {
  var name = _ref6.name,
      options = _ref6.options;

  mixpanel.track('Library Modifier Delete', {
    'Name': name,
    'Options': _lodash2.default.map(options, 'id')
  });
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsTransactionsStart = reportsTransactionsStart;
exports.reportsTransactionsChangeFilter = reportsTransactionsChangeFilter;
exports.reportsTransactionsExport = reportsTransactionsExport;
exports.reportsTransactionsSearchBarInit = reportsTransactionsSearchBarInit;
exports.reportsTransactionsSelect = reportsTransactionsSelect;
exports.reportsTransactionsResendReceipt = reportsTransactionsResendReceipt;
exports.reportsTransactionRefund = reportsTransactionRefund;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global mixpanel */
function reportsTransactionsStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Transactions Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsTransactionsChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Transactions Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsTransactionsExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Transactions Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsTransactionsSearchBarInit() {
  mixpanel.track('Report Transactions Search Bar Init');
}

function reportsTransactionsSelect(_ref4) {
  var transactionDetail = _ref4.transactionDetail;

  mixpanel.track('Report Transactions Select', {
    'Transaction Date': (0, _moment2.default)(transactionDetail.created_at).format('YYYY-MM-DD'),
    'Transaction Time': (0, _moment2.default)(transactionDetail.created_at).format('hh:mm:ss'),
    'Receipt Number': transactionDetail.payment_no,
    'Served By': transactionDetail.served_by,
    'Collected By': transactionDetail.collected_by,
    'Total': transactionDetail.total_collected - transactionDetail.total_refund,
    'Payment Method': transactionDetail.payment_type,
    'Payment Amount': transactionDetail.payment_amount,
    'Payment Note': transactionDetail.payment_note
  });
}

function reportsTransactionsResendReceipt() {
  mixpanel.track('Report Transactions Resend Receipt');
}

function reportsTransactionRefund(_ref5) {
  var amount = _ref5.amount,
      isFullRefund = _ref5.isFullRefund,
      outletIds = _ref5.outletIds,
      startDate = _ref5.startDate,
      endDate = _ref5.endDate;

  mixpanel.track('Report Transactions Refund', {
    'Amount': amount,
    'Is Full Refund': isFullRefund,
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptRefundInfo = __webpack_require__(1167);

var _ReceiptRefundInfo2 = _interopRequireDefault(_ReceiptRefundInfo);

var _ReceiptRefundReason = __webpack_require__(1174);

var _ReceiptRefundReason2 = _interopRequireDefault(_ReceiptRefundReason);

var _ReceiptRefundTotal = __webpack_require__(1175);

var _ReceiptRefundTotal2 = _interopRequireDefault(_ReceiptRefundTotal);

var _ReceiptRefundListItem = __webpack_require__(1170);

var _ReceiptRefundListItem2 = _interopRequireDefault(_ReceiptRefundListItem);

var _ReceiptCountingBox = __webpack_require__(1164);

var _ReceiptCountingBox2 = _interopRequireDefault(_ReceiptCountingBox);

var _InvoiceActivity = __webpack_require__(1168);

var _InvoiceActivity2 = _interopRequireDefault(_InvoiceActivity);

var _reactRedux = __webpack_require__(6);

var _BrandImage = __webpack_require__(445);

var _BrandImage2 = _interopRequireDefault(_BrandImage);

var _ReceiptInfo = __webpack_require__(1166);

var _ReceiptInfo2 = _interopRequireDefault(_ReceiptInfo);

var _ReceiptListItem = __webpack_require__(1169);

var _ReceiptListItem2 = _interopRequireDefault(_ReceiptListItem);

var _ReceiptRefundCountingBox = __webpack_require__(1165);

var _ReceiptRefundCountingBox2 = _interopRequireDefault(_ReceiptRefundCountingBox);

var _ReceiptTotal = __webpack_require__(1176);

var _ReceiptTotal2 = _interopRequireDefault(_ReceiptTotal);

var _LoyaltyInfo = __webpack_require__(639);

var _LoyaltyInfo2 = _interopRequireDefault(_LoyaltyInfo);

var _RefundedLoyaltyInfo = __webpack_require__(640);

var _RefundedLoyaltyInfo2 = _interopRequireDefault(_RefundedLoyaltyInfo);

var _styleReceipt = __webpack_require__(772);

var _styleReceipt2 = _interopRequireDefault(_styleReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptInvoices = function (_React$Component) {
  (0, _inherits3.default)(ReceiptInvoices, _React$Component);

  function ReceiptInvoices() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptInvoices);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptInvoices.__proto__ || (0, _getPrototypeOf2.default)(ReceiptInvoices)).call.apply(_ref, [this].concat(args))), _this), _this._checkIsUnpaidInvoiceEarningPoints = function () {
      var invoiceDetail = _this.props.invoiceDetail;

      return invoiceDetail.total_amount_due > 0 && invoiceDetail.loyalty.type === 'EARNING';
    }, _this._setClassNameStatusInvoice = function (statusFormatter) {
      var string = statusFormatter;

      if (string.includes('invoice-status-red')) {
        return 'invoice-status-red';
      } else if (string.includes('invoice-status-green')) {
        return 'invoice-status-green';
      } else if (string.includes('invoice-status-orange')) {
        return 'invoice-status-orange';
      } else if (string.includes('invoice-status-grey')) {
        return 'invoice-status-grey';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptInvoices, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var invoiceDetail = this.props.invoiceDetail;

      return React.createElement(
        'div',
        { className: _styleReceipt2.default['scrolled-area'] + ' invoice' },
        React.createElement(
          'div',
          { className: 'scroll-content ' + _styleReceipt2.default['col-right-inner'] },
          React.createElement(
            'div',
            { className: _styleReceipt2.default['receipt-container'] },
            React.createElement(
              'div',
              { className: _styleReceipt2.default['receipt-scrolled-area'] + _styleReceipt2.default['serrated-border'], id: 'receipt' },
              invoiceDetail.payment_refunds.length > 0 && React.createElement(
                'div',
                { className: _styleReceipt2.default[this._setClassNameStatusInvoice(invoiceDetail.status_formatter)] },
                React.createElement('div', { dangerouslySetInnerHTML: { __html: invoiceDetail.status_formatter } })
              ),
              invoiceDetail.payment_refunds.map(function (invoiceRefund, idx) {
                return React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: _styleReceipt2.default['mk-receipt-inner-box'], key: idx },
                    React.createElement(_BrandImage2.default, {
                      businessLogo: invoiceDetail.business_logo_url,
                      businessName: invoiceDetail.business_name,
                      outletAddress: invoiceDetail.outlet_address,
                      outletPhone: invoiceDetail.outlet_phone
                    }),
                    React.createElement(_ReceiptRefundInfo2.default, { invoiceDetail: invoiceDetail, invoiceRefund: invoiceRefund }),
                    React.createElement(_ReceiptRefundReason2.default, { invoiceRefund: invoiceRefund }),
                    React.createElement(_ReceiptRefundListItem2.default, { invoiceRefund: invoiceRefund }),
                    React.createElement(_ReceiptRefundCountingBox2.default, { invoiceRefund: invoiceRefund, subtotal: invoiceDetail.subtotal }),
                    React.createElement(_ReceiptRefundTotal2.default, { invoiceRefund: invoiceRefund }),
                    invoiceRefund.loyalty && (0, _keys2.default)(invoiceRefund.loyalty).length > 0 && React.createElement(_RefundedLoyaltyInfo2.default, {
                      loyalty: invoiceRefund.loyalty,
                      memberPhone: invoiceRefund.customer_phone,
                      isUnpaidInvoiceEarningPoints: _this2._checkIsUnpaidInvoiceEarningPoints()
                    })
                  ),
                  React.createElement('div', { className: _styleReceipt2.default['separator-receipt'] }),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { className: _styleReceipt2.default['mk-receipt-inner-box'] },
                      React.createElement(_BrandImage2.default, {
                        businessLogo: invoiceDetail.business_logo_url,
                        businessName: invoiceDetail.business_name,
                        outletAddress: invoiceDetail.outlet_address,
                        outletPhone: invoiceDetail.outlet_phone
                      }),
                      React.createElement(_ReceiptInfo2.default, { invoiceDetail: invoiceDetail }),
                      React.createElement(_ReceiptListItem2.default, { invoiceDetail: invoiceDetail }),
                      React.createElement(_ReceiptCountingBox2.default, { invoiceDetail: invoiceDetail }),
                      React.createElement(_ReceiptTotal2.default, { invoiceDetail: invoiceDetail }),
                      invoiceDetail.loyalty && (0, _keys2.default)(invoiceDetail.loyalty).length > 0 && React.createElement(_LoyaltyInfo2.default, {
                        loyalty: invoiceDetail.loyalty,
                        memberPhone: invoiceDetail.customer_phone,
                        isUnpaidInvoiceEarningPoints: _this2._checkIsUnpaidInvoiceEarningPoints()
                      })
                    )
                  )
                );
              }),
              invoiceDetail.payment_refunds.length === 0 && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: _styleReceipt2.default[this._setClassNameStatusInvoice(invoiceDetail.status_formatter)] },
                  React.createElement('div', { dangerouslySetInnerHTML: { __html: invoiceDetail.status_formatter } })
                ),
                React.createElement(
                  'div',
                  { className: _styleReceipt2.default['mk-receipt-inner-box'] },
                  React.createElement(_BrandImage2.default, {
                    businessLogo: invoiceDetail.business_logo_url,
                    businessName: invoiceDetail.business_name,
                    outletAddress: invoiceDetail.outlet_address,
                    outletPhone: invoiceDetail.outlet_phone
                  }),
                  React.createElement(_ReceiptInfo2.default, { invoiceDetail: invoiceDetail }),
                  React.createElement(_ReceiptListItem2.default, { invoiceDetail: invoiceDetail }),
                  React.createElement(_ReceiptCountingBox2.default, { invoiceDetail: invoiceDetail }),
                  React.createElement(_ReceiptTotal2.default, { invoiceDetail: invoiceDetail }),
                  invoiceDetail.loyalty && (0, _keys2.default)(invoiceDetail.loyalty).length > 0 && React.createElement(_LoyaltyInfo2.default, {
                    loyalty: invoiceDetail.loyalty,
                    memberPhone: invoiceDetail.customer_phone,
                    isUnpaidInvoiceEarningPoints: this._checkIsUnpaidInvoiceEarningPoints()
                  })
                )
              )
            ),
            React.createElement(_InvoiceActivity2.default, { invoiceDetail: invoiceDetail })
          )
        )
      );
    }
  }]);
  return ReceiptInvoices;
}(React.Component);

ReceiptInvoices.propTypes = {
  invoiceDetail: React.PropTypes.object
};

function mapStateToProps(state) {
  return {
    data: {
      reports: state.reports
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReceiptInvoices);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashRow = function (_React$Component) {
  (0, _inherits3.default)(CashRow, _React$Component);

  function CashRow() {
    (0, _classCallCheck3.default)(this, CashRow);
    return (0, _possibleConstructorReturn3.default)(this, (CashRow.__proto__ || (0, _getPrototypeOf2.default)(CashRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(CashRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          value = _props.value;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12 box-divider' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              label
            ),
            React.createElement(
              'div',
              null,
              value
            )
          )
        )
      );
    }
  }]);
  return CashRow;
}(React.Component);

CashRow.propTypes = {
  label: React.PropTypes.string,
  value: React.PropTypes.string
};
exports.default = CashRow;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailRow = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailRow, _React$Component);

  function ShiftDetailRow() {
    (0, _classCallCheck3.default)(this, ShiftDetailRow);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailRow.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailRow, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              this.props.label
            ),
            React.createElement(
              'div',
              { className: 'pull-right' },
              this.props.value
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailRow;
}(React.Component);

ShiftDetailRow.propTypes = {
  label: React.PropTypes.string
};
exports.default = ShiftDetailRow;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___hs8Z0","scrolled-area":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___3J37r","mk-col-right-action-box-bottom":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___2mLue","no-hover":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___3FrVq","col-right-inner":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___1EQlB","col-outlet":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___YDlXj","col-sale":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___3pvNC","header-name":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___1Sm7K","address":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___2aGcE","email":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___3bxzi","receipt-trx-container":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___2Wvcf","label-transaction":"app-pages-Customers-CustomerList-ListNonLoyalty-CustomerDetail-__style___27AiX"};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapped-program":"app-pages-Customers-Loyalty-Components-Program-__Program___2p5bx","splash-page":"app-pages-Customers-Loyalty-Components-Program-__Program___1bdTl","gray-backgrond":"app-pages-Customers-Loyalty-Components-Program-__Program___14Wv4","panel-title":"app-pages-Customers-Loyalty-Components-Program-__Program___2V1v8","panel-title-disabled":"app-pages-Customers-Loyalty-Components-Program-__Program___3cNs5","option-title":"app-pages-Customers-Loyalty-Components-Program-__Program___2cCqb","option-title-disabled":"app-pages-Customers-Loyalty-Components-Program-__Program___2pcDL","option-body":"app-pages-Customers-Loyalty-Components-Program-__Program___1Hsfa","option-body-disabled":"app-pages-Customers-Loyalty-Components-Program-__Program___3APFq","disabled-review-button":"app-pages-Customers-Loyalty-Components-Program-__Program___1UB9u"};

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-Customers-Loyalty-Existing-__Existing___10r0y","section-label":"app-pages-Customers-Loyalty-Existing-__Existing___22sED","program-info":"app-pages-Customers-Loyalty-Existing-__Existing___1bK4Y","program-info-chosen":"app-pages-Customers-Loyalty-Existing-__Existing___3Ub_8","modal-title":"app-pages-Customers-Loyalty-Existing-__Existing___1y78T","modal-content":"app-pages-Customers-Loyalty-Existing-__Existing___3KNTl","modal-close-button":"app-pages-Customers-Loyalty-Existing-__Existing___3Joz5","modal-header":"app-pages-Customers-Loyalty-Existing-__Existing___2416i","modal-body":"app-pages-Customers-Loyalty-Existing-__Existing___VGsqj","modal-dialog":"app-pages-Customers-Loyalty-Existing-__Existing___fHYxP","modal-highlighted-message":"app-pages-Customers-Loyalty-Existing-__Existing___3Yzyk","point-balance-label":"app-pages-Customers-Loyalty-Existing-__Existing___163yg"};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___3uctW","field-wrapper":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___1-wmo","form-wrapper":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___2xU9N","footer":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___1_POz","btn-done":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___16UyM","separator-row":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___3hWGy","variant-name":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___2gk7F","variant-quantity":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___5fz23","label-total":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___396T1","total-trf":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___3BFJ_","total-ing-trf":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___ypH06","label-trf-detail":"app-pages-Inventory-Transfer-TransferDetail-__TransferDetail___29bdL"};

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2450),
    listCacheDelete = __webpack_require__(2451),
    listCacheGet = __webpack_require__(2452),
    listCacheHas = __webpack_require__(2453),
    listCacheSet = __webpack_require__(2454);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(545);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2447);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(268);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(2395),
    baseKeys = __webpack_require__(2413),
    isArrayLike = __webpack_require__(267);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(277);
var ViewportMetrics = __webpack_require__(879);

var getEventModifierState = __webpack_require__(569);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  true ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  true ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (true) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "90572c010c2fffcc9bbc240ac225a458.jpg";

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REFERRAL_REQUEST = exports.REFERRAL_REQUEST = 'REFERRAL_REQUEST';
var CHANGE_REFERRAL_DATA = exports.CHANGE_REFERRAL_DATA = 'CHANGE_REFERRAL_DATA';

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showBillingNotification = showBillingNotification;

var _constant = __webpack_require__(606);

function showBillingNotification(billingNotification) {
  return {
    type: _constant.BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION,
    payload: { billingNotification: billingNotification }
  };
} /**
   * Created by alvinoktavianus on 6/22/17.
   */

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by alvinoktavianus on 6/21/17.
 */

var BILLING_REDIRECT_UPDATE_PAYMENT_STATUS = exports.BILLING_REDIRECT_UPDATE_PAYMENT_STATUS = 'BILLING_REDIRECT_UPDATE_PAYMENT_STATUS';
var BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE = exports.BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE = 'BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE';
var BILLING_REDIRECT_SET_NOTIFICATION_TYPE = exports.BILLING_REDIRECT_SET_NOTIFICATION_TYPE = 'BILLING_REDIRECT_SET_NOTIFICATION_TYPE';

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CALENDAR_UPDATE_DATE_REQUEST = exports.CALENDAR_UPDATE_DATE_REQUEST = 'CALENDAR_UPDATE_DATE_REQUEST';

var CALENDAR_CHANGE_DATE = exports.CALENDAR_CHANGE_DATE = 'CALENDAR_CHANGE_DATE';

var CALENDAR_SET_DATE = exports.CALENDAR_SET_DATE = 'CALENDAR_SET_DATE';

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/****************************************************************************************************
 * Action Confirmation
 ****************************************************************************************************/
var prefix = "CONFIRM_ACTION_";
var CONFIRM_ACTION_SET_NEXT_ACTION = exports.CONFIRM_ACTION_SET_NEXT_ACTION = prefix + "NEXT_ACTION";
var CONFIRM_ACTION_ASK_CONFIRM_ACTION = exports.CONFIRM_ACTION_ASK_CONFIRM_ACTION = prefix + "ASK_CONFIRM_ACTION";
var CONFIRM_ACTION_CONFIRM_ACTION = exports.CONFIRM_ACTION_CONFIRM_ACTION = prefix + "CONFIRM_ACTION";
var CONFIRM_ACTION_CANCEL_ACTION = exports.CONFIRM_ACTION_CANCEL_ACTION = prefix + "CANCEL_ACTION";

var CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL = exports.CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL = prefix + "SHOW_CONFIRM_ACTION_MODAL";
var CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL = exports.CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL = prefix + "HIDE_CONFIRM_ACTION_MODAL";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'CONFIRM_EMPLOYEE';

var CONFIRM_EMPLOYEE_PAGE_REQUEST = exports.CONFIRM_EMPLOYEE_PAGE_REQUEST = PREFIX + '_PAGE_REQUEST';

var CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT = exports.CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT = PREFIX + '_CREATE_EMPLOYEE_ACCOUNT';

var CONFIRM_EMPLOYEE_INVALID_INVITATION = exports.CONFIRM_EMPLOYEE_INVALID_INVITATION = PREFIX + '_INVALID_INVITATION';

var CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE = exports.CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE = PREFIX + '_SET_INVITED_EMPLOYEE';

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// customers feedback actions
var CUSTOMERS_FEEDBACK_PAGE_REQUEST = exports.CUSTOMERS_FEEDBACK_PAGE_REQUEST = 'CUSTOMERS_FEEDBACK_PAGE_REQUEST';
var CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST = exports.CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST = 'CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST';
var CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK = exports.CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK = 'CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK';

// Filter feedback by date constants
var CUSTOMERS_FEEDBACK_CHANGE_DATE = exports.CUSTOMERS_FEEDBACK_CHANGE_DATE = 'CUSTOMERS_FEEDBACK_CHANGE_DATE';

// feedback detail actions
var CUSTOMERS_FEEDBACK_MESSAGES_REQUEST = exports.CUSTOMERS_FEEDBACK_MESSAGES_REQUEST = 'CUSTOMERS_FEEDBACK_MESSAGES_REQUEST';
var CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES = exports.CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES = 'CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES';
var CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST = exports.CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST = 'CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST';
var CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY = exports.CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY = 'CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY';
var CUSTOMERS_FEEDBACK_RECEIPT_REQUEST = exports.CUSTOMERS_FEEDBACK_RECEIPT_REQUEST = 'CUSTOMERS_FEEDBACK_RECEIPT_REQUEST';
var CUSTOMERS_FEEDBACK_SET_RECEIPT = exports.CUSTOMERS_FEEDBACK_SET_RECEIPT = 'CUSTOMERS_FEEDBACK_SET_RECEIPT';
var CUSTOMERS_FEEDBACK_ON_CLICK_ROW = exports.CUSTOMERS_FEEDBACK_ON_CLICK_ROW = 'CUSTOMERS_FEEDBACK_ON_CLICK_ROW';

var CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE = exports.CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE = 'CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE';
var CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE = exports.CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE = 'CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE';

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'CUSTOMER_LIST_';

var CUSTOMER_LIST_PAGE_REQUEST = exports.CUSTOMER_LIST_PAGE_REQUEST = PREFIX + 'PAGE_REQUEST';

/******************************************************************************************
 * Customer List
 ******************************************************************************************/

var CUSTOMER_LIST_CUSTOMERS_REQUEST = exports.CUSTOMER_LIST_CUSTOMERS_REQUEST = PREFIX + 'CUSTOMERS_REQUEST';

var CUSTOMER_LIST_SET_CUSTOMERS = exports.CUSTOMER_LIST_SET_CUSTOMERS = PREFIX + 'SET_CUSTOMERS';

var CUSTOMER_LIST_SET_TOTAL_PAGE = exports.CUSTOMER_LIST_SET_TOTAL_PAGE = PREFIX + 'SET_TOTAL_PAGE';

var CUSTOMER_LIST_SET_CURRENT_PAGE = exports.CUSTOMER_LIST_SET_CURRENT_PAGE = PREFIX + 'SET_CURRENT_PAGE';

var CUSTOMER_LIST_SET_KEYWORD = exports.CUSTOMER_LIST_SET_KEYWORD = PREFIX + 'SET_KEYWORD';

var CUSTOMER_LIST_SET_TYPE = exports.CUSTOMER_LIST_SET_TYPE = PREFIX + 'SET_TYPE';

var CUSTOMER_LIST_SET_SUMMARY = exports.CUSTOMER_LIST_SET_SUMMARY = PREFIX + 'SET_SUMMARY';

var CUSTOMER_LIST_SET_HAS_LOYALTY = exports.CUSTOMER_LIST_SET_HAS_LOYALTY = PREFIX + 'SET_HAS_LOYALTY';

/******************************************************************************************
 * End Customer List
 ******************************************************************************************/

/******************************************************************************************
 * Customer redemption histories
 ******************************************************************************************/
var CUSTOMER_LIST_SET_REDEMPTION_HISTORIES = exports.CUSTOMER_LIST_SET_REDEMPTION_HISTORIES = PREFIX + 'SET_REDEMPTION_HISTORIES';

var CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST = exports.CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST = PREFIX + 'REDEMPTION_HISTORIES_REQUEST';

/******************************************************************************************
* End Customer redemption histories
******************************************************************************************/

/******************************************************************************************
 * Customer redemption histories
 ******************************************************************************************/
var CUSTOMER_LIST_SET_POINT_ACTIVITIES = exports.CUSTOMER_LIST_SET_POINT_ACTIVITIES = PREFIX + 'SET_POINT_ACTIVITIES';

var CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST = exports.CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST = PREFIX + 'POINT_ACTIVITIES_REQUEST';

/******************************************************************************************
 * End Customer redemption histories
 ******************************************************************************************/

/******************************************************************************************
 * Customer Details
 ******************************************************************************************/

var CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST = exports.CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST = PREFIX + 'CUSTOMER_DETAIL_REQUEST';

var CUSTOMER_LIST_SET_CUSTOMER_DETAIL = exports.CUSTOMER_LIST_SET_CUSTOMER_DETAIL = PREFIX + 'SET_CUSTOMER_DETAIL';

var CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL = exports.CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL = PREFIX + 'CLOSE_CUSTOMER_DETAIL';

var CUSTOMER_LIST_RECEIPT_REQUEST = exports.CUSTOMER_LIST_RECEIPT_REQUEST = PREFIX + 'RECEIPT_REQUEST';

var CUSTOMER_LIST_SET_RECEIPT = exports.CUSTOMER_LIST_SET_RECEIPT = PREFIX + 'SET_RECEIPT';

/******************************************************************************************
 * End Customer Details
 ******************************************************************************************/

/******************************************************************************************
 * Export/Import
 ******************************************************************************************/
var CUSTOMERS_DOWNLOAD_TEMPLATE = exports.CUSTOMERS_DOWNLOAD_TEMPLATE = PREFIX + 'DOWNLOAD_TEMPLATE';
var CUSTOMER_LIST_EXPORT = exports.CUSTOMER_LIST_EXPORT = PREFIX + 'EXPORT';
/******************************************************************************************
 * End Export/Import
 ******************************************************************************************/

var CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL = exports.CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL = PREFIX + 'SHOW_IMPORTING_MODE_MODAL';
var CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL = exports.CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL = PREFIX + 'HIDE_IMPORTING_MODE_MODAL';
var CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY = exports.CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY = PREFIX + 'CHANGE_MODAL_VISIBILITY';

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_LOYALTY = exports.SET_LOYALTY = 'SET_LOYALTY';
var CREATE_LOYALTY = exports.CREATE_LOYALTY = 'CREATE_LOYALTY';
var EDIT_LOYALTY = exports.EDIT_LOYALTY = 'EDIT_LOYALTY';
var RESET_LOYALTY = exports.RESET_LOYALTY = 'RESET_LOYALTY';
var REACTIVATE_LOYALTY = exports.REACTIVATE_LOYALTY = 'REACTIVATE_LOYALTY';
var DEACTIVATE_LOYALTY = exports.DEACTIVATE_LOYALTY = 'DEACTIVATE_LOYALTY';
var INIT_LOYALTY_DATA = exports.INIT_LOYALTY_DATA = 'INIT_LOYALTY_DATA';

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_DASHBOARD_REQUEST = exports.GET_DASHBOARD_REQUEST = 'dashboard/GET_DASHBOARD_REQUEST';
var DASHBOARD_PAGE_REQUEST = exports.DASHBOARD_PAGE_REQUEST = 'DASHBOARD_PAGE_REQUEST';
var SET_DASHBOARD = exports.SET_DASHBOARD = 'SET_DASHBOARD';
var DASHBOARD_CHANGE_OUTLET = exports.DASHBOARD_CHANGE_OUTLET = 'DASHBOARD_CHANGE_OUTLET';
var DASHBOARD_CHANGE_DATE = exports.DASHBOARD_CHANGE_DATE = 'DASHBOARD_CHANGE_DATE';
var DASHBOARD_SET_OUTLETS = exports.DASHBOARD_SET_OUTLETS = 'DASHBOARD_SET_OUTLETS';

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDashboard = setDashboard;
exports.setOutlets = setOutlets;
exports.getDashboardRequest = getDashboardRequest;
exports.changeOutlet = changeOutlet;
exports.changeDate = changeDate;
exports.pageRequest = pageRequest;

var _constants = __webpack_require__(389);

function setDashboard(data) {
  return { type: _constants.SET_DASHBOARD, payload: { dashboard: data } };
}

function setOutlets(outlets) {
  return { type: _constants.DASHBOARD_SET_OUTLETS, payload: { outlets: outlets } };
}

function getDashboardRequest(query) {
  return { type: _constants.GET_DASHBOARD_REQUEST, payload: { query: query } };
}

function changeOutlet(outletIds, startDate, endDate) {
  return { type: _constants.DASHBOARD_CHANGE_OUTLET, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate } };
}

function changeDate(startDate, endDate) {
  return { type: _constants.DASHBOARD_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function pageRequest() {
  return { type: _constants.DASHBOARD_PAGE_REQUEST, payload: {} };
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'EMPLOYEE_LIST_';

var EMPLOYEE_LIST_PAGE_REQUEST = exports.EMPLOYEE_LIST_PAGE_REQUEST = PREFIX + 'PAGE_REQUEST';

var EMPLOYEE_LIST_SUBMIT_FORM = exports.EMPLOYEE_LIST_SUBMIT_FORM = PREFIX + 'SUBMIT_FORM';

var EMPLOYEE_LIST_SET_EMPLOYEES = exports.EMPLOYEE_LIST_SET_EMPLOYEES = PREFIX + 'SET_EMPLOYEES';

var EMPLOYEE_LIST_RESEND_INVITATION = exports.EMPLOYEE_LIST_RESEND_INVITATION = PREFIX + 'RESEND_INVITATION';

var EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE = exports.EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE = PREFIX + 'ASK_DELETE_EMPLOYEE';

var EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE = exports.EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE = PREFIX + 'CANCEL_DELETE_EMPLOYEE';

var EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE = exports.EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE = PREFIX + 'CONFIRM_DELETE_EMPLOYEE';

var EMPLOYEE_LIST_SET_DELETED_EMPLOYEE = exports.EMPLOYEE_LIST_SET_DELETED_EMPLOYEE = PREFIX + 'SET_DELETED_EMPLOYEE';

var EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL = exports.EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL = PREFIX + 'SHOW_DELETE_EMPLOYEE_MODAL';

var EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL = exports.EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL = PREFIX + 'HIDE_DELETE_EMPLOYEE_MODAL';

var EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL = exports.EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL = PREFIX + 'SHOW_ASSIGN_OUTLET_MODAL';

var EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL = exports.EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL = PREFIX + 'HIDE_ASSIGN_OUTLET_MODAL';

var EMPLOYEE_LIST_SET_OUTLETS = exports.EMPLOYEE_LIST_SET_OUTLETS = PREFIX + 'SET_OUTLETS';

var EMPLOYEE_LIST_CHECK_ALL_OUTLETS = exports.EMPLOYEE_LIST_CHECK_ALL_OUTLETS = PREFIX + 'CHECK_ALL_OUTLETS';

var EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS = exports.EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS = PREFIX + 'UNCHECK_ALL_OUTLETS';

var EMPLOYEE_LIST_SEARCH_OUTLET = exports.EMPLOYEE_LIST_SEARCH_OUTLET = PREFIX + 'SEARCH_OUTLET';

var EMPLOYEE_LIST_SET_CHECKED_OUTLETS = exports.EMPLOYEE_LIST_SET_CHECKED_OUTLETS = PREFIX + 'SET_CHECKED_OUTLETS';

var EMPLOYEE_LIST_ASSIGN_OUTLETS = exports.EMPLOYEE_LIST_ASSIGN_OUTLETS = PREFIX + 'ASSIGN_OUTLETS';

var EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS = exports.EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS = PREFIX + 'CONFIRM_ASSIGN_OUTLETS';

var EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS = exports.EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS = PREFIX + 'CANCEL_ASSIGN_OUTLETS';

var EMPLOYEE_LIST_SET_PROFILE = exports.EMPLOYEE_LIST_SET_PROFILE = PREFIX + 'SET_PROFILE';

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'EMPLOYEE_PERMISSION_';

var EMPLOYEE_PERMISSION_PAGE_REQUEST = exports.EMPLOYEE_PERMISSION_PAGE_REQUEST = PREFIX + 'PAGE_REQUEST';

var EMPLOYEE_PERMISSION_SUBMIT_FORM = exports.EMPLOYEE_PERMISSION_SUBMIT_FORM = PREFIX + 'SUBMIT_FORM';

var EMPLOYEE_PERMISSION_SET_SETTING = exports.EMPLOYEE_PERMISSION_SET_SETTING = PREFIX + 'SET_SETTING';

var EMPLOYEE_PERMISSION_CHANGE_PAGE = exports.EMPLOYEE_PERMISSION_CHANGE_PAGE = PREFIX + 'CHANGE_PAGE';

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'FEEDBACK_FORM';

var FEEDBACK_FORM_PAGE_REQUEST = exports.FEEDBACK_FORM_PAGE_REQUEST = PREFIX + '_PAGE_REQUEST';

var FEEDBACK_FORM_SUBMIT_FEEDBACK = exports.FEEDBACK_FORM_SUBMIT_FEEDBACK = PREFIX + '_SUBMIT_FEEDBACK';

var FEEDBACK_FORM_INVALID_FEEDBACK = exports.FEEDBACK_FORM_INVALID_FEEDBACK = PREFIX + '_INVALID_FEEDBACK';

var FEEDBACK_FORM_SUCCESS_SUBMIT = exports.FEEDBACK_FORM_SUCCESS_SUBMIT = PREFIX + '_SUCCESS_SUBMIT';

var FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN = exports.FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN = PREFIX + '_SET_DATA_CHECK_FEEDBACK_TOKEN';

var FEEDBACK_FORM_SHOW_FORM = exports.FEEDBACK_FORM_SHOW_FORM = PREFIX + '_SHOW_FORM';

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REQUEST_FEEDBACK_REPLY = exports.REQUEST_FEEDBACK_REPLY = 'REQUEST_FEEDBACK_REPLY';
var CHECK_TOKEN_FEEDBACK_REPLY_FORM = exports.CHECK_TOKEN_FEEDBACK_REPLY_FORM = 'CHECK_TOKEN_FEEDBACK_REPLY_FORM';
var SET_FEEDBACK_REPLY_FORM = exports.SET_FEEDBACK_REPLY_FORM = 'SET_FEEDBACK_REPLY_FORM';
var SEND_FEEDBACK_REPLY_FORM = exports.SEND_FEEDBACK_REPLY_FORM = 'SEND_FEEDBACK_REPLY_FORM';
var SET_INVALID_TOKEN = exports.SET_INVALID_TOKEN = 'SET_INVALID_TOKEN';

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_CONST = "INGREDIENT_CATEGORY";

var INGREDIENT_CATEGORY_PAGE_REQUEST = exports.INGREDIENT_CATEGORY_PAGE_REQUEST = BASE_CONST + "_PAGE_REQUEST";

var INGREDIENT_CATEGORY_CATEGORIES_REQUEST = exports.INGREDIENT_CATEGORY_CATEGORIES_REQUEST = BASE_CONST + "_CATEGORIES_REQUEST";

var INGREDIENT_CATEGORY_SET_OUTLETS = exports.INGREDIENT_CATEGORY_SET_OUTLETS = BASE_CONST + "_SET_OUTLETS";

var INGREDIENT_CATEGORY_SET_CATEGORIES = exports.INGREDIENT_CATEGORY_SET_CATEGORIES = BASE_CONST + "_SET_CATEGORIES";

var INGREDIENT_CATEGORY_SET_CURRENT_PAGE = exports.INGREDIENT_CATEGORY_SET_CURRENT_PAGE = BASE_CONST + "_SET_CURRENT_PAGE";

var INGREDIENT_CATEGORY_SET_TOTAL_PAGE = exports.INGREDIENT_CATEGORY_SET_TOTAL_PAGE = BASE_CONST + "_SET_TOTAL_PAGE";

var INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL = exports.INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL = BASE_CONST + "_SET_CATEGORY_DETAIL";

var INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS = exports.INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS = BASE_CONST + "_ON_CHANGE_OUTLET_IDS";

var INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD = exports.INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD = BASE_CONST + "_ON_CHANGE_KEYWORD";

var INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY = exports.INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY = BASE_CONST + "_ON_CLICK_CREATE_CATEGORY";

var INGREDIENT_CATEGORY_ON_CLICK_CANCEL = exports.INGREDIENT_CATEGORY_ON_CLICK_CANCEL = BASE_CONST + "_ON_CLICK_CANCEL";

var INGREDIENT_CATEGORY_ON_CLICK_ROW = exports.INGREDIENT_CATEGORY_ON_CLICK_ROW = BASE_CONST + "_ON_CLICK_ROW";

var INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN = exports.INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN = BASE_CONST + "_SHOW_RIGHT_COLUMN";

var INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN = exports.INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN = BASE_CONST + "_HIDE_RIGHT_COLUMN";

var INGREDIENT_CATEGORY_SUBMIT_FORM = exports.INGREDIENT_CATEGORY_SUBMIT_FORM = BASE_CONST + "_SUBMIT_FORM";

var INGREDIENT_CATEGORY_SHOW_DELETE_MODAL = exports.INGREDIENT_CATEGORY_SHOW_DELETE_MODAL = BASE_CONST + "_SHOW_DELETE_MODAL";

var INGREDIENT_CATEGORY_HIDE_DELETE_MODAL = exports.INGREDIENT_CATEGORY_HIDE_DELETE_MODAL = BASE_CONST + "_HIDE_DELETE_MODAL";

var INGREDIENT_CATEGORY_DELETE_CATEGORY = exports.INGREDIENT_CATEGORY_DELETE_CATEGORY = BASE_CONST + "_DELETE_CATEGORY";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY = BASE_CONST + "_ASSIGN_TO_INGREDIENT_SET_CATEGORY";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST = BASE_CONST + "ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM = BASE_CONST + "ASSIGN_TO_INGREDIENT_FILL_FORM";

var INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT = exports.INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT = BASE_CONST + "SUBMIT_ASSIGN_TO_INGREDIENT";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE = BASE_CONST + "ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE = BASE_CONST + "ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE";

var INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS = exports.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS = BASE_CONST + "ASSIGN_TO_INGREDIENT_SET_INGREDIENTS";

var INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT = exports.INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT = BASE_CONST + "CANCEL_ASSIGN_TO_INGREDIENT";

var INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL = exports.INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL = BASE_CONST + "HIDE_ASSIGN_TO_INGREDIENT_MODAL";

var INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL = exports.INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL = BASE_CONST + "SHOW_ASSIGN_TO_INGREDIENT_MODAL";

var INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT = exports.INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT = BASE_CONST + "ON_CLICK_ASSIGN_TO_INGREDIENT";

var INGREDIENT_CATEGORY_SET_IS_SUBMITTING = exports.INGREDIENT_CATEGORY_SET_IS_SUBMITTING = BASE_CONST + "SET_IS_SUBMITTING";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by alvinoktavianus on 6/27/17.
 */

// Default dispatcher
var INGREDIENT_SUBSCRIPTION_PAGE_REQUEST = exports.INGREDIENT_SUBSCRIPTION_PAGE_REQUEST = 'INGREDIENT_SUBSCRIPTION_PAGE_REQUEST';
var INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS = exports.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS = 'INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS';
var INGREDIENT_SUBSCRIPTION_FEATURE_PRICE = exports.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE = 'INGREDIENT_SUBSCRIPTION_FEATURE_PRICE';
var INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS = exports.INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS = 'INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS';
var INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE = exports.INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE = 'INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE';
var INGREDIENT_SUBSCRIPTION_END_TUTORIAL = exports.INGREDIENT_SUBSCRIPTION_END_TUTORIAL = 'INGREDIENT_SUBSCRIPTION_END_TUTORIAL';
var INGREDIENT_SUBSCRIPTION_VERIFY_BILLING = exports.INGREDIENT_SUBSCRIPTION_VERIFY_BILLING = 'INGREDIENT_SUBSCRIPTION_VERIFY_BILLING';
var INGREDIENT_SUBSCRIPTION_START_TRIAL = exports.INGREDIENT_SUBSCRIPTION_START_TRIAL = 'INGREDIENT_SUBSCRIPTION_START_TRIAL';

// Setter
var INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL = exports.INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL = 'INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL';
var INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS = exports.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS = 'INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS';
var INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE = exports.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE = 'INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE';
var INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE = exports.INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE';
var INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE = exports.INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE';
var INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL = exports.INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL = 'INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL';
var INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT = exports.INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT = 'INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT';
var INGREDIENT_SUBSCRIPTION_SET_OUTLETS = exports.INGREDIENT_SUBSCRIPTION_SET_OUTLETS = 'INGREDIENT_SUBSCRIPTION_SET_OUTLETS';
var INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE = exports.INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE = 'INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE';

// Getter
var INGREDIENT_SUBSCRIPTION_GET_BILLINGS = exports.INGREDIENT_SUBSCRIPTION_GET_BILLINGS = 'INGREDIENT_SUBSCRIPTION_GET_BILLINGS';
var INGREDIENT_SUBSCRIPTION_GET_OUTLETS = exports.INGREDIENT_SUBSCRIPTION_GET_OUTLETS = 'INGREDIENT_SUBSCRIPTION_GET_OUTLETS';

// Other dispatcher
var INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON = exports.INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON = 'INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON';
var INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON = exports.INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON = 'INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON';
var INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL = exports.INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL = 'INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL';
var INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL = exports.INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL = 'INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL';
var INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = exports.INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = 'INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';
var INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = exports.INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = 'INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INGREDIENT_LIBRARY_PAGE_REQUEST = exports.INGREDIENT_LIBRARY_PAGE_REQUEST = 'INGREDIENT_LIBRARY_PAGE_REQUEST';
var INGREDIENT_LIBRARY_LIST_ITEM_REQUEST = exports.INGREDIENT_LIBRARY_LIST_ITEM_REQUEST = 'INGREDIENT_LIBRARY_LIST_ITEM_REQUEST';
var INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST = exports.INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST = 'INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST';
var INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST = exports.INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST = 'INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST';
var INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN = exports.INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN = 'INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN';
var INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN = exports.INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN = 'INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN';
var INGREDIENT_LIBRARY_SET_CATEGORY_LIST = exports.INGREDIENT_LIBRARY_SET_CATEGORY_LIST = 'INGREDIENT_LIBRARY_SET_CATEGORY_LIST';
var INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID = exports.INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID = 'INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID';
var INGREDIENT_LIBRARY_SET_ITEM_LIST = exports.INGREDIENT_LIBRARY_SET_ITEM_LIST = 'INGREDIENT_LIBRARY_SET_ITEM_LIST';
var INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID = exports.INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID = 'INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID';
var INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID = exports.INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID = 'INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID';
var INGREDIENT_LIBRARY_SET_ITEM_SUMMARY = exports.INGREDIENT_LIBRARY_SET_ITEM_SUMMARY = 'INGREDIENT_LIBRARY_SET_ITEM_SUMMARY';
var INGREDIENT_LIBRARY_SET_OUTLETS = exports.INGREDIENT_LIBRARY_SET_OUTLETS = 'INGREDIENT_LIBRARY_SET_OUTLETS';
var INGREDIENT_LIBRARY_SET_FILTER_STATE = exports.INGREDIENT_LIBRARY_SET_FILTER_STATE = 'INGREDIENT_LIBRARY_SET_FILTER_STATE';
var INGREDIENT_LIBRARY_SET_FILTER_ITEM = exports.INGREDIENT_LIBRARY_SET_FILTER_ITEM = 'INGREDIENT_LIBRARY_SET_FILTER_ITEM';
var INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS = exports.INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS = 'INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS';
var INGREDIENT_LIBRARY_SET_CURRENT_PAGE = exports.INGREDIENT_LIBRARY_SET_CURRENT_PAGE = 'INGREDIENT_LIBRARY_SET_CURRENT_PAGE';
var INGREDIENT_LIBRARY_SET_TOTAL_PAGE = exports.INGREDIENT_LIBRARY_SET_TOTAL_PAGE = 'INGREDIENT_LIBRARY_SET_TOTAL_PAGE';
var INGREDIENT_LIBRARY_ITEMS_REQUEST = exports.INGREDIENT_LIBRARY_ITEMS_REQUEST = 'INGREDIENT_LIBRARY_ITEMS_REQUEST';
var INGREDIENT_LIBRARY_UNSET_FILTER_STATE = exports.INGREDIENT_LIBRARY_UNSET_FILTER_STATE = 'INGREDIENT_LIBRARY_UNSET_FILTER_STATE';
var INGREDIENT_LIBRARY_ITEM_LIST_EXPORT = exports.INGREDIENT_LIBRARY_ITEM_LIST_EXPORT = 'INGREDIENT_LIBRARY_ITEM_LIST_EXPORT';
var INGREDIENT_LIBRARY_SET_TYPE_IMPORT = exports.INGREDIENT_LIBRARY_SET_TYPE_IMPORT = 'INGREDIENT_LIBRARY_SET_TYPE_IMPORT';
var INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER = exports.INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER = 'INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER';
var INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE = exports.INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE = 'INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE';
var INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN = exports.INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN = 'INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN';
var INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN = exports.INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN = 'INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN';
var INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM = exports.INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM = 'INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM';
var INGREDIENT_LIBRARY_SET_ITEM_DETAIL = exports.INGREDIENT_LIBRARY_SET_ITEM_DETAIL = 'INGREDIENT_LIBRARY_SET_ITEM_DETAIL';
var INGREDIENT_LIBRARY_ON_CLICK_CANCEL = exports.INGREDIENT_LIBRARY_ON_CLICK_CANCEL = 'INGREDIENT_LIBRARY_ON_CLICK_CANCEL';
var INGREDIENT_LIBRARY_ON_CLICK_ROW = exports.INGREDIENT_LIBRARY_ON_CLICK_ROW = 'INGREDIENT_LIBRARY_ON_CLICK_ROW';
var INGREDIENT_LIBRARY_ON_DROP_IMAGE = exports.INGREDIENT_LIBRARY_ON_DROP_IMAGE = 'INGREDIENT_LIBRARY_ON_DROP_IMAGE';
var INGREDIENT_LIBRARY_ON_DELETE_IMAGE = exports.INGREDIENT_LIBRARY_ON_DELETE_IMAGE = 'INGREDIENT_LIBRARY_ON_DELETE_IMAGE';
var INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT = exports.INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT = 'INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT';
var INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL = exports.INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL = 'INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL';
var INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL = exports.INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL = 'INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL';
var INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM = exports.INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM = 'INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM';
var INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL = exports.INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL = 'INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL';
var INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL = exports.INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL = 'INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL';
var INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL = exports.INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL = 'INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL';
var INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL = exports.INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL = 'INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL';
var INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING = exports.INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING = 'INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING';
var INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL = exports.INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL = 'INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL';
var INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL = exports.INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL = 'INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL';
var INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM = exports.INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM = 'INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM';
var INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM = exports.INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM = 'INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM';
var INGREDIENT_LIBRARY_SET_MODIFIERS = exports.INGREDIENT_LIBRARY_SET_MODIFIERS = 'INGREDIENT_LIBRARY_SET_MODIFIERS';
var INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS = exports.INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS = 'INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS';
var INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY = exports.INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY = 'INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY';
var INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE = exports.INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE = 'INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE';
var INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE = exports.INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE = 'INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE';
var INGREDIENT_LIBRARY_SHOW_DELETE_MODAL = exports.INGREDIENT_LIBRARY_SHOW_DELETE_MODAL = 'INGREDIENT_LIBRARY_SHOW_DELETE_MODAL';
var INGREDIENT_LIBRARY_HIDE_DELETE_MODAL = exports.INGREDIENT_LIBRARY_HIDE_DELETE_MODAL = 'INGREDIENT_LIBRARY_HIDE_DELETE_MODAL';
var INGREDIENT_LIBRARY_DELETE_ITEM = exports.INGREDIENT_LIBRARY_DELETE_ITEM = 'INGREDIENT_LIBRARY_DELETE_ITEM';
var INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY = exports.INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY = 'INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY';
var INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL = exports.INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL = 'INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL';
var INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL = exports.INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL = 'INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL';
var INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY = exports.INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY = 'INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY';
var INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY = exports.INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY = 'INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY';
var INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES = exports.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES = 'INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES';
var INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID = exports.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID = 'INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID';
var INGREDIENT_LIBRARY_SET_NEW_CATEGORY = exports.INGREDIENT_LIBRARY_SET_NEW_CATEGORY = 'INGREDIENT_LIBRARY_SET_NEW_CATEGORY';
var INGREDIENT_LIBRARY_SET_UNITS = exports.INGREDIENT_LIBRARY_SET_UNITS = 'INGREDIENT_LIBRARY_SET_UNITS';
var INGREDIENT_LIBRARY_SET_UNCATEGORIZED = exports.INGREDIENT_LIBRARY_SET_UNCATEGORIZED = 'INGREDIENT_LIBRARY_SET_UNCATEGORIZED';
var INGREDIENT_LIBRARY_STORE_UNCATEGORIZED = exports.INGREDIENT_LIBRARY_STORE_UNCATEGORIZED = 'INGREDIENT_LIBRARY_STORE_UNCATEGORIZED';
var INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL = exports.INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL = 'INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL';
var INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL = exports.INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL = 'INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL';
var INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT = exports.INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT = 'INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT';
var INGREDIENT_LIBRARY_SHOW_COGS_MODAL = exports.INGREDIENT_LIBRARY_SHOW_COGS_MODAL = 'INGREDIENT_LIBRARY_SHOW_COGS_MODAL';
var INGREDIENT_LIBRARY_HIDE_COGS_MODAL = exports.INGREDIENT_LIBRARY_HIDE_COGS_MODAL = 'INGREDIENT_LIBRARY_HIDE_COGS_MODAL';
var INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS = exports.INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS = 'INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS';
var INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL = exports.INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL = 'INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL';
var INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL = exports.INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL = 'INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL';
var INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = exports.INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = 'INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';
var INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = exports.INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = 'INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';
var INGREDIENT_LIBRARY_SET_CREATED_OUTLETS = exports.INGREDIENT_LIBRARY_SET_CREATED_OUTLETS = 'INGREDIENT_LIBRARY_SET_CREATED_OUTLETS';
var INGREDIENT_LIBRARY_SHOW_INPUT_COGS = exports.INGREDIENT_LIBRARY_SHOW_INPUT_COGS = 'INGREDIENT_LIBRARY_SHOW_INPUT_COGS';
var INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY = exports.INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY = 'INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY';
var INGREDIENT_LIBRARY_IS_SUBMITTING_FORM = exports.INGREDIENT_LIBRARY_IS_SUBMITTING_FORM = 'INGREDIENT_LIBRARY_IS_SUBMITTING_FORM';

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'INGREDIENT_RECIPES';
var INGREDIENT_RECIPES_PAGE_REQUEST = exports.INGREDIENT_RECIPES_PAGE_REQUEST = prefix + '_PAGE_REQUEST';
var INGREDIENT_RECIPES_RECIPES_REQUEST = exports.INGREDIENT_RECIPES_RECIPES_REQUEST = prefix + '_RECIPES_REQUEST';
var INGREDIENT_RECIPES_INGREDIENT_RECIPES_REQUEST = exports.INGREDIENT_RECIPES_INGREDIENT_RECIPES_REQUEST = prefix + '_INGREDIENT_RECIPES_REQUEST';
var INGREDIENT_RECIPES_SET_OUTLETS = exports.INGREDIENT_RECIPES_SET_OUTLETS = prefix + '_SET_OUTLETS';
var INGREDIENT_RECIPES_SET_RECIPES = exports.INGREDIENT_RECIPES_SET_RECIPES = prefix + '_SET_RECIPES';
var INGREDIENT_RECIPES_SUBMIT_FORM_CREATE = exports.INGREDIENT_RECIPES_SUBMIT_FORM_CREATE = prefix + '_SUBMIT_FORM_CREATE';
var INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS = exports.INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS = prefix + '_ON_CHANGE_OUTLET_IDS';
var INGREDIENT_RECIPES_SET_CURRENT_PAGE = exports.INGREDIENT_RECIPES_SET_CURRENT_PAGE = prefix + '_SET_CURRENT_PAGE';
var INGREDIENT_RECIPES_SET_TOTAL_PAGE = exports.INGREDIENT_RECIPES_SET_TOTAL_PAGE = prefix + '_SET_TOTAL_PAGE';
var INGREDIENT_RECIPES_EXPORT_RECIPES = exports.INGREDIENT_RECIPES_EXPORT_RECIPES = prefix + '_EXPORT_RECIPES';
var INGREDIENT_RECIPES_ON_CLICK_ROW = exports.INGREDIENT_RECIPES_ON_CLICK_ROW = prefix + '_ON_CLICK_ROW';
var INGREDIENT_RECIPES_ON_CLICK_DONE = exports.INGREDIENT_RECIPES_ON_CLICK_DONE = prefix + '_ON_CLICK_DONE';
var INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN = exports.INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN = prefix + '_OPEN_RIGHT_COLUMN';
var INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN = exports.INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN = prefix + '_CLOSE_RIGHT_COLUMN';
var INGREDIENT_RECIPES_SET_RECIPES_DETAIL = exports.INGREDIENT_RECIPES_SET_RECIPES_DETAIL = prefix + '_SET_RECIPES_DETAIL';
var INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES = exports.INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES = prefix + '_ON_CLICK_CREATE_RECIPES';
var INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL = exports.INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL = prefix + '_SHOW_ADD_ITEMS_MODAL';
var INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL = exports.INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL = prefix + '_HIDE_ADD_ITEMS_MODAL';
var INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS = exports.INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS = prefix + '_ON_CLICK_ADD_ITEMS';
var INGREDIENT_RECIPES_ADD_ITEMS_CONFIRM_ADD_ITEMS = exports.INGREDIENT_RECIPES_ADD_ITEMS_CONFIRM_ADD_ITEMS = prefix + '_ADD_ITEMS_CONFIRM_ADD_ITEMS';
var INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS = exports.INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS = prefix + '_ADD_ITEMS_SET_ITEMS';
var INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS = exports.INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS = prefix + '_ADD_ITEMS_SET_INGREDIENTS';
var INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT = exports.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT = prefix + '_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT';
var INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT = exports.INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT = prefix + '_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT';
var INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING = exports.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING = prefix + '_ADD_ITEMS_SHOW_LOADING';
var INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING = exports.INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING = prefix + '_ADD_ITEMS_HIDE_LOADING';
var INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS = exports.INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS = prefix + '_ADD_ITEMS_ON_SEARCH_ITEMS';
var INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS = exports.INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS = prefix + '_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS';
var INGREDIENT_RECIPES_RECIPES_DETAIL_PAGE = exports.INGREDIENT_RECIPES_RECIPES_DETAIL_PAGE = prefix + '_RECIPES_DETAIL_PAGE';
var INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET = exports.INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET = prefix + '_RECIPES_FORM_ON_CHANGE_OUTLET';
var INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL = exports.INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL = prefix + '_RECIPES_FORM_ON_CLICK_CANCEL';
var INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL = exports.INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL = prefix + '_SHOW_CONFIRM_SUBMIT_MODAL';
var INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL = exports.INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL = prefix + '_HIDE_CONFIRM_SUBMIT_MODAL';
var INGREDIENT_RECIPES_CONFIRM_SUBMIT = exports.INGREDIENT_RECIPES_CONFIRM_SUBMIT = prefix + '_CONFIRM_SUBMIT';
var INGREDIENT_RECIPES_SET_FILTER_ITEM = exports.INGREDIENT_RECIPES_SET_FILTER_ITEM = prefix + '_SET_FILTER_ITEM';
var INGREDIENT_RECIPES_SET_FILTER_STATE = exports.INGREDIENT_RECIPES_SET_FILTER_STATE = prefix + '_RECIPES_SET_FILTER_STATE';
var INGREDIENT_RECIPES_UNSET_FILTER_STATE = exports.INGREDIENT_RECIPES_UNSET_FILTER_STATE = prefix + '_RECIPES_UNSET_FILTER_STATE';
var INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN = exports.INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN = prefix + '_SET_ITEMS_DROPDOWN';
var INGREDIENT_RECIPES_SET_ITEM_VARIANT = exports.INGREDIENT_RECIPES_SET_ITEM_VARIANT = prefix + '_SET_ITEM_VARIANT';
var INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST = exports.INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST = prefix + '_GET_INGREDIENT_REQUEST';
var INGREDIENT_RECIPES_SET_INGREDIENT_REQUEST = exports.INGREDIENT_RECIPES_SET_INGREDIENT_REQUEST = prefix + '_SET_INGREDIENT_REQUEST';
var INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS = exports.INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS = prefix + '_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS';
var INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS = exports.INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS = prefix + '_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS';
var INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT = exports.INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT = prefix + '_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT';
var INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST = exports.INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST = prefix + '_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST';
var INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT = exports.INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT = prefix + '_ADD_RECIPES_SET_SELECTED_ID';
var INGREDIENT_RECIPES_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT = exports.INGREDIENT_RECIPES_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT = prefix + '_ADD_RECIPES_HIDE_ALREADY_ADDED_ALERT';
var INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD = exports.INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD = prefix + '_ADD_RECIPES_SET_KEYWORD';
var INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS = exports.INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS = prefix + '_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS';
var INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS = exports.INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS = prefix + '_ADD_ITEMS_ON_CHANGE_ITEMS';
var INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES = exports.INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES = prefix + '_ADD_INGREDIENT_DETAIL_RECIPES';
var INGREDIENT_RECIPES_SHOW_DELETE_MODAL = exports.INGREDIENT_RECIPES_SHOW_DELETE_MODAL = prefix + '_SHOW_DELETE_MODAL';
var INGREDIENT_RECIPES_HIDE_DELETE_MODAL = exports.INGREDIENT_RECIPES_HIDE_DELETE_MODAL = prefix + '_HIDE_DELETE_MODAL';
var INGREDIENT_RECIPES_DELETE_ITEM = exports.INGREDIENT_RECIPES_DELETE_ITEM = prefix + '_DELETE_ITEM';
var INGREDIENT_RECIPES_SAVE_RECIPES = exports.INGREDIENT_RECIPES_SAVE_RECIPES = prefix + '_SAVE_RECIPES';
var INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET = exports.INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET = prefix + '_SAVE_RECIPES_ALL_OUTLET';
var INGREDIENT_RECIPES_UPDATE_RECIPES = exports.INGREDIENT_RECIPES_UPDATE_RECIPES = prefix + '_UPDATE_RECIPES';
var INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET = exports.INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET = prefix + '_UPDATE_RECIPES_ALL_OUTLET';
var INGREDIENT_RECIPES_SET_RECIPES_FORM = exports.INGREDIENT_RECIPES_SET_RECIPES_FORM = prefix + '_SET_RECIPES_FORM';
var INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = exports.INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = prefix + '_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';
var INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = exports.INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = prefix + '_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';
var INGREDIENT_RECIPES_SET_CREATED_OUTLETS = exports.INGREDIENT_RECIPES_SET_CREATED_OUTLETS = prefix + '_SET_CREATED_OUTLETS';
var INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID = exports.INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID = prefix + '_SET_INGREDIENT_BY_VARIANT_ID';
var INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID = exports.INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID = prefix + '_UNSET_INGREDIENT_BY_VARIANT_ID';
var INGREDIENT_RECIPES_IS_SUBMITTING_FORM = exports.INGREDIENT_RECIPES_IS_SUBMITTING_FORM = prefix + '_IS_SUBMITTING_FORM';

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'INVENTORY_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_PAGE_REQUEST = exports.INVENTORY_ADJUSTMENT_PAGE_REQUEST = prefix + '_PAGE_REQUEST';

var INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST = exports.INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST = prefix + '_ADJUSTMENTS_REQUEST';

var INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST = exports.INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST = prefix + '_INGREDIENT_ADJUSTMENT_REQUEST';

var INVENTORY_ADJUSTMENT_SET_OUTLETS = exports.INVENTORY_ADJUSTMENT_SET_OUTLETS = prefix + '_SET_OUTLETS';

var INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS = exports.INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS = prefix + '_SET_ADJUSTMENTS';

var INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS = exports.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS = prefix + '_SET_INGREDIENT_ADJUSTMENTS';

var INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE = exports.INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE = prefix + '_SUBMIT_FORM_CREATE';

var INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS = exports.INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS = prefix + '_ON_CHANGE_OUTLET_IDS';

var INVENTORY_ADJUSTMENT_ON_CHANGE_DATE = exports.INVENTORY_ADJUSTMENT_ON_CHANGE_DATE = prefix + '_ON_CHANGE_DATE';

var INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE = exports.INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE = prefix + '_ON_CHANGE_NAMESPACE';

var INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE = exports.INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE = prefix + '_SET_CURRENT_PAGE';

var INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE = exports.INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE = prefix + '_SET_TOTAL_PAGE';

var INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT = prefix + '_EXPORT_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT = prefix + '_EXPORT_INGREDIENT_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_ON_CLICK_ROW = exports.INVENTORY_ADJUSTMENT_ON_CLICK_ROW = prefix + '_ON_CLICK_ROW';

var INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT = prefix + '_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_ON_CLICK_DONE = exports.INVENTORY_ADJUSTMENT_ON_CLICK_DONE = prefix + '_ON_CLICK_DONE';

var INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN = exports.INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN = prefix + '_OPEN_RIGHT_COLUMN';

var INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN = exports.INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN = prefix + '_CLOSE_RIGHT_COLUMN';

var INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL = exports.INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL = prefix + '_SET_ADJUSTMENT_DETAIL';

var INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL = exports.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL = prefix + '_SET_INGREDIENT_ADJUSTMENT_DETAIL';

var INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT = prefix + '_ON_CLICK_CREATE_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL = exports.INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL = prefix + '_SHOW_ADD_ITEMS_MODAL';

var INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL = exports.INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL = prefix + '_HIDE_ADD_ITEMS_MODAL';

var INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS = exports.INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS = prefix + '_ON_CLICK_ADD_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS = prefix + '_ADD_ITEMS_CANCEL_ADD_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS = prefix + '_ADD_ITEMS_CONFIRM_ADD_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST = prefix + '_ADD_ITEMS_GET_ITEMS_REQUEST';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST = prefix + '_ADD_ITEMS_GET_INGREDIENTS_REQUEST';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS = prefix + '_ADD_ITEMS_SET_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID = prefix + '_ADD_ITEMS_SET_SELECTED_ID';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS = prefix + '_ADD_ITEMS_SET_INGREDIENTS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT = prefix + '_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT = prefix + '_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING = prefix + '_ADD_ITEMS_SHOW_LOADING';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING = prefix + '_ADD_ITEMS_HIDE_LOADING';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS = prefix + '_ADD_ITEMS_ON_SEARCH_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS = prefix + '_ADD_ITEMS_ON_CHANGE_ITEMS';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE = prefix + '_ADD_ITEMS_SET_CURRENT_PAGE';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE = prefix + '_ADD_ITEMS_SET_TOTAL_PAGE';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD = prefix + '_ADD_ITEMS_SET_KEYWORD';

var INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE = exports.INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE = prefix + '_ADJUSTMENT_DETAIL_PAGE';

var INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET = exports.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET = prefix + '_ADJUSTMENT_FORM_ON_CHANGE_OUTLET';

var INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL = exports.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL = prefix + '_ADJUSTMENT_FORM_ON_CLICK_CANCEL';

var INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL = exports.INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL = prefix + '_SHOW_CONFIRM_SUBMIT_MODAL';

var INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL = exports.INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL = prefix + '_HIDE_CONFIRM_SUBMIT_MODAL';

var INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT = exports.INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT = prefix + '_CONFIRM_SUBMIT';

var INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL = exports.INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL = prefix + '_SHOW_IMPORT_MODAL';

var INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL = exports.INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL = prefix + '_HIDE_IMPORT_MODAL';

var INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT = exports.INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT = prefix + '_ON_SUCCESS_IMPORT';

var INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT = prefix + '_SET_SUMMARY_INVENTORY_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT = exports.INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT = prefix + '_SET_SUMMARY_INGREDIENT_ADJUSTMENT';

var INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE = exports.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE = prefix + '_ADD_ITEMS_SET_ITEM_HAS_RECIPE';

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS = exports.INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS = 'INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS';
var INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS = exports.INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS = 'INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS';

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_CONST = 'INVENTORY_PURCHASE_ORDER_';

var INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER = BASE_CONST + 'SET_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_PAGE_REQUEST = exports.INVENTORY_PURCHASE_ORDER_PAGE_REQUEST = BASE_CONST + 'PAGE_REQUEST';

var INVENTORY_PURCHASE_ORDER_SET_OUTLETS = exports.INVENTORY_PURCHASE_ORDER_SET_OUTLETS = BASE_CONST + 'SET_OUTLETS';

var INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST = exports.INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST = BASE_CONST + 'PURCHASE_ORDER_REQUEST';

var INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN = exports.INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN = BASE_CONST + 'OPEN_RIGHT_COLUMN';

var INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN = exports.INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN = BASE_CONST + 'CLOSE_RIGHT_COLUMN';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW = BASE_CONST + 'ON_CLICK_ROW';

var INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE = exports.INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE = BASE_CONST + 'SET_TOTAL_PAGE';

var INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE = exports.INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE = BASE_CONST + 'SET_CURRENT_PAGE';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS = BASE_CONST + 'ON_CHANGE_OUTLET_IDS';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE = BASE_CONST + 'ON_CHANGE_DATE';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE = BASE_CONST + 'ON_CHANGE_NAMESPACE';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS = BASE_CONST + 'ON_CHANGE_STATUS';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD = BASE_CONST + 'ON_CHANGE_KEYWORD';

var INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER = BASE_CONST + 'EXPORT_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE = BASE_CONST + 'ON_CLICK_DONE';

var INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL = exports.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL = BASE_CONST + 'PURCHASE_ORDER_DETAIL';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT = BASE_CONST + 'ON_CLICK_PRINT';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL = BASE_CONST + 'ON_CLICK_RESEND_EMAIL';

var INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS = exports.INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS = BASE_CONST + 'SET_SUPPLIERS';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO = BASE_CONST + 'ON_CLICK_CREATE_PO';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL = BASE_CONST + 'ON_CLICK_CANCEL';

var INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER = BASE_CONST + 'UPDATE_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM = exports.INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM = BASE_CONST + 'SHOW_MODAL_ITEM';

var INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM = exports.INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM = BASE_CONST + 'CLOSE_MODAL_ITEM';

var INVENTORY_PURCHASE_ORDER_IS_LOADING = exports.INVENTORY_PURCHASE_ORDER_IS_LOADING = BASE_CONST + 'IS_LOADING';

var INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH = exports.INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH = BASE_CONST + 'SET_ITEM';

var INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API = exports.INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API = BASE_CONST + 'GET_ITEMS_FROM_API';

var INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET = exports.INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET = BASE_CONST + 'SET_SELECTED_OUTLET';

var INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM = exports.INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM = BASE_CONST + 'SET_ADDED_ITEM';

var INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM = exports.INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM = BASE_CONST + 'ON_CANCEL_MODAL_ADD_ITEM';

var INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM = exports.INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM = BASE_CONST + 'SET_MODAL_ITEM_FORM';

var INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED = exports.INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED = BASE_CONST + 'SET_IS_ITEM_ADDED';

var INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM = exports.INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM = BASE_CONST + 'ADD_ITEM_TO_FORM';

var INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER = BASE_CONST + 'CREATE_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER = BASE_CONST + 'CREATE_AND_FULFILLED_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER = exports.INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER = BASE_CONST + 'EDIT_PURCHASE_ORDER';

var INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM = exports.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM = BASE_CONST + 'ON_CHANGE_OUTLET_FORM';

var INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT = exports.INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT = BASE_CONST + 'ON_CLICK_EDIT';

var INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL = exports.INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL = BASE_CONST + 'SHOW_CONFIRM_SUBMIT_MODAL';

var INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL = exports.INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL = BASE_CONST + 'HIDE_CONFIRM_SUBMIT_MODAL';

var INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS = exports.INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS = BASE_CONST + 'SET_FIRST_ITEMS';

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'INVENTORY_SUMMARY';

var INVENTORY_SUMMARY_PAGE_REQUEST = exports.INVENTORY_SUMMARY_PAGE_REQUEST = prefix + '_PAGE_REQUEST';

var INVENTORY_SUMMARY_SUMMARY_REQUEST = exports.INVENTORY_SUMMARY_SUMMARY_REQUEST = prefix + '_SUMMARY_REQUEST';

var INVENTORY_SUMMARY_SET_OUTLETS = exports.INVENTORY_SUMMARY_SET_OUTLETS = prefix + '_SET_OUTLETS';

var INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS = exports.INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS = prefix + '_ON_CHANGE_OUTLET_IDS';

var INVENTORY_SUMMARY_ON_CHANGE_DATE = exports.INVENTORY_SUMMARY_ON_CHANGE_DATE = prefix + '_ON_CHANGE_DATE';

var INVENTORY_SUMMARY_ON_CHANGE_KEYWORD = exports.INVENTORY_SUMMARY_ON_CHANGE_KEYWORD = prefix + '_ON_CHANGE_KEYWORD';

var INVENTORY_SUMMARY_SET_CURRENT_PAGE = exports.INVENTORY_SUMMARY_SET_CURRENT_PAGE = prefix + '_SET_CURRENT_PAGE';

var INVENTORY_SUMMARY_SET_TOTAL_PAGE = exports.INVENTORY_SUMMARY_SET_TOTAL_PAGE = prefix + '_SET_TOTAL_PAGE';

var INVENTORY_SUMMARY_SET_ITEMS = exports.INVENTORY_SUMMARY_SET_ITEMS = prefix + '_SET_ITEMS';

var INVENTORY_SUMMARY_SET_ROW_ITEMS = exports.INVENTORY_SUMMARY_SET_ROW_ITEMS = prefix + '_SET_ROW_ITEMS';

var INVENTORY_SUMMARY_EXPORT_SUMMARY = exports.INVENTORY_SUMMARY_EXPORT_SUMMARY = prefix + '_EXPORT_SUMMARY';

var INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE = exports.INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE = prefix + '_ON_CHANGE_NAMESPACE';

var INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST = exports.INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST = prefix + '_INGREDIENT_INVENTORY_SUMMARY_REQUEST';

var INVENTORY_SUMMARY_SET_INGREDIENTS = exports.INVENTORY_SUMMARY_SET_INGREDIENTS = prefix + '_SET_INGREDIENTS';

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'INVENTORY_SUPPLIER';

var INVENTORY_SUPPLIER_PAGE_REQUEST = exports.INVENTORY_SUPPLIER_PAGE_REQUEST = prefix + '_PAGE_REQUEST';

var INVENTORY_SUPPLIER_SUPPLIERS_REQUEST = exports.INVENTORY_SUPPLIER_SUPPLIERS_REQUEST = prefix + '_SUPPLIER_REQUEST';

var INVENTORY_SUPPLIER_SET_OUTLETS = exports.INVENTORY_SUPPLIER_SET_OUTLETS = prefix + '_SET_OUTLETS';

var INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD = exports.INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD = prefix + '_ON_CHANGE_KEYWORD';

var INVENTORY_SUPPLIER_SET_SUPPLIERS = exports.INVENTORY_SUPPLIER_SET_SUPPLIERS = prefix + '_SET_SUPPLIERS';

var INVENTORY_SUPPLIER_EXPORT_SUPPLIER = exports.INVENTORY_SUPPLIER_EXPORT_SUPPLIER = prefix + '_EXPORT_SUPPLIER';

var INVENTORY_SUPPLIER_SET_PROFILE = exports.INVENTORY_SUPPLIER_SET_PROFILE = prefix + '_SET_PROFILE';

var INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN = exports.INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN = prefix + '_OPEN_RIGHT_COLUMN';

var INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN = exports.INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN = prefix + '_CLOSE_RIGHT_COLUMN';

var INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER = exports.INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER = prefix + '_ASK_DELETE_SUPPLIER';

var INVENTORY_SUPPLIER_ON_CLICK_ROW = exports.INVENTORY_SUPPLIER_ON_CLICK_ROW = prefix + '_ON_CLICK_ROW';

var INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL = exports.INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL = prefix + '_SET_SUPPLIER_DETAIL';

var INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE = exports.INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE = prefix + '_SUBMIT_FORM_CREATE';

var INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE = exports.INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE = prefix + '_SUBMIT_FORM_UPDATE';

var INVENTORY_SUPPLIER_ON_CLICK_CANCEL = exports.INVENTORY_SUPPLIER_ON_CLICK_CANCEL = prefix + '_ON_CLICK_CANCEL';

var INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER = exports.INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER = prefix + '_CANCEL_DELETE_SUPPLIER';

var INVENTORY_SUPPLIER_DELETE_SUPPLIER = exports.INVENTORY_SUPPLIER_DELETE_SUPPLIER = prefix + '_DELETE_SUPPLIER';

var INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL = exports.INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL = prefix + '_OPEN_DELETE_SUPPLIER_MODAL';

var INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL = exports.INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL = prefix + '_CLOSE_DELETE_SUPPLIER_MODAL';

var INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER = exports.INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER = prefix + '_ON_CLICK_CREATE_SUPPLIER';

var INVENTORY_SUPPLIER_IS_SUBMITTING_FORM = exports.INVENTORY_SUPPLIER_IS_SUBMITTING_FORM = prefix + '_IS_SUBMITTING_FORM';

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'INVENTORY_TRANSFER';

var INVENTORY_TRANSFER_RESET_STATE = exports.INVENTORY_TRANSFER_RESET_STATE = prefix + '_RESET_STATE';
var INVENTORY_TRANSFER_PAGE_REQUEST = exports.INVENTORY_TRANSFER_PAGE_REQUEST = prefix + '_PAGE_REQUEST';
var INVENTORY_TRANSFER_SET_TRANSFERS = exports.INVENTORY_TRANSFER_SET_TRANSFERS = prefix + '_SET_TRANSFERS';
var INVENTORY_TRANSFER_SET_TRANSFER_DETAIL = exports.INVENTORY_TRANSFER_SET_TRANSFER_DETAIL = prefix + '_SET_TRANSFER_DETAIL';
var INVENTORY_TRANSFER_SET_OUTLETS = exports.INVENTORY_TRANSFER_SET_OUTLETS = prefix + '_SET_OUTLETS';
var INVENTORY_TRANSFER_SET_SELECTED_OUTLETS = exports.INVENTORY_TRANSFER_SET_SELECTED_OUTLETS = prefix + '_SET_SELECTED_OUTLETS';
var INVENTORY_TRANSFER_TRANSFERS_REQUEST = exports.INVENTORY_TRANSFER_TRANSFERS_REQUEST = prefix + '_TRANSFERS_REQUEST';
var INVENTORY_TRANSFER_SET_CURRENT_PAGE = exports.INVENTORY_TRANSFER_SET_CURRENT_PAGE = prefix + '_SET_CURRENT_PAGE';
var INVENTORY_TRANSFER_SET_TOTAL_PAGE = exports.INVENTORY_TRANSFER_SET_TOTAL_PAGE = prefix + '_SET_TOTAL_PAGE';
var INVENTORY_TRANSFER_ON_CLICK_ROW = exports.INVENTORY_TRANSFER_ON_CLICK_ROW = prefix + '_ON_CLICK_ROW';
var INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN = exports.INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN = prefix + '_OPEN_RIGHT_COLUMN';
var INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN = exports.INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN = prefix + '_CLOSE_RIGHT_COLUMN';
var INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS = exports.INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS = prefix + '_ON_CHANGE_OUTLET_IDS';
var INVENTORY_TRANSFER_ON_CHANGE_DATE = exports.INVENTORY_TRANSFER_ON_CHANGE_DATE = prefix + '_ON_CHANGE_DATE';
var INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER = exports.INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER = prefix + '_ON_CLICK_CREATE_TRANSFER';
var INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM = exports.INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM = prefix + '_ON_CLICK_ADD_ITEM';
var INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL = exports.INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL = prefix + '_CLOSE_ADD_ITEM_MODAL';
var INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL = exports.INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL = prefix + '_ON_MODAL_CLICK_CANCEL';
var INVENTORY_TRANSFER_GET_ITEMS = exports.INVENTORY_TRANSFER_GET_ITEMS = prefix + '_GET_ITEMS';
var INVENTORY_TRANSFER_SET_ADD_ITEMS = exports.INVENTORY_TRANSFER_SET_ADD_ITEMS = prefix + '_SET_ADD_ITEMS';
var INVENTORY_TRANSFER_RESET_ADD_ITEMS = exports.INVENTORY_TRANSFER_RESET_ADD_ITEMS = prefix + '_RESET_ADD_ITEMS';
var INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING = exports.INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING = prefix + '_SET_ITEMS_OPTION_IS_LOADING';
var INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE = exports.INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE = prefix + '_ON_MODAL_SELECT_CHANGE';
var INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM = exports.INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM = prefix + '_ON_MODAL_ADD_ITEM';
var INVENTORY_TRANSFER_RESET_TRANSFERS_FORM = exports.INVENTORY_TRANSFER_RESET_TRANSFERS_FORM = prefix + '_RESET_TRANSFERS_FORM';
var INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL = exports.INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL = prefix + '_SET_SHOW_CONFRIM_SUBMIT_MODAL';
var INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM = exports.INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM = prefix + '_ON_SUBMIT_CREATE_TRANSFER_FORM';
var INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER = exports.INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER = prefix + '_ON_CONFIRM_CREATE_TRANSFER';
var INVENTORY_TRANSFER_EXPORT = exports.INVENTORY_TRANSFER_EXPORT = prefix + '_EXPORT';
var INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS = exports.INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS = prefix + '_SET_EXPORT_BUTTON_STATUS';
var INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED = exports.INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED = prefix + '_SET_IS_ITEM_ALREADY_ADDED';
var INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS = exports.INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS = prefix + '_SET_CONFIRM_CREATE_BUTTON_STATUS';
var INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT = exports.INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT = prefix + '_SET_SEARCH_ITEMS_INIT';

var INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE = exports.INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE = prefix + '_ON_NAMESPACE_CHANGE';

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// category action constants
var LIBRARY_CATEGORIES_PAGE_REQUEST = exports.LIBRARY_CATEGORIES_PAGE_REQUEST = 'LIBRARY_CATEGORIES_PAGE_REQUEST';

var LIBRARY_CATEGORIES_LIST_REQUEST = exports.LIBRARY_CATEGORIES_LIST_REQUEST = 'LIBRARY_CATEGORIES_LIST_REQUEST';

var LIBRARY_CATEGORIES_SET_LIST_CATEGORIES = exports.LIBRARY_CATEGORIES_SET_LIST_CATEGORIES = 'LIBRARY_CATEGORIES_SET_LIST_CATEGORIES';

var LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS = 'LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS';

var LIBRARY_CATEGORIES_SET_OUTLETS = exports.LIBRARY_CATEGORIES_SET_OUTLETS = 'LIBRARY_CATEGORIES_SET_OUTLETS';

var LIBRARY_CATEGORIES_SET_CURRENT_PAGE = exports.LIBRARY_CATEGORIES_SET_CURRENT_PAGE = 'LIBRARY_CATEGORIES_SET_CURRENT_PAGE';

var LIBRARY_CATEGORIES_SET_TOTAL_PAGE = exports.LIBRARY_CATEGORIES_SET_TOTAL_PAGE = 'LIBRARY_CATEGORIES_SET_TOTAL_PAGE';

var LIBRARY_CATEGORIES_SET_KEYWORD = exports.LIBRARY_CATEGORIES_SET_KEYWORD = 'LIBRARY_CATEGORIES_SET_KEYWORD';

var LIBRARY_CATEGORIES_ON_CLICK_ROW = exports.LIBRARY_CATEGORIES_ON_CLICK_ROW = 'LIBRARY_CATEGORIES_ON_CLICK_ROW';

var LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL = exports.LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL = 'LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL';

var LIBRARY_CATEGORIES_ON_CLICK_CANCEL = exports.LIBRARY_CATEGORIES_ON_CLICK_CANCEL = 'LIBRARY_CATEGORIES_ON_CLICK_CANCEL';

var LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY = exports.LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY = 'LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY';

var LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE = exports.LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE = 'LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE';

var LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE = exports.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE = 'LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE';

var LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST = exports.LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST = 'LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST';

var LIBRARY_CATEGORIES_SHOW_DELETE_MODAL = exports.LIBRARY_CATEGORIES_SHOW_DELETE_MODAL = 'LIBRARY_CATEGORIES_SHOW_DELETE_MODAL';

var LIBRARY_CATEGORIES_HIDE_DELETE_MODAL = exports.LIBRARY_CATEGORIES_HIDE_DELETE_MODAL = 'LIBRARY_CATEGORIES_HIDE_DELETE_MODAL';

var LIBRARY_CATEGORIES_CANCEL_DELETE = exports.LIBRARY_CATEGORIES_CANCEL_DELETE = 'LIBRARY_CATEGORIES_CANCEL_DELETE';

var LIBRARY_CATEGORIES_DELETE_CATEGORY = exports.LIBRARY_CATEGORIES_DELETE_CATEGORY = 'LIBRARY_CATEGORIES_DELETE_CATEGORY';

var LIBRARY_CATEGORIES_SET_DELETED_CATEGORY = exports.LIBRARY_CATEGORIES_SET_DELETED_CATEGORY = 'LIBRARY_CATEGORIES_SET_DELETED_CATEGORY';

var LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS = exports.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS = 'LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS';

var LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM = exports.LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM = 'LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM';

var LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL = exports.LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL = 'LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL';

var LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL = exports.LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL = 'LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL';

var LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM = exports.LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM = 'LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM';

var LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS = exports.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS = 'LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS';

var LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE = exports.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE = 'LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE';

var LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE = exports.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE = 'LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE';

var LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST = exports.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST = 'LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST';

var LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM = exports.LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM = 'LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM';

var LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM = exports.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM = 'LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM';

var LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN = exports.LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN = 'LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN';

var LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN = exports.LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN = 'LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN';

var LIBRARY_CATEGORIES_IS_SUBMITTING_FORM = exports.LIBRARY_CATEGORIES_IS_SUBMITTING_FORM = 'LIBRARY_CATEGORIES_IS_SUBMITTING_FORM';

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'LIBRARY_DISCOUNT_';

var LIBRARY_DISCOUNT_PAGE_REQUEST = exports.LIBRARY_DISCOUNT_PAGE_REQUEST = prefix + 'PAGE_REQUEST';

var LIBRARY_DISCOUNT_SET_OUTLETS = exports.LIBRARY_DISCOUNT_SET_OUTLETS = prefix + 'SET_OUTLETS';

var LIBRARY_DISCOUNT_OUTLETS_REQUEST = exports.LIBRARY_DISCOUNT_OUTLETS_REQUEST = prefix + 'OUTLETS_REQUEST';

var LIBRARY_DISCOUNT_DISCOUNTS_REQUEST = exports.LIBRARY_DISCOUNT_DISCOUNTS_REQUEST = prefix + 'DISCOUNTS_REQUEST';

var LIBRARY_DISCOUNT_ON_CLICK_ROW = exports.LIBRARY_DISCOUNT_ON_CLICK_ROW = prefix + 'ON_CLICK_ROW';

var LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS = prefix + 'ON_CHANGE_OUTLET_IDS';

var LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT = exports.LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT = prefix + 'ON_CLICK_CREATE_DISCOUNT';

var LIBRARY_DISCOUNT_SET_DISCOUNTS = exports.LIBRARY_DISCOUNT_SET_DISCOUNTS = prefix + 'SET_DISCOUNTS';

var LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL = exports.LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL = prefix + 'SET_DISCOUNT_DETAIL';

var LIBRARY_DISCOUNT_SET_CURRENT_PAGE = exports.LIBRARY_DISCOUNT_SET_CURRENT_PAGE = prefix + 'SET_CURRENT_PAGE';

var LIBRARY_DISCOUNT_SET_TOTAL_PAGE = exports.LIBRARY_DISCOUNT_SET_TOTAL_PAGE = prefix + 'SET_TOTAL_PAGE';

var LIBRARY_DISCOUNT_UNSET_DISCOUNT = exports.LIBRARY_DISCOUNT_UNSET_DISCOUNT = prefix + 'UNSET_DISCOUNT';

var LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT = exports.LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT = prefix + 'SET_CREATE_DISCOUNT';

var LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD = exports.LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD = prefix + 'CLEAR_AMOUNT_FIELD';

var LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE = exports.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE = prefix + 'SUBMIT_FORM_CREATE';

var LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET = exports.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET = prefix + 'SUBMIT_FORM_CREATE_ALL_OUTLET';

var LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE = exports.LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE = prefix + 'SUBMIT_FORM_UPDATE';

var LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT = exports.LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT = prefix + 'ASK_DELETE_DISCOUNT';

var LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL = exports.LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL = prefix + 'SHOW_DELETE_DISCOUNT_MODAL';

var LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL = exports.LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL = prefix + 'HIDE_DELETE_DISCOUNT_MODAL';

var LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT = exports.LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT = prefix + 'SET_DELETED_DISCOUNT';

var LIBRARY_DISCOUNT_DELETE_DISCOUNT = exports.LIBRARY_DISCOUNT_DELETE_DISCOUNT = prefix + 'DELETE_DISCOUNT';

var LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT = exports.LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT = prefix + 'CANCEL_DELETE_DISCOUNT';

var LIBRARY_DISCOUNT_ON_CLICK_CANCEL = exports.LIBRARY_DISCOUNT_ON_CLICK_CANCEL = prefix + 'ON_CLICK_CANCEL';

var LIBRARY_DISCOUNT_IS_SUBMITTING_FORM = exports.LIBRARY_DISCOUNT_IS_SUBMITTING_FORM = prefix + 'IS_SUBMITTING_FORM';

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'LIBRARY_GRATUITY_';

var LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET = exports.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET = prefix + 'SUBMIT_FORM_CREATE_ALL_OUTLET';

var LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY = exports.LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY = prefix + 'CANCEL_DELETE_GRATUITY';

var LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL = exports.LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL = prefix + 'SHOW_DELETE_GRATUITY_MODAL';

var LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL = exports.LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL = prefix + 'HIDE_DELETE_GRATUITY_MODAL';

var LIBRARY_GRATUITY_ASK_DELETE_GRATUITY = exports.LIBRARY_GRATUITY_ASK_DELETE_GRATUITY = prefix + 'ASK_DELETE_GRATUITY';

var LIBRARY_GRATUITY_SET_DELETED_GRATUITY = exports.LIBRARY_GRATUITY_SET_DELETED_GRATUITY = prefix + 'SET_DELETED_GRATUITY';

var LIBRARY_GRATUITY_SUBMIT_FORM_CREATE = exports.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE = prefix + 'SUBMIT_FORM_CREATE';

var LIBRARY_GRATUITY_DELETE_GRATUITY = exports.LIBRARY_GRATUITY_DELETE_GRATUITY = prefix + 'DELETE_GRATUITY';

var LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE = exports.LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE = prefix + 'SUBMIT_FORM_UPDATE';

var LIBRARY_GRATUITY_ON_CLICK_CANCEL = exports.LIBRARY_GRATUITY_ON_CLICK_CANCEL = prefix + 'ON_CLICK_CANCEL';

var LIBRARY_GRATUITY_PAGE_REQUEST = exports.LIBRARY_GRATUITY_PAGE_REQUEST = prefix + 'PAGE_REQUEST';

var LIBRARY_GRATUITY_SET_OUTLETS = exports.LIBRARY_GRATUITY_SET_OUTLETS = prefix + 'SET_OUTLETS';

var LIBRARY_GRATUITY_OUTLETS_REQUEST = exports.LIBRARY_GRATUITY_OUTLETS_REQUEST = prefix + 'OUTLETS_REQUEST';

var LIBRARY_GRATUITY_GRATUITIES_REQUEST = exports.LIBRARY_GRATUITY_GRATUITIES_REQUEST = prefix + 'GRATUITIES_REQUEST';

var LIBRARY_GRATUITY_ON_CLICK_ROW = exports.LIBRARY_GRATUITY_ON_CLICK_ROW = prefix + 'ON_CLICK_ROW';

var LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS = prefix + 'ON_CHANGE_OUTLET_IDS';

var LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY = exports.LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY = prefix + 'ON_CLICK_CREATE_GRATUITY';

var LIBRARY_GRATUITY_SET_GRATUITIES = exports.LIBRARY_GRATUITY_SET_GRATUITIES = prefix + 'SET_GRATUITIES';

var LIBRARY_GRATUITY_SET_GRATUITY_DETAIL = exports.LIBRARY_GRATUITY_SET_GRATUITY_DETAIL = prefix + 'SET_GRATUITY_DETAIL';

var LIBRARY_GRATUITY_SET_CURRENT_PAGE = exports.LIBRARY_GRATUITY_SET_CURRENT_PAGE = prefix + 'SET_CURRENT_PAGE';

var LIBRARY_GRATUITY_SET_TOTAL_PAGE = exports.LIBRARY_GRATUITY_SET_TOTAL_PAGE = prefix + 'SET_TOTAL_PAGE';

var LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN = exports.LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN = prefix + 'OPEN_RIGHT_COLUMN';

var LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN = exports.LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN = prefix + 'CLOSE_RIGHT_COLUMN';

var LIBRARY_GRATUITY_IS_SUBMITTING_FORM = exports.LIBRARY_GRATUITY_IS_SUBMITTING_FORM = prefix + 'IS_SUBMITTING_FORM';

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIBRARY_ITEM_PAGE_REQUEST = exports.LIBRARY_ITEM_PAGE_REQUEST = 'LIBRARY_ITEM_PAGE_REQUEST';
var LIBRARY_ITEM_LIST_ITEM_REQUEST = exports.LIBRARY_ITEM_LIST_ITEM_REQUEST = 'LIBRARY_ITEM_LIST_ITEM_REQUEST';
var LIBRARY_ITEM_LIST_CATEGORY_REQUEST = exports.LIBRARY_ITEM_LIST_CATEGORY_REQUEST = 'LIBRARY_ITEM_LIST_CATEGORY_REQUEST';
var LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST = exports.LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST = 'LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST';
var LIBRARY_ITEM_ITEM_SUMMARY_REQUEST = exports.LIBRARY_ITEM_ITEM_SUMMARY_REQUEST = 'LIBRARY_ITEM_ITEM_SUMMARY_REQUEST';
var LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN = exports.LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN = 'LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN';
var LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN = exports.LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN = 'LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN';
var LIBRARY_ITEM_SET_CATEGORY_LIST = exports.LIBRARY_ITEM_SET_CATEGORY_LIST = 'LIBRARY_ITEM_SET_CATEGORY_LIST';
var LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID = exports.LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID = 'LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID';
var LIBRARY_ITEM_SET_ITEM_LIST = exports.LIBRARY_ITEM_SET_ITEM_LIST = 'LIBRARY_ITEM_SET_ITEM_LIST';
var LIBRARY_ITEM_SET_CURRENT_ITEM_ID = exports.LIBRARY_ITEM_SET_CURRENT_ITEM_ID = 'LIBRARY_ITEM_SET_CURRENT_ITEM_ID';
var LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID = exports.LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID = 'LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID';
var LIBRARY_ITEM_SET_ITEM_SUMMARY = exports.LIBRARY_ITEM_SET_ITEM_SUMMARY = 'LIBRARY_ITEM_SET_ITEM_SUMMARY';
var LIBRARY_ITEM_SET_OUTLETS = exports.LIBRARY_ITEM_SET_OUTLETS = 'LIBRARY_ITEM_SET_OUTLETS';
var LIBRARY_ITEM_SET_FILTER_STATE = exports.LIBRARY_ITEM_SET_FILTER_STATE = 'LIBRARY_ITEM_SET_FILTER_STATE';
var LIBRARY_ITEM_SET_FILTER_ITEM = exports.LIBRARY_ITEM_SET_FILTER_ITEM = 'LIBRARY_ITEM_SET_FILTER_ITEM';
var LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS = 'LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS';
var LIBRARY_ITEM_SET_CURRENT_PAGE = exports.LIBRARY_ITEM_SET_CURRENT_PAGE = 'LIBRARY_ITEM_SET_CURRENT_PAGE';
var LIBRARY_ITEM_SET_TOTAL_PAGE = exports.LIBRARY_ITEM_SET_TOTAL_PAGE = 'LIBRARY_ITEM_SET_TOTAL_PAGE';
var LIBRARY_ITEM_ITEMS_REQUEST = exports.LIBRARY_ITEM_ITEMS_REQUEST = 'LIBRARY_ITEM_ITEMS_REQUEST';
var LIBRARY_ITEM_UNSET_FILTER_STATE = exports.LIBRARY_ITEM_UNSET_FILTER_STATE = 'LIBRARY_ITEM_UNSET_FILTER_STATE';
var LIBRARY_ITEM_ITEM_LIST_EXPORT = exports.LIBRARY_ITEM_ITEM_LIST_EXPORT = 'LIBRARY_ITEM_ITEM_LIST_EXPORT';
var LIBRARY_ITEM_SET_TYPE_IMPORT = exports.LIBRARY_ITEM_SET_TYPE_IMPORT = 'LIBRARY_ITEM_SET_TYPE_IMPORT';
var LIBRARY_ITEM_SHOW_SECTION_UPLOADER = exports.LIBRARY_ITEM_SHOW_SECTION_UPLOADER = 'LIBRARY_ITEM_SHOW_SECTION_UPLOADER';
var LIBRARY_ITEM_ITEM_LIST_TEMPLATE = exports.LIBRARY_ITEM_ITEM_LIST_TEMPLATE = 'LIBRARY_ITEM_ITEM_LIST_TEMPLATE';
var LIBRARY_ITEM_OPEN_RIGHT_COLUMN = exports.LIBRARY_ITEM_OPEN_RIGHT_COLUMN = 'LIBRARY_ITEM_OPEN_RIGHT_COLUMN';
var LIBRARY_ITEM_CLOSE_RIGHT_COLUMN = exports.LIBRARY_ITEM_CLOSE_RIGHT_COLUMN = 'LIBRARY_ITEM_CLOSE_RIGHT_COLUMN';
var LIBRARY_ITEM_ON_CLICK_CREATE_ITEM = exports.LIBRARY_ITEM_ON_CLICK_CREATE_ITEM = 'LIBRARY_ITEM_ON_CLICK_CREATE_ITEM';
var LIBRARY_ITEM_SET_ITEM_DETAIL = exports.LIBRARY_ITEM_SET_ITEM_DETAIL = 'LIBRARY_ITEM_SET_ITEM_DETAIL';
var LIBRARY_ITEM_ON_CLICK_CANCEL = exports.LIBRARY_ITEM_ON_CLICK_CANCEL = 'LIBRARY_ITEM_ON_CLICK_CANCEL';
var LIBRARY_ITEM_ON_CLICK_ROW = exports.LIBRARY_ITEM_ON_CLICK_ROW = 'LIBRARY_ITEM_ON_CLICK_ROW';
var LIBRARY_ITEM_ON_DROP_IMAGE = exports.LIBRARY_ITEM_ON_DROP_IMAGE = 'LIBRARY_ITEM_ON_DROP_IMAGE';
var LIBRARY_ITEM_ON_DELETE_IMAGE = exports.LIBRARY_ITEM_ON_DELETE_IMAGE = 'LIBRARY_ITEM_ON_DELETE_IMAGE';
var LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT = exports.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT = 'LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT';
var LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL = exports.LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL = 'LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL';
var LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL = exports.LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL = 'LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL';
var LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM = exports.LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM = 'LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM';
var LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL = exports.LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL = 'LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL';
var LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL = exports.LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL = 'LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL';
var LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL = exports.LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL = 'LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL';
var LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL = exports.LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL = 'LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL';
var LIBRARY_ITEM_SHOW_COGS_MODAL = exports.LIBRARY_ITEM_SHOW_COGS_MODAL = 'LIBRARY_ITEM_SHOW_COGS_MODAL';
var LIBRARY_ITEM_HIDE_COGS_MODAL = exports.LIBRARY_ITEM_HIDE_COGS_MODAL = 'LIBRARY_ITEM_HIDE_COGS_MODAL';
var LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING = exports.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING = 'LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING';
var LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING = exports.LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING = 'LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING';
var LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL = exports.LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL = 'LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL';
var LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL = exports.LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL = 'LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL';
var LIBRARY_ITEM_ON_CANCEL_COGS_MODAL = exports.LIBRARY_ITEM_ON_CANCEL_COGS_MODAL = 'LIBRARY_ITEM_ON_CANCEL_COGS_MODAL';
var LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL = exports.LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL = 'LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL';
var LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM = exports.LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM = 'LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM';
var LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM = exports.LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM = 'LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM';
var LIBRARY_ITEM_SET_MODIFIERS = exports.LIBRARY_ITEM_SET_MODIFIERS = 'LIBRARY_ITEM_SET_MODIFIERS';
var LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS = exports.LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS = 'LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS';
var LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY = exports.LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY = 'LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY';
var LIBRARY_ITEM_SUBMIT_FORM_CREATE = exports.LIBRARY_ITEM_SUBMIT_FORM_CREATE = 'LIBRARY_ITEM_SUBMIT_FORM_CREATE';
var LIBRARY_ITEM_SUBMIT_FORM_UPDATE = exports.LIBRARY_ITEM_SUBMIT_FORM_UPDATE = 'LIBRARY_ITEM_SUBMIT_FORM_UPDATE';
var LIBRARY_ITEM_SHOW_DELETE_MODAL = exports.LIBRARY_ITEM_SHOW_DELETE_MODAL = 'LIBRARY_ITEM_SHOW_DELETE_MODAL';
var LIBRARY_ITEM_HIDE_DELETE_MODAL = exports.LIBRARY_ITEM_HIDE_DELETE_MODAL = 'LIBRARY_ITEM_HIDE_DELETE_MODAL';
var LIBRARY_ITEM_DELETE_ITEM = exports.LIBRARY_ITEM_DELETE_ITEM = 'LIBRARY_ITEM_DELETE_ITEM';
var LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY = exports.LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY = 'LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY';
var LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL = exports.LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL = 'LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL';
var LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL = exports.LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL = 'LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL';
var LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY = exports.LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY = 'LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY';
var LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY = exports.LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY = 'LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY';
var LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES = exports.LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES = 'LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES';
var LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID = exports.LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID = 'LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID';
var LIBRARY_ITEM_SET_NEW_CATEGORY = exports.LIBRARY_ITEM_SET_NEW_CATEGORY = 'LIBRARY_ITEM_SET_NEW_CATEGORY';
var LIBRARY_ITEM_SHOW_IMPORT_MODAL = exports.LIBRARY_ITEM_SHOW_IMPORT_MODAL = 'LIBRARY_ITEM_SHOW_IMPORT_MODAL';
var LIBRARY_ITEM_HIDE_IMPORT_MODAL = exports.LIBRARY_ITEM_HIDE_IMPORT_MODAL = 'LIBRARY_ITEM_HIDE_IMPORT_MODAL';
var LIBRARY_ITEM_ON_SUCCESS_IMPORT = exports.LIBRARY_ITEM_ON_SUCCESS_IMPORT = 'LIBRARY_ITEM_ON_SUCCESS_IMPORT';
var LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = exports.LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = 'LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';
var LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = exports.LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = 'LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';
var LIBRARY_ITEM_SET_MUST_SCROLL_TOP = exports.LIBRARY_ITEM_SET_MUST_SCROLL_TOP = 'LIBRARY_ITEM_SET_MUST_SCROLL_TOP';
var LIBRARY_ITEM_SET_IS_SUBMITTING_FORM = exports.LIBRARY_ITEM_SET_IS_SUBMITTING_FORM = 'LIBRARY_ITEM_SET_IS_SUBMITTING_FORM';
var LIBRARY_ITEM_SET_TAXES = exports.LIBRARY_ITEM_SET_TAXES = 'LIBRARY_ITEM_SET_TAXES';

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'LIBRARY_MODIFIER_';

var LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET = exports.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET = prefix + 'SUBMIT_FORM_CREATE_ALL_OUTLET';

var LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER = exports.LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER = prefix + 'CANCEL_DELETE_MODIFIER';

var LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL = exports.LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL = prefix + 'SHOW_DELETE_MODIFIER_MODAL';

var LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL = exports.LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL = prefix + 'HIDE_DELETE_MODIFIER_MODAL';

var LIBRARY_MODIFIER_ASK_DELETE_MODIFIER = exports.LIBRARY_MODIFIER_ASK_DELETE_MODIFIER = prefix + 'ASK_DELETE_MODIFIER';

var LIBRARY_MODIFIER_SET_DELETED_MODIFIER = exports.LIBRARY_MODIFIER_SET_DELETED_MODIFIER = prefix + 'SET_DELETED_MODIFIER';

var LIBRARY_MODIFIER_SUBMIT_FORM_CREATE = exports.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE = prefix + 'SUBMIT_FORM_CREATE';

var LIBRARY_MODIFIER_DELETE_MODIFIER = exports.LIBRARY_MODIFIER_DELETE_MODIFIER = prefix + 'DELETE_MODIFIER';

var LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE = exports.LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE = prefix + 'SUBMIT_FORM_UPDATE';

var LIBRARY_MODIFIER_ON_CLICK_CANCEL = exports.LIBRARY_MODIFIER_ON_CLICK_CANCEL = prefix + 'ON_CLICK_CANCEL';

var LIBRARY_MODIFIER_PAGE_REQUEST = exports.LIBRARY_MODIFIER_PAGE_REQUEST = prefix + 'PAGE_REQUEST';

var LIBRARY_MODIFIER_SET_OUTLETS = exports.LIBRARY_MODIFIER_SET_OUTLETS = prefix + 'SET_OUTLETS';

var LIBRARY_MODIFIER_OUTLETS_REQUEST = exports.LIBRARY_MODIFIER_OUTLETS_REQUEST = prefix + 'OUTLETS_REQUEST';

var LIBRARY_MODIFIER_MODIFIERS_REQUEST = exports.LIBRARY_MODIFIER_MODIFIERS_REQUEST = prefix + 'MODIFIERS_REQUEST';

var LIBRARY_MODIFIER_ON_CLICK_ROW = exports.LIBRARY_MODIFIER_ON_CLICK_ROW = prefix + 'ON_CLICK_ROW';

var LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS = prefix + 'ON_CHANGE_OUTLET_IDS';

var LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER = exports.LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER = prefix + 'ON_CLICK_CREATE_MODIFIER';

var LIBRARY_MODIFIER_SET_MODIFIERS = exports.LIBRARY_MODIFIER_SET_MODIFIERS = prefix + 'SET_MODIFIERS';

var LIBRARY_MODIFIER_SET_MODIFIER_DETAIL = exports.LIBRARY_MODIFIER_SET_MODIFIER_DETAIL = prefix + 'SET_MODIFIER_DETAIL';

var LIBRARY_MODIFIER_SET_CURRENT_PAGE = exports.LIBRARY_MODIFIER_SET_CURRENT_PAGE = prefix + 'SET_CURRENT_PAGE';

var LIBRARY_MODIFIER_SET_TOTAL_PAGE = exports.LIBRARY_MODIFIER_SET_TOTAL_PAGE = prefix + 'SET_TOTAL_PAGE';

var LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM = exports.LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM = prefix + '_ON_CLICK_APPLY_SET_ITEM';

var LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL = exports.LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL = prefix + '_SHOW_APPLY_SET_ITEM_MODAL';

var LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL = exports.LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL = prefix + '_HIDE_APPLY_SET_ITEM_MODAL';

var LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM = exports.LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM = prefix + '_CANCEL_APPLY_SET_ITEM';

var LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM = exports.LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM = prefix + '_CONFIRM_APPLY_SET_ITEM';

var LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS = exports.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS = prefix + '_APPLY_SET_ITEM_SET_ITEMS';

var LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE = exports.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE = prefix + '_APPLY_SET_ITEM_SET_CURRENT_PAGE';

var LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE = exports.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE = prefix + '_APPLY_SET_ITEM_SET_TOTAL_PAGE';

var LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM = exports.LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM = prefix + '_APPLY_SET_ITEM_FILL_FORM';

var LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST = exports.LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST = prefix + '_APPLY_SET_ITEM_ITEMS_REQUEST';

var LIBRARY_MODIFIER_FILL_MODIFIER_FORM = exports.LIBRARY_MODIFIER_FILL_MODIFIER_FORM = prefix + '_FILL_MODIFIER_FORM_FLOW';

var LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL = exports.LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL = prefix + '_SHOW_MODIFIER_OPTIONS_MODAL';

var LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL = exports.LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL = prefix + '_HIDE_MODIFIER_OPTIONS_MODAL';

var LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS = exports.LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS = prefix + '_ON_CLICK_MANAGE_MODIFIER_OPTIONS';

var LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS = exports.LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS = prefix + '_ON_CANCEL_MANAGE_MODIFIER_OPTIONS';

var LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS = exports.LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS = prefix + '_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS';

var LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM = exports.LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM = prefix + '_EMPTY_MODIFIER_FORM';

var LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM = exports.LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM = prefix + '_SET_PREVIOUS_MODIFIER_FORM';

var LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN = exports.LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN = prefix + 'OPEN_RIGHT_COLUMN';

var LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN = exports.LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN = prefix + 'CLOSE_RIGHT_COLUMN';

var LIBRARY_MODIFIER_IS_SUBMITTING_FORM = exports.LIBRARY_MODIFIER_IS_SUBMITTING_FORM = prefix + 'IS_SUBMITTING_FORM';

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Tax action constants
var LIBRARY_TAXES_PAGE_REQUEST = exports.LIBRARY_TAXES_PAGE_REQUEST = 'LIBRARY_TAXES_PAGE_REQUEST';

var LIBRARY_TAXES_LIST_REQUEST = exports.LIBRARY_TAXES_LIST_REQUEST = 'LIBRARY_TAXES_LIST_REQUEST';

var LIBRARY_TAXES_SET_LIST_TAXES = exports.LIBRARY_TAXES_SET_LIST_TAXES = 'LIBRARY_TAXES_SET_LIST_TAXES';

var LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS = exports.LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS = 'LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS';

var LIBRARY_TAXES_SET_OUTLETS = exports.LIBRARY_TAXES_SET_OUTLETS = 'LIBRARY_TAXES_SET_OUTLETS';

var LIBRARY_TAXES_ON_CLICK_CREATE_TAX = exports.LIBRARY_TAXES_ON_CLICK_CREATE_TAX = 'LIBRARY_TAXES_ON_CLICK_CREATE_TAX';

var LIBRARY_TAXES_SET_CURRENT_PAGE = exports.LIBRARY_TAXES_SET_CURRENT_PAGE = 'LIBRARY_TAXES_SET_CURRENT_PAGE';

var LIBRARY_TAXES_SET_TOTAL_PAGE = exports.LIBRARY_TAXES_SET_TOTAL_PAGE = 'LIBRARY_TAXES_SET_TOTAL_PAGE';

var LIBRARY_TAXES_ON_CLICK_ROW = exports.LIBRARY_TAXES_ON_CLICK_ROW = 'LIBRARY_TAXES_ON_CLICK_ROW';

var LIBRARY_TAXES_SET_TAX_DETAIL = exports.LIBRARY_TAXES_SET_TAX_DETAIL = 'LIBRARY_TAXES_SET_TAX_DETAIL';

var LIBRARY_TAXES_ON_CLICK_CANCEL = exports.LIBRARY_TAXES_ON_CLICK_CANCEL = 'LIBRARY_TAXES_ON_CLICK_CANCEL';

var LIBRARY_TAXES_SUBMIT_FORM_UPDATE = exports.LIBRARY_TAXES_SUBMIT_FORM_UPDATE = 'LIBRARY_TAXES_SUBMIT_FORM_UPDATE';

var LIBRARY_TAXES_SUBMIT_FORM_CREATE = exports.LIBRARY_TAXES_SUBMIT_FORM_CREATE = 'LIBRARY_TAXES_SUBMIT_FORM_CREATE';

var LIBRARY_TAXES_DELETE_TAX_REQUEST = exports.LIBRARY_TAXES_DELETE_TAX_REQUEST = 'LIBRARY_TAXES_DELETE_TAX_REQUEST';

var LIBRARY_TAXES_SHOW_DELETE_MODAL = exports.LIBRARY_TAXES_SHOW_DELETE_MODAL = 'LIBRARY_TAXES_SHOW_DELETE_MODAL';

var LIBRARY_TAXES_HIDE_DELETE_MODAL = exports.LIBRARY_TAXES_HIDE_DELETE_MODAL = 'LIBRARY_TAXES_HIDE_DELETE_MODAL';

var LIBRARY_TAXES_CANCEL_DELETE = exports.LIBRARY_TAXES_CANCEL_DELETE = 'LIBRARY_TAXES_CANCEL_DELETE';

var LIBRARY_TAXES_DELETE_TAX = exports.LIBRARY_TAXES_DELETE_TAX = 'LIBRARY_TAXES_DELETE_TAX';

var LIBRARY_TAXES_SET_DELETED_TAX = exports.LIBRARY_TAXES_SET_DELETED_TAX = 'LIBRARY_TAXES_SET_DELETED_TAX';

var LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS = exports.LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS = 'LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS';

var LIBRARY_TAXES_OPEN_RIGHT_COLUMN = exports.LIBRARY_TAXES_OPEN_RIGHT_COLUMN = 'LIBRARY_TAXES_OPEN_RIGHT_COLUMN';

var LIBRARY_TAXES_CLOSE_RIGHT_COLUMN = exports.LIBRARY_TAXES_CLOSE_RIGHT_COLUMN = 'LIBRARY_TAXES_CLOSE_RIGHT_COLUMN';

var LIBRARY_TAXES_IS_SUBMITTING_FORM = exports.LIBRARY_TAXES_IS_SUBMITTING_FORM = 'LIBRARY_TAXES_IS_SUBMITTING_FORM';

var LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL = exports.LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL = 'LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL';

var LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL = exports.LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL = 'LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL';

var LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM = exports.LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM = 'LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST';

var LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM = exports.LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM = 'LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM';

var LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM = exports.LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM = 'LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM';

var LIBRARY_TAXES_SET_CATEGORY_LIST = exports.LIBRARY_TAXES_SET_CATEGORY_LIST = 'LIBRARY_TAXES_SET_CATEGORY_LIST';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE';

var LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE = exports.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE = 'LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE';

var LIBRARY_TAXES_SET_SETTING = exports.LIBRARY_TAXES_SET_SETTING = 'LIBRARY_TAXES_SET_SETTING';

var LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = exports.LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = 'LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';

var LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = exports.LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = 'LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';

var LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS = exports.LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS = 'LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS';

var LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS = exports.LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS = 'LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS';

var LIBRARY_TAXES_SET_CREATED_OUTLETS = exports.LIBRARY_TAXES_SET_CREATED_OUTLETS = 'LIBRARY_TAXES_SET_CREATED_OUTLETS';

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOTIFICATION_SUCCESS = exports.NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
var NOTIFICATION_WARNING = exports.NOTIFICATION_WARNING = 'NOTIFICATION_WARNING';
var NOTIFICATION_ERROR = exports.NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
var NOTIFICATION_RESET = exports.NOTIFICATION_RESET = 'NOTIFICATION_RESET';
var NOTIFICATION_CLICKED = exports.NOTIFICATION_CLICKED = 'NOTIFICATION_CLICKED';

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_OUTLETS = exports.SET_OUTLETS = 'SET_OUTLETS';
var SET_CURRENT_OUTLET = exports.SET_CURRENT_OUTLET = 'CURRENT_OUTLET';
var GET_CURRENT_OUTLET_REQUEST = exports.GET_CURRENT_OUTLET_REQUEST = 'GET_CURRENT_OUTLET_REQUEST';
var OUTLETS_REQUEST = exports.OUTLETS_REQUEST = 'OUTLET_REQUEST';

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OUTLET_PAGE_LIST_PAGE_REQUEST = exports.OUTLET_PAGE_LIST_PAGE_REQUEST = 'OUTLET_PAGE_LIST_PAGE_REQUEST';

var OUTLET_PAGE_LIST_SET_PROFILE = exports.OUTLET_PAGE_LIST_SET_PROFILE = 'OUTLET_PAGE_LIST_SET_PROFILE';

var OUTLET_PAGE_LIST_SET_OUTLETS = exports.OUTLET_PAGE_LIST_SET_OUTLETS = 'OUTLET_PAGE_LIST_SET_OUTLETS';

var OUTLET_PAGE_LIST_SET_OUTLET_DETAIL = exports.OUTLET_PAGE_LIST_SET_OUTLET_DETAIL = 'OUTLET_PAGE_LIST_SET_OUTLET_DETAIL';

var OUTLET_PAGE_LIST_CLICK_OUTLET_ROW = exports.OUTLET_PAGE_LIST_CLICK_OUTLET_ROW = 'OUTLET_PAGE_LIST_CLICK_OUTLET_ROW';

var OUTLET_PAGE_LIST_CLICK_CANCEL = exports.OUTLET_PAGE_LIST_CLICK_CANCEL = 'OUTLET_PAGE_LIST_CLICK_CANCEL';

var OUTLET_PAGE_LIST_SEARCH = exports.OUTLET_PAGE_LIST_SEARCH = 'OUTLET_PAGE_LIST_SEARCH';

var OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET = exports.OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET = 'OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET';

var OUTLET_PAGE_LIST_CLICK_ADD_OUTLET = exports.OUTLET_PAGE_LIST_CLICK_ADD_OUTLET = 'OUTLET_PAGE_LIST_CLICK_ADD_OUTLET';

var OUTLET_PAGE_LIST_SET_OUTLET_SLOTS = exports.OUTLET_PAGE_LIST_SET_OUTLET_SLOTS = 'OUTLET_PAGE_LIST_SET_OUTLET_SLOTS';

var OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS = exports.OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS = 'OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS';

var OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE = exports.OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE = 'OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE';

var OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE = exports.OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE = 'OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE';

var OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET = exports.OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET = 'OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET';

var OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET = exports.OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET = 'OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET';

var OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET = exports.OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET = 'OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET';

var OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET = exports.OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET = 'OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET';

var OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL = exports.OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL = 'OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL';

var OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL = exports.OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL = 'OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL';

var OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN = exports.OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN = 'OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN';

var OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN = exports.OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN = 'OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN';

var OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL = exports.OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL = 'OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL';

var OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL = exports.OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL = 'OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL';

var OUTLET_PAGE_LIST_GET_OUTLET_PRICE = exports.OUTLET_PAGE_LIST_GET_OUTLET_PRICE = 'OUTLET_PAGE_LIST_GET_OUTLET_PRICE';

var OUTLET_PAGE_LIST_SET_OUTLET_PRICE = exports.OUTLET_PAGE_LIST_SET_OUTLET_PRICE = 'OUTLET_PAGE_LIST_SET_OUTLET_PRICE';

var OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS = exports.OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS = 'OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS';

var OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS = exports.OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS = 'OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS';

var OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA = exports.OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA = 'OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA';

var OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON = exports.OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON = 'OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON';

var OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON = exports.OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON = 'OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON';

var OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE = exports.OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE = 'OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE';

var OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = exports.OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = 'OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';

var OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = exports.OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = 'OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';

var OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE = exports.OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE = 'OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE';

var OUTLET_PAGE_LIST_GET_BILLING = exports.OUTLET_PAGE_LIST_GET_BILLING = 'OUTLET_PAGE_LIST_GET_BILLING';

var OUTLET_PAGE_LIST_SET_ON_LOADING = exports.OUTLET_PAGE_LIST_SET_ON_LOADING = 'OUTLET_PAGE_LIST_SET_ON_LOADING';

var OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON = exports.OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON = 'OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON';

var OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY = exports.OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY = 'OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY';

var OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY = exports.OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY = 'OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY';

var OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY = exports.OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY = 'OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY';

var OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY = exports.OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY = 'OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY';

var OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL = exports.OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL = 'OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL';

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Invoices action constants

var REPORTS_INVOICES_PAGE_REQUEST = exports.REPORTS_INVOICES_PAGE_REQUEST = 'REPORTS_INVOICES_PAGE_REQUEST';
var REPORTS_INVOICES_LIST_INVOICE_REQUEST = exports.REPORTS_INVOICES_LIST_INVOICE_REQUEST = 'REPORTS_INVOICES_LIST_INVOICE_REQUEST';
var REPORTS_INVOICES_SET_LIST_INVOICE = exports.REPORTS_INVOICES_SET_LIST_INVOICE = 'REPORTS_INVOICES_SET_LIST_INVOICE';

// Filter invoices constants
var REPORTS_INVOICES_CHANGE_DATE = exports.REPORTS_INVOICES_CHANGE_DATE = 'REPORTS_INVOICES_CHANGE_DATE';
var REPORTS_INVOICES_CHANGE_OUTLET = exports.REPORTS_INVOICES_CHANGE_OUTLET = 'REPORTS_INVOICES_CHANGE_OUTLET';
var REPORTS_INVOICES_CHANGE_STATUS = exports.REPORTS_INVOICES_CHANGE_STATUS = 'REPORTS_INVOICES_CHANGE_STATUS';

// Receipt invoices constants
var REPORTS_INVOICES_RECEIPT_REQUEST = exports.REPORTS_INVOICES_RECEIPT_REQUEST = 'REPORTS_INVOICES_RECEIPT_REQUEST';
var REPORTS_INVOICES_SET_RECEIPT = exports.REPORTS_INVOICES_SET_RECEIPT = 'REPORTS_INVOICES_SET_RECEIPT';

// Hide invoice receipt constants
var REPORTS_INVOICES_HIDE_RECEIPT = exports.REPORTS_INVOICES_HIDE_RECEIPT = 'REPORTS_INVOICES_HIDE_RECEIPT';

var REPORTS_INVOICES_RESEND_EMAIL = exports.REPORTS_INVOICES_RESEND_EMAIL = 'REPORTS_INVOICES_RESEND_EMAIL';
// Record payment action constants
var REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT = exports.REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT = 'REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT';
var REPORTS_INVOICES_RECORD_PAYMENT_REQUEST = exports.REPORTS_INVOICES_RECORD_PAYMENT_REQUEST = 'REPORTS_INVOICES_RECORD_PAYMENT_REQUEST';
var REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL = exports.REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL = 'REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL';
var REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL = exports.REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL = 'REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL';

var REPORTS_INVOICES_PRINT_RECEIPT_PDF = exports.REPORTS_INVOICES_PRINT_RECEIPT_PDF = 'REPORTS_INVOICES_PRINT_RECEIPT_PDF';

var REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL = exports.REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL';
var REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL = exports.REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL';
var REPORTS_INVOICES_ISSUE_REFUND_REQUEST = exports.REPORTS_INVOICES_ISSUE_REFUND_REQUEST = 'REPORTS_INVOICES_ISSUE_REFUND_REQUEST';

var REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL = exports.REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL';
var REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL = exports.REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL = 'REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL';
var REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST = exports.REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST = 'REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST';

var REPORTS_INVOICES_EXPORT_INVOICES = exports.REPORTS_INVOICES_EXPORT_INVOICES = 'REPORTS_INVOICES_EXPORT_INVOICES';

var REPORTS_INVOICES_SET_OUTLETS = exports.REPORTS_INVOICES_SET_OUTLETS = 'REPORTS_INVOICES_SET_OUTLETS';
var REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT = exports.REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT = 'REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT';
var REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT = exports.REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT = 'REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT';

var REPORTS_INVOICES_SET_CURRENT_PAGE = exports.REPORTS_INVOICES_SET_CURRENT_PAGE = 'REPORTS_INVOICES_SET_CURRENT_PAGE';
var REPORTS_INVOICES_SET_TOTAL_PAGE = exports.REPORTS_INVOICES_SET_TOTAL_PAGE = 'REPORTS_INVOICES_SET_TOTAL_PAGE';

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_CONST = 'REPORTS_SALES';

// Sales Summary constants
var REPORTS_SALES_PAGE_REQUEST = exports.REPORTS_SALES_PAGE_REQUEST = BASE_CONST + '_PAGE_REQUEST';
var REPORTS_SALES_SUMMARY_REQUEST = exports.REPORTS_SALES_SUMMARY_REQUEST = BASE_CONST + '_SUMMARY_REQUEST';
var REPORTS_SET_LIST_SALES_SUMMARY = exports.REPORTS_SET_LIST_SALES_SUMMARY = 'REPORTS_SET_LIST_SALES_SUMMARY';
var REPORTS_SALES_EXPORT_SUMMARY = exports.REPORTS_SALES_EXPORT_SUMMARY = BASE_CONST + '_EXPORT_SUMMARY';

// Sales Summary constants
var REPORTS_GROSS_PROFIT_PAGE_REQUEST = exports.REPORTS_GROSS_PROFIT_PAGE_REQUEST = 'REPORTS_GROSS_PROFIT_PAGE_REQUEST';
var REPORTS_GROSS_PROFIT_REQUEST = exports.REPORTS_GROSS_PROFIT_REQUEST = 'REPORTS_GROSS_PROFIT_REQUEST';
var REPORTS_SET_LIST_GROSS_PROFIT = exports.REPORTS_SET_LIST_GROSS_PROFIT = 'REPORTS_SET_LIST_GROSS_PROFIT';
var REPORTS_SALES_EXPORT_GROSS_PROFIT = exports.REPORTS_SALES_EXPORT_GROSS_PROFIT = BASE_CONST + '_GROSS_PROFIT';

// Payment Methods constants
var REPORTS_PAYMENT_METHODS_PAGE_REQUEST = exports.REPORTS_PAYMENT_METHODS_PAGE_REQUEST = 'REPORTS_PAYMENT_METHODS_PAGE_REQUEST';
var REPORTS_PAYMENT_METHODS_REQUEST = exports.REPORTS_PAYMENT_METHODS_REQUEST = 'REPORTS_PAYMENT_METHODS_REQUEST';
var REPORTS_SET_PAYMENT_METHODS = exports.REPORTS_SET_PAYMENT_METHODS = 'REPORTS_SET_PAYMENT_METHODS';
var REPORTS_SALES_EXPORT_PAYMENT_METHODS = exports.REPORTS_SALES_EXPORT_PAYMENT_METHODS = BASE_CONST + '_EXPORT_PAYMENT_METHODS';

// Item Sales constants
var REPORTS_ITEM_SALES_PAGE_REQUEST = exports.REPORTS_ITEM_SALES_PAGE_REQUEST = 'REPORTS_ITEM_SALES_PAGE_REQUEST';
var REPORTS_ITEM_SALES_REQUEST = exports.REPORTS_ITEM_SALES_REQUEST = 'REPORTS_ITEM_SALES_REQUEST';
var REPORTS_SET_ITEM_SALES = exports.REPORTS_SET_ITEM_SALES = 'REPORTS_SET_ITEM_SALES';
var REPORTS_SALES_EXPORT_ITEM_SALES = exports.REPORTS_SALES_EXPORT_ITEM_SALES = BASE_CONST + '_EXPORT_ITEM_SALES';

// Category sales constants
var REPORTS_CATEGORY_SALES_PAGE_REQUEST = exports.REPORTS_CATEGORY_SALES_PAGE_REQUEST = 'REPORTS_CATEGORY_SALES_PAGE_REQUEST';
var REPORTS_CATEGORY_SALES_REQUEST = exports.REPORTS_CATEGORY_SALES_REQUEST = 'REPORTS_CATEGORY_SALES_REQUEST';
var REPORTS_SET_CATEGORY_SALES = exports.REPORTS_SET_CATEGORY_SALES = 'REPORTS_SET_CATEGORY_SALES';
var REPORTS_SALES_EXPORT_CATEGORY_SALES = exports.REPORTS_SALES_EXPORT_CATEGORY_SALES = BASE_CONST + '_EXPORT_CATEGORY_SALES';

// Modifier sales constants
var REPORTS_MODIFIER_SALES_PAGE_REQUEST = exports.REPORTS_MODIFIER_SALES_PAGE_REQUEST = 'REPORTS_MODIFIER_SALES_PAGE_REQUEST';
var REPORTS_MODIFIER_SALES_REQUEST = exports.REPORTS_MODIFIER_SALES_REQUEST = 'REPORTS_MODIFIER_SALES_REQUEST';
var REPORTS_SET_MODIFIER_SALES = exports.REPORTS_SET_MODIFIER_SALES = 'REPORTS_SET_MODIFIER_SALES';
var REPORTS_SALES_EXPORT_MODIFIER_SALES = exports.REPORTS_SALES_EXPORT_MODIFIER_SALES = BASE_CONST + '_EXPORT_MODIFIER_SALES';

// Discounts constants
var REPORTS_DISCOUNTS_PAGE_REQUEST = exports.REPORTS_DISCOUNTS_PAGE_REQUEST = 'REPORTS_DISCOUNTS_PAGE_REQUEST';
var REPORTS_DISCOUNTS_REQUEST = exports.REPORTS_DISCOUNTS_REQUEST = 'REPORTS_DISCOUNTS_REQUEST';
var REPORTS_SET_DISCOUNTS = exports.REPORTS_SET_DISCOUNTS = 'REPORTS_SET_DISCOUNTS';
var REPORTS_SALES_EXPORT_DISCOUNTS = exports.REPORTS_SALES_EXPORT_DISCOUNTS = BASE_CONST + '_EXPORT_DISCOUNTS';

// Taxes constants
var REPORTS_TAXES_PAGE_REQUEST = exports.REPORTS_TAXES_PAGE_REQUEST = 'REPORTS_TAXES_PAGE_REQUEST';
var REPORTS_TAXES_REQUEST = exports.REPORTS_TAXES_REQUEST = 'REPORTS_TAXES_REQUEST';
var REPORTS_SET_TAXES = exports.REPORTS_SET_TAXES = 'REPORTS_SET_TAXES';
var REPORTS_SALES_EXPORT_TAXES = exports.REPORTS_SALES_EXPORT_TAXES = BASE_CONST + '_EXPORT_TAXES';

// Gratuity constants
var REPORTS_GRATUITY_PAGE_REQUEST = exports.REPORTS_GRATUITY_PAGE_REQUEST = 'REPORTS_GRATUITY_PAGE_REQUEST';
var REPORTS_GRATUITY_REQUEST = exports.REPORTS_GRATUITY_REQUEST = 'REPORTS_GRATUITY_REQUEST';
var REPORTS_SET_GRATUITY = exports.REPORTS_SET_GRATUITY = 'REPORTS_SET_GRATUITY';
var REPORTS_SALES_EXPORT_GRATUITY = exports.REPORTS_SALES_EXPORT_GRATUITY = BASE_CONST + '_EXPORT_GRATUITY';

// Collected By constants
var REPORTS_COLLECTEDBY_PAGE_REQUEST = exports.REPORTS_COLLECTEDBY_PAGE_REQUEST = 'REPORTS_COLLECTEDBY_PAGE_REQUEST';
var REPORTS_COLLECTEDBY_REQUEST = exports.REPORTS_COLLECTEDBY_REQUEST = 'REPORTS_COLLECTEDBY_REQUEST';
var REPORTS_SET_COLLECTEDBY = exports.REPORTS_SET_COLLECTEDBY = 'REPORTS_SET_COLLECTEDBY';
var REPORTS_SALES_EXPORT_COLECTEDBY = exports.REPORTS_SALES_EXPORT_COLECTEDBY = BASE_CONST + '_EXPORT_COLECTEDBY';

// Served By constants
var REPORTS_SERVEDBY_PAGE_REQUEST = exports.REPORTS_SERVEDBY_PAGE_REQUEST = 'REPORTS_SERVEDBY_PAGE_REQUEST';
var REPORTS_SERVEDBY_REQUEST = exports.REPORTS_SERVEDBY_REQUEST = 'REPORTS_SERVEDBY_REQUEST';
var REPORTS_SET_SERVEDBY = exports.REPORTS_SET_SERVEDBY = 'REPORTS_SET_SERVEDBY';
var REPORTS_SALES_EXPORT_SERVEDBY = exports.REPORTS_SALES_EXPORT_SERVEDBY = BASE_CONST + '_EXPORT_SERVEDBY';

// Filter by date constants
var REPORTS_SALES_SUMMARY_CHANGE_DATE = exports.REPORTS_SALES_SUMMARY_CHANGE_DATE = BASE_CONST + '_SUMMARY_CHANGE_DATE';
var REPORTS_SALES_SUMMARY_SET_START_END_DATE = exports.REPORTS_SALES_SUMMARY_SET_START_END_DATE = BASE_CONST + '_SUMMARY_SET_START_END_DATE';

var REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE = exports.REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE = BASE_CONST + '_GROSS_PROFIT_CHANGE_DATE';
var REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE = exports.REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE = BASE_CONST + '_GROSS_PROFIT_SET_START_END_DATE';

var REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE = exports.REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE = BASE_CONST + '_PAYMENT_METHODS_CHANGE_DATE';
var REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE = exports.REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE = BASE_CONST + '_PAYMENT_METHODS_SET_START_END_DATE';

var REPORTS_SALES_ITEM_SALES_CHANGE_DATE = exports.REPORTS_SALES_ITEM_SALES_CHANGE_DATE = BASE_CONST + '_ITEM_SALES_CHANGE_DATE';
var REPORTS_SALES_ITEM_SALES_SET_START_END_DATE = exports.REPORTS_SALES_ITEM_SALES_SET_START_END_DATE = BASE_CONST + '_ITEM_SALES_SET_START_END_DATE';

var REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE = exports.REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE = BASE_CONST + '_CATEGORY_SALES_CHANGE_DATE';
var REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE = exports.REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE = BASE_CONST + '_CATEGORY_SALES_SET_START_END_DATE';

var REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE = exports.REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE = BASE_CONST + '_MODIFIER_SALES_CHANGE_DATE';
var REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE = exports.REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE = BASE_CONST + '_MODIFIER_SALES_SET_START_END_DATE';

var REPORTS_SALES_DISCOUNTS_CHANGE_DATE = exports.REPORTS_SALES_DISCOUNTS_CHANGE_DATE = BASE_CONST + '_DISCOUNTS_CHANGE_DATE';
var REPORTS_SALES_DISCOUNTS_SET_START_END_DATE = exports.REPORTS_SALES_DISCOUNTS_SET_START_END_DATE = BASE_CONST + '_DISCOUNTS_SET_START_END_DATE';

var REPORTS_SALES_TAXES_CHANGE_DATE = exports.REPORTS_SALES_TAXES_CHANGE_DATE = BASE_CONST + '_TAXES_CHANGE_DATE';
var REPORTS_SALES_TAXES_SET_START_END_DATE = exports.REPORTS_SALES_TAXES_SET_START_END_DATE = BASE_CONST + '_TAXES_SET_START_END_DATE';

var REPORTS_SALES_GRATUITY_CHANGE_DATE = exports.REPORTS_SALES_GRATUITY_CHANGE_DATE = BASE_CONST + '_GRATUITY_CHANGE_DATE';
var REPORTS_SALES_GRATUITY_SET_START_END_DATE = exports.REPORTS_SALES_GRATUITY_SET_START_END_DATE = BASE_CONST + '_GRATUITY_SET_START_END_DATE';

var REPORTS_SALES_COLLECTEDBY_CHANGE_DATE = exports.REPORTS_SALES_COLLECTEDBY_CHANGE_DATE = BASE_CONST + '_COLLECTEDBY_CHANGE_DATE';
var REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE = exports.REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE = BASE_CONST + '_COLLECTEDBY_SET_START_END_DATE';

var REPORTS_SALES_SERVEDBY_CHANGE_DATE = exports.REPORTS_SALES_SERVEDBY_CHANGE_DATE = BASE_CONST + '_SERVEDBY_CHANGE_DATE';
var REPORTS_SALES_SERVEDBY_SET_START_END_DATE = exports.REPORTS_SALES_SERVEDBY_SET_START_END_DATE = BASE_CONST + '_SERVEDBY_SET_START_END_DATE';

// Filter by outlet constants
var REPORTS_SALES_SUMMARY_CHANGE_OUTLET = exports.REPORTS_SALES_SUMMARY_CHANGE_OUTLET = BASE_CONST + '_SUMMARY_CHANGE_OUTLET';
var REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET = exports.REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET = BASE_CONST + '_GROSS_PROFIT_CHANGE_OUTLET';
var REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET = exports.REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET = BASE_CONST + '_PAYMENT_METHODS_CHANGE_OUTLET';
var REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET = exports.REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET = BASE_CONST + '_ITEM_SALES_CHANGE_OUTLET';
var REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET = exports.REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET = BASE_CONST + '_CATEGORY_SALES_CHANGE_OUTLET';
var REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET = exports.REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET = BASE_CONST + '_MODIFIER_SALES_CHANGE_OUTLET';
var REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET = exports.REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET = BASE_CONST + '_DISCOUNTS_CHANGE_OUTLET';
var REPORTS_SALES_TAXES_CHANGE_OUTLET = exports.REPORTS_SALES_TAXES_CHANGE_OUTLET = BASE_CONST + '_TAXES_CHANGE_OUTLET';
var REPORTS_SALES_GRATUITY_CHANGE_OUTLET = exports.REPORTS_SALES_GRATUITY_CHANGE_OUTLET = BASE_CONST + '_GRATUITY_CHANGE_OUTLET';
var REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET = exports.REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET = BASE_CONST + '_COLLECTEDBY_CHANGE_OUTLET';
var REPORTS_SALES_SERVEDBY_CHANGE_OUTLET = exports.REPORTS_SALES_SERVEDBY_CHANGE_OUTLET = BASE_CONST + '_SERVEDBY_CHANGE_OUTLET';

var REPORTS_SALES_SET_OUTLETS = exports.REPORTS_SALES_SET_OUTLETS = BASE_CONST + '_SET_OUTLETS';

var REPORTS_SALES_SHOW_LOADING_SPINNER = exports.REPORTS_SALES_SHOW_LOADING_SPINNER = BASE_CONST + '_SHOW_LOADING_SPINNER';

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/****************************************
 * Request/API Call Constants
 ****************************************/
var REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST = exports.REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST = 'REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST';
var REPORTS_SHIFTS_LIST_SHIFT_REQUEST = exports.REPORTS_SHIFTS_LIST_SHIFT_REQUEST = 'REPORTS_SHIFTS_LIST_SHIFT_REQUEST';
var REPORTS_SHIFTS_PAGE_REQUEST = exports.REPORTS_SHIFTS_PAGE_REQUEST = 'REPORTS_SHIFTS_PAGE_REQUEST';
var REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST = exports.REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST = 'REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST';
var REPORTS_SHIFTS_DETAILS_REQUEST = exports.REPORTS_SHIFTS_DETAILS_REQUEST = 'REPORTS_SHIFTS_DETAILS_REQUEST';
var REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA = exports.REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA = 'REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA';

/****************************************
 * On Change handler
 ****************************************/
var REPORTS_SHIFTS_CHANGE_DATE = exports.REPORTS_SHIFTS_CHANGE_DATE = 'REPORTS_SHIFTS_CHANGE_DATE';
var REPORTS_SHIFTS_CHANGE_OUTLET = exports.REPORTS_SHIFTS_CHANGE_OUTLET = 'REPORTS_SHIFTS_CHANGE_OUTLET';
var REPORTS_SHIFTS_SET_CURRENT_PAGE = exports.REPORTS_SHIFTS_SET_CURRENT_PAGE = 'REPORTS_SHIFTS_SET_CURRENT_PAGE';

/****************************************
 * Setter
 ****************************************/
var REPORTS_SHIFTS_SET_SHIFT_SUMMARY = exports.REPORTS_SHIFTS_SET_SHIFT_SUMMARY = 'REPORTS_SHIFTS_SET_SHIFT_SUMMARY';
var REPORTS_SHIFTS_SET_LIST_SHIFT = exports.REPORTS_SHIFTS_SET_LIST_SHIFT = 'REPORTS_SHIFTS_SET_LIST_SHIFT';
var REPORTS_SHIFTS_SET_START_END_DATE = exports.REPORTS_SHIFTS_SET_START_END_DATE = 'REPORTS_SHIFTS_SET_START_END_DATE';
var REPORTS_SHIFTS_SET_SHIFT_DETAILS = exports.REPORTS_SHIFTS_SET_SHIFT_DETAILS = 'REPORTS_SHIFTS_SET_SHIFT_DETAILS';
var REPORTS_SHIFTS_SET_OUTLETS = exports.REPORTS_SHIFTS_SET_OUTLETS = 'REPORTS_SHIFTS_SET_OUTLETS';
var REPORTS_SHIFTS_DETAIL_HIDE = exports.REPORTS_SHIFTS_DETAIL_HIDE = 'REPORTS_SHIFTS_DETAIL_HIDE';

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiftSummaryRequest = shiftSummaryRequest;
exports.listShiftRequest = listShiftRequest;
exports.pageRequest = pageRequest;
exports.shiftSummaryLoadMoreData = shiftSummaryLoadMoreData;
exports.exportShiftRequest = exportShiftRequest;
exports.shiftDetailsRequest = shiftDetailsRequest;
exports.hideShiftDetail = hideShiftDetail;
exports.changeDate = changeDate;
exports.changeOutletShift = changeOutletShift;
exports.setCurrentPage = setCurrentPage;
exports.setShifts = setShifts;
exports.setSummary = setSummary;
exports.setStartEndDate = setStartEndDate;
exports.setShiftDetails = setShiftDetails;
exports.setOutlets = setOutlets;

var _constants = __webpack_require__(416);

/****************************************
 * Request
 ****************************************/

function shiftSummaryRequest(query) {
  return { type: _constants.REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST, payload: { query: query } };
}

function listShiftRequest(query) {
  return { type: _constants.REPORTS_SHIFTS_LIST_SHIFT_REQUEST, payload: { query: query } };
}

function pageRequest() {
  return { type: _constants.REPORTS_SHIFTS_PAGE_REQUEST, payload: {} };
}

function shiftSummaryLoadMoreData(query, previousShift) {
  return { type: _constants.REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA, payload: { query: query, previousShift: previousShift } };
}

/**
 *
 * @param {start,end} query
 * @param {string} filename to be matched against get profile
 * @param {int} outletId the exported outlet id. If you select 'all outlet', then specify the first outlet
 * @return {{type, payload: {query: *, filename: *}}}
 */
function exportShiftRequest(query, filename, outletId) {
  return { type: _constants.REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST, payload: { query: query, filename: filename, outletId: outletId } };
}

function shiftDetailsRequest(query, isMobile) {
  return { type: _constants.REPORTS_SHIFTS_DETAILS_REQUEST, payload: { query: query, isMobile: isMobile } };
}

function hideShiftDetail(isMobile) {
  return { type: _constants.REPORTS_SHIFTS_DETAIL_HIDE, payload: { isMobile: isMobile } };
}

/****************************************
 * Change handler
 ****************************************/
function changeDate(startDate, endDate, isMobile) {
  return { type: _constants.REPORTS_SHIFTS_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, isMobile: isMobile } };
}

function changeOutletShift(outletIds, startDate, endDate, isMobile) {
  return { type: _constants.REPORTS_SHIFTS_CHANGE_OUTLET, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, isMobile: isMobile } };
}

function setCurrentPage(page) {
  return { type: _constants.REPORTS_SHIFTS_SET_CURRENT_PAGE, payload: { page: page } };
}

/****************************************
 * Setter of items
 ****************************************/

function setShifts(shifts) {
  return { type: _constants.REPORTS_SHIFTS_SET_LIST_SHIFT, payload: { shifts: shifts } };
}

function setSummary(summary) {
  return { type: _constants.REPORTS_SHIFTS_SET_SHIFT_SUMMARY, payload: { summary: summary } };
}

function setStartEndDate(startDate, endDate) {
  return { type: _constants.REPORTS_SHIFTS_SET_START_END_DATE, payload: { startDate: startDate, endDate: endDate } };
}

function setShiftDetails(shiftDetails) {
  return { type: _constants.REPORTS_SHIFTS_SET_SHIFT_DETAILS, payload: { shiftDetails: shiftDetails } };
}

function setOutlets(outlets) {
  return { type: _constants.REPORTS_SHIFTS_SET_OUTLETS, payload: { outlets: outlets } };
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_CONST = 'REPORTS_TRANSACTIONS';

/********************************************************************************
 * Transactions related
 ********************************************************************************/

var REPORTS_TRANSACTIONS_PAGE_REQUEST = exports.REPORTS_TRANSACTIONS_PAGE_REQUEST = BASE_CONST + '_PAGE_REQUEST';
var REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST = exports.REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST = BASE_CONST + '_TRANSACTIONS_REQUEST';
var REPORTS_TRANSACTIONS_SET_TRANSACTIONS = exports.REPORTS_TRANSACTIONS_SET_TRANSACTIONS = BASE_CONST + '_SET_TRANSACTIONS';

/********************************************************************************
 * End transactions related
 ********************************************************************************/

/********************************************************************************
 * Change Related
 ********************************************************************************/
var REPORTS_TRANSACTIONS_CHANGE_OUTLET = exports.REPORTS_TRANSACTIONS_CHANGE_OUTLET = BASE_CONST + '_CHANGE_OUTLET';
var REPORTS_TRANSACTIONS_CHANGE_DATE = exports.REPORTS_TRANSACTIONS_CHANGE_DATE = BASE_CONST + '_CHANGE_DATE';
var REPORTS_TRANSACTIONS_CHANGE_KEYWORD = exports.REPORTS_TRANSACTIONS_CHANGE_KEYWORD = BASE_CONST + '_CHANGE_KEYWORD';
/********************************************************************************
 * End Change Related
 ********************************************************************************/

/********************************************************************************
 * Transaction Detail Related
 ********************************************************************************/
var REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL = exports.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL = BASE_CONST + '_HIDE_TRANSACTION_DETAIL';
var REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL = exports.REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL = BASE_CONST + '_SET_TRANSACTION_DETAIL';
var REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE = exports.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE = BASE_CONST + '_TRANSACTION_DETAIL_REQUEST_NON_MOBILE';
var REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE = exports.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE = BASE_CONST + '_TRANSACTION_DETAIL_REQUEST_MOBILE';
var REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL = exports.REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL = BASE_CONST + '_SHOW_TRANSACTION_DETAIL_MODAL';
var REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL = exports.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL = BASE_CONST + '_HIDE_TRANSACTION_DETAIL_MODAL';

/********************************************************************************
 * Resend Email Related
 ********************************************************************************/
var REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT = exports.REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT = BASE_CONST + '_SEND_EMAIL_RECEIPT';
var REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL = exports.REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL = BASE_CONST + '_SHOW_RESEND_EMAIL_MODAL';
var REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL = exports.REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL = BASE_CONST + '_HIDE_RESEND_EMAIL_MODAL';
var REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL = exports.REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL = BASE_CONST + '_CANCEL_RESEND_EMAIL';
/********************************************************************************
 * End Resend Email Related
 ********************************************************************************/

/********************************************************************************
 * Refund Breakdown Modal Related
 ********************************************************************************/
var REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL = exports.REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL = BASE_CONST + '_SHOW_REFUND_BREAKDOWN_MODAL';
var REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL = exports.REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL = BASE_CONST + '_HIDE_REFUND_BREAKDOWN_MODAL';

var REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS = exports.REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS = BASE_CONST + '_REFUND_BREAKDOWN_SET_REFUND_ITEMS';

var REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST = exports.REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST = BASE_CONST + '_REFUND_BREAKDOWN_ISSUE_REFUND_REQUEST';

var REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL = exports.REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL = BASE_CONST + '_SHOW_SET_QUANTITY_MODAL';

var REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL = exports.REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL = BASE_CONST + '_HIDE_SET_QUANTITY_MODAL';

var REPORTS_TRANSACTIONS_ASK_SET_QUANTITY = exports.REPORTS_TRANSACTIONS_ASK_SET_QUANTITY = BASE_CONST + '_ASK_SET_QUANTITY';

var REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY = exports.REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY = BASE_CONST + '_CONFIRM_SET_QUANTITY';

var REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY = exports.REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY = BASE_CONST + '_CANCEL_SET_QUANTITY';

/********************************************************************************
 * End Refund Breakdown Modal Related
 ********************************************************************************/

/********************************************************************************
 * Old Refund Modal Related
 ********************************************************************************/
var REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL = exports.REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL = BASE_CONST + '_SHOW_OLD_REFUND_MODAL';
var REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL = exports.REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL = BASE_CONST + '_HIDE_OLD_REFUND_MODAL';

var REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST = exports.REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST = BASE_CONST + '_ISSUE_OLD_REFUND_ISSUE_REQUEST';

/********************************************************************************
 * End Old Refund Modal Related
 ********************************************************************************/

/********************************************************************************
 * Export Transaction Related
 ********************************************************************************/

var REPORTS_TRANSACTIONS_EXPORT_TRANSACTION = exports.REPORTS_TRANSACTIONS_EXPORT_TRANSACTION = BASE_CONST + '_EXPORT_TRANSACTION';

/********************************************************************************
 * End Export Transaction Related
 ********************************************************************************/

var REPORTS_TRANSACTIONS_SET_OUTLETS = exports.REPORTS_TRANSACTIONS_SET_OUTLETS = BASE_CONST + '_SET_OUTLETS';

var REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN = exports.REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN = BASE_CONST + '_CANCEL_REFUND_BREAKDOWN';

var REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER = exports.REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER = BASE_CONST + '_SHOW_LOADING_SPINNER';

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by alvinoktavianus on 5/9/17.
 */

var SETTING_BILLING_BILLINGS = exports.SETTING_BILLING_BILLINGS = 'SETTING_BILLING_BILLINGS';
var SETTING_BILLING_PAGE_REQUEST = exports.SETTING_BILLING_PAGE_REQUEST = 'SETTING_BILLING_PAGE_REQUEST';
var SETTING_BILLING_SET_BILLINGS = exports.SETTING_BILLING_SET_BILLINGS = 'SETTING_BILLING_SET_BILLINGS';
var SETTING_BILLING_SET_OUTLETS = exports.SETTING_BILLING_SET_OUTLETS = 'SETTING_BILLING_SET_OUTLETS';
var SETTING_BILLING_SET_RULES = exports.SETTING_BILLING_SET_RULES = 'SETTING_BILLING_SET_RULES';
var SETTING_BILLING_SET_SUBSCRIPTION_STATUS = exports.SETTING_BILLING_SET_SUBSCRIPTION_STATUS = 'SETTING_BILLING_SET_SUBSCRIPTION_STATUS';
var SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES = exports.SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES = 'SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES';
var SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES = exports.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES = 'SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES';
var SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES = exports.SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES = 'SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES';
var SETTING_BILLING_PAY_MOKA_SUBSCRIPTION = exports.SETTING_BILLING_PAY_MOKA_SUBSCRIPTION = 'SETTING_BILLING_PAY_MOKA_SUBSCRIPTION';
var SETTING_BILLING_IS_CLICKED_BUTTON_PAY = exports.SETTING_BILLING_IS_CLICKED_BUTTON_PAY = 'SETTING_BILLING_IS_CLICKED_BUTTON_PAY';
var SETTING_BILLING_PAY_BUTTON_MESSAGE = exports.SETTING_BILLING_PAY_BUTTON_MESSAGE = 'SETTING_BILLING_PAY_BUTTON_MESSAGE';
var SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = exports.SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = 'SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';
var SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = exports.SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = 'SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';
var SETTING_BILLING_SET_TOTAL_BILLING_PRICE = exports.SETTING_BILLING_SET_TOTAL_BILLING_PRICE = 'SETTING_BILLING_SET_TOTAL_BILLING_PRICE';
var SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE = exports.SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE = 'SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE';
var SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE = exports.SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE = 'SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE';
var SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME = exports.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME = 'SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME';
var SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION = exports.SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION = 'SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION';
var SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL = exports.SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL = 'SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
var SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL = exports.SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL = 'SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
var SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL = exports.SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL = 'SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
var SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL = exports.SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL = 'SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL';
var SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE = exports.SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE = 'SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE';
var SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE = exports.SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE = 'SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE';
var SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION = exports.SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION = 'SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION';
var SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE = exports.SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE = 'SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE';
var SETTING_BILLING_ON_CLICK_TURN_BUTTON = exports.SETTING_BILLING_ON_CLICK_TURN_BUTTON = 'SETTING_BILLING_ON_CLICK_TURN_BUTTON';
var SETTING_BILLING_SET_IS_DELETED_OUTLET = exports.SETTING_BILLING_SET_IS_DELETED_OUTLET = 'SETTING_BILLING_SET_IS_DELETED_OUTLET';

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SETTING_CHECKOUT_PAGE_REQUEST = exports.SETTING_CHECKOUT_PAGE_REQUEST = 'SETTING_CHECKOUT_PAGE_REQUEST';
var SETTING_CHECKOUT_UPDATE_SETTING = exports.SETTING_CHECKOUT_UPDATE_SETTING = 'SETTING_CHECKOUT_UPDATE_SETTING';
var SETTING_CHECKOUT_SET_SETTING = exports.SETTING_CHECKOUT_SET_SETTING = 'SETTING_CHECKOUT_SET_SETTING';

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'SETTING_EMAIL_';

var SETTING_EMAIL_PAGE_REQUEST = exports.SETTING_EMAIL_PAGE_REQUEST = prefix + 'PAGE_REQUEST';

var SETTING_EMAIL_SUBMIT_FORM = exports.SETTING_EMAIL_SUBMIT_FORM = prefix + 'SUBMIT_FORM';

var SETTING_EMAIL_SET_PROFILE = exports.SETTING_EMAIL_SET_PROFILE = prefix + 'SET_PROFILE';

var SETTING_EMAIL_SHOW_RECIPIENT_MODAL = exports.SETTING_EMAIL_SHOW_RECIPIENT_MODAL = prefix + 'SHOW_RECIPIENT_MODAL';

var SETTING_EMAIL_HIDE_RECIPIENT_MODAL = exports.SETTING_EMAIL_HIDE_RECIPIENT_MODAL = prefix + 'HIDE_RECIPIENT_MODAL';

var SETTING_EMAIL_CHANGE_PAGE = exports.SETTING_EMAIL_CHANGE_PAGE = prefix + 'CHANGE_PAGE';

var SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS = exports.SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS = prefix + 'ON_CANCEL_MANAGE_RECIPIENTS';

var SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS = exports.SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS = prefix + 'ON_CLICK_MANAGE_RECIPIENTS';

var SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM = exports.SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM = prefix + 'SET_PREVIOUS_EMAIL_NOTIFICATION_FORM';

var SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS = exports.SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS = prefix + 'ON_CONFIRM_MANAGE_RECIPIENTS';

var SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS = exports.SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS = prefix + 'SHOW_SETTING_ALERT_RECIPIENTS_ERRORS';

var SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS = exports.SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS = prefix + 'HIDE_SETTING_ALERT_RECIPIENTS_ERRORS';

var SETTING_EMAIL_ON_CLICK_DELETE_ICON = exports.SETTING_EMAIL_ON_CLICK_DELETE_ICON = prefix + 'ON_CLICK_DELETE_ICON';

var SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL = exports.SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL = prefix + 'SHOW_DELETE_RECIPIENT_MODAL';

var SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL = exports.SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL = prefix + 'HIDE_DELETE_RECIPIENT_MODAL';

var SETTING_EMAIL_CANCEL_DELETE_RECIPIENT = exports.SETTING_EMAIL_CANCEL_DELETE_RECIPIENT = prefix + 'CANCEL_DELETE_RECIPIENT';

var SETTING_EMAIL_DELETE_RECIPIENT = exports.SETTING_EMAIL_DELETE_RECIPIENT = prefix + 'DELETE_RECIPIENT';

var SETTING_EMAIL_SET_DELETED_RECIPIENT = exports.SETTING_EMAIL_SET_DELETED_RECIPIENT = prefix + 'SET_DELETED_RECIPIENT';

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'SETTING_RECEIPT_';

var SETTING_RECEIPT_SET_PROFILE = exports.SETTING_RECEIPT_SET_PROFILE = prefix + 'SET_PROFILE';
var SETTING_RECEIPT_PAGE_REQUEST = exports.SETTING_RECEIPT_PAGE_REQUEST = prefix + 'PAGE_REQUEST';
var SETTING_RECEIPT_CHANGE_OUTLET = exports.SETTING_RECEIPT_CHANGE_OUTLET = prefix + 'CHANGE_OUTLET';
var SETTING_RECEIPT_CHANGE_OUTLET_NAME = exports.SETTING_RECEIPT_CHANGE_OUTLET_NAME = prefix + 'CHANGE_OUTLET_NAME';
var SETTING_RECEIPT_SUBMIT_FORM = exports.SETTING_RECEIPT_SUBMIT_FORM = prefix + 'SUBMIT_FORM';

var SETTING_RECEIPT_CHANGE_PAGE = exports.SETTING_RECEIPT_CHANGE_PAGE = prefix + 'CHANGE_PAGE';
var SETTING_RECEIPT_SET_OUTLETS = exports.SETTING_RECEIPT_SET_OUTLETS = prefix + 'SET_OUTLETS';

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = submitForm;
exports.changeOutlet = changeOutlet;
exports.changeOutletName = changeOutletName;
exports.pageRequest = pageRequest;
exports.setProfile = setProfile;
exports.changePage = changePage;
exports.setOutlets = setOutlets;

var _constants = __webpack_require__(422);

/**
 * @param {int} outletId
 * @param {object} data
 * @param {object} query
 * @return {{type, payload: {outletId: *, data: *, query: *}}}
 */
function submitForm(outletId, data, query) {
  return { type: _constants.SETTING_RECEIPT_SUBMIT_FORM, payload: { outletId: outletId, data: data, query: query } };
}

/**
 * @param {array} outletIds
 * @return {{type, payload: {outletIds: *}}}
 */
function changeOutlet(outletIds) {
  return { type: _constants.SETTING_RECEIPT_CHANGE_OUTLET, payload: { outletIds: outletIds } };
}

/**
 * @param {string} name new name of outlet
 * @param {array} outlets
 * @param {object} currentProfile profile get from /profile api
 */
function changeOutletName(name, outlets, currentProfile) {
  return { type: _constants.SETTING_RECEIPT_CHANGE_OUTLET_NAME, payload: { name: name, outlets: outlets, currentProfile: currentProfile } };
}

/**
 * @return {{type, payload: {}}}
 */
function pageRequest() {
  return { type: _constants.SETTING_RECEIPT_PAGE_REQUEST, payload: {} };
}

function setProfile(profile) {
  return { type: _constants.SETTING_RECEIPT_SET_PROFILE, payload: { profile: profile } };
}

function changePage(nextLocation) {
  return { type: _constants.SETTING_RECEIPT_CHANGE_PAGE, payload: { nextLocation: nextLocation } };
}

function setOutlets(outlets) {
  return { type: _constants.SETTING_RECEIPT_SET_OUTLETS, payload: { outlets: outlets } };
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'SUBSCRIPTION_EXPIRED';

var SUBSCRIPTION_EXPIRED_SHOW_MODAL = exports.SUBSCRIPTION_EXPIRED_SHOW_MODAL = PREFIX + '_SHOW_MODAL';

var SUBSCRIPTION_EXPIRED_HIDE_MODAL = exports.SUBSCRIPTION_EXPIRED_HIDE_MODAL = PREFIX + '_HIDE_MODAL';

var IS_SUBSCRIPTION_EXPIRED = exports.IS_SUBSCRIPTION_EXPIRED = 'IS_SUBSCRIPTION_EXPIRED';

var ASK_SHOW_SUBSCRIPTION_EXPIRED = exports.ASK_SHOW_SUBSCRIPTION_EXPIRED = 'ASK_SHOW_SUBSCRIPTION_EXPIRED';

var SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION = exports.SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION = PREFIX + '_SET_NEXT_ACTION';

var SUBSCRIPTION_EXPIRED_CLOSE_MODAL = exports.SUBSCRIPTION_EXPIRED_CLOSE_MODAL = PREFIX + '_CLOSE_MODAL';

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Upload Image action constants
var DO_IMPORT_CUSTOMER = exports.DO_IMPORT_CUSTOMER = 'DO_IMPORT_CUSTOMER';
var SHOW_MODAL_IMPORT = exports.SHOW_MODAL_IMPORT = 'SHOW_MODAL_IMPORT';
var HIDE_MODAL_IMPORT = exports.HIDE_MODAL_IMPORT = 'HIDE_MODAL_IMPORT';
var SHOW_MODAL_ERROR_IMPORT = exports.SHOW_MODAL_ERROR_IMPORT = 'SHOW_MODAL_ERROR_IMPORT';
var HIDE_MODAL_ERROR_IMPORT = exports.HIDE_MODAL_ERROR_IMPORT = 'HIDE_MODAL_ERROR_IMPORT';
var SET_IMPORTING_STATUS = exports.SET_IMPORTING_STATUS = 'SET_IMPORTING_STATUS';
var DO_IMPORT_ITEM = exports.DO_IMPORT_ITEM = 'DO_IMPORT_ITEM';

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEND_VERIFY_EMAIL = exports.SEND_VERIFY_EMAIL = 'SEND_VERIFY_EMAIL';

var VERIFY_EMAIL_INVALID_TOKEN = exports.VERIFY_EMAIL_INVALID_TOKEN = 'VERIFY_EMAIL_INVALID_TOKEN';

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEND_VERIFY_EMAIL_ALERT_RECIPIENT = exports.SEND_VERIFY_EMAIL_ALERT_RECIPIENT = 'SEND_VERIFY_EMAIL_ALERT_RECIPIENT';

var VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN = exports.VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN = 'VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN';

var SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT = exports.SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT = 'SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT';

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getBillings = getBillings;
exports.getOutlets = getOutlets;
exports.getRules = getRules;
exports.getSubscriptionStatus = getSubscriptionStatus;
exports.verifyBilling = verifyBilling;
exports.getFeatureSubscriptionPrice = getFeatureSubscriptionPrice;
exports.cancelSubscription = cancelSubscription;
exports.getAllOutlets = getAllOutlets;

var _constant = __webpack_require__(1058);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBillings(params) {
  return axios.get(_constant.BILLINGS, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
} /**
   * Created by alvinoktavianus on 5/9/17.
   */

function getOutlets(params) {
  return axios.get(_constant.OUTLETS, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getRules(params) {
  return axios.get(_constant.RULES, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getSubscriptionStatus(params) {
  return axios.post(_constant.SUBSCRIPTION_STATUS, null, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function verifyBilling(params) {
  return axios.post(_constant.VERIFY_BILLING, params, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    return _promise2.default.reject(error.response);
  });
}

function getFeatureSubscriptionPrice() {
  return axios.post(_constant.FEATURE_SUBSCRIPTION_PRICE, null, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function cancelSubscription(params) {
  return axios.put(_constant.CANCEL_SUBSCRIPTION, params, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getAllOutlets() {
  return axios.get(_constant.ALL_OUTLETS, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCategories = getCategories;
exports.getCategoriesV1 = getCategoriesV1;
exports.getCategoryDetail = getCategoryDetail;
exports.categoryRequestWithKeywordAndType = categoryRequestWithKeywordAndType;
exports.updateCategory = updateCategory;
exports.createCategory = createCategory;
exports.createCategoryAllOutlets = createCategoryAllOutlets;
exports.deleteCategory = deleteCategory;
exports.assignToItem = assignToItem;
exports.getCategoriesWithUncategorizedV1 = getCategoriesWithUncategorizedV1;

var _constants = __webpack_require__(1063);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/categories_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */

function getCategories(params) {
  return axios.get(_constants.LIBRARY_CATEGORIES, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function getCategoriesV1(params) {
  return axios.get(_constants.LIBRARY_CATEGORIES_V1, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

/**
 * https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/categories_controller.rb#L88
 * @param id
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getCategoryDetail(id, params) {
  return axios.get((0, _constants.V1_CATEGORY_BY_ID)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function categoryRequestWithKeywordAndType(params) {
  return axios.get(_constants.LIBRARY_CATEGORIES_V1, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function updateCategory(id, data, params) {
  return axios.put((0, _constants.V1_CATEGORY_BY_ID)(id), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data = error.response.data;
      if (_data.errors) {
        errorObj = new Error(_data.errors);
      } else if (_data.message) {
        errorObj = new Error(_data.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}

function createCategory(data, params) {
  return axios.post(_constants.LIBRARY_CATEGORIES_V1, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data2 = error.response.data;
      if (_data2.errors) {
        errorObj = new Error(_data2.errors);
      } else if (_data2.message) {
        errorObj = new Error(_data2.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}

function createCategoryAllOutlets(data, params) {
  return axios.post(_constants.CATEGORY_ALL_OUTLETS, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data3 = error.response.data;
      if (_data3.errors) {
        errorObj = new Error(_data3.errors);
      } else if (_data3.message) {
        errorObj = new Error(_data3.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}

function deleteCategory(id, params) {
  return axios.delete((0, _constants.V1_CATEGORY_BY_ID)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}

function assignToItem(id, data, params) {
  return axios.put((0, _constants.ASSIGN_TO_ITEM)(id), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data4 = error.response.data;
      if (_data4.errors) {
        errorObj = new Error(_data4.errors);
      } else if (_data4.message) {
        errorObj = new Error(_data4.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}

function getCategoriesWithUncategorizedV1(params) {
  return axios.get(_constants.V1_CATEGORIES_WITH_UNCATEGORIZED, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
      return _promise2.default.reject(errorObj);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT_ADJUSTMENT = exports.V1_EXPORT_SUPPLIER = exports.V1_ADJUSTMENTS = exports.V1_EXPORT_SUMMARY = exports.V1_SUPPLIER = exports.V1_SUPPLIER_BY_ID = exports.V1_SUMMARY = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/ingredients_inventory';

var V1_SUMMARY = exports.V1_SUMMARY = V1_URL + '/summary';

var V1_SUPPLIER_BY_ID = exports.V1_SUPPLIER_BY_ID = function V1_SUPPLIER_BY_ID(id) {
  return V1_URL + '/suppliers/' + id;
};

var V1_SUPPLIER = exports.V1_SUPPLIER = V1_URL + '/suppliers';

var V1_EXPORT_SUMMARY = exports.V1_EXPORT_SUMMARY = V1_URL + '/summary/export';

var V1_ADJUSTMENTS = exports.V1_ADJUSTMENTS = V1_URL + '/adjustment';

var V1_EXPORT_SUPPLIER = exports.V1_EXPORT_SUPPLIER = V1_URL + '/suppliers/export';

var V1_EXPORT_ADJUSTMENT = exports.V1_EXPORT_ADJUSTMENT = V1_URL + '/adjustment/export';

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_IMPORT_LIBRARY_TEMPLATE = exports.V1_IMPORT_LIBRARY = exports.V1_IMPORT_LIBRARY_TEMPORARY = exports.INGREDIENT_CREATE_CATEGORY = exports.LIBRARY_GET_UNITS = exports.DELETE_LIBRARY_BY_ID_V1 = exports.UPDATE_LIBRARY_BY_ID = exports.CREATE_ALL_OUTLET_LIBRARY = exports.CREATE_LIBRARY = exports.LIBRARY_BY_ID = exports.LIBRARY_SUMMARY_URL = exports.INGREDIENT_WITH_UNCATEGORY = exports.LIST_LIBRARY_URL = exports.LIBRARY_DOWNLOAD_TEMPLATE = exports.LIBRARIES_EXPORT = undefined;

var _constants = __webpack_require__(30);

var LIBRARIES_EXPORT = exports.LIBRARIES_EXPORT = _constants.API_URL + '/v1/ingredients/export';
var LIBRARY_DOWNLOAD_TEMPLATE = exports.LIBRARY_DOWNLOAD_TEMPLATE = 'LIBRARY_DOWNLOAD_TEMPLATE';
var LIST_LIBRARY_URL = exports.LIST_LIBRARY_URL = _constants.API_URL + '/v1/ingredients';
var INGREDIENT_WITH_UNCATEGORY = exports.INGREDIENT_WITH_UNCATEGORY = _constants.API_URL + '/v1/ingredient_categories/with_uncategorized';
var LIBRARY_SUMMARY_URL = exports.LIBRARY_SUMMARY_URL = _constants.API_URL + '/v1/ingredients';
var LIBRARY_BY_ID = exports.LIBRARY_BY_ID = function LIBRARY_BY_ID(id) {
  return LIST_LIBRARY_URL + '/' + id;
};
var CREATE_LIBRARY = exports.CREATE_LIBRARY = _constants.API_URL + '/v1/ingredients';
var CREATE_ALL_OUTLET_LIBRARY = exports.CREATE_ALL_OUTLET_LIBRARY = _constants.API_URL + '/v1/ingredients/create_all_outlet';
var UPDATE_LIBRARY_BY_ID = exports.UPDATE_LIBRARY_BY_ID = function UPDATE_LIBRARY_BY_ID(id) {
  return LIBRARY_BY_ID(id) + '/update_image';
};
var DELETE_LIBRARY_BY_ID_V1 = exports.DELETE_LIBRARY_BY_ID_V1 = function DELETE_LIBRARY_BY_ID_V1(id) {
  return '' + LIBRARY_BY_ID(id);
};
var LIBRARY_GET_UNITS = exports.LIBRARY_GET_UNITS = _constants.API_URL + '/v1/units';
var INGREDIENT_CREATE_CATEGORY = exports.INGREDIENT_CREATE_CATEGORY = _constants.API_URL + '/v1/ingredient_categories';
var V1_IMPORT_LIBRARY_TEMPORARY = exports.V1_IMPORT_LIBRARY_TEMPORARY = _constants.API_URL + '/v1/ingredients/import_temp';
var V1_IMPORT_LIBRARY = exports.V1_IMPORT_LIBRARY = _constants.API_URL + '/v1/ingredients/import';
var V1_IMPORT_LIBRARY_TEMPLATE = exports.V1_IMPORT_LIBRARY_TEMPLATE = _constants.API_URL + '/v1/ingredients/export?&inventory=all';

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/inventory';

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_IMPORT_ITEMS_TEMPLATE = exports.V1_IMPORT_ITEMS = exports.V1_IMPORT_ITEMS_TEMPORARY = exports.V1_ITEM_BY_ID = exports.V1_ITEMS = exports.V2_ITEMS = exports.ITEMS = undefined;

var _constants = __webpack_require__(30);

// TODO remove
var ITEMS = exports.ITEMS = _constants.API_URL + '/v2/items';

var V2_ITEMS = exports.V2_ITEMS = _constants.API_URL + '/v2/items';

var V1_ITEMS = exports.V1_ITEMS = _constants.API_URL + '/v1/items';

var V1_ITEM_BY_ID = exports.V1_ITEM_BY_ID = function V1_ITEM_BY_ID(id) {
  return V1_ITEMS + '/' + id;
};

var V1_IMPORT_ITEMS_TEMPORARY = exports.V1_IMPORT_ITEMS_TEMPORARY = V1_ITEMS + '/import_items_temporary';

var V1_IMPORT_ITEMS = exports.V1_IMPORT_ITEMS = V1_ITEMS + '/import_items';

var V1_IMPORT_ITEMS_TEMPLATE = exports.V1_IMPORT_ITEMS_TEMPLATE = V1_ITEMS + '/import_items_template';

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getTransactions = getTransactions;
exports.getTransactionDetail = getTransactionDetail;
exports.exportTransaction = exportTransaction;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/****************************************************************
 * Transaction API
 ****************************************************************/

/**
 * @param {object} query query params
 * @return {Axios.IPromise<U>}
 */
function getTransactions(query) {
  return axios.get(_constants.REPORT_TRANSACTION, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}
/**
 *
 * @param {int} transactionId
 * @param {object} query
 * @return
 */
function getTransactionDetail(transactionId, query) {
  return axios.get((0, _constants.REPORT_TRANSACTION_DETAIL)(transactionId), { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function exportTransaction(query) {
  return axios.get(_constants.EXPORT_TRANSACTION, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _styleForm = __webpack_require__(1968);

var _styleForm2 = _interopRequireDefault(_styleForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthField = function (_React$Component) {
  (0, _inherits3.default)(AuthField, _React$Component);

  function AuthField() {
    (0, _classCallCheck3.default)(this, AuthField);
    return (0, _possibleConstructorReturn3.default)(this, (AuthField.__proto__ || (0, _getPrototypeOf2.default)(AuthField)).apply(this, arguments));
  }

  (0, _createClass3.default)(AuthField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          icon = _props.icon,
          maxLength = _props.maxLength;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: !touched ? _styleForm2.default['field-wrapper'] : error ? _styleForm2.default['field-error'] : _styleForm2.default['field-success'] },
          React.createElement('i', { className: icon }),
          React.createElement('input', (0, _extends3.default)({}, input, { type: type, maxLength: maxLength, placeholder: placeholder, className: _styleForm2.default['field-input'] }))
        ),
        React.createElement(
          'small',
          { className: 'error' },
          touched ? error : ''
        )
      );
    }
  }]);
  return AuthField;
}(React.Component);

AuthField.propTypes = {
  icon: React.PropTypes.string
};

exports.default = AuthField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownSelect = function (_React$Component) {
  (0, _inherits3.default)(DropdownSelect, _React$Component);

  function DropdownSelect() {
    (0, _classCallCheck3.default)(this, DropdownSelect);
    return (0, _possibleConstructorReturn3.default)(this, (DropdownSelect.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(DropdownSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          options = _props.options,
          defaultOption = _props.defaultOption,
          id = _props.id,
          dir = _props.dir;

      return React.createElement(
        'label',
        { className: 'mk-select-label' },
        React.createElement(
          'select',
          (0, _extends3.default)({}, input, { className: 'mk-select', id: id, dir: dir }),
          defaultOption && React.createElement(
            'option',
            { value: defaultOption.id, selected: 'selected' },
            defaultOption.name
          ),
          options.map(function (option) {
            return React.createElement(
              'option',
              { value: option.id },
              option.name
            );
          })
        )
      );
    }
  }]);
  return DropdownSelect;
}(React.Component);

DropdownSelect.propTypes = {};

exports.default = DropdownSelect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SwitchField = __webpack_require__(1965);

var _SwitchField2 = _interopRequireDefault(_SwitchField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchField = function (_React$Component) {
  (0, _inherits3.default)(SwitchField, _React$Component);

  function SwitchField() {
    (0, _classCallCheck3.default)(this, SwitchField);
    return (0, _possibleConstructorReturn3.default)(this, (SwitchField.__proto__ || (0, _getPrototypeOf2.default)(SwitchField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SwitchField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          _props$onText = _props.onText,
          onText = _props$onText === undefined ? 'ON' : _props$onText,
          _props$offText = _props.offText,
          offText = _props$offText === undefined ? 'OFF' : _props$offText,
          discount = _props.discount;

      return React.createElement(
        'label',
        { className: '' + (discount ? _SwitchField2.default.switch : _SwitchField2.default['switch-large']) },
        React.createElement('input', (0, _extends3.default)({}, input, { type: 'checkbox' })),
        React.createElement(
          'div',
          { className: (discount ? _SwitchField2.default.slider : _SwitchField2.default['slider-large']) + ' col-sm-12' },
          React.createElement(
            'div',
            { className: '' + (discount ? _SwitchField2.default.on : _SwitchField2.default['on-large']) },
            onText
          ),
          React.createElement(
            'div',
            { className: '' + (discount ? _SwitchField2.default.middle : _SwitchField2.default['middle-large']) },
            '\xA0'
          ),
          React.createElement(
            'div',
            { className: '' + (discount ? _SwitchField2.default.off : _SwitchField2.default['off-large']) },
            offText
          )
        )
      );
    }
  }]);
  return SwitchField;
}(React.Component);

exports.default = SwitchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(683);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactDropzone = __webpack_require__(598);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _UploadImage = __webpack_require__(1966);

var _UploadImage2 = _interopRequireDefault(_UploadImage);

var _reactRedux = __webpack_require__(6);

var _reactBootstrap = __webpack_require__(10);

var _uploadImage = __webpack_require__(634);

var apiUploadImage = _interopRequireWildcard(_uploadImage);

var _notifications = __webpack_require__(23);

var _formData = __webpack_require__(228);

var _formData2 = _interopRequireDefault(_formData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDeleteModal = function ConfirmDeleteModal(_ref) {
  var onCancel = _ref.onCancel,
      onDelete = _ref.onDelete,
      show = _ref.show;

  return React.createElement(
    _reactBootstrap.Modal,
    { onHide: function onHide() {},
      show: show,
      dialogClassName: 'modal-dialog ' + _UploadImage2.default['confirm-delete-dialog']
    },
    React.createElement(
      _reactBootstrap.Modal.Header,
      { bsClass: 'modal-header ' + _UploadImage2.default['confirm-delete-header'] },
      React.createElement(
        _reactBootstrap.Modal.Title,
        null,
        'Information'
      )
    ),
    React.createElement(
      _reactBootstrap.Modal.Body,
      null,
      'Are you sure to delete this image?'
    ),
    React.createElement(
      _reactBootstrap.Modal.Footer,
      null,
      React.createElement(
        'span',
        { className: 'pull-right' },
        React.createElement(
          'button',
          { className: 'btn btn-default', onClick: onCancel },
          'Cancel'
        ),
        React.createElement(
          'button',
          { className: 'btn btn-danger', onClick: onDelete },
          'Delete'
        )
      )
    )
  );
};

var UploadValidationModal = function UploadValidationModal(_ref2) {
  var onHide = _ref2.onHide,
      showUploadValidationModal = _ref2.showUploadValidationModal,
      textModal = _ref2.textModal;

  return React.createElement(
    _reactBootstrap.Modal,
    {
      onHide: onHide,
      show: showUploadValidationModal,
      dialogClassName: _UploadImage2.default.dialog + ' modal-dialog margin-top-120' },
    React.createElement(
      _reactBootstrap.Modal.Header,
      null,
      React.createElement(
        _reactBootstrap.Modal.Title,
        { className: _UploadImage2.default['title-modal'] },
        'Information'
      )
    ),
    React.createElement(
      _reactBootstrap.Modal.Body,
      null,
      React.createElement(
        'div',
        null,
        textModal
      )
    ),
    React.createElement(
      _reactBootstrap.Modal.Footer,
      null,
      React.createElement(
        'div',
        null,
        React.createElement(
          'button',
          {
            type: 'button',
            className: 'btn btn-default',
            onClick: onHide },
          'OK'
        )
      )
    )
  );
};

var UploadImage = function (_React$Component) {
  (0, _inherits3.default)(UploadImage, _React$Component);

  function UploadImage(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, UploadImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UploadImage.__proto__ || (0, _getPrototypeOf2.default)(UploadImage)).call(this, props));

    _this._onDrop = function (acceptedFiles) {
      var _this$props = _this.props,
          onChange = _this$props.input.onChange,
          dispatch = _this$props.meta.dispatch;

      var type = acceptedFiles[0].type;
      if (acceptedFiles[0].size >= 256000) {
        // show validation modal
        _this.setState({
          showUploadValidationModal: true,
          textModal: 'Error: Image file is too big, please upload less than 250 KB'
        });
      } else if (type !== 'image/jpg' && type !== 'image/jpeg' && type !== 'image/png' && type !== 'image/gif') {
        _this.setState({
          showUploadValidationModal: true,
          textModal: 'Error: Please upload valid image'
        });
      } else {
        _this.uploadImage(acceptedFiles[0]).then(function (url) {
          onChange(url);
          _this.setState({
            loading: false
          });
        }).catch(function (reject) {
          dispatch((0, _notifications.error)('Upload image failed'));
        });
      }
    };

    _this.uploadImage = function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(file) {
        var _this$props2, beforeUpload, afterUpload, resUploadImage, data, formData;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = _this.props, beforeUpload = _this$props2.beforeUpload, afterUpload = _this$props2.afterUpload;

                if (beforeUpload) {
                  beforeUpload();
                }
                _this.setState({ loading: true });
                _context.next = 5;
                return apiUploadImage.getImage({ filename: file.name });

              case 5:
                resUploadImage = _context.sent;
                data = resUploadImage.data;
                formData = new _formData2.default();

                formData.append('key', data.key);
                formData.append('acl', data.acl);
                formData.append('AWSAccessKeyId', data.aws_access_key_id);
                formData.append('success_action_status', data.success_action_status);
                formData.append('Content-Type', data.content_type);
                formData.append('Cache-Control', data.cache_control);
                formData.append('policy', data.policy);
                formData.append('signature', data.signature);
                formData.append('file', file);
                _context.prev = 17;
                _context.next = 20;
                return axios.post(data.url, formData, {});

              case 20:
                return _context.abrupt('return', _promise2.default.resolve(data.fullUrl));

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](17);
                return _context.abrupt('return', _promise2.default.reject(false));

              case 26:
                _context.prev = 26;

                if (afterUpload) {
                  afterUpload();
                }
                return _context.finish(26);

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[17, 23, 26, 29]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this._onClickDelete = function () {
      if (_this.props.confirmOnDelete) {
        _this.setState({
          showConfirmDeleteModal: true
        });
      } else {
        _this._onDelete();
      }
    };

    _this._onDelete = function () {
      var onChange = _this.props.input.onChange;

      onChange('');
    };

    _this._onHideValidationModal = function () {
      _this.setState({
        showUploadValidationModal: false,
        textModal: ''
      });
    };

    _this.state = {
      showUploadValidationModal: false,
      showConfirmDeleteModal: false,
      textModal: '',
      loading: false
    };
    return _this;
  }

  (0, _createClass3.default)(UploadImage, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          name = _props.name,
          className = _props.className,
          value = _props.input.value,
          defaultImage = _props.defaultImage,
          placeholder = _props.placeholder,
          imageContainerClassName = _props.imageContainerClassName,
          backgroundColor = _props.backgroundColor;
      var loading = this.state.loading;

      var actionEditClassName = value ? _UploadImage2.default['edit-button'] : _UploadImage2.default['edit-button-full'];
      return React.createElement(
        'div',
        { className: 'mk-brand-img-box ' + className },
        React.createElement(
          'div',
          { className: 'image-preview ' + _UploadImage2.default['image-container'] },
          !loading && !value && React.createElement(
            'div',
            { style: defaultImage ? { background: 'url(' + defaultImage + ')' } : backgroundColor ? { background: backgroundColor } : { background: '#ddd' }, id: 'img-public-profile', className: _UploadImage2.default['default-image-container'] + ' ' + imageContainerClassName },
            placeholder
          ),
          !loading && value && React.createElement('img', { src: value, id: 'img-public-profile' }),
          loading && React.createElement('img', { src: 'http://dev.mokapos.com/assets/item-image-loading.gif', id: 'img-public-profile' })
        ),
        React.createElement(
          'div',
          { className: 'img-action-bar trans-1' },
          React.createElement(
            'div',
            { className: 'action ' + _UploadImage2.default.action },
            React.createElement(
              _reactDropzone2.default,
              {
                name: name,
                className: actionEditClassName,
                onDrop: this._onDrop,
                multiple: false },
              'Edit'
            ),
            !!value && React.createElement(
              'div',
              { className: _UploadImage2.default['delete-button'] },
              React.createElement(
                'span',
                { onClick: this._onClickDelete },
                'Delete'
              )
            )
          )
        ),
        React.createElement(UploadValidationModal, {
          showUploadValidationModal: this.state.showUploadValidationModal,
          onHide: this._onHideValidationModal,
          textModal: this.state.textModal
        }),
        this.props.confirmOnDelete && React.createElement(ConfirmDeleteModal, {
          show: this.state.showConfirmDeleteModal,
          onDelete: function onDelete() {
            _this3._onDelete();_this3.setState({ showConfirmDeleteModal: false });
          },
          onCancel: function onCancel() {
            _this3.setState({ showConfirmDeleteModal: false });
          }
        })
      );
    }
  }]);
  return UploadImage;
}(React.Component);

function mapStateToProps(state) {
  var deleted = state.uploadImage.uploadImage.deleted;

  return { deleted: deleted };
}

UploadImage.propTypes = {
  name: React.PropTypes.string,
  files: React.PropTypes.object,
  onDrop: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  beforeUpload: React.PropTypes.func,
  afterUpload: React.PropTypes.func,
  confirmOnDelete: React.PropTypes.bool
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(UploadImage);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(25)))

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, axios, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(683);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _server = __webpack_require__(575);

var _server2 = _interopRequireDefault(_server);

__webpack_require__(1973);

__webpack_require__(1972);

var _reactBootstrap = __webpack_require__(10);

var _ImportModal = __webpack_require__(1970);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

var _reactDropzoneComponent = __webpack_require__(285);

var _reactDropzoneComponent2 = _interopRequireDefault(_reactDropzoneComponent);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _s = __webpack_require__(1114);

var apiS3 = _interopRequireWildcard(_s);

var _reduxSaga = __webpack_require__(68);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _formData = __webpack_require__(228);

var _formData2 = _interopRequireDefault(_formData);

var _InformationModal = __webpack_require__(1138);

var _InformationModal2 = _interopRequireDefault(_InformationModal);

var _list = __webpack_require__(246);

var mpLibrary = _interopRequireWildcard(_list);

var _constants = __webpack_require__(431);

var _constants2 = __webpack_require__(433);

var _ConfirmImportModal = __webpack_require__(1137);

var _ConfirmImportModal2 = _interopRequireDefault(_ConfirmImportModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportModal = function (_React$Component) {
  (0, _inherits3.default)(ImportModal, _React$Component);

  function ImportModal(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, ImportModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImportModal.__proto__ || (0, _getPrototypeOf2.default)(ImportModal)).call(this, props));

    _this._showDropzoneBody = function () {
      return _this.state.act === ImportModal.WAIT_FOR_FILE || _this.state.act === ImportModal.PROCESSING || _this.state.act === ImportModal.VALIDATING;
    };

    _this._disableUploadButton = function () {
      return _this.state.act === ImportModal.PROCESSING || !_this.state.file || _this.state.act === ImportModal.VALIDATING;
    };

    _this._onHideInformationModal = function () {
      _this.setState({ showInformationModal: false });
    };

    _this._onClickDownloadTemplate = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var _this$props, dispatch, templateImportUrl, namespace, templatePrefix, exportFinished, profile, resProfile, pattern;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, dispatch = _this$props.dispatch, templateImportUrl = _this$props.templateImportUrl, namespace = _this$props.namespace, templatePrefix = _this$props.templatePrefix;

              dispatch(action.showLoadingSpinner(true));
              _context.prev = 2;
              _context.next = 5;
              return axios.get(templateImportUrl, { withCredentials: true });

            case 5:
              // begin infinite loop until the import process finished
              exportFinished = false;
              profile = void 0;

            case 7:
              if (exportFinished) {
                _context.next = 17;
                break;
              }

              _context.next = 10;
              return (0, _reduxSaga.delay)(5000);

            case 10:
              _context.next = 12;
              return apiProfile.getProfile();

            case 12:
              resProfile = _context.sent;

              profile = resProfile.data;
              if (!profile.exporting) {
                exportFinished = true;
              }
              _context.next = 7;
              break;

            case 17:
              pattern = new RegExp(templatePrefix, 'i');

              if (!profile || !pattern.test(profile.export_items_file)) {
                dispatch(actNotif.error('Failed to download ' + namespace + ' template'));
              } else {
                window.location.href = profile.export_items_file;
              }
              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context['catch'](2);

              dispatch(actNotif.error(_context.t0.message));

            case 24:
              _context.prev = 24;

              dispatch(action.showLoadingSpinner(false));
              return _context.finish(24);

            case 27:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 21, 24, 27]]);
    }));
    _this._confirmBeforeUpload = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var _this$props2, confirmPromiseFunction, dispatch, needConfirmation;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, confirmPromiseFunction = _this$props2.confirmPromiseFunction, dispatch = _this$props2.dispatch;

              if (!confirmPromiseFunction) {
                _context2.next = 9;
                break;
              }

              dispatch(action.showLoadingSpinner(true));
              _context2.next = 5;
              return confirmPromiseFunction();

            case 5:
              needConfirmation = _context2.sent;

              if (needConfirmation) {
                _this.setState({
                  act: ImportModal.CONFIRM_IMPORT
                });
                dispatch(action.showLoadingSpinner(false));
              } else {
                _this._onUpload();
              }
              _context2.next = 10;
              break;

            case 9:
              _this._onUpload();

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this._onUpload = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
      var _this$props3, dispatch, temporaryImportUrl, importUrl, afterSuccessCallback, onErrorCallback, eventName, pathImporting, selectedOutletIds, file, s3CallResult, response, formData, importFinished, result, resOutlet, resProfile, outletId, errorMessage, errorCode, errors;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = _this.props, dispatch = _this$props3.dispatch, temporaryImportUrl = _this$props3.temporaryImportUrl, importUrl = _this$props3.importUrl, afterSuccessCallback = _this$props3.afterSuccessCallback, onErrorCallback = _this$props3.onErrorCallback, eventName = _this$props3.eventName, pathImporting = _this$props3.pathImporting, selectedOutletIds = _this$props3.selectedOutletIds;
              file = _this.state.file;

              dispatch(action.showLoadingSpinner(true));

              _context3.prev = 3;

              _this.setState({ act: ImportModal.PROCESSING });
              _context3.next = 7;
              return apiS3.getNew({ filename: file.name });

            case 7:
              s3CallResult = _context3.sent;
              response = s3CallResult.data;
              formData = new _formData2.default();

              formData.append('key', response.key);
              formData.append('acl', response.acl);
              formData.append('AWSAccessKeyId', response.aws_access_key_id);
              formData.append('success_action_status', response.success_action_status);
              formData.append('Content-Type', response.content_type);
              formData.append('Cache-Control', response.cache_control);
              formData.append('policy', response.policy);
              formData.append('signature', response.signature);
              formData.append('file', file);
              // upload to S3
              _context3.next = 21;
              return axios.post(response.url, formData, {});

            case 21:
              _context3.next = 23;
              return axios.post(temporaryImportUrl, { uploadfile: response.fullUrl }, { withCredentials: true });

            case 23:
              _context3.next = 25;
              return axios.post(importUrl, {}, { withCredentials: true });

            case 25:
              // begin infinite loop until the import process finished
              importFinished = false;

            case 26:
              if (importFinished) {
                _context3.next = 46;
                break;
              }

              _context3.next = 29;
              return (0, _reduxSaga.delay)(5000);

            case 29:
              result = void 0, resOutlet = void 0, resProfile = void 0;

              if (!(pathImporting === 'outlet')) {
                _context3.next = 38;
                break;
              }

              outletId = selectedOutletIds.length > 1 ? selectedOutletIds[0] : selectedOutletIds;
              _context3.next = 34;
              return apiOutlet.getOutletById(outletId);

            case 34:
              resOutlet = _context3.sent;

              result = resOutlet.data;
              _context3.next = 43;
              break;

            case 38:
              if (!(pathImporting === 'profile')) {
                _context3.next = 43;
                break;
              }

              _context3.next = 41;
              return apiProfile.getProfile();

            case 41:
              resProfile = _context3.sent;

              result = resProfile.data;

            case 43:
              if (!result.importing) {
                importFinished = true;
                mpLibrary.libraryItemImport({ eventName: eventName });
              }
              _context3.next = 26;
              break;

            case 46:

              if (afterSuccessCallback) {
                afterSuccessCallback();
              }
              _context3.next = 58;
              break;

            case 49:
              _context3.prev = 49;
              _context3.t0 = _context3['catch'](3);
              errorMessage = '';
              errorCode = _context3.t0.response.status;

              // ni gara2 backend ngasihnya beda2 jadi harus if berdasarkan target URL
              // bahkan satu api struktur responsenya pun bisa beda

              if (temporaryImportUrl === _constants.V1_IMPORT_LIBRARY_TEMPORARY || temporaryImportUrl === _constants2.V1_IMPORT_ITEMS_TEMPORARY) {
                errorMessage = _context3.t0.response.data.error.map(function (error) {
                  if (error.constructor === Array) {
                    return '["' + error[0] + '","' + error[1] + '"]';
                  } else {
                    return error;
                  }
                });
              } else if (_context3.t0.response.data.errors) {
                errorMessage = _context3.t0.response.data.errors;
              } else if (_context3.t0.response.data.error) {
                errorMessage = _context3.t0.response.data.error;
              } else {
                errorMessage = ["Oops, something isn't right. Please make sure that your file has the right format"];
              }

              errors = [];

              if (typeof errorMessage === 'string') {
                errors = errorMessage.split(',');
              } else {
                // assume array
                errors = errorMessage;
              }
              _this.setState({
                errors: errors,
                act: ImportModal.UPLOAD_ERROR
              });
              if (onErrorCallback) {
                onErrorCallback(errors, errorCode);
              }

            case 58:
              _context3.prev = 58;

              dispatch(action.showLoadingSpinner(false));
              return _context3.finish(58);

            case 61:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[3, 49, 58, 61]]);
    }));

    _this._onClickTryAgain = function () {
      _this.setState({
        errors: [],
        act: ImportModal.WAIT_FOR_FILE,
        file: null
      });
    };

    _this._renderErrors = function () {
      var errors = _this.state.errors;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _ImportModal2.default['description'] + ' text-left' },
          'We Found ',
          errors.length,
          ' errors in your file. Please correct them and re-upload your file.'
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'ol',
            null,
            errors.map(function (message, i) {
              return React.createElement(
                'li',
                { key: i },
                React.createElement(
                  'span',
                  { className: _ImportModal2.default['list-type'] },
                  i + 1,
                  '. '
                ),
                React.createElement(
                  'strong',
                  { className: 'text-error' },
                  React.createElement(
                    'span',
                    { className: 'text-red' },
                    message
                  )
                )
              );
            })
          )
        )
      );
    };

    _this._validate = function (file) {
      return new _promise2.default(function (resolve, reject) {
        var element = $('.progress');
        $(element).css('width', '0%').show();
        /* global FileReader */
        var reader = new FileReader();
        var reactContext = _this;
        var validate = _this.props.validate;

        reader.readAsText(file);
        reader.onload = function (event) {
          // HACK => because sometimes windows has different code in newline so we change windows new line into universal string newline
          var csv = event.target.result.replace(/\r/g, '\n').replace(/\n\n/g, '\n');
          var resultOBject = $.csv.toArrays(csv);
          var resultLength = resultOBject.length;

          var errorMessage = null;
          var headers = reactContext.props.csvHeaders;
          // https://mokapos.atlassian.net/browse/FD-1500
          // validasi header dilakukan lebih dahulu sebelum validasi empty file
          // kalo urutan validasi header dan empty file diubah lagi
          // please reconsider this ticket
          if (!errorMessage && headers && headers.length > 0) {
            var isSame = true;
            isSame = isSame && resultOBject[0] && resultOBject[0].length > 0;
            isSame = isSame && resultOBject[0].slice(0, headers.length).every(function (element, index) {
              return element === headers[index];
            });
            if (!isSame) {
              errorMessage = 'Invalid format, upload process failed. Please re-download the template and try again';
            }
          }
          if (!errorMessage && resultLength > 2501) {
            errorMessage = 'Please upload less than 2500 ' + reactContext.props.filterNamespace;
          }
          if (!errorMessage && resultLength <= 1) {
            errorMessage = reactContext.props.filterNamespace + ' can\'t be empty';
          }
          if (!errorMessage && validate !== undefined && validate(resultOBject)) {
            errorMessage = 'Invalid stock alert value ' + validate(resultOBject)[0].cell + ', ' + validate(resultOBject)[0].message + '';
          }

          var MAX_COUNTER = 25;

          var _loop = function _loop(i) {
            setTimeout(function () {
              $(element).css('width', i * (108 / MAX_COUNTER) + '%');
              if (i === MAX_COUNTER) {
                if (errorMessage) {
                  reject(errorMessage);
                } else {
                  resolve(true);
                }
                $(element).css('width', '0%');
              }
            }, i * 108);
          };

          for (var i = 1; i <= MAX_COUNTER; i++) {
            _loop(i);
          }
        };
      });
    };

    _this._showUploadButton = function () {
      return _this.state.act === ImportModal.WAIT_FOR_FILE || _this.state.act === ImportModal.PROCESSING || _this.state.act === ImportModal.VALIDATING;
    };

    _this._showTryAgainButton = function () {
      return _this.state.act === ImportModal.UPLOAD_ERROR;
    };

    _this._showBackButton = function () {
      return _this.state.act === ImportModal.WAIT_FOR_FILE && !!_this.props.onBack || _this.state.act === ImportModal.VALIDATING;
    };

    _this._description = function () {
      var namespace = _this.props.namespace;

      if (namespace === 'adjustment') {
        return React.createElement(
          'span',
          null,
          'file to adjust the the actual stock of your inventory in bulk. To optimize performance, we can only process 2500 adjustments at a time.If you have any questions on how to bulk import your adjustments, please send an email to support@mokapos.com.'
        );
      } else {
        return React.createElement(
          'span',
          null,
          ' file and add your ',
          namespace,
          ' information to upload ',
          namespace,
          ' in bulk. To optimize performance, we can only process 2500 items at a time. If you have any questions on how to bulk import your ',
          namespace,
          ', please send an email to support@mokapos.com.'
        );
      }
    };

    _this.state = {
      file: null,
      act: ImportModal.WAIT_FOR_FILE,
      errors: [],
      showInformationModal: false,
      informationModalMessage: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ImportModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.show !== nextProps.show) {
        this.setState({
          file: null,
          act: ImportModal.WAIT_FOR_FILE,
          errors: []
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var componentConfig = {
        iconFiletypes: ['.csv'],
        showFiletypeIcon: true,
        postUrl: 'no-url',
        uploadMultiple: false,
        addRemoveLinks: 'no'
      };
      var reactContext = this;
      var djsConfig = {
        previewTemplate: _server2.default.renderToStaticMarkup(React.createElement(
          'div',
          { className: _ImportModal2.default['preview-import'] },
          React.createElement(
            'div',
            { className: 'dz-preview dz-file-preview' },
            React.createElement(
              'div',
              { className: 'dz-details' },
              React.createElement(
                'div',
                { className: 'dz-file-remove' },
                React.createElement(
                  'a',
                  { href: '#', 'data-dz-remove': true },
                  React.createElement('span', { className: 'glyphicon glyphicon-remove-sign' })
                )
              ),
              React.createElement(
                'div',
                { className: 'dz-filename' },
                React.createElement('span', { 'data-dz-name': true })
              ),
              React.createElement(
                'strong',
                null,
                React.createElement('div', { className: 'dz-size', 'data-dz-size': true })
              ),
              React.createElement(
                'div',
                { className: 'progress' },
                React.createElement('div', { className: 'progress-bar progress-bar-success progress-bar-striped',
                  role: 'progressbar',
                  'aria-valuenow': '40', 'aria-valuemin': '0', 'aria-valuemax': '100' })
              ),
              React.createElement('img', { 'data-dz-thumbnail': true })
            )
          )
        )),
        autoProcessQueue: false,
        acceptedFiles: '.csv',
        uploadMultiple: false,
        init: function init() {
          this.on('addedfile', function (file) {
            var _this3 = this;

            if (reactContext.state.file) {
              this.removeFile(reactContext.state.file);
              reactContext.setState({ file: null });
            }
            reactContext.setState({
              file: file,
              act: ImportModal.VALIDATING
            });
            reactContext._validate(file).then(function (resolve) {
              // only modify state if the file name is same from before
              // this is used because user can upload another file during validation
              if (_this3.files && _this3.files[0] && _this3.files[0].name === file.name) {
                reactContext.setState({
                  act: ImportModal.WAIT_FOR_FILE
                });
              }
            }).catch(function (reject) {
              // only modify state if the file name is same from before
              // this is used because user can upload another file during validation
              // and makes current validation invalid
              if (_this3.files && _this3.files[0] && _this3.files[0].name === file.name) {
                reactContext.setState({
                  file: null,
                  act: ImportModal.WAIT_FOR_FILE,
                  showInformationModal: true,
                  informationModalMessage: reject
                });
                _this3.removeFile(file);
              }
            });
          });

          this.on('removedfile', function (file) {
            reactContext.setState({ file: null });
          });

          this.on('error', function (file) {
            if (!file.accepted) {
              reactContext.setState({ showInformationModal: true, informationModalMessage: 'Only allowed CSV files' });
            }
            this.removeFile(file);
            reactContext.setState({ file: null });
          });
        }

      };

      var _props = this.props,
          namespace = _props.namespace,
          body = _props.body,
          header = _props.header,
          footer = _props.footer,
          confirmImportHeader = _props.confirmImportHeader,
          confirmImportBody = _props.confirmImportBody;

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: !this.state.showInformationModal && this.state.act !== ImportModal.CONFIRM_IMPORT && this.state.act !== ImportModal.PROCESSING && this.props.show, bsClass: this.props.className + ' import-modal modal' },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            !!header && header,
            !header && React.createElement(
              _reactBootstrap.Modal.Title,
              null,
              ' Import ',
              this.state.act === ImportModal.UPLOAD_ERROR ? 'Error' : namespace,
              ' '
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: 'modal-body no-padding' },
            !!body && body,
            !body && React.createElement(
              'div',
              { className: this.state.act === ImportModal.UPLOAD_ERROR ? _ImportModal2.default['error-body-wrapper'] : '' },
              this._showDropzoneBody() && React.createElement(
                'div',
                { className: _ImportModal2.default['description'] + ' text-left' },
                React.createElement(
                  'a',
                  { className: 'download-our-template', onClick: this._onClickDownloadTemplate },
                  'Download Our Template'
                ),
                ' ',
                this._description()
              ),
              this._showDropzoneBody() && React.createElement(
                'div',
                { className: 'box-dropzone' },
                React.createElement(
                  _reactDropzoneComponent2.default,
                  {
                    className: _ImportModal2.default['dropzone-area'],
                    config: componentConfig,
                    djsConfig: djsConfig
                  },
                  React.createElement('div', { className: 'dz-default dz-message' })
                )
              ),
              this.state.act === ImportModal.UPLOAD_ERROR && this._renderErrors()
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            !!footer && footer,
            !footer && React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'pull-left' },
                this._showBackButton() && React.createElement(
                  'a',
                  { className: 'btn btn-default', onClick: this.props.onBack },
                  'Back'
                ),
                React.createElement(
                  'a',
                  { className: 'btn btn-default', onClick: this.props.onCancel },
                  'Cancel'
                )
              ),
              React.createElement(
                'span',
                { className: 'pull-right' },
                this._showUploadButton() && React.createElement(
                  'a',
                  {
                    className: 'btn btn-primary',
                    disabled: this._disableUploadButton(),
                    onClick: this._disableUploadButton() ? '' : this._confirmBeforeUpload
                  },
                  'Upload'
                ),
                this._showTryAgainButton() && React.createElement(
                  'a',
                  {
                    className: 'btn btn-primary',
                    onClick: this._onClickTryAgain
                  },
                  'Try Again'
                )
              )
            )
          )
        ),
        React.createElement(_InformationModal2.default, {
          show: this.state.showInformationModal,
          onHide: this._onHideInformationModal,
          message: this.state.informationModalMessage
        }),
        React.createElement(_ConfirmImportModal2.default, {
          show: this.state.act === ImportModal.CONFIRM_IMPORT,
          onCancel: this.props.onCancel,
          onConfirm: this._onUpload,
          body: confirmImportBody,
          header: confirmImportHeader
        })
      );
    }
  }]);
  return ImportModal;
}(React.Component);

ImportModal.WAIT_FOR_FILE = 'wait_for_file';
ImportModal.PROCESSING = 'processing';
ImportModal.UPLOAD_ERROR = 'upload_error';
ImportModal.CONFIRM_IMPORT = 'confirm_import';
ImportModal.VALIDATING = 'validating';


ImportModal.propTypes = {
  dispatch: React.PropTypes.func,
  templateImportUrl: React.PropTypes.string,
  temporaryImportUrl: React.PropTypes.string,
  importUrl: React.PropTypes.string,
  // if not provided, there will be no back button
  onBack: React.PropTypes.func,
  afterSuccessCallback: React.PropTypes.func,
  // will be called with (errors) where errors is array of error
  onErrorCallback: React.PropTypes.func,
  show: React.PropTypes.bool,
  onCancel: React.PropTypes.func,
  // adjustment, library, customers, etc...
  namespace: React.PropTypes.string,
  templatePrefix: React.PropTypes.string,
  // if provided it will override modal body
  body: React.PropTypes.object,
  // if provided it will override modal footer
  footer: React.PropTypes.object,
  // if provided it will override modal header
  header: React.PropTypes.object,
  // header for confirm import modal. doesn't needed if confirmPromiseFunction is not provided
  confirmImportHeader: React.PropTypes.object,
  // body for confirm import modal. doesn't needed if confirmPromiseFunction is not provided
  confirmImportBody: React.PropTypes.object,
  // function that return promise. must return true (must be confirmed) or false (doesn't need to be confirmed)
  confirmPromiseFunction: React.PropTypes.func,
  // items or ingredients
  filterNamespace: React.PropTypes.string,
  csvHeaders: React.PropTypes.array
};

exports.default = ImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(25), __webpack_require__(43)))

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _ItemHasRecipe = __webpack_require__(1974);

var _ItemHasRecipe2 = _interopRequireDefault(_ItemHasRecipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemHasRecipe = function (_React$Component) {
  (0, _inherits3.default)(ItemHasRecipe, _React$Component);

  function ItemHasRecipe() {
    (0, _classCallCheck3.default)(this, ItemHasRecipe);
    return (0, _possibleConstructorReturn3.default)(this, (ItemHasRecipe.__proto__ || (0, _getPrototypeOf2.default)(ItemHasRecipe)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemHasRecipe, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClickIngredient = _props.onClickIngredient,
          hasRecipe = _props.hasRecipe;

      return hasRecipe && React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'div',
            { className: _ItemHasRecipe2.default['content-wrapper'] },
            React.createElement('img', {
              src: __webpack_require__(2867),
              alt: 'item has recipe icon',
              className: _ItemHasRecipe2.default['recipe-icon']
            }),
            React.createElement(
              'p',
              { className: _ItemHasRecipe2.default['text-has-recipe'] },
              'This item has recipe'
            ),
            React.createElement(
              'p',
              { className: _ItemHasRecipe2.default['text-manage'] },
              'Please go to ',
              React.createElement(
                _reactRouter.Link,
                { onClick: onClickIngredient },
                'ingredient'
              ),
              ' to manage your inventory'
            )
          )
        )
      );
    }
  }]);
  return ItemHasRecipe;
}(React.Component);

ItemHasRecipe.propTypes = {
  hasRecipe: React.PropTypes.bool,
  onClickIngredient: React.PropTypes.func
};

exports.default = ItemHasRecipe;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _formatter = __webpack_require__(11);

var _PaymentGatewayErrorModal = __webpack_require__(1985);

var _PaymentGatewayErrorModal2 = _interopRequireDefault(_PaymentGatewayErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 6/13/17.
 */

var PaymentGatewayErrorModal = function (_Component) {
  (0, _inherits3.default)(PaymentGatewayErrorModal, _Component);

  function PaymentGatewayErrorModal() {
    (0, _classCallCheck3.default)(this, PaymentGatewayErrorModal);
    return (0, _possibleConstructorReturn3.default)(this, (PaymentGatewayErrorModal.__proto__ || (0, _getPrototypeOf2.default)(PaymentGatewayErrorModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaymentGatewayErrorModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showModal = _props.showModal,
          onHide = _props.onHide,
          totalPrice = _props.totalPrice;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { onHide: onHide, show: showModal, dialogClassName: _PaymentGatewayErrorModal2.default['dialog'] + ' ' + _PaymentGatewayErrorModal2.default['payment-error-modal-wrapper'] + ' modal-dialog' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'payment-error-modal-wrapper' },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'close', onClick: onHide },
              _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'PAYMENT'
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row text-primary' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-7' },
                _react2.default.createElement(
                  'h4',
                  null,
                  'Total Payment'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-5' },
                _react2.default.createElement(
                  'h4',
                  { className: 'totalCount pull-right' },
                  (0, _formatter.currencyFormatter)(totalPrice)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row ' + _PaymentGatewayErrorModal2.default['mt-20px'] },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                'We are having a technical issue with our payment gateway. Please send the payment via bank transfer to address provided.'
              )
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row ' + _PaymentGatewayErrorModal2.default['mt-20px'] },
              _react2.default.createElement(
                'div',
                { className: 'col-md-2' },
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['text-grey'] },
                  'Bank Name'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['font-medium'] },
                  'BCA'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3' },
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['text-grey'] },
                  'Account Number'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['font-medium'] },
                  '6560112538'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-4' },
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['text-grey'] },
                  'Account Holder'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['font-medium'] },
                  'PT Moka Teknologi Indonesia'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3' },
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['text-grey'] },
                  'Branch Name'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _PaymentGatewayErrorModal2.default['font-medium'] },
                  'Kebon Jeruk'
                )
              )
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row ' + _PaymentGatewayErrorModal2.default['mt-20px'] },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12 ' + _PaymentGatewayErrorModal2.default['mb-20px'] },
                'Confirm your payment with payment receipt to ',
                _react2.default.createElement(
                  'a',
                  { href: 'mailto:billing@mokapos.com' },
                  'billing@mokapos.com'
                ),
                ' so we can process your payment immediately (within office hour).'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row ' + _PaymentGatewayErrorModal2.default['mb-20px'] },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                _react2.default.createElement(
                  'button',
                  {
                    type: 'button',
                    className: 'btn btn-default btn-large btn-block',
                    onClick: onHide },
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Close'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PaymentGatewayErrorModal;
}(_react.Component);

exports.default = PaymentGatewayErrorModal;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(106);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(1991);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableScrollHorizontalVertical = function (_React$Component) {
  (0, _inherits3.default)(TableScrollHorizontalVertical, _React$Component);

  function TableScrollHorizontalVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableScrollHorizontalVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableScrollHorizontalVertical.__proto__ || (0, _getPrototypeOf2.default)(TableScrollHorizontalVertical)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      window.addEventListener('resize', _this._handleWindowHeight(_this.props.fTueStatus, _this.props.fTueStatusCategory));
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('resize', _this._handleWindowHeight(_this.props.fTueStatus, _this.props.fTueStatusCategory));
    }, _this._contentHeightInterval = function () {
      return setInterval(function () {
        this._handleWindowHeight(this.props.fTueStatus, this.props.fTueStatusCategory);
      }, 100);
    }, _this._handleScroll = function () {
      var divScroll = $('.div-scroll');
      document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft();
    }, _this._handleTableScroll = function () {
      var tableScroll = $('.table-scroll');
      var widthDiv = tableScroll.scrollLeft() + tableScroll.width();
      document.getElementById('tbodyinner').style.width = widthDiv + 'px';
    }, _this._handleTbodyInner = function () {
      var tbodyInner = $('#tbodyinner');
      document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop();
    }, _this._handleWindowHeight = function (fTueStatus, fTueStatusCategory) {
      var bodyHeight = $(window).height();
      var contentHeight = void 0;
      if (fTueStatus === true || fTueStatusCategory === true) {
        contentHeight = bodyHeight - 390;
      } else {
        contentHeight = bodyHeight - 266;
      }
      $('.div-scroll > .table-scroll tbody').css('max-height', contentHeight + 'px');
      $('.div-static > .table-static tbody').css('max-height', contentHeight + 'px');
      if ($('.div-scroll > .table-scroll tbody').css('max-height') === contentHeight + 'px' && $('.report-table-outer').hasClass('element-non-mobi')) {
        clearInterval(_this._contentHeightInterval);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableScrollHorizontalVertical, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      this._handleWindowHeight(nextProps.fTueStatus, nextProps.fTueStatusCategory);
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var divScroll = $('.div-scroll');
      var tableScroll = $('.table-scroll');
      var tbodyInner = $('#tbodyinner');
      divScroll.scroll(this._handleScroll);
      tableScroll.scroll(this._handleTableScroll);
      tbodyInner.scroll(this._handleTbodyInner);
      this._handleWindowHeight(this.props.fTueStatus, this.props.fTueStatusCategory);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          parentHeader = _props.parentHeader,
          parentBody = _props.parentBody,
          parentFoot = _props.parentFoot,
          childHeaders = _props.childHeaders,
          childBody = _props.childBody,
          childFoot = _props.childFoot,
          parentClassName = _props.parentClassName,
          childHeaderClassName = _props.childHeaderClassName,
          childBodyClassName = _props.childBodyClassName,
          childFootClassName = _props.childFootClassName;

      return React.createElement(
        'div',
        { id: 'report-sales-scroll', className: 'report-table-outer report-table-sales element-non-mobi' },
        React.createElement(
          'div',
          { className: 'div-static' },
          React.createElement(
            'table',
            { className: 'table table-static' },
            React.createElement(
              'thead',
              { className: parentClassName[0] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  null,
                  parentHeader
                )
              )
            ),
            React.createElement(
              'tbody',
              { id: 'tbodydiv', className: parentClassName[1] },
              parentBody.map(function (val, pidx) {
                return React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    null,
                    val
                  )
                );
              })
            ),
            React.createElement(
              'tfoot',
              { className: parentClassName[2] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  React.createElement(
                    'strong',
                    null,
                    parentFoot
                  )
                )
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'div-scroll' },
          React.createElement(
            'table',
            { className: 'table table-scroll' },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                childHeaders.map(function (val, pidx) {
                  return React.createElement(
                    'th',
                    { className: childHeaderClassName[pidx] },
                    val
                  );
                })
              )
            ),
            React.createElement(
              'tbody',
              { id: 'tbodyinner' },
              childBody.map(function (val, pidx) {
                var valObj = (0, _values2.default)(val);
                return React.createElement(
                  'tr',
                  null,
                  valObj.map(function (value, pidx) {
                    return React.createElement(
                      'td',
                      { className: childBodyClassName[pidx] },
                      value
                    );
                  })
                );
              })
            ),
            React.createElement(
              'tfoot',
              { id: 'tfootscroll' },
              React.createElement(
                'tr',
                { className: 'text-total' },
                (0, _values2.default)(childFoot).map(function (value, pidx) {
                  return React.createElement(
                    'td',
                    { className: childFootClassName[pidx] },
                    React.createElement(
                      'b',
                      null,
                      value
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return TableScrollHorizontalVertical;
}(React.Component);

exports.default = TableScrollHorizontalVertical;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AuthTitle = __webpack_require__(1993);

var _AuthTitle2 = _interopRequireDefault(_AuthTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthTitle = function (_React$PureComponent) {
  (0, _inherits3.default)(AuthTitle, _React$PureComponent);

  function AuthTitle() {
    (0, _classCallCheck3.default)(this, AuthTitle);
    return (0, _possibleConstructorReturn3.default)(this, (AuthTitle.__proto__ || (0, _getPrototypeOf2.default)(AuthTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(AuthTitle, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _AuthTitle2.default.title },
        this.props.title
      );
    }
  }]);
  return AuthTitle;
}(React.PureComponent);

AuthTitle.propTypes = {
  title: React.PropTypes.string
};

exports.default = AuthTitle;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WarningMessage = __webpack_require__(1995);

var _WarningMessage2 = _interopRequireDefault(_WarningMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningMessage = function WarningMessage(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'alert ' + _WarningMessage2.default['alert-orange'], role: 'alert' },
      _react2.default.createElement('img', { src: __webpack_require__(2874) }),
      props.children
    )
  );
};

exports.default = WarningMessage;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BrandImage = __webpack_require__(1996);

var _BrandImage2 = _interopRequireDefault(_BrandImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandImage = function (_React$Component) {
  (0, _inherits3.default)(BrandImage, _React$Component);

  function BrandImage() {
    (0, _classCallCheck3.default)(this, BrandImage);
    return (0, _possibleConstructorReturn3.default)(this, (BrandImage.__proto__ || (0, _getPrototypeOf2.default)(BrandImage)).apply(this, arguments));
  }

  (0, _createClass3.default)(BrandImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          businessName = _props.businessName,
          businessLogo = _props.businessLogo,
          outletAddress = _props.outletAddress,
          outletPhone = _props.outletPhone;

      return React.createElement(
        'div',
        { className: _BrandImage2.default['receipt-brand-img'] },
        !businessLogo && React.createElement('img', { className: _BrandImage2.default['business-logo'], src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDAiIGhlaWdodD0iMTQwIj48cmVjdCB3aWR0aD0iMTQwIiBoZWlnaHQ9IjE0MCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHRleHQtYW5jaG9yPSJtaWRkbGUiIHg9IjcwIiB5PSI3MCIgc3R5bGU9ImZpbGw6I2FhYTtmb250LXdlaWdodDpib2xkO2ZvbnQtc2l6ZToxMnB4O2ZvbnQtZmFtaWx5OkFyaWFsLEhlbHZldGljYSxzYW5zLXNlcmlmO2RvbWluYW50LWJhc2VsaW5lOmNlbnRyYWwiPjE0MHgxNDA8L3RleHQ+PC9zdmc+' }),
        businessLogo && React.createElement('img', { src: businessLogo, className: _BrandImage2.default['business-logo']
        }),
        React.createElement(
          'div',
          { className: _BrandImage2.default['receipt-business-info-box'] },
          React.createElement(
            'div',
            { className: _BrandImage2.default['receipt-business-name'] },
            businessName
          ),
          React.createElement(
            'div',
            { className: 'receipt-business-address ' + _BrandImage2.default['receipt-business-address'] },
            outletAddress
          ),
          React.createElement(
            'div',
            { className: _BrandImage2.default['receipt-business-phone'] },
            React.createElement('span', { className: 'glyphicon glyphicon-earphone' }),
            ' +62 ',
            outletPhone[0] === '0' ? outletPhone.substr(1) : outletPhone
          )
        )
      );
    }
  }]);
  return BrandImage;
}(React.Component);

BrandImage.propTypes = {
  businessName: React.PropTypes.string,
  outletAddress: React.PropTypes.string,
  outletPhone: React.PropTypes.string,
  businessLogo: React.PropTypes.string
};

exports.default = BrandImage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _ItemTable = __webpack_require__(749);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTable = function (_React$Component) {
  (0, _inherits3.default)(ItemTable, _React$Component);

  function ItemTable() {
    (0, _classCallCheck3.default)(this, ItemTable);
    return (0, _possibleConstructorReturn3.default)(this, (ItemTable.__proto__ || (0, _getPrototypeOf2.default)(ItemTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checkouts = _props.checkouts,
          checkoutPriceFormatter = _props.checkoutPriceFormatter;

      return React.createElement(
        'table',
        { className: 'table table-responsive no-border ' + _ItemTable2.default['checkout-table'] },
        React.createElement(
          'tbody',
          null,
          checkouts.map(function (checkout) {
            return React.createElement(
              'tr',
              { key: checkout.id },
              React.createElement(
                'td',
                { className: _ItemTable2.default['checkout-cell'] },
                React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-main'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    (0, _formatter.limitTo)(checkout.item_name, 25),
                    ' ',
                    checkout.item_name.length > 25 ? '...' : ''
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-center'] },
                    'x',
                    Math.abs(checkout.quantity)
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-right'] },
                    checkoutPriceFormatter(checkout.price)
                  )
                ),
                checkout.item_variant_name && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-variant-box'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    (0, _formatter.limitTo)(checkout.item_variant_name, 45),
                    ' ',
                    checkout.item_variant_name.length > 45 ? '...' : ''
                  )
                ),
                checkout.modifiers.length > 0 && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-modifier-box'] },
                  checkout.modifiers.map(function (modifier, i) {
                    return React.createElement(
                      'div',
                      { className: _ItemTable2.default['item-modifier'], key: i },
                      React.createElement(
                        'div',
                        { className: _ItemTable2.default['text-left'] },
                        (0, _formatter.limitTo)(modifier.modifier_name, 15),
                        ' ',
                        modifier.modifier_name.length > 15 ? '...' : '',
                        ' - \xA0',
                        (0, _formatter.limitTo)(modifier.modifier_option_name, 15),
                        ' ',
                        modifier.modifier_option_name.length > 15 ? '...' : '',
                        ' - \xA0',
                        (0, _formatter.rupiah)(modifier.price)
                      ),
                      React.createElement('div', { className: _ItemTable2.default['text-right'] })
                    );
                  })
                ),
                checkout.discounts.length > 0 && React.createElement(
                  'div',
                  { className: _ItemTable2.default['discount-box'] },
                  checkout.discounts.map(function (discount, i) {
                    return React.createElement(
                      'div',
                      { className: _ItemTable2.default['discount'], key: i },
                      React.createElement(
                        'div',
                        { className: _ItemTable2.default['text-left'] },
                        (0, _formatter.limitTo)(discount.discount_name, 25),
                        ' ',
                        discount.discount_name.length > 25 ? '...' : '',
                        '(',
                        discount.discount_percentage,
                        '%)'
                      ),
                      React.createElement(
                        'div',
                        { className: _ItemTable2.default['text-right'] },
                        (0, _formatter.rupiahWithNegative)(discount.discount_amount * -1)
                      )
                    );
                  })
                ),
                checkout.note && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-note'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    React.createElement(
                      'span',
                      null,
                      React.createElement(
                        'div',
                        null,
                        checkout.note
                      )
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);
  return ItemTable;
}(React.Component);

ItemTable.propTypes = {
  checkouts: React.PropTypes.array,
  checkoutPriceFormatter: React.PropTypes.func
};

exports.default = ItemTable;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AmountToRefund = __webpack_require__(2009);

var _AmountToRefund2 = _interopRequireDefault(_AmountToRefund);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountToRefund = function (_React$Component) {
  (0, _inherits3.default)(AmountToRefund, _React$Component);

  function AmountToRefund() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AmountToRefund);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AmountToRefund.__proto__ || (0, _getPrototypeOf2.default)(AmountToRefund)).call.apply(_ref, [this].concat(args))), _this), _this._calculateAmountToRefund = function () {
      return _this.props.calculateAmountToRefund();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AmountToRefund, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12 ' + _AmountToRefund2.default['amount-refund'] },
          React.createElement(
            'label',
            { className: _AmountToRefund2.default['amount-refund-label'] },
            'Amount to refund'
          ),
          React.createElement('input', {
            type: 'text',
            className: 'form-control ' + _AmountToRefund2.default['amount-refund-input'],
            placeholder: (0, _formatter.rupiah)(this._calculateAmountToRefund()),
            name: 'refund[amount]',
            disabled: 'true' })
        )
      );
    }
  }]);
  return AmountToRefund;
}(React.Component);

AmountToRefund.propTypes = {
  // calculateAmountToRefund() returns number
  calculateAmountToRefund: React.PropTypes.func
};
exports.default = AmountToRefund;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RefundReason = __webpack_require__(2017);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundReason = function (_React$Component) {
  (0, _inherits3.default)(RefundReason, _React$Component);

  function RefundReason(props) {
    (0, _classCallCheck3.default)(this, RefundReason);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RefundReason.__proto__ || (0, _getPrototypeOf2.default)(RefundReason)).call(this, props));

    _this._onChangeReasonForRefund = function (e) {
      var value = e.target.value;
      _this.setState({ reasonForRefund: value });
      _this.props.onChangeReasonForRefund(value);
    };

    _this._onChangeOtherReasonForRefund = function (e) {
      var value = e.target.value;
      _this.setState({ otherReasonForRefund: value });
      _this.props.onChangeOtherReasonForRefund(value);
    };

    _this.state = {
      reasonForRefund: '',
      otherReasonForRefund: ''
    };
    return _this;
  }

  (0, _createClass3.default)(RefundReason, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'label',
            { className: 'refund-reason' },
            this.props.labelReason
          ),
          React.createElement(
            'select',
            { className: 'form-control', onChange: this._onChangeReasonForRefund, defaultValue: this.state.reasonForRefund },
            React.createElement(
              'option',
              { value: '' },
              '- Select Reason -'
            ),
            React.createElement(
              'option',
              { value: 'Returned Goods' },
              'Returned Goods'
            ),
            React.createElement(
              'option',
              { value: 'Accidental Charge' },
              'Accidental Charge'
            ),
            React.createElement(
              'option',
              { value: 'Cancelled Order' },
              'Cancelled Order'
            ),
            React.createElement(
              'option',
              { value: 'Other' },
              'Other'
            )
          )
        ),
        this.state.reasonForRefund === 'Other' && React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement('input', { type: 'text',
            value: this.state.otherReasonForRefund,
            onChange: this._onChangeOtherReasonForRefund,
            placeholder: 'Reason for refund',
            className: 'form-control ' + _RefundReason2.default['other-reason'] })
        )
      );
    }
  }]);
  return RefundReason;
}(React.Component);

RefundReason.propTypes = {
  // onChangeReasonForRefund(newValue)
  onChangeReasonForRefund: React.PropTypes.func,
  // onChangeOtherReasonForRefund(newValue)
  onChangeOtherReasonForRefund: React.PropTypes.func,
  labelReason: React.PropTypes.string
};

exports.default = RefundReason;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBarDetailWrapper = __webpack_require__(2031);

var _ActionBarDetailWrapper2 = _interopRequireDefault(_ActionBarDetailWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBarDetailWrapper = function (_React$Component) {
  (0, _inherits3.default)(ActionBarDetailWrapper, _React$Component);

  function ActionBarDetailWrapper() {
    (0, _classCallCheck3.default)(this, ActionBarDetailWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ActionBarDetailWrapper.__proto__ || (0, _getPrototypeOf2.default)(ActionBarDetailWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActionBarDetailWrapper, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _ActionBarDetailWrapper2.default.wrapper + ' row' },
        this.props.children
      );
    }
  }]);
  return ActionBarDetailWrapper;
}(React.Component);

exports.default = ActionBarDetailWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerListStart = customerListStart;
exports.customerListExport = customerListExport;
exports.customerListImport = customerListImport;
exports.customerListSelect = customerListSelect;
exports.customerListSelectPurchaseHistoryInvoice = customerListSelectPurchaseHistoryInvoice;
exports.customerListSelectPurchaseHistoryTransaction = customerListSelectPurchaseHistoryTransaction;

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global mixpanel */
function customerListStart() {
  mixpanel.track('Customer Start');
}

function customerListExport() {
  mixpanel.track('Customer Export');
}

function customerListImport() {
  mixpanel.track('Customer Import');
}

function customerListSelect(_ref) {
  var customer = _ref.customer;

  mixpanel.track('Customer List Select', {
    'Customer Name': customer.name,
    'Customer Address': customer.address,
    'Customer Phone': customer.phone,
    'Customer Email': customer.email,
    'Customer Birthday': customer.birthday,
    'Customer Total Transactions': customer.orders,
    'Customer Lifetime Amount': customer.lifetime_total,
    'Customer Average Amount': customer.average_amount,
    'Customer Since': customer.member_since,
    'Customer Last Visit': customer.last_visit
  });
}

function customerListSelectPurchaseHistoryInvoice(_ref2) {
  var invoice = _ref2.invoice;

  mixpanel.track('Customer List Select Purchase History Select', {
    'Customer Name': invoice.customer_name,
    'Customer Phone': invoice.customer_phone,
    'Customer Email': invoice.customer_email,
    'Transaction Date': (0, _moment2.default)(invoice.created_at).format('YYYY-MM-DD'),
    'Transaction Time': (0, _moment2.default)(invoice.created_at).format('hh:mm:ss'),
    'Receipt Number': invoice.invoice_no,
    'Served By': invoice.served_by,
    'Collected By': invoice.collected_by,
    'Total': invoice.total_collected,
    'Payment Method': _lodash2.default.uniq(invoice.payment_records.map(function (pr) {
      return pr.payment_type;
    })),
    'Payment Amount': invoice.total_amount_received,
    'Payment Note': invoice.payment_note
  });
}

function customerListSelectPurchaseHistoryTransaction(_ref3) {
  var transaction = _ref3.transaction,
      customer = _ref3.customer;

  mixpanel.track('Customer List Select Purchase History Select', {
    'Customer Name': customer.name,
    'Customer Phone': customer.phone,
    'Customer Email': customer.email,
    'Transaction Date': (0, _moment2.default)(transaction.created_at).format('YYYY-MM-DD'),
    'Transaction Time': (0, _moment2.default)(transaction.created_at).format('hh:mm:ss'),
    'Receipt Number': transaction.payment_no,
    'Served By': transaction.served_by,
    'Collected By': transaction.collected_by,
    'Total': transaction.total_collected,
    'Payment Method': transaction.payment_type,
    'Payment Amount': transaction.tendered,
    'Change': transaction.change,
    'Payment Note': transaction.payment_note
  });
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inventoryPOStart = inventoryPOStart;
exports.inventoryPOChangeFilter = inventoryPOChangeFilter;
exports.inventoryPOCreate = inventoryPOCreate;
exports.inventoryPOSelect = inventoryPOSelect;
exports.inventoryPOUpdateStatus = inventoryPOUpdateStatus;
exports.inventoryPOExport = inventoryPOExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapHistoryDetailToMixpanel(d) {
  return {
    'Item Name': d.item_name,
    'Variant': d.item_variant_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.price,
    'Total Cost': d.quantity * d.price
  };
} /* global mixpanel */


function mapIngredientHistoryDetailToMixpanel(d) {
  return {
    'Ingredient Name': d.ingredient_name,
    'Qty in Stock': d.beginning_stock,
    'Qty Order': d.quantity,
    'Unit Cost': d.unit_price,
    'Total Cost': d.quantity * d.unit_price
  };
}

function inventoryPOStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      namespace = _ref.namespace;

  mixpanel.track('Inventory PO Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

function inventoryPOChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      namespace = _ref2.namespace;

  mixpanel.track('Inventory PO Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

function inventoryPOCreate(_ref3) {
  var fulfilled = _ref3.fulfilled,
      supplier = _ref3.supplier,
      outlet = _ref3.outlet,
      namespace = _ref3.namespace,
      items = _ref3.items;

  var data = {
    'Current Inventory Filter': namespace,
    'Outlet Name': outlet.name,
    'Supplier Name': supplier.name
  };
  if (namespace === 'items') {
    data['List of Items'] = items.map(function (d) {
      return {
        'Ingredient Name': d.item_name,
        'Qty in Stock': d.instock,
        'Qty Order': d.order,
        'Unit Cost': d.unitcost,
        'Total Cost': d.order * d.unitcost
      };
    });
  } else {
    data['List of Ingredients'] = items.map(function (d) {
      return {
        'Item Name': d.item_name,
        'Variant': d.item_var_name,
        'Qty in Stock': d.instock,
        'Qty Order': d.order,
        'Unit Cost': d.unitcost,
        'Total Cost': d.order * d.unitcost
      };
    });
  }
  if (fulfilled) {
    mixpanel.track('Inventory PO Create and Fulfill', data);
  } else {
    mixpanel.track('Inventory PO Create', data);
  }
}

function inventoryPOSelect(_ref4) {
  var purchaseOrder = _ref4.purchaseOrder;

  var namespace = purchaseOrder.hasOwnProperty('history_details') ? 'items' : 'ingredients';
  var mixpanelData = {
    'Supplier Name': purchaseOrder.supplier_name,
    'Supplier Email': purchaseOrder.supplier_email,
    'Supplier Phone': purchaseOrder.supplier_phone,
    'PO Number': purchaseOrder.order_no,
    'PO Created At': (0, _formatDate2.default)(purchaseOrder.created_at),
    'PO Created By': purchaseOrder.creator.first_name + ' ' + purchaseOrder.creator.last_name,
    'Email': purchaseOrder.creator.email,
    'Outlet Name': purchaseOrder.outlet.name,
    'Phone': purchaseOrder.outlet.phone_number,
    'Address': purchaseOrder.outlet.address
  };
  if (namespace === 'items') {
    mixpanelData['List of Items'] = purchaseOrder.history_details.map(mapHistoryDetailToMixpanel);
  } else {
    mixpanelData['List of Ingredients'] = purchaseOrder.ingredient_history_details.map(mapIngredientHistoryDetailToMixpanel);
  }
  mixpanel.track('Inventory Select PO', mixpanelData);
}

function inventoryPOUpdateStatus(_ref5) {
  var purchaseOrder = _ref5.purchaseOrder,
      status = _ref5.status;

  var namespace = purchaseOrder.hasOwnProperty('history_details') ? 'items' : 'ingredients';
  var mixpanelData = {
    'Outlet Name': purchaseOrder.outlet.name,
    'Supplier Name': purchaseOrder.supplier_name,
    'Current Inventory Filter': namespace
  };
  var eventName = void 0;
  if (status === 'Fulfilled') {
    eventName = 'Inventory PO Mark Fulfilled';
  } else if (status === 'Cancelled') {
    eventName = 'Inventory PO Cancel Order';
  }
  if (namespace === 'items') {
    mixpanelData['List of Items'] = purchaseOrder.history_details.map(mapHistoryDetailToMixpanel);
  } else {
    mixpanelData['List of Ingredients'] = purchaseOrder.ingredient_history_details.map(mapIngredientHistoryDetailToMixpanel);
  }

  // if eventname is null, do not track
  if (eventName) {
    mixpanel.track(eventName, mixpanelData);
  }
}

function inventoryPOExport(_ref6) {
  var outletIds = _ref6.outletIds,
      startDate = _ref6.startDate,
      endDate = _ref6.endDate,
      namespace = _ref6.namespace;

  mixpanel.track('Inventory PO Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryCategoryStart = libraryCategoryStart;
exports.libraryCategoryChangeOutlet = libraryCategoryChangeOutlet;
exports.libraryCategoryCreate = libraryCategoryCreate;
exports.libraryCategoryUpdateOneOutlet = libraryCategoryUpdateOneOutlet;
exports.libraryCategoryAssignToItems = libraryCategoryAssignToItems;
exports.libraryCategoryDelete = libraryCategoryDelete;
/* global mixpanel */

function libraryCategoryStart(_ref) {
  var currentOutlet = _ref.currentOutlet;

  mixpanel.track('Library Category Start', {
    'Current Selected Outlet': currentOutlet
  });
}

function libraryCategoryChangeOutlet(_ref2) {
  var currentOutlet = _ref2.currentOutlet;

  mixpanel.track('Library Category Change Outlet', {
    'Current Selected Outlet': currentOutlet
  });
}

function libraryCategoryCreate(_ref3) {
  var category = _ref3.category,
      allOutlet = _ref3.allOutlet;

  var eventName = allOutlet ? 'Library Category Create All Outlet' : 'Library Category Create One Outlet';
  mixpanel.track(eventName, {
    'Name': category.name
  });
}

function libraryCategoryUpdateOneOutlet(_ref4) {
  var oldName = _ref4.oldName,
      newName = _ref4.newName;

  mixpanel.track('Library Category Update One Outlet', {
    'Old Name': oldName,
    'New Name': newName
  });
}

function libraryCategoryAssignToItems(_ref5) {
  var name = _ref5.name,
      itemNames = _ref5.itemNames;

  mixpanel.track('Library Category Assign To Items', {
    'Name': name,
    'Item Names': itemNames
  });
}

function libraryCategoryDelete(_ref6) {
  var name = _ref6.name;

  mixpanel.track('Library Category Delete', {
    'Name': name
  });
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryDiscountStart = libraryDiscountStart;
exports.libraryDiscountChangeOutlet = libraryDiscountChangeOutlet;
exports.libraryDiscountCreate = libraryDiscountCreate;
exports.libraryDiscountUpdate = libraryDiscountUpdate;
exports.libraryDiscountDelete = libraryDiscountDelete;
/* global mixpanel */

function libraryDiscountStart(_ref) {
  var outletId = _ref.outletId;

  mixpanel.track('Library Discount Start', {
    'Current Selected Outlet': outletId
  });
}

function libraryDiscountChangeOutlet(_ref2) {
  var prevOutlet = _ref2.prevOutlet,
      currOutlet = _ref2.currOutlet;

  mixpanel.track('Library Discount Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet
  });
}

function libraryDiscountCreate(_ref3) {
  var discount = _ref3.discount,
      allOutlet = _ref3.allOutlet;

  var eventName = allOutlet ? 'Library Discount Create All Outlet' : 'Library Discount Create One Outlet';
  mixpanel.track(eventName, {
    'Name': discount.name,
    'Type': discount.type
  });
}

function libraryDiscountUpdate(_ref4) {
  var oldDiscount = _ref4.oldDiscount,
      newDiscount = _ref4.newDiscount;

  mixpanel.track('Library Discount Update One Outlet', {
    'Old Name': oldDiscount.name,
    'Old Type': oldDiscount.type ? 'percentage' : 'rupiah',
    'New Name': newDiscount.name,
    'New Type': newDiscount.type
  });
}

function libraryDiscountDelete(_ref5) {
  var discount = _ref5.discount;

  mixpanel.track('Library Discount Delete', {
    'Name': discount.name,
    'Type': discount.type
  });
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outletListStart = outletListStart;
exports.outletListCreate = outletListCreate;
exports.outletStart = outletStart;
exports.outletPay = outletPay;
/* global mixpanel */

function outletListStart() {
  mixpanel.track('Outlet Start');
}

function outletListCreate(_ref) {
  var outlet = _ref.outlet;

  mixpanel.track('Outlet Create', {
    'Name': outlet.name,
    'Phone': outlet.phone_number,
    'Address': outlet.address,
    'City': outlet.city,
    'Province': outlet.province,
    'Zip': outlet.postal_code
  });
}

function outletStart() {
  mixpanel.track('Outlet Add');
}

function outletPay(_ref2) {
  var billingData = _ref2.billingData;

  mixpanel.track('Outlet Add Pay', {
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.add_outlet_count
  });
}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FailedFeedback = __webpack_require__(1302);

var _FailedFeedback2 = _interopRequireDefault(_FailedFeedback);

var _reactNumberFormat = __webpack_require__(377);

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberInputWithFeedback = function (_Component) {
  (0, _inherits3.default)(NumberInputWithFeedback, _Component);

  function NumberInputWithFeedback() {
    (0, _classCallCheck3.default)(this, NumberInputWithFeedback);
    return (0, _possibleConstructorReturn3.default)(this, (NumberInputWithFeedback.__proto__ || (0, _getPrototypeOf2.default)(NumberInputWithFeedback)).apply(this, arguments));
  }

  (0, _createClass3.default)(NumberInputWithFeedback, [{
    key: 'render',
    value: function render() {
      var errorMessage = this.props.errorMessage;


      var contentClass = '';
      var contentFeedback = '';

      if (errorMessage !== null) {
        if (errorMessage) {
          contentClass = 'has-error';
          contentFeedback = _react2.default.createElement(_FailedFeedback2.default, { error: errorMessage });
        } else {
          contentClass = 'has-success';
          contentFeedback = _react2.default.createElement('span', { className: 'form-control-feedback glyphicon glyphicon-ok' });
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'has-feedback ' + contentClass },
        _react2.default.createElement(_reactNumberFormat2.default, {
          className: 'form-control',
          value: this.props.inputValue,
          onChange: this.props.onChangeValue,
          suffix: this.props.suffix,
          prefix: this.props.prefix,
          placeholder: this.props.placeholder,
          thousandSeparator: '.',
          decimalSeparator: ',',
          decimalPrecision: 0,
          allowNegative: false,
          disabled: this.props.disabled
        }),
        contentFeedback
      );
    }
  }]);
  return NumberInputWithFeedback;
}(_react.Component);

NumberInputWithFeedback.propTypes = {
  inputValue: _react.PropTypes.string,
  onChangeValue: _react.PropTypes.func,
  suffix: _react.PropTypes.string,
  prefix: _react.PropTypes.string,
  placeholder: _react.PropTypes.String,
  maximumDigit: _react.PropTypes.number
};

exports.default = NumberInputWithFeedback;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Program = __webpack_require__(328);

var _Program2 = _interopRequireDefault(_Program);

var _Program3 = __webpack_require__(1304);

var _Program4 = _interopRequireDefault(_Program3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedProgram = function (_Component) {
  (0, _inherits3.default)(WrappedProgram, _Component);

  function WrappedProgram() {
    (0, _classCallCheck3.default)(this, WrappedProgram);
    return (0, _possibleConstructorReturn3.default)(this, (WrappedProgram.__proto__ || (0, _getPrototypeOf2.default)(WrappedProgram)).apply(this, arguments));
  }

  (0, _createClass3.default)(WrappedProgram, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          program = (0, _objectWithoutProperties3.default)(_props, ['title']);

      return _react2.default.createElement(
        'div',
        { className: _Program2.default['splash-page'] + ' ' + _Program2.default['gray-backgrond'] },
        _react2.default.createElement(
          'div',
          { className: 'splash-box' },
          _react2.default.createElement(
            'div',
            { className: _Program2.default['splash-content'] },
            _react2.default.createElement(
              'div',
              { className: _Program2.default['wrapped-program'] },
              _react2.default.createElement(
                'h3',
                { style: { color: '#000000' }, className: 'text-center bottom40 font-weight-300' },
                title
              ),
              _react2.default.createElement(_Program4.default, (0, _extends3.default)({}, program, { isAccordionEnabled: this.props.isAccordionEnabled }))
            )
          )
        )
      );
    }
  }]);
  return WrappedProgram;
}(_react.Component);

WrappedProgram.propTypes = {
  title: _react.PropTypes.string.isRequired,
  isAccordionEnabled: _react.PropTypes.bool,
  spendingAmount: _react.PropTypes.number.isRequired,
  pointFromSpendingAmount: _react.PropTypes.func.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  setSpendingAmount: _react.PropTypes.func.isRequired,
  setPointFromSpendingAmount: _react.PropTypes.func.isRequired,
  sentValidationCode: _react.PropTypes.bool.isRequired,
  toggleSentValidationCode: _react.PropTypes.func.isRequired,
  showReview: _react.PropTypes.func.isRequired
};

exports.default = WrappedProgram;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

var _RewardList = __webpack_require__(458);

var _RewardList2 = _interopRequireDefault(_RewardList);

var _formatter = __webpack_require__(11);

var _sortBy2 = __webpack_require__(549);

var _sortBy3 = _interopRequireDefault(_sortBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewInfo = function (_Component) {
  (0, _inherits3.default)(ReviewInfo, _Component);

  function ReviewInfo() {
    (0, _classCallCheck3.default)(this, ReviewInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewInfo.__proto__ || (0, _getPrototypeOf2.default)(ReviewInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pointFromSpendingAmount = _props.pointFromSpendingAmount,
          rewards = _props.rewards,
          spendingAmount = _props.spendingAmount,
          newMemberPoint = _props.newMemberPoint,
          sentValidationCode = _props.sentValidationCode;

      var formattedNewMemberPoint = newMemberPoint !== '' ? (0, _formatter.formatDecimal)(newMemberPoint) : 0;
      var formattedPointFromSpendingAmount = pointFromSpendingAmount !== '' ? (0, _formatter.formatDecimal)(pointFromSpendingAmount) : 0;

      var variationCodeContentInfo = 'Use SMS validation code for every reward redemption';
      if (!sentValidationCode) {
        variationCodeContentInfo = 'Do not use SMS validation code for reward redemptions';
      }

      var sortedRewards = (0, _sortBy3.default)(rewards, ['point']);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'text-center ' + _Review2.default['title'] },
          'Review Your Loyalty Program'
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { style: { paddingRight: '38px' }, className: 'col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['section-label'] },
                  'LOYALTY PROGRAM'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['program-info'] },
                  'Loyalty Program : ',
                  _react2.default.createElement(
                    'span',
                    { className: _Review2.default['program-info-chosen'] },
                    ' Rp X = Y Point '
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['program-info'] },
                  'Point Rule : ',
                  _react2.default.createElement(
                    'span',
                    { className: _Review2.default['program-info-chosen'] },
                    'For every ',
                    (0, _formatter.rupiah)(spendingAmount),
                    ' member will get ',
                    formattedPointFromSpendingAmount,
                    ' points'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['program-info'] },
                  'New Member Point : ',
                  _react2.default.createElement(
                    'span',
                    { className: _Review2.default['program-info-chosen'] },
                    ' ',
                    formattedNewMemberPoint,
                    ' Points '
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row top20' },
              _react2.default.createElement(
                'div',
                { style: { paddingRight: '38px' }, className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['section-label'] },
                  'DURATION'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['program-info'] },
                  _react2.default.createElement(
                    'span',
                    { className: _Review2.default['program-info-chosen'] },
                    'No expiry date, until deactivated manually.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row top20' },
              _react2.default.createElement(
                'div',
                { style: { paddingRight: '38px' }, className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['section-label'] },
                  'Validation Code for Redeem'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Review2.default['program-info'] },
                  _react2.default.createElement(
                    'span',
                    { className: _Review2.default['program-info-chosen'] },
                    variationCodeContentInfo
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: '38px' }, className: 'col-md-6' },
            _react2.default.createElement(
              'div',
              { className: _Review2.default['section-label'] },
              'REWARD LIST'
            ),
            _react2.default.createElement(_RewardList2.default, { rewards: sortedRewards })
          )
        )
      );
    }
  }]);
  return ReviewInfo;
}(_react.Component);

ReviewInfo.propTypes = {
  pointFromSpendingAmount: _react.PropTypes.array.isRequired,
  rewards: _react.PropTypes.array,
  spendingAmount: _react.PropTypes.number,
  newMemberPoint: _react.PropTypes.number
};

exports.default = ReviewInfo;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RewardList = __webpack_require__(765);

var _RewardList2 = _interopRequireDefault(_RewardList);

var _RewardInfo = __webpack_require__(1318);

var _RewardInfo2 = _interopRequireDefault(_RewardInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardList = function (_Component) {
  (0, _inherits3.default)(RewardList, _Component);

  function RewardList() {
    (0, _classCallCheck3.default)(this, RewardList);
    return (0, _possibleConstructorReturn3.default)(this, (RewardList.__proto__ || (0, _getPrototypeOf2.default)(RewardList)).apply(this, arguments));
  }

  (0, _createClass3.default)(RewardList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          removeReward = _props.removeReward,
          rewards = _props.rewards;

      var views = [];
      for (var i = 0; i < rewards.length; i++) {
        var divClassName = 'row';
        var reward = rewards[i];
        if (reward.deleted) {
          continue;
        }
        // because this view is shared between review / existing and create program
        if (removeReward) {
          divClassName = divClassName + ' bottom20';
        }
        views.push(_react2.default.createElement(
          'div',
          { className: divClassName },
          _react2.default.createElement(_RewardInfo2.default, {
            point: reward.point,
            discount: reward.discount,
            discountType: reward.discountType,
            maximumDiscount: reward.maximumDiscount,
            minimumPurchase: reward.minimumPurchase,
            index: i,
            removeReward: removeReward,
            isLastRow: i === rewards.length - 1,
            isFirstRow: i === 0
          })
        ));
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row bottom10' },
          views.length > 0 && _react2.default.createElement(
            'div',
            { style: { paddingLeft: '28px' }, className: 'col-md-4' },
            'REDEEM POINT'
          ),
          views.length > 0 && _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            'REWARD'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + (removeReward ? '' : _RewardList2.default['list-box']) },
          views
        )
      );
    }
  }]);
  return RewardList;
}(_react.Component);

RewardList.propTypes = {
  rewards: _react.PropTypes.array.isRequired,
  removeReward: _react.PropTypes.func
};

exports.default = RewardList;

/***/ }),
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"app-components-Modal-__Modal___2b7N4","modal-body":"app-components-Modal-__Modal___3K4AZ","old-reason-field":"app-components-Modal-__Modal___1t3qL"};

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mk-receipt-inner-box":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___3fJ0y","stream-feed-box":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___17ocY","footer-feed":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___1ljyY","receipt-action-bottom":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___2xpua","header-feed":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___3uuer","title-truncate":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___804wc","scrolled-area":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___2d4MX","bottom-separator":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___hATjf","counter-feedback":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___2hP1g","form-sms-feedback":"app-pages-Customers-Feedback-FeedbackDetail-__style-detail___1NVAd"};

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"active":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___3voDt","disabled":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___2CR-V","title":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___H8Rgr","tooltip-image":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___pYKCF","popover":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___3GoCI","reward":"app-pages-Customers-Loyalty-Components-Program-Reward-AddRewardModal-__AddRewardModal___2Xb7z"};

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___2zmNU","field-wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___2mHPi","form-wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___1JAf-","footer":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___IrIud","btn-done":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___2VMyO","separator-row":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___1ySQI","variant-name":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___3v8zI","label-total":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___37E3R","total-adj":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___3aNEo","label-adj-detail":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail____-ZJi","break-word":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___1tDKc","row-inventory":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___Y_T3V","label-unit-total":"app-pages-Inventory-Adjustment-AdjustmentDetail-__AdjustmentDetail___mkzBV"};

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bold":"app-pages-RegisterComplete-__style___2SamA","logoButton":"app-pages-RegisterComplete-__style___26EgS","noOffset":"app-pages-RegisterComplete-__style___31YAZ"};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ResetPassword-__style___3BpP6","left":"app-pages-ResetPassword-__style___1RlTc","right":"app-pages-ResetPassword-__style___1QKv0","description-reset-password":"app-pages-ResetPassword-__style___12LD-","title-panel":"app-pages-ResetPassword-__style___wRMNY","submit-btn":"app-pages-ResetPassword-__style___1XTHu","submit-btn-container":"app-pages-ResetPassword-__style___BznvV","back-to-login":"app-pages-ResetPassword-__style___2zKQn"};

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2455),
    mapCacheDelete = __webpack_require__(2456),
    mapCacheGet = __webpack_require__(2457),
    mapCacheHas = __webpack_require__(2458),
    mapCacheSet = __webpack_require__(2459);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(537),
    setCacheAdd = __webpack_require__(2466),
    setCacheHas = __webpack_require__(2467);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2408),
    isObjectLike = __webpack_require__(160);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2414),
    baseMatchesProperty = __webpack_require__(2415),
    identity = __webpack_require__(349),
    isArray = __webpack_require__(98),
    property = __webpack_require__(2484);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(349),
    overRest = __webpack_require__(2465),
    setToString = __webpack_require__(2469);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(98),
    isSymbol = __webpack_require__(268);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2407),
    isObjectLike = __webpack_require__(160);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(539);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(2400),
    baseOrderBy = __webpack_require__(2416),
    baseRest = __webpack_require__(541),
    isIterateeCall = __webpack_require__(2446);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(272);
var Danger = __webpack_require__(2602);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactInstrumentation = __webpack_require__(111);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(567);
var setInnerHTML = __webpack_require__(572);
var setTextContent = __webpack_require__(886);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (true) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (true) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (true) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (true) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (true) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (true) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (true) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (true) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  true ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  true ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  true ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  true ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (true) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  true ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (true) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactErrorUtils = __webpack_require__(565);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (true) {
       true ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (true) {
       true ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (true) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

     true ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (true) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (true) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (true) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  true ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactPropTypesSecret = __webpack_require__(876);
var propTypesFactory = __webpack_require__(840);

var React = __webpack_require__(280);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  true ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  true ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  true ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         true ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var EventPluginRegistry = __webpack_require__(559);
var ReactEventEmitterMixin = __webpack_require__(2623);
var ViewportMetrics = __webpack_require__(879);

var getVendorPrefixedEventName = __webpack_require__(2661);
var isEventSupported = __webpack_require__(571);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  true ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (true) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);
var DOMNamespaces = __webpack_require__(558);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(567);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var emptyFunction = __webpack_require__(142);
var warning = __webpack_require__(52);

var validateDOMNesting = emptyFunction;

if (true) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
       true ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
         true ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
         true ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2617);


/***/ }),
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (true) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61dc057728dfa7ad74827e602f34e8fa.gif";

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTION_BAR_SET_SELECTED_OUTLET_IDS = exports.ACTION_BAR_SET_SELECTED_OUTLET_IDS = 'ACTION_BAR_SET_SELECTED_OUTLET_IDS';

var ACTION_BAR_SET_OUTLETS = exports.ACTION_BAR_SET_OUTLETS = 'ACTION_BAR_SET_OUTLETS';

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referralRequest = referralRequest;
exports.changeReferralData = changeReferralData;

var _constants = __webpack_require__(380);

/**
 * Create a referral request action.
 * Called from react component
 * @param {string} referral
 * @returns {{type: *, payload: {referral: *}}}
 */
function referralRequest(referral) {
  return { type: _constants.REFERRAL_REQUEST, payload: { referral: referral } };
}

/**
 * Create a change referral action.
 * Called after new data from server is fetched. Example: from the saga
 * @param {object} referral referal data from server
 * @returns {{type: *}}
 */
function changeReferralData(referral) {
  return { type: _constants.CHANGE_REFERRAL_DATA, payload: { referral: referral } };
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by alvinoktavianus on 6/22/17.
 */

var BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION = exports.BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION = 'BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION';

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Upload Image action constants
var SHOW_LOADING_BUTTON = exports.SHOW_LOADING_BUTTON = 'SHOW_LOADING_BUTTON';

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.setInvitedEmployee = setInvitedEmployee;
exports.createEmployeeAccount = createEmployeeAccount;
exports.isInvalidInvitation = isInvalidInvitation;

var _constants = __webpack_require__(385);

function pageRequest(params) {
  return { type: _constants.CONFIRM_EMPLOYEE_PAGE_REQUEST, payload: { params: params } };
}

function setInvitedEmployee(invitedEmployee) {
  return { type: _constants.CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE, payload: { invitedEmployee: invitedEmployee } };
}

function createEmployeeAccount(data) {
  return { type: _constants.CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT, payload: { data: data } };
}

function isInvalidInvitation(invalidInvitation) {
  return { type: _constants.CONFIRM_EMPLOYEE_INVALID_INVITATION, payload: { invalidInvitation: invalidInvitation } };
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initLoyaltyData = initLoyaltyData;
exports.createLoyalty = createLoyalty;
exports.editLoyalty = editLoyalty;
exports.resetLoyalty = resetLoyalty;
exports.deactivateLoyalty = deactivateLoyalty;
exports.reactivateLoyalty = reactivateLoyalty;
exports.setLoyalty = setLoyalty;

var _constants = __webpack_require__(388);

function initLoyaltyData() {
  return { type: _constants.INIT_LOYALTY_DATA };
}

function createLoyalty(data) {
  return { type: _constants.CREATE_LOYALTY, payload: data };
}

function editLoyalty(data) {
  return { type: _constants.EDIT_LOYALTY, payload: data };
}

function resetLoyalty(data) {
  return { type: _constants.RESET_LOYALTY, payload: data };
}

function deactivateLoyalty() {
  return { type: _constants.DEACTIVATE_LOYALTY };
}

function reactivateLoyalty(data) {
  return { type: _constants.REACTIVATE_LOYALTY, payload: data };
}

function setLoyalty(loyalty) {
  return { type: _constants.SET_LOYALTY, payload: loyalty };
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.submitForm = submitForm;
exports.setSetting = setSetting;
exports.changePage = changePage;

var _constants = __webpack_require__(392);

function pageRequest() {
  return { type: _constants.EMPLOYEE_PERMISSION_PAGE_REQUEST, payload: {} };
}

function submitForm(data, params) {
  return { type: _constants.EMPLOYEE_PERMISSION_SUBMIT_FORM, payload: { data: data, params: params } };
}

function setSetting(setting) {
  return { type: _constants.EMPLOYEE_PERMISSION_SET_SETTING, payload: { setting: setting } };
}

function changePage(pathname) {
  return { type: _constants.EMPLOYEE_PERMISSION_CHANGE_PAGE, payload: { pathname: pathname } };
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackFormPageRequest = feedbackFormPageRequest;
exports.submitFeedback = submitFeedback;
exports.isInvalidFeedback = isInvalidFeedback;
exports.isSubmitSuccess = isSubmitSuccess;
exports.setDataCheckFeedbackToken = setDataCheckFeedbackToken;
exports.showForm = showForm;

var _constants = __webpack_require__(393);

function feedbackFormPageRequest(params) {
  return { type: _constants.FEEDBACK_FORM_PAGE_REQUEST, payload: { params: params } };
}

function submitFeedback(data) {
  return { type: _constants.FEEDBACK_FORM_SUBMIT_FEEDBACK, payload: { data: data } };
}

function isInvalidFeedback(invalidFeedback) {
  return { type: _constants.FEEDBACK_FORM_INVALID_FEEDBACK, payload: { invalidFeedback: invalidFeedback } };
}

function isSubmitSuccess(submitSuccess) {
  return { type: _constants.FEEDBACK_FORM_SUCCESS_SUBMIT, payload: { submitSuccess: submitSuccess } };
}

function setDataCheckFeedbackToken(dataFeedbackToken) {
  return { type: _constants.FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN, payload: { dataFeedbackToken: dataFeedbackToken } };
}

function showForm(showFeedbackForm) {
  return { type: _constants.FEEDBACK_FORM_SHOW_FORM, payload: { showFeedbackForm: showFeedbackForm } };
}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestFeedbackReply = requestFeedbackReply;
exports.checkTokenFeedbackReplyForm = checkTokenFeedbackReplyForm;
exports.setFeedbackCustomers = setFeedbackCustomers;
exports.sendFeedbackReplyForm = sendFeedbackReplyForm;
exports.setInvalidToken = setInvalidToken;

var _constants = __webpack_require__(394);

/**
 * Export file
 * @param {string} filename prefix to be matched against
 * @param {int} outletId current outlet id export
 * @param {string} currentPage name of current page that will be displayed when export fails
 * @return {{type, payload: {filename: *, outletId: *, currentPage: *}}}
 */
function requestFeedbackReply(token) {
  return { type: _constants.REQUEST_FEEDBACK_REPLY, payload: { token: token } };
}

function checkTokenFeedbackReplyForm(token) {
  return { type: _constants.CHECK_TOKEN_FEEDBACK_REPLY_FORM, payload: token };
}

function setFeedbackCustomers(data) {
  return { type: _constants.SET_FEEDBACK_REPLY_FORM, payload: { data: data } };
}

function sendFeedbackReplyForm(message, token) {
  return { type: _constants.SEND_FEEDBACK_REPLY_FORM, payload: { message: message, token: token } };
}

function setInvalidToken(status) {
  return { type: _constants.SET_INVALID_TOKEN, payload: { isValid: status } };
}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var BASE_CONST = 'GET_EXPORTED_FILE';
var GET_EXPORTED_FILE = exports.GET_EXPORTED_FILE = '' + BASE_CONST;
var GET_EXPORTED_FILE_TEMPLATE = exports.GET_EXPORTED_FILE_TEMPLATE = BASE_CONST + '_TEMPLATE';

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.featurePricePerMonths = featurePricePerMonths;
exports.featurePrice = featurePrice;
exports.subscriptionStatus = subscriptionStatus;
exports.finishLoadingPage = finishLoadingPage;
exports.endTutorial = endTutorial;
exports.verifyBilling = verifyBilling;
exports.startTrial = startTrial;
exports.setIsOnTutorial = setIsOnTutorial;
exports.setFeaturePricePerMonths = setFeaturePricePerMonths;
exports.setFeaturePrice = setFeaturePrice;
exports.setPendingPaymentMessage = setPendingPaymentMessage;
exports.setPendingOutletMessage = setPendingOutletMessage;
exports.setSubscriptionDetail = setSubscriptionDetail;
exports.setCurrentOutletCount = setCurrentOutletCount;
exports.setOutlets = setOutlets;
exports.setPayButtonMessage = setPayButtonMessage;
exports.getBillings = getBillings;
exports.getOutlets = getOutlets;
exports.enablePayButton = enablePayButton;
exports.disablePayButton = disablePayButton;
exports.showDetailTransactionModal = showDetailTransactionModal;
exports.hideDetailTransactionModal = hideDetailTransactionModal;
exports.showPaymentGatewayErrorModal = showPaymentGatewayErrorModal;
exports.hidePaymentGatewayErrorModal = hidePaymentGatewayErrorModal;

var _constant = __webpack_require__(396);

// Default dispatch
function pageRequest(trialEndAt, outletSlot, billingNotification, alreadySubscribed) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_PAGE_REQUEST,
    payload: { trialEndAt: trialEndAt, outletSlot: outletSlot, billingNotification: billingNotification, alreadySubscribed: alreadySubscribed }
  };
} /**
   * Created by alvinoktavianus on 6/27/17.
   */

function featurePricePerMonths() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS
  };
}

function featurePrice(trialEndAt, outletSlot, alreadySubscribed) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE,
    payload: { trialEndAt: trialEndAt, outletSlot: outletSlot, alreadySubscribed: alreadySubscribed }
  };
}

function subscriptionStatus() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS
  };
}

function finishLoadingPage() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE
  };
}

function endTutorial(featureName) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_END_TUTORIAL,
    payload: { featureName: featureName }
  };
}

function verifyBilling(billingData) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_VERIFY_BILLING,
    payload: { billingData: billingData }
  };
}

function startTrial() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_START_TRIAL
  };
}

// Setter
function setIsOnTutorial(isOnTutorial) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
    payload: { isOnTutorial: isOnTutorial }
  };
}

function setFeaturePricePerMonths(featurePricePerMonths) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
    payload: { featurePricePerMonths: featurePricePerMonths }
  };
}

function setFeaturePrice(featurePrice) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE,
    payload: { featurePrice: featurePrice }
  };
}

function setPendingPaymentMessage(pendingPaymentMessage) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingPaymentMessage: pendingPaymentMessage }
  };
}

function setPendingOutletMessage(pendingOutletMessage) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
    payload: { pendingOutletMessage: pendingOutletMessage }
  };
}

function setSubscriptionDetail(subscriptionDetail) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
    payload: { subscriptionDetail: subscriptionDetail }
  };
}

function setCurrentOutletCount(currentOutletCount) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
    payload: { currentOutletCount: currentOutletCount }
  };
}

function setOutlets(outlets) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_OUTLETS,
    payload: { outlets: outlets }
  };
}

function setPayButtonMessage(buttonMessage) {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
    payload: { buttonMessage: buttonMessage }
  };
}

// Getter
function getBillings() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_GET_BILLINGS
  };
}

function getOutlets() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_GET_OUTLETS
  };
}

// Other dispatch
function enablePayButton() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON
  };
}

function disablePayButton() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON
  };
}

function showDetailTransactionModal() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL
  };
}

function hideDetailTransactionModal() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL
  };
}

function showPaymentGatewayErrorModal() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
  };
}

function hidePaymentGatewayErrorModal() {
  return {
    type: _constant.INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL
  };
}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.pageRequest = pageRequest;
exports.setTransfers = setTransfers;
exports.setTransferDetail = setTransferDetail;
exports.setOutlets = setOutlets;
exports.setSelectedOutlets = setSelectedOutlets;
exports.transfersRequest = transfersRequest;
exports.setCurrentPage = setCurrentPage;
exports.setTotalPage = setTotalPage;
exports.onClickRow = onClickRow;
exports.openRightColumn = openRightColumn;
exports.closeRightColumn = closeRightColumn;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeDate = onChangeDate;
exports.onClickCreateTransfer = onClickCreateTransfer;
exports.onClickAddItem = onClickAddItem;
exports.onModalClickCancel = onModalClickCancel;
exports.getItems = getItems;
exports.setAddItems = setAddItems;
exports.resetAddItems = resetAddItems;
exports.setItemsOptionIsLoading = setItemsOptionIsLoading;
exports.onModalSelectChange = onModalSelectChange;
exports.onModalAddItems = onModalAddItems;
exports.closeAddItemModal = closeAddItemModal;
exports.resetTransfersForm = resetTransfersForm;
exports.setShowConfirmSubmitModal = setShowConfirmSubmitModal;
exports.onSubmitCreateTransfer = onSubmitCreateTransfer;
exports.onConfirmCreateTransfer = onConfirmCreateTransfer;
exports.exportTransfer = exportTransfer;
exports.setIsItemAlreadyAdded = setIsItemAlreadyAdded;
exports.onNamespaceChange = onNamespaceChange;
exports.setExportButtonStatus = setExportButtonStatus;
exports.setConfirmCreateButtonStatus = setConfirmCreateButtonStatus;
exports.setSearchItemsInit = setSearchItemsInit;

var _constants = __webpack_require__(404);

function resetState() {
  return { type: _constants.INVENTORY_TRANSFER_RESET_STATE };
}

function pageRequest() {
  return { type: _constants.INVENTORY_TRANSFER_PAGE_REQUEST, payload: {} };
}

function setTransfers(transfers) {
  return { type: _constants.INVENTORY_TRANSFER_SET_TRANSFERS, payload: { transfers: transfers } };
}

function setTransferDetail(transfer) {
  return { type: _constants.INVENTORY_TRANSFER_SET_TRANSFER_DETAIL, payload: { transfer: transfer } };
}

function setOutlets(outlets) {
  return { type: _constants.INVENTORY_TRANSFER_SET_OUTLETS, payload: { outlets: outlets } };
}

function setSelectedOutlets(selectedOutlets) {
  return { type: _constants.INVENTORY_TRANSFER_SET_SELECTED_OUTLETS, payload: { selectedOutlets: selectedOutlets } };
}

function transfersRequest(params, previuosTransfers, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_TRANSFERS_REQUEST, payload: { params: params, previuosTransfers: previuosTransfers, namespace: namespace } };
}

function setCurrentPage(currentPage) {
  return { type: _constants.INVENTORY_TRANSFER_SET_CURRENT_PAGE, payload: { currentPage: currentPage } };
}

function setTotalPage(totalPage) {
  return { type: _constants.INVENTORY_TRANSFER_SET_TOTAL_PAGE, payload: { totalPage: totalPage } };
}

function onClickRow(transfer) {
  return { type: _constants.INVENTORY_TRANSFER_ON_CLICK_ROW, payload: { transfer: transfer } };
}

function openRightColumn() {
  return { type: _constants.INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN };
}

function closeRightColumn() {
  return { type: _constants.INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN };
}

function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS, payload: { outletIds: outletIds, startDate: startDate, endDate: endDate, namespace: namespace } };
}

function onChangeDate(startDate, endDate, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_ON_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate, namespace: namespace } };
}

function onClickCreateTransfer(outletIds) {
  return { type: _constants.INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER, payload: { outletIds: outletIds } };
}

function onClickAddItem() {
  return { type: _constants.INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM };
}

function onModalClickCancel() {
  return { type: _constants.INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL };
}

function getItems(fromOutletId, keyword, page, namespace, isInit, isGetFromInit, previousAddItems, previousTotalPage, initData) {
  return { type: _constants.INVENTORY_TRANSFER_GET_ITEMS, payload: { fromOutletId: fromOutletId, keyword: keyword, page: page, namespace: namespace, isInit: isInit, isGetFromInit: isGetFromInit, previousAddItems: previousAddItems, previousTotalPage: previousTotalPage, initData: initData } };
}

function setAddItems(addItems) {
  return { type: _constants.INVENTORY_TRANSFER_SET_ADD_ITEMS, payload: { addItems: addItems } };
}

function resetAddItems() {
  return { type: _constants.INVENTORY_TRANSFER_RESET_ADD_ITEMS };
}

function setItemsOptionIsLoading(itemOptionIsLoading) {
  return { type: _constants.INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING, payload: { itemOptionIsLoading: itemOptionIsLoading } };
}

function onModalSelectChange(selectedItemId, items, transfers, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE, payload: { selectedItemId: selectedItemId, items: items, transfers: transfers, namespace: namespace } };
}

function onModalAddItems(items) {
  return { type: _constants.INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM, payload: { items: items } };
}

function closeAddItemModal() {
  return { type: _constants.INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL };
}

function resetTransfersForm() {
  return { type: _constants.INVENTORY_TRANSFER_RESET_TRANSFERS_FORM };
}

function setShowConfirmSubmitModal(isShowConfirmSubmitModal) {
  return { type: _constants.INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL, payload: { isShowConfirmSubmitModal: isShowConfirmSubmitModal } };
}

function onSubmitCreateTransfer(values) {
  return { type: _constants.INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM, payload: { values: values } };
}

function onConfirmCreateTransfer(values, date, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER, payload: { values: values, date: date, namespace: namespace } };
}

function exportTransfer(date, filename, outletId, namespace) {
  return { type: _constants.INVENTORY_TRANSFER_EXPORT, payload: { date: date, filename: filename, outletId: outletId, namespace: namespace } };
}

function setIsItemAlreadyAdded(isItemAlreadyAdded) {
  return { type: _constants.INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED, payload: { isItemAlreadyAdded: isItemAlreadyAdded } };
}

function onNamespaceChange(namespace) {
  return { type: _constants.INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE, payload: { namespace: namespace } };
}

function setExportButtonStatus(exportButtonStatus) {
  return { type: _constants.INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS, payload: { exportButtonStatus: exportButtonStatus } };
}

function setConfirmCreateButtonStatus(isClicked) {
  return { type: _constants.INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS, payload: { isClicked: isClicked } };
}

function setSearchItemsInit(itemInit) {
  return { type: _constants.INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT, payload: { itemInit: itemInit } };
}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAGE_SHOW_LOADING_SPINNER = exports.PAGE_SHOW_LOADING_SPINNER = 'PAGE_SHOW_LOADING_SPINNER';

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Account action constants
var SETTING_ACCOUNT_PAGE_REQUEST = exports.SETTING_ACCOUNT_PAGE_REQUEST = 'SETTING_ACCOUNT_PAGE_REQUEST';
var SETTING_ACCOUNT_REQUEST = exports.SETTING_ACCOUNT_REQUEST = 'SETTING_ACCOUNT_REQUEST';

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageRequest = pageRequest;
exports.updateSettingRequest = updateSettingRequest;
exports.setSetting = setSetting;

var _constant = __webpack_require__(420);

function pageRequest() {
  return { type: _constant.SETTING_CHECKOUT_PAGE_REQUEST, payload: {} };
}

function updateSettingRequest(data) {
  return { type: _constant.SETTING_CHECKOUT_UPDATE_SETTING, payload: { data: data } };
}

function setSetting(data) {
  return { type: _constant.SETTING_CHECKOUT_SET_SETTING, payload: { data: data } };
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Public Profile action constants
var SETTING_PUBLIC_PROFILE_PAGE_REQUEST = exports.SETTING_PUBLIC_PROFILE_PAGE_REQUEST = 'SETTING_PUBLIC_PROFILE_PAGE_REQUEST';
var SETTING_PUBLIC_PROFILE_CHANGE_FORM = exports.SETTING_PUBLIC_PROFILE_CHANGE_FORM = 'SETTING_PUBLIC_PROFILE_CHANGE_FORM';
var SETTING_PUBLIC_PROFILE_REQUEST = exports.SETTING_PUBLIC_PROFILE_REQUEST = 'SETTING_PUBLIC_PROFILE_REQUEST';
var SETTING_PUBLIC_PROFILE_DISCARD_CHANGE = exports.SETTING_PUBLIC_PROFILE_DISCARD_CHANGE = 'SETTING_PUBLIC_PROFILE_DISCARD_CHANGE';

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVerifyEmail = sendVerifyEmail;
exports.isInvalidTokenVerifyEmail = isInvalidTokenVerifyEmail;

var _constants = __webpack_require__(426);

function sendVerifyEmail(token) {
  return { type: _constants.SEND_VERIFY_EMAIL, payload: { access_token: token } };
}

function isInvalidTokenVerifyEmail(invalidTokenVerifyEmail) {
  return { type: _constants.VERIFY_EMAIL_INVALID_TOKEN, payload: { invalidTokenVerifyEmail: invalidTokenVerifyEmail } };
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVerifyEmailAlertRecipient = sendVerifyEmailAlertRecipient;
exports.isInvalidTokenVerifyEmailAlertRecipient = isInvalidTokenVerifyEmailAlertRecipient;
exports.setMessageVerifyEmailAlertRecipient = setMessageVerifyEmailAlertRecipient;

var _constants = __webpack_require__(427);

function sendVerifyEmailAlertRecipient(token) {
  return { type: _constants.SEND_VERIFY_EMAIL_ALERT_RECIPIENT, payload: { token: token } };
}

function isInvalidTokenVerifyEmailAlertRecipient(invalidTokenVerifyEmailAlertRecipient) {
  return { type: _constants.VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN, payload: { invalidTokenVerifyEmailAlertRecipient: invalidTokenVerifyEmailAlertRecipient } };
}

function setMessageVerifyEmailAlertRecipient(message) {
  return { type: _constants.SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT, payload: { message: message } };
}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCustomers = getCustomers;
exports.getCustomerDetail = getCustomerDetail;
exports.getRedemptionHistories = getRedemptionHistories;
exports.getPointActivities = getPointActivities;
exports.getCustomerTemplate = getCustomerTemplate;
exports.getCustomerExport = getCustomerExport;
exports.postCustomerFeedback = postCustomerFeedback;

var _constants = __webpack_require__(1070);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getCustomers(params) {
  return axios.get(_constants.CUSTOMERS, { params: params, withCredentials: false }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb#L35
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getCustomerDetail(customerId, params) {
  return axios.get((0, _constants.CUSTOMER_DETAIL)(customerId), { params: params }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getRedemptionHistories(customerId, params) {
  return axios.get((0, _constants.REDEMPTION_HISTORIES)(customerId), { params: params }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getPointActivities(customerId, params) {
  return axios.get((0, _constants.POINT_ACTIVITIES)(customerId), { params: params }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/customers_controller.rb
 * @param none
 * @return {Axios.IPromise<U>}
 */
function getCustomerTemplate() {
  return axios.get(_constants.CUSTOMERS_DOWNLOAD_TEMPLATE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getCustomerExport(params) {
  return axios.get(_constants.CUSTOMERS_EXPORT, { params: params }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function postCustomerFeedback(data) {
  return axios.post(_constants.CUSTOMERS_SUBMIT_FEEDBACK, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.endTutorial = endTutorial;

var _constants = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function endTutorial(featureName, params) {
  return axios.put(_constants.END_TUTORIAL, featureName, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (reject) {
    return _promise2.default.reject(reject);
  });
} /**
   * Created by alvinoktavianus on 6/29/17.
   */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.checkFeedbackToken = checkFeedbackToken;
exports.getFeedbackReplyForm = getFeedbackReplyForm;
exports.sendFeedbackReplyForm = sendFeedbackReplyForm;

var _constants = __webpack_require__(1080);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkFeedbackToken(token) {
  return axios.get(_constants.CHECK_TOKEN_FEEDBACK_URL, { params: { feedback_token: token } }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error.response);
  });
}

function getFeedbackReplyForm(feedbackId) {
  return axios.get((0, _constants.GET_FEEDBACK_REPLY_FORM)(feedbackId), {}).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function sendFeedbackReplyForm(data) {
  return axios
  // TODO: please comunication with backend team for change structure of params
  .post(_constants.SEND_FEEDBACK_REPLY_FORM, { comment: data.message, feedback_token: data.token }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_IMPORT_ADJUSTMENT_TEMPLATE = exports.V1_IMPORT_ADJUSTMENTS = exports.V1_EXPORT_ADJUSTMENT = exports.V1_ADJUSTMENTS = undefined;

var _constants = __webpack_require__(430);

var V1_ADJUSTMENTS = exports.V1_ADJUSTMENTS = _constants.V1_URL + '/adjustment';

var V1_EXPORT_ADJUSTMENT = exports.V1_EXPORT_ADJUSTMENT = V1_ADJUSTMENTS + '/export';

var V1_IMPORT_ADJUSTMENTS = exports.V1_IMPORT_ADJUSTMENTS = V1_ADJUSTMENTS + '/import_adjustments';

var V1_IMPORT_ADJUSTMENT_TEMPLATE = exports.V1_IMPORT_ADJUSTMENT_TEMPLATE = V1_ADJUSTMENTS + '/import_adjustment_template';

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT_ADJUSTMENT = exports.V1_IMPORT_ADJUSTMENT_TEMPLATE = exports.V1_IMPORT_ADJUSTMENTS = exports.V1_IMPORT_ADJUSTMENT_TEMPORARY = exports.V1_ADJUSTMENT = undefined;

var _constants = __webpack_require__(432);

var V1_ADJUSTMENT = exports.V1_ADJUSTMENT = _constants.V1_URL + '/adjustment';

var V1_IMPORT_ADJUSTMENT_TEMPORARY = exports.V1_IMPORT_ADJUSTMENT_TEMPORARY = V1_ADJUSTMENT + '/import_adjustments_temporary';

var V1_IMPORT_ADJUSTMENTS = exports.V1_IMPORT_ADJUSTMENTS = V1_ADJUSTMENT + '/import_adjustments';

var V1_IMPORT_ADJUSTMENT_TEMPLATE = exports.V1_IMPORT_ADJUSTMENT_TEMPLATE = V1_ADJUSTMENT + '/import_adjustment_template';

var V1_EXPORT_ADJUSTMENT = exports.V1_EXPORT_ADJUSTMENT = V1_ADJUSTMENT + '/export';

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSuppliers = getSuppliers;
exports.getExportSupplier = getExportSupplier;
exports.deleteSupplier = deleteSupplier;
exports.putSupplier = putSupplier;
exports.postSuppliers = postSuppliers;

var _constants = __webpack_require__(1102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getSuppliers(params) {
  return axios.get(_constants.V1_SUPPLIER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportSupplier(params) {
  return axios.get(_constants.V1_EXPORT_SUPPLIER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function deleteSupplier(id, params) {
  return axios.delete((0, _constants.V1_SUPPLIER_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function putSupplier(id, data, params) {
  return axios.put((0, _constants.V1_SUPPLIER_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postSuppliers(data, params) {
  return axios.post(_constants.V1_SUPPLIER, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getInvoices = getInvoices;
exports.getReceiptInvoices = getReceiptInvoices;
exports.createRecordPayment = createRecordPayment;
exports.resendEmail = resendEmail;
exports.printReceiptInvoicePdf = printReceiptInvoicePdf;
exports.exportInvoices = exportInvoices;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get invoices.
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/reports_controller.rb#L74
 * @param startDate, endDate, page, perPage
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getInvoices(queryparams) {
  return axios.get(_constants.INVOICES_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get receipt invoices.
 * @param ID invoice
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getReceiptInvoices(id, queryparams) {
  return axios.get((0, _constants.RECEIPT_INVOICES_URL)(id), { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Post record payment data to the server
 * @param id, paymentRecord
 */
function createRecordPayment(data) {
  return axios.post(_constants.RECORD_PAYMENT_URL, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

// Resend receipt to customer email
function resendEmail(invoiceId) {
  return axios.post((0, _constants.RESEND_EMAIL_URL)(invoiceId), {}, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

// Open generated receipt invoice pdf
function printReceiptInvoicePdf(invoiceId) {
  return window.open((0, _constants.PRINT_RECEIPT_INVOICE_PDF)(invoiceId));
}

function exportInvoices(query) {
  return axios.get(_constants.EXPORT_INVOICES, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCustomerTemplate = getCustomerTemplate;
exports.getExportItem = getExportItem;
exports.getItemTemplate = getItemTemplate;
exports.getItems = getItems;
exports.getItemById = getItemById;
exports.getSummary = getSummary;
exports.putItemById = putItemById;
exports.postItem = postItem;
exports.postCreateAllOutletItem = postCreateAllOutletItem;
exports.updateImageById = updateImageById;
exports.deleteItemByIdV1 = deleteItemByIdV1;
exports.getNewItem = getNewItem;

var _constants = __webpack_require__(1107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolve = function resolve(response) {
  return _promise2.default.resolve(response);
};

var reject = function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
};

function getCustomerTemplate() {
  return axios.get(_constants.ITEM_DOWNLOAD_TEMPLATE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getExportItem() {
  return axios.get(_constants.ITEMS_EXPORT, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
function getItemTemplate() {
  return axios.get(_constants.ITEMS_TEMPLATE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getItems(queryparams) {
  return axios.get(_constants.LIST_ITEM_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    // TODO low show the error message maybe?
    if (error.response) {
      var obj = new Error(new Error(error.message));
      obj.status = error.response.status;
      return _promise2.default.reject(obj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getItemById(id, params) {
  return axios.get((0, _constants.ITEM_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getSummary(queryParams) {
  return axios.get(_constants.ITEM_SUMMARY_URL, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function putItemById(id, data, params) {
  var postedData = (0, _extends3.default)({}, data, { item: (0, _extends3.default)({}, data.item, { updated_at: null }) });
  return axios.put((0, _constants.ITEM_BY_ID)(id), postedData, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postItem(data, params) {
  var postedData = (0, _extends3.default)({}, data, { item: (0, _extends3.default)({}, data.item, { updated_at: new Date(Date.now()), created_at: new Date(Date.now()) }) });
  return axios.post(_constants.CREATE_ITEM, postedData, { params: params, withCredentials: true }).then(resolve).catch(function (err) {
    var eobj = void 0;
    var data = err.response.data;
    if (data.errors && typeof data.errors === 'string') {
      eobj = new Error(data.errors);
    } else if (data.message && typeof data.message === 'string') {
      eobj = new Error(data.message);
    } else if (data.errors.length > 0) {
      eobj = new Error(data.errors[0]);
    }
    return _promise2.default.reject(eobj);
  });
}

function postCreateAllOutletItem(data, params) {
  var postedData = (0, _extends3.default)({}, data, { item: (0, _extends3.default)({}, data.item, { updated_at: new Date(Date.now()), created_at: new Date(Date.now()) }) });
  return axios.post(_constants.CREATE_ALL_OUTLET_ITEM, postedData, { params: params, withCredentials: true }).then(resolve).catch(function (err) {
    var eobj = void 0;
    var data = err.response.data;
    if (data.errors && typeof data.errors === 'string') {
      eobj = new Error(data.errors);
    } else if (data.message && typeof data.message === 'string') {
      eobj = new Error(data.message);
    } else if (data.errors.length > 0) {
      eobj = new Error(data.errors[0]);
    }
    return _promise2.default.reject(eobj);
  });
}

function updateImageById(id, data, params) {
  return axios.put((0, _constants.UPDATE_ITEM_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function deleteItemByIdV1(id, params) {
  return axios.delete((0, _constants.DELETE_ITEM_BY_ID_V1)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getNewItem(id, params) {
  return axios.get(_constants.GET_NEW_ITEM_V1, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.loginOutlet = loginOutlet;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/sessions_controller.rb#L65
 * @param payload
 * @return {IPromise<U>}
 */
function loginOutlet(payload) {
  return axios.patch(api.UPDATE_SELECTED_OUTLET, payload, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(true);
  }).catch(function (error) {
    if (error.response && error.response.data.error) {
      return _promise2.default.reject(new Error(error.response.data.error));
    } else {
      return _promise2.default.reject(error);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getModifiers = getModifiers;
exports.getModifiersV1 = getModifiersV1;
exports.getModifierById = getModifierById;
exports.postModifier = postModifier;
exports.deleteModifier = deleteModifier;
exports.putModifier = putModifier;
exports.postCreateAllOutlet = postCreateAllOutlet;
exports.postApplyToItems = postApplyToItems;
exports.getShowItemModifer = getShowItemModifer;

var _constants = __webpack_require__(1108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getModifiers(params) {
  return axios.get(_constants.MODIFIERS, { withCredentials: true, params: params }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getModifiersV1(params) {
  return axios.get(_constants.V1_MODIFIER, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getModifierById(id, params) {
  return axios.get((0, _constants.MODIFIER_BY_ID)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postModifier(data, params) {
  return axios.post(_constants.V1_MODIFIER, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data = error.response.data;
      if (_data.errors) {
        eobj = new Error(_data.errors);
      } else if (_data.message) {
        eobj = new Error(_data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function deleteModifier(id, params) {
  return axios.delete((0, _constants.V1_DELETE_MODIFIER)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function putModifier(id, data, params) {
  return axios.put((0, _constants.MODIFIER_BY_ID)(id), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data2 = error.response.data;
      if (_data2.errors) {
        eobj = new Error(_data2.errors);
      } else if (_data2.message) {
        eobj = new Error(_data2.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postCreateAllOutlet(data, params) {
  return axios.post(_constants.CREATE_ALL_OUTLET, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data3 = error.response.data;
      if (_data3.errors) {
        eobj = new Error(_data3.errors);
      } else if (_data3.message) {
        eobj = new Error(_data3.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postApplyToItems(modifierId, data, params) {
  return axios.post((0, _constants.V1_APPLY_TO_ITEMS)(modifierId), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data4 = error.response.data;
      if (_data4.errors) {
        eobj = new Error(_data4.errors);
      } else if (_data4.message) {
        eobj = new Error(_data4.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function getShowItemModifer(modifierId, params) {
  return axios.get((0, _constants.V1_SHOW_ITEM_MODIFIER)(modifierId), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSalesSummary = getSalesSummary;
exports.getGrossProfit = getGrossProfit;
exports.getPaymentMethods = getPaymentMethods;
exports.getItemSales = getItemSales;
exports.getCategorySales = getCategorySales;
exports.getModifierSales = getModifierSales;
exports.getDiscounts = getDiscounts;
exports.getTaxes = getTaxes;
exports.getGratuities = getGratuities;
exports.getStaffs = getStaffs;
exports.getServers = getServers;
exports.exportTransaction = exportTransaction;
exports.exportSummary = exportSummary;
exports.exportGrossProfit = exportGrossProfit;
exports.exportPaymentMethod = exportPaymentMethod;
exports.exportItemSales = exportItemSales;
exports.exportCategorySales = exportCategorySales;
exports.exportModifierSales = exportModifierSales;
exports.exportDiscounts = exportDiscounts;
exports.exportTaxes = exportTaxes;
exports.exportGratuity = exportGratuity;
exports.exportColectedBy = exportColectedBy;
exports.exportServedBy = exportServedBy;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get sales summary.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getSalesSummary(queryparams) {
  return axios.get('' + api.SALES_SUMMARY_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getGrossProfit(queryparams) {
  return axios.get('' + api.GROSS_PROFIT_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get payment methods.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getPaymentMethods(queryparams) {
  return axios.get('' + api.PAYMENT_METHODS_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get item sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getItemSales(queryparams) {
  return axios.get('' + api.ITEM_SALES_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get category sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getCategorySales(queryparams) {
  return axios.get('' + api.CATEGORY_SALES_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get modifier sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getModifierSales(queryparams) {
  return axios.get('' + api.MODIFIER_SALES_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get discounts.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getDiscounts(queryparams) {
  return axios.get('' + api.DISCOUNTS_URL, { params: queryparams, withCredentials: false }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get taxes.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getTaxes(queryparams) {
  return axios.get('' + api.TAXES_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get Gratuities.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getGratuities(queryparams) {
  return axios.get('' + api.GRATUITY_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get Collected By data (staff).
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getStaffs(queryparams) {
  return axios.get('' + api.COLLECTEDBY_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get servers.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getServers(queryparams) {
  return axios.get('' + api.SERVEDBY_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function exportTransaction(query) {
  return axios.get('' + api.EXPORT_TRANSACTION, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportSummary(query) {
  return axios.get('' + api.EXPORT_SUMMARY, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportGrossProfit(query) {
  return axios.get('' + api.EXPORT_GROSS_PROFIT, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportPaymentMethod(query) {
  return axios.get('' + api.EXPORT_PAYMENT_METHOD, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportItemSales(query) {
  return axios.get('' + api.EXPORT_ITEM_SALES, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportCategorySales(query) {
  return axios.get('' + api.EXPORT_CATEGORY_SALES, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportModifierSales(query) {
  return axios.get('' + api.EXPORT_MODIFIER_SALES, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportDiscounts(query) {
  return axios.get('' + api.EXPORT_DISCOUNT, { params: query, withCredentials: false }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportTaxes(query) {
  return axios.get('' + api.EXPORT_TAXES, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportGratuity(query) {
  return axios.get('' + api.EXPORT_GRATUITY, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportColectedBy(query) {
  return axios.get('' + api.EXPORT_COLLECTEDBY, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}

function exportServedBy(query) {
  return axios.get('' + api.EXPORT_SERVEDBY, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = new Error(error.response.errors);
      return _promise2.default.reject(eobj);
    }
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOutletId = exports.getBusinessId = undefined;

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getTaxes = getTaxes;
exports.getTaxService = getTaxService;
exports.getTaxDetail = getTaxDetail;
exports.getTaxItemDetail = getTaxItemDetail;
exports.getTaxItemDetailCustomAmount = getTaxItemDetailCustomAmount;
exports.getItemCustomAmount = getItemCustomAmount;
exports.filterTaxItem = filterTaxItem;
exports.updateTax = updateTax;
exports.createTax = createTax;
exports.deleteTax = deleteTax;
exports.createTaxAllOutlets = createTaxAllOutlets;

var _constants = __webpack_require__(1116);

var _callbacks = __webpack_require__(1061);

var _effects = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getTaxService, getTaxDetail, getTaxItemDetail, getTaxItemDetailCustomAmount, getItemCustomAmount, filterTaxItem, updateTax, createTax, deleteTax, createTaxAllOutlets].map(_regenerator2.default.mark);

var getBusinessId = exports.getBusinessId = function getBusinessId(state) {
  return state.moka.user.business.id;
};
var getOutletId = exports.getOutletId = function getOutletId(state) {
  return state.form.search.values.outletIds[0];
};

function getTaxes(params) {
  return axios.get(_constants.LIBRARY_TAXES, { params: params, withCredentials: true }).then(_callbacks.serviceAccountSuccessCallback).catch(_callbacks.serviceAccountErrorCallback);
}

function getTaxService(params) {
  var outletId;
  return _regenerator2.default.wrap(function getTaxService$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(getOutletId);

        case 2:
          outletId = _context.sent;

          console.log('getTaxService', outletId);
          _context.next = 6;
          return axios.get((0, _constants.GET_TAX_SERVICE)(outletId), { params: params, withCredentials: false });

        case 6:
          return _context.abrupt('return', _context.sent);

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function getTaxDetail(id, params) {
  return _regenerator2.default.wrap(function getTaxDetail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return axios.get((0, _constants.GET_TAX_BY_ID_SERVICE)(id), { params: params, withCredentials: false });

        case 2:
          return _context2.abrupt('return', _context2.sent);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function getTaxItemDetail(id, params) {
  return _regenerator2.default.wrap(function getTaxItemDetail$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return axios.get((0, _constants.GET_TAXITEMS_BY_ID_SERVICE)(id), { params: params, withCredentials: false });

        case 2:
          return _context3.abrupt('return', _context3.sent);

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function getTaxItemDetailCustomAmount(id, params) {
  return _regenerator2.default.wrap(function getTaxItemDetailCustomAmount$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return axios.get((0, _constants.GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE)(id), { params: params, withCredentials: false });

        case 2:
          return _context4.abrupt('return', _context4.sent);

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function getItemCustomAmount(params) {
  var outletId;
  return _regenerator2.default.wrap(function getItemCustomAmount$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getOutletId);

        case 2:
          outletId = _context5.sent;
          _context5.next = 5;
          return axios.get((0, _constants.GET_ITEM_CUSTOM_AMOUNT_SERVICE)(outletId), { params: params, withCredentials: false });

        case 5:
          return _context5.abrupt('return', _context5.sent);

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function filterTaxItem(categoryId, name, params) {
  var outletId;
  return _regenerator2.default.wrap(function filterTaxItem$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(getOutletId);

        case 2:
          outletId = _context6.sent;
          _context6.next = 5;
          return axios.get((0, _constants.GET_ITEM_SERVICE)(outletId, categoryId, name), { params: params, withCredentials: false });

        case 5:
          return _context6.abrupt('return', _context6.sent);

        case 6:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateTax(id, data, params) {
  return _regenerator2.default.wrap(function updateTax$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return axios.put((0, _constants.PUT_TAX_BY_ID_SERVICE)(id), data, { params: params, withCredentials: false });

        case 2:
          return _context7.abrupt('return', _context7.sent);

        case 3:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function createTax(data, params) {
  return _regenerator2.default.wrap(function createTax$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return axios.post((0, _constants.POST_TAX_BY_ID_SERVICE)(), data, { params: params, withCredentials: false });

        case 2:
          return _context8.abrupt('return', _context8.sent);

        case 3:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function deleteTax(id, params) {
  return _regenerator2.default.wrap(function deleteTax$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return axios.delete((0, _constants.DELETE_TAX_BY_ID_SERVICE)(id), { params: params, withCredentials: false });

        case 2:
          return _context9.abrupt('return', _context9.sent);

        case 3:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function createTaxAllOutlets(data, params) {
  return _regenerator2.default.wrap(function createTaxAllOutlets$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return axios.post((0, _constants.POST_TAX_BY_ID_SERVICE)(), data, { params: params, withCredentials: false });

        case 2:
          return _context10.abrupt('return', _context10.sent);

        case 3:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getImage = getImage;
exports.getLoadingImage = getLoadingImage;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get filename to be uploaded.
 * @param filename
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getImage(queryparams) {
  return axios.get(_constants.GET_NEW_IMAGE_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getLoadingImage() {
  return axios.get(_constants.GET_LOADING_IMAGE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ic_locked2x = __webpack_require__(2863);

var _ic_locked2x2 = _interopRequireDefault(_ic_locked2x);

var _FeatureBlockerPage = __webpack_require__(1946);

var _FeatureBlockerPage2 = _interopRequireDefault(_FeatureBlockerPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureBlockerPage = function FeatureBlockerPage() {
  return _react2.default.createElement(
    'div',
    { className: _FeatureBlockerPage2.default['blocker-page'] },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        { className: 'text-center' },
        _react2.default.createElement('img', { src: _ic_locked2x2.default, className: 'img-circle ' + _FeatureBlockerPage2.default['padlock'] })
      ),
      _react2.default.createElement(
        'h3',
        { className: 'text-center' },
        'Feature Locked'
      ),
      _react2.default.createElement(
        'p',
        { className: 'text-center ' + _FeatureBlockerPage2.default['blocker-message'] },
        'Please contact your business owner to activate this feature.'
      )
    )
  );
}; /**
    * Created by alvinoktavianus on 7/21/17.
    */

exports.default = FeatureBlockerPage;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DescriptiveSwitchField = __webpack_require__(1130);

var _DescriptiveSwitchField2 = _interopRequireDefault(_DescriptiveSwitchField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DescriptiveSwitchField2.default;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingFieldWithIcon = __webpack_require__(1964);

var _SettingFieldWithIcon2 = _interopRequireDefault(_SettingFieldWithIcon);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingFieldWithIcon = function (_React$Component) {
  (0, _inherits3.default)(SettingFieldWithIcon, _React$Component);

  function SettingFieldWithIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SettingFieldWithIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SettingFieldWithIcon.__proto__ || (0, _getPrototypeOf2.default)(SettingFieldWithIcon)).call.apply(_ref, [this].concat(args))), _this), _this._onChange = function (e) {
      var nextVal = e.target.value;
      var _this$props = _this.props,
          positiveNumberOnly = _this$props.positiveNumberOnly,
          onChange = _this$props.input.onChange,
          maxFractionDigits = _this$props.maxFractionDigits;

      if (isNaN(nextVal) && positiveNumberOnly) {
        // case if one digit < 0 integer
        if (nextVal === '-') {
          onChange(e, '');
        } else {
          // no op. invalid change
        }
      } else if (maxFractionDigits !== undefined) {
        // we must check also if == 0, so we check using undefined instead of comparing zero values (!maxFractionDigits
        var dotPosition = nextVal.indexOf('.');
        if (dotPosition !== -1 && nextVal.length - dotPosition - 1 > maxFractionDigits) {
          // no op. invalid change
        } else {
          onChange(e, nextVal);
        }
      } else {
        onChange(e, nextVal);
      }
    }, _this._renderFeedback = function () {
      var error = _this.props.meta.error;

      return error ? React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: React.createElement(
            _reactBootstrap.Tooltip,
            { id: 'tooltip' },
            error
          ) },
        React.createElement('span', {
          className: _SettingFieldWithIcon2.default['icon-addon'] + ' form-control-feedback glyphicon glyphicon-remove',
          style: { 'pointer-events': 'auto', 'cursor': 'pointer' }
        })
      ) : React.createElement('span', { className: _SettingFieldWithIcon2.default['icon-addon'] + ' form-control-feedback glyphicon glyphicon-ok' });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SettingFieldWithIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          maxLength = _props.maxLength,
          icon = _props.icon;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        { className: touched ? error ? 'has-feedback has-error' : 'has-feedback has-success' : '' },
        React.createElement(
          'div',
          { className: 'input-group' },
          React.createElement('input', (0, _extends3.default)({}, input, {
            type: type,
            readOnly: readOnly,
            maxLength: maxLength,
            className: 'form-control',
            placeholder: placeholder,
            onChange: this._onChange
          })),
          touched ? this._renderFeedback() : '',
          React.createElement(
            'div',
            { className: 'input-group-addon' },
            icon
          )
        )
      );
    }
  }]);
  return SettingFieldWithIcon;
}(React.Component);

SettingFieldWithIcon.propTypes = {
  positiveNumberOnly: React.PropTypes.bool,
  maxFractionDigits: React.PropTypes.number
};

exports.default = SettingFieldWithIcon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _styleForm = __webpack_require__(1967);

var _styleForm2 = _interopRequireDefault(_styleForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordField = function (_React$Component) {
  (0, _inherits3.default)(ResetPasswordField, _React$Component);

  function ResetPasswordField() {
    (0, _classCallCheck3.default)(this, ResetPasswordField);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordField.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPasswordField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          maxLength = _props.maxLength;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _styleForm2.default['field-wrapper'] },
          React.createElement('input', (0, _extends3.default)({}, input, {
            type: type,
            maxLength: maxLength,
            placeholder: placeholder,
            className: _styleForm2.default['field-input']
          }))
        ),
        React.createElement(
          'small',
          { className: 'error ' + _styleForm2.default['text-error-reset'] },
          touched ? error : ''
        )
      );
    }
  }]);
  return ResetPasswordField;
}(React.Component);

ResetPasswordField.propTypes = {
  icon: React.PropTypes.string
};

exports.default = ResetPasswordField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _style = __webpack_require__(1998);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoyaltyInfo = function (_Component) {
  (0, _inherits3.default)(LoyaltyInfo, _Component);

  function LoyaltyInfo() {
    (0, _classCallCheck3.default)(this, LoyaltyInfo);
    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyInfo.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoyaltyInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loyalty = _props.loyalty,
          memberPhone = _props.memberPhone;

      return _react2.default.createElement(
        'div',
        { className: '' + _style2.default['receipt-loyalty-info'] },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: _style2.default.title + ' pull-left' },
            'Loyalty Program'
          ),
          _react2.default.createElement('div', { className: 'clearfix' })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'pull-left' },
            'Member Since'
          ),
          _react2.default.createElement(
            'span',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(loyalty.member_since, 'date')
          ),
          _react2.default.createElement('span', { className: 'clearfix' })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'pull-left' },
            'Member Number'
          ),
          _react2.default.createElement(
            'span',
            { className: 'pull-right' },
            memberPhone
          ),
          _react2.default.createElement('span', { className: 'clearfix' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'top20' },
          this.props.isUnpaidInvoiceEarningPoints ? _react2.default.createElement(
            'div',
            { style: { opacity: '0.8', fontSize: '12px' } },
            'Member can earn ',
            (0, _formatter.formatDecimal)(loyalty.new_earned_points + loyalty.new_member_points),
            ' points after the invoice payment is fully paid.'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'pull-left' },
              'Loyalty Program'
            ),
            _react2.default.createElement('div', { className: 'clearfix' }),
            _react2.default.createElement(
              'div',
              { className: '' + _style2.default['loyalty-info-detail'] },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Current Balance'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.current_balance)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              Boolean(loyalty.new_member_points) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'New Member Points'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.new_member_points)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'New Earned Points'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.new_earned_points)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Redeemed in This Purchase'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.redemption ? loyalty.redemption.redeem_points : 0)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Closing Balance'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.closing_balance)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              )
            )
          )
        )
      );
    }
  }]);
  return LoyaltyInfo;
}(_react.Component);

LoyaltyInfo.propTypes = {
  loyalty: _react.PropTypes.object
};

exports.default = LoyaltyInfo;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _style = __webpack_require__(2000);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundedLoyaltyInfo = function (_Component) {
  (0, _inherits3.default)(RefundedLoyaltyInfo, _Component);

  function RefundedLoyaltyInfo() {
    (0, _classCallCheck3.default)(this, RefundedLoyaltyInfo);
    return (0, _possibleConstructorReturn3.default)(this, (RefundedLoyaltyInfo.__proto__ || (0, _getPrototypeOf2.default)(RefundedLoyaltyInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefundedLoyaltyInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loyalty = _props.loyalty,
          memberPhone = _props.memberPhone;

      return _react2.default.createElement(
        'div',
        { className: '' + _style2.default['refunded-loyalty-info'] },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: _style2.default.title + ' pull-left' },
            'Loyalty Program'
          ),
          _react2.default.createElement('div', { className: 'clearfix' })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'pull-left' },
            'Member Since'
          ),
          _react2.default.createElement(
            'span',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(loyalty.member_since, 'date')
          ),
          _react2.default.createElement('span', { className: 'clearfix' })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'pull-left' },
            'Member Number'
          ),
          _react2.default.createElement(
            'span',
            { className: 'pull-right' },
            memberPhone
          ),
          _react2.default.createElement('span', { className: 'clearfix' })
        ),
        !this.props.isUnpaidInvoiceEarningPoints && _react2.default.createElement(
          'div',
          { className: 'top20' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'pull-left' },
              'Loyalty Program'
            ),
            _react2.default.createElement('div', { className: 'clearfix' }),
            _react2.default.createElement(
              'div',
              { className: '' + _style2.default['loyalty-info-detail'] },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Current Balance'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.current_balance)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Point Correction'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  loyalty.point_correction ? '(' + (0, _formatter.formatDecimal)(Math.abs(loyalty.point_correction)) + ')' : (0, _formatter.formatDecimal)(Math.abs(loyalty.point_correction))
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'pull-left' },
                  'Closing Balance'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  (0, _formatter.formatDecimal)(loyalty.closing_balance)
                ),
                _react2.default.createElement('span', { className: 'clearfix' })
              )
            )
          )
        )
      );
    }
  }]);
  return RefundedLoyaltyInfo;
}(_react.Component);

RefundedLoyaltyInfo.propTypes = {
  loyalty: _react.PropTypes.object
};

exports.default = RefundedLoyaltyInfo;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(2002);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptButtonGroup = function (_React$Component) {
  (0, _inherits3.default)(ReceiptButtonGroup, _React$Component);

  function ReceiptButtonGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptButtonGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(ReceiptButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this._disabledButton = function (status) {
      if (status === 'cancelled' || status === 'paid') {
        return true;
      } else {
        return false;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          clickResendButton = _props.clickResendButton,
          invoiceDetail = _props.invoiceDetail,
          onClickRecordPayment = _props.onClickRecordPayment,
          onClickPrintButton = _props.onClickPrintButton,
          onCancelInvoice = _props.onCancelInvoice;


      return React.createElement(
        'div',
        { className: 'mk-col-right-action-box bottom invoice' },
        React.createElement(
          'button',
          {
            className: 'btn btn-default pull-left resend-invoice ' + _style2.default.resend,
            onClick: clickResendButton },
          invoiceDetail.invoice_status === 'paid' ? 'Send Receipt' : 'Resend'
        ),
        React.createElement(
          'div',
          { className: 'btn-group pull-right ' + _style2.default['mr-btn'] },
          React.createElement(
            'button',
            {
              'aria-expanded': 'false',
              className: 'btn btn-default dropdown-toggle invoice',
              'data-toggle': 'dropdown' },
            'More\xA0',
            React.createElement('b', { className: 'caret invoice' })
          ),
          React.createElement(
            'ul',
            { className: 'dropdown-menu import-export-menu invoice', role: 'menu' },
            invoiceDetail.invoice_status !== 'cancelled' && React.createElement(
              'li',
              { onClick: onCancelInvoice },
              React.createElement(
                'a',
                null,
                'Cancel Invoice'
              )
            ),
            React.createElement(
              'li',
              { onClick: onClickPrintButton },
              React.createElement(
                _reactRouter.Link,
                { target: '_blank' },
                'Print'
              )
            )
          )
        ),
        React.createElement(
          'button',
          {
            className: 'btn btn-primary mr-20px pull-right',
            id: _style2.default['btn-record-payment'],
            onClick: onClickRecordPayment,
            disabled: this._disabledButton(invoiceDetail.invoice_status) },
          'Record Payment'
        )
      );
    }
  }]);
  return ReceiptButtonGroup;
}(React.Component);

ReceiptButtonGroup.propTypes = {
  clickResendButton: React.PropTypes.func,
  invoiceDetail: React.PropTypes.object,
  onClickRecordPayment: React.PropTypes.func,
  onClickPrintButton: React.PropTypes.func,
  onCancelInvoice: React.PropTypes.func
};

exports.default = ReceiptButtonGroup;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _ItemTable = __webpack_require__(749);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTable = function (_React$Component) {
  (0, _inherits3.default)(ItemTable, _React$Component);

  function ItemTable() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemTable.__proto__ || (0, _getPrototypeOf2.default)(ItemTable)).call.apply(_ref, [this].concat(args))), _this), _this._percentageDiscountFormatter = function (discount) {
      return parseFloat(discount);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          checkouts = _props.checkouts,
          checkoutPriceFormatter = _props.checkoutPriceFormatter;

      return React.createElement(
        'table',
        { className: 'table table-responsive no-border ' + _ItemTable2.default['checkout-table'] },
        React.createElement(
          'tbody',
          null,
          checkouts.map(function (checkout) {
            return React.createElement(
              'tr',
              { key: checkout.id },
              React.createElement(
                'td',
                { className: _ItemTable2.default['checkout-cell'] },
                React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-main'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    (0, _formatter.limitTo)(checkout.item_name, 25),
                    ' ',
                    checkout.item_name.length > 25 ? '...' : ''
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-center'] },
                    'x',
                    Math.abs(checkout.quantity)
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-right'] },
                    checkoutPriceFormatter(checkout.price)
                  )
                ),
                checkout.item_variant_name && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-variant-box'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    (0, _formatter.limitTo)(checkout.item_variant_name, 45),
                    ' ',
                    checkout.item_variant_name.length > 45 ? '...' : ''
                  )
                ),
                checkout.modifiers.length > 0 && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-modifier-box'] },
                  checkout.modifiers.map(function (modifier, i) {
                    return React.createElement(
                      'div',
                      { className: _ItemTable2.default['item-modifier'], key: i },
                      React.createElement(
                        'div',
                        { className: _ItemTable2.default['text-left'] },
                        (0, _formatter.limitTo)(modifier.modifier_name, 15),
                        ' ',
                        modifier.modifier_name.length > 15 ? '...' : '',
                        ' - \xA0',
                        (0, _formatter.limitTo)(modifier.modifier_option_name, 15),
                        ' ',
                        modifier.modifier_option_name.length > 15 ? '...' : '',
                        ' - \xA0',
                        (0, _formatter.rupiah)(modifier.price)
                      ),
                      React.createElement('div', { className: _ItemTable2.default['text-right'] })
                    );
                  })
                ),
                checkout.discounts.length > 0 && React.createElement(
                  'div',
                  { className: _ItemTable2.default['discount-box'] },
                  checkout.discounts.map(function (discount) {
                    return discount.discount_hash.map(function (disc, i) {
                      return disc.discount_type === 'percentage' && React.createElement(
                        'div',
                        { className: _ItemTable2.default['discount'], key: i },
                        React.createElement(
                          'div',
                          { className: _ItemTable2.default['text-left'] },
                          (0, _formatter.limitTo)(disc.discount_name, 25),
                          ' ',
                          disc.discount_name.length > 25 ? '...' : '',
                          '(',
                          _this2._percentageDiscountFormatter(disc.discount_percentage),
                          '%)'
                        ),
                        React.createElement(
                          'div',
                          { className: _ItemTable2.default['text-right'] },
                          (0, _formatter.rupiahWithNegative)(disc.discount_amount * -1)
                        )
                      );
                    });
                  })
                ),
                checkout.note && React.createElement(
                  'div',
                  { className: _ItemTable2.default['item-note'] },
                  React.createElement(
                    'div',
                    { className: _ItemTable2.default['text-left'] },
                    React.createElement(
                      'span',
                      null,
                      React.createElement(
                        'div',
                        null,
                        checkout.note
                      )
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);
  return ItemTable;
}(React.Component);

ItemTable.propTypes = {
  checkouts: React.PropTypes.array,
  checkoutPriceFormatter: React.PropTypes.func
};

exports.default = ItemTable;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Discount = __webpack_require__(2012);

var _Discount2 = _interopRequireDefault(_Discount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discount = function (_React$Component) {
  (0, _inherits3.default)(Discount, _React$Component);

  function Discount() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Discount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Discount.__proto__ || (0, _getPrototypeOf2.default)(Discount)).call.apply(_ref, [this].concat(args))), _this), _this._calculateDiscount = function (discountId) {
      return _this.props.calculateDiscount(discountId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Discount, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var paymentDiscounts = this.props.paymentDiscounts;

      return paymentDiscounts.length > 0 && React.createElement(
        'div',
        { className: 'row discount-row border-on-bottom' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'label',
            null,
            'Discount'
          ),
          React.createElement(
            'table',
            { className: 'table mk-table-summary table-truncate' },
            React.createElement(
              'tbody',
              null,
              paymentDiscounts.map(function (discount, idxdisc) {
                return React.createElement(
                  'tr',
                  { key: idxdisc },
                  React.createElement(
                    'td',
                    { width: '55%', className: 'name-item-refund tax-grat-disc' },
                    discount.discount_name
                  ),
                  React.createElement(
                    'td',
                    { width: '45%', className: 'text-right price text-gray no-border ' + _Discount2.default['discount-price'] },
                    (0, _formatter.rupiahWithNegative)(-_this2._calculateDiscount(discount.discount_id))
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Discount;
}(React.Component);

Discount.propTypes = {
  paymentDiscounts: React.PropTypes.array,
  calculateDiscount: React.PropTypes.func
};

exports.default = Discount;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Gratuity = __webpack_require__(2013);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gratuity = function (_React$Component) {
  (0, _inherits3.default)(Gratuity, _React$Component);

  function Gratuity() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Gratuity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Gratuity.__proto__ || (0, _getPrototypeOf2.default)(Gratuity)).call.apply(_ref, [this].concat(args))), _this), _this._calculateGratuity = function (gratuityId) {
      return _this.props.calculateGratuity(gratuityId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Gratuity, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          paymentGratuities = _props.paymentGratuities,
          includeGratuityTax = _props.includeGratuityTax;


      return paymentGratuities.length > 0 && React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'label',
            null,
            'Gratuity'
          ),
          React.createElement(
            'table',
            { className: 'table mk-table-summary table-truncate' },
            React.createElement(
              'tbody',
              null,
              paymentGratuities.map(function (gratuity, idxdisc) {
                return React.createElement(
                  'tr',
                  { key: idxdisc },
                  React.createElement(
                    'td',
                    { width: '70%', className: 'name-item-refund tax-grat-disc', style: { border: 'none !important' } },
                    gratuity.name,
                    ' ',
                    includeGratuityTax && '(Included)'
                  ),
                  React.createElement(
                    'td',
                    { width: '30%', className: 'text-right price text-gray ' + _Gratuity2.default['grat-price'], style: { border: 'none !important' } },
                    !includeGratuityTax && (0, _formatter.rupiah)(_this2._calculateGratuity(gratuity.id))
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Gratuity;
}(React.Component);

Gratuity.propTypes = {
  paymentGratuities: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool,
  // calculateGratuity(gratuity_id)
  calculateGratuity: React.PropTypes.func
};

exports.default = Gratuity;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Item = __webpack_require__(2014);

var _Item2 = _interopRequireDefault(_Item);

var _SetQuantityModal = __webpack_require__(1182);

var _SetQuantityModal2 = _interopRequireDefault(_SetQuantityModal);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_React$Component) {
  (0, _inherits3.default)(Item, _React$Component);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

    _this._isSelectedAll = function () {
      return _this.props.isSelectedAll();
    };

    _this._isChecked = function (idx) {
      return _this.props.isChecked(idx);
    };

    _this._isRefunded = function (idx) {
      return _this.props.isRefunded(idx);
    };

    _this._canBeRefunded = function (idx) {
      return _this.props.canBeRefunded(idx);
    };

    _this._canSelectAll = function () {
      return _this.props.canSelectAll();
    };

    _this._onClickCheck = function (idx) {
      return _this.props.onClickCheck(idx);
    };

    _this._onClickSelectAll = function (idx) {
      return _this.props.onClickSelectAll(idx);
    };

    _this._onClickDeselectAll = function (idx) {
      return _this.props.onClickDeselectAll(idx);
    };

    _this._onClickIncreaseQty = function (idx) {
      return _this.props.onClickIncreaseQty(idx);
    };

    _this._onClickDecreaseQty = function (idx) {
      return _this.props.onClickDecreaseQty(idx);
    };

    _this._onChangeInputAmountRefunded = function (idx, newValue) {
      return _this.props.onChangeInputAmountRefunded(idx, newValue);
    };

    _this._calculateItemPrice = function (idx) {
      return _this.props.calculateItemPrice(idx);
    };

    _this._askSetQuantity = function (idx, refundAmount) {
      return _this.props.onAskSetQtyModal(idx, refundAmount);
    };

    _this._cancelSetQuantity = function () {
      return _this.props.onCancelSetQtyModal();
    };

    _this._onSubmitSetQuantity = function (values) {
      var idx = values.idx,
          quantity = values.quantity;

      return _this.props.onConfirmSetQtyModal(idx, quantity);
    };

    _this._renderNonMobileTable = function (refundItems, selectedRow) {
      return React.createElement(
        'table',
        { className: 'table mk-table-summary table-truncate item-refund-breakdown' },
        refundItems.map(function (refundItem, idx) {
          var itemName = refundItem.itemName,
              itemVariantName = refundItem.itemVariantName,
              refundAmount = refundItem.refundAmount;

          return React.createElement(
            'div',
            { key: idx, className: 'row ' + _Item2.default['separator'] },
            React.createElement(
              'div',
              { className: 'col-md-6 col-xs-7 qty-box-left', style: { border: 'none !important' } },
              React.createElement(
                'div',
                { className: 'top-8 text-elipsis' },
                itemName,
                ' ',
                itemVariantName
              ),
              React.createElement(
                'p',
                { className: _Item2.default['refund-item-price'] },
                (0, _formatter.rupiah)(_this._calculateItemPrice(idx))
              )
            ),
            React.createElement(
              'div',
              { className: 'col-xs-2 no-border quantity-refund-breakdown text-right visible-xs visible-sm' },
              React.createElement(
                'div',
                { className: 'input-group box-quantity-refund' },
                'x ',
                refundAmount
              )
            ),
            React.createElement(
              'div',
              { className: !_this.props.showCheckbox ? 'col-md-6 col-xs-3' : 'col-md-6 col-xs-3 ' + _Item2.default['qty-checkbox'] },
              React.createElement(
                'div',
                { className: !_this.props.showCheckbox ? 'col-md-9 visible-lg visible-md no-border qty-box ' + _Item2.default['padTop'] : 'col-md-9 visible-lg visible-md no-border ' + _Item2.default['padTop-mrLeft'] },
                React.createElement(
                  'div',
                  { className: 'input-group ' + (_this._canBeRefunded(idx) ? _this._isRefunded(idx) ? _Item2.default['is-refunded'] : _Item2.default['is-not-refunded'] : _Item2.default['cannot-be-refunded']) },
                  React.createElement(
                    'span',
                    { className: 'input-group-addon ' + _Item2.default['add-qty-button'] + ' ' + (_this._canBeRefunded(idx) ? _Item2.default['can-be-refunded'] : _Item2.default['cannot-be-refunded']),
                      onClick: function onClick() {
                        !_this._isChecked(idx) || !_this._canBeRefunded(idx) ? function () {} : _this._onClickDecreaseQty(idx);
                      } },
                    React.createElement('i', { className: 'fa fa-minus' })
                  ),
                  React.createElement('input', {
                    className: 'form-control text-center ' + _Item2.default['add-qty-input'],
                    disabled: !_this._isChecked(idx) || !_this._canBeRefunded(idx),
                    value: _this.state.amounts[idx],
                    onChange: function onChange(e) {
                      if (!isNaN(e.target.value)) {
                        _this.state.amounts[idx] = e.target.value < 0 ? _this.state.amounts[idx] : e.target.value;
                        _this.setState({ amounts: _this.state.amounts });
                      }
                    },
                    onBlur: function onBlur(e) {
                      _this._onChangeInputAmountRefunded(idx, e.target.value);
                    }
                  }),
                  React.createElement(
                    'span',
                    { className: 'input-group-addon ' + _Item2.default['add-qty-button'] + ' ' + (_this._canBeRefunded(idx) ? _Item2.default['can-be-refunded'] : _Item2.default['cannot-be-refunded']),
                      onClick: function onClick() {
                        !_this._isChecked(idx) || !_this._canBeRefunded(idx) ? function () {} : _this._onClickIncreaseQty(idx);
                      } },
                    React.createElement('i', { className: 'fa fa-plus' })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: !_this.props.showCheckbox ? 'col-md-3 col-xs-12' : 'col-md-3 col-xs-12 ' + _Item2.default['right-checkbox'] },
                _this._canBeRefunded(idx) && React.createElement(
                  'div',
                  { className: 'checkbox-refund-breakdown no-border' },
                  React.createElement(
                    'div',
                    { className: 'top-8 checkbox-input pull-right' },
                    React.createElement(
                      'div',
                      { className: 'checkbox pull-right checkbox-primary checkbox-circle ' + _Item2.default['refund-checkbox'] },
                      React.createElement('input', { type: 'checkbox', onClick: function onClick() {
                          return _this._onClickCheck(idx);
                        }, checked: _this._isChecked(idx) }),
                      React.createElement(
                        'label',
                        null,
                        '\xA0'
                      )
                    )
                  )
                )
              )
            )
          );
        })
      );
    };

    _this._renderMobileTable = function (refundItems, selectedRow) {
      return React.createElement(
        'table',
        { className: 'table mk-table-summary table-truncate item-refund-breakdown item-refund-mobile' },
        refundItems.map(function (refundItem, idx) {
          var itemName = refundItem.itemName,
              itemVariantName = refundItem.itemVariantName,
              refundAmount = refundItem.refundAmount;

          return React.createElement(
            'tr',
            { width: '90%', key: idx, className: 'box-item-name list-item-to-refund', id: _Item2.default['item-mobi'] },
            React.createElement(
              'td',
              { className: 'name-item-refund no-padding', style: { border: 'none !important' }, onClick: !_this._isChecked(idx) || !_this._canBeRefunded(idx) ? function () {} : function () {
                  return _this._askSetQuantity(idx, refundAmount);
                } },
              React.createElement(
                'div',
                { className: 'top-8 text-elipsis' },
                itemName,
                ' ',
                itemVariantName
              ),
              React.createElement(
                'p',
                { className: _Item2.default['refund-item-price'] },
                (0, _formatter.rupiah)(_this._calculateItemPrice(idx))
              ),
              !_this.props.showCheckbox && React.createElement(
                'div',
                { className: 'input-group ' + _Item2.default['is-not-refunded'] + ' ' + _Item2.default['cannot-be-refunded'] },
                React.createElement(
                  'span',
                  { className: 'input-group-addon ' + _Item2.default['add-qty-button'] + ' ' + _Item2.default['cannot-be-refunded'] },
                  React.createElement('i', { className: 'fa fa-minus' })
                ),
                React.createElement('input', { type: 'number',
                  className: 'form-control text-center ' + _Item2.default['add-qty-input'],
                  disabled: !_this._isChecked(idx) || !_this._canBeRefunded(idx),
                  value: _this.state.amounts[idx],
                  onChange: function onChange(e) {
                    _this.state.amounts[idx] = e.target.value;
                    _this.setState({ amounts: _this.state.amounts });
                  },
                  onBlur: function onBlur(e) {
                    _this._onChangeInputAmountRefunded(idx, e.target.value);
                  }
                }),
                React.createElement(
                  'span',
                  { className: 'input-group-addon ' + _Item2.default['add-qty-button'] + ' ' + _Item2.default['cannot-be-refunded'] },
                  React.createElement('i', { className: 'fa fa-plus' })
                )
              )
            ),
            _this.props.showCheckbox && React.createElement(
              'td',
              { className: 'no-border quantity-refund-breakdown text-right visible-xs visible-sm', onClick: !_this._isChecked(idx) || !_this._canBeRefunded(idx) ? function () {} : function () {
                  return _this._askSetQuantity(idx, refundAmount);
                } },
              React.createElement(
                'div',
                { className: 'input-group box-quantity-refund' },
                'x ',
                refundAmount
              )
            ),
            React.createElement(
              'td',
              { className: 'checkbox-refund-breakdown no-border' },
              _this._canBeRefunded(idx) && React.createElement(
                'div',
                { className: 'top-8 checkbox-input pull-right' },
                React.createElement(
                  'div',
                  { className: 'checkbox pull-right checkbox-primary checkbox-circle ' + _Item2.default['refund-checkbox'] },
                  React.createElement('input', { type: 'checkbox', onClick: function onClick() {
                      return _this._onClickCheck(idx);
                    }, checked: _this._isChecked(idx) }),
                  React.createElement(
                    'label',
                    null,
                    '\xA0'
                  )
                )
              )
            )
          );
        })
      );
    };

    _this.state = {
      amounts: props.refundItems.map(function (refundItem) {
        return refundItem.refundAmount;
      })
    };
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var amounts = nextProps.refundItems.map(function (refundItem) {
        return refundItem.refundAmount;
      });
      this.setState({ amounts: amounts });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          refundItems = _props.refundItems,
          idx = _props.setQuantity.idx;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12 item-to-refund' },
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'label',
              { className: 'item-to-refund' },
              'Item to Refund'
            )
          ),
          this._canSelectAll() && React.createElement(
            'span',
            { className: 'pull-right' },
            !this._isSelectedAll() && React.createElement(
              'a',
              { className: _Item2.default['select-all'], onClick: this._onClickSelectAll },
              'Select All'
            ),
            this._isSelectedAll() && React.createElement(
              'a',
              { className: _Item2.default['select-all'], onClick: this._onClickDeselectAll },
              'Deselect All'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-12 visible-lg visible-md' },
          this._renderNonMobileTable(refundItems)
        ),
        React.createElement(
          'div',
          { className: 'col-xs-12 visible-xs visible-sm' },
          this._renderMobileTable(refundItems, idx)
        ),
        React.createElement(_SetQuantityModal2.default, { onSubmit: this._onSubmitSetQuantity,
          refundItems: refundItems,
          onCancel: this._cancelSetQuantity,
          open: this.props.openSetQtyModal
        })
      );
    }
  }]);
  return Item;
}(React.Component);

Item.propTypes = {
  onAskSetQtyModal: React.PropTypes.func,

  onConfirmSetQtyModal: React.PropTypes.func,

  onCancelSetQtyModal: React.PropTypes.func,

  openSetQtyModal: React.PropTypes.bool,

  // canSelectAll() is whether the 'select all' or deselect all is enabled
  canSelectAll: React.PropTypes.func,

  // isChecked(idx) is whether item[idx] is checked (included in refund)
  isChecked: React.PropTypes.func,

  // isSelectedAll is whether all items is selected for refund
  isSelectedAll: React.PropTypes.func,

  // isRefunded(idx) is whether item[idx] can be refunded
  // where idx is array key (not item id!)
  isRefunded: React.PropTypes.func,

  // canBeRefunded(idx) is whethere item[idx] can be refunded
  // where idx is array key (not item id!)
  canBeRefunded: React.PropTypes.func,

  // onClickCheck(idx) is event listener when checkbox for specific item is checked
  // where idx is array key (not item id!)
  onClickCheck: React.PropTypes.func,

  // onClickSelectAll() is event listener when 'select all' button is clicked
  onClickSelectAll: React.PropTypes.func,

  // onClickDeselectAll() is event listener when 'deselect all' button is clicked
  onClickDeselectAll: React.PropTypes.func,

  // onClickIncreaseQty(idx) is event listener when + button on item is clicked
  onClickIncreaseQty: React.PropTypes.func,

  // onClickIncreaseQty(idx) is event listener when - button on item is clicked
  onClickDecreaseQty: React.PropTypes.func,

  // onChangeInputAmountRefunded(idx,newValue) is event listener when value of input amount refunded of a item is refunded
  // idx - array key
  // newValue new value
  onChangeInputAmountRefunded: React.PropTypes.func,

  // refundItems is array of items
  // where each of them contains {itemName, itemVariantName, refundAmount}
  refundItems: React.PropTypes.array,

  // calculateItemPrice(idx) is how much the item price
  calculateItemPrice: React.PropTypes.func,

  // true if the checkbox is showed
  showCheckbox: React.PropTypes.bool
};

var selector = (0, _reduxForm.formValueSelector)('setQuantity');

function mapStateToProps(state) {
  return {
    setQuantity: {
      idx: selector(state, 'idx')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Item);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _RewardRedemption = __webpack_require__(2015);

var _RewardRedemption2 = _interopRequireDefault(_RewardRedemption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardRedemption = function (_React$Component) {
  (0, _inherits3.default)(RewardRedemption, _React$Component);

  function RewardRedemption() {
    (0, _classCallCheck3.default)(this, RewardRedemption);
    return (0, _possibleConstructorReturn3.default)(this, (RewardRedemption.__proto__ || (0, _getPrototypeOf2.default)(RewardRedemption)).apply(this, arguments));
  }

  (0, _createClass3.default)(RewardRedemption, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          redeemReward = _props.redeemReward,
          redeemAmount = _props.redeemAmount;

      return Boolean(redeemReward) && redeemAmount > 0 && React.createElement(
        'div',
        { className: 'row discount-row border-on-bottom' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'label',
            null,
            'Redeemed Reward'
          ),
          React.createElement(
            'table',
            { className: 'table mk-table-summary table-truncate' },
            React.createElement(
              'tbody',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { width: '55%', className: 'name-item-refund tax-grat-disc' },
                  redeemReward
                ),
                React.createElement(
                  'td',
                  { width: '45%', className: 'text-right price text-gray no-border ' + _RewardRedemption2.default['redeem-amount'] },
                  (0, _formatter.rupiahWithNegative)(-redeemAmount)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RewardRedemption;
}(React.Component);

RewardRedemption.propTypes = {
  redeemReward: React.PropTypes.string,
  redeemAmount: React.PropTypes.number
};

exports.default = RewardRedemption;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Tax = __webpack_require__(2016);

var _Tax2 = _interopRequireDefault(_Tax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tax = function (_React$Component) {
  (0, _inherits3.default)(Tax, _React$Component);

  function Tax() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tax);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tax.__proto__ || (0, _getPrototypeOf2.default)(Tax)).call.apply(_ref, [this].concat(args))), _this), _this._calculateTax = function (taxId) {
      return _this.props.calculateTax(taxId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tax, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          paymentTaxes = _props.paymentTaxes,
          includeGratuityTax = _props.includeGratuityTax;

      return paymentTaxes.length > 0 && React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'label',
            null,
            'Tax'
          ),
          React.createElement(
            'table',
            { className: 'table mk-table-summary table-truncate', style: { marginBottom: '0px' } },
            React.createElement(
              'tbody',
              null,
              paymentTaxes.map(function (tax, idxdisc) {
                return React.createElement(
                  'tr',
                  { key: idxdisc },
                  React.createElement(
                    'td',
                    { width: '70%', className: 'name-item-refund tax-grat-disc', style: { border: 'none !important' } },
                    tax.name,
                    ' ',
                    includeGratuityTax && '(Included)'
                  ),
                  React.createElement(
                    'td',
                    { width: '30%', className: 'text-right price text-gray ' + _Tax2.default['tax-price'] },
                    !includeGratuityTax && (0, _formatter.rupiah)(_this2._calculateTax(tax.id))
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Tax;
}(React.Component);

Tax.propTypes = {
  paymentTaxes: React.PropTypes.array,
  includeGratuityTax: React.PropTypes.bool,
  // calculateTax(tax_id)
  calculateTax: React.PropTypes.func
};

exports.default = Tax;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var _reactBootstrap = __webpack_require__(10);

var _TransactionDetail = __webpack_require__(2027);

var _TransactionDetail2 = _interopRequireDefault(_TransactionDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionDetail = function (_React$Component) {
  (0, _inherits3.default)(TransactionDetail, _React$Component);

  function TransactionDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransactionDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransactionDetail.__proto__ || (0, _getPrototypeOf2.default)(TransactionDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDoneButton = function () {
      _this.props.onClickDoneButton();
    }, _this._onClickResendReceipt = function () {
      _this.props.dispatch((0, _transactions.showResendEmailModal)());
    }, _this._onClickIssueRefund = function () {
      _this.props.dispatch((0, _transactions.showRefundBreakdownModal)());
    }, _this._onClickOldIssueRefund = function () {
      _this.props.dispatch((0, _transactions.showOldRefundModal)());
    }, _this._isRefundBreakdown = function () {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      if (transactionDetail.payment_refunds.length > 0) {
        var hasOldRefund = false;
        transactionDetail.payment_refunds.forEach(function (refund) {
          if (!refund.is_refund_breakdown) {
            hasOldRefund = true;
          }
        });
        return !hasOldRefund;
      } else {
        return transactionDetail.refund_availability.length > 0;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransactionDetail, [{
    key: 'render',
    value: function render() {
      var transactionDetail = this.props.data.reports.transactions.transactionDetail;

      var popover = React.createElement(
        _reactBootstrap.Popover,
        { id: 'refundCardTransaction', placement: 'bottom' },
        'Card transaction can only be refunded from the mobile device'
      );

      return transactionDetail != null && React.createElement(
        'div',
        { className: _TransactionDetail2.default['receipt-box'] },
        React.createElement(
          'div',
          { className: _TransactionDetail2.default['action-box-top'] },
          React.createElement(
            'button',
            { className: 'btn btn-default', onClick: this._onClickResendReceipt },
            'Resend Receipt'
          ),
          transactionDetail.refundable && transactionDetail.payment_type !== 'card' && React.createElement(
            'button',
            { className: 'btn btn-default pull-right',
              onClick: this._isRefundBreakdown() ? this._onClickIssueRefund : this._onClickOldIssueRefund },
            'Issue Refund'
          ),
          transactionDetail.refundable && transactionDetail.payment_type === 'card' && React.createElement(
            _reactBootstrap.OverlayTrigger,
            { overlay: popover },
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-default pull-right' },
              'Issue Refund'
            )
          )
        ),
        React.createElement(
          'div',
          { className: _TransactionDetail2.default['receipt-container'] },
          React.createElement(_TransactionDetailReceipt2.default, { paymentDetail: transactionDetail })
        ),
        React.createElement(
          'div',
          { className: _TransactionDetail2.default['action-box-bottom'] },
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right', onClick: this._onClickDoneButton },
            'Done'
          )
        )
      );
    }

    /**
     * Determine whether the transaction detail can be refunded with refund breakdown
     * @return boolean
     * @private
     */

  }]);
  return TransactionDetail;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
};

TransactionDetail.propTypes = {
  onClickDoneButton: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TransactionDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dashboardStart = dashboardStart;
exports.dashboardChangeFilter = dashboardChangeFilter;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dashboardStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Dashboard Init', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function dashboardChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Dashboard Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inventoryAdjustmentStart = inventoryAdjustmentStart;
exports.inventoryAdjustmentChangeFilter = inventoryAdjustmentChangeFilter;
exports.inventoryAdjustmentCreate = inventoryAdjustmentCreate;
exports.inventoryAdjustmentExport = inventoryAdjustmentExport;
exports.inventoryAdjustmentImport = inventoryAdjustmentImport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inventoryAdjustmentStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      namespace = _ref.namespace;

  mixpanel.track('Inventory Adjustment Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
} /* global mixpanel */
function inventoryAdjustmentChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      namespace = _ref2.namespace;

  mixpanel.track('Inventory Adjustment Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

function inventoryAdjustmentCreate(_ref3) {
  var adjustment = _ref3.adjustment,
      outlet = _ref3.outlet;

  var mixpanelData = {
    'Outlet Name': outlet.name
  };
  var namespace = void 0;
  if (adjustment.hasOwnProperty('history_details')) {
    namespace = 'items';
    mixpanelData['List of Items'] = adjustment.history_details.map(function (d) {
      return {
        'Name': d.item_name,
        'Variant': d.item_variant_name,
        'Previous Qty': d.beginning_stock,
        'New Qty': d.quantity
      };
    });
  } else {
    mixpanelData['List of Ingredients'] = adjustment.ingredient_history_details.map(function (d) {
      return {
        'Name': d.ingredient_name,
        'Previous Qty': d.beginning_stock,
        'New Qty': d.quantity
      };
    });
    namespace = 'ingredients';
  }
  mixpanelData['Current Inventory Filter'] = namespace;
  mixpanel.track('Inventory Adjustment Create', mixpanelData);
}

function inventoryAdjustmentExport(_ref4) {
  var outletIds = _ref4.outletIds,
      startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      namespace = _ref4.namespace;

  var mixpanelData = {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  };
  mixpanel.track('Inventory Adjustment Export', mixpanelData);
}

function inventoryAdjustmentImport(_ref5) {
  var namespace = _ref5.namespace;

  mixpanel.track('Inventory Adjustment Import', {
    'Current Inventory Filter': namespace
  });
}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inventorySummaryStart = inventorySummaryStart;
exports.inventorySummaryChangeFilter = inventorySummaryChangeFilter;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inventorySummaryStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      namespace = _ref.namespace;

  mixpanel.track('Inventory Summary Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
} /* global mixpanel */
function inventorySummaryChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      namespace = _ref2.namespace;

  mixpanel.track('Inventory Summary Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inventorySupplierStart = inventorySupplierStart;
exports.inventorySupplierSelect = inventorySupplierSelect;
exports.inventorySupplierCreate = inventorySupplierCreate;
exports.inventorySupplierDelete = inventorySupplierDelete;
exports.inventorySupplierExport = inventorySupplierExport;
/* global mixpanel */

function inventorySupplierStart() {
  mixpanel.track('Inventory Supplier Start');
}

function inventorySupplierSelect(_ref) {
  var supplier = _ref.supplier;

  mixpanel.track('Inventory Supplier Select', {
    'Supplier Name': supplier.name,
    'Supplier Address': supplier.address,
    'Supplier Phone': supplier.phone,
    'Supplier Email': supplier.email
  });
}

function inventorySupplierCreate(_ref2) {
  var supplier = _ref2.supplier;

  mixpanel.track('Inventory Supplier Create', {
    'Name': supplier.name,
    'Email': supplier.email,
    'Phone': supplier.phone,
    'Address': supplier.address,
    'City': supplier.city,
    'State': supplier.state,
    'Zip': supplier.postal_code
  });
}

function inventorySupplierDelete(_ref3) {
  var supplier = _ref3.supplier;

  mixpanel.track('Inventory Supplier Delete', {
    'Name': supplier.name,
    'Email': supplier.email,
    'Phone': supplier.phone,
    'Address': supplier.address,
    'City': supplier.city,
    'State': supplier.state,
    'Zip': supplier.postal_code
  });
}

function inventorySupplierExport() {
  mixpanel.track('Inventory Supplier Export');
}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inventoryTransferStart = inventoryTransferStart;
exports.inventoryTransferChangeFilter = inventoryTransferChangeFilter;
exports.inventoryTransferCreate = inventoryTransferCreate;
exports.inventoryTransferExport = inventoryTransferExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global mixpanel */
function inventoryTransferStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      namespace = _ref.namespace;

  mixpanel.track('Inventory Transfer Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

function inventoryTransferChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      namespace = _ref2.namespace;

  mixpanel.track('Inventory Transfer Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

function inventoryTransferCreate(_ref3) {
  var outletFromName = _ref3.outletFromName,
      outletToName = _ref3.outletToName,
      namespace = _ref3.namespace,
      items = _ref3.items;

  var data = {
    'Outlet From Name': outletFromName,
    'outletFromName': outletToName,
    'Current Inventory Filter': namespace
  };
  if (namespace === _constants.NAMESPACE_ITEMS) {
    data['List of Items'] = items.map(function (d) {
      return {
        'Item Name': d.name,
        'Variant Name': d.item_variant_name,
        'Qty Beginning Stock': d.beginning_stock,
        'Qty Transfer': parseInt(d.quantity)
      };
    });
  } else {
    data['List of Ingredients'] = items.map(function (d) {
      return {
        'Ingredient Name': d.ingredient_name,
        'Qty Beginning Stock': d.beginning_stock,
        'Qty Transfer': parseInt(d.quantity),
        'Unit': d.unit_name
      };
    });
  }
  mixpanel.track('Inventory Transfer Create', data);
}

function inventoryTransferExport(_ref4) {
  var outletIds = _ref4.outletIds,
      startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      namespace = _ref4.namespace;

  mixpanel.track('Inventory Transfer Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Inventory Filter': namespace
  });
}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryGratuityStart = libraryGratuityStart;
exports.libraryGratuityChangeOutlet = libraryGratuityChangeOutlet;
exports.libraryGratuityCreate = libraryGratuityCreate;
exports.libraryGratuityDelete = libraryGratuityDelete;
exports.libraryGratuityUpdate = libraryGratuityUpdate;
/**
 * Created by alvinoktavianus on 7/20/17.
 */
/* global mixpanel */

function libraryGratuityStart(_ref) {
  var currOutlet = _ref.currOutlet;

  mixpanel.track('Library Gratuity Start', {
    'Current Selected Outlet': currOutlet
  });
}

function libraryGratuityChangeOutlet(_ref2) {
  var currOutlet = _ref2.currOutlet;

  mixpanel.track('Library Gratuity Change Outlet', {
    'Current Selected Outlet': currOutlet
  });
}

function libraryGratuityCreate(_ref3) {
  var values = _ref3.values,
      isAllOutlet = _ref3.isAllOutlet;

  var eventName = isAllOutlet ? 'Library Gratuity Create All Outlet' : 'Library Gratuity Create One Outlet';
  mixpanel.track(eventName, {
    'Name': values.name,
    'Value': values.amount
  });
}

function libraryGratuityDelete(_ref4) {
  var gratuity = _ref4.gratuity;

  mixpanel.track('Library Gratuity Delete', {
    'Name': gratuity.name,
    'Value': gratuity.amount
  });
}

function libraryGratuityUpdate(_ref5) {
  var newValue = _ref5.newValue;

  mixpanel.track('Library Gratuity Update One Outlet', {
    'New Name': newValue.name,
    'New Value': newValue.amount
  });
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registrationStart = registrationStart;
exports.registrationBusinessInfo = registrationBusinessInfo;
exports.registrationCompleted = registrationCompleted;
/* global mixpanel */

function registrationStart() {
  mixpanel.track('Registration Start');
}

function registrationBusinessInfo(_ref) {
  var email = _ref.email;

  mixpanel.track('Registration Create Email', { email: email });
}

function registrationCompleted(_ref2) {
  var user = _ref2.user,
      business = _ref2.business;

  mixpanel.track('Registration Create Business', {
    'Email': user.email,
    'First Name': user.first_name,
    'Last Name': user.last_name,
    'Phone': user.phone,
    'Business Name': business.name,
    'Business Type ID': business.business_type_id,
    // 'Business Type Name': '',
    'Business Category ID': business.business_category_id,
    // 'Business Category Name':'',
    'Business Address': business.address,
    'Business City': business.city,
    'Business State': business.state,
    'Business Zip': business.postal_code
  });
}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsCategorySalesStart = reportsCategorySalesStart;
exports.reportsCategorySalesChangeFilter = reportsCategorySalesChangeFilter;
exports.reportsCategorySalesExport = reportsCategorySalesExport;
exports.reportsCategorySalesFTUE = reportsCategorySalesFTUE;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsCategorySalesStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Category Sales Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsCategorySalesChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Category Sales Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsCategorySalesExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Category Sales Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsCategorySalesFTUE() {
  mixpanel.track('Report Category Sales FTUE', {});
}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportCollectedStart = reportCollectedStart;
exports.reportCollectedChangeFilter = reportCollectedChangeFilter;
exports.reportCollectedExport = reportCollectedExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportCollectedStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Collected Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportCollectedChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Collected Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportCollectedExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Collected Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsDiscountStart = reportsDiscountStart;
exports.reportsDiscountChangeFilter = reportsDiscountChangeFilter;
exports.reportsDiscountExport = reportsDiscountExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsDiscountStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Discount Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsDiscountChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Discount Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsDiscountExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Discount Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsGratuityStart = reportsGratuityStart;
exports.reportsGratuityChangeFilter = reportsGratuityChangeFilter;
exports.reportsGratuityExport = reportsGratuityExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsGratuityStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Gratuity Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsGratuityChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Gratuity Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsGratuityExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Gratuity Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportGrossProfitStart = reportGrossProfitStart;
exports.reportGrossProfitChangeFilter = reportGrossProfitChangeFilter;
exports.reportGrossProfitHoverCOGSAdj = reportGrossProfitHoverCOGSAdj;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportGrossProfitStart(_ref) {
  var grossProfit = _ref.grossProfit;

  mixpanel.track('Report Gross Profit Start', {
    'Cost of Goods Sold': grossProfit.cogs,
    'Discounts': grossProfit.discount,
    'Refunds': grossProfit.refund,
    'Net Sales': grossProfit.net_sales,
    'Gross Profit': grossProfit.gross_profit,
    'Gross Sales': grossProfit.gross_sales
  });
} /* global mixpanel */
function reportGrossProfitChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Gross Profit Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportGrossProfitHoverCOGSAdj() {
  mixpanel.track('Report Gross Profit Hover COGS Adj', {});
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsInvoiceStart = reportsInvoiceStart;
exports.reportsInvoiceChangeFilter = reportsInvoiceChangeFilter;
exports.reportsInvoicesSelect = reportsInvoicesSelect;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsInvoiceStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Invoice Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsInvoiceChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      statuses = _ref2.statuses;

  if (!statuses) {
    statuses = [];
  }
  mixpanel.track('Report Invoices Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate),
    'Current Filter Status Cancelled is Selected': statuses.includes('cancelled'),
    'Current Filter Status Unpaid is Selected': statuses.includes('unpaid'),
    'Current Filter Status Overdue is Selected': statuses.includes('overdue'),
    'Current Filter Status Paid is Selected': statuses.includes('paid'),
    'Current Filter Status Partially Paid is Selected': statuses.includes('partially_paid')
  });
}

function reportsInvoicesSelect(_ref3) {
  var invoice = _ref3.invoice;

  mixpanel.track('Report Invoice Select', {
    'Invoice Number': invoice.invoice_no,
    'Invoice Date Created': (0, _formatDate2.default)(invoice.created_at),
    'Invoice Status': invoice.invoice_status,
    'Invoice Total': invoice.total_collected,
    'Invoice Amount Due': invoice.total_amount_due,
    'Invoice Due Date': (0, _formatDate2.default)(invoice.invoice_due_date)
  });
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsItemSalesStart = reportsItemSalesStart;
exports.reportsItemSalesChangeFilter = reportsItemSalesChangeFilter;
exports.reportsItemSalesExport = reportsItemSalesExport;
exports.reportsItemSalesFTUE = reportsItemSalesFTUE;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsItemSalesStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Item Sales Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsItemSalesChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Item Sales Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsItemSalesExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Item Sales Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsItemSalesFTUE() {
  mixpanel.track('Report Item Sales FTUE');
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsModifierSalesStart = reportsModifierSalesStart;
exports.reportsModifierSalesChangeFilter = reportsModifierSalesChangeFilter;
exports.reportsModifierSalesExport = reportsModifierSalesExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsModifierSalesStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Modifier Sales', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsModifierSalesChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Modifier Sales Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsModifierSalesExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Modifier Sales Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsPaymentMethodsStart = reportsPaymentMethodsStart;
exports.reportsPaymentMethodsChangeFilter = reportsPaymentMethodsChangeFilter;
exports.reportsPaymentMethodsExportData = reportsPaymentMethodsExportData;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsPaymentMethodsStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Payment Methods Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsPaymentMethodsChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Payment Methods Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsPaymentMethodsExportData(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Payment Method Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportServedStart = reportServedStart;
exports.reportServedChangeFilter = reportServedChangeFilter;
exports.reportServedExport = reportServedExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportServedStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Served Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportServedChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Served Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportServedExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Served Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsShiftsStart = reportsShiftsStart;
exports.reportsShiftsChangeFilter = reportsShiftsChangeFilter;
exports.reportsShiftsSelect = reportsShiftsSelect;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsShiftsStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Shifts Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsShiftsChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Shifts Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsShiftsSelect(_ref3) {
  var shift = _ref3.shift;

  mixpanel.track('Report Shift Select', {
    'Name': shift.employee_name,
    'Starting Shift': (0, _formatDate2.default)(shift.created_at),
    'Ending Shift': (0, _formatDate2.default)(shift.ended_at),
    'Starting Cash': shift.starting_cash,
    'Cash Sales': shift.cash_sales,
    'Cash from Invoice': shift.cash_invoice,
    'Cash Refunds': shift.cash_refund,
    'Total Expense': shift.total_expense,
    'Total Income': shift.total_income,
    'Expected Ending Cash': shift.expected_ending_cash,
    'Actual Ending Cash': shift.actual_ending_cash,
    'Debit Credit': shift.total_debit_credit,
    'Debit Credit Voided': shift.total_voided,
    'Expected Card Payment': shift.expected_card_payment,
    'EDC': shift.total_edc,
    'Gift Card': shift.total_gift_card,
    'Other': shift.total_other,
    'Other Refunds': shift.other_refunds,
    'Expected Other Payment': shift.expected_other_payment,
    'Total Expected': shift.total_expected,
    'Total Actual': shift.total_actual,
    'Difference': shift.total_difference
  });
}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportSummaryStart = reportSummaryStart;
exports.reportSummaryChangeFilter = reportSummaryChangeFilter;
exports.summaryExport = summaryExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportSummaryStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Summary Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportSummaryChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Summary Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function summaryExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Summary Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsTaxStart = reportsTaxStart;
exports.reportsTaxChangeFilter = reportsTaxChangeFilter;
exports.reportsTaxExport = reportsTaxExport;

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportsTaxStart(_ref) {
  var outletIds = _ref.outletIds,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  mixpanel.track('Report Tax Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
} /* global mixpanel */
function reportsTaxChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  mixpanel.track('Report Tax Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

function reportsTaxExport(_ref3) {
  var outletIds = _ref3.outletIds,
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  mixpanel.track('Report Tax Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': (0, _formatDate2.default)(startDate),
    'Current Time Filter End': (0, _formatDate2.default)(endDate)
  });
}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(1241);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Header2.default;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Program = __webpack_require__(328);

var _Program2 = _interopRequireDefault(_Program);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function (_Component) {
  (0, _inherits3.default)(Option, _Component);

  function Option() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Option);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Option.__proto__ || (0, _getPrototypeOf2.default)(Option)).call.apply(_ref, [this].concat(args))), _this), _this._onClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          type = _this$props.type;

      if (onClick) {
        _this.props.onClick(type);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Option, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { onClick: this._onClick, className: 'row' },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '15px' }, className: 'col-md-2 text-center v-center' },
          _react2.default.createElement('img', { src: this.props.img })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-10 v-center' },
          _react2.default.createElement(
            'div',
            { className: _Program2.default['option-title'] + ' ' + (this.props.isDisabled ? _Program2.default['option-title-disabled'] : '') },
            this.props.title
          ),
          _react2.default.createElement(
            'div',
            { className: '' + _Program2.default['option-body'] },
            this.props.body
          )
        )
      );
    }
  }]);
  return Option;
}(_react.Component);

Option.propTypes = {
  isDisabled: _react.PropTypes.bool,
  isSelected: _react.PropTypes.bool,
  title: _react.PropTypes.string,
  body: _react.PropTypes.string
};

exports.default = Option;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NoData = __webpack_require__(2084);

var _NoData2 = _interopRequireDefault(_NoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoData = function (_React$Component) {
  (0, _inherits3.default)(NoData, _React$Component);

  function NoData() {
    (0, _classCallCheck3.default)(this, NoData);
    return (0, _possibleConstructorReturn3.default)(this, (NoData.__proto__ || (0, _getPrototypeOf2.default)(NoData)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoData, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _NoData2.default.wrapper },
        React.createElement(
          'div',
          { className: _NoData2.default.text },
          'No Data'
        )
      );
    }
  }]);
  return NoData;
}(React.Component);

exports.default = NoData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__(1336);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Header2.default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _WarningLabel = __webpack_require__(2181);

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningLabel = function WarningLabel(_ref) {
  var content = _ref.content,
      type = _ref.type,
      link = _ref.link,
      recepie = _ref.recepie,
      props = (0, _objectWithoutProperties3.default)(_ref, ['content', 'type', 'link', 'recepie']);

  return React.createElement(
    'div',
    { className: (recepie ? 'mt-10px' : '') + ' ' + _WarningLabel2.default['wrapper'] },
    React.createElement('i', { className: type === 'info' ? 'fa fa-exclamation-circle ' + _WarningLabel2.default.circle : 'fa fa-lock ' + _WarningLabel2.default.lock }),
    !link && React.createElement(
      'label',
      { className: '' + _WarningLabel2.default.content },
      content
    ),
    link && React.createElement(
      'label',
      { className: '' + _WarningLabel2.default.content },
      props.children
    )
  );
};

exports.default = WarningLabel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierInputWithoutValidation = function (_Component) {
  (0, _inherits3.default)(ModifierInputWithoutValidation, _Component);

  function ModifierInputWithoutValidation() {
    (0, _classCallCheck3.default)(this, ModifierInputWithoutValidation);
    return (0, _possibleConstructorReturn3.default)(this, (ModifierInputWithoutValidation.__proto__ || (0, _getPrototypeOf2.default)(ModifierInputWithoutValidation)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModifierInputWithoutValidation, [{
    key: 'render',
    value: function render() {
      var props = this.props;

      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement('input', (0, _extends3.default)({ type: 'text' }, props, props.input))
      );
    }
  }]);
  return ModifierInputWithoutValidation;
}(_react.Component);

exports.default = ModifierInputWithoutValidation;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getInvoices = getInvoices;
exports.getReceiptInvoices = getReceiptInvoices;
exports.createRecordPayment = createRecordPayment;
exports.resendEmail = resendEmail;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _invoices = __webpack_require__(628);

var api = _interopRequireWildcard(_invoices);

var _invoices2 = __webpack_require__(170);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getInvoices, getReceiptInvoices, createRecordPayment, resendEmail].map(_regenerator2.default.mark);

/**
 * Fetch invoices from the server
 * @param {object} params
 * @returns {*} invoices from server, or false if the request fails
 */
function getInvoices(params) {
  var response;
  return _regenerator2.default.wrap(function getInvoices$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getInvoices, params);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch receipt invoices info from the server
 * @param {object} params
 * @returns {*} receipt invoices info from server, or false if the request fails
 */
function getReceiptInvoices(id, params) {
  var response;
  return _regenerator2.default.wrap(function getReceiptInvoices$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getReceiptInvoices, id, params);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          return _context2.abrupt('return', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context2.finish(16);

        case 22:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 16, 22]]);
}

function createRecordPayment(data) {
  var response;
  return _regenerator2.default.wrap(function createRecordPayment$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(api.createRecordPayment, data);

        case 7:
          response = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)((0, _invoices2.invoicesPageRequest)());

        case 10:
          return _context3.abrupt('return', response.data);

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3['catch'](4);
          _context3.next = 17;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 17:
          return _context3.abrupt('return', false);

        case 18:
          _context3.prev = 18;
          _context3.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          _context3.next = 23;
          return (0, _effects.put)(action.sendingRequest(false));

        case 23:
          return _context3.finish(18);

        case 24:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 13, 18, 24]]);
}

function resendEmail(invoiceId) {
  var response;
  return _regenerator2.default.wrap(function resendEmail$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(api.resendEmail, invoiceId);

        case 7:
          response = _context4.sent;
          return _context4.abrupt('return', response);

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](4);
          _context4.next = 15;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 15:
          return _context4.abrupt('return', false);

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context4.finish(16);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.postRefund = postRefund;
exports.postOldRefund = postOldRefund;

var _refunds = __webpack_require__(1112);

var api = _interopRequireWildcard(_refunds);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [postRefund, postOldRefund].map(_regenerator2.default.mark);

function postRefund(data) {
  var response;
  return _regenerator2.default.wrap(function postRefund$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.postRefund, data);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          _context.prev = 15;
          _context.next = 18;
          return (0, _effects.put)(action.sendingRequest(false));

        case 18:
          _context.next = 20;
          return (0, _effects.put)(action.hideProgressBar());

        case 20:
          return _context.finish(15);

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 15, 21]]);
}

function postOldRefund(data) {
  var response;
  return _regenerator2.default.wrap(function postOldRefund$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.postOldRefund, data);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          _context2.prev = 15;
          _context2.next = 18;
          return (0, _effects.put)(action.sendingRequest(false));

        case 18:
          _context2.next = 20;
          return (0, _effects.put)(action.hideProgressBar());

        case 20:
          return _context2.finish(15);

        case 21:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 15, 21]]);
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getTransactions = getTransactions;
exports.getTransactionDetail = getTransactionDetail;

var _reports = __webpack_require__(434);

var api = _interopRequireWildcard(_reports);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getTransactions, getTransactionDetail].map(_regenerator2.default.mark);

/**
 *
 * @param {object} query
 * @return {{object}|boolean}
 */
function getTransactions(query) {
  var response;
  return _regenerator2.default.wrap(function getTransactions$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getTransactions, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * @param {int} transactionId
 * @param {object} query
 * @return {object | boolean}
 */
function getTransactionDetail(transactionId, query) {
  var response;
  return _regenerator2.default.wrap(function getTransactionDetail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getTransactionDetail, transactionId, query);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          return _context2.abrupt('return', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context2.finish(16);

        case 22:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getImage = getImage;
exports.getLoadingImage = getLoadingImage;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _uploadImage = __webpack_require__(634);

var api = _interopRequireWildcard(_uploadImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getImage, getLoadingImage].map(_regenerator2.default.mark);

/**
 * @param filename
 *
 */
function getImage(params) {
  var response;
  return _regenerator2.default.wrap(function getImage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getImage, params);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          return _context.abrupt('return', false);

        case 14:
          _context.prev = 14;
          _context.next = 17;
          return (0, _effects.put)(action.hideProgressBar());

        case 17:
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          return _context.finish(14);

        case 20:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 14, 20]]);
}

function getLoadingImage() {
  var response;
  return _regenerator2.default.wrap(function getLoadingImage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getLoadingImage);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          return _context2.abrupt('return', false);

        case 14:
          _context2.prev = 14;
          _context2.next = 17;
          return (0, _effects.put)(action.hideProgressBar());

        case 17:
          _context2.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          return _context2.finish(14);

        case 20:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 14, 20]]);
}

/***/ }),
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1662), __esModule: true };

/***/ }),
/* 682 */,
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(107)
  , core    = __webpack_require__(61)
  , fails   = __webpack_require__(208);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(207)
  , invoke             = __webpack_require__(1677)
  , html               = __webpack_require__(695)
  , cel                = __webpack_require__(464)
  , global             = __webpack_require__(95)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(252)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkout-table":"app-components-receipt-commons-ListItemBox-__ItemTable___2b19F","checkout-cell":"app-components-receipt-commons-ListItemBox-__ItemTable___1t9WD","discount":"app-components-receipt-commons-ListItemBox-__ItemTable___2U9w0","text-left":"app-components-receipt-commons-ListItemBox-__ItemTable___rjXTH","text-right":"app-components-receipt-commons-ListItemBox-__ItemTable___2x9cX","item-main":"app-components-receipt-commons-ListItemBox-__ItemTable___3lzGI","text-center":"app-components-receipt-commons-ListItemBox-__ItemTable___MpVyX","item-modifier":"app-components-receipt-commons-ListItemBox-__ItemTable___gJfhm","item-variant":"app-components-receipt-commons-ListItemBox-__ItemTable___28Gsy","item-variant-box":"app-components-receipt-commons-ListItemBox-__ItemTable___2GLWi","item-note":"app-components-receipt-commons-ListItemBox-__ItemTable___3ENyO"};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-counting-box":"app-components-receipt-invoices-CountingBox-__CountingBox___2N0V7"};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-invoices-InfoBox-__InfoBox___37O8V","receipt-date":"app-components-receipt-invoices-InfoBox-__InfoBox___1mQLF","receipt-number":"app-components-receipt-invoices-InfoBox-__InfoBox___3WHHx","receipt-served":"app-components-receipt-invoices-InfoBox-__InfoBox___1rkqk","receipt-collected":"app-components-receipt-invoices-InfoBox-__InfoBox___zieBV","payment-due-invoice":"app-components-receipt-invoices-InfoBox-__InfoBox___1T3dn","payment-due-invoice-black":"app-components-receipt-invoices-InfoBox-__InfoBox___pv3eT"};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-list-item-box":"app-components-receipt-invoices-ListItemBox-__ListItem___1Xh_z"};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-total-box":"app-components-receipt-invoices-Total-__Total___1LIsm","receipt-counting-box":"app-components-receipt-invoices-Total-__Total___1mn2t","receipt-total":"app-components-receipt-invoices-Total-__Total___2Igej","total-invoice":"app-components-receipt-invoices-Total-__Total___16BvX","amount-received":"app-components-receipt-invoices-Total-__Total___1Gdi0","amount-due":"app-components-receipt-invoices-Total-__Total___oiaSS"};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-transactions-InfoBox-__InfoBox___2iAL6","receipt-date":"app-components-receipt-transactions-InfoBox-__InfoBox___BVOwA","receipt-number":"app-components-receipt-transactions-InfoBox-__InfoBox___2crGL","receipt-served":"app-components-receipt-transactions-InfoBox-__InfoBox___iti4m","receipt-collected":"app-components-receipt-transactions-InfoBox-__InfoBox___2RPR8"};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-total-box":"app-components-receipt-transactions-Total-__style___hDdBY","receipt-total":"app-components-receipt-transactions-Total-__style___1pJP2","overflow-word":"app-components-receipt-transactions-Total-__style___Tljj1"};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mk-section-header":"app-pages-AccountSetting-Account-__style___3WUYN","mk-sub-section-header":"app-pages-AccountSetting-Account-__style___-ZOFd","mk-divider-section-line":"app-pages-AccountSetting-Account-__style___1N-yC"};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mk-section-header":"app-pages-AccountSetting-PublicProfile-__style___TOQJ4 app-pages-AccountSetting-Account-__style___3WUYN","mk-sub-section-header":"app-pages-AccountSetting-PublicProfile-__style___2-zBZ app-pages-AccountSetting-Account-__style___-ZOFd","mk-divider-section-line":"app-pages-AccountSetting-PublicProfile-__style___1foxr app-pages-AccountSetting-Account-__style___1N-yC","link-list":"app-pages-AccountSetting-PublicProfile-__style___1jiC3","color-link":"app-pages-AccountSetting-PublicProfile-__style___384OX","color-twitter":"app-pages-AccountSetting-PublicProfile-__style___3tyoh","color-facebook":"app-pages-AccountSetting-PublicProfile-__style___39qzW","color-instagram":"app-pages-AccountSetting-PublicProfile-__style___NZxZw","save-button":"app-pages-AccountSetting-PublicProfile-__style___UNgnG","upload-image":"app-pages-AccountSetting-PublicProfile-__style___3tUyq","upload-image-content":"app-pages-AccountSetting-PublicProfile-__style___3PVNO"};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"confirm-success":"app-pages-ConfirmEmployee-__ConfirmEmployee___2s_Iq","invalid-message":"app-pages-ConfirmEmployee-__ConfirmEmployee___1cWk_","form-container":"app-pages-ConfirmEmployee-__ConfirmEmployee___3S464","text-signIn":"app-pages-ConfirmEmployee-__ConfirmEmployee___2uDw5"};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropzone-area":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___3UhbO","description":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___cw0ET","vertical-center":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___3IK_g","list-type":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___zGlb8","preview-import":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___z-y4C","information-modal":"app-pages-Customers-CustomerList-ListLoyalty-importModal-__ImportModal___2i9rh"};

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropzone-area":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___2YNJB","description":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___3q9Gj","vertical-center":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___1mujO","list-type":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___2C1LG","preview-import":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___2BDTK","information-modal":"app-pages-Customers-CustomerList-ListNonLoyalty-importModal-__ImportModal___3WrT4"};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Customers-CustomerList-PointActivity-List-__List___PmqKc","table-content-wrapper":"app-pages-Customers-CustomerList-PointActivity-List-__List___9qba5","table-content":"app-pages-Customers-CustomerList-PointActivity-List-__List___1-0io","point":"app-pages-Customers-CustomerList-PointActivity-List-__List___3FlWP","sale":"app-pages-Customers-CustomerList-PointActivity-List-__List___8O0S-","date":"app-pages-Customers-CustomerList-PointActivity-List-__List___3Rn0H","outlet":"app-pages-Customers-CustomerList-PointActivity-List-__List___2bXE2","selected":"app-pages-Customers-CustomerList-PointActivity-List-__List___30AlH","center":"app-pages-Customers-CustomerList-PointActivity-List-__List___22H7p","customers":"app-pages-Customers-CustomerList-PointActivity-List-__List___2QsQW","wrapper":"app-pages-Customers-CustomerList-PointActivity-List-__List___1m_DV","length-wrapper":"app-pages-Customers-CustomerList-PointActivity-List-__List___6rGwQ"};

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___1BpNt","table-content-wrapper":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___1Z_3f","table-content":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___3bAcr","sale":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___29e07","date":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___-B3wu","outlet":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___19E0x","selected":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___1or22","center":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___3EK5Z","wrapper":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___KU8vT","length-wrapper":"app-pages-Customers-CustomerList-PurchaseHistory-List-__List___2usKU"};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___dnBOp","table-content-wrapper":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___Jruch","table-content":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___2ar6D","point":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___1hJ0B","date":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___3xbmf","reward":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___1dcQD","selected":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___3QiKg","center":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___3kZOy","customers":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___3FNEI","wrapper":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___ZcsA1","length-wrapper":"app-pages-Customers-CustomerList-RedeemHistory-List-__List___3drLv"};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"feedback":"app-pages-Customers-Feedback-__style-feedback___gv5Uk","mk-action-bar":"app-pages-Customers-Feedback-__style-feedback___15j2v","table-feedback":"app-pages-Customers-Feedback-__style-feedback___2IWin","box-scroll":"app-pages-Customers-Feedback-__style-feedback___K54E5","feedback-row":"app-pages-Customers-Feedback-__style-feedback___18agJ"};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"remove-icon":"app-pages-Customers-Loyalty-Components-RewardList-__RewardList___-8ah0","list-box":"app-pages-Customers-Loyalty-Components-RewardList-__RewardList___3AVJF"};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"feedback-wrapper":"app-pages-FeedbackForm-__FeedbackForm___dZaNa","feedback-options":"app-pages-FeedbackForm-__FeedbackForm___go159","title":"app-pages-FeedbackForm-__FeedbackForm___1cA9t","image-mode":"app-pages-FeedbackForm-__FeedbackForm___2qluP","subtitle":"app-pages-FeedbackForm-__FeedbackForm___3upu_","invalid-message":"app-pages-FeedbackForm-__FeedbackForm___203IK","success-message":"app-pages-FeedbackForm-__FeedbackForm___331Ov","emoji":"app-pages-FeedbackForm-__FeedbackForm___2r4yG","comment-field":"app-pages-FeedbackForm-__FeedbackForm___1W9fZ","feed-form":"app-pages-FeedbackForm-__FeedbackForm___3UioT","form-cust-feedback":"app-pages-FeedbackForm-__FeedbackForm___1yOre","radio-option":"app-pages-FeedbackForm-__FeedbackForm___37BEV","label-radio":"app-pages-FeedbackForm-__FeedbackForm___19J5x","submit-btn":"app-pages-FeedbackForm-__FeedbackForm___2ZIsD","wrapper-form":"app-pages-FeedbackForm-__FeedbackForm___34clm"};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___33EsJ","footer-info":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___2BU4l","table":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___3tqTk","text-elipsis":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___47NLi","rp-avgCost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___ZinfY","input-avgCost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGSModal-__LibraryCOGSModal___1RWVf"};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer-info":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlertModal-__LibraryInventoryAlertModal___2Qkd8","body":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlertModal-__LibraryInventoryAlertModal___3y5VX","dialog":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlertModal-__LibraryInventoryAlertModal___3h_aM","table":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlertModal-__LibraryInventoryAlertModal___1r3EQ","text-elipsis":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlertModal-__LibraryInventoryAlertModal___spr5r"};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Library-Category-CategoryDetail-__style___13aXB","wrapper":"app-pages-Library-Category-CategoryDetail-__style___3I5Z9","title":"app-pages-Library-Category-CategoryDetail-__style___3O-GH","footer":"app-pages-Library-Category-CategoryDetail-__style___2pqBJ","btn-save":"app-pages-Library-Category-CategoryDetail-__style___Phtzj","btn-cancel":"app-pages-Library-Category-CategoryDetail-__style___2D7tC"};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Library-Tax-TaxDetail-__style___2O1Cc","wrapper":"app-pages-Library-Tax-TaxDetail-__style___8v0vX","title":"app-pages-Library-Tax-TaxDetail-__style___2hq62","btn-assign":"app-pages-Library-Tax-TaxDetail-__style___j6YW3","footer":"app-pages-Library-Tax-TaxDetail-__style___1FnBw","btn-cancel":"app-pages-Library-Tax-TaxDetail-__style___3YxxY","btn-save":"app-pages-Library-Tax-TaxDetail-__style___1C2GI","table-content-wrapper":"app-pages-Library-Tax-TaxDetail-__style___18SnE","table-content":"app-pages-Library-Tax-TaxDetail-__style___tLVSz","name":"app-pages-Library-Tax-TaxDetail-__style___3AK4R","amount":"app-pages-Library-Tax-TaxDetail-__style___17Fen","no-items":"app-pages-Library-Tax-TaxDetail-__style___1kkC_","Warning-Icon":"app-pages-Library-Tax-TaxDetail-__style___2CFWG","custom-amount-cb":"app-pages-Library-Tax-TaxDetail-__style___28CUk"};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-Register-__style___2Mq_i app-pages-Login-__style___2z-qW","title":"app-pages-Register-__style___2F7Ai app-pages-Login-__style___2nGvt","margin-link":"app-pages-Register-__style___2bMfI undefined","left":"app-pages-Register-__style___1YeZo app-pages-Login-__style___2WkBU","right":"app-pages-Register-__style___88cMP app-pages-Login-__style___3Bp4v","mk-sub-section-header":"app-pages-Register-__style___3_FqH","mk-section-header":"app-pages-Register-__style___vk6DT","mk-divider-section-line":"app-pages-Register-__style___2Vu37","row-continue":"app-pages-Register-__style___vvk-_","form-group":"app-pages-Register-__style___3xt2b","margin-bottom-5":"app-pages-Register-__style___k6Sz0","divider-business-information":"app-pages-Register-__style___3KWeY"};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"scrolled-area":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___3OCd-","details":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___1dP8O","modal-body":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___2rtJZ","col-right-inner":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___11LBR","receipt-scrolled-area":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___3VC14","mk-receipt-inner-box":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___3kYTe","serrated-border":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___3z_5Z","invoice-status-red":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___1aR9y","invoice-status-green":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___34qNY","invoice-status-orange":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___2Wl9E","invoice-status-grey":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___33T3v","separator-receipt":"app-pages-Reports-Invoices-ReceiptInvoices-__style-receipt___VSH8S"};

/***/ }),
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(343),
    stackClear = __webpack_require__(2471),
    stackDelete = __webpack_require__(2472),
    stackGet = __webpack_require__(2473),
    stackHas = __webpack_require__(2474),
    stackSet = __webpack_require__(2475);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2405);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 806 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(814);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(2402),
    createBaseEach = __webpack_require__(2428);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(812),
    toKey = __webpack_require__(348);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(809),
    isArrayLike = __webpack_require__(267);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(98),
    isKey = __webpack_require__(544),
    stringToPath = __webpack_require__(2477),
    toString = __webpack_require__(2487);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(2393),
    baseAggregator = __webpack_require__(2397),
    baseIteratee = __webpack_require__(540),
    isArray = __webpack_require__(98);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(538),
    arraySome = __webpack_require__(2396),
    cacheHas = __webpack_require__(542);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 816 */,
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(350);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 819 */,
/* 820 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(808),
    createAggregator = __webpack_require__(813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(267),
    isObjectLike = __webpack_require__(160);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(137),
    stubFalse = __webpack_require__(2486);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(165)(module)))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(189),
    isObject = __webpack_require__(350);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 825 */,
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2412),
    baseUnary = __webpack_require__(345),
    nodeUtil = __webpack_require__(2463);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(808),
    createAggregator = __webpack_require__(813);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(2423),
    keys = __webpack_require__(351);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(841);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(193);

var invariant = __webpack_require__(35);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  true ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(273);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactInstrumentation = __webpack_require__(111);

var quoteAttributeValueForBrowser = __webpack_require__(2663);
var warning = __webpack_require__(52);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   true ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (true) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (true) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (true) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (true) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var LinkedValueUtils = __webpack_require__(562);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactUpdates = __webpack_require__(140);

var warning = __webpack_require__(52);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     true ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       true ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       true ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (true) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       true ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactInvalidSetStateWarningHook = __webpack_require__(2628);
var ReactHostOperationHistoryHook = __webpack_require__(2626);
var ReactComponentTreeHook = __webpack_require__(123);
var ExecutionEnvironment = __webpack_require__(74);

var performanceNow = __webpack_require__(2677);
var warning = __webpack_require__(52);

var hooks = [];
var didHookThrowForEvent = {};

function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
  try {
    fn.call(context, arg1, arg2, arg3, arg4, arg5);
  } catch (e) {
     true ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
    didHookThrowForEvent[event] = true;
  }
}

function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
  for (var i = 0; i < hooks.length; i++) {
    var hook = hooks[i];
    var fn = hook[event];
    if (fn) {
      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
    }
  }
}

var isProfiling = false;
var flushHistory = [];
var lifeCycleTimerStack = [];
var currentFlushNesting = 0;
var currentFlushMeasurements = [];
var currentFlushStartTime = 0;
var currentTimerDebugID = null;
var currentTimerStartTime = 0;
var currentTimerNestedFlushDuration = 0;
var currentTimerType = null;

var lifeCycleTimerHasWarned = false;

function clearHistory() {
  ReactComponentTreeHook.purgeUnmountedComponents();
  ReactHostOperationHistoryHook.clearHistory();
}

function getTreeSnapshot(registeredIDs) {
  return registeredIDs.reduce(function (tree, id) {
    var ownerID = ReactComponentTreeHook.getOwnerID(id);
    var parentID = ReactComponentTreeHook.getParentID(id);
    tree[id] = {
      displayName: ReactComponentTreeHook.getDisplayName(id),
      text: ReactComponentTreeHook.getText(id),
      updateCount: ReactComponentTreeHook.getUpdateCount(id),
      childIDs: ReactComponentTreeHook.getChildIDs(id),
      // Text nodes don't have owners but this is close enough.
      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
      parentID: parentID
    };
    return tree;
  }, {});
}

function resetMeasurements() {
  var previousStartTime = currentFlushStartTime;
  var previousMeasurements = currentFlushMeasurements;
  var previousOperations = ReactHostOperationHistoryHook.getHistory();

  if (currentFlushNesting === 0) {
    currentFlushStartTime = 0;
    currentFlushMeasurements = [];
    clearHistory();
    return;
  }

  if (previousMeasurements.length || previousOperations.length) {
    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
    flushHistory.push({
      duration: performanceNow() - previousStartTime,
      measurements: previousMeasurements || [],
      operations: previousOperations || [],
      treeSnapshot: getTreeSnapshot(registeredIDs)
    });
  }

  clearHistory();
  currentFlushStartTime = performanceNow();
  currentFlushMeasurements = [];
}

function checkDebugID(debugID) {
  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowRoot && debugID === 0) {
    return;
  }
  if (!debugID) {
     true ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
  }
}

function beginLifeCycleTimer(debugID, timerType) {
  if (currentFlushNesting === 0) {
    return;
  }
  if (currentTimerType && !lifeCycleTimerHasWarned) {
     true ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
    lifeCycleTimerHasWarned = true;
  }
  currentTimerStartTime = performanceNow();
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = debugID;
  currentTimerType = timerType;
}

function endLifeCycleTimer(debugID, timerType) {
  if (currentFlushNesting === 0) {
    return;
  }
  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
     true ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
    lifeCycleTimerHasWarned = true;
  }
  if (isProfiling) {
    currentFlushMeasurements.push({
      timerType: timerType,
      instanceID: debugID,
      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
    });
  }
  currentTimerStartTime = 0;
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = null;
  currentTimerType = null;
}

function pauseCurrentLifeCycleTimer() {
  var currentTimer = {
    startTime: currentTimerStartTime,
    nestedFlushStartTime: performanceNow(),
    debugID: currentTimerDebugID,
    timerType: currentTimerType
  };
  lifeCycleTimerStack.push(currentTimer);
  currentTimerStartTime = 0;
  currentTimerNestedFlushDuration = 0;
  currentTimerDebugID = null;
  currentTimerType = null;
}

function resumeCurrentLifeCycleTimer() {
  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
      startTime = _lifeCycleTimerStack$.startTime,
      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
      debugID = _lifeCycleTimerStack$.debugID,
      timerType = _lifeCycleTimerStack$.timerType;

  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
  currentTimerStartTime = startTime;
  currentTimerNestedFlushDuration += nestedFlushDuration;
  currentTimerDebugID = debugID;
  currentTimerType = timerType;
}

var lastMarkTimeStamp = 0;
var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';

function shouldMark(debugID) {
  if (!isProfiling || !canUsePerformanceMeasure) {
    return false;
  }
  var element = ReactComponentTreeHook.getElement(debugID);
  if (element == null || typeof element !== 'object') {
    return false;
  }
  var isHostElement = typeof element.type === 'string';
  if (isHostElement) {
    return false;
  }
  return true;
}

function markBegin(debugID, markType) {
  if (!shouldMark(debugID)) {
    return;
  }

  var markName = debugID + '::' + markType;
  lastMarkTimeStamp = performanceNow();
  performance.mark(markName);
}

function markEnd(debugID, markType) {
  if (!shouldMark(debugID)) {
    return;
  }

  var markName = debugID + '::' + markType;
  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';

  // Chrome has an issue of dropping markers recorded too fast:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
  // To work around this, we will not report very small measurements.
  // I determined the magic number by tweaking it back and forth.
  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
  // When the bug is fixed, we can `measure()` unconditionally if we want to.
  var timeStamp = performanceNow();
  if (timeStamp - lastMarkTimeStamp > 0.1) {
    var measurementName = displayName + ' [' + markType + ']';
    performance.measure(measurementName, markName);
  }

  performance.clearMarks(markName);
  if (measurementName) {
    performance.clearMeasures(measurementName);
  }
}

var ReactDebugTool = {
  addHook: function (hook) {
    hooks.push(hook);
  },
  removeHook: function (hook) {
    for (var i = 0; i < hooks.length; i++) {
      if (hooks[i] === hook) {
        hooks.splice(i, 1);
        i--;
      }
    }
  },
  isProfiling: function () {
    return isProfiling;
  },
  beginProfiling: function () {
    if (isProfiling) {
      return;
    }

    isProfiling = true;
    flushHistory.length = 0;
    resetMeasurements();
    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
  },
  endProfiling: function () {
    if (!isProfiling) {
      return;
    }

    isProfiling = false;
    resetMeasurements();
    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
  },
  getFlushHistory: function () {
    return flushHistory;
  },
  onBeginFlush: function () {
    currentFlushNesting++;
    resetMeasurements();
    pauseCurrentLifeCycleTimer();
    emitEvent('onBeginFlush');
  },
  onEndFlush: function () {
    resetMeasurements();
    currentFlushNesting--;
    resumeCurrentLifeCycleTimer();
    emitEvent('onEndFlush');
  },
  onBeginLifeCycleTimer: function (debugID, timerType) {
    checkDebugID(debugID);
    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
    markBegin(debugID, timerType);
    beginLifeCycleTimer(debugID, timerType);
  },
  onEndLifeCycleTimer: function (debugID, timerType) {
    checkDebugID(debugID);
    endLifeCycleTimer(debugID, timerType);
    markEnd(debugID, timerType);
    emitEvent('onEndLifeCycleTimer', debugID, timerType);
  },
  onBeginProcessingChildContext: function () {
    emitEvent('onBeginProcessingChildContext');
  },
  onEndProcessingChildContext: function () {
    emitEvent('onEndProcessingChildContext');
  },
  onHostOperation: function (operation) {
    checkDebugID(operation.instanceID);
    emitEvent('onHostOperation', operation);
  },
  onSetState: function () {
    emitEvent('onSetState');
  },
  onSetChildren: function (debugID, childDebugIDs) {
    checkDebugID(debugID);
    childDebugIDs.forEach(checkDebugID);
    emitEvent('onSetChildren', debugID, childDebugIDs);
  },
  onBeforeMountComponent: function (debugID, element, parentDebugID) {
    checkDebugID(debugID);
    checkDebugID(parentDebugID, true);
    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
    markBegin(debugID, 'mount');
  },
  onMountComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'mount');
    emitEvent('onMountComponent', debugID);
  },
  onBeforeUpdateComponent: function (debugID, element) {
    checkDebugID(debugID);
    emitEvent('onBeforeUpdateComponent', debugID, element);
    markBegin(debugID, 'update');
  },
  onUpdateComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'update');
    emitEvent('onUpdateComponent', debugID);
  },
  onBeforeUnmountComponent: function (debugID) {
    checkDebugID(debugID);
    emitEvent('onBeforeUnmountComponent', debugID);
    markBegin(debugID, 'unmount');
  },
  onUnmountComponent: function (debugID) {
    checkDebugID(debugID);
    markEnd(debugID, 'unmount');
    emitEvent('onUnmountComponent', debugID);
  },
  onTestEvent: function () {
    emitEvent('onTestEvent');
  }
};

// TODO remove these when RN/www gets updated
ReactDebugTool.addDevtool = ReactDebugTool.addHook;
ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;

ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
ReactDebugTool.addHook(ReactComponentTreeHook);
var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
if (/[?&]react_perf\b/.test(url)) {
  ReactDebugTool.beginProfiling();
}

module.exports = ReactDebugTool;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var ReactUpdates = __webpack_require__(140);
var Transaction = __webpack_require__(360);

var emptyFunction = __webpack_require__(142);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  true ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(2616);

var containsNode = __webpack_require__(2666);
var focusNode = __webpack_require__(891);
var getActiveElement = __webpack_require__(892);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var PooledClass = __webpack_require__(193);
var Transaction = __webpack_require__(360);
var ReactInstrumentation = __webpack_require__(111);
var ReactServerUpdateQueue = __webpack_require__(2639);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (true) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactCurrentOwner = __webpack_require__(163);
var ReactInstanceMap = __webpack_require__(566);
var ReactInstrumentation = __webpack_require__(111);
var ReactUpdates = __webpack_require__(140);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (true) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
       true ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (true) {
     true ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (true) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
         true ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (true) {
      ReactInstrumentation.debugTool.onSetState();
       true ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  true ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  true ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(67);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var ReactCompositeComponent = __webpack_require__(2609);
var ReactEmptyComponent = __webpack_require__(873);
var ReactHostComponent = __webpack_require__(874);

var getNextDebugID = __webpack_require__(2743);
var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (true) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  true ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  true ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (true) {
     true ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (true) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (true) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);
var escapeTextContentForBrowser = __webpack_require__(361);
var setInnerHTML = __webpack_require__(572);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactCurrentOwner = __webpack_require__(163);
var REACT_ELEMENT_TYPE = __webpack_require__(2622);

var getIteratorFn = __webpack_require__(2659);
var invariant = __webpack_require__(35);
var KeyEscapeUtils = __webpack_require__(561);
var warning = __webpack_require__(52);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (true) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
           true ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (true) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  true ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(142);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (true) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (true) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(223),
    _assign = __webpack_require__(44);

var ReactNoopUpdateQueue = __webpack_require__(917);

var canDefineProperty = __webpack_require__(365);
var emptyObject = __webpack_require__(920);
var invariant = __webpack_require__(195);
var lowPriorityWarning = __webpack_require__(583);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  true ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (true) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */



var ReactCurrentOwner = __webpack_require__(163);
var ReactComponentTreeHook = __webpack_require__(123);
var ReactElement = __webpack_require__(194);

var checkReactTypeSpec = __webpack_require__(2741);

var canDefineProperty = __webpack_require__(365);
var getIteratorFn = __webpack_require__(918);
var warning = __webpack_require__(196);
var lowPriorityWarning = __webpack_require__(583);

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = ReactCurrentOwner.current.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

function getSourceInfoErrorAddendum(elementProps) {
  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
    var source = elementProps.__source;
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      info = ' Check the top-level render call using <' + parentName + '>.';
    }
  }
  return info;
}

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});

  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
  if (memoizer[currentComponentErrorInfo]) {
    return;
  }
  memoizer[currentComponentErrorInfo] = true;

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  var childOwner = '';
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
  }

   true ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (ReactElement.isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (ReactElement.isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    // Entry iterators provide implicit keys.
    if (iteratorFn) {
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;
        while (!(step = iterator.next()).done) {
          if (ReactElement.isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  if (componentClass.propTypes) {
    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
  }
  if (typeof componentClass.getDefaultProps === 'function') {
     true ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
  }
}

var ReactElementValidator = {
  createElement: function (type, props, children) {
    var validType = typeof type === 'string' || typeof type === 'function';
    // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.
    if (!validType) {
      if (typeof type !== 'function' && typeof type !== 'string') {
        var info = '';
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }

        var sourceInfo = getSourceInfoErrorAddendum(props);
        if (sourceInfo) {
          info += sourceInfo;
        } else {
          info += getDeclarationErrorAddendum();
        }

        info += ReactComponentTreeHook.getCurrentStackAddendum();

        var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
        ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
         true ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
        ReactComponentTreeHook.popNonStandardWarningStack();
      }
    }

    var element = ReactElement.createElement.apply(this, arguments);

    // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.
    if (element == null) {
      return element;
    }

    // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)
    if (validType) {
      for (var i = 2; i < arguments.length; i++) {
        validateChildKeys(arguments[i], type);
      }
    }

    validatePropTypes(element);

    return element;
  },

  createFactory: function (type) {
    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
    // Legacy hook TODO: Warn if this is accessed
    validatedFactory.type = type;

    if (true) {
      if (canDefineProperty) {
        Object.defineProperty(validatedFactory, 'type', {
          enumerable: false,
          get: function () {
            lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
            Object.defineProperty(this, 'type', {
              value: type
            });
            return type;
          }
        });
      }
    }

    return validatedFactory;
  },

  cloneElement: function (element, props, children) {
    var newElement = ReactElement.cloneElement.apply(this, arguments);
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], newElement.type);
    }
    validatePropTypes(newElement);
    return newElement;
  }
};

module.exports = ReactElementValidator;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(196);

function warnNoop(publicInstance, callerName) {
  if (true) {
    var constructor = publicInstance.constructor;
     true ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (true) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af89c27f3fcb4864f1b3b5c613c9a612.png";

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a10371d793caf442a88fa88813dd3c2e.png";

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "670a20aa70dfa80a003dc2036334fc4a.png";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef8e9e51d676994ff368c486340b1c64.png";

/***/ }),
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(302);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = createMiddleware;

var _ravenJs = __webpack_require__(373);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = function identity(stuff) {
  return stuff;
};
// we use hashmap to quickly search for ignoredActions
var ignoredActions = {
  '@@redux-form/REGISTER_FIELD': true,
  '@@redux-form/UNREGISTER_FIELD': true,
  '@@redux-form/DESTROY': true,
  'PAGE_SHOW_LOADING_SPINNER': true,
  'SHOW_PROGRESS_BAR': true,
  'HIDE_PROGRESS_BAR': true

  /**
    Function that generates a crash reporter for Sentry.
    @param dsn - private Sentry DSN.
    @param cfg - object to configure Raven.
    @param options - customize extra data sent to sentry
      actionTransformer - tranform the action object to send; default to identity function
      stateTransformer - transform the state object to send; default to identity function
      logger - the logger to use for logging; default to console.error
  */
};function createMiddleware(dsn) {
  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var MAX_PAYLOAD_LENGTH = 500;

  if (!_ravenJs2.default.isSetup()) {
    if (!dsn) {
      // Skip this middleware if there is no DSN.
      console.error('[redux-raven-middleware] Sentry DSN required.');
      return function (store) {
        return function (next) {
          return function (action) {
            next(action);
          };
        };
      };
    }
    _ravenJs2.default.config(dsn, cfg).install();
  }

  return function (store) {
    return function (next) {
      return function (action) {
        var _options$actionTransf = options.actionTransformer,
            actionTransformer = _options$actionTransf === undefined ? identity : _options$actionTransf,
            _options$stateTransfo = options.stateTransformer,
            stateTransformer = _options$stateTransfo === undefined ? identity : _options$stateTransfo,
            _options$logger = options.logger,
            logger = _options$logger === undefined ? console.error.bind(console, '[redux-raven-middleware] Reporting error to Sentry:') : _options$logger;

        try {
          var payload = void 0;
          if ((0, _typeof3.default)(action.payload) === 'object') {
            payload = (0, _stringify2.default)(action.payload).substr(0, MAX_PAYLOAD_LENGTH);
          } else {
            payload = action.payload;
          }
          if (!ignoredActions[action.type]) {
            _ravenJs2.default.captureBreadcrumb({
              category: 'redux',
              message: action.type,
              data: (0, _extends3.default)({}, action, { payload: payload })
            });
          }
          return next(action);
        } catch (err) {
          logger(err);

          // Send the report.
          _ravenJs2.default.captureException(err, {
            extra: {
              action: actionTransformer(action),
              state: stateTransformer(store.getState())
            }
          });
        }
      };
    };
  };
}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(604);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  selectedOutletIds: [],
  outlets: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.ACTION_BAR_SET_SELECTED_OUTLET_IDS:
      return (0, _extends3.default)({}, state, { selectedOutletIds: payload.selectedOutletIds });
    case _constants.ACTION_BAR_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(380);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  referral: {
    'code': '',
    'name': '',
    'logo_url': '',
    id: null
  }

};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.CHANGE_REFERRAL_DATA:
      return (0, _extends3.default)({}, state, { referral: payload.referral });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constant = __webpack_require__(382);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  notificationMessage: null,
  notificationType: null
}; /**
    * Created by alvinoktavianus on 6/21/17.
    */

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constant.BILLING_REDIRECT_SET_NOTIFICATION_TYPE:
      return (0, _extends3.default)({}, state, { notificationType: payload.notifType });
    case _constant.BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE:
      return (0, _extends3.default)({}, state, { notificationMessage: payload.notifMessage });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _constants = __webpack_require__(607);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  showLoadingButton: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SHOW_LOADING_BUTTON:
      return (0, _extends3.default)({}, state, { showLoadingButton: payload.showLoadingButton });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(383);

var _fluxStandardAction = __webpack_require__(28);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  startDate: (0, _moment2.default)(),
  endDate: (0, _moment2.default)()

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.CALENDAR_SET_DATE:
      var startDate = payload.startDate,
          endDate = payload.endDate;

      var momentStartDate = (0, _moment2.default)(startDate);
      var momentEndDate = (0, _moment2.default)(endDate);
      return (0, _extends3.default)({}, state, { startDate: momentStartDate, endDate: momentEndDate });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(384);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  nextAction: null,
  showConfirmActionModal: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var payload = action.payload;


  switch (action.type) {
    case _constants.CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmActionModal: true });
    case _constants.CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmActionModal: false });
    case _constants.CONFIRM_ACTION_SET_NEXT_ACTION:
      return (0, _extends3.default)({}, state, { nextAction: payload.nextAction });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(385);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  invalidInvitation: false,
  invitedEmployee: {
    business: null,
    employee: null
  }

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.CONFIRM_EMPLOYEE_INVALID_INVITATION:
      return (0, _extends3.default)({}, state, { invalidInvitation: payload.invalidInvitation });
    case _constants.CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE:
      return (0, _extends3.default)({}, state, { invitedEmployee: payload.invitedEmployee });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerLoyaltyReducer = exports.customerListReducer = exports.customerFeedbackReducer = undefined;

var _feedback = __webpack_require__(1576);

var _feedback2 = _interopRequireDefault(_feedback);

var _list = __webpack_require__(1577);

var _list2 = _interopRequireDefault(_list);

var _loyalty = __webpack_require__(1578);

var _loyalty2 = _interopRequireDefault(_loyalty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.customerFeedbackReducer = _feedback2.default;
exports.customerListReducer = _list2.default;
exports.customerLoyaltyReducer = _loyalty2.default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _constants = __webpack_require__(389);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  gross_sales: 0,
  net_sales: 0,
  total_transactions: 0,
  top_items: [],
  transactions: [],
  outlets: []

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SET_DASHBOARD:
      return (0, _extends3.default)({}, state, payload.dashboard);
    case _constants.DASHBOARD_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    default:
      return (0, _extends3.default)({}, state, { hasError: false });
  }
}

exports.reducer = reducer;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.employeeListReducer = exports.employeePermissionReducer = undefined;

var _permission = __webpack_require__(1580);

var _permission2 = _interopRequireDefault(_permission);

var _list = __webpack_require__(1579);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.employeePermissionReducer = _permission2.default;
exports.employeeListReducer = _list2.default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  invalidFeedback: false,
  submitSuccess: false,
  dataFeedbackToken: null,
  showFeedbackForm: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.FEEDBACK_FORM_INVALID_FEEDBACK:
      return (0, _extends3.default)({}, state, { invalidFeedback: payload.invalidFeedback });
    case _constants.FEEDBACK_FORM_SUCCESS_SUBMIT:
      return (0, _extends3.default)({}, state, { submitSuccess: payload.submitSuccess });
    case _constants.FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN:
      return (0, _extends3.default)({}, state, { dataFeedbackToken: payload.dataFeedbackToken });
    case _constants.FEEDBACK_FORM_SHOW_FORM:
      return (0, _extends3.default)({}, state, { showFeedbackForm: payload.showFeedbackForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(394);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  data: null,
  isInvalidToken: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.SET_FEEDBACK_REPLY_FORM:
      return (0, _extends3.default)({}, state, { data: payload.data });
    case _constants.SET_INVALID_TOKEN:
      return (0, _extends3.default)({}, state, { isInvalidToken: payload.isValid });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(91);

var _constants2 = __webpack_require__(287);

var _auth = __webpack_require__(237);

var _fluxStandardAction = __webpack_require__(28);

var _login = __webpack_require__(1632);

var sentryLogin = _interopRequireWildcard(_login);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * The reducer takes care of state changes in our app through actions
 */

var store = __webpack_require__(199);

// The initial application state
var initialState = {
  formState: {
    email: '',
    password: ''
  },
  formRegState: {
    email: '',
    password: '',
    confpassword: ''
  },
  forgotState: {
    email: ''
  },
  businessState: {
    business_name: '',
    business_type: '',
    business_category: '',
    business_address: '',
    business_city: '',
    business_province: '',
    business_postal_code: '',
    user_first_name: '',
    user_last_name: '',
    user_phone: ''
  },
  businessTypesState: [],
  businessCategoriesState: [],
  hasError: false, // determine if the currentState hasError
  error: {}, // error object - based on FSA (Flux Standard Action), this must be Error() object
  currentlySending: false,
  loggedIn: (0, _auth.loggedIn)(),
  loadingBar: 0,
  user: null, // object of authenticated user. null if not authenticated
  outlets: [],
  currentOutlet: [],
  resetPasswordState: {
    token_error: true,
    message: '',
    userFullName: ''
  },
  encryption: {
    public_modulus: '',
    public_exponent: '',
    key: ''
  },
  showLoadingSpinner: false,
  isRegistered: false,
  resendVerificationEmail: {
    isModalShow: false,
    headerMessage: 'Error',
    bodyMessage: '',
    modalStatus: ''
  },
  showModalOutletMobile: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload,
      _action$error = action.error,
      error = _action$error === undefined ? null : _action$error;

  // check if action has key 'error' then hasError must be changed to true

  var hasError = false;
  if (error) {
    hasError = true;
  }

  switch (action.type) {
    case _constants.CHANGE_FORM:
      return (0, _extends3.default)({}, state, { hasError: hasError, formState: payload.newFormState });
    case _constants.SET_AUTH:
      payload.user && store.set('response:login', (0, _stringify2.default)(payload.user));
      sentryLogin.setUserContext({ profile: payload.user });
      return (0, _extends3.default)({}, state, { hasError: hasError, loggedIn: payload.newAuthState, user: payload.user });
    case _constants.CHANGE_FORM_REGISTER:
      return (0, _extends3.default)({}, state, { hasError: hasError, formRegState: payload.newFormRegState });
    case _constants.CHANGE_FORM_FORGOT:
      return (0, _extends3.default)({}, state, { hasError: hasError, forgotState: payload.newForgotState });
    case _constants.CHANGE_FORM_BUSINESS:
      return (0, _extends3.default)({}, state, { hasError: hasError, businessState: payload.newBusinessState });
    case _constants.SENDING_REQUEST:
      return (0, _extends3.default)({}, state, { hasError: hasError, currentlySending: payload.sending });
    case _constants.REQUEST_ERROR:
      return (0, _extends3.default)({}, state, { hasError: hasError, error: payload.error });
    case _constants.CLEAR_ERROR:
      return (0, _extends3.default)({}, state, { hasError: false, error: error });
    case _constants.SHOW_PROGRESS_BAR:
      return (0, _extends3.default)({}, state, { hasError: hasError, loadingBar: state.loadingBar + 30 });
    case _constants.SHOW_LOADING_SPINNER:
      return (0, _extends3.default)({}, state, { hasError: hasError, showLoadingSpinner: payload.showLoadingSpinner });
    case _constants.HIDE_PROGRESS_BAR:
      return (0, _extends3.default)({}, state, { hasError: hasError, loadingBar: state.loadingBar > 0 ? state.loadingBar - 30 : 0 });
    case _constants.CHANGE_BUSINESS_TYPES_DATA:
      return (0, _extends3.default)({}, state, { hasError: hasError, businessTypesState: payload.newBusinessTypes });
    case _constants.CHANGE_BUSINESS_CATEGORIES_DATA:
      return (0, _extends3.default)({}, state, { hasError: hasError, businessCategoriesState: payload.newBusinessCategories });
    case _constants.SET_AUTH_FROM_LOCAL:
      var loginResponse = store.get('response:login');
      var user = null;
      if (loginResponse) {
        user = JSON.parse(loginResponse);
      }
      if (user) {
        sentryLogin.setUserContext({ profile: user });
      }
      return (0, _extends3.default)({}, state, { hasError: hasError, loggedIn: !!user, user: user });
    case _constants.REDIRECT_TO:
      return (0, _extends3.default)({}, state, { hasError: hasError, url: payload.url });
    case _constants.LOAD_RESET_PASSWORD:
      return (0, _extends3.default)({}, state, { hasError: hasError, url: payload.token });
    case _constants.CHANGE_FORM_RESET_PASSWORD:
      return (0, _extends3.default)({}, state, { hasError: hasError, resetPasswordState: payload.resetPasswordState });
    case _constants.SET_PREPARE_ENCRYPTION:
      return (0, _extends3.default)({}, state, { hasError: hasError, encryption: payload.encryption });
    case _constants.SET_PROFILE:
      return (0, _extends3.default)({}, state, { user: payload.profile });
    case _constants.CLEAR_REGISTER_FORM:
      return (0, _extends3.default)({}, state, { formRegState: { email: '', password: '', confpassword: '' } });
    case _constants.SET_IS_REGISTERED:
      return (0, _extends3.default)({}, state, { isRegistered: payload.isRegistered });
    case _constants.SET_RESEND_VERIFICATION_EMAIL_STATE:
      return (0, _extends3.default)({}, state, { resendVerificationEmail: payload.resendVerificationEmail });
    case _constants.DASHBOARD_SHOW_MODAL_OUTLET_MOBILE:
      return (0, _extends3.default)({}, state, { showModalOutletMobile: payload.showModalOutletMobile });
    case _constants2.SAVE_UPLOAD_IMAGE:
      return (0, _extends3.default)({}, state, { user: (0, _extends3.default)({}, state.user, { gravatar: payload.filename }) });
    case _constants.SET_AUTH_FROM_API:
      var profileResponse = payload.data;
      var profile = null;
      if (profileResponse) {
        profile = profileResponse;
        sentryLogin.setUserContext({ profile: profile });
      }
      return (0, _extends3.default)({}, state, { hasError: hasError, loggedIn: !!profile, user: profile });
    default:
      return (0, _extends3.default)({}, state, { hasError: false });
  }
}

exports.default = reducer;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipesReducer = exports.ingredientSubscriptionReducer = exports.categoryReducer = exports.libraryReducer = undefined;

var _library = __webpack_require__(1583);

var _library2 = _interopRequireDefault(_library);

var _category = __webpack_require__(1581);

var _category2 = _interopRequireDefault(_category);

var _ingredientSubscription = __webpack_require__(1582);

var _ingredientSubscription2 = _interopRequireDefault(_ingredientSubscription);

var _recipes = __webpack_require__(1584);

var _recipes2 = _interopRequireDefault(_recipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.libraryReducer = _library2.default;
exports.categoryReducer = _category2.default;
exports.ingredientSubscriptionReducer = _ingredientSubscription2.default;
exports.recipesReducer = _recipes2.default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ingredientSubscriptionReducer = exports.transferReducer = exports.supplierReducer = exports.summaryReducer = exports.purchaseOrderReducer = exports.adjustmentReducer = undefined;

var _adjustment = __webpack_require__(1585);

var _adjustment2 = _interopRequireDefault(_adjustment);

var _purchaseOrder = __webpack_require__(1587);

var _purchaseOrder2 = _interopRequireDefault(_purchaseOrder);

var _summary = __webpack_require__(1588);

var _summary2 = _interopRequireDefault(_summary);

var _supplier = __webpack_require__(1589);

var _supplier2 = _interopRequireDefault(_supplier);

var _transfer = __webpack_require__(1590);

var _transfer2 = _interopRequireDefault(_transfer);

var _ingredientSubscription = __webpack_require__(1586);

var _ingredientSubscription2 = _interopRequireDefault(_ingredientSubscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.adjustmentReducer = _adjustment2.default;
exports.purchaseOrderReducer = _purchaseOrder2.default;
exports.summaryReducer = _summary2.default;
exports.supplierReducer = _supplier2.default;
exports.transferReducer = _transfer2.default;
exports.ingredientSubscriptionReducer = _ingredientSubscription2.default;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryTaxReducer = exports.libraryModifierReducer = exports.libraryItemReducer = exports.libraryGratuityReducer = exports.libraryDiscountReducer = exports.libraryCategoryReducer = undefined;

var _category = __webpack_require__(1591);

var _category2 = _interopRequireDefault(_category);

var _discount = __webpack_require__(1592);

var _discount2 = _interopRequireDefault(_discount);

var _gratuity = __webpack_require__(1593);

var _gratuity2 = _interopRequireDefault(_gratuity);

var _item = __webpack_require__(1594);

var _item2 = _interopRequireDefault(_item);

var _modifier = __webpack_require__(1595);

var _modifier2 = _interopRequireDefault(_modifier);

var _tax = __webpack_require__(1596);

var _tax2 = _interopRequireDefault(_tax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.libraryCategoryReducer = _category2.default;
exports.libraryDiscountReducer = _discount2.default;
exports.libraryGratuityReducer = _gratuity2.default;
exports.libraryItemReducer = _item2.default;
exports.libraryModifierReducer = _modifier2.default;
exports.libraryTaxReducer = _tax2.default;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  showLoadingSpinnerPage: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.PAGE_SHOW_LOADING_SPINNER:
      return (0, _extends3.default)({}, state, { showLoadingSpinnerPage: payload.showLoadingSpinnerPage });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(411);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  bars: [], // notification bar
  notificationClicked: false
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  var newBars = [];
  state.bars.forEach(function (bar) {
    newBars.push(bar);
  });

  switch (action.type) {
    case _constants.NOTIFICATION_SUCCESS:
      newBars.push({ 'level': 'success', 'message': payload.message });
      return (0, _extends3.default)({}, state, { bars: newBars });
    case _constants.NOTIFICATION_WARNING:
      newBars.push({ 'level': 'warning', 'message': payload.message });
      return (0, _extends3.default)({}, state, { bars: newBars });
    case _constants.NOTIFICATION_ERROR:
      newBars.push({ 'level': 'error', 'message': payload.message });
      return (0, _extends3.default)({}, state, { bars: newBars });
    case _constants.NOTIFICATION_RESET:
      return (0, _extends3.default)({}, state, { bars: [] });
    case _constants.NOTIFICATION_CLICKED:
      return (0, _extends3.default)({}, state, { notificationClicked: payload.notificationClicked });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(412);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  outlets: [],
  currentOutlet: []

  // Takes care of changing the application state
}; /*
    * The reducer takes care of state changes in our app through actions
    */

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.SET_CURRENT_OUTLET:
      return (0, _extends3.default)({}, state, { currentOutlet: payload.data.selected_outlets });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outletPagesListReducer = undefined;

var _list = __webpack_require__(1597);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.outletPagesListReducer = _list2.default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(414);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  invoices: {
    results: [],
    total_items: 0,
    total_pages: 0
  },
  page: 0,
  perPage: 0,
  receiptInvoices: null,
  openRecordPaymentModal: false,
  openCancelInvoiceModal: false,
  openOldCancelInvoiceModal: false,
  recordPayment: {
    id: 0,
    payment_record: {}
  },
  outlets: [],
  currentPage: null,
  totalPage: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.REPORTS_INVOICES_SET_LIST_INVOICE:
      return (0, _extends3.default)({}, state, { invoices: payload.invoices });
    case _constants.REPORTS_INVOICES_SET_RECEIPT:
      return (0, _extends3.default)({}, state, { receiptInvoices: payload.receiptInvoices });
    case _constants.REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT:
      return (0, _extends3.default)({}, state, { recordPayment: payload.recordPayment });
    case _constants.REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL:
      return (0, _extends3.default)({}, state, { openRecordPaymentModal: true });
    case _constants.REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL:
      return (0, _extends3.default)({}, state, { openRecordPaymentModal: false });
    case _constants.REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL:
      return (0, _extends3.default)({}, state, { openCancelInvoiceModal: true });
    case _constants.REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL:
      return (0, _extends3.default)({}, state, { openCancelInvoiceModal: false });
    case _constants.REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL:
      return (0, _extends3.default)({}, state, { openOldCancelInvoiceModal: true });
    case _constants.REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL:
      return (0, _extends3.default)({}, state, { openOldCancelInvoiceModal: false });
    case _constants.REPORTS_INVOICES_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.REPORTS_INVOICES_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.REPORTS_INVOICES_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(415);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  sales: [], // sales summary,
  gross_profit: [],
  paymentMethods: {
    total_number_of_transactions: 0,
    total_collected: 0,
    reports: {
      cash_or_card: [],
      invoice: [],
      other: []
    }
  },
  itemSales: [],
  categorySales: [],
  modifierSales: [],
  discounts: [],
  taxes: { reports_taxes: [], total_tax_collected: 0 },
  gratuities: { reports_gratuities: [], total_gratuity_collected: 0 },
  staffs: { staff_reports: {}, total_transaction_amount: 0, total_transaction_count: 0 },
  servers: { servers: [], total_collected: 0, total_number_transaction: 0 },
  startDate: (0, _moment2.default)().add(-1, 'years').startOf('year'),
  endDate: (0, _moment2.default)().add(-1, 'years').endOf('year'),
  outlets: [],
  showLoadingSpinnerReport: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.REPORTS_SET_LIST_SALES_SUMMARY:
      return (0, _extends3.default)({}, state, { sales: payload.sales });
    case _constants.REPORTS_SET_LIST_GROSS_PROFIT:
      return (0, _extends3.default)({}, state, { gross_profit: payload.grossProfit });
    case _constants.REPORTS_SET_PAYMENT_METHODS:
      return (0, _extends3.default)({}, state, { paymentMethods: payload.paymentMethods });
    case _constants.REPORTS_SET_ITEM_SALES:
      return (0, _extends3.default)({}, state, { itemSales: payload.itemSales });
    case _constants.REPORTS_SET_CATEGORY_SALES:
      return (0, _extends3.default)({}, state, { categorySales: payload.categorySales });
    case _constants.REPORTS_SET_MODIFIER_SALES:
      return (0, _extends3.default)({}, state, { modifierSales: payload.modifierSales });
    case _constants.REPORTS_SET_DISCOUNTS:
      return (0, _extends3.default)({}, state, { discounts: payload.discounts });
    case _constants.REPORTS_SET_TAXES:
      return (0, _extends3.default)({}, state, { taxes: payload.taxes });
    case _constants.REPORTS_SET_GRATUITY:
      return (0, _extends3.default)({}, state, { gratuities: payload.gratuities });
    case _constants.REPORTS_SET_COLLECTEDBY:
      return (0, _extends3.default)({}, state, { staffs: payload.staffs });
    case _constants.REPORTS_SET_SERVEDBY:
      return (0, _extends3.default)({}, state, { servers: payload.servers });
    case _constants.REPORTS_SALES_SUMMARY_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_ITEM_SALES_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_DISCOUNTS_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_TAXES_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_GRATUITY_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_SERVEDBY_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SALES_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.REPORTS_SALES_SHOW_LOADING_SPINNER:
      return (0, _extends3.default)({}, state, { showLoadingSpinnerReport: payload.showLoadingSpinnerReport });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(416);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  shifts: [],
  shiftSummary: {},
  shiftDetails: [],
  startDate: (0, _moment2.default)().add(-1, 'years').startOf('year'),
  endDate: (0, _moment2.default)().add(-1, 'years').endOf('year'),
  keyword: '',
  page: 0,
  outlets: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.REPORTS_SHIFTS_SET_LIST_SHIFT:
      return (0, _extends3.default)({}, state, { shifts: payload.shifts });
    case _constants.REPORTS_SHIFTS_SET_SHIFT_SUMMARY:
      return (0, _extends3.default)({}, state, { shiftSummary: payload.summary });
    case _constants.REPORTS_SHIFTS_SET_START_END_DATE:
      return (0, _extends3.default)({}, state, { startDate: payload.startDate, endDate: payload.endDate });
    case _constants.REPORTS_SHIFTS_SET_SHIFT_DETAILS:
      return (0, _extends3.default)({}, state, { shiftDetails: payload.shiftDetails });
    case _constants.REPORTS_SHIFTS_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.REPORTS_SHIFTS_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { page: payload.page });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  transactions: [],
  transactionDetail: null,
  netSales: 0,
  totalCollected: 0,
  totalTransactions: 0,
  openResendEmailModal: false,
  openRefundBreakdownModal: false,
  openTransactionDetailModal: false,
  openOldRefundModal: false,
  openSetQuantityModal: false,
  refundBreakdown: {
    refundItems: []
  },
  outlets: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;
  var refundBreakdown = state.refundBreakdown;

  switch (action.type) {
    case _constants.REPORTS_TRANSACTIONS_SET_TRANSACTIONS:
      return (0, _extends3.default)({}, state, payload.transactions);
    case _constants.REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL:
      return (0, _extends3.default)({}, state, { transactionDetail: payload.transactionDetail });
    case _constants.REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL:
      return (0, _extends3.default)({}, state, { openResendEmailModal: true });
    case _constants.REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL:
      return (0, _extends3.default)({}, state, { openResendEmailModal: false });
    case _constants.REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL:
      return (0, _extends3.default)({}, state, { openRefundBreakdownModal: true });
    case _constants.REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL:
      return (0, _extends3.default)({}, state, { openRefundBreakdownModal: false

        // set qty modal
      });case _constants.REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL:
      return (0, _extends3.default)({}, state, { openSetQuantityModal: true });
    case _constants.REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL:
      return (0, _extends3.default)({}, state, { openSetQuantityModal: false

        // transaction detail
      });case _constants.REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL:
      return (0, _extends3.default)({}, state, { openTransactionDetailModal: true });
    case _constants.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL:
      return (0, _extends3.default)({}, state, { openTransactionDetailModal: false

        // old refund modal
      });case _constants.REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL:
      return (0, _extends3.default)({}, state, { openOldRefundModal: true });
    case _constants.REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL:
      return (0, _extends3.default)({}, state, { openOldRefundModal: false });

    case _constants.REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS:
      refundBreakdown.refundItems = payload.items;
      return (0, _extends3.default)({}, state, { refundBreakdown: refundBreakdown });

    case _constants.REPORTS_TRANSACTIONS_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });

    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  account: {
    password_confirmation: '',
    user: {}
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  switch (action.type) {
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constant = __webpack_require__(419);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  billings: [],
  outlets: {},
  rules: {},
  featureSubscriptionStatus: [],
  countFeatureSubscription: 0,
  currentSubscriptionRules: {},
  payButtonClicked: false,
  buttonMessage: 'Pay',
  showPaymentGatewayErrorModal: false,
  totalBillingPrice: 0,
  pendingPaymentMessage: null,
  unusedOutletMessage: null,
  currentSubscriptionPlanName: null,
  showCancelFeatureSubscriptionModal: false,
  cancelFeatureSubscriptionModalData: {},
  featureSubscriptionPrice: {},
  outletMinMaxDate: {},
  showBillingPage: true,
  isDeleted: {}
}; /**
    * Created by alvinoktavianus on 5/12/17.
    */

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constant.SETTING_BILLING_SET_BILLINGS:
      return (0, _extends3.default)({}, state, { billings: payload.data });
    case _constant.SETTING_BILLING_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.data });
    case _constant.SETTING_BILLING_SET_RULES:
      return (0, _extends3.default)({}, state, { rules: payload.data });
    case _constant.SETTING_BILLING_SET_SUBSCRIPTION_STATUS:
      return (0, _extends3.default)({}, state, { featureSubscriptionStatus: payload.data });
    case _constant.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES:
      return (0, _extends3.default)({}, state, { currentSubscriptionRules: payload.newSubscriptionRules });
    case _constant.SETTING_BILLING_IS_CLICKED_BUTTON_PAY:
      return (0, _extends3.default)({}, state, { payButtonClicked: payload.payButtonClicked });
    case _constant.SETTING_BILLING_PAY_BUTTON_MESSAGE:
      return (0, _extends3.default)({}, state, { buttonMessage: payload.payButtonMessage });
    case _constant.SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: true });
    case _constant.SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: false });
    case _constant.SETTING_BILLING_SET_TOTAL_BILLING_PRICE:
      return (0, _extends3.default)({}, state, { totalBillingPrice: payload.totalBillingPrice });
    case _constant.SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE:
      return (0, _extends3.default)({}, state, { pendingPaymentMessage: payload.pendingPaymentMessage });
    case _constant.SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE:
      return (0, _extends3.default)({}, state, { unusedOutletMessage: payload.unusedOutletMessage });
    case _constant.SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME:
      return (0, _extends3.default)({}, state, { currentSubscriptionPlanName: payload.planName });
    case _constant.SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION:
      return (0, _extends3.default)({}, state, { countFeatureSubscription: payload.countFeatureSubscription });
    case _constant.SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return (0, _extends3.default)({}, state, { showCancelFeatureSubscriptionModal: true });
    case _constant.SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return (0, _extends3.default)({}, state, { showCancelFeatureSubscriptionModal: false });
    case _constant.SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL:
      return (0, _extends3.default)({}, state, { cancelFeatureSubscriptionModalData: payload.featureSubscriptionModalData });
    case _constant.SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE:
      return (0, _extends3.default)({}, state, { featureSubscriptionPrice: payload.featureSubscriptionPrice });
    case _constant.SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE:
      return (0, _extends3.default)({}, state, { outletMinMaxDate: payload.minMaxDate });
    case _constant.SETTING_BILLING_SET_IS_DELETED_OUTLET:
      return (0, _extends3.default)({}, state, { isDeleted: payload.isDeleted });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constant = __webpack_require__(420);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  setting: {}

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constant.SETTING_CHECKOUT_SET_SETTING:
      return (0, _extends3.default)({}, state, { setting: payload.data });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailNotificationReducer = undefined;

var _emailNotification = __webpack_require__(1598);

var _emailNotification2 = _interopRequireDefault(_emailNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.emailNotificationReducer = _emailNotification2.default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _deepFreeze = __webpack_require__(1896);

var _deepFreeze2 = _interopRequireDefault(_deepFreeze);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(422);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  // current profile
  profile: null,
  outlets: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _deepFreeze2.default)(initialState);
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var payload = action.payload;


  switch (action.type) {
    case _constants.SETTING_RECEIPT_SET_PROFILE:
      return (0, _extends3.default)({}, state, { profile: payload.profile });
    case _constants.SETTING_RECEIPT_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  expired: false,
  showSubscriptionExpiredModal: false,
  nextActionExpired: null

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.IS_SUBSCRIPTION_EXPIRED:
      return (0, _extends3.default)({}, state, { expired: payload.expired });
    case _constants.SUBSCRIPTION_EXPIRED_SHOW_MODAL:
      return (0, _extends3.default)({}, state, { showSubscriptionExpiredModal: true });
    case _constants.SUBSCRIPTION_EXPIRED_HIDE_MODAL:
      return (0, _extends3.default)({}, state, { showSubscriptionExpiredModal: false });
    case _constants.SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION:
      return (0, _extends3.default)({}, state, { nextActionExpired: payload.nextActionExpired });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _constants = __webpack_require__(287);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  filename: null,
  tempFileUrl: null,
  deleted: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SET_UPLOAD_IMAGE:
      return (0, _extends3.default)({}, state, { filename: payload.filename });
    case _constants.SET_TEMP_IMG:
      return (0, _extends3.default)({}, state, { tempFileUrl: payload.tempFileUrl });
    case _constants.DELETE_IMAGE:
      return (0, _extends3.default)({}, state, { deleted: payload.deleted });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _constants = __webpack_require__(425);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  showModalImport: false,
  showModalErrorImport: false,
  messageError: [],
  importingStatus: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SHOW_MODAL_IMPORT:
      return (0, _extends3.default)({}, state, { showModalImport: payload.showModalImport });
    case _constants.SHOW_MODAL_ERROR_IMPORT:
      return (0, _extends3.default)({}, state, { showModalErrorImport: payload.showModalErrorImport, messageError: payload.messageError });
    case _constants.SET_IMPORTING_STATUS:
      return (0, _extends3.default)({}, state, { importingStatus: payload.importingStatus });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  invalidTokenVerifyEmail: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.VERIFY_EMAIL_INVALID_TOKEN:
      return (0, _extends3.default)({}, state, { invalidTokenVerifyEmail: payload.invalidTokenVerifyEmail });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(427);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  invalidTokenVerifyEmailAlertRecipient: false,
  message: null

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN:
      return (0, _extends3.default)({}, state, { invalidTokenVerifyEmailAlertRecipient: payload.invalidTokenVerifyEmailAlertRecipient });
    case _constants.SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT:
      return (0, _extends3.default)({}, state, { message: payload.message });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.reducer = reducer;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, axios, Cookies) {

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

__webpack_require__(2245);

var _reactRouter = __webpack_require__(15);

var _reactRedux = __webpack_require__(6);

var _App = __webpack_require__(1251);

var _App2 = _interopRequireDefault(_App);

var _AccountSetting = __webpack_require__(1219);

var _AccountSetting2 = _interopRequireDefault(_AccountSetting);

var _Login = __webpack_require__(1507);

var _Login2 = _interopRequireDefault(_Login);

var _Register = __webpack_require__(1522);

var _Register2 = _interopRequireDefault(_Register);

var _Library = __webpack_require__(1506);

var LibraryPages = _interopRequireWildcard(_Library);

var _RegisterComplete = __webpack_require__(1525);

var _RegisterComplete2 = _interopRequireDefault(_RegisterComplete);

var _Dashboard = __webpack_require__(1333);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _ForgotPassword = __webpack_require__(1356);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SuccessForgotPassword = __webpack_require__(1571);

var _SuccessForgotPassword2 = _interopRequireDefault(_SuccessForgotPassword);

var _NotFound = __webpack_require__(1509);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Report = __webpack_require__(1530);

var _Report2 = _interopRequireDefault(_Report);

var _ReportSummary = __webpack_require__(1543);

var _ReportSummary2 = _interopRequireDefault(_ReportSummary);

var _GrossProfit = __webpack_require__(1535);

var _GrossProfit2 = _interopRequireDefault(_GrossProfit);

var _ItemSales = __webpack_require__(1538);

var _ItemSales2 = _interopRequireDefault(_ItemSales);

var _PaymentMethods = __webpack_require__(1542);

var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);

var _CategorySales = __webpack_require__(1531);

var _CategorySales2 = _interopRequireDefault(_CategorySales);

var _ModifierSales = __webpack_require__(1539);

var _ModifierSales2 = _interopRequireDefault(_ModifierSales);

var _Discounts = __webpack_require__(1533);

var _Discounts2 = _interopRequireDefault(_Discounts);

var _Taxes = __webpack_require__(1545);

var _Taxes2 = _interopRequireDefault(_Taxes);

var _Gratuity = __webpack_require__(1534);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _CollectedBy = __webpack_require__(1532);

var _CollectedBy2 = _interopRequireDefault(_CollectedBy);

var _ServedBy = __webpack_require__(1544);

var _ServedBy2 = _interopRequireDefault(_ServedBy);

var _ResendVerificationEmail = __webpack_require__(1566);

var _ResendVerificationEmail2 = _interopRequireDefault(_ResendVerificationEmail);

var _Shift = __webpack_require__(1547);

var _Shift2 = _interopRequireDefault(_Shift);

var _Invoices = __webpack_require__(1528);

var _Invoices2 = _interopRequireDefault(_Invoices);

var _ResetPassword = __webpack_require__(1568);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _SuccessResetPassword = __webpack_require__(1572);

var _SuccessResetPassword2 = _interopRequireDefault(_SuccessResetPassword);

var _Transaction = __webpack_require__(1563);

var _Transaction2 = _interopRequireDefault(_Transaction);

var _Account = __webpack_require__(1217);

var _Account2 = _interopRequireDefault(_Account);

var _PublicProfile = __webpack_require__(1243);

var _PublicProfile2 = _interopRequireDefault(_PublicProfile);

var _Version = __webpack_require__(1575);

var _Version2 = _interopRequireDefault(_Version);

var _Checkout = __webpack_require__(1228);

var _Checkout2 = _interopRequireDefault(_Checkout);

var _Receipt = __webpack_require__(1247);

var _Receipt2 = _interopRequireDefault(_Receipt);

var _EmailNotification = __webpack_require__(1242);

var _EmailNotification2 = _interopRequireDefault(_EmailNotification);

var _Billing = __webpack_require__(1221);

var _Billing2 = _interopRequireDefault(_Billing);

var _Customers = __webpack_require__(1330);

var _Customers2 = _interopRequireDefault(_Customers);

var _Employees = __webpack_require__(1350);

var _Employees2 = _interopRequireDefault(_Employees);

var _Inventory = __webpack_require__(1434);

var _Inventory2 = _interopRequireDefault(_Inventory);

var _Ingredient = __webpack_require__(1389);

var _Ingredient2 = _interopRequireDefault(_Ingredient);

var _Outlets = __webpack_require__(1519);

var _Outlets2 = _interopRequireDefault(_Outlets);

var _subscriptionExpired = __webpack_require__(204);

var _actions = __webpack_require__(18);

var _notifications = __webpack_require__(23);

var _reactRouterRedux = __webpack_require__(49);

var _FeedbackReplyForm = __webpack_require__(1353);

var _FeedbackReplyForm2 = _interopRequireDefault(_FeedbackReplyForm);

var _VerifyEmail = __webpack_require__(1573);

var _VerifyEmail2 = _interopRequireDefault(_VerifyEmail);

var _ConfirmEmployee = __webpack_require__(1253);

var _ConfirmEmployee2 = _interopRequireDefault(_ConfirmEmployee);

var _SuccessConfirmEmployee = __webpack_require__(1255);

var _SuccessConfirmEmployee2 = _interopRequireDefault(_SuccessConfirmEmployee);

var _FeedbackForm = __webpack_require__(1352);

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

var _BillingRedirect = __webpack_require__(1252);

var _BillingRedirect2 = _interopRequireDefault(_BillingRedirect);

var _VerifyEmailAlertRecipient = __webpack_require__(1574);

var _VerifyEmailAlertRecipient2 = _interopRequireDefault(_VerifyEmailAlertRecipient);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeJS = __webpack_require__(199);

/**
 * DO NOT REMOVE COMMENTED CODE
 * This is intended if the 'async import version' becomes problematic
 * Then uncomment the 'sync import version' and comment the `async version`
 */


module.exports = function (store) {
  // This array consists of routes that CANNOT be accessed by manager
  var ManagerRouteExcept = ['/library/tax', '/library/gratuity', '/inventory/suppliers', '/employees/permission', '/outlets', '/outlets/list', '/settings', '/settings/billing', '/settings/public_profile', '/settings/checkout', '/settings/email'];

  // This array consists of routes that CAN be accessed by staff
  var StaffRouteOnly = ['/settings/accounts'];

  var routes = function routes() {
    var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
    return React.createElement(
      _reactRedux.Provider,
      { store: store },
      React.createElement(
        _reactRouter.Router,
        { history: history },
        React.createElement(_reactRouter.Route, { path: '/version', component: _Version2.default }),
        React.createElement(
          _reactRouter.Route,
          { onEnter: fillApplicationState, component: _App2.default, onChange: handleOnChange },
          React.createElement(_reactRouter.Route, { path: '/feedback/reply-form/:token', hideHeader: true, component: _FeedbackReplyForm2.default }),
          React.createElement(_reactRouter.Route, { path: '/feedback/feedback-form/:token/:quality', hideHeader: true, component: _FeedbackForm2.default }),
          React.createElement(_reactRouter.Route, { path: '/confirm-employee-invitation', component: _ConfirmEmployee2.default }),
          React.createElement(_reactRouter.Route, { path: '/success-confirm-employee-invitation', component: _SuccessConfirmEmployee2.default }),
          React.createElement(_reactRouter.Route, { path: '/verify-email-alert-recipient/:token', component: _VerifyEmailAlertRecipient2.default }),
          React.createElement(_reactRouter.Route, { path: '/', onEnter: handleStaffAccess }),
          React.createElement(
            _reactRouter.Route,
            { onEnter: shouldLogin },
            React.createElement(_reactRouter.Route, { path: '/', component: _Dashboard2.default, onEnter: handleStaffAccess }),
            React.createElement(_reactRouter.Route, { path: '/dashboard', component: _Dashboard2.default, onEnter: handleAccess }),
            React.createElement(
              _reactRouter.Route,
              { path: '/reports', component: _Report2.default },
              React.createElement(_reactRouter.Route, { path: '/reports/summary', component: _ReportSummary2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/gross_profit', component: _GrossProfit2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/item_sales', component: _ItemSales2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/payment_methods', component: _PaymentMethods2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/category_sales', component: _CategorySales2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/modifier_sales', component: _ModifierSales2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/discounts', component: _Discounts2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/taxes', component: _Taxes2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/gratuity', component: _Gratuity2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/staff', component: _CollectedBy2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/server', component: _ServedBy2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/shifts', component: _Shift2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/invoices', component: _Invoices2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/transactions', component: _Transaction2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/transactions', component: _Transaction2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/reports/invoices', component: _Invoices2.default, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/library', component: LibraryPages.default },
              React.createElement(_reactRouter.Route, { path: '/library/list', component: LibraryPages.Item, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/library/category', component: LibraryPages.Category, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/library/discount', component: LibraryPages.Discount, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/library/gratuity', component: LibraryPages.Gratuity, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/library/modifier', component: LibraryPages.Modifier, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/library/tax', component: LibraryPages.Tax, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/settings', component: _AccountSetting2.default },
              React.createElement(_reactRouter.Route, { path: '/settings/accounts', component: _Account2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/settings/billing', component: _Billing2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/settings/checkout', component: _Checkout2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/settings/public_profile', component: _PublicProfile2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/settings/receipt', component: _Receipt2.default, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/settings/email', component: _EmailNotification2.default, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: 'customers', component: _Customers2.default },
              React.createElement(_reactRouter.Route, { path: '/customers/list', component: _Customers.CustomerList, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/customers/feedback_list', component: _Customers.Feedback, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/customers/loyalty', component: _Customers.Loyalty, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/employees', component: _Employees2.default },
              React.createElement(_reactRouter.Route, { path: '/employees/list', component: _Employees.List, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: '/employees/permission', component: _Employees.Permission, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/inventory', component: _Inventory2.default },
              React.createElement(_reactRouter.Route, { path: 'summary', component: _Inventory.Summary, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'suppliers', component: _Inventory.Supplier, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'purchase_orders', component: _Inventory.PurchaseOrder, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'transfer', component: _Inventory.Transfer, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'adjustment', component: _Inventory.Adjustment, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/ingredient', component: _Ingredient2.default },
              React.createElement(_reactRouter.Route, { path: 'list', component: _Ingredient.Library, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'categories', component: _Ingredient.Category, onEnter: handleAccess }),
              React.createElement(_reactRouter.Route, { path: 'recipes', component: _Ingredient.Recipes, onEnter: handleAccess })
            ),
            React.createElement(
              _reactRouter.Route,
              { path: '/outlets', component: _Outlets2.default },
              React.createElement(_reactRouter.Route, { path: '/outlets/list', component: _Outlets.List, onEnter: handleAccess })
            ),
            React.createElement(_reactRouter.Route, { path: '/billings/redirect', component: _BillingRedirect2.default, onEnter: handleAccess })
          ),
          React.createElement(
            _reactRouter.Route,
            { onEnter: shouldNotLogin },
            React.createElement(_reactRouter.Route, { path: '/login', component: _Login2.default }),
            React.createElement(_reactRouter.Route, { path: '/register(/:chapcha)', component: _Register2.default }),
            React.createElement(_reactRouter.Route, { path: '/register-complete', component: _RegisterComplete2.default }),
            React.createElement(_reactRouter.Route, { path: '/forgot', component: _ForgotPassword2.default }),
            React.createElement(_reactRouter.Route, { path: '/reset-password/:token', component: _ResetPassword2.default }),
            React.createElement(_reactRouter.Route, { path: '/success-reset-password', component: _SuccessResetPassword2.default }),
            React.createElement(_reactRouter.Route, { path: '/success-forgot-password', component: _SuccessForgotPassword2.default }),
            React.createElement(_reactRouter.Route, { path: '/resend', component: _ResendVerificationEmail2.default }),
            React.createElement(_reactRouter.Route, { path: '/verify-email/:token', component: _VerifyEmail2.default }),
            React.createElement(_reactRouter.Route, { path: '/confirm-employee-invitation', component: _ConfirmEmployee2.default }),
            React.createElement(_reactRouter.Route, { path: '/success-confirm-employee-invitation', component: _SuccessConfirmEmployee2.default })
          )
        ),
        React.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
      )
    );
  };
  function handleOnChange(prevState, nextState) {
    // reset the notification.
    store.dispatch((0, _notifications.reset)());
  }

  function fillApplicationState(nextState, replace, callback) {
    var _store$getState = store.getState(),
        loggedIn = _store$getState.moka.loggedIn;

    store.dispatch((0, _actions.clearError)());

    if (isLocalStorageNameSupported()) {
      store.dispatch((0, _actions.setAuthFromLocal)());
      setTimeout(function () {
        callback();
      }, 100);
    } else {
      if (loggedIn) {
        apiProfile.getProfile().then(function (response) {
          store.dispatch((0, _actions.setAuthFromApi)(response.data));
          setTimeout(function () {
            callback();
          }, 100);
        });
      } else {
        callback();
      }
    }
  }

  function handleAccess() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var routes = args[0],
        replace = args[1];

    var _store$getState2 = store.getState(),
        moka = _store$getState2.moka;

    var user = moka.user,
        loggedIn = moka.loggedIn;

    if (loggedIn) {
      if (user.is_manager && _.includes(ManagerRouteExcept, routes.location.pathname)) {
        replace('/dashboard');
      } else if (!user.is_manager && !user.is_owner && !_.includes(StaffRouteOnly, routes.location.pathname)) {
        replace('/settings/accounts');
      }
    }
  }

  function shouldNotLogin(nextState, replace) {
    var _store$getState3 = store.getState(),
        moka = _store$getState3.moka;

    var loggedIn = moka.loggedIn;


    if (loggedIn) {
      replace('/');
    }
  }

  function shouldLogin(nextState, replace) {
    var _store$getState4 = store.getState(),
        moka = _store$getState4.moka;

    var loggedIn = moka.loggedIn;


    if (!loggedIn) {
      replace('/login?next=' + nextState.location.pathname);
      store.dispatch((0, _notifications.error)('You must be Signed in'));
    }
  }

  function handleStaffAccess(nextState, replace) {
    var _store$getState5 = store.getState(),
        moka = _store$getState5.moka;

    var user = moka.user,
        loggedIn = moka.loggedIn;

    if (loggedIn) {
      if (!user.is_manager && !user.is_owner) {
        replace('/settings/accounts');
      } else {
        replace('/dashboard');
      }
    } else {
      replace('/login');
    }
  }

  axios.interceptors.request.use(function (config) {
    // ONLY SEND AUTHORIZATION IF ITS GOING TO MOKAPOS.COM
    // THIS LOGIC IS FOR SOLVING AUTHORIZATION PROBLEM HITTING S3 ENDPOINT
    if (config.url.includes('mokapos.com')) {
      var rememberToken = Cookies.get('remember_token');
      config.headers['Authorization'] = rememberToken;
    }
    return config;
  }, function (error) {
    // Do something with request error
    return _promise2.default.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    if (response.config.url.match(/profile/g)) {
      store.dispatch((0, _actions.setAuthState)(true, response.data));
      store.dispatch((0, _actions.setProfile)(response.data));
      if ((0, _moment2.default)(response.data.business.expired_at) <= (0, _moment2.default)()) {
        store.dispatch((0, _subscriptionExpired.isSubscriptionExpired)(true));
        store.dispatch((0, _subscriptionExpired.showSubscriptionExpiredModal)());
        if (window.location.pathname !== '/settings/billing') {
          forwardTo('/settings/billing');
        }
      } else {
        store.dispatch((0, _subscriptionExpired.isSubscriptionExpired)(false));
        store.dispatch((0, _subscriptionExpired.hideSubscriptionExpiredModal)());
      }
    }
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      if (error.response.data.error) {
        store.dispatch((0, _notifications.error)(error.response.data.error));
        return _promise2.default.reject(error);
      } else {
        resetLoggedIn();
        return _promise2.default.reject(new Error('You must be Signed in'));
      }
    } else {
      return _promise2.default.reject(error);
    }
  });

  axios.interceptors.request.use(function (config) {
    var rememberToken = Cookies.get('remember_token');
    // only include auth header if it is new endpoint
    var serviceHost = "https://service-dev.mokapos.com";
    if (config.url.startsWith(serviceHost)) {
      config.headers['Authorization'] = rememberToken;
    }
    return config;
  }, function (error) {
    // Do something with request error
    return _promise2.default.reject(error);
  });

  function resetLoggedIn() {
    Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' });
    storeJS.clearAll();
    window.location.reload();
  }

  function forwardTo(location) {
    _reactRouter.browserHistory.push(location);
  }

  function isLocalStorageNameSupported() {
    var testKey = 'test';
    var storage = window.localStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  return routes;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(25), __webpack_require__(65)))

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.referralFlow = referralFlow;
exports.default = authSaga;

var _constants = __webpack_require__(380);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actionNotif = _interopRequireWildcard(_notifications);

var _auth = __webpack_require__(605);

var actionAuth = _interopRequireWildcard(_auth);

var _auth2 = __webpack_require__(237);

var apiAuth = _interopRequireWildcard(_auth2);

var _effects = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [referralFlow, authSaga].map(_regenerator2.default.mark);

function referralFlow() {
  var request, referral, response;
  return _regenerator2.default.wrap(function referralFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 29;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.REFERRAL_REQUEST);

        case 3:
          request = _context.sent;
          _context.next = 6;
          return (0, _effects.put)(action.showProgressBar());

        case 6:
          _context.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          referral = request.payload.referral;
          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.call)(apiAuth.referral, referral);

        case 12:
          response = _context.sent;
          _context.next = 15;
          return (0, _effects.put)(actionAuth.changeReferralData(response.data));

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context['catch'](9);
          _context.next = 21;
          return (0, _effects.put)(actionNotif.error(_context.t0.message));

        case 21:
          _context.prev = 21;
          _context.next = 24;
          return (0, _effects.put)(action.sendingRequest(false));

        case 24:
          _context.next = 26;
          return (0, _effects.put)(action.hideProgressBar());

        case 26:
          return _context.finish(21);

        case 27:
          _context.next = 0;
          break;

        case 29:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 17, 21, 27]]);
}

function authSaga() {
  return _regenerator2.default.wrap(function authSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(referralFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.showBillingNotificationFlow = showBillingNotificationFlow;
exports.default = billingNotificationSaga;

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _constant = __webpack_require__(606);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [showBillingNotificationFlow, billingNotificationSaga].map(_regenerator2.default.mark); /**
                                                                                                       * Created by alvinoktavianus on 6/22/17.
                                                                                                       */

function showBillingNotificationFlow(request) {
  var _request$payload$bill, notificationMessage, notificationType;

  return _regenerator2.default.wrap(function showBillingNotificationFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _request$payload$bill = request.payload.billingNotification, notificationMessage = _request$payload$bill.notificationMessage, notificationType = _request$payload$bill.notificationType;
          _context.t0 = notificationType;
          _context.next = _context.t0 === 'success' ? 4 : _context.t0 === 'pending' ? 7 : _context.t0 === 'failed' ? 10 : 13;
          break;

        case 4:
          _context.next = 6;
          return (0, _effects.put)(actNotif.success(notificationMessage));

        case 6:
          return _context.abrupt('break', 13);

        case 7:
          _context.next = 9;
          return (0, _effects.put)(actNotif.warning(notificationMessage));

        case 9:
          return _context.abrupt('break', 13);

        case 10:
          _context.next = 12;
          return (0, _effects.put)(actNotif.error(notificationMessage));

        case 12:
          return _context.abrupt('break', 13);

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function billingNotificationSaga() {
  return _regenerator2.default.wrap(function billingNotificationSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constant.BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION, showBillingNotificationFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.updatePaymentStatusFlow = updatePaymentStatusFlow;
exports.default = billingRedirectSaga;

var _effects = __webpack_require__(22);

var _reactRouter = __webpack_require__(15);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _billingRedirect = __webpack_require__(232);

var _constant = __webpack_require__(382);

var _billingRedirect2 = __webpack_require__(1059);

var _profile = __webpack_require__(48);

var _subscriptionExpired = __webpack_require__(204);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [updatePaymentStatusFlow, billingRedirectSaga].map(_regenerator2.default.mark); /**
                                                                                               * Created by alvinoktavianus on 6/21/17.
                                                                                               */

function updatePaymentStatusFlow(request) {
  var queryParams, response, _response$data, message, type, url, resProfile;

  return _regenerator2.default.wrap(function updatePaymentStatusFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          action.showProgressBar();
          queryParams = {
            order_id: request.payload.orderId,
            status_code: request.payload.statusCode,
            transaction_status: request.payload.transactionStatus
          };
          _context.next = 4;
          return (0, _effects.call)(_billingRedirect2.updatePaymentStatus, queryParams);

        case 4:
          response = _context.sent;
          _response$data = response.data, message = _response$data.message, type = _response$data.type, url = _response$data.url;
          _context.next = 8;
          return (0, _effects.put)((0, _billingRedirect.setNotificationMessage)(message));

        case 8:
          _context.next = 10;
          return (0, _effects.put)((0, _billingRedirect.setNotificationType)(type));

        case 10:
          _context.next = 12;
          return (0, _effects.call)(_profile.getProfile);

        case 12:
          resProfile = _context.sent;

          if (!((0, _moment2.default)(resProfile.data.business.expired_at) > (0, _moment2.default)())) {
            _context.next = 16;
            break;
          }

          _context.next = 16;
          return (0, _effects.put)((0, _subscriptionExpired.isSubscriptionExpired)(false));

        case 16:
          action.hideProgressBar();
          _reactRouter.browserHistory.push('' + url);

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function billingRedirectSaga() {
  return _regenerator2.default.wrap(function billingRedirectSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constant.BILLING_REDIRECT_UPDATE_PAYMENT_STATUS, updatePaymentStatusFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.changeDateFlow = changeDateFlow;
exports.default = calendarSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(383);

var _calendar = __webpack_require__(1052);

var _updateFilteredDate = __webpack_require__(1606);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [changeDateFlow, calendarSaga].map(_regenerator2.default.mark);

function changeDateFlow() {
  var request, _request$payload, startDate, endDate, data;

  return _regenerator2.default.wrap(function changeDateFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 13;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.CALENDAR_CHANGE_DATE);

        case 3:
          request = _context.sent;
          _request$payload = request.payload, startDate = _request$payload.startDate, endDate = _request$payload.endDate;
          _context.next = 7;
          return (0, _effects.call)(_updateFilteredDate.updateFilteredDate, { from: startDate.toString(), to: endDate.startOf('day').toString() });

        case 7:
          data = _context.sent;

          if (!data) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)((0, _calendar.setDate)((0, _moment2.default)(data.start_date), (0, _moment2.default)(data.end_date)));

        case 11:
          _context.next = 0;
          break;

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function calendarSaga() {
  return _regenerator2.default.wrap(function calendarSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(changeDateFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.askConfirmActionFlow = askConfirmActionFlow;
exports.confirmActionFlow = confirmActionFlow;
exports.cancelActionFlow = cancelActionFlow;
exports.default = confirmActionSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(384);

var _confirmAction = __webpack_require__(29);

var actConfirmAction = _interopRequireWildcard(_confirmAction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [askConfirmActionFlow, confirmActionFlow, cancelActionFlow, confirmActionSaga].map(_regenerator2.default.mark);

/****************************************************************************************************
 * Action Confirmation
 ****************************************************************************************************/

function askConfirmActionFlow() {
  var _ref, nextAction;

  return _regenerator2.default.wrap(function askConfirmActionFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 11;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.CONFIRM_ACTION_ASK_CONFIRM_ACTION);

        case 3:
          _ref = _context.sent;
          nextAction = _ref.payload.nextAction;
          _context.next = 7;
          return (0, _effects.put)(actConfirmAction.setNextAction(nextAction));

        case 7:
          _context.next = 9;
          return (0, _effects.put)(actConfirmAction.showConfirmActionModal());

        case 9:
          _context.next = 0;
          break;

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function confirmActionFlow() {
  var _ref2, _nextAction;

  return _regenerator2.default.wrap(function confirmActionFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 13;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.CONFIRM_ACTION_CONFIRM_ACTION);

        case 3:
          _ref2 = _context2.sent;
          _nextAction = _ref2.payload.nextAction;
          _context2.next = 7;
          return (0, _effects.put)(actConfirmAction.setNextAction(null));

        case 7:
          _context2.next = 9;
          return (0, _effects.put)(actConfirmAction.hideConfirmActionModal());

        case 9:
          _context2.next = 11;
          return (0, _effects.put)(_nextAction);

        case 11:
          _context2.next = 0;
          break;

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function cancelActionFlow() {
  return _regenerator2.default.wrap(function cancelActionFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (false) {
            _context3.next = 9;
            break;
          }

          _context3.next = 3;
          return (0, _effects.take)(_constants.CONFIRM_ACTION_CANCEL_ACTION);

        case 3:
          _context3.next = 5;
          return (0, _effects.put)(actConfirmAction.setNextAction(null));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(actConfirmAction.hideConfirmActionModal());

        case 7:
          _context3.next = 0;
          break;

        case 9:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/****************************************************************************************************
 * End Action Confirmation
 ****************************************************************************************************/

function confirmActionSaga() {
  return _regenerator2.default.wrap(function confirmActionSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(askConfirmActionFlow);

        case 2:
          _context4.next = 4;
          return (0, _effects.fork)(confirmActionFlow);

        case 4:
          _context4.next = 6;
          return (0, _effects.fork)(cancelActionFlow);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.createEmployeeAccount = createEmployeeAccount;
exports.default = confirmEmployeeSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(385);

var _getEmployee = __webpack_require__(1082);

var _reduxForm = __webpack_require__(7);

var _confirmEmployee = __webpack_require__(1066);

var _confirmEmployee2 = __webpack_require__(608);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _reactRouter = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillFormConfirmEmployee, pageRequest, createEmployeeAccount, confirmEmployeeSaga].map(_regenerator2.default.mark);

function fillFormConfirmEmployee(request) {
  var employee, form;
  return _regenerator2.default.wrap(function fillFormConfirmEmployee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          employee = request;
          form = {
            firstName: employee.first_name,
            lastName: employee.last_name,
            email: employee.email,
            password: '',
            confirmPassword: ''
          };
          _context.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('confirmEmployeeForm', form));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function pageRequest(request) {
  var params, resEmployee, employee, business;
  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          params = request.payload.params;
          _context2.next = 6;
          return (0, _effects.call)(_getEmployee.getEmployee, { business_id: params.business_id, pending_email: params.pending_email });

        case 6:
          resEmployee = _context2.sent;
          employee = resEmployee.data.user;
          business = resEmployee.data.business;
          _context2.next = 11;
          return (0, _effects.call)(fillFormConfirmEmployee, employee);

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _confirmEmployee2.setInvitedEmployee)({ business: business, employee: employee }));

        case 13:
          _context2.next = 21;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 19;
          return (0, _effects.put)((0, _confirmEmployee2.isInvalidInvitation)(true));

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 21:
          _context2.prev = 21;
          _context2.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
          return _context2.finish(21);

        case 25:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 15, 21, 25]]);
}

function createEmployeeAccount(request) {
  var _request$payload$data, business, employee;

  return _regenerator2.default.wrap(function createEmployeeAccount$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _request$payload$data = request.payload.data, business = _request$payload$data.business, employee = _request$payload$data.employee;
          _context3.next = 6;
          return (0, _effects.call)(_confirmEmployee.confirmEmployeeInvitation, { business: business, employee: employee });

        case 6:
          _reactRouter.browserHistory.push('/success-confirm-employee-invitation');
          _context3.next = 9;
          return (0, _effects.put)(actNotif.success('Employee invitation confirmed'));

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 15;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 15:
          _context3.prev = 15;
          _context3.next = 18;
          return (0, _effects.put)((0, _reduxForm.reset)('confirmEmployeeForm'));

        case 18:
          _context3.next = 20;
          return (0, _effects.put)(act.hideProgressBar());

        case 20:
          return _context3.finish(15);

        case 21:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 11, 15, 21]]);
}

function confirmEmployeeSaga() {
  return _regenerator2.default.wrap(function confirmEmployeeSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_constants.CONFIRM_EMPLOYEE_PAGE_REQUEST, pageRequest);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeLatest)(_constants.CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT, createEmployeeAccount);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loyaltySaga = exports.customerListSaga = exports.customerFeedbackSaga = undefined;

var _feedback = __webpack_require__(1607);

var _feedback2 = _interopRequireDefault(_feedback);

var _list = __webpack_require__(1608);

var _list2 = _interopRequireDefault(_list);

var _loyalty = __webpack_require__(1609);

var _loyalty2 = _interopRequireDefault(_loyalty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.customerFeedbackSaga = _feedback2.default;
exports.customerListSaga = _list2.default;
exports.loyaltySaga = _loyalty2.default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.getDashboardRequestFlow = getDashboardRequestFlow;
exports.changeOutletFlow = changeOutletFlow;
exports.changeDateFlow = changeDateFlow;
exports.cancelAction = cancelAction;
exports.default = dashboardSaga;

var _dashboard = __webpack_require__(1073);

var authDashboard = _interopRequireWildcard(_dashboard);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _getFilteredDate = __webpack_require__(249);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _dashboard2 = __webpack_require__(390);

var _actionBar = __webpack_require__(80);

var actActionBar = _interopRequireWildcard(_actionBar);

var _profile = __webpack_require__(114);

var _login = __webpack_require__(250);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _constants = __webpack_require__(389);

var _constants2 = __webpack_require__(91);

var _notifications = __webpack_require__(23);

var actNotification = _interopRequireWildcard(_notifications);

var _profile2 = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile2);

var _loadingSpinner = __webpack_require__(46);

var _dashboard3 = __webpack_require__(649);

var mpDashboard = _interopRequireWildcard(_dashboard3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, getDashboardRequestFlow, changeOutletFlow, changeDateFlow, cancelAction, dashboardSaga].map(_regenerator2.default.mark);

function pageRequest(request) {
  var data, startDate, endDate, resOutlet, resProfile, query, dashboardData;
  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _dashboard2.setDashboard)({ gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: [] }));

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDateAsMoment);

        case 9:
          data = _context.sent;
          startDate = data.startDate, endDate = data.endDate;
          _context.next = 13;
          return (0, _effects.call)(apiOutlet.outlets);

        case 13:
          resOutlet = _context.sent;
          _context.next = 16;
          return (0, _effects.put)((0, _dashboard2.setOutlets)(resOutlet.data));

        case 16:
          _context.next = 18;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlet.data));

        case 18:
          _context.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          resProfile = _context.sent;
          _context.next = 23;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(resProfile.data.outlet_id));

        case 23:
          _context.next = 25;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            'date': { startDate: startDate, endDate: endDate },
            'outlet': resProfile.data.outlet_id
          }));

        case 25:

          // call dashboard api
          query = {
            start_date: startDate.format('D/M/YYYY'),
            end_date: endDate.format('D/M/YYYY')
          };
          _context.next = 28;
          return (0, _effects.call)(authDashboard.dashboard, query);

        case 28:
          dashboardData = _context.sent;
          _context.next = 31;
          return (0, _effects.put)((0, _dashboard2.setDashboard)(dashboardData.data));

        case 31:
          mpDashboard.dashboardStart({
            outletIds: resProfile.data.outlet_id,
            startDate: startDate,
            endDate: endDate
          });
          _context.next = 38;
          break;

        case 34:
          _context.prev = 34;
          _context.t0 = _context['catch'](4);
          _context.next = 38;
          return (0, _effects.put)(actNotification.error(_context.t0.message));

        case 38:
          _context.prev = 38;
          _context.next = 41;
          return (0, _effects.put)(action.hideProgressBar());

        case 41:
          _context.next = 43;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 43:
          return _context.finish(38);

        case 44:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 34, 38, 44]]);
}

function getDashboardRequestFlow(request) {
  var payload, query, data, startDate, endDate, resOutlet, profileData, dashboardData;
  return _regenerator2.default.wrap(function getDashboardRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          payload = request.payload;
          query = payload.query;

          if (query) {
            _context2.next = 12;
            break;
          }

          _context2.next = 7;
          return (0, _effects.call)(_getFilteredDate.getFilteredDateAsMoment);

        case 7:
          data = _context2.sent;
          startDate = data.startDate, endDate = data.endDate;
          _context2.next = 11;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'date', { startDate: startDate, endDate: endDate }));

        case 11:
          query = {
            start_date: startDate.format('D/M/YYYY'),
            end_date: endDate.format('D/M/YYYY')
          };

        case 12:
          _context2.next = 14;
          return (0, _effects.put)(action.sendingRequest(true));

        case 14:
          _context2.next = 16;
          return (0, _effects.put)(action.showProgressBar());

        case 16:
          _context2.next = 18;
          return (0, _effects.call)(apiOutlet.outlets);

        case 18:
          resOutlet = _context2.sent;
          _context2.next = 21;
          return (0, _effects.put)((0, _dashboard2.setOutlets)(resOutlet.data));

        case 21:
          _context2.prev = 21;
          _context2.next = 24;
          return (0, _effects.call)(_profile.getProfile);

        case 24:
          profileData = _context2.sent;
          _context2.next = 27;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outlet', profileData.outlet_id));

        case 27:
          _context2.next = 29;
          return (0, _effects.call)(authDashboard.dashboard, query);

        case 29:
          dashboardData = _context2.sent;
          _context2.next = 32;
          return (0, _effects.put)((0, _dashboard2.setDashboard)(dashboardData.data));

        case 32:
          _context2.next = 38;
          break;

        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2['catch'](21);
          _context2.next = 38;
          return (0, _effects.put)(actNotification.error(_context2.t0.message));

        case 38:
          _context2.prev = 38;
          _context2.next = 41;
          return (0, _effects.put)(action.sendingRequest(false));

        case 41:
          _context2.next = 43;
          return (0, _effects.put)(action.hideProgressBar());

        case 43:
          _context2.next = 45;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 45:
          return _context2.finish(38);

        case 46:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[21, 34, 38, 46]]);
}

function changeOutletFlow(request) {
  var payload, outletIds, startDate, endDate, dashboardData;
  return _regenerator2.default.wrap(function changeOutletFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _dashboard2.setDashboard)({ gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: [] }));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context3.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context3.next = 10;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'date', { startDate: startDate, endDate: endDate }));

        case 10:
          _context3.next = 12;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outlet', outletIds));

        case 12:
          _context3.next = 14;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(outletIds));

        case 14:
          _context3.next = 16;
          return (0, _effects.call)(authDashboard.dashboard, { start_date: startDate.format('D/M/YYYY'), end_date: endDate.format('D/M/YYYY') });

        case 16:
          dashboardData = _context3.sent;
          _context3.next = 19;
          return (0, _effects.put)((0, _dashboard2.setDashboard)(dashboardData.data));

        case 19:
          _context3.next = 21;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 21:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function changeDateFlow(request) {
  var _request$payload, startDate, endDate, queryParams, dashboardData;

  return _regenerator2.default.wrap(function changeDateFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _dashboard2.setDashboard)({ gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: [] }));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload = request.payload, startDate = _request$payload.startDate, endDate = _request$payload.endDate;
          queryParams = { start_date: (0, _moment2.default)(startDate).format('D/M/YYYY'), end_date: (0, _moment2.default)(endDate).format('D/M/YYYY') };
          _context4.next = 8;
          return (0, _effects.call)(authDashboard.dashboard, queryParams);

        case 8:
          dashboardData = _context4.sent;
          _context4.next = 11;
          return (0, _effects.put)((0, _dashboard2.setDashboard)(dashboardData.data));

        case 11:
          _context4.next = 13;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function cancelAction(args) {
  return _regenerator2.default.wrap(function cancelAction$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(args));

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function dashboardSaga() {
  var pageReqTask, task, task2, changeDateTask;
  return _regenerator2.default.wrap(function dashboardSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_constants.DASHBOARD_PAGE_REQUEST, pageRequest);

        case 2:
          pageReqTask = _context6.sent;
          _context6.next = 5;
          return (0, _effects.takeLatest)(_constants.GET_DASHBOARD_REQUEST, getDashboardRequestFlow);

        case 5:
          task = _context6.sent;
          _context6.next = 8;
          return (0, _effects.takeLatest)(_constants.DASHBOARD_CHANGE_OUTLET, changeOutletFlow);

        case 8:
          task2 = _context6.sent;
          _context6.next = 11;
          return (0, _effects.takeLatest)(_constants.DASHBOARD_CHANGE_DATE, changeDateFlow);

        case 11:
          changeDateTask = _context6.sent;
          _context6.next = 14;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [task, task2, pageReqTask, changeDateTask]);

        case 14:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.employeePermissionSaga = exports.employeeListSaga = undefined;

var _permission = __webpack_require__(1611);

var _permission2 = _interopRequireDefault(_permission);

var _list = __webpack_require__(1610);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.employeeListSaga = _list2.default;
exports.employeePermissionSaga = _permission2.default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownCalendarFormSaga = undefined;

var _dropdownCalendarForm = __webpack_require__(1612);

var _dropdownCalendarForm2 = _interopRequireDefault(_dropdownCalendarForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.dropdownCalendarFormSaga = _dropdownCalendarForm2.default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.submitCustomerFeedback = submitCustomerFeedback;
exports.default = feedbackFormSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(393);

var _reduxForm = __webpack_require__(7);

var _feedbackForm = __webpack_require__(611);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _feedbackReplyForm = __webpack_require__(624);

var _customers = __webpack_require__(622);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillCustomerFeedbackForm, pageRequest, submitCustomerFeedback, feedbackFormSaga].map(_regenerator2.default.mark);

function fillCustomerFeedbackForm() {
  var form;
  return _regenerator2.default.wrap(function fillCustomerFeedbackForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          form = {
            feedbackType: 'wait_time',
            comment: ''
          };
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('customerFeedbackForm', form));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function pageRequest(request) {
  var params, resFeedbackToken, invalidToken, data;
  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          params = request.payload.params;
          _context2.next = 6;
          return (0, _effects.call)(_feedbackReplyForm.checkFeedbackToken, params.feedback_token);

        case 6:
          resFeedbackToken = _context2.sent;
          invalidToken = resFeedbackToken.data.feedback_error;
          data = resFeedbackToken.data;

          if (!invalidToken) {
            _context2.next = 14;
            break;
          }

          _context2.next = 12;
          return (0, _effects.put)((0, _feedbackForm.isInvalidFeedback)(true));

        case 12:
          _context2.next = 16;
          break;

        case 14:
          _context2.next = 16;
          return (0, _effects.put)((0, _feedbackForm.showForm)(true));

        case 16:
          _context2.next = 18;
          return (0, _effects.call)(fillCustomerFeedbackForm);

        case 18:
          _context2.next = 20;
          return (0, _effects.put)((0, _feedbackForm.setDataCheckFeedbackToken)(data));

        case 20:
          _context2.next = 26;
          break;

        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 26;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 26:
          _context2.prev = 26;
          _context2.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context2.finish(26);

        case 30:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 22, 26, 30]]);
}

function submitCustomerFeedback(request) {
  var data, res, error;
  return _regenerator2.default.wrap(function submitCustomerFeedback$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          data = request.payload.data;
          _context3.next = 6;
          return (0, _effects.call)(_customers.postCustomerFeedback, data);

        case 6:
          res = _context3.sent;
          error = res.data.error;

          if (error) {
            _context3.next = 15;
            break;
          }

          _context3.next = 11;
          return (0, _effects.put)((0, _feedbackForm.showForm)(false));

        case 11:
          _context3.next = 13;
          return (0, _effects.put)((0, _feedbackForm.isSubmitSuccess)(true));

        case 13:
          _context3.next = 19;
          break;

        case 15:
          _context3.next = 17;
          return (0, _effects.put)((0, _feedbackForm.isInvalidFeedback)(true));

        case 17:
          _context3.next = 19;
          return (0, _effects.put)((0, _feedbackForm.showForm)(false));

        case 19:
          _context3.next = 25;
          break;

        case 21:
          _context3.prev = 21;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 25;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 25:
          _context3.prev = 25;
          _context3.next = 28;
          return (0, _effects.put)((0, _reduxForm.reset)('customerFeedbackForm'));

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          return _context3.finish(25);

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 21, 25, 31]]);
}

function feedbackFormSaga() {
  return _regenerator2.default.wrap(function feedbackFormSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_constants.FEEDBACK_FORM_PAGE_REQUEST, pageRequest);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeLatest)(_constants.FEEDBACK_FORM_SUBMIT_FEEDBACK, submitCustomerFeedback);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.feedbackReplyPageRequestFlow = feedbackReplyPageRequestFlow;
exports.sendFeedbackReplyForm = sendFeedbackReplyForm;
exports.default = feedbackReplyFeedbackSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(394);

var _feedbackReplyForm = __webpack_require__(624);

var api = _interopRequireWildcard(_feedbackReplyForm);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _feedbackReplyForm2 = __webpack_require__(612);

var actionFeedback = _interopRequireWildcard(_feedbackReplyForm2);

var _reduxForm = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [feedbackReplyPageRequestFlow, sendFeedbackReplyForm, feedbackReplyFeedbackSaga].map(_regenerator2.default.mark);

function feedbackReplyPageRequestFlow() {
  var _ref, payload, response, result, responseFeedbackReply;

  return _regenerator2.default.wrap(function feedbackReplyPageRequestFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 35;
            break;
          }

          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.take)(_constants.REQUEST_FEEDBACK_REPLY);

        case 4:
          _ref = _context.sent;
          payload = _ref.payload;
          _context.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          _context.next = 10;
          return (0, _effects.put)(action.showProgressBar());

        case 10:
          _context.next = 12;
          return (0, _effects.call)(api.checkFeedbackToken, payload.token);

        case 12:
          response = _context.sent;
          result = response.data;

          if (result.token_error) {
            _context.next = 20;
            break;
          }

          _context.next = 17;
          return (0, _effects.call)(api.getFeedbackReplyForm, result.feedback_id);

        case 17:
          responseFeedbackReply = _context.sent;
          _context.next = 20;
          return (0, _effects.put)(actionFeedback.setFeedbackCustomers(responseFeedbackReply.data));

        case 20:
          _context.next = 27;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context['catch'](1);

          if (!_context.t0.data.token_error) {
            _context.next = 27;
            break;
          }

          _context.next = 27;
          return (0, _effects.put)(actionFeedback.setInvalidToken(true));

        case 27:
          _context.prev = 27;
          _context.next = 30;
          return (0, _effects.put)(action.sendingRequest(false));

        case 30:
          _context.next = 32;
          return (0, _effects.put)(action.hideProgressBar());

        case 32:
          return _context.finish(27);

        case 33:
          _context.next = 0;
          break;

        case 35:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[1, 22, 27, 33]]);
}

function sendFeedbackReplyForm() {
  var _ref2, payload;

  return _regenerator2.default.wrap(function sendFeedbackReplyForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 26;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.SEND_FEEDBACK_REPLY_FORM);

        case 3:
          _ref2 = _context2.sent;
          payload = _ref2.payload;
          _context2.prev = 5;

          $('#submit-feedback').prop('disabled', true);
          _context2.next = 9;
          return (0, _effects.put)(action.sendingRequest(true));

        case 9:
          _context2.next = 11;
          return (0, _effects.put)(action.showProgressBar());

        case 11:
          _context2.next = 13;
          return (0, _effects.call)(api.sendFeedbackReplyForm, { message: payload.message, token: payload.token });

        case 13:
          _context2.next = 15;
          return (0, _effects.put)(actionFeedback.requestFeedbackReply(payload.token));

        case 15:
          $('#submit-feedback').prop('disabled', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)((0, _reduxForm.reset)('messageForm'));

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          _context2.next = 23;
          return (0, _effects.put)(action.hideProgressBar());

        case 23:
          return _context2.finish(16);

        case 24:
          _context2.next = 0;
          break;

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[5,, 16, 24]]);
}

function feedbackReplyFeedbackSaga() {
  return _regenerator2.default.wrap(function feedbackReplyFeedbackSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(feedbackReplyPageRequestFlow);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(sendFeedbackReplyForm);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forgotPasswordSaga = undefined;

var _forgotPassword = __webpack_require__(1613);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.forgotPasswordSaga = _forgotPassword2.default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getExportedFile = getExportedFile;
exports.getExportedWithoutOutlet = getExportedWithoutOutlet;
exports.default = getExportedFileSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(613);

var _profile = __webpack_require__(114);

var _outlets = __webpack_require__(1603);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _index = __webpack_require__(18);

var act = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getExportedFile, getExportedWithoutOutlet, getExportedFileSaga].map(_regenerator2.default.mark);

function wait(millis) {
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      resolve(true);
    }, millis);
  });
}

function getExportedFile() {
  var request, _request$payload, filename, outletId, currentPage, stop, outlet, profile, pattern;

  return _regenerator2.default.wrap(function getExportedFile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 36;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.GET_EXPORTED_FILE);

        case 3:
          request = _context.sent;
          _context.next = 6;
          return (0, _effects.put)(act.sendingRequest(true));

        case 6:
          _context.next = 8;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 8:
          _request$payload = request.payload, filename = _request$payload.filename, outletId = _request$payload.outletId, currentPage = _request$payload.currentPage;
          stop = false;
          // noinspection InfiniteLoopJS

        case 10:
          if (stop) {
            _context.next = 30;
            break;
          }

          _context.next = 13;
          return (0, _effects.call)(wait, 5000);

        case 13:
          _context.next = 15;
          return (0, _effects.call)(_outlets.getOutletById, outletId);

        case 15:
          outlet = _context.sent;

          if (outlet.exporting) {
            _context.next = 28;
            break;
          }

          _context.next = 19;
          return (0, _effects.call)(_profile.getProfile);

        case 19:
          profile = _context.sent;
          pattern = new RegExp(filename, 'i');

          if (pattern.test(profile.export_items_file)) {
            _context.next = 26;
            break;
          }

          _context.next = 24;
          return (0, _effects.put)(actNotif.error('Failed to export report ' + currentPage));

        case 24:
          _context.next = 27;
          break;

        case 26:
          window.location.href = profile.export_items_file;

        case 27:
          stop = true;

        case 28:
          _context.next = 10;
          break;

        case 30:
          _context.next = 32;
          return (0, _effects.put)(act.sendingRequest(false));

        case 32:
          _context.next = 34;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 34:
          _context.next = 0;
          break;

        case 36:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function getExportedWithoutOutlet() {
  var request, _filename, stop, profile, pattern;

  return _regenerator2.default.wrap(function getExportedWithoutOutlet$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 33;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.GET_EXPORTED_FILE_TEMPLATE);

        case 3:
          request = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)(act.sendingRequest(true));

        case 6:
          _context2.next = 8;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 8:
          _filename = request.payload.filename;
          stop = false;
          // noinspection InfiniteLoopJS

        case 10:
          if (stop) {
            _context2.next = 27;
            break;
          }

          _context2.next = 13;
          return (0, _effects.call)(wait, 5000);

        case 13:
          _context2.next = 15;
          return (0, _effects.call)(_profile.getProfile);

        case 15:
          profile = _context2.sent;

          if (!(profile.exporting === false)) {
            _context2.next = 25;
            break;
          }

          pattern = new RegExp(_filename, 'i');

          if (pattern.test(profile.export_items_file)) {
            _context2.next = 23;
            break;
          }

          _context2.next = 21;
          return (0, _effects.put)(actNotif.error('Failed to download file '));

        case 21:
          _context2.next = 24;
          break;

        case 23:
          window.location.href = profile.export_items_file;

        case 24:
          stop = true;

        case 25:
          _context2.next = 10;
          break;

        case 27:
          _context2.next = 29;
          return (0, _effects.put)(act.sendingRequest(false));

        case 29:
          _context2.next = 31;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 31:
          _context2.next = 0;
          break;

        case 33:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function getExportedFileSaga() {
  return _regenerator2.default.wrap(function getExportedFileSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(getExportedFile);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(getExportedWithoutOutlet);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.authorize = authorize;
exports.loginFlow = loginFlow;
exports.logout = logout;
exports.resendVerificationEmailFlow = resendVerificationEmailFlow;
exports.logoutFlow = logoutFlow;
exports.registerFlow = registerFlow;
exports.fetchBusinessTypes = fetchBusinessTypes;
exports.businessTypesFlow = businessTypesFlow;
exports.fetchBusinessCategories = fetchBusinessCategories;
exports.businessCategoriesFlow = businessCategoriesFlow;
exports.registerBusinessFlow = registerBusinessFlow;
exports.redirectTo = redirectTo;
exports.loadResetPassword = loadResetPassword;
exports.sendResetPassword = sendResetPassword;
exports.loadPrepareEncryption = loadPrepareEncryption;
exports.getProfileFlow = getProfileFlow;
exports.toLoginPage = toLoginPage;
exports.toSignUpPage = toSignUpPage;
exports.default = root;

var _reactRouter = __webpack_require__(15);

var _reduxSaga = __webpack_require__(68);

var _effects = __webpack_require__(22);

var _auth = __webpack_require__(237);

var auth = _interopRequireWildcard(_auth);

var _notifications = __webpack_require__(23);

var actionNotification = _interopRequireWildcard(_notifications);

var _profile = __webpack_require__(114);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(91);

var _store = __webpack_require__(199);

var _store2 = _interopRequireDefault(_store);

var _profile2 = __webpack_require__(48);

var _subscriptionExpired = __webpack_require__(204);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _register = __webpack_require__(655);

var mpRegister = _interopRequireWildcard(_register);

var _login = __webpack_require__(1209);

var mpLogin = _interopRequireWildcard(_login);

var _logout = __webpack_require__(1210);

var mpLogout = _interopRequireWildcard(_logout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [authorize, loginFlow, logout, resendVerificationEmailFlow, logoutFlow, registerFlow, fetchBusinessTypes, businessTypesFlow, fetchBusinessCategories, businessCategoriesFlow, registerBusinessFlow, redirectTo, loadResetPassword, sendResetPassword, loadPrepareEncryption, getProfileFlow, toLoginPage, toSignUpPage, root].map(_regenerator2.default.mark); // This file contains the sagas used for async actions in our app. It's divided into
// "effects" that the sagas call (`authorize` and `logout`) and the actual sagas themselves,
// which listen for actions.

// Sagas help us gather all our side effects (network requests in this case) in one place

/**
 * Effect to handle authorization
 * @param  {string} email               The email of the user
 * @param  {string} password               The password of the user
 * @param  {object} options                Options
 * @param  {boolean} options.isRegistering Is this a register request?
 */
function authorize(email, password) {
  var response;
  return _regenerator2.default.wrap(function authorize$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(auth.login, email, password);

        case 3:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 7:
          _context.prev = 7;
          _context.t0 = _context['catch'](0);

          if (!_context.t0.errorTypes) {
            _context.next = 13;
            break;
          }

          return _context.abrupt('return', _context.t0);

        case 13:
          return _context.abrupt('return', _context.t0.response.data);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 7]]);
}

/**
 * Log in saga
 */
function loginFlow() {
  var request, _request$payload$data, email, password, next, winner, _winner$auth, errorTypes, user, error, profile;

  return _regenerator2.default.wrap(function loginFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 62;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.LOGIN_REQUEST);

        case 3:
          request = _context2.sent;
          _request$payload$data = request.payload.data, email = _request$payload$data.email, password = _request$payload$data.password;
          next = request.payload.next;
          _context2.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)(action.showProgressBar());

        case 10:
          _context2.next = 12;
          return (0, _effects.race)({
            auth: (0, _effects.call)(authorize, email, password),
            logout: (0, _effects.take)(_constants.LOGOUT)
          });

        case 12:
          winner = _context2.sent;
          _context2.next = 15;
          return (0, _effects.put)(action.sendingRequest(false));

        case 15:
          _context2.next = 17;
          return (0, _effects.put)(action.hideProgressBar());

        case 17:
          if (!winner.auth) {
            _context2.next = 56;
            break;
          }

          _winner$auth = winner.auth, errorTypes = _winner$auth.errorTypes, user = _winner$auth.user, error = _winner$auth.error;

          if (!user) {
            _context2.next = 46;
            break;
          }

          _context2.next = 22;
          return (0, _effects.call)(_profile2.getProfile);

        case 22:
          profile = _context2.sent;

          mpLogin.identifyFromProfile({ profile: profile.data });
          mpLogin.login({ profile: profile.data });
          _context2.next = 27;
          return (0, _effects.put)(action.setAuthState(true, profile.data));

        case 27:
          if (!(user.is_owner || user.is_manager)) {
            _context2.next = 41;
            break;
          }

          if (!((0, _moment2.default)(profile.data.business.expired_at) <= (0, _moment2.default)())) {
            _context2.next = 36;
            break;
          }

          _context2.next = 31;
          return (0, _effects.put)((0, _subscriptionExpired.isSubscriptionExpired)(true));

        case 31:
          _context2.next = 33;
          return (0, _effects.put)((0, _subscriptionExpired.showSubscriptionExpiredModal)());

        case 33:
          forwardTo('/settings/billing');
          _context2.next = 39;
          break;

        case 36:
          // owner or manager go to dashboard page,
          // unless next url is provided
          // if next url is a forbidden page
          // the interceptor should be given in react-router, not here
          if (next) {
            forwardTo(next);
          } else {
            forwardTo('/dashboard');
          }
          _context2.next = 39;
          return (0, _effects.put)(actionNotification.success('Welcome back, ' + user.first_name));

        case 39:
          _context2.next = 44;
          break;

        case 41:
          // staff go to account settings
          forwardTo('/settings/accounts');
          _context2.next = 44;
          return (0, _effects.put)(actionNotification.success('Welcome back, ' + user.first_name));

        case 44:
          _context2.next = 54;
          break;

        case 46:
          if (!error) {
            _context2.next = 53;
            break;
          }

          _context2.next = 49;
          return (0, _effects.call)(_reduxSaga.delay, 1000);

        case 49:
          _context2.next = 51;
          return (0, _effects.put)(actionNotification.error(error));

        case 51:
          _context2.next = 54;
          break;

        case 53:
          if (errorTypes) {
            // user has logined
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }

        case 54:
          _context2.next = 60;
          break;

        case 56:
          if (!winner.logout) {
            _context2.next = 60;
            break;
          }

          _context2.next = 59;
          return (0, _effects.call)(logout);

        case 59:
          forwardTo('/login');

        case 60:
          _context2.next = 0;
          break;

        case 62:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/**
 * Effect to handle logging out
 */
function logout() {
  var response, eobj;
  return _regenerator2.default.wrap(function logout$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context3.prev = 4;

          _store2.default.remove('response:login');
          _context3.next = 8;
          return (0, _effects.call)(auth.logout);

        case 8:
          response = _context3.sent;
          return _context3.abrupt('return', response);

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](4);
          eobj = new Error(_context3.t0.message);
          _context3.next = 17;
          return (0, _effects.put)(action.requestError(eobj));

        case 17:
          _context3.prev = 17;
          _context3.next = 20;
          return (0, _effects.put)(action.sendingRequest(false));

        case 20:
          _context3.next = 22;
          return (0, _effects.put)(action.hideProgressBar());

        case 22:
          return _context3.finish(17);

        case 23:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 12, 17, 23]]);
}

function resendVerificationEmailFlow() {
  var request, _email, response;

  return _regenerator2.default.wrap(function resendVerificationEmailFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (false) {
            _context4.next = 29;
            break;
          }

          _context4.next = 3;
          return (0, _effects.take)(_constants.RESEND_VERIFICATION_EMAIL);

        case 3:
          request = _context4.sent;
          _email = request.payload.email;

          // UI

          _context4.next = 7;
          return (0, _effects.put)(action.sendingRequest(true));

        case 7:
          _context4.next = 9;
          return (0, _effects.put)(action.showProgressBar());

        case 9:
          _context4.prev = 9;
          _context4.next = 12;
          return (0, _effects.call)(auth.resendVerificationEmail, _email);

        case 12:
          response = _context4.sent;
          _context4.next = 15;
          return (0, _effects.put)(action.setResendEmailVerificationState({ isModalShow: true, headerMessage: 'Notification', bodyMessage: response.data.message, modalStatus: response.data.status }));

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4['catch'](9);
          _context4.next = 21;
          return (0, _effects.put)(action.setResendEmailVerificationState({ isModalShow: true, headerMessage: 'Error', bodyMessage: _context4.t0.message, modalStatus: _context4.t0.status }));

        case 21:
          _context4.prev = 21;
          _context4.next = 24;
          return (0, _effects.put)(action.hideProgressBar());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(action.sendingRequest(false));

        case 26:
          return _context4.finish(21);

        case 27:
          _context4.next = 0;
          break;

        case 29:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[9, 17, 21, 27]]);
}

/**
 * Log out saga
 * This is basically the same as the `if (winner.logout)` of above, just written
 * as a saga that is always listening to `LOGOUT` actions
 */
function logoutFlow() {
  return _regenerator2.default.wrap(function logoutFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (false) {
            _context5.next = 10;
            break;
          }

          _context5.next = 3;
          return (0, _effects.take)(_constants.LOGOUT);

        case 3:
          mpLogout.logout();
          _context5.next = 6;
          return (0, _effects.call)(logout);

        case 6:
          mpLogout.resetAfterLogout();
          // don't remove window.location.replace, because this code is temporary fix.
          window.location.replace('/login');
          _context5.next = 0;
          break;

        case 10:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

/**
 * Register saga
 */
function registerFlow() {
  var request, _request$payload$data2, _email2, _password, response, result;

  return _regenerator2.default.wrap(function registerFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (false) {
            _context6.next = 40;
            break;
          }

          _context6.next = 3;
          return (0, _effects.take)(_constants.REGISTER_REQUEST);

        case 3:
          request = _context6.sent;
          _request$payload$data2 = request.payload.data, _email2 = _request$payload$data2.email, _password = _request$payload$data2.password;

          mpRegister.registrationBusinessInfo({ email: _email2 });

          _context6.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          _context6.next = 10;
          return (0, _effects.put)(action.showProgressBar());

        case 10:
          _context6.next = 12;
          return (0, _effects.call)(auth.registered, _email2);

        case 12:
          response = _context6.sent;
          result = response.data;
          _context6.prev = 14;

          if (!result.present) {
            _context6.next = 22;
            break;
          }

          _context6.next = 18;
          return (0, _effects.put)(actionNotification.error('Email already exist!'));

        case 18:
          _context6.next = 20;
          return (0, _effects.put)((0, _reduxForm.change)('registerForm', 'email', null));

        case 20:
          _context6.next = 26;
          break;

        case 22:
          _context6.next = 24;
          return (0, _effects.put)(action.changeFormRegister({ email: _email2, password: _password, confpassword: _password }));

        case 24:
          _context6.next = 26;
          return (0, _effects.put)(action.setIsRegistered(true));

        case 26:
          _context6.next = 32;
          break;

        case 28:
          _context6.prev = 28;
          _context6.t0 = _context6['catch'](14);
          _context6.next = 32;
          return (0, _effects.put)(action.requestError(_context6.t0));

        case 32:
          _context6.prev = 32;
          _context6.next = 35;
          return (0, _effects.put)(action.hideProgressBar());

        case 35:
          _context6.next = 37;
          return (0, _effects.put)(action.sendingRequest(false));

        case 37:
          return _context6.finish(32);

        case 38:
          _context6.next = 0;
          break;

        case 40:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[14, 28, 32, 38]]);
}

function fetchBusinessTypes() {
  var response;
  return _regenerator2.default.wrap(function fetchBusinessTypes$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context7.prev = 2;
          _context7.next = 5;
          return (0, _effects.call)(auth.getBusinessTypes);

        case 5:
          response = _context7.sent;
          return _context7.abrupt('return', response.data);

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7['catch'](2);
          _context7.next = 13;
          return (0, _effects.put)(action.requestError(_context7.t0));

        case 13:
          _context7.prev = 13;
          _context7.next = 16;
          return (0, _effects.put)(action.sendingRequest(false));

        case 16:
          return _context7.finish(13);

        case 17:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[2, 9, 13, 17]]);
}

function businessTypesFlow() {
  var response;
  return _regenerator2.default.wrap(function businessTypesFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (false) {
            _context8.next = 10;
            break;
          }

          _context8.next = 3;
          return (0, _effects.take)(_constants.BUSINESS_TYPES_REQUEST);

        case 3:
          _context8.next = 5;
          return (0, _effects.call)(fetchBusinessTypes);

        case 5:
          response = _context8.sent;
          _context8.next = 8;
          return (0, _effects.put)(action.changeBusinessTypesData(response));

        case 8:
          _context8.next = 0;
          break;

        case 10:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function fetchBusinessCategories(businessTypeId) {
  var response;
  return _regenerator2.default.wrap(function fetchBusinessCategories$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context9.prev = 2;
          _context9.next = 5;
          return (0, _effects.call)(auth.getBusinessCategories, businessTypeId);

        case 5:
          response = _context9.sent;
          return _context9.abrupt('return', response.data);

        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9['catch'](2);
          _context9.next = 13;
          return (0, _effects.put)(action.requestError(_context9.t0));

        case 13:
          _context9.prev = 13;
          _context9.next = 16;
          return (0, _effects.put)(action.sendingRequest(false));

        case 16:
          return _context9.finish(13);

        case 17:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[2, 9, 13, 17]]);
}

function businessCategoriesFlow() {
  var request, businessTypeId, response;
  return _regenerator2.default.wrap(function businessCategoriesFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (false) {
            _context10.next = 12;
            break;
          }

          _context10.next = 3;
          return (0, _effects.take)('BUSINESS_CATEGORIES_REQUEST');

        case 3:
          request = _context10.sent;
          businessTypeId = request.payload.data;
          _context10.next = 7;
          return (0, _effects.call)(fetchBusinessCategories, businessTypeId);

        case 7:
          response = _context10.sent;
          _context10.next = 10;
          return (0, _effects.put)(action.changeBusinessCategoriesData(response));

        case 10:
          _context10.next = 0;
          break;

        case 12:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function registerBusinessFlow() {
  var request;
  return _regenerator2.default.wrap(function registerBusinessFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (false) {
            _context11.next = 30;
            break;
          }

          _context11.next = 3;
          return (0, _effects.take)(_constants.REGISTER_BUSINESS_REQUEST);

        case 3:
          request = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)(action.sendingRequest(true));

        case 6:
          _context11.next = 8;
          return (0, _effects.put)(action.showProgressBar());

        case 8:
          _context11.prev = 8;

          mpRegister.registrationCompleted({ user: request.payload.data.user, business: request.payload.data.business });
          _context11.next = 12;
          return (0, _effects.call)(auth.registerBusiness, request.payload.data);

        case 12:
          _context11.next = 14;
          return (0, _effects.put)(action.changeFormBusiness({
            businessName: '',
            businessType: '',
            businessCategory: '',
            businessAddress: '',
            businessCity: '',
            businessProvince: '',
            businessPostalCode: '',
            userFirstName: '',
            userLastName: '',
            userPhone: ''
          }));

        case 14:
          // Clear form
          forwardTo('/register-complete');
          _context11.next = 22;
          break;

        case 17:
          _context11.prev = 17;
          _context11.t0 = _context11['catch'](8);
          _context11.next = 21;
          return (0, _effects.put)(action.requestError(_context11.t0));

        case 21:
          return _context11.abrupt('return', false);

        case 22:
          _context11.prev = 22;
          _context11.next = 25;
          return (0, _effects.put)(action.hideProgressBar());

        case 25:
          _context11.next = 27;
          return (0, _effects.put)(action.sendingRequest(false));

        case 27:
          return _context11.finish(22);

        case 28:
          _context11.next = 0;
          break;

        case 30:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[8, 17, 22, 28]]);
}
function redirectTo() {
  var request;
  return _regenerator2.default.wrap(function redirectTo$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (false) {
            _context12.next = 7;
            break;
          }

          _context12.next = 3;
          return (0, _effects.take)(_constants.REDIRECT_TO);

        case 3:
          request = _context12.sent;

          forwardTo('/' + request.payload.url);
          _context12.next = 0;
          break;

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function loadResetPassword() {
  var request, response, user;
  return _regenerator2.default.wrap(function loadResetPassword$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (false) {
            _context13.next = 20;
            break;
          }

          _context13.next = 3;
          return (0, _effects.take)(_constants.LOAD_RESET_PASSWORD);

        case 3:
          request = _context13.sent;
          _context13.prev = 4;
          _context13.next = 7;
          return (0, _effects.call)(auth.getResetPassword, { access_token: request.payload.token });

        case 7:
          response = _context13.sent;
          user = JSON.parse(response.data.user);
          _context13.next = 11;
          return (0, _effects.put)(action.changeFormResetPassword({ tokenError: false, fullName: user.first_name + ' ' + user.last_name }));

        case 11:
          _context13.next = 18;
          break;

        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13['catch'](4);

          if (!(_context13.t0.status === 404)) {
            _context13.next = 18;
            break;
          }

          _context13.next = 18;
          return (0, _effects.put)(action.changeFormResetPassword({ tokenError: true, message: _context13.t0.data.message }));

        case 18:
          _context13.next = 0;
          break;

        case 20:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[4, 13]]);
}

function sendResetPassword() {
  var requestPayload, responsePayload;
  return _regenerator2.default.wrap(function sendResetPassword$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          if (false) {
            _context14.next = 28;
            break;
          }

          _context14.next = 3;
          return (0, _effects.take)(_constants.SEND_RESET_PASSWORD);

        case 3:
          requestPayload = _context14.sent;
          responsePayload = requestPayload.payload.data;

          responsePayload.access_token = requestPayload.payload.access_token;
          _context14.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          _context14.next = 10;
          return (0, _effects.put)(action.showProgressBar(true));

        case 10:
          _context14.prev = 10;
          _context14.next = 13;
          return (0, _effects.call)(auth.resetPassword, responsePayload);

        case 13:
          forwardTo('/success-reset-password');
          _context14.next = 20;
          break;

        case 16:
          _context14.prev = 16;
          _context14.t0 = _context14['catch'](10);
          _context14.next = 20;
          return (0, _effects.put)(action.requestError(_context14.t0));

        case 20:
          _context14.prev = 20;
          _context14.next = 23;
          return (0, _effects.put)(action.hideProgressBar());

        case 23:
          _context14.next = 25;
          return (0, _effects.put)(action.sendingRequest(false));

        case 25:
          return _context14.finish(20);

        case 26:
          _context14.next = 0;
          break;

        case 28:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[10, 16, 20, 26]]);
}

function loadPrepareEncryption() {
  var response, responseData;
  return _regenerator2.default.wrap(function loadPrepareEncryption$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          if (false) {
            _context15.next = 18;
            break;
          }

          _context15.next = 3;
          return (0, _effects.take)(_constants.LOAD_PREPARE_ENCRYPTION);

        case 3:
          _context15.prev = 3;
          _context15.next = 6;
          return (0, _effects.call)(auth.loadPrepareEncryption);

        case 6:
          response = _context15.sent;
          responseData = response.data;
          _context15.next = 10;
          return (0, _effects.put)(action.setPrepareEncryption({ responseData: responseData }));

        case 10:
          _context15.next = 16;
          break;

        case 12:
          _context15.prev = 12;
          _context15.t0 = _context15['catch'](3);
          _context15.next = 16;
          return (0, _effects.put)(action.requestError(_context15.t0));

        case 16:
          _context15.next = 0;
          break;

        case 18:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[3, 12]]);
}
function getProfileFlow() {
  var data;
  return _regenerator2.default.wrap(function getProfileFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          if (false) {
            _context16.next = 11;
            break;
          }

          _context16.next = 3;
          return (0, _effects.take)(_constants.GET_PROFILE_REQUEST);

        case 3:
          _context16.next = 5;
          return (0, _effects.call)(_profile.getProfile, {});

        case 5:
          data = _context16.sent;

          if (!data) {
            _context16.next = 9;
            break;
          }

          _context16.next = 9;
          return (0, _effects.put)(action.setProfile(data));

        case 9:
          _context16.next = 0;
          break;

        case 11:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function toLoginPage() {
  return _regenerator2.default.wrap(function toLoginPage$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          if (false) {
            _context17.next = 6;
            break;
          }

          _context17.next = 3;
          return (0, _effects.take)(_constants.TO_LOGIN_PAGE);

        case 3:
          forwardTo('/login');
          _context17.next = 0;
          break;

        case 6:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function toSignUpPage() {
  return _regenerator2.default.wrap(function toSignUpPage$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          if (false) {
            _context18.next = 6;
            break;
          }

          _context18.next = 3;
          return (0, _effects.take)(_constants.TO_SIGNUP_PAGE);

        case 3:
          forwardTo('/register');
          _context18.next = 0;
          break;

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

// The root saga is what we actually send to Redux's middleware. In here we fork
// each saga so that they are all "active" and listening.
// Sagas are fired once at the start of an app and can be thought of as processes running
// in the background, watching actions dispatched to the store.
function root() {
  return _regenerator2.default.wrap(function root$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.fork)(loginFlow);

        case 2:
          _context19.next = 4;
          return (0, _effects.fork)(logoutFlow);

        case 4:
          _context19.next = 6;
          return (0, _effects.fork)(registerFlow);

        case 6:
          _context19.next = 8;
          return (0, _effects.fork)(businessTypesFlow);

        case 8:
          _context19.next = 10;
          return (0, _effects.fork)(resendVerificationEmailFlow);

        case 10:
          _context19.next = 12;
          return (0, _effects.fork)(registerBusinessFlow);

        case 12:
          _context19.next = 14;
          return (0, _effects.fork)(businessTypesFlow);

        case 14:
          _context19.next = 16;
          return (0, _effects.fork)(businessCategoriesFlow);

        case 16:
          _context19.next = 18;
          return (0, _effects.fork)(redirectTo);

        case 18:
          _context19.next = 20;
          return (0, _effects.fork)(loadResetPassword);

        case 20:
          _context19.next = 22;
          return (0, _effects.fork)(sendResetPassword);

        case 22:
          _context19.next = 24;
          return (0, _effects.fork)(loadPrepareEncryption);

        case 24:
          _context19.next = 26;
          return (0, _effects.fork)(getProfileFlow);

        case 26:
          _context19.next = 28;
          return (0, _effects.fork)(toLoginPage);

        case 28:
          _context19.next = 30;
          return (0, _effects.fork)(toSignUpPage);

        case 30:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

// Little helper function to abstract going to different pages
function forwardTo(location) {
  _reactRouter.browserHistory.push(location);
}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipesSaga = exports.ingredientSubscriptionSaga = exports.categorySaga = exports.librarySaga = undefined;

var _library = __webpack_require__(1616);

var _library2 = _interopRequireDefault(_library);

var _category = __webpack_require__(1614);

var _category2 = _interopRequireDefault(_category);

var _ingredientSubscription = __webpack_require__(1615);

var _ingredientSubscription2 = _interopRequireDefault(_ingredientSubscription);

var _recipes = __webpack_require__(1617);

var _recipes2 = _interopRequireDefault(_recipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.librarySaga = _library2.default;
exports.categorySaga = _category2.default;
exports.ingredientSubscriptionSaga = _ingredientSubscription2.default;
exports.recipesSaga = _recipes2.default;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ingredientSubscriptionSaga = exports.transferSaga = exports.supplierSaga = exports.summarySaga = exports.purchaseOrderSaga = exports.adjustmentSaga = undefined;

var _adjustment = __webpack_require__(1618);

var _adjustment2 = _interopRequireDefault(_adjustment);

var _purchaseOrder = __webpack_require__(1620);

var _purchaseOrder2 = _interopRequireDefault(_purchaseOrder);

var _summary = __webpack_require__(1621);

var _summary2 = _interopRequireDefault(_summary);

var _supplier = __webpack_require__(1622);

var _supplier2 = _interopRequireDefault(_supplier);

var _transfer = __webpack_require__(1623);

var _transfer2 = _interopRequireDefault(_transfer);

var _ingredientSubscription = __webpack_require__(1619);

var _ingredientSubscription2 = _interopRequireDefault(_ingredientSubscription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.adjustmentSaga = _adjustment2.default;
exports.purchaseOrderSaga = _purchaseOrder2.default;
exports.summarySaga = _summary2.default;
exports.supplierSaga = _supplier2.default;
exports.transferSaga = _transfer2.default;
exports.ingredientSubscriptionSaga = _ingredientSubscription2.default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libraryItemSaga = exports.libraryModifierSaga = exports.libraryTaxSaga = exports.libraryGratuitySaga = exports.libraryDiscountSaga = exports.libraryCategorySaga = undefined;

var _category = __webpack_require__(1624);

var _category2 = _interopRequireDefault(_category);

var _discount = __webpack_require__(1625);

var _discount2 = _interopRequireDefault(_discount);

var _gratuity = __webpack_require__(1626);

var _gratuity2 = _interopRequireDefault(_gratuity);

var _tax = __webpack_require__(1629);

var _tax2 = _interopRequireDefault(_tax);

var _item = __webpack_require__(1627);

var _item2 = _interopRequireDefault(_item);

var _modifier = __webpack_require__(1628);

var _modifier2 = _interopRequireDefault(_modifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.libraryCategorySaga = _category2.default;
exports.libraryDiscountSaga = _discount2.default;
exports.libraryGratuitySaga = _gratuity2.default;
exports.libraryTaxSaga = _tax2.default;
exports.libraryModifierSaga = _modifier2.default;
exports.libraryItemSaga = _item2.default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.resetNotification = resetNotification;
exports.default = saga;

var _constants = __webpack_require__(411);

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _notifications = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [resetNotification, saga].map(_regenerator2.default.mark);

function resetNotification() {
  return _regenerator2.default.wrap(function resetNotification$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _notifications.onClickNotif)(false));

        case 2:
          _context.next = 4;
          return (0, _reduxSaga.delay)(4000, true);

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _notifications.reset)());

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.NOTIFICATION_SUCCESS, resetNotification);

        case 2:
          _context2.next = 4;
          return (0, _effects.takeLatest)(_constants.NOTIFICATION_ERROR, resetNotification);

        case 4:
          _context2.next = 6;
          return (0, _effects.takeLatest)(_constants.NOTIFICATION_WARNING, resetNotification);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.outlets = outlets;
exports.loadOutletsFlow = loadOutletsFlow;
exports.getCurrentOutletFlow = getCurrentOutletFlow;
exports.default = outletSaga;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _outlet = __webpack_require__(235);

var actOutlet = _interopRequireWildcard(_outlet);

var _auth = __webpack_require__(237);

var auth = _interopRequireWildcard(_auth);

var _effects = __webpack_require__(22);

var _reactRouter = __webpack_require__(15);

var _profile = __webpack_require__(114);

var _constants = __webpack_require__(412);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [outlets, loadOutletsFlow, getCurrentOutletFlow, outletSaga].map(_regenerator2.default.mark);

function outlets() {
  var response, eobj;
  return _regenerator2.default.wrap(function outlets$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(auth.outlets);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);

          if (!(_context.t0.status === 401)) {
            _context.next = 19;
            break;
          }

          _context.next = 16;
          return (0, _effects.put)(action.setAuthState(false));

        case 16:
          _reactRouter.browserHistory.push('/login');
          _context.next = 22;
          break;

        case 19:
          eobj = new Error(_context.t0.message);
          _context.next = 22;
          return (0, _effects.put)(action.requestError(eobj));

        case 22:
          return _context.abrupt('return', false);

        case 23:
          _context.prev = 23;
          _context.next = 26;
          return (0, _effects.put)(action.sendingRequest(false));

        case 26:
          _context.next = 28;
          return (0, _effects.put)(action.hideProgressBar());

        case 28:
          return _context.finish(23);

        case 29:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 23, 29]]);
}

function loadOutletsFlow() {
  var outletsData;
  return _regenerator2.default.wrap(function loadOutletsFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 11;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.OUTLETS_REQUEST);

        case 3:
          _context2.next = 5;
          return (0, _effects.call)(outlets);

        case 5:
          outletsData = _context2.sent;

          if (!outletsData) {
            _context2.next = 9;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)(actOutlet.setOutlets(outletsData));

        case 9:
          _context2.next = 0;
          break;

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function getCurrentOutletFlow() {
  var currentOutlet;
  return _regenerator2.default.wrap(function getCurrentOutletFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (false) {
            _context3.next = 11;
            break;
          }

          _context3.next = 3;
          return (0, _effects.take)(_constants.GET_CURRENT_OUTLET_REQUEST);

        case 3:
          _context3.next = 5;
          return (0, _effects.call)(_profile.getProfile);

        case 5:
          currentOutlet = _context3.sent;

          if (!currentOutlet) {
            _context3.next = 9;
            break;
          }

          _context3.next = 9;
          return (0, _effects.put)(actOutlet.setCurrentOutlet(currentOutlet));

        case 9:
          _context3.next = 0;
          break;

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function outletSaga() {
  return _regenerator2.default.wrap(function outletSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(loadOutletsFlow);

        case 2:
          _context4.next = 4;
          return (0, _effects.fork)(getCurrentOutletFlow);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outletPagesListSaga = undefined;

var _list = __webpack_require__(1630);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.outletPagesListSaga = _list2.default;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.invoicesPageRequestFlow = invoicesPageRequestFlow;
exports.getInvoicesFlow = getInvoicesFlow;
exports.changeDateInvoicesFlow = changeDateInvoicesFlow;
exports.changeOutletInvoicesFlow = changeOutletInvoicesFlow;
exports.changeStatusInvoicesFlow = changeStatusInvoicesFlow;
exports.receiptInvoicesRequestFlow = receiptInvoicesRequestFlow;
exports.hideReceiptInvoiceFlow = hideReceiptInvoiceFlow;
exports.createRecordPaymentFlow = createRecordPaymentFlow;
exports.resendEmailFlow = resendEmailFlow;
exports.printReceiptInvoicePdfFlow = printReceiptInvoicePdfFlow;
exports.issueRefundFlow = issueRefundFlow;
exports.issueOldRefundFlow = issueOldRefundFlow;
exports.exportInvoicesFlow = exportInvoicesFlow;
exports.cancelAction = cancelAction;
exports.onClickRecordPaymentFlow = onClickRecordPaymentFlow;
exports.onCancelRecordPaymentFlow = onCancelRecordPaymentFlow;
exports.default = reportsInvoicesSaga;

var _effects = __webpack_require__(22);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(414);

var _constants2 = __webpack_require__(91);

var _refunds = __webpack_require__(676);

var _getFilteredDate = __webpack_require__(249);

var _profile = __webpack_require__(114);

var _invoices = __webpack_require__(675);

var _invoices2 = __webpack_require__(170);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _login = __webpack_require__(250);

var _actionBar = __webpack_require__(80);

var actActionBar = _interopRequireWildcard(_actionBar);

var _invoices3 = __webpack_require__(628);

var api = _interopRequireWildcard(_invoices3);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _reduxForm = __webpack_require__(7);

var _loadingSpinner = __webpack_require__(46);

var _invoices4 = __webpack_require__(661);

var mpReportsInvoices = _interopRequireWildcard(_invoices4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, closeRightColumn, invoicesPageRequestFlow, getInvoicesFlow, changeDateInvoicesFlow, changeOutletInvoicesFlow, changeStatusInvoicesFlow, receiptInvoicesRequestFlow, hideReceiptInvoiceFlow, createRecordPaymentFlow, resendEmailFlow, printReceiptInvoicePdfFlow, issueRefundFlow, issueOldRefundFlow, exportInvoicesFlow, cancelAction, onClickRecordPaymentFlow, onCancelRecordPaymentFlow, reportsInvoicesSaga].map(_regenerator2.default.mark);

function fillForm(outletIds, startDate, endDate) {
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outlet: outletIds,
            date: { startDate: startDate, endDate: endDate }
          }));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(outletIds));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function closeRightColumn() {
  var toggledClass;
  return _regenerator2.default.wrap(function closeRightColumn$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          toggledClass = 'col-sm-12 col-md-6 col-xs-6';

          $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
          $('#mk-col-left').addClass('col-sm-12');

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function invoicesPageRequestFlow() {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function invoicesPageRequestFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(null));

        case 3:
          _context3.next = 5;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(null));

        case 7:
          _context3.next = 9;
          return (0, _effects.call)(closeRightColumn);

        case 9:
          _context3.next = 11;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 11:
          filteredDate = _context3.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context3.next = 18;
          return (0, _effects.call)(apiOutlets.outlets);

        case 18:
          resOutlets = _context3.sent;
          _context3.next = 21;
          return (0, _effects.put)((0, _invoices2.setOutlets)(resOutlets.data));

        case 21:
          _context3.next = 23;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 23:
          _context3.next = 25;
          return (0, _effects.call)(_profile.getProfile);

        case 25:
          profile = _context3.sent;
          _context3.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)((0, _invoices2.listInvoiceRequest)({ startDate: startDateFormatted, endDate: endDateFormatted, page: 1 }));

        case 30:
          mpReportsInvoices.reportsInvoiceStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          $('#invoice-table-tbody').animate({ scrollTop: 0 }, 'slow');
          _context3.next = 38;
          break;

        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 38;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 38:
          _context3.prev = 38;
          _context3.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          return _context3.finish(38);

        case 42:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 34, 38, 42]]);
}

function getInvoicesFlow(request) {
  var _request$payload, query, previousInvoices, start, end, page, perPage, status, keyword, resInvoices, invoices;

  return _regenerator2.default.wrap(function getInvoicesFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _request$payload = request.payload, query = _request$payload.query, previousInvoices = _request$payload.previousInvoices;
          start = query.startDate;
          end = query.endDate;
          page = query.page;
          perPage = query.perPage;
          status = query.status;
          keyword = query.keyword;
          _context4.next = 9;
          return (0, _effects.call)(_invoices.getInvoices, { start: start, end: end, page: page, perPage: perPage, status: status, keyword: keyword });

        case 9:
          resInvoices = _context4.sent;

          if (previousInvoices) {
            _context4.next = 13;
            break;
          }

          _context4.next = 13;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(null));

        case 13:
          if (!resInvoices) {
            _context4.next = 22;
            break;
          }

          invoices = void 0;

          if (previousInvoices) {
            invoices = previousInvoices.concat(resInvoices.results);
          } else {
            invoices = resInvoices.results;
          }
          _context4.next = 18;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(invoices));

        case 18:
          _context4.next = 20;
          return (0, _effects.put)((0, _invoices2.setCurrentPage)(page));

        case 20:
          _context4.next = 22;
          return (0, _effects.put)((0, _invoices2.setTotalPage)(resInvoices.total_pages));

        case 22:
          _context4.next = 24;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function changeDateInvoicesFlow(request) {
  var payload, startDate, endDate, statuses, keyword, startDateFormatted, endDateFormatted;
  return _regenerator2.default.wrap(function changeDateInvoicesFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(null));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context5.next = 6;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(null));

        case 6:
          _context5.next = 8;
          return (0, _effects.call)(closeRightColumn);

        case 8:
          payload = request.payload;
          startDate = payload.startDate, endDate = payload.endDate, statuses = payload.statuses, keyword = payload.keyword;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context5.next = 14;
          return (0, _effects.put)((0, _invoices2.listInvoiceRequest)({
            startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: statuses, keyword: keyword
          }));

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function changeOutletInvoicesFlow(request) {
  var payload, outletIds, startDate, endDate, keyword, startDateFormatted, endDateFormatted;
  return _regenerator2.default.wrap(function changeOutletInvoicesFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(null));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context6.next = 6;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(null));

        case 6:
          _context6.next = 8;
          return (0, _effects.call)(closeRightColumn);

        case 8:
          // noinspection InfiniteLoopJS
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate, keyword = payload.keyword;
          _context6.next = 12;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 12:
          _context6.next = 14;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 14:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context6.next = 18;
          return (0, _effects.put)((0, _invoices2.listInvoiceRequest)({
            startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: [], keyword: keyword
          }));

        case 18:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function changeStatusInvoicesFlow(request) {
  var payload, startDate, endDate, statuses, keyword, startDateFormatted, endDateFormatted;
  return _regenerator2.default.wrap(function changeStatusInvoicesFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _invoices2.setListInvoice)(null));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(null));

        case 6:
          _context7.next = 8;
          return (0, _effects.call)(closeRightColumn);

        case 8:
          payload = request.payload;
          startDate = payload.startDate, endDate = payload.endDate, statuses = payload.statuses, keyword = payload.keyword;
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context7.next = 14;
          return (0, _effects.put)((0, _invoices2.listInvoiceRequest)({
            startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: statuses, keyword: keyword
          }));

        case 14:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function receiptInvoicesRequestFlow(request) {
  var _request$payload2, id, isMobile, receiptInvoices;

  return _regenerator2.default.wrap(function receiptInvoicesRequestFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload2 = request.payload, id = _request$payload2.id, isMobile = _request$payload2.isMobile;
          _context8.next = 3;
          return (0, _effects.call)(_invoices.getReceiptInvoices, id);

        case 3:
          receiptInvoices = _context8.sent;

          mpReportsInvoices.reportsInvoicesSelect({
            invoice: receiptInvoices
          });
          _context8.next = 7;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(receiptInvoices));

        case 7:

          // animation
          if (!isMobile) {
            if ($('#mk-col-left').hasClass('col-sm-12')) {
              $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6');
              setTimeout(function () {
                $('#mk-col-right').show();
                $('[data-toggle="popover"]').popover();
              }, 600);
            }
          }

        case 8:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function hideReceiptInvoiceFlow(request) {
  var isMobile;
  return _regenerator2.default.wrap(function hideReceiptInvoiceFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          isMobile = request.payload.isMobile;
          _context9.next = 3;
          return (0, _effects.put)((0, _invoices2.setReceiptInvoices)(null));

        case 3:

          if (!isMobile) {
            // animation
            $('#mk-col-right').hide();
            $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6');
          }

        case 4:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function createRecordPaymentFlow(request) {
  var recordPayment;
  return _regenerator2.default.wrap(function createRecordPaymentFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          recordPayment = request.payload.data;
          _context10.next = 3;
          return (0, _effects.call)(_invoices.createRecordPayment, recordPayment);

        case 3:
          _context10.next = 5;
          return (0, _effects.call)(_invoices.resendEmail, recordPayment.id);

        case 5:
          _context10.next = 7;
          return (0, _effects.put)(actNotif.success('Record payment has been created and Invoice Email has been successfully sent'));

        case 7:
          _context10.next = 9;
          return (0, _effects.put)((0, _invoices2.hideRecordPaymentModal)());

        case 9:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function resendEmailFlow(request) {
  var invoiceId;
  return _regenerator2.default.wrap(function resendEmailFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          invoiceId = request.payload.invoiceId;
          _context11.next = 3;
          return (0, _effects.call)(_invoices.resendEmail, invoiceId);

        case 3:
          _context11.next = 5;
          return (0, _effects.put)(actNotif.success('Email has been successfully resend'));

        case 5:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function printReceiptInvoicePdfFlow(request) {
  var invoiceId;
  return _regenerator2.default.wrap(function printReceiptInvoicePdfFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          invoiceId = request.payload.invoiceId;
          _context12.next = 3;
          return (0, _effects.call)(api.printReceiptInvoicePdf, invoiceId);

        case 3:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function issueRefundFlow(request) {
  var data;
  return _regenerator2.default.wrap(function issueRefundFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          data = request.payload.data;
          _context13.next = 3;
          return (0, _effects.call)(_refunds.postRefund, data);

        case 3:
          _context13.next = 5;
          return (0, _effects.put)((0, _invoices2.hideCancelInvoiceModal)());

        case 5:
          _context13.next = 7;
          return (0, _effects.put)((0, _invoices2.hideReceiptInvoice)());

        case 7:
          _context13.next = 9;
          return (0, _effects.put)((0, _invoices2.invoicesPageRequest)());

        case 9:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function issueOldRefundFlow(request) {
  var data;
  return _regenerator2.default.wrap(function issueOldRefundFlow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          data = request.payload.data;
          _context14.next = 3;
          return (0, _effects.call)(_refunds.postOldRefund, data);

        case 3:
          _context14.next = 5;
          return (0, _effects.put)((0, _invoices2.hideOldCancelInvoiceModal)());

        case 5:
          _context14.next = 7;
          return (0, _effects.put)((0, _invoices2.hideReceiptInvoice)());

        case 7:
          _context14.next = 9;
          return (0, _effects.put)((0, _invoices2.invoicesPageRequest)());

        case 9:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function exportInvoicesFlow(request) {
  var _request$payload3, query, filename, outletId;

  return _regenerator2.default.wrap(function exportInvoicesFlow$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _request$payload3 = request.payload, query = _request$payload3.query, filename = _request$payload3.filename, outletId = _request$payload3.outletId;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.call)(api.exportInvoices, query);

        case 4:
          _context15.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'invoices'));

        case 6:
          _context15.next = 12;
          break;

        case 8:
          _context15.prev = 8;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 12;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 8]]);
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function onClickRecordPaymentFlow(request) {
  return _regenerator2.default.wrap(function onClickRecordPaymentFlow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('recordPaymentForm', {
            amount_received: null,
            payment_type: 'cash',
            note: '',
            payment_date: (0, _moment2.default)()
          }));

        case 2:
          _context17.next = 4;
          return (0, _effects.put)((0, _invoices2.showRecordPaymentModal)());

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function onCancelRecordPaymentFlow(request) {
  return _regenerator2.default.wrap(function onCancelRecordPaymentFlow$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)((0, _invoices2.hideRecordPaymentModal)());

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function reportsInvoicesSaga() {
  var pageReqTask, getInvoicesTask, changeDateInvoiceTask, changeOutletTask, receiptInvoiceTask, resendEmailTask, printReceiptInvoicePdfTask, exportInvoiceTask;
  return _regenerator2.default.wrap(function reportsInvoicesSaga$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_PAGE_REQUEST, invoicesPageRequestFlow);

        case 2:
          pageReqTask = _context19.sent;
          _context19.next = 5;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_LIST_INVOICE_REQUEST, getInvoicesFlow);

        case 5:
          getInvoicesTask = _context19.sent;
          _context19.next = 8;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_CHANGE_DATE, changeDateInvoicesFlow);

        case 8:
          changeDateInvoiceTask = _context19.sent;
          _context19.next = 11;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_CHANGE_OUTLET, changeOutletInvoicesFlow);

        case 11:
          changeOutletTask = _context19.sent;
          _context19.next = 14;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_RECEIPT_REQUEST, receiptInvoicesRequestFlow);

        case 14:
          receiptInvoiceTask = _context19.sent;
          _context19.next = 17;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_HIDE_RECEIPT, hideReceiptInvoiceFlow);

        case 17:
          _context19.next = 19;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_RESEND_EMAIL, resendEmailFlow);

        case 19:
          resendEmailTask = _context19.sent;
          _context19.next = 22;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_PRINT_RECEIPT_PDF, printReceiptInvoicePdfFlow);

        case 22:
          printReceiptInvoicePdfTask = _context19.sent;
          _context19.next = 25;
          return (0, _effects.takeEvery)(_constants.REPORTS_INVOICES_RECORD_PAYMENT_REQUEST, createRecordPaymentFlow);

        case 25:
          _context19.next = 27;
          return (0, _effects.takeEvery)(_constants.REPORTS_INVOICES_ISSUE_REFUND_REQUEST, issueRefundFlow);

        case 27:
          _context19.next = 29;
          return (0, _effects.takeEvery)(_constants.REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST, issueOldRefundFlow);

        case 29:
          _context19.next = 31;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_EXPORT_INVOICES, exportInvoicesFlow);

        case 31:
          exportInvoiceTask = _context19.sent;
          _context19.next = 34;
          return (0, _effects.takeEvery)(_constants.REPORTS_INVOICES_CHANGE_STATUS, changeStatusInvoicesFlow);

        case 34:
          _context19.next = 36;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT, onClickRecordPaymentFlow);

        case 36:
          _context19.next = 38;
          return (0, _effects.takeLatest)(_constants.REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT, onCancelRecordPaymentFlow);

        case 38:
          _context19.next = 40;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [pageReqTask, getInvoicesTask, changeDateInvoiceTask, changeOutletTask, receiptInvoiceTask, resendEmailTask, printReceiptInvoicePdfTask, exportInvoiceTask]);

        case 40:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.reportsSalesPageRequestFlow = reportsSalesPageRequestFlow;
exports.getSalesSummaryFlow = getSalesSummaryFlow;
exports.grossProfitPageRequestFlow = grossProfitPageRequestFlow;
exports.getGrossProfitFlow = getGrossProfitFlow;
exports.paymentMethodsPageRequestFlow = paymentMethodsPageRequestFlow;
exports.getPaymentMethodsFlow = getPaymentMethodsFlow;
exports.itemSalesPageRequestFlow = itemSalesPageRequestFlow;
exports.getItemSalesFlow = getItemSalesFlow;
exports.categorySalesPageRequestFlow = categorySalesPageRequestFlow;
exports.getCategorySalesFlow = getCategorySalesFlow;
exports.modifierSalesPageRequestFlow = modifierSalesPageRequestFlow;
exports.getModifierSalesFlow = getModifierSalesFlow;
exports.discountsPageRequestFlow = discountsPageRequestFlow;
exports.getDiscountsFlow = getDiscountsFlow;
exports.taxesPageRequestFlow = taxesPageRequestFlow;
exports.getTaxesFlow = getTaxesFlow;
exports.gratuityPageRequestFlow = gratuityPageRequestFlow;
exports.getGratuitiesFlow = getGratuitiesFlow;
exports.collectedByPageRequestFlow = collectedByPageRequestFlow;
exports.getStaffsFlow = getStaffsFlow;
exports.servedByPageRequestFlow = servedByPageRequestFlow;
exports.getServersFlow = getServersFlow;
exports.changeDateSalesSummaryFlow = changeDateSalesSummaryFlow;
exports.changeDateGrossProfitFlow = changeDateGrossProfitFlow;
exports.changeDatePaymentMethodsFlow = changeDatePaymentMethodsFlow;
exports.changeDateItemSalesFlow = changeDateItemSalesFlow;
exports.changeDateCategorySalesFlow = changeDateCategorySalesFlow;
exports.changeDateModifierSalesFlow = changeDateModifierSalesFlow;
exports.changeDateDiscountsFlow = changeDateDiscountsFlow;
exports.changeDateTaxesFlow = changeDateTaxesFlow;
exports.changeDateGratuityFlow = changeDateGratuityFlow;
exports.changeDateCollectedByFlow = changeDateCollectedByFlow;
exports.changeDateServedByFlow = changeDateServedByFlow;
exports.changeOutletSalesSummaryFlow = changeOutletSalesSummaryFlow;
exports.changeOutletGrossProfitFlow = changeOutletGrossProfitFlow;
exports.changeOutletPaymentMethodsFlow = changeOutletPaymentMethodsFlow;
exports.changeOutletItemSalesFlow = changeOutletItemSalesFlow;
exports.changeOutletCategorySalesFlow = changeOutletCategorySalesFlow;
exports.changeOutletModifierSalesFlow = changeOutletModifierSalesFlow;
exports.changeOutletDiscountsFlow = changeOutletDiscountsFlow;
exports.changeOutletTaxesFlow = changeOutletTaxesFlow;
exports.changeOutletGratuityFlow = changeOutletGratuityFlow;
exports.changeOutletCollectedByFlow = changeOutletCollectedByFlow;
exports.changeOutletServedByFlow = changeOutletServedByFlow;
exports.exportSummaryFlow = exportSummaryFlow;
exports.exportGrossProfitFlow = exportGrossProfitFlow;
exports.exportPaymentMethodsFlow = exportPaymentMethodsFlow;
exports.exportItemSalesFlow = exportItemSalesFlow;
exports.exportCategorySalesFlow = exportCategorySalesFlow;
exports.exportModifierSalesFlow = exportModifierSalesFlow;
exports.exportDiscountFlow = exportDiscountFlow;
exports.exportTaxesFlow = exportTaxesFlow;
exports.exportGratuityFlow = exportGratuityFlow;
exports.exportColectedByFlow = exportColectedByFlow;
exports.exportServedByFlow = exportServedByFlow;
exports.cancelAction = cancelAction;
exports.default = reportsSalesSaga;

var _effects = __webpack_require__(22);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reactFileDownload = __webpack_require__(374);

var _reactFileDownload2 = _interopRequireDefault(_reactFileDownload);

var _sales = __webpack_require__(1604);

var _constants = __webpack_require__(415);

var _constants2 = __webpack_require__(91);

var _sales2 = __webpack_require__(94);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _outlet = __webpack_require__(235);

var _getFilteredDate = __webpack_require__(249);

var _profile = __webpack_require__(114);

var _login = __webpack_require__(250);

var _sales3 = __webpack_require__(632);

var apiReport = _interopRequireWildcard(_sales3);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _actionBar = __webpack_require__(80);

var actActionBar = _interopRequireWildcard(_actionBar);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _summary = __webpack_require__(667);

var mpReportSummary = _interopRequireWildcard(_summary);

var _paymentMethods = __webpack_require__(664);

var mpReportPaymentMethod = _interopRequireWildcard(_paymentMethods);

var _itemSales = __webpack_require__(662);

var mpReportItemSales = _interopRequireWildcard(_itemSales);

var _categorySales = __webpack_require__(656);

var mpReportCategorySales = _interopRequireWildcard(_categorySales);

var _modifierSales = __webpack_require__(663);

var mpReportModifierSales = _interopRequireWildcard(_modifierSales);

var _taxes = __webpack_require__(668);

var mpReportTaxes = _interopRequireWildcard(_taxes);

var _discounts = __webpack_require__(658);

var mpDiscount = _interopRequireWildcard(_discounts);

var _gratuity = __webpack_require__(659);

var mpReportGratuity = _interopRequireWildcard(_gratuity);

var _collected = __webpack_require__(657);

var mpReportCollected = _interopRequireWildcard(_collected);

var _served = __webpack_require__(665);

var mpReportServedBy = _interopRequireWildcard(_served);

var _grossProfit = __webpack_require__(660);

var mpGrossProfit = _interopRequireWildcard(_grossProfit);

var _index = __webpack_require__(18);

var act = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, reportsSalesPageRequestFlow, getSalesSummaryFlow, grossProfitPageRequestFlow, getGrossProfitFlow, paymentMethodsPageRequestFlow, getPaymentMethodsFlow, itemSalesPageRequestFlow, getItemSalesFlow, categorySalesPageRequestFlow, getCategorySalesFlow, modifierSalesPageRequestFlow, getModifierSalesFlow, discountsPageRequestFlow, getDiscountsFlow, taxesPageRequestFlow, getTaxesFlow, gratuityPageRequestFlow, getGratuitiesFlow, collectedByPageRequestFlow, getStaffsFlow, servedByPageRequestFlow, getServersFlow, changeDateSalesSummaryFlow, changeDateGrossProfitFlow, changeDatePaymentMethodsFlow, changeDateItemSalesFlow, changeDateCategorySalesFlow, changeDateModifierSalesFlow, changeDateDiscountsFlow, changeDateTaxesFlow, changeDateGratuityFlow, changeDateCollectedByFlow, changeDateServedByFlow, changeOutletSalesSummaryFlow, changeOutletGrossProfitFlow, changeOutletPaymentMethodsFlow, changeOutletItemSalesFlow, changeOutletCategorySalesFlow, changeOutletModifierSalesFlow, changeOutletDiscountsFlow, changeOutletTaxesFlow, changeOutletGratuityFlow, changeOutletCollectedByFlow, changeOutletServedByFlow, exportSummaryFlow, exportGrossProfitFlow, exportPaymentMethodsFlow, exportItemSalesFlow, exportCategorySalesFlow, exportModifierSalesFlow, exportDiscountFlow, exportTaxesFlow, exportGratuityFlow, exportColectedByFlow, exportServedByFlow, cancelAction, reportsSalesSaga].map(_regenerator2.default.mark);

function fillForm(outletIds, startDate, endDate) {
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outlet: outletIds,
            date: { startDate: startDate, endDate: endDate }
          }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function reportsSalesPageRequestFlow(request) {
  var filteredDate, start, end, resOutlets, startDateFormatted, endDateFormatted, profile;
  return _regenerator2.default.wrap(function reportsSalesPageRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)((0, _sales2.setSalesSummary)([]));

        case 3:
          _context2.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context2.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context2.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');

          // set outlets

          _context2.next = 14;
          return (0, _effects.call)(apiOutlets.outlets);

        case 14:
          resOutlets = _context2.sent;
          _context2.next = 17;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 17:
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');
          _context2.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context2.sent;
          _context2.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context2.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context2.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)((0, _sales2.salesSummaryRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 30:
          mpReportSummary.reportSummaryStart({
            outletIds: profile.outlet_id,
            startDate: (0, _moment2.default)(filteredDate.start_date),
            endDate: (0, _moment2.default)(filteredDate.end_date)
          });
          _context2.next = 37;
          break;

        case 33:
          _context2.prev = 33;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 37;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 37:
          _context2.prev = 37;
          _context2.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context2.finish(37);

        case 41:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 33, 37, 41]]);
}

function getSalesSummaryFlow(request) {
  var start, end, salesSummary;
  return _regenerator2.default.wrap(function getSalesSummaryFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context3.next = 6;
          return (0, _effects.call)(_sales.getSalesSummary, { start: start, end: end });

        case 6:
          salesSummary = _context3.sent;

          if (!salesSummary) {
            _context3.next = 10;
            break;
          }

          _context3.next = 10;
          return (0, _effects.put)((0, _sales2.setSalesSummary)(salesSummary));

        case 10:
          _context3.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function grossProfitPageRequestFlow(request) {
  var filteredDate, start, end, resOutlets, startDateFormatted, endDateFormatted, profile;
  return _regenerator2.default.wrap(function grossProfitPageRequestFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.put)((0, _sales2.setGrossProfit)([]));

        case 3:
          _context4.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context4.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context4.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context4.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');

          // set outlets

          _context4.next = 14;
          return (0, _effects.call)(apiOutlets.outlets);

        case 14:
          resOutlets = _context4.sent;
          _context4.next = 17;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 17:
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');
          _context4.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context4.sent;
          _context4.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context4.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context4.next = 30;
          return (0, _effects.put)((0, _sales2.grossProfitRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 30:
          _context4.next = 36;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 36;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 36:
          _context4.prev = 36;
          _context4.next = 39;
          return (0, _effects.put)(action.hideProgressBar());

        case 39:
          return _context4.finish(36);

        case 40:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[0, 32, 36, 40]]);
}

function getGrossProfitFlow(request) {
  var start, end, grossProfit;
  return _regenerator2.default.wrap(function getGrossProfitFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context5.next = 6;
          return (0, _effects.call)(_sales.getGrossProfit, { start: start, end: end });

        case 6:
          grossProfit = _context5.sent;

          if (!grossProfit) {
            _context5.next = 11;
            break;
          }

          _context5.next = 10;
          return (0, _effects.put)((0, _sales2.setGrossProfit)(grossProfit));

        case 10:
          mpGrossProfit.reportGrossProfitStart({ grossProfit: grossProfit });

        case 11:
          _context5.next = 13;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 13:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function paymentMethodsPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function paymentMethodsPageRequestFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 3:
          _context6.next = 5;
          return (0, _effects.put)(action.showProgressBar());

        case 5:
          _context6.next = 7;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 7:
          filteredDate = _context6.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context6.next = 14;
          return (0, _effects.call)(apiOutlets.outlets);

        case 14:
          resOutlets = _context6.sent;
          _context6.next = 17;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 17:
          _context6.next = 19;
          return (0, _effects.call)(_profile.getProfile);

        case 19:
          profile = _context6.sent;
          _context6.next = 22;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 22:
          _context6.next = 24;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 24:
          _context6.next = 26;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 26:
          _context6.next = 28;
          return (0, _effects.put)((0, _sales2.paymentMethodsRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 28:
          mpReportPaymentMethod.reportsPaymentMethodsStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context6.next = 35;
          break;

        case 31:
          _context6.prev = 31;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 35;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 35:
          _context6.prev = 35;
          _context6.next = 38;
          return (0, _effects.put)(action.hideProgressBar());

        case 38:
          return _context6.finish(35);

        case 39:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[0, 31, 35, 39]]);
}

function getPaymentMethodsFlow(request) {
  var start, end, paymentMethods;
  return _regenerator2.default.wrap(function getPaymentMethodsFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context7.next = 6;
          return (0, _effects.call)(_sales.getPaymentMethods, { start: start, end: end });

        case 6:
          paymentMethods = _context7.sent;

          if (!paymentMethods) {
            _context7.next = 10;
            break;
          }

          _context7.next = 10;
          return (0, _effects.put)((0, _sales2.setPaymentMethods)(paymentMethods));

        case 10:
          _context7.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function itemSalesPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function itemSalesPageRequestFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.put)((0, _sales2.setItemSales)([]));

        case 3:
          _context8.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context8.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context8.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context8.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context8.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context8.sent;
          _context8.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context8.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context8.sent;
          _context8.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context8.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context8.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          mpReportItemSales.reportsItemSalesStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context8.next = 31;
          return (0, _effects.put)((0, _sales2.itemSalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 31:
          _context8.next = 37;
          break;

        case 33:
          _context8.prev = 33;
          _context8.t0 = _context8['catch'](0);
          _context8.next = 37;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 37:
          _context8.prev = 37;
          _context8.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context8.finish(37);

        case 41:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[0, 33, 37, 41]]);
}

function getItemSalesFlow(request) {
  var start, end, itemSales;
  return _regenerator2.default.wrap(function getItemSalesFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context9.next = 6;
          return (0, _effects.call)(_sales.getItemSales, { start: start, end: end });

        case 6:
          itemSales = _context9.sent;

          if (!itemSales) {
            _context9.next = 10;
            break;
          }

          _context9.next = 10;
          return (0, _effects.put)((0, _sales2.setItemSales)(itemSales));

        case 10:
          _context9.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function categorySalesPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function categorySalesPageRequestFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.put)((0, _sales2.setCategorySales)([]));

        case 3:
          _context10.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context10.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context10.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context10.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context10.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context10.sent;
          _context10.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context10.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context10.sent;
          _context10.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context10.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context10.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context10.next = 30;
          return (0, _effects.put)((0, _sales2.categorySalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 30:
          mpReportCategorySales.reportsCategorySalesStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context10.next = 37;
          break;

        case 33:
          _context10.prev = 33;
          _context10.t0 = _context10['catch'](0);
          _context10.next = 37;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 37:
          _context10.prev = 37;
          _context10.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context10.finish(37);

        case 41:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[0, 33, 37, 41]]);
}

function getCategorySalesFlow(request) {
  var start, end, categorySales;
  return _regenerator2.default.wrap(function getCategorySalesFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context11.next = 6;
          return (0, _effects.call)(_sales.getCategorySales, { start: start, end: end });

        case 6:
          categorySales = _context11.sent;

          if (!categorySales) {
            _context11.next = 10;
            break;
          }

          _context11.next = 10;
          return (0, _effects.put)((0, _sales2.setCategorySales)(categorySales));

        case 10:
          _context11.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function modifierSalesPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function modifierSalesPageRequestFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.put)((0, _sales2.setModifierSales)([]));

        case 3:
          _context12.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context12.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context12.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context12.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context12.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context12.sent;
          _context12.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context12.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context12.sent;
          _context12.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context12.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context12.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          mpReportModifierSales.reportsModifierSalesStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context12.next = 31;
          return (0, _effects.put)((0, _sales2.modifierSalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 31:
          _context12.next = 37;
          break;

        case 33:
          _context12.prev = 33;
          _context12.t0 = _context12['catch'](0);
          _context12.next = 37;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 37:
          _context12.prev = 37;
          _context12.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context12.finish(37);

        case 41:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[0, 33, 37, 41]]);
}

function getModifierSalesFlow(request) {
  var start, end, modifierSales;
  return _regenerator2.default.wrap(function getModifierSalesFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context13.next = 6;
          return (0, _effects.call)(_sales.getModifierSales, { start: start, end: end });

        case 6:
          modifierSales = _context13.sent;

          if (!modifierSales) {
            _context13.next = 10;
            break;
          }

          _context13.next = 10;
          return (0, _effects.put)((0, _sales2.setModifierSales)(modifierSales));

        case 10:
          _context13.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function discountsPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile, outletIds;
  return _regenerator2.default.wrap(function discountsPageRequestFlow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.put)((0, _sales2.setDiscounts)([]));

        case 3:
          _context14.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context14.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context14.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context14.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context14.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context14.sent;
          _context14.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context14.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context14.sent;
          _context14.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context14.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context14.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          mpDiscount.reportsDiscountStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });

          outletIds = profile.outlet_id.join(',');
          _context14.next = 32;
          return (0, _effects.put)((0, _sales2.discountsRequest)({ startDate: startDateFormatted, endDate: endDateFormatted, outletIds: outletIds }));

        case 32:
          _context14.next = 38;
          break;

        case 34:
          _context14.prev = 34;
          _context14.t0 = _context14['catch'](0);
          _context14.next = 38;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 38:
          _context14.prev = 38;
          _context14.next = 41;
          return (0, _effects.put)(action.hideProgressBar());

        case 41:
          return _context14.finish(38);

        case 42:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[0, 34, 38, 42]]);
}

function getDiscountsFlow(request) {
  var start, end, outletIds, discounts;
  return _regenerator2.default.wrap(function getDiscountsFlow$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          outletIds = request.payload.outletIds;
          _context15.next = 7;
          return (0, _effects.call)(_sales.getDiscounts, { start: start, end: end, outletIds: outletIds });

        case 7:
          discounts = _context15.sent;

          if (!discounts) {
            _context15.next = 11;
            break;
          }

          _context15.next = 11;
          return (0, _effects.put)((0, _sales2.setDiscounts)(discounts));

        case 11:
          _context15.next = 13;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 13:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function taxesPageRequestFlow() {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function taxesPageRequestFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.put)((0, _sales2.setTaxes)([]));

        case 3:
          _context16.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context16.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context16.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context16.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context16.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context16.sent;
          _context16.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context16.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context16.sent;
          _context16.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context16.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context16.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          mpReportTaxes.reportsTaxStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context16.next = 31;
          return (0, _effects.put)((0, _sales2.taxesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 31:
          _context16.next = 37;
          break;

        case 33:
          _context16.prev = 33;
          _context16.t0 = _context16['catch'](0);
          _context16.next = 37;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 37:
          _context16.prev = 37;
          _context16.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context16.finish(37);

        case 41:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[0, 33, 37, 41]]);
}

function getTaxesFlow(request) {
  var start, end, taxes;
  return _regenerator2.default.wrap(function getTaxesFlow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context17.next = 6;
          return (0, _effects.call)(_sales.getTaxes, { start: start, end: end });

        case 6:
          taxes = _context17.sent;

          if (!taxes) {
            _context17.next = 10;
            break;
          }

          _context17.next = 10;
          return (0, _effects.put)((0, _sales2.setTaxes)(taxes));

        case 10:
          _context17.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function gratuityPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function gratuityPageRequestFlow$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.put)((0, _sales2.setGratuity)([]));

        case 3:
          _context18.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context18.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context18.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context18.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context18.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context18.sent;
          _context18.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context18.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context18.sent;
          _context18.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context18.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context18.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context18.next = 30;
          return (0, _effects.put)((0, _sales2.gratuityRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 30:
          mpReportGratuity.reportsGratuityStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context18.next = 37;
          break;

        case 33:
          _context18.prev = 33;
          _context18.t0 = _context18['catch'](0);
          _context18.next = 37;
          return (0, _effects.put)(actNotif.error(_context18.t0.message));

        case 37:
          _context18.prev = 37;
          _context18.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context18.finish(37);

        case 41:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this, [[0, 33, 37, 41]]);
}

function getGratuitiesFlow(request) {
  var start, end, gratuities;
  return _regenerator2.default.wrap(function getGratuitiesFlow$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context19.next = 6;
          return (0, _effects.call)(_sales.getGratuities, { start: start, end: end });

        case 6:
          gratuities = _context19.sent;

          if (!gratuities) {
            _context19.next = 10;
            break;
          }

          _context19.next = 10;
          return (0, _effects.put)((0, _sales2.setGratuity)(gratuities));

        case 10:
          _context19.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function collectedByPageRequestFlow() {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function collectedByPageRequestFlow$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.put)((0, _sales2.setCollectedBy)([]));

        case 3:
          _context20.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context20.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context20.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context20.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context20.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context20.sent;
          _context20.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context20.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context20.sent;
          _context20.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context20.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context20.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          _context20.next = 30;
          return (0, _effects.put)((0, _sales2.collectedByRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 30:
          mpReportCollected.reportCollectedStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context20.next = 37;
          break;

        case 33:
          _context20.prev = 33;
          _context20.t0 = _context20['catch'](0);
          _context20.next = 37;
          return (0, _effects.put)(actNotif.error(_context20.t0.message));

        case 37:
          _context20.prev = 37;
          _context20.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context20.finish(37);

        case 41:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this, [[0, 33, 37, 41]]);
}

function getStaffsFlow(request) {
  var start, end, staffs;
  return _regenerator2.default.wrap(function getStaffsFlow$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context21.next = 6;
          return (0, _effects.call)(_sales.getStaffs, { start: start, end: end });

        case 6:
          staffs = _context21.sent;

          if (!staffs) {
            _context21.next = 10;
            break;
          }

          _context21.next = 10;
          return (0, _effects.put)((0, _sales2.setCollectedBy)(staffs));

        case 10:
          _context21.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function servedByPageRequestFlow(request) {
  var filteredDate, start, end, startDateFormatted, endDateFormatted, resOutlets, profile;
  return _regenerator2.default.wrap(function servedByPageRequestFlow$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return (0, _effects.put)((0, _sales2.setServedBy)([]));

        case 3:
          _context22.next = 5;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 5:
          _context22.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context22.next = 9;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 9:
          filteredDate = _context22.sent;
          start = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          end = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          startDateFormatted = start.format('D/M/YYYY');
          endDateFormatted = end.format('D/M/YYYY');

          // set outlets

          _context22.next = 16;
          return (0, _effects.call)(apiOutlets.outlets);

        case 16:
          resOutlets = _context22.sent;
          _context22.next = 19;
          return (0, _effects.put)((0, _sales2.setOutlets)(resOutlets.data));

        case 19:
          _context22.next = 21;
          return (0, _effects.call)(_profile.getProfile);

        case 21:
          profile = _context22.sent;
          _context22.next = 24;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 24:
          _context22.next = 26;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 26:
          _context22.next = 28;
          return (0, _effects.call)(fillForm, profile.outlet_id, start, end);

        case 28:
          mpReportServedBy.reportServedStart({
            outletIds: profile.outlet_id,
            startDate: start,
            endDate: end
          });
          _context22.next = 31;
          return (0, _effects.put)((0, _sales2.servedByRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 31:
          _context22.next = 37;
          break;

        case 33:
          _context22.prev = 33;
          _context22.t0 = _context22['catch'](0);
          _context22.next = 37;
          return (0, _effects.put)(actNotif.error(_context22.t0.message));

        case 37:
          _context22.prev = 37;
          _context22.next = 40;
          return (0, _effects.put)(action.hideProgressBar());

        case 40:
          return _context22.finish(37);

        case 41:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this, [[0, 33, 37, 41]]);
}

function getServersFlow(request) {
  var start, end, servers;
  return _regenerator2.default.wrap(function getServersFlow$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          start = request.payload.startDate;
          end = request.payload.endDate;
          _context23.next = 6;
          return (0, _effects.call)(_sales.getServers, { start: start, end: end });

        case 6:
          servers = _context23.sent;

          if (!servers) {
            _context23.next = 10;
            break;
          }

          _context23.next = 10;
          return (0, _effects.put)((0, _sales2.setServedBy)(servers));

        case 10:
          _context23.next = 12;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 12:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this);
}

function changeDateSalesSummaryFlow(request) {
  var _request$payload, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateSalesSummaryFlow$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          _request$payload = request.payload, startDate = _request$payload.startDate, endDate = _request$payload.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context24.next = 7;
          return (0, _effects.put)((0, _sales2.salesSummaryRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 7:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this);
}

function changeDateGrossProfitFlow(request) {
  var _request$payload2, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateGrossProfitFlow$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          _request$payload2 = request.payload, startDate = _request$payload2.startDate, endDate = _request$payload2.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context25.next = 7;
          return (0, _effects.put)((0, _sales2.grossProfitRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 7:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this);
}

function changeDatePaymentMethodsFlow(request) {
  var _request$payload3, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDatePaymentMethodsFlow$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          _request$payload3 = request.payload, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context26.next = 7;
          return (0, _effects.put)((0, _sales2.paymentMethodsRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 7:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this);
}

function changeDateItemSalesFlow(request) {
  var _request$payload4, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateItemSalesFlow$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return (0, _effects.put)((0, _sales2.setItemSales)([]));

        case 2:
          _context27.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload4 = request.payload, startDate = _request$payload4.startDate, endDate = _request$payload4.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context27.next = 9;
          return (0, _effects.put)((0, _sales2.itemSalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked[26], this);
}

function changeDateCategorySalesFlow(request) {
  var _request$payload5, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateCategorySalesFlow$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return (0, _effects.put)((0, _sales2.setCategorySales)([]));

        case 2:
          _context28.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload5 = request.payload, startDate = _request$payload5.startDate, endDate = _request$payload5.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context28.next = 9;
          return (0, _effects.put)((0, _sales2.categorySalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked[27], this);
}

function changeDateModifierSalesFlow(request) {
  var _request$payload6, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateModifierSalesFlow$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return (0, _effects.put)((0, _sales2.setModifierSales)([]));

        case 2:
          _context29.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload6 = request.payload, startDate = _request$payload6.startDate, endDate = _request$payload6.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context29.next = 9;
          return (0, _effects.put)((0, _sales2.modifierSalesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked[28], this);
}

function changeDateDiscountsFlow(request) {
  var _request$payload7, startDate, endDate, outletIds, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateDiscountsFlow$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          _context30.next = 2;
          return (0, _effects.put)((0, _sales2.setDiscounts)([]));

        case 2:
          _context30.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload7 = request.payload, startDate = _request$payload7.startDate, endDate = _request$payload7.endDate, outletIds = _request$payload7.outletIds;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context30.next = 9;
          return (0, _effects.put)((0, _sales2.discountsRequest)({ startDate: startDateFormatted, endDate: endDateFormatted, outletIds: outletIds }));

        case 9:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked[29], this);
}

function changeDateTaxesFlow(request) {
  var _request$payload8, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateTaxesFlow$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return (0, _effects.put)((0, _sales2.setTaxes)([]));

        case 2:
          _context31.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload8 = request.payload, startDate = _request$payload8.startDate, endDate = _request$payload8.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context31.next = 9;
          return (0, _effects.put)((0, _sales2.taxesRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context31.stop();
      }
    }
  }, _marked[30], this);
}

function changeDateGratuityFlow(request) {
  var _request$payload9, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateGratuityFlow$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return (0, _effects.put)((0, _sales2.setGratuity)([]));

        case 2:
          _context32.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload9 = request.payload, startDate = _request$payload9.startDate, endDate = _request$payload9.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context32.next = 9;
          return (0, _effects.put)((0, _sales2.gratuityRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context32.stop();
      }
    }
  }, _marked[31], this);
}

function changeDateCollectedByFlow(request) {
  var _request$payload10, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateCollectedByFlow$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return (0, _effects.put)((0, _sales2.setCollectedBy)([]));

        case 2:
          _context33.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload10 = request.payload, startDate = _request$payload10.startDate, endDate = _request$payload10.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context33.next = 9;
          return (0, _effects.put)((0, _sales2.collectedByRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context33.stop();
      }
    }
  }, _marked[32], this);
}

function changeDateServedByFlow(request) {
  var _request$payload11, startDate, endDate, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateServedByFlow$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return (0, _effects.put)((0, _sales2.setServedBy)([]));

        case 2:
          _context34.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _request$payload11 = request.payload, startDate = _request$payload11.startDate, endDate = _request$payload11.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context34.next = 9;
          return (0, _effects.put)((0, _sales2.servedByRequest)({ startDate: startDateFormatted, endDate: endDateFormatted }));

        case 9:
        case 'end':
          return _context34.stop();
      }
    }
  }, _marked[33], this);
}

function changeOutletSalesSummaryFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, salesSummaryData;
  return _regenerator2.default.wrap(function changeOutletSalesSummaryFlow$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return (0, _effects.put)((0, _sales2.setSalesSummary)([]));

        case 2:
          _context35.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context35.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context35.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context35.sent;
          _context35.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context35.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context35.next = 19;
          return (0, _effects.call)(apiReport.getSalesSummary, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          salesSummaryData = _context35.sent;
          _context35.next = 22;
          return (0, _effects.put)((0, _sales2.setSalesSummary)(salesSummaryData.data));

        case 22:
          _context35.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context35.stop();
      }
    }
  }, _marked[34], this);
}

function changeOutletGrossProfitFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, grossProfitData;
  return _regenerator2.default.wrap(function changeOutletGrossProfitFlow$(_context36) {
    while (1) {
      switch (_context36.prev = _context36.next) {
        case 0:
          _context36.next = 2;
          return (0, _effects.put)((0, _sales2.setGrossProfit)([]));

        case 2:
          _context36.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context36.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context36.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context36.sent;
          _context36.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context36.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context36.next = 19;
          return (0, _effects.call)(apiReport.getGrossProfit, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          grossProfitData = _context36.sent;
          _context36.next = 22;
          return (0, _effects.put)((0, _sales2.setGrossProfit)(grossProfitData.data));

        case 22:
          _context36.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context36.stop();
      }
    }
  }, _marked[35], this);
}

function changeOutletPaymentMethodsFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, paymentMethodsData;
  return _regenerator2.default.wrap(function changeOutletPaymentMethodsFlow$(_context37) {
    while (1) {
      switch (_context37.prev = _context37.next) {
        case 0:
          _context37.next = 2;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 2:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context37.next = 6;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 6:
          _context37.next = 8;
          return (0, _effects.call)(_profile.getProfile);

        case 8:
          currentOutlet = _context37.sent;
          _context37.next = 11;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 11:
          _context37.next = 13;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 13:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context37.next = 17;
          return (0, _effects.call)(apiReport.getPaymentMethods, { start: startDateFormatted, end: endDateFormatted });

        case 17:
          paymentMethodsData = _context37.sent;
          _context37.next = 20;
          return (0, _effects.put)((0, _sales2.setPaymentMethods)(paymentMethodsData.data));

        case 20:
          _context37.next = 22;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 22:
        case 'end':
          return _context37.stop();
      }
    }
  }, _marked[36], this);
}

function changeOutletItemSalesFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, itemSalesData;
  return _regenerator2.default.wrap(function changeOutletItemSalesFlow$(_context38) {
    while (1) {
      switch (_context38.prev = _context38.next) {
        case 0:
          _context38.next = 2;
          return (0, _effects.put)((0, _sales2.setItemSales)([]));

        case 2:
          _context38.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context38.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context38.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context38.sent;
          _context38.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context38.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context38.next = 19;
          return (0, _effects.call)(apiReport.getItemSales, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          itemSalesData = _context38.sent;
          _context38.next = 22;
          return (0, _effects.put)((0, _sales2.setItemSales)(itemSalesData.data));

        case 22:
          _context38.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context38.stop();
      }
    }
  }, _marked[37], this);
}

function changeOutletCategorySalesFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, categorySalesData;
  return _regenerator2.default.wrap(function changeOutletCategorySalesFlow$(_context39) {
    while (1) {
      switch (_context39.prev = _context39.next) {
        case 0:
          _context39.next = 2;
          return (0, _effects.put)((0, _sales2.setCategorySales)([]));

        case 2:
          _context39.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context39.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context39.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context39.sent;
          _context39.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context39.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context39.next = 19;
          return (0, _effects.call)(apiReport.getCategorySales, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          categorySalesData = _context39.sent;
          _context39.next = 22;
          return (0, _effects.put)((0, _sales2.setCategorySales)(categorySalesData.data));

        case 22:
          _context39.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context39.stop();
      }
    }
  }, _marked[38], this);
}

function changeOutletModifierSalesFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, modifierSalesData;
  return _regenerator2.default.wrap(function changeOutletModifierSalesFlow$(_context40) {
    while (1) {
      switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return (0, _effects.put)((0, _sales2.setModifierSales)([]));

        case 2:
          _context40.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context40.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context40.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context40.sent;
          _context40.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context40.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context40.next = 19;
          return (0, _effects.call)(apiReport.getModifierSales, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          modifierSalesData = _context40.sent;
          _context40.next = 22;
          return (0, _effects.put)((0, _sales2.setModifierSales)(modifierSalesData.data));

        case 22:
          _context40.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context40.stop();
      }
    }
  }, _marked[39], this);
}

function changeOutletDiscountsFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, discountsData;
  return _regenerator2.default.wrap(function changeOutletDiscountsFlow$(_context41) {
    while (1) {
      switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return (0, _effects.put)((0, _sales2.setDiscounts)([]));

        case 2:
          _context41.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context41.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context41.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context41.sent;
          _context41.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context41.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context41.next = 19;
          return (0, _effects.call)(apiReport.getDiscounts, { start: startDateFormatted, end: endDateFormatted, outletIds: outletIds.join(',') });

        case 19:
          discountsData = _context41.sent;
          _context41.next = 22;
          return (0, _effects.put)((0, _sales2.setDiscounts)(discountsData.data));

        case 22:
          _context41.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context41.stop();
      }
    }
  }, _marked[40], this);
}

function changeOutletTaxesFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, taxesData;
  return _regenerator2.default.wrap(function changeOutletTaxesFlow$(_context42) {
    while (1) {
      switch (_context42.prev = _context42.next) {
        case 0:
          _context42.next = 2;
          return (0, _effects.put)((0, _sales2.setTaxes)([]));

        case 2:
          _context42.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context42.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context42.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context42.sent;
          _context42.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context42.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context42.next = 19;
          return (0, _effects.call)(apiReport.getTaxes, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          taxesData = _context42.sent;
          _context42.next = 22;
          return (0, _effects.put)((0, _sales2.setTaxes)(taxesData.data));

        case 22:
          _context42.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context42.stop();
      }
    }
  }, _marked[41], this);
}

function changeOutletGratuityFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, gratuityData;
  return _regenerator2.default.wrap(function changeOutletGratuityFlow$(_context43) {
    while (1) {
      switch (_context43.prev = _context43.next) {
        case 0:
          _context43.next = 2;
          return (0, _effects.put)((0, _sales2.setGratuity)([]));

        case 2:
          _context43.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context43.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context43.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context43.sent;
          _context43.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context43.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context43.next = 19;
          return (0, _effects.call)(apiReport.getGratuities, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          gratuityData = _context43.sent;
          _context43.next = 22;
          return (0, _effects.put)((0, _sales2.setGratuity)(gratuityData.data));

        case 22:
          _context43.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context43.stop();
      }
    }
  }, _marked[42], this);
}

function changeOutletCollectedByFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, staffData;
  return _regenerator2.default.wrap(function changeOutletCollectedByFlow$(_context44) {
    while (1) {
      switch (_context44.prev = _context44.next) {
        case 0:
          _context44.next = 2;
          return (0, _effects.put)((0, _sales2.setCollectedBy)([]));

        case 2:
          _context44.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          _context44.prev = 4;
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context44.next = 9;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 9:
          _context44.next = 11;
          return (0, _effects.call)(_profile.getProfile);

        case 11:
          currentOutlet = _context44.sent;
          _context44.next = 14;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 14:
          _context44.next = 16;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 16:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context44.next = 20;
          return (0, _effects.call)(apiReport.getStaffs, { start: startDateFormatted, end: endDateFormatted });

        case 20:
          staffData = _context44.sent;
          _context44.next = 23;
          return (0, _effects.put)((0, _sales2.setCollectedBy)(staffData.data));

        case 23:
          _context44.next = 29;
          break;

        case 25:
          _context44.prev = 25;
          _context44.t0 = _context44['catch'](4);
          _context44.next = 29;
          return (0, _effects.put)(actNotif.error(_context44.t0.message));

        case 29:
          _context44.prev = 29;
          _context44.next = 32;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 32:
          return _context44.finish(29);

        case 33:
        case 'end':
          return _context44.stop();
      }
    }
  }, _marked[43], this, [[4, 25, 29, 33]]);
}

function changeOutletServedByFlow(request) {
  var payload, outletIds, startDate, endDate, currentOutlet, startDateFormatted, endDateFormatted, serverData;
  return _regenerator2.default.wrap(function changeOutletServedByFlow$(_context45) {
    while (1) {
      switch (_context45.prev = _context45.next) {
        case 0:
          _context45.next = 2;
          return (0, _effects.put)((0, _sales2.setServedBy)([]));

        case 2:
          _context45.next = 4;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          outletIds = payload.outletIds, startDate = payload.startDate, endDate = payload.endDate;
          _context45.next = 8;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 8:
          _context45.next = 10;
          return (0, _effects.call)(_profile.getProfile);

        case 10:
          currentOutlet = _context45.sent;
          _context45.next = 13;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 13:
          _context45.next = 15;
          return (0, _effects.call)(fillForm, outletIds, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context45.next = 19;
          return (0, _effects.call)(apiReport.getServers, { start: startDateFormatted, end: endDateFormatted });

        case 19:
          serverData = _context45.sent;
          _context45.next = 22;
          return (0, _effects.put)((0, _sales2.setServedBy)(serverData.data));

        case 22:
          _context45.next = 24;
          return (0, _effects.put)((0, _sales2.reportsShowLoadingSpinner)(false));

        case 24:
        case 'end':
          return _context45.stop();
      }
    }
  }, _marked[44], this);
}

function exportSummaryFlow(request) {
  var _request$payload12, query, filename, outletId;

  return _regenerator2.default.wrap(function exportSummaryFlow$(_context46) {
    while (1) {
      switch (_context46.prev = _context46.next) {
        case 0:
          _request$payload12 = request.payload, query = _request$payload12.query, filename = _request$payload12.filename, outletId = _request$payload12.outletId;
          _context46.prev = 1;
          _context46.next = 4;
          return (0, _effects.call)(apiReport.exportSummary, query);

        case 4:
          _context46.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'sales summary'));

        case 6:
          _context46.next = 12;
          break;

        case 8:
          _context46.prev = 8;
          _context46.t0 = _context46['catch'](1);
          _context46.next = 12;
          return (0, _effects.put)(actNotif.error(_context46.t0.message));

        case 12:
        case 'end':
          return _context46.stop();
      }
    }
  }, _marked[45], this, [[1, 8]]);
}
function exportGrossProfitFlow(request) {
  var _request$payload13, query, filename, outletId;

  return _regenerator2.default.wrap(function exportGrossProfitFlow$(_context47) {
    while (1) {
      switch (_context47.prev = _context47.next) {
        case 0:
          _request$payload13 = request.payload, query = _request$payload13.query, filename = _request$payload13.filename, outletId = _request$payload13.outletId;
          _context47.prev = 1;
          _context47.next = 4;
          return (0, _effects.call)(apiReport.exportGrossProfit, query);

        case 4:
          _context47.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'sales summary'));

        case 6:
          _context47.next = 12;
          break;

        case 8:
          _context47.prev = 8;
          _context47.t0 = _context47['catch'](1);
          _context47.next = 12;
          return (0, _effects.put)(actNotif.error(_context47.t0.message));

        case 12:
        case 'end':
          return _context47.stop();
      }
    }
  }, _marked[46], this, [[1, 8]]);
}

function exportPaymentMethodsFlow(request) {
  var _request$payload14, query, filename, outletId;

  return _regenerator2.default.wrap(function exportPaymentMethodsFlow$(_context48) {
    while (1) {
      switch (_context48.prev = _context48.next) {
        case 0:
          _request$payload14 = request.payload, query = _request$payload14.query, filename = _request$payload14.filename, outletId = _request$payload14.outletId;
          _context48.prev = 1;
          _context48.next = 4;
          return (0, _effects.call)(apiReport.exportPaymentMethod, query);

        case 4:
          _context48.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'payment methods'));

        case 6:
          _context48.next = 12;
          break;

        case 8:
          _context48.prev = 8;
          _context48.t0 = _context48['catch'](1);
          _context48.next = 12;
          return (0, _effects.put)(actNotif.error(_context48.t0.message));

        case 12:
        case 'end':
          return _context48.stop();
      }
    }
  }, _marked[47], this, [[1, 8]]);
}

function exportItemSalesFlow(request) {
  var _request$payload15, query, filename, outletId;

  return _regenerator2.default.wrap(function exportItemSalesFlow$(_context49) {
    while (1) {
      switch (_context49.prev = _context49.next) {
        case 0:
          _request$payload15 = request.payload, query = _request$payload15.query, filename = _request$payload15.filename, outletId = _request$payload15.outletId;
          _context49.prev = 1;
          _context49.next = 4;
          return (0, _effects.call)(apiReport.exportItemSales, query);

        case 4:
          _context49.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'item sales'));

        case 6:
          _context49.next = 12;
          break;

        case 8:
          _context49.prev = 8;
          _context49.t0 = _context49['catch'](1);
          _context49.next = 12;
          return (0, _effects.put)(actNotif.error(_context49.t0.message));

        case 12:
        case 'end':
          return _context49.stop();
      }
    }
  }, _marked[48], this, [[1, 8]]);
}

function exportCategorySalesFlow(request) {
  var _request$payload16, query, filename, outletId;

  return _regenerator2.default.wrap(function exportCategorySalesFlow$(_context50) {
    while (1) {
      switch (_context50.prev = _context50.next) {
        case 0:
          _request$payload16 = request.payload, query = _request$payload16.query, filename = _request$payload16.filename, outletId = _request$payload16.outletId;
          _context50.prev = 1;
          _context50.next = 4;
          return (0, _effects.call)(apiReport.exportCategorySales, query);

        case 4:
          _context50.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'category sales'));

        case 6:
          _context50.next = 12;
          break;

        case 8:
          _context50.prev = 8;
          _context50.t0 = _context50['catch'](1);
          _context50.next = 12;
          return (0, _effects.put)(actNotif.error(_context50.t0.message));

        case 12:
        case 'end':
          return _context50.stop();
      }
    }
  }, _marked[49], this, [[1, 8]]);
}

function exportModifierSalesFlow(request) {
  var _request$payload17, query, filename, outletId;

  return _regenerator2.default.wrap(function exportModifierSalesFlow$(_context51) {
    while (1) {
      switch (_context51.prev = _context51.next) {
        case 0:
          _request$payload17 = request.payload, query = _request$payload17.query, filename = _request$payload17.filename, outletId = _request$payload17.outletId;
          _context51.prev = 1;
          _context51.next = 4;
          return (0, _effects.call)(apiReport.exportModifierSales, query);

        case 4:
          _context51.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'modifier sales'));

        case 6:
          _context51.next = 12;
          break;

        case 8:
          _context51.prev = 8;
          _context51.t0 = _context51['catch'](1);
          _context51.next = 12;
          return (0, _effects.put)(actNotif.error(_context51.t0.message));

        case 12:
        case 'end':
          return _context51.stop();
      }
    }
  }, _marked[50], this, [[1, 8]]);
}

function exportDiscountFlow(request) {
  var _request$payload18, query, filename, _ref, data;

  return _regenerator2.default.wrap(function exportDiscountFlow$(_context52) {
    while (1) {
      switch (_context52.prev = _context52.next) {
        case 0:
          _request$payload18 = request.payload, query = _request$payload18.query, filename = _request$payload18.filename;
          _context52.prev = 1;
          _context52.next = 4;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 4:
          _context52.next = 6;
          return (0, _effects.call)(apiReport.exportDiscounts, query);

        case 6:
          _ref = _context52.sent;
          data = _ref.data;
          _context52.next = 10;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 10:
          (0, _reactFileDownload2.default)(data, filename + '.csv');
          _context52.next = 17;
          break;

        case 13:
          _context52.prev = 13;
          _context52.t0 = _context52['catch'](1);
          _context52.next = 17;
          return (0, _effects.put)(actNotif.error(_context52.t0.message));

        case 17:
        case 'end':
          return _context52.stop();
      }
    }
  }, _marked[51], this, [[1, 13]]);
}

function exportTaxesFlow(request) {
  var _request$payload19, query, filename, outletId;

  return _regenerator2.default.wrap(function exportTaxesFlow$(_context53) {
    while (1) {
      switch (_context53.prev = _context53.next) {
        case 0:
          _request$payload19 = request.payload, query = _request$payload19.query, filename = _request$payload19.filename, outletId = _request$payload19.outletId;
          _context53.prev = 1;
          _context53.next = 4;
          return (0, _effects.call)(apiReport.exportTaxes, query);

        case 4:
          _context53.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'taxes'));

        case 6:
          _context53.next = 12;
          break;

        case 8:
          _context53.prev = 8;
          _context53.t0 = _context53['catch'](1);
          _context53.next = 12;
          return (0, _effects.put)(actNotif.error(_context53.t0.message));

        case 12:
        case 'end':
          return _context53.stop();
      }
    }
  }, _marked[52], this, [[1, 8]]);
}

function exportGratuityFlow(request) {
  var _request$payload20, query, filename, outletId;

  return _regenerator2.default.wrap(function exportGratuityFlow$(_context54) {
    while (1) {
      switch (_context54.prev = _context54.next) {
        case 0:
          _request$payload20 = request.payload, query = _request$payload20.query, filename = _request$payload20.filename, outletId = _request$payload20.outletId;
          _context54.prev = 1;
          _context54.next = 4;
          return (0, _effects.call)(apiReport.exportGratuity, query);

        case 4:
          _context54.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'gratuity'));

        case 6:
          _context54.next = 12;
          break;

        case 8:
          _context54.prev = 8;
          _context54.t0 = _context54['catch'](1);
          _context54.next = 12;
          return (0, _effects.put)(actNotif.error(_context54.t0.message));

        case 12:
        case 'end':
          return _context54.stop();
      }
    }
  }, _marked[53], this, [[1, 8]]);
}

function exportColectedByFlow(request) {
  var _request$payload21, query, filename, outletId;

  return _regenerator2.default.wrap(function exportColectedByFlow$(_context55) {
    while (1) {
      switch (_context55.prev = _context55.next) {
        case 0:
          _request$payload21 = request.payload, query = _request$payload21.query, filename = _request$payload21.filename, outletId = _request$payload21.outletId;
          _context55.prev = 1;
          _context55.next = 4;
          return (0, _effects.call)(apiReport.exportColectedBy, query);

        case 4:
          _context55.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'collected by'));

        case 6:
          _context55.next = 12;
          break;

        case 8:
          _context55.prev = 8;
          _context55.t0 = _context55['catch'](1);
          _context55.next = 12;
          return (0, _effects.put)(actNotif.error(_context55.t0.message));

        case 12:
        case 'end':
          return _context55.stop();
      }
    }
  }, _marked[54], this, [[1, 8]]);
}

function exportServedByFlow(request) {
  var _request$payload22, query, filename, outletId;

  return _regenerator2.default.wrap(function exportServedByFlow$(_context56) {
    while (1) {
      switch (_context56.prev = _context56.next) {
        case 0:
          _request$payload22 = request.payload, query = _request$payload22.query, filename = _request$payload22.filename, outletId = _request$payload22.outletId;
          _context56.prev = 1;
          _context56.next = 4;
          return (0, _effects.call)(apiReport.exportServedBy, query);

        case 4:
          _context56.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'served by'));

        case 6:
          _context56.next = 12;
          break;

        case 8:
          _context56.prev = 8;
          _context56.t0 = _context56['catch'](1);
          _context56.next = 12;
          return (0, _effects.put)(actNotif.error(_context56.t0.message));

        case 12:
        case 'end':
          return _context56.stop();
      }
    }
  }, _marked[55], this, [[1, 8]]);
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context57) {
    while (1) {
      switch (_context57.prev = _context57.next) {
        case 0:
          _context57.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context57.stop();
      }
    }
  }, _marked[56], this);
}

function reportsSalesSaga() {
  var pageRequestTask, getSalesSummaryTask, grossProfitPageRequestTask, getSalesGrossProfitTask, paymentMethodsPageRequestTask, getPaymentMethodsTask, itemSalesPageReqTask, itemSalesReqTask, categorySalesPageReqTask, getCategorySalesTask, modifierSalesPageReqTask, modifierSalesReqTask, discountPageReqTask, discountReqTask, taxPagReqTask, taxReqTask, gratuityPagReqTask, gratuityReqTask, collectedByPageReqTask, collectedByReqTask, servedByPageReqTask, servedByReqTask, changeDateSalesSummaryTask, changeDateGrossProfitTask, changeDatePaymentMethodsTask, changeDateItemSalesTask, changeDateCategorySalesTask, changeDateModifierSalesTask, changeDateDiscountTask, changeDateTaxTask, changeDateGratuityTask, changeDateCollectedByTask, changeDateServedByTask, changeOutletSalesSummaryTask, changeOutletGrossProfitTask, changeOutletPaymentMethodsTask, changeOutletItemSalesTask, changeOutletCategorySalesTask, changeOutletModifierSalesTask, changeOutletDiscountTask, changeOutletTaxTask, changeOutletGratuityTask, changeOutletCollectedByTask, changeOutletServedByTask, exportSummaryTask, exportGrossProfitTask, exportPaymentMethodTask, exportItemSalesTask, exportCategorySalesTask, exportModifierSalesTask, exportDiscountsTask, exportTaxesTask, exportGratuityTask, exportCollectedByTask, exportServedByTask;
  return _regenerator2.default.wrap(function reportsSalesSaga$(_context58) {
    while (1) {
      switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_PAGE_REQUEST, reportsSalesPageRequestFlow);

        case 2:
          pageRequestTask = _context58.sent;
          _context58.next = 5;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_SUMMARY_REQUEST, getSalesSummaryFlow);

        case 5:
          getSalesSummaryTask = _context58.sent;
          _context58.next = 8;
          return (0, _effects.takeLatest)(_constants.REPORTS_GROSS_PROFIT_PAGE_REQUEST, grossProfitPageRequestFlow);

        case 8:
          grossProfitPageRequestTask = _context58.sent;
          _context58.next = 11;
          return (0, _effects.takeLatest)(_constants.REPORTS_GROSS_PROFIT_REQUEST, getGrossProfitFlow);

        case 11:
          getSalesGrossProfitTask = _context58.sent;
          _context58.next = 14;
          return (0, _effects.takeLatest)(_constants.REPORTS_PAYMENT_METHODS_PAGE_REQUEST, paymentMethodsPageRequestFlow);

        case 14:
          paymentMethodsPageRequestTask = _context58.sent;
          _context58.next = 17;
          return (0, _effects.takeLatest)(_constants.REPORTS_PAYMENT_METHODS_REQUEST, getPaymentMethodsFlow);

        case 17:
          getPaymentMethodsTask = _context58.sent;
          _context58.next = 20;
          return (0, _effects.takeLatest)(_constants.REPORTS_ITEM_SALES_PAGE_REQUEST, itemSalesPageRequestFlow);

        case 20:
          itemSalesPageReqTask = _context58.sent;
          _context58.next = 23;
          return (0, _effects.takeLatest)(_constants.REPORTS_ITEM_SALES_REQUEST, getItemSalesFlow);

        case 23:
          itemSalesReqTask = _context58.sent;
          _context58.next = 26;
          return (0, _effects.takeLatest)(_constants.REPORTS_CATEGORY_SALES_PAGE_REQUEST, categorySalesPageRequestFlow);

        case 26:
          categorySalesPageReqTask = _context58.sent;
          _context58.next = 29;
          return (0, _effects.takeLatest)(_constants.REPORTS_CATEGORY_SALES_REQUEST, getCategorySalesFlow);

        case 29:
          getCategorySalesTask = _context58.sent;
          _context58.next = 32;
          return (0, _effects.takeLatest)(_constants.REPORTS_MODIFIER_SALES_PAGE_REQUEST, modifierSalesPageRequestFlow);

        case 32:
          modifierSalesPageReqTask = _context58.sent;
          _context58.next = 35;
          return (0, _effects.takeLatest)(_constants.REPORTS_MODIFIER_SALES_REQUEST, getModifierSalesFlow);

        case 35:
          modifierSalesReqTask = _context58.sent;
          _context58.next = 38;
          return (0, _effects.takeLatest)(_constants.REPORTS_DISCOUNTS_PAGE_REQUEST, discountsPageRequestFlow);

        case 38:
          discountPageReqTask = _context58.sent;
          _context58.next = 41;
          return (0, _effects.takeLatest)(_constants.REPORTS_DISCOUNTS_REQUEST, getDiscountsFlow);

        case 41:
          discountReqTask = _context58.sent;
          _context58.next = 44;
          return (0, _effects.takeLatest)(_constants.REPORTS_TAXES_PAGE_REQUEST, taxesPageRequestFlow);

        case 44:
          taxPagReqTask = _context58.sent;
          _context58.next = 47;
          return (0, _effects.takeLatest)(_constants.REPORTS_TAXES_REQUEST, getTaxesFlow);

        case 47:
          taxReqTask = _context58.sent;
          _context58.next = 50;
          return (0, _effects.takeLatest)(_constants.REPORTS_GRATUITY_PAGE_REQUEST, gratuityPageRequestFlow);

        case 50:
          gratuityPagReqTask = _context58.sent;
          _context58.next = 53;
          return (0, _effects.takeLatest)(_constants.REPORTS_GRATUITY_REQUEST, getGratuitiesFlow);

        case 53:
          gratuityReqTask = _context58.sent;
          _context58.next = 56;
          return (0, _effects.takeLatest)(_constants.REPORTS_COLLECTEDBY_PAGE_REQUEST, collectedByPageRequestFlow);

        case 56:
          collectedByPageReqTask = _context58.sent;
          _context58.next = 59;
          return (0, _effects.takeLatest)(_constants.REPORTS_COLLECTEDBY_REQUEST, getStaffsFlow);

        case 59:
          collectedByReqTask = _context58.sent;
          _context58.next = 62;
          return (0, _effects.takeLatest)(_constants.REPORTS_SERVEDBY_PAGE_REQUEST, servedByPageRequestFlow);

        case 62:
          servedByPageReqTask = _context58.sent;
          _context58.next = 65;
          return (0, _effects.takeLatest)(_constants.REPORTS_SERVEDBY_REQUEST, getServersFlow);

        case 65:
          servedByReqTask = _context58.sent;
          _context58.next = 68;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_SUMMARY_CHANGE_DATE, changeDateSalesSummaryFlow);

        case 68:
          changeDateSalesSummaryTask = _context58.sent;
          _context58.next = 71;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE, changeDateGrossProfitFlow);

        case 71:
          changeDateGrossProfitTask = _context58.sent;
          _context58.next = 74;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE, changeDatePaymentMethodsFlow);

        case 74:
          changeDatePaymentMethodsTask = _context58.sent;
          _context58.next = 77;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_ITEM_SALES_CHANGE_DATE, changeDateItemSalesFlow);

        case 77:
          changeDateItemSalesTask = _context58.sent;
          _context58.next = 80;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE, changeDateCategorySalesFlow);

        case 80:
          changeDateCategorySalesTask = _context58.sent;
          _context58.next = 83;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE, changeDateModifierSalesFlow);

        case 83:
          changeDateModifierSalesTask = _context58.sent;
          _context58.next = 86;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_DISCOUNTS_CHANGE_DATE, changeDateDiscountsFlow);

        case 86:
          changeDateDiscountTask = _context58.sent;
          _context58.next = 89;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_TAXES_CHANGE_DATE, changeDateTaxesFlow);

        case 89:
          changeDateTaxTask = _context58.sent;
          _context58.next = 92;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_GRATUITY_CHANGE_DATE, changeDateGratuityFlow);

        case 92:
          changeDateGratuityTask = _context58.sent;
          _context58.next = 95;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_COLLECTEDBY_CHANGE_DATE, changeDateCollectedByFlow);

        case 95:
          changeDateCollectedByTask = _context58.sent;
          _context58.next = 98;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_SERVEDBY_CHANGE_DATE, changeDateServedByFlow);

        case 98:
          changeDateServedByTask = _context58.sent;
          _context58.next = 101;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_SUMMARY_CHANGE_OUTLET, changeOutletSalesSummaryFlow);

        case 101:
          changeOutletSalesSummaryTask = _context58.sent;
          _context58.next = 104;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET, changeOutletGrossProfitFlow);

        case 104:
          changeOutletGrossProfitTask = _context58.sent;
          _context58.next = 107;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET, changeOutletPaymentMethodsFlow);

        case 107:
          changeOutletPaymentMethodsTask = _context58.sent;
          _context58.next = 110;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET, changeOutletItemSalesFlow);

        case 110:
          changeOutletItemSalesTask = _context58.sent;
          _context58.next = 113;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET, changeOutletCategorySalesFlow);

        case 113:
          changeOutletCategorySalesTask = _context58.sent;
          _context58.next = 116;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET, changeOutletModifierSalesFlow);

        case 116:
          changeOutletModifierSalesTask = _context58.sent;
          _context58.next = 119;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET, changeOutletDiscountsFlow);

        case 119:
          changeOutletDiscountTask = _context58.sent;
          _context58.next = 122;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_TAXES_CHANGE_OUTLET, changeOutletTaxesFlow);

        case 122:
          changeOutletTaxTask = _context58.sent;
          _context58.next = 125;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_GRATUITY_CHANGE_OUTLET, changeOutletGratuityFlow);

        case 125:
          changeOutletGratuityTask = _context58.sent;
          _context58.next = 128;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET, changeOutletCollectedByFlow);

        case 128:
          changeOutletCollectedByTask = _context58.sent;
          _context58.next = 131;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_SERVEDBY_CHANGE_OUTLET, changeOutletServedByFlow);

        case 131:
          changeOutletServedByTask = _context58.sent;
          _context58.next = 134;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_SUMMARY, exportSummaryFlow);

        case 134:
          exportSummaryTask = _context58.sent;
          _context58.next = 137;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_GROSS_PROFIT, exportGrossProfitFlow);

        case 137:
          exportGrossProfitTask = _context58.sent;
          _context58.next = 140;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_PAYMENT_METHODS, exportPaymentMethodsFlow);

        case 140:
          exportPaymentMethodTask = _context58.sent;
          _context58.next = 143;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_ITEM_SALES, exportItemSalesFlow);

        case 143:
          exportItemSalesTask = _context58.sent;
          _context58.next = 146;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_CATEGORY_SALES, exportCategorySalesFlow);

        case 146:
          exportCategorySalesTask = _context58.sent;
          _context58.next = 149;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_MODIFIER_SALES, exportModifierSalesFlow);

        case 149:
          exportModifierSalesTask = _context58.sent;
          _context58.next = 152;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_DISCOUNTS, exportDiscountFlow);

        case 152:
          exportDiscountsTask = _context58.sent;
          _context58.next = 155;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_TAXES, exportTaxesFlow);

        case 155:
          exportTaxesTask = _context58.sent;
          _context58.next = 158;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_GRATUITY, exportGratuityFlow);

        case 158:
          exportGratuityTask = _context58.sent;
          _context58.next = 161;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_COLECTEDBY, exportColectedByFlow);

        case 161:
          exportCollectedByTask = _context58.sent;
          _context58.next = 164;
          return (0, _effects.takeLatest)(_constants.REPORTS_SALES_EXPORT_SERVEDBY, exportServedByFlow);

        case 164:
          exportServedByTask = _context58.sent;
          _context58.next = 167;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [pageRequestTask, getSalesSummaryTask, grossProfitPageRequestTask, getSalesGrossProfitTask, getPaymentMethodsTask, paymentMethodsPageRequestTask, itemSalesPageReqTask, itemSalesReqTask, categorySalesPageReqTask, getCategorySalesTask, modifierSalesPageReqTask, modifierSalesReqTask, discountPageReqTask, discountReqTask, taxPagReqTask, taxReqTask, gratuityPagReqTask, gratuityReqTask, collectedByPageReqTask, collectedByReqTask, servedByPageReqTask, servedByReqTask, changeDateSalesSummaryTask, changeDateGrossProfitTask, changeDatePaymentMethodsTask, changeDateItemSalesTask, changeDateCategorySalesTask, changeDateModifierSalesTask, changeDateDiscountTask, changeDateGratuityTask, changeDateTaxTask, changeDateCollectedByTask, changeDateServedByTask, changeOutletSalesSummaryTask, changeOutletGrossProfitTask, changeOutletPaymentMethodsTask, changeOutletItemSalesTask, changeOutletCategorySalesTask, changeOutletModifierSalesTask, changeOutletDiscountTask, changeOutletTaxTask, changeOutletGratuityTask, changeOutletCollectedByTask, changeOutletServedByTask, exportSummaryTask, exportGrossProfitTask, exportPaymentMethodTask, exportItemSalesTask, exportCategorySalesTask, exportModifierSalesTask, exportDiscountsTask, exportTaxesTask, exportGratuityTask, exportCollectedByTask, exportServedByTask]);

        case 167:
        case 'end':
          return _context58.stop();
      }
    }
  }, _marked[57], this);
}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequestFlow = pageRequestFlow;
exports.changeOutletShift = changeOutletShift;
exports.changeDateFlow = changeDateFlow;
exports.shiftSummaryRequestFlow = shiftSummaryRequestFlow;
exports.listShiftRequestFlow = listShiftRequestFlow;
exports.getShiftDetailFlow = getShiftDetailFlow;
exports.getMoreShiftData = getMoreShiftData;
exports.hideShiftDetailFlow = hideShiftDetailFlow;
exports.exportShiftsFlow = exportShiftsFlow;
exports.cancelAction = cancelAction;
exports.default = reportsShiftsSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(416);

var _constants2 = __webpack_require__(91);

var _login = __webpack_require__(250);

var _getFilteredDate = __webpack_require__(249);

var _outlet = __webpack_require__(235);

var _profile = __webpack_require__(114);

var _shifts = __webpack_require__(1600);

var _shifts2 = __webpack_require__(417);

var _getExportedFile = __webpack_require__(92);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _actionBar = __webpack_require__(80);

var actActionBar = _interopRequireWildcard(_actionBar);

var _loadingSpinner = __webpack_require__(46);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _shifts3 = __webpack_require__(666);

var mpReportsShifts = _interopRequireWildcard(_shifts3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getShiftSummaryAndShiftList, initForm, pageRequestFlow, changeOutletShift, changeDateFlow, shiftSummaryRequestFlow, listShiftRequestFlow, getShiftDetailFlow, getMoreShiftData, hideShiftDetailFlow, exportShiftsFlow, cancelAction, reportsShiftsSaga].map(_regenerator2.default.mark);

function getShiftSummaryAndShiftList(responseProfile, startDateFormatted, endDateFormatted) {
  return _regenerator2.default.wrap(function getShiftSummaryAndShiftList$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(responseProfile));

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _shifts2.listShiftRequest)({ page: 1, start: startDateFormatted, end: endDateFormatted }));

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _shifts2.shiftSummaryRequest)({ start: startDateFormatted, end: endDateFormatted }));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function initForm(outlet, startDate, endDate) {
  return _regenerator2.default.wrap(function initForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', { outlet: outlet, date: { startDate: startDate, endDate: endDate } }));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/**
 * Page flow
 */
function pageRequestFlow(request) {
  var filteredDate, startDate, endDate, startDateFormatted, endDateFormatted, responseProfile, resOutlet;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _shifts2.setShifts)([]));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)((0, _shifts2.setSummary)({}));

        case 6:
          _context3.next = 8;
          return (0, _effects.put)((0, _shifts2.setCurrentPage)(0));

        case 8:
          _context3.prev = 8;
          _context3.next = 11;
          return (0, _effects.put)((0, _shifts2.setShiftDetails)(null));

        case 11:
          _context3.next = 13;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 13:
          filteredDate = _context3.sent;
          startDate = (0, _moment2.default)(filteredDate.start_date, 'YYYY-MM-DD');
          endDate = (0, _moment2.default)(filteredDate.end_date, 'YYYY-MM-DD');
          // yield put(setDate(startDate, endDate))

          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          // get profile and set it to dropdown outlet

          _context3.next = 20;
          return (0, _effects.call)(_profile.getProfile);

        case 20:
          responseProfile = _context3.sent;
          _context3.next = 23;
          return (0, _effects.call)(getShiftSummaryAndShiftList, responseProfile, startDateFormatted, endDateFormatted);

        case 23:
          _context3.next = 25;
          return (0, _effects.call)(apiOutlet.outlets);

        case 25:
          resOutlet = _context3.sent;
          _context3.next = 28;
          return (0, _effects.put)((0, _shifts2.setOutlets)(resOutlet.data));

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlet.data));

        case 30:
          _context3.next = 32;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(responseProfile.outlet_id));

        case 32:
          _context3.next = 34;
          return (0, _effects.call)(initForm, responseProfile.outlet_id, startDate, endDate);

        case 34:
          mpReportsShifts.reportsShiftsStart({
            outletIds: responseProfile.outlet_id,
            startDate: startDate,
            endDate: endDate
          });
          _context3.next = 39;
          break;

        case 37:
          _context3.prev = 37;
          _context3.t0 = _context3['catch'](8);

        case 39:
          _context3.prev = 39;
          return _context3.finish(39);

        case 41:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[8, 37, 39, 41]]);
}

function changeOutletShift(request) {
  var _request$payload, outletIds, startDate, endDate, isMobile, startDateFormatted, endDateFormatted, responseProfile;

  return _regenerator2.default.wrap(function changeOutletShift$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _shifts2.setShifts)([]));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _shifts2.setSummary)({}));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload = request.payload, outletIds = _request$payload.outletIds, startDate = _request$payload.startDate, endDate = _request$payload.endDate, isMobile = _request$payload.isMobile;
          _context4.next = 9;
          return (0, _effects.put)((0, _shifts2.hideShiftDetail)(isMobile));

        case 9:
          _context4.next = 11;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 11:
          _context4.next = 13;
          return (0, _effects.call)(initForm, outletIds, startDate, endDate);

        case 13:
          _context4.next = 15;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(outletIds));

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context4.next = 19;
          return (0, _effects.call)(_profile.getProfile);

        case 19:
          responseProfile = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(getShiftSummaryAndShiftList, responseProfile, startDateFormatted, endDateFormatted);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function changeDateFlow(request) {
  var _request$payload2, startDate, endDate, isMobile, startDateFormatted, endDateFormatted;

  return _regenerator2.default.wrap(function changeDateFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)((0, _shifts2.setShifts)([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _shifts2.setSummary)({}));

        case 4:
          _context5.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload2 = request.payload, startDate = _request$payload2.startDate, endDate = _request$payload2.endDate, isMobile = _request$payload2.isMobile;
          _context5.next = 9;
          return (0, _effects.put)((0, _shifts2.hideShiftDetail)(isMobile));

        case 9:
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context5.next = 13;
          return (0, _effects.put)((0, _shifts2.shiftSummaryRequest)({ start: startDateFormatted, end: endDateFormatted }));

        case 13:
          _context5.next = 15;
          return (0, _effects.put)((0, _shifts2.listShiftRequest)({ page: 0, start: startDateFormatted, end: endDateFormatted }));

        case 15:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

/***********************************
 * API CALL
 ***********************************/
function shiftSummaryRequestFlow(request) {
  var query, summary;
  return _regenerator2.default.wrap(function shiftSummaryRequestFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          query = request.payload.query;
          _context6.next = 3;
          return (0, _effects.call)(_shifts.getSummary, query);

        case 3:
          summary = _context6.sent;

          if (!summary) {
            _context6.next = 7;
            break;
          }

          _context6.next = 7;
          return (0, _effects.put)((0, _shifts2.setSummary)(summary));

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function listShiftRequestFlow(request) {
  var query, shifts;
  return _regenerator2.default.wrap(function listShiftRequestFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          query = request.payload.query;
          _context7.next = 5;
          return (0, _effects.call)(_shifts.getShifts, query);

        case 5:
          shifts = _context7.sent;

          if (!shifts) {
            _context7.next = 11;
            break;
          }

          _context7.next = 9;
          return (0, _effects.put)((0, _shifts2.setShifts)(shifts));

        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _shifts2.setCurrentPage)(query.page));

        case 11:
          _context7.next = 13;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function getShiftDetailFlow(request) {
  var _request$payload3, query, isMobile, shiftDetails;

  return _regenerator2.default.wrap(function getShiftDetailFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload3 = request.payload, query = _request$payload3.query, isMobile = _request$payload3.isMobile;
          _context8.next = 3;
          return (0, _effects.call)(_shifts.getShiftDetails, query);

        case 3:
          shiftDetails = _context8.sent;

          mpReportsShifts.reportsShiftsSelect({ shift: shiftDetails });

          if (!shiftDetails) {
            _context8.next = 9;
            break;
          }

          _context8.next = 8;
          return (0, _effects.put)((0, _shifts2.setShiftDetails)(shiftDetails));

        case 8:
          if (!isMobile) {
            if ($('#mk-col-left').hasClass('col-md-12')) {
              $('#mk-col-left').removeClass('col-md-12').addClass('col-md-6');
              $('#mk-col-right').removeClass('col-md-12').addClass('col-md-6');
              setTimeout(function () {
                $('#mk-col-right').show();
                $('[data-toggle="popover"]').popover();
              }, 300);
            }
          }

        case 9:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function getMoreShiftData(params) {
  var previousShift, _params$payload$query, endDate, page, startDate, startdate, enddate, query, shifts, newShifts;

  return _regenerator2.default.wrap(function getMoreShiftData$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          previousShift = params.payload.previousShift;
          _params$payload$query = params.payload.query, endDate = _params$payload$query.endDate, page = _params$payload$query.page, startDate = _params$payload$query.startDate;
          startdate = (0, _moment2.default)(startDate).format('DD/MM/YYYY');
          enddate = (0, _moment2.default)(endDate).format('DD/MM/YYYY');
          query = {
            page: page,
            start: startdate,
            end: enddate
          };
          _context9.prev = 5;
          _context9.next = 8;
          return (0, _effects.put)(action.showProgressBar());

        case 8:
          _context9.next = 10;
          return (0, _effects.call)(_shifts.getShifts, query);

        case 10:
          shifts = _context9.sent;
          newShifts = previousShift.concat(shifts);
          _context9.next = 14;
          return (0, _effects.put)((0, _shifts2.setShifts)(newShifts));

        case 14:
          _context9.next = 16;
          return (0, _effects.put)((0, _shifts2.setCurrentPage)(page));

        case 16:
          _context9.next = 20;
          break;

        case 18:
          _context9.prev = 18;
          _context9.t0 = _context9['catch'](5);

        case 20:
          _context9.prev = 20;
          _context9.next = 23;
          return (0, _effects.put)(action.hideProgressBar());

        case 23:
          _context9.next = 25;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 25:
          return _context9.finish(20);

        case 26:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[5, 18, 20, 26]]);
}

function hideShiftDetailFlow(request) {
  var isMobile;
  return _regenerator2.default.wrap(function hideShiftDetailFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          isMobile = request.payload.isMobile;
          _context10.next = 3;
          return (0, _effects.put)((0, _shifts2.setShiftDetails)(null));

        case 3:
          if (!isMobile) {
            // animation
            $('#mk-col-right').hide();
            $('#mk-col-left').removeClass('col-md-6').addClass('col-md-12');
          }

        case 4:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function exportShiftsFlow(request) {
  var _request$payload4, query, filename, outletId, data;

  return _regenerator2.default.wrap(function exportShiftsFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload4 = request.payload, query = _request$payload4.query, filename = _request$payload4.filename, outletId = _request$payload4.outletId;
          _context11.next = 3;
          return (0, _effects.call)(_shifts.exportShift, query);

        case 3:
          data = _context11.sent;

          if (!(data && data.message === 'ok')) {
            _context11.next = 7;
            break;
          }

          _context11.next = 7;
          return (0, _effects.put)((0, _getExportedFile.getExportedFile)(filename, outletId, 'shifts'));

        case 7:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function reportsShiftsSaga() {
  var summaryTask, listShiftTask, pageReqTask, changeDateTask, exportShiftTask, getShiftDetailTask, changeOutletTask, hideShiftDetailTask, moreShiftData;
  return _regenerator2.default.wrap(function reportsShiftsSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST, shiftSummaryRequestFlow);

        case 2:
          summaryTask = _context13.sent;
          _context13.next = 5;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_LIST_SHIFT_REQUEST, listShiftRequestFlow);

        case 5:
          listShiftTask = _context13.sent;
          _context13.next = 8;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_PAGE_REQUEST, pageRequestFlow);

        case 8:
          pageReqTask = _context13.sent;
          _context13.next = 11;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_CHANGE_DATE, changeDateFlow);

        case 11:
          changeDateTask = _context13.sent;
          _context13.next = 14;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST, exportShiftsFlow);

        case 14:
          exportShiftTask = _context13.sent;
          _context13.next = 17;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_DETAILS_REQUEST, getShiftDetailFlow);

        case 17:
          getShiftDetailTask = _context13.sent;
          _context13.next = 20;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_CHANGE_OUTLET, changeOutletShift);

        case 20:
          changeOutletTask = _context13.sent;
          _context13.next = 23;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_DETAIL_HIDE, hideShiftDetailFlow);

        case 23:
          hideShiftDetailTask = _context13.sent;
          _context13.next = 26;
          return (0, _effects.takeLatest)(_constants.REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA, getMoreShiftData);

        case 26:
          moreShiftData = _context13.sent;
          _context13.next = 29;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [summaryTask, listShiftTask, pageReqTask, changeOutletTask, changeDateTask, exportShiftTask, getShiftDetailTask, hideShiftDetailTask, moreShiftData]);

        case 29:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequestFlow = pageRequestFlow;
exports.transactionsFlow = transactionsFlow;
exports.issueRefundFlow = issueRefundFlow;
exports.askSetQuantity = askSetQuantity;
exports.confirmSetQuantity = confirmSetQuantity;
exports.cancelSetQuantity = cancelSetQuantity;
exports.issueOldRefundFlow = issueOldRefundFlow;
exports.changeOutletFlow = changeOutletFlow;
exports.changeDateFlow = changeDateFlow;
exports.changeKeywordFlow = changeKeywordFlow;
exports.transactionDetailMobileFlow = transactionDetailMobileFlow;
exports.transactionDetailNonMobileFlow = transactionDetailNonMobileFlow;
exports.hideTransactionDetailFlow = hideTransactionDetailFlow;
exports.exportTransactionFlow = exportTransactionFlow;
exports.sendEmailReceiptFlow = sendEmailReceiptFlow;
exports.cancelResendEmail = cancelResendEmail;
exports.cancelRefundBreakdown = cancelRefundBreakdown;
exports.cancelAction = cancelAction;
exports.default = reportsTransactionsSaga;

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _constants = __webpack_require__(418);

var _constants2 = __webpack_require__(91);

var _actions = __webpack_require__(18);

var _getFilteredDate = __webpack_require__(249);

var _report = __webpack_require__(677);

var _profile = __webpack_require__(114);

var _outlet = __webpack_require__(235);

var _transactions = __webpack_require__(128);

var _refunds = __webpack_require__(676);

var _login = __webpack_require__(250);

var _emailReceipt = __webpack_require__(1074);

var _reports = __webpack_require__(434);

var apiReport = _interopRequireWildcard(_reports);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _actionBar = __webpack_require__(80);

var actActionBar = _interopRequireWildcard(_actionBar);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _reduxForm = __webpack_require__(7);

var _loadingSpinner = __webpack_require__(46);

var _transactions2 = __webpack_require__(298);

var mpReportTransactions = _interopRequireWildcard(_transactions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initForm, initResendEmailForm, pageRequestFlow, transactionsFlow, issueRefundFlow, askSetQuantity, confirmSetQuantity, cancelSetQuantity, issueOldRefundFlow, changeOutletFlow, changeDateFlow, changeKeywordFlow, transactionDetailMobileFlow, transactionDetailNonMobileFlow, hideTransactionDetailFlow, exportTransactionFlow, sendEmailReceiptFlow, cancelResendEmail, cancelRefundBreakdown, cancelAction, reportsTransactionsSaga].map(_regenerator2.default.mark);

function initForm(outletIds, startDate, endDate) {
  return _regenerator2.default.wrap(function initForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', { outlet: outletIds, date: { startDate: startDate, endDate: endDate } }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function initResendEmailForm(transactionDetail) {
  return _regenerator2.default.wrap(function initResendEmailForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('resendEmailForm', { email: transactionDetail.email }));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function extractForRefundBreakdown(transactionDetail) {
  // extract for refund breakdown
  var refundAvailabilities = transactionDetail.refund_availability;
  var refundItems = [];
  refundAvailabilities.forEach(function (refundAvailability) {
    // set necessary data for refund breakdown
    refundItems.push({
      categoryId: refundAvailability.category_id,
      categoryName: refundAvailability.category_name,
      discountPerItem: refundAvailability.discount_per_item,
      redemptionPerItem: refundAvailability.redemption_per_item,
      discounts: refundAvailability.discounts,
      itemId: refundAvailability.item_id,
      itemName: refundAvailability.item_name,
      itemImage: refundAvailability.item_image,
      itemVariantId: refundAvailability.item_variant_id,
      itemVariantName: refundAvailability.item_variant_name,
      itemVariantSku: refundAvailability.item_variant_sku,
      gratuityPerItem: refundAvailability.gratuity_per_item,
      grossPerItem: refundAvailability.gross_per_item,
      modifiers: refundAvailability.modifiers,
      taxPerItem: refundAvailability.tax_per_item,
      trackStock: refundAvailability.track_stock,
      parentCheckoutId: refundAvailability.parent_checkout_id,
      pricePerItem: refundAvailability.price_per_item,
      netPerItem: refundAvailability.net_per_item,
      position: refundAvailability.position,
      // max quantity is maximum amount that can be refunded
      maxQuantity: refundAvailability.quantity,
      // is refunded is whether the item is included as refunded item.
      // if 0, it can't be refunded and must be excluded
      isRefunded: refundAvailability.quantity > 0,
      // default value is quantity if can be refunded
      refundAmount: refundAvailability.quantity > 0 ? refundAvailability.quantity : 0
    });
  });
  return refundItems;
}
/********************************************************************************
 * Transactions
 ********************************************************************************/

function pageRequestFlow(request) {
  var profile, resOutlets, _ref, startDate, endDate, formattedStartDate, formattedEndDate;

  return _regenerator2.default.wrap(function pageRequestFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _transactions.setTransactions)({
            transactions: null,
            netSales: null,
            totalCollected: null,
            totalTransactions: null
          }));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.put)((0, _transactions.setTransactionDetail)(null));

        case 7:
          _context3.next = 9;
          return (0, _effects.call)(_profile.getProfile);

        case 9:
          profile = _context3.sent;
          _context3.next = 12;
          return (0, _effects.put)(actActionBar.setSelectedOutletIds(profile.outlet_id));

        case 12:
          _context3.next = 14;
          return (0, _effects.call)(apiOutlet.outlets);

        case 14:
          resOutlets = _context3.sent;
          _context3.next = 17;
          return (0, _effects.put)((0, _transactions.setOutlets)(resOutlets.data));

        case 17:
          _context3.next = 19;
          return (0, _effects.put)(actActionBar.setOutlets(resOutlets.data));

        case 19:
          _context3.next = 21;
          return (0, _effects.call)(_getFilteredDate.getFilteredDateAsMoment);

        case 21:
          _ref = _context3.sent;
          startDate = _ref.startDate;
          endDate = _ref.endDate;
          formattedStartDate = startDate.format('D/M/YYYY');
          formattedEndDate = endDate.format('D/M/YYYY');
          _context3.next = 28;
          return (0, _effects.call)(initForm, profile.outlet_id, startDate, endDate);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)((0, _transactions.getTransactionsRequest)({ start: formattedStartDate, end: formattedEndDate }));

        case 30:

          mpReportTransactions.reportsTransactionsStart({
            outletIds: profile.outlet_id,
            startDate: startDate,
            endDate: endDate
          });
          // animate scroll to top
          $('#transaction-table-list').animate({ scrollTop: 0 }, 'slow');
          _context3.next = 36;
          break;

        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3['catch'](4);

        case 36:
          _context3.prev = 36;
          return _context3.finish(36);

        case 38:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 34, 36, 38]]);
}

function transactionsFlow(request) {
  var query, result;
  return _regenerator2.default.wrap(function transactionsFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          query = request.payload.query;
          _context4.next = 5;
          return (0, _effects.call)(_report.getTransactions, query);

        case 5:
          result = _context4.sent;

          if (!result) {
            _context4.next = 9;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)((0, _transactions.setTransactions)({
            transactions: result.transactions,
            netSales: result.net_sales,
            totalCollected: result.total_collected,
            totalTransactions: result.total_transactions
          }));

        case 9:
          _context4.next = 11;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/********************************************************************************
 * End Transactions
 ********************************************************************************/

/********************************************************************************
 * Refund Breakdown
 ********************************************************************************/

function issueRefundFlow(request) {
  var data;
  return _regenerator2.default.wrap(function issueRefundFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          data = request.payload.data;
          _context5.next = 3;
          return (0, _effects.call)(_refunds.postRefund, data);

        case 3:
          _context5.next = 5;
          return (0, _effects.put)((0, _transactions.hideRefundBreakdownModal)());

        case 5:
          _context5.next = 7;
          return (0, _effects.put)((0, _transactions.hideTransactionDetailModal)());

        case 7:
          _context5.next = 9;
          return (0, _effects.put)((0, _transactions.hideTransactionDetail)());

        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _transactions.pageRequest)());

        case 11:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function askSetQuantity(request) {
  var _request$payload, refundItemsIdx, refundAmount;

  return _regenerator2.default.wrap(function askSetQuantity$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _request$payload = request.payload, refundItemsIdx = _request$payload.refundItemsIdx, refundAmount = _request$payload.refundAmount;
          _context6.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('setQuantity', {
            idx: refundItemsIdx,
            quantity: refundAmount
          }));

        case 3:
          _context6.next = 5;
          return (0, _effects.put)((0, _transactions.showSetQuantityModal)());

        case 5:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function confirmSetQuantity(request) {
  var refundItems;
  return _regenerator2.default.wrap(function confirmSetQuantity$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          refundItems = request.payload.refundItems;
          _context7.next = 3;
          return (0, _effects.put)((0, _transactions.setRefundItems)(refundItems));

        case 3:
          _context7.next = 5;
          return (0, _effects.put)((0, _transactions.hideSetQuantityModal)());

        case 5:
          _context7.next = 7;
          return (0, _effects.put)((0, _reduxForm.initialize)('setQuantity', { idx: null, quantity: null }));

        case 7:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function cancelSetQuantity(request) {
  return _regenerator2.default.wrap(function cancelSetQuantity$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)((0, _transactions.hideSetQuantityModal)());

        case 2:
          _context8.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('setQuantity', { idx: null, quantity: null }));

        case 4:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

/********************************************************************************
 * End Refund Breakdown
 ********************************************************************************/

/********************************************************************************
 * Old Refund
 ********************************************************************************/

function issueOldRefundFlow(request) {
  var data;
  return _regenerator2.default.wrap(function issueOldRefundFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          data = request.payload.data;
          _context9.next = 3;
          return (0, _effects.call)(_refunds.postOldRefund, data);

        case 3:
          _context9.next = 5;
          return (0, _effects.put)((0, _transactions.hideOldRefundModal)());

        case 5:
          _context9.next = 7;
          return (0, _effects.put)((0, _transactions.hideTransactionDetailModal)());

        case 7:
          _context9.next = 9;
          return (0, _effects.put)((0, _transactions.hideTransactionDetail)());

        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _transactions.pageRequest)());

        case 11:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

/********************************************************************************
 * End Old Refund
 ********************************************************************************/

/********************************************************************************
 * Change Handler
 ********************************************************************************/

function changeOutletFlow(request) {
  var outletIds, currentOutlet, _ref2, startDate, endDate, formattedStartDate, formattedEndDate;

  return _regenerator2.default.wrap(function changeOutletFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)((0, _transactions.setTransactions)({
            transactions: null,
            netSales: null,
            totalCollected: null,
            totalTransactions: null
          }));

        case 2:
          _context10.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context10.next = 6;
          return (0, _effects.put)((0, _transactions.hideTransactionDetail)());

        case 6:
          outletIds = request.payload.outletIds;
          _context10.next = 9;
          return (0, _effects.call)(_login.loginOutlet, { id: outletIds });

        case 9:
          _context10.next = 11;
          return (0, _effects.call)(_profile.getProfile);

        case 11:
          currentOutlet = _context10.sent;
          _context10.next = 14;
          return (0, _effects.put)((0, _outlet.setCurrentOutlet)(currentOutlet));

        case 14:
          _context10.next = 16;
          return (0, _effects.call)(_getFilteredDate.getFilteredDateAsMoment);

        case 16:
          _ref2 = _context10.sent;
          startDate = _ref2.startDate;
          endDate = _ref2.endDate;
          _context10.next = 21;
          return (0, _effects.call)(initForm, outletIds, startDate, endDate);

        case 21:
          formattedStartDate = startDate.format('D/M/YYYY');
          formattedEndDate = endDate.format('D/M/YYYY');
          _context10.next = 25;
          return (0, _effects.put)((0, _transactions.getTransactionsRequest)({ start: formattedStartDate, end: formattedEndDate }));

        case 25:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function changeDateFlow(request) {
  var _request$payload2, startDate, endDate, formattedStartDate, formattedEndDate;

  return _regenerator2.default.wrap(function changeDateFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)((0, _transactions.setTransactions)({
            transactions: null,
            netSales: null,
            totalCollected: null,
            totalTransactions: null
          }));

        case 2:
          _context11.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context11.next = 6;
          return (0, _effects.put)((0, _transactions.hideTransactionDetail)());

        case 6:
          _request$payload2 = request.payload, startDate = _request$payload2.startDate, endDate = _request$payload2.endDate;
          formattedStartDate = startDate.format('D/M/YYYY');
          formattedEndDate = endDate.format('D/M/YYYY');
          _context11.next = 11;
          return (0, _effects.put)((0, _transactions.getTransactionsRequest)({ start: formattedStartDate, end: formattedEndDate }));

        case 11:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function changeKeywordFlow(request) {
  var _request$payload3, keyword, startDate, endDate, filterTotalTransactions, filterTotalCollected, filterNetSales, filterResult, formattedStartDate, formattedEndDate, transRes, query, data, regexTransaction, ts;

  return _regenerator2.default.wrap(function changeKeywordFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)((0, _transactions.setTransactions)({
            transactions: null,
            netSales: null,
            totalCollected: null,
            totalTransactions: null
          }));

        case 2:
          _context12.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context12.next = 6;
          return (0, _effects.put)((0, _transactions.hideTransactionDetail)());

        case 6:
          _request$payload3 = request.payload, keyword = _request$payload3.keyword, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate;
          filterTotalTransactions = 0;
          filterTotalCollected = 0;
          filterNetSales = 0;
          filterResult = [];
          formattedStartDate = startDate.format('D/M/YYYY');
          formattedEndDate = endDate.format('D/M/YYYY');
          transRes = void 0;
          _context12.next = 16;
          return (0, _reduxSaga.delay)(300, true);

        case 16:
          _context12.prev = 16;
          _context12.next = 19;
          return (0, _effects.put)((0, _actions.showProgressBar)());

        case 19:
          query = { start: formattedStartDate, end: formattedEndDate };
          _context12.next = 22;
          return (0, _effects.call)(apiReport.getTransactions, query);

        case 22:
          transRes = _context12.sent;
          _context12.next = 29;
          break;

        case 25:
          _context12.prev = 25;
          _context12.t0 = _context12['catch'](16);
          _context12.next = 29;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 29:
          _context12.prev = 29;
          _context12.next = 32;
          return (0, _effects.put)((0, _actions.hideProgressBar)());

        case 32:
          return _context12.finish(29);

        case 33:
          if (!transRes.data) {
            _context12.next = 40;
            break;
          }

          data = transRes.data;
          regexTransaction = new RegExp(keyword, 'i');


          data.transactions.forEach(function (transPayment) {
            var paymentArray = [];
            var perDateTotalCollected = 0;

            transPayment.payments.forEach(function (transaction) {
              if (transaction.payment_no.match(regexTransaction)) {
                if (!transaction.is_refunded) {
                  filterTotalTransactions += 1;
                }
                perDateTotalCollected += transaction.total_collected_report;
                filterNetSales += transaction.net_sales_report;
                paymentArray.push(transaction);
              }
            });

            if (paymentArray.length > 0) {
              filterTotalCollected += perDateTotalCollected;
              var trxPerDate = { date_label: transPayment.date_label, total_collected: perDateTotalCollected, payments: paymentArray };
              filterResult.push(trxPerDate);
            }
          });
          ts = {
            transactions: filterResult,
            totalTransactions: filterTotalTransactions,
            totalCollected: filterTotalCollected,
            netSales: filterNetSales
          };
          _context12.next = 40;
          return (0, _effects.put)((0, _transactions.setTransactions)(ts));

        case 40:
          _context12.next = 42;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 42:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[16, 25, 29, 33]]);
}
/********************************************************************************
 * End Change Handler
 ********************************************************************************/

/********************************************************************************
 * Transaction Detail Flow
 ********************************************************************************/
function transactionDetailMobileFlow(request) {
  var id, transactionDetail, refundItems;
  return _regenerator2.default.wrap(function transactionDetailMobileFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          id = request.payload.id;
          _context13.next = 3;
          return (0, _effects.call)(_report.getTransactionDetail, id);

        case 3:
          transactionDetail = _context13.sent;

          mpReportTransactions.reportsTransactionsSelect({
            transactionDetail: transactionDetail
          });
          _context13.next = 7;
          return (0, _effects.put)((0, _transactions.setTransactionDetail)(transactionDetail));

        case 7:
          _context13.next = 9;
          return (0, _effects.call)(initResendEmailForm, transactionDetail);

        case 9:
          refundItems = extractForRefundBreakdown(transactionDetail);
          _context13.next = 12;
          return (0, _effects.put)((0, _transactions.setRefundItems)(refundItems));

        case 12:
          _context13.next = 14;
          return (0, _effects.put)((0, _transactions.showTransactionDetailModal)());

        case 14:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function transactionDetailNonMobileFlow(request) {
  var id, transactionDetail, refundItems;
  return _regenerator2.default.wrap(function transactionDetailNonMobileFlow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          id = request.payload.id;
          _context14.next = 3;
          return (0, _effects.call)(_report.getTransactionDetail, id);

        case 3:
          transactionDetail = _context14.sent;

          mpReportTransactions.reportsTransactionsSelect({
            transactionDetail: transactionDetail
          });
          _context14.next = 7;
          return (0, _effects.put)((0, _transactions.setTransactionDetail)(transactionDetail));

        case 7:
          _context14.next = 9;
          return (0, _effects.call)(initResendEmailForm, transactionDetail);

        case 9:
          refundItems = extractForRefundBreakdown(transactionDetail);
          _context14.next = 12;
          return (0, _effects.put)((0, _transactions.setRefundItems)(refundItems));

        case 12:

          // animate
          if ($('#mk-col-left').hasClass('col-sm-12')) {
            $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6');
            setTimeout(function () {
              $('#mk-col-right').fadeIn(200);
              $('[data-toggle="popover"]').popover();
            }, 600);
          }

        case 13:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function hideTransactionDetailFlow(request) {
  var toggledClass;
  return _regenerator2.default.wrap(function hideTransactionDetailFlow$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)((0, _transactions.setTransactionDetail)(null));

        case 2:
          // animation
          toggledClass = 'col-sm-12 col-md-6 col-xs-6';

          $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
          $('#mk-col-left').addClass('col-sm-12');

        case 5:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

/********************************************************************************
 * End Transaction Detail Flow
 ********************************************************************************/

/********************************************************************************
 * Export Transaction Flow
 ********************************************************************************/

function exportTransactionFlow(request) {
  var _request$payload4, query, filename, outletId;

  return _regenerator2.default.wrap(function exportTransactionFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          // noinspection JSUnresolvedVariable
          _request$payload4 = request.payload, query = _request$payload4.query, filename = _request$payload4.filename, outletId = _request$payload4.outletId;
          _context16.prev = 1;
          _context16.next = 4;
          return (0, _effects.call)(apiReport.exportTransaction, query);

        case 4:
          _context16.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Transaction'));

        case 6:
          _context16.next = 12;
          break;

        case 8:
          _context16.prev = 8;
          _context16.t0 = _context16['catch'](1);
          _context16.next = 12;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 12:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[1, 8]]);
}

/********************************************************************************
 * End Export Transaction Flow
 ********************************************************************************/

/********************************************************************************
 * Resend Email
 ********************************************************************************/

function sendEmailReceiptFlow(request) {
  var query, response, _response;

  return _regenerator2.default.wrap(function sendEmailReceiptFlow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          query = request.payload.data;
          _context17.prev = 1;
          _context17.next = 4;
          return (0, _effects.call)(_emailReceipt.postEmailReceipt, query);

        case 4:
          response = _context17.sent;
          _context17.next = 7;
          return (0, _effects.put)(actNotif.success(response.data.message));

        case 7:
          mpReportTransactions.reportsTransactionsResendReceipt();
          _context17.next = 15;
          break;

        case 10:
          _context17.prev = 10;
          _context17.t0 = _context17['catch'](1);
          _response = _context17.t0.response;
          _context17.next = 15;
          return (0, _effects.put)(actNotif.error(_response.data.message));

        case 15:
          _context17.prev = 15;
          _context17.next = 18;
          return (0, _effects.put)((0, _transactions.hideResendEmailModal)());

        case 18:
          return _context17.finish(15);

        case 19:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[1, 10, 15, 19]]);
}

function cancelResendEmail(request) {
  var transactionDetail;
  return _regenerator2.default.wrap(function cancelResendEmail$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          transactionDetail = request.payload.transactionDetail;
          _context18.next = 3;
          return (0, _effects.call)(initResendEmailForm, transactionDetail);

        case 3:
          _context18.next = 5;
          return (0, _effects.put)((0, _transactions.hideResendEmailModal)());

        case 5:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function cancelRefundBreakdown(request) {
  var transactionDetail, refundItems;
  return _regenerator2.default.wrap(function cancelRefundBreakdown$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          transactionDetail = request.payload.transactionDetail;
          refundItems = extractForRefundBreakdown(transactionDetail);
          _context19.next = 4;
          return (0, _effects.put)((0, _transactions.setRefundItems)(refundItems));

        case 4:
          _context19.next = 6;
          return (0, _effects.put)((0, _transactions.hideRefundBreakdownModal)());

        case 6:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

/********************************************************************************
 * End Resend Email
 ********************************************************************************/

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function reportsTransactionsSaga() {
  var pageReqTask, transDetailNonMobTask, transDetailMobTask, transTask, changeOutletTask, changeDateTask, sendEmailReceiptTask, issueRefundTask, exportTransTask, issueOldRefundTask, changeKeywordTask;
  return _regenerator2.default.wrap(function reportsTransactionsSaga$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_PAGE_REQUEST, pageRequestFlow);

        case 2:
          pageReqTask = _context21.sent;
          _context21.next = 5;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE, transactionDetailNonMobileFlow);

        case 5:
          transDetailNonMobTask = _context21.sent;
          _context21.next = 8;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE, transactionDetailMobileFlow);

        case 8:
          transDetailMobTask = _context21.sent;
          _context21.next = 11;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST, transactionsFlow);

        case 11:
          transTask = _context21.sent;
          _context21.next = 14;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CHANGE_OUTLET, changeOutletFlow);

        case 14:
          changeOutletTask = _context21.sent;
          _context21.next = 17;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CHANGE_DATE, changeDateFlow);

        case 17:
          changeDateTask = _context21.sent;
          _context21.next = 20;
          return (0, _effects.takeEvery)(_constants.REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL, hideTransactionDetailFlow);

        case 20:
          _context21.next = 22;
          return (0, _effects.takeEvery)(_constants.REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT, sendEmailReceiptFlow);

        case 22:
          sendEmailReceiptTask = _context21.sent;
          _context21.next = 25;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST, issueRefundFlow);

        case 25:
          issueRefundTask = _context21.sent;
          _context21.next = 28;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_EXPORT_TRANSACTION, exportTransactionFlow);

        case 28:
          exportTransTask = _context21.sent;
          _context21.next = 31;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST, issueOldRefundFlow);

        case 31:
          issueOldRefundTask = _context21.sent;
          _context21.next = 34;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CHANGE_KEYWORD, changeKeywordFlow);

        case 34:
          changeKeywordTask = _context21.sent;
          _context21.next = 37;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_ASK_SET_QUANTITY, askSetQuantity);

        case 37:
          _context21.next = 39;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY, confirmSetQuantity);

        case 39:
          _context21.next = 41;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY, cancelSetQuantity);

        case 41:
          _context21.next = 43;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL, cancelResendEmail);

        case 43:
          _context21.next = 45;
          return (0, _effects.takeLatest)(_constants.REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN, cancelRefundBreakdown);

        case 45:
          _context21.next = 47;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [pageReqTask, transDetailNonMobTask, transDetailMobTask, transTask, issueRefundTask, exportTransTask, changeOutletTask, changeDateTask, sendEmailReceiptTask, issueOldRefundTask, changeKeywordTask]);

        case 47:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.accountPageRequestFlow = accountPageRequestFlow;
exports.settingAccountFlow = settingAccountFlow;
exports.default = settingAccountSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(617);

var _profile = __webpack_require__(114);

var _account = __webpack_require__(1599);

var _reduxForm = __webpack_require__(7);

var _accounts = __webpack_require__(1211);

var mpSettingAccount = _interopRequireWildcard(_accounts);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [accountPageRequestFlow, settingAccountFlow, settingAccountSaga].map(_regenerator2.default.mark);

function accountPageRequestFlow() {
  var profile;
  return _regenerator2.default.wrap(function accountPageRequestFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 11;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.SETTING_ACCOUNT_PAGE_REQUEST);

        case 3:
          mpSettingAccount.settingAccountStart();
          _context.next = 6;
          return (0, _effects.call)(_profile.getProfile);

        case 6:
          profile = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _reduxForm.initialize)('accountForm', {
            'first_name': profile.first_name,
            'last_name': profile.last_name,
            'email': profile.email
          }));

        case 9:
          _context.next = 0;
          break;

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function settingAccountFlow() {
  var request, data;
  return _regenerator2.default.wrap(function settingAccountFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 11;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.SETTING_ACCOUNT_REQUEST);

        case 3:
          request = _context2.sent;
          data = request.payload.data;
          _context2.next = 7;
          return (0, _effects.call)(_account.settingAccount, data);

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _reduxForm.initialize)('accountForm', {
            'first_name': data.user.first_name,
            'last_name': data.user.last_name,
            'email': data.user.email
          }));

        case 9:
          _context2.next = 0;
          break;

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function settingAccountSaga() {
  return _regenerator2.default.wrap(function settingAccountSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(accountPageRequestFlow);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(settingAccountFlow);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getBillingsFlow = getBillingsFlow;
exports.pageRequest = pageRequest;
exports.rulesOutletsSubscriptionStatusFlow = rulesOutletsSubscriptionStatusFlow;
exports.featureSubscriptionPriceFlow = featureSubscriptionPriceFlow;
exports.onChangeSubscriptionRules = onChangeSubscriptionRules;
exports.payMokaSubscriptionFlow = payMokaSubscriptionFlow;
exports.onClickCancelSubscriptionModalFlow = onClickCancelSubscriptionModalFlow;
exports.cancelFeatureSubscriptionFlow = cancelFeatureSubscriptionFlow;
exports.onClickTurnButtonFlow = onClickTurnButtonFlow;
exports.default = settingBillingSaga;

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _constant = __webpack_require__(419);

var _billing = __webpack_require__(428);

var _billing2 = __webpack_require__(202);

var _billingRedirect = __webpack_require__(232);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _billingNotification = __webpack_require__(381);

var _subscriptionExpired = __webpack_require__(204);

var _loadingSpinner = __webpack_require__(46);

var _billing3 = __webpack_require__(1212);

var mpSettingBilling = _interopRequireWildcard(_billing3);

var _is_js = __webpack_require__(372);

var is = _interopRequireWildcard(_is_js);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getBillingsFlow, pageRequest, rulesOutletsSubscriptionStatusFlow, featureSubscriptionPriceFlow, onChangeSubscriptionRules, payMokaSubscriptionFlow, onClickCancelSubscriptionModalFlow, cancelFeatureSubscriptionFlow, onClickTurnButtonFlow, settingBillingSaga].map(_regenerator2.default.mark); /**
                                                                                                                                                                                                                                                                                                                   * Created by alvinoktavianus on 5/9/17.
                                                                                                                                                                                                                                                                                                                   */

function getBillingsFlow() {
  var response, pendingPaymentMessage;
  return _regenerator2.default.wrap(function getBillingsFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _context.prev = 6;
          _context.next = 9;
          return (0, _effects.call)(_billing.getBillings);

        case 9:
          response = _context.sent;
          pendingPaymentMessage = null;

          _lodash2.default.forEach(response.data, function (invoice) {
            if (invoice.status === 'pending') {
              if (invoice.payment_type === 'credit_card') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please wait 24 hours before making a new payment.';
              } else if (invoice.payment_type === 'bank_transfer' || invoice.payment_type === 'echannel') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please transfer full amount of the invoice within 3 days before making a new payment. Please check your email for payment instruction.';
              }
              return false;
            }
          });

          if (!(pendingPaymentMessage !== null)) {
            _context.next = 17;
            break;
          }

          _context.next = 15;
          return (0, _effects.put)((0, _billing2.setPendingPaymentMessage)(pendingPaymentMessage));

        case 15:
          _context.next = 17;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(true));

        case 17:
          _context.next = 19;
          return (0, _effects.put)((0, _billing2.setBillings)(response.data));

        case 19:
          _context.next = 23;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context['catch'](6);

        case 23:
          _context.prev = 23;
          _context.next = 26;
          return (0, _effects.put)(action.hideProgressBar());

        case 26:
          _context.next = 28;
          return (0, _effects.put)(action.sendingRequest(false));

        case 28:
          return _context.finish(23);

        case 29:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[6, 21, 23, 29]]);
}

function pageRequest(request) {
  var _request$payload, currentPlan, expired, isOwner, billingNotification, responseProfile, isTrial, outletSlot;

  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)((0, _billing2.setBillings)([]));

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _billing2.setOutlets)([]));

        case 6:
          _context2.next = 8;
          return (0, _effects.put)((0, _billing2.setRules)({}));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)((0, _billing2.setSubscriptionStatus)([]));

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _billing2.setCountFeatureSubscription)(0));

        case 12:
          _context2.next = 14;
          return (0, _effects.put)((0, _billing2.setCurrentSubscriptionRules)({}));

        case 14:
          _context2.next = 16;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(false));

        case 16:
          _context2.next = 18;
          return (0, _effects.put)((0, _billing2.payButtonMessage)('Pay'));

        case 18:
          _context2.next = 20;
          return (0, _effects.put)((0, _billing2.hidePaymentGatewayErrorModal)());

        case 20:
          _context2.next = 22;
          return (0, _effects.put)((0, _billing2.setTotalBillingPrice)(0));

        case 22:
          _context2.next = 24;
          return (0, _effects.put)((0, _billing2.setPendingPaymentMessage)(null));

        case 24:
          _context2.next = 26;
          return (0, _effects.put)((0, _billing2.setUnusedOutletMessage)(null));

        case 26:
          _context2.next = 28;
          return (0, _effects.put)((0, _billing2.setCurrentSubscriptionPlanName)(null));

        case 28:
          _context2.next = 30;
          return (0, _effects.put)((0, _billing2.hidePaymentGatewayErrorModal)());

        case 30:
          _context2.next = 32;
          return (0, _effects.put)((0, _billing2.setCancelSubsciptionModalData)({}));

        case 32:
          _context2.next = 34;
          return (0, _effects.put)((0, _billing2.setFeatureSubscriptionPrice)({}));

        case 34:
          _context2.next = 36;
          return (0, _effects.put)((0, _billing2.setMinMaxDate)({}));

        case 36:
          _request$payload = request.payload, currentPlan = _request$payload.currentPlan, expired = _request$payload.expired, isOwner = _request$payload.isOwner, billingNotification = _request$payload.billingNotification;
          responseProfile = void 0, isTrial = void 0, outletSlot = void 0;
          _context2.prev = 38;
          _context2.next = 41;
          return (0, _effects.call)(apiProfile.getProfile);

        case 41:
          responseProfile = _context2.sent;

          expired = (0, _moment2.default)(responseProfile.data.business.expired_at) <= (0, _moment2.default)();
          isTrial = responseProfile.data.business.is_trial;
          outletSlot = responseProfile.data.business.outlet_slot;
          _context2.next = 49;
          break;

        case 47:
          _context2.prev = 47;
          _context2.t0 = _context2['catch'](38);

        case 49:
          if (!expired) {
            _context2.next = 58;
            break;
          }

          if (isOwner) {
            _context2.next = 56;
            break;
          }

          _context2.next = 53;
          return (0, _effects.put)(action.logout());

        case 53:
          return _context2.abrupt('return');

        case 56:
          _context2.next = 58;
          return (0, _effects.put)((0, _subscriptionExpired.showSubscriptionExpiredModal)());

        case 58:
          _context2.next = 60;
          return (0, _effects.put)((0, _billing2.billings)());

        case 60:
          _context2.next = 62;
          return (0, _effects.put)((0, _billing2.rulesOutletsSubscriptionStatus)(currentPlan, expired, isTrial, outletSlot));

        case 62:
          _context2.next = 64;
          return (0, _effects.put)((0, _billingNotification.showBillingNotification)(billingNotification));

        case 64:
          _context2.next = 66;
          return (0, _effects.put)((0, _billing2.featureSubscriptionPrice)());

        case 66:
          _context2.next = 68;
          return (0, _effects.put)((0, _billingRedirect.setNotificationType)(null));

        case 68:
          _context2.next = 70;
          return (0, _effects.put)((0, _billingRedirect.setNotificationMessage)(null));

        case 70:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[38, 47]]);
}

function rulesOutletsSubscriptionStatusFlow(request) {
  var _request$payload2, currentPlan, expired, isTrial, outletSlot, outlets, minDate, maxDate, responseOutlets, _responseOutlets, dateCollection, minMaxDate, isDeleted, sortedOutlet, unusedOutlet, initialRule, responseRules, rules, currentPlanName, initialValue, response, featureSubscription, featureCount;

  return _regenerator2.default.wrap(function rulesOutletsSubscriptionStatusFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _request$payload2 = request.payload, currentPlan = _request$payload2.currentPlan, expired = _request$payload2.expired, isTrial = _request$payload2.isTrial, outletSlot = _request$payload2.outletSlot;
          outlets = void 0, minDate = void 0, maxDate = void 0;
          _context3.next = 4;
          return (0, _effects.put)(action.sendingRequest(true));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(action.showProgressBar());

        case 6:
          _context3.prev = 6;

          if (!expired) {
            _context3.next = 15;
            break;
          }

          _context3.next = 10;
          return (0, _effects.call)(_billing.getAllOutlets);

        case 10:
          responseOutlets = _context3.sent;

          outlets = responseOutlets.data;
          _lodash2.default.forEach(outlets, function (outlet, index) {
            outlets[index].is_deleted = false;
            outlets[index].is_available = true;
          });
          _context3.next = 27;
          break;

        case 15:
          _context3.next = 17;
          return (0, _effects.call)(_billing.getOutlets);

        case 17:
          _responseOutlets = _context3.sent;

          outlets = _responseOutlets.data;
          dateCollection = [];

          _lodash2.default.forEach(outlets, function (outlet) {
            dateCollection.push(new Date((0, _moment2.default)(outlet.end_date).format('YYYY'), (0, _moment2.default)(outlet.end_date).format('MM') - 1, (0, _moment2.default)(outlet.end_date).format('DD')));
          });
          maxDate = (0, _moment2.default)(new Date(Math.max.apply(null, dateCollection))).format('DD/MM/YYYY');
          minDate = (0, _moment2.default)(new Date(Math.min.apply(null, dateCollection))).format('DD/MM/YYYY');
          minMaxDate = {
            minDate: minDate,
            maxDate: maxDate
          };
          _context3.next = 26;
          return (0, _effects.put)((0, _billing2.setMinMaxDate)(minMaxDate));

        case 26:
          if (maxDate !== minDate) {
            _lodash2.default.forEach(outlets, function (outlet, index) {
              var outletEndDate = (0, _moment2.default)(outlet.end_date).format('DD/MM/YYYY');
              if (outletEndDate === maxDate) {
                outlets[index].is_available = false;
                outlets[index].is_deleted = true;
              } else {
                outlets[index].is_available = true;
                outlets[index].is_deleted = false;
              }
            });
          } else {
            _lodash2.default.forEach(outlets, function (outlet, index) {
              outlets[index].is_available = true;
              outlets[index].is_deleted = false;
            });
          }

        case 27:
          isDeleted = {};

          _lodash2.default.forEach(outlets, function (outlet) {
            isDeleted[outlet.id] = outlet.is_deleted;
          });
          _context3.next = 31;
          return (0, _effects.put)((0, _billing2.setIsDeletedOutlet)(isDeleted));

        case 31:

          // After successfully fetch outlets and update the data,
          // change it to hash map instead array
          sortedOutlet = _lodash2.default.orderBy(outlets, [function (outlet) {
            return outlet.name.toLowerCase();
          }], ['asc']);
          _context3.next = 34;
          return (0, _effects.put)((0, _billing2.setOutlets)(sortedOutlet));

        case 34:
          unusedOutlet = isTrial ? 0 : outletSlot - outlets.length;

          if (!(unusedOutlet > 0)) {
            _context3.next = 40;
            break;
          }

          _context3.next = 38;
          return (0, _effects.put)((0, _billing2.setUnusedOutletMessage)('You still have slots for additional ' + unusedOutlet + ' outlets. Please create the outlets before making a payment.'));

        case 38:
          _context3.next = 40;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(true));

        case 40:

          // Get all rules
          initialRule = {};
          _context3.next = 43;
          return (0, _effects.call)(_billing.getRules);

        case 43:
          responseRules = _context3.sent;
          rules = responseRules.data;
          currentPlanName = null;
          _context3.next = 48;
          return (0, _effects.put)((0, _billing2.setRules)(rules));

        case 48:
          if (rules.subscription_plans.length > 1) {
            _lodash2.default.forEach(rules.subscription_plans, function (plan) {
              if (plan.name === 'Moka 12 Months') {
                initialRule = plan;
              }
              if (currentPlan === plan.month) {
                currentPlanName = plan.name;
              }
            });
          } else {
            initialRule = rules.subscription_plans[0];
            currentPlanName = rules.subscription_plans[0].name;
          }
          currentPlanName = expired ? 'Expired' : !expired && isTrial ? 'Trial' : currentPlanName;
          _context3.next = 52;
          return (0, _effects.put)((0, _billing2.setCurrentSubscriptionPlanName)(currentPlanName));

        case 52:
          _context3.next = 54;
          return (0, _effects.put)((0, _billing2.setCurrentSubscriptionRules)(initialRule));

        case 54:

          // Create redux-form initial value
          initialValue = {
            subscriptionRules: 'Moka 12 Months'

            // Initialize redux-form value
          };
          _context3.next = 57;
          return (0, _effects.put)((0, _reduxForm.initialize)('BillingReceipt', initialValue));

        case 57:
          _context3.next = 59;
          return (0, _effects.call)(_billing.getSubscriptionStatus);

        case 59:
          response = _context3.sent;
          featureSubscription = response.data;
          featureCount = 0;

          _lodash2.default.forEach(featureSubscription, function (feature) {
            if (feature.is_active && feature.is_subscribing) {
              featureCount++;
              feature.isHaveFeature = true;
              feature.isFeatureNeedToBePaid = true;
              feature.isFeatureActiveUntil = false; // please remove is this variable is not using anymore
              feature.featureActiveUntilDate = null; // please remove is this variable is not using anymore
            } else if (feature.is_active && !feature.is_subscribing) {
              featureCount++;
              feature.isHaveFeature = false;
              feature.featureActiveUntilDate = (0, _moment2.default)(feature.expiration_date).format('DD/MM/YYYY');
              feature.isFeatureNeedToBePaid = minDate !== maxDate ? !(minDate >= feature.featureActiveUntilDate && maxDate >= feature.featureActiveUntilDate) : false;
              feature.isFeatureActiveUntil = true; // please remove is this variable is not using anymore
            }
          });
          _context3.next = 65;
          return (0, _effects.put)((0, _billing2.setCountFeatureSubscription)(featureCount));

        case 65:
          _context3.next = 67;
          return (0, _effects.put)((0, _billing2.setSubscriptionStatus)(featureSubscription));

        case 67:
          _context3.next = 71;
          break;

        case 69:
          _context3.prev = 69;
          _context3.t0 = _context3['catch'](6);

        case 71:
          _context3.prev = 71;
          _context3.next = 74;
          return (0, _effects.put)(action.hideProgressBar());

        case 74:
          _context3.next = 76;
          return (0, _effects.put)(action.sendingRequest(false));

        case 76:
          _context3.next = 78;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 78:
          return _context3.finish(71);

        case 79:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[6, 69, 71, 79]]);
}

function featureSubscriptionPriceFlow() {
  var response;
  return _regenerator2.default.wrap(function featureSubscriptionPriceFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(_billing.getFeatureSubscriptionPrice);

        case 7:
          response = _context4.sent;
          _context4.next = 10;
          return (0, _effects.put)((0, _billing2.setFeatureSubscriptionPrice)(response.data));

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4['catch'](4);

        case 14:
          _context4.prev = 14;
          _context4.next = 17;
          return (0, _effects.put)(action.hideProgressBar());

        case 17:
          _context4.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          return _context4.finish(14);

        case 20:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[4, 12, 14, 20]]);
}

function onChangeSubscriptionRules(newSubscriptionRules) {
  var subscriptionRules;
  return _regenerator2.default.wrap(function onChangeSubscriptionRules$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          subscriptionRules = newSubscriptionRules.payload.subscriptionRules;
          _context5.next = 3;
          return (0, _effects.put)((0, _billing2.setCurrentSubscriptionRules)(subscriptionRules));

        case 3:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function payMokaSubscriptionFlow(request) {
  var _request$payload3, totalPrice, subscriptionPlan, purchasedOutlets, activatedFeatures, response, billingData;

  return _regenerator2.default.wrap(function payMokaSubscriptionFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(action.showProgressBar());

        case 2:
          _context6.next = 4;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(true));

        case 4:
          _request$payload3 = request.payload, totalPrice = _request$payload3.totalPrice, subscriptionPlan = _request$payload3.subscriptionPlan, purchasedOutlets = _request$payload3.purchasedOutlets, activatedFeatures = _request$payload3.activatedFeatures;
          response = {};
          billingData = {
            type: 'SubscriptionBilling',
            total_amount: totalPrice,
            subscription_plan: subscriptionPlan.month,
            feature_ids: activatedFeatures,
            purchased_outlets: purchasedOutlets
          };
          _context6.t0 = billingData.subscription_plan;
          _context6.next = _context6.t0 === 1 ? 10 : _context6.t0 === 12 ? 12 : 14;
          break;

        case 10:
          billingData.subscription_name = 'Monthly';
          return _context6.abrupt('break', 15);

        case 12:
          billingData.subscription_name = '12 Months';
          return _context6.abrupt('break', 15);

        case 14:
          billingData.subscription_name = 'Total Payment';

        case 15:

          mpSettingBilling.settingBillingPay({ billingData: billingData });

          _context6.prev = 16;
          _context6.next = 19;
          return (0, _effects.call)(_billing.verifyBilling, billingData);

        case 19:
          response = _context6.sent;
          _context6.next = 33;
          break;

        case 22:
          _context6.prev = 22;
          _context6.t1 = _context6['catch'](16);
          _context6.next = 26;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(false));

        case 26:
          if (!(!_context6.t1.data || _context6.t1.data === ' ' || _context6.t1.status >= 500)) {
            _context6.next = 31;
            break;
          }

          _context6.next = 29;
          return (0, _effects.put)((0, _billing2.showPaymentGatewayErrorModal)());

        case 29:
          _context6.next = 33;
          break;

        case 31:
          _context6.next = 33;
          return (0, _effects.put)(actNotif.error(_context6.t1.data.message));

        case 33:
          _context6.prev = 33;
          _context6.next = 36;
          return (0, _effects.put)(action.hideProgressBar());

        case 36:
          _context6.next = 38;
          return (0, _effects.put)(action.sendingRequest(false));

        case 38:
          if (!response.data) {
            _context6.next = 47;
            break;
          }

          _context6.next = 41;
          return (0, _effects.put)((0, _billing2.payButtonMessage)('Redirecting to Veritrans'));

        case 41:
          if (!is.safari()) {
            _context6.next = 46;
            break;
          }

          _context6.next = 44;
          return (0, _effects.put)((0, _billing2.isClickedPayButton)(false));

        case 44:
          _context6.next = 46;
          return (0, _effects.put)((0, _billing2.payButtonMessage)('Pay'));

        case 46:
          window.location.href = response.data.data.redirect_url;

        case 47:
          return _context6.finish(33);

        case 48:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[16, 22, 33, 48]]);
}

function onClickCancelSubscriptionModalFlow(request) {
  return _regenerator2.default.wrap(function onClickCancelSubscriptionModalFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _billing2.showCancelSubscriptionModal)());

        case 2:
          _context7.next = 4;
          return (0, _effects.put)((0, _billing2.setCancelSubsciptionModalData)(request.payload.featureSubscriptionModalData));

        case 4:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function cancelFeatureSubscriptionFlow(request) {
  var featureSubscriptionStatus, _request$payload$outl, minDate, maxDate, response, newFeatureStatus;

  return _regenerator2.default.wrap(function cancelFeatureSubscriptionFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          featureSubscriptionStatus = request.payload.featureSubscriptionStatus;
          _request$payload$outl = request.payload.outletMinMaxDate, minDate = _request$payload$outl.minDate, maxDate = _request$payload$outl.maxDate;
          _context8.prev = 2;
          _context8.next = 5;
          return (0, _effects.call)(_billing.cancelSubscription, request.payload.featureName);

        case 5:
          response = _context8.sent;
          newFeatureStatus = response.data[0];

          _lodash2.default.forEach(featureSubscriptionStatus, function (feature, index) {
            if (feature.id === newFeatureStatus.id) {
              featureSubscriptionStatus[index] = newFeatureStatus;
              featureSubscriptionStatus[index].isHaveFeature = false;
              featureSubscriptionStatus[index].featureActiveUntilDate = (0, _moment2.default)(feature.expiration_date).format('DD/MM/YYYY');
              featureSubscriptionStatus[index].isFeatureNeedToBePaid = minDate !== maxDate ? !(minDate >= feature.featureActiveUntilDate && maxDate >= feature.featureActiveUntilDate) : false;
              featureSubscriptionStatus[index].isFeatureActiveUntil = true;
            }
          });
          _context8.next = 10;
          return (0, _effects.put)((0, _billing2.setSubscriptionStatus)([]));

        case 10:
          _context8.next = 12;
          return (0, _effects.put)((0, _billing2.setSubscriptionStatus)(featureSubscriptionStatus));

        case 12:
          _context8.next = 16;
          break;

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8['catch'](2);

        case 16:
          _context8.prev = 16;
          _context8.next = 19;
          return (0, _effects.put)((0, _billing2.hideCancelSubscriptionModal)());

        case 19:
          return _context8.finish(16);

        case 20:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[2, 14, 16, 20]]);
}

function onClickTurnButtonFlow(request) {
  var _request$payload4, id, prevIsDeleted, newDeleted;

  return _regenerator2.default.wrap(function onClickTurnButtonFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload4 = request.payload, id = _request$payload4.id, prevIsDeleted = _request$payload4.prevIsDeleted;
          newDeleted = (0, _extends3.default)({}, prevIsDeleted);

          newDeleted[id] = !prevIsDeleted[id];
          _context9.next = 5;
          return (0, _effects.put)((0, _billing2.setIsDeletedOutlet)(newDeleted));

        case 5:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function settingBillingSaga() {
  return _regenerator2.default.wrap(function settingBillingSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_PAGE_REQUEST, pageRequest);

        case 2:
          _context10.next = 4;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES, rulesOutletsSubscriptionStatusFlow);

        case 4:
          _context10.next = 6;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_BILLINGS, getBillingsFlow);

        case 6:
          _context10.next = 8;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES, onChangeSubscriptionRules);

        case 8:
          _context10.next = 10;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_PAY_MOKA_SUBSCRIPTION, payMokaSubscriptionFlow);

        case 10:
          _context10.next = 12;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL, onClickCancelSubscriptionModalFlow);

        case 12:
          _context10.next = 14;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE, featureSubscriptionPriceFlow);

        case 14:
          _context10.next = 16;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION, cancelFeatureSubscriptionFlow);

        case 16:
          _context10.next = 18;
          return (0, _effects.takeLatest)(_constant.SETTING_BILLING_ON_CLICK_TURN_BUTTON, onClickTurnButtonFlow);

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillForm = fillForm;
exports.pageRequestFlow = pageRequestFlow;
exports.updateSettingFlow = updateSettingFlow;
exports.default = settingCheckoutSaga;

var _effects = __webpack_require__(22);

var _constant = __webpack_require__(420);

var _checkoutSetting = __webpack_require__(1602);

var _settings = __webpack_require__(1605);

var _reduxForm = __webpack_require__(7);

var _checkout = __webpack_require__(618);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _checkout2 = __webpack_require__(1213);

var mpSettingCheckout = _interopRequireWildcard(_checkout2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, pageRequestFlow, updateSettingFlow, settingCheckoutSaga].map(_regenerator2.default.mark);

function fillForm(data) {
  var formName;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          // see CheckoutForm for formname
          formName = 'checkout';
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)(formName, {
            'tax': data.enable_tax,
            'gratuity': data.enable_gratuity,
            'includeGratuityTax': data.include_gratuity_tax.toString(),
            'trackServer': data.track_server
          }));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function pageRequestFlow() {
  var data;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 14;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constant.SETTING_CHECKOUT_PAGE_REQUEST);

        case 3:
          mpSettingCheckout.settingCheckoutStart();
          _context2.next = 6;
          return (0, _effects.call)(_checkoutSetting.getCheckoutSetting, {});

        case 6:
          data = _context2.sent;

          if (!data) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.call)(fillForm, data);

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _checkout.setSetting)(data));

        case 12:
          _context2.next = 0;
          break;

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function updateSettingFlow() {
  var req, data, res;
  return _regenerator2.default.wrap(function updateSettingFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (false) {
            _context3.next = 16;
            break;
          }

          _context3.next = 3;
          return (0, _effects.take)(_constant.SETTING_CHECKOUT_UPDATE_SETTING);

        case 3:
          req = _context3.sent;
          data = req.payload.data;

          mpSettingCheckout.settingCheckoutUpdate({
            settings: data.settings
          });
          _context3.next = 8;
          return (0, _effects.call)(_settings.putUpdateSetting, data);

        case 8:
          res = _context3.sent;

          if (!res) {
            _context3.next = 14;
            break;
          }

          _context3.next = 12;
          return (0, _effects.call)(fillForm, res);

        case 12:
          _context3.next = 14;
          return (0, _effects.put)(actNotif.success(res.message));

        case 14:
          _context3.next = 0;
          break;

        case 16:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function settingCheckoutSaga() {
  return _regenerator2.default.wrap(function settingCheckoutSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(pageRequestFlow);

        case 2:
          _context4.next = 4;
          return (0, _effects.fork)(updateSettingFlow);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailNotificationSaga = undefined;

var _emailNotification = __webpack_require__(1631);

var _emailNotification2 = _interopRequireDefault(_emailNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.emailNotificationSaga = _emailNotification2.default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.publicProfilePageRequestFlow = publicProfilePageRequestFlow;
exports.publicProfileRequestFlow = publicProfileRequestFlow;
exports.default = settingPublicProfileSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(619);

var _profile2 = __webpack_require__(48);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _formatter = __webpack_require__(11);

var _publicProfile = __webpack_require__(1111);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _publicProfile2 = __webpack_require__(1215);

var mpSettingPublicProfile = _interopRequireWildcard(_publicProfile2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [publicProfilePageRequestFlow, publicProfileRequestFlow, settingPublicProfileSaga].map(_regenerator2.default.mark);

function publicProfilePageRequestFlow() {
  var resProfile, profile;
  return _regenerator2.default.wrap(function publicProfilePageRequestFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

          mpSettingPublicProfile.settingPublicProfileStart();
          _context.next = 4;
          return (0, _effects.put)(action.sendingRequest(true));

        case 4:
          _context.next = 6;
          return (0, _effects.put)(action.showProgressBar());

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_profile2.getProfile);

        case 8:
          resProfile = _context.sent;
          profile = resProfile.data;
          _context.next = 12;
          return (0, _effects.put)(action.setProfile(profile));

        case 12:
          _context.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('publicProfileForm', {
            'gravatar': profile.gravatar,
            'name': profile.business.name,
            'description': profile.business.description,
            'address': profile.business.address,
            'city': profile.business.city,
            'province': profile.business.province,
            'postal_code': profile.business.postal_code,
            'phone': profile.business.phone ? (0, _formatter.phoneNumberFormatter)(profile.business.phone) : '',
            'email': profile.business.email,
            'website': profile.business.website,
            'twitter': profile.business.twitter,
            'facebook': profile.business.facebook,
            'instagram': profile.business.instagram
          }));

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context['catch'](0);
          _context.next = 20;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.put)(action.sendingRequest(false));

        case 23:
          _context.next = 25;
          return (0, _effects.put)(action.hideProgressBar());

        case 25:
          return _context.finish(20);

        case 26:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 16, 20, 26]]);
}

function publicProfileRequestFlow(request) {
  var _request$payload$data, _request$payload$data2, gravatar, name, description, address, city, province, postal_code, phone, email, website, twitter, facebook, instagram, profile, businessId, business, data, gravatarChanged, resProfile, _profile;

  return _regenerator2.default.wrap(function publicProfileRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _request$payload$data = request.payload.data, _request$payload$data2 = _request$payload$data.values, gravatar = _request$payload$data2.gravatar, name = _request$payload$data2.name, description = _request$payload$data2.description, address = _request$payload$data2.address, city = _request$payload$data2.city, province = _request$payload$data2.province, postal_code = _request$payload$data2.postal_code, phone = _request$payload$data2.phone, email = _request$payload$data2.email, website = _request$payload$data2.website, twitter = _request$payload$data2.twitter, facebook = _request$payload$data2.facebook, instagram = _request$payload$data2.instagram, profile = _request$payload$data.user;
          businessId = profile.business.id;
          business = profile.business;
          data = {
            business: {
              id: businessId,
              name: name,
              description: description,
              address: address,
              city: city,
              province: province,
              postal_code: postal_code,
              phone: '0' + phone,
              email: email,
              website: website,
              twitter: twitter,
              facebook: facebook,
              instagram: instagram,
              logo: { url: gravatar },
              suite: business.suite,
              notify_per_deposit: business.notify_per_deposit,
              notify_per_trans: business.notify_per_trans,
              user_id: business.user_id,
              is_deleted: business.is_deleted,
              created_at: business.created_at,
              updated_at: business.updated_at,
              business_type_id: business.business_type_id,
              business_category_id: business.business_category_id,
              notes: business.notes,
              latitude: business.latitude,
              longitude: business.longitude,
              synchronized_at: business.synchronized_at,
              outlet_slot: business.outlet_slot,
              is_trial: business.is_trial,
              current_plan: business.current_plan,
              expired_at: business.expired_at,
              last_payment_date: business.last_payment_date,
              trial_end_at: business.trial_end_at,
              setting: business.setting
            }
            // https://mokapos.atlassian.net/browse/FD-1720
            // somehow backend bakal rusak kalo dia upload remote_logo_url tapi sama dengan yang sebelumnya
            // jadi hanya kirim remote_logo kalo beda dengan sebelumnya
            // wasting time amat
          };
          gravatarChanged = gravatar === '';

          if (business.logo) {
            gravatarChanged = gravatarChanged || business.logo.url !== gravatar;
          } else {
            gravatarChanged = !gravatar;
          }
          if (gravatarChanged) {
            data.business.remote_logo_url = gravatar;
            data.business.remove_logo = gravatar === '';
          }
          _context2.prev = 11;
          _context2.next = 14;
          return (0, _effects.call)(_publicProfile.settingPublicProfile, businessId, data);

        case 14:
          _context2.next = 16;
          return (0, _effects.call)(_profile2.getProfile);

        case 16:
          resProfile = _context2.sent;
          _profile = resProfile.data;
          _context2.next = 20;
          return (0, _effects.put)(action.setProfile(_profile));

        case 20:
          _context2.next = 22;
          return (0, _effects.put)((0, _reduxForm.initialize)('publicProfileForm', {
            'gravatar': gravatar,
            'name': name,
            'description': description,
            'address': address,
            'city': city,
            'province': province,
            'postal_code': postal_code,
            'phone': (0, _formatter.phoneNumberFormatter)('0' + phone),
            'email': email,
            'website': website,
            'twitter': twitter,
            'facebook': facebook,
            'instagram': instagram
          }));

        case 22:
          _context2.next = 24;
          return (0, _effects.put)(actNotif.success('Business successfully edited.'));

        case 24:
          _context2.next = 31;
          break;

        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2['catch'](11);
          _context2.next = 30;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 30:
          return _context2.abrupt('return', false);

        case 31:
          _context2.prev = 31;
          _context2.next = 34;
          return (0, _effects.put)(action.hideProgressBar());

        case 34:
          _context2.next = 36;
          return (0, _effects.put)(action.sendingRequest(false));

        case 36:
          return _context2.finish(31);

        case 37:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[11, 26, 31, 37]]);
}

function settingPublicProfileSaga() {
  return _regenerator2.default.wrap(function settingPublicProfileSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.SETTING_PUBLIC_PROFILE_PAGE_REQUEST, publicProfilePageRequestFlow);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_constants.SETTING_PUBLIC_PROFILE_REQUEST, publicProfileRequestFlow);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillForm = fillForm;
exports.fillSearchForm = fillSearchForm;
exports.pageRequestFlow = pageRequestFlow;
exports.changeOutletFlow = changeOutletFlow;
exports.changeOutletNameFlow = changeOutletNameFlow;
exports.submitFormFlow = submitFormFlow;
exports.changePageFlow = changePageFlow;
exports.default = settingReceiptFlowSaga;

var _effects = __webpack_require__(22);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _reduxForm = __webpack_require__(7);

var _constants = __webpack_require__(422);

var _index = __webpack_require__(18);

var action = _interopRequireWildcard(_index);

var _outlet = __webpack_require__(235);

var actOutlet = _interopRequireWildcard(_outlet);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _receipt = __webpack_require__(423);

var actReceipt = _interopRequireWildcard(_receipt);

var _login = __webpack_require__(630);

var apiLogin = _interopRequireWildcard(_login);

var _formatter = __webpack_require__(11);

var _receipt2 = __webpack_require__(1216);

var mpSettingReceipt = _interopRequireWildcard(_receipt2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, fillSearchForm, pageRequestFlow, changeOutletFlow, changeOutletNameFlow, submitFormFlow, changePageFlow, settingReceiptFlowSaga].map(_regenerator2.default.mark);

function fillForm(currentOutlet) {
  var name, address, city, province, postal_code, notes, phone_number;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          name = currentOutlet.name, address = currentOutlet.address, city = currentOutlet.city, province = currentOutlet.province, postal_code = currentOutlet.postal_code, notes = currentOutlet.notes, phone_number = currentOutlet.phone_number;
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('checkout', {
            name: name,
            address: address,
            city: city,
            province: province,
            zipcode: postal_code,
            phone: (0, _formatter.phoneNumberFormatter)(phone_number),
            notes: notes
          }, false));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillSearchForm(outletIds) {
  return _regenerator2.default.wrap(function fillSearchForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outlet: outletIds
          }));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function pageRequestFlow() {
  var outletRes, outlets, currentProfileRes, currentProfile;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.take)(_constants.SETTING_RECEIPT_PAGE_REQUEST);

        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.put)(action.sendingRequest(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context3.next = 9;
          return (0, _effects.call)(apiOutlet.outlets);

        case 9:
          outletRes = _context3.sent;
          outlets = outletRes.data;
          _context3.next = 13;
          return (0, _effects.put)(actReceipt.setOutlets(outlets));

        case 13:
          _context3.next = 15;
          return (0, _effects.call)(apiProfile.getProfile);

        case 15:
          currentProfileRes = _context3.sent;
          currentProfile = currentProfileRes.data;
          _context3.next = 19;
          return (0, _effects.put)(actOutlet.setCurrentOutlet(currentProfile));

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(actReceipt.setProfile(currentProfile));

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(fillForm, currentProfile.selected_outlets[0]);

        case 23:
          _context3.next = 25;
          return (0, _effects.call)(fillSearchForm, [currentProfile.outlet_id[0]]);

        case 25:
          mpSettingReceipt.settingReceiptStart({ outletIds: [currentProfile.outlet_id[0]] });
          _context3.next = 32;
          break;

        case 28:
          _context3.prev = 28;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 32;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 32:
          _context3.prev = 32;
          _context3.next = 35;
          return (0, _effects.put)(action.sendingRequest(false));

        case 35:
          _context3.next = 37;
          return (0, _effects.put)(action.hideProgressBar());

        case 37:
          return _context3.finish(32);

        case 38:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[2, 28, 32, 38]]);
}

function changeOutletFlow() {
  var _ref, outletIds, currentProfileRes, currentProfile, outletsRes, outlets;

  return _regenerator2.default.wrap(function changeOutletFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (false) {
            _context4.next = 39;
            break;
          }

          _context4.next = 3;
          return (0, _effects.take)(_constants.SETTING_RECEIPT_CHANGE_OUTLET);

        case 3:
          _ref = _context4.sent;
          outletIds = _ref.payload.outletIds;

          mpSettingReceipt.settingReceiptChangeOutlet({ outletIds: outletIds });
          _context4.prev = 6;
          _context4.next = 9;
          return (0, _effects.put)(action.sendingRequest(true));

        case 9:
          _context4.next = 11;
          return (0, _effects.put)(action.showProgressBar());

        case 11:
          _context4.next = 13;
          return (0, _effects.call)(apiLogin.loginOutlet, { id: outletIds });

        case 13:
          _context4.next = 15;
          return (0, _effects.call)(apiProfile.getProfile);

        case 15:
          currentProfileRes = _context4.sent;
          currentProfile = currentProfileRes.data;
          _context4.next = 19;
          return (0, _effects.put)(actOutlet.setCurrentOutlet(currentProfile));

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(actReceipt.setProfile(currentProfile));

        case 21:
          _context4.next = 23;
          return (0, _effects.call)(fillForm, currentProfile.selected_outlets[0]);

        case 23:
          _context4.next = 25;
          return (0, _effects.call)(fillSearchForm, outletIds);

        case 25:
          _context4.next = 27;
          return (0, _effects.call)(apiOutlet.outlets);

        case 27:
          outletsRes = _context4.sent;
          outlets = outletsRes.data;
          _context4.next = 31;
          return (0, _effects.put)(actOutlet.setOutlets(outlets));

        case 31:
          _context4.prev = 31;
          _context4.next = 34;
          return (0, _effects.put)(action.sendingRequest(false));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(action.hideProgressBar());

        case 36:
          return _context4.finish(31);

        case 37:
          _context4.next = 0;
          break;

        case 39:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[6,, 31, 37]]);
}

function changeOutletNameFlow() {
  var _this = this;

  var _loop;

  return _regenerator2.default.wrap(function changeOutletNameFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _loop = _regenerator2.default.mark(function _loop() {
            var _ref2, _ref2$payload, outlets, currentProfile, name;

            return _regenerator2.default.wrap(function _loop$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return (0, _effects.take)(_constants.SETTING_RECEIPT_CHANGE_OUTLET_NAME);

                  case 2:
                    _ref2 = _context5.sent;
                    _ref2$payload = _ref2.payload;
                    outlets = _ref2$payload.outlets;
                    currentProfile = _ref2$payload.currentProfile;
                    name = _ref2$payload.name;

                    outlets.forEach(function (outlet) {
                      if (outlet.id === currentProfile.selected_outlets[0].id) {
                        outlet.name = name;
                        currentProfile.selected_outlets[0].name = name;
                      }
                    });
                    _context5.next = 10;
                    return (0, _effects.put)(actOutlet.setCurrentOutlet(currentProfile));

                  case 10:
                    _context5.next = 12;
                    return (0, _effects.put)(actOutlet.setOutlets(outlets));

                  case 12:
                    _context5.next = 14;
                    return (0, _effects.put)(actReceipt.setProfile(currentProfile));

                  case 14:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _loop, _this);
          });

        case 1:
          if (false) {
            _context6.next = 5;
            break;
          }

          return _context6.delegateYield(_loop(), 't0', 3);

        case 3:
          _context6.next = 1;
          break;

        case 5:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[4], this);
}

function submitFormFlow() {
  var _ref3, _ref3$payload, data, outletId, outletRes, outlets, currentProfileRes, _currentProfile;

  return _regenerator2.default.wrap(function submitFormFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (false) {
            _context7.next = 48;
            break;
          }

          _context7.next = 3;
          return (0, _effects.take)(_constants.SETTING_RECEIPT_SUBMIT_FORM);

        case 3:
          _ref3 = _context7.sent;
          _ref3$payload = _ref3.payload;
          data = _ref3$payload.data;
          outletId = _ref3$payload.outletId;
          _context7.prev = 7;
          _context7.next = 10;
          return (0, _effects.put)(action.sendingRequest(true));

        case 10:
          _context7.next = 12;
          return (0, _effects.put)(action.showProgressBar());

        case 12:
          _context7.next = 14;
          return (0, _effects.call)(apiOutlet.putOutletById, outletId, data, {});

        case 14:
          _context7.next = 16;
          return (0, _effects.put)(actNotif.success('Outlet was successfully updated.'));

        case 16:
          _context7.next = 18;
          return (0, _effects.call)(apiOutlet.outlets);

        case 18:
          outletRes = _context7.sent;
          outlets = outletRes.data;
          _context7.next = 22;
          return (0, _effects.put)(actReceipt.setOutlets(outlets));

        case 22:
          _context7.next = 24;
          return (0, _effects.call)(apiProfile.getProfile);

        case 24:
          currentProfileRes = _context7.sent;
          _currentProfile = currentProfileRes.data;
          _context7.next = 28;
          return (0, _effects.put)(actOutlet.setCurrentOutlet(_currentProfile));

        case 28:
          _context7.next = 30;
          return (0, _effects.put)(actReceipt.setProfile(_currentProfile));

        case 30:
          _context7.next = 32;
          return (0, _effects.call)(fillForm, _currentProfile.selected_outlets[0]);

        case 32:
          _context7.next = 34;
          return (0, _effects.call)(fillSearchForm, [_currentProfile.outlet_id[0]]);

        case 34:
          _context7.next = 40;
          break;

        case 36:
          _context7.prev = 36;
          _context7.t0 = _context7['catch'](7);
          _context7.next = 40;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 40:
          _context7.prev = 40;
          _context7.next = 43;
          return (0, _effects.put)(action.sendingRequest(false));

        case 43:
          _context7.next = 45;
          return (0, _effects.put)(action.hideProgressBar());

        case 45:
          return _context7.finish(40);

        case 46:
          _context7.next = 0;
          break;

        case 48:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[5], this, [[7, 36, 40, 46]]);
}

function changePageFlow() {
  var _ref4, nextLocation;

  return _regenerator2.default.wrap(function changePageFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (false) {
            _context8.next = 8;
            break;
          }

          _context8.next = 3;
          return (0, _effects.take)(_constants.SETTING_RECEIPT_CHANGE_PAGE);

        case 3:
          _ref4 = _context8.sent;
          nextLocation = _ref4.payload.nextLocation;

          // temporary cheat - not using browserHistory
          window.location.href = nextLocation;
          // browserHistory.push(nextLocation)
          _context8.next = 0;
          break;

        case 8:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[6], this);
}

function settingReceiptFlowSaga() {
  return _regenerator2.default.wrap(function settingReceiptFlowSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.fork)(changeOutletFlow);

        case 2:
          _context9.next = 4;
          return (0, _effects.fork)(pageRequestFlow);

        case 4:
          _context9.next = 6;
          return (0, _effects.fork)(submitFormFlow);

        case 6:
          _context9.next = 8;
          return (0, _effects.fork)(changeOutletNameFlow);

        case 8:
          _context9.next = 10;
          return (0, _effects.fork)(changePageFlow);

        case 10:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[7], this);
}

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.askModal = askModal;
exports.closeSubscriptionExpiredModal = closeSubscriptionExpiredModal;
exports.default = subscriptionExpiredSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(424);

var _subscriptionExpired = __webpack_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [askModal, closeSubscriptionExpiredModal, subscriptionExpiredSaga].map(_regenerator2.default.mark);

function askModal(request) {
  var nextActionExpired;
  return _regenerator2.default.wrap(function askModal$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          nextActionExpired = request.payload.nextActionExpired;
          _context.next = 3;
          return (0, _effects.put)((0, _subscriptionExpired.setNextActionExpired)(nextActionExpired));

        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _subscriptionExpired.showSubscriptionExpiredModal)());

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function closeSubscriptionExpiredModal() {
  return _regenerator2.default.wrap(function closeSubscriptionExpiredModal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _subscriptionExpired.setNextActionExpired)(null));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)((0, _subscriptionExpired.hideSubscriptionExpiredModal)());

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function subscriptionExpiredSaga() {
  return _regenerator2.default.wrap(function subscriptionExpiredSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.ASK_SHOW_SUBSCRIPTION_EXPIRED, askModal);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_constants.SUBSCRIPTION_EXPIRED_CLOSE_MODAL, closeSubscriptionExpiredModal);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getLoadingImageFlow = getLoadingImageFlow;
exports.uploadImageFlow = uploadImageFlow;
exports.default = uploadImageSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(287);

var _uploadImage = __webpack_require__(678);

var _uploadImage2 = __webpack_require__(1056);

var _formData = __webpack_require__(228);

var _formData2 = _interopRequireDefault(_formData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getLoadingImageFlow, uploadImageFlow, uploadImageSaga].map(_regenerator2.default.mark);

function getLoadingImageFlow() {
  return _regenerator2.default.wrap(function getLoadingImageFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 7;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)(_constants.GET_LOADING_IMAGE);

        case 3:
          _context.next = 5;
          return (0, _effects.call)(_uploadImage.getLoadingImage);

        case 5:
          _context.next = 0;
          break;

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function uploadImageFlow() {
  var request, file, data, formData;
  return _regenerator2.default.wrap(function uploadImageFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 30;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.UPLOAD_IMAGE_REQUEST);

        case 3:
          request = _context2.sent;

          $('#save-public-profile').prop('disabled', true);
          $('#save-public-profile').html('Loading...');
          $('.upload-img-spinner').removeClass('hide');
          $('.upload-img').addClass('hide');
          file = request.payload.file.file;
          _context2.next = 11;
          return (0, _effects.call)(_uploadImage.getImage, { filename: file.name });

        case 11:
          data = _context2.sent;
          formData = new _formData2.default();

          formData.append('key', data.key);
          formData.append('acl', data.acl);
          formData.append('AWSAccessKeyId', data.aws_access_key_id);
          formData.append('success_action_status', data.success_action_status);
          formData.append('Content-Type', data.content_type);
          formData.append('Cache-Control', data.cache_control);
          formData.append('policy', data.policy);
          formData.append('signature', data.signature);
          formData.append('file', file);
          _context2.prev = 22;

          fetch('' + data.url, {
            method: 'POST',
            body: formData
          }).then(function () {
            $('#save-public-profile').prop('disabled', false);
            $('#save-public-profile').html('Save');
            $('.upload-img-spinner').addClass('hide');
            $('.upload-img').removeClass('hide');
          });

        case 24:
          _context2.prev = 24;
          _context2.next = 27;
          return (0, _effects.put)((0, _uploadImage2.setTemporaryImage)(data.fullUrl));

        case 27:
          return _context2.finish(24);

        case 28:
          _context2.next = 0;
          break;

        case 30:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[22,, 24, 28]]);
}

function uploadImageSaga() {
  return _regenerator2.default.wrap(function uploadImageSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(getLoadingImageFlow);

        case 2:
          _context3.next = 4;
          return (0, _effects.fork)(uploadImageFlow);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getImportedStatus = getImportedStatus;
exports.doImportCustemers = doImportCustemers;
exports.default = importCustomers;

var _effects = __webpack_require__(22);

var _uploaders = __webpack_require__(236);

var actUploaders = _interopRequireWildcard(_uploaders);

var _buttons = __webpack_require__(1051);

var actionBtn = _interopRequireWildcard(_buttons);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _formData = __webpack_require__(228);

var _formData2 = _interopRequireDefault(_formData);

var _profile = __webpack_require__(114);

var _uploadImage = __webpack_require__(678);

var _uploaders2 = __webpack_require__(1118);

var api = _interopRequireWildcard(_uploaders2);

var _list = __webpack_require__(75);

var actCustomerList = _interopRequireWildcard(_list);

var _constants = __webpack_require__(425);

var _list2 = __webpack_require__(450);

var mpCustomerList = _interopRequireWildcard(_list2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getImportedStatus, doImportCustemers, importCustomers].map(_regenerator2.default.mark);

function wait(millis) {
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      resolve(true);
    }, millis);
  });
}

function getImportedStatus() {
  var stop, profile;
  return _regenerator2.default.wrap(function getImportedStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (false) {
            _context.next = 15;
            break;
          }

          stop = false;
          // noinspection InfiniteLoopJS

        case 2:
          if (stop) {
            _context.next = 13;
            break;
          }

          _context.next = 5;
          return (0, _effects.call)(wait, 5000);

        case 5:
          _context.next = 7;
          return (0, _effects.call)(_profile.getProfile);

        case 7:
          profile = _context.sent;

          if (profile.importing) {
            _context.next = 11;
            break;
          }

          stop = true;
          return _context.abrupt('return', true);

        case 11:
          _context.next = 2;
          break;

        case 13:
          _context.next = 0;
          break;

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

/**
 * Ini kalo direfactor
 * ensure mixpanelnya ikutan direfactor
 */
function doImportCustemers() {
  var request, _request$payload, file, hasLoyalty, response, formData, customersReqParam;

  return _regenerator2.default.wrap(function doImportCustemers$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 64;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.DO_IMPORT_CUSTOMER);

        case 3:
          request = _context2.sent;

          mpCustomerList.customerListImport();
          _request$payload = request.payload, file = _request$payload.file, hasLoyalty = _request$payload.hasLoyalty;
          _context2.next = 8;
          return (0, _effects.put)(action.sendingRequest(true));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)(action.showLoadingSpinner(true));

        case 10:
          _context2.next = 12;
          return (0, _effects.put)(actionBtn.showLoadingButton(true));

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(_uploadImage.getImage, { filename: file.name });

        case 14:
          response = _context2.sent;
          formData = new _formData2.default();

          formData.append('key', response.key);
          formData.append('acl', response.acl);
          formData.append('AWSAccessKeyId', response.aws_access_key_id);
          formData.append('success_action_status', response.success_action_status);
          formData.append('Content-Type', response.content_type);
          formData.append('Cache-Control', response.cache_control);
          formData.append('policy', response.policy);
          formData.append('signature', response.signature);
          formData.append('file', file);
          _context2.prev = 25;
          _context2.next = 28;
          return (0, _effects.put)(actUploaders.showModalImport(false));

        case 28:
          _context2.next = 30;
          return (0, _effects.call)(api.uploadToS3, response.url, formData);

        case 30:
          _context2.next = 32;
          return (0, _effects.call)(api.sendSuccessUploadCustomers, response.fullUrl);

        case 32:
          _context2.next = 34;
          return (0, _effects.call)(api.requestImportDataToCustomers);

        case 34:
          _context2.next = 36;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 36:
          _context2.next = 38;
          return (0, _effects.put)(actCustomerList.showImportingModeModal());

        case 38:
          _context2.next = 40;
          return (0, _effects.call)(getImportedStatus);

        case 40:
          customersReqParam = { page: 1 };

          if (hasLoyalty) {
            customersReqParam.type = 'ALL';
          }
          _context2.next = 44;
          return (0, _effects.put)(actCustomerList.customersRequest(customersReqParam, []));

        case 44:
          _context2.next = 46;
          return (0, _effects.put)(actCustomerList.setCustomerDetail(null));

        case 46:
          _context2.next = 48;
          return (0, _effects.put)(actCustomerList.hideImportingModeModal());

        case 48:
          _context2.next = 56;
          break;

        case 50:
          _context2.prev = 50;
          _context2.t0 = _context2['catch'](25);
          _context2.next = 54;
          return (0, _effects.put)(actUploaders.showModalErrorImport(true, _context2.t0.data.errors));

        case 54:
          _context2.next = 56;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 56:
          _context2.prev = 56;
          _context2.next = 59;
          return (0, _effects.put)(action.sendingRequest(false));

        case 59:
          _context2.next = 61;
          return (0, _effects.put)(actionBtn.showLoadingButton(false));

        case 61:
          return _context2.finish(56);

        case 62:
          _context2.next = 0;
          break;

        case 64:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[25, 50, 56, 62]]);
}

function importCustomers() {
  return _regenerator2.default.wrap(function importCustomers$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(doImportCustemers);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.verifyEmail = verifyEmail;
exports.default = verifyEmailSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(426);

var _verifyEmail = __webpack_require__(1122);

var _index = __webpack_require__(18);

var act = _interopRequireWildcard(_index);

var _reactRouter = __webpack_require__(15);

var _verifyEmail2 = __webpack_require__(620);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [verifyEmail, verifyEmailSaga].map(_regenerator2.default.mark);

function verifyEmail(request) {
  var token, resVerifyEmail, user;
  return _regenerator2.default.wrap(function verifyEmail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 2:
          _context.prev = 2;
          token = request.payload.access_token;
          _context.next = 6;
          return (0, _effects.call)(_verifyEmail.postVerifyEmail, { access_token: token });

        case 6:
          resVerifyEmail = _context.sent;
          user = resVerifyEmail.data;

          if (!user) {
            _context.next = 12;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)(act.setAuthState(true, user));

        case 11:
          if (user.is_owner || user.is_manager) {
            // owner or manager go to dashboard page
            _reactRouter.browserHistory.push('/dashboard');
          } else {
            // staff go to account settings
            _reactRouter.browserHistory.push('/settings/accounts');
          }

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](2);
          _context.next = 18;
          return (0, _effects.put)((0, _verifyEmail2.isInvalidTokenVerifyEmail)(true));

        case 18:
          _context.prev = 18;
          _context.next = 21;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 21:
          return _context.finish(18);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[2, 14, 18, 22]]);
}

function verifyEmailSaga() {
  return _regenerator2.default.wrap(function verifyEmailSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.SEND_VERIFY_EMAIL, verifyEmail);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.verifyEmailAlertRecipient = verifyEmailAlertRecipient;
exports.default = verifyEmailAlertRecipientSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(427);

var _verifyEmailAlertRecipient = __webpack_require__(1124);

var _index = __webpack_require__(18);

var act = _interopRequireWildcard(_index);

var _verifyEmailAlertRecipient2 = __webpack_require__(621);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [verifyEmailAlertRecipient, verifyEmailAlertRecipientSaga].map(_regenerator2.default.mark);

function verifyEmailAlertRecipient(request) {
  var token, resVerifyEmail;
  return _regenerator2.default.wrap(function verifyEmailAlertRecipient$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 2:
          _context.prev = 2;
          token = request.payload.token;
          _context.next = 6;
          return (0, _effects.call)(_verifyEmailAlertRecipient.getVerifyEmailAlertRecipient, { token: token });

        case 6:
          resVerifyEmail = _context.sent;
          _context.next = 9;
          return (0, _effects.put)((0, _verifyEmailAlertRecipient2.setMessageVerifyEmailAlertRecipient)(resVerifyEmail.data.message));

        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _verifyEmailAlertRecipient2.isInvalidTokenVerifyEmailAlertRecipient)(resVerifyEmail.data.error));

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context['catch'](2);

        case 15:
          _context.prev = 15;
          _context.next = 18;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 18:
          return _context.finish(15);

        case 19:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[2, 13, 15, 19]]);
}

function verifyEmailAlertRecipientSaga() {
  return _regenerator2.default.wrap(function verifyEmailAlertRecipientSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.SEND_VERIFY_EMAIL_ALERT_RECIPIENT, verifyEmailAlertRecipient);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2633);

/***/ }),
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.composeWithDevTools = (
  "development" !== 'production' && typeof window !== 'undefined' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      var compose = __webpack_require__(167).compose;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);


/***/ }),
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoadingButton = showLoadingButton;

var _constants = __webpack_require__(607);

function showLoadingButton(status) {
  return { type: _constants.SHOW_LOADING_BUTTON, payload: { showLoadingButton: status } };
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeDate = changeDate;
exports.setDate = setDate;

var _constants = __webpack_require__(383);

/****************************************
 * On Change Handler
 ****************************************/

function changeDate(startDate, endDate) {
  return { type: _constants.CALENDAR_CHANGE_DATE, payload: { startDate: startDate, endDate: endDate } };
}

/****************************************
 * Setter
 ****************************************/

function setDate(startDate, endDate) {
  return { type: _constants.CALENDAR_SET_DATE, payload: { startDate: startDate, endDate: endDate } };
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_';

var EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST = exports.EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST = PREFIX + 'PAGE_REQUEST';

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountPageRequest = accountPageRequest;
exports.settingAccountRequest = settingAccountRequest;

var _constants = __webpack_require__(617);

function accountPageRequest() {
  return { type: _constants.SETTING_ACCOUNT_PAGE_REQUEST, payload: {} };
}

function settingAccountRequest(data) {
  return { type: _constants.SETTING_ACCOUNT_REQUEST, payload: { data: data } };
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publicProfilePageRequest = publicProfilePageRequest;
exports.changeFormPublicProfile = changeFormPublicProfile;
exports.publicProfileRequest = publicProfileRequest;
exports.discardChange = discardChange;

var _constants = __webpack_require__(619);

function publicProfilePageRequest() {
  return { type: _constants.SETTING_PUBLIC_PROFILE_PAGE_REQUEST, payload: {} };
}

function changeFormPublicProfile(profile) {
  return { type: _constants.SETTING_PUBLIC_PROFILE_CHANGE_FORM, payload: { profile: profile } };
}

function publicProfileRequest(data) {
  return { type: _constants.SETTING_PUBLIC_PROFILE_REQUEST, payload: { data: data } };
}

function discardChange(location) {
  return { type: _constants.SETTING_PUBLIC_PROFILE_DISCARD_CHANGE, payload: { location: location } };
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewImageRequest = getNewImageRequest;
exports.setUploadImage = setUploadImage;
exports.saveUploadImage = saveUploadImage;
exports.getLoadingImage = getLoadingImage;
exports.uploadImageRequest = uploadImageRequest;
exports.setTemporaryImage = setTemporaryImage;
exports.deleteImage = deleteImage;

var _constants = __webpack_require__(287);

function getNewImageRequest(filename) {
  return { type: _constants.GET_NEW_IMAGE_REQUEST, payload: { filename: filename } };
}

function setUploadImage(filename) {
  return { type: _constants.SET_UPLOAD_IMAGE, payload: { filename: filename } };
}

function saveUploadImage(filename) {
  return { type: _constants.SAVE_UPLOAD_IMAGE, payload: { filename: filename } };
}

function getLoadingImage() {
  return { type: _constants.GET_LOADING_IMAGE, payload: {} };
}

function uploadImageRequest(file) {
  return { type: _constants.UPLOAD_IMAGE_REQUEST, payload: { file: file } };
}

function setTemporaryImage(data) {
  return { type: _constants.SET_TEMP_IMG, payload: { tempFileUrl: data } };
}

function deleteImage(deleted) {
  return { type: _constants.DELETE_IMAGE, payload: { deleted: deleted } };
}

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.settingAccount = settingAccount;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function settingAccount(data) {
  return axios.put(_constants.SETTING_ACCOUNT, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_OUTLETS = exports.CANCEL_SUBSCRIPTION = exports.FEATURE_SUBSCRIPTION_PRICE = exports.VERIFY_BILLING = exports.SUBSCRIPTION_STATUS = exports.RULES = exports.OUTLETS = exports.BILLINGS = undefined;

var _constants = __webpack_require__(30);

var BILLINGS = exports.BILLINGS = _constants.API_URL + '/v1/billings'; /**
                                                                        * Created by alvinoktavianus on 5/9/17.
                                                                        */

var OUTLETS = exports.OUTLETS = _constants.API_URL + '/v1/outlets';
var RULES = exports.RULES = _constants.API_URL + '/v1/billings/rules';
var SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_STATUS = _constants.API_URL + '/v1/feature/get_subscription_status';
var VERIFY_BILLING = exports.VERIFY_BILLING = _constants.API_URL + '/v1/billings/verify';
var FEATURE_SUBSCRIPTION_PRICE = exports.FEATURE_SUBSCRIPTION_PRICE = _constants.API_URL + '/v1/feature/get_feature_price_per_months';
var CANCEL_SUBSCRIPTION = exports.CANCEL_SUBSCRIPTION = _constants.API_URL + '/v1/feature/cancel_subscription';
var ALL_OUTLETS = exports.ALL_OUTLETS = _constants.API_URL + '/v1/outlets?with_inactive=true';

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.updatePaymentStatus = updatePaymentStatus;

var _constant = __webpack_require__(1060);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updatePaymentStatus(params) {
  return axios.get(_constant.UPDATE_PAYMENT_STATUS, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
} /**
   * Created by alvinoktavianus on 6/21/17.
   */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PAYMENT_STATUS = undefined;

var _constants = __webpack_require__(30);

var UPDATE_PAYMENT_STATUS = exports.UPDATE_PAYMENT_STATUS = _constants.HOST_URL + '/billings/update_payment_status'; /**
                                                                                                                      * Created by alvinoktavianus on 6/21/17.
                                                                                                                      */

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.serviceAccountSuccessCallback = serviceAccountSuccessCallback;
exports.serviceAccountErrorCallback = serviceAccountErrorCallback;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Why there are so many callbacks exists?
 * Because they don't want to standardize it.
 */

/**
 * 20x callback with json format from moka-service-auth a.k.a /account api
 * @param response
 * @return {Promise.<T>}
 */
function serviceAccountSuccessCallback(response) {
  return _promise2.default.resolve(response);
}

/**
 * 4xx/5xx callback with json format from moka-service-auth a.k.a /account api
 * @param error
 * @return {Promise.<T>}
 */
function serviceAccountErrorCallback(error) {
  if (error.response && error.response.data) {
    var data = error.response.data;
    // default error message
    var message = error.message;

    if (data.error && data.error.user_message) {
      message = data.error.user_message;
    } else if (data.message) {
      message = data.message;
    } else if (typeof data.error === 'string') {
      message = data.error;
    }
    return _promise2.default.reject({
      message: message,
      data: data
    });
  } else {
    return _promise2.default.reject({
      message: error.message
    });
  }
}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSummary = getSummary;
exports.getShifts = getShifts;
exports.exportShift = exportShift;
exports.getShiftDetails = getShiftDetails;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSummary(queryParams) {
  return axios.get(_constants.CASH_DRAWER_SHIFT_SUMMARY, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getShifts(queryParams) {
  return axios.get(_constants.CASH_DRAWER_LIST_SHIFT, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/cash_drawer/shifts_controller.rb#L87
 * @param {object} query
 * @return {Axios.IPromise<U>}
 */
function exportShift(query) {
  return axios.get(_constants.CASH_DRAWER_EXPORT_SHIFT, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      return _promise2.default.reject(new Error(error.response.data.errors));
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getShiftDetails(shiftId, query) {
  return axios.get((0, _constants.CASH_DRAWER_SHIFT_DETAILS)(shiftId), { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_CATEGORIES_WITH_UNCATEGORIZED = exports.ASSIGN_TO_ITEM = exports.CATEGORY_ALL_OUTLETS = exports.V1_CATEGORY_BY_ID = exports.LIBRARY_CATEGORIES_V1 = exports.LIBRARY_CATEGORIES = undefined;

var _constants = __webpack_require__(30);

var LIBRARY_CATEGORIES = exports.LIBRARY_CATEGORIES = _constants.API_URL + '/v2/categories';
var LIBRARY_CATEGORIES_V1 = exports.LIBRARY_CATEGORIES_V1 = _constants.API_URL + '/v1/categories';
var V1_CATEGORY_BY_ID = exports.V1_CATEGORY_BY_ID = function V1_CATEGORY_BY_ID(id) {
  return _constants.API_URL + '/v1/categories/' + id;
};
var CATEGORY_ALL_OUTLETS = exports.CATEGORY_ALL_OUTLETS = _constants.API_URL + '/v1/categories/create_all_outlet';
var ASSIGN_TO_ITEM = exports.ASSIGN_TO_ITEM = function ASSIGN_TO_ITEM(id) {
  return _constants.API_URL + '/v1/categories/' + id + '/move_items';
};
var V1_CATEGORIES_WITH_UNCATEGORIZED = exports.V1_CATEGORIES_WITH_UNCATEGORIZED = _constants.API_URL + '/v1/categories/with_uncategorized';

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCategories = getCategories;
exports.getCategoriesWithUncategorized = getCategoriesWithUncategorized;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCategories() {
  return axios.get(_constants.LIST_CATEGORY_URL, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getCategoriesWithUncategorized() {
  return axios.get(_constants.LIST_CATEGORY_WITH_UNCATEGORIZED_URL, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCheckoutSetting = getCheckoutSetting;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/users_controller.rb#L34
 * @return {Axios.IPromise<U>}
 */
function getCheckoutSetting(query) {
  return axios.get(_constants.CHECKOUT_SETTING, { params: { query: query }, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.confirmEmployeeInvitation = confirmEmployeeInvitation;

var _constants = __webpack_require__(1067);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function confirmEmployeeInvitation(data) {
  return axios.post(_constants.CONFIRM_EMPLOYEE, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKEND_HOST = "https://experiment-taxitem.mokapos.com";
var BACKEND_PORT = "443";
var HOST = BACKEND_HOST + ":" + BACKEND_PORT;

var CONFIRM_EMPLOYEE = exports.CONFIRM_EMPLOYEE = HOST + "/confirm_employee";

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENT_INVENTORY_DROPDOWN = undefined;

var _constants = __webpack_require__(30);

var CURRENT_INVENTORY_DROPDOWN = exports.CURRENT_INVENTORY_DROPDOWN = _constants.API_URL + '/v1/current_inventory_dropdown';

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCustomerFeedbacks = getCustomerFeedbacks;
exports.getFeedbackMessages = getFeedbackMessages;
exports.submitReply = submitReply;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get customer feedbacks
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L8
 * @param start, end, page
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getCustomerFeedbacks(queryparams) {
  return axios.get(_constants.LIST_CUSTOMER_FEEDBACK_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Get customer feedback messages
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L43
 * @param ID feedback
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function getFeedbackMessages(id, queryparams) {
  return axios.get((0, _constants.FEEDBACK_MESSAGES)(id), { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

/**
 * Send customer feedback to server
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L19
 * @param comment, feedback_id
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */

function submitReply(data) {
  return axios.post(_constants.SUBMIT_REPLY_URL, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.response.data.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POINT_ACTIVITIES = exports.REDEMPTION_HISTORIES = exports.CUSTOMERS_SUBMIT_FEEDBACK = exports.CUSTOMERS_EXPORT = exports.CUSTOMERS_DOWNLOAD_TEMPLATE = exports.CUSTOMERS = undefined;
exports.CUSTOMER_DETAIL = CUSTOMER_DETAIL;

var _constants = __webpack_require__(30);

var CUSTOMERS = exports.CUSTOMERS = _constants.MOKA_SERVICE_URL + '/customer/v1/customers';
function CUSTOMER_DETAIL(customerId) {
  return _constants.MOKA_SERVICE_URL + '/customer/v1/customers/' + customerId;
}
var CUSTOMERS_DOWNLOAD_TEMPLATE = exports.CUSTOMERS_DOWNLOAD_TEMPLATE = _constants.API_URL + '/v1/customers/import_customers_template';
var CUSTOMERS_EXPORT = exports.CUSTOMERS_EXPORT = _constants.MOKA_SERVICE_URL + '/customer/v1/customers/export';
var CUSTOMERS_SUBMIT_FEEDBACK = exports.CUSTOMERS_SUBMIT_FEEDBACK = _constants.API_URL + '/v1/customers/submit_feedback';
var REDEMPTION_HISTORIES = exports.REDEMPTION_HISTORIES = function REDEMPTION_HISTORIES(customerId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/customers/' + customerId + '/redemptions';
};
var POINT_ACTIVITIES = exports.POINT_ACTIVITIES = function POINT_ACTIVITIES(customerId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/customers/' + customerId + '/point-activities';
};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEACTIVATE_LOYALTY = exports.REACTIVATE_LOYALTY = exports.RESET_LOYALTY = exports.EDIT_LOYALTY = exports.CREATE_LOYALTY = exports.GET_LOYALTY = exports.ADD_SUBSCRIPTION = undefined;

var _constants = __webpack_require__(30);

var ADD_SUBSCRIPTION = exports.ADD_SUBSCRIPTION = _constants.API_URL + '/v1/feature/add_subscription';
var GET_LOYALTY = exports.GET_LOYALTY = function GET_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs';
};
var CREATE_LOYALTY = exports.CREATE_LOYALTY = function CREATE_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs';
};
var EDIT_LOYALTY = exports.EDIT_LOYALTY = function EDIT_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs';
};
var RESET_LOYALTY = exports.RESET_LOYALTY = function RESET_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs/reset';
};
var REACTIVATE_LOYALTY = exports.REACTIVATE_LOYALTY = function REACTIVATE_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs/reactivate';
};
var DEACTIVATE_LOYALTY = exports.DEACTIVATE_LOYALTY = function DEACTIVATE_LOYALTY(businessId) {
  return _constants.MOKA_SERVICE_URL + '/loyalty/v1/programs/deactivate';
};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getLoyalty = getLoyalty;
exports.createLoyalty = createLoyalty;
exports.editLoyalty = editLoyalty;
exports.resetLoyalty = resetLoyalty;
exports.deactivateLoyalty = deactivateLoyalty;
exports.reactivateLoyalty = reactivateLoyalty;
exports.addSubscription = addSubscription;

var _constants = __webpack_require__(1071);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getLoyalty(businessId) {
  return axios.get((0, _constants.GET_LOYALTY)(businessId)).then(function (res) {
    // return new Promise(resolve => setTimeout(() => resolve(res), 3000))
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function createLoyalty(businessId, data) {
  return axios.post((0, _constants.CREATE_LOYALTY)(businessId), data).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data = error.response.data;
      if (_data.errors) {
        errorObj = new Error(_data.errors);
      } else if (_data.message) {
        errorObj = new Error(_data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function editLoyalty(businessId, data) {
  return axios.put((0, _constants.EDIT_LOYALTY)(businessId), data).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data2 = error.response.data;
      if (_data2.errors) {
        errorObj = new Error(_data2.errors);
      } else if (_data2.message) {
        errorObj = new Error(_data2.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function resetLoyalty(businessId, data) {
  return axios.patch((0, _constants.RESET_LOYALTY)(businessId), data).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data3 = error.response.data;
      if (_data3.errors) {
        errorObj = new Error(_data3.errors);
      } else if (_data3.message) {
        errorObj = new Error(_data3.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function deactivateLoyalty(businessId) {
  return axios.patch((0, _constants.DEACTIVATE_LOYALTY)(businessId)).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function reactivateLoyalty(businessId, data) {
  var url = (0, _constants.REACTIVATE_LOYALTY)(businessId);
  if (data.reset) {
    url = url + '?reset=' + data.reset;
  }
  return axios.patch(url).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var _data4 = error.response.data;
      if (_data4.errors) {
        errorObj = new Error(_data4.errors);
      } else if (_data4.message) {
        errorObj = new Error(_data4.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}

function addSubscription() {
  return axios.put(_constants.ADD_SUBSCRIPTION, {
    feature_name: 'Loyalty'
  }, { withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var errorObj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        errorObj = new Error(data.errors);
      } else if (data.message) {
        errorObj = new Error(data.message);
      } else {
        errorObj = new Error(error.message);
      }
    } else {
      errorObj = new Error(error.message);
    }
    return _promise2.default.reject(errorObj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.dashboard = dashboard;
exports.loggedIn = loggedIn;

var _constants = __webpack_require__(30);

var api = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = __webpack_require__(199);

function dashboard(query) {
  if (!loggedIn()) return _promise2.default.reject(new Error('Not logged in'));
  return axios.get(api.GET_DASHBOARD, { params: query, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}

function loggedIn() {
  var loggedInData = store.get('response:login');
  var cookiesData = Cookies.get('remember_token');

  if (isLocalStorageNameSupported()) {
    if (!loggedInData || !cookiesData) {
      resetLoggedIn();
      return false;
    }

    try {
      JSON.parse(loggedInData).user;
      return true;
    } catch (e) {
      resetLoggedIn();
      return false;
    }
  } else {
    if (!cookiesData) {
      resetLoggedIn();
      return false;
    } else {
      return true;
    }
  }
}

function resetLoggedIn() {
  Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' });
  store.clearAll();
}

function isLocalStorageNameSupported() {
  var testKey = 'test';
  var storage = window.localStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(65)))

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.postEmailReceipt = postEmailReceipt;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {email,payment_id,resend_email} data
 * @return {Axios.IPromise<U>}
 */
function postEmailReceipt(data) {
  return axios.post(_constants.EMAIL_RECEIPT, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESEND_INVITATION = exports.ASSIGNED_STAFF = exports.EMPLOYEES = undefined;
exports.EMPLOYEE = EMPLOYEE;

var _constants = __webpack_require__(30);

var EMPLOYEES = exports.EMPLOYEES = _constants.API_URL + '/v1/employees';
var ASSIGNED_STAFF = exports.ASSIGNED_STAFF = _constants.API_URL + '/v1/employees/get_assigned_staff';
/**
 * @return {string}
 */
function EMPLOYEE(id) {
  return _constants.API_URL + '/v1/employees/' + id;
}

var RESEND_INVITATION = exports.RESEND_INVITATION = _constants.API_URL + '/v1/employees/resend_invitation';

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getEmployees = getEmployees;
exports.getAssignedStaffV1 = getAssignedStaffV1;
exports.deleteEmployee = deleteEmployee;
exports.postEmployee = postEmployee;
exports.resendInvitation = resendInvitation;

var _constants = __webpack_require__(1075);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L13
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
function getEmployees(params) {
  return axios.get(_constants.EMPLOYEES, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getAssignedStaffV1(params) {
  return axios.get(_constants.ASSIGNED_STAFF, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (err) {
    return _promise2.default.reject(err.response);
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L95
 * @param employeeId
 * @param params
 */
function deleteEmployee(employeeId, params) {
  return axios.delete((0, _constants.EMPLOYEE)(employeeId), { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var data = error.response.data;

      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L85
 * @param {object} data
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
function postEmployee(data, params) {
  return axios.post(_constants.EMPLOYEES, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var _data = error.response.data;

      if (_data.errors) {
        eobj = new Error(_data.errors);
      } else if (_data.message) {
        eobj = new Error(_data.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}
/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L102
 * @param data
 * @param params
 * @return {Axios.IPromise<U>}
 */
function resendInvitation(data, params) {
  return axios.post(_constants.RESEND_INVITATION, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    if (error.response) {
      var eobj = void 0;
      var _data2 = error.response.data;

      if (_data2.errors) {
        eobj = new Error(_data2.errors);
      } else if (_data2.message) {
        eobj = new Error(_data2.message);
      } else {
        eobj = new Error(error.message);
      }
      return _promise2.default.reject(eobj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getFeaturePrice = getFeaturePrice;

var _constants = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFeaturePrice(data, params) {
  return axios.post(_constants.GET_FEATURE_PRICE, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
} /**
   * Created by alvinoktavianus on 6/27/17.
   */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getFeaturePricePerMonths = getFeaturePricePerMonths;

var _constants = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFeaturePricePerMonths(data, params) {
  return axios.post(_constants.GET_FEATURE_PRICE_PER_MONTHS, data, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(error);
  });
} /**
   * Created by alvinoktavianus on 6/27/17.
   */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.startTrial = startTrial;

var _constants = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startTrial(featureData, params) {
  return axios.put(_constants.ACTIVATE_TRIAL, featureData, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (reject) {
    return _promise2.default.reject(reject);
  });
} /**
   * Created by alvinoktavianus on 6/29/17.
   */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_FEEDBACK_REPLY_FORM = exports.CHECK_TOKEN_FEEDBACK_URL = undefined;
exports.GET_FEEDBACK_REPLY_FORM = GET_FEEDBACK_REPLY_FORM;

var _constants = __webpack_require__(30);

var CHECK_TOKEN_FEEDBACK_URL = exports.CHECK_TOKEN_FEEDBACK_URL = _constants.API_URL + '/v1/customers/check_feedback_token';
var SEND_FEEDBACK_REPLY_FORM = exports.SEND_FEEDBACK_REPLY_FORM = _constants.API_URL + '/v1/customers/reply_feedback_to_business';
function GET_FEEDBACK_REPLY_FORM(feedbackId) {
  return _constants.API_URL + '/v1/customer_feedbacks/' + feedbackId + '/feedback_messages';
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKEND_HOST = "https://experiment-taxitem.mokapos.com";
var BACKEND_PORT = "443";
var HOST = BACKEND_HOST + ":" + BACKEND_PORT;

var GET_EMPLOYEE = exports.GET_EMPLOYEE = HOST + "/get_employee";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getEmployee = getEmployee;

var _constants = __webpack_require__(1081);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getEmployee(params) {
  return axios.get(_constants.GET_EMPLOYEE, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_ALL_OUTLET = exports.GRATUITY_BY_ID = exports.V1_GRATUITIES = exports.GRATUITIES = undefined;

var _constants = __webpack_require__(30);

var GRATUITIES = exports.GRATUITIES = _constants.API_URL + '/v2/gratuities';

var V1_GRATUITIES = exports.V1_GRATUITIES = _constants.API_URL + '/v1/gratuities';
var GRATUITY_BY_ID = exports.GRATUITY_BY_ID = function GRATUITY_BY_ID(id) {
  return _constants.API_URL + '/v1/gratuities/' + id;
};
var CREATE_ALL_OUTLET = exports.CREATE_ALL_OUTLET = _constants.API_URL + '/v1/gratuities/create_all_outlet';

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getGratuities = getGratuities;
exports.getGratutityById = getGratutityById;
exports.postGratuity = postGratuity;
exports.deleteGratuity = deleteGratuity;
exports.putGratuity = putGratuity;
exports.postCreateAllOutlet = postCreateAllOutlet;

var _constants = __webpack_require__(1083);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/gratuities_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getGratuities(params) {
  return axios.get(_constants.GRATUITIES, { withCredentials: true, params: params }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

/**
 * https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/gratuities_controller.rb#L26
 * @param id
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getGratutityById(id, params) {
  return axios.get((0, _constants.GRATUITY_BY_ID)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postGratuity(data, params) {
  return axios.post(_constants.V1_GRATUITIES, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data = error.response.data;
      if (_data.errors) {
        eobj = new Error(_data.errors);
      } else if (_data.message) {
        eobj = new Error(_data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function deleteGratuity(id, params) {
  return axios.delete((0, _constants.GRATUITY_BY_ID)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function putGratuity(id, data, params) {
  return axios.put((0, _constants.GRATUITY_BY_ID)(id), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data2 = error.response.data;
      if (_data2.errors) {
        eobj = new Error(_data2.errors);
      } else if (_data2.message) {
        eobj = new Error(_data2.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postCreateAllOutlet(data, params) {
  return axios.post(_constants.CREATE_ALL_OUTLET, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data3 = error.response.data;
      if (_data3.errors) {
        eobj = new Error(_data3.errors);
      } else if (_data3.message) {
        eobj = new Error(_data3.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT = exports.V1_CREATE_ALL_OUTLET = exports.V1_INGREDIENT_CATEGORY_BY_ID = exports.V1_INGREDIENT_CATEGORIES = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/ingredient_categories';

var V1_INGREDIENT_CATEGORIES = exports.V1_INGREDIENT_CATEGORIES = '' + V1_URL;

var V1_INGREDIENT_CATEGORY_BY_ID = exports.V1_INGREDIENT_CATEGORY_BY_ID = function V1_INGREDIENT_CATEGORY_BY_ID(id) {
  return V1_URL + '/' + id;
};

var V1_CREATE_ALL_OUTLET = exports.V1_CREATE_ALL_OUTLET = V1_INGREDIENT_CATEGORIES + '/create_all_outlet';

var V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT = exports.V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT = function V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT(id) {
  return V1_INGREDIENT_CATEGORIES + '/' + id + '/assigns';
};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getCategories = getCategories;
exports.postCategory = postCategory;
exports.putCategory = putCategory;
exports.deleteCategory = deleteCategory;
exports.postCreateAllOutlet = postCreateAllOutlet;
exports.assignToIngredient = assignToIngredient;

var _constants = __webpack_require__(1085);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getCategories(params) {
  return axios.get(_constants.V1_INGREDIENT_CATEGORIES, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postCategory(data, params) {
  return axios.post(_constants.V1_INGREDIENT_CATEGORIES, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function putCategory(id, data, params) {
  return axios.put((0, _constants.V1_INGREDIENT_CATEGORY_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function deleteCategory(id, params) {
  return axios.delete((0, _constants.V1_INGREDIENT_CATEGORY_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postCreateAllOutlet(data, params) {
  return axios.post(_constants.V1_CREATE_ALL_OUTLET, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function assignToIngredient(id, data, params) {
  return axios.put((0, _constants.V1_INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getAdjustments = getAdjustments;
exports.getExportAdjustment = getExportAdjustment;
exports.postAdjustment = postAdjustment;

var _constants = __webpack_require__(625);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getAdjustments(params) {
  return axios.get(_constants.V1_ADJUSTMENTS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportAdjustment(params) {
  return axios.get(_constants.V1_EXPORT_ADJUSTMENT, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postAdjustment(data, params) {
  return axios.post(_constants.V1_ADJUSTMENTS, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSummary = getSummary;
exports.getExportSummary = getExportSummary;
exports.getSuppliers = getSuppliers;
exports.getExportSupplier = getExportSupplier;
exports.deleteSupplier = deleteSupplier;
exports.putSupplier = putSupplier;
exports.postSuppliers = postSuppliers;
exports.getAdjustments = getAdjustments;
exports.getExportAdjustment = getExportAdjustment;

var _constants = __webpack_require__(430);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getSummary(params) {
  return axios.get(_constants.V1_SUMMARY, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportSummary(params) {
  return axios.get(_constants.V1_EXPORT_SUMMARY, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getSuppliers(params) {
  return axios.get(_constants.V1_SUPPLIER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportSupplier(params) {
  return axios.get(_constants.V1_EXPORT_SUPPLIER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function deleteSupplier(id, params) {
  return axios.delete((0, _constants.V1_SUPPLIER_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function putSupplier(id, data, params) {
  return axios.put((0, _constants.V1_SUPPLIER_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postSuppliers(data, params) {
  return axios.post(_constants.V1_SUPPLIER, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getAdjustments(params) {
  return axios.get(_constants.V1_ADJUSTMENTS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportAdjustment(params) {
  return axios.get(_constants.V1_EXPORT_ADJUSTMENT, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_UPDATE_PURCHASE_ORDER = exports.V1_EDIT_PURCHASE_ORDER = exports.V1_CREATE_AND_FULFILLED = exports.V1_RESEND_EMAIL_PURCHASE_ORDER = exports.V1_PRINT_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER_BY_ID = exports.V1_EXPORT_PURCHASE_ORDER = exports.V1_SEARCH_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER = undefined;

var _constants = __webpack_require__(430);

var V1_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER = _constants.V1_URL + '/purchase_orders'; /**
                                                                                             * Created by emhaje-workspace on 6/14/17.
                                                                                             */
var V1_SEARCH_PURCHASE_ORDER = exports.V1_SEARCH_PURCHASE_ORDER = V1_PURCHASE_ORDER + '/search';

var V1_EXPORT_PURCHASE_ORDER = exports.V1_EXPORT_PURCHASE_ORDER = V1_PURCHASE_ORDER + '/export';

var V1_PURCHASE_ORDER_BY_ID = exports.V1_PURCHASE_ORDER_BY_ID = function V1_PURCHASE_ORDER_BY_ID(id) {
  return V1_PURCHASE_ORDER + '/' + id + '.json';
};

var V1_PRINT_PURCHASE_ORDER = exports.V1_PRINT_PURCHASE_ORDER = function V1_PRINT_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '.pdf';
};

var V1_RESEND_EMAIL_PURCHASE_ORDER = exports.V1_RESEND_EMAIL_PURCHASE_ORDER = function V1_RESEND_EMAIL_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '/resend_email';
};

var V1_CREATE_AND_FULFILLED = exports.V1_CREATE_AND_FULFILLED = V1_PURCHASE_ORDER + '/create_and_fulfilled';

var V1_EDIT_PURCHASE_ORDER = exports.V1_EDIT_PURCHASE_ORDER = function V1_EDIT_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '/edit.json';
};

var V1_UPDATE_PURCHASE_ORDER = exports.V1_UPDATE_PURCHASE_ORDER = function V1_UPDATE_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id;
};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getPurchaseOrders = getPurchaseOrders;
exports.getSearchPurchaseOrders = getSearchPurchaseOrders;
exports.getPurchaseOrderById = getPurchaseOrderById;
exports.getExportPurchaseOrder = getExportPurchaseOrder;
exports.printPurchaseOrder = printPurchaseOrder;
exports.resendEmailPurchaseOrder = resendEmailPurchaseOrder;
exports.postPurchaseOrder = postPurchaseOrder;
exports.createAndfullfilled = createAndfullfilled;
exports.getEditDataPO = getEditDataPO;
exports.updateDataPO = updateDataPO;

var _constant = __webpack_require__(1089);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
} /**
   * Created by emhaje-workspace on 6/14/17.
   */


function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getPurchaseOrders(params) {
  return axios.get(_constant.V1_PURCHASE_ORDER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getSearchPurchaseOrders(params) {
  return axios.get(_constant.V1_SEARCH_PURCHASE_ORDER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getPurchaseOrderById(id, params) {
  return axios.get((0, _constant.V1_PURCHASE_ORDER_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportPurchaseOrder(params) {
  return axios.get(_constant.V1_EXPORT_PURCHASE_ORDER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function printPurchaseOrder(id) {
  return window.open((0, _constant.V1_PRINT_PURCHASE_ORDER)(id));
}

function resendEmailPurchaseOrder(id, data, params) {
  return axios.post((0, _constant.V1_RESEND_EMAIL_PURCHASE_ORDER)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postPurchaseOrder(data) {
  return axios.post(_constant.V1_PURCHASE_ORDER, data, { withCredentials: true }).then(resolve).catch(reject);
}

function createAndfullfilled(data) {
  return axios.post(_constant.V1_CREATE_AND_FULFILLED, data, { withCredentials: true }).then(resolve).catch(reject);
}

function getEditDataPO(id) {
  return axios.get((0, _constant.V1_EDIT_PURCHASE_ORDER)(id), { withCredentials: true }).then(resolve).catch(reject);
}

function updateDataPO(id, data) {
  return axios.put((0, _constant.V1_UPDATE_PURCHASE_ORDER)(id), data, { withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT = exports.V1_TRANSFERS = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/ingredients_inventory';
var V1_TRANSFERS = exports.V1_TRANSFERS = V1_URL + '/transfer';
var V1_EXPORT = exports.V1_EXPORT = V1_TRANSFERS + '/export';

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getTransfers = getTransfers;
exports.postTransfers = postTransfers;
exports.getExportTransfer = getExportTransfer;

var _constants = __webpack_require__(1091);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getTransfers(params) {
  return axios.get(_constants.V1_TRANSFERS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postTransfers(data, params) {
  return axios.post(_constants.V1_TRANSFERS, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportTransfer(params) {
  return axios.get(_constants.V1_EXPORT, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_HAVE_RECIPE = exports.V1_ALL = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/ingredients';

var V1_ALL = exports.V1_ALL = V1_URL + '/all';

var V1_HAVE_RECIPE = exports.V1_HAVE_RECIPE = V1_URL + '/have_recipe';

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getExportLibrary = getExportLibrary;
exports.getUnits = getUnits;
exports.getCategoriesWithUncategorized = getCategoriesWithUncategorized;
exports.getLibraryTemplate = getLibraryTemplate;
exports.getLibraries = getLibraries;
exports.getLibraryById = getLibraryById;
exports.getSummary = getSummary;
exports.putLibraryById = putLibraryById;
exports.postLibrary = postLibrary;
exports.postCreateAllOutletLibrary = postCreateAllOutletLibrary;
exports.updateImageById = updateImageById;
exports.deleteLibraryByIdV1 = deleteLibraryByIdV1;
exports.createIngredientCategory = createIngredientCategory;

var _constants = __webpack_require__(431);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolve = function resolve(response) {
  return _promise2.default.resolve(response);
};

var reject = function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
};

function getExportLibrary(params) {
  return axios.get(_constants.LIBRARIES_EXPORT, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getUnits() {
  return axios.get(_constants.LIBRARY_GET_UNITS, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response.data);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getCategoriesWithUncategorized() {
  return axios.get(_constants.INGREDIENT_WITH_UNCATEGORY, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getLibraryTemplate() {
  return axios.get(_constants.LIBRARYS_TEMPLATE, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function getLibraries(queryparams) {
  return axios.get(_constants.LIST_LIBRARY_URL, { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response.data.results);
  }).catch(function (error) {
    // TODO low show the error message maybe?
    if (error.response) {
      var obj = new Error(new Error(error.message));
      obj.status = error.response.status;
      return _promise2.default.reject(obj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getLibraryById(id, queryparams) {
  return axios.get((0, _constants.LIBRARY_BY_ID)(id), { params: queryparams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response.data);
  }).catch(function (error) {
    // TODO low show the error message maybe?
    if (error.response) {
      var obj = new Error(new Error(error.message));
      obj.status = error.response.status;
      return _promise2.default.reject(obj);
    } else {
      return _promise2.default.reject(new Error(error.message));
    }
  });
}

function getSummary(queryParams) {
  return axios.get(_constants.LIBRARY_SUMMARY_URL, { params: queryParams, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function putLibraryById(id, data, params) {
  return axios.put((0, _constants.LIBRARY_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postLibrary(data, params) {
  return axios.post(_constants.CREATE_LIBRARY, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postCreateAllOutletLibrary(data, params) {
  return axios.post(_constants.CREATE_ALL_OUTLET_LIBRARY, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function updateImageById(id, data, params) {
  return axios.put((0, _constants.UPDATE_LIBRARY_BY_ID)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function deleteLibraryByIdV1(id, params) {
  return axios.delete((0, _constants.DELETE_LIBRARY_BY_ID_V1)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function createIngredientCategory(data) {
  return axios.post(_constants.INGREDIENT_CREATE_CATEGORY, data, { withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_RECIPE_BY_VARIANT_ID = exports.UPDATE_RECIPES_ALL_OUTLET = exports.UPDATE_RECIPES = exports.CREATE_ALL_OUTLET_RECIPES = exports.CREATE_RECIPES = exports.DELETE_RECIPES_BY_ID = exports.GET_ITEM_INGREDIENT = exports.GET_ITEM_VARIANT = exports.V1_GET_ITEM_DROPDOWN = exports.V1_EXPORT_RECIPES = exports.V1_IMPORT_RECIPES_TEMPLATE = exports.V1_RECIPES = undefined;

var _constants = __webpack_require__(30);

var V1_RECIPES = exports.V1_RECIPES = _constants.API_URL + '/v1/recipes';
var V1_IMPORT_RECIPES_TEMPLATE = exports.V1_IMPORT_RECIPES_TEMPLATE = V1_RECIPES + '/import_recipes_template';
var V1_EXPORT_RECIPES = exports.V1_EXPORT_RECIPES = V1_RECIPES + '/export';
var V1_GET_ITEM_DROPDOWN = exports.V1_GET_ITEM_DROPDOWN = _constants.API_URL + '/v1/items/item_dropdowns';
var GET_ITEM_VARIANT = exports.GET_ITEM_VARIANT = function GET_ITEM_VARIANT(id) {
  return _constants.API_URL + '/v1/recipes/item_variants/' + id;
};
var GET_ITEM_INGREDIENT = exports.GET_ITEM_INGREDIENT = function GET_ITEM_INGREDIENT(page, perPage, keyword) {
  return _constants.API_URL + '/v1/ingredients?page=' + page + '&per_page=' + perPage + '&keyword=' + keyword;
};
var DELETE_RECIPES_BY_ID = exports.DELETE_RECIPES_BY_ID = function DELETE_RECIPES_BY_ID(id) {
  return _constants.API_URL + '/v1/recipes/' + id;
};
var CREATE_RECIPES = exports.CREATE_RECIPES = _constants.API_URL + '/v1/recipes';
var CREATE_ALL_OUTLET_RECIPES = exports.CREATE_ALL_OUTLET_RECIPES = _constants.API_URL + '/v1/recipes/create_all_outlets';
var UPDATE_RECIPES = exports.UPDATE_RECIPES = function UPDATE_RECIPES(id) {
  return _constants.API_URL + '/v1/recipes/' + id;
};
var UPDATE_RECIPES_ALL_OUTLET = exports.UPDATE_RECIPES_ALL_OUTLET = function UPDATE_RECIPES_ALL_OUTLET(id) {
  return _constants.API_URL + '/v1/recipes/' + id + '/update_all_outlets';
};
var GET_RECIPE_BY_VARIANT_ID = exports.GET_RECIPE_BY_VARIANT_ID = function GET_RECIPE_BY_VARIANT_ID(id) {
  return _constants.API_URL + '/v1/recipes/item_variant/' + id;
};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.postRecipes = postRecipes;
exports.getRecipes = getRecipes;
exports.getExportRecipes = getExportRecipes;
exports.getItemDropdown = getItemDropdown;
exports.getItemIngredient = getItemIngredient;
exports.getItemVariant = getItemVariant;
exports.deleteRecipesById = deleteRecipesById;
exports.createRecipes = createRecipes;
exports.updateRecipes = updateRecipes;
exports.updateRecipesAllOutlet = updateRecipesAllOutlet;
exports.createRecipesAllOutlet = createRecipesAllOutlet;
exports.getRecipesByVariantId = getRecipesByVariantId;

var _constants = __webpack_require__(1095);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function postRecipes(data, params) {
  return axios.post(_constants.V1_RECIPES, data, { withCredentials: true, params: params }).then(resolve).catch(reject);
}

function getRecipes(params) {
  return axios.get(_constants.V1_RECIPES, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportRecipes(params) {
  return axios.get(_constants.V1_EXPORT_RECIPES, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getItemDropdown() {
  return axios.get(_constants.V1_GET_ITEM_DROPDOWN, { withCredentials: true }).then(resolve).catch(reject);
}

function getItemIngredient(params) {
  var page = params.page,
      per_page = params.per_page,
      keyword = params.keyword;

  return axios.get((0, _constants.GET_ITEM_INGREDIENT)(page, per_page, keyword), { withCredentials: true }).then(resolve).catch(reject);
}

function getItemVariant(selectedItem) {
  return axios.get((0, _constants.GET_ITEM_VARIANT)(selectedItem), { withCredentials: true }).then(resolve).catch(reject);
}

function deleteRecipesById(id) {
  return axios.delete((0, _constants.DELETE_RECIPES_BY_ID)(id), { withCredentials: true }).then(resolve).catch(reject);
}

function createRecipes(data) {
  return axios.post(_constants.CREATE_RECIPES, data, { withCredentials: true }).then(resolve).catch(reject);
}

function updateRecipes(id, data) {
  return axios.put((0, _constants.UPDATE_RECIPES)(id), data, { withCredentials: true }).then(resolve).catch(reject);
}

function updateRecipesAllOutlet(id, data) {
  return axios.put((0, _constants.UPDATE_RECIPES_ALL_OUTLET)(id), data, { withCredentials: true }).then(resolve).catch(reject);
}

function createRecipesAllOutlet(data) {
  return axios.post(_constants.CREATE_ALL_OUTLET_RECIPES, data, { withCredentials: true }).then(resolve).catch(reject);
}

function getRecipesByVariantId(id) {
  return axios.get((0, _constants.GET_RECIPE_BY_VARIANT_ID)(id), { withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.postAdjustment = postAdjustment;
exports.getAdjustments = getAdjustments;
exports.getExportAdjustment = getExportAdjustment;

var _constants = __webpack_require__(626);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function postAdjustment(data, params) {
  return axios.post(_constants.V1_ADJUSTMENT, data, { withCredentials: true, params: params }).then(resolve).catch(reject);
}

function getAdjustments(params) {
  return axios.get(_constants.V1_ADJUSTMENT, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportAdjustment(params) {
  return axios.get(_constants.V1_EXPORT_ADJUSTMENT, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_UPDATE_PURCHASE_ORDER = exports.V1_EDIT_PURCHASE_ORDER = exports.V1_CREATE_AND_FULFILLED = exports.V1_RESEND_EMAIL_PURCHASE_ORDER = exports.V1_PRINT_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER_BY_ID = exports.V1_EXPORT_PURCHASE_ORDER = exports.V1_SEARCH_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER = undefined;

var _constants = __webpack_require__(432);

var V1_PURCHASE_ORDER = exports.V1_PURCHASE_ORDER = _constants.V1_URL + '/purchase_orders';

var V1_SEARCH_PURCHASE_ORDER = exports.V1_SEARCH_PURCHASE_ORDER = V1_PURCHASE_ORDER + '/search';

var V1_EXPORT_PURCHASE_ORDER = exports.V1_EXPORT_PURCHASE_ORDER = V1_PURCHASE_ORDER + '/export';

var V1_PURCHASE_ORDER_BY_ID = exports.V1_PURCHASE_ORDER_BY_ID = function V1_PURCHASE_ORDER_BY_ID(id) {
  return V1_PURCHASE_ORDER + '/' + id + '.json';
};

var V1_PRINT_PURCHASE_ORDER = exports.V1_PRINT_PURCHASE_ORDER = function V1_PRINT_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '.pdf';
};

var V1_RESEND_EMAIL_PURCHASE_ORDER = exports.V1_RESEND_EMAIL_PURCHASE_ORDER = function V1_RESEND_EMAIL_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '/resend_email';
};

var V1_CREATE_AND_FULFILLED = exports.V1_CREATE_AND_FULFILLED = V1_PURCHASE_ORDER + '/create_and_fulfilled';

var V1_EDIT_PURCHASE_ORDER = exports.V1_EDIT_PURCHASE_ORDER = function V1_EDIT_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id + '/edit.json';
};

var V1_UPDATE_PURCHASE_ORDER = exports.V1_UPDATE_PURCHASE_ORDER = function V1_UPDATE_PURCHASE_ORDER(id) {
  return V1_PURCHASE_ORDER + '/' + id;
};

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSearchPurchaseOrders = getSearchPurchaseOrders;
exports.getExportPurchaseOrder = getExportPurchaseOrder;
exports.getPurchaseOrderById = getPurchaseOrderById;
exports.printPurchaseOrder = printPurchaseOrder;
exports.resendEmailPurchaseOrder = resendEmailPurchaseOrder;
exports.postPurchaseOrder = postPurchaseOrder;
exports.createAndfullfilled = createAndfullfilled;
exports.getEditDataPO = getEditDataPO;
exports.updateDataPO = updateDataPO;

var _constants = __webpack_require__(1098);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.error) {
      eobj = new Error(data.error[0]);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getSearchPurchaseOrders(params) {
  return axios.get(_constants.V1_SEARCH_PURCHASE_ORDER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportPurchaseOrder(params) {
  return axios.get(_constants.V1_EXPORT_PURCHASE_ORDER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getPurchaseOrderById(id, params) {
  return axios.get((0, _constants.V1_PURCHASE_ORDER_BY_ID)(id), { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function printPurchaseOrder(id) {
  return window.open((0, _constants.V1_PRINT_PURCHASE_ORDER)(id));
}

function resendEmailPurchaseOrder(id, data, params) {
  return axios.post((0, _constants.V1_RESEND_EMAIL_PURCHASE_ORDER)(id), data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postPurchaseOrder(data) {
  return axios.post(_constants.V1_PURCHASE_ORDER, data, { withCredentials: true }).then(resolve).catch(reject);
}

function createAndfullfilled(data) {
  return axios.post(_constants.V1_CREATE_AND_FULFILLED, data, { withCredentials: true }).then(resolve).catch(reject);
}

function getEditDataPO(id) {
  return axios.get((0, _constants.V1_EDIT_PURCHASE_ORDER)(id), { withCredentials: true }).then(resolve).catch(reject);
}

function updateDataPO(id, data) {
  return axios.put((0, _constants.V1_UPDATE_PURCHASE_ORDER)(id), data, { withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT_SUMMARY = exports.V1_SUMMARY = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/inventory';

var V1_SUMMARY = exports.V1_SUMMARY = V1_URL + '/summary';

var V1_EXPORT_SUMMARY = exports.V1_EXPORT_SUMMARY = V1_URL + '/summary/export';

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getSummary = getSummary;
exports.getExportSummary = getExportSummary;

var _constants = __webpack_require__(1100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getSummary(params) {
  return axios.get(_constants.V1_SUMMARY, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportSummary(params) {
  return axios.get(_constants.V1_EXPORT_SUMMARY, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT_SUPPLIER = exports.V1_SUPPLIER_BY_ID = exports.V1_SUPPLIER = undefined;

var _constants = __webpack_require__(432);

var V1_SUPPLIER = exports.V1_SUPPLIER = _constants.V1_URL + '/suppliers';

var V1_SUPPLIER_BY_ID = exports.V1_SUPPLIER_BY_ID = function V1_SUPPLIER_BY_ID(id) {
  return V1_SUPPLIER + '/' + id;
};

var V1_EXPORT_SUPPLIER = exports.V1_EXPORT_SUPPLIER = V1_SUPPLIER + '/export';

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_EXPORT_TRANSFER = exports.V1_TRANSFERS = exports.V1_URL = undefined;

var _constants = __webpack_require__(30);

var V1_URL = exports.V1_URL = _constants.API_URL + '/v1/inventory';
var V1_TRANSFERS = exports.V1_TRANSFERS = V1_URL + '/transfer';
var V1_EXPORT_TRANSFER = exports.V1_EXPORT_TRANSFER = V1_URL + '/transfer/export';

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getTransfers = getTransfers;
exports.postTransfers = postTransfers;
exports.getExportTransfer = getExportTransfer;

var _constants = __webpack_require__(1103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolve(res) {
  return _promise2.default.resolve(res);
}

function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
}

function getTransfers(params) {
  return axios.get(_constants.V1_TRANSFERS, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function postTransfers(data, params) {
  return axios.post(_constants.V1_TRANSFERS, data, { params: params, withCredentials: true }).then(resolve).catch(reject);
}

function getExportTransfer(params) {
  return axios.get(_constants.V1_EXPORT_TRANSFER, { params: params, withCredentials: true }).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_ALL_OUTLET = exports.DELETE_DISCOUNT = exports.PUT_DISCOUNT = exports.POST_DISCOUNT = exports.DISCOUNTS = undefined;

var _constants = __webpack_require__(30);

var DISCOUNTS = exports.DISCOUNTS = _constants.API_URL + '/v2/discounts';
var POST_DISCOUNT = exports.POST_DISCOUNT = _constants.API_URL + '/v1/discounts';
var PUT_DISCOUNT = exports.PUT_DISCOUNT = function PUT_DISCOUNT(id) {
  return _constants.API_URL + '/v1/discounts/' + id;
};
var DELETE_DISCOUNT = exports.DELETE_DISCOUNT = function DELETE_DISCOUNT(id) {
  return _constants.API_URL + '/v1/discounts/' + id;
};
var CREATE_ALL_OUTLET = exports.CREATE_ALL_OUTLET = _constants.API_URL + '/v1/discounts/create_all_outlet';

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getDiscounts = getDiscounts;
exports.postDiscount = postDiscount;
exports.putDiscount = putDiscount;
exports.deleteDiscount = deleteDiscount;
exports.postCreateAllOutlet = postCreateAllOutlet;

var _constants = __webpack_require__(1105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/discounts_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */
function getDiscounts(params) {
  return axios.get(_constants.DISCOUNTS, { withCredentials: true, params: params }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postDiscount(data, params) {
  return axios.post(_constants.POST_DISCOUNT, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data = error.response.data;
      if (_data.errors) {
        eobj = new Error(_data.errors);
      } else if (_data.message) {
        eobj = new Error(_data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function putDiscount(id, data, params) {
  return axios.put((0, _constants.PUT_DISCOUNT)(id), data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data2 = error.response.data;
      if (_data2.errors) {
        eobj = new Error(_data2.errors);
      } else if (_data2.message) {
        eobj = new Error(_data2.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function deleteDiscount(id, params) {
  return axios.delete((0, _constants.DELETE_DISCOUNT)(id), { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var data = error.response.data;
      if (data.errors) {
        eobj = new Error(data.errors);
      } else if (data.message) {
        eobj = new Error(data.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}

function postCreateAllOutlet(data, params) {
  return axios.post(_constants.CREATE_ALL_OUTLET, data, { params: params, withCredentials: true }).then(function (res) {
    return _promise2.default.resolve(res);
  }).catch(function (error) {
    var eobj = void 0;
    if (error.response) {
      var _data3 = error.response.data;
      if (_data3.errors) {
        eobj = new Error(_data3.errors);
      } else if (_data3.message) {
        eobj = new Error(_data3.message);
      } else {
        eobj = new Error(error.message);
      }
    } else {
      eobj = new Error(error.message);
    }
    return _promise2.default.reject(eobj);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_NEW_ITEM_V1 = exports.DELETE_ITEM_BY_ID_V1 = exports.UPDATE_ITEM_BY_ID = exports.CREATE_ALL_OUTLET_ITEM = exports.CREATE_ITEM = exports.ITEM_BY_ID = exports.ITEMS_TEMPLATE = exports.ITEM_SUMMARY_URL = exports.LIST_ITEM_URL = exports.ITEM_DOWNLOAD_TEMPLATE = exports.ITEMS_EXPORT = undefined;

var _constants = __webpack_require__(30);

var ITEMS_EXPORT = exports.ITEMS_EXPORT = _constants.API_URL + '/v1/items/import_items_template';
var ITEM_DOWNLOAD_TEMPLATE = exports.ITEM_DOWNLOAD_TEMPLATE = 'ITEM_DOWNLOAD_TEMPLATE';
var LIST_ITEM_URL = exports.LIST_ITEM_URL = _constants.API_URL + '/v1/items';
var ITEM_SUMMARY_URL = exports.ITEM_SUMMARY_URL = _constants.API_URL + '/v1/items/summary';
var ITEMS_TEMPLATE = exports.ITEMS_TEMPLATE = _constants.API_URL + '/v1/items/import_items_template';
var ITEM_BY_ID = exports.ITEM_BY_ID = function ITEM_BY_ID(id) {
  return LIST_ITEM_URL + '/' + id;
};
var CREATE_ITEM = exports.CREATE_ITEM = _constants.API_URL + '/v1/items';
var CREATE_ALL_OUTLET_ITEM = exports.CREATE_ALL_OUTLET_ITEM = _constants.API_URL + '/v1/items/create_all_outlet';
var UPDATE_ITEM_BY_ID = exports.UPDATE_ITEM_BY_ID = function UPDATE_ITEM_BY_ID(id) {
  return ITEM_BY_ID(id) + '/update_image';
};
var DELETE_ITEM_BY_ID_V1 = exports.DELETE_ITEM_BY_ID_V1 = function DELETE_ITEM_BY_ID_V1(id) {
  return '' + ITEM_BY_ID(id);
};
var GET_NEW_ITEM_V1 = exports.GET_NEW_ITEM_V1 = LIST_ITEM_URL + '/new';

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_SHOW_ITEM_MODIFIER = exports.V1_APPLY_TO_ITEMS = exports.CREATE_ALL_OUTLET = exports.V1_DELETE_MODIFIER = exports.MODIFIER_BY_ID = exports.V1_MODIFIER = exports.MODIFIERS = undefined;

var _constants = __webpack_require__(30);

var MODIFIERS = exports.MODIFIERS = _constants.API_URL + '/v2/modifiers';
var V1_MODIFIER = exports.V1_MODIFIER = _constants.API_URL + '/v1/modifiers';
var MODIFIER_BY_ID = exports.MODIFIER_BY_ID = function MODIFIER_BY_ID(id) {
  return _constants.API_URL + '/v1/modifiers/' + id;
};
var V1_DELETE_MODIFIER = exports.V1_DELETE_MODIFIER = function V1_DELETE_MODIFIER(id) {
  return _constants.API_URL + '/v1/modifiers/' + id + '/delete_modifier';
};
var CREATE_ALL_OUTLET = exports.CREATE_ALL_OUTLET = _constants.API_URL + '/v1/modifiers/create_all_outlet';
var V1_APPLY_TO_ITEMS = exports.V1_APPLY_TO_ITEMS = function V1_APPLY_TO_ITEMS(id) {
  return _constants.API_URL + '/v1/modifiers/' + id + '/apply_to_items';
};
var V1_SHOW_ITEM_MODIFIER = exports.V1_SHOW_ITEM_MODIFIER = function V1_SHOW_ITEM_MODIFIER(id) {
  return _constants.API_URL + '/v1/modifiers/show_item_modifier';
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OUTLET_PRICE = exports.OUTLETS_URL = exports.UPDATE_SELECTED_OUTLET = exports.OUTLET_NEW = exports.OUTLETS_SEARCH = undefined;
exports.OUTLET_BY_ID = OUTLET_BY_ID;

var _constants = __webpack_require__(30);

/**
 * @return {string}
 */
function OUTLET_BY_ID(outletId) {
  return _constants.API_URL + '/v1/outlets/' + outletId;
}

var OUTLETS_SEARCH = exports.OUTLETS_SEARCH = _constants.API_URL + '/v1/outlets/search';

var OUTLET_NEW = exports.OUTLET_NEW = _constants.API_URL + '/v1/outlets/new';

var UPDATE_SELECTED_OUTLET = exports.UPDATE_SELECTED_OUTLET = _constants.API_URL + '/v2/login/outlets';

var OUTLETS_URL = exports.OUTLETS_URL = _constants.API_URL + '/v1/outlets';

var OUTLET_PRICE = exports.OUTLET_PRICE = _constants.API_URL + '/v1/billings/outlet_price';

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_PROFILE = undefined;

var _constants = __webpack_require__(30);

var GET_PROFILE = exports.GET_PROFILE = _constants.API_URL + '/v1/profile';

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.settingPublicProfile = settingPublicProfile;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function settingPublicProfile(businessId, data) {
  return axios.put((0, _constants.SETTING_PUBLIC_PROFILE)(businessId), data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.postRefund = postRefund;
exports.postOldRefund = postOldRefund;

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function postRefund(data) {
  return axios.post(_constants.REFUNDS, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}

function postOldRefund(data) {
  return axios.post(_constants.OLD_REFUNDS, data, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var reject = void 0;
    if (error.response) {
      reject = new Error(error.response.data.error);
    } else {
      reject = new Error(error.message);
    }
    return _promise2.default.reject(reject);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V1_NEW_URL = undefined;

var _constants = __webpack_require__(30);

var V1_NEW_URL = exports.V1_NEW_URL = _constants.API_URL + '/v1/s3/new';

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getNew = getNew;

var _constants = __webpack_require__(1113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNew(params) {
  return axios.get(_constants.V1_NEW_URL, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SETTING = exports.UPDATE_SETTING = undefined;

var _constants = __webpack_require__(30);

var UPDATE_SETTING = exports.UPDATE_SETTING = _constants.API_URL + '/v1/settings/update_settings';

var GET_SETTING = exports.GET_SETTING = _constants.API_URL + '/v1/settings';

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_TAX_BY_ID_SERVICE = exports.POST_TAX_BY_ID_SERVICE = exports.PUT_TAX_BY_ID_SERVICE = exports.GET_ITEM_CUSTOM_AMOUNT_SERVICE = exports.GET_ITEM_SERVICE = exports.GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE = exports.GET_TAXITEMS_BY_ID_SERVICE = exports.GET_TAX_BY_ID_SERVICE = exports.GET_TAX_SERVICE = exports.ITEMS_SERVICE = exports.TAXES_SERVICE = exports.TAX_ALL_OUTLET = exports.V1_TAX_URL = exports.V1_TAX_BY_ID = exports.LIBRARY_TAXES = undefined;

var _constants = __webpack_require__(30);

var LIBRARY_TAXES = exports.LIBRARY_TAXES = _constants.API_URL + '/v2/taxes';
var V1_TAX_BY_ID = exports.V1_TAX_BY_ID = function V1_TAX_BY_ID(id) {
  return _constants.API_URL + '/v1/taxes/' + id;
};
var V1_TAX_URL = exports.V1_TAX_URL = _constants.API_URL + '/v1/taxes';
var TAX_ALL_OUTLET = exports.TAX_ALL_OUTLET = _constants.API_URL + '/v1/taxes/create_all_outlet';

var TAXES_SERVICE = exports.TAXES_SERVICE = function TAXES_SERVICE() {
  var service = '/library/v1/taxes';
  return _constants.MOKA_SERVICE_URL + service;
};

var ITEMS_SERVICE = exports.ITEMS_SERVICE = function ITEMS_SERVICE() {
  var service = '/library/v1/items';
  return _constants.MOKA_SERVICE_URL + service;
};

var GET_TAX_SERVICE = exports.GET_TAX_SERVICE = function GET_TAX_SERVICE(outletId) {
  return TAXES_SERVICE() + ('?outletId=' + outletId) + '&sort=name,amount,id,asc';
};
var GET_TAX_BY_ID_SERVICE = exports.GET_TAX_BY_ID_SERVICE = function GET_TAX_BY_ID_SERVICE(taxId) {
  return TAXES_SERVICE() + ('/' + taxId + '?deep=false');
};
var GET_TAXITEMS_BY_ID_SERVICE = exports.GET_TAXITEMS_BY_ID_SERVICE = function GET_TAXITEMS_BY_ID_SERVICE(taxId) {
  return TAXES_SERVICE() + ('/' + taxId + '/items?basic=true&customAmount=false');
};
var GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE = exports.GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE = function GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE(taxId) {
  return TAXES_SERVICE() + ('/' + taxId + '/items?basic=true&customAmount=true');
};

var GET_ITEM_SERVICE = exports.GET_ITEM_SERVICE = function GET_ITEM_SERVICE(outletId, categoryId, name) {
  return ITEMS_SERVICE() + ('?basic=true&unpaged=true&outletId=' + outletId + '&categoryId=' + categoryId + '&name=' + name);
};
var GET_ITEM_CUSTOM_AMOUNT_SERVICE = exports.GET_ITEM_CUSTOM_AMOUNT_SERVICE = function GET_ITEM_CUSTOM_AMOUNT_SERVICE(outletId) {
  return ITEMS_SERVICE() + ('?basic=true&unpaged=true&customAmount=true&outletId=' + outletId);
};

var PUT_TAX_BY_ID_SERVICE = exports.PUT_TAX_BY_ID_SERVICE = function PUT_TAX_BY_ID_SERVICE(taxId) {
  return TAXES_SERVICE() + ('/' + taxId);
};
var POST_TAX_BY_ID_SERVICE = exports.POST_TAX_BY_ID_SERVICE = function POST_TAX_BY_ID_SERVICE() {
  return TAXES_SERVICE();
};
var DELETE_TAX_BY_ID_SERVICE = exports.DELETE_TAX_BY_ID_SERVICE = function DELETE_TAX_BY_ID_SERVICE(taxId) {
  return TAXES_SERVICE() + ('/' + taxId);
};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUEST_IMPORT_DATA_TO_CUSTOMERS = exports.SEND_INFO_FILE_UPLOADED_CUSTOMERS = undefined;

var _constants = __webpack_require__(30);

var SEND_INFO_FILE_UPLOADED_CUSTOMERS = exports.SEND_INFO_FILE_UPLOADED_CUSTOMERS = _constants.API_URL + '/v1/customers/import_customers_temporary';
var REQUEST_IMPORT_DATA_TO_CUSTOMERS = exports.REQUEST_IMPORT_DATA_TO_CUSTOMERS = _constants.API_URL + '/v1/customers/import_customers';

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.uploadToS3 = uploadToS3;
exports.sendSuccessUploadCustomers = sendSuccessUploadCustomers;
exports.requestImportDataToCustomers = requestImportDataToCustomers;

var _constants = __webpack_require__(1117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * post file as a formdata to mokapos-*.s3.amazonaws.com/
 * @param formdata
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
function uploadToS3(url, formData) {
  var config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return axios.post(url, formData, config).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error));
  });
}

/**
  * send information to server about file has been saved to s3
  * @param uploadFile
  * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
  */
function sendSuccessUploadCustomers(url) {
  return axios.post(_constants.SEND_INFO_FILE_UPLOADED_CUSTOMERS, { uploadfile: url }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error));
  });
}

function requestImportDataToCustomers() {
  return axios.post(_constants.REQUEST_IMPORT_DATA_TO_CUSTOMERS, {}, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    var response = error.response;

    return _promise2.default.reject(response);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORGOT_PASSWORD = undefined;

var _constants = __webpack_require__(30);

var V1_URL = _constants.API_URL + '/v1/users';

var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = V1_URL + '/forgot_password';

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.forgotPassword = forgotPassword;

var _constants = __webpack_require__(1119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolve = function resolve(response) {
  return _promise2.default.resolve(response);
};

var reject = function reject(error) {
  var eobj = void 0;
  if (error.response) {
    var data = error.response.data;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return _promise2.default.reject(eobj);
};

function forgotPassword(data) {
  return axios.post(_constants.FORGOT_PASSWORD, data).then(resolve).catch(reject);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKEND_HOST = "https://experiment-taxitem.mokapos.com";
var BACKEND_PORT = "443";
var HOST = BACKEND_HOST + ":" + BACKEND_PORT;

var VERIFY_EMAIL = exports.VERIFY_EMAIL = HOST + "/verify_email";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.postVerifyEmail = postVerifyEmail;

var _constants = __webpack_require__(1121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function postVerifyEmail(query) {
  return axios.post(_constants.VERIFY_EMAIL, { access_token: query.access_token }, { withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERIFY_EMAIL_ALERT_RECIPIENT = undefined;

var _constants = __webpack_require__(30);

var VERIFY_EMAIL_ALERT_RECIPIENT = exports.VERIFY_EMAIL_ALERT_RECIPIENT = _constants.API_URL + '/v1/email_alert_recipients/verify';

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(axios) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.getVerifyEmailAlertRecipient = getVerifyEmailAlertRecipient;

var _constants = __webpack_require__(1123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getVerifyEmailAlertRecipient(params) {
  return axios.get(_constants.VERIFY_EMAIL_ALERT_RECIPIENT, { params: params, withCredentials: true }).then(function (response) {
    return _promise2.default.resolve(response);
  }).catch(function (error) {
    return _promise2.default.reject(new Error(error.message));
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _CancelFeatureSubscriptionModal = __webpack_require__(1943);

var _CancelFeatureSubscriptionModal2 = _interopRequireDefault(_CancelFeatureSubscriptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelFeatureSubscriptionModal = function (_Component) {
  (0, _inherits3.default)(CancelFeatureSubscriptionModal, _Component);

  function CancelFeatureSubscriptionModal() {
    (0, _classCallCheck3.default)(this, CancelFeatureSubscriptionModal);
    return (0, _possibleConstructorReturn3.default)(this, (CancelFeatureSubscriptionModal.__proto__ || (0, _getPrototypeOf2.default)(CancelFeatureSubscriptionModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(CancelFeatureSubscriptionModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showModal = _props.showModal,
          featureName = _props.featureName,
          hideModal = _props.hideModal,
          expirationDate = _props.expirationDate,
          cancelSubscription = _props.cancelSubscription;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: showModal, onHide: hideModal, dialogClassName: _CancelFeatureSubscriptionModal2.default['dialog'] + ' ' + _CancelFeatureSubscriptionModal2.default['cancel-feature-subscription-wrapper'] + ' modal-dialog' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true, bsClass: _CancelFeatureSubscriptionModal2.default['modal-header'] },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            { bsClass: _CancelFeatureSubscriptionModal2.default['modal-title'], componentClass: 'div' },
            'Cancel Subscription'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            null,
            'Are you sure you want to cancel subscription for ',
            featureName,
            '? You can keep using this feature until ',
            _react2.default.createElement(
              'strong',
              null,
              expirationDate
            ),
            '.'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn btn-default pull-left', onClick: hideModal },
              'Cancel'
            ),
            _react2.default.createElement(
              'button',
              { className: 'btn btn-danger', onClick: cancelSubscription },
              'Proceed'
            )
          )
        )
      );
    }
  }]);
  return CancelFeatureSubscriptionModal;
}(_react.Component); /**
                      * Created by alvinoktavianus on 6/14/17.
                      */

exports.default = CancelFeatureSubscriptionModal;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _formatter = __webpack_require__(11);

var _FeatureDetailTransactionModal = __webpack_require__(1127);

var _FeatureDetailTransactionModal2 = _interopRequireDefault(_FeatureDetailTransactionModal);

var _PaymentGatewayErrorModal = __webpack_require__(441);

var _PaymentGatewayErrorModal2 = _interopRequireDefault(_PaymentGatewayErrorModal);

var _reactRouter = __webpack_require__(15);

var _PageWrapper = __webpack_require__(296);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _FeatureBillingPage = __webpack_require__(1945);

var _FeatureBillingPage2 = _interopRequireDefault(_FeatureBillingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureBillingPage = function (_Component) {
  (0, _inherits3.default)(FeatureBillingPage, _Component);

  function FeatureBillingPage() {
    (0, _classCallCheck3.default)(this, FeatureBillingPage);
    return (0, _possibleConstructorReturn3.default)(this, (FeatureBillingPage.__proto__ || (0, _getPrototypeOf2.default)(FeatureBillingPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeatureBillingPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          featureName = _props.featureName,
          videoLink = _props.videoLink,
          featureMessage = _props.featureMessage,
          featureLogo = _props.featureLogo,
          featurePrice = _props.featurePrice,
          featurePricePerMonths = _props.featurePricePerMonths,
          currentOutletCount = _props.currentOutletCount,
          isButtonDisabled = _props.isButtonDisabled,
          buttonMessage = _props.buttonMessage,
          billingMessages = _props.billingMessages,
          showDetailModal = _props.showDetailModal,
          onHide = _props.onHide,
          onShow = _props.onShow,
          outletList = _props.outletList,
          verifyBilling = _props.verifyBilling,
          showPaymentGatewayErrorModal = _props.showPaymentGatewayErrorModal,
          hidePaymentGatewayErrorModal = _props.hidePaymentGatewayErrorModal,
          discountPriceLowerBound = _props.discountPriceLowerBound;


      return React.createElement(
        'div',
        null,
        React.createElement(
          _PageWrapper2.default,
          null,
          React.createElement(
            'div',
            { className: _FeatureBillingPage2.default['splash-page'] },
            React.createElement(
              'div',
              { className: _FeatureBillingPage2.default['splash-content'] },
              React.createElement(
                'p',
                { className: 'text-center' },
                React.createElement('img', { src: featureLogo, className: 'img-circle ' + _FeatureBillingPage2.default['feature-logo'] })
              ),
              React.createElement(
                'h3',
                { className: 'text-center ' + _FeatureBillingPage2.default['splash-title'] },
                featureName
              ),
              React.createElement(
                'p',
                { className: _FeatureBillingPage2.default['feature-description'] },
                featureMessage
              ),
              React.createElement(
                'p',
                { className: 'text-center ' + _FeatureBillingPage2.default['splash-video'] },
                React.createElement('iframe', { width: '248', height: '167', src: videoLink, frameBorder: 0, allowFullScreen: true, id: 'video' })
              ),
              React.createElement(
                'p',
                { className: _FeatureBillingPage2.default['pricing-message'] },
                'Pricing'
              ),
              React.createElement(
                'table',
                { className: _FeatureBillingPage2.default['pricing-table'] },
                React.createElement(
                  'tr',
                  { className: _FeatureBillingPage2.default['pricing-row'] },
                  React.createElement(
                    'td',
                    { align: 'left', className: _FeatureBillingPage2.default['pricing-colomn'] },
                    featureName
                  ),
                  featurePricePerMonths < discountPriceLowerBound && React.createElement(
                    'td',
                    { className: 'text-right ' + _FeatureBillingPage2.default['pricing-colomn'] + ' ' + _FeatureBillingPage2.default['pricing-colomn-discount'] },
                    (0, _formatter.currencyFormatter)(discountPriceLowerBound)
                  ),
                  React.createElement(
                    'td',
                    { className: 'text-right ' + _FeatureBillingPage2.default['pricing-colomn'] },
                    (0, _formatter.currencyFormatter)(featurePricePerMonths),
                    '/mo'
                  )
                )
              ),
              React.createElement(
                'table',
                { className: _FeatureBillingPage2.default['pricing-table'] },
                React.createElement(
                  'tr',
                  { className: _FeatureBillingPage2.default['pricing-row'] + ' ' + _FeatureBillingPage2.default['no-border'] },
                  React.createElement(
                    'td',
                    { className: _FeatureBillingPage2.default['total-pricing-colomn'] + ' ' + _FeatureBillingPage2.default['no-padding-bottom'] },
                    'Total Payment'
                  ),
                  React.createElement(
                    'td',
                    { className: 'text-right ' + _FeatureBillingPage2.default['total-pricing-colomn'] + ' ' + _FeatureBillingPage2.default['no-padding-bottom'] },
                    (0, _formatter.currencyFormatter)(featurePrice['final_price'])
                  )
                ),
                React.createElement(
                  'tr',
                  { className: _FeatureBillingPage2.default['pricing-row'] + ' ' + _FeatureBillingPage2.default['no-border'] },
                  React.createElement(
                    'td',
                    { align: 'left', className: _FeatureBillingPage2.default['pricing-prorated'] + ' ' + _FeatureBillingPage2.default['paid-outlet-row'] },
                    'Your paid for ',
                    currentOutletCount,
                    ' Outlet',
                    currentOutletCount > 1 ? '(s)' : ''
                  )
                ),
                React.createElement(
                  'tr',
                  { className: _FeatureBillingPage2.default['pricing-row'] + ' ' + _FeatureBillingPage2.default['last-row-pricing-table'] },
                  React.createElement(
                    'td',
                    { align: 'left', className: _FeatureBillingPage2.default['pricing-prorated'] + ' ' + _FeatureBillingPage2.default['add-padding-payment-detail'], colSpan: '2' },
                    React.createElement(
                      'button',
                      { className: _FeatureBillingPage2.default['no-padding'] + ' btn btn-primary btn-link', onClick: onShow },
                      'View detail transactions'
                    )
                  )
                )
              ),
              React.createElement(
                'button',
                { className: _FeatureBillingPage2.default['btn-use-feature'] + ' btn btn-block ' + (isButtonDisabled ? 'btn-disabled ' + _FeatureBillingPage2.default['disabled-button'] : 'btn-primary'), disabled: isButtonDisabled, onClick: verifyBilling },
                React.createElement(
                  'strong',
                  null,
                  buttonMessage
                )
              ),
              billingMessages && React.createElement(
                'div',
                { className: 'row ' + _FeatureBillingPage2.default['pending-notification'] },
                React.createElement(
                  'div',
                  { className: 'col-md-12' },
                  React.createElement(
                    'em',
                    null,
                    billingMessages
                  )
                )
              ),
              React.createElement(
                'p',
                { className: _FeatureBillingPage2.default['feature-message'] },
                'Check your ',
                React.createElement(
                  _reactRouter.Link,
                  { to: '/settings/billing' },
                  'billing page'
                ),
                ' for transaction history'
              )
            )
          )
        ),
        React.createElement(_FeatureDetailTransactionModal2.default, {
          onHide: onHide,
          showModal: showDetailModal,
          featurePrice: featurePrice,
          outletList: outletList,
          featureName: featureName
        }),
        React.createElement(_PaymentGatewayErrorModal2.default, {
          showModal: showPaymentGatewayErrorModal,
          onHide: hidePaymentGatewayErrorModal,
          totalPrice: featurePrice.final_price
        })
      );
    }
  }]);
  return FeatureBillingPage;
}(_react.Component); /**
                      * Created by alvinoktavianus on 6/29/17.
                      */

exports.default = FeatureBillingPage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _reactBootstrap = __webpack_require__(10);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _PageWrapper = __webpack_require__(296);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _FeatureDetailTransactionModal = __webpack_require__(1947);

var _FeatureDetailTransactionModal2 = _interopRequireDefault(_FeatureDetailTransactionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureDetailTransactionModal = function (_Component) {
  (0, _inherits3.default)(FeatureDetailTransactionModal, _Component);

  function FeatureDetailTransactionModal() {
    (0, _classCallCheck3.default)(this, FeatureDetailTransactionModal);
    return (0, _possibleConstructorReturn3.default)(this, (FeatureDetailTransactionModal.__proto__ || (0, _getPrototypeOf2.default)(FeatureDetailTransactionModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeatureDetailTransactionModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onHide = _props.onHide,
          showModal = _props.showModal,
          featurePrice = _props.featurePrice,
          outletList = _props.outletList,
          featureName = _props.featureName;


      if (!onHide || !showModal || !featurePrice || !outletList || !featureName) return React.createElement('div', null);

      return React.createElement(
        _reactBootstrap.Modal,
        { onHide: onHide, show: showModal, dialogClassName: _FeatureDetailTransactionModal2.default['feature-detail-transaction'] + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: _FeatureDetailTransactionModal2.default['modal-wrapper'] },
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              { type: 'button', className: 'close', onClick: onHide },
              React.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            React.createElement(
              'h4',
              null,
              'DETAIL TRANSACTION'
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              null,
              React.createElement(
                _PageWrapper2.default,
                null,
                React.createElement(
                  'div',
                  { className: _FeatureDetailTransactionModal2.default['payment-container'] },
                  featurePrice && outletList && _lodash2.default.map(outletList, function (outlet) {
                    if (outlet.is_paying) {
                      return React.createElement(
                        'div',
                        { className: 'row ' + _FeatureDetailTransactionModal2.default['detail-wrapper'] },
                        React.createElement(
                          'div',
                          { className: 'col-md-12' },
                          React.createElement(
                            'div',
                            { className: 'row' },
                            React.createElement(
                              'div',
                              { className: 'col-md-12' },
                              outlet.name
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'row' },
                            React.createElement(
                              'div',
                              { className: 'col-md-6' },
                              featureName
                            ),
                            React.createElement(
                              'div',
                              { className: 'col-md-6' },
                              React.createElement(
                                'span',
                                { className: _FeatureDetailTransactionModal2.default['right-span'] },
                                (0, _formatter.currencyFormatter)(featurePrice[outlet.id].final_price)
                              )
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'row' },
                            React.createElement(
                              'div',
                              { className: 'col-md-12' },
                              'Prorated for period from'
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'row' },
                            React.createElement(
                              'div',
                              { className: 'col-md-12' },
                              (0, _moment2.default)(featurePrice[outlet.id].start_date).format('DD/MM/YYYY'),
                              ' - ',
                              (0, _moment2.default)(featurePrice[outlet.id].end_date).format('DD/MM/YYYY')
                            )
                          )
                        )
                      );
                    }
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'row ' + _FeatureDetailTransactionModal2.default['close-wrapper'] },
              React.createElement(
                'div',
                { className: 'col-md-12' },
                React.createElement(
                  'button',
                  { className: 'btn btn-default btn-large btn-block', onClick: onHide },
                  React.createElement(
                    'strong',
                    null,
                    'Close'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FeatureDetailTransactionModal;
}(_react.Component); /**
                      * Created by alvinoktavianus on 6/29/17.
                      */

exports.default = FeatureDetailTransactionModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

var _FeatureTrialPage = __webpack_require__(1948);

var _FeatureTrialPage2 = _interopRequireDefault(_FeatureTrialPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 6/29/17.
 */

var FeatureTrialPage = function (_Component) {
  (0, _inherits3.default)(FeatureTrialPage, _Component);

  function FeatureTrialPage() {
    (0, _classCallCheck3.default)(this, FeatureTrialPage);
    return (0, _possibleConstructorReturn3.default)(this, (FeatureTrialPage.__proto__ || (0, _getPrototypeOf2.default)(FeatureTrialPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeatureTrialPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          featureName = _props.featureName,
          featurePricePerMonths = _props.featurePricePerMonths,
          description = _props.description,
          trialEndAt = _props.trialEndAt,
          featureIcon = _props.featureIcon,
          featureVideo = _props.featureVideo,
          startTrial = _props.startTrial,
          discountPriceLowerBound = _props.discountPriceLowerBound;

      return React.createElement(
        'div',
        { className: _FeatureTrialPage2.default['splash-page'] },
        React.createElement(
          'div',
          { className: _FeatureTrialPage2.default['splash-content'] },
          React.createElement(
            'p',
            { className: 'text-center' },
            React.createElement('img', { src: featureIcon, className: 'img-circle ' + _FeatureTrialPage2.default['feature-logo'] })
          ),
          React.createElement(
            'h3',
            { className: 'text-center ' + _FeatureTrialPage2.default['splash-title'] },
            featureName
          ),
          React.createElement(
            'p',
            { className: _FeatureTrialPage2.default['feature-description'] },
            description
          ),
          React.createElement(
            'p',
            { className: 'text-center ' + _FeatureTrialPage2.default['splash-video'] },
            React.createElement('iframe', { width: '248', height: '167', src: featureVideo, frameBorder: 0, allowFullScreen: true, id: 'video' })
          ),
          React.createElement(
            'p',
            { className: _FeatureTrialPage2.default['pricing-message'] },
            'Pricing'
          ),
          React.createElement(
            'table',
            { className: _FeatureTrialPage2.default['pricing-table'] },
            React.createElement(
              'tr',
              { className: _FeatureTrialPage2.default['pricing-row'] },
              React.createElement(
                'td',
                { align: 'left', className: _FeatureTrialPage2.default['pricing-colomn'] },
                featureName
              ),
              featurePricePerMonths < discountPriceLowerBound && React.createElement(
                'td',
                { className: 'text-right ' + _FeatureTrialPage2.default['pricing-colomn'] + ' ' + _FeatureTrialPage2.default['pricing-colomn-discount'] },
                (0, _formatter.currencyFormatter)(discountPriceLowerBound)
              ),
              React.createElement(
                'td',
                { className: 'text-right ' + _FeatureTrialPage2.default['pricing-colomn'] },
                (0, _formatter.currencyFormatter)(featurePricePerMonths),
                '/mo'
              )
            )
          ),
          React.createElement(
            'button',
            { className: 'btn btn-block btn-primary ' + _FeatureTrialPage2.default['btn-use-feature'], onClick: startTrial },
            React.createElement(
              'strong',
              null,
              'Start Free Trial'
            )
          ),
          React.createElement(
            'p',
            { className: _FeatureTrialPage2.default['feature-due-date'] },
            'Your free trial due on ',
            (0, _moment2.default)(trialEndAt).format('DD MMM YYYY')
          )
        )
      );
    }
  }]);
  return FeatureTrialPage;
}(_react.Component);

exports.default = FeatureTrialPage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FeatureTutorialPage = __webpack_require__(1949);

var _FeatureTutorialPage2 = _interopRequireDefault(_FeatureTutorialPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 6/27/17.
 */

var FeatureTutorialPage = function (_Component) {
  (0, _inherits3.default)(FeatureTutorialPage, _Component);

  function FeatureTutorialPage() {
    (0, _classCallCheck3.default)(this, FeatureTutorialPage);
    return (0, _possibleConstructorReturn3.default)(this, (FeatureTutorialPage.__proto__ || (0, _getPrototypeOf2.default)(FeatureTutorialPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeatureTutorialPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          featureName = _props.featureName,
          isSubscribedAccount = _props.isSubscribedAccount,
          videoLink = _props.videoLink,
          endTutorial = _props.endTutorial;

      var message = 'Thank you for ' + (isSubscribedAccount ? 'purchasing' : 'trying') + ' Moka\u2019s Ingredient Inventory. Here\u2019s the tutorial to show you how it works.';

      return _react2.default.createElement(
        'div',
        { className: _FeatureTutorialPage2.default['splash-page'] },
        _react2.default.createElement(
          'div',
          { className: _FeatureTutorialPage2.default['splash-content'] },
          _react2.default.createElement(
            'h3',
            { className: 'text-center ' + _FeatureTutorialPage2.default['splash-title'] },
            featureName
          ),
          _react2.default.createElement(
            'p',
            { className: _FeatureTutorialPage2.default['ingredients-description'] },
            message
          ),
          _react2.default.createElement(
            'p',
            { className: 'text-center ' + _FeatureTutorialPage2.default['splash-video'] },
            _react2.default.createElement('iframe', { width: '248', height: '167', src: videoLink, frameBorder: 0, allowFullScreen: true, id: 'video' })
          ),
          _react2.default.createElement(
            'button',
            { className: 'btn btn-primary btn-block ' + _FeatureTutorialPage2.default['btn-use-ingredients'], onClick: endTutorial },
            _react2.default.createElement(
              'strong',
              null,
              'Got it!'
            )
          )
        )
      );
    }
  }]);
  return FeatureTutorialPage;
}(_react.Component);

FeatureTutorialPage.propTypes = {
  featureName: _react2.default.PropTypes.string,
  isSubscribedAccount: _react2.default.PropTypes.bool,
  videoLink: _react2.default.PropTypes.string,
  endTutorial: _react2.default.PropTypes.func
};

exports.default = FeatureTutorialPage;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DescriptiveSwithField = __webpack_require__(1950);

var _DescriptiveSwithField2 = _interopRequireDefault(_DescriptiveSwithField);

var _SwitchField = __webpack_require__(437);

var _SwitchField2 = _interopRequireDefault(_SwitchField);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptiveSwitchField = function (_React$Component) {
  (0, _inherits3.default)(DescriptiveSwitchField, _React$Component);

  function DescriptiveSwitchField() {
    (0, _classCallCheck3.default)(this, DescriptiveSwitchField);
    return (0, _possibleConstructorReturn3.default)(this, (DescriptiveSwitchField.__proto__ || (0, _getPrototypeOf2.default)(DescriptiveSwitchField)).apply(this, arguments));
  }

  (0, _createClass3.default)(DescriptiveSwitchField, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _DescriptiveSwithField2.default['form-group'] + ' row' },
        React.createElement(
          'div',
          { className: 'col-lg-9 col-md-9 col-sm-6' },
          React.createElement(
            'div',
            { className: _DescriptiveSwithField2.default.label },
            this.props.label
          ),
          React.createElement(
            'div',
            { className: _DescriptiveSwithField2.default.sublabel },
            this.props.sublabel
          )
        ),
        React.createElement(
          'div',
          { className: 'col-lg-3 col-md-3 col-sm-6' },
          React.createElement(
            'div',
            { className: _DescriptiveSwithField2.default['field-right'] },
            React.createElement(_reduxForm.Field, {
              component: _SwitchField2.default,
              name: this.props.name,
              type: 'checkbox'
            })
          )
        )
      );
    }
  }]);
  return DescriptiveSwitchField;
}(React.Component);

DescriptiveSwitchField.propTypes = {
  label: React.PropTypes.string,
  sublabel: React.PropTypes.string,
  name: React.PropTypes.string
  // we using value from redux form so no props of value here
};

exports.default = DescriptiveSwitchField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ApplyBox = __webpack_require__(1952);

var _ApplyBox2 = _interopRequireDefault(_ApplyBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _notifications = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplyBox = function (_React$Component) {
  (0, _inherits3.default)(ApplyBox, _React$Component);

  function ApplyBox(props) {
    (0, _classCallCheck3.default)(this, ApplyBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ApplyBox.__proto__ || (0, _getPrototypeOf2.default)(ApplyBox)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;

    _this.state = {
      startDate: (0, _moment2.default)(startDate),
      endDate: (0, _moment2.default)(endDate),
      startDateText: (0, _moment2.default)(startDate).format('D/M/YYYY'),
      endDateText: (0, _moment2.default)(endDate).format('D/M/YYYY')
    };
    return _this;
  }

  (0, _createClass3.default)(ApplyBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var isSameStartDate = (0, _moment2.default)(props.startDate).isSame(this.state.startDate, 'days');
      var isSameEndDate = (0, _moment2.default)(props.endDate).isSame(this.state.endDate, 'days');
      if (props.startDate && props.endDate && !(isSameEndDate && isSameStartDate)) {
        this.setState({
          startDate: (0, _moment2.default)(props.startDate),
          endDate: (0, _moment2.default)(props.endDate),
          startDateText: (0, _moment2.default)(props.startDate).format('D/M/YYYY'),
          endDateText: (0, _moment2.default)(props.endDate).format('D/M/YYYY')
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _ApplyBox2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement(
              'form',
              { className: 'form-inline' },
              React.createElement(
                'div',
                { className: 'form-group ' + _ApplyBox2.default['form-group'] },
                React.createElement('input', { type: 'text',
                  className: 'form-control ' + _ApplyBox2.default.input,
                  onChange: this._onChangeStartDate,
                  value: this.state.startDateText
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group ' + _ApplyBox2.default['form-group'] },
                React.createElement('input', { type: 'text',
                  className: 'form-control ' + _ApplyBox2.default.input,
                  onChange: this._onChangeEndDate,
                  value: this.state.endDateText
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group ' + _ApplyBox2.default['form-group'] },
                React.createElement(
                  'button',
                  { className: 'btn btn-primary btn-block ' + _ApplyBox2.default['btn-apply'], onClick: this._onClickApply },
                  'Apply'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ApplyBox;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._onChangeStartDate = function (e) {
    _this2.setState({ startDateText: e.target.value });
  };

  this._onChangeEndDate = function (e) {
    _this2.setState({ endDateText: e.target.value });
  };

  this._onClickApply = function (e) {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onApply)
    e.preventDefault();
    e.stopPropagation();

    var dispatch = _this2.props.dispatch;
    var _state = _this2.state,
        startDateText = _state.startDateText,
        endDateText = _state.endDateText;

    var startDate = (0, _moment2.default)(startDateText, 'D/M/YYYY');
    var endDate = (0, _moment2.default)(endDateText, 'D/M/YYYY');

    // required to display timezone
    var endDateMessage = new Date(endDateText.split('/')[2], endDateText.split('/')[1] - 1, endDateText.split('/')[0]);
    var currentDateMessage = new Date();

    if (!startDate.isValid()) {
      dispatch((0, _notifications.error)('Invalid start date. Format must be D/M/YYYY'));
    } else if (!endDate.isValid()) {
      dispatch((0, _notifications.error)('Invalid end date. Format must be D/M/YYYY'));
    } else if (startDate.isAfter(endDate, 'days')) {
      dispatch((0, _notifications.error)('Start date should be lower than equal end date (' + endDateMessage.toString() + ')'));
    } else if (startDate.isAfter((0, _moment2.default)(), 'days')) {
      dispatch((0, _notifications.error)('Start date should be lower than equal current date (' + currentDateMessage.toString() + ')'));
    } else if (Math.abs(startDate.diff(endDate, 'days')) > 365) {
      dispatch((0, _notifications.error)('Reports can only be shown for one year period or less'));
    } else {
      _this2.props.onApply({ startDate: startDate, endDate: endDate });
    }
  };
};

ApplyBox.propTypes = {
  startDate: React.PropTypes.object,
  endDate: React.PropTypes.object,
  onApply: React.PropTypes.func
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ApplyBox);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DateBox = __webpack_require__(1953);

var _DateBox2 = _interopRequireDefault(_DateBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateBox = function (_React$Component) {
  (0, _inherits3.default)(DateBox, _React$Component);

  function DateBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DateBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateBox.__proto__ || (0, _getPrototypeOf2.default)(DateBox)).call.apply(_ref, [this].concat(args))), _this), _this._getDaysOfWeek = function () {
      var daysOfWeek = [];
      var d = (0, _moment2.default)().startOf('week');
      for (var i = 0; i < 7; i++) {
        daysOfWeek.push((0, _moment2.default)(d));
        d.add(1, 'days');
      }
      return daysOfWeek;
    }, _this._onClickDate = function (date) {
      // do nothing if the selected is future date
      if (_this._isFutureDate(date)) {
        return false;
      }
      var _this$props = _this.props,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate,
          onChange = _this$props.onChange;

      if (startDate.isSame(endDate)) {
        // if the dates are equal, then promote this to a range.
        if (date.isAfter(startDate)) {
          onChange({
            startDate: (0, _moment2.default)(startDate).startOf('days'),
            endDate: (0, _moment2.default)(date).startOf('days')
          });
        } else {
          onChange({
            startDate: (0, _moment2.default)(date).startOf('days'),
            endDate: (0, _moment2.default)(startDate).startOf('days')
          });
        }
      } else {
        // if the dates are not both equal, then demote this to a single date.
        onChange({ startDate: (0, _moment2.default)(date).startOf('days'), endDate: (0, _moment2.default)(date).startOf('days') });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DateBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: _DateBox2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement(
              'table',
              { className: _DateBox2.default.table },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  this._getDaysOfWeek().map(function (dateObj, idx) {
                    return React.createElement(
                      'th',
                      { key: idx },
                      dateObj.format('ddd')
                    );
                  })
                )
              ),
              React.createElement(
                'tbody',
                null,
                this._getCalendarWeeks().map(function (week, widx) {
                  return React.createElement(
                    'tr',
                    { key: widx },
                    week.map(function (dateObj, idx) {
                      var fadedDay = _this2._isPartOfMonth(dateObj) ? '' : 'fadedDay';
                      var selectedBetweenDate = _this2._isPartOfSelected(dateObj) ? 'selected' : '';
                      var selectedStartDate = _this2._isSelectedStartDate(dateObj) ? 'selected-start-date' : '';
                      var selectedEndDate = _this2._isSelectedEndDate(dateObj) ? 'selected-end-date' : '';
                      var disabled = _this2._isFutureDate(dateObj) ? 'disabled' : '';
                      var cssClass = ['day', fadedDay, selectedBetweenDate, selectedStartDate, selectedEndDate, disabled].join(' ');
                      return React.createElement(
                        'td',
                        { key: idx, className: cssClass },
                        React.createElement(
                          'a',
                          {
                            className: _DateBox2.default.anchor,
                            disabled: _this2._isFutureDate(dateObj),
                            onClick: function onClick() {
                              return _this2._onClickDate(dateObj);
                            } },
                          dateObj.date()
                        )
                      );
                    })
                  );
                })
              ),
              React.createElement('tbody', null)
            )
          )
        )
      );
    }
  }, {
    key: '_getCalendarWeeks',
    value: function _getCalendarWeeks() {
      var _props = this.props,
          year = _props.year,
          month = _props.month;

      var calendar = [];
      var dateIterator = (0, _moment2.default)({ year: year, month: month }).startOf('month').startOf('week');
      var weekIterator = 0;
      var dayIterator = 0; // day of week iterator

      // 42 days
      for (var i = 0; i < 42; i++) {
        if (calendar[weekIterator] === undefined) {
          calendar[weekIterator] = [];
        }
        // must be new object!
        calendar[weekIterator][dayIterator] = (0, _moment2.default)(dateIterator);
        // if day of week is saturday, rest
        if (dateIterator.day() === 6) {
          weekIterator += 1;
          dayIterator = 0;
          calendar[weekIterator] = [];
        } else {
          dayIterator++;
        }
        dateIterator.add(1, 'days');
      }
      return calendar;
    }

    /**
     * Check whether a date object is part of month
     * @param {Date} date
     * @return {boolean}
     * @private
     */

  }, {
    key: '_isPartOfMonth',
    value: function _isPartOfMonth(date) {
      var _props2 = this.props,
          year = _props2.year,
          month = _props2.month;

      var startOfMonth = (0, _moment2.default)({ year: year, month: month }).startOf('month');
      var endOfMonth = (0, _moment2.default)({ year: year, month: month }).endOf('month');
      var ret = startOfMonth <= date && date <= endOfMonth;
      return ret;
    }

    /**
     * Check whether a date is selected by user
     * @param {Date} date
     * @return {boolean}
     * @private
     */

  }, {
    key: '_isPartOfSelected',
    value: function _isPartOfSelected(date) {
      var _props3 = this.props,
          startDate = _props3.startDate,
          endDate = _props3.endDate;

      if (!startDate || !endDate) {
        return false;
      } else {
        var a = startDate.isSameOrBefore(date, 'day');
        var b = endDate.isSameOrAfter(date, 'day');
        return a && b;
      }
    }
  }, {
    key: '_isFutureDate',
    value: function _isFutureDate(date) {
      return date.isAfter((0, _moment2.default)(), 'day');
    }
  }, {
    key: '_isSelectedStartDate',
    value: function _isSelectedStartDate(date) {
      var startDate = this.props.startDate;

      if (!startDate) {
        return false;
      } else {
        return startDate.isSame(date, 'day');
      }
    }
  }, {
    key: '_isSelectedEndDate',
    value: function _isSelectedEndDate(date) {
      var endDate = this.props.endDate;

      if (!endDate) {
        return false;
      } else {
        return endDate.isSame(date, 'day');
      }
    }
  }]);
  return DateBox;
}(React.Component);

DateBox.propTypes = {
  year: React.PropTypes.number,
  month: React.PropTypes.number,
  startDate: React.PropTypes.object,
  endDate: React.PropTypes.object,
  onChange: React.PropTypes.func
};

exports.default = DateBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _MonthSelectBox = __webpack_require__(1955);

var _MonthSelectBox2 = _interopRequireDefault(_MonthSelectBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthSelectBox = function (_React$Component) {
  (0, _inherits3.default)(MonthSelectBox, _React$Component);

  function MonthSelectBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MonthSelectBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MonthSelectBox.__proto__ || (0, _getPrototypeOf2.default)(MonthSelectBox)).call.apply(_ref, [this].concat(args))), _this), _this._previousMonth = function () {
      var _this$props = _this.props,
          year = _this$props.year,
          month = _this$props.month;

      var newDate = (0, _moment2.default)({ year: year, month: month }).add(-1, 'months');
      _this.props.onChange({
        year: newDate.year(),
        month: newDate.month()
      });
    }, _this._nextMonth = function () {
      var _this$props2 = _this.props,
          year = _this$props2.year,
          month = _this$props2.month;

      var newDate = (0, _moment2.default)({ year: year, month: month }).add(1, 'months');
      _this.props.onChange({
        year: newDate.year(),
        month: newDate.month()
      });
    }, _this._monthLabel = function () {
      var _this$props3 = _this.props,
          year = _this$props3.year,
          month = _this$props3.month;

      return (0, _moment2.default)({ year: year, month: month }).format('MMMM');
    }, _this._yearLabel = function () {
      var _this$props4 = _this.props,
          year = _this$props4.year,
          month = _this$props4.month;

      return (0, _moment2.default)({ year: year, month: month }).format('YYYY');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MonthSelectBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: _MonthSelectBox2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement(
              'table',
              { className: _MonthSelectBox2.default.table, cellSpacing: '0' },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    null,
                    React.createElement(
                      'button',
                      { className: 'btn btn-default ' + _MonthSelectBox2.default['btn'], onClick: function onClick() {
                          return _this2._previousMonth();
                        } },
                      React.createElement('span', { className: 'fa fa-angle-left' })
                    )
                  ),
                  React.createElement(
                    'td',
                    { colSpan: '5' },
                    React.createElement(
                      'span',
                      { className: _MonthSelectBox2.default.month },
                      this._monthLabel()
                    ),
                    '\xA0',
                    React.createElement(
                      'span',
                      { className: _MonthSelectBox2.default.year },
                      this._yearLabel()
                    )
                  ),
                  React.createElement(
                    'td',
                    null,
                    React.createElement(
                      'button',
                      { className: 'btn btn-default ' + _MonthSelectBox2.default['btn'], onClick: function onClick() {
                          return _this2._nextMonth();
                        } },
                      React.createElement('span', { className: 'fa fa-angle-right' })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return MonthSelectBox;
}(React.Component);

MonthSelectBox.propTypes = {
  year: React.PropTypes.number,
  month: React.PropTypes.number
};
exports.default = MonthSelectBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RangeBox = __webpack_require__(1956);

var _RangeBox2 = _interopRequireDefault(_RangeBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangeBox = function (_React$Component) {
  (0, _inherits3.default)(RangeBox, _React$Component);

  function RangeBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RangeBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RangeBox.__proto__ || (0, _getPrototypeOf2.default)(RangeBox)).call.apply(_ref, [this].concat(args))), _this), _this.buttonOptions = [{ id: 'today', name: 'Today' }, { id: 'yesterday', name: 'Yesterday' }, { id: 'this_week', name: 'This Week' }, { id: 'last_week', name: 'Last Week' }, { id: 'this_month', name: 'This Month' }, { id: 'last_month', name: 'Last Month' }, { id: 'this_year', name: 'This Year' }, { id: 'last_year', name: 'Last Year' }], _this._onClickButton = function (e, id) {
      // we need this to prevent keep opening of dropdown
      // because the open state needs to be set manually (from onChange)
      e.preventDefault();
      e.stopPropagation();

      var startDate = (0, _moment2.default)();
      var endDate = (0, _moment2.default)();
      switch (id) {
        case 'today':
          // no op
          break;
        case 'yesterday':
          startDate.startOf('day').add(-1, 'days');
          endDate = (0, _moment2.default)(startDate).endOf('day');
          break;
        case 'this_week':
          startDate.startOf('week');
          break;
        case 'last_week':
          startDate.startOf('week').add(-1, 'week');
          endDate = (0, _moment2.default)(startDate).endOf('week');
          break;
        case 'this_month':
          startDate.startOf('month');
          break;
        case 'last_month':
          startDate.startOf('month').add(-1, 'month');
          endDate = (0, _moment2.default)(startDate).endOf('month');
          break;
        case 'this_year':
          startDate.startOf('year');
          break;
        case 'last_year':
          startDate.startOf('year').add(-1, 'year');
          endDate = (0, _moment2.default)(startDate).endOf('year');
          break;
      }
      _this.props.onChange({ startDate: startDate, endDate: endDate });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RangeBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: _RangeBox2.default.wrapper },
        this.buttonOptions.map(function (_ref2) {
          var id = _ref2.id,
              name = _ref2.name;

          return React.createElement(
            'div',
            { className: 'row ' + _RangeBox2.default.row },
            React.createElement(
              'button',
              { className: 'btn btn-default btn-block', onClick: function onClick(e) {
                  _this2._onClickButton(e, id);
                } },
              name
            )
          );
        })
      );
    }
  }]);
  return RangeBox;
}(React.Component);

RangeBox.propTypes = {
  // onChange({startDate, endDate})
  onChange: React.PropTypes.func
};
exports.default = RangeBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Toggle = __webpack_require__(1957);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toggle = function (_React$Component) {
  (0, _inherits3.default)(Toggle, _React$Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this._label = function () {
      var _this$props = _this.props,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate;

      if (!startDate || !endDate) {
        return 'Loading...';
      } else {
        var momentStart = (0, _moment2.default)(startDate);
        var momentEnd = (0, _moment2.default)(endDate);
        if (momentStart.isSame(momentEnd, 'days')) {
          return momentStart.format('D/M/YYYY');
        } else {
          return momentStart.format('D/M/YYYY') + ' - ' + momentEnd.format('D/M/YYYY');
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Toggle, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        _reactBootstrap.Button,
        { bsClass: 'btn btn-default ' + _Toggle2.default['wrapper'], onClick: this.props.onClick },
        this._label(),
        ' ',
        React.createElement('i', { className: 'fa fa-angle-down' })
      );
    }
  }]);
  return Toggle;
}(React.Component);

Toggle.propTypes = {
  startDate: React.PropTypes.object,
  endDate: React.PropTypes.object,
  onClick: React.PropTypes.func
};

exports.default = Toggle;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _MultipleDropdownSelect = __webpack_require__(1959);

var _MultipleDropdownSelect2 = _interopRequireDefault(_MultipleDropdownSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultipleDropdownSelect = function (_React$Component) {
  (0, _inherits3.default)(MultipleDropdownSelect, _React$Component);

  function MultipleDropdownSelect() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MultipleDropdownSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MultipleDropdownSelect.__proto__ || (0, _getPrototypeOf2.default)(MultipleDropdownSelect)).call.apply(_ref, [this].concat(args))), _this), _this._dropdownSelectStatusLabel = function () {
      var _this$props = _this.props,
          value = _this$props.input.value,
          placeholder = _this$props.placeholder;

      var isArray = !!value && value.constructor === Array;

      if (!isArray) {
        return placeholder;
      } else {
        if (value.length) {
          return value.length + ' checked';
        } else {
          return placeholder;
        }
      }
    }, _this._isSelected = function (key) {
      var value = _this.props.input.value;

      var isSelected = false;
      var isArray = !!value && value.constructor === Array;

      if (isArray) {
        value.forEach(function (v) {
          isSelected = isSelected || v === key;
        });
      }
      return isSelected;
    }, _this._onClick = function (targetVal) {
      var _this$props$input = _this.props.input,
          onChange = _this$props$input.onChange,
          value = _this$props$input.value;

      var retVal = [];
      var targetValExist = false;
      var isArray = !!value && value.constructor === Array;
      if (!isArray) {
        // immediately return 1 element array since the initial value is not array
        retVal.push(targetVal);
      } else {
        value.forEach(function (v) {
          if (v === targetVal) {
            targetValExist = true;
            // deselect - don't insert the value
          } else {
            retVal.push(v);
          }
        });
        if (!targetValExist) {
          retVal.push(targetVal);
        }
      }
      onChange(retVal);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MultipleDropdownSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;

      return React.createElement(
        'div',
        { className: 'btn-group ' + _MultipleDropdownSelect2.default.wrapper },
        React.createElement(
          'button',
          { type: 'button',
            className: 'dropdown-toggle btn btn-default',
            'data-toggle': 'dropdown',
            'aria-haspopup': 'true',
            'aria-expanded': 'false' },
          this._dropdownSelectStatusLabel(),
          ' \xA0',
          React.createElement('span', { className: 'caret' })
        ),
        React.createElement(
          'ul',
          { className: 'dropdown-menu' },
          (0, _keys2.default)(options).map(function (key, index) {
            return React.createElement(
              'li',
              { key: index, onClick: function onClick() {
                  _this2._onClick(key);
                } },
              React.createElement(
                'a',
                null,
                _this2._isSelected(key) && React.createElement('span', { className: 'glyphicon glyphicon-ok' }),
                options[key]
              )
            );
          })
        )
      );
    }
  }]);
  return MultipleDropdownSelect;
}(React.Component);

MultipleDropdownSelect.propTypes = (0, _extends3.default)({}, _reduxForm.propTypes, {
  options: React.PropTypes.object,
  placeholder: React.PropTypes.string
});
exports.default = MultipleDropdownSelect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ConfirmImportModal = __webpack_require__(1969);

var _ConfirmImportModal2 = _interopRequireDefault(_ConfirmImportModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmImportModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmImportModal, _React$Component);

  function ConfirmImportModal() {
    (0, _classCallCheck3.default)(this, ConfirmImportModal);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmImportModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmImportModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmImportModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onConfirm = _props.onConfirm,
          onCancel = _props.onCancel,
          show = _props.show,
          header = _props.header,
          body = _props.body;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: show, dialogClassName: _ConfirmImportModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { id: _ConfirmImportModal2.default['header-delete'] },
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _ConfirmImportModal2.default['title-modal'] },
            header
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          body
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { className: 'btn btn-default', onClick: onCancel },
            'Cancel'
          ),
          React.createElement(
            'button',
            { className: 'btn btn-danger', onClick: onConfirm },
            'Proceed'
          )
        )
      );
    }
  }]);
  return ConfirmImportModal;
}(React.Component);

ConfirmImportModal.propTypes = {
  show: React.PropTypes.bool,
  onCancel: React.PropTypes.func,
  onConfirm: React.PropTypes.func,
  header: React.PropTypes.object,
  body: React.PropTypes.object
};

exports.default = ConfirmImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _InformationModal = __webpack_require__(1971);

var _InformationModal2 = _interopRequireDefault(_InformationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InformationModal = function (_React$Component) {
  (0, _inherits3.default)(InformationModal, _React$Component);

  function InformationModal() {
    (0, _classCallCheck3.default)(this, InformationModal);
    return (0, _possibleConstructorReturn3.default)(this, (InformationModal.__proto__ || (0, _getPrototypeOf2.default)(InformationModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(InformationModal, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        _reactBootstrap.Modal,
        { show: this.props.show, onHide: function onHide() {}, dialogClassName: _InformationModal2.default.dialog },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            'span',
            { className: _InformationModal2.default.title },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Error: ',
          this.props.message
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { type: 'button', className: 'btn btn-default', onClick: this.props.onHide },
            'OK'
          )
        )
      );
    }
  }]);
  return InformationModal;
}(React.Component);

InformationModal.propTypes = {
  show: React.PropTypes.bool,
  message: React.PropTypes.message,
  onHide: React.PropTypes.func
};
exports.default = InformationModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoadingIndicator = __webpack_require__(1140);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingButton(props) {
  return React.createElement(
    'a',
    { href: '#', className: props.className + ' btn btn--loading', disabled: 'true' },
    React.createElement(_LoadingIndicator2.default, null)
  );
}

LoadingButton.propTypes = {
  className: React.PropTypes.string
};

exports.default = LoadingButton;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

function LoadingIndicator() {
  return React.createElement(
    'div',
    null,
    'Loading',
    React.createElement(
      'div',
      { className: 'sk-fading-circle' },
      React.createElement('div', { className: 'sk-circle1 sk-circle' }),
      React.createElement('div', { className: 'sk-circle2 sk-circle' }),
      React.createElement('div', { className: 'sk-circle3 sk-circle' }),
      React.createElement('div', { className: 'sk-circle4 sk-circle' }),
      React.createElement('div', { className: 'sk-circle5 sk-circle' }),
      React.createElement('div', { className: 'sk-circle6 sk-circle' }),
      React.createElement('div', { className: 'sk-circle7 sk-circle' }),
      React.createElement('div', { className: 'sk-circle8 sk-circle' }),
      React.createElement('div', { className: 'sk-circle9 sk-circle' }),
      React.createElement('div', { className: 'sk-circle10 sk-circle' }),
      React.createElement('div', { className: 'sk-circle11 sk-circle' }),
      React.createElement('div', { className: 'sk-circle12 sk-circle' })
    )
  );
}

exports.default = LoadingIndicator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NavMokaLogo = __webpack_require__(1143);

var _NavMokaLogo2 = _interopRequireDefault(_NavMokaLogo);

var _NavLoggedIn = __webpack_require__(1142);

var _NavLoggedIn2 = _interopRequireDefault(_NavLoggedIn);

var _NavNotLoggedIn = __webpack_require__(1144);

var _NavNotLoggedIn2 = _interopRequireDefault(_NavNotLoggedIn);

var _NavOutlet = __webpack_require__(1145);

var _NavOutlet2 = _interopRequireDefault(_NavOutlet);

var _style = __webpack_require__(1980);

var _style2 = _interopRequireDefault(_style);

var _transactions = __webpack_require__(128);

var _invoices = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = function (_React$Component) {
  (0, _inherits3.default)(Nav, _React$Component);

  function Nav() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Nav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Nav.__proto__ || (0, _getPrototypeOf2.default)(Nav)).call.apply(_ref, [this].concat(args))), _this), _this._onClickHamburgerButton = function () {
      _this.props.dispatch((0, _transactions.setTransactionDetail)(null));
      _this.props.dispatch((0, _transactions.hideTransactionDetailModal)());
      _this.props.dispatch((0, _invoices.setReceiptInvoices)(null));
      _this.props.dispatch((0, _invoices.hideReceiptInvoice)(true));
    }, _this._mokaLogoLink = function () {
      var user = _this.props.user;

      if (user) {
        if (user.is_owner || user.is_manager) {
          return '/dashboard';
        } else {
          return '/settings/accounts';
        }
      } else {
        return '/login';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Nav, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.loggedIn !== nextProps.loggedIn) {
        return true;
      }
      if (this.props.location.pathname !== nextProps.location.pathname) {
        return true;
      }

      var user = this.props.user;

      var nextUser = nextProps.user;
      if (user || nextUser) {
        if (user.first_name !== nextUser.first_name) {
          return true;
        }
        if (user.last_name !== nextUser.last_name) {
          return true;
        }
        if (user.email !== nextUser.last_name) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'nav',
        { className: 'navbar mk-navbar ' + _style2.default['navbar-moka'], role: 'navigation' },
        React.createElement(
          'div',
          { className: 'container' },
          React.createElement(
            'div',
            { className: 'col-xs-3 col-md-1 col-image ' + _style2.default['logo-wrapper'] },
            React.createElement(_NavMokaLogo2.default, { link: this.props.loggedIn ? this._mokaLogoLink() : '/login' })
          ),
          React.createElement(
            'div',
            { className: 'col-xs-6 nav-outlet visible-xs visible-sm ' },
            this.props.loggedIn && this.props.location.pathname !== '/settings/billing' && React.createElement(_NavOutlet2.default, (0, _extends3.default)({}, this.props, { onChangeOutlet: this._onChangeOutlet }))
          ),
          React.createElement(
            'div',
            { className: 'col-xs-3 visible-sm visible-xs' },
            React.createElement(
              'button',
              {
                className: 'navbar-toggle navbar-toggle-always',
                'data-toggle': 'collapse',
                'data-target': this.props.loggedIn ? '#NavLoggedIn' : '#NavNotLoggedIn',
                'aria-controls': 'NavNotLoggedIn',
                'aria-expanded': 'false',
                type: 'button',
                onClick: function onClick() {
                  _this2._onClickHamburgerButton();
                } },
              React.createElement(
                'span',
                { className: 'sr-only' },
                'Menu'
              ),
              React.createElement('span', { className: 'icon-bar' }),
              React.createElement('span', { className: 'icon-bar' }),
              React.createElement('span', { className: 'icon-bar' })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-12 col-md-11 col-menu ' + _style2.default['navbar-wrapper'] },
            this.props.location.pathname === '/confirm-employee-invitation' || this.props.location.pathname === '/success-confirm-employee-invitation' || this.props.location.pathname.startsWith('/verify-email-alert-recipient') ? React.createElement(_NavNotLoggedIn2.default, this.props) : this.props.loggedIn ? React.createElement(_NavLoggedIn2.default, this.props) : React.createElement(_NavNotLoggedIn2.default, this.props)
          )
        )
      );
    }
  }, {
    key: '_onChangeOutlet',
    value: function _onChangeOutlet(outletIds, pathname) {}
  }]);
  return Nav;
}(React.Component);

Nav.propTypes = {
  loggedIn: React.PropTypes.bool,
  currentlySending: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
};

exports.default = Nav;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _NavLoggedIn = __webpack_require__(1977);

var _NavLoggedIn2 = _interopRequireDefault(_NavLoggedIn);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavLoggedIn = function (_React$Component) {
  (0, _inherits3.default)(NavLoggedIn, _React$Component);

  function NavLoggedIn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NavLoggedIn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavLoggedIn.__proto__ || (0, _getPrototypeOf2.default)(NavLoggedIn)).call.apply(_ref, [this].concat(args))), _this), _this._logout = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.props.dispatch((0, _actions.logout)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NavLoggedIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          location = _props.location;

      var path = location.pathname;
      var statusLabelNew = Cookies.get('labelNewLoyalty') === undefined || Cookies.get('labelNewLoyalty') === 'true';
      return React.createElement(
        'div',
        { className: 'navbar-collapse collapse header-login ' + _NavLoggedIn2.default.wrapper, id: 'NavLoggedIn' },
        React.createElement(
          'ul',
          { className: 'nav navbar-nav nav-outlet-dekstop-dropdown mk-navbar-nav navbar-right pull-right visible-md visible-lg' },
          React.createElement(
            'li',
            { className: 'dropdown' },
            React.createElement(
              _reactRouter.Link,
              { to: '#', className: 'dropdown-toggle', 'data-toggle': 'dropdown', role: 'button' },
              React.createElement('i', { className: 'glyphicon glyphicon-user' }),
              React.createElement('span', { className: 'fa fa-angle-down' })
            ),
            React.createElement(
              'ul',
              { className: 'dropdown-menu mk-short-profile-dropdown info-width', role: 'menu' },
              React.createElement(
                'li',
                { className: 'mk-short-profile' },
                React.createElement(
                  'div',
                  { className: 'avatar' },
                  React.createElement('img', { src: !this.props.user.gravatar ? __webpack_require__(368) : this.props.user.gravatar, alt: 'account profile default' })
                ),
                React.createElement(
                  'div',
                  { className: 'mk-business-info' },
                  React.createElement(
                    'div',
                    { className: 'business-name gt' },
                    this.props.user.first_name,
                    ' ',
                    this.props.user.last_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'business-email' },
                    this.props.user.email
                  )
                ),
                React.createElement('div', { className: 'clearfix' })
              ),
              React.createElement('li', { className: 'divider' }),
              React.createElement(
                'li',
                null,
                React.createElement(
                  _reactRouter.Link,
                  { to: '/settings/accounts' },
                  'Account Settings'
                )
              ),
              React.createElement('li', { className: 'divider' }),
              React.createElement(
                'li',
                null,
                React.createElement(
                  _reactRouter.Link,
                  { to: '#', onClick: this._logout },
                  React.createElement('i', { className: 'fa fa-sign-out' }),
                  'Logout'
                )
              )
            )
          )
        ),
        user.is_owner || user.is_manager ? React.createElement(
          'ul',
          { className: 'nav nav-outlet-dekstop navbar-nav mk-navbar-nav uppercase visible-md visible-lg' },
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/dashboard') || path === '/' ? 'active' : '', to: '/dashboard' },
              'dashboard'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/reports') ? 'active' : '', to: '/reports/summary' },
              'reports'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/library') ? 'active' : '', to: '/library/list' },
              'library'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/ingredient') ? 'active' : '', to: '/ingredient/list' },
              'ingredient'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/inventory') ? 'active' : '', to: '/inventory/summary' },
              'inventory'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/customers') ? 'active' : '', to: '/customers/list' },
              'customers ',
              statusLabelNew && React.createElement(
                'span',
                { className: 'new-label' },
                'NEW'
              )
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/employees') ? 'active' : '', to: '/employees/list' },
              'employees'
            )
          ),
          !user.is_manager && React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/outlets') ? 'active' : '', to: '/outlets/list' },
              'outlets'
            )
          )
        ) : '',
        user.is_owner || user.is_manager ? React.createElement(
          'ul',
          { className: 'nav navbar-nav mk-navbar-nav uppercase visible-xs visible-sm text-center full-width' },
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/dashboard') || path === '/' ? 'active' : '',
                to: '/dashboard',
                'data-toggle': 'collapse',
                'data-target': '.navbar-collapse' },
              'dashboard'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/reports') ? 'active' : '',
                to: '/reports/summary',
                'data-toggle': 'collapse',
                'data-target': '.navbar-collapse' },
              'reports'
            )
          ),
          !user.is_manager && React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { className: path.startsWith('/settings') ? 'active' : '',
                to: '/settings/billing',
                'data-toggle': 'collapse',
                'data-target': '.navbar-collapse' },
              'account'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { to: '#', onClick: this._logout },
              React.createElement('i', { className: 'fa fa-sign-out' }),
              'Logout'
            )
          )
        ) : React.createElement(
          'ul',
          { className: 'nav navbar-nav mk-navbar-nav uppercase visible-xs visible-sm text-center full-width' },
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { to: '#', onClick: this._logout },
              React.createElement('i', { className: 'fa fa-sign-out' }),
              'Logout'
            )
          )
        )
      );
    }
  }]);
  return NavLoggedIn;
}(React.Component);

exports.default = NavLoggedIn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _NavMokaLogo = __webpack_require__(1978);

var _NavMokaLogo2 = _interopRequireDefault(_NavMokaLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavMokaLogo = function (_React$Component) {
  (0, _inherits3.default)(NavMokaLogo, _React$Component);

  function NavMokaLogo() {
    (0, _classCallCheck3.default)(this, NavMokaLogo);
    return (0, _possibleConstructorReturn3.default)(this, (NavMokaLogo.__proto__ || (0, _getPrototypeOf2.default)(NavMokaLogo)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavMokaLogo, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: '' + _NavMokaLogo2.default.wrapper },
        React.createElement(
          _reactRouter.Link,
          { to: this.props.link, className: 'navbar-brand mk-brand' },
          React.createElement('img', { src: __webpack_require__(2864), className: 'logo-moka' })
        )
      );
    }
  }]);
  return NavMokaLogo;
}(React.Component);

exports.default = NavMokaLogo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _NavNotLoggedIn = __webpack_require__(1979);

var _NavNotLoggedIn2 = _interopRequireDefault(_NavNotLoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACKEND_HOST = "https://experiment-taxitem.mokapos.com";
var BACKEND_PORT = "443";

var NavNotLoggedIn = function (_React$Component) {
  (0, _inherits3.default)(NavNotLoggedIn, _React$Component);

  function NavNotLoggedIn() {
    (0, _classCallCheck3.default)(this, NavNotLoggedIn);
    return (0, _possibleConstructorReturn3.default)(this, (NavNotLoggedIn.__proto__ || (0, _getPrototypeOf2.default)(NavNotLoggedIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavNotLoggedIn, [{
    key: 'render',
    value: function render() {
      var signInStyle = this.props.location.pathname === '/login' ? { color: 'white' } : {};
      var SUPPORT_PAGE = BACKEND_HOST + ':' + BACKEND_PORT + '/support';
      return React.createElement(
        'div',
        { className: 'navbar-collapse collapse header-login ' + _NavNotLoggedIn2.default.wrapper, id: 'NavNotLoggedIn' },
        React.createElement(
          'ul',
          { className: 'nav navbar-nav mk-navbar-nav navbar-right text-center ' + _NavNotLoggedIn2.default['list-menu'] },
          React.createElement(
            'li',
            null,
            React.createElement(
              'a',
              { href: SUPPORT_PAGE, 'data-toggle': 'collapse', 'data-target': '.navbar-collapse.in' },
              'help'
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              _reactRouter.Link,
              { to: '/login', 'data-toggle': 'collapse', 'data-target': '.navbar-collapse.in', style: signInStyle },
              'Sign In'
            )
          )
        )
      );
    }
  }]);
  return NavNotLoggedIn;
}(React.Component);

exports.default = NavNotLoggedIn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _reactRedux = __webpack_require__(6);

var _style = __webpack_require__(1981);

var _style2 = _interopRequireDefault(_style);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavOutlet = function (_React$Component) {
  (0, _inherits3.default)(NavOutlet, _React$Component);

  function NavOutlet() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NavOutlet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavOutlet.__proto__ || (0, _getPrototypeOf2.default)(NavOutlet)).call.apply(_ref, [this].concat(args))), _this), _this._outletName = function () {
      var _this$props = _this.props,
          selectedOutletIds = _this$props.selectedOutletIds,
          outlets = _this$props.outlets;

      if (selectedOutletIds.length > 1) {
        return 'All';
      } else {
        var label = 'Loading...';
        outlets.forEach(function (o) {
          if (o.id === selectedOutletIds[0]) {
            label = o.name;
          }
        });
        return label;
      }
    }, _this._onClickOutletModal = function () {
      _this.props.dispatch((0, _actions.showModalOutletMobile)(true));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NavOutlet, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          location = _props.location;

      return (user.is_owner || user.is_manager) && location.pathname !== '/settings/billings' && React.createElement(
        'div',
        { className: '' + _style2.default['nav-outlet-wrapper'] },
        React.createElement(
          _reactRouter.Link,
          { className: _style2.default['nav-outlet-link'], onClick: this._onClickOutletModal },
          React.createElement(
            'div',
            { className: 'cell-outlet' },
            React.createElement(
              'div',
              { className: 'bar' },
              React.createElement(
                'p',
                { className: _style2.default['text-block-center'] },
                this._outletName(),
                '\xA0'
              )
            ),
            React.createElement(
              'div',
              { className: 'baz' },
              React.createElement('span', { className: 'caret' })
            )
          )
        )
      );
    }
  }]);
  return NavOutlet;
}(React.Component);

function select(state) {
  var _state$actionBar = state.actionBar,
      selectedOutletIds = _state$actionBar.selectedOutletIds,
      outlets = _state$actionBar.outlets;

  return {
    selectedOutletIds: selectedOutletIds, outlets: outlets
  };
}

NavOutlet.propTypes = {
  outlets: React.PropTypes.array
};

exports.default = (0, _reactRedux.connect)(select)(NavOutlet);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(1984);

var _notifications = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationBar = function (_React$Component) {
  (0, _inherits3.default)(NotificationBar, _React$Component);

  function NotificationBar() {
    (0, _classCallCheck3.default)(this, NotificationBar);
    return (0, _possibleConstructorReturn3.default)(this, (NotificationBar.__proto__ || (0, _getPrototypeOf2.default)(NotificationBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotificationBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$notification = this.props.notification,
          bars = _props$notification.bars,
          notificationClicked = _props$notification.notificationClicked;
      var pathname = this.props.location.pathname;

      var doms = bars.map(function (bar, index) {
        return !notificationClicked && React.createElement(
          'div',
          { key: index, className: pathname === '/reports/invoices' || pathname === '/reports/transactions' ? 'mk-alert-box-trx-inv trans-1 ' + bar.level : 'mk-alert-box trans-1 ' + bar.level },
          React.createElement(
            'div',
            { className: 'container' },
            React.createElement(
              'div',
              { className: bar.message.length > 37 ? 'mk-alert pad2' : 'mk-alert pad11' },
              React.createElement(
                'div',
                null,
                bar.message
              )
            )
          )
        );
      });

      return React.createElement(
        'div',
        { onClick: function onClick() {
            _this2.props.dispatch((0, _notifications.onClickNotif)(true));
          } },
        doms
      );
    }
  }]);
  return NotificationBar;
}(React.Component);

NotificationBar.propTypes = {
  notification: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  location: React.PropTypes.object
};
exports.default = NotificationBar;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = exports.ANIMATION_TIME = exports.PROGRESS_INCREASE = exports.MAX_PROGRESS = exports.UPDATE_TIME = undefined;

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_TIME = exports.UPDATE_TIME = 200;
var MAX_PROGRESS = exports.MAX_PROGRESS = 90;
var PROGRESS_INCREASE = exports.PROGRESS_INCREASE = 10;
var ANIMATION_TIME = exports.ANIMATION_TIME = UPDATE_TIME * 2;

var initialState = {
  percent: 0,
  progressInterval: null,
  animationTimeout: null,
  inAnimation: false
};

var ProgressBar = exports.ProgressBar = function (_React$Component) {
  (0, _inherits3.default)(ProgressBar, _React$Component);

  function ProgressBar(props) {
    (0, _classCallCheck3.default)(this, ProgressBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).call(this, props));

    _this.state = initialState;

    _this.boundSimulateProgress = _this.simulateProgress.bind(_this);
    _this.boundResetProgress = _this.resetProgress.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ProgressBar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.loading > 0) {
        this.launch();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading > this.props.loading) {
        this.launch();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.state.progressInterval);
      clearTimeout(this.state.animationTimeout);
    }
  }, {
    key: 'launch',
    value: function launch() {
      var _state = this.state,
          progressInterval = _state.progressInterval,
          percent = _state.percent;
      var animationTimeout = this.state.animationTimeout;


      if (!progressInterval) {
        progressInterval = setInterval(this.boundSimulateProgress, this.props.updateTime);
        clearTimeout(animationTimeout);
        percent = 1;
      }

      this.setState((0, _extends3.default)({}, this.state, { progressInterval: progressInterval, percent: percent }));
    }
  }, {
    key: 'simulateProgress',
    value: function simulateProgress() {
      var _state2 = this.state,
          progressInterval = _state2.progressInterval,
          percent = _state2.percent,
          animationTimeout = _state2.animationTimeout,
          inAnimation = _state2.inAnimation;


      if (percent === 100) {
        clearInterval(progressInterval);
        animationTimeout = setTimeout(this.boundResetProgress, ANIMATION_TIME);
        progressInterval = null;
        inAnimation = false;
      } else if (this.props.loading === 0) {
        percent = 100;
        inAnimation = false;
      } else if (percent < this.props.maxProgress) {
        percent = percent + this.props.progressIncrease;
        inAnimation = true;
      }

      this.setState({ percent: percent, progressInterval: progressInterval, animationTimeout: animationTimeout, inAnimation: inAnimation });
    }
  }, {
    key: 'resetProgress',
    value: function resetProgress() {
      this.setState(initialState);
    }
  }, {
    key: 'shouldShow',
    value: function shouldShow(percent) {
      return percent > 0 && percent < 100;
    }
  }, {
    key: 'buildStyle',
    value: function buildStyle() {
      var style = {
        width: this.state.percent + '%',
        transition: 'width ' + ANIMATION_TIME + 'ms ease-out,\n                   height ' + ANIMATION_TIME + 'ms linear,\n                   opacity ' + ANIMATION_TIME + 'ms ease-out',
        opacity: '1',
        zIndex: 9999 // put at top

        // https://mokapos.atlassian.net/browse/FD-1736
      };if (!this.state.inAnimation) {
        style.transition = 'height ' + ANIMATION_TIME + 'ms linear,\n                   opacity ' + ANIMATION_TIME + 'ms ease-out';
      }
      // Use default styling if there's no CSS class applied
      if (!this.props.className) {
        style.height = '5px';
        style.backgroundColor = 'white';
        style.position = 'absolute';
      }

      return (0, _extends3.default)({}, style, this.props.style);
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this.buildStyle();
      if (this.shouldShow(this.state.percent)) {
        style.opacity = '1';
      } else {
        style.opacity = '0';
      }
      var ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { style: style, className: this.props.className }),
        _react2.default.createElement('div', { style: { display: 'table', clear: 'both' } })
      );
      return ret;
    }
  }]);
  return ProgressBar;
}(_react2.default.Component);

ProgressBar.propTypes = {
  style: _react.PropTypes.object,
  className: _react.PropTypes.string,
  actions: _react.PropTypes.object,
  loading: _react.PropTypes.number,
  updateTime: _react.PropTypes.number,
  maxProgress: _react.PropTypes.number,
  progressIncrease: _react.PropTypes.number
};

ProgressBar.defaultProps = {
  style: {},
  className: undefined,
  loading: 0,
  updateTime: UPDATE_TIME,
  maxProgress: MAX_PROGRESS,
  progressIncrease: PROGRESS_INCREASE
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.moka.loadingBar
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProgressBar);

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavCustomer = function (_React$Component) {
  (0, _inherits3.default)(SubNavCustomer, _React$Component);

  function SubNavCustomer() {
    (0, _classCallCheck3.default)(this, SubNavCustomer);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavCustomer.__proto__ || (0, _getPrototypeOf2.default)(SubNavCustomer)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavCustomer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          subscriptionExpired = _props.subscriptionExpired;

      var statusLabelNew = Cookies.get('labelNewLoyalty') === undefined || Cookies.get('labelNewLoyalty') === 'true';
      var links = [{
        href: '/customers/list',
        label: 'Customers List'
      }, {
        href: '/customers/feedback_list',
        label: 'Feedback'
      }, {
        href: '/customers/loyalty',
        label: 'Loyalty Program',
        isNew: statusLabelNew
      }];

      return React.createElement(_SubNav2.default, { links: links, location: this.props.location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavCustomer;
}(React.Component);

SubNavCustomer.propTypes = {
  location: React.PropTypes.object
};
exports.default = SubNavCustomer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavEmployee = function (_React$Component) {
  (0, _inherits3.default)(SubNavEmployee, _React$Component);

  function SubNavEmployee() {
    (0, _classCallCheck3.default)(this, SubNavEmployee);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavEmployee.__proto__ || (0, _getPrototypeOf2.default)(SubNavEmployee)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavEmployee, [{
    key: 'render',
    value: function render() {
      var links = void 0;
      var _props = this.props,
          user = _props.user,
          location = _props.location,
          subscriptionExpired = _props.subscriptionExpired;


      if (user.is_owner) {
        links = [{
          href: '/employees/list',
          label: 'Staff'
        }, {
          href: '/employees/permission',
          label: 'Permissions'
        }];
      } else if (user.is_manager) {
        links = [{
          href: '/employees/list',
          label: 'Staff'
        }];
      }

      return React.createElement(_SubNav2.default, { links: links, location: location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavEmployee;
}(React.Component);

SubNavEmployee.propTypes = {
  location: React.PropTypes.object
};

exports.default = SubNavEmployee;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavIngredient = function (_React$Component) {
  (0, _inherits3.default)(SubNavIngredient, _React$Component);

  function SubNavIngredient() {
    (0, _classCallCheck3.default)(this, SubNavIngredient);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavIngredient.__proto__ || (0, _getPrototypeOf2.default)(SubNavIngredient)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavIngredient, [{
    key: 'render',
    value: function render() {
      var links = void 0;
      var _props = this.props,
          user = _props.user,
          location = _props.location,
          subscriptionExpired = _props.subscriptionExpired;


      if (user.is_owner) {
        links = [{
          href: '/ingredient/list',
          label: 'Ingredient Library'
        }, {
          href: '/ingredient/categories',
          label: 'Ingredient Categories'
        }, {
          href: '/ingredient/recipes',
          label: 'Recipes'
        }];
      } else if (user.is_manager) {
        links = [{
          href: '/ingredient/list',
          label: 'Ingredient Library'
        }, {
          href: '/ingredient/categories',
          label: 'Ingredient Categories'
        }, {
          href: '/ingredient/recipes',
          label: 'Recipes'
        }];
      }

      return React.createElement(_SubNav2.default, { links: links, location: location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavIngredient;
}(React.Component);

SubNavIngredient.propTypes = {
  location: React.PropTypes.object
};
exports.default = SubNavIngredient;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavInventory = function (_React$Component) {
  (0, _inherits3.default)(SubNavInventory, _React$Component);

  function SubNavInventory() {
    (0, _classCallCheck3.default)(this, SubNavInventory);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavInventory.__proto__ || (0, _getPrototypeOf2.default)(SubNavInventory)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavInventory, [{
    key: 'render',
    value: function render() {
      var links = void 0;
      var _props = this.props,
          user = _props.user,
          location = _props.location,
          subscriptionExpired = _props.subscriptionExpired;


      if (user.is_owner) {
        links = [{
          href: '/inventory/summary',
          label: 'Summary'
        }, {
          href: '/inventory/suppliers',
          label: 'Suppliers'
        }, {
          href: '/inventory/purchase_orders',
          label: 'Purchase Order (PO)'
        }, {
          href: '/inventory/transfer',
          label: 'Transfer'
        }, {
          href: '/inventory/adjustment',
          label: 'Adjustment'
        }];
      } else if (user.is_manager) {
        links = [{
          href: '/inventory/summary',
          label: 'Summary'
        }, {
          href: '/inventory/purchase_orders',
          label: 'Purchase Order (PO)'
        }, {
          href: '/inventory/transfer',
          label: 'Transfer'
        }, {
          href: '/inventory/adjustment',
          label: 'Adjustment'
        }];
      }

      return React.createElement(_SubNav2.default, { links: links, location: location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavInventory;
}(React.Component);

SubNavInventory.propTypes = {
  location: React.PropTypes.object
};
exports.default = SubNavInventory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavLibrary = function (_React$Component) {
  (0, _inherits3.default)(SubNavLibrary, _React$Component);

  function SubNavLibrary() {
    (0, _classCallCheck3.default)(this, SubNavLibrary);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavLibrary.__proto__ || (0, _getPrototypeOf2.default)(SubNavLibrary)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavLibrary, [{
    key: 'render',
    value: function render() {
      var links = void 0;
      var _props = this.props,
          user = _props.user,
          location = _props.location,
          subscriptionExpired = _props.subscriptionExpired;


      if (user.is_owner) {
        links = [{
          href: '/library/list',
          label: 'Item Library'
        }, {
          href: '/library/modifier',
          label: 'Modifiers'
        }, {
          href: '/library/category',
          label: 'Categories'
        }, {
          href: '/library/discount',
          label: 'Discounts'
        }, {
          href: '/library/tax',
          label: 'Taxes'
        }, {
          href: '/library/gratuity',
          label: 'Gratuity'
        }];
      } else if (user.is_manager) {
        links = [{
          href: '/library/list',
          label: 'Item Library'
        }, {
          href: '/library/modifier',
          label: 'Modifiers'
        }, {
          href: '/library/category',
          label: 'Categories'
        }, {
          href: '/library/discount',
          label: 'Discounts'
        }];
      }

      return React.createElement(_SubNav2.default, { links: links, location: location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavLibrary;
}(React.Component);

SubNavLibrary.propTypes = {
  location: React.PropTypes.object
};

exports.default = SubNavLibrary;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavOutlet = function (_React$Component) {
  (0, _inherits3.default)(SubNavOutlet, _React$Component);

  function SubNavOutlet() {
    (0, _classCallCheck3.default)(this, SubNavOutlet);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavOutlet.__proto__ || (0, _getPrototypeOf2.default)(SubNavOutlet)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavOutlet, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          subscriptionExpired = _props.subscriptionExpired;


      var links = [{
        href: '/outlets/list',
        label: 'Outlets'
      }];

      return React.createElement(_SubNav2.default, { links: links, location: this.props.location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavOutlet;
}(React.Component);

SubNavOutlet.propTypes = {
  location: React.PropTypes.object
};

exports.default = SubNavOutlet;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavReport = function (_React$Component) {
  (0, _inherits3.default)(SubNavReport, _React$Component);

  function SubNavReport() {
    (0, _classCallCheck3.default)(this, SubNavReport);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavReport.__proto__ || (0, _getPrototypeOf2.default)(SubNavReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavReport, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          subscriptionExpired = _props.subscriptionExpired;


      var links = [{
        href: '/reports/transactions',
        label: 'Transactions'
      }, {
        href: '/reports/invoices',
        label: 'Invoices'
      }, {
        href: '/reports/shifts',
        label: 'Shift'
      }];

      return React.createElement(_SubNav2.default, { links: links, location: this.props.location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavReport;
}(React.Component);

SubNavReport.propTypes = {
  location: React.PropTypes.object
};
exports.default = SubNavReport;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubNav = __webpack_require__(149);

var _SubNav2 = _interopRequireDefault(_SubNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavSetting = function (_React$Component) {
  (0, _inherits3.default)(SubNavSetting, _React$Component);

  function SubNavSetting() {
    (0, _classCallCheck3.default)(this, SubNavSetting);
    return (0, _possibleConstructorReturn3.default)(this, (SubNavSetting.__proto__ || (0, _getPrototypeOf2.default)(SubNavSetting)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubNavSetting, [{
    key: 'render',
    value: function render() {
      var links = void 0;
      var _props = this.props,
          user = _props.user,
          location = _props.location,
          isMobile = _props.isMobile,
          subscriptionExpired = _props.subscriptionExpired;


      if (user.is_owner) {
        if (isMobile) {
          links = [{
            href: '/settings/billing',
            label: 'Billing'
          }];
        } else {
          links = [{
            href: '/settings/accounts',
            label: 'Account'
          }, {
            href: '/settings/billing',
            label: 'Billing'
          }, {
            href: '/settings/public_profile',
            label: 'Public Profile'
          }, {
            href: '/settings/receipt',
            label: 'Receipt'
          }, {
            href: '/settings/checkout',
            label: 'Checkout'
          }, {
            href: '/settings/email',
            label: 'Email Notification'
          }];
        }
      } else if (user.is_manager) {
        links = [{
          href: '/settings/accounts',
          label: 'Account'
        }, {
          href: '/settings/receipt',
          label: 'Receipt'
        }];
      } else {
        if (isMobile) {
          links = [];
        } else {
          links = [{
            href: '/settings/accounts',
            label: 'Account'
          }];
        }
      }
      return React.createElement(_SubNav2.default, { links: links, location: location, user: user, subscriptionExpired: subscriptionExpired });
    }
  }]);
  return SubNavSetting;
}(React.Component);

SubNavSetting.propTypes = {
  location: React.PropTypes.object
};

exports.default = SubNavSetting;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SubscriptionExpired = __webpack_require__(1988);

var _SubscriptionExpired2 = _interopRequireDefault(_SubscriptionExpired);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionExpiredModal = function (_React$Component) {
  (0, _inherits3.default)(SubscriptionExpiredModal, _React$Component);

  function SubscriptionExpiredModal() {
    (0, _classCallCheck3.default)(this, SubscriptionExpiredModal);
    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionExpiredModal.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionExpiredModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubscriptionExpiredModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onHide = _props.onHide,
          showModal = _props.showModal;

      return React.createElement(
        _reactBootstrap.Modal,
        {
          onHide: onHide,
          show: showModal,
          dialogClassName: _SubscriptionExpired2.default.dialog + ' ' + _SubscriptionExpired2.default['subscription-expired'] + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { id: _SubscriptionExpired2.default['header-expired'] },
          React.createElement(
            'button',
            { onClick: onHide,
              type: 'button',
              className: 'close',
              'data-dismiss': 'modal',
              'aria-label': 'Close' },
            React.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _SubscriptionExpired2.default['title-modal'] },
            'Subscription Expired'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Your subscription has expired. Please extend your subscription to reactivate the account.'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          { bsClass: 'modal-footer ' + _SubscriptionExpired2.default.footer + '  ' + _SubscriptionExpired2.default['subscription-expired'] + ' ' },
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default',
                onClick: onHide },
              'Close'
            )
          )
        )
      );
    }
  }]);
  return SubscriptionExpiredModal;
}(React.Component);

SubscriptionExpiredModal.propTypes = {
  onHide: React.PropTypes.func,
  showModal: React.PropTypes.bool
};

exports.default = SubscriptionExpiredModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(106);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(1989);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableWithChild = function (_React$Component) {
  (0, _inherits3.default)(TableWithChild, _React$Component);

  function TableWithChild() {
    (0, _classCallCheck3.default)(this, TableWithChild);
    return (0, _possibleConstructorReturn3.default)(this, (TableWithChild.__proto__ || (0, _getPrototypeOf2.default)(TableWithChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableWithChild, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerBody = _props.headerBody,
          childBody = _props.childBody,
          footBody = _props.footBody,
          tableClass = _props.tableClass,
          headerBodyClassName = _props.headerBodyClassName,
          childBodyClassName = _props.childBodyClassName,
          footBodyClassName = _props.footBodyClassName;

      return React.createElement(
        'table',
        { className: 'table mk-table-summary mk-table-fixed-hf report-table ' + tableClass },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            headerBody.map(function (val, pidx) {
              return React.createElement(
                'th',
                { className: headerBodyClassName[pidx] },
                val
              );
            })
          )
        ),
        React.createElement(
          'tbody',
          null,
          childBody.map(function (val, pidx) {
            var valObj = (0, _values2.default)(val.data);
            return React.createElement(
              'tr',
              null,
              valObj.map(function (value, pidx) {
                return React.createElement(
                  'td',
                  { className: childBodyClassName[pidx] + ' ' + (!val.isParent && value === valObj[0] ? 'child' : '') + ' ' + (val.isParent && value === valObj[0] ? 'parent' : '') },
                  value
                );
              })
            );
          })
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'divider text-total' },
            (0, _values2.default)(footBody).map(function (value, pidx) {
              return React.createElement(
                'td',
                { className: footBodyClassName[pidx] },
                React.createElement(
                  'b',
                  null,
                  value
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TableWithChild;
}(React.Component);

exports.default = TableWithChild;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(106);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(1992);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableScrollWithChildHorizontalVertical = function (_React$Component) {
  (0, _inherits3.default)(TableScrollWithChildHorizontalVertical, _React$Component);

  function TableScrollWithChildHorizontalVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableScrollWithChildHorizontalVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableScrollWithChildHorizontalVertical.__proto__ || (0, _getPrototypeOf2.default)(TableScrollWithChildHorizontalVertical)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      window.addEventListener('resize', _this._handleWindowHeight);
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('resize', _this._handleWindowHeight);
    }, _this._contentHeightInterval = function () {
      return setInterval(function () {
        this._handleWindowHeight();
      }, 100);
    }, _this._handleScroll = function () {
      var divScroll = $('.div-scroll');
      document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft();
    }, _this._handleTableScroll = function () {
      var tableScroll = $('.table-scroll');
      var widthDiv = tableScroll.scrollLeft() + tableScroll.width();
      document.getElementById('tbodyinner').style.width = widthDiv + 'px';
    }, _this._handleTbodyInner = function () {
      var tbodyInner = $('#tbodyinner');
      document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop();
    }, _this._handleWindowHeight = function () {
      var bodyHeight = $(window).height();
      var contentHeight = bodyHeight - 266;
      $('.div-scroll > .table-scroll tbody').css('max-height', contentHeight + 'px');
      $('.div-static > .table-static tbody').css('max-height', contentHeight + 'px');
      if ($('.div-scroll > .table-scroll tbody').css('max-height') === contentHeight + 'px' && $('.report-table-outer').hasClass('element-non-mobi')) {
        clearInterval(_this._contentHeightInterval);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableScrollWithChildHorizontalVertical, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var divScroll = $('.div-scroll');
      var tableScroll = $('.table-scroll');
      var tbodyInner = $('#tbodyinner');
      divScroll.scroll(this._handleScroll);
      tableScroll.scroll(this._handleTableScroll);
      tbodyInner.scroll(this._handleTbodyInner);
      this._handleWindowHeight();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          parentHeader = _props.parentHeader,
          parentBody = _props.parentBody,
          parentFoot = _props.parentFoot,
          childHeaders = _props.childHeaders,
          childBody = _props.childBody,
          childFoot = _props.childFoot,
          parentClassName = _props.parentClassName,
          childHeaderClassName = _props.childHeaderClassName,
          childBodyClassName = _props.childBodyClassName,
          childFootClassName = _props.childFootClassName;


      return React.createElement(
        'div',
        { id: 'report-sales-scroll', className: 'report-table-outer report-table-sales element-non-mobi' },
        React.createElement(
          'div',
          { className: 'div-static' },
          React.createElement(
            'table',
            { className: 'table table-static' },
            React.createElement(
              'thead',
              { className: parentClassName[0] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  null,
                  parentHeader
                )
              )
            ),
            React.createElement(
              'tbody',
              { id: 'tbodydiv', className: parentClassName[1] },
              parentBody.map(function (val, pidx) {
                return React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    { className: val.isParent ? 'parent' : 'child' },
                    val.name
                  )
                );
              })
            ),
            React.createElement(
              'tfoot',
              { className: parentClassName[2] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  React.createElement(
                    'strong',
                    null,
                    parentFoot
                  )
                )
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'div-scroll' },
          React.createElement(
            'table',
            { className: 'table table-scroll' },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                childHeaders.map(function (val, pidx) {
                  return React.createElement(
                    'th',
                    { className: childHeaderClassName[pidx] },
                    val
                  );
                })
              )
            ),
            React.createElement(
              'tbody',
              { id: 'tbodyinner' },
              childBody.map(function (val, pidx) {
                var valObj = (0, _values2.default)(val.data);
                return React.createElement(
                  'tr',
                  null,
                  valObj.map(function (value, pidx) {
                    return React.createElement(
                      'td',
                      { className: childBodyClassName[pidx] + ' ' + (val.isParent ? 'parent' : 'child') },
                      value
                    );
                  })
                );
              })
            ),
            React.createElement(
              'tfoot',
              { id: 'tfootscroll' },
              React.createElement(
                'tr',
                { className: 'text-total' },
                (0, _values2.default)(childFoot).map(function (value, pidx) {
                  return React.createElement(
                    'td',
                    { className: childFootClassName[pidx] },
                    React.createElement(
                      'b',
                      null,
                      value
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return TableScrollWithChildHorizontalVertical;
}(React.Component);

exports.default = TableScrollWithChildHorizontalVertical;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _style = __webpack_require__(1994);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadValidationModal = function (_React$Component) {
  (0, _inherits3.default)(UploadValidationModal, _React$Component);

  function UploadValidationModal() {
    (0, _classCallCheck3.default)(this, UploadValidationModal);
    return (0, _possibleConstructorReturn3.default)(this, (UploadValidationModal.__proto__ || (0, _getPrototypeOf2.default)(UploadValidationModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(UploadValidationModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hideUploadValidationModal = _props.hideUploadValidationModal,
          showUploadValidationModal = _props.showUploadValidationModal,
          textModal = _props.textModal;


      return React.createElement(
        _reactBootstrap.Modal,
        {
          onHide: hideUploadValidationModal,
          show: showUploadValidationModal,
          dialogClassName: _style2.default.dialog + ' modal-dialog margin-top-120' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _style2.default['title-modal'] },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            textModal
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default',
                onClick: hideUploadValidationModal },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return UploadValidationModal;
}(React.Component);

UploadValidationModal.propTypes = {
  hideUploadValidationModal: React.PropTypes.func,
  showUploadValidationModal: React.PropTypes.func,
  textModal: React.PropTypes.func
};

exports.default = UploadValidationModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundSubTotal = function (_React$Component) {
  (0, _inherits3.default)(RefundSubTotal, _React$Component);

  function RefundSubTotal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RefundSubTotal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RefundSubTotal.__proto__ || (0, _getPrototypeOf2.default)(RefundSubTotal)).call.apply(_ref, [this].concat(args))), _this), _this._formatSubtotal = function (subtotal) {
      if (subtotal > 0) {
        return '(' + (0, _formatter.rupiah)(subtotal) + ')';
      } else {
        return '(' + (0, _formatter.rupiah)(-1 * subtotal) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RefundSubTotal, [{
    key: 'render',
    value: function render() {
      var subtotal = this.props.subtotal;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'pull-left' },
          'Subtotal'
        ),
        React.createElement(
          'div',
          { className: 'pull-right' },
          this._formatSubtotal(subtotal)
        ),
        React.createElement('div', { className: 'clearfix' })
      );
    }
  }]);
  return RefundSubTotal;
}(React.Component);

RefundSubTotal.propTypes = {
  subtotal: React.PropTypes.number
};

exports.default = RefundSubTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Notes = __webpack_require__(1999);

var _Notes2 = _interopRequireDefault(_Notes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notes = function (_React$Component) {
  (0, _inherits3.default)(Notes, _React$Component);

  function Notes() {
    (0, _classCallCheck3.default)(this, Notes);
    return (0, _possibleConstructorReturn3.default)(this, (Notes.__proto__ || (0, _getPrototypeOf2.default)(Notes)).apply(this, arguments));
  }

  (0, _createClass3.default)(Notes, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Notes2.default.wrapper },
        React.createElement(
          'div',
          { className: _Notes2.default.title },
          'NOTE'
        ),
        React.createElement(
          'p',
          { className: _Notes2.default.content },
          this.props.content
        )
      );
    }
  }]);
  return Notes;
}(React.Component);

Notes.propTypes = {
  content: React.PropTypes.string
};

exports.default = Notes;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SocialMediaLink = __webpack_require__(2001);

var _SocialMediaLink2 = _interopRequireDefault(_SocialMediaLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMediaLink = function (_React$Component) {
  (0, _inherits3.default)(SocialMediaLink, _React$Component);

  function SocialMediaLink() {
    (0, _classCallCheck3.default)(this, SocialMediaLink);
    return (0, _possibleConstructorReturn3.default)(this, (SocialMediaLink.__proto__ || (0, _getPrototypeOf2.default)(SocialMediaLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(SocialMediaLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          website = _props.website,
          twitter = _props.twitter,
          facebook = _props.facebook,
          instagram = _props.instagram;

      return React.createElement(
        'div',
        { className: _SocialMediaLink2.default.wrapper },
        React.createElement(
          'div',
          { className: _SocialMediaLink2.default.header },
          'LINKS'
        ),
        React.createElement(
          'ul',
          null,
          React.createElement(
            'li',
            null,
            React.createElement(
              'span',
              { className: 'fa-stack ' + _SocialMediaLink2.default['link-icon-wrapper'] },
              React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
              React.createElement('i', { className: 'fa fa-link fa-stack-1x fa-inverse' })
            ),
            React.createElement(
              'span',
              null,
              website
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              'span',
              { className: 'fa-stack ' + _SocialMediaLink2.default['twitter-icon-wrapper'] },
              React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
              React.createElement('i', { className: 'fa fa-twitter fa-stack-1x fa-inverse' })
            ),
            React.createElement(
              'span',
              null,
              twitter
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              'span',
              { className: 'fa-stack ' + _SocialMediaLink2.default['facebook-icon-wrapper'] },
              React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
              React.createElement('i', { className: 'fa fa-facebook fa-stack-1x fa-inverse' })
            ),
            React.createElement(
              'span',
              null,
              facebook
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              'span',
              { className: 'fa-stack ' + _SocialMediaLink2.default['instagram-icon-wrapper'] },
              React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
              React.createElement('i', { className: 'fa fa-instagram fa-stack-1x fa-inverse' })
            ),
            React.createElement(
              'span',
              null,
              instagram
            )
          )
        )
      );
    }
  }]);
  return SocialMediaLink;
}(React.Component);

SocialMediaLink.propTypes = {
  website: React.PropTypes.string,
  twitter: React.PropTypes.string,
  facebook: React.PropTypes.string,
  instagram: React.PropTypes.string
};

exports.default = SocialMediaLink;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SocialMediaLink = __webpack_require__(1162);

var _SocialMediaLink2 = _interopRequireDefault(_SocialMediaLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SocialMediaLink2.default;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptTax = __webpack_require__(244);

var _ReceiptTax2 = _interopRequireDefault(_ReceiptTax);

var _Subtotal = __webpack_require__(294);

var _Subtotal2 = _interopRequireDefault(_Subtotal);

var _Gratuity = __webpack_require__(243);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _CountingBox = __webpack_require__(750);

var _CountingBox2 = _interopRequireDefault(_CountingBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptCountingBox = function (_React$Component) {
  (0, _inherits3.default)(ReceiptCountingBox, _React$Component);

  function ReceiptCountingBox() {
    (0, _classCallCheck3.default)(this, ReceiptCountingBox);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptCountingBox.__proto__ || (0, _getPrototypeOf2.default)(ReceiptCountingBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptCountingBox, [{
    key: 'render',
    value: function render() {
      var invoiceDetail = this.props.invoiceDetail;


      return React.createElement(
        'div',
        { className: _CountingBox2.default['receipt-counting-box'] },
        React.createElement(_Subtotal2.default, { subtotal: invoiceDetail.subtotal }),
        invoiceDetail.payment_gratuities.length > 0 && React.createElement(_Gratuity2.default, {
          gratuities: invoiceDetail.payment_gratuities,
          includeGratuityTax: invoiceDetail.include_gratuity_tax
        }),
        invoiceDetail.payment_taxes.length > 0 && React.createElement(_ReceiptTax2.default, {
          taxes: invoiceDetail.payment_taxes,
          includeGratuityTax: invoiceDetail.include_gratuity_tax
        })
      );
    }
  }]);
  return ReceiptCountingBox;
}(React.Component);

ReceiptCountingBox.propTypes = {
  invoiceDetail: React.PropTypes.object
};

exports.default = ReceiptCountingBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptTax = __webpack_require__(244);

var _ReceiptTax2 = _interopRequireDefault(_ReceiptTax);

var _RefundSubTotal = __webpack_require__(1160);

var _RefundSubTotal2 = _interopRequireDefault(_RefundSubTotal);

var _Gratuity = __webpack_require__(243);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _CountingBox = __webpack_require__(750);

var _CountingBox2 = _interopRequireDefault(_CountingBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptRefundCountingBox = function (_React$Component) {
  (0, _inherits3.default)(ReceiptRefundCountingBox, _React$Component);

  function ReceiptRefundCountingBox() {
    (0, _classCallCheck3.default)(this, ReceiptRefundCountingBox);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptRefundCountingBox.__proto__ || (0, _getPrototypeOf2.default)(ReceiptRefundCountingBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptRefundCountingBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          invoiceRefund = _props.invoiceRefund,
          subtotal = _props.subtotal;


      return invoiceRefund.is_refund_breakdown && React.createElement(
        'div',
        { className: _CountingBox2.default['receipt-counting-box'] },
        React.createElement(_RefundSubTotal2.default, { subtotal: subtotal }),
        invoiceRefund.payment_gratuities.length > 0 && React.createElement(_Gratuity2.default, {
          gratuities: invoiceRefund.payment_gratuities,
          includeGratuityTax: invoiceRefund.include_gratuity_tax
        }),
        invoiceRefund.payment_taxes.length > 0 && React.createElement(_ReceiptTax2.default, {
          taxes: invoiceRefund.payment_taxes,
          includeGratuityTax: invoiceRefund.include_gratuity_tax
        })
      );
    }
  }]);
  return ReceiptRefundCountingBox;
}(React.Component);

ReceiptRefundCountingBox.propTypes = {
  invoiceRefund: React.PropTypes.object,
  subtotal: React.PropTypes.number
};

exports.default = ReceiptRefundCountingBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _InfoBox = __webpack_require__(751);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptInfo = function (_React$Component) {
  (0, _inherits3.default)(ReceiptInfo, _React$Component);

  function ReceiptInfo() {
    (0, _classCallCheck3.default)(this, ReceiptInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptInfo.__proto__ || (0, _getPrototypeOf2.default)(ReceiptInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptInfo, [{
    key: 'render',
    value: function render() {
      var invoiceDetail = this.props.invoiceDetail;

      return React.createElement(
        'div',
        { className: _InfoBox2.default['receipt-info-box'] },
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-date'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            (0, _formatter.invoiceReceiptDateTime)(invoiceDetail.created_at, 'date')
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(invoiceDetail.created_at, 'time')
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Invoice Number'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.invoice_no
          )
        ),
        invoiceDetail.table_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Table Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.table_name
          )
        ),
        invoiceDetail.served_by && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-served'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Served By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.served_by
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Collected By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.collected_by
          )
        ),
        invoiceDetail.customer_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-served'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Customer Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.customer_name
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Customer Email'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.customer_email
          )
        ),
        React.createElement(
          'div',
          { className: invoiceDetail.invoice_status !== 'paid' ? _InfoBox2.default['payment-due-invoice'] : _InfoBox2.default['payment-due-invoice-black'] },
          'Payment Due by ',
          (0, _moment2.default)(invoiceDetail.invoice_due_date).format('DD MMM YYYY')
        )
      );
    }
  }]);
  return ReceiptInfo;
}(React.Component);

ReceiptInfo.propTypes = {
  invoiceDetail: React.PropTypes.object
};

exports.default = ReceiptInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _InfoBox = __webpack_require__(751);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptRefundInfo = function (_React$Component) {
  (0, _inherits3.default)(ReceiptRefundInfo, _React$Component);

  function ReceiptRefundInfo() {
    (0, _classCallCheck3.default)(this, ReceiptRefundInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptRefundInfo.__proto__ || (0, _getPrototypeOf2.default)(ReceiptRefundInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptRefundInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          invoiceDetail = _props.invoiceDetail,
          invoiceRefund = _props.invoiceRefund;

      return React.createElement(
        'div',
        { className: _InfoBox2.default['receipt-info-box'] },
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-date'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            (0, _formatter.invoiceReceiptDateTime)(invoiceRefund.created_at, 'date')
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(invoiceRefund.created_at, 'time')
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Invoice Number'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.invoice_no
          )
        ),
        invoiceDetail.table_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Table Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.table_name
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Cancelled By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceRefund.refunded_by
          )
        ),
        invoiceDetail.customer_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-served'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Customer Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.customer_name
          )
        ),
        invoiceDetail.customer_email && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Customer Email'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            invoiceDetail.customer_email
          )
        )
      );
    }
  }]);
  return ReceiptRefundInfo;
}(React.Component);

ReceiptRefundInfo.propTypes = {
  invoiceDetail: React.PropTypes.object,
  invoiceRefund: React.PropTypes.object
};

exports.default = ReceiptRefundInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _InvoiceActivity = __webpack_require__(2003);

var _InvoiceActivity2 = _interopRequireDefault(_InvoiceActivity);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvoiceActivity = function (_React$Component) {
  (0, _inherits3.default)(InvoiceActivity, _React$Component);

  function InvoiceActivity() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InvoiceActivity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InvoiceActivity.__proto__ || (0, _getPrototypeOf2.default)(InvoiceActivity)).call.apply(_ref, [this].concat(args))), _this), _this._paymentTypeFormatter = function (paymentType) {
      return paymentType.split('_').join(' ');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(InvoiceActivity, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var invoiceDetail = this.props.invoiceDetail;

      return React.createElement(
        'div',
        { className: 'row ' + _InvoiceActivity2.default['invoice-wrapper'] },
        React.createElement(
          'div',
          { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity'] },
          React.createElement(
            'div',
            { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-container'] },
            'INVOICE ACTIVITY'
          ),
          React.createElement(
            'div',
            { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-list'] },
            React.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
            '\xA0\xA0 At ',
            (0, _moment2.default)(invoiceDetail.created_at).format('D/MM/YYYY'),
            ' Invoice #',
            invoiceDetail.invoice_no,
            ' created for ',
            (0, _formatter.rupiah)(invoiceDetail.total_collected),
            React.createElement(
              'div',
              { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-note'] },
              invoiceDetail.payment_note ? 'Note:' : ''
            ),
            React.createElement(
              'div',
              { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-note-value'] },
              React.createElement(
                'i',
                null,
                invoiceDetail.payment_note
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-list'] },
            React.createElement('span', { className: 'glyphicon glyphicon-envelope' }),
            '\xA0\xA0 At ',
            (0, _moment2.default)(invoiceDetail.created_at).format('D/MM/YYYY'),
            ' Invoice #',
            invoiceDetail.invoice_no,
            ' send to ',
            invoiceDetail.customer_email
          ),
          React.createElement(
            'div',
            { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-list'] },
            invoiceDetail.payment_records.length > 0 && invoiceDetail.payment_records.map(function (paymentRecord, idx) {
              return React.createElement(
                'div',
                { key: idx },
                invoiceDetail.invoice_deposit_amount === paymentRecord.amount_received ? React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'glyphicon glyphicon-tags' }),
                  '\xA0\xA0 At ',
                  (0, _moment2.default)(paymentRecord.payment_date).format('D/MM/YYYY'),
                  ' Down Payment of ',
                  (0, _formatter.rupiah)(paymentRecord.amount_received),
                  ' is received.'
                ) : React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'glyphicon glyphicon-tags' }),
                  '\xA0\xA0 At ',
                  (0, _moment2.default)(paymentRecord.payment_date).format('D/MM/YYYY'),
                  ' payment of ',
                  (0, _formatter.rupiah)(paymentRecord.amount_received),
                  ' is received via ',
                  _this2._paymentTypeFormatter(paymentRecord.payment_type),
                  '.'
                ),
                paymentRecord.note && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-note'] },
                    'Note:'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-note-value'] },
                    React.createElement(
                      'i',
                      null,
                      paymentRecord.note
                    )
                  )
                )
              );
            })
          ),
          invoiceDetail.payment_refunds.length > 0 && React.createElement(
            'div',
            { className: 'col-md-12 ' + _InvoiceActivity2.default['invoice-activity-list'] },
            React.createElement('span', { className: 'glyphicon glyphicon-list-alt' }),
            '\xA0\xA0 At ',
            (0, _moment2.default)(invoiceDetail.created_at).format('D/MM/YYYY'),
            ' Invoice #',
            invoiceDetail.invoice_no,
            ' is cancelled with refund of ',
            (0, _formatter.rupiah)(invoiceDetail.total_collected)
          )
        )
      );
    }
  }]);
  return InvoiceActivity;
}(React.Component);

InvoiceActivity.propTypes = {
  invoiceDetail: React.PropTypes.object
};

exports.default = InvoiceActivity;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DiscountTable = __webpack_require__(245);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

var _ItemTable = __webpack_require__(642);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

var _formatter = __webpack_require__(11);

var _ListItem = __webpack_require__(752);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _RewardRedemptionInfo = __webpack_require__(295);

var _RewardRedemptionInfo2 = _interopRequireDefault(_RewardRedemptionInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptListItem = function (_React$Component) {
  (0, _inherits3.default)(ReceiptListItem, _React$Component);

  function ReceiptListItem() {
    (0, _classCallCheck3.default)(this, ReceiptListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptListItem.__proto__ || (0, _getPrototypeOf2.default)(ReceiptListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptListItem, [{
    key: 'render',
    value: function render() {
      var invoiceDetail = this.props.invoiceDetail;
      var loyalty = invoiceDetail.loyalty;

      return invoiceDetail.checkouts.length > 0 && React.createElement(
        'div',
        { className: _ListItem2.default['receipt-list-item-box'] },
        React.createElement(_ItemTable2.default, {
          checkouts: invoiceDetail.checkouts,
          checkoutPriceFormatter: _formatter.rupiah
        }),
        React.createElement(_DiscountTable2.default, {
          discounts: invoiceDetail.payment_discounts
        }),
        loyalty && loyalty.redemption && loyalty.redemption.reward && React.createElement(_RewardRedemptionInfo2.default, { redeemReward: loyalty.redemption.reward, totalRedeemAmount: invoiceDetail.total_redeem_amount })
      );
    }
  }]);
  return ReceiptListItem;
}(React.Component);

ReceiptListItem.propTypes = {
  invoiceDetail: React.PropTypes.object
};

exports.default = ReceiptListItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemTable = __webpack_require__(642);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

var _DiscountTable = __webpack_require__(245);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

var _formatter = __webpack_require__(11);

var _ListItem = __webpack_require__(752);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _RewardRedemptionInfo = __webpack_require__(295);

var _RewardRedemptionInfo2 = _interopRequireDefault(_RewardRedemptionInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptRefundListItem = function (_React$Component) {
  (0, _inherits3.default)(ReceiptRefundListItem, _React$Component);

  function ReceiptRefundListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptRefundListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptRefundListItem.__proto__ || (0, _getPrototypeOf2.default)(ReceiptRefundListItem)).call.apply(_ref, [this].concat(args))), _this), _this._checkoutPriceFormatter = function (price) {
      if (price >= 0) {
        return (0, _formatter.negativeCurrencyFormatter)(price);
      } else {
        return '(' + (0, _formatter.negativeCurrencyFormatter)(price) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptRefundListItem, [{
    key: 'render',
    value: function render() {
      var invoiceRefund = this.props.invoiceRefund;
      var loyalty = invoiceRefund.loyalty;

      return invoiceRefund.checkouts.length > 0 && React.createElement(
        'div',
        { className: _ListItem2.default['receipt-list-item-box'] },
        invoiceRefund.is_refund_breakdown && React.createElement(_ItemTable2.default, {
          checkouts: invoiceRefund.checkouts,
          checkoutPriceFormatter: this._checkoutPriceFormatter
        }),
        invoiceRefund.is_refund_breakdown && React.createElement(_DiscountTable2.default, {
          discounts: invoiceRefund.payment_discounts,
          isRefunded: true
        }),
        invoiceRefund.is_refund_breakdown && loyalty && loyalty.redemption && loyalty.redemption.reward && React.createElement(_RewardRedemptionInfo2.default, { redeemReward: loyalty.redemption.reward, totalRedeemAmount: invoiceRefund.total_redeem_amount, isRefunded: true })
      );
    }
  }]);
  return ReceiptRefundListItem;
}(React.Component);

ReceiptRefundListItem.propTypes = {
  invoiceRefund: React.PropTypes.object
};

exports.default = ReceiptRefundListItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactDatepicker = __webpack_require__(597);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(2246);

__webpack_require__(2005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MokaDatePicker = function (_React$Component) {
  (0, _inherits3.default)(MokaDatePicker, _React$Component);

  function MokaDatePicker() {
    (0, _classCallCheck3.default)(this, MokaDatePicker);
    return (0, _possibleConstructorReturn3.default)(this, (MokaDatePicker.__proto__ || (0, _getPrototypeOf2.default)(MokaDatePicker)).apply(this, arguments));
  }

  (0, _createClass3.default)(MokaDatePicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          _props$meta = _props.meta,
          touched = _props$meta.touched,
          error = _props$meta.error,
          className = _props.className,
          minDate = _props.minDate;

      return React.createElement(
        'div',
        null,
        React.createElement(_reactDatepicker2.default, (0, _extends3.default)({}, input, {
          dateFormat: 'DD/MM/YYYY',
          onBlur: function onBlur() {
            return input.onBlur();
          },
          selected: input.value ? (0, _moment2.default)(input.value) : null,
          placeholder: 'Payment Date',
          className: className,
          maxDate: (0, _moment2.default)(),
          minDate: minDate,
          readOnly: true
        })),
        touched && error && React.createElement(
          'span',
          null,
          error
        )
      );
    }
  }]);
  return MokaDatePicker;
}(React.Component);

exports.default = MokaDatePicker;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _MokaDatePicker = __webpack_require__(1171);

var _MokaDatePicker2 = _interopRequireDefault(_MokaDatePicker);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.amount_received || values.amount_received < 1) {
    errors.amount_received = 'Please enter a value greater than or equal to 1';
  }
  if (!values.payment_type) {
    errors.payment_type = 'Please select payment type';
  }
  if (!values.payment_date || !(0, _moment2.default)(values.payment_date).isValid()) {
    errors.payment_date = true;
  }
  return errors;
};

var RecordPaymentForm = function (_React$Component) {
  (0, _inherits3.default)(RecordPaymentForm, _React$Component);

  function RecordPaymentForm() {
    (0, _classCallCheck3.default)(this, RecordPaymentForm);
    return (0, _possibleConstructorReturn3.default)(this, (RecordPaymentForm.__proto__ || (0, _getPrototypeOf2.default)(RecordPaymentForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecordPaymentForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          amountDue = _props.amountDue,
          createdDate = _props.createdDate;

      return React.createElement(
        'form',
        { id: 'form-create-payment-record' },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'div',
            { className: 'col-md-6' },
            React.createElement(_reduxForm.Field, {
              component: RecordPaymentForm.renderAmountReceived,
              placeholder: 'Amount Received',
              id: 'payment_record_amount_received',
              name: 'amount_received',
              label: 'Amount Received (Rp)',
              onChange: function onChange(event) {
                var value = event.target.value;
                var maxFractionDigits = 3;
                if (!isNaN(value)) {
                  if (maxFractionDigits !== undefined) {
                    var dotPosition = value.indexOf('.');
                    if (dotPosition !== -1 && value.length - dotPosition - 1 > maxFractionDigits) {
                      // no operation. invalid change
                    } else {
                      if (value > amountDue) {
                        _this2.props.dispatch((0, _reduxForm.change)('recordPaymentForm', 'amount_received', amountDue));
                      } else {
                        _this2.props.dispatch((0, _reduxForm.change)('recordPaymentForm', 'amount_received', value));
                      }
                    }
                  }
                }
                event.preventDefault();
              }
            })
          ),
          React.createElement(
            'div',
            { className: 'col-md-6' },
            React.createElement(
              'label',
              null,
              'Payment Date'
            ),
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _MokaDatePicker2.default,
                className: 'form-control',
                id: 'payment_record_payment_date',
                name: 'payment_date',
                minDate: createdDate
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-12 payment-type' },
            React.createElement(
              'label',
              { className: 'col-md-12 payment-type' },
              'Payment Type'
            ),
            React.createElement(
              'div',
              { className: 'col-md-2 cash' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'radio',
                value: 'cash',
                name: 'payment_type'
              }),
              '\xA0\xA0Cash'
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'radio',
                value: 'check',
                name: 'payment_type'
              }),
              '\xA0\xA0Check'
            ),
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'radio',
                value: 'bank_transfer',
                name: 'payment_type'
              }),
              '\xA0\xA0Bank Transfer'
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'radio',
                value: 'other',
                name: 'payment_type'
              }),
              '\xA0\xA0Other'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement(
              'div',
              { className: 'form-group note' },
              React.createElement(
                'label',
                null,
                'Note:'
              ),
              React.createElement(_reduxForm.Field, {
                component: 'textarea',
                className: 'form-control',
                rows: '5',
                maxLength: '500',
                id: 'payment_record_note',
                name: 'note'
              })
            )
          )
        )
      );
    }
  }], [{
    key: 'renderAmountReceived',
    value: function renderAmountReceived(field) {
      var _field$meta = field.meta,
          touched = _field$meta.touched,
          error = _field$meta.error;

      var className = 'form-group ' + (touched && error ? 'has-error' : '');

      return React.createElement(
        'div',
        { className: className },
        React.createElement(
          'label',
          null,
          field.label
        ),
        React.createElement('input', (0, _extends3.default)({
          type: 'tel',
          className: 'form-control',
          placeholder: field.placeholder
        }, field.input)),
        React.createElement(
          'span',
          { className: 'help-block' },
          touched ? error : ''
        )
      );
    }
  }]);
  return RecordPaymentForm;
}(React.Component);

RecordPaymentForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  amountDue: React.PropTypes.number
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'recordPaymentForm', // a unique identifier for this form,
  validate: validate
})(RecordPaymentForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

__webpack_require__(2004);

var _RecordPaymentForm = __webpack_require__(1172);

var _RecordPaymentForm2 = _interopRequireDefault(_RecordPaymentForm);

var _reactRedux = __webpack_require__(6);

var _invoices = __webpack_require__(170);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecordPaymentModal = function (_React$Component) {
  (0, _inherits3.default)(RecordPaymentModal, _React$Component);

  function RecordPaymentModal(props) {
    (0, _classCallCheck3.default)(this, RecordPaymentModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecordPaymentModal.__proto__ || (0, _getPrototypeOf2.default)(RecordPaymentModal)).call(this, props));

    _this.handleSubmit = function (recordPayment) {
      _this.setState({ isClicked: true });
      var id = _this.props.data.reports.invoices.receiptInvoices.id;

      recordPayment = { id: id, payment_record: _this.props.data.form.recordPaymentForm.values };
      _this.props.dispatch((0, _invoices.recordPaymentRequest)(recordPayment));
    };

    _this.state = {
      isClicked: false
    };
    return _this;
  }

  (0, _createClass3.default)(RecordPaymentModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRecordPaymentModal = _props.openRecordPaymentModal,
          closeRecordPaymentModal = _props.closeRecordPaymentModal,
          onClickCancel = _props.onClickCancel,
          dispatch = _props.dispatch,
          isValidForm = _props.isValidForm;

      return React.createElement(
        'div',
        { className: 'modal-invoice' },
        React.createElement(
          _reactBootstrap.Modal,
          { onHide: closeRecordPaymentModal, show: openRecordPaymentModal, bsClass: 'full-height-modal margin-top-modal modal' },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              'h4',
              { className: 'modal-title' },
              'Record Payment'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(
              'div',
              { className: 'invoice' },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-sm-12' },
                  React.createElement(_RecordPaymentForm2.default, {
                    dispatch: dispatch,
                    amountDue: this.props.data.reports.invoices.receiptInvoices.total_amount_due,
                    createdDate: this.props.data.reports.invoices.receiptInvoices.created_at
                  })
                )
              )
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'div',
              { className: 'pull-left' },
              React.createElement(
                'button',
                {
                  type: 'button',
                  className: 'btn btn-default',
                  onClick: onClickCancel,
                  'data-dismiss': 'modal' },
                'Cancel'
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'button',
                {
                  type: 'submit',
                  onClick: this.handleSubmit,
                  disabled: !isValidForm || this.state.isClicked,
                  className: 'btn btn-primary pull-right' },
                'Save'
              )
            )
          )
        )
      );
    }
  }]);
  return RecordPaymentModal;
}(React.Component);

RecordPaymentModal.propTypes = {
  openRecordPaymentModal: React.PropTypes.bool,
  closeRecordPaymentModal: React.PropTypes.func,
  onClickCancel: React.PropTypes.func,
  data: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var openRecordPaymentModal = state.reports.invoices.openRecordPaymentModal;

  return {
    openRecordPaymentModal: openRecordPaymentModal,
    data: {
      reports: state.reports,
      form: state.form
    },
    isValidForm: (0, _reduxForm.isValid)('recordPaymentForm')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RecordPaymentModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RefundReasonStyle = __webpack_require__(2006);

var _RefundReasonStyle2 = _interopRequireDefault(_RefundReasonStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptRefundReason = function (_React$Component) {
  (0, _inherits3.default)(ReceiptRefundReason, _React$Component);

  function ReceiptRefundReason() {
    (0, _classCallCheck3.default)(this, ReceiptRefundReason);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptRefundReason.__proto__ || (0, _getPrototypeOf2.default)(ReceiptRefundReason)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptRefundReason, [{
    key: 'render',
    value: function render() {
      var invoiceRefund = this.props.invoiceRefund;

      return React.createElement(
        'div',
        { className: _RefundReasonStyle2.default['receipt-refund-reason'] },
        React.createElement(
          'div',
          { className: 'receipt-returned-goods pull-left' },
          'Reason for Cancellation'
        ),
        React.createElement(
          'div',
          { className: _RefundReasonStyle2.default['truncate-refund-reason'] },
          invoiceRefund.refunded_reason
        )
      );
    }
  }]);
  return ReceiptRefundReason;
}(React.Component);

ReceiptRefundReason.propTypes = {
  invoiceRefund: React.PropTypes.object
};

exports.default = ReceiptRefundReason;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Total = __webpack_require__(753);

var _Total2 = _interopRequireDefault(_Total);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptRefundTotal = function (_React$Component) {
  (0, _inherits3.default)(ReceiptRefundTotal, _React$Component);

  function ReceiptRefundTotal() {
    (0, _classCallCheck3.default)(this, ReceiptRefundTotal);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptRefundTotal.__proto__ || (0, _getPrototypeOf2.default)(ReceiptRefundTotal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptRefundTotal, [{
    key: 'render',
    value: function render() {
      var invoiceRefund = this.props.invoiceRefund;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _Total2.default['receipt-total-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Total'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            '(',
            (0, _formatter.rupiah)(invoiceRefund.total_collected_amount * -1),
            ')'
          )
        )
      );
    }
  }]);
  return ReceiptRefundTotal;
}(React.Component);

ReceiptRefundTotal.propTypes = {
  invoiceRefund: React.PropTypes.object
};

exports.default = ReceiptRefundTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Total = __webpack_require__(753);

var _Total2 = _interopRequireDefault(_Total);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptTotal = function (_React$Component) {
  (0, _inherits3.default)(ReceiptTotal, _React$Component);

  function ReceiptTotal() {
    (0, _classCallCheck3.default)(this, ReceiptTotal);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptTotal.__proto__ || (0, _getPrototypeOf2.default)(ReceiptTotal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptTotal, [{
    key: 'render',
    value: function render() {
      var invoiceDetail = this.props.invoiceDetail;


      return React.createElement(
        'div',
        { className: _Total2.default['receipt-counting-box'] },
        React.createElement(
          'div',
          { className: _Total2.default['receipt-total'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Total'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.rupiah)(invoiceDetail.total_collected)
          )
        ),
        invoiceDetail.total_amount_received !== 0 && React.createElement(
          'div',
          { className: _Total2.default['amount-received'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Amount Received'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.rupiah)(invoiceDetail.total_amount_received)
          )
        ),
        React.createElement(
          'div',
          { className: _Total2.default['amount-due'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Amount Due'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.rupiah)(invoiceDetail.total_amount_due)
          )
        )
      );
    }
  }]);
  return ReceiptTotal;
}(React.Component);

ReceiptTotal.propTypes = {
  invoiceDetail: React.PropTypes.object
};

exports.default = ReceiptTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _InfoBox = __webpack_require__(2007);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoBox = function (_React$Component) {
  (0, _inherits3.default)(InfoBox, _React$Component);

  function InfoBox() {
    (0, _classCallCheck3.default)(this, InfoBox);
    return (0, _possibleConstructorReturn3.default)(this, (InfoBox.__proto__ || (0, _getPrototypeOf2.default)(InfoBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          createdAt = _props.createdAt,
          collectedBy = _props.collectedBy,
          paymentNo = _props.paymentNo,
          servedBy = _props.servedBy;

      return React.createElement(
        'div',
        { className: _InfoBox2.default['receipt-info-box'] },
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-date'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            (0, _formatter.invoiceReceiptDateTime)(createdAt, 'date')
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(createdAt, 'time')
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Receipt Number'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentNo
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-served'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Served By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            servedBy
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Collected By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            collectedBy
          )
        )
      );
    }
  }]);
  return InfoBox;
}(React.Component);

InfoBox.propTypes = {
  servedBy: React.PropTypes.string,
  collectedBy: React.PropTypes.string,
  paymentNo: React.PropTypes.string,
  createdAt: React.PropTypes.object
};

exports.default = InfoBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Total = __webpack_require__(2008);

var _Total2 = _interopRequireDefault(_Total);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Total = function (_React$Component) {
  (0, _inherits3.default)(Total, _React$Component);

  function Total() {
    (0, _classCallCheck3.default)(this, Total);
    return (0, _possibleConstructorReturn3.default)(this, (Total.__proto__ || (0, _getPrototypeOf2.default)(Total)).apply(this, arguments));
  }

  (0, _createClass3.default)(Total, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Total2.default.wrapper },
        React.createElement(
          'div',
          { className: _Total2.default['receipt-total-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Total'
          ),
          React.createElement(
            'div',
            { className: 'pull-right text-pre-wrap' },
            (0, _formatter.rupiah)(this.props.total)
          )
        ),
        React.createElement(
          'div',
          { className: 'row ' + _Total2.default['receipt-cash-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Cash'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.rupiah)(this.props.cash)
          )
        ),
        React.createElement(
          'div',
          { className: 'row ' + _Total2.default['receipt-change-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Change'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.rupiah)(this.props.change)
          )
        )
      );
    }
  }]);
  return Total;
}(React.Component);

Total.propTypes = {
  total: React.PropTypes.number,
  cash: React.PropTypes.number,
  change: React.PropTypes.number
};

exports.default = Total;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _Modal = __webpack_require__(505);

var _Modal2 = _interopRequireDefault(_Modal);

var _invoices = __webpack_require__(170);

var actInvoice = _interopRequireWildcard(_invoices);

var _reactRedux = __webpack_require__(6);

var _Item = __webpack_require__(645);

var _Item2 = _interopRequireDefault(_Item);

var _AmountToRefund = __webpack_require__(447);

var _AmountToRefund2 = _interopRequireDefault(_AmountToRefund);

var _Gratuity = __webpack_require__(644);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _Tax = __webpack_require__(647);

var _Tax2 = _interopRequireDefault(_Tax);

var _Discount = __webpack_require__(643);

var _Discount2 = _interopRequireDefault(_Discount);

var _RewardRedemption = __webpack_require__(646);

var _RewardRedemption2 = _interopRequireDefault(_RewardRedemption);

var _RefundReason = __webpack_require__(448);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

__webpack_require__(2010);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelInvoiceModal = function (_React$Component) {
  (0, _inherits3.default)(CancelInvoiceModal, _React$Component);

  function CancelInvoiceModal(props) {
    (0, _classCallCheck3.default)(this, CancelInvoiceModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CancelInvoiceModal.__proto__ || (0, _getPrototypeOf2.default)(CancelInvoiceModal)).call(this, props));

    _this._onHide = function () {
      _this.setState({
        reasonForRefund: null
      });
      _this.props.dispatch(actInvoice.hideCancelInvoiceModal());
    };

    _this._getRewardName = function () {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      return receiptInvoices.loyalty && receiptInvoices.loyalty.type.toLowerCase() === 'redemption' ? receiptInvoices.loyalty.redemption.reward : '';
    };

    _this._onChangeOtherReasonForRefund = function (value) {
      _this.setState({
        otherReasonForRefund: value
      });
    };

    _this._onChangeReasonForRefund = function (value) {
      _this.setState({
        reasonForRefund: value
      });
    };

    _this._onClickIssueRefund = function () {
      _this.setState({ sending: true });
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      // construct taxes

      var taxes = receiptInvoices.payment_taxes.map(function (tax) {
        return {
          'tax_id': tax.tax_id,
          'tax_percentage': tax.amount,
          'taxable_amount': -tax.taxable_amount,
          'tax_amount': -tax.total,
          'tax_name': tax.name
        };
      });

      // construct discounts
      var discounts = receiptInvoices.payment_discounts.map(function (discount) {
        return {
          'discount_id': discount.discount_id,
          'discount_amount': -discount.discount_amount,
          'discount_type': discount.discount_type,
          'discount_name': discount.discount_name,
          'discount_cash': discount.discount_cash
        };
      });

      // construct gratuities
      var gratuities = receiptInvoices.payment_gratuities.map(function (gratuity) {
        return {
          'gratuity_id': gratuity.gratuity_id,
          'gratuity_percentage': gratuity.amount,
          'gratuity_amount': -gratuity.total,
          'gratuity_name': gratuity.name
        };
      });

      var items = receiptInvoices.checkouts.map(function (item) {
        var checkoutDiscounts = [];

        item.discounts.map(function (discount) {
          discount.discount_hash.forEach(function (checkoutDiscount) {
            checkoutDiscounts.push({
              'discount_id': checkoutDiscount.discount_id,
              'discount_name': checkoutDiscount.discount_name,
              'discount_type': checkoutDiscount.discount_type,
              'discount_cash': checkoutDiscount.discount_cash,
              'discount_percentage': checkoutDiscount.discount_percentage,
              'discount_amount': -checkoutDiscount.discount_amount
            });
          });
        });
        return {
          'parent_checkout_id': item.id,
          'item_id': item.item_id,
          'item_variant_id': item.item_variant_id,
          'item_name': item.item_name,
          'item_variant_name': item.item_variant_name,
          'item_variant_sku': item.sku,
          'item_image': item.item_image,
          'quantity': -item.quantity,
          'gross_sales': -item.gross_sales,
          'client_price': item.item_price,
          'discount_amount': -item.discount_amount,
          'redeem_amount': -item.redeem_amount,
          'net_sales': -item.net_sales,
          'gratuity': -item.gratuity_amount,
          'tax': -item.tax_amount,
          'track_stock': item.track_stock,
          'category_id': item.category_id,
          'category_name': item.category_name,
          'discounts': checkoutDiscounts,
          'modifiers': item.modifiers.map(function (modifier) {
            return {
              'modifier_id': modifier.modifier_id,
              'modifier_name': modifier.modifier_name,
              'modifier_option_id': modifier.modifier_option_id,
              'modifier_option_name': modifier.modifier_option_name,
              'modifier_option_price': modifier.price,
              'gross_sales': -modifier.gross_sales,
              'net_sales': -modifier.net_sales,
              'discount_amount': -modifier.discount_amount,
              'redeem_amount': -modifier.redeem_amount,
              'modifier_discounts': modifier.discount_hash.map(function (modifierDiscount) {
                modifierDiscount.discount_amount = -modifierDiscount.discount_amount;
                return modifierDiscount;
              })
            };
          })
        };
      });

      var loyalty = null;
      if (receiptInvoices.loyalty) {
        loyalty = {
          new_earned_points: -receiptInvoices.loyalty.new_earned_points,
          program_id: receiptInvoices.loyalty.program_id,
          member_since: receiptInvoices.loyalty.member_since,
          earning_rule: receiptInvoices.loyalty.earning_rule,
          member_id: receiptInvoices.loyalty.member_id,
          member_uniq_id: receiptInvoices.loyalty.member_uniq_id,
          member_guid: receiptInvoices.loyalty.member_guid
        };

        if (receiptInvoices.loyalty.type.toUpperCase() === 'REDEMPTION') {
          var redemption = receiptInvoices.loyalty.redemption;

          loyalty.redemption = {
            'redeem_points': redemption.redeem_points,
            'redeem_amount': -receiptInvoices.total_redeem_amount,
            'reward_type': redemption.reward_type,
            'reward_id': redemption.reward_id,
            'reward': redemption.reward,
            'discount': redemption.discount,
            'discount_type': redemption.discount_type
          };
        }
      }

      var data = {
        amount: receiptInvoices.total_collected,
        client_created_at: (0, _moment2.default)().format(),
        custom_reason: _this.state.otherReasonForRefund,
        discounts: discounts,
        loyalty: loyalty,
        gratuities: gratuities,
        is_refund_transaction: true,
        items: items,
        payment_id: receiptInvoices.id,
        reason: _this.state.reasonForRefund !== 'Other' ? _this.state.reasonForRefund : _this.state.otherReasonForRefund,
        refund_amount: receiptInvoices.total_net_sales,
        taxes: taxes,
        total_collected: -receiptInvoices.total_collected_amount,
        total_discount: -receiptInvoices.total_discount_amount,
        total_redeem_amount: -receiptInvoices.total_redeem_amount,
        total_gratuity: -receiptInvoices.total_gratuity_amount,
        total_gross_sales: -receiptInvoices.total_gross_sales,
        total_net_sales: -receiptInvoices.total_net_sales,
        total_tax: -receiptInvoices.total_tax_amount
      };

      _this.props.dispatch(actInvoice.issueRefundRequest({ refund: data }));
    };

    _this._calculateAmountToRefund = function () {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      return receiptInvoices.total_collected;
    };

    _this._calculateGratuity = function (gratuityId) {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      var result = 0;
      receiptInvoices.payment_gratuities.forEach(function (gratuity) {
        if (gratuity.id === gratuityId) {
          result = gratuity.total;
        }
      });
      return result;
    };

    _this._calculateTax = function (taxId) {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      var result = 0;
      receiptInvoices.payment_taxes.forEach(function (tax) {
        if (tax.id === taxId) {
          result = tax.total;
        }
      });
      return result;
    };

    _this._calculateDiscount = function (discountId) {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      var result = 0;
      receiptInvoices.payment_discounts.forEach(function (discount) {
        if (discount.discount_id === discountId) {
          result = discount.discount_amount;
        }
      });
      return result;
    };

    _this._calculateItemPrice = function (idx) {
      var checkouts = _this.props.data.reports.invoices.receiptInvoices.checkouts;

      var price = checkouts[idx].price - checkouts[idx].discount_amount;
      if (price < 0) {
        return 0;
      } else {
        return price;
      }
    };

    _this._canCancelInvoice = function () {
      // refund reason is not empty, and if refundReason is 'Other', customReason is not empty
      return _this.state.reasonForRefund && (_this.state.reasonForRefund !== 'Other' || _this.state.otherReasonForRefund) && !_this.state.sending;
    };

    _this.state = {
      reasonForRefund: '',
      otherReasonForRefund: '',
      sending: false
    };
    return _this;
  }

  (0, _createClass3.default)(CancelInvoiceModal, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$i = this.props.data.reports.invoices,
          openCancelInvoiceModal = _props$data$reports$i.openCancelInvoiceModal,
          receiptInvoices = _props$data$reports$i.receiptInvoices;


      var items = receiptInvoices.checkouts.map(function (item) {
        return {
          itemName: item.item_name,
          itemVariantName: item.item_variant_name,
          refundAmount: item.quantity
        };
      });

      return React.createElement(
        _reactBootstrap.Modal,
        { onHide: this._onHide, show: openCancelInvoiceModal, bsClass: 'cancel-invoice full-height-modal margin-top-modal modal' },
        React.createElement(_ModalHeader2.default, { title: 'Cancel Invoice' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: _Modal2.default['modal-body'] + ' modal-body' },
          React.createElement(_AmountToRefund2.default, { calculateAmountToRefund: this._calculateAmountToRefund }),
          React.createElement(_Item2.default, {
            isChecked: function isChecked(idx) {},
            isSelectedAll: function isSelectedAll(idx) {},
            isRefunded: function isRefunded(idx) {},
            canBeRefunded: function canBeRefunded(idx) {},
            canSelectAll: function canSelectAll() {
              return false;
            },
            onClickCheck: function onClickCheck(idx) {},
            onClickSelectAll: function onClickSelectAll(idx) {},
            onClickDeselectAll: function onClickDeselectAll(idx) {},
            onClickIncreaseQty: function onClickIncreaseQty(idx) {},
            onClickDecreaseQty: function onClickDecreaseQty(idx) {},
            onChangeInputAmountRefunded: function onChangeInputAmountRefunded(idx) {},
            refundItems: items,
            calculateItemPrice: this._calculateItemPrice,
            showCheckbox: false
          }),
          React.createElement(_Discount2.default, {
            paymentDiscounts: receiptInvoices.payment_discounts,
            calculateDiscount: this._calculateDiscount
          }),
          React.createElement(_RewardRedemption2.default, {
            redeemReward: this._getRewardName(),
            redeemAmount: receiptInvoices.total_redeem_amount
          }),
          React.createElement(_Gratuity2.default, {
            includeGratuityTax: receiptInvoices.include_gratuity_tax,
            paymentGratuities: receiptInvoices.payment_gratuities,
            calculateGratuity: this._calculateGratuity
          }),
          React.createElement(_Tax2.default, {
            includeGratuityTax: receiptInvoices.include_gratuity_tax,
            paymentTaxes: receiptInvoices.payment_taxes,
            calculateTax: this._calculateTax
          }),
          React.createElement(_RefundReason2.default, {
            className: 'refund-reason',
            labelReason: 'Reason for Cancelation',
            onChangeOtherReasonForRefund: this._onChangeOtherReasonForRefund,
            onChangeReasonForRefund: this._onChangeReasonForRefund
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-default', onClick: this._onHide },
              'Cancel'
            )
          ),
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary pull-right',
                disabled: !this._canCancelInvoice(),
                onClick: this._onClickIssueRefund
              },
              'Cancel Invoice'
            )
          )
        )
      );
    }
    /***************************************************************************
     * Calculation
     ***************************************************************************/

    /***************************************************************************
     * End Calculation
     ***************************************************************************/

  }]);
  return CancelInvoiceModal;
}(React.Component);

CancelInvoiceModal.propTypes = {};

function mapStateToProps(state) {
  return {
    data: {
      reports: {
        invoices: state.reports.invoices
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CancelInvoiceModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _invoices = __webpack_require__(170);

var actInvoices = _interopRequireWildcard(_invoices);

var _AmountToRefund = __webpack_require__(447);

var _AmountToRefund2 = _interopRequireDefault(_AmountToRefund);

var _RefundReason = __webpack_require__(448);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldCancelInvoiceModal = function (_React$Component) {
  (0, _inherits3.default)(OldCancelInvoiceModal, _React$Component);

  function OldCancelInvoiceModal(props) {
    (0, _classCallCheck3.default)(this, OldCancelInvoiceModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OldCancelInvoiceModal.__proto__ || (0, _getPrototypeOf2.default)(OldCancelInvoiceModal)).call(this, props));

    _this._calculateAmountToRefund = function () {
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      return receiptInvoices.total_collected;
    };

    _this._canIssueRefund = function () {
      // refund reason is not empty, and if refundReason is 'Other', customReason is not empty
      return _this.state.reason && (_this.state.reason !== 'Other' || _this.state.otherReason) && !_this.state.sending;
    };

    _this._onChangeReasonForRefund = function (value) {
      _this.setState({ reason: value });
    };

    _this._onChangeReasonOtherReason = function (value) {
      _this.setState({ otherReason: value });
    };

    _this._onSubmit = function () {
      _this.setState({ sending: true });
      var receiptInvoices = _this.props.data.reports.invoices.receiptInvoices;

      var data = {
        refund: {
          'amount': _this._calculateAmountToRefund(),
          'reason': _this.state.reason !== 'Other' ? _this.state.reason : _this.state.otherReason,
          'payment_id': receiptInvoices.id,
          'custom_reason': _this.state.otherReason
        }
      };
      _this.props.dispatch(actInvoices.issueOldRefundRequest(data));
    };

    _this._onHide = function () {
      _this.setState({ reason: null });
      _this.props.dispatch(actInvoices.hideOldCancelInvoiceModal());
    };

    _this.state = {
      reason: '',
      otherReason: '',
      sending: false
    };
    return _this;
  }

  (0, _createClass3.default)(OldCancelInvoiceModal, [{
    key: 'render',
    value: function render() {
      var openOldCancelInvoiceModal = this.props.data.reports.invoices.openOldCancelInvoiceModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: openOldCancelInvoiceModal, onHide: this._onHide, bsClass: 'old-cancel-invoice full-height-modal margin-top-modal modal' },
        React.createElement(_ModalHeader2.default, { title: 'Cancel Invoice' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(_AmountToRefund2.default, { calculateAmountToRefund: this._calculateAmountToRefund }),
          React.createElement(_RefundReason2.default, {
            labelReason: 'Reason for Cancelation',
            onChangeReasonForRefund: this._onChangeReasonForRefund,
            onChangeOtherReasonForRefund: this._onChangeReasonOtherReason })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { className: 'btn btn-default mr-10px pull-left', onClick: this._onHide, type: 'button' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right', type: 'submit', disabled: !this._canIssueRefund(), onClick: this._onSubmit },
            'Cancel Invoice'
          )
        )
      );
    }
  }]);
  return OldCancelInvoiceModal;
}(React.Component);

OldCancelInvoiceModal.propTypes = {};

function mapStateToProps(state) {
  return {
    data: {
      reports: {
        invoices: state.reports.invoices
      }
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(OldCancelInvoiceModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var actTransaction = _interopRequireWildcard(_transactions);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _formatter = __webpack_require__(11);

var _oldRefundTransactionModal = __webpack_require__(2011);

var _oldRefundTransactionModal2 = _interopRequireDefault(_oldRefundTransactionModal);

var _transactions2 = __webpack_require__(298);

var mpReportsTransactions = _interopRequireWildcard(_transactions2);

var _reduxForm = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldRefundTransactionModal = function (_React$Component) {
  (0, _inherits3.default)(OldRefundTransactionModal, _React$Component);

  function OldRefundTransactionModal(props) {
    (0, _classCallCheck3.default)(this, OldRefundTransactionModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OldRefundTransactionModal.__proto__ || (0, _getPrototypeOf2.default)(OldRefundTransactionModal)).call(this, props));

    _initialiseProps.call(_this);

    var transactionDetail = props.data.reports.transactions.transactionDetail;

    var amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund;

    _this.state = {
      amount: amountToRefund,
      reason: '',
      otherReason: ''
    };
    return _this;
  }

  (0, _createClass3.default)(OldRefundTransactionModal, [{
    key: 'render',
    value: function render() {
      var openOldRefundModal = this.props.data.reports.transactions.openOldRefundModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: openOldRefundModal, onHide: this._onHide, bsClass: 'full-height-modal margin-top-modal modal' },
        React.createElement(_ModalHeader2.default, { title: 'Issue Refund' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-12', style: { textAlign: 'center' } },
              (0, _formatter.rupiah)(this.state.amount),
              ' should be tendered in cash upon refund.'
            ),
            React.createElement(
              'div',
              { className: 'col-md-6' },
              React.createElement('input', { className: 'form-control ' + _oldRefundTransactionModal2.default['amount-reason'], onChange: this._onChangeAmount, value: this.state.amount })
            ),
            React.createElement(
              'div',
              { className: 'col-md-6' },
              React.createElement(
                'select',
                { className: 'form-control ' + _oldRefundTransactionModal2.default['select-reason'], onChange: this._onChangeReason, value: this.state.reason },
                React.createElement(
                  'option',
                  { value: '' },
                  '- Select Reason -'
                ),
                React.createElement(
                  'option',
                  { value: 'Returned Goods' },
                  'Returned Goods'
                ),
                React.createElement(
                  'option',
                  { value: 'Accidental Charge' },
                  'Accidental Charge'
                ),
                React.createElement(
                  'option',
                  { value: 'Cancelled Order' },
                  'Cancelled Order'
                ),
                React.createElement(
                  'option',
                  { value: 'Other' },
                  'Other'
                )
              )
            ),
            this.state.reason === 'Other' && React.createElement(
              'div',
              { className: 'col-md-12 ' + _oldRefundTransactionModal2.default['reason-field'] },
              React.createElement('input', { className: 'form-control ' + _oldRefundTransactionModal2.default['reason-for-refund'], placeholder: 'Reason for refund', onChange: this._onChangeOtherReason, value: this.state.otherReason })
            )
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { className: 'btn btn-default mr-10px pull-left', onClick: this._onHide, type: 'button' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right',
              disabled: !this._canIssueRefund(),
              type: 'button',
              onClick: this._onClickIssueRefund
            },
            'Issue Refund'
          )
        )
      );
    }
  }]);
  return OldRefundTransactionModal;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._onChangeAmount = function (e) {
    var transactionDetail = _this2.props.data.reports.transactions.transactionDetail;

    var amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund;
    if (!e.target.value) {
      _this2.setState({ amount: 0 });
    } else if (isNaN(e.target.value)) {
      return false;
    } else if (e.target.value < 0) {
      _this2.setState({ amount: 0 });
    } else if (e.target.value > amountToRefund) {
      _this2.setState({ amount: amountToRefund });
    } else {
      _this2.setState({ amount: parseInt(e.target.value) });
    }
  };

  this._onChangeReason = function (e) {
    _this2.setState({ reason: e.target.value });
  };

  this._onChangeOtherReason = function (e) {
    _this2.setState({ otherReason: e.target.value });
  };

  this._onClickIssueRefund = function () {
    var transactionDetail = _this2.props.data.reports.transactions.transactionDetail;
    var search = _this2.props.search;

    var maxAmountToRefund = transactionDetail.total_collected - transactionDetail.total_refund;
    var data = {
      refund: {
        'amount': _this2.state.amount,
        'reason': _this2.state.reason !== 'Other' ? _this2.state.reason : _this2.state.otherReason,
        'payment_id': transactionDetail.id,
        'custom_reason': _this2.state.otherReason
      }
    };
    mpReportsTransactions.reportsTransactionRefund({
      amount: _this2.state.amount,
      isFullRefund: _this2.state.amount === maxAmountToRefund,
      outletIds: search.outlet,
      startDate: search.date.startDate,
      endDate: search.date.endDate
    });
    _this2.props.dispatch(actTransaction.issueOldRefundRequest(data));
  };

  this._onHide = function () {
    var transactionDetail = _this2.props.data.reports.transactions.transactionDetail;

    var amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund;
    _this2.setState({ amount: amountToRefund, reason: '', otherReason: '' });
    _this2.props.dispatch(actTransaction.hideOldRefundModal());
  };

  this._canIssueRefund = function () {
    return _this2.state.reason && (_this2.state.reason !== 'Other' || _this2.state.otherReason);
  };
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(OldRefundTransactionModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _SetQuantityModal = __webpack_require__(2018);

var _SetQuantityModal2 = _interopRequireDefault(_SetQuantityModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetQuantityModal = function (_React$Component) {
  (0, _inherits3.default)(SetQuantityModal, _React$Component);

  function SetQuantityModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SetQuantityModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SetQuantityModal.__proto__ || (0, _getPrototypeOf2.default)(SetQuantityModal)).call.apply(_ref, [this].concat(args))), _this), _this._setZindex = function () {
      $('.modal-dialog-set-quantity').parent().css('z-index', '1057');
    }, _this._onHide = function () {
      $('.modal-backdrop.fade.in').css('z-index', '499');
      $('.modal-dialog-set-quantity').parent().css('z-index', '1057');
    }, _this._itemName = function () {
      var _this$props = _this.props,
          idx = _this$props.idx,
          refundItems = _this$props.refundItems;

      if (!idx && idx !== 0) {
        return false;
      } else {
        return refundItems[idx].itemName;
      }
    }, _this._onClickCancel = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.props.onCancel();
    }, _this._incrementQty = function (value) {
      var _this$props2 = _this.props,
          idx = _this$props2.idx,
          refundItems = _this$props2.refundItems,
          quantity = _this$props2.quantity,
          dispatch = _this$props2.dispatch;

      var refundItem = refundItems[idx];
      if (idx === undefined) {
        return false;
      } else if (quantity + value < 1) {
        return false;
      } else if (quantity + value > refundItem.maxQuantity) {
        return false;
      } else {
        dispatch((0, _reduxForm.change)('setQuantity', 'quantity', quantity + value));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SetQuantityModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open && nextProps.open !== this.props.open) {
        $('.modal-backdrop.in').css('z-index', '1056');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: this.props.open, onExit: this._onHide, onEnter: this._setZindex, dialogClassName: _SetQuantityModal2.default['modal-dialog-set-quantity'] + ' ' + _SetQuantityModal2.default.dialog + ' modal-dialog-set-quantity' },
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { bsClass: 'modal-body ' + _SetQuantityModal2.default['modal-body'] },
            React.createElement(
              'p',
              { className: _SetQuantityModal2.default.header },
              'Set Quantity'
            ),
            React.createElement(
              'p',
              null,
              this._itemName()
            ),
            React.createElement(
              'div',
              { className: 'input-group ' + _SetQuantityModal2.default['qty-field'] },
              React.createElement(
                'span',
                { className: 'input-group-addon ' + _SetQuantityModal2.default['btn-add'] + ' ' + _SetQuantityModal2.default['btn-inc'], onClick: function onClick() {
                    return _this2._incrementQty(-1);
                  } },
                React.createElement('i', { className: 'fa fa-minus' })
              ),
              React.createElement(_reduxForm.Field, {
                type: 'text',
                component: 'input',
                name: 'quantity',
                className: 'form-control ' + _SetQuantityModal2.default.quantity,
                disabled: true
              }),
              React.createElement(
                'span',
                { className: 'input-group-addon ' + _SetQuantityModal2.default['btn-add'] + ' ' + _SetQuantityModal2.default['btn-dec'], onClick: function onClick() {
                    return _this2._incrementQty(1);
                  } },
                React.createElement('i', { className: 'fa fa-plus' })
              ),
              React.createElement(_reduxForm.Field, {
                type: 'hidden',
                component: 'input',
                name: 'idx'
              })
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            { bsClass: _SetQuantityModal2.default.footer + ' modal-footer' },
            React.createElement(
              'button',
              { onClick: this._onClickCancel, className: 'btn btn-link ' + _SetQuantityModal2.default['btn-cancel'] },
              'Cancel'
            ),
            React.createElement(
              'button',
              { type: 'submit', className: 'btn btn-link ' + _SetQuantityModal2.default['btn-set'] },
              'Set'
            )
          )
        )
      );
    }
  }]);
  return SetQuantityModal;
}(React.Component);

SetQuantityModal.propTypes = {
  onCancel: React.PropTypes.func
};

var selector = (0, _reduxForm.formValueSelector)('setQuantity');

function mapStateToProps(state) {
  return {
    quantity: selector(state, 'quantity'),
    idx: selector(state, 'idx')
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'setQuantity'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SetQuantityModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var _reactBootstrap = __webpack_require__(10);

var _TransactionRefundModal = __webpack_require__(2019);

var _TransactionRefundModal2 = _interopRequireDefault(_TransactionRefundModal);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Gratuity = __webpack_require__(644);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _Tax = __webpack_require__(647);

var _Tax2 = _interopRequireDefault(_Tax);

var _Discount = __webpack_require__(643);

var _Discount2 = _interopRequireDefault(_Discount);

var _RewardRedemption = __webpack_require__(646);

var _RewardRedemption2 = _interopRequireDefault(_RewardRedemption);

var _AmountToRefund = __webpack_require__(447);

var _AmountToRefund2 = _interopRequireDefault(_AmountToRefund);

var _RefundReason = __webpack_require__(448);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

var _Item = __webpack_require__(645);

var _Item2 = _interopRequireDefault(_Item);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _transactions2 = __webpack_require__(298);

var mpReportsTransactions = _interopRequireWildcard(_transactions2);

var _reduxForm = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionRefundModal = function (_React$Component) {
  (0, _inherits3.default)(TransactionRefundModal, _React$Component);

  function TransactionRefundModal(props) {
    (0, _classCallCheck3.default)(this, TransactionRefundModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TransactionRefundModal.__proto__ || (0, _getPrototypeOf2.default)(TransactionRefundModal)).call(this, props));

    _this._getRewardName = function () {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      return transactionDetail.loyalty && transactionDetail.loyalty.type.toLowerCase() === 'redemption' ? transactionDetail.loyalty.redemption.reward : '';
    };

    _this._onHide = function () {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      _this.setState({ reasonForRefund: null });
      _this.props.dispatch((0, _transactions.cancelRefundBreakdown)(transactionDetail));
    };

    _this._onChangeReasonForRefund = function (value) {
      _this.setState({ reasonForRefund: value });
    };

    _this._onChangeOtherReasonForRefund = function (value) {
      _this.setState({ otherReasonForRefund: value });
    };

    _this._isIssueRefundButtonEnabled = function () {
      // if all items are refunded disable it
      var hasItemRefunded = false;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      refundItems.forEach(function (refundItem) {
        hasItemRefunded = hasItemRefunded || refundItem.isRefunded;
      });

      if (_this.state.reasonForRefund === 'Other') {
        //! ! --> boolean not empty
        return hasItemRefunded && !!_this.state.otherReasonForRefund;
      } else {
        //! ! --> boolean not empty
        return hasItemRefunded && !!_this.state.reasonForRefund;
      }
    };

    _this._onClickIssueRefund = function () {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;
      // construct items

      var itemCallbacks = [];

      refundItems.forEach(function (refundItem) {
        // items - discounts
        var itemDiscounts = refundItem.discounts.map(function (discount) {
          return {
            discount_id: discount.discount_id,
            discount_name: discount.discount_name,
            discount_type: discount.discount_type,
            discount_cash: discount.discount_cash,
            discount_percentage: discount.discount_percentage,
            discount_amount: -refundItem.refundAmount * discount.discount_per_item
          };
        });
        // items - modifiers
        var itemModifiers = refundItem.modifiers.map(function (modifier) {
          modifier.gross_sales = -refundItem.refundAmount * modifier.gross_per_item;
          modifier.net_sales = -refundItem.refundAmount * modifier.net_per_item;
          modifier.discount_amount = -refundItem.refundAmount * modifier.discount_per_item;
          modifier.redeem_amount = -refundItem.refundAmount * modifier.redeem_per_item;
          modifier.modifier_discounts = modifier.modifier_discounts.map(function (modifierDiscount) {
            modifierDiscount.discount_amount = -refundItem.refundAmount * modifierDiscount.discount_per_item;
            return modifierDiscount;
          });
          return modifier;
        });

        if (refundItem.isRefunded) {
          itemCallbacks.push({
            category_id: refundItem.categoryId,
            category_name: refundItem.categoryName,
            client_price: refundItem.pricePerItem,
            discount_amount: -refundItem.refundAmount * refundItem.discountPerItem,
            redeem_amount: -refundItem.refundAmount * refundItem.redemptionPerItem,
            discounts: itemDiscounts,
            gratuity: -refundItem.refundAmount * refundItem.gratuityPerItem,
            gross_sales: -refundItem.refundAmount * refundItem.grossPerItem,
            item_id: refundItem.itemId,
            item_image: refundItem.itemImage,
            item_name: refundItem.itemName,
            item_variant_id: refundItem.itemVariantId,
            item_variant_name: refundItem.itemVariantName,
            item_variant_sku: refundItem.itemVariantSku,
            modifiers: itemModifiers,
            net_sales: -refundItem.refundAmount * refundItem.netPerItem,
            parent_checkout_id: refundItem.parentCheckoutId,
            position: refundItem.position,
            quantity: -refundItem.refundAmount,
            tax: -refundItem.refundAmount * refundItem.taxPerItem,
            track_stock: refundItem.trackStock
          });
        }
      });
      // construct discounts
      var discounts = [];
      transactionDetail.payment_discounts.forEach(function (discount) {
        discounts.push({
          discount_amount: -_this._calculateDiscount(discount.discount_id),
          discount_cash: discount.discount_cash,
          discount_id: discount.discount_id,
          discount_name: discount.discount_name,
          discount_type: discount.discount_type
        });
      });

      // construct gratuities
      var gratuities = [];
      transactionDetail.payment_gratuities.forEach(function (gratuity) {
        gratuities.push({
          gratuity_amount: -_this._calculateGratuity(gratuity.id),
          gratuity_id: gratuity.gratuity_id,
          gratuity_name: gratuity.name,
          gratuity_percentage: gratuity.amount
        });
      });

      // construct taxes
      var taxes = [];
      transactionDetail.payment_taxes.forEach(function (tax) {
        taxes.push({
          tax_amount: -_this._calculateTax(tax.id),
          tax_id: tax.tax_id,
          tax_name: tax.name,
          tax_percentage: tax.amount,
          taxable_amount: -_this._calculateTaxable(tax.id)
        });
      });

      var totalDiscount = 0;
      var totalGratuity = 0;
      var totalGrossSales = 0;
      var totalNetSales = 0;
      var totalTax = 0;
      var totalRedeemAmount = 0;

      refundItems.forEach(function (refundItem) {
        if (refundItem.isRefunded) {
          totalDiscount += refundItem.refundAmount * refundItem.discountPerItem;
          totalGratuity += refundItem.refundAmount * refundItem.gratuityPerItem;
          totalGrossSales += refundItem.refundAmount * refundItem.grossPerItem;
          totalNetSales += refundItem.refundAmount * refundItem.netPerItem;
          totalTax += refundItem.refundAmount * refundItem.taxPerItem;
          totalRedeemAmount += refundItem.refundAmount * refundItem.redemptionPerItem;
        }
      });

      var totalCollected = totalNetSales + totalGratuity + totalTax;

      var loyalty = null;
      if (transactionDetail.loyalty) {
        loyalty = {
          new_earned_points: 0,
          program_id: transactionDetail.loyalty.program_id,
          member_since: transactionDetail.loyalty.member_since,
          earning_rule: transactionDetail.loyalty.earning_rule,
          member_id: transactionDetail.loyalty.member_id,
          member_uniq_id: transactionDetail.loyalty.member_uniq_id,
          member_guid: transactionDetail.loyalty.member_guid
        };

        if (transactionDetail.loyalty.type.toUpperCase() === 'REDEMPTION') {
          var redemption = transactionDetail.loyalty.redemption;

          loyalty.redemption = {
            'redeem_points': redemption.redeem_points,
            'redeem_amount': -totalRedeemAmount,
            'reward_type': redemption.reward_type,
            'reward_id': redemption.reward_id,
            'reward': redemption.reward,
            'discount': redemption.discount,
            'discount_type': redemption.discount_type
          };
        }

        if (transactionDetail.loyalty.type.toUpperCase() === 'EARNING') {
          var parentTotalCollected = transactionDetail.total_collected;
          var parentTotalRefund = transactionDetail.total_refund;
          var earningRule = transactionDetail.loyalty.earning_rule;
          var refundedPoint = transactionDetail.payment_refunds.map(function (e) {
            return e.loyalty ? e.loyalty.point_correction : 0;
          }).reduce(function (first, second) {
            return first + second;
          }, 0);

          var currentAvailablePoint = transactionDetail.loyalty.new_earned_points - refundedPoint;

          var finalCustomerSpendingAmount = parentTotalCollected - parentTotalRefund - totalCollected;
          loyalty.new_earned_points = parseInt(finalCustomerSpendingAmount / earningRule.amount) * earningRule.point - currentAvailablePoint;
        }
      }

      var data = {
        amount: Math.round(transactionDetail.total_collected - transactionDetail.total_refund),
        client_created_at: (0, _moment2.default)().format(),
        custom_reason: _this.state.reasonForRefund === 'Other' ? _this.state.otherReasonForRefund : '',
        discounts: discounts,
        gratuities: gratuities,
        is_refund_transaction: true,
        items: itemCallbacks,
        payment_id: transactionDetail.id,
        reason: _this.state.reasonForRefund !== 'Other' ? _this.state.reasonForRefund : _this.state.otherReasonForRefund,
        refund_amount: totalNetSales,
        taxes: taxes,
        loyalty: loyalty,
        total_collected: -totalCollected,
        total_discount: -totalDiscount,
        total_redeem_amount: -totalRedeemAmount,
        total_gratuity: -totalGratuity,
        total_gross_sales: -totalGrossSales,
        total_net_sales: -totalNetSales,
        total_tax: -totalTax
      };
      var maxAmountToRefund = Math.round(transactionDetail.total_collected - transactionDetail.total_refund);
      var amountToRefund = totalNetSales;
      var _this$props$search = _this.props.search,
          outlet = _this$props$search.outlet,
          _this$props$search$da = _this$props$search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpReportsTransactions.reportsTransactionRefund({
        amount: amountToRefund,
        isFullRefund: Math.abs(amountToRefund - maxAmountToRefund) < 0.0001,
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });

      _this.props.dispatch((0, _transactions.issueRefundRequest)({ refund: data }));
    };

    _this._isSelectedAll = function () {
      var isRefundedAll = true;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      refundItems.forEach(function (refundItem) {
        if (refundItem.maxQuantity > 0 && !refundItem.isRefunded) {
          isRefundedAll = false;
        }
      });
      return isRefundedAll;
    };

    _this._onClickSelectAll = function () {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      refundItems.forEach(function (refundItem) {
        if (refundItem.maxQuantity > 0) {
          // can be refunded if only max_qty > 0
          refundItem.isRefunded = true;
        }
      });
      _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
    };

    _this._onClickDeselectAll = function () {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      refundItems.forEach(function (refundItem) {
        refundItem.isRefunded = false;
      });
      _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
    };

    _this._onClickCheck = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      refundItems[idx].isRefunded = !refundItems[idx].isRefunded;
      _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
    };

    _this._onClickDecreaseQty = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      if (refundItems[idx].refundAmount > 1) {
        refundItems[idx].refundAmount -= 1;
        _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
      }
    };

    _this._onClickIncreaseQty = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      if (refundItems[idx].refundAmount < refundItems[idx].maxQuantity) {
        refundItems[idx].refundAmount += 1;
        _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
      }
    };

    _this._isChecked = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      return refundItems[idx].isRefunded;
    };

    _this._canBeRefunded = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      return (!refundItems[idx].refundAmount && _this._calculateItemPrice(idx) === 0 || _this._calculateItemPrice(idx) > 0 && refundItems[idx].refundAmount > 0) && refundItems[idx].maxQuantity > 0;
    };

    _this._isRefunded = function (idx) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      return refundItems[idx].isRefunded;
    };

    _this._onChangeInputAmountRefunded = function (idx, value) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var maxQuantity = refundItems[idx].maxQuantity;
      if (parseInt(value)) {
        if (value > maxQuantity) {
          refundItems[idx].refundAmount = parseInt(maxQuantity);
        } else {
          refundItems[idx].refundAmount = parseInt(value);
        }
      } else {
        refundItems[idx].refundAmount = refundItems[idx].maxQuantity;
      }
      _this.props.dispatch((0, _transactions.setRefundItems)(refundItems));
    };

    _this._onAskSetQtyModal = function (idx, refundAmount) {
      _this.props.dispatch((0, _transactions.askSetQuantity)(idx, refundAmount));
    };

    _this._onCancelSetQtyModal = function () {
      _this.props.dispatch((0, _transactions.cancelSetQuantity)());
    };

    _this._onConfirmSetQtyModal = function (idx, value) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var maxQuantity = refundItems[idx].maxQuantity;
      if (value) {
        if (value > maxQuantity) {
          refundItems[idx].refundAmount = maxQuantity;
        } else {
          refundItems[idx].refundAmount = value;
        }
      } else {
        refundItems[idx].refundAmount = 0;
      }
      _this.props.dispatch((0, _transactions.confirmSetQuantity)(refundItems));
    };

    _this._calculateAmountToRefund = function () {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      var totalGratuities = 0;
      var totalTaxes = 0;
      var totalDiscounts = 0;
      var totalItems = 0;
      var totalRedeemAmount = 0;

      refundItems.forEach(function (refundItem, idx) {
        if (refundItem.isRefunded) {
          totalItems += _this._calculateItemPrice(idx);
        }
      });

      transactionDetail.payment_gratuities.forEach(function (gratuity) {
        totalGratuities += _this._calculateGratuity(gratuity.id);
      });

      transactionDetail.payment_discounts.forEach(function (discount) {
        totalDiscounts += _this._calculateDiscount(discount.discount_id);
      });

      transactionDetail.payment_taxes.forEach(function (tax) {
        totalTaxes += _this._calculateTax(tax.id);
      });

      totalRedeemAmount = _this._calculateRedeemAmount();
      return totalItems - totalDiscounts - totalRedeemAmount + totalGratuities + totalTaxes;
    };

    _this._calculateItemPrice = function (itemId) {
      var totalDiscounts = 0;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var refundItem = refundItems[itemId];
      refundItem.discounts.forEach(function (discount) {
        if (discount.discount_type === 'percentage') {
          totalDiscounts += parseFloat(discount.discount_percentage);
        }
      });
      var itemPrice = void 0;
      // if all refunded
      if (!refundItem.maxQuantity) {
        itemPrice = (1 - totalDiscounts / 100.0) * refundItem.pricePerItem;
      } else {
        itemPrice = (1 - totalDiscounts / 100.0) * (refundItem.refundAmount * refundItem.pricePerItem);
      }
      if (itemPrice < 0) itemPrice = 0;
      return itemPrice;
    };

    _this._calculateDiscount = function (discountId) {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var total = 0;
      refundItems.forEach(function (refundItem) {
        if (refundItem.isRefunded) {
          refundItem.discounts.forEach(function (discount) {
            if (discount.discount_id === discountId) {
              total += refundItem.refundAmount * discount.discount_per_item;
            }
          });
        }
      });
      return total;
    };

    _this._calculateRedeemAmount = function () {
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var totalAmount = refundItems.filter(function (item) {
        return item.isRefunded;
      }).reduce(function (total, item) {
        return total + item.redemptionPerItem * item.refundAmount;
      }, 0);
      return totalAmount;
    };

    _this._calculateGratuity = function (gratuityId) {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var total = 0;
      transactionDetail.payment_gratuities.forEach(function (gratuity) {
        if (gratuity.id === gratuityId) {
          refundItems.forEach(function (refundItem) {
            if (refundItem.isRefunded) {
              total += gratuity.amount / 100 * refundItem.refundAmount * refundItem.netPerItem;
            }
          });
        }
      });
      return total;
    };

    _this._calculateTax = function (taxId) {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var total = 0;
      transactionDetail.payment_taxes.forEach(function (tax) {
        if (tax.id === taxId) {
          refundItems.forEach(function (refundItem) {
            if (refundItem.isRefunded) {
              total += tax.amount / 100.0 * refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem);
            }
          });
        }
      });
      return total;
    };

    _this._calculateTaxable = function (taxId) {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;
      var refundItems = _this.props.data.reports.transactions.refundBreakdown.refundItems;

      var total = 0;
      transactionDetail.payment_taxes.forEach(function (tax) {
        if (tax.id === taxId) {
          refundItems.forEach(function (refundItem) {
            if (refundItem.isRefunded) {
              total += refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem);
            }
          });
        }
      });
      return total;
    };

    _this.state = {
      reasonForRefund: '',
      otherReasonForRefund: ''
    };
    return _this;
  }

  (0, _createClass3.default)(TransactionRefundModal, [{
    key: 'render',


    /**********************************************************************
     * End of Calculation
     **********************************************************************/
    value: function render() {
      var _props$data$reports$t = this.props.data.reports.transactions,
          openRefundBreakdownModal = _props$data$reports$t.openRefundBreakdownModal,
          refundBreakdown = _props$data$reports$t.refundBreakdown,
          transactionDetail = _props$data$reports$t.transactionDetail,
          openSetQuantityModal = _props$data$reports$t.openSetQuantityModal;

      return transactionDetail !== null && React.createElement(
        _reactBootstrap.Modal,
        { onHide: this._onHide, show: openRefundBreakdownModal, bsClass: 'full-height-modal margin-top-modal modal' },
        React.createElement(_ModalHeader2.default, { title: 'Issue Refund' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: _TransactionRefundModal2.default['modal-body'] + ' modal-body' },
          React.createElement(_AmountToRefund2.default, { calculateAmountToRefund: this._calculateAmountToRefund }),
          React.createElement(_Item2.default, {
            isChecked: this._isChecked,
            isSelectedAll: this._isSelectedAll,
            isRefunded: this._isRefunded,
            canBeRefunded: this._canBeRefunded,
            canSelectAll: function canSelectAll() {
              return true;
            },
            onClickCheck: this._onClickCheck,
            onClickSelectAll: this._onClickSelectAll,
            onClickDeselectAll: this._onClickDeselectAll,
            onClickIncreaseQty: this._onClickIncreaseQty,
            onClickDecreaseQty: this._onClickDecreaseQty,
            onChangeInputAmountRefunded: this._onChangeInputAmountRefunded,
            refundItems: refundBreakdown.refundItems,
            calculateItemPrice: this._calculateItemPrice,
            onAskSetQtyModal: this._onAskSetQtyModal,
            onConfirmSetQtyModal: this._onConfirmSetQtyModal,
            onCancelSetQtyModal: this._onCancelSetQtyModal,
            openSetQtyModal: openSetQuantityModal,
            showCheckbox: true
          }),
          React.createElement(_Discount2.default, {
            paymentDiscounts: transactionDetail.payment_discounts,
            calculateDiscount: this._calculateDiscount
          }),
          React.createElement(_RewardRedemption2.default, {
            redeemReward: this._getRewardName(),
            redeemAmount: this._calculateRedeemAmount()
          }),
          React.createElement(_Gratuity2.default, {
            includeGratuityTax: transactionDetail.include_gratuity_tax,
            paymentGratuities: transactionDetail.payment_gratuities,
            calculateGratuity: this._calculateGratuity
          }),
          React.createElement(_Tax2.default, {
            includeGratuityTax: transactionDetail.include_gratuity_tax,
            paymentTaxes: transactionDetail.payment_taxes,
            calculateTax: this._calculateTax
          }),
          React.createElement(_RefundReason2.default, {
            labelReason: 'Reason for Refund',
            onChangeOtherReasonForRefund: this._onChangeOtherReasonForRefund,
            onChangeReasonForRefund: this._onChangeReasonForRefund
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-default', onClick: this._onHide },
              'Cancel'
            )
          ),
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary pull-right',
                onClick: this._onClickIssueRefund,
                disabled: !this._isIssueRefundButtonEnabled()
              },
              'Issue Refund'
            )
          )
        )
      );
    }

    /**
     * @param {int} idx index of refundItems in array of refundBreakdown
     * @private
     */


    /**
     * @param {int} idx index of refundItems in array of refundBreakdown
     * @private
     */


    /**
     *
     * @param idx
     * @private
     */


    /**********************************************************************
     * Calculation
     **********************************************************************/

  }]);
  return TransactionRefundModal;
}(React.Component);

TransactionRefundModal.propTypes = {};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TransactionRefundModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptTax = __webpack_require__(244);

var _ReceiptTax2 = _interopRequireDefault(_ReceiptTax);

var _Subtotal = __webpack_require__(294);

var _Subtotal2 = _interopRequireDefault(_Subtotal);

var _Gratuity = __webpack_require__(243);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _CountingBox = __webpack_require__(2020);

var _CountingBox2 = _interopRequireDefault(_CountingBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountingBox = function (_React$Component) {
  (0, _inherits3.default)(CountingBox, _React$Component);

  function CountingBox() {
    (0, _classCallCheck3.default)(this, CountingBox);
    return (0, _possibleConstructorReturn3.default)(this, (CountingBox.__proto__ || (0, _getPrototypeOf2.default)(CountingBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(CountingBox, [{
    key: 'render',
    value: function render() {
      var paymentDetail = this.props.paymentDetail;
      // noinspection JSUnresolvedVariable

      return React.createElement(
        'div',
        { className: _CountingBox2.default['counting-box'] },
        React.createElement(_Subtotal2.default, { subtotal: paymentDetail.subtotal }),
        paymentDetail.enable_gratuity && React.createElement(_Gratuity2.default, { gratuities: paymentDetail.payment_gratuities,
          includeGratuityTax: paymentDetail.include_gratuity_tax }),
        paymentDetail.enable_tax && React.createElement(_ReceiptTax2.default, { taxes: paymentDetail.payment_taxes,
          includeGratuityTax: paymentDetail.include_gratuity_tax })
      );
    }
  }]);
  return CountingBox;
}(React.Component);

CountingBox.propTypes = {
  paymentDetail: React.PropTypes.object
};

exports.default = CountingBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptTax = __webpack_require__(244);

var _ReceiptTax2 = _interopRequireDefault(_ReceiptTax);

var _Subtotal = __webpack_require__(294);

var _Subtotal2 = _interopRequireDefault(_Subtotal);

var _Gratuity = __webpack_require__(243);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _RefundCountingBox = __webpack_require__(2021);

var _RefundCountingBox2 = _interopRequireDefault(_RefundCountingBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundCountingBox = function (_React$Component) {
  (0, _inherits3.default)(RefundCountingBox, _React$Component);

  function RefundCountingBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RefundCountingBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RefundCountingBox.__proto__ || (0, _getPrototypeOf2.default)(RefundCountingBox)).call.apply(_ref, [this].concat(args))), _this), _this.calculateSubTotal = function (paymentDetail) {
      var subtotal = 0;
      var checkouts = paymentDetail.checkouts;

      for (var x = 0; x < checkouts.length; x++) {
        var checkoutDiscounts = checkouts[x].discounts;
        var totalDiscounts = 0;

        for (var y = 0; y < checkoutDiscounts.length; y++) {
          totalDiscounts += parseFloat(checkoutDiscounts[y].discount_amount);
        }

        subtotal += checkouts[x].price - totalDiscounts;
      }

      var paymentDiscounts = paymentDetail.payment_discounts;

      for (var _x = 0; _x < paymentDiscounts.length; _x++) {
        subtotal -= paymentDiscounts[_x].discount_amount;
      }

      subtotal -= paymentDetail.total_redeem_amount;
      return subtotal;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RefundCountingBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          paymentDetail = _props.paymentDetail,
          paymentRefund = _props.paymentRefund;
      // noinspection JSUnresolvedVariable

      return paymentRefund.is_refund_breakdown && React.createElement(
        'div',
        { className: _RefundCountingBox2.default['refund-counting-box'] },
        React.createElement(_Subtotal2.default, { subtotal: this.calculateSubTotal(paymentRefund) }),
        paymentDetail.enable_gratuity && React.createElement(_Gratuity2.default, { gratuities: paymentRefund.payment_gratuities,
          includeGratuityTax: paymentDetail.include_gratuity_tax }),
        paymentDetail.enable_tax && React.createElement(_ReceiptTax2.default, { taxes: paymentRefund.payment_taxes,
          includeGratuityTax: paymentDetail.include_gratuity_tax })
      );
    }
  }]);
  return RefundCountingBox;
}(React.Component);

RefundCountingBox.propTypes = {
  paymentDetail: React.PropTypes.object,
  paymentRefund: React.PropTypes.object
};

exports.default = RefundCountingBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _InfoBox = __webpack_require__(754);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionDetailReceiptInfoBox = function (_React$Component) {
  (0, _inherits3.default)(TransactionDetailReceiptInfoBox, _React$Component);

  function TransactionDetailReceiptInfoBox() {
    (0, _classCallCheck3.default)(this, TransactionDetailReceiptInfoBox);
    return (0, _possibleConstructorReturn3.default)(this, (TransactionDetailReceiptInfoBox.__proto__ || (0, _getPrototypeOf2.default)(TransactionDetailReceiptInfoBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransactionDetailReceiptInfoBox, [{
    key: 'render',
    value: function render() {
      var paymentDetail = this.props.paymentDetail;

      return React.createElement(
        'div',
        { className: _InfoBox2.default['receipt-info-box'] },
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-date'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            (0, _formatter.invoiceReceiptDateTime)(paymentDetail.parent_payment_created_at, 'date')
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(paymentDetail.parent_payment_created_at, 'time')
          )
        ),
        paymentDetail.payment_no && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Receipt Number'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.payment_no
          )
        ),
        paymentDetail.table_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Table Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.table_name
          )
        ),
        paymentDetail.served_by && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-served'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Served By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.served_by
          )
        ),
        paymentDetail.collected_by && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Collected By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.collected_by
          )
        )
      );
    }
  }]);
  return TransactionDetailReceiptInfoBox;
}(React.Component);

TransactionDetailReceiptInfoBox.propTypes = {
  paymentDetail: React.PropTypes.object
};

exports.default = TransactionDetailReceiptInfoBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _InfoBox = __webpack_require__(754);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionDetailReceiptInfoBox = function (_React$Component) {
  (0, _inherits3.default)(TransactionDetailReceiptInfoBox, _React$Component);

  function TransactionDetailReceiptInfoBox() {
    (0, _classCallCheck3.default)(this, TransactionDetailReceiptInfoBox);
    return (0, _possibleConstructorReturn3.default)(this, (TransactionDetailReceiptInfoBox.__proto__ || (0, _getPrototypeOf2.default)(TransactionDetailReceiptInfoBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransactionDetailReceiptInfoBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          paymentDetail = _props.paymentDetail,
          paymentRefund = _props.paymentRefund;

      return React.createElement(
        'div',
        { className: _InfoBox2.default['receipt-info-box'] },
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-date'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            (0, _formatter.invoiceReceiptDateTime)(paymentRefund.refunded_at, 'date')
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            (0, _formatter.invoiceReceiptDateTime)(paymentRefund.refunded_at, 'time')
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Receipt Number'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.payment_no
          )
        ),
        paymentDetail.table_name && React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-number'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Table Name'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentDetail.table_name
          )
        ),
        React.createElement(
          'div',
          { className: _InfoBox2.default['receipt-collected'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Refunded By'
          ),
          React.createElement(
            'div',
            { className: 'pull-right' },
            paymentRefund.refunded_by
          )
        )
      );
    }
  }]);
  return TransactionDetailReceiptInfoBox;
}(React.Component);

TransactionDetailReceiptInfoBox.propTypes = {
  paymentDetail: React.PropTypes.object,
  paymentRefund: React.PropTypes.object
};

exports.default = TransactionDetailReceiptInfoBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DiscountTable = __webpack_require__(245);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

var _ItemTable = __webpack_require__(446);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

var _RewardRedemptionInfo = __webpack_require__(295);

var _RewardRedemptionInfo2 = _interopRequireDefault(_RewardRedemptionInfo);

var _formatter = __webpack_require__(11);

var _ListItemBox = __webpack_require__(2022);

var _ListItemBox2 = _interopRequireDefault(_ListItemBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemBox = function (_React$Component) {
  (0, _inherits3.default)(ListItemBox, _React$Component);

  function ListItemBox() {
    (0, _classCallCheck3.default)(this, ListItemBox);
    return (0, _possibleConstructorReturn3.default)(this, (ListItemBox.__proto__ || (0, _getPrototypeOf2.default)(ListItemBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItemBox, [{
    key: 'render',
    value: function render() {
      var paymentDetail = this.props.paymentDetail;
      var loyalty = paymentDetail.loyalty;
      // noinspection JSUnresolvedVariable

      return paymentDetail.checkouts.length > 0 && React.createElement(
        'div',
        { className: _ListItemBox2.default['list-item-box'] },
        React.createElement(_ItemTable2.default, { checkouts: paymentDetail.checkouts, checkoutPriceFormatter: _formatter.rupiah }),
        React.createElement(_DiscountTable2.default, { discounts: paymentDetail.payment_discounts }),
        loyalty && loyalty.redemption && loyalty.redemption.reward && React.createElement(_RewardRedemptionInfo2.default, { redeemReward: loyalty.redemption.reward, totalRedeemAmount: paymentDetail.total_redeem_amount })
      );
    }
  }]);
  return ListItemBox;
}(React.Component);

ListItemBox.propTypes = {
  paymentDetail: React.PropTypes.object
};

exports.default = ListItemBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DiscountTable = __webpack_require__(245);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

var _ItemTable = __webpack_require__(446);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

var _RewardRedemptionInfo = __webpack_require__(295);

var _RewardRedemptionInfo2 = _interopRequireDefault(_RewardRedemptionInfo);

var _formatter = __webpack_require__(11);

var _RefundListItemBox = __webpack_require__(2023);

var _RefundListItemBox2 = _interopRequireDefault(_RefundListItemBox);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundListItemBox = function (_React$Component) {
  (0, _inherits3.default)(RefundListItemBox, _React$Component);

  function RefundListItemBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RefundListItemBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RefundListItemBox.__proto__ || (0, _getPrototypeOf2.default)(RefundListItemBox)).call.apply(_ref, [this].concat(args))), _this), _this._checkoutPriceFormatter = function (price) {
      if (price >= 0) {
        return (0, _formatter.negativeCurrencyFormatter)(price);
      } else {
        return '(' + (0, _formatter.negativeCurrencyFormatter)(price) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RefundListItemBox, [{
    key: 'render',
    value: function render() {
      var paymentRefund = this.props.paymentRefund;
      var loyalty = paymentRefund.loyalty;

      var discounts = _lodash2.default.cloneDeep(paymentRefund.payment_discounts);
      if (discounts) {
        discounts.forEach(function (d) {
          d.discount_amount *= -1;
        });
      }
      // noinspection JSUnresolvedVariable
      return paymentRefund.checkouts.length > 0 && React.createElement(
        'div',
        { className: _RefundListItemBox2.default['list-item-box'] },
        React.createElement(_ItemTable2.default, { checkouts: paymentRefund.checkouts, checkoutPriceFormatter: this._checkoutPriceFormatter }),
        React.createElement(_DiscountTable2.default, { discounts: discounts, isRefunded: true }),
        loyalty && loyalty.redemption && loyalty.redemption.reward && React.createElement(_RewardRedemptionInfo2.default, { redeemReward: loyalty.redemption.reward, totalRedeemAmount: paymentRefund.total_redeem_amount, isRefunded: true })
      );
    }
  }]);
  return RefundListItemBox;
}(React.Component);

RefundListItemBox.propTypes = {
  paymentRefund: React.PropTypes.object
};

exports.default = RefundListItemBox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RefundReason = __webpack_require__(2024);

var _RefundReason2 = _interopRequireDefault(_RefundReason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundReason = function (_React$Component) {
  (0, _inherits3.default)(RefundReason, _React$Component);

  function RefundReason() {
    (0, _classCallCheck3.default)(this, RefundReason);
    return (0, _possibleConstructorReturn3.default)(this, (RefundReason.__proto__ || (0, _getPrototypeOf2.default)(RefundReason)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefundReason, [{
    key: 'render',
    value: function render() {
      var paymentRefund = this.props.paymentRefund;

      // noinspection JSUnresolvedVariable

      return React.createElement(
        'div',
        { className: _RefundReason2.default['receipt-refund-reason'] },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-6 col-xs-8', style: { 'textAlign': 'left' } },
            'Reason for Refund'
          ),
          React.createElement(
            'div',
            { className: 'col-md-6 col-xs-4' },
            React.createElement(
              'div',
              { className: _RefundReason2.default['truncate-refund-reason'] + ' pull-right' },
              paymentRefund.refunded_reason
            )
          )
        )
      );
    }
  }]);
  return RefundReason;
}(React.Component);

RefundReason.propTypes = {
  paymentRefund: React.PropTypes.object
};

exports.default = RefundReason;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailField = function (_React$Component) {
  (0, _inherits3.default)(EmailField, _React$Component);

  function EmailField() {
    (0, _classCallCheck3.default)(this, EmailField);
    return (0, _possibleConstructorReturn3.default)(this, (EmailField.__proto__ || (0, _getPrototypeOf2.default)(EmailField)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmailField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          placeholder = _props.placeholder,
          maxLength = _props.maxLength;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        { className: 'form-group' },
        React.createElement('input', (0, _extends3.default)({}, input, { type: type, maxLength: maxLength, placeholder: placeholder, className: 'form-control' })),
        React.createElement(
          'small',
          { className: 'error' },
          touched ? error : ''
        )
      );
    }
  }]);
  return EmailField;
}(React.Component);

EmailField.propTypes = {};

exports.default = EmailField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var _reduxForm = __webpack_require__(7);

var _EmailField = __webpack_require__(1191);

var _EmailField2 = _interopRequireDefault(_EmailField);

var _Modal = __webpack_require__(505);

var _Modal2 = _interopRequireDefault(_Modal);

var _resendEmailModal = __webpack_require__(2025);

var _resendEmailModal2 = _interopRequireDefault(_resendEmailModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'The value is not a valid email address';
  }
  return errors;
};

var ResendEmailModal = function (_React$Component) {
  (0, _inherits3.default)(ResendEmailModal, _React$Component);

  function ResendEmailModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResendEmailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResendEmailModal.__proto__ || (0, _getPrototypeOf2.default)(ResendEmailModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      $('.modal-backdrop').css('z-index', '499');
      $('.modal-dialog-resend-receipt').parent().css('z-index', '1057');
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      _this.props.dispatch((0, _transactions.cancelResendEmail)(transactionDetail));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResendEmailModal, [{
    key: 'render',
    value: function render() {
      var openResendEmailModal = this.props.data.reports.transactions.openResendEmailModal;
      var invalid = this.props.invalid;


      if (openResendEmailModal) {
        $('.modal-backdrop.fade').css('z-index', '1056');
        $('.modal-dialog-resend-receipt').parent().css('z-index', '1057');
      }

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: openResendEmailModal, onHide: this._onHide, bsClass: 'modal', dialogClassName: 'modal-dialog-resend-receipt modal-dialog ' + _resendEmailModal2.default.dialog },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              { bsClass: 'modal-title ' + _Modal2.default['modal-title'] },
              'Resend Email'
            )
          ),
          React.createElement(
            'form',
            { onSubmit: this.props.handleSubmit },
            React.createElement(
              _reactBootstrap.Modal.Body,
              null,
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-md-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: _EmailField2.default,
                      name: 'email',
                      type: 'text',
                      placeholder: 'Email',
                      autoCorrect: 'off',
                      maxLength: '40',
                      autoCapitalize: 'off',
                      spellCheck: 'false',
                      className: 'form-control'
                    })
                  )
                )
              )
            ),
            React.createElement(
              _reactBootstrap.Modal.Footer,
              { className: _resendEmailModal2.default.footer },
              React.createElement(
                'span',
                { className: 'pull-right' },
                React.createElement(
                  'button',
                  { className: 'btn btn-default mr-10px', onClick: this._onHide, type: 'button' },
                  'Cancel'
                ),
                React.createElement(
                  'button',
                  { className: 'btn btn-primary', type: 'submit', disabled: invalid },
                  'Send'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ResendEmailModal;
}(React.Component);

function mapStateToProps(state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
}

ResendEmailModal.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func
};

var mapFormValidation = {
  form: 'resendEmailForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)((0, _reactRedux.connect)(mapStateToProps)(ResendEmailModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _Summary = __webpack_require__(2026);

var _Summary2 = _interopRequireDefault(_Summary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Summary = function (_React$Component) {
  (0, _inherits3.default)(Summary, _React$Component);

  function Summary() {
    (0, _classCallCheck3.default)(this, Summary);
    return (0, _possibleConstructorReturn3.default)(this, (Summary.__proto__ || (0, _getPrototypeOf2.default)(Summary)).apply(this, arguments));
  }

  (0, _createClass3.default)(Summary, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          totalTransactions = _props.totalTransactions,
          totalCollected = _props.totalCollected,
          netSales = _props.netSales;

      return React.createElement(
        'div',
        { className: _Summary2.default['summary-data-box'] + ' visible-md visible-lg' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _Summary2.default['amount'] },
              totalTransactions
            ),
            React.createElement(
              'div',
              { className: _Summary2.default['title-center'] },
              'Transactions'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _Summary2.default['amount'] },
              (0, _formatter.currencyFormatter)(totalCollected)
            ),
            React.createElement(
              'div',
              { className: _Summary2.default['title-center'] },
              'Total Collected'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _Summary2.default['amount'] },
              (0, _formatter.currencyFormatter)(netSales)
            ),
            React.createElement(
              'div',
              { className: _Summary2.default['title-center'] },
              'NET SALES'
            )
          )
        )
      );
    }
  }]);
  return Summary;
}(React.Component);

Summary.propTypes = {
  totalTransactions: React.PropTypes.number,
  totalCollected: React.PropTypes.number,
  netSales: React.PropTypes.number
};

exports.default = Summary;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(755);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundTotal = function (_React$Component) {
  (0, _inherits3.default)(RefundTotal, _React$Component);

  function RefundTotal() {
    (0, _classCallCheck3.default)(this, RefundTotal);
    return (0, _possibleConstructorReturn3.default)(this, (RefundTotal.__proto__ || (0, _getPrototypeOf2.default)(RefundTotal)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefundTotal, [{
    key: 'render',
    value: function render() {
      var amount = this.props.amount;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _style2.default['receipt-total-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Total'
          ),
          React.createElement(
            'div',
            { className: 'pull-right text-pre-wrap' },
            '(',
            (0, _formatter.rupiah)(amount),
            ')'
          )
        )
      );
    }
  }]);
  return RefundTotal;
}(React.Component);

RefundTotal.propTypes = {
  amount: React.PropTypes.number
};

exports.default = RefundTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _style = __webpack_require__(755);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Total = function (_React$Component) {
  (0, _inherits3.default)(Total, _React$Component);

  function Total() {
    (0, _classCallCheck3.default)(this, Total);
    return (0, _possibleConstructorReturn3.default)(this, (Total.__proto__ || (0, _getPrototypeOf2.default)(Total)).apply(this, arguments));
  }

  (0, _createClass3.default)(Total, [{
    key: 'render',
    value: function render() {
      var paymentDetail = this.props.paymentDetail;

      return React.createElement(
        'div',
        { className: _style2.default['receipt-total'] },
        React.createElement(
          'div',
          { className: _style2.default['receipt-total-box'] },
          React.createElement(
            'div',
            { className: 'pull-left' },
            'Total'
          ),
          React.createElement(
            'div',
            { className: 'pull-right text-pre-wrap' },
            (0, _formatter.rupiah)(paymentDetail.total_collected)
          )
        ),
        React.createElement(
          'div',
          { className: 'receipt-payment-box' },
          React.createElement(
            'div',
            { className: 'payment-method', style: { 'height': '30px' } },
            paymentDetail.payment_type !== 'card' && React.createElement(
              'div',
              { className: 'pull-left' },
              paymentDetail.payment_type_label
            ),
            paymentDetail.payment_type === 'card' && React.createElement(
              'div',
              { className: 'pull-left' },
              'Card'
            ),
            React.createElement(
              'div',
              { className: 'pull-right' },
              (0, _formatter.rupiah)(paymentDetail.tendered)
            )
          ),
          React.createElement(
            'div',
            { className: 'payment-method', style: { 'textAlign': 'left' } },
            React.createElement(
              'div',
              { className: 'payment-note' },
              paymentDetail.payment_note && paymentDetail.payment_type !== 'cash' && paymentDetail.payment_type !== 'card' && React.createElement(
                'div',
                { className: _style2.default['overflow-word'] },
                paymentDetail.payment_note
              ),
              paymentDetail.payment_type === 'card' && paymentDetail.card_type && React.createElement(
                'div',
                { className: 'pull-left' },
                paymentDetail.card_type,
                ' - ',
                paymentDetail.card_no
              ),
              paymentDetail.payment_type === 'card' && !paymentDetail.card_type && React.createElement(
                'div',
                { className: 'pull-left' },
                'Debit/Credit - ',
                paymentDetail
              )
            )
          ),
          paymentDetail.payment_type === 'cash' && React.createElement(
            'div',
            { className: 'payment-change' },
            React.createElement(
              'div',
              { className: 'pull-left' },
              'Change'
            ),
            React.createElement(
              'div',
              { className: 'pull-right' },
              (0, _formatter.rupiah)(paymentDetail.change)
            )
          )
        )
      );
    }
  }]);
  return Total;
}(React.Component);

Total.propTypes = {
  paymentDetail: React.PropTypes.object
};

exports.default = Total;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactBootstrap = __webpack_require__(10);

var _transactions = __webpack_require__(128);

var _TransactionDetail = __webpack_require__(648);

var _TransactionDetail2 = _interopRequireDefault(_TransactionDetail);

var _TransactionDetailModal = __webpack_require__(2028);

var _TransactionDetailModal2 = _interopRequireDefault(_TransactionDetailModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionDetailModal = function (_React$Component) {
  (0, _inherits3.default)(TransactionDetailModal, _React$Component);

  function TransactionDetailModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransactionDetailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransactionDetailModal.__proto__ || (0, _getPrototypeOf2.default)(TransactionDetailModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _transactions.hideTransactionDetailModal)());
    }, _this._onClickDoneButton = function () {
      _this.props.dispatch((0, _transactions.hideTransactionDetailModal)());
      _this.props.dispatch((0, _transactions.setTransactionDetail)(null));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransactionDetailModal, [{
    key: 'render',
    value: function render() {
      var openTransactionDetailModal = this.props.data.reports.transactions.openTransactionDetailModal;

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: openTransactionDetailModal, onHide: this._onHide, bsClass: 'show-navbar box-detail-modal modal', backdrop: false },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { bsClass: _TransactionDetailModal2.default['modal-body'] },
            React.createElement(_TransactionDetail2.default, {
              dispatch: this.props.dispatch,
              onClickDoneButton: this._onClickDoneButton })
          )
        )
      );
    }
  }]);
  return TransactionDetailModal;
}(React.Component);

function mapStateToProps(state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TransactionDetailModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBarWrapper = __webpack_require__(2032);

var _ActionBarWrapper2 = _interopRequireDefault(_ActionBarWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBarWrapper = function (_React$Component) {
  (0, _inherits3.default)(ActionBarWrapper, _React$Component);

  function ActionBarWrapper() {
    (0, _classCallCheck3.default)(this, ActionBarWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ActionBarWrapper.__proto__ || (0, _getPrototypeOf2.default)(ActionBarWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActionBarWrapper, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _ActionBarWrapper2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row ' + _ActionBarWrapper2.default['row-wrapper'] },
          this.props.children
        )
      );
    }
  }]);
  return ActionBarWrapper;
}(React.Component);

exports.default = ActionBarWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ContentWrapper = __webpack_require__(2033);

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = function (_React$Component) {
  (0, _inherits3.default)(ContentWrapper, _React$Component);

  function ContentWrapper() {
    (0, _classCallCheck3.default)(this, ContentWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ContentWrapper.__proto__ || (0, _getPrototypeOf2.default)(ContentWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContentWrapper, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row ' + _ContentWrapper2.default.wrapper },
        this.props.children
      );
    }
  }]);
  return ContentWrapper;
}(React.Component);

exports.default = ContentWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LeftColumnWrapper = __webpack_require__(2034);

var _LeftColumnWrapper2 = _interopRequireDefault(_LeftColumnWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftColumnWrapper = function (_React$Component) {
  (0, _inherits3.default)(LeftColumnWrapper, _React$Component);

  function LeftColumnWrapper() {
    (0, _classCallCheck3.default)(this, LeftColumnWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (LeftColumnWrapper.__proto__ || (0, _getPrototypeOf2.default)(LeftColumnWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftColumnWrapper, [{
    key: 'render',
    value: function render() {
      var openRightColumn = this.props.openRightColumn;

      var classSlider = openRightColumn ? 'col-md-6 col-lg-6 visible-md visible-lg visible-sm' : 'col-md-12 col-lg-12';

      return React.createElement(
        'div',
        { id: 'mk-col-left', className: _LeftColumnWrapper2.default.wrapper + ' ' + classSlider },
        this.props.children
      );
    }
  }]);
  return LeftColumnWrapper;
}(React.Component);

exports.default = LeftColumnWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RightColumnWrapper = __webpack_require__(2036);

var _RightColumnWrapper2 = _interopRequireDefault(_RightColumnWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RightColumnWrapper = function (_React$Component) {
  (0, _inherits3.default)(RightColumnWrapper, _React$Component);

  function RightColumnWrapper(props) {
    (0, _classCallCheck3.default)(this, RightColumnWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RightColumnWrapper.__proto__ || (0, _getPrototypeOf2.default)(RightColumnWrapper)).call(this, props));

    _this.state = {
      openRightColumn: props.openRightColumn
    };
    return _this;
  }

  (0, _createClass3.default)(RightColumnWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.openRightColumn !== nextProps.openRightColumn) {
        // delay tampilan supaya gak scroll ke bawah sampai animasi geser kiri selesai
        if (nextProps.openRightColumn) {
          setTimeout(function () {
            _this2.setState({ openRightColumn: nextProps.openRightColumn });
          }, 600);
        } else {
          this.setState({ openRightColumn: nextProps.openRightColumn });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var openRightColumn = this.state.openRightColumn;

      var classSlider = openRightColumn ? 'col-md-6 col-lg-6 visible-md visible-lg visible-sm' : 'col-md-12 col-lg-12';

      // ini buat mengatasi issue redux-form
      // https://github.com/erikras/redux-form/issues/2971
      // dimana kalo redux form component di reset dia gak bakal ngerun validasi
      // karena bugnya divalidasi library redux form
      // jadi kita destroy component ketika bagian ini ke-hide
      // dan kita mount ulang component ketika show
      return React.createElement(
        'div',
        { id: 'mk-col-right', className: _RightColumnWrapper2.default.wrapper + ' ' + classSlider },
        openRightColumn && this.props.children
      );
    }
  }]);
  return RightColumnWrapper;
}(React.Component);

exports.default = RightColumnWrapper;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NODE_ENV = exports.NODE_ENV = "development" || '';

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ReactDOM, React) {

__webpack_require__(378);

var _redux = __webpack_require__(167);

var _developmentOnly = __webpack_require__(1041);

var _reactRouterRedux = __webpack_require__(49);

var _reactRouter = __webpack_require__(15);

var _reduxSaga = __webpack_require__(68);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reduxLogger = __webpack_require__(379);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reducers = __webpack_require__(976);

var _reducers2 = _interopRequireDefault(_reducers);

var _sagas = __webpack_require__(1013);

var _sagas2 = _interopRequireDefault(_sagas);

var _auth = __webpack_require__(999);

var _auth2 = _interopRequireDefault(_auth);

var _outlet = __webpack_require__(1018);

var _outlet2 = _interopRequireDefault(_outlet);

var _sales = __webpack_require__(1021);

var _sales2 = _interopRequireDefault(_sales);

var _shifts = __webpack_require__(1022);

var _shifts2 = _interopRequireDefault(_shifts);

var _invoices = __webpack_require__(1020);

var _invoices2 = _interopRequireDefault(_invoices);

var _calendar = __webpack_require__(1002);

var _calendar2 = _interopRequireDefault(_calendar);

var _index = __webpack_require__(1006);

var _index2 = _interopRequireDefault(_index);

var _transactions = __webpack_require__(1023);

var _transactions2 = _interopRequireDefault(_transactions);

var _getExportedFile = __webpack_require__(1012);

var _getExportedFile2 = _interopRequireDefault(_getExportedFile);

var _account = __webpack_require__(1024);

var _account2 = _interopRequireDefault(_account);

var _publicProfile = __webpack_require__(1028);

var _publicProfile2 = _interopRequireDefault(_publicProfile);

var _index3 = __webpack_require__(1031);

var _index4 = _interopRequireDefault(_index3);

var _importCustomer = __webpack_require__(1032);

var _importCustomer2 = _interopRequireDefault(_importCustomer);

var _checkout = __webpack_require__(1026);

var _checkout2 = _interopRequireDefault(_checkout);

var _receipt = __webpack_require__(1029);

var _receipt2 = _interopRequireDefault(_receipt);

var _billing = __webpack_require__(1025);

var _billing2 = _interopRequireDefault(_billing);

var _confirmAction = __webpack_require__(1003);

var _confirmAction2 = _interopRequireDefault(_confirmAction);

var _notifications = __webpack_require__(1017);

var _notifications2 = _interopRequireDefault(_notifications);

var _feedbackReplyForm = __webpack_require__(1010);

var _feedbackReplyForm2 = _interopRequireDefault(_feedbackReplyForm);

var _verifyEmail = __webpack_require__(1033);

var _verifyEmail2 = _interopRequireDefault(_verifyEmail);

var _billingRedirect = __webpack_require__(1001);

var _billingRedirect2 = _interopRequireDefault(_billingRedirect);

var _billingNotification = __webpack_require__(1000);

var _billingNotification2 = _interopRequireDefault(_billingNotification);

var _customers = __webpack_require__(1005);

var customerSagas = _interopRequireWildcard(_customers);

var _setting = __webpack_require__(1027);

var settingSagas = _interopRequireWildcard(_setting);

var _employees = __webpack_require__(1007);

var employeeSagas = _interopRequireWildcard(_employees);

var _outletPages = __webpack_require__(1019);

var outletPageSagas = _interopRequireWildcard(_outletPages);

var _library = __webpack_require__(1016);

var librarySagas = _interopRequireWildcard(_library);

var _form = __webpack_require__(1008);

var exampleFormSagas = _interopRequireWildcard(_form);

var _inventory = __webpack_require__(1015);

var inventorySagas = _interopRequireWildcard(_inventory);

var _ingredients = __webpack_require__(1014);

var ingredientSagas = _interopRequireWildcard(_ingredients);

var _forgotPassword = __webpack_require__(1011);

var forgotPasswordSagas = _interopRequireWildcard(_forgotPassword);

var _confirmEmployee = __webpack_require__(1004);

var _confirmEmployee2 = _interopRequireDefault(_confirmEmployee);

var _feedbackForm = __webpack_require__(1009);

var _feedbackForm2 = _interopRequireDefault(_feedbackForm);

var _subscriptionExpired = __webpack_require__(1030);

var _subscriptionExpired2 = _interopRequireDefault(_subscriptionExpired);

var _verifyEmailAlertRecipient = __webpack_require__(1034);

var _verifyEmailAlertRecipient2 = _interopRequireDefault(_verifyEmailAlertRecipient);

var _index5 = __webpack_require__(972);

var _reduxForm = __webpack_require__(7);

var _notifications3 = __webpack_require__(981);

var _auth3 = __webpack_require__(965);

var _outlet3 = __webpack_require__(982);

var _transactions3 = __webpack_require__(987);

var _receipt3 = __webpack_require__(992);

var _billing3 = __webpack_require__(989);

var _billingRedirect3 = __webpack_require__(966);

var _sales3 = __webpack_require__(985);

var _actionBar = __webpack_require__(964);

var _actionBar2 = _interopRequireDefault(_actionBar);

var _shifts3 = __webpack_require__(986);

var _invoices3 = __webpack_require__(984);

var _calendar3 = __webpack_require__(968);

var _reduxSentry = __webpack_require__(963);

var _reduxSentry2 = _interopRequireDefault(_reduxSentry);

var _account3 = __webpack_require__(988);

var _index6 = __webpack_require__(994);

var _index7 = __webpack_require__(995);

var _index8 = __webpack_require__(967);

var _index9 = __webpack_require__(975);

var _checkout3 = __webpack_require__(990);

var _confirmAction3 = __webpack_require__(969);

var _customers2 = __webpack_require__(971);

var customerReducers = _interopRequireWildcard(_customers2);

var _setting2 = __webpack_require__(991);

var settingReducers = _interopRequireWildcard(_setting2);

var _employees2 = __webpack_require__(973);

var employeeReducers = _interopRequireWildcard(_employees2);

var _outletPages2 = __webpack_require__(983);

var outletPageReducers = _interopRequireWildcard(_outletPages2);

var _library2 = __webpack_require__(979);

var libraryReducers = _interopRequireWildcard(_library2);

var _inventory2 = __webpack_require__(978);

var inventoryReducers = _interopRequireWildcard(_inventory2);

var _ingredients2 = __webpack_require__(977);

var ingredientReducers = _interopRequireWildcard(_ingredients2);

var _index10 = __webpack_require__(996);

var _index11 = __webpack_require__(970);

var _index12 = __webpack_require__(980);

var _index13 = __webpack_require__(974);

var _index14 = __webpack_require__(993);

var _index15 = __webpack_require__(997);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SENTRY_DSN = "https://721fa4813c8a46c0babdeaf19041c5a1@sentry.io/196852"; /**
                                          * app/index.js
                                          *
                                          * This is the entry file for the application, only setup and boilerplate
                                          * code.
                                          */

if (true) {
  window.mixpanel.init("fba66ea51dc228ad7971579fec7c7f6f");
}

var logger = (0, _reduxLogger2.default)({
  // Ignore `CHANGE_FORM` actions in the logger, since they fire after every keystroke
  predicate: function predicate(getState, action) {
    return action.type !== 'CHANGE_FORM' && action.type !== '@@redux-form/REGISTER_FIELD' && action.type !== '@@redux-form/UNREGISTER_FIELD';
  }
});

var sagaMiddleware = (0, _reduxSaga2.default)();

// Creates the Redux store using our reducer and the logger and saga middlewares
var middlewares = [sagaMiddleware];

if (SENTRY_DSN) {
  middlewares.unshift((0, _reduxSentry2.default)(SENTRY_DSN, {
    environment: "development",
    autoBreadcrumbs: {
      'xhr': true, // XMLHttpRequest
      'console': false, // console logging
      'dom': true, // DOM interactions, i.e. clicks/typing
      'location': true // url changes, including pushState/popState
    },
    release: '' + "81d5d42d\n" // from webpack.common.js
  }));
}

// https://github.com/reactjs/react-router-redux
middlewares.unshift((0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory));

if (true) {
  window.Perf = __webpack_require__(1038);
  middlewares.unshift(logger);
}

var reducers = {
  routing: _reactRouterRedux.routerReducer, // reducer from react-router-redux. Please don't change the key name
  moka: _reducers2.default, // moka default reducer. Please don't change the key name,
  actionBar: _actionBar2.default,
  form: _reduxForm.reducer, // redux form reducer. Please don't change the key name
  calendar: _calendar3.reducer, // for dropdown calendar
  notification: _notifications3.reducer, // our custom reducer for notification.
  auth: _auth3.reducer, // auth specific reducer
  outlet: _outlet3.reducer, // outlet for related user
  library: (0, _redux.combineReducers)({
    category: libraryReducers.libraryCategoryReducer,
    discount: libraryReducers.libraryDiscountReducer,
    gratuity: libraryReducers.libraryGratuityReducer,
    item: libraryReducers.libraryItemReducer,
    modifier: libraryReducers.libraryModifierReducer,
    tax: libraryReducers.libraryTaxReducer
  }),
  reports: (0, _redux.combineReducers)({
    sales: _sales3.reducer,
    grossProfit: _sales3.reducer,
    paymentMethods: _sales3.reducer,
    itemSales: _sales3.reducer,
    categorySales: _sales3.reducer,
    modifierSales: _sales3.reducer,
    discounts: _sales3.reducer,
    taxes: _sales3.reducer,
    gratuities: _sales3.reducer,
    staffs: _sales3.reducer,
    servers: _sales3.reducer,
    shifts: _shifts3.reducer,
    transactions: _transactions3.reducer,
    invoices: _invoices3.reducer,
    showLoadingSpinnerReport: _sales3.reducer
  }),
  ingredients: (0, _redux.combineReducers)({
    library: ingredientReducers.libraryReducer,
    category: ingredientReducers.categoryReducer,
    recipes: ingredientReducers.recipesReducer,
    ingredientSubscription: ingredientReducers.ingredientSubscriptionReducer
  }),
  inventory: (0, _redux.combineReducers)({
    summary: inventoryReducers.summaryReducer,
    supplier: inventoryReducers.supplierReducer,
    purchaseOrder: inventoryReducers.purchaseOrderReducer,
    transfer: inventoryReducers.transferReducer,
    adjustment: inventoryReducers.adjustmentReducer,
    ingredientSubscription: inventoryReducers.ingredientSubscriptionReducer
  }),
  dashboard: (0, _redux.combineReducers)({ index: _index5.reducer }),
  setting: (0, _redux.combineReducers)({
    account: _account3.reducer,
    checkout: _checkout3.reducer,
    receipt: _receipt3.reducer,
    emailNotification: settingReducers.emailNotificationReducer,
    billing: _billing3.reducer
  }),
  uploadImage: (0, _redux.combineReducers)({ uploadImage: _index6.reducer }),
  confirmAction: _confirmAction3.reducer,
  customers: (0, _redux.combineReducers)({
    feedback: customerReducers.customerFeedbackReducer,
    list: customerReducers.customerListReducer,
    loyalty: customerReducers.customerLoyaltyReducer
  }),
  employee: (0, _redux.combineReducers)({
    permission: employeeReducers.employeePermissionReducer,
    list: employeeReducers.employeeListReducer
  }),
  outletPages: (0, _redux.combineReducers)({
    list: outletPageReducers.outletPagesListReducer
  }),
  uploaders: (0, _redux.combineReducers)({
    import: _index7.reducer
  }),
  buttons: _index8.reducer,
  feedback: (0, _redux.combineReducers)({
    replyForm: _index9.reducer
  }),
  verifyEmail: _index10.reducer,
  confirmEmployee: _index11.reducer,
  loadingSpinner: _index12.reducer,
  feedbackForm: _index13.reducer,
  subscriptionExpired: _index14.reducer,
  billingNotification: _billingRedirect3.reducer,
  verifyEmailAlertRecipient: _index15.reducer
};

var store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers), (0, _developmentOnly.composeWithDevTools)(_redux.applyMiddleware.apply(undefined, middlewares)));

// We run the root saga automatically
sagaMiddleware.run(_sagas2.default);
sagaMiddleware.run(_auth2.default);
sagaMiddleware.run(forgotPasswordSagas.forgotPasswordSaga);
sagaMiddleware.run(_outlet2.default);
sagaMiddleware.run(_sales2.default);
sagaMiddleware.run(_shifts2.default);
sagaMiddleware.run(_invoices2.default);
sagaMiddleware.run(_calendar2.default);
sagaMiddleware.run(_index2.default);
sagaMiddleware.run(_transactions2.default);
sagaMiddleware.run(_getExportedFile2.default);
sagaMiddleware.run(_account2.default);
sagaMiddleware.run(_publicProfile2.default);
sagaMiddleware.run(_index4.default);
sagaMiddleware.run(_importCustomer2.default);
sagaMiddleware.run(_checkout2.default);
sagaMiddleware.run(_receipt2.default);
sagaMiddleware.run(_confirmAction2.default);
sagaMiddleware.run(_feedbackReplyForm2.default);
sagaMiddleware.run(settingSagas.emailNotificationSaga);
sagaMiddleware.run(customerSagas.customerFeedbackSaga);
sagaMiddleware.run(customerSagas.customerListSaga);
sagaMiddleware.run(customerSagas.loyaltySaga);
sagaMiddleware.run(employeeSagas.employeePermissionSaga);
sagaMiddleware.run(employeeSagas.employeeListSaga);
sagaMiddleware.run(outletPageSagas.outletPagesListSaga);
sagaMiddleware.run(librarySagas.libraryCategorySaga);
sagaMiddleware.run(librarySagas.libraryDiscountSaga);
sagaMiddleware.run(librarySagas.libraryItemSaga);
sagaMiddleware.run(librarySagas.libraryGratuitySaga);
sagaMiddleware.run(librarySagas.libraryModifierSaga);
sagaMiddleware.run(librarySagas.libraryTaxSaga);
sagaMiddleware.run(exampleFormSagas.dropdownCalendarFormSaga);
sagaMiddleware.run(_notifications2.default);
sagaMiddleware.run(ingredientSagas.librarySaga);
sagaMiddleware.run(ingredientSagas.categorySaga);
sagaMiddleware.run(ingredientSagas.ingredientSubscriptionSaga);
sagaMiddleware.run(ingredientSagas.recipesSaga);
sagaMiddleware.run(inventorySagas.summarySaga);
sagaMiddleware.run(inventorySagas.supplierSaga);
sagaMiddleware.run(inventorySagas.purchaseOrderSaga);
sagaMiddleware.run(inventorySagas.transferSaga);
sagaMiddleware.run(inventorySagas.adjustmentSaga);
sagaMiddleware.run(inventorySagas.ingredientSubscriptionSaga);
sagaMiddleware.run(_verifyEmail2.default);
sagaMiddleware.run(_confirmEmployee2.default);
sagaMiddleware.run(_feedbackForm2.default);
sagaMiddleware.run(_billing2.default);
sagaMiddleware.run(_verifyEmail2.default);
sagaMiddleware.run(_subscriptionExpired2.default);
sagaMiddleware.run(_billingRedirect2.default);
sagaMiddleware.run(_billingNotification2.default);
sagaMiddleware.run(_verifyEmailAlertRecipient2.default);

var MokaBackofficeRoutes = __webpack_require__(998)(store);
ReactDOM.render(React.createElement(MokaBackofficeRoutes, null), document.getElementById('app'));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(0)))

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerFeedbackStart = customerFeedbackStart;
exports.customerFeedbackReply = customerFeedbackReply;
exports.customerFeedbackSelect = customerFeedbackSelect;

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function customerFeedbackStart() {
  mixpanel.track('Feedback Start');
} /* global mixpanel */
function customerFeedbackReply(_ref) {
  var feedback = _ref.feedback;

  mixpanel.track('Feedback Reply', {
    'Type': feedback.feedback_from
  });
}

function customerFeedbackSelect(_ref2) {
  var feedback = _ref2.feedback,
      transaction = _ref2.transaction,
      feedbackMessages = _ref2.feedbackMessages;

  var lastCustomerMessage = '';
  var lastMerchatMessage = '';
  for (var i = feedbackMessages.messages.length - 1; i >= 0 && (!lastCustomerMessage || !lastMerchatMessage); i--) {
    if (feedbackMessages.messages[i].is_customer && !lastCustomerMessage) {
      lastCustomerMessage = feedbackMessages.messages[i].comment;
    } else if (!feedbackMessages.messages[i].is_customer && !lastMerchatMessage) {
      lastMerchatMessage = feedbackMessages.messages[i].comment;
    }
  }
  mixpanel.track('Feedback List Select', {
    'Feedback Date': feedback.feedback_date,
    'Feedback Message Type': feedback.feedback_type,
    'Feedback Last Customer Message': lastCustomerMessage,
    'Feedback Last Merchant Message': lastMerchatMessage,
    'Transaction Date': (0, _moment2.default)(transaction.created_at).format('YYYY-MM-DD'),
    'Transaction Time': (0, _moment2.default)(transaction.created_at).format('hh:mm:ss'),
    'Receipt Number': transaction.payment_no,
    'Served By': transaction.served_by,
    'Collected By': transaction.collected_by,
    'Total': transaction.total_collected,
    'Payment Method': transaction.payment_type,
    'Payment Amount': transaction.tendered,
    'Change': transaction.change,
    'Payment Note': transaction.payment_note
  });
}

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forgotPasswordStart = forgotPasswordStart;
/* global mixpanel */
function forgotPasswordStart(_ref) {
  var email = _ref.email;

  mixpanel.track('Forgot Password Start', {
    'Email': email
  });
}

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addIdentify;
/* global mixpanel */

function addIdentify(profileId) {
  mixpanel.identify(profileId);
}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ingredientCategoryStart = ingredientCategoryStart;
exports.ingredientCategoryChangeOutlet = ingredientCategoryChangeOutlet;
exports.ingredientCategorySelect = ingredientCategorySelect;
exports.ingredientCategoryCreate = ingredientCategoryCreate;
exports.ingredientCategoryDelete = ingredientCategoryDelete;
exports.ingredientCategoryAssign = ingredientCategoryAssign;
/* global mixpanel */

function ingredientCategoryStart(_ref) {
  var outletIds = _ref.outletIds;

  mixpanel.track('Ingredient Category Start', {
    'Current Selected Outlet': outletIds
  });
}

function ingredientCategoryChangeOutlet(_ref2) {
  var outletIds = _ref2.outletIds;

  mixpanel.track('Ingredient Category Change Outlet', {
    'Current Selected Outlet': outletIds
  });
}

function ingredientCategorySelect(_ref3) {
  var category = _ref3.category;

  mixpanel.track('Ingredient Category Select', {
    'Name': category.name
  });
}

function ingredientCategoryCreate(_ref4) {
  var category = _ref4.category,
      allOutlet = _ref4.allOutlet;

  var eventName = void 0;
  if (allOutlet) {
    eventName = 'Ingredient Category Create All Outlet';
  } else {
    eventName = 'Ingredient Category Create One Outlet';
  }
  mixpanel.track(eventName, {
    'Name': category.name
  });
}

function ingredientCategoryDelete(_ref5) {
  var category = _ref5.category;

  mixpanel.track('Ingredient Category Delete', {
    'Name': category.name
  });
}

function ingredientCategoryAssign(_ref6) {
  var category = _ref6.category,
      data = _ref6.data;

  mixpanel.track('Ingredient Category Assign', {
    'Name': category.name,
    'Ingredient List': data
  });
}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateInventoryCode = translateInventoryCode;
exports.ingredientLibraryStart = ingredientLibraryStart;
exports.ingredientLibraryChangeFilter = ingredientLibraryChangeFilter;
exports.ingredientLibrarySelect = ingredientLibrarySelect;
exports.ingredientLibraryCreate = ingredientLibraryCreate;
exports.ingredientLibraryDelete = ingredientLibraryDelete;
exports.cogsTrackingIngredient = cogsTrackingIngredient;
/* global mixpanel */
function translateInventoryCode(inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert';
    case 2:
    case '2':
      return 'Out of Stock Alert';
    default:
      return 'All';
  }
}

function ingredientLibraryStart(_ref) {
  var outletIds = _ref.outletIds,
      categoryIds = _ref.categoryIds,
      InventoryIds = _ref.InventoryIds;

  mixpanel.track('Ingredient Library Start', {
    'Current Selected Outlet': outletIds,
    'Current Selected Category': categoryIds,
    'Current Selected Inventory': translateInventoryCode(InventoryIds)
  });
}

function ingredientLibraryChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds,
      categoryIds = _ref2.categoryIds,
      inventoryIds = _ref2.inventoryIds;

  mixpanel.track('Ingredient Library Change Filter', {
    'Current Selected Outlet Filter': outletIds,
    'Current Selected Category Filter': categoryIds,
    'Current Selected Inventory Filter': translateInventoryCode(inventoryIds)
  });
}

function ingredientLibrarySelect(_ref3) {
  var outletIds = _ref3.outletIds,
      name = _ref3.name,
      category = _ref3.category,
      unit = _ref3.unit;

  mixpanel.track('Ingredient Library Select', {
    'Current Selected Outlet': outletIds,
    'Name': name,
    'Category': category,
    'Unit': unit
  });
}

function ingredientLibraryCreate(_ref4) {
  var ingredient = _ref4.ingredient,
      allOutlet = _ref4.allOutlet;

  var eventName = '';
  if (allOutlet) {
    eventName = 'Ingredient Create All Outlet';
  } else {
    eventName = 'Ingredient Create One Outlet';
  }
  mixpanel.track(eventName, {
    'Name': ingredient.name,
    'Category': ingredient.ingredient_category_name,
    'Unit': ingredient.unit_name,
    'In Stock Current': ingredient.in_stock
  });
}

function ingredientLibraryDelete(_ref5) {
  var outletIds = _ref5.outletIds,
      name = _ref5.name,
      category = _ref5.category,
      unit = _ref5.unit;

  mixpanel.track('Ingredient Library Delete', {
    'Current Selected Outlet': outletIds,
    'Name': name,
    'Category': category,
    'Unit': unit
  });
}

function cogsTrackingIngredient(_ref6) {
  var ingredientList = _ref6.ingredientList,
      libraryCOGSForm = _ref6.libraryCOGSForm,
      showInputCOGS = _ref6.showInputCOGS;

  var eventName = '';
  !showInputCOGS ? eventName = 'COGS Tracking Start Ingredient' : eventName = 'COGS Tracking Manage Ingredient';
  mixpanel.track(eventName, {
    'Ingredient [List]': ingredientList,
    'Name': ingredientList.name,
    'Average Cost': libraryCOGSForm.cogs
  });
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ingredientRecipesStart = ingredientRecipesStart;
exports.ingredientRecipesChangeFilter = ingredientRecipesChangeFilter;
exports.ingredientRecipesSelect = ingredientRecipesSelect;
exports.ingredientRecipesCreate = ingredientRecipesCreate;
exports.ingredientRecipesUpdate = ingredientRecipesUpdate;
exports.ingredientRecipesDelete = ingredientRecipesDelete;
/* global mixpanel */

function ingredientRecipesStart(_ref) {
  var outletIds = _ref.outletIds;

  mixpanel.track('Ingredient Recipes Start', {
    'Current Selected Outlet': outletIds
  });
}

function ingredientRecipesChangeFilter(_ref2) {
  var outletIds = _ref2.outletIds;

  mixpanel.track('Ingredient Recipes Change Outlet', {
    'Current Selected Outlet': outletIds
  });
}

function ingredientRecipesSelect(_ref3) {
  var recipe = _ref3.recipe;

  mixpanel.track('Ingredient Recipes Select', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map(function (ri) {
      return {
        'Ingredient Name': ri.ingredient_name,
        'Ingredient Quantity': ri.quantity,
        'Ingredient Unit': ri.unit_name
      };
    })
  });
}

function ingredientRecipesCreate(_ref4) {
  var recipe = _ref4.recipe,
      allOutlet = _ref4.allOutlet;

  var eventName = void 0;
  if (allOutlet) {
    eventName = 'Ingredient Recipes Create All Outlet';
  } else {
    eventName = 'Ingredient Recipes Create One Outlet';
  }
  mixpanel.track(eventName, {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map(function (ri) {
      return {
        'Ingredient Name': ri.ingredient_name,
        'Ingredient Quantity': ri.quantity,
        'Ingredient Unit': ri.unit_name
      };
    })
  });
}

function ingredientRecipesUpdate(_ref5) {
  var recipe = _ref5.recipe;

  mixpanel.track('Ingredient Recipes Update One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map(function (ri) {
      return {
        'Current Ingredient Name': ri.ingredient_name,
        'Current Ingredient Quantity': ri.quantity,
        'Current Ingredient Unit': ri.unit_name
      };
    })
  });
}

function ingredientRecipesDelete(_ref6) {
  var recipe = _ref6.recipe;

  mixpanel.track('Ingredient Recipes Delete One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Ingredient': recipe.recipe_ingredients.map(function (ri) {
      return {
        'Ingredient Name': ri.ingredient_name,
        'Ingredient Quantity': ri.quantity,
        'Ingredient Unit': ri.unit_name
      };
    })
  });
}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyFromProfile = identifyFromProfile;
exports.login = login;

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatDate = __webpack_require__(59);

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param profile data from api profile
 */
/* global mixpanel */
function identifyFromProfile(_ref) {
  var profile = _ref.profile;

  mixpanel.identify(profile.id);
  mixpanel.people.set({
    $email: profile.email,
    $first_name: profile.first_name,
    $last_name: profile.last_name,
    $created: (0, _formatDate2.default)(profile.created_at),
    'Last Login': (0, _formatDate2.default)((0, _moment2.default)()),
    'Phone': profile.phone,
    'Business Name': profile.business.name,
    'Business Type ID': profile.business.business_type_id,
    'Business Category ID': profile.business.business_category_id,
    'Business Address': profile.business.address,
    'Business City': profile.business.city,
    'Business State': profile.business.province,
    'Business ZIP': profile.business.zip
  });
}

function login(_ref2) {
  var profile = _ref2.profile;

  mixpanel.track('Login', {
    'Active Subscription': profile.already_subscribed,
    'Is Business Owner': profile.is_owner,
    'Email': profile.email
  });
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetAfterLogout = resetAfterLogout;
exports.logout = logout;
/* global mixpanel */
function resetAfterLogout() {
  mixpanel.reset();
}

function logout() {
  mixpanel.track('Logout');
}

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingAccountStart = settingAccountStart;
/* global mixpanel */
function settingAccountStart() {
  mixpanel.track('Setting Account Start');
}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingBillingPay = settingBillingPay;
/**
 * Created by alvinoktavianus on 7/21/17.
 */
/* global mixpanel */

function settingBillingPay(_ref) {
  var billingData = _ref.billingData;

  mixpanel.track('Setting Billing Pay', {
    'Billing Cycle': billingData.subscription_name !== 'Monthly' ? 'Annual' : billingData.subscription_name,
    'Payment Amount': billingData.total_amount,
    'Total Outlet': billingData.purchased_outlets.length
  });
}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingCheckoutStart = settingCheckoutStart;
exports.settingCheckoutUpdate = settingCheckoutUpdate;
/* global mixpanel */
function settingCheckoutStart() {
  mixpanel.track('Setting Checkout Start');
}

function settingCheckoutUpdate(_ref) {
  var settings = _ref.settings;

  mixpanel.track('Setting Checkout Update', {
    'Tax Enable': settings.enable_tax,
    'Gratuity Enable': settings.enable_gratuity,
    'Include or Add': settings.include_gratuity_tax,
    'Track Server': settings.track_server
  });
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingEmailStart = settingEmailStart;
exports.settingEmailUpdate = settingEmailUpdate;
/* global mixpanel */
function settingEmailStart() {
  mixpanel.track('Setting Notification Start');
}

function settingEmailUpdate(_ref) {
  var settings = _ref.settings;

  mixpanel.track('Setting Notification Update', {
    'Daily Enable': settings.daily_sales_summary,
    'Product Enable': settings.product_updates,
    'Inventory Enable': settings.inventory_alerts,
    'List of Recipients': settings.setting_alert_recipients.map(function (sar) {
      return sar.email;
    })
  });
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingPublicProfileStart = settingPublicProfileStart;
/* global mixpanel */
function settingPublicProfileStart() {
  mixpanel.track('Setting Public Start');
}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingReceiptStart = settingReceiptStart;
exports.settingReceiptChangeOutlet = settingReceiptChangeOutlet;
/* global mixpanel */
function settingReceiptStart(_ref) {
  var outletIds = _ref.outletIds;

  mixpanel.track('Setting Receipt Start', {
    'Current Selected Outlet': outletIds
  });
}

function settingReceiptChangeOutlet(_ref2) {
  var outletIds = _ref2.outletIds;

  mixpanel.track('Setting Receipt Change Outlet', {
    'Current Selected Outlet': outletIds
  });
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _account = __webpack_require__(1054);

var _style = __webpack_require__(756);

var _style2 = _interopRequireDefault(_style);

var _AccountForm = __webpack_require__(1218);

var _AccountForm2 = _interopRequireDefault(_AccountForm);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouter = __webpack_require__(15);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account = function (_React$Component) {
  (0, _inherits3.default)(Account, _React$Component);

  function Account() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Account);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).call.apply(_ref, [this].concat(args))), _this), _this._handleSubmit = function (account) {
      var user = _this.props.data.moka.user;
      var values = _this.props.data.form.accountForm.values;

      account = {
        password_confirmation: values.old_password,
        user: {
          email: user.email,
          first_name: values.first_name || user.first_name,
          last_name: values.last_name || user.last_name,
          password: values.password,
          password_confirmation: values.password_confirmation,
          security_question: user.security_question || null,
          security_question_answer: user.security_question_answer || null,
          updated_at: user.updated_at
        }
      };
      _this.props.dispatch((0, _account.settingAccountRequest)(account));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Account, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _account.accountPageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.data.isDirtyForm && !_this2.props.nextAction) {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location.pathname)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.data.moka.user;

      return React.createElement(
        'div',
        { id: 'account-setting' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-6 col-lg-6 col-sm-12' },
            React.createElement(
              'div',
              { className: _style2.default['mk-section-header'] },
              'ACCOUNT'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-6 col-lg-6 col-sm-12' },
            React.createElement(_AccountForm2.default, {
              email: user.email,
              onSubmit: this._handleSubmit
            })
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Account;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
      form: state.form,
      isDirtyForm: (0, _reduxForm.isDirty)('accountForm')(state),
      subscriptionExpired: state.subscriptionExpired
    },
    nextAction: state.confirmAction.nextAction
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Account);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(756);

var _style2 = _interopRequireDefault(_style);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.first_name) {
    errors.first_name = 'This field is required';
  }
  if (!values.last_name) {
    errors.last_name = 'This field is required';
  }

  if (values.password || values.old_password || values.password_confirmation) {
    if (!values.old_password) {
      errors.old_password = 'This field is required';
    }
    if (!values.password) {
      errors.password = 'This field is required';
    } else {
      if (values.password.length < 6) {
        errors.password = 'Please enter at least 6 characters';
      }
    }
    if (!values.password_confirmation) {
      errors.password_confirmation = 'This field is required';
    } else {
      if (values.password_confirmation !== values.password) {
        errors.password_confirmation = 'Password is not match';
      }
    }
  }
  return errors;
};

var AccountForm = function (_React$Component) {
  (0, _inherits3.default)(AccountForm, _React$Component);

  function AccountForm() {
    (0, _classCallCheck3.default)(this, AccountForm);
    return (0, _possibleConstructorReturn3.default)(this, (AccountForm.__proto__ || (0, _getPrototypeOf2.default)(AccountForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { name: 'form', id: 'account-form', onSubmit: handleSubmit },
        React.createElement(
          'fieldset',
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: _style2.default['mk-sub-section-header'] },
                'basic information'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-6 col-md-12 col-sm-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'text',
                  placeholder: 'First Name',
                  name: 'first_name',
                  maxLength: '40'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-lg-6 col-md-12 col-sm-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'text',
                  placeholder: 'Last Name',
                  name: 'last_name',
                  maxLength: '40'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'text',
                  placeholder: 'Email',
                  readOnly: 'true',
                  name: 'email',
                  maxLength: '40',
                  dis: true
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement('div', { className: _style2.default['mk-divider-section-line'] })
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: _style2.default['mk-sub-section-header'] },
                'change password'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'password',
                  placeholder: 'Current Password',
                  name: 'old_password',
                  maxLength: '40'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-lg-6 col-md-12 col-sm-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'password',
                  placeholder: 'New Password',
                  id: 'new_password',
                  name: 'password',
                  maxLength: '40'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-lg-6 col-md-12 col-sm-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  type: 'password',
                  placeholder: 'Confirm New Password',
                  id: 'new_password_confirmation',
                  name: 'password_confirmation',
                  maxLength: '40'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement('div', { className: _style2.default['mk-divider-section-line'] })
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'button',
                {
                  type: 'submit',
                  className: 'btn btn-primary pull-right' },
                'Save'
              )
            )
          )
        )
      );
    }
  }]);
  return AccountForm;
}(React.Component);

AccountForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'accountForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate // a unique identifier for this form
})(AccountForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2059);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountSetting = function (_React$Component) {
  (0, _inherits3.default)(AccountSetting, _React$Component);

  function AccountSetting() {
    (0, _classCallCheck3.default)(this, AccountSetting);
    return (0, _possibleConstructorReturn3.default)(this, (AccountSetting.__proto__ || (0, _getPrototypeOf2.default)(AccountSetting)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountSetting, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _style2.default['container-full-nosub'], id: 'account-setting' },
        React.createElement(
          'div',
          { className: 'container box-report-child ' + _style2.default['container'] },
          this.props.children
        )
      );
    }
  }]);
  return AccountSetting;
}(React.Component);

exports.default = AccountSetting;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _Header = __webpack_require__(248);

var _Header2 = _interopRequireDefault(_Header);

var _ActiveOutlets = __webpack_require__(2037);

var _ActiveOutlets2 = _interopRequireDefault(_ActiveOutlets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/18/17.
 */

var ActiveOutlets = function (_Component) {
  (0, _inherits3.default)(ActiveOutlets, _Component);

  function ActiveOutlets() {
    (0, _classCallCheck3.default)(this, ActiveOutlets);
    return (0, _possibleConstructorReturn3.default)(this, (ActiveOutlets.__proto__ || (0, _getPrototypeOf2.default)(ActiveOutlets)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActiveOutlets, [{
    key: 'renderActiveOutlets',
    value: function renderActiveOutlets() {
      var outlets = this.props.outlets;

      return _lodash2.default.map(outlets, function (outlet) {
        var today = (0, _moment2.default)();
        if ((0, _moment2.default)(outlet.end_date).diff(today) > 0) {
          return _react2.default.createElement(
            'div',
            { className: _ActiveOutlets2.default['mb-20px'], key: outlet.id },
            _react2.default.createElement(
              'div',
              { className: _ActiveOutlets2.default['mb-10px'] },
              _react2.default.createElement(
                'p',
                { className: _ActiveOutlets2.default['outlet-name'] },
                _react2.default.createElement(
                  'strong',
                  null,
                  outlet.name
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              'Expiration Date: ',
              _react2.default.createElement(
                'strong',
                null,
                (0, _moment2.default)(outlet.end_date).format('DD MMMM YYYY')
              )
            )
          );
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showLoadingSpinnerPage = this.props.showLoadingSpinnerPage;

      return !showLoadingSpinnerPage && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, { title: 'active outlets' }),
        this.renderActiveOutlets()
      );
    }
  }]);
  return ActiveOutlets;
}(_react.Component);

function mapStateToProps(state) {
  var outlets = state.setting.billing.outlets;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return { outlets: outlets, showLoadingSpinnerPage: showLoadingSpinnerPage };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActiveOutlets);

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _PageWrapper = __webpack_require__(296);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _index = __webpack_require__(202);

var _billing = __webpack_require__(202);

var _BillingHistory = __webpack_require__(1222);

var _BillingHistory2 = _interopRequireDefault(_BillingHistory);

var _BillingReceipt = __webpack_require__(1223);

var _BillingReceipt2 = _interopRequireDefault(_BillingReceipt);

var _ActiveOutlets = __webpack_require__(1220);

var _ActiveOutlets2 = _interopRequireDefault(_ActiveOutlets);

var _CurrentPlan = __webpack_require__(1226);

var _CurrentPlan2 = _interopRequireDefault(_CurrentPlan);

var _FeatureSubscriptions = __webpack_require__(1227);

var _FeatureSubscriptions2 = _interopRequireDefault(_FeatureSubscriptions);

var _PaymentGatewayErrorModal = __webpack_require__(441);

var _PaymentGatewayErrorModal2 = _interopRequireDefault(_PaymentGatewayErrorModal);

var _Billing = __webpack_require__(2038);

var _Billing2 = _interopRequireDefault(_Billing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/18/17.
 */

var Billing = function (_Component) {
  (0, _inherits3.default)(Billing, _Component);

  function Billing() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Billing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Billing.__proto__ || (0, _getPrototypeOf2.default)(Billing)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _index.hidePaymentGatewayErrorModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Billing, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showPaymentGatewayErrorModal = _props.showPaymentGatewayErrorModal,
          totalBillingPrice = _props.totalBillingPrice,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      var isLoading = 'col-xs-12 col-md-6 ' + _Billing2.default['mr-loading'];
      var isNotLoading = 'col-xs-12 col-md-6';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _PageWrapper2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: !showLoadingSpinnerPage ? isNotLoading : isLoading },
              _react2.default.createElement(_CurrentPlan2.default, null),
              _react2.default.createElement(_ActiveOutlets2.default, null),
              _react2.default.createElement(_FeatureSubscriptions2.default, null)
            ),
            _react2.default.createElement(
              'div',
              { className: !showLoadingSpinnerPage ? isNotLoading : isLoading },
              _react2.default.createElement(_BillingReceipt2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: !showLoadingSpinnerPage ? 'col-xs-12' : 'col-xs-12 ' + _Billing2.default['mr-loading'] },
              _react2.default.createElement(_BillingHistory2.default, null)
            )
          )
        ),
        _react2.default.createElement(_PaymentGatewayErrorModal2.default, {
          showModal: showPaymentGatewayErrorModal,
          onHide: this._onHide,
          totalPrice: totalBillingPrice
        })
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          current_plan = _props2.current_plan,
          expired = _props2.expired,
          is_owner = _props2.is_owner,
          billingNotification = _props2.billingNotification;

      this.props.dispatch((0, _billing.billingPageRequest)(current_plan, expired, is_owner, billingNotification));
    }
  }]);
  return Billing;
}(_react.Component);

function mapStateToProps(state) {
  var _state$moka$user = state.moka.user,
      is_owner = _state$moka$user.is_owner,
      current_plan = _state$moka$user.business.current_plan;
  var _state$setting$billin = state.setting.billing,
      showPaymentGatewayErrorModal = _state$setting$billin.showPaymentGatewayErrorModal,
      totalBillingPrice = _state$setting$billin.totalBillingPrice;
  var _state$subscriptionEx = state.subscriptionExpired,
      nextActionExpired = _state$subscriptionEx.nextActionExpired,
      expired = _state$subscriptionEx.expired;
  var billingNotification = state.billingNotification;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    showPaymentGatewayErrorModal: showPaymentGatewayErrorModal,
    totalBillingPrice: totalBillingPrice,
    current_plan: current_plan,
    nextActionExpired: nextActionExpired,
    expired: expired,
    is_owner: is_owner,
    billingNotification: billingNotification,
    showLoadingSpinnerPage: showLoadingSpinnerPage
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Billing);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

var _reactRedux = __webpack_require__(6);

var _constants = __webpack_require__(30);

var _Header = __webpack_require__(248);

var _Header2 = _interopRequireDefault(_Header);

var _BillingHistory = __webpack_require__(2039);

var _BillingHistory2 = _interopRequireDefault(_BillingHistory);

var _download = __webpack_require__(2856);

var _download2 = _interopRequireDefault(_download);

var _emptyTable = __webpack_require__(2858);

var _emptyTable2 = _interopRequireDefault(_emptyTable);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingHistory = function (_Component) {
  (0, _inherits3.default)(BillingHistory, _Component);

  function BillingHistory() {
    (0, _classCallCheck3.default)(this, BillingHistory);
    return (0, _possibleConstructorReturn3.default)(this, (BillingHistory.__proto__ || (0, _getPrototypeOf2.default)(BillingHistory)).apply(this, arguments));
  }

  (0, _createClass3.default)(BillingHistory, [{
    key: 'renderBillingTable',
    value: function renderBillingTable() {
      var _this2 = this;

      var billings = this.props.billings;

      return _lodash2.default.map(billings, function (billing) {
        return _react2.default.createElement(
          'tr',
          { key: billing.id },
          _react2.default.createElement(
            'td',
            null,
            (0, _moment2.default)(billing.created_at).format('DD MMM YYYY')
          ),
          _react2.default.createElement(
            'td',
            { className: 'visible-lg visible-md' },
            billing.invoice_number
          ),
          _react2.default.createElement(
            'td',
            { className: 'visible-lg visible-md' },
            (0, _moment2.default)(billing.start_period).format('DD MMM YYYY'),
            ' - ',
            (0, _moment2.default)(billing.end_period).format('DD MMM YYYY')
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'div',
              null,
              (0, _formatter.currencyFormatter)(billing.total_amount)
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'span',
              { className: _BillingHistory2.default[billing.status] },
              billing.status
            )
          ),
          _react2.default.createElement(
            'td',
            { className: 'visible-lg visible-md' },
            _react2.default.createElement('input', {
              type: 'image',
              src: _download2.default,
              className: _BillingHistory2.default['download-button'],
              value: billing.invoice_number,
              onClick: function onClick(e) {
                _this2._downloadInvoice(e);
              }
            })
          )
        );
      });
    }
  }, {
    key: 'renderBillingHistory',
    value: function renderBillingHistory() {
      var billings = this.props.billings;

      if (billings.length !== 0) {
        return _react2.default.createElement(
          'div',
          { className: 'col-sm-12 ' + _BillingHistory2.default['billing-history-table'] },
          _react2.default.createElement(
            'table',
            { className: 'table ' + _BillingHistory2.default['billing-history'] },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Invoice Date'
                ),
                _react2.default.createElement(
                  'th',
                  { className: 'visible-lg visible-md' },
                  'Invoice Number'
                ),
                _react2.default.createElement(
                  'th',
                  { className: 'visible-lg visible-md' },
                  'Period'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Total Amount'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Status'
                ),
                _react2.default.createElement(
                  'th',
                  { className: 'visible-lg visible-md' },
                  'Download Invoice'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              this.renderBillingTable()
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: _BillingHistory2.default['empty-table'] },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: _emptyTable2.default })
        ),
        _react2.default.createElement(
          'div',
          null,
          'You don\'t have ',
          _react2.default.createElement('br', null),
          'any invoices yet'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var showLoadingSpinnerPage = this.props.showLoadingSpinnerPage;

      return _react2.default.createElement(
        'div',
        { className: _BillingHistory2.default['billing-history-wrapper'] },
        _react2.default.createElement(
          'div',
          { className: _BillingHistory2.default['billing-container'] },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: !showLoadingSpinnerPage ? 'col-sm-12' : 'col-sm-12 ' + _BillingHistory2.default['load-header'] },
              _react2.default.createElement(_Header2.default, { title: 'billing history' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row ' + _BillingHistory2.default['billing-list'] },
            showLoadingSpinnerPage && _react2.default.createElement(
              'div',
              { className: 'col-sm-12 ' + _BillingHistory2.default['load-table'] },
              _react2.default.createElement(
                'div',
                { className: _BillingHistory2.default['loading-billing-history'] },
                _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerPage })
              )
            ),
            !showLoadingSpinnerPage && this.renderBillingHistory()
          )
        )
      );
    }
  }, {
    key: '_downloadInvoice',
    value: function _downloadInvoice(event) {
      window.location.replace(_constants.API_URL + ('/v1/billings/' + event.target.value + '.pdf'));
    }
  }]);
  return BillingHistory;
}(_react.Component); /**
                      * Created by alvinoktavianus on 5/17/17.
                      */

var mapStateToProps = function mapStateToProps(state) {
  var billings = state.setting.billing.billings;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return { billings: billings, showLoadingSpinnerPage: showLoadingSpinnerPage };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingHistory);

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _Header = __webpack_require__(248);

var _Header2 = _interopRequireDefault(_Header);

var _BillingReceiptForm = __webpack_require__(1224);

var _BillingReceiptForm2 = _interopRequireDefault(_BillingReceiptForm);

var _billing = __webpack_require__(202);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _BillingReceipt = __webpack_require__(2040);

var _BillingReceipt2 = _interopRequireDefault(_BillingReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/17/17.
 */

var BillingReceipt = function (_Component) {
  (0, _inherits3.default)(BillingReceipt, _Component);

  function BillingReceipt() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BillingReceipt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BillingReceipt.__proto__ || (0, _getPrototypeOf2.default)(BillingReceipt)).call.apply(_ref, [this].concat(args))), _this), _this._handleSubmit = function () {
      var _this$props = _this.props,
          currentSubscriptionRules = _this$props.currentSubscriptionRules,
          outlets = _this$props.outlets,
          totalBillingPrice = _this$props.totalBillingPrice,
          featureSubscriptionStatus = _this$props.featureSubscriptionStatus,
          pendingPaymentMessage = _this$props.pendingPaymentMessage,
          isDeleted = _this$props.isDeleted;

      if (pendingPaymentMessage) {
        //  do nothing
      } else {
        var mapedOutlets = _lodash2.default.mapKeys(outlets, 'id');
        var purchasedOutlets = [];
        var activatedFeatures = [];
        _lodash2.default.map(isDeleted, function (value, key) {
          if (!value) purchasedOutlets.push(mapedOutlets[key]);
        });
        _lodash2.default.forEach(featureSubscriptionStatus, function (feature) {
          if (feature.is_active && feature.is_subscribing) {
            activatedFeatures.push(feature.id);
          }
        });
        _this.props.dispatch((0, _billing.payMokaSubscription)(totalBillingPrice, currentSubscriptionRules, purchasedOutlets, activatedFeatures));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BillingReceipt, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          payButtonClicked = _props.payButtonClicked,
          buttonMessage = _props.buttonMessage,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      return _react2.default.createElement(
        'div',
        { className: showLoadingSpinnerPage ? _BillingReceipt2.default['load-billing-receipt'] : '' },
        _react2.default.createElement(_Header2.default, { title: 'billing' }),
        _react2.default.createElement(
          'div',
          { className: _BillingReceipt2.default['loading-receipt'] },
          _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerPage })
        ),
        !showLoadingSpinnerPage && _react2.default.createElement(_BillingReceiptForm2.default, {
          onSubmit: this._handleSubmit,
          payButtonClicked: payButtonClicked,
          buttonMessage: buttonMessage })
      );
    }
  }]);
  return BillingReceipt;
}(_react.Component);

function mapStateToProps(state) {
  var _state$setting$billin = state.setting.billing,
      rules = _state$setting$billin.rules,
      currentSubscriptionRules = _state$setting$billin.currentSubscriptionRules,
      outlets = _state$setting$billin.outlets,
      payButtonClicked = _state$setting$billin.payButtonClicked,
      buttonMessage = _state$setting$billin.buttonMessage,
      totalBillingPrice = _state$setting$billin.totalBillingPrice,
      featureSubscriptionStatus = _state$setting$billin.featureSubscriptionStatus,
      pendingPaymentMessage = _state$setting$billin.pendingPaymentMessage,
      isDeleted = _state$setting$billin.isDeleted;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    rules: rules,
    currentSubscriptionRules: currentSubscriptionRules,
    outlets: outlets,
    payButtonClicked: payButtonClicked,
    buttonMessage: buttonMessage,
    totalBillingPrice: totalBillingPrice,
    featureSubscriptionStatus: featureSubscriptionStatus,
    pendingPaymentMessage: pendingPaymentMessage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    isDeleted: isDeleted
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingReceipt);

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(10);

var _style = __webpack_require__(2041);

var _style2 = _interopRequireDefault(_style);

var _DropdownSelect = __webpack_require__(1225);

var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);

var _billing = __webpack_require__(202);

var _turn_on = __webpack_require__(2870);

var _turn_on2 = _interopRequireDefault(_turn_on);

var _turn_off = __webpack_require__(2869);

var _turn_off2 = _interopRequireDefault(_turn_off);

var _notAvailableButton = __webpack_require__(2865);

var _notAvailableButton2 = _interopRequireDefault(_notAvailableButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InformationWithTooltip = function (_Component) {
  (0, _inherits3.default)(InformationWithTooltip, _Component);

  function InformationWithTooltip() {
    (0, _classCallCheck3.default)(this, InformationWithTooltip);
    return (0, _possibleConstructorReturn3.default)(this, (InformationWithTooltip.__proto__ || (0, _getPrototypeOf2.default)(InformationWithTooltip)).apply(this, arguments));
  }

  (0, _createClass3.default)(InformationWithTooltip, [{
    key: 'render',
    value: function render() {
      var tooltip = _react2.default.createElement(
        _reactBootstrap.Tooltip,
        { id: this.props.id },
        'This outlet cannot be extended',
        _react2.default.createElement('br', null),
        'unless the other outlets are',
        _react2.default.createElement('br', null),
        'expired or all outlets have the',
        _react2.default.createElement('br', null),
        'same billing date.'
      );
      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: tooltip },
        _react2.default.createElement('input', { type: 'image', src: _notAvailableButton2.default, className: _style2.default['not-available-button'],
          onClick: function onClick(e) {
            e.preventDefault();
          } })
      );
    }
  }]);
  return InformationWithTooltip;
}(_react.Component); /**
                      * Created by alvinoktavianus on 6/7/17.
                      */

var BillingEachOutlet = function BillingEachOutlet(props) {
  var outlets = props.outlets,
      featurePrice = props.featurePrice,
      featureStatus = props.featureStatus,
      mokaPrice = props.mokaPrice,
      currentRules = props.currentRules,
      dispatch = props.dispatch,
      isDeleted = props.isDeleted;


  var calculatePrice = function calculatePrice(price, discount) {
    return price - discount / 100 * price;
  };

  return _react2.default.createElement(
    'div',
    null,
    _lodash2.default.map(outlets, function (outlet) {
      return _react2.default.createElement(
        'div',
        { key: outlet.id },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-1 col-xs-1 col-sm-1 col-lg-1' },
            !outlet.is_available && _react2.default.createElement(InformationWithTooltip, null),
            outlet.is_available && !isDeleted[outlet.id] && _react2.default.createElement('input', { type: 'image', src: _turn_on2.default,
              className: _style2.default['turn-on-off'],
              onClick: function onClick(event) {
                event.preventDefault();
                dispatch((0, _billing.onClickTurnButton)(outlet.id, isDeleted));
              } }),
            outlet.is_available && isDeleted[outlet.id] && _react2.default.createElement('input', { type: 'image', src: _turn_off2.default,
              className: _style2.default['turn-on-off'],
              onClick: function onClick(event) {
                event.preventDefault();
                dispatch((0, _billing.onClickTurnButton)(outlet.id, isDeleted));
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-4 col-xs-10 col-sm-5 col-lg-5' },
            _react2.default.createElement(
              'p',
              { className: (currentRules.discount > 0 ? _style2.default['outlet-name-elipsis'] : _style2.default['outlet-name-mobi']) + ' ' + (isDeleted[outlet.id] ? _style2.default['inactive'] : '') },
              _react2.default.createElement(
                'strong',
                null,
                outlet.name
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-3 col-xs-6 col-sm-3 col-lg-3' },
            currentRules.discount > 0 && _react2.default.createElement(
              'p',
              { className: 'text-red text-left ' + (isDeleted[outlet.id] ? _style2.default['inactive-red'] : '') },
              _react2.default.createElement(
                'del',
                null,
                (0, _formatter.currencyFormatter)(mokaPrice)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-4 col-xs-6 col-sm-3 col-lg-3 ' + (currentRules.discount > 0 ? '' : _style2.default['price-mobi']) },
            _react2.default.createElement(
              'p',
              { className: 'pull-right ' + (isDeleted[outlet.id] ? _style2.default['inactive'] : '') },
              (0, _formatter.currencyFormatter)(calculatePrice(mokaPrice, currentRules.discount)),
              '/mo'
            )
          )
        ),
        _lodash2.default.map(featureStatus, function (feature) {
          if (feature.isFeatureNeedToBePaid) {
            return _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('div', { className: 'col-md-1 col-xs-1 col-sm-1 col-lg-1' }),
              _react2.default.createElement(
                'div',
                { className: 'col-md-4 col-xs-10 col-sm-5 col-lg-5' },
                _react2.default.createElement(
                  'p',
                  { className: (isDeleted[outlet.id] ? _style2.default['inactive'] : '') + ' ' + _style2.default['mb-0px'] },
                  _react2.default.createElement(
                    'p',
                    { className: currentRules.discount > 0 ? _style2.default['feature-name'] : _style2.default['feature-name-elipsis'] },
                    feature.name
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 col-xs-6 col-sm-3 col-lg-3' },
                currentRules.discount > 0 && _react2.default.createElement(
                  'p',
                  { className: 'text-red text-left ' + (isDeleted[outlet.id] ? _style2.default['inactive-red'] : '') },
                  _react2.default.createElement(
                    'del',
                    null,
                    feature.name === 'Loyalty' ? 'Rp. 250.000' : (0, _formatter.currencyFormatter)(featurePrice[feature.name])
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-4 col-xs-6 col-sm-3 col-lg-3 ' + (currentRules.discount > 0 ? '' : _style2.default['price-mobi']) },
                _react2.default.createElement(
                  'p',
                  { className: 'pull-right ' + (isDeleted[outlet.id] ? _style2.default['inactive'] : '') },
                  (0, _formatter.currencyFormatter)(calculatePrice(featurePrice[feature.name], currentRules.discount)),
                  '/mo'
                )
              )
            );
          }
        })
      );
    })
  );
};

var BillingReceiptForm = function (_Component2) {
  (0, _inherits3.default)(BillingReceiptForm, _Component2);

  function BillingReceiptForm() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, BillingReceiptForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = BillingReceiptForm.__proto__ || (0, _getPrototypeOf2.default)(BillingReceiptForm)).call.apply(_ref, [this].concat(args))), _this2), _this2._onChangeSubscriptionRules = function (event, subscriptionRules) {
      var rules = _lodash2.default.mapKeys(_this2.props.rules.subscription_plans, 'name');
      _this2.props.dispatch((0, _billing.onChangeSubscriptionRules)(rules[subscriptionRules]));
    }, _this2._calculateTotalOutlet = function () {
      var _this2$props = _this2.props,
          outlets = _this2$props.outlets,
          isDeleted = _this2$props.isDeleted;

      var totalOutlets = 0;
      _lodash2.default.map(outlets, function (outlet) {
        if (!isDeleted[outlet.id]) totalOutlets++;
      });
      return totalOutlets;
    }, _this2._calculateTotalPrice = function () {
      var _this2$props2 = _this2.props,
          currentSubscriptionRules = _this2$props2.currentSubscriptionRules,
          rules = _this2$props2.rules,
          featureSubscriptionStatus = _this2$props2.featureSubscriptionStatus,
          featureSubscriptionPrice = _this2$props2.featureSubscriptionPrice,
          outlets = _this2$props2.outlets,
          isDeleted = _this2$props2.isDeleted;

      if (!currentSubscriptionRules || !rules) {
        return 0;
      }
      var totalPrice = void 0;
      var activeOutletCount = 0;
      var mokaPrice = rules.moka_price - currentSubscriptionRules.discount / 100 * rules.moka_price;
      var featurePrice = 0;
      _lodash2.default.map(outlets, function (outlet) {
        if (!isDeleted[outlet.id]) activeOutletCount++;
      });
      _lodash2.default.forEach(featureSubscriptionStatus, function (feature) {
        if (feature.isFeatureNeedToBePaid) {
          featurePrice += featureSubscriptionPrice[feature.name] - currentSubscriptionRules.discount / 100 * featureSubscriptionPrice[feature.name];
        }
      });
      totalPrice = (mokaPrice + featurePrice) * activeOutletCount;
      totalPrice = isNaN(totalPrice) ? 0 : totalPrice;
      var monthRules = 0;
      if (currentSubscriptionRules.month) {
        monthRules = currentSubscriptionRules.month;
      }
      _this2.props.dispatch((0, _billing.setTotalBillingPrice)(totalPrice * monthRules));
      return totalPrice * currentSubscriptionRules.month;
    }, _this2._endOfNextPlan = function () {
      var _this2$props3 = _this2.props,
          outlets = _this2$props3.outlets,
          currentSubscriptionRules = _this2$props3.currentSubscriptionRules,
          expired = _this2$props3.expired,
          rules = _this2$props3.rules;

      if (expired) {
        var subscriptionPlans = rules.subscription_plans;
        var monthRules = currentSubscriptionRules.month;
        if (subscriptionPlans) {
          return subscriptionPlans.length === 1 ? (0, _moment2.default)().format('D MMMM YYYY') : (0, _moment2.default)().add(monthRules, 'month').format('D MMMM YYYY');
        } else {
          return (0, _moment2.default)().format('D MMMM YYYY');
        }
      } else {
        var dateCollection = [];
        _lodash2.default.forEach(outlets, function (outlet) {
          dateCollection.push(new Date((0, _moment2.default)(outlet.end_date).format('YYYY'), (0, _moment2.default)(outlet.end_date).format('MM') - 1, (0, _moment2.default)(outlet.end_date).format('DD')));
        });
        var maxDate = (0, _moment2.default)(new Date(Math.max.apply(null, dateCollection))).format('DD/MM/YYYY');
        var minDate = (0, _moment2.default)(new Date(Math.min.apply(null, dateCollection))).format('DD/MM/YYYY');
        return maxDate !== minDate ? (0, _moment2.default)(new Date(Math.max.apply(null, dateCollection))).format('D MMMM YYYY') : (0, _moment2.default)(new Date(Math.max.apply(null, dateCollection))).add(currentSubscriptionRules.month, 'month').format('D MMMM YYYY');
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(BillingReceiptForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rules = _props.rules,
          currentSubscriptionRules = _props.currentSubscriptionRules,
          handleSubmit = _props.handleSubmit,
          payButtonClicked = _props.payButtonClicked,
          buttonMessage = _props.buttonMessage,
          pendingPaymentMessage = _props.pendingPaymentMessage,
          unusedOutletMessage = _props.unusedOutletMessage,
          featureSubscriptionStatus = _props.featureSubscriptionStatus,
          featureSubscriptionPrice = _props.featureSubscriptionPrice,
          outlets = _props.outlets,
          dispatch = _props.dispatch,
          isDeleted = _props.isDeleted;

      var subscriptionRules = _lodash2.default.mapKeys(rules.subscription_plans, 'name');
      return _react2.default.createElement(
        'div',
        { className: _style2.default['billing-receipt-form-wrapper'] },
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit },
          _react2.default.createElement('div', { className: _style2.default['billing-receipt-slot'] }),
          _react2.default.createElement(
            'div',
            { className: _style2.default['billing-receipt-paper'] },
            _react2.default.createElement(
              'div',
              { className: _style2.default['billing-receipt-paper-box'] },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-3 col-sm-6' },
                  _react2.default.createElement(
                    'span',
                    { className: _style2.default['text-vertically-aligned'] },
                    'Billing Cycle'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-4 col-sm-6' },
                  _react2.default.createElement(_reduxForm.Field, {
                    name: 'subscriptionRules',
                    component: _DropdownSelect2.default,
                    options: subscriptionRules,
                    defaultOptionKey: { name: 'Moka 12 Months' },
                    className: 'dropdown-select-subscription-rules',
                    id: 'changeSubscriptionRules',
                    onChange: this._onChangeSubscriptionRules
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default['billing-receipt-paper-box'] },
              _react2.default.createElement(
                'h4',
                { className: _style2.default['mb-20px'] },
                'OUTLETS : ',
                this._calculateTotalOutlet()
              ),
              _react2.default.createElement(BillingEachOutlet, {
                outlets: outlets,
                featureStatus: featureSubscriptionStatus,
                featurePrice: featureSubscriptionPrice,
                mokaPrice: rules.moka_price,
                currentRules: currentSubscriptionRules,
                dispatch: dispatch,
                isDeleted: isDeleted
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default['billing-receipt-paper-box'] },
              this._calculateTotalOutlet() > 0 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'text-primary row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-md-7 col-xs-6' },
                    _react2.default.createElement(
                      'h4',
                      null,
                      currentSubscriptionRules.month,
                      ' Month',
                      currentSubscriptionRules.month > 1 && 's',
                      ' Total'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-md-5 col-xs-6' },
                    _react2.default.createElement(
                      'h4',
                      { className: 'pull-right' },
                      (0, _formatter.currencyFormatter)(this._calculateTotalPrice())
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row ' + _style2.default['mb-30px'] },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-md-7 col-xs-6' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['text-xs'] },
                      _react2.default.createElement(
                        'em',
                        null,
                        'Your expiration date will be extended to'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['text-xs'] },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(
                          'em',
                          null,
                          this._endOfNextPlan()
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-md-5 col-xs-6' },
                    currentSubscriptionRules.discount > 0 && _react2.default.createElement(
                      'div',
                      { className: 'pull-right ' + _style2.default['text-green'] },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(
                          'em',
                          null,
                          'Save ',
                          currentSubscriptionRules.discount,
                          '%'
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-12 ' + (this._calculateTotalOutlet() !== 0 ? _style2.default['btn-pay'] : '') },
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'btn btn-lg btn-block ' + (this._calculateTotalOutlet() === 0 || payButtonClicked ? 'btn-disabled' : 'btn-primary'),
                      type: 'submit',
                      id: 'pay-button',
                      disabled: this._calculateTotalOutlet() === 0 || payButtonClicked },
                    buttonMessage
                  )
                )
              ),
              pendingPaymentMessage !== null && _react2.default.createElement(
                'div',
                { className: 'row ' + _style2.default['mt-10px'] + ' ' + _style2.default['text-xs'] + ' text-red' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-12' },
                  _react2.default.createElement(
                    'em',
                    null,
                    pendingPaymentMessage
                  )
                )
              ),
              unusedOutletMessage !== null && _react2.default.createElement(
                'div',
                { className: 'row ' + _style2.default['mt-10px'] + ' ' + _style2.default['text-xs'] + ' text-red' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-12' },
                  _react2.default.createElement(
                    'em',
                    null,
                    unusedOutletMessage
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return BillingReceiptForm;
}(_react.Component);

var mapForm = {
  form: 'BillingReceipt'
};

function mapStateToProps(state) {
  var _state$setting$billin = state.setting.billing,
      outlets = _state$setting$billin.outlets,
      rules = _state$setting$billin.rules,
      currentSubscriptionRules = _state$setting$billin.currentSubscriptionRules,
      pendingPaymentMessage = _state$setting$billin.pendingPaymentMessage,
      unusedOutletMessage = _state$setting$billin.unusedOutletMessage,
      featureSubscriptionStatus = _state$setting$billin.featureSubscriptionStatus,
      featureSubscriptionPrice = _state$setting$billin.featureSubscriptionPrice,
      isDeleted = _state$setting$billin.isDeleted;
  var expired = state.subscriptionExpired.expired;

  return {
    outlets: outlets,
    rules: rules,
    currentSubscriptionRules: currentSubscriptionRules,
    pendingPaymentMessage: pendingPaymentMessage,
    unusedOutletMessage: unusedOutletMessage,
    featureSubscriptionStatus: featureSubscriptionStatus,
    featureSubscriptionPrice: featureSubscriptionPrice,
    expired: expired,
    isDeleted: isDeleted
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(BillingReceiptForm));

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/24/17.
 */

var DropdownSelect = function (_React$Component) {
  (0, _inherits3.default)(DropdownSelect, _React$Component);

  function DropdownSelect() {
    (0, _classCallCheck3.default)(this, DropdownSelect);
    return (0, _possibleConstructorReturn3.default)(this, (DropdownSelect.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(DropdownSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          options = _props.options,
          id = _props.id,
          dir = _props.dir;

      return _react2.default.createElement(
        'label',
        { className: 'mk-select-label' },
        _react2.default.createElement(
          'select',
          (0, _extends3.default)({}, input, { className: 'mk-select', id: id, dir: dir }),
          DropdownSelect.renderSubscriptionPlansOption(options)
        )
      );
    }
  }], [{
    key: 'renderSubscriptionPlansOption',
    value: function renderSubscriptionPlansOption(options) {
      return _lodash2.default.map(options, function (rules, key) {
        return _react2.default.createElement(
          'option',
          { key: key, value: rules.name },
          rules.name
        );
      });
    }
  }]);
  return DropdownSelect;
}(_react2.default.Component);

DropdownSelect.propTypes = {};

exports.default = DropdownSelect;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Header = __webpack_require__(248);

var _Header2 = _interopRequireDefault(_Header);

var _CurrentPlan = __webpack_require__(2042);

var _CurrentPlan2 = _interopRequireDefault(_CurrentPlan);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 5/18/17.
 */

var CurrentPlan = function (_Component) {
  (0, _inherits3.default)(CurrentPlan, _Component);

  function CurrentPlan() {
    (0, _classCallCheck3.default)(this, CurrentPlan);
    return (0, _possibleConstructorReturn3.default)(this, (CurrentPlan.__proto__ || (0, _getPrototypeOf2.default)(CurrentPlan)).apply(this, arguments));
  }

  (0, _createClass3.default)(CurrentPlan, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentSubscriptionPlanName = _props.currentSubscriptionPlanName,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      var lastPaymentDate = this.props.last_payment_date;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, { title: 'current plan' }),
        _react2.default.createElement(
          'div',
          { className: _CurrentPlan2.default['loading-plan'] },
          _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerPage })
        ),
        !showLoadingSpinnerPage && _react2.default.createElement(
          'div',
          { className: _CurrentPlan2.default['mb-30px'] },
          _react2.default.createElement(
            'div',
            { className: _CurrentPlan2.default['mb-10px'] },
            'Your current subscription plan: ',
            _react2.default.createElement(
              'strong',
              { className: currentSubscriptionPlanName === 'Expired' ? _CurrentPlan2.default['is-expired'] : '' },
              currentSubscriptionPlanName
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            'Last Payment: ',
            _react2.default.createElement(
              'strong',
              null,
              lastPaymentDate ? (0, _moment2.default)(lastPaymentDate).format('DD MMMM YYYY') : 'N/A'
            )
          )
        )
      );
    }
  }]);
  return CurrentPlan;
}(_react.Component);

function mapStateToProps(state) {
  var currentSubscriptionPlanName = state.setting.billing.currentSubscriptionPlanName;
  var last_payment_date = state.moka.user.business.last_payment_date;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return { last_payment_date: last_payment_date, currentSubscriptionPlanName: currentSubscriptionPlanName, showLoadingSpinnerPage: showLoadingSpinnerPage };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CurrentPlan);

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Header = __webpack_require__(248);

var _Header2 = _interopRequireDefault(_Header);

var _FeatureSubscriptions = __webpack_require__(2043);

var _FeatureSubscriptions2 = _interopRequireDefault(_FeatureSubscriptions);

var _billing = __webpack_require__(202);

var _CancelFeatureSubscriptionModal = __webpack_require__(1125);

var _CancelFeatureSubscriptionModal2 = _interopRequireDefault(_CancelFeatureSubscriptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureSubscriptions = function (_Component) {
  (0, _inherits3.default)(FeatureSubscriptions, _Component);

  function FeatureSubscriptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeatureSubscriptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeatureSubscriptions.__proto__ || (0, _getPrototypeOf2.default)(FeatureSubscriptions)).call.apply(_ref, [this].concat(args))), _this), _this._showModal = function (feature) {
      var featureSubscription = {
        name: feature.name,
        expirationDate: (0, _moment2.default)(feature.expiration_date).format('DD MMM YYYY')
      };
      _this.props.dispatch((0, _billing.onClickCancelSubscriptionModal)(featureSubscription));
    }, _this._hideModal = function () {
      _this.props.dispatch((0, _billing.hideCancelSubscriptionModal)());
    }, _this._cancelSubscription = function (featureName) {
      var _this$props = _this.props,
          featureSubscriptionStatus = _this$props.featureSubscriptionStatus,
          outletMinMaxDate = _this$props.outletMinMaxDate;

      var feature = {
        feature_name: featureName
      };
      _this.props.dispatch((0, _billing.cancelFeatureSubscription)(feature, featureSubscriptionStatus, outletMinMaxDate));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeatureSubscriptions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          countFeatureSubscription = _props.countFeatureSubscription,
          featureSubscriptionStatus = _props.featureSubscriptionStatus,
          showCancelFeatureSubscriptionModal = _props.showCancelFeatureSubscriptionModal,
          cancelFeatureSubscriptionModalData = _props.cancelFeatureSubscriptionModalData,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      return !showLoadingSpinnerPage && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, { title: 'feature subscriptions' }),
        countFeatureSubscription > 0 && featureSubscriptionStatus.map(function (feature) {
          if (feature.is_active) {
            return _react2.default.createElement(
              'div',
              { className: _FeatureSubscriptions2.default['mb-20px'], key: feature.id },
              _react2.default.createElement(
                'div',
                { className: 'row ' + _FeatureSubscriptions2.default['feature-row'] },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6' },
                  feature.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6' },
                  feature.is_subscribing && feature.name !== 'Loyalty' && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      { className: 'text-right ' + _FeatureSubscriptions2.default['btn-link-cancel'] },
                      _react2.default.createElement(
                        'button',
                        { className: 'btn btn-link', onClick: function onClick() {
                            _this2._showModal(feature);
                          } },
                        'Cancel Subscription'
                      )
                    )
                  ),
                  !feature.is_subscribing && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      { className: 'text-right ' + _FeatureSubscriptions2.default['btn-link-cancel'] + ' ' + _FeatureSubscriptions2.default['active-until-text'] },
                      'Active until ',
                      (0, _moment2.default)(feature.expiration_date).format('DD MMM YYYY')
                    )
                  )
                )
              )
            );
          }
        }),
        countFeatureSubscription === 0 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'i',
            null,
            'None'
          )
        ),
        _react2.default.createElement(_CancelFeatureSubscriptionModal2.default, {
          showModal: showCancelFeatureSubscriptionModal,
          featureName: cancelFeatureSubscriptionModalData.name,
          hideModal: this._hideModal,
          expirationDate: cancelFeatureSubscriptionModalData.expirationDate,
          cancelSubscription: function cancelSubscription() {
            _this2._cancelSubscription(cancelFeatureSubscriptionModalData.name);
          }
        })
      );
    }
  }]);
  return FeatureSubscriptions;
}(_react.Component); /**
                      * Created by alvinoktavianus on 5/18/17.
                      */

function mapStateToProps(state) {
  var _state$setting$billin = state.setting.billing,
      featureSubscriptionStatus = _state$setting$billin.featureSubscriptionStatus,
      countFeatureSubscription = _state$setting$billin.countFeatureSubscription,
      showCancelFeatureSubscriptionModal = _state$setting$billin.showCancelFeatureSubscriptionModal,
      cancelFeatureSubscriptionModalData = _state$setting$billin.cancelFeatureSubscriptionModalData,
      outletMinMaxDate = _state$setting$billin.outletMinMaxDate;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    featureSubscriptionStatus: featureSubscriptionStatus,
    countFeatureSubscription: countFeatureSubscription,
    showCancelFeatureSubscriptionModal: showCancelFeatureSubscriptionModal,
    cancelFeatureSubscriptionModalData: cancelFeatureSubscriptionModalData,
    outletMinMaxDate: outletMinMaxDate,
    showLoadingSpinnerPage: showLoadingSpinnerPage
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeatureSubscriptions);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CheckoutForm = __webpack_require__(1229);

var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);

var _reactRedux = __webpack_require__(6);

var _checkout = __webpack_require__(618);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkout = function (_React$Component) {
  (0, _inherits3.default)(Checkout, _React$Component);

  function Checkout() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkout.__proto__ || (0, _getPrototypeOf2.default)(Checkout)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var data = (0, _extends3.default)({}, _this.props.data.setting.checkout.setting);
      data.enable_tax = values.tax;
      data.enable_gratuity = values.gratuity;
      data.include_gratuity_tax = values.includeGratuityTax;
      data.track_server = values.trackServer;
      _this.props.dispatch((0, _checkout.updateSettingRequest)({ settings: data }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _checkout.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          // this is still hacky, don't copy paste this
          if (_this2.props.isDirtyCheckout && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(_CheckoutForm2.default, { onSubmit: this._onSubmit }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Checkout;
}(React.Component);

Checkout.propTypes = {};

function mapStateToProps(state) {
  return {
    isDirtyCheckout: (0, _reduxForm.isDirty)('checkout')(state),
    nextAction: state.confirmAction.nextAction,
    form: state.form,
    data: {
      setting: {
        checkout: state.setting.checkout
      },
      subscriptionExpired: {
        expired: state.subscriptionExpired.expired
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Checkout);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _CheckoutForm = __webpack_require__(2045);

var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);

var _SwitchField = __webpack_require__(437);

var _SwitchField2 = _interopRequireDefault(_SwitchField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutForm = function (_React$Component) {
  (0, _inherits3.default)(CheckoutForm, _React$Component);

  function CheckoutForm() {
    (0, _classCallCheck3.default)(this, CheckoutForm);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutForm.__proto__ || (0, _getPrototypeOf2.default)(CheckoutForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutForm, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'form',
        { onSubmit: this.props.handleSubmit },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-6 col-md-6 col-sm-12' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  { className: _CheckoutForm2.default.header },
                  'Tax and Gratuity SETTINGS'
                )
              )
            ),
            React.createElement(
              'div',
              { className: _CheckoutForm2.default['form-group'] + ' row' },
              React.createElement(
                'div',
                { className: 'col-lg-9 col-md-9 col-sm-6' },
                'Enable Tax'
              ),
              React.createElement(
                'div',
                { className: 'col-lg-3 col-md-3 col-sm-6' },
                React.createElement(
                  'span',
                  { className: _CheckoutForm2.default['switchbox'] },
                  React.createElement(_reduxForm.Field, {
                    component: _SwitchField2.default,
                    name: 'tax',
                    type: 'checkbox'
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: _CheckoutForm2.default['form-group'] + ' row' },
              React.createElement(
                'div',
                { className: 'col-lg-9 col-md-9 col-sm-6' },
                'Enable Gratuity'
              ),
              React.createElement(
                'div',
                { className: 'col-lg-3 col-md-3 col-sm-6' },
                React.createElement(
                  'span',
                  { className: _CheckoutForm2.default['switchbox'] },
                  React.createElement(_reduxForm.Field, {
                    component: _SwitchField2.default,
                    name: 'gratuity',
                    type: 'checkbox'
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: _CheckoutForm2.default['form-group'] + ' row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  { className: 'col-sm-12 no-padding' },
                  React.createElement(
                    _reduxForm.Field,
                    { component: 'select', name: 'includeGratuityTax', className: 'form-control' },
                    React.createElement(
                      'option',
                      { value: 'false' },
                      'Add Tax and Gratuity to Item Price'
                    ),
                    React.createElement(
                      'option',
                      { value: 'true' },
                      'Include Tax and Gratuity to Item Price'
                    )
                  )
                )
              )
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  { className: _CheckoutForm2.default.header },
                  'Other Settings'
                )
              )
            ),
            React.createElement(
              'div',
              { className: _CheckoutForm2.default['form-group'] + ' row' },
              React.createElement(
                'div',
                { className: 'col-lg-9 col-md-9 col-sm-6' },
                'Track Server'
              ),
              React.createElement(
                'div',
                { className: 'col-lg-3 col-md-3 col-sm-6' },
                React.createElement(
                  'span',
                  { className: _CheckoutForm2.default['switchbox'] },
                  React.createElement(_reduxForm.Field, {
                    component: _SwitchField2.default,
                    name: 'trackServer',
                    type: 'checkbox'
                  })
                )
              )
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: _CheckoutForm2.default['form-group'] + ' row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  React.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary' },
                    'Save'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CheckoutForm;
}(React.Component);

CheckoutForm.FORM_NAME = 'checkout';


CheckoutForm.propTypes = {
  // onSubmit(values)
  onSubmit: React.PropTypes.func
};

var mapForm = {
  form: CheckoutForm.FORM_NAME
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)(CheckoutForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _EmailNotificationForm = __webpack_require__(1240);

var _EmailNotificationForm2 = _interopRequireDefault(_EmailNotificationForm);

var _EmailNotification = __webpack_require__(2046);

var _EmailNotification2 = _interopRequireDefault(_EmailNotification);

var _reactRedux = __webpack_require__(6);

var _emailNotification = __webpack_require__(203);

var actEmailNotification = _interopRequireWildcard(_emailNotification);

var _Header = __webpack_require__(669);

var _Header2 = _interopRequireDefault(_Header);

var _confirmAction = __webpack_require__(29);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _pages = __webpack_require__(38);

var _DeleteRecipientModal = __webpack_require__(1232);

var _DeleteRecipientModal2 = _interopRequireDefault(_DeleteRecipientModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailNotification = function (_React$Component) {
  (0, _inherits3.default)(EmailNotification, _React$Component);

  function EmailNotification() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EmailNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailNotification.__proto__ || (0, _getPrototypeOf2.default)(EmailNotification)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var setting = _this.props.data.setting.emailNotification.profile.business.setting;

      setting.daily_sales_summary = values.dailySalesSummary;
      setting.inventory_alerts = values.inventoryAlerts;
      setting.product_updates = values.productUpdates;
      setting.setting_alert_recipients = values.settingAlertRecipients;
      _this.props.dispatch(actEmailNotification.submitForm({ settings: (0, _extends3.default)({}, setting) }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EmailNotification, [{
    key: 'render',
    value: function render() {
      var _props$data$setting$e = this.props.data.setting.emailNotification,
          showDeleteRecipientModal = _props$data$setting$e.showDeleteRecipientModal,
          deletedRecipient = _props$data$setting$e.deletedRecipient;
      var emailNotificationForm = this.props.emailNotificationForm;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-xs-12 col-md-6' },
            React.createElement(_Header2.default, { title: 'manage email notification' }),
            React.createElement(
              'p',
              { className: _EmailNotification2.default.description },
              'Receive emails on new products or how your business is performing. Emails are automatically sent to your account email.'
            ),
            React.createElement(_EmailNotificationForm2.default, { onSubmit: this._onSubmit })
          )
        ),
        React.createElement(_DeleteRecipientModal2.default, {
          showDeleteRecipientModal: showDeleteRecipientModal,
          deletedRecipient: deletedRecipient,
          dispatch: this.props.dispatch,
          emailNotificationForm: emailNotificationForm
        }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (!_this2.props.data.isDirtyForm) {
            _this2.props.dispatch(actEmailNotification.changePage(location.pathname));
          } else {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)(actEmailNotification.changePage(location.pathname)));
          }
          return false;
        });
        this.props.dispatch(actEmailNotification.pageRequest());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return EmailNotification;
}(React.Component);

function mapStateToProps(state) {
  return {
    emailNotificationForm: (0, _reduxForm.getFormValues)('emailNotification')(state),
    data: {
      isDirtyForm: (0, _reduxForm.isDirty)('emailNotification')(state),
      setting: {
        emailNotification: state.setting.emailNotification
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EmailNotification);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _DeleteRecipientModal = __webpack_require__(2047);

var _DeleteRecipientModal2 = _interopRequireDefault(_DeleteRecipientModal);

var _emailNotification = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteRecipientModal = function (_React$Component) {
  (0, _inherits3.default)(DeleteRecipientModal, _React$Component);

  function DeleteRecipientModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DeleteRecipientModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeleteRecipientModal.__proto__ || (0, _getPrototypeOf2.default)(DeleteRecipientModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      _this.props.dispatch((0, _emailNotification.cancelDeleteRecipient)());
    }, _this._onDelete = function () {
      var _this$props = _this.props,
          deletedRecipient = _this$props.deletedRecipient,
          emailNotificationForm = _this$props.emailNotificationForm;

      _this.props.dispatch((0, _emailNotification.onDeleteRecipient)(deletedRecipient, emailNotificationForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DeleteRecipientModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteRecipientModal = _props.showDeleteRecipientModal,
          deletedRecipient = _props.deletedRecipient;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showDeleteRecipientModal, onHide: this._onHide, bsClass: 'margin-top-modal modal' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _DeleteRecipientModal2.default.header },
          React.createElement(
            'button',
            { onClick: this._onCancel,
              type: 'button',
              className: 'close',
              'data-dismiss': 'modal',
              'aria-label': 'Close' },
            React.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          React.createElement(
            'h4',
            null,
            'Delete Recipient'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          deletedRecipient && 'Are you sure want to remove email ' + deletedRecipient.email + '?'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { onClick: this._onCancel, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { onClick: this._onDelete, className: 'btn btn-danger' },
            'Delete'
          )
        )
      );
    }
  }]);
  return DeleteRecipientModal;
}(React.Component);

DeleteRecipientModal.propTypes = {
  showDeleteRecipientModal: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  deletedRecipient: React.PropTypes.object
};

exports.default = DeleteRecipientModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DeleteRecipientModal = __webpack_require__(1231);

var _DeleteRecipientModal2 = _interopRequireDefault(_DeleteRecipientModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DeleteRecipientModal2.default;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _DescriptiveSwitchField = __webpack_require__(636);

var _DescriptiveSwitchField2 = _interopRequireDefault(_DescriptiveSwitchField);

var _ReceipientModal = __webpack_require__(1239);

var _ReceipientModal2 = _interopRequireDefault(_ReceipientModal);

var _emailNotification = __webpack_require__(203);

var actEmailNotif = _interopRequireWildcard(_emailNotification);

var _reactRedux = __webpack_require__(6);

var _EmailNotificationForm = __webpack_require__(2048);

var _EmailNotificationForm2 = _interopRequireDefault(_EmailNotificationForm);

var _ManageRecipientAlertEmail = __webpack_require__(1237);

var _ManageRecipientAlertEmail2 = _interopRequireDefault(_ManageRecipientAlertEmail);

var _ListRecipient = __webpack_require__(1235);

var _ListRecipient2 = _interopRequireDefault(_ListRecipient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var settingAlertRecipientsErrors = [];
  if (values.settingAlertRecipients) {
    values.settingAlertRecipients.forEach(function (member, index) {
      var memberErrors = {};
      // test non-empty string and invalid regex format
      if (member.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(member.email.trim())) {
        memberErrors.email = 'Please enter a valid email address';
        settingAlertRecipientsErrors[index] = memberErrors;
      }
    });
  }
  if (settingAlertRecipientsErrors.length) {
    errors.settingAlertRecipients = settingAlertRecipientsErrors;
  }
  return errors;
};

var EmailNotificationForm = function (_React$Component) {
  (0, _inherits3.default)(EmailNotificationForm, _React$Component);

  function EmailNotificationForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EmailNotificationForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailNotificationForm.__proto__ || (0, _getPrototypeOf2.default)(EmailNotificationForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickManageRecipients = function () {
      var emailNotificationForm = _this.props.emailNotificationForm;

      _this.props.dispatch(actEmailNotif.onClickManageRecipients(emailNotificationForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EmailNotificationForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          emailNotificationForm = _props.emailNotificationForm;


      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(_DescriptiveSwitchField2.default, {
          label: 'daily sales summary',
          sublabel: 'Receive emails about your sales',
          name: 'dailySalesSummary'
        }),
        React.createElement(
          'div',
          { className: 'hidden' },
          React.createElement(_DescriptiveSwitchField2.default, {
            label: 'Product Update',
            sublabel: 'Stay up to date with new products and features',
            name: 'productUpdates'
          })
        ),
        React.createElement(_DescriptiveSwitchField2.default, {
          label: 'Inventory Alerts',
          sublabel: 'Receive daily email of items that are low or out of stock',
          name: 'inventoryAlerts'
        }),
        React.createElement(_ManageRecipientAlertEmail2.default, null),
        React.createElement(
          'button',
          { type: 'button',
            className: 'btn btn-primary ' + _EmailNotificationForm2.default['btn-manage-recipients'],
            onClick: this._onClickManageRecipients },
          'Add Email Recipient'
        ),
        emailNotificationForm && emailNotificationForm.settingAlertRecipients && React.createElement(_ListRecipient2.default, {
          settingAlertRecipients: emailNotificationForm.settingAlertRecipients
        }),
        React.createElement('br', null),
        React.createElement(
          'div',
          { className: 'pull-right' },
          React.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary' },
            'Save'
          )
        ),
        React.createElement(_ReceipientModal2.default, { handleSubmit: handleSubmit })
      );
    }
  }]);
  return EmailNotificationForm;
}(React.Component);

var mapForm = {
  form: 'emailNotification',
  validate: validate,
  touchOnBlur: false,
  touchOnChange: false
};

function mapStateToProps(state) {
  return {
    emailNotificationForm: (0, _reduxForm.getFormValues)('emailNotification')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(EmailNotificationForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ListRecipient = __webpack_require__(2049);

var _ListRecipient2 = _interopRequireDefault(_ListRecipient);

var _emailNotification = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListRecipient = function (_React$Component) {
  (0, _inherits3.default)(ListRecipient, _React$Component);

  function ListRecipient() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListRecipient);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListRecipient.__proto__ || (0, _getPrototypeOf2.default)(ListRecipient)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDelete = function (event, deletedRecipient) {
      event.stopPropagation();
      event.preventDefault();
      _this.props.dispatch((0, _emailNotification.onClickDelete)(deletedRecipient));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListRecipient, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var settingAlertRecipients = this.props.settingAlertRecipients;

      return React.createElement(
        'div',
        null,
        settingAlertRecipients.map(function (recipient, idx) {
          if (!recipient.is_added) {
            return React.createElement('div', null);
          }
          return React.createElement(
            'div',
            { className: idx !== 0 ? 'row ' + _ListRecipient2.default['box-recipient'] : 'row ' + _ListRecipient2.default['box-recipient-disabled'] },
            React.createElement(
              'div',
              { className: idx === 0 ? 'col-xs-6' : 'col-xs-6 ' + _ListRecipient2.default['list-email'] },
              recipient.email
            ),
            React.createElement(
              'div',
              { className: idx === 0 ? 'col-xs-4' : 'col-xs-4 ' + _ListRecipient2.default['list-status'] },
              recipient.verified ? React.createElement(
                'div',
                { className: _ListRecipient2.default['status-verified'] },
                React.createElement('i', { className: 'fa fa-check-circle fa-lg fa-fw ' + _ListRecipient2.default['icon-verified'] }),
                'Verified'
              ) : recipient.id && React.createElement(
                'div',
                { className: _ListRecipient2.default['status-waiting'] },
                'Waiting for Verification'
              )
            ),
            idx > 0 && React.createElement(
              'div',
              { className: 'col-xs-2 ' + _ListRecipient2.default['btn-delete'] },
              React.createElement(
                'button',
                { className: 'btn btn-danger', onClick: function onClick(event) {
                    return _this2._onClickDelete(event, recipient);
                  } },
                React.createElement('i', { className: 'fa fa-trash' })
              )
            )
          );
        })
      );
    }
  }]);
  return ListRecipient;
}(React.Component);

ListRecipient.propTypes = {
  settingAlertRecipients: React.PropTypes.object
};

function mapStateToProps(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ListRecipient);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListRecipient = __webpack_require__(1234);

var _ListRecipient2 = _interopRequireDefault(_ListRecipient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ListRecipient2.default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Header = __webpack_require__(669);

var _Header2 = _interopRequireDefault(_Header);

var _style = __webpack_require__(2050);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageRecipientAlertEmail = function (_React$Component) {
  (0, _inherits3.default)(ManageRecipientAlertEmail, _React$Component);

  function ManageRecipientAlertEmail() {
    (0, _classCallCheck3.default)(this, ManageRecipientAlertEmail);
    return (0, _possibleConstructorReturn3.default)(this, (ManageRecipientAlertEmail.__proto__ || (0, _getPrototypeOf2.default)(ManageRecipientAlertEmail)).apply(this, arguments));
  }

  (0, _createClass3.default)(ManageRecipientAlertEmail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(_Header2.default, { title: 'manage recipient alert email' }),
        React.createElement(
          'p',
          { className: _style2.default.description },
          'Email notification will only be sent to recipient that already ',
          React.createElement(
            'b',
            null,
            'verified'
          ),
          ' their email. Please check your email inbox or SPAM folder and make sure to mark us as not spam sender to receive our email notifications.'
        )
      );
    }
  }]);
  return ManageRecipientAlertEmail;
}(React.Component);

exports.default = ManageRecipientAlertEmail;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ManageRecipientAlertEmail = __webpack_require__(1236);

var _ManageRecipientAlertEmail2 = _interopRequireDefault(_ManageRecipientAlertEmail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ManageRecipientAlertEmail2.default;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _emailNotification = __webpack_require__(203);

var actEmailNotif = _interopRequireWildcard(_emailNotification);

var _reduxForm = __webpack_require__(7);

var _RecipientModal = __webpack_require__(2051);

var _RecipientModal2 = _interopRequireDefault(_RecipientModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderFieldArray = function renderFieldArray(_ref) {
  var fields = _ref.fields,
      showSettingAlertRecipientsErrors = _ref.showSettingAlertRecipientsErrors,
      settingAlertRecipients = _ref.settingAlertRecipients;

  return React.createElement(
    'ul',
    null,
    React.createElement(
      'button',
      { className: 'btn btn-primary btn-block ' + _RecipientModal2.default['btn-add-email'],
        onClick: function onClick() {
          return fields.push({ email: '' });
        },
        type: 'button' },
      'Add'
    ),
    fields.map(function (member, index) {
      return React.createElement(
        'li',
        { key: index, style: { 'position': 'relative' } },
        settingAlertRecipients && index >= settingAlertRecipients.length && React.createElement(_reduxForm.Field, {
          name: member + '.email',
          component: renderField,
          disabled: index === 0,
          showSettingAlertRecipientsErrors: showSettingAlertRecipientsErrors
        }),
        index > settingAlertRecipients.length && React.createElement(
          'span',
          { className: _RecipientModal2.default['btn-remove-email'], onClick: function onClick() {
              return fields.remove(index);
            }, type: 'button' },
          React.createElement('i', { className: 'fa fa-times-circle' })
        )
      );
    })
  );
};

var renderField = function renderField(_ref2) {
  var input = _ref2.input,
      _ref2$meta = _ref2.meta,
      touched = _ref2$meta.touched,
      error = _ref2$meta.error,
      disabled = _ref2.disabled,
      showSettingAlertRecipientsErrors = _ref2.showSettingAlertRecipientsErrors;

  var errorClass = '';
  if (showSettingAlertRecipientsErrors && !disabled) {
    if (error) {
      errorClass = 'has-feedback has-error';
    } else {
      errorClass = 'has-feedback has-success';
    }
  }
  return React.createElement(
    'div',
    { className: 'form-group ' + _RecipientModal2.default['form-group'] + ' ' + errorClass },
    React.createElement('input', (0, _extends3.default)({}, input, { type: 'text', className: 'form-control ' + _RecipientModal2.default['input-email'], disabled: disabled })),
    showSettingAlertRecipientsErrors && !disabled ? error ? React.createElement(
      _reactBootstrap.OverlayTrigger,
      { placement: 'top', overlay: React.createElement(
          _reactBootstrap.Tooltip,
          { id: 'tooltip' },
          error
        ) },
      React.createElement('span', {
        className: 'form-control-feedback glyphicon glyphicon-remove ' + _RecipientModal2.default['form-control-feedback'],
        style: { 'pointer-events': 'auto', 'cursor': 'pointer' }
      })
    ) : React.createElement('span', { className: 'form-control-feedback glyphicon glyphicon-ok ' + _RecipientModal2.default['form-control-feedback'] }) : ''
  );
};

var RecipientModal = function (_React$Component) {
  (0, _inherits3.default)(RecipientModal, _React$Component);

  function RecipientModal() {
    var _ref3;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RecipientModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = RecipientModal.__proto__ || (0, _getPrototypeOf2.default)(RecipientModal)).call.apply(_ref3, [this].concat(args))), _this), _this._onCancel = function () {
      var previousEmailNotificationForm = _this.props.data.setting.emailNotification.previousEmailNotificationForm;

      _this.props.dispatch(actEmailNotif.onCancelManageRecipients(previousEmailNotificationForm));
    }, _this._onConfirm = function (e) {
      var _this$props = _this.props,
          emailNotificationForm = _this$props.emailNotificationForm,
          emailNotificationFormErrors = _this$props.emailNotificationFormErrors,
          dispatch = _this$props.dispatch;
      var settingAlertRecipients = _this.props.data.setting.emailNotification.previousEmailNotificationForm.settingAlertRecipients;

      // we can only confirm if there is no error

      if (emailNotificationFormErrors && emailNotificationFormErrors.settingAlertRecipients && emailNotificationFormErrors.settingAlertRecipients.length) {
        // no op. force user to change email
        dispatch(actEmailNotif.showSettingAlertRecipientsErrors());
      } else {
        dispatch(actEmailNotif.onConfirmManageRecipients(emailNotificationForm, settingAlertRecipients));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RecipientModal, [{
    key: 'render',
    value: function render() {
      var _props$data$setting$e = this.props.data.setting.emailNotification,
          showRecipientModal = _props$data$setting$e.showRecipientModal,
          showSettingAlertRecipientsErrors = _props$data$setting$e.showSettingAlertRecipientsErrors,
          previousEmailNotificationForm = _props$data$setting$e.previousEmailNotificationForm;
      var settingAlertRecipients = previousEmailNotificationForm.settingAlertRecipients;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showRecipientModal, dialogClassName: _RecipientModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            null,
            'Add Email Recipients'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: 'modal-body ' + _RecipientModal2.default.body },
          React.createElement(_reduxForm.FieldArray, {
            name: 'settingAlertRecipients',
            component: renderFieldArray,
            showSettingAlertRecipientsErrors: showSettingAlertRecipientsErrors,
            settingAlertRecipients: settingAlertRecipients
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-default pull-left', onClick: this._onCancel },
              'Cancel'
            ),
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary pull-right', onClick: this._onConfirm },
              'Confirm'
            )
          )
        )
      );
    }
  }]);
  return RecipientModal;
}(React.Component);

function mapStateToProps(state) {
  return {
    emailNotificationFormErrors: (0, _reduxForm.getFormSyncErrors)('emailNotification')(state),
    emailNotificationForm: (0, _reduxForm.getFormValues)('emailNotification')(state),
    data: {
      setting: {
        emailNotification: state.setting.emailNotification
      }
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RecipientModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RecipientModal = __webpack_require__(1238);

var _RecipientModal2 = _interopRequireDefault(_RecipientModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RecipientModal2.default;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailNotificationForm = __webpack_require__(1233);

var _EmailNotificationForm2 = _interopRequireDefault(_EmailNotificationForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailNotificationForm2.default;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Header = __webpack_require__(2052);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Header2.default['wrapper'] },
        this.props.title
      );
    }
  }]);
  return Header;
}(React.Component);

Header.propTypes = {
  title: React.PropTypes.string
};

exports.default = Header;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailNotification = __webpack_require__(1230);

var _EmailNotification2 = _interopRequireDefault(_EmailNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailNotification2.default;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _PublicProfileForm = __webpack_require__(1244);

var _PublicProfileForm2 = _interopRequireDefault(_PublicProfileForm);

var _style = __webpack_require__(757);

var _style2 = _interopRequireDefault(_style);

var _publicProfile = __webpack_require__(1055);

var _reactRedux = __webpack_require__(6);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouter = __webpack_require__(15);

var _UploadValidationModal = __webpack_require__(1159);

var _UploadValidationModal2 = _interopRequireDefault(_UploadValidationModal);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicProfile = function (_React$Component) {
  (0, _inherits3.default)(PublicProfile, _React$Component);

  function PublicProfile(props) {
    (0, _classCallCheck3.default)(this, PublicProfile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublicProfile.__proto__ || (0, _getPrototypeOf2.default)(PublicProfile)).call(this, props));

    _this._handleSubmit = function () {
      var publicProfileForm = _this.props.data.form.publicProfileForm;
      var values = publicProfileForm.values;

      var user = _this.props.data.user;
      _this.props.dispatch((0, _publicProfile.publicProfileRequest)({ values: values, user: user }));
    };

    _this._hideValidationModal = function () {
      _this.setState({ showUploadValidationModal: false });
    };

    _this.state = {
      files: null,
      tempFiles: {},
      gravatar: null,
      remove_logo: false,
      showUploadValidationModal: false,
      textModal: ''
    };
    return _this;
  }

  (0, _createClass3.default)(PublicProfile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _publicProfile.publicProfilePageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.data.isDirtyForm && !_this2.props.nextAction) {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location.pathname)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var tempFileUrl = this.props.data.temp.uploadImage;
      if (!tempFileUrl.deleted) {
        this.setState({ gravatar: tempFileUrl.filename });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { id: 'public-profile' },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['mk-section-header'] },
                'Account Profile'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row last' },
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12 form-content' },
              React.createElement(_PublicProfileForm2.default, {
                onSubmit: this._handleSubmit
              })
            )
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_UploadValidationModal2.default, {
          showUploadValidationModal: this.state.showUploadValidationModal,
          hideUploadValidationModal: this._hideValidationModal,
          textModal: this.state.textModal
        })
      );
    }
  }]);
  return PublicProfile;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      form: state.form,
      temp: state.uploadImage,
      user: state.moka.user,
      isDirtyForm: (0, _reduxForm.isDirty)('publicProfileForm')(state),
      subscriptionExpired: state.subscriptionExpired
    },
    nextAction: state.confirmAction.nextAction
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublicProfile);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(757);

var _style2 = _interopRequireDefault(_style);

var _UploadImage = __webpack_require__(438);

var _UploadImage2 = _interopRequireDefault(_UploadImage);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _PhoneNumberField = __webpack_require__(242);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

var _accountProfileDefault = __webpack_require__(368);

var _accountProfileDefault2 = _interopRequireDefault(_accountProfileDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var FIELD_REQUIRED_ERROR = 'This field is required';
  var name = values.name,
      address = values.address,
      city = values.city,
      province = values.province,
      phone = values.phone,
      email = values.email;

  if (!name) {
    errors.name = FIELD_REQUIRED_ERROR;
  }
  if (!address) {
    errors.address = FIELD_REQUIRED_ERROR;
  }
  if (!city) {
    errors.city = FIELD_REQUIRED_ERROR;
  }
  if (!province) {
    errors.province = FIELD_REQUIRED_ERROR;
  }
  if (!values.postal_code || !/^\d{5}$/.test(values.postal_code)) {
    errors.postal_code = FIELD_REQUIRED_ERROR;
  }
  if (!phone) {
    errors.phone = FIELD_REQUIRED_ERROR;
  }
  if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim())) {
    errors.email = 'The value is not a valid email address';
  }
  return errors;
};

var PublicProfileForm = function (_React$Component) {
  (0, _inherits3.default)(PublicProfileForm, _React$Component);

  function PublicProfileForm(props) {
    (0, _classCallCheck3.default)(this, PublicProfileForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublicProfileForm.__proto__ || (0, _getPrototypeOf2.default)(PublicProfileForm)).call(this, props));

    _this.state = {
      uploading: false
    };
    return _this;
  }

  (0, _createClass3.default)(PublicProfileForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(
          'fieldset',
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-3 col-md-12 col-sm-6' },
              React.createElement(_reduxForm.Field, {
                name: 'gravatar',
                component: _UploadImage2.default,
                defaultImage: _accountProfileDefault2.default,
                imageContainerClassName: _style2.default['upload-image-content'],
                className: _style2.default['upload-image'],
                beforeUpload: function beforeUpload() {
                  _this2.setState({ uploading: true });
                },
                afterUpload: function afterUpload() {
                  _this2.setState({ uploading: false });
                }
              })
            ),
            React.createElement(
              'div',
              { className: 'col-lg-9 col-md-12 col-sm-6' },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: _SettingField2.default,
                      className: 'form-control',
                      name: 'name',
                      maxLength: '40',
                      placeholder: 'Business Name',
                      type: 'text'
                    })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(
                      'label',
                      { className: 'sr-only' },
                      'Description'
                    ),
                    React.createElement(_reduxForm.Field, {
                      component: 'textarea',
                      className: 'form-control general-textarea business-description',
                      name: 'description',
                      placeholder: 'Description',
                      rows: '10',
                      cols: '40'
                    })
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'Address'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  className: 'form-control',
                  placeholder: 'Address',
                  maxLength: '70',
                  name: 'address',
                  type: 'text'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'City'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  className: 'form-control',
                  name: 'city',
                  maxLength: '30',
                  placeholder: 'City',
                  type: 'text'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'Province'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  className: 'form-control',
                  placeholder: 'State',
                  maxLength: '30',
                  name: 'province',
                  type: 'text'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'Zipcode'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  className: 'form-control',
                  pattern: '[0-9]{5}',
                  name: 'postal_code',
                  maxLength: '5',
                  placeholder: 'Zip',
                  autoCorrect: 'off',
                  type: 'tel',
                  autoCapitalize: 'off',
                  spellCheck: 'false',
                  positiveNumberOnly: true,
                  maxFractionDigits: 0,
                  keyboardType: 'numeric'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-md-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'Phone'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _PhoneNumberField2.default,
                  name: 'phone',
                  type: 'tel',
                  placeholder: '812'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-6' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: 'sr-only' },
                  'Email'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  className: 'form-control',
                  placeholder: 'Email',
                  maxLength: '30',
                  name: 'email',
                  type: 'email'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: _style2.default['mk-sub-section-header'] },
                'Links'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: _style2.default['link-list'] },
                React.createElement(
                  'ul',
                  null,
                  React.createElement(
                    'li',
                    null,
                    React.createElement(
                      'span',
                      { className: 'fa-stack ' + _style2.default['color-link'] },
                      React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
                      React.createElement('i', { className: 'fa fa-globe fa-stack-1x fa-inverse' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'form-group' },
                      React.createElement(
                        'label',
                        { className: 'sr-only' },
                        'Website'
                      ),
                      React.createElement(_reduxForm.Field, {
                        component: 'input',
                        className: 'form-control',
                        placeholder: 'Website',
                        maxLength: '50',
                        name: 'website',
                        type: 'text'
                      })
                    )
                  ),
                  React.createElement(
                    'li',
                    null,
                    React.createElement(
                      'span',
                      { className: 'fa-stack ' + _style2.default['color-twitter'] },
                      React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
                      React.createElement('i', { className: 'fa fa-twitter fa-stack-1x fa-inverse' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'form-group' },
                      React.createElement(
                        'label',
                        { className: 'sr-only' },
                        'Twitter'
                      ),
                      React.createElement(_reduxForm.Field, {
                        component: 'input',
                        className: 'form-control',
                        placeholder: 'Twitter Username',
                        name: 'twitter',
                        maxLength: '50',
                        type: 'text'
                      })
                    )
                  ),
                  React.createElement(
                    'li',
                    null,
                    React.createElement(
                      'span',
                      { className: 'fa-stack ' + _style2.default['color-facebook'] },
                      React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
                      React.createElement('i', { className: 'fa fa-facebook fa-stack-1x fa-inverse' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'form-group' },
                      React.createElement(
                        'label',
                        { className: 'sr-only' },
                        'Facebook'
                      ),
                      React.createElement(_reduxForm.Field, {
                        component: 'input',
                        className: 'form-control',
                        placeholder: 'Facebook Username',
                        name: 'facebook',
                        maxLength: '50',
                        type: 'text'
                      })
                    )
                  ),
                  React.createElement(
                    'li',
                    null,
                    React.createElement(
                      'span',
                      { className: 'fa-stack ' + _style2.default['color-instagram'] },
                      React.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
                      React.createElement('i', { className: 'fa fa-instagram fa-stack-1x fa-inverse' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'form-group' },
                      React.createElement(
                        'label',
                        { className: 'sr-only' },
                        'Instagram'
                      ),
                      React.createElement(_reduxForm.Field, {
                        component: 'input',
                        className: 'form-control',
                        placeholder: 'Instagram Username',
                        name: 'instagram',
                        maxLength: '50',
                        type: 'text'
                      })
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement('div', { className: _style2.default['mk-divider-section-line'] })
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12 ' + _style2.default['save-button'] },
              React.createElement(
                'button',
                {
                  className: 'btn btn-primary pull-right',
                  id: 'save-public-profile',
                  type: 'submit',
                  disabled: this.state.uploading
                },
                'Save'
              )
            )
          )
        )
      );
    }
  }]);
  return PublicProfileForm;
}(React.Component);

PublicProfileForm.propTypes = {
  onSubmit: React.PropTypes.func
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'publicProfileForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(PublicProfileForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _ActionBar = __webpack_require__(2053);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function (outletIds) {
      _this.props.onChangeOutlet(outletIds);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        'div',
        { className: _ActionBar2.default['action-bar'] },
        React.createElement(_reduxForm.Field, {
          component: _DropdownOutlet2.default,
          outlets: outlets,
          onChangeOutletIds: this._onChangeOutlet,
          name: 'outlet'
        })
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  return {
    outlets: state.setting.receipt.outlets
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Header = __webpack_require__(2054);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Header2.default['wrapper'] },
        this.props.title
      );
    }
  }]);
  return Header;
}(React.Component);

Header.propTypes = {
  title: React.PropTypes.string
};

exports.default = Header;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ReceiptForm = __webpack_require__(1249);

var _ReceiptForm2 = _interopRequireDefault(_ReceiptForm);

var _reduxForm = __webpack_require__(7);

var _ReceiptPreview = __webpack_require__(1250);

var _ReceiptPreview2 = _interopRequireDefault(_ReceiptPreview);

var _Header = __webpack_require__(1246);

var _Header2 = _interopRequireDefault(_Header);

var _receipt = __webpack_require__(423);

var _confirmAction = __webpack_require__(29);

var _Receipt = __webpack_require__(2055);

var _Receipt2 = _interopRequireDefault(_Receipt);

var _reactRouter = __webpack_require__(15);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _ActionBar = __webpack_require__(1245);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Receipt = function (_React$Component) {
  (0, _inherits3.default)(Receipt, _React$Component);

  function Receipt() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Receipt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Receipt.__proto__ || (0, _getPrototypeOf2.default)(Receipt)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (_this.props.data.isDirtyForm) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _receipt.changeOutlet)(outletIds)));
      } else {
        _this.props.dispatch((0, _receipt.changeOutlet)(outletIds));
      }
    }, _this._onSubmit = function (values) {
      var outletId = _this.props.data.outlet.currentOutlet[0].id;
      var data = {
        outlet: {
          address: values.address,
          city: values.city,
          name: values.name,
          notes: values.notes,
          province: values.province,
          phone_number: '0' + values.phone,
          postal_code: values.zipcode
        }
      };
      _this.props.dispatch((0, _receipt.submitForm)(outletId, data, {}));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Receipt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        $('#mk-col-right').show();
        this.props.dispatch((0, _receipt.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (!_this2.props.data.isDirtyForm) {
            _this2.props.dispatch((0, _receipt.changePage)(location.pathname));
          } else {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _receipt.changePage)(location.pathname)));
          }
          return false;
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var receiptForm = React.createElement(_ReceiptForm2.default, { onSubmit: this._onSubmit });
      return React.createElement(
        'div',
        { className: _Receipt2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeOutlet: this._onChangeOutlet }),
        React.createElement(
          'div',
          { className: _Receipt2.default.container },
          React.createElement(
            'div',
            { className: _Receipt2.default['receipt-info-wrapper'] + ' col-sm-6', id: 'mk-col-left', style: { paddingRight: 0 } },
            React.createElement(_Header2.default, { title: 'Receipt info' }),
            receiptForm
          ),
          React.createElement(
            'div',
            { className: _Receipt2.default['receipt-preview-wrapper'] + ' col-sm-6', id: 'mk-col-right' },
            React.createElement(_Header2.default, { title: 'Receipt preview' }),
            React.createElement(_ReceiptPreview2.default, null)
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Receipt;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      isDirtyForm: (0, _reduxForm.isDirty)('checkout')(state),
      outlet: state.outlet,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Receipt);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Header = __webpack_require__(2056);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Header2.default['wrapper'] },
        this.props.title
      );
    }
  }]);
  return Header;
}(React.Component);

Header.propTypes = {
  title: React.PropTypes.string
};

exports.default = Header;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _Header = __webpack_require__(1248);

var _Header2 = _interopRequireDefault(_Header);

var _reactRedux = __webpack_require__(6);

var _receipt = __webpack_require__(423);

var _ReceiptForm = __webpack_require__(2057);

var _ReceiptForm2 = _interopRequireDefault(_ReceiptForm);

var _PhoneNumberField = __webpack_require__(242);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var FIELD_REQUIRED_ERROR = 'This field is required';
  var errors = {};
  if (!values.name) {
    errors.name = FIELD_REQUIRED_ERROR;
  }

  if (!values.address) {
    errors.address = FIELD_REQUIRED_ERROR;
  }

  if (!values.city) {
    errors.city = FIELD_REQUIRED_ERROR;
  }

  if (!values.province) {
    errors.province = FIELD_REQUIRED_ERROR;
  }

  if (!values.zipcode || !/^\d{5}$/.test(values.zipcode)) {
    errors.zipcode = FIELD_REQUIRED_ERROR;
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR;
  }

  return errors;
};

var ReceiptForm = function (_React$Component) {
  (0, _inherits3.default)(ReceiptForm, _React$Component);

  function ReceiptForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptForm.__proto__ || (0, _getPrototypeOf2.default)(ReceiptForm)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutletName = function (e) {
      var outlets = _this.props.data.outlet.outlets;
      var profile = _this.props.data.setting.receipt.profile;

      _this.props.dispatch((0, _receipt.changeOutletName)(e.target.value, outlets, profile));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptForm, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'form',
        { className: _ReceiptForm2.default['wrapper'], onSubmit: this.props.handleSubmit, id: 'form-receipt' },
        React.createElement(_Header2.default, { title: 'outlet info' }),
        React.createElement(
          'div',
          { className: 'row ' + _ReceiptForm2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                className: 'form-control',
                name: 'name',
                type: 'text',
                maxLength: '40',
                placeholder: 'Outlet Name',
                onChange: this._onChangeOutletName
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                className: 'form-control',
                name: 'address',
                type: 'text',
                maxLength: '90',
                placeholder: 'Address'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-4' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                className: 'form-control',
                name: 'city',
                type: 'text',
                maxLength: '40',
                placeholder: 'City'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-4' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                className: 'form-control',
                name: 'province',
                type: 'text',
                placeholder: 'State',
                maxLength: '40'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-4' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'zipcode',
                className: 'form-control',
                pattern: '[0-9]{5}',
                maxLength: '5',
                placeholder: 'Zip',
                autoCorrect: 'off',
                type: 'tel',
                autoCapitalize: 'off',
                positiveNumberOnly: true,
                maxFractionDigits: 0,
                spellCheck: 'false',
                keyboardType: 'numeric'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(_reduxForm.Field, {
                component: _PhoneNumberField2.default,
                name: 'phone',
                type: 'tel',
                placeholder: '812'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement('br', null),
            React.createElement('hr', null),
            React.createElement(_Header2.default, { title: 'notes' })
          ),
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(_reduxForm.Field, {
              component: 'textarea',
              className: 'form-control',
              name: 'notes',
              maxLength: '100',
              placeholder: 'Notes',
              rows: '3'
            })
          ),
          React.createElement('div', { className: 'col-md-12', style: { height: 25 } }),
          React.createElement(
            'div',
            { className: _ReceiptForm2.default.footer },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary' },
                'Save'
              )
            )
          )
        )
      );
    }
  }]);
  return ReceiptForm;
}(React.Component);

ReceiptForm.propTypes = {};

var mapForm = {
  form: 'checkout',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    data: {
      isDirtyForm: (0, _reduxForm.isDirty)('checkout')(state),
      outlet: state.outlet,
      setting: {
        receipt: state.setting.receipt
      }
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(ReceiptForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _BrandImage = __webpack_require__(445);

var _BrandImage2 = _interopRequireDefault(_BrandImage);

var _ItemTable = __webpack_require__(446);

var _ItemTable2 = _interopRequireDefault(_ItemTable);

var _Subtotal = __webpack_require__(294);

var _Subtotal2 = _interopRequireDefault(_Subtotal);

var _Gratuity = __webpack_require__(243);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _ReceiptTax = __webpack_require__(244);

var _ReceiptTax2 = _interopRequireDefault(_ReceiptTax);

var _Total = __webpack_require__(1178);

var _Total2 = _interopRequireDefault(_Total);

var _ReceiptPreview = __webpack_require__(2058);

var _ReceiptPreview2 = _interopRequireDefault(_ReceiptPreview);

var _formatter = __webpack_require__(11);

var _Notes = __webpack_require__(1161);

var _Notes2 = _interopRequireDefault(_Notes);

var _DiscountTable = __webpack_require__(245);

var _DiscountTable2 = _interopRequireDefault(_DiscountTable);

var _SocialMediaLink = __webpack_require__(1163);

var _SocialMediaLink2 = _interopRequireDefault(_SocialMediaLink);

var _InfoBox = __webpack_require__(1177);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptPreview = function (_React$Component) {
  (0, _inherits3.default)(ReceiptPreview, _React$Component);

  function ReceiptPreview() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReceiptPreview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReceiptPreview.__proto__ || (0, _getPrototypeOf2.default)(ReceiptPreview)).call.apply(_ref, [this].concat(args))), _this), _this.DUMMY_CHECKOUTS = [{
      id: 1,
      item_name: 'Milk Tea',
      item_variant_name: 'Venti',
      price: 25000,
      quantity: 1,
      modifiers: [{
        modifier_name: 'Pearl',
        modifier_option_name: 'Sweet',
        price: 2000
      }, {
        modifier_name: 'Grass Jelly',
        modifier_option_name: 'Salt',
        price: 2000
      }, {
        modifier_name: 'Sugar',
        modifier_option_name: 'Rare',
        price: 2000
      }],
      discounts: [{
        discount_name: 'Promo Sultan',
        discount_amount: 1000,
        discount_percentage: 0.5
      }]
    }, {
      id: 2,
      item_name: 'Nasi Goreng',
      item_variant_name: 'Ayam',
      price: 25000,
      quantity: 1,
      modifiers: [{
        modifier_name: 'Cabe',
        modifier_option_name: 'Sedikit',
        price: 1000
      }],
      discounts: []
    }, {
      id: 3,
      item_name: 'Beef Wellington',
      item_variant_name: '',
      price: 50000,
      quantity: 1,
      modifiers: [{
        modifier_name: 'Potato',
        modifier_option_name: 'Mashed',
        price: 10000
      }, {
        modifier_name: 'Sauce',
        modifier_option_name: 'Mushroom',
        price: 4000
      }],
      discounts: []
    }], _this.DUMMY_INFO = {
      createdAt: (0, _moment2.default)().format('Y-M-D H:m'),
      paymentNo: 'QGKTER5',
      servedBy: 'John Doe',
      collectedBy: 'Anne Doe'
    }, _this.DUMMY_DISCOUNTS = [{ discount_name: 'Discount Test', discount_amount: -10000 }], _this.DUMMY_TAXES = [{ name: 'Tax Test', amount: 5, total: '10000' }], _this.DUMMY_GRATUITITES = [{ name: 'Gratuity Test', amount: 5, total: '10000' }], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReceiptPreview, [{
    key: 'render',
    value: function render() {
      var _props$form = this.props.form,
          _props$form$address = _props$form.address,
          address = _props$form$address === undefined ? '' : _props$form$address,
          _props$form$city = _props$form.city,
          city = _props$form$city === undefined ? '' : _props$form$city,
          _props$form$province = _props$form.province,
          province = _props$form$province === undefined ? '' : _props$form$province,
          _props$form$zipcode = _props$form.zipcode,
          zipcode = _props$form$zipcode === undefined ? '' : _props$form$zipcode,
          _props$form$phone = _props$form.phone,
          phone = _props$form$phone === undefined ? '' : _props$form$phone,
          _props$form$notes = _props$form.notes,
          notes = _props$form$notes === undefined ? '' : _props$form$notes;
      var profile = this.props.data.setting.receipt.profile;

      return profile && React.createElement(
        'div',
        { className: _ReceiptPreview2.default.wrapper },
        React.createElement(
          'div',
          { className: _ReceiptPreview2.default.receipt },
          React.createElement(_BrandImage2.default, {
            businessLogo: profile.business.logo.url,
            businessName: profile.business.name,
            outletAddress: address + ', ' + city + ', ' + province + ', ' + zipcode,
            outletPhone: phone
          }),
          React.createElement(_InfoBox2.default, {
            servedBy: this.DUMMY_INFO.servedBy,
            collectedBy: this.DUMMY_INFO.collectedBy,
            paymentNo: this.DUMMY_INFO.paymentNo,
            createdAt: this.DUMMY_INFO.createdAt
          }),
          React.createElement(_ItemTable2.default, { checkouts: this.DUMMY_CHECKOUTS, checkoutPriceFormatter: _formatter.rupiah }),
          React.createElement(_DiscountTable2.default, { discounts: this.DUMMY_DISCOUNTS }),
          React.createElement(
            'div',
            { className: _ReceiptPreview2.default['counting-box'] },
            React.createElement(_Subtotal2.default, { subtotal: 110000 }),
            React.createElement(_Gratuity2.default, { includeGratuityTax: false, gratuities: this.DUMMY_GRATUITITES }),
            React.createElement(_ReceiptTax2.default, { includeGratuityTax: false, taxes: this.DUMMY_TAXES })
          ),
          React.createElement(_Total2.default, { cash: 150000, change: 40000, total: 110000 }),
          React.createElement(_SocialMediaLink2.default, {
            instagram: profile.business.instagram,
            facebook: profile.business.facebook,
            twitter: profile.business.twitter,
            website: profile.business.website
          }),
          React.createElement(_Notes2.default, { content: notes }),
          React.createElement('div', { style: { clear: 'both' } })
        )
      );
    }
  }]);
  return ReceiptPreview;
}(React.Component);

ReceiptPreview.propTypes = {};

var selector = (0, _reduxForm.formValueSelector)('checkout'); // must be same as ReceiptForm name reduxForm

function mapStateToProps(state) {
  return {
    form: {
      name: selector(state, 'name'),
      address: selector(state, 'address'),
      city: selector(state, 'city'),
      province: selector(state, 'province'),
      zipcode: selector(state, 'zipcode'),
      phone: selector(state, 'phone'),
      notes: selector(state, 'notes')
    },
    data: {
      outlet: state.outlet,
      setting: {
        receipt: state.setting.receipt
      }
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReceiptPreview);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ProgressBar = __webpack_require__(1147);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Nav = __webpack_require__(1141);

var _Nav2 = _interopRequireDefault(_Nav);

var _SubNavReport = __webpack_require__(1154);

var _SubNavReport2 = _interopRequireDefault(_SubNavReport);

var _SubNavSetting = __webpack_require__(1155);

var _SubNavSetting2 = _interopRequireDefault(_SubNavSetting);

var _SubNavLibrary = __webpack_require__(1152);

var _SubNavLibrary2 = _interopRequireDefault(_SubNavLibrary);

var _SubNavCustomer = __webpack_require__(1148);

var _SubNavCustomer2 = _interopRequireDefault(_SubNavCustomer);

var _SubNavEmployee = __webpack_require__(1149);

var _SubNavEmployee2 = _interopRequireDefault(_SubNavEmployee);

var _NotificationBar = __webpack_require__(1146);

var _NotificationBar2 = _interopRequireDefault(_NotificationBar);

var _SubNavOutlet = __webpack_require__(1153);

var _SubNavOutlet2 = _interopRequireDefault(_SubNavOutlet);

var _SubNavInventory = __webpack_require__(1151);

var _SubNavInventory2 = _interopRequireDefault(_SubNavInventory);

var _SubNavIngredient = __webpack_require__(1150);

var _SubNavIngredient2 = _interopRequireDefault(_SubNavIngredient);

var _perfectScrollbar = __webpack_require__(596);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

var _SubscriptionExpiredModal = __webpack_require__(1156);

var _SubscriptionExpiredModal2 = _interopRequireDefault(_SubscriptionExpiredModal);

var _subscriptionExpired = __webpack_require__(204);

var _BillingReminder = __webpack_require__(291);

var _BillingReminder2 = _interopRequireDefault(_BillingReminder);

var _identify = __webpack_require__(1205);

var _identify2 = _interopRequireDefault(_identify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function (_React$Component) {
  (0, _inherits3.default)(App, _React$Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args))), _this), _this._hideExpiredModal = function () {
      _this.props.dispatch((0, _subscriptionExpired.closeModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$data$moka = this.props.data.moka,
          loggedIn = _props$data$moka.loggedIn,
          user = _props$data$moka.user;

      if (loggedIn) {
        (0, _identify2.default)(user.id);
      }

      if (!/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) {
        var containerScroll = document.getElementById('scroll-auto');
        _perfectScrollbar2.default.initialize(containerScroll);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          history = _props.history,
          dispatch = _props.dispatch,
          location = _props.location,
          routes = _props.routes,
          children = _props.children;
      var pathname = location.pathname;
      var moka = data.moka,
          notification = data.notification,
          outlet = data.outlet,
          subscriptionExpired = data.subscriptionExpired;
      var loggedIn = moka.loggedIn,
          user = moka.user,
          currentlySending = moka.currentlySending,
          showLoadingSpinner = moka.showLoadingSpinner;
      var currentOutlet = outlet.currentOutlet,
          outlets = outlet.outlets;

      var hideHeader = routes[1].hideHeader;
      var expired = subscriptionExpired.expired,
          showSubscriptionExpiredModal = subscriptionExpired.showSubscriptionExpiredModal;


      return React.createElement(
        'div',
        null,
        showLoadingSpinner ? React.createElement(
          'div',
          { id: 'loading-container', className: 'mk-loading-container' },
          React.createElement('div', { className: 'center-spinner moka-spinner' })
        ) : React.createElement(_ProgressBar2.default, { updateTime: 500 }),
        !hideHeader && React.createElement(
          'header',
          { className: 'mk-head-bar' },
          React.createElement(_Nav2.default, {
            loggedIn: loggedIn,
            user: user,
            currentlySending: currentlySending,
            history: history,
            dispatch: dispatch,
            location: location,
            currentOutlet: currentOutlet,
            outlets: outlets
          }),
          pathname.startsWith('/reports') && React.createElement(_SubNavReport2.default, {
            location: location,
            user: user,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/settings') && React.createElement(_SubNavSetting2.default, {
            user: user,
            location: location,
            isMobile: window.innerWidth <= 768,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/library') && React.createElement(_SubNavLibrary2.default, {
            user: user,
            location: location,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/customers') && React.createElement(_SubNavCustomer2.default, {
            location: location,
            user: user,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/employees') && React.createElement(_SubNavEmployee2.default, {
            user: user,
            location: location,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/outlets') && React.createElement(_SubNavOutlet2.default, {
            location: location,
            user: user,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/inventory') && React.createElement(_SubNavInventory2.default, {
            user: user,
            location: location,
            subscriptionExpired: subscriptionExpired }),
          pathname.startsWith('/ingredient') && React.createElement(_SubNavIngredient2.default, {
            user: user,
            location: location,
            subscriptionExpired: subscriptionExpired }),
          !hideHeader && React.createElement(_NotificationBar2.default, { dispatch: dispatch, notification: notification, location: location })
        ),
        React.createElement('div', { className: 'separator' }),
        React.createElement(
          'div',
          { className: 'full-height section-content ' + (hideHeader ? ' no-header' : '') + ' ' + this._getClassByPath() },
          !pathname.startsWith('/dashboard') && React.createElement(
            'div',
            { className: 'visible-sm visible-xs reminder-responsive' },
            React.createElement(_BillingReminder2.default, { user: user, subscriptionExpired: subscriptionExpired })
          ),
          React.createElement(
            'div',
            { className: 'container-full-nosub box-content-container', id: 'scroll-auto' },
            children
          )
        ),
        expired && React.createElement(_SubscriptionExpiredModal2.default, { showModal: showSubscriptionExpiredModal, onHide: this._hideExpiredModal })
      );
    }
  }, {
    key: '_getClassByPath',
    value: function _getClassByPath() {
      var location = this.props.location;

      var classbyPath = location.pathname.split('/');
      if (location.pathname.startsWith('/feedback')) {
        return 'feedback';
      }
      if (classbyPath[1] === 'reset-password') {
        return 'reset-password';
      }
      return classbyPath[classbyPath.length - 1];
    }
  }]);
  return App;
}(React.Component);

App.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  location: React.PropTypes.object,
  children: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
};

function select(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(select)(App);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _billingRedirect = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingRedirect = function (_Component) {
  (0, _inherits3.default)(BillingRedirect, _Component);

  function BillingRedirect() {
    (0, _classCallCheck3.default)(this, BillingRedirect);
    return (0, _possibleConstructorReturn3.default)(this, (BillingRedirect.__proto__ || (0, _getPrototypeOf2.default)(BillingRedirect)).apply(this, arguments));
  }

  (0, _createClass3.default)(BillingRedirect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location$query = this.props.location.query,
          order_id = _props$location$query.order_id,
          status_code = _props$location$query.status_code,
          transaction_status = _props$location$query.transaction_status;

      this.props.dispatch((0, _billingRedirect.updatePaymentStatus)(order_id, status_code, transaction_status));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);
  return BillingRedirect;
}(_react.Component); /**
                      * Created by alvinoktavianus on 6/21/17.
                      */

function mapStateToProps() {
  return {};
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BillingRedirect);

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ConfirmEmployeeForm = __webpack_require__(1254);

var _ConfirmEmployeeForm2 = _interopRequireDefault(_ConfirmEmployeeForm);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(15);

var _confirmEmployee = __webpack_require__(608);

var _ConfirmEmployee = __webpack_require__(758);

var _ConfirmEmployee2 = _interopRequireDefault(_ConfirmEmployee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmEmployee = function (_React$Component) {
  (0, _inherits3.default)(ConfirmEmployee, _React$Component);

  function ConfirmEmployee() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmEmployee);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmEmployee.__proto__ || (0, _getPrototypeOf2.default)(ConfirmEmployee)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var _this$props$data$conf = _this.props.data.confirmEmployee.invitedEmployee,
          business = _this$props$data$conf.business,
          employee = _this$props$data$conf.employee;

      var inputValues = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        password: values.password,
        password_confirmation: values.confirmPassword
      };
      _this.props.dispatch((0, _confirmEmployee.createEmployeeAccount)({ business: business, employee: inputValues || employee }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmEmployee, [{
    key: 'render',
    value: function render() {
      var _props$data$confirmEm = this.props.data.confirmEmployee,
          invalidInvitation = _props$data$confirmEm.invalidInvitation,
          invitedEmployee = _props$data$confirmEm.invitedEmployee;
      var business = invitedEmployee.business;

      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'col-sm-6 col-sm-offset-3' },
          !invalidInvitation ? React.createElement(
            'div',
            { className: _ConfirmEmployee2.default['form-container'] },
            React.createElement(
              'h3',
              null,
              'Complete Registration'
            ),
            React.createElement(
              'div',
              null,
              'to accept payment on behalf of ',
              React.createElement(
                'b',
                null,
                business && business.name
              )
            ),
            React.createElement(_ConfirmEmployeeForm2.default, { onSubmit: this.handleSubmit })
          ) : React.createElement(
            'div',
            { className: _ConfirmEmployee2.default['invalid-message'] },
            React.createElement(
              'h2',
              null,
              'Sorry, this invitation is no longer valid.'
            )
          ),
          React.createElement(
            'div',
            { className: _ConfirmEmployee2.default['text-signIn'] },
            'Already have a Moka account? ',
            React.createElement(
              _reactRouter.Link,
              { to: '/login' },
              'Sign in.'
            )
          )
        )
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location$query = this.props.location.query,
          business_id = _props$location$query.business_id,
          pending_email = _props$location$query.pending_email;

      this.props.dispatch((0, _confirmEmployee.pageRequest)({ business_id: business_id, pending_email: pending_email }));
    }
  }]);
  return ConfirmEmployee;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      confirmEmployee: state.confirmEmployee
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConfirmEmployee);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputField = function inputField(field) {
  return React.createElement(
    'div',
    null,
    React.createElement('input', (0, _extends3.default)({}, field.input, {
      type: field.type || 'text',
      maxLength: field.maxLength,
      className: 'form-control',
      placeholder: field.placeholder,
      readOnly: field.readOnly
    })),
    React.createElement(
      'small',
      { className: 'error' },
      field.meta.touched ? field.meta.error : ''
    )
  );
};

var validate = function validate(values) {
  var errors = {};
  var password = values.password,
      confirmPassword = values.confirmPassword;

  if (!password) {
    errors.password = 'This field is required';
  } else if (password.length < 6) {
    errors.password = 'Please Enter at least 6 Characters';
  }
  if (!confirmPassword) {
    errors.confirmPassword = 'This field is required';
  } else if (confirmPassword !== password) {
    errors.confirmPassword = 'Please enter the same value again.';
  }
  return errors;
};

var ConfirmEmployeeForm = function (_React$Component) {
  (0, _inherits3.default)(ConfirmEmployeeForm, _React$Component);

  function ConfirmEmployeeForm() {
    (0, _classCallCheck3.default)(this, ConfirmEmployeeForm);
    return (0, _possibleConstructorReturn3.default)(this, (ConfirmEmployeeForm.__proto__ || (0, _getPrototypeOf2.default)(ConfirmEmployeeForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfirmEmployeeForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-12 form-group' },
            React.createElement('hr', null),
            React.createElement(_reduxForm.Field, {
              component: inputField,
              placeholder: 'First Name',
              name: 'firstName',
              maxLength: '40',
              readOnly: 'true'
            }),
            React.createElement(_reduxForm.Field, {
              component: inputField,
              placeholder: 'Last Name',
              name: 'lastName',
              maxLength: '40',
              readOnly: 'true'
            }),
            React.createElement(_reduxForm.Field, {
              component: inputField,
              placeholder: 'Email',
              name: 'email',
              maxLength: '40',
              readOnly: 'true'
            }),
            React.createElement(_reduxForm.Field, {
              component: inputField,
              placeholder: 'Password',
              name: 'password',
              type: 'password',
              maxLength: '40'
            }),
            React.createElement(_reduxForm.Field, {
              component: inputField,
              placeholder: 'Confirm Password',
              name: 'confirmPassword',
              type: 'password',
              maxLength: '40'
            }),
            React.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn btn-primary pull-left' },
              'Create Employee Account'
            )
          )
        )
      );
    }
  }]);
  return ConfirmEmployeeForm;
}(React.Component);

var mapFormValidation = {
  form: 'confirmEmployeeForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)(ConfirmEmployeeForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ConfirmEmployee = __webpack_require__(758);

var _ConfirmEmployee2 = _interopRequireDefault(_ConfirmEmployee);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessConfirmEmployee = function (_React$Component) {
  (0, _inherits3.default)(SuccessConfirmEmployee, _React$Component);

  function SuccessConfirmEmployee() {
    (0, _classCallCheck3.default)(this, SuccessConfirmEmployee);
    return (0, _possibleConstructorReturn3.default)(this, (SuccessConfirmEmployee.__proto__ || (0, _getPrototypeOf2.default)(SuccessConfirmEmployee)).apply(this, arguments));
  }

  (0, _createClass3.default)(SuccessConfirmEmployee, [{
    key: 'render',
    value: function render() {
      var business = this.props.data.confirmEmployee.invitedEmployee.business;

      return business && React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: _ConfirmEmployee2.default['confirm-success'] },
            React.createElement(
              'h1',
              null,
              'Success!'
            ),
            'You can now start accepting payments on behalf of ',
            React.createElement(
              'b',
              null,
              business.name
            )
          )
        )
      );
    }
  }]);
  return SuccessConfirmEmployee;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SuccessConfirmEmployee);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Customer = __webpack_require__(2060);

var _Customer2 = _interopRequireDefault(_Customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Customer = function (_React$Component) {
  (0, _inherits3.default)(Customer, _React$Component);

  function Customer() {
    (0, _classCallCheck3.default)(this, Customer);
    return (0, _possibleConstructorReturn3.default)(this, (Customer.__proto__ || (0, _getPrototypeOf2.default)(Customer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Customer, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Customer2.default['container-full-nosub'], id: _Customer2.default.customers },
        React.createElement(
          'div',
          { className: 'container box-report-child ' + _Customer2.default['container'] },
          this.props.children
        )
      );
    }
  }]);
  return Customer;
}(React.Component);

exports.default = Customer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ListLoyalty = __webpack_require__(1271);

var _ListLoyalty2 = _interopRequireDefault(_ListLoyalty);

var _ListNonLoyalty = __webpack_require__(1280);

var _ListNonLoyalty2 = _interopRequireDefault(_ListNonLoyalty);

var _reactToggleDisplay = __webpack_require__(229);

var _reactToggleDisplay2 = _interopRequireDefault(_reactToggleDisplay);

var _RedeemHistory = __webpack_require__(1293);

var _RedeemHistory2 = _interopRequireDefault(_RedeemHistory);

var _PurchaseHistory = __webpack_require__(1290);

var _PurchaseHistory2 = _interopRequireDefault(_PurchaseHistory);

var _PointActivity = __webpack_require__(1287);

var _PointActivity2 = _interopRequireDefault(_PointActivity);

var _list = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerList = function (_Component) {
  (0, _inherits3.default)(CustomerList, _Component);

  function CustomerList(props) {
    (0, _classCallCheck3.default)(this, CustomerList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerList.__proto__ || (0, _getPrototypeOf2.default)(CustomerList)).call(this, props));

    _this._showPointActivity = function (customerId) {
      _this.props.customerPointActivitiesRequest({ customerId: customerId, page: 1, size: 12, sort: 'createdAt,desc' });
      _this.setState({ currentView: _this.state.views[4] });
    };

    _this._showRedeemHistory = function (customerId) {
      _this.props.customerRedemptionHistoriesRequest({ customerId: customerId, page: 1, size: 12, sort: 'createdAt,desc' });
      _this.setState({ currentView: _this.state.views[2] });
    };

    _this._showListLoyalty = function () {
      _this.setState({ currentView: _this.state.views[0] });
    };

    _this._showPurchaseHistory = function () {
      _this.setState({ currentView: _this.state.views[3] });
    };

    var views = ['loyalty', 'non-loyalty', 'redeemHistory', 'purchaseHistory', 'pointActivity'];
    var currentView = '';

    if (_this.props.hasLoyalty) {
      currentView = views[0];
    } else if (_this.props.hasLoyalty === false) {
      currentView = views[1];
    }

    _this.state = { views: views, currentView: currentView };
    return _this;
  }

  (0, _createClass3.default)(CustomerList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.pageRequest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.hasLoyalty !== nextProps.hasLoyalty) {
        if (nextProps.hasLoyalty) {
          this.setState({ currentView: this.state.views[0] });
        } else {
          this.setState({ currentView: this.state.views[1] });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          views = _state.views,
          currentView = _state.currentView;

      return _react2.default.createElement(
        'div',
        { style: { height: '100%' } },
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[0] || currentView === views[1] },
          this.props.hasLoyalty && _react2.default.createElement(_ListLoyalty2.default, {
            showRedeemHistory: this._showRedeemHistory,
            showPurchaseHistory: this._showPurchaseHistory,
            showPointActivity: this._showPointActivity
          }),
          !this.props.hasLoyalty && _react2.default.createElement(_ListNonLoyalty2.default, null)
        ),
        views[2] === currentView && _react2.default.createElement(_RedeemHistory2.default, { backToCustomerList: this._showListLoyalty }),
        views[3] === currentView && _react2.default.createElement(_PurchaseHistory2.default, { backToCustomerList: this._showListLoyalty }),
        views[4] === currentView && _react2.default.createElement(_PointActivity2.default, { backToCustomerList: this._showListLoyalty })
      );
    }

    // the behaviour of purchase history is different because there is not server side pagination provided

  }]);
  return CustomerList;
}(_react.Component);

CustomerList.propTypes = {
  hasLoyalty: _react2.default.PropTypes.object
};

function mapStateToProps(_ref) {
  var hasLoyalty = _ref.customers.list.hasLoyalty;

  return { hasLoyalty: hasLoyalty };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  customerRedemptionHistoriesRequest: _list.customerRedemptionHistoriesRequest,
  customerPointActivitiesRequest: _list.customerPointActivitiesRequest,
  pageRequest: _list.pageRequest
})(CustomerList);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(2061);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reactBootstrap = __webpack_require__(10);

var _reduxForm = __webpack_require__(7);

var _DropdownSelect = __webpack_require__(436);

var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeKeyword = function (event, keyword) {
      _this.props.onChangeKeyword(keyword);
    }, _this._onChangeType = function (event, type) {
      _this.props.onChangeType(type);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClickImport = _props.onClickImport,
          onClickExport = _props.onClickExport;


      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-12 col-sm-12 col-xs-12' },
            React.createElement(
              'ul',
              null,
              React.createElement(
                'li',
                { className: '' + _ActionBar2.default['li-filter'] },
                React.createElement(_reduxForm.Field, {
                  name: 'customerType',
                  component: _DropdownSelect2.default,
                  options: ActionBar.CUSTOMER_TYPE,
                  defaultOption: { id: 'ALL', name: 'All Customers' },
                  id: 'filterSelectCustomerType',
                  style: { backgroundColor: 'white' },
                  onChange: this._onChangeType
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-searching' },
                React.createElement(_reduxForm.Field, {
                  name: 'keyword',
                  component: _SearchBar2.default,
                  onChange: this._onChangeKeyword,
                  placeholder: 'Name, email, phone',
                  className: 'searchbar-customerlist'
                })
              ),
              React.createElement(
                'li',
                { className: 'pull-right' },
                React.createElement(
                  _reactBootstrap.DropdownButton,
                  { title: 'Import / Export', bsStyle: 'primary' },
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickImport },
                    'Import Customer'
                  ),
                  React.createElement(_reactBootstrap.MenuItem, { divider: true }),
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickExport },
                    'Export Customer'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

ActionBar.CUSTOMER_TYPE = [{ id: 'LOYALTY', name: 'Loyalty Member' }, { id: 'NON_LOYALTY', name: 'Non-Loyalty Member' }];


ActionBar.propTypes = {};

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        list: state.customers.list
      }
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CustomerInfo = __webpack_require__(1261);

var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);

var _CustomerHighlight = __webpack_require__(1260);

var _CustomerHighlight2 = _interopRequireDefault(_CustomerHighlight);

var _PurchaseHistory = __webpack_require__(1265);

var _PurchaseHistory2 = _interopRequireDefault(_PurchaseHistory);

var _LoyaltyMembership = __webpack_require__(1262);

var _LoyaltyMembership2 = _interopRequireDefault(_LoyaltyMembership);

var _RedeemHistory = __webpack_require__(1267);

var _RedeemHistory2 = _interopRequireDefault(_RedeemHistory);

var _PointActivity = __webpack_require__(1263);

var _PointActivity2 = _interopRequireDefault(_PointActivity);

var _reactRedux = __webpack_require__(6);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

var _list = __webpack_require__(75);

var _ReceiptInvoices = __webpack_require__(299);

var _ReceiptInvoices2 = _interopRequireDefault(_ReceiptInvoices);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerDetail = function (_React$Component) {
  (0, _inherits3.default)(CustomerDetail, _React$Component);

  function CustomerDetail(props) {
    (0, _classCallCheck3.default)(this, CustomerDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerDetail.__proto__ || (0, _getPrototypeOf2.default)(CustomerDetail)).call(this, props));

    _this._onClickDone = function () {
      // on done receipt view, do not close right side
      if (_this.state.showReceipt) {
        _this.setState({ showReceipt: false });
      } else {
        _this.props.onClickDone();
      }
    };

    _this._openReceipt = function (payment) {
      _this.setState({ showReceipt: true });
      var customerDetail = _this.props.list.customerDetail;

      _this.props.dispatch((0, _list.receiptCustomerRequest)(payment, customerDetail));
    };

    _this.state = { showReceipt: false };
    return _this;
  }

  (0, _createClass3.default)(CustomerDetail, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.list.customerDetail !== nextProps.list.customerDetail) {
        this.setState({ showReceipt: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$list = this.props.list,
          customerDetail = _props$list.customerDetail,
          receiptData = _props$list.receiptData;

      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          'div',
          { className: _style2.default['col-right-inner'] },
          React.createElement(
            'div',
            { className: _style2.default['scrolled-area'] },
            !this.state.showReceipt && React.createElement(
              'div',
              { className: 'customer-info-box-container' },
              React.createElement(_CustomerInfo2.default, { customerDetail: customerDetail }),
              React.createElement(_CustomerHighlight2.default, { customerDetail: customerDetail }),
              React.createElement(_LoyaltyMembership2.default, { customerDetail: customerDetail }),
              React.createElement(_RedeemHistory2.default, {
                customerDetail: customerDetail,
                onClickHistory: this._openReceipt,
                seeMore: this.props.showRedeemHistory
              }),
              React.createElement(_PointActivity2.default, {
                customerDetail: customerDetail,
                onClickHistory: this._openReceipt,
                seeMore: this.props.showPointActivity
              }),
              React.createElement(_PurchaseHistory2.default, {
                customerDetail: customerDetail,
                onClickHistory: this._openReceipt,
                seeMore: this.props.showPurchaseHistory
              })
            ),
            receiptData && this.state.showReceipt && receiptData.payment_type === 'invoice' && React.createElement(
              'div',
              null,
              React.createElement(_ReceiptInvoices2.default, { invoiceDetail: receiptData })
            ),
            receiptData && this.state.showReceipt && receiptData.payment_type !== 'invoice' && React.createElement(
              'div',
              { className: _style2.default['receipt-trx-container'] },
              React.createElement(_TransactionDetailReceipt2.default, { paymentDetail: receiptData })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _style2.default['mk-col-right-action-box-bottom'] },
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right', onClick: this._onClickDone },
            'Done'
          )
        )
      );
    }
  }]);
  return CustomerDetail;
}(React.Component);

CustomerDetail.propTypes = {
  onClickDone: React.PropTypes.func
};

function mapStateToProps(_ref) {
  var list = _ref.customers.list;

  return {
    list: list
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CustomerDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerHighlight = function (_React$Component) {
  (0, _inherits3.default)(CustomerHighlight, _React$Component);

  function CustomerHighlight() {
    (0, _classCallCheck3.default)(this, CustomerHighlight);
    return (0, _possibleConstructorReturn3.default)(this, (CustomerHighlight.__proto__ || (0, _getPrototypeOf2.default)(CustomerHighlight)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomerHighlight, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;


      return customerDetail && React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header ' + _style2.default['header-name'] },
          'Customer Highlights'
        ),
        React.createElement(
          'div',
          { className: 'info-profile' },
          React.createElement(
            'table',
            null,
            React.createElement(
              'tbody',
              { className: _style2.default['no-hover'] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Number of Transaction'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.orders
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Customer Since'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.member_since
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Last Visit'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.last_visit
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'This Month'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.rupiah)(customerDetail.this_month_total)
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'This Year'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.rupiah)(customerDetail.this_year_total)
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Lifetime Spend'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.rupiah)(customerDetail.lifetime_total)
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Average Spend'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.rupiah)(customerDetail.average_amount)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CustomerHighlight;
}(React.Component);

CustomerHighlight.propTypes = {
  customerDetail: React.PropTypes.object
};

exports.default = CustomerHighlight;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerInfo = function (_React$Component) {
  (0, _inherits3.default)(CustomerInfo, _React$Component);

  function CustomerInfo() {
    (0, _classCallCheck3.default)(this, CustomerInfo);
    return (0, _possibleConstructorReturn3.default)(this, (CustomerInfo.__proto__ || (0, _getPrototypeOf2.default)(CustomerInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomerInfo, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;


      return customerDetail && React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header ' + _style2.default['header-name'] },
          customerDetail.name || customerDetail.email || customerDetail.phone
        ),
        React.createElement(
          'div',
          { className: 'info-profile' },
          React.createElement(
            'table',
            null,
            React.createElement(
              'tbody',
              { className: _style2.default['no-hover'] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Address'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6 wrap-customer-address ' + _style2.default.address },
                  customerDetail.address
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Phone'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.phone
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Email'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6 ' + _style2.default.email },
                  customerDetail.email
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Birthday'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.birthday
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Gender'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.sex
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CustomerInfo;
}(React.Component);

CustomerInfo.propTypes = {
  customerDetail: React.PropTypes.object
};

exports.default = CustomerInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoyaltyMembership = function (_React$Component) {
  (0, _inherits3.default)(LoyaltyMembership, _React$Component);

  function LoyaltyMembership() {
    (0, _classCallCheck3.default)(this, LoyaltyMembership);
    return (0, _possibleConstructorReturn3.default)(this, (LoyaltyMembership.__proto__ || (0, _getPrototypeOf2.default)(LoyaltyMembership)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoyaltyMembership, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;

      return React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header ' + _style2.default['header-name'] },
          'Loyalty Membership'
        ),
        customerDetail && customerDetail.loyalty_membership_info ? React.createElement(
          'div',
          { className: 'info-profile' },
          React.createElement(
            'table',
            null,
            React.createElement(
              'tbody',
              { className: _style2.default['no-hover'] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Member Since'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.dateFormatter)(customerDetail.loyalty_membership_info.join_date)
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Member Number'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  customerDetail.phone
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Current Balance Point'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.formatDecimal)(customerDetail.loyalty_membership_info.point_balance),
                  ' Points'
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Reward Redeemed'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.formatDecimal)(customerDetail.loyalty_membership_info.reward_redeemed),
                  ' Times'
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  'Member Spending'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left col-md-6' },
                  (0, _formatter.rupiah)(customerDetail.loyalty_membership_info.member_spending)
                )
              )
            )
          )
        ) : React.createElement(
          'div',
          { className: '' + _style2.default['no-loyalty-membership'] },
          ' ',
          React.createElement(
            'i',
            null,
            'Not a member'
          )
        )
      );
    }
  }]);
  return LoyaltyMembership;
}(React.Component);

LoyaltyMembership.propTypes = {
  customerDetail: React.PropTypes.object
};

exports.default = LoyaltyMembership;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _PointActivityRow = __webpack_require__(1264);

var _PointActivityRow2 = _interopRequireDefault(_PointActivityRow);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointActivity = function (_React$Component) {
  (0, _inherits3.default)(PointActivity, _React$Component);

  function PointActivity() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PointActivity);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PointActivity.__proto__ || (0, _getPrototypeOf2.default)(PointActivity)).call.apply(_ref, [this].concat(args))), _this), _this._onClickSeeMore = function () {
      _this.props.seeMore(_this.props.customerDetail.id);
    }, _this._getPointActivityRowsView = function (pointActivities) {
      var pointActivityList = [];
      for (var i = 0; i < pointActivities.content.length && i < PointActivity.maximumPointActivityToShow; i++) {
        var pointActivity = pointActivities.content[i];
        pointActivityList.push(React.createElement(_PointActivityRow2.default, { key: pointActivity.rowId, pointActivity: pointActivity, onClickRow: _this._onClickRow }));
      }

      return pointActivityList;
    }, _this._onClickRow = function (data) {
      _this.props.onClickHistory(data);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PointActivity, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;

      return React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header2' },
          'Point Activity'
        ),
        customerDetail && customerDetail.point_activities && customerDetail.point_activities.content && customerDetail.point_activities.content.length ? React.createElement(
          'table',
          { style: { marginBottom: '0px' }, className: 'table mk-table-fixed mk-table-clickable moka-table-details' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: 'col-md-3' },
                'Date'
              ),
              React.createElement(
                'th',
                { className: 'col-md-5' },
                'Outlet'
              ),
              React.createElement(
                'th',
                { className: 'col-md-2 text-right' },
                'Sale'
              ),
              React.createElement(
                'th',
                { className: 'col-md-2 text-right' },
                'Point'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            this._getPointActivityRowsView(customerDetail.point_activities),
            customerDetail.point_activities.total_elements > PointActivity.maximumPointActivityToShow && React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { onClick: this._onClickSeeMore, className: _style2.default['see-more'] + ' col-md-2' },
                '+ See More'
              )
            )
          )
        ) : React.createElement(
          'div',
          { className: '' + _style2.default['no-point-activity'] },
          ' ',
          React.createElement(
            'i',
            null,
            'No point activity'
          ),
          ' '
        )
      );
    }
  }]);
  return PointActivity;
}(React.Component);

PointActivity.maximumPointActivityToShow = 5;


PointActivity.propTypes = {
  customerDetail: React.PropTypes.object,
  onClickHistory: React.PropTypes.func
};

exports.default = PointActivity;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointActivityRow = function (_Component) {
  (0, _inherits3.default)(PointActivityRow, _Component);

  function PointActivityRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PointActivityRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PointActivityRow.__proto__ || (0, _getPrototypeOf2.default)(PointActivityRow)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function () {
      _this.props.onClickRow({
        payment_type: _this.props.pointActivity.payment_type.toLowerCase(),
        parent_payment_id: _this.props.pointActivity.parent_payment_id
      });
    }, _this._saleFormatter = function (sale) {
      return sale < 0 ? '(' + (0, _formatter.rupiah)(-sale) + ')' : (0, _formatter.rupiah)(sale);
    }, _this._getFormattedPoint = function () {
      var pointActivity = _this.props.pointActivity;

      var point = pointActivity.points + pointActivity.new_member_points;
      if (pointActivity.type.toUpperCase() === 'EARNING') {
        if (point >= 0) {
          return (0, _formatter.formatDecimal)(point);
        } else {
          return '(' + (0, _formatter.formatDecimal)(-point) + ')';
        }
      } else {
        return '(' + (0, _formatter.formatDecimal)(point) + ')';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PointActivityRow, [{
    key: 'render',
    value: function render() {
      var pointActivity = this.props.pointActivity;

      return _react2.default.createElement(
        'tr',
        { onClick: this._onClickRow },
        _react2.default.createElement(
          'td',
          { className: 'col-md-3' },
          (0, _formatter.dateFormatter)(pointActivity.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-md-5' },
          pointActivity.outlet_name
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-md-2 text-right' },
          this._saleFormatter(pointActivity.total_collected_amount)
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-md-2 text-right' },
          this._getFormattedPoint()
        )
      );
    }
  }]);
  return PointActivityRow;
}(_react.Component);

PointActivityRow.propTypes = {
  onClickRow: _react2.default.PropTypes.func,
  pointActivity: _react2.default.PropTypes.object
};

exports.default = PointActivityRow;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

var _PurchaseHistoryRow = __webpack_require__(1266);

var _PurchaseHistoryRow2 = _interopRequireDefault(_PurchaseHistoryRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseHistory = function (_React$Component) {
  (0, _inherits3.default)(PurchaseHistory, _React$Component);

  function PurchaseHistory() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PurchaseHistory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseHistory.__proto__ || (0, _getPrototypeOf2.default)(PurchaseHistory)).call.apply(_ref, [this].concat(args))), _this), _this._getPurchaseHistoriesRowsView = function (payments) {
      var purchaseHistoryList = [];
      for (var i = 0; i < payments.length && i < PurchaseHistory.maximumPurchasesToShow; i++) {
        var payment = payments[i];
        purchaseHistoryList.push(React.createElement(_PurchaseHistoryRow2.default, { payment: payment, key: payment.id, onClickRow: _this._onClickRowHistory }));
      }

      return purchaseHistoryList;
    }, _this._onClickRowHistory = function (payment) {
      _this.props.onClickHistory(payment);
    }, _this._onClickSeeMore = function () {
      _this.props.seeMore();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PurchaseHistory, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;

      return React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header2' },
          'Purchase History'
        ),
        customerDetail && customerDetail.payments && customerDetail.payments.length ? React.createElement(
          'table',
          { className: 'table mk-table-fixed mk-table-clickable moka-table-details', id: 'purchase-history-table' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Date'
              ),
              React.createElement(
                'th',
                null,
                'Outlet'
              ),
              React.createElement(
                'th',
                { className: 'text-right' },
                'Sale'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            this._getPurchaseHistoriesRowsView(customerDetail.payments),
            React.createElement(
              'tr',
              null,
              customerDetail.payments.length > PurchaseHistory.maximumPurchasesToShow && React.createElement(
                'td',
                { onClick: this._onClickSeeMore, className: _style2.default['see-more'] + ' col-md-2' },
                '+ See More'
              )
            )
          )
        ) : React.createElement(
          'div',
          { className: '' + _style2.default['no-purchase-history'] },
          ' ',
          React.createElement(
            'i',
            null,
            'No purchase history'
          ),
          ' '
        )
      );
    }
  }]);
  return PurchaseHistory;
}(React.Component);

PurchaseHistory.maximumPurchasesToShow = 5;


PurchaseHistory.propTypes = {
  customerDetail: React.PropTypes.object,
  onClickHistory: React.PropTypes.func
};

exports.default = PurchaseHistory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formatter = __webpack_require__(11);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseHistoryRow = function (_Component) {
  (0, _inherits3.default)(PurchaseHistoryRow, _Component);

  function PurchaseHistoryRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PurchaseHistoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseHistoryRow.__proto__ || (0, _getPrototypeOf2.default)(PurchaseHistoryRow)).call.apply(_ref, [this].concat(args))), _this), _this._purchaseHistoryTotalFormatter = function (payment) {
      var amount = payment.is_refunded ? (0, _formatter.rupiah)(parseFloat(payment.refund_amount).toFixed(0)) : (0, _formatter.rupiah)(parseFloat(payment.total_collected).toFixed(0));

      if (payment.is_refunded) {
        amount = '(' + amount + ')';
      }

      return amount;
    }, _this._onClickRow = function () {
      _this.props.onClickRow(_this.props.payment);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PurchaseHistoryRow, [{
    key: 'render',
    value: function render() {
      var payment = this.props.payment;

      return _react2.default.createElement(
        'tr',
        { onClick: this._onClickRow },
        _react2.default.createElement(
          'td',
          null,
          (0, _formatter.dateFormatter)(payment.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: _style2.default['col-outlet'] },
          payment.outlet_name
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right ' + _style2.default['col-sale'] },
          this._purchaseHistoryTotalFormatter(payment)
        )
      );
    }
  }]);
  return PurchaseHistoryRow;
}(_react.Component);

PurchaseHistoryRow.propTypes = {
  customerDetail: _react2.default.PropTypes.object,
  onClickRow: _react2.default.PropTypes.func
};

exports.default = PurchaseHistoryRow;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _RedeemHistoryRow = __webpack_require__(1268);

var _RedeemHistoryRow2 = _interopRequireDefault(_RedeemHistoryRow);

var _style = __webpack_require__(157);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedeemHistory = function (_React$Component) {
  (0, _inherits3.default)(RedeemHistory, _React$Component);

  function RedeemHistory() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RedeemHistory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RedeemHistory.__proto__ || (0, _getPrototypeOf2.default)(RedeemHistory)).call.apply(_ref, [this].concat(args))), _this), _this._getRedemptionRowsView = function (redemptions) {
      var redemptionList = [];
      for (var i = 0; i < redemptions.content.length && i < RedeemHistory.maximumRedemptionsToShow; i++) {
        var redemption = redemptions.content[i];
        redemptionList.push(React.createElement(_RedeemHistoryRow2.default, { redemption: redemption, key: redemption.redeemId, onClickRow: _this._onClickRow }));
      }

      return redemptionList;
    }, _this._onClickSeeMore = function () {
      _this.props.seeMore(_this.props.customerDetail.id);
    }, _this._onClickRow = function (data) {
      _this.props.onClickHistory(data);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RedeemHistory, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;


      return React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header2' },
          'Redeem History'
        ),
        customerDetail && customerDetail.redemptions && customerDetail.redemptions.content && customerDetail.redemptions.content.length ? React.createElement(
          'table',
          { style: { marginBottom: '0px' }, className: 'table mk-table-fixed mk-table-clickable moka-table-details' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: 'col-md-3' },
                'Date'
              ),
              React.createElement(
                'th',
                { className: 'col-md-7' },
                'Reward'
              ),
              React.createElement(
                'th',
                { className: 'col-md-2 text-right' },
                'Point'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            this._getRedemptionRowsView(customerDetail.redemptions),
            customerDetail.redemptions.total_elements > RedeemHistory.maximumRedemptionsToShow && React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { onClick: this._onClickSeeMore, className: _style2.default['see-more'] + ' col-md-2' },
                '+ See More'
              )
            )
          )
        ) : React.createElement(
          'div',
          { className: '' + _style2.default['no-redeem-histories'] },
          ' ',
          React.createElement(
            'i',
            null,
            'No redeem history'
          ),
          ' '
        )
      );
    }
  }]);
  return RedeemHistory;
}(React.Component);

RedeemHistory.maximumRedemptionsToShow = 5;


RedeemHistory.propTypes = {
  customerDetail: React.PropTypes.object,
  seeMore: React.PropTypes.func,
  onClickHistory: React.PropTypes.func
};

exports.default = RedeemHistory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedeemHistoryRow = function (_Component) {
  (0, _inherits3.default)(RedeemHistoryRow, _Component);

  function RedeemHistoryRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RedeemHistoryRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RedeemHistoryRow.__proto__ || (0, _getPrototypeOf2.default)(RedeemHistoryRow)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function () {
      var redemption = _this.props.redemption;

      _this.props.onClickRow({
        payment_type: redemption.payment_type.toLowerCase(),
        parent_payment_id: redemption.parent_payment_id
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RedeemHistoryRow, [{
    key: 'render',
    value: function render() {
      var redemption = this.props.redemption;

      return _react2.default.createElement(
        'tr',
        { onClick: this._onClickRow },
        _react2.default.createElement(
          'td',
          { className: 'col-md-3' },
          (0, _formatter.dateFormatter)(redemption.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-md-7' },
          redemption.reward
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-md-2 text-right' },
          (0, _formatter.formatDecimal)(redemption.redeem_points)
        )
      );
    }
  }]);
  return RedeemHistoryRow;
}(_react.Component);

RedeemHistoryRow.propTypes = {
  onClickRow: _react2.default.PropTypes.func
};

exports.default = RedeemHistoryRow;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _ImportingModeModal = __webpack_require__(2062);

var _ImportingModeModal2 = _interopRequireDefault(_ImportingModeModal);

var _list = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportingModeModal = function (_React$Component) {
  (0, _inherits3.default)(ImportingModeModal, _React$Component);

  function ImportingModeModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportingModeModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportingModeModal.__proto__ || (0, _getPrototypeOf2.default)(ImportingModeModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _list.hideImportingModeModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportingModeModal, [{
    key: 'render',
    value: function render() {
      var showImportingModeModal = this.props.showImportingModeModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { onHide: this._onHide, show: showImportingModeModal, dialogClassName: _ImportingModeModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _ImportingModeModal2.default['title-modal'] },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Your customer is in importing mode, you can\'t access customers until importing has finished'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary', onClick: this._onHide },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return ImportingModeModal;
}(React.Component);

function mapStateToProps(state) {
  var showImportingModeModal = state.customers.list.showImportingModeModal;

  return {
    showImportingModeModal: showImportingModeModal
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportingModeModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2063);

var _List2 = _interopRequireDefault(_List);

var _list = __webpack_require__(75);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (customer) {
      _this.props.dispatch((0, _list.customerDetailRequest)(customer, { type: _this.props.type }));
      _this.props.showDetail();
    }, _this._onReachBottom = function () {
      _this.props.closeDetail();
      var _this$props = _this.props,
          customers = _this$props.customers,
          currentPage = _this$props.currentPage,
          dispatch = _this$props.dispatch,
          keyword = _this$props.keyword,
          type = _this$props.type;

      dispatch((0, _list.customersRequest)({ page: currentPage + 1, keyword: keyword, type: type }, customers));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          customers = _props.customers,
          customerDetail = _props.customerDetail;


      return React.createElement(
        'div',
        { className: _List2.default['length-wrapper'] },
        customers.length > 0 && React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: '' + _List2.default.name },
                  'Name'
                ),
                React.createElement(
                  'th',
                  { className: '' + _List2.default['customer-since'] },
                  'Customer Since'
                ),
                React.createElement(
                  'th',
                  { className: '' + _List2.default['member-since'] },
                  'Member Since'
                ),
                React.createElement(
                  'th',
                  { className: '' + _List2.default['points'] },
                  'Points'
                ),
                React.createElement(
                  'th',
                  { className: '' + _List2.default['lifetime'] },
                  'Lifetime Spending'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore(),
                useWindow: false,
                threshold: 10,
                initialLoad: false
              },
              React.createElement(
                'table',
                { className: _List2.default['table-content'] },
                React.createElement(
                  'tbody',
                  null,
                  customers.map(function (customer) {
                    return React.createElement(
                      'tr',
                      { className: '' + (customerDetail && customer.id === customerDetail.id ? _List2.default.selected : ''), onClick: function onClick() {
                          return _this2._onClickRow(customer);
                        } },
                      React.createElement(
                        'td',
                        { className: '' + _List2.default.name },
                        customer.name || customer.email || customer.phone
                      ),
                      React.createElement(
                        'td',
                        { className: '' + _List2.default['customer-since'] },
                        customer.member_since
                      ),
                      React.createElement(
                        'td',
                        { className: '' + _List2.default['member-since'] },
                        customer.loyalty_member_since ? (0, _formatter.dateFormatter)(customer.loyalty_member_since) : ''
                      ),
                      React.createElement(
                        'td',
                        { className: '' + _List2.default['points'] },
                        customer.loyalty_point !== null ? (0, _formatter.formatDecimal)(customer.loyalty_point) : ''
                      ),
                      React.createElement(
                        'td',
                        { className: '' + _List2.default['lifetime'] },
                        (0, _formatter.rupiah)(customer.lifetime_total)
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        customers.length === 0 && React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display', classPath: 'no-data-without-description' })
      );
    }
  }]);
  return List;
}(React.Component);

List.propTypes = {
  customers: React.PropTypes.array,
  customerDetail: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  keyword: React.PropTypes.string
};

function mapStateToProps(state) {
  var _state$customers$list = state.customers.list,
      customers = _state$customers$list.customers,
      customerDetail = _state$customers$list.customerDetail,
      currentPage = _state$customers$list.currentPage,
      totalPage = _state$customers$list.totalPage,
      keyword = _state$customers$list.keyword,
      type = _state$customers$list.type;

  return { customers: customers, customerDetail: customerDetail, currentPage: currentPage, totalPage: totalPage, keyword: keyword, type: type };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(1270);

var _List2 = _interopRequireDefault(_List);

var _list = __webpack_require__(75);

var actCustomerList = _interopRequireWildcard(_list);

var _ActionBar = __webpack_require__(1258);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _importModal = __webpack_require__(1273);

var _importModal2 = _interopRequireDefault(_importModal);

var _importModalError = __webpack_require__(1274);

var _importModalError2 = _interopRequireDefault(_importModalError);

var _ImportingModeModal = __webpack_require__(1269);

var _ImportingModeModal2 = _interopRequireDefault(_ImportingModeModal);

var _Summary = __webpack_require__(1272);

var _Summary2 = _interopRequireDefault(_Summary);

var _reactRedux = __webpack_require__(6);

var _CustomerDetail = __webpack_require__(1259);

var _CustomerDetail2 = _interopRequireDefault(_CustomerDetail);

var _uploaders = __webpack_require__(236);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _pages = __webpack_require__(38);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListLoyalty = function (_React$Component) {
  (0, _inherits3.default)(ListLoyalty, _React$Component);

  function ListLoyalty(props) {
    (0, _classCallCheck3.default)(this, ListLoyalty);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ListLoyalty.__proto__ || (0, _getPrototypeOf2.default)(ListLoyalty)).call(this, props));

    _this._showDetail = function () {
      _this.setState({ showDetail: true });
    };

    _this._closeDetail = function () {
      _this.setState({ showDetail: false });
    };

    _this._onClickTryBtn = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(true));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
    };

    _this._onClickCancelBtnError = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(false));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
    };

    _this._onClickExport = function () {
      var userEmail = _this.props.data.moka.user.email;
      var hasLoyalty = _this.props.data.customers.list.hasLoyalty;

      var filename = 'Customer List - ' + userEmail;
      _this.props.dispatch(actCustomerList.customerExportRequest(filename, hasLoyalty));
    };

    _this._onChangeKeyword = function (keyword) {
      _this.props.dispatch(actCustomerList.customersRequest({
        page: 1,
        keyword: keyword,
        type: _this.props.data.customers.list.type
      }, []));
      _this._closeDetail();
    };

    _this._onChangeType = function (type) {
      _this.props.dispatch(actCustomerList.customersRequest({
        page: 1,
        keyword: _this.props.data.customers.list.keyword,
        type: type
      }, []));
      _this._closeDetail();
    };

    _this._onClickImport = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(true));
    };

    _this._onClickCancelImport = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(false));
    };

    _this._onClickUploadButton = function (file) {
      _this.props.dispatch((0, _uploaders.doImportCustomer)(file, true));
    };

    _this._onClickDownloadTemplate = function () {
      var userEmail = _this.props.data.moka.user.email;
      var filename = 'Customer List - ' + userEmail;
      _this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename));
    };

    _this.state = { showDetail: false };
    return _this;
  }

  (0, _createClass3.default)(ListLoyalty, [{
    key: 'render',
    value: function render() {
      var _props$data$uploaders = this.props.data.uploaders.import,
          showModalImport = _props$data$uploaders.showModalImport,
          showModalErrorImport = _props$data$uploaders.showModalErrorImport,
          messageError = _props$data$uploaders.messageError;
      var showLoadingButton = this.props.data.buttons.showLoadingButton;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;
      var summary = this.props.data.customers.list.summary;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, {
          onClickImport: this._onClickImport,
          onClickExport: this._onClickExport,
          onChangeKeyword: this._onChangeKeyword,
          onChangeType: this._onChangeType
        }),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: this.state.showDetail },
            React.createElement(_Summary2.default, {
              nonLoyaltyMemberTotal: summary.total_customer - summary.total_loyalty_member,
              loyaltyMemberTotal: summary.total_loyalty_member,
              rewardsTotal: summary.total_rewards_redeemed
            }),
            React.createElement(
              'div',
              { style: { top: '116px', position: 'relative' } },
              React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerPage })
            ),
            React.createElement(_List2.default, { showDetail: this._showDetail, closeDetail: this._closeDetail })
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: this.state.showDetail },
            React.createElement(_CustomerDetail2.default, {
              onClickDone: this._closeDetail,
              showRedeemHistory: this.props.showRedeemHistory,
              showPurchaseHistory: this.props.showPurchaseHistory,
              showPointActivity: this.props.showPointActivity
            })
          )
        ),
        React.createElement(_importModal2.default, {
          onShow: showModalImport,
          onHide: this._onClickCancelImport,
          onUpload: this._onClickUploadButton,
          showLoadingButton: showLoadingButton,
          onClickDownloadTemplate: this._onClickDownloadTemplate
        }),
        React.createElement(_importModalError2.default, {
          onShow: showModalErrorImport,
          messageError: messageError,
          onClickTryBtn: this._onClickTryBtn,
          onClickCancelBtnError: this._onClickCancelBtnError
        }),
        React.createElement(_ImportingModeModal2.default, null)
      );
    }
  }]);
  return ListLoyalty;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ListLoyalty);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Summary = __webpack_require__(2064);

var _Summary2 = _interopRequireDefault(_Summary);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Summary = function (_Component) {
  (0, _inherits3.default)(Summary, _Component);

  function Summary() {
    (0, _classCallCheck3.default)(this, Summary);
    return (0, _possibleConstructorReturn3.default)(this, (Summary.__proto__ || (0, _getPrototypeOf2.default)(Summary)).apply(this, arguments));
  }

  (0, _createClass3.default)(Summary, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          nonLoyaltyMemberTotal = _props.nonLoyaltyMemberTotal,
          loyaltyMemberTotal = _props.loyaltyMemberTotal,
          rewardsTotal = _props.rewardsTotal;

      return _react2.default.createElement(
        'div',
        { className: 'col-md-12 ' + _Summary2.default['summary'] },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { style: { padding: '25px 0px 25px 0px' }, className: 'col-md-4 col-sm-4 text-center' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.total },
              (0, _formatter.formatDecimal)(nonLoyaltyMemberTotal)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.title },
              'NON-LOYALTY MEMBER'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '25px 0px 25px 0px' }, className: 'col-md-4 col-sm-4 text-center' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.total },
              (0, _formatter.formatDecimal)(loyaltyMemberTotal)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.title },
              'LOYALTY MEMBER'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '25px 0px 25px 0px' }, className: 'col-md-4 col-sm-4 text-center' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.total },
              (0, _formatter.formatDecimal)(rewardsTotal)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 col-sm-12 ' + _Summary2.default.title },
              'REWARDS REDEEMED'
            )
          )
        )
      );
    }
  }]);
  return Summary;
}(_react.Component);

Summary.propTypes = {
  nonLoyaltyMemberTotal: _react2.default.PropTypes.number,
  loyaltyMemberTotal: _react2.default.PropTypes.number,
  rewardsTotal: _react2.default.PropTypes.number
};

exports.default = Summary;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactDropzoneComponent = __webpack_require__(285);

var _reactDropzoneComponent2 = _interopRequireDefault(_reactDropzoneComponent);

var _server = __webpack_require__(575);

var _server2 = _interopRequireDefault(_server);

__webpack_require__(2066);

__webpack_require__(2065);

var _ImportModal = __webpack_require__(759);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportModal = function (_React$Component) {
  (0, _inherits3.default)(ImportModal, _React$Component);

  function ImportModal(props) {
    (0, _classCallCheck3.default)(this, ImportModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImportModal.__proto__ || (0, _getPrototypeOf2.default)(ImportModal)).call(this, props));

    _this.setShowModalDialog = function () {
      _this.setState({ showInformationDialog: true });
    };

    _this._onClickBtnUpload = function () {
      _this.props.onUpload(_this.state.file);
      _this.setState({ file: null });
    };

    _this._onClickBtnHide = function () {
      _this.props.onHide();
      _this.setState({ file: null });
    };

    _this.validationFile = function (file) {
      return new _promise2.default(function (resolve, reject) {
        var element = $('.progress');
        $(element).css('width', '0%').show();
        /* global FileReader */
        /* is a way for tell eslint that filereader is a global */
        var reader = new FileReader();
        var errorMessage = null;
        reader.readAsText(file);
        reader.onload = function (event) {
          // HACK => because sometimes windows has different code in newline so we change windows new line into universal string newline
          var csv = event.target.result.replace(/\r/g, '\n').replace(/\n\n/g, '\n');
          var resultOBject = $.csv.toArrays(csv);
          var resultLength = resultOBject.length;
          if (resultLength > 2501) {
            // first line is table header. 2500 items is the limit
            errorMessage = 'Please upload less than 2500 items';
          } else if (resultLength === 1) {
            errorMessage = "Customer can't be empty.";
          }
          var MAX_COUNTER = 25;

          var _loop = function _loop(i) {
            setTimeout(function () {
              $(element).css('width', i * (100 / MAX_COUNTER) + '%');
              if (i === MAX_COUNTER) {
                if (errorMessage) {
                  reject(errorMessage);
                } else {
                  resolve(true);
                }
                $(element).css('width', '0%');
              }
            }, i * 100);
          };

          for (var i = 1; i <= MAX_COUNTER; i++) {
            _loop(i);
          }
        };
      });
    };

    _this.hideInformationDialog = function () {
      _this.setState({ showInformationDialog: false, errorDescription: '', file: null });
    };

    _this.state = {
      showInformationDialog: false,
      errorDescription: '',
      file: null
    };
    return _this;
  }

  (0, _createClass3.default)(ImportModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showLoadingButton = _props.showLoadingButton,
          onClickDownloadTemplate = _props.onClickDownloadTemplate;

      var statusButton = showLoadingButton ? 'active' : '';
      var copyThis = this;
      var componentConfig = {
        iconFiletypes: ['.csv'],
        showFiletypeIcon: true,
        postUrl: 'no-url',
        uploadMultiple: false
      };
      var djsConfig = {
        previewTemplate: _server2.default.renderToStaticMarkup(React.createElement(
          'div',
          { className: _ImportModal2.default['preview-import'] },
          React.createElement(
            'div',
            { className: 'dz-preview dz-file-preview' },
            React.createElement(
              'div',
              { className: 'dz-details' },
              React.createElement(
                'div',
                { className: 'dz-file-remove' },
                React.createElement(
                  'a',
                  { href: '#', 'data-dz-remove': true },
                  React.createElement('span', { className: 'glyphicon glyphicon-remove-sign' })
                )
              ),
              React.createElement(
                'div',
                { className: 'dz-filename' },
                React.createElement('span', { 'data-dz-name': true })
              ),
              React.createElement(
                'strong',
                null,
                React.createElement('div', { className: 'dz-size', 'data-dz-size': true })
              ),
              React.createElement(
                'div',
                { className: 'progress' },
                React.createElement('div', { className: 'progress-bar progress-bar-success progress-bar-striped',
                  role: 'progressbar',
                  'aria-valuenow': '40', 'aria-valuemin': '0', 'aria-valuemax': '100' })
              ),
              React.createElement('img', { 'data-dz-thumbnail': true })
            )
          )
        )),
        autoProcessQueue: false,
        acceptedFiles: '.csv',
        uploadMultiple: false,
        init: function init() {
          this.on('addedfile', function (file) {
            if (copyThis.state.file) {
              this.removeFile(copyThis.state.file);
              copyThis.setState({ file: null });
            }
            copyThis.setState({
              file: file,
              act: ImportModal.VALIDATING
            });
            copyThis.validationFile(file).then(function (resolve) {
              copyThis.setState({ file: file });
            }).catch(function (reject) {
              copyThis.props.changeModalVisibility();
              copyThis.setState({ showInformationDialog: true, errorDescription: 'Error : ' + reject });
            });
          });

          this.on('removedfile', function (file) {
            copyThis.setState({ file: null });
          });

          this.on('error', function (file) {
            if (!file.accepted) {
              copyThis.setState({ showInformationDialog: true, errorDescription: 'Error: Only allowed CSV files' });
              this.removeFile(file);
              copyThis.setState({ file: null });
            }
          });
        }

      };

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: this.props.onShow, bsClass: 'modal-import- modal', backdrop: true },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              null,
              ' Import Customers'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: 'modal-body no-padding' },
            React.createElement(
              'div',
              { className: 'customer-body' },
              React.createElement(
                'div',
                { className: 'customer-scroll' },
                React.createElement(
                  'div',
                  { className: 'mk-col-right-box right-modal-customer' },
                  React.createElement(
                    'div',
                    { className: _ImportModal2.default['description'] + ' text-left' },
                    React.createElement(
                      'a',
                      { className: 'download-our-template', onClick: onClickDownloadTemplate },
                      'Download Our Template'
                    ),
                    ' file and add your customer information to upload customers in bulk. To optimize performance, we can only process 2500 items at a time. If you have any questions on how to bulk import your customers, please send an email to support@mokapos.com.'
                  ),
                  showLoadingButton ? React.createElement(
                    'div',
                    { className: 'box-dropzone box-dropzone-when-upload' },
                    React.createElement(
                      'h3',
                      null,
                      'Uploading is in progress...'
                    )
                  ) : React.createElement(
                    'div',
                    { className: 'box-dropzone' },
                    React.createElement(
                      _reactDropzoneComponent2.default,
                      {
                        className: _ImportModal2.default['dropzone-area'],
                        config: componentConfig,
                        djsConfig: djsConfig
                      },
                      React.createElement('div', { className: 'dz-default dz-message' })
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { className: 'pull-left', onClick: this._onClickBtnHide, disabled: showLoadingButton },
              'Cancel'
            ),
            showLoadingButton ? React.createElement(
              'button',
              { className: 'btn btn-primary has-spinner pull-right ' + statusButton, disabled: !this.state.file },
              React.createElement('span', { className: 'glyphicon glyphicon-repeat normal-right-spinner' }),
              'Upload'
            ) : React.createElement(
              'button',
              { className: 'btn btn-primary has-spinner pull-right', onClick: this._onClickBtnUpload, disabled: !this.state.file },
              'Upload'
            )
          )
        ),
        React.createElement(
          _reactBootstrap.Modal,
          { bsClass: 'modal-import- modal', show: this.state.showInformationDialog },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              { bsClass: _ImportModal2.default['information-modal'], componentClass: 'div' },
              'Information'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(
              'p',
              null,
              this.state.errorDescription
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  _this2.hideInformationDialog();
                  _this2.props.changeModalVisibility();
                } },
              'Ok'
            )
          )
        )
      );
    }
  }]);
  return ImportModal;
}(React.Component);

exports.default = ImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ImportModal = __webpack_require__(759);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportModalError = function (_React$Component) {
  (0, _inherits3.default)(ImportModalError, _React$Component);

  function ImportModalError() {
    (0, _classCallCheck3.default)(this, ImportModalError);
    return (0, _possibleConstructorReturn3.default)(this, (ImportModalError.__proto__ || (0, _getPrototypeOf2.default)(ImportModalError)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImportModalError, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          messageError = _props.messageError,
          onShow = _props.onShow,
          onClickTryBtn = _props.onClickTryBtn,
          onClickCancelBtnError = _props.onClickCancelBtnError;


      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: onShow, bsClass: 'modal-import modal', id: 'modalImportError', backdrop: true },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              null,
              'Import Errors'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: 'modal-body no-padding' },
            React.createElement(
              'div',
              { className: 'customer-body' },
              React.createElement(
                'div',
                { className: 'customer-scroll' },
                React.createElement(
                  'div',
                  { className: 'mk-col-right-box right-modal-customer' },
                  React.createElement(
                    'div',
                    { className: _ImportModal2.default['description'] + ' text-left' },
                    'We Found ',
                    messageError.length,
                    ' errors in your file. Please correct them and re-upload your file.'
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'ol',
                      null,
                      messageError.map(function (message, i) {
                        return React.createElement(
                          'li',
                          { key: i },
                          React.createElement(
                            'span',
                            { className: _ImportModal2.default['list-type'] },
                            i + 1,
                            '. '
                          ),
                          React.createElement(
                            'strong',
                            { className: 'text-error' },
                            React.createElement(
                              'span',
                              { className: 'text-red' },
                              (0, _stringify2.default)(message)
                            )
                          )
                        );
                      })
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-default pull-left', onClick: onClickCancelBtnError },
              'Cancel'
            ),
            React.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-primary pull-right', onClick: onClickTryBtn },
              'Try Again'
            )
          )
        )
      );
    }
  }]);
  return ImportModalError;
}(React.Component);

exports.default = ImportModalError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(2067);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reactBootstrap = __webpack_require__(10);

var _list = __webpack_require__(75);

var _reduxForm = __webpack_require__(7);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _loadingSpinner = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeKeyword = function (event, keyword) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _list.setCustomers)([]));
      dispatch((0, _loadingSpinner.showPageLoadingSpinner)(true));
      dispatch((0, _list.customersRequest)({
        page: 1,
        keyword: keyword.trim()
      }, []));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClickImport = _props.onClickImport,
          onClickExport = _props.onClickExport;


      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-3 col-xs-4' },
            React.createElement(_reduxForm.Field, {
              name: 'keyword',
              component: _SearchBar2.default,
              onChange: this._onChangeKeyword,
              placeholder: 'Name, email, phone',
              className: 'searchbar-customerlist'
            })
          ),
          React.createElement(
            'div',
            { className: 'col-sm-6 col-xs-4 pull-right' },
            React.createElement(
              'div',
              { className: 'pull-right' },
              React.createElement(
                _reactBootstrap.DropdownButton,
                { title: 'Import / Export', bsStyle: 'primary' },
                React.createElement(
                  _reactBootstrap.MenuItem,
                  { onSelect: onClickImport },
                  'Import Customer'
                ),
                React.createElement(_reactBootstrap.MenuItem, { divider: true }),
                React.createElement(
                  _reactBootstrap.MenuItem,
                  { onSelect: onClickExport },
                  'Export Customer'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

ActionBar.propTypes = {};

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        list: state.customers.list
      }
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CustomerInfo = __webpack_require__(1278);

var _CustomerInfo2 = _interopRequireDefault(_CustomerInfo);

var _CustomerHighlight = __webpack_require__(1277);

var _CustomerHighlight2 = _interopRequireDefault(_CustomerHighlight);

var _PurchaseHistory = __webpack_require__(1279);

var _PurchaseHistory2 = _interopRequireDefault(_PurchaseHistory);

var _reactRedux = __webpack_require__(6);

var _style = __webpack_require__(327);

var _style2 = _interopRequireDefault(_style);

var _list = __webpack_require__(75);

var _ReceiptInvoices = __webpack_require__(299);

var _ReceiptInvoices2 = _interopRequireDefault(_ReceiptInvoices);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerDetail = function (_React$Component) {
  (0, _inherits3.default)(CustomerDetail, _React$Component);

  function CustomerDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomerDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomerDetail.__proto__ || (0, _getPrototypeOf2.default)(CustomerDetail)).call.apply(_ref, [this].concat(args))), _this), _this._openReceipt = function (payment) {
      var customerDetail = _this.props.data.customers.list.customerDetail;

      _this.props.dispatch((0, _list.receiptCustomerRequest)(payment, customerDetail));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomerDetail, [{
    key: 'render',
    value: function render() {
      var onClickDone = this.props.onClickDone;
      var _props$data$customers = this.props.data.customers.list,
          customerDetail = _props$data$customers.customerDetail,
          receiptData = _props$data$customers.receiptData;


      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          'div',
          { className: _style2.default['col-right-inner'] },
          React.createElement(
            'div',
            { className: _style2.default['scrolled-area'] },
            React.createElement(
              'div',
              { className: 'customer-info-box-container', id: 'customer-detail' },
              React.createElement(_CustomerInfo2.default, { customerDetail: customerDetail }),
              React.createElement(_CustomerHighlight2.default, { customerDetail: customerDetail }),
              React.createElement(_PurchaseHistory2.default, {
                customerDetail: customerDetail,
                onClickHistory: this._openReceipt
              })
            ),
            receiptData && receiptData.payment_type === 'invoice' && React.createElement(
              'div',
              { id: 'receipt-invoice-customer' },
              React.createElement(_ReceiptInvoices2.default, { invoiceDetail: receiptData })
            ),
            receiptData && receiptData.payment_type !== 'invoice' && React.createElement(
              'div',
              { id: 'receipt-transaction-customer', className: _style2.default['receipt-trx-container'] },
              React.createElement(_TransactionDetailReceipt2.default, { paymentDetail: receiptData })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _style2.default['mk-col-right-action-box-bottom'] },
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right', onClick: onClickDone },
            'Done'
          )
        )
      );
    }
  }]);
  return CustomerDetail;
}(React.Component);

CustomerDetail.propTypes = {
  onClickDone: React.PropTypes.func
};

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        list: state.customers.list
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CustomerDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _style = __webpack_require__(327);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerHighlight = function (_React$Component) {
  (0, _inherits3.default)(CustomerHighlight, _React$Component);

  function CustomerHighlight() {
    (0, _classCallCheck3.default)(this, CustomerHighlight);
    return (0, _possibleConstructorReturn3.default)(this, (CustomerHighlight.__proto__ || (0, _getPrototypeOf2.default)(CustomerHighlight)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomerHighlight, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;


      return customerDetail && React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header2' },
          'Customer Highlights'
        ),
        React.createElement(
          'div',
          { className: 'info-highlight' },
          React.createElement(
            'table',
            { className: 'customer-highlight' },
            React.createElement(
              'tbody',
              { className: _style2.default['no-hover'] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { rowSpan: '2' },
                  React.createElement(
                    'div',
                    { className: 'value truncate' },
                    customerDetail.orders
                  ),
                  React.createElement(
                    'div',
                    { className: 'label ' + _style2.default['label-transaction'] },
                    'Transactions'
                  )
                ),
                React.createElement(
                  'td',
                  null,
                  React.createElement(
                    'div',
                    { className: 'value truncate' },
                    (0, _formatter.rupiah)(customerDetail.lifetime_total)
                  ),
                  React.createElement(
                    'div',
                    { className: 'label' },
                    'Lifetime Amount'
                  )
                ),
                React.createElement(
                  'td',
                  null,
                  React.createElement(
                    'div',
                    { className: 'value truncate' },
                    (0, _formatter.rupiah)(customerDetail.average_amount)
                  ),
                  React.createElement(
                    'div',
                    { className: 'label' },
                    'Average Amount'
                  )
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  null,
                  React.createElement(
                    'div',
                    { className: 'value truncate' },
                    customerDetail.member_since
                  ),
                  React.createElement(
                    'div',
                    { className: 'label' },
                    'Customer Since'
                  )
                ),
                React.createElement(
                  'td',
                  null,
                  React.createElement(
                    'div',
                    { className: 'value truncate' },
                    customerDetail.last_visit
                  ),
                  React.createElement(
                    'div',
                    { className: 'label' },
                    'Last Visit'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CustomerHighlight;
}(React.Component);

CustomerHighlight.propTypes = {
  customerDetail: React.PropTypes.object
};

exports.default = CustomerHighlight;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(327);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerInfo = function (_React$Component) {
  (0, _inherits3.default)(CustomerInfo, _React$Component);

  function CustomerInfo() {
    (0, _classCallCheck3.default)(this, CustomerInfo);
    return (0, _possibleConstructorReturn3.default)(this, (CustomerInfo.__proto__ || (0, _getPrototypeOf2.default)(CustomerInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomerInfo, [{
    key: 'render',
    value: function render() {
      var customerDetail = this.props.customerDetail;


      return customerDetail && React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header ' + _style2.default['header-name'] },
          customerDetail.name || customerDetail.email || customerDetail.phone
        ),
        React.createElement(
          'div',
          { className: 'info-profile' },
          React.createElement(
            'table',
            null,
            React.createElement(
              'tbody',
              { className: _style2.default['no-hover'] },
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  'Address'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left wrap-customer-address ' + _style2.default.address },
                  customerDetail.address
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  'Phone'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  customerDetail.phone
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  'Email'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left ' + _style2.default.email },
                  customerDetail.email
                )
              ),
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  'Birthday'
                ),
                React.createElement(
                  'td',
                  { className: 'text-left' },
                  customerDetail.birthday
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CustomerInfo;
}(React.Component);

CustomerInfo.propTypes = {
  customerDetail: React.PropTypes.object
};

exports.default = CustomerInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

var _style = __webpack_require__(327);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseHistory = function (_React$Component) {
  (0, _inherits3.default)(PurchaseHistory, _React$Component);

  function PurchaseHistory() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PurchaseHistory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseHistory.__proto__ || (0, _getPrototypeOf2.default)(PurchaseHistory)).call.apply(_ref, [this].concat(args))), _this), _this._purchaseHistoryTotalFormatter = function (payment) {
      var amount = payment.is_refunded ? (0, _formatter.rupiah)(parseFloat(payment.refund_amount).toFixed(0)) : (0, _formatter.rupiah)(parseFloat(payment.total_collected).toFixed(0));

      if (payment.is_refunded) {
        amount = '(' + amount + ')';
      }

      return amount;
    }, _this._onClickRowHistory = function (payment) {
      _this.props.onClickHistory(payment);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PurchaseHistory, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var customerDetail = this.props.customerDetail;


      return customerDetail && React.createElement(
        'div',
        { className: 'customer-info-box' },
        React.createElement(
          'div',
          { className: 'header2' },
          'Purchase History'
        ),
        React.createElement(
          'table',
          { className: 'table mk-table-fixed mk-table-clickable moka-table-details', id: 'purchase-history-table' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Date'
              ),
              React.createElement(
                'th',
                null,
                'Outlet'
              ),
              React.createElement(
                'th',
                { className: 'text-right' },
                'Sale'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            customerDetail.payments.length > 0 && customerDetail.payments.map(function (payment, idx) {
              return React.createElement(
                'tr',
                { key: idx, onClick: function onClick() {
                    return _this2._onClickRowHistory(payment);
                  } },
                React.createElement(
                  'td',
                  null,
                  (0, _moment2.default)(payment.created_at).format('DD/MM/YYYY')
                ),
                React.createElement(
                  'td',
                  { className: _style2.default['col-outlet'] },
                  payment.outlet_name
                ),
                React.createElement(
                  'td',
                  { className: 'text-right ' + _style2.default['col-sale'] },
                  _this2._purchaseHistoryTotalFormatter(payment)
                )
              );
            })
          )
        )
      );
    }
  }]);
  return PurchaseHistory;
}(React.Component);

PurchaseHistory.propTypes = {
  customerDetail: React.PropTypes.object,
  onClickHistory: React.PropTypes.func
};

exports.default = PurchaseHistory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(1282);

var _List2 = _interopRequireDefault(_List);

var _list = __webpack_require__(75);

var actCustomerList = _interopRequireWildcard(_list);

var _ActionBar = __webpack_require__(1275);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _importModal = __webpack_require__(1283);

var _importModal2 = _interopRequireDefault(_importModal);

var _importModalError = __webpack_require__(1284);

var _importModalError2 = _interopRequireDefault(_importModalError);

var _reactRedux = __webpack_require__(6);

var _CustomerList = __webpack_require__(2068);

var _CustomerList2 = _interopRequireDefault(_CustomerList);

var _CustomerDetail = __webpack_require__(1276);

var _CustomerDetail2 = _interopRequireDefault(_CustomerDetail);

var _uploaders = __webpack_require__(236);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _ImportingModeModal = __webpack_require__(1281);

var _ImportingModeModal2 = _interopRequireDefault(_ImportingModeModal);

var _reactRouter = __webpack_require__(15);

var _list2 = __webpack_require__(450);

var mpCustomerList = _interopRequireWildcard(_list2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerList = function (_React$Component) {
  (0, _inherits3.default)(CustomerList, _React$Component);

  function CustomerList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomerList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomerList.__proto__ || (0, _getPrototypeOf2.default)(CustomerList)).call.apply(_ref, [this].concat(args))), _this), _this._onClickTryBtn = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(true));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
    }, _this._onClickCancelBtnError = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(false));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
    }, _this._onClickExport = function () {
      var userEmail = _this.props.data.moka.user.email;
      var filename = 'Customer List - ' + userEmail;
      mpCustomerList.customerListExport();
      _this.props.dispatch(actCustomerList.customerExportRequest(filename));
    }, _this._onClickImport = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(true));
    }, _this._onClickCancelImport = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(false));
    }, _this._onClickUploadButton = function (file) {
      _this.props.dispatch((0, _uploaders.doImportCustomer)(file));
    }, _this._changeModalVisibility = function () {
      var showModalImport = _this.props.data.uploaders.import.showModalImport;

      _this.props.dispatch(actCustomerList.changeModalVisibility(!showModalImport));
    }, _this._closeCustomerDetail = function () {
      if ($('#customer-detail').is(':visible')) {
        _this.props.dispatch(actCustomerList.closeCustomerDetail()); // back to list customers
      } else {
        // back to customer detail
        $('#receipt-invoice-customer').hide();
        $('#receipt-transaction-customer').hide();
        $('#customer-detail').show();
      }
    }, _this._onClickDownloadTemplate = function () {
      var userEmail = _this.props.data.moka.user.email;
      var filename = 'Customer List - ' + userEmail;
      _this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomerList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      var expireTime = 365; // expire time 1 year
      if (!expired) {
        this.props.dispatch(actCustomerList.pageRequest());
        if (Cookies.get('labelNew') === 'true') {
          Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
        }
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$uploaders = this.props.data.uploaders.import,
          showModalImport = _props$data$uploaders.showModalImport,
          showModalErrorImport = _props$data$uploaders.showModalErrorImport,
          messageError = _props$data$uploaders.messageError;
      var showLoadingButton = this.props.data.buttons.showLoadingButton;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;
      var customers = this.props.data.customers.list.customers;


      return React.createElement(
        'div',
        { id: 'customer-list', className: _CustomerList2.default.wrapper },
        React.createElement(_ActionBar2.default, {
          onClickImport: this._onClickImport,
          onClickExport: this._onClickExport
        }),
        React.createElement(
          'div',
          { className: 'row ' + _CustomerList2.default['mk-customer-list'] },
          React.createElement(
            'div',
            { className: 'col-sm-12 col-md-12 ' + _CustomerList2.default['left-column'], id: 'mk-col-left' },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: customers.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 ' + _CustomerList2.default['right-column'], id: 'mk-col-right' },
            React.createElement(_CustomerDetail2.default, {
              onClickDone: this._closeCustomerDetail
            })
          )
        ),
        React.createElement(_importModal2.default, {
          onShow: showModalImport,
          onHide: this._onClickCancelImport,
          onUpload: this._onClickUploadButton,
          showLoadingButton: showLoadingButton,
          onClickDownloadTemplate: this._onClickDownloadTemplate,
          changeModalVisibility: this._changeModalVisibility
        }),
        React.createElement(_importModalError2.default, {
          onShow: showModalErrorImport,
          messageError: messageError,
          onClickTryBtn: this._onClickTryBtn,
          onClickCancelBtnError: this._onClickCancelBtnError,
          onClickDownloadTemplate: this._onClickDownloadTemplate
        }),
        React.createElement(_ImportingModeModal2.default, null)
      );
    }
  }]);
  return CustomerList;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CustomerList);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43), __webpack_require__(65)))

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _ImportingModeModal = __webpack_require__(2069);

var _ImportingModeModal2 = _interopRequireDefault(_ImportingModeModal);

var _list = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportingModeModal = function (_React$Component) {
  (0, _inherits3.default)(ImportingModeModal, _React$Component);

  function ImportingModeModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportingModeModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportingModeModal.__proto__ || (0, _getPrototypeOf2.default)(ImportingModeModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _list.hideImportingModeModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportingModeModal, [{
    key: 'render',
    value: function render() {
      var showImportingModeModal = this.props.showImportingModeModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { onHide: this._onHide, show: showImportingModeModal, dialogClassName: _ImportingModeModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _ImportingModeModal2.default['title-modal'] },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Your customer is in importing mode, you can\'t access customers until importing has finished'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'div',
            null,
            React.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary', onClick: this._onHide },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return ImportingModeModal;
}(React.Component);

function mapStateToProps(state) {
  var showImportingModeModal = state.customers.list.showImportingModeModal;

  return {
    showImportingModeModal: showImportingModeModal
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportingModeModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _formatter = __webpack_require__(11);

var _List = __webpack_require__(2070);

var _List2 = _interopRequireDefault(_List);

var _list = __webpack_require__(75);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (customer) {
      _this.props.dispatch((0, _list.customerDetailRequest)(customer));
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          customers = _this$props.customers,
          currentPage = _this$props.currentPage,
          dispatch = _this$props.dispatch,
          keyword = _this$props.keyword;

      dispatch((0, _list.customersRequest)({ page: currentPage + 1, keyword: keyword }, customers));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          customers = _props.customers,
          customerDetail = _props.customerDetail;


      return React.createElement(
        'div',
        { className: _List2.default['length-wrapper'] },
        customers.length > 0 && React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: _List2.default.name },
                  'Name'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['customer-since'] },
                  'Customer Since'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['this-month'] },
                  'This Month'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['this-year'] },
                  'This Year'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['lifetime'] },
                  'Lifetime'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore(),
                useWindow: false,
                threshold: 10,
                initialLoad: false
              },
              React.createElement(
                'table',
                { className: _List2.default['table-content'] },
                React.createElement(
                  'tbody',
                  null,
                  customers.map(function (customer) {
                    return React.createElement(
                      'tr',
                      { className: '' + (customerDetail && customer.id === customerDetail.id ? _List2.default.selected : ''), onClick: function onClick() {
                          return _this2._onClickRow(customer);
                        } },
                      React.createElement(
                        'td',
                        { className: _List2.default.name },
                        customer.name || customer.email || customer.phone
                      ),
                      React.createElement(
                        'td',
                        { className: _List2.default['customer-since'] },
                        customer.member_since
                      ),
                      React.createElement(
                        'td',
                        { className: _List2.default['this-month'] },
                        (0, _formatter.rupiahWithNegative)(customer.this_month_total)
                      ),
                      React.createElement(
                        'td',
                        { className: _List2.default['this-year'] },
                        (0, _formatter.rupiahWithNegative)(customer.this_year_total)
                      ),
                      React.createElement(
                        'td',
                        { className: _List2.default['lifetime'] },
                        (0, _formatter.rupiahWithNegative)(customer.lifetime_total)
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

List.propTypes = {
  customers: React.PropTypes.array,
  customerDetail: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  keyword: React.PropTypes.string
};

function mapStateToProps(state) {
  var _state$customers$list = state.customers.list,
      customers = _state$customers$list.customers,
      customerDetail = _state$customers$list.customerDetail,
      currentPage = _state$customers$list.currentPage,
      totalPage = _state$customers$list.totalPage,
      keyword = _state$customers$list.keyword;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return { customers: customers, customerDetail: customerDetail, currentPage: currentPage, totalPage: totalPage, keyword: keyword, showLoadingSpinnerPage: showLoadingSpinnerPage };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactDropzoneComponent = __webpack_require__(285);

var _reactDropzoneComponent2 = _interopRequireDefault(_reactDropzoneComponent);

var _server = __webpack_require__(575);

var _server2 = _interopRequireDefault(_server);

__webpack_require__(2072);

__webpack_require__(2071);

var _ImportModal = __webpack_require__(760);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportModal = function (_React$Component) {
  (0, _inherits3.default)(ImportModal, _React$Component);

  function ImportModal(props) {
    (0, _classCallCheck3.default)(this, ImportModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImportModal.__proto__ || (0, _getPrototypeOf2.default)(ImportModal)).call(this, props));

    _this.setShowModalDialog = function () {
      _this.setState({ showInformationDialog: true });
    };

    _this._onClickBtnUpload = function () {
      _this.props.onUpload(_this.state.file);
      _this.setState({ file: null });
    };

    _this._onClickBtnHide = function () {
      _this.props.onHide();
      _this.setState({ file: null });
    };

    _this.validationFile = function (file) {
      return new _promise2.default(function (resolve, reject) {
        var element = $('.progress');
        $(element).css('width', '0%').show();
        /* global FileReader */
        /* is a way for tell eslint that filereader is a global */
        var reader = new FileReader();
        var errorMessage = null;
        reader.readAsText(file);
        reader.onload = function (event) {
          // HACK => because sometimes windows has different code in newline so we change windows new line into universal string newline
          var csv = event.target.result.replace(/\r/g, '\n').replace(/\n\n/g, '\n');
          var resultOBject = $.csv.toArrays(csv);
          var resultLength = resultOBject.length;
          if (resultLength > 2501) {
            // first line is table header. 2500 items is the limit
            errorMessage = 'Please upload less than 2500 items';
          } else if (resultLength === 1) {
            errorMessage = "Customer can't be empty.";
          }
          var MAX_COUNTER = 25;

          var _loop = function _loop(i) {
            setTimeout(function () {
              $(element).css('width', i * (100 / MAX_COUNTER) + '%');
              if (i === MAX_COUNTER) {
                if (errorMessage) {
                  reject(errorMessage);
                } else {
                  resolve(true);
                }
                $(element).css('width', '0%');
              }
            }, i * 100);
          };

          for (var i = 1; i <= MAX_COUNTER; i++) {
            _loop(i);
          }
        };
      });
    };

    _this.hideInformationDialog = function () {
      _this.setState({ showInformationDialog: false, errorDescription: '', file: null });
    };

    _this.state = {
      showInformationDialog: false,
      errorDescription: '',
      file: null
    };
    return _this;
  }

  (0, _createClass3.default)(ImportModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showLoadingButton = _props.showLoadingButton,
          onClickDownloadTemplate = _props.onClickDownloadTemplate;

      var statusButton = showLoadingButton ? 'active' : '';
      var copyThis = this;
      var componentConfig = {
        iconFiletypes: ['.csv'],
        showFiletypeIcon: true,
        postUrl: 'no-url',
        uploadMultiple: false
      };
      var djsConfig = {
        previewTemplate: _server2.default.renderToStaticMarkup(React.createElement(
          'div',
          { className: _ImportModal2.default['preview-import'] },
          React.createElement(
            'div',
            { className: 'dz-preview dz-file-preview' },
            React.createElement(
              'div',
              { className: 'dz-details' },
              React.createElement(
                'div',
                { className: 'dz-file-remove' },
                React.createElement(
                  'a',
                  { href: '#', 'data-dz-remove': true },
                  React.createElement('span', { className: 'glyphicon glyphicon-remove-sign' })
                )
              ),
              React.createElement(
                'div',
                { className: 'dz-filename' },
                React.createElement('span', { 'data-dz-name': true })
              ),
              React.createElement(
                'strong',
                null,
                React.createElement('div', { className: 'dz-size', 'data-dz-size': true })
              ),
              React.createElement(
                'div',
                { className: 'progress' },
                React.createElement('div', { className: 'progress-bar progress-bar-success progress-bar-striped',
                  role: 'progressbar',
                  'aria-valuenow': '40', 'aria-valuemin': '0', 'aria-valuemax': '100' })
              ),
              React.createElement('img', { 'data-dz-thumbnail': true })
            )
          )
        )),
        autoProcessQueue: false,
        acceptedFiles: '.csv',
        uploadMultiple: false,
        init: function init() {
          this.on('addedfile', function (file) {
            if (copyThis.state.file) {
              this.removeFile(copyThis.state.file);
              copyThis.setState({ file: null });
            }
            copyThis.setState({
              file: file,
              act: ImportModal.VALIDATING
            });
            copyThis.validationFile(file).then(function (resolve) {
              copyThis.setState({ file: file });
            }).catch(function (reject) {
              copyThis.props.changeModalVisibility();
              copyThis.setState({ showInformationDialog: true, errorDescription: 'Error : ' + reject });
            });
          });

          this.on('removedfile', function (file) {
            copyThis.setState({ file: null });
          });

          this.on('error', function (file) {
            if (!file.accepted) {
              copyThis.setState({ showInformationDialog: true, errorDescription: 'Error: Only allowed CSV files' });
              this.removeFile(file);
              copyThis.setState({ file: null });
            }
          });
        }

      };

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: this.props.onShow, bsClass: 'modal-import- modal', backdrop: true },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              null,
              ' Import Customers'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: 'modal-body no-padding' },
            React.createElement(
              'div',
              { className: 'customer-body' },
              React.createElement(
                'div',
                { className: 'customer-scroll' },
                React.createElement(
                  'div',
                  { className: 'mk-col-right-box right-modal-customer' },
                  React.createElement(
                    'div',
                    { className: _ImportModal2.default['description'] + ' text-left' },
                    React.createElement(
                      'a',
                      { className: 'download-our-template', onClick: onClickDownloadTemplate },
                      'Download Our Template'
                    ),
                    ' file and add your customer information to upload customers in bulk. To optimize performance, we can only process 2500 items at a time. If you have any questions on how to bulk import your customers, please send an email to support@mokapos.com.'
                  ),
                  showLoadingButton ? React.createElement(
                    'div',
                    { className: 'box-dropzone box-dropzone-when-upload' },
                    React.createElement(
                      'h3',
                      null,
                      'Uploading is in progress...'
                    )
                  ) : React.createElement(
                    'div',
                    { className: 'box-dropzone' },
                    React.createElement(
                      _reactDropzoneComponent2.default,
                      {
                        className: _ImportModal2.default['dropzone-area'],
                        config: componentConfig,
                        djsConfig: djsConfig
                      },
                      React.createElement('div', { className: 'dz-default dz-message' })
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { className: 'pull-left', onClick: this._onClickBtnHide, disabled: showLoadingButton },
              'Cancel'
            ),
            showLoadingButton ? React.createElement(
              'button',
              { className: 'btn btn-primary has-spinner pull-right ' + statusButton, disabled: !this.state.file },
              React.createElement('span', { className: 'glyphicon glyphicon-repeat normal-right-spinner' }),
              'Upload'
            ) : React.createElement(
              'button',
              { className: 'btn btn-primary has-spinner pull-right', onClick: this._onClickBtnUpload, disabled: !this.state.file },
              'Upload'
            )
          )
        ),
        React.createElement(
          _reactBootstrap.Modal,
          { bsClass: 'modal-import- modal', show: this.state.showInformationDialog },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              { bsClass: _ImportModal2.default['information-modal'], componentClass: 'div' },
              'Information'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(
              'p',
              null,
              this.state.errorDescription
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  _this2.hideInformationDialog();
                  _this2.props.changeModalVisibility();
                } },
              'Ok'
            )
          )
        )
      );
    }
  }]);
  return ImportModal;
}(React.Component);

exports.default = ImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ImportModal = __webpack_require__(760);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportModalError = function (_React$Component) {
  (0, _inherits3.default)(ImportModalError, _React$Component);

  function ImportModalError() {
    (0, _classCallCheck3.default)(this, ImportModalError);
    return (0, _possibleConstructorReturn3.default)(this, (ImportModalError.__proto__ || (0, _getPrototypeOf2.default)(ImportModalError)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImportModalError, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          messageError = _props.messageError,
          onShow = _props.onShow,
          onClickTryBtn = _props.onClickTryBtn,
          onClickCancelBtnError = _props.onClickCancelBtnError,
          onClickDownloadTemplate = _props.onClickDownloadTemplate;


      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: onShow, bsClass: 'modal-import modal', id: 'modalImportError', backdrop: true },
          React.createElement(
            _reactBootstrap.Modal.Header,
            null,
            React.createElement(
              _reactBootstrap.Modal.Title,
              null,
              'Import Errors'
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: 'modal-body no-padding' },
            React.createElement(
              'div',
              { className: 'customer-body' },
              React.createElement(
                'div',
                { className: 'customer-scroll' },
                React.createElement(
                  'div',
                  { className: 'mk-col-right-box right-modal-customer' },
                  messageError && React.createElement(
                    'div',
                    { className: _ImportModal2.default['description'] + ' text-left' },
                    'We Found ',
                    messageError.length,
                    ' errors in your file. Please correct them and re-upload your file.'
                  ),
                  !messageError && React.createElement(
                    'div',
                    { className: _ImportModal2.default['description'] + ' text-left' },
                    'Do not change the format of the template. Please ',
                    React.createElement(
                      'a',
                      { className: 'download-our-template', onClick: onClickDownloadTemplate },
                      're-download'
                    ),
                    ' the template and use the original format.'
                  ),
                  messageError && React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'ol',
                      null,
                      messageError.map(function (message, i) {
                        return React.createElement(
                          'li',
                          { key: i },
                          React.createElement(
                            'span',
                            { className: _ImportModal2.default['list-type'] },
                            i + 1,
                            '. '
                          ),
                          React.createElement(
                            'strong',
                            { className: 'text-error' },
                            React.createElement(
                              'span',
                              { className: 'text-red' },
                              message
                            )
                          )
                        );
                      })
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-default pull-left', onClick: onClickCancelBtnError },
              'Cancel'
            ),
            React.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-primary pull-right', onClick: onClickTryBtn },
              'Try Again'
            )
          )
        )
      );
    }
  }]);
  return ImportModalError;
}(React.Component);

exports.default = ImportModalError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(761);

var _List2 = _interopRequireDefault(_List);

var _reactBootstrap = __webpack_require__(10);

var _Row = __webpack_require__(1286);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List(props) {
    (0, _classCallCheck3.default)(this, List);

    var _this = (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).call(this, props));

    _this._onSelectPageNumber = function (eventKey) {
      _this.props.getPointActivity({
        page: eventKey,
        size: 12,
        sort: 'createdAt,desc',
        customerId: _this.props.customerDetail.id
      });
      _this.setState({ selectedPointActivityId: '' });
    };

    _this._onClickRow = function (paymentType, paymentId, pointActivityId) {
      _this.props.openReceipt({
        payment_type: paymentType,
        parent_payment_id: paymentId
      });
      _this.setState({ selectedPointActivityId: paymentId });
    };

    _this.state = { selectedPointActivityId: null };
    return _this;
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pointActivities = this.props.pointActivities;

      if (!pointActivities) {
        return null;
      }

      var views = pointActivities.content.map(function (pointActivity) {
        return React.createElement(_Row2.default, {
          key: pointActivity.row_id,
          onClickRow: _this2._onClickRow,
          pointActivity: pointActivity,
          isSelected: _this2.state.selectedPointActivityId === pointActivity.parent_payment_id
        });
      });

      return React.createElement(
        'div',
        { className: _List2.default['length-wrapper'] },
        React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: _List2.default['date'] },
                  'Date'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['outlet'] },
                  'Outlet'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['sale'] },
                  'Sale'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['point'] },
                  'Point'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              'table',
              { className: _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                views
              )
            )
          )
        ),
        React.createElement(_reactBootstrap.Pagination, {
          className: 'pull-right',
          prev: true,
          next: true,
          ellipsis: true,
          boundaryLinks: true,
          items: pointActivities.total_pages,
          maxButtons: 5,
          activePage: pointActivities.number + 1,
          onSelect: this._onSelectPageNumber
        })
      );
    }
  }]);
  return List;
}(React.Component);

exports.default = List;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(761);

var _List2 = _interopRequireDefault(_List);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function (_Component) {
  (0, _inherits3.default)(Row, _Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).call.apply(_ref, [this].concat(args))), _this), _this._saleFormatter = function (sale) {
      return sale < 0 ? '(' + (0, _formatter.rupiah)(-sale) + ')' : (0, _formatter.rupiah)(sale);
    }, _this._getFormattedPoint = function () {
      var pointActivity = _this.props.pointActivity;

      var point = pointActivity.points + pointActivity.new_member_points;
      if (pointActivity.type.toUpperCase() === 'EARNING') {
        if (point >= 0) {
          return (0, _formatter.formatDecimal)(point);
        } else {
          // this is for the case of refund, the point will be minus
          return '(' + (0, _formatter.formatDecimal)(-point) + ')';
        }
      } else {
        return '(' + (0, _formatter.formatDecimal)(point) + ')';
      }
    }, _this._onClickRow = function () {
      _this.props.onClickRow(_this.props.pointActivity.payment_type.toLowerCase(), _this.props.pointActivity.parent_payment_id, _this.props.pointActivity.row_id);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      var pointActivity = this.props.pointActivity;

      return _react2.default.createElement(
        'tr',
        { className: '' + (this.props.isSelected ? _List2.default.selected : ''), onClick: this._onClickRow },
        _react2.default.createElement(
          'td',
          { className: _List2.default['date'] },
          (0, _formatter.dateFormatter)(pointActivity.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['outlet'] },
          pointActivity.outlet_name
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['sale'] },
          this._saleFormatter(pointActivity.total_collected_amount)
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['point'] },
          this._getFormattedPoint()
        )
      );
    }
  }]);
  return Row;
}(_react.Component);

exports.default = Row;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(1285);

var _List2 = _interopRequireDefault(_List);

var _PointActivity = __webpack_require__(2073);

var _PointActivity2 = _interopRequireDefault(_PointActivity);

var _reactRedux = __webpack_require__(6);

var _reactFontawesome = __webpack_require__(198);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _list = __webpack_require__(75);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

var _pages = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointActivity = function (_Component) {
  (0, _inherits3.default)(PointActivity, _Component);

  function PointActivity(props) {
    (0, _classCallCheck3.default)(this, PointActivity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PointActivity.__proto__ || (0, _getPrototypeOf2.default)(PointActivity)).call(this, props));

    _this._getPointActivity = function (params) {
      _this.setState({ showDetail: false });
      _this.props.customerPointActivitiesRequest(params);
    };

    _this._onClickDone = function () {
      _this.setState({ showDetail: false });
    };

    _this._openReceipt = function (payment) {
      var customerDetail = _this.props.customerDetail;

      _this.props.receiptCustomerRequest(payment, customerDetail);
      _this.setState({ showDetail: true });
    };

    _this.state = {
      showDetail: false
    };
    return _this;
  }

  (0, _createClass3.default)(PointActivity, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          receiptData = _props.receiptData,
          pointActivities = _props.pointActivities,
          customerDetail = _props.customerDetail;


      return _react2.default.createElement(
        _pages.PageWrapper,
        null,
        _react2.default.createElement(
          'div',
          { onClick: this.props.backToCustomerList, className: '' + _PointActivity2.default['go-back-section'] },
          _react2.default.createElement(_reactFontawesome2.default, { style: { top: '-1px', position: 'relative' }, size: 'lg', name: 'angle-left' }),
          _react2.default.createElement(
            'span',
            { style: { fontSize: '15px' } },
            ' Back to Customer List'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _PointActivity2.default.header },
          'Point Activity - ',
          customerDetail && (customerDetail.name || customerDetail.email || customerDetail.phone)
        ),
        _react2.default.createElement(
          _pages.ContentWrapper,
          null,
          _react2.default.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: false }),
            _react2.default.createElement(_List2.default, {
              getPointActivity: this._getPointActivity,
              pointActivities: pointActivities,
              openReceipt: this._openReceipt,
              customerDetail: this.props.customerDetail
            })
          ),
          _react2.default.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(
              'div',
              { className: _PointActivity2.default['col-right-inner'] },
              _react2.default.createElement(
                'div',
                { className: _PointActivity2.default['scrolled-area'] },
                _react2.default.createElement(
                  'div',
                  { className: _PointActivity2.default['receipt-trx-container'] },
                  _react2.default.createElement(_TransactionDetailReceipt2.default, { paymentDetail: receiptData })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _PointActivity2.default['mk-col-right-action-box-bottom'] },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary pull-right', onClick: this._onClickDone },
                'Done'
              )
            )
          )
        )
      );
    }
  }]);
  return PointActivity;
}(_react.Component);

PointActivity.propTypes = {
  receiptData: _react2.default.PropTypes.object,
  customerDetail: _react2.default.PropTypes.object,
  pointActivities: _react2.default.PropTypes.object
};

function mapStateToProps(_ref) {
  var _ref$customers$list = _ref.customers.list,
      receiptData = _ref$customers$list.receiptData,
      customerDetail = _ref$customers$list.customerDetail,
      pointActivities = _ref$customers$list.pointActivities;

  return { receiptData: receiptData, customerDetail: customerDetail, pointActivities: pointActivities };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, { receiptCustomerRequest: _list.receiptCustomerRequest, customerPointActivitiesRequest: _list.customerPointActivitiesRequest })(PointActivity);

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(762);

var _List2 = _interopRequireDefault(_List);

var _reactBootstrap = __webpack_require__(10);

var _Row = __webpack_require__(1289);

var _Row2 = _interopRequireDefault(_Row);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List(props) {
    (0, _classCallCheck3.default)(this, List);

    var _this = (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).call(this, props));

    _this._getRowsView = function () {
      var payments = _this.props.payments;
      var _this$state = _this.state,
          selectedPage = _this$state.selectedPage,
          sizePerPage = _this$state.sizePerPage;

      var arrayStartingIndex = (selectedPage - 1) * sizePerPage;
      var arrayEndIndex = selectedPage * sizePerPage;
      return (0, _map3.default)(payments.slice(arrayStartingIndex, arrayEndIndex), function (payment) {
        return React.createElement(_Row2.default, {
          key: payment.id,
          onClickRow: _this._onClickRow,
          payment: payment,
          isSelected: _this.state.selectedPaymentId === payment.parent_payment_id
        });
      });
    };

    _this._onSelectPageNumber = function (eventKey) {
      _this.props.closeDetail();
      _this.setState({ selectedPage: eventKey, selectedPaymentId: '' });
    };

    _this._onClickRow = function (payment) {
      _this.props.openReceipt({
        payment_type: 'cash',
        parent_payment_id: payment.parent_payment_id
      });
      _this.setState({ selectedPaymentId: payment.parent_payment_id });
    };

    _this.state = {
      selectedPaymentId: null,
      sizePerPage: 12,
      selectedPage: 1
    };
    return _this;
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var payments = this.props.payments;

      return React.createElement(
        'div',
        { className: _List2.default['length-wrapper'] },
        React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: _List2.default['date'] },
                  'Date'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['outlet'] },
                  'Outlet'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['sale'] },
                  'Sale'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              'table',
              { className: _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                this._getRowsView()
              )
            )
          )
        ),
        React.createElement(_reactBootstrap.Pagination, {
          className: 'pull-right',
          prev: true,
          next: true,
          ellipsis: true,
          boundaryLinks: true,
          items: Math.ceil(payments.length / this.state.sizePerPage),
          maxButtons: 5,
          activePage: this.state.selectedPage,
          onSelect: this._onSelectPageNumber
        })
      );
    }
  }]);
  return List;
}(React.Component);

exports.default = List;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(762);

var _List2 = _interopRequireDefault(_List);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function (_Component) {
  (0, _inherits3.default)(Row, _Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).call.apply(_ref, [this].concat(args))), _this), _this._purchaseHistoryTotalFormatter = function (payment) {
      var amount = payment.is_refunded ? (0, _formatter.rupiah)(parseFloat(payment.refund_amount).toFixed(0)) : (0, _formatter.rupiah)(parseFloat(payment.total_collected).toFixed(0));

      if (payment.is_refunded) {
        amount = '(' + amount + ')';
      }

      return amount;
    }, _this.onClickRow = function () {
      _this.props.onClickRow(_this.props.payment);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      var payment = this.props.payment;

      return _react2.default.createElement(
        'tr',
        { className: '' + (this.props.isSelected ? _List2.default.selected : ''), onClick: this.onClickRow },
        _react2.default.createElement(
          'td',
          { className: _List2.default['date'] },
          (0, _formatter.dateFormatter)(payment.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['outlet'] },
          payment.outlet_name
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['sale'] },
          this._purchaseHistoryTotalFormatter(payment)
        )
      );
    }
  }]);
  return Row;
}(_react.Component);

exports.default = Row;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(1288);

var _List2 = _interopRequireDefault(_List);

var _PurchaseHistory = __webpack_require__(2074);

var _PurchaseHistory2 = _interopRequireDefault(_PurchaseHistory);

var _reactRedux = __webpack_require__(6);

var _reactFontawesome = __webpack_require__(198);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _list = __webpack_require__(75);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

var _pages = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseHistory = function (_Component) {
  (0, _inherits3.default)(PurchaseHistory, _Component);

  function PurchaseHistory(props) {
    (0, _classCallCheck3.default)(this, PurchaseHistory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PurchaseHistory.__proto__ || (0, _getPrototypeOf2.default)(PurchaseHistory)).call(this, props));

    _this._closeDetail = function () {
      _this.setState({ showDetail: false });
    };

    _this._onClickDone = function () {
      _this._closeDetail();
    };

    _this._openReceipt = function (payment) {
      var customerDetail = _this.props.customerDetail;

      _this.props.receiptCustomerRequest(payment, customerDetail);
      _this.setState({ showDetail: true });
    };

    _this.state = {
      showDetail: false
    };
    return _this;
  }

  (0, _createClass3.default)(PurchaseHistory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          receiptData = _props.receiptData,
          customerDetail = _props.customerDetail;


      return _react2.default.createElement(
        _pages.PageWrapper,
        null,
        _react2.default.createElement(
          'div',
          { onClick: this.props.backToCustomerList, className: '' + _PurchaseHistory2.default['go-back-section'] },
          _react2.default.createElement(_reactFontawesome2.default, { style: { top: '-1px', position: 'relative' }, size: 'lg', name: 'angle-left' }),
          _react2.default.createElement(
            'span',
            { style: { fontSize: '15px' } },
            ' Back to Customer List'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _PurchaseHistory2.default.header },
          'Purchase History - ',
          customerDetail && (customerDetail.name || customerDetail.email || customerDetail.phone)
        ),
        _react2.default.createElement(
          _pages.ContentWrapper,
          null,
          _react2.default.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: false }),
            _react2.default.createElement(_List2.default, {
              closeDetail: this._closeDetail,
              payments: this.props.customerDetail.payments,
              openReceipt: this._openReceipt,
              customerDetail: this.props.customerDetail
            })
          ),
          _react2.default.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(
              'div',
              { className: _PurchaseHistory2.default['col-right-inner'] },
              _react2.default.createElement(
                'div',
                { className: _PurchaseHistory2.default['scrolled-area'] },
                _react2.default.createElement(
                  'div',
                  { className: _PurchaseHistory2.default['receipt-trx-container'] },
                  _react2.default.createElement(_TransactionDetailReceipt2.default, { paymentDetail: receiptData })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _PurchaseHistory2.default['mk-col-right-action-box-bottom'] },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary pull-right', onClick: this._onClickDone },
                'Done'
              )
            )
          )
        )
      );
    }
  }]);
  return PurchaseHistory;
}(_react.Component);

PurchaseHistory.propTypes = {
  receiptData: _react2.default.PropTypes.object,
  customerDetail: _react2.default.PropTypes.object
};

function mapStateToProps(_ref) {
  var _ref$customers$list = _ref.customers.list,
      receiptData = _ref$customers$list.receiptData,
      customerDetail = _ref$customers$list.customerDetail;

  return { receiptData: receiptData, customerDetail: customerDetail };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, { receiptCustomerRequest: _list.receiptCustomerRequest })(PurchaseHistory);

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(763);

var _List2 = _interopRequireDefault(_List);

var _reactBootstrap = __webpack_require__(10);

var _Row = __webpack_require__(1292);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List(props) {
    (0, _classCallCheck3.default)(this, List);

    var _this = (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).call(this, props));

    _this._onSelectPageNumber = function (eventKey) {
      _this.props.getRedemptionHistory({
        page: eventKey,
        size: 12,
        sort: 'createdAt,desc',
        customerId: _this.props.customerDetail.id
      });

      _this.setState({ selectedRedeemId: '' });
    };

    _this._onClickRow = function (paymentType, paymentId, redeemId) {
      _this.props.openReceipt({
        payment_type: paymentType,
        parent_payment_id: paymentId
      });
      _this.setState({ selectedRedeemId: paymentId });
    };

    _this.state = { selectedRedeemId: null };
    return _this;
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var redemptions = this.props.redemptions;

      if (!redemptions) {
        return null;
      }

      return React.createElement(
        'div',
        { className: _List2.default['length-wrapper'] },
        React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: _List2.default['date'] },
                  'Date'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['reward'] },
                  'Reward'
                ),
                React.createElement(
                  'th',
                  { className: _List2.default['point'] },
                  'Point'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              'table',
              { className: _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                redemptions.content.map(function (redemption) {
                  return React.createElement(_Row2.default, {
                    key: redemption.redeem_id,
                    onClickRow: _this2._onClickRow,
                    redemption: redemption,
                    isSelected: _this2.state.selectedRedeemId === redemption.parent_payment_id
                  });
                })
              )
            )
          )
        ),
        React.createElement(_reactBootstrap.Pagination, {
          className: 'pull-right',
          prev: true,
          next: true,
          ellipsis: true,
          boundaryLinks: true,
          items: redemptions.total_pages,
          maxButtons: 5,
          activePage: redemptions.number + 1,
          onSelect: this._onSelectPageNumber
        })
      );
    }
  }]);
  return List;
}(React.Component);

exports.default = List;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(763);

var _List2 = _interopRequireDefault(_List);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function (_Component) {
  (0, _inherits3.default)(Row, _Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).call.apply(_ref, [this].concat(args))), _this), _this.onClickRow = function () {
      _this.props.onClickRow(_this.props.redemption.payment_type.toLowerCase(), _this.props.redemption.payment_id, _this.props.redemption.redeem_id);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      var redemption = this.props.redemption;

      return _react2.default.createElement(
        'tr',
        { className: '' + (this.props.isSelected ? _List2.default.selected : ''), onClick: this.onClickRow },
        _react2.default.createElement(
          'td',
          { className: _List2.default['date'] },
          (0, _formatter.dateFormatter)(redemption.created_at)
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['reward'] },
          redemption.reward
        ),
        _react2.default.createElement(
          'td',
          { className: _List2.default['point'] },
          (0, _formatter.formatDecimal)(redemption.redeem_points)
        )
      );
    }
  }]);
  return Row;
}(_react.Component);

exports.default = Row;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(1291);

var _List2 = _interopRequireDefault(_List);

var _RedeemHistory = __webpack_require__(2075);

var _RedeemHistory2 = _interopRequireDefault(_RedeemHistory);

var _reactRedux = __webpack_require__(6);

var _reactFontawesome = __webpack_require__(198);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _list = __webpack_require__(75);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

var _pages = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedeemHistory = function (_Component) {
  (0, _inherits3.default)(RedeemHistory, _Component);

  function RedeemHistory(props) {
    (0, _classCallCheck3.default)(this, RedeemHistory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RedeemHistory.__proto__ || (0, _getPrototypeOf2.default)(RedeemHistory)).call(this, props));

    _this._getRedemptionHistory = function (params) {
      _this.setState({ showDetail: false });
      _this.props.customerRedemptionHistoriesRequest(params);
    };

    _this._onClickDone = function () {
      _this.setState({ showDetail: false });
    };

    _this._openReceipt = function (payment) {
      var customerDetail = _this.props.customerDetail;

      _this.props.receiptCustomerRequest(payment, customerDetail);
      _this.setState({ showDetail: true });
    };

    _this.state = {
      showDetail: false
    };
    return _this;
  }

  (0, _createClass3.default)(RedeemHistory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          receiptData = _props.receiptData,
          redemptionHistories = _props.redemptionHistories,
          customerDetail = _props.customerDetail;


      return _react2.default.createElement(
        _pages.PageWrapper,
        null,
        _react2.default.createElement(
          'div',
          { onClick: this.props.backToCustomerList, className: '' + _RedeemHistory2.default['go-back-section'] },
          _react2.default.createElement(_reactFontawesome2.default, { style: { top: '-1px', position: 'relative' }, size: 'lg', name: 'angle-left' }),
          _react2.default.createElement(
            'span',
            { style: { fontSize: '15px' } },
            ' Back to Customer List'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _RedeemHistory2.default.header },
          'Redeem History - ',
          customerDetail && (customerDetail.name || customerDetail.email || customerDetail.phone)
        ),
        _react2.default.createElement(
          _pages.ContentWrapper,
          null,
          _react2.default.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(_LoadingSpinner2.default, { showLoadingSpinner: false }),
            _react2.default.createElement(_List2.default, {
              getRedemptionHistory: this._getRedemptionHistory,
              redemptions: redemptionHistories,
              openReceipt: this._openReceipt,
              customerDetail: this.props.customerDetail
            })
          ),
          _react2.default.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: this.state.showDetail },
            _react2.default.createElement(
              'div',
              { className: _RedeemHistory2.default['col-right-inner'] },
              _react2.default.createElement(
                'div',
                { className: _RedeemHistory2.default['scrolled-area'] },
                _react2.default.createElement(
                  'div',
                  { className: _RedeemHistory2.default['receipt-trx-container'] },
                  _react2.default.createElement(_TransactionDetailReceipt2.default, { paymentDetail: receiptData })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _RedeemHistory2.default['mk-col-right-action-box-bottom'] },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-primary pull-right', onClick: this._onClickDone },
                'Done'
              )
            )
          )
        )
      );
    }
  }]);
  return RedeemHistory;
}(_react.Component);

RedeemHistory.propTypes = {
  receiptData: _react2.default.PropTypes.object,
  customerDetail: _react2.default.PropTypes.object,
  redemptionHistories: _react2.default.PropTypes.object
};

function mapStateToProps(_ref) {
  var _ref$customers$list = _ref.customers.list,
      receiptData = _ref$customers$list.receiptData,
      customerDetail = _ref$customers$list.customerDetail,
      redemptionHistories = _ref$customers$list.redemptionHistories;

  return { receiptData: receiptData, customerDetail: customerDetail, redemptionHistories: redemptionHistories };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, { receiptCustomerRequest: _list.receiptCustomerRequest, customerRedemptionHistoriesRequest: _list.customerRedemptionHistoriesRequest })(RedeemHistory);

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(2076);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _feedback = __webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      _this.props.dispatch((0, _feedback.changeDateFeedback)(startDate, endDate));
      $('#customer-feedback').show();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-sm-6 col-xs-8' },
        React.createElement(
          'form',
          { className: 'form-inline', onSubmit: function onSubmit() {
              return false;
            } },
          React.createElement(
            'div',
            { className: 'form-group ' + _ActionBar2.default['form-group'] },
            React.createElement(_reduxForm.Field, {
              component: _DropdownCalendar2.default,
              name: 'date',
              onChange: this._onChangeDate
            })
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'search'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _FeedbackTable = __webpack_require__(1300);

var _FeedbackTable2 = _interopRequireDefault(_FeedbackTable);

var _FeedbackDetail = __webpack_require__(1296);

var _FeedbackDetail2 = _interopRequireDefault(_FeedbackDetail);

var _feedback = __webpack_require__(286);

var _styleFeedback = __webpack_require__(764);

var _styleFeedback2 = _interopRequireDefault(_styleFeedback);

var _ActionBar = __webpack_require__(1294);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feedback = function (_React$Component) {
  (0, _inherits3.default)(Feedback, _React$Component);
  (0, _createClass3.default)(Feedback, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _feedback.feedbackPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function Feedback() {
    (0, _classCallCheck3.default)(this, Feedback);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Feedback.__proto__ || (0, _getPrototypeOf2.default)(Feedback)).call(this));

    _this._onClickRow = function (feedback) {
      $('#customer-feedback').hide();
      $('#customer-feedback-detail').show();
      _this.props.dispatch((0, _feedback.onClickRow)(feedback));
      _this.setState({ feedbackId: feedback.id });
      _this.setState({ feedbackType: feedback.feedback_type });
      _this.setState({ feedbackMode: feedback.mode });
    };

    _this._handleSubmit = function (feedbackData) {
      var _feedbackData = feedbackData,
          comment = _feedbackData.comment,
          feedbackfrom = _feedbackData.feedbackfrom,
          business_name = _feedbackData.business_name;

      var id = _this.state.feedbackId;
      var commentSanited = '';
      if (feedbackfrom === 'sms') {
        commentSanited = comment.substring(business_name.length);
      } else {
        commentSanited = comment;
      }
      feedbackData = {
        comment: commentSanited,
        feedback_id: id,
        feedback_from: feedbackfrom
      };
      _this.props.dispatch((0, _feedback.submitReplyRequest)(feedbackData));
    };

    _this.state = {
      feedbackId: 0,
      feedbackType: '',
      feedbackMode: ''
    };
    return _this;
  }

  (0, _createClass3.default)(Feedback, [{
    key: 'render',
    value: function render() {
      var _props$data$customers = this.props.data.customers.feedback,
          feedbackMessages = _props$data$customers.feedbackMessages,
          transactionDetail = _props$data$customers.transactionDetail;


      return React.createElement(
        'div',
        { id: 'feedback-list', className: _styleFeedback2.default.feedback },
        React.createElement(
          'div',
          { className: _styleFeedback2.default['mk-action-bar'] },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(_ActionBar2.default, null)
          )
        ),
        React.createElement(
          'div',
          { className: 'mk-customer-feedback moka-container-content' },
          React.createElement(_FeedbackTable2.default, { onClickRow: this._onClickRow }),
          React.createElement(_FeedbackDetail2.default, {
            feedbackMessages: feedbackMessages,
            onSubmitReply: this._handleSubmit,
            transactionDetail: transactionDetail,
            feedbackType: this.state.feedbackType,
            feedbackMode: this.state.feedbackMode
          })
        )
      );
    }
  }]);
  return Feedback;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback
      },
      form: state.form,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Feedback);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _FeedbackReply = __webpack_require__(1298);

var _FeedbackReply2 = _interopRequireDefault(_FeedbackReply);

var _FeedbackReceipt = __webpack_require__(1297);

var _FeedbackReceipt2 = _interopRequireDefault(_FeedbackReceipt);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackDetail = function (_React$Component) {
  (0, _inherits3.default)(FeedbackDetail, _React$Component);

  function FeedbackDetail() {
    (0, _classCallCheck3.default)(this, FeedbackDetail);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackDetail.__proto__ || (0, _getPrototypeOf2.default)(FeedbackDetail)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          feedbacks = _props.feedbacks,
          feedbackMessages = _props.feedbackMessages,
          onSubmitReply = _props.onSubmitReply,
          transactionDetail = _props.transactionDetail,
          feedbackType = _props.feedbackType,
          feedbackMode = _props.feedbackMode;


      return React.createElement(
        'div',
        { className: 'col-md-12 no-padding', id: 'customer-feedback-detail' },
        React.createElement(_FeedbackReply2.default, {
          feedbacks: feedbacks,
          feedbackMessages: feedbackMessages,
          onSubmit: onSubmitReply,
          feedbackType: feedbackType,
          feedbackMode: feedbackMode
        }),
        React.createElement(_FeedbackReceipt2.default, {
          transactionDetail: transactionDetail
        })
      );
    }
  }]);
  return FeedbackDetail;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback
      }
    }
  };
}

FeedbackDetail.propTypes = {
  feedbackMessages: React.PropTypes.object,
  transactionDetail: React.PropTypes.object,
  onSubmitReply: React.PropTypes.func,
  feedbackType: React.PropTypes.string,
  feedbackMode: React.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeedbackDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _styleDetail = __webpack_require__(506);

var _styleDetail2 = _interopRequireDefault(_styleDetail);

var _TransactionDetailReceipt = __webpack_require__(173);

var _TransactionDetailReceipt2 = _interopRequireDefault(_TransactionDetailReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackReceipt = function (_React$Component) {
  (0, _inherits3.default)(FeedbackReceipt, _React$Component);

  function FeedbackReceipt() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackReceipt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackReceipt.__proto__ || (0, _getPrototypeOf2.default)(FeedbackReceipt)).call.apply(_ref, [this].concat(args))), _this), _this._hideDetail = function () {
      $('#customer-feedback').show();
      $('#customer-feedback-detail').hide();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeedbackReceipt, [{
    key: 'render',
    value: function render() {
      var transactionDetail = this.props.transactionDetail;


      return transactionDetail && React.createElement(
        'div',
        { className: 'col-sm-6', id: 'mk-col-right' },
        React.createElement(
          'div',
          { className: 'mk-col-right-box' },
          React.createElement(
            'div',
            { className: _styleDetail2.default['scrolled-area'] },
            React.createElement(_TransactionDetailReceipt2.default, { paymentDetail: transactionDetail }),
            React.createElement('div', { className: _styleDetail2.default['bottom-separator'] }),
            React.createElement(
              'div',
              { className: _styleDetail2.default['receipt-action-bottom'] },
              React.createElement(
                'button',
                {
                  className: 'btn btn-primary pull-right',
                  id: 'btn-close',
                  onClick: this._hideDetail },
                'Done'
              )
            )
          )
        )
      );
    }
  }]);
  return FeedbackReceipt;
}(React.Component);

FeedbackReceipt.propTypes = {
  transactionDetail: React.PropTypes.object
};

exports.default = FeedbackReceipt;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _FeedbackReplyForm = __webpack_require__(1299);

var _FeedbackReplyForm2 = _interopRequireDefault(_FeedbackReplyForm);

var _formatter = __webpack_require__(11);

var _styleDetail = __webpack_require__(506);

var _styleDetail2 = _interopRequireDefault(_styleDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackReply = function (_React$Component) {
  (0, _inherits3.default)(FeedbackReply, _React$Component);

  function FeedbackReply() {
    (0, _classCallCheck3.default)(this, FeedbackReply);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackReply.__proto__ || (0, _getPrototypeOf2.default)(FeedbackReply)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackReply, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          feedbackMessages = _props.feedbackMessages,
          onSubmit = _props.onSubmit,
          feedbackType = _props.feedbackType,
          feedbackMode = _props.feedbackMode;


      return React.createElement(
        'div',
        { className: 'col-sm-6 no-padding-left', id: 'mk-col-left' },
        React.createElement(
          'div',
          { className: 'mk-feed-box' },
          React.createElement(
            'div',
            { className: _styleDetail2.default['header-feed'] },
            React.createElement(
              'div',
              { className: _styleDetail2.default['title-truncate'] },
              feedbackMode === 'happy' ? React.createElement('i', { className: 'fa fa-smile-o pull-left' }) : React.createElement('i', { className: 'fa fa-frown-o pull-left' }),
              React.createElement(
                'span',
                null,
                feedbackType
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'feed-scrolled-area feedback-list-page' },
            React.createElement(
              'div',
              { className: _styleDetail2.default['stream-feed-box'] },
              feedbackMessages.messages.map(function (feedbackDetail, idx) {
                return React.createElement(
                  'div',
                  { key: idx },
                  feedbackDetail.is_customer ? React.createElement(
                    'div',
                    { className: 'left-feed-box' },
                    React.createElement(
                      'div',
                      { className: 'img-profile' },
                      React.createElement('img', { src: __webpack_require__(368), alt: 'account profile default' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'bubble-text' },
                      feedbackMessages.feedback_from === 'sms' && React.createElement(
                        'div',
                        { className: 'name' },
                        feedbackMessages.customer_phone
                      ),
                      feedbackMessages.feedback_from !== 'sms' && React.createElement(
                        'div',
                        { className: 'name' },
                        feedbackDetail.name || feedbackDetail.email
                      ),
                      React.createElement(
                        'div',
                        { className: 'feed' },
                        feedbackDetail.comment
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'time' },
                      React.createElement('i', { className: 'fa fa-clock-o' }),
                      (0, _formatter.invoiceReceiptDateTime)(feedbackDetail.created_at, 'datetime')
                    )
                  ) : React.createElement(
                    'div',
                    { className: 'right-feed-box' },
                    feedbackMessages.business_logo_url ? React.createElement(
                      'div',
                      { className: 'img-profile' },
                      React.createElement('img', { src: feedbackMessages.business_logo_url })
                    ) : React.createElement(
                      'div',
                      { className: 'img-profile' },
                      React.createElement('img', { src: __webpack_require__(368) })
                    ),
                    React.createElement(
                      'div',
                      { className: 'bubble-text' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        feedbackMessages.business_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'feed' },
                        feedbackDetail.comment
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'time' },
                      React.createElement('i', { className: 'fa fa-clock-o' }),
                      (0, _formatter.invoiceReceiptDateTime)(feedbackDetail.created_at, 'datetime')
                    )
                  )
                );
              })
            )
          ),
          React.createElement(
            'div',
            { className: _styleDetail2.default['footer-feed'] },
            React.createElement(_FeedbackReplyForm2.default, { onSubmit: onSubmit, feedbackfrom: feedbackMessages.feedback_from })
          )
        )
      );
    }
  }]);
  return FeedbackReply;
}(React.Component);

FeedbackReply.propTypes = {
  feedbackMessages: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  feedbackType: React.PropTypes.string,
  feedbackMode: React.PropTypes.string
};

exports.default = FeedbackReply;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _styleDetail = __webpack_require__(506);

var _styleDetail2 = _interopRequireDefault(_styleDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smsInput = function smsInput(props) {
  var input = props.input;

  return React.createElement(
    'div',
    null,
    React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: 'haesoo - ', placeholder: 'Reply SMS Feedback...', maxlength: '160', type: 'text', className: 'reply-text form-control ' + _styleDetail2.default['form-sms-feedback'] })),
    React.createElement(
      'div',
      { className: _styleDetail2.default['counter-feedback'] },
      160 - input.value.length
    )
  );
};

var normalizeSMSForm = function normalizeSMSForm(value, prevVal, allValues) {
  var result = '';
  if (value.length === 1) {
    result = allValues['business_name'] + value;
  } else {
    result = allValues['business_name'] + value.substring(allValues['business_name'].length);
  }
  return result.slice(0, 160);
};

var FeedbackReplyForm = function (_React$Component) {
  (0, _inherits3.default)(FeedbackReplyForm, _React$Component);

  function FeedbackReplyForm() {
    (0, _classCallCheck3.default)(this, FeedbackReplyForm);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackReplyForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackReplyForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackReplyForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          feedbackfrom = _props.feedbackfrom;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          'data-fv-notempty': 'true',
          name: 'feedbackfrom',
          type: 'hidden'
        }),
        React.createElement(_reduxForm.Field, {
          component: 'input',
          'data-fv-notempty': 'true',
          name: 'business_name',
          type: 'hidden'
        }),
        React.createElement(
          'div',
          { className: 'input-group' },
          feedbackfrom === 'sms' && React.createElement(_reduxForm.Field, {
            component: smsInput,
            'data-fv-notempty': 'true',
            name: 'comment',
            normalize: normalizeSMSForm
          }),
          feedbackfrom !== 'sms' && React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'reply-text form-control',
            'data-fv-notempty': 'true',
            name: 'comment',
            placeholder: 'Reply Feedback...',
            type: 'text'
          }),
          React.createElement(
            'span',
            { className: 'input-group-btn' },
            React.createElement('input', {
              className: 'btn btn-primary btn btn-primary',
              type: 'submit',
              value: 'Reply'
            })
          )
        )
      );
    }
  }]);
  return FeedbackReplyForm;
}(React.Component);

FeedbackReplyForm.propTypes = {
  onSubmit: React.PropTypes.func
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'feedbackReplyForm'
})(FeedbackReplyForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _styleFeedback = __webpack_require__(764);

var _styleFeedback2 = _interopRequireDefault(_styleFeedback);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _feedback = __webpack_require__(286);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackTable = function (_React$Component) {
  (0, _inherits3.default)(FeedbackTable, _React$Component);

  function FeedbackTable() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackTable.__proto__ || (0, _getPrototypeOf2.default)(FeedbackTable)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (feedback) {
      _this.props.onClickRow(feedback);
    }, _this._onReachBottom = function () {
      var _this$props$data$cust = _this.props.data.customers.feedback,
          feedbacks = _this$props$data$cust.feedbacks,
          currentPage = _this$props$data$cust.currentPage;
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      var startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
      var endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
      _this.props.dispatch((0, _feedback.listFeedbackRequest)({ start: startDateFormatted, end: endDateFormatted, page: currentPage + 1 }, feedbacks));
    }, _this._hasMore = function () {
      var _this$props$data$cust2 = _this.props.data.customers.feedback,
          currentPage = _this$props$data$cust2.currentPage,
          totalPage = _this$props$data$cust2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeedbackTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var feedbacks = this.props.data.customers.feedback.feedbacks;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;


      return React.createElement(
        'div',
        { className: 'col-md-12 ' + _styleFeedback2.default['table-feedback'], id: 'customer-feedback' },
        feedbacks.length > 0 && React.createElement(
          'div',
          { className: 'col-sm-12 trans-1 box-customers no-padding', id: 'mk-col-left' },
          React.createElement(
            'table',
            { className: 'table header-table mk-table-fixed table-truncate' },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  null,
                  'Date'
                ),
                React.createElement(
                  'th',
                  null,
                  'Name'
                ),
                React.createElement(
                  'th',
                  null,
                  'Comment'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _styleFeedback2.default['box-scroll'] },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore,
                useWindow: false,
                threshold: 10,
                initialLoad: false
              },
              React.createElement(
                'table',
                { className: 'table mk-table-fixed table-truncate' },
                React.createElement(
                  'tbody',
                  null,
                  feedbacks.map(function (feedback, idx) {
                    return React.createElement(
                      'tr',
                      { key: idx, onClick: function onClick() {
                          return _this2._onClickRow(feedback);
                        }, className: _styleFeedback2.default['feedback-row'] },
                      React.createElement(
                        'td',
                        null,
                        feedback.feedback_date
                      ),
                      feedback.feedback_from === 'sms' && React.createElement(
                        'td',
                        null,
                        feedback.customer_name || feedback.customer_phone || feedback.customer_email
                      ),
                      feedback.feedback_from !== 'sms' && React.createElement(
                        'td',
                        null,
                        feedback.customer_name || feedback.customer_email || feedback.customer_phone
                      ),
                      React.createElement(
                        'td',
                        null,
                        feedback.mode === 'happy' ? React.createElement('i', { className: 'fa fa-smile-o' }) : React.createElement('i', { className: 'fa fa-frown-o' }),
                        React.createElement(
                          'span',
                          { className: 'title type' },
                          feedback.feedback_type
                        ),
                        React.createElement(
                          'span',
                          { className: 'comment' },
                          '"' + feedback.comment + '"'
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        feedbacks.length === 0 && React.createElement(_NoDataAndLoading2.default, {
          showLoadingSpinner: showLoadingSpinnerPage,
          noDataToDisplay: true,
          title: 'No Data To Display',
          description: '' })
      );
    }
  }]);
  return FeedbackTable;
}(React.Component);

FeedbackTable.propTypes = {
  onClickRow: React.PropTypes.func
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback
      },
      loadingSpinner: state.loadingSpinner
    },
    search: {
      date: selector(state, 'date')
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeedbackTable);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CannotReviewModal = function (_Component) {
  (0, _inherits3.default)(CannotReviewModal, _Component);

  function CannotReviewModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CannotReviewModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CannotReviewModal.__proto__ || (0, _getPrototypeOf2.default)(CannotReviewModal)).call.apply(_ref, [this].concat(args))), _this), _this._close = function (e) {
      e.stopPropagation();
      _this.props.close();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CannotReviewModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            style: { top: '120px' },
            show: this.props.show,
            onHide: this._close,
            container: this,
            'aria-labelledby': 'contained-modal-title',
            backdrop: 'static'
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { fontSize: '14px', fontWeight: '400', color: 'rgba(255, 255, 255, 0.83)' } },
              'Information'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            'Cannot review, please complete all the required fields with correct value.'
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-primary', onClick: this._close },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return CannotReviewModal;
}(_react.Component);

exports.default = CannotReviewModal;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FailedFeedback = function (_Component) {
  (0, _inherits3.default)(FailedFeedback, _Component);

  function FailedFeedback() {
    (0, _classCallCheck3.default)(this, FailedFeedback);
    return (0, _possibleConstructorReturn3.default)(this, (FailedFeedback.__proto__ || (0, _getPrototypeOf2.default)(FailedFeedback)).apply(this, arguments));
  }

  (0, _createClass3.default)(FailedFeedback, [{
    key: 'render',
    value: function render() {
      var tooltip = _react2.default.createElement(
        _reactBootstrap.Tooltip,
        null,
        this.props.error
      );
      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: tooltip },
        _react2.default.createElement('span', {
          className: 'form-control-feedback glyphicon glyphicon-remove',
          style: { 'pointer-events': 'auto', 'cursor': 'pointer' }
        })
      );
    }
  }]);
  return FailedFeedback;
}(_react.Component);

FailedFeedback.propTypes = {
  error: _react.PropTypes.bool.isRequired
};

exports.default = FailedFeedback;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactNumberFormat = __webpack_require__(377);

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _NumberInputWithFeedback = __webpack_require__(455);

var _NumberInputWithFeedback2 = _interopRequireDefault(_NumberInputWithFeedback);

var _PointRule = __webpack_require__(2077);

var _PointRule2 = _interopRequireDefault(_PointRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointRule = function (_Component) {
  (0, _inherits3.default)(PointRule, _Component);

  function PointRule(props) {
    (0, _classCallCheck3.default)(this, PointRule);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PointRule.__proto__ || (0, _getPrototypeOf2.default)(PointRule)).call(this, props));

    _initialiseProps.call(_this);

    var spendingAmount = props.spendingAmount,
        pointFromSpendingAmount = props.pointFromSpendingAmount;

    var amountInputError = spendingAmount === '' ? null : _this._getAmountInputError(spendingAmount);
    var pointInputError = pointFromSpendingAmount === '' ? null : _this._getPointInputError(pointFromSpendingAmount);
    _this.state = {
      amountInputError: amountInputError,
      pointInputError: pointInputError
    };
    return _this;
  }

  (0, _createClass3.default)(PointRule, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          amountInputError = _state.amountInputError,
          pointInputError = _state.pointInputError;

      var isDisabledNext = amountInputError !== '' || pointInputError !== '';

      return _react2.default.createElement(
        'div',
        { className: 'top20' },
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12 ' + _PointRule2.default['action-label'] },
            'Set your point conversion'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom30' },
          _react2.default.createElement(
            'div',
            { className: '' + _PointRule2.default['wrapped-input'] },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.spendingAmount,
              onChangeValue: this._onChangeAmount,
              prefix: 'Rp. ',
              placeholder: 'Rp. 0',
              errorMessage: this.state.amountInputError
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-center ' + _PointRule2.default['middle-equal'] },
            '='
          ),
          _react2.default.createElement(
            'div',
            { className: '' + _PointRule2.default['wrapped-input'] },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.pointFromSpendingAmount,
              onChangeValue: this._onChangePoint,
              suffix: ' Points',
              placeholder: '0 Points',
              errorMessage: this.state.pointInputError
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12 ' + _PointRule2.default['action-label'] },
            'Offer new member points to join loyalty program (Optional)'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + _PointRule2.default['wrapped-input'] },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'has-feedback' },
              _react2.default.createElement(_reactNumberFormat2.default, {
                className: 'form-control form-control-success',
                value: this.props.newMemberPoint,
                onChange: this._onChangeNewMemberPoint,
                suffix: ' Points',
                placeholder: '0 Points',
                thousandSeparator: '.',
                decimalPrecision: 0,
                decimalSeparator: ',',
                allowNegative: false
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'top20' },
          _react2.default.createElement(
            'button',
            {
              style: { color: '' + (isDisabledNext ? '' : '#3e8acc') },
              className: 'btn btn-default pull-right',
              onClick: this._onClickNext,
              disabled: isDisabledNext
            },
            'Next'
          )
        )
      );
    }
  }]);
  return PointRule;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._onChangeAmount = function (e, rawAmount) {
    var maximum = 999999999999;
    var amountInputError = _this2._getAmountInputError(rawAmount);
    if (rawAmount > maximum) {
      rawAmount = _this2.props.spendingAmount;
    }

    if ($.isNumeric(rawAmount)) {
      rawAmount = parseInt(rawAmount);
    }

    _this2.props.setSpendingAmount(rawAmount);
    _this2.setState({ amountInputError: amountInputError });
  };

  this._getAmountInputError = function (amount) {
    var amountInputError = '';
    if (!amount) {
      amountInputError = 'Please enter a value';
    } else if (amount < 1000) {
      amountInputError = 'Minimum value is Rp 1000';
    }

    return amountInputError;
  };

  this._onChangePoint = function (e, rawPoint) {
    var maximum = 999999999999;
    if (rawPoint > maximum) {
      rawPoint = _this2.props.pointFromSpendingAmount;
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint);
    }

    var pointInputError = _this2._getPointInputError(rawPoint);
    _this2.props.setPointFromSpendingAmount(rawPoint);
    _this2.setState({ pointInputError: pointInputError });
  };

  this._getPointInputError = function (point) {
    var pointInputError = '';
    if (point <= 0) {
      pointInputError = 'Please enter a value';
    }

    return pointInputError;
  };

  this._onChangeNewMemberPoint = function (e, rawPoint) {
    var maximum = 999999999999;
    if (rawPoint > maximum) {
      rawPoint = _this2.props.newMemberPoint;
    }

    if ($.isNumeric(rawPoint)) {
      rawPoint = parseInt(rawPoint);
    }

    _this2.props.setNewMemberPoint(rawPoint);
  };

  this._onClickNext = function (e) {
    e.stopPropagation();
    _this2.props.onFinish();
  };
};

PointRule.propTypes = {
  spendingAmount: _react.PropTypes.number.isRequired,
  pointFromSpendingAmount: _react.PropTypes.func.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  setSpendingAmount: _react.PropTypes.func.isRequired,
  setPointFromSpendingAmount: _react.PropTypes.func.isRequired,
  onFinish: _react.PropTypes.func.isRequired
};

exports.default = PointRule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Program = __webpack_require__(328);

var _Program2 = _interopRequireDefault(_Program);

var _reactBootstrap = __webpack_require__(10);

var _WrappedPanel = __webpack_require__(1311);

var _WrappedPanel2 = _interopRequireDefault(_WrappedPanel);

var _ProgramType = __webpack_require__(1306);

var _ProgramType2 = _interopRequireDefault(_ProgramType);

var _PointRule = __webpack_require__(1303);

var _PointRule2 = _interopRequireDefault(_PointRule);

var _Reward = __webpack_require__(1310);

var _Reward2 = _interopRequireDefault(_Reward);

var _ProgramConfiguration = __webpack_require__(1305);

var _ProgramConfiguration2 = _interopRequireDefault(_ProgramConfiguration);

var _CannotReviewModal = __webpack_require__(1301);

var _CannotReviewModal2 = _interopRequireDefault(_CannotReviewModal);

var _loyalty = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Program = function (_Component) {
  (0, _inherits3.default)(Program, _Component);

  function Program(props) {
    (0, _classCallCheck3.default)(this, Program);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Program.__proto__ || (0, _getPrototypeOf2.default)(Program)).call(this, props));

    _this._isReviewDisabled = function () {
      return !(_this._pointRuleValidity() && _this._rewardValidity() && _this._configurationValidity() && _this.state.isPointRuleVisited && _this.state.isRewardVisited && _this.state.isConfigurationVisited);
    };

    _this._changeActiveKey = function (activeKey) {
      // currently only do tracking for create
      if (_this.props.parentComponent === 'Create' && _this.state.activeKey !== activeKey) {
        if (activeKey === '1') {
          mpLoyalty.createProgramShowProgramType();
        } else if (activeKey === '2') {
          mpLoyalty.createProgramShowPointRule();
        } else if (activeKey === '3') {
          mpLoyalty.createProgramShowReward();
        } else if (activeKey === '4') {
          mpLoyalty.createProgramShowConfiguration();
        }
      }

      _this.setState({ activeKey: activeKey });
    };

    _this._pointRuleValidity = function () {
      return _this.props.spendingAmount >= 1000 && _this.props.pointFromSpendingAmount > 0;
    };

    _this._rewardValidity = function () {
      return _this.props.rewards.length > 0;
    };

    _this._configurationValidity = function () {
      return true;
    };

    _this._onFinishProgramType = function () {
      _this.setState({ isPointRuleVisited: true, activeKey: '2' });
      if (_this.props.parentComponent === 'Create') {
        mpLoyalty.createProgramShowPointRule();
      }
    };

    _this._onFinishPointRule = function () {
      _this.setState({ isRewardVisited: true, activeKey: '3' });
      if (_this.props.parentComponent === 'Create') {
        mpLoyalty.createProgramShowReward();
      }
    };

    _this._onFinishReward = function () {
      _this.setState({ isConfigurationVisited: true, activeKey: '4' });
      if (_this.props.parentComponent === 'Create') {
        mpLoyalty.createProgramShowConfiguration();
      }
    };

    _this._closeModal = function () {
      _this.setState({
        showModal: false
      });
    };

    _this._onClickReview = function (e) {
      e.stopPropagation();
      if (_this._isReviewDisabled()) {
        _this.setState({
          showModal: true
        });
      } else {
        _this.setState({ activeKey: '1' });
        _this.props.showReview();
      }
    };

    _this.state = {
      activeKey: '1',
      isPointRuleVisited: props.isAccordionEnabled,
      isRewardVisited: props.isAccordionEnabled,
      isConfigurationVisited: props.isAccordionEnabled,
      showModalAtFirst: !props.isAccordionEnabled,
      showModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(Program, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.parentComponent === 'Create') {
        mpLoyalty.createProgramShowProgramType();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isPointRuleVisited = _state.isPointRuleVisited,
          isRewardVisited = _state.isRewardVisited,
          isConfigurationVisited = _state.isConfigurationVisited;

      var isReviewDisabled = this._isReviewDisabled();
      var disabledReviewClass = isReviewDisabled ? _Program2.default['disabled-review-button'] + ' btn-basic' : 'btn-primary';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.PanelGroup,
          { activeKey: this.state.activeKey, accordion: true },
          _react2.default.createElement(
            _WrappedPanel2.default,
            {
              title: '1. LOYALTY PROGRAM TYPE',
              isOpened: this.state.activeKey === '1',
              isValid: true,
              isVisited: true,
              eventKey: '1',
              changeActiveKey: this._changeActiveKey
            },
            _react2.default.createElement(_ProgramType2.default, { onFinish: this._onFinishProgramType })
          ),
          _react2.default.createElement(
            _WrappedPanel2.default,
            {
              title: '2. POINT RULE',
              isOpened: this.state.activeKey === '2',
              isValid: this._pointRuleValidity(),
              isVisited: isPointRuleVisited,
              eventKey: '2',
              changeActiveKey: this._changeActiveKey
            },
            _react2.default.createElement(_PointRule2.default, {
              spendingAmount: this.props.spendingAmount,
              pointFromSpendingAmount: this.props.pointFromSpendingAmount,
              newMemberPoint: this.props.newMemberPoint,
              setSpendingAmount: this.props.setSpendingAmount,
              setPointFromSpendingAmount: this.props.setPointFromSpendingAmount,
              setNewMemberPoint: this.props.setNewMemberPoint,
              onFinish: this._onFinishPointRule
            })
          ),
          _react2.default.createElement(
            _WrappedPanel2.default,
            {
              title: '3. REWARD',
              isOpened: this.state.activeKey === '3',
              isValid: this._rewardValidity(),
              isVisited: isRewardVisited,
              eventKey: '3',
              changeActiveKey: this._changeActiveKey
            },
            _react2.default.createElement(_Reward2.default, {
              rewards: this.props.rewards,
              addReward: this.props.addReward,
              removeReward: this.props.removeReward,
              isOpened: this.state.activeKey === '3',
              onFinish: this._onFinishReward,
              showModalAtFirst: this.state.showModalAtFirst
            })
          ),
          _react2.default.createElement(
            _WrappedPanel2.default,
            {
              title: '4. LOYALTY PROGRAM CONFIGURATION',
              isOpened: this.state.activeKey === '4',
              isValid: this._configurationValidity(),
              isVisited: isConfigurationVisited,
              eventKey: '4',
              changeActiveKey: this._changeActiveKey
            },
            _react2.default.createElement(_ProgramConfiguration2.default, {
              toggleSentValidationCode: this.props.toggleSentValidationCode,
              sentValidationCode: this.props.sentValidationCode
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
              'button',
              { onClick: this.props.cancelProgram, style: { color: '#2e79b9' }, className: 'btn btn-default text-center form-control' },
              'Cancel'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-6' },
            _react2.default.createElement(
              'button',
              { onClick: this._onClickReview, className: 'btn text-center form-control ' + disabledReviewClass },
              'Review'
            )
          )
        ),
        _react2.default.createElement(_CannotReviewModal2.default, {
          show: this.state.showModal,
          close: this._closeModal
        })
      );
    }
  }]);
  return Program;
}(_react.Component);

Program.propTypes = {
  spendingAmount: _react.PropTypes.number.isRequired,
  pointFromSpendingAmount: _react.PropTypes.func.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  setSpendingAmount: _react.PropTypes.func.isRequired,
  setPointFromSpendingAmount: _react.PropTypes.func.isRequired,
  sentValidationCode: _react.PropTypes.bool.isRequired,
  toggleSentValidationCode: _react.PropTypes.func.isRequired,
  showReview: _react.PropTypes.func.isRequired
};

exports.default = Program;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProgramConfiguration = __webpack_require__(2078);

var _ProgramConfiguration2 = _interopRequireDefault(_ProgramConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgramConfiguration = function (_Component) {
  (0, _inherits3.default)(ProgramConfiguration, _Component);

  function ProgramConfiguration() {
    (0, _classCallCheck3.default)(this, ProgramConfiguration);
    return (0, _possibleConstructorReturn3.default)(this, (ProgramConfiguration.__proto__ || (0, _getPrototypeOf2.default)(ProgramConfiguration)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProgramConfiguration, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'top20' },
        _react2.default.createElement(
          'div',
          { className: 'bottom40' },
          _react2.default.createElement(
            'div',
            { className: 'row bottom10 top10' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              'Loyalty program time period'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'checkbox time-period' },
            _react2.default.createElement(
              'label',
              { className: 'blur50' },
              _react2.default.createElement('input', { type: 'checkbox', disabled: true }),
              ' Set time period (Coming Soon)'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: '' + _ProgramConfiguration2.default.blur70 },
            'For now, this Loyalty Program will run forever. You can choose to deactivate it later.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom30' },
          _react2.default.createElement(
            'div',
            { className: 'row bottom10 top10' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              'Security'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'checkbox security-configuration' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement('input', {
                type: 'checkbox',
                checked: this.props.sentValidationCode,
                onChange: this.props.toggleSentValidationCode
              }),
              'Send customer validation code'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: '' + _ProgramConfiguration2.default.blur70 },
            'If enabled, a validation code will be sent to customers via SMS for every reward redemptions.'
          )
        )
      );
    }
  }]);
  return ProgramConfiguration;
}(_react.Component);

ProgramConfiguration.propTypes = {
  sentValidationCode: _react.PropTypes.bool.isRequired,
  toggleSentValidationCode: _react.PropTypes.func.isRequired
};

exports.default = ProgramConfiguration;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProgramType = __webpack_require__(2079);

var _ProgramType2 = _interopRequireDefault(_ProgramType);

var _reactBootstrap = __webpack_require__(10);

var _Option = __webpack_require__(670);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgramType = function (_Component) {
  (0, _inherits3.default)(ProgramType, _Component);

  function ProgramType() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProgramType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgramType.__proto__ || (0, _getPrototypeOf2.default)(ProgramType)).call.apply(_ref, [this].concat(args))), _this), _this._onClickNext = function (e) {
      e.stopPropagation();
      _this.props.onFinish();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProgramType, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'top20' },
        _react2.default.createElement(
          'p',
          { className: _ProgramType2.default['action-label'] },
          'Choose the Loyalty Program you want to implement'
        ),
        _react2.default.createElement(
          _reactBootstrap.ListGroup,
          null,
          _react2.default.createElement(
            _reactBootstrap.ListGroupItem,
            { className: _ProgramType2.default['active'] + ' ' + _ProgramType2.default['program'] + ' bottom10 cursor-pointer' },
            _react2.default.createElement(_Option2.default, {
              img: __webpack_require__(951),
              title: 'Rp X = Y Point',
              body: 'Customers will get points for a certain amount of price they spend in one transaction.',
              isDisabled: false
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.ListGroupItem,
            { className: _ProgramType2.default['disabled'] + ' bottom10 cursor-not-allowed' },
            _react2.default.createElement(_Option2.default, {
              img: __webpack_require__(2860),
              title: 'Item X = Y Point (Coming Soon)',
              body: 'Customers will get points by purchasing specific item or any item in a category.',
              isDisabled: true
            })
          )
        ),
        _react2.default.createElement(
          'button',
          {
            onClick: this._onClickNext,
            style: { color: '#3e8acc' },
            className: 'btn btn-default pull-right'
          },
          'Next'
        )
      );
    }
  }]);
  return ProgramType;
}(_react.Component);

exports.default = ProgramType;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Option = __webpack_require__(670);

var _Option2 = _interopRequireDefault(_Option);

var _AddRewardModal = __webpack_require__(507);

var _AddRewardModal2 = _interopRequireDefault(_AddRewardModal);

var _reactBootstrap = __webpack_require__(10);

var _PercentageTypeInput = __webpack_require__(1309);

var _PercentageTypeInput2 = _interopRequireDefault(_PercentageTypeInput);

var _AmountTypeInput = __webpack_require__(1308);

var _AmountTypeInput2 = _interopRequireDefault(_AmountTypeInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRewardModal = function (_Component) {
  (0, _inherits3.default)(AddRewardModal, _Component);

  function AddRewardModal(props) {
    (0, _classCallCheck3.default)(this, AddRewardModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddRewardModal.__proto__ || (0, _getPrototypeOf2.default)(AddRewardModal)).call(this, props));

    _this._initialState = function () {
      return {
        discountInputError: null,
        pointInputError: null,
        maximumDiscountInputError: null,
        minimumPurchaseInputError: null,
        discountType: 'PERCENTAGE',
        point: '',
        discount: '',
        maximumDiscount: '',
        isMaximumDiscountEnabled: false,
        minimumPurchase: '',
        isMinimumPurchaseEnabled: false
      };
    };

    _this._isAddButtonDisabled = function () {
      var _this$state = _this.state,
          discountInputError = _this$state.discountInputError,
          pointInputError = _this$state.pointInputError,
          maximumDiscountInputError = _this$state.maximumDiscountInputError,
          minimumPurchaseInputError = _this$state.minimumPurchaseInputError,
          isMaximumDiscountEnabled = _this$state.isMaximumDiscountEnabled,
          isMinimumPurchaseEnabled = _this$state.isMinimumPurchaseEnabled;

      if (discountInputError !== '' || pointInputError !== '') {
        return true;
      }

      if (isMaximumDiscountEnabled && maximumDiscountInputError !== '') {
        return true;
      }

      if (isMinimumPurchaseEnabled && minimumPurchaseInputError !== '') {
        return true;
      }

      return false;
    };

    _this._onClickOption = function (discountType) {
      _this.setState(_this._initialState());
      _this.setState({ discountType: discountType });
    };

    _this._onClickCancel = function (e) {
      e.stopPropagation();
      _this.setState(_this._initialState());
      _this.props.hideModal();
    };

    _this._onChangePoint = function (displayedPoint, rawPoint) {
      var pointInputError = '';
      if (rawPoint <= 0) {
        pointInputError = 'Please input a value';
      } else {
        var rewards = _this.props.rewards;

        var maximum = 999999999999;
        if (rawPoint > maximum) {
          rawPoint = _this.state.point;
        }

        if ($.isNumeric(rawPoint)) {
          rawPoint = parseInt(rawPoint);
        }

        for (var i = 0; i < rewards.length; i++) {
          if (rewards[i].deleted) {
            continue;
          }
          if (rewards[i].point === rawPoint && rewards[i].discountType === _this.state.discountType) {
            pointInputError = 'Value cannot be the same with the existing rewards';
          }
        }
      }

      _this.setState({ point: rawPoint, pointInputError: pointInputError });
    };

    _this._onChangeDiscount = function (displayedDiscount, rawDiscount) {
      var discountInputError = '';
      if (rawDiscount <= 0) {
        discountInputError = 'Please input a value';
      } else {
        var rewards = _this.props.rewards;

        var maximum = _this.state.discountType === 'PERCENTAGE' ? 100 : 999999999999;
        if (rawDiscount > maximum) {
          rawDiscount = _this.state.discount;
        }

        if ($.isNumeric(rawDiscount)) {
          rawDiscount = parseInt(rawDiscount);
        }

        for (var i = 0; i < rewards.length; i++) {
          if (rewards[i].deleted) {
            continue;
          }
          if (rewards[i].discount === rawDiscount && rewards[i].discountType === _this.state.discountType) {
            discountInputError = 'Value cannot be the same with the existing rewards';
          }
        }
      }
      _this.setState({ discount: rawDiscount, discountInputError: discountInputError });
    };

    _this._onChangeMaximumDiscount = function (displayedDiscount, rawDiscount) {
      var maximumDiscountInputError = '';
      if (rawDiscount < 1000) {
        maximumDiscountInputError = 'Minimum value is Rp 1000';
      } else {
        var maximum = 999999999999;
        if (rawDiscount > maximum) {
          rawDiscount = _this.state.maximumDiscount;
        }

        if ($.isNumeric(rawDiscount)) {
          rawDiscount = parseInt(rawDiscount);
        }
      }

      _this.setState({ maximumDiscount: rawDiscount, maximumDiscountInputError: maximumDiscountInputError });
    };

    _this._onChangeMinimumPurchase = function (displayedPurchase, purchase) {
      var minimumPurchaseInputError = '';
      if (purchase < 1000) {
        minimumPurchaseInputError = 'Minimum value is Rp 1000';
      } else {
        var maximum = 999999999999;
        if (purchase > maximum) {
          purchase = _this.state.minimumPurchase;
        }

        if ($.isNumeric(purchase)) {
          purchase = parseInt(purchase);
        }
      }

      _this.setState({ minimumPurchase: purchase, minimumPurchaseInputError: minimumPurchaseInputError });
    };

    _this._onClickAdd = function (e) {
      e.stopPropagation();
      var _this$state2 = _this.state,
          point = _this$state2.point,
          discount = _this$state2.discount,
          discountType = _this$state2.discountType,
          minimumPurchase = _this$state2.minimumPurchase,
          maximumDiscount = _this$state2.maximumDiscount;

      _this.props.hideModal();
      _this.props.addReward({ discountType: discountType, point: point, discount: discount, minimumPurchase: minimumPurchase, maximumDiscount: maximumDiscount });
      _this.setState(_this._initialState());
    };

    _this._onChangeMaximumDiscountCheckbox = function (e) {
      var nextCheckBoxState = !_this.state.isMaximumDiscountEnabled;
      if (!nextCheckBoxState) {
        _this.setState({
          maximumDiscount: '',
          maximumDiscountInputError: null
        });
      }
      _this.setState({ isMaximumDiscountEnabled: nextCheckBoxState });
    };

    _this._onChangeMinimumPurchaseCheckbox = function (e) {
      var nextCheckBoxState = !_this.state.isMinimumPurchaseEnabled;
      if (!nextCheckBoxState) {
        _this.setState({
          minimumPurchase: '',
          minimumPurchaseInputError: null
        });
      }
      _this.setState({ isMinimumPurchaseEnabled: nextCheckBoxState });
    };

    _this.state = _this._initialState();
    return _this;
  }

  (0, _createClass3.default)(AddRewardModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.props.show, backdrop: 'static' },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            null,
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { color: '#ffffff' }, className: 'text-center' },
              'Add Reward'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { style: { padding: '25px 47px 15px 47px' } },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: _AddRewardModal2.default['title'] + ' bottom20' },
              'Reward Type'
            ),
            _react2.default.createElement(
              _reactBootstrap.ListGroup,
              null,
              _react2.default.createElement(
                _reactBootstrap.ListGroupItem,
                { className: (this.state.discountType === 'PERCENTAGE' ? _AddRewardModal2.default['active'] : '') + ' ' + _AddRewardModal2.default.reward + ' bottom10 cursor-pointer' },
                _react2.default.createElement(_Option2.default, {
                  img: __webpack_require__(2866),
                  title: 'Y Point = X% Discount of Total Sale',
                  body: 'Customers will get some percentages discount off an entire transaction when they redeem this reward.',
                  isDisabled: false,
                  type: 'PERCENTAGE',
                  onClick: this._onClickOption
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.ListGroupItem,
                { className: (this.state.discountType === 'AMOUNT' ? _AddRewardModal2.default['active'] : '') + ' ' + _AddRewardModal2.default.reward + ' bottom10 cursor-pointer' },
                _react2.default.createElement(_Option2.default, {
                  img: __webpack_require__(951),
                  title: 'Y Point = Rp X Discount of Total Sale',
                  body: 'Customers will get some rupiahs discount off an entire transaction when they redeem this reward.',
                  isDisabled: false,
                  type: 'AMOUNT',
                  onClick: this._onClickOption
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.ListGroupItem,
                { className: _AddRewardModal2.default['disabled'] + ' bottom20 cursor-not-allowed' },
                _react2.default.createElement(_Option2.default, {
                  img: __webpack_require__(2861),
                  title: 'Y Point = X% Discount on Item (Coming Soon)',
                  body: 'Customers will get some percentages discount off any specific item or category when they redeem this reward.',
                  isDisabled: true
                })
              )
            ),
            this.state.discountType === 'PERCENTAGE' && _react2.default.createElement(_PercentageTypeInput2.default, {
              point: this.state.point,
              onChangePoint: this._onChangePoint,
              pointInputError: this.state.pointInputError,
              discount: this.state.discount,
              onChangeDiscount: this._onChangeDiscount,
              discountInputError: this.state.discountInputError,
              isMaximumDiscountEnabled: this.state.isMaximumDiscountEnabled,
              onChangeMaximumDiscountCheckbox: this._onChangeMaximumDiscountCheckbox,
              maximumDiscount: this.state.maximumDiscount,
              onChangeMaximumDiscount: this._onChangeMaximumDiscount,
              maximumDiscountInputError: this.state.maximumDiscountInputError
            }),
            this.state.discountType === 'AMOUNT' && _react2.default.createElement(_AmountTypeInput2.default, {
              point: this.state.point,
              onChangePoint: this._onChangePoint,
              pointInputError: this.state.pointInputError,
              discount: this.state.discount,
              onChangeDiscount: this._onChangeDiscount,
              discountInputError: this.state.discountInputError,
              isMinimumPurchaseEnabled: this.state.isMinimumPurchaseEnabled,
              onChangeMinimumPurchaseCheckbox: this._onChangeMinimumPurchaseCheckbox,
              minimumPurchase: this.state.minimumPurchase,
              onChangeMinimumPurchase: this._onChangeMinimumPurchase,
              minimumPurchaseInputError: this.state.minimumPurchaseInputError
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: this._onClickCancel, className: 'btn btn-default pull-left' },
              'Cancel'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              {
                onClick: this._onClickAdd,
                className: 'btn btn-primary pull-right',
                disabled: this._isAddButtonDisabled()
              },
              'Add'
            )
          )
        )
      );
    }
  }]);
  return AddRewardModal;
}(_react.Component);

AddRewardModal.propTypes = {
  rewards: _react.PropTypes.array.isRequired,
  addReward: _react.PropTypes.func.isRequired,
  show: _react.PropTypes.bool.isRequired,
  hideModal: _react.PropTypes.func.isRequired
};

exports.default = AddRewardModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRewardModal = __webpack_require__(507);

var _AddRewardModal2 = _interopRequireDefault(_AddRewardModal);

var _reactBootstrap = __webpack_require__(10);

var _NumberInputWithFeedback = __webpack_require__(455);

var _NumberInputWithFeedback2 = _interopRequireDefault(_NumberInputWithFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popover = _react2.default.createElement(
  _reactBootstrap.Popover,
  { className: '' + _AddRewardModal2.default.popover, id: 'popover' },
  'If enabled, member will get Rp X',
  _react2.default.createElement('br', null),
  'discount when the Total',
  _react2.default.createElement('br', null),
  'transaction is equal or more than',
  _react2.default.createElement('br', null),
  'specified minimum purchase.'
);

var AmountTypeInput = function (_Component) {
  (0, _inherits3.default)(AmountTypeInput, _Component);

  function AmountTypeInput() {
    (0, _classCallCheck3.default)(this, AmountTypeInput);
    return (0, _possibleConstructorReturn3.default)(this, (AmountTypeInput.__proto__ || (0, _getPrototypeOf2.default)(AmountTypeInput)).apply(this, arguments));
  }

  (0, _createClass3.default)(AmountTypeInput, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row bottom5', style: { paddingTop: '20px' } },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: _AddRewardModal2.default['title'] + ' bottom10' },
              'Redeem Points (Y)'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.point,
              onChangeValue: this.props.onChangePoint,
              suffix: ' Points',
              placeholder: '0 Points',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.pointInputError
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom5' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: _AddRewardModal2.default['title'] + ' bottom10' },
              'Discount Rupiah on Total Sale (Rp X)'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom10' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.discount,
              onChangeValue: this.props.onChangeDiscount,
              prefix: 'Rp. ',
              placeholder: 'Rp. 0',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.discountInputError
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom5', style: { paddingTop: '20px' } },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: '' + _AddRewardModal2.default['title'] },
              'Rewards Rule'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { className: 'checkbox maximum-discount' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  checked: this.props.isMinimumPurchaseEnabled,
                  onChange: this.props.onChangeMinimumPurchaseCheckbox
                }),
                'Set minimum purchase',
                _react2.default.createElement(
                  _reactBootstrap.OverlayTrigger,
                  { placement: 'left', overlay: popover },
                  _react2.default.createElement('img', { className: '' + _AddRewardModal2.default['tooltip-image'], src: __webpack_require__(950) })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.minimumPurchase,
              onChangeValue: this.props.onChangeMinimumPurchase,
              prefix: 'Rp. ',
              placeholder: 'Rp. 0',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.minimumPurchaseInputError,
              disabled: !this.props.isMinimumPurchaseEnabled
            })
          )
        )
      );
    }
  }]);
  return AmountTypeInput;
}(_react.Component);

AmountTypeInput.propTypes = {
  point: _react.PropTypes.string.isRequired,
  onChangePoint: _react.PropTypes.func.isRequired,
  pointInputError: _react.PropTypes.string.isRequired,
  isMaximumDiscountEnabled: _react.PropTypes.bool.isRequired,
  onChangeMaximumDiscountCheckbox: _react.PropTypes.func.isRequired,
  minimumPurchase: _react.PropTypes.string.isRequired,
  onChangeMinimumPurchase: _react.PropTypes.func.isRequired,
  minimumPurchaseInputError: _react.PropTypes.string.isRequired
};

exports.default = AmountTypeInput;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRewardModal = __webpack_require__(507);

var _AddRewardModal2 = _interopRequireDefault(_AddRewardModal);

var _reactBootstrap = __webpack_require__(10);

var _NumberInputWithFeedback = __webpack_require__(455);

var _NumberInputWithFeedback2 = _interopRequireDefault(_NumberInputWithFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popover = _react2.default.createElement(
  _reactBootstrap.Popover,
  { className: '' + _AddRewardModal2.default.popover, id: 'popover' },
  'If enabled, member will get X%',
  _react2.default.createElement('br', null),
  'discount with specified',
  _react2.default.createElement('br', null),
  'maximum value'
);

var PercentageTypeInput = function (_Component) {
  (0, _inherits3.default)(PercentageTypeInput, _Component);

  function PercentageTypeInput() {
    (0, _classCallCheck3.default)(this, PercentageTypeInput);
    return (0, _possibleConstructorReturn3.default)(this, (PercentageTypeInput.__proto__ || (0, _getPrototypeOf2.default)(PercentageTypeInput)).apply(this, arguments));
  }

  (0, _createClass3.default)(PercentageTypeInput, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row bottom5', style: { paddingTop: '20px' } },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: _AddRewardModal2.default['title'] + ' bottom10' },
              'Redeem Points (Y)'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.point,
              onChangeValue: this.props.onChangePoint,
              suffix: ' Points',
              placeholder: '0 Points',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.pointInputError
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom5' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: _AddRewardModal2.default['title'] + ' bottom10' },
              'Discount Percentage on Total Sale (X%)'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom10' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.discount,
              onChangeValue: this.props.onChangeDiscount,
              suffix: '%',
              placeholder: '0%',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.discountInputError
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom5', style: { paddingTop: '20px' } },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '18px' }, className: '' + _AddRewardModal2.default['title'] },
              'Rewards Rule'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { className: 'checkbox maximum-discount' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  checked: this.props.isMaximumDiscountEnabled,
                  onChange: this.props.onChangeMaximumDiscountCheckbox
                }),
                'Set maximum discount value',
                _react2.default.createElement(
                  _reactBootstrap.OverlayTrigger,
                  { placement: 'top', overlay: popover },
                  _react2.default.createElement('img', { className: '' + _AddRewardModal2.default['tooltip-image'], src: __webpack_require__(950) })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(_NumberInputWithFeedback2.default, {
              inputValue: this.props.maximumDiscount,
              onChangeValue: this.props.onChangeMaximumDiscount,
              prefix: 'Rp. ',
              placeholder: 'Rp. 0',
              thousandSeparator: '.',
              decimalPrecision: 0,
              decimalSeparator: ',',
              errorMessage: this.props.maximumDiscountInputError,
              disabled: !this.props.isMaximumDiscountEnabled
            })
          )
        )
      );
    }
  }]);
  return PercentageTypeInput;
}(_react.Component);

PercentageTypeInput.propTypes = {
  point: _react.PropTypes.string.isRequired,
  onChangePoint: _react.PropTypes.func.isRequired,
  pointInputError: _react.PropTypes.string.isRequired,
  isMaximumDiscountEnabled: _react.PropTypes.bool.isRequired,
  onChangeMaximumDiscountCheckbox: _react.PropTypes.func.isRequired,
  maximumDiscount: _react.PropTypes.string.isRequired,
  onChangeMaximumDiscount: _react.PropTypes.func.isRequired,
  maximumDiscountInputError: _react.PropTypes.string.isRequired
};

exports.default = PercentageTypeInput;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AddRewardModal = __webpack_require__(1307);

var _AddRewardModal2 = _interopRequireDefault(_AddRewardModal);

var _RewardList = __webpack_require__(458);

var _RewardList2 = _interopRequireDefault(_RewardList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reward = function (_Component) {
  (0, _inherits3.default)(Reward, _Component);

  function Reward(props) {
    (0, _classCallCheck3.default)(this, Reward);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Reward.__proto__ || (0, _getPrototypeOf2.default)(Reward)).call(this, props));

    _this._onClickNext = function (e) {
      e.stopPropagation();
      _this.props.onFinish();
    };

    _this._onClickAddReward = function (e) {
      _this.setState({ showModal: true });
    };

    _this._hideAddRewardModal = function () {
      _this.setState({ showModal: false });
    };

    _this.state = {
      showModal: props.showModalAtFirst
    };
    return _this;
  }

  (0, _createClass3.default)(Reward, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rewards = _props.rewards,
          removeReward = _props.removeReward;

      var isDisabledNext = rewards.length === 0;
      return _react2.default.createElement(
        'div',
        { className: 'top20' },
        _react2.default.createElement(_AddRewardModal2.default, {
          addReward: this.props.addReward,
          rewards: this.props.rewards,
          show: this.props.isOpened && this.state.showModal,
          hideModal: this._hideAddRewardModal
        }),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20 top20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            'Customer can exchange'
          )
        ),
        _react2.default.createElement(_RewardList2.default, { removeReward: removeReward, rewards: rewards }),
        _react2.default.createElement(
          'div',
          { className: 'row bottom20' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'button',
              { className: 'btn btn-primary form-control', onClick: this._onClickAddReward },
              'Add Reward'
            )
          )
        ),
        _react2.default.createElement(
          'button',
          {
            style: { color: '' + (isDisabledNext ? '' : '#3e8acc') },
            className: 'btn btn-default pull-right',
            onClick: this._onClickNext,
            disabled: isDisabledNext
          },
          'Next'
        )
      );
    }
  }]);
  return Reward;
}(_react.Component);

Reward.propTypes = {
  rewards: _react.PropTypes.array.isRequired,
  addReward: _react.PropTypes.func.isRequired,
  removeReward: _react.PropTypes.func.isRequired,
  isOpened: _react.PropTypes.bool.isRequired
};

exports.default = Reward;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _WrappedPanelHeader = __webpack_require__(1312);

var _WrappedPanelHeader2 = _interopRequireDefault(_WrappedPanelHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedPanel = function (_Component) {
  (0, _inherits3.default)(WrappedPanel, _Component);

  function WrappedPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WrappedPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WrappedPanel.__proto__ || (0, _getPrototypeOf2.default)(WrappedPanel)).call.apply(_ref, [this].concat(args))), _this), _this._onClickPanel = function () {
      var _this$props = _this.props,
          changeActiveKey = _this$props.changeActiveKey,
          eventKey = _this$props.eventKey,
          isVisited = _this$props.isVisited;

      if (isVisited) {
        changeActiveKey(eventKey);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WrappedPanel, [{
    key: 'render',
    value: function render() {
      // ...props is passed by PanelGroup of bootstrap
      // reference http://stackoverflow.com/questions/28906086/react-bootstrap-accordion-not-collapsing-with-map
      var _props = this.props,
          title = _props.title,
          isValid = _props.isValid,
          isOpened = _props.isOpened,
          children = _props.children,
          isVisited = _props.isVisited,
          props = (0, _objectWithoutProperties3.default)(_props, ['title', 'isValid', 'isOpened', 'children', 'isVisited']);

      var header = _react2.default.createElement(_WrappedPanelHeader2.default, {
        title: title,
        isOpened: isOpened,
        isValid: isValid,
        isVisited: isVisited
      });
      return _react2.default.createElement(
        _reactBootstrap.Panel,
        (0, _extends3.default)({
          onClick: this._onClickPanel,
          header: header,
          eventKey: this.props.eventKey
        }, props),
        children
      );
    }
  }]);
  return WrappedPanel;
}(_react.Component);

WrappedPanel.propTypes = {
  children: _react.PropTypes.element,
  title: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  isValid: _react.PropTypes.bool,
  isOpened: _react.PropTypes.bool.isRequired,
  eventKey: _react.PropTypes.string.isRequired,
  changeActiveKey: _react.PropTypes.func.isRequired
};

exports.default = WrappedPanel;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Program = __webpack_require__(328);

var _Program2 = _interopRequireDefault(_Program);

var _reactFontawesome = __webpack_require__(198);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedPanelHeader = function (_Component) {
  (0, _inherits3.default)(WrappedPanelHeader, _Component);

  function WrappedPanelHeader() {
    (0, _classCallCheck3.default)(this, WrappedPanelHeader);
    return (0, _possibleConstructorReturn3.default)(this, (WrappedPanelHeader.__proto__ || (0, _getPrototypeOf2.default)(WrappedPanelHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(WrappedPanelHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          isValid = _props.isValid,
          isVisited = _props.isVisited;

      var icon = _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-up' });
      var titleStyle = _Program2.default['panel-title-disabled'];

      if (!isOpened) {
        if (!isVisited) {
          icon = _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-down' });
        } else {
          titleStyle = _Program2.default['panel-title'];
          if (isValid) {
            icon = _react2.default.createElement(_reactFontawesome2.default, { style: { color: 'green' }, name: 'check-circle' });
          } else {
            icon = _react2.default.createElement(_reactFontawesome2.default, { style: { color: 'red' }, name: 'minus-circle' });
          }
        }
      } else {
        titleStyle = _Program2.default['panel-title'];
      }

      return _react2.default.createElement(
        'div',
        { className: 'cursor-pointer' },
        _react2.default.createElement(
          'span',
          { className: titleStyle },
          this.props.title
        ),
        _react2.default.createElement(
          'span',
          { className: 'pull-right' },
          icon
        )
      );
    }
  }]);
  return WrappedPanelHeader;
}(_react.Component);

WrappedPanelHeader.propTypes = {
  title: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  isValid: _react.PropTypes.bool,
  isOpened: _react.PropTypes.bool.isRequired
};

exports.default = WrappedPanelHeader;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

var _ReviewInfo = __webpack_require__(457);

var _ReviewInfo2 = _interopRequireDefault(_ReviewInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateReview = function (_Component) {
  (0, _inherits3.default)(CreateReview, _Component);

  function CreateReview() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CreateReview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CreateReview.__proto__ || (0, _getPrototypeOf2.default)(CreateReview)).call.apply(_ref, [this].concat(args))), _this), _this._onClickConfirm = function (e) {
      e.stopPropagation();
      _this.props.confirmProgram();
    }, _this._onClickRevise = function (e) {
      e.stopPropagation();
      _this.props.revise();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CreateReview, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Review2.default['splash-page'] },
        _react2.default.createElement(
          'div',
          { style: { padding: '0px 30px 30px 30px' } },
          _react2.default.createElement(_ReviewInfo2.default, this.props),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 text-center ' + _Review2.default['button-fixed-position'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickRevise,
                  className: 'btn btn-default btn-lg ' + _Review2.default['review-button-revise']
                },
                'Revise'
              ),
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickConfirm,
                  className: 'btn btn-primary btn-lg ' + _Review2.default['review-button-confirm']
                },
                'Confirm Program'
              )
            )
          )
        )
      );
    }
  }]);
  return CreateReview;
}(_react.Component);

CreateReview.propTypes = {
  pointFromSpendingAmount: _react.PropTypes.array.isRequired,
  rewards: _react.PropTypes.array.isRequired,
  spendingAmount: _react.PropTypes.number.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  revise: _react.PropTypes.func.isRequired
};

exports.default = CreateReview;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

var _ReviewInfo = __webpack_require__(457);

var _ReviewInfo2 = _interopRequireDefault(_ReviewInfo);

var _EditReviewConfirmModal = __webpack_require__(1315);

var _EditReviewConfirmModal2 = _interopRequireDefault(_EditReviewConfirmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditReview = function (_Component) {
  (0, _inherits3.default)(EditReview, _Component);

  function EditReview(props) {
    (0, _classCallCheck3.default)(this, EditReview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EditReview.__proto__ || (0, _getPrototypeOf2.default)(EditReview)).call(this, props));

    _this._confirmEdit = function () {
      _this.props.confirmProgram();
      _this.setState({
        showConfirmModal: false
      });
    };

    _this._onClickConfirm = function (e) {
      e.stopPropagation();
      _this.setState({
        showConfirmModal: true
      });
    };

    _this._closeConfirmModal = function (e) {
      _this.setState({
        showConfirmModal: false
      });
    };

    _this._onClickRevise = function (e) {
      e.stopPropagation();
      _this.props.revise();
    };

    _this.state = {
      showConfirmModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(EditReview, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Review2.default['splash-page'] },
        _react2.default.createElement(
          'div',
          { style: { padding: '0px 30px 30px 30px' } },
          _react2.default.createElement(_ReviewInfo2.default, this.props),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 text-center ' + _Review2.default['button-fixed-position'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickRevise,
                  className: 'btn btn-default btn-lg ' + _Review2.default['review-button-revise']
                },
                'Revise'
              ),
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickConfirm,
                  className: 'btn btn-primary btn-lg ' + _Review2.default['review-button-confirm']
                },
                'Confirm Program'
              )
            )
          )
        ),
        _react2.default.createElement(_EditReviewConfirmModal2.default, {
          confirmEdit: this._confirmEdit,
          close: this._closeConfirmModal,
          show: this.state.showConfirmModal
        })
      );
    }
  }]);
  return EditReview;
}(_react.Component);

EditReview.propTypes = {
  pointFromSpendingAmount: _react.PropTypes.array.isRequired,
  rewards: _react.PropTypes.array.isRequired,
  spendingAmount: _react.PropTypes.number.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  revise: _react.PropTypes.func.isRequired
};

exports.default = EditReview;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditReviewConfirmModal = function (_Component) {
  (0, _inherits3.default)(EditReviewConfirmModal, _Component);

  function EditReviewConfirmModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditReviewConfirmModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditReviewConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(EditReviewConfirmModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickClose = function (e) {
      e.stopPropagation();
      _this.props.close();
    }, _this._onClickEdit = function (e) {
      e.stopPropagation();
      _this.props.confirmEdit();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditReviewConfirmModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            style: { top: '120px' },
            show: this.props.show,
            onHide: this._onClickClose,
            container: this,
            backdrop: 'static',
            dialogClassName: _Review2.default['modal-dialog']
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { className: _Review2.default['modal-header-danger'], closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { fontSize: '19px', fontWeight: '300' } },
              _react2.default.createElement(
                'div',
                null,
                'Edit Loyalty Program'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { className: _Review2.default['modal-body'] + ' top10 bottom10' },
            'Are You sure you want to edit the loyalty program? After you save, the changes will be implemented immediately to all outlet.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            'All the points and rewards redeemed by customer will not be changed.'
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-default', onClick: this._onClickClose },
              'Cancel'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-danger', onClick: this._onClickEdit },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return EditReviewConfirmModal;
}(_react.Component);

exports.default = EditReviewConfirmModal;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetConfirmModal = function (_Component) {
  (0, _inherits3.default)(ResetConfirmModal, _Component);

  function ResetConfirmModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetConfirmModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(ResetConfirmModal)).call.apply(_ref, [this].concat(args))), _this), _this._close = function (e) {
      e.stopPropagation();
      _this.props.close();
    }, _this._onClickReset = function (e) {
      e.stopPropagation();
      _this.props.confirmReset();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetConfirmModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            style: { top: '120px' },
            show: this.props.show,
            onHide: this._close,
            container: this,
            backdrop: 'static',
            dialogClassName: _Review2.default['modal-dialog']
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { className: _Review2.default['modal-header-danger'], closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { fontSize: '19px', fontWeight: '300' } },
              _react2.default.createElement(
                'div',
                null,
                'Reset Loyalty Program'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { className: _Review2.default['modal-body'] + ' top10 bottom10' },
            'Are you sure you want to reset the loyalty program? You will discard the current loyalty',
            _react2.default.createElement('br', null),
            'setting, reset the program and the customer\'s point balance.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              { className: _Review2.default['modal-highlighted-message'] },
              'Please make sure all customers & outlets are aware of this reset.'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-default', onClick: this._close },
              'Cancel'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-danger', onClick: this._onClickReset },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return ResetConfirmModal;
}(_react.Component);

exports.default = ResetConfirmModal;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Review = __webpack_require__(218);

var _Review2 = _interopRequireDefault(_Review);

var _ReviewInfo = __webpack_require__(457);

var _ReviewInfo2 = _interopRequireDefault(_ReviewInfo);

var _ResetConfirmModal = __webpack_require__(1316);

var _ResetConfirmModal2 = _interopRequireDefault(_ResetConfirmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetReview = function (_Component) {
  (0, _inherits3.default)(ResetReview, _Component);

  function ResetReview(props) {
    (0, _classCallCheck3.default)(this, ResetReview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResetReview.__proto__ || (0, _getPrototypeOf2.default)(ResetReview)).call(this, props));

    _this._confirmReset = function () {
      _this.setState({
        showConfirmModal: false
      });

      _this.props.confirmProgram();
    };

    _this._onClickConfirm = function (e) {
      e.stopPropagation();
      _this.setState({
        showConfirmModal: true
      });
    };

    _this._closeConfirmModal = function (e) {
      _this.setState({
        showConfirmModal: false
      });
    };

    _this._onClickRevise = function (e) {
      e.stopPropagation();
      _this.props.revise();
    };

    _this.state = {
      showConfirmModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(ResetReview, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Review2.default['splash-page'] },
        _react2.default.createElement(
          'div',
          { style: { padding: '0px 30px 30px 30px' } },
          _react2.default.createElement(_ReviewInfo2.default, this.props),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 text-center ' + _Review2.default['button-fixed-position'] },
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickRevise,
                  className: 'btn btn-default btn-lg ' + _Review2.default['review-button-revise']
                },
                'Revise'
              ),
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickConfirm,
                  className: 'btn btn-primary btn-lg ' + _Review2.default['review-button-confirm']
                },
                'Confirm Program'
              )
            )
          )
        ),
        _react2.default.createElement(_ResetConfirmModal2.default, {
          confirmReset: this._confirmReset,
          close: this._closeConfirmModal,
          show: this.state.showConfirmModal
        })
      );
    }
  }]);
  return ResetReview;
}(_react.Component);

ResetReview.propTypes = {
  pointFromSpendingAmount: _react.PropTypes.array.isRequired,
  rewards: _react.PropTypes.array.isRequired,
  spendingAmount: _react.PropTypes.number.isRequired,
  newMemberPoint: _react.PropTypes.number.isRequired,
  revise: _react.PropTypes.func.isRequired
};

exports.default = ResetReview;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__(198);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _RewardList = __webpack_require__(765);

var _RewardList2 = _interopRequireDefault(_RewardList);

var _formatter = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardInfo = function (_Component) {
  (0, _inherits3.default)(RewardInfo, _Component);

  function RewardInfo() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RewardInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RewardInfo.__proto__ || (0, _getPrototypeOf2.default)(RewardInfo)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRemove = function (e) {
      _this.props.removeReward(_this.props.index);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RewardInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLastRow = _props.isLastRow,
          isFirstRow = _props.isFirstRow,
          removeReward = _props.removeReward;

      var pointAdditionalClass = void 0;
      var discountAdditionalClass = void 0;
      if (!removeReward && !(isFirstRow && isLastRow)) {
        if (isFirstRow) {
          pointAdditionalClass = 'no-border-radius-bottom-left';
          discountAdditionalClass = 'no-border-radius-bottom-right';
        } else if (isLastRow) {
          pointAdditionalClass = 'no-border-radius-top-left no-border-top';
          discountAdditionalClass = 'no-border-radius-top-right no-border-top';
        } else {
          pointAdditionalClass = 'no-border-radius-left no-border-top';
          discountAdditionalClass = 'no-border-radius-right no-border-top';
        }
      }

      var message = void 0,
          extraInfoMessage = void 0;
      if (this.props.discountType === 'PERCENTAGE') {
        message = this.props.discount + '% Discount of Total Sale ';
        if (this.props.maximumDiscount) {
          extraInfoMessage = '(maximum value ' + (0, _formatter.rupiah)(this.props.maximumDiscount) + ')';
        }
      } else if (this.props.discountType === 'AMOUNT') {
        message = (0, _formatter.rupiah)(this.props.discount) + ' Discount of Total Sale ';
        if (this.props.minimumPurchase) {
          extraInfoMessage = '(minimum purchase ' + (0, _formatter.rupiah)(this.props.minimumPurchase) + ')';
        }
      }

      var popover = _react2.default.createElement(
        _reactBootstrap.Popover,
        { className: '' + _RewardList2.default.popover, id: 'popover' },
        message,
        _react2.default.createElement('br', null),
        extraInfoMessage
      );

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'col-md-4 no-padding-right ' },
          _react2.default.createElement(
            'div',
            {
              style: { borderRight: 'none', color: '#8e8e8e', fontWeight: '300' },
              className: 'form-control no-border-radius-right truncate ' + pointAdditionalClass
            },
            (0, _formatter.formatDecimal)(this.props.point),
            ' Points'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-8 no-padding-left' },
          _react2.default.createElement(
            _reactBootstrap.OverlayTrigger,
            { placement: 'top', overlay: popover },
            _react2.default.createElement(
              'div',
              {
                style: { color: '#8e8e8e', fontWeight: '300' },
                className: (removeReward ? 'has-feedback' : '') + ' truncate'
              },
              _react2.default.createElement(
                'div',
                {
                  style: { color: '#8e8e8e' },
                  className: 'form-control truncate no-border-radius-left ' + discountAdditionalClass
                },
                message,
                extraInfoMessage
              ),
              removeReward && _react2.default.createElement(_reactFontawesome2.default, {
                onClick: this._onClickRemove,
                className: 'form-control-feedback cursor-pointer ' + _RewardList2.default['remove-icon'],
                name: 'times-circle'
              })
            )
          )
        )
      );
    }
  }]);
  return RewardInfo;
}(_react.Component);

RewardInfo.propTypes = {
  point: _react.PropTypes.number.isRequired,
  discount: _react.PropTypes.number.isRequired,
  index: _react.PropTypes.number.isRequired
};

exports.default = RewardInfo;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CreateReview = __webpack_require__(1313);

var _CreateReview2 = _interopRequireDefault(_CreateReview);

var _WrappedProgram = __webpack_require__(456);

var _WrappedProgram2 = _interopRequireDefault(_WrappedProgram);

var _Subscribe = __webpack_require__(1320);

var _Subscribe2 = _interopRequireDefault(_Subscribe);

var _reactToggleDisplay = __webpack_require__(229);

var _reactToggleDisplay2 = _interopRequireDefault(_reactToggleDisplay);

var _reactAddonsUpdate = __webpack_require__(284);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _loyalty = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty);

var _reactRouter = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Create = function (_Component) {
  (0, _inherits3.default)(Create, _Component);

  function Create(props) {
    (0, _classCallCheck3.default)(this, Create);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Create.__proto__ || (0, _getPrototypeOf2.default)(Create)).call(this, props));

    _this._isDirty = function () {
      var _this$state = _this.state,
          spendingAmount = _this$state.spendingAmount,
          pointFromSpendingAmount = _this$state.pointFromSpendingAmount,
          newMemberPoint = _this$state.newMemberPoint,
          rewards = _this$state.rewards,
          sentValidationCode = _this$state.sentValidationCode;

      return spendingAmount !== '' || pointFromSpendingAmount !== '' || newMemberPoint !== '' || rewards.length > 0 || !sentValidationCode;
    };

    _this._createLoyalty = function () {
      var rewards = _this.state.rewards.map(function (reward) {
        var rewardReq = {
          'reward_type': 'TOTAL_SALES',
          'redeem_point': reward.point,
          'discount': reward.discount
        };

        if (reward.discountType === 'AMOUNT') {
          rewardReq.discount_type = 'AMOUNT';
          rewardReq.min_purchase_amount = reward.minimumPurchase;
        } else if (reward.discountType === 'PERCENTAGE') {
          rewardReq.max_discount_amount = reward.maximumDiscount;
          rewardReq.discount_type = 'PERCENTAGE';
        }
        return rewardReq;
      });

      var newMemberPoint = _this.state.newMemberPoint === '' ? 0 : _this.state.newMemberPoint;
      var data = {
        'earning_rule': {
          'type': 'SPENDING',
          'amount': _this.state.spendingAmount,
          'point': _this.state.pointFromSpendingAmount
        },
        'new_member_point': newMemberPoint,
        'description': '',
        'is_sent_validation_code': _this.state.sentValidationCode,
        'rewards': rewards
      };

      _this.props.createLoyalty(data);
      mpLoyalty.createLoyalty(data);
    };

    _this._setSpendingAmount = function (spendingAmount) {
      _this.setState({ spendingAmount: spendingAmount });
    };

    _this._setPointFromSpendingAmount = function (pointFromSpendingAmount) {
      _this.setState({ pointFromSpendingAmount: pointFromSpendingAmount });
    };

    _this._setNewMemberPoint = function (newMemberPoint) {
      _this.setState({ newMemberPoint: newMemberPoint });
    };

    _this._addReward = function (newReward) {
      _this.setState({ rewards: _this.state.rewards.concat(newReward) });
    };

    _this._removeReward = function (index) {
      _this.setState({
        rewards: (0, _reactAddonsUpdate2.default)(_this.state.rewards, { $splice: [[index, 1]] })
      });
    };

    _this._toggleSentValidationCode = function () {
      _this.setState({ sentValidationCode: !_this.state.sentValidationCode });
    };

    _this._showCreateProgram = function () {
      _this.setState({
        currentView: _this.state.views[0]
      });
      mpLoyalty.createProgramShowProgramType();
    };

    _this._showSubscribe = function () {
      _this.setState({
        currentView: _this.state.views[2]
      });
      mpLoyalty.createProgramShowSubscribeFreeTrial(_this.props.subscriptionExpiredDate);
    };

    _this._showReview = function () {
      _this.setState({
        currentView: _this.state.views[1]
      });
      mpLoyalty.createProgramShowReview();
    };

    var views = ['program', 'review', 'subscribe'];
    _this.state = {
      views: views,
      currentView: views[0],
      spendingAmount: '',
      pointFromSpendingAmount: '',
      newMemberPoint: '',
      rewards: [],
      sentValidationCode: true
    };
    return _this;
  }

  (0, _createClass3.default)(Create, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.removeBrowserListener = _reactRouter.browserHistory.listenBefore(function (location) {
        if (_this2._isDirty() && !_this2.props.nextAction) {
          _this2.props.askConfirmAction(location);
          return false;
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeBrowserListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          currentView = _state.currentView,
          views = _state.views,
          createState = (0, _objectWithoutProperties3.default)(_state, ['currentView', 'views']);

      return _react2.default.createElement(
        'div',
        { style: { height: '100%' } },
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[0] },
          _react2.default.createElement(_WrappedProgram2.default, (0, _extends3.default)({}, createState, {
            title: 'Create a Loyalty Program',
            parentComponent: 'Create',
            isAccordionEnabled: false,
            setSpendingAmount: this._setSpendingAmount,
            setPointFromSpendingAmount: this._setPointFromSpendingAmount,
            setNewMemberPoint: this._setNewMemberPoint,
            addReward: this._addReward,
            removeReward: this._removeReward,
            toggleSentValidationCode: this._toggleSentValidationCode,
            sentValidationCode: this.state.sentValidationCode,
            showReview: this._showReview,
            cancelProgram: this.props.cancelProgram
          }))
        ),
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[1] },
          _react2.default.createElement(_CreateReview2.default, (0, _extends3.default)({}, createState, {
            revise: this._showCreateProgram,
            confirmProgram: this._showSubscribe
          }))
        ),
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[2] },
          _react2.default.createElement(_Subscribe2.default, { subscriptionExpiredDate: this.props.subscriptionExpiredDate, createLoyalty: this._createLoyalty })
        )
      );
    }
  }]);
  return Create;
}(_react.Component);

exports.default = Create;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Create = __webpack_require__(2080);

var _Create2 = _interopRequireDefault(_Create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subscribe = function (_Component) {
  (0, _inherits3.default)(Subscribe, _Component);

  function Subscribe() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Subscribe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Subscribe.__proto__ || (0, _getPrototypeOf2.default)(Subscribe)).call.apply(_ref, [this].concat(args))), _this), _this._onClickStartTrial = function (e) {
      e.stopPropagation();
      _this.props.createLoyalty();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Subscribe, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Create2.default['splash-page'] + ' ' + _Create2.default['gray-backgrond'] },
        _react2.default.createElement(
          'div',
          { className: 'splash-box' },
          _react2.default.createElement(
            'div',
            { className: _Create2.default['splash-content'] },
            _react2.default.createElement(
              'div',
              { id: _Create2.default.create },
              _react2.default.createElement(
                'h3',
                { style: { color: '#000000' }, className: 'text-center bottom40 font-weight-300' },
                'Subscribe & Start Your Loyalty Program'
              ),
              _react2.default.createElement(
                'div',
                { id: _Create2.default.subscribe },
                _react2.default.createElement(
                  'p',
                  { style: { marginBottom: '25px' }, className: 'text-center' },
                  _react2.default.createElement('img', { className: 'img-circle', src: __webpack_require__(949) })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'text-center ' + _Create2.default['title'] },
                  'Loyalty Program Feature'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'text-center ' + _Create2.default['body-content'] },
                  'Earn your customer\'s loyalty by giving them rewards',
                  _react2.default.createElement('br', null),
                  'to keep them coming back. Start your loyalty',
                  _react2.default.createElement('br', null),
                  'program now!'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: '' + _Create2.default['pricing-title'] },
                    'Pricing'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: '' + _Create2.default['pricing-body'] },
                    _react2.default.createElement(
                      'span',
                      { className: 'pull-left' },
                      'Loyalty Program'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'pull-right' },
                      _react2.default.createElement(
                        'span',
                        { className: '' + _Create2.default['original-price'] },
                        'Rp 250.000/mo'
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        ' FREE'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'button',
                  { onClick: this._onClickStartTrial,
                    className: 'btn btn-primary btn-block ' + _Create2.default['start-trial-button']
                  },
                  'Start free trial'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Create2.default['free-trial-footer'] },
                  'Your free trial is due on ',
                  this.props.subscriptionExpiredDate
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Subscribe;
}(_react.Component);

exports.default = Subscribe;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(1639);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EditReview = __webpack_require__(1314);

var _EditReview2 = _interopRequireDefault(_EditReview);

var _WrappedProgram = __webpack_require__(456);

var _WrappedProgram2 = _interopRequireDefault(_WrappedProgram);

var _reactToggleDisplay = __webpack_require__(229);

var _reactToggleDisplay2 = _interopRequireDefault(_reactToggleDisplay);

var _reactAddonsUpdate = __webpack_require__(284);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _sortBy2 = __webpack_require__(549);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = function (_Component) {
  (0, _inherits3.default)(Edit, _Component);

  function Edit(props) {
    (0, _classCallCheck3.default)(this, Edit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Edit.__proto__ || (0, _getPrototypeOf2.default)(Edit)).call(this, props));

    _this._isDirty = function () {
      var _this$state = _this.state,
          spendingAmount = _this$state.spendingAmount,
          pointFromSpendingAmount = _this$state.pointFromSpendingAmount,
          newMemberPoint = _this$state.newMemberPoint,
          rewards = _this$state.rewards,
          sentValidationCode = _this$state.sentValidationCode;

      return spendingAmount !== _this.props.earning_rule.amount || pointFromSpendingAmount !== _this.props.earning_rule.point || newMemberPoint !== _this.props.new_member_point || sentValidationCode !== _this.props.is_sent_validation_code || (0, _stringify2.default)(rewards) !== (0, _stringify2.default)(_this._toDisplayRewards(_this.props.rewards));
    };

    _this._toDisplayRewards = function (rewards) {
      rewards = rewards.map(function (reward) {
        return {
          id: reward.reward_id,
          point: reward.redeem_point,
          discount: reward.discount,
          discountType: reward.discount_type,
          maximumDiscount: reward.max_discount_amount,
          minimumPurchase: reward.min_purchase_amount
        };
      });

      return (0, _sortBy3.default)(rewards, ['point']);
    };

    _this._setSpendingAmount = function (spendingAmount) {
      _this.setState({ spendingAmount: spendingAmount });
    };

    _this._setPointFromSpendingAmount = function (pointFromSpendingAmount) {
      _this.setState({ pointFromSpendingAmount: pointFromSpendingAmount });
    };

    _this._setNewMemberPoint = function (newMemberPoint) {
      _this.setState({ newMemberPoint: newMemberPoint });
    };

    _this._addReward = function (newReward) {
      _this.setState({ rewards: _this.state.rewards.concat(newReward) });
    };

    _this._removeReward = function (index) {
      _this.setState({
        rewards: (0, _reactAddonsUpdate2.default)(_this.state.rewards, (0, _defineProperty3.default)({}, index, { deleted: { $set: true } }))
      });
    };

    _this._toggleSentValidationCode = function () {
      _this.setState({ sentValidationCode: !_this.state.sentValidationCode });
    };

    _this._confirmProgram = function () {
      var rewards = _this.state.rewards.map(function (reward) {
        var rewardReq = {
          'reward_id': reward.id || null,
          'reward_type': 'TOTAL_SALES',
          'redeem_point': reward.point,
          'discount': reward.discount,
          'is_deleted': reward.deleted
        };

        if (reward.discountType === 'AMOUNT') {
          rewardReq.discount_type = 'AMOUNT';
          rewardReq.min_purchase_amount = reward.minimumPurchase;
        } else if (reward.discountType === 'PERCENTAGE') {
          rewardReq.max_discount_amount = reward.maximumDiscount;
          rewardReq.discount_type = 'PERCENTAGE';
        }
        return rewardReq;
      });

      var newMemberPoint = _this.state.newMemberPoint === '' ? 0 : _this.state.newMemberPoint;
      var data = {
        'earning_rule': {
          'id': _this.state.earningRuleId,
          'type': 'SPENDING',
          'amount': _this.state.spendingAmount,
          'point': _this.state.pointFromSpendingAmount
        },
        'new_member_point': newMemberPoint,
        'description': '',
        'is_sent_validation_code': _this.state.sentValidationCode,
        'rewards': rewards
      };
      _this.props.editLoyalty(data);
    };

    _this._showCreateProgram = function () {
      _this.setState({
        currentView: _this.state.views[0]
      });
    };

    _this._showReview = function () {
      _this.setState({
        currentView: _this.state.views[1]
      });
    };

    var views = ['program', 'review'];
    _this.state = {
      views: views,
      currentView: views[0],
      earningRuleId: props.earning_rule.id,
      spendingAmount: props.earning_rule.amount,
      pointFromSpendingAmount: props.earning_rule.point,
      newMemberPoint: props.new_member_point,
      rewards: _this._toDisplayRewards(props.rewards),
      sentValidationCode: props.is_sent_validation_code
    };
    return _this;
  }

  (0, _createClass3.default)(Edit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.removeBrowserListener = _reactRouter.browserHistory.listenBefore(function (location) {
        if (_this2._isDirty() && !_this2.props.nextAction) {
          _this2.props.askConfirmAction(location);
          return false;
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeBrowserListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          currentView = _state.currentView,
          views = _state.views,
          editState = (0, _objectWithoutProperties3.default)(_state, ['currentView', 'views']);

      return _react2.default.createElement(
        'div',
        { style: { height: '100%' } },
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[0] },
          _react2.default.createElement(_WrappedProgram2.default, (0, _extends3.default)({
            title: 'Edit Loyalty Program',
            isAccordionEnabled: true
          }, editState, {
            setSpendingAmount: this._setSpendingAmount,
            setPointFromSpendingAmount: this._setPointFromSpendingAmount,
            setNewMemberPoint: this._setNewMemberPoint,
            addReward: this._addReward,
            removeReward: this._removeReward,
            toggleSentValidationCode: this._toggleSentValidationCode,
            sentValidationCode: this.state.sentValidationCode,
            showReview: this._showReview,
            cancelProgram: this.props.cancelProgram
          }))
        ),
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[1] },
          _react2.default.createElement(_EditReview2.default, (0, _extends3.default)({}, editState, {
            revise: this._showCreateProgram,
            confirmProgram: this._confirmProgram
          }))
        )
      );
    }
  }]);
  return Edit;
}(_react.Component);

exports.default = Edit;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _Existing = __webpack_require__(329);

var _Existing2 = _interopRequireDefault(_Existing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeactivateConfirmModal = function (_Component) {
  (0, _inherits3.default)(DeactivateConfirmModal, _Component);

  function DeactivateConfirmModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DeactivateConfirmModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeactivateConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(DeactivateConfirmModal)).call.apply(_ref, [this].concat(args))), _this), _this._close = function (e) {
      e.stopPropagation();
      _this.props.close();
    }, _this._onClickDeactivate = function (e) {
      e.stopPropagation();
      _this.props.confirm();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DeactivateConfirmModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            style: { top: '120px' },
            show: this.props.show,
            onHide: this._close,
            container: this,
            backdrop: 'static',
            dialogClassName: _Existing2.default['modal-dialog']
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { className: _Existing2.default['modal-header'], closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { fontSize: '19px', fontWeight: '300' } },
              _react2.default.createElement(
                'div',
                null,
                'Deactivate Loyalty Program'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { className: _Existing2.default['modal-body'] + ' top10 bottom10' },
            'Are you sure you want to deactivate the loyalty program? Deactivation will stop the loyalty',
            _react2.default.createElement('br', null),
            'program immediately and customers will not be able to earn nor redeem points.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              { className: _Existing2.default['modal-highlighted-message'] },
              'Please make sure all customers & outlets are aware of this deactivation.'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-default', onClick: this._close },
              'Cancel'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-danger', onClick: this._onClickDeactivate },
              'Deactivate'
            )
          )
        )
      );
    }
  }]);
  return DeactivateConfirmModal;
}(_react.Component);

DeactivateConfirmModal.propTypes = {
  show: _react.PropTypes.bool.isRequired,
  close: _react.PropTypes.func.isRequired
};

exports.default = DeactivateConfirmModal;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Existing = __webpack_require__(329);

var _Existing2 = _interopRequireDefault(_Existing);

var _RewardList = __webpack_require__(458);

var _RewardList2 = _interopRequireDefault(_RewardList);

var _SuccessfulModal = __webpack_require__(1326);

var _SuccessfulModal2 = _interopRequireDefault(_SuccessfulModal);

var _formatter = __webpack_require__(11);

var _sortBy2 = __webpack_require__(549);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _ManageAction = __webpack_require__(1324);

var _ManageAction2 = _interopRequireDefault(_ManageAction);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _loyalty = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Existing = function (_Component) {
  (0, _inherits3.default)(Existing, _Component);

  function Existing() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Existing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Existing.__proto__ || (0, _getPrototypeOf2.default)(Existing)).call.apply(_ref, [this].concat(args))), _this), _this._toDisplayRewards = function () {
      var rewards = _this.props.rewards.map(function (reward) {
        return {
          point: reward.redeem_point,
          discount: reward.discount,
          discountType: reward.discount_type,
          maximumDiscount: reward.max_discount_amount,
          minimumPurchase: reward.min_purchase_amount
        };
      });

      return (0, _sortBy3.default)(rewards, ['point']);
    }, _this._showEdit = function () {
      _this.props.showEdit();
      mpLoyalty.editProgramStart();
    }, _this._showReset = function () {
      _this.props.showReset();
      mpLoyalty.resetProgramStart();
    }, _this._reactivateLoyalty = function (data) {
      _this.props.reactivateLoyalty(data);
      mpLoyalty.reactivateLoyalty(_this.props);
    }, _this._deactivateLoyalty = function () {
      _this.props.deactivateLoyalty();
      mpLoyalty.deactivateLoyalty(_this.props);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Existing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      mpLoyalty.showManageLoyalty();
    }
  }, {
    key: 'render',
    value: function render() {
      var spendingAmount = this.props.earning_rule.amount;
      var status = void 0;
      var durationExtraInfo = '';
      var statusFontColor = '#59bc23';
      if (this.props.status === 'ACTIVE') {
        status = 'Active';
        durationExtraInfo = ', until deactivated manually.';
      } else {
        statusFontColor = '#fbba35';
        status = 'Inactive since ' + (0, _moment2.default)(this.props.inactive_since).format('DD MMM YYYY');
      }

      return _react2.default.createElement(
        'div',
        { style: { paddingTop: '20px' } },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'div',
              { className: 'pull-right bottom20' },
              _react2.default.createElement(_ManageAction2.default, {
                status: status,
                showEdit: this._showEdit,
                showReset: this._showReset,
                reactivateLoyalty: this._reactivateLoyalty,
                deactivateLoyalty: this._deactivateLoyalty
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingRight: '38px' }, className: 'col-md-6' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['section-label'] },
                  'LOYALTY PROGRAM'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  'Status: ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: statusFontColor }, className: '' + _Existing2.default['program-info-chosen'] },
                    ' ',
                    status,
                    ' '
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  'Created At: ',
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    ' ',
                    (0, _moment2.default)(this.props.created_at).format('MM/DD/YYYY HH:mm')
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: '' + _Existing2.default['program-info'] },
                  'Created By: ',
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    ' ',
                    this.props.created_by,
                    ' '
                  )
                ),
                _react2.default.createElement('div', { className: 'bottom30' }),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  'Loyalty Program: ',
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    ' Rp X = Y Point '
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  'Point Rule: ',
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    'For every ',
                    (0, _formatter.rupiah)(spendingAmount),
                    ' member will get ',
                    (0, _formatter.formatDecimal)(this.props.earning_rule.point),
                    ' points'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  'New Member Point: ',
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    ' ',
                    (0, _formatter.formatDecimal)(this.props.new_member_point),
                    ' Points '
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row top30' },
              _react2.default.createElement(
                'div',
                { style: { paddingRight: '38px' }, className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['section-label'] },
                  'DURATION'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    'No expiry date',
                    durationExtraInfo
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row top30' },
              _react2.default.createElement(
                'div',
                { style: { paddingRight: '38px' }, className: 'col-md-12' },
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['section-label'] },
                  'Validation Code for Redeem'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Existing2.default['program-info'] },
                  _react2.default.createElement(
                    'span',
                    { className: _Existing2.default['program-info-chosen'] },
                    this.props.is_sent_validation_code ? 'Use SMS validation code for every reward redemption' : 'Do not use SMS validation code for reward redemptions'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: '38px' }, className: 'col-md-6' },
            _react2.default.createElement(
              'div',
              { className: _Existing2.default['section-label'] },
              'REWARD LIST'
            ),
            _react2.default.createElement(_RewardList2.default, { rewards: this._toDisplayRewards() })
          )
        ),
        _react2.default.createElement(_SuccessfulModal2.default, { close: this.props.closeSuccessModal, show: this.props.showSuccessModal })
      );
    }
  }]);
  return Existing;
}(_react.Component);

exports.default = Existing;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _DeactivateConfirmModal = __webpack_require__(1322);

var _DeactivateConfirmModal2 = _interopRequireDefault(_DeactivateConfirmModal);

var _ReactivateConfirmModal = __webpack_require__(1325);

var _ReactivateConfirmModal2 = _interopRequireDefault(_ReactivateConfirmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageAction = function (_Component) {
  (0, _inherits3.default)(ManageAction, _Component);

  function ManageAction(props) {
    (0, _classCallCheck3.default)(this, ManageAction);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ManageAction.__proto__ || (0, _getPrototypeOf2.default)(ManageAction)).call(this, props));

    _this._onClickEdit = function (e) {
      _this.props.showEdit();
    };

    _this._onClickReset = function (e) {
      _this.props.showReset();
    };

    _this._onClickDeactivate = function (e) {
      _this.setState({
        showDeactivateModal: true
      });
    };

    _this._confirmDeactivate = function () {
      _this._closeDeactivateModal();
      _this.props.deactivateLoyalty();
    };

    _this._closeDeactivateModal = function () {
      _this.setState({
        showDeactivateModal: false
      });
    };

    _this._onClickReactivate = function (e) {
      _this.setState({
        showReactivateModal: true
      });
    };

    _this._confirmReactivate = function (shouldResetPointBalance) {
      _this._closeReactivateModal();
      _this.props.reactivateLoyalty(shouldResetPointBalance);
    };

    _this._closeReactivateModal = function () {
      _this.setState({
        showReactivateModal: false
      });
    };

    _this.state = {
      showDeactivateModal: false,
      showReactivateModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(ManageAction, [{
    key: 'render',
    value: function render() {
      var menuItem = void 0;
      if (this.props.status === 'Active') {
        menuItem = _react2.default.createElement(
          _reactBootstrap.DropdownButton,
          { bsStyle: 'primary', pullRight: true, title: 'Manage' },
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: '1', onClick: this._onClickEdit },
            'Edit'
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: '2', onClick: this._onClickDeactivate },
            'Deactivate'
          )
        );
      } else {
        menuItem = _react2.default.createElement(
          _reactBootstrap.DropdownButton,
          { bsStyle: 'primary', pullRight: true, title: 'Manage' },
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: '1', onClick: this._onClickReactivate },
            _react2.default.createElement(
              'span',
              { style: { color: '#59bc23' } },
              'Reactivate'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: '2', onClick: this._onClickReset },
            'Reset Program'
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        menuItem,
        _react2.default.createElement(_DeactivateConfirmModal2.default, {
          show: this.state.showDeactivateModal,
          close: this._closeDeactivateModal,
          confirm: this._confirmDeactivate
        }),
        _react2.default.createElement(_ReactivateConfirmModal2.default, {
          show: this.state.showReactivateModal,
          close: this._closeReactivateModal,
          confirm: this._confirmReactivate
        })
      );
    }
  }]);
  return ManageAction;
}(_react.Component);

ManageAction.contextTypes = {
  mixpanel: _react.PropTypes.object.isRequired
};

exports.default = ManageAction;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _Existing = __webpack_require__(329);

var _Existing2 = _interopRequireDefault(_Existing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivateConfirmModal = function (_Component) {
  (0, _inherits3.default)(ReactivateConfirmModal, _Component);

  function ReactivateConfirmModal(props) {
    (0, _classCallCheck3.default)(this, ReactivateConfirmModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReactivateConfirmModal.__proto__ || (0, _getPrototypeOf2.default)(ReactivateConfirmModal)).call(this, props));

    _this._close = function (e) {
      e.stopPropagation();
      _this.props.close();
    };

    _this._onClickReactivate = function (e) {
      e.stopPropagation();
      var data = {};
      if (_this.state.shouldResetPointBalance) {
        data.reset = 'point';
      }
      _this.props.confirm(data);
    };

    _this._onClickResetPointBalanceYes = function (e) {
      _this.setState({
        shouldResetPointBalance: true
      });
    };

    _this._onClickResetPointBalanceNo = function (e) {
      _this.setState({
        shouldResetPointBalance: false
      });
    };

    _this.state = {
      shouldResetPointBalance: false
    };
    return _this;
  }

  (0, _createClass3.default)(ReactivateConfirmModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.show !== nextProps.show) {
        this.setState({ shouldResetPointBalance: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            style: { top: '120px' },
            show: this.props.show,
            onHide: this._close,
            container: this,
            backdrop: 'static',
            dialogClassName: _Existing2.default['modal-dialog']
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              { style: { fontSize: '19px', color: '#ffffff', fontWeight: '300' } },
              _react2.default.createElement(
                'div',
                null,
                'Reactivate Loyalty Program'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            { className: _Existing2.default['modal-body'] + ' top10 bottom10' },
            'Are you sure you want to reactivate the loyalty program? The program will run again for all',
            _react2.default.createElement('br', null),
            'outlets immediately. Please confirm the point configuration below:',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'form-horizontal clearfix bottom20' },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                { className: _Existing2.default['point-balance-label'] },
                'Reset customer\'s point balance?  '
              ),
              _react2.default.createElement(
                'div',
                { style: { float: 'left' } },
                _react2.default.createElement(
                  _reactBootstrap.Radio,
                  { className: 'point-balance-radio', onClick: this._onClickResetPointBalanceYes, name: 'radioGroup', checked: this.state.shouldResetPointBalance },
                  'Yes'
                ),
                _react2.default.createElement(
                  _reactBootstrap.Radio,
                  { className: 'point-balance-radio', onClick: this._onClickResetPointBalanceNo, name: 'radioGroup', checked: !this.state.shouldResetPointBalance },
                  'No'
                )
              )
            ),
            _react2.default.createElement(
              'span',
              { className: _Existing2.default['modal-highlighted-message'] },
              'Please make sure all customers & outlets are aware of this reactivation.'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-default', onClick: this._close },
              'Cancel'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { style: { width: '100px' }, className: 'btn btn-primary', onClick: this._onClickReactivate },
              'Reactivate'
            )
          )
        )
      );
    }
  }]);
  return ReactivateConfirmModal;
}(_react.Component);

ReactivateConfirmModal.propTypes = {
  show: _react.PropTypes.bool.isRequired,
  close: _react.PropTypes.func.isRequired
};

exports.default = ReactivateConfirmModal;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _Existing = __webpack_require__(329);

var _Existing2 = _interopRequireDefault(_Existing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessfulModal = function (_Component) {
  (0, _inherits3.default)(SuccessfulModal, _Component);

  function SuccessfulModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SuccessfulModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SuccessfulModal.__proto__ || (0, _getPrototypeOf2.default)(SuccessfulModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickClose = function (e) {
      e.stopPropagation();
      _this.props.close();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SuccessfulModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { style: { top: '85px' }, show: this.props.show },
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          { style: { padding: '45px' }, className: 'text-center' },
          _react2.default.createElement(
            'div',
            { className: 'bottom30' },
            _react2.default.createElement('img', { src: __webpack_require__(2868) })
          ),
          _react2.default.createElement(
            'div',
            { className: _Existing2.default['modal-title'] + ' bottom20' },
            'Congratulations! Your Loyalty Program',
            _react2.default.createElement('br', null),
            'Subscription is now Activated'
          ),
          _react2.default.createElement(
            'div',
            { className: _Existing2.default['modal-content'] + ' bottom40' },
            'Your Loyalty Program will be implemented to all outlets, and will',
            _react2.default.createElement('br', null),
            'be applied immediately for all transactions. Please make sure all',
            _react2.default.createElement('br', null),
            'of your customers and outlets are aware of this program.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            'You can check the status of your Subscription in',
            _react2.default.createElement(
              'a',
              { href: '/settings/billing' },
              ' Billing'
            ),
            ' page'
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickClose,
                  className: 'btn btn-default btn-lg btn-block ' + _Existing2.default['modal-close-button']
                },
                'Close'
              )
            )
          )
        )
      );
    }
  }]);
  return SuccessfulModal;
}(_react.Component);

exports.default = SuccessfulModal;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Introduction = __webpack_require__(2081);

var _Introduction2 = _interopRequireDefault(_Introduction);

var _loyalty = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty);

var _reactPlayer = __webpack_require__(599);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Introduction = function (_Component) {
  (0, _inherits3.default)(Introduction, _Component);

  function Introduction() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Introduction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Introduction.__proto__ || (0, _getPrototypeOf2.default)(Introduction)).call.apply(_ref, [this].concat(args))), _this), _this._onVideoPlay = function () {
      mpLoyalty.loyaltyVideoStart();
    }, _this._onClickCreateLoyaltyProgram = function () {
      _this.props.goToCreateView();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Introduction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      mpLoyalty.loyaltyStart();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Introduction2.default['splash-page'] + ' ' + _Introduction2.default['gray-backgrond'] },
        _react2.default.createElement(
          'div',
          { className: 'splash-box' },
          _react2.default.createElement(
            'div',
            { id: _Introduction2.default.create, className: _Introduction2.default['splash-content'] },
            _react2.default.createElement(
              'div',
              { id: _Introduction2.default.introduction },
              _react2.default.createElement(
                'p',
                { style: { marginBottom: '25px' }, className: 'text-center' },
                _react2.default.createElement('img', { className: 'img-circle', src: __webpack_require__(949) })
              ),
              _react2.default.createElement(
                'h4',
                { className: 'text-center ' + _Introduction2.default['title'] },
                'Loyalty Program Feature'
              ),
              _react2.default.createElement(
                'p',
                { className: 'text-center ' + _Introduction2.default['body-content'] },
                'Set up your Loyalty Program today and keep your customers coming back for repeat purchases!',
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                'Loyalty Program will be implemented to all',
                _react2.default.createElement('br', null),
                'your active outlets.'
              ),
              _react2.default.createElement(_reactPlayer2.default, { url: 'https://www.youtube.com/watch?v=iwIe4tpGK7Q&feature=youtu.be',
                height: '146px',
                width: '248px',
                className: _Introduction2.default['video-content'],
                playing: false,
                controls: true,
                onPlay: this._onVideoPlay
              }),
              _react2.default.createElement(
                'button',
                {
                  onClick: this._onClickCreateLoyaltyProgram,
                  className: 'btn btn-primary btn-block ' + _Introduction2.default['create-button']
                },
                'Create a Loyalty Program'
              ),
              _react2.default.createElement(
                'div',
                { className: _Introduction2.default.compatibility },
                _react2.default.createElement(
                  'b',
                  null,
                  'Compatibility:'
                ),
                ' Requires Moka App v7.0 (android tablet only) or v12.8 (iOS) or newer.'
              )
            )
          )
        )
      );
    }
  }]);
  return Introduction;
}(_react.Component);

Introduction.propTypes = {
  goToCreateView: _react.PropTypes.func.isRequired
};

exports.default = Introduction;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Loyalty = __webpack_require__(2082);

var _Loyalty2 = _interopRequireDefault(_Loyalty);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _Introduction = __webpack_require__(1327);

var _Introduction2 = _interopRequireDefault(_Introduction);

var _Create = __webpack_require__(1319);

var _Create2 = _interopRequireDefault(_Create);

var _Existing = __webpack_require__(1323);

var _Existing2 = _interopRequireDefault(_Existing);

var _Edit = __webpack_require__(1321);

var _Edit2 = _interopRequireDefault(_Edit);

var _Reset = __webpack_require__(1329);

var _Reset2 = _interopRequireDefault(_Reset);

var _formatter = __webpack_require__(11);

var _loyalty = __webpack_require__(609);

var _reactRouterRedux = __webpack_require__(49);

var _confirmAction = __webpack_require__(29);

var _loyalty2 = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty2);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _FeatureBlockerPage = __webpack_require__(635);

var _FeatureBlockerPage2 = _interopRequireDefault(_FeatureBlockerPage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loyalty = function (_Component) {
  (0, _inherits3.default)(Loyalty, _Component);

  function Loyalty(props) {
    (0, _classCallCheck3.default)(this, Loyalty);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Loyalty.__proto__ || (0, _getPrototypeOf2.default)(Loyalty)).call(this, props));

    _this._askConfirmAction = function (location) {
      _this.props.askConfirmAction((0, _reactRouterRedux.push)(location));
    };

    _this._createLoyalty = function (data) {
      _this.props.createLoyalty(data);
      _this.setState({ showSuccessfulSubscriptionModal: true });
    };

    _this._resetLoyalty = function (data) {
      _this.props.resetLoyalty(data);
      _this.setState({
        currentView: _this.state.views[2]
      });
      mpLoyalty.resetLoyalty(data);
    };

    _this._editLoyalty = function (data) {
      _this.props.editLoyalty(data);
      _this.setState({
        currentView: _this.state.views[2]
      });
      mpLoyalty.editLoyalty(data);
    };

    _this._showCreate = function () {
      _this.setState({
        currentView: _this.state.views[1]
      });
    };

    _this._cancelProgram = function () {
      if (_this.props.loyalty.hasLoyalty) {
        _this.setState({ currentView: _this.state.views[2] });
      } else {
        _this.setState({ currentView: _this.state.views[0] });
      }
    };

    _this._showEdit = function () {
      _this.setState({
        currentView: _this.state.views[3]
      });
    };

    _this._showReset = function () {
      _this.setState({
        currentView: _this.state.views[4]
      });
    };

    _this._closeSuccessfulSubscriptionModal = function () {
      _this.setState({ showSuccessfulSubscriptionModal: false });
    };

    var views = ['introduction', 'create', 'exist', 'edit'];
    _this.state = {
      views: views,
      currentView: props.loyalty.hasLoyalty ? views[2] : views[0],
      showSuccessfulSubscriptionModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(Loyalty, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.loyalty.hasLoyalty === null) {
        this.props.initLoyaltyData();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (Cookies.get('labelNewLoyalty') === undefined || Cookies.get('labelNewLoyalty') === 'true') {
        Cookies.set('labelNewLoyalty', 'false', { path: '/' });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasLoyalty = nextProps.loyalty.hasLoyalty;


      if (this.props.loyalty.hasLoyalty !== hasLoyalty) {
        if (hasLoyalty) {
          this.setState({ currentView: this.state.views[2] });
        } else {
          this.setState({ currentView: this.state.views[0] });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          loyalty = _props.loyalty;

      if (loyalty.hasLoyalty === null) {
        return null;
      }

      var _state = this.state,
          currentView = _state.currentView,
          views = _state.views;

      return _react2.default.createElement(
        'div',
        { id: 'loyalty-content', className: _Loyalty2.default.wrapper },
        !user.is_owner && !loyalty.hasLoyalty ? _react2.default.createElement(_FeatureBlockerPage2.default, null) : _react2.default.createElement(
          'div',
          { className: 'container ' + _Loyalty2.default['loyalty-container'] },
          currentView === views[0] && _react2.default.createElement(_Introduction2.default, { goToCreateView: this._showCreate }),
          currentView === views[1] && _react2.default.createElement(_Create2.default, {
            createLoyalty: this._createLoyalty,
            subscriptionExpiredDate: (0, _formatter.dateFormatter)(this.props.user.business.expired_at, 'DD MMMM YYYY'),
            askConfirmAction: this._askConfirmAction,
            nextAction: this.props.nextAction,
            cancelProgram: this._cancelProgram
          }),
          currentView === views[2] && _react2.default.createElement(_Existing2.default, (0, _extends3.default)({}, this.props.loyalty, {
            showSuccessModal: this.state.showSuccessfulSubscriptionModal,
            closeSuccessModal: this._closeSuccessfulSubscriptionModal,
            showEdit: this._showEdit,
            showReset: this._showReset,
            reactivateLoyalty: this.props.reactivateLoyalty,
            deactivateLoyalty: this.props.deactivateLoyalty
          })),
          currentView === views[3] && _react2.default.createElement(_Edit2.default, (0, _extends3.default)({}, this.props.loyalty, {
            editLoyalty: this._editLoyalty,
            askConfirmAction: this._askConfirmAction,
            nextAction: this.props.nextAction,
            cancelProgram: this._cancelProgram
          })),
          currentView === views[4] && _react2.default.createElement(_Reset2.default, {
            resetLoyalty: this._resetLoyalty,
            askConfirmAction: this._askConfirmAction,
            nextAction: this.props.nextAction,
            cancelProgram: this._cancelProgram
          })
        ),
        _react2.default.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Loyalty;
}(_react.Component);

function mapStateToProps(_ref) {
  var loyalty = _ref.customers.loyalty,
      user = _ref.moka.user,
      nextAction = _ref.confirmAction.nextAction;

  return {
    loyalty: loyalty,
    user: user,
    nextAction: nextAction
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  initLoyaltyData: _loyalty.initLoyaltyData,
  createLoyalty: _loyalty.createLoyalty,
  editLoyalty: _loyalty.editLoyalty,
  resetLoyalty: _loyalty.resetLoyalty,
  deactivateLoyalty: _loyalty.deactivateLoyalty,
  reactivateLoyalty: _loyalty.reactivateLoyalty,
  askConfirmAction: _confirmAction.askConfirmAction
})(Loyalty);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ResetReview = __webpack_require__(1317);

var _ResetReview2 = _interopRequireDefault(_ResetReview);

var _WrappedProgram = __webpack_require__(456);

var _WrappedProgram2 = _interopRequireDefault(_WrappedProgram);

var _reactToggleDisplay = __webpack_require__(229);

var _reactToggleDisplay2 = _interopRequireDefault(_reactToggleDisplay);

var _reactAddonsUpdate = __webpack_require__(284);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reset = function (_Component) {
  (0, _inherits3.default)(Reset, _Component);

  function Reset(props) {
    (0, _classCallCheck3.default)(this, Reset);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Reset.__proto__ || (0, _getPrototypeOf2.default)(Reset)).call(this, props));

    _this._isDirty = function () {
      var _this$state = _this.state,
          spendingAmount = _this$state.spendingAmount,
          pointFromSpendingAmount = _this$state.pointFromSpendingAmount,
          newMemberPoint = _this$state.newMemberPoint,
          rewards = _this$state.rewards,
          sentValidationCode = _this$state.sentValidationCode;

      return spendingAmount !== '' || pointFromSpendingAmount !== '' || newMemberPoint !== '' || rewards.length > 0 || !sentValidationCode;
    };

    _this._setSpendingAmount = function (spendingAmount) {
      _this.setState({ spendingAmount: spendingAmount });
    };

    _this._setPointFromSpendingAmount = function (pointFromSpendingAmount) {
      _this.setState({ pointFromSpendingAmount: pointFromSpendingAmount });
    };

    _this._setNewMemberPoint = function (newMemberPoint) {
      _this.setState({ newMemberPoint: newMemberPoint });
    };

    _this._addReward = function (newReward) {
      _this.setState({ rewards: _this.state.rewards.concat(newReward) });
    };

    _this._removeReward = function (index) {
      _this.setState({
        rewards: (0, _reactAddonsUpdate2.default)(_this.state.rewards, { $splice: [[index, 1]] })
      });
    };

    _this._toggleSentValidationCode = function () {
      _this.setState({ sentValidationCode: !_this.state.sentValidationCode });
    };

    _this._confirmProgram = function () {
      var rewards = _this.state.rewards.map(function (reward) {
        var rewardReq = {
          'reward_type': 'TOTAL_SALES',
          'redeem_point': reward.point,
          'discount': reward.discount
        };

        if (reward.discountType === 'AMOUNT') {
          rewardReq.discount_type = 'AMOUNT';
          rewardReq.min_purchase_amount = reward.minimumPurchase;
        } else if (reward.discountType === 'PERCENTAGE') {
          rewardReq.max_discount_amount = reward.maximumDiscount;
          rewardReq.discount_type = 'PERCENTAGE';
        }
        return rewardReq;
      });

      var newMemberPoint = _this.state.newMemberPoint === '' ? 0 : _this.state.newMemberPoint;
      var data = {
        'earning_rule': {
          'type': 'SPENDING',
          'amount': _this.state.spendingAmount,
          'point': _this.state.pointFromSpendingAmount
        },
        'new_member_point': newMemberPoint,
        'description': '',
        'is_sent_validation_code': _this.state.sentValidationCode,
        'rewards': rewards
      };

      _this.props.resetLoyalty(data);
    };

    _this._showCreateProgram = function () {
      _this.setState({
        currentView: _this.state.views[0]
      });
    };

    _this._showReview = function () {
      _this.setState({
        currentView: _this.state.views[1]
      });
    };

    var views = ['program', 'review'];
    _this.state = {
      views: views,
      currentView: views[0],
      spendingAmount: '',
      pointFromSpendingAmount: '',
      newMemberPoint: '',
      rewards: [],
      sentValidationCode: true
    };
    return _this;
  }

  (0, _createClass3.default)(Reset, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.removeBrowserListener = _reactRouter.browserHistory.listenBefore(function (location) {
        if (_this2._isDirty() && !_this2.props.nextAction) {
          _this2.props.askConfirmAction(location);
          return false;
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeBrowserListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          currentView = _state.currentView,
          views = _state.views,
          resetState = (0, _objectWithoutProperties3.default)(_state, ['currentView', 'views']);

      return _react2.default.createElement(
        'div',
        { style: { height: '100%' } },
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[0] },
          _react2.default.createElement(_WrappedProgram2.default, (0, _extends3.default)({}, resetState, {
            isAccordionEnabled: false,
            title: 'Reset Loyalty Program',
            setSpendingAmount: this._setSpendingAmount,
            setPointFromSpendingAmount: this._setPointFromSpendingAmount,
            setNewMemberPoint: this._setNewMemberPoint,
            addReward: this._addReward,
            removeReward: this._removeReward,
            toggleSentValidationCode: this._toggleSentValidationCode,
            sentValidationCode: this.state.sentValidationCode,
            showReview: this._showReview,
            cancelProgram: this.props.cancelProgram
          }))
        ),
        _react2.default.createElement(
          _reactToggleDisplay2.default,
          { show: currentView === views[1] },
          _react2.default.createElement(_ResetReview2.default, (0, _extends3.default)({}, resetState, {
            revise: this._showCreateProgram,
            confirmProgram: this._confirmProgram
          }))
        )
      );
    }
  }]);
  return Reset;
}(_react.Component);

exports.default = Reset;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loyalty = exports.Feedback = exports.CustomerList = undefined;

var _CustomerList = __webpack_require__(1257);

var _CustomerList2 = _interopRequireDefault(_CustomerList);

var _Feedback = __webpack_require__(1295);

var _Feedback2 = _interopRequireDefault(_Feedback);

var _Customer = __webpack_require__(1256);

var _Customer2 = _interopRequireDefault(_Customer);

var _Loyalty = __webpack_require__(1328);

var _Loyalty2 = _interopRequireDefault(_Loyalty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Customer2.default;
exports.CustomerList = _CustomerList2.default;
exports.Feedback = _Feedback2.default;
exports.Loyalty = _Loyalty2.default;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _dashboard = __webpack_require__(390);

var _ActionBar = __webpack_require__(2083);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _OutletModal = __webpack_require__(241);

var _OutletModal2 = _interopRequireDefault(_OutletModal);

var _BillingReminder = __webpack_require__(291);

var _BillingReminder2 = _interopRequireDefault(_BillingReminder);

var _dashboard2 = __webpack_require__(649);

var mpDashboard = _interopRequireWildcard(_dashboard2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onHideOutletModal = function () {
      _this.props.dispatch((0, _dashboard.showModalOutletMobile)(false));
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var outlet = _this.props.search.outlet;

      mpDashboard.dashboardChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _dashboard.changeDate)(startDate, endDate));
    }, _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpDashboard.dashboardChangeFilter({
        outletIds: outletIds, startDate: startDate, endDate: endDate
      });
      _this.props.dispatch((0, _dashboard.changeOutlet)(outletIds, startDate, endDate));
    }, _this._onSubmit = function (e) {
      e.preventDefault();
      e.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          showModalOutletMobileState = _props.showModalOutletMobileState,
          user = _props.user,
          subscriptionExpired = _props.subscriptionExpired;

      return React.createElement(
        'div',
        { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12' },
        React.createElement(
          'form',
          { className: 'form-inline', onSubmit: this._onSubmit },
          React.createElement(
            'div',
            { className: 'visible-lg visible-md' },
            React.createElement(_BillingReminder2.default, { user: user, subscriptionExpired: subscriptionExpired })
          ),
          React.createElement(
            'div',
            { className: 'form-group ' + _ActionBar2.default['form-group'] },
            React.createElement(
              'div',
              { className: 'visible-md visible-lg' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownOutlet2.default,
                name: 'outlet',
                outlets: outlets || [],
                onChangeOutletIds: this._onChangeOutlet,
                allOutletOption: true
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'form-group ' + _ActionBar2.default['form-group'] },
            React.createElement(_reduxForm.Field, {
              component: _DropdownCalendar2.default,
              name: 'date',
              onChange: this._onChangeDate,
              updateServerOnChange: true
            })
          )
        ),
        React.createElement(_reduxForm.Field, {
          component: _OutletModal2.default,
          name: 'outlet',
          outlets: outlets || [],
          onChangeOutletIds: this._onChangeOutlet,
          allOutletOption: true,
          show: showModalOutletMobileState
        })
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  return {
    outlets: state.dashboard.index.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile,
    user: state.moka.user,
    subscriptionExpired: state.subscriptionExpired
  };
}

var mapForm = {
  form: 'search'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartLoadingSpinner = function (_React$Component) {
  (0, _inherits3.default)(ChartLoadingSpinner, _React$Component);

  function ChartLoadingSpinner() {
    (0, _classCallCheck3.default)(this, ChartLoadingSpinner);
    return (0, _possibleConstructorReturn3.default)(this, (ChartLoadingSpinner.__proto__ || (0, _getPrototypeOf2.default)(ChartLoadingSpinner)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartLoadingSpinner, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { style: { width: '100%', height: '100%', textAlign: 'center' } },
        React.createElement('img', { src: __webpack_require__(591), width: '100px', height: '100px' })
      );
    }
  }]);
  return ChartLoadingSpinner;
}(React.Component);

exports.default = ChartLoadingSpinner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _reactGoogleCharts = __webpack_require__(376);

var _style = __webpack_require__(2085);

var _style2 = _interopRequireDefault(_style);

var _dashboard = __webpack_require__(390);

var _NoData = __webpack_require__(671);

var _NoData2 = _interopRequireDefault(_NoData);

var _TopItemsByCategoryAllChart = __webpack_require__(1334);

var _TopItemsByCategoryAllChart2 = _interopRequireDefault(_TopItemsByCategoryAllChart);

var _formatter = __webpack_require__(11);

var _ActionBar = __webpack_require__(1331);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reactRouter = __webpack_require__(15);

var _BillingReminder = __webpack_require__(291);

var _BillingReminder2 = _interopRequireDefault(_BillingReminder);

var _ChartLoadingSpinner = __webpack_require__(1332);

var _ChartLoadingSpinner2 = _interopRequireDefault(_ChartLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = function (_React$Component) {
  (0, _inherits3.default)(Dashboard, _React$Component);

  function Dashboard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dashboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dashboard.__proto__ || (0, _getPrototypeOf2.default)(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this._dailyGrossSalesAmount = function () {
      var transactions = _this.props.data.dashboard.index.transactions;

      var startDate = void 0;
      var endDate = void 0;
      if (_this.props.search.date) {
        startDate = _this.props.search.date.startDate;
        endDate = _this.props.search.date.endDate;
      } else {
        startDate = (0, _moment2.default)();
        endDate = (0, _moment2.default)();
      }

      var rows = [];
      rows.push([{ role: 'domain' }, 'Gross Sales']);

      var _loop = function _loop(currentDate) {
        var grossSales = 0;
        var numSales = 0;
        transactions.forEach(function (transaction) {
          if ((0, _moment2.default)(transaction.date_label).isSame(currentDate, 'day')) {
            transaction.payments.forEach(function (payment) {
              grossSales += Math.round(payment.gross_sales);
              numSales += 1;
            });
          }
        });
        var dateLabel = currentDate.format('DD-M-YYYY');
        rows.push([dateLabel, {
          v: grossSales,
          f: (0, _formatter.rupiah)(grossSales) + ' \n Num Sales: ' + numSales
        }]);
      };

      for (var currentDate = (0, _moment2.default)(startDate); currentDate.isSameOrBefore(endDate); currentDate.add(1, 'days')) {
        _loop(currentDate);
      }
      return { data: rows };
    }, _this._dayOfWeekSalesAmount = function () {
      var transactions = _this.props.data.dashboard.index.transactions;

      var data = {};
      // init by day of week
      for (var i = 0; i < 7; i++) {
        data[i] = { grossSales: 0, numSales: 0 };
      }
      var days = (0, _keys2.default)(data);
      var result = [];

      // PUSH HEADER
      result.push([{ role: 'domain' }, 'Gross Sales']);
      days.forEach(function (day) {
        transactions.forEach(function (transaction) {
          var transactionDate = (0, _moment2.default)(transaction.date_label, 'dddd, MMMM DD, YYYY').day();
          if (parseInt(transactionDate) === parseInt(day)) {
            transaction.payments.forEach(function (payment) {
              if (!payment.is_refunded) data[day].numSales += 1;
              data[day].grossSales += Math.round(payment.gross_sales);
            });
          }
        });
        var dayName = (0, _moment2.default)().day(day).format('ddd');
        if (data[day].grossSales === 0) {
          result.push([dayName, 0]);
        } else {
          result.push([dayName, {
            v: data[day].grossSales,
            f: (0, _formatter.rupiah)(data[day].grossSales) + ' \n Num Sales: ' + data[day].numSales
          }]);
        }
      });

      return { data: result };
    }, _this._hourlySalesAmount = function () {
      var transactions = _this.props.data.dashboard.index.transactions;

      var data = {};
      var result = [];
      for (var i = 0; i < 24; i++) {
        data[i] = { grossSales: 0, numSales: 0 };
      }
      var hours = (0, _keys2.default)(data);

      transactions.forEach(function (transaction) {
        transaction.payments.forEach(function (payment) {
          var hourLabel = (0, _moment2.default)(new Date(payment.created_at)).format('H');

          hours.forEach(function (hour) {
            if (parseInt(hour) === parseInt(hourLabel)) {
              data[hourLabel].grossSales += Math.round(payment.gross_sales);
              if (!payment.is_refunded) data[hourLabel].numSales += 1;
            }
          });
        });
      });
      // push header
      result.push([{ role: 'domain' }, 'Gross Sales']);
      // push data
      for (var _i = 0; _i < 24; _i++) {
        var hourly = data[_i];
        if (hourly.grossSales === 0) {
          result.push([_i, 0]);
        } else {
          result.push([_i, { v: hourly.grossSales, f: (0, _formatter.rupiah)(hourly.grossSales) + ' \n Num Sales: ' + hourly.numSales }]);
        }
      }
      return { data: result };
    }, _this._categorySalesAmountByRevenue = function () {
      var data = {};
      var colors = [];

      var totalRevenue = 0;

      var transactions = _this.props.data.dashboard.index.transactions;

      transactions.forEach(function (t) {
        t.payments.forEach(function (p) {
          totalRevenue += p.total_item_price_amount;
        });
      });
      transactions.forEach(function (t) {
        t.payments.forEach(function (p) {
          p.checkouts.forEach(function (c) {
            if (!p.is_refunded) {
              var categoryName = c.category_name;

              if (!data.hasOwnProperty(categoryName)) {
                var newColor = _this.getRandomColor();
                data[categoryName] = { name: categoryName, colorCode: newColor, revenue: 0 };
                colors.push(newColor);
              }

              data[categoryName].revenue += Math.round(c.revenue);
              data[categoryName].percent = data[categoryName].revenue / totalRevenue * 100;
            }
          });
        });
      });
      var rows = [];
      for (var key in data) {
        var value = data[key];
        rows.push([value.name, value.revenue, value.percent]);
      }
      rows = rows.sort(function (a, b) {
        return b[1] - a[1];
      });
      return { rows: rows, colors: colors };
    }, _this._categorySalesAmountByVolume = function () {
      var transactions = _this.props.data.dashboard.index.transactions;

      var colors = [];
      var data = {};
      transactions.forEach(function (transaction) {
        transaction.payments.forEach(function (payment) {
          var itemSold = payment.checkouts.length;
          payment.checkouts.forEach(function (checkout) {
            if (!payment.is_refunded) {
              var categoryName = checkout.category_name;

              if (!data.hasOwnProperty(categoryName)) {
                var newColor = _this.getRandomColor();
                data[categoryName] = { name: categoryName, count: 0, colorCode: newColor, percent: 0 };
                colors.push(newColor);
              }

              data[categoryName].count += checkout.quantity;
              data[categoryName].percent = data[categoryName].count / itemSold * 100;
            }
          }); // end payment checkouts
        }); // end transaction.payments
      }); // end transactions

      var rows = [];
      for (var key in data) {
        rows.push([data[key].name, data[key].count, data[key].percent]);
      }
      rows = rows.sort(function (a, b) {
        return b[1] - a[1];
      });
      return { rows: rows, colors: colors };
    }, _this._topItems = function () {
      var top_items = _this.props.data.dashboard.index.top_items;

      var rows = [];
      top_items.forEach(function (item) {
        rows.push([item.name, item.count, { v: item.revenue, f: (0, _formatter.rupiah)(item.revenue) }]);
      });
      return { rows: rows };
    }, _this.CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS = {
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      vAxis: { title: 'Category Sales by Sales', gridlines: { count: 0 } },
      hAxis: { title: 'Date' },
      is3D: false
    }, _this.CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS = [{ id: 'item', label: 'Item', type: 'string' }, { id: 'sales', label: 'Sales', type: 'number' }, { id: 'percent', label: 'Percent', type: 'number' }], _this.CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS = {
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      vAxis: { title: 'Category Sales by Volume', gridlines: { count: 20 } },
      hAxis: { title: 'Date' },
      is3D: false
    }, _this.CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS = [{ id: 'item', label: 'Item', type: 'string' }, { id: 'sales', label: 'Sales', type: 'number' }, { id: 'percent', label: 'Percent', type: 'number' }], _this.DAY_OF_WEEK_SALES_CHART_OPTIONS = {
      title: '',
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      vAxis: { title: '', gridlines: { count: 10, color: 'transparent' } },
      legend: { position: 'none' },
      hAxis: { title: '' },
      colors: ['#3498DB', '#3498DB'],
      areaOpacity: 1.0
    }, _this.HOURLY_SALES_CHART_OPTIONS = {
      title: '',
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      legend: { position: 'none' },
      vAxis: { title: '', gridlines: { count: 10, color: 'transparent' }, textStyle: { fontSize: 10 } },
      hAxis: {
        title: '',
        gridlines: { count: 24, color: 'transparent' },
        textStyle: { fontSize: 10 },
        baselineColor: 'transparent'
      },
      colors: ['#3498DB', '#3498DB'],
      areaOpacity: 1.0
    }, _this.TOP_ITEMS_CHART_COLUMNS = [{ 'type': 'string', 'label': 'Item' }, { 'type': 'number', 'label': 'Volume' }, { 'type': 'number', 'label': 'Sales' }], _this.DAILY_SALES_CHART_OPTIONS = {
      title: '',
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      legend: { position: 'none' },
      vAxis: { title: '', gridlines: { count: 10, color: 'transparent' } },
      hAxis: { title: '' },
      colors: ['#3498DB', '#3498DB'],
      areaOpacity: 1.0
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Dashboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      var expireTime = 365; // expire time 1 year
      if (!expired) {
        // TODO HIGH change based on update_filtered_date
        this.props.dispatch((0, _dashboard.pageRequest)());
        if (Cookies.get('labelNew') === 'true') {
          Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
        }
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var dailyGrossSalesAmount = this._dailyGrossSalesAmount();
      var categorySalesAmountByVolume = this._categorySalesAmountByVolume();
      var categorySalesAmountByRevenue = this._categorySalesAmountByRevenue();
      var dayOfWeekSalesAmount = this._dayOfWeekSalesAmount();
      var hourlySalesAmount = this._hourlySalesAmount();
      var topItems = this._topItems();
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;
      var _props$data = this.props.data,
          moka = _props$data.moka,
          subscriptionExpired = _props$data.subscriptionExpired;

      return _react2.default.createElement(
        'div',
        { className: 'container-full-nosub ng-scope', id: 'moka-dashboard' },
        _react2.default.createElement(
          'div',
          { className: 'visible-sm visible-xs ' + _style2.default['billing-reminder-dashboard'] },
          _react2.default.createElement(_BillingReminder2.default, { user: moka.user, subscriptionExpired: subscriptionExpired })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 ' + _style2.default.bottom },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(_ActionBar2.default, null)
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'h2',
                    { className: _style2.default['title-section'] },
                    'SALES SUMMARY'
                  )
                )
              ),
              _react2.default.createElement(_NoDataAndLoading2.default, {
                showLoadingSpinner: showLoadingSpinnerPage,
                noDataToDisplay: this.noTransaction() === 0,
                title: 'No Sales',
                description: 'You can make transactions through your device, or select different time frame.' }),
              this.noTransaction() > 0 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-amount-box' },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['about-box'] },
                        (0, _formatter.currencyFormatter)(this.props.data.dashboard.index.gross_sales)
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'title-center' },
                        'GROSS SALES'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-amount-box' },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['about-box'] },
                        (0, _formatter.currencyFormatter)(this.props.data.dashboard.index.net_sales)
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'title-center' },
                        'NET SALES'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-amount-box' },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['about-box'] },
                        this.props.data.dashboard.index.total_transactions
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'title-center' },
                        'NUMBER OF TRANSACTIONS'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-3' },
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-amount-box' },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['about-box'] },
                        (0, _formatter.currencyFormatter)(this.avgSales(this.props.data.dashboard.index.net_sales, this.props.data.dashboard.index.total_transactions))
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'title-center' },
                        'AVG. SALE PER TRANSACTION'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  dailyGrossSalesAmount.data.length > 2 && _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'DAILY GROSS SALES AMOUNT'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'AreaChart',
                          data: dailyGrossSalesAmount.data,
                          options: this.DAILY_SALES_CHART_OPTIONS,
                          graph_id: 'area-chart-daily',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-4' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'DAY OF THE WEEK GROSS SALES AMOUNT'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'ColumnChart',
                          data: dayOfWeekSalesAmount.data,
                          options: this.DAY_OF_WEEK_SALES_CHART_OPTIONS,
                          graph_id: 'area-chart-week',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-6 col-md-8' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'HOURLY GROSS SALES AMOUNT'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'AreaChart',
                          data: hourlySalesAmount.data,
                          options: this.HOURLY_SALES_CHART_OPTIONS,
                          graph_id: 'area-chart-hourly',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'h2',
                    { className: _style2.default['title-section'] },
                    'ITEM SUMMARY'
                  )
                )
              ),
              _react2.default.createElement(_NoDataAndLoading2.default, {
                showLoadingSpinner: showLoadingSpinnerPage,
                noDataToDisplay: this.noTransaction() === 0,
                title: 'No Sales',
                description: 'You can make transactions through your device, or select different time frame.' }),
              this.noTransaction() > 0 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-md-4' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'CATEGORY BY VOLUME'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        !!categorySalesAmountByVolume.rows.length && _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'PieChart',
                          rows: categorySalesAmountByVolume.rows,
                          colors: categorySalesAmountByVolume.colors,
                          columns: this.CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS,
                          options: this.CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS,
                          graph_id: 'area-chart-volume',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        }),
                        !categorySalesAmountByVolume.rows.length && _react2.default.createElement(_NoData2.default, null)
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-md-4' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'CATEGORY BY SALES'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        !!categorySalesAmountByRevenue.rows.length && _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'PieChart',
                          rows: categorySalesAmountByRevenue.rows,
                          colors: categorySalesAmountByRevenue.colors,
                          columns: this.CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS,
                          options: this.CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS,
                          graph_id: 'area-chart-sales',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        }),
                        !categorySalesAmountByRevenue.rows.length && _react2.default.createElement(_NoData2.default, null)
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-md-4' },
                    _react2.default.createElement(
                      'div',
                      { className: _style2.default['sales-chart-box'] },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'TOP ITEMS'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'my-pretty-chart-container' },
                        topItems.rows.length > 0 && _react2.default.createElement(_reactGoogleCharts.Chart, {
                          chartType: 'Table',
                          columns: this.TOP_ITEMS_CHART_COLUMNS,
                          rows: topItems.rows,
                          options: {},
                          graph_id: 'area-chart-top-item',
                          width: '100%',
                          height: '200px',
                          legend_toggle: true,
                          loader: _react2.default.createElement(_ChartLoadingSpinner2.default, null)
                        }),
                        !topItems.rows.length && _react2.default.createElement(_NoData2.default, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    _react2.default.createElement(
                      'div',
                      { className: 'mk-sales-chart-box' },
                      _react2.default.createElement(
                        'div',
                        { className: _style2.default['title-chart-left'] },
                        'TOP ITEMS BY CATEGORY'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_TopItemsByCategoryAllChart2.default, {
                          transactions: this.props.data.dashboard.index.transactions,
                          ChartLoadingSpinner: _ChartLoadingSpinner2.default
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'avgSales',
    value: function avgSales(netSales, numTransaction) {
      return netSales / (numTransaction || 1);
    }
  }, {
    key: 'noTransaction',
    value: function noTransaction() {
      return this.props.data.dashboard.index.transactions.length;
    }
  }, {
    key: 'getRandomColor',
    value: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    // Tambahan ada toolTip: isHtml true

  }]);
  return Dashboard;
}(_react2.default.Component);

Dashboard.propTypes = {
  data: _react2.default.PropTypes.object,
  history: _react2.default.PropTypes.object,
  dispatch: _react2.default.PropTypes.func,
  rupiah: _react2.default.PropTypes.func
};

var selector = (0, _reduxForm.formValueSelector)('search');

// Which props do we want to inject, given the global state?
function select(state) {
  return {
    data: state,
    search: {
      date: selector(state, 'date')
    }
  };
}

// Wrap the component to inject dispatch and state into it
exports.default = (0, _reactRedux.connect)(select)(Dashboard);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactGoogleCharts = __webpack_require__(376);

var _NoData = __webpack_require__(671);

var _NoData2 = _interopRequireDefault(_NoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopItemsByCategoryAllChart = function (_React$Component) {
  (0, _inherits3.default)(TopItemsByCategoryAllChart, _React$Component);

  function TopItemsByCategoryAllChart(props) {
    (0, _classCallCheck3.default)(this, TopItemsByCategoryAllChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopItemsByCategoryAllChart.__proto__ || (0, _getPrototypeOf2.default)(TopItemsByCategoryAllChart)).call(this, props));

    _this._topItemsByCategory = function () {
      var charts = [];
      var data = {};
      _this.props.transactions.forEach(function (t) {
        t.payments.forEach(function (p) {
          p.checkouts.forEach(function (c) {
            var categoryName = c.category_name;
            var itemName = c.item_name;

            if (itemName && !p.is_refunded) {
              if (!data.hasOwnProperty(categoryName)) {
                data[categoryName] = { name: categoryName, items: {} };
                charts.push(data[categoryName]);
              }

              if (!data[categoryName].items.hasOwnProperty(itemName)) {
                data[categoryName].items[itemName] = { name: itemName, count: 0, gross_sales: 0 };
              }
              data[categoryName].items[itemName].count += c.quantity;
              data[categoryName].items[itemName].gross_sales += c.gross_sales;
            }
          });
        });
      });
      // convert all of this into array
      var retState = [];
      for (var categoryName in data) {
        var categoryItems = { name: categoryName };
        categoryItems.items = [];
        var items = data[categoryName].items;
        for (var itemName in items) {
          categoryItems.items.push({
            name: data[categoryName].items[itemName].name,
            count: data[categoryName].items[itemName].count,
            gross_sales: data[categoryName].items[itemName].gross_sales
          });
        }
        retState.push(categoryItems);
      }
      var stateCharts = [];
      retState.forEach(function (chart) {
        var chartRows = [];
        // header
        chartRows.push([{ role: 'domain' }, 'Count']);
        chart.items.sort(_this._cmpItemDesc);

        for (var i = 0; i < Math.min(3, chart.items.length); i++) {
          var item = chart.items[i];
          chartRows.push([item.name, item.count]);
        }
        stateCharts.push({ name: chart.name, rows: chartRows });
      });
      return { charts: stateCharts };
    };

    _this.state = {
      charts: []
    };
    return _this;
  }

  (0, _createClass3.default)(TopItemsByCategoryAllChart, [{
    key: 'render',
    value: function render() {
      var topItemsByCategory = this._topItemsByCategory();
      var ChartLoadingSpinner = this.props.ChartLoadingSpinner;

      return React.createElement(
        'div',
        null,
        topItemsByCategory.charts.length > 0 && topItemsByCategory.charts.map(function (chart, idx) {
          var chartOptions = {
            title: chart.name,
            legend: { position: 'none' },
            vAxis: { gridlines: { colors: 'transparent' } },
            colors: ['#3498DB', '#3498DB']
          };

          return React.createElement(
            'div',
            { key: idx, className: 'col-md-3' },
            React.createElement(
              'div',
              { className: 'categories-sales-by-volume' },
              React.createElement(_reactGoogleCharts.Chart, {
                chartType: 'ColumnChart',
                data: chart.rows,
                options: chartOptions,
                graph_id: 'top-items-by-category-' + idx + '-chart',
                width: '100%',
                height: '200px',
                legend_toggle: true,
                loader: React.createElement(ChartLoadingSpinner, null)
              })
            )
          );
        }),
        !topItemsByCategory.charts.length && React.createElement(_NoData2.default, null)
      );
    }
  }, {
    key: '_cmpItemDesc',


    /**
     *
     * @param {{name,count, gross_sales}} itemA
     * @param {{name,count, gross_sales}} itemB
     * @private
     */
    value: function _cmpItemDesc(itemA, itemB) {
      if (itemA.count !== itemB.count) {
        if (itemA.count > itemB.count) {
          return -1;
        } else {
          return 1;
        }
      } else if (itemA.gross_sales !== itemB.gross_sales) {
        if (itemA.gross_sales > itemB.gross_sales) {
          return -1;
        } else {
          return 1;
        }
      } else {
        return 0;
      }
    }
  }]);
  return TopItemsByCategoryAllChart;
}(React.Component);

TopItemsByCategoryAllChart.propTypes = {
  transactions: React.PropTypes.array,
  ChartLoadingSpinner: React.PropTypes.node
};
exports.default = TopItemsByCategoryAllChart;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Employee = __webpack_require__(2086);

var _Employee2 = _interopRequireDefault(_Employee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Employee = function (_React$Component) {
  (0, _inherits3.default)(Employee, _React$Component);

  function Employee() {
    (0, _classCallCheck3.default)(this, Employee);
    return (0, _possibleConstructorReturn3.default)(this, (Employee.__proto__ || (0, _getPrototypeOf2.default)(Employee)).apply(this, arguments));
  }

  (0, _createClass3.default)(Employee, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Employee2.default['container-full-nosub'], id: 'moka-employee' },
        React.createElement(
          'div',
          { className: 'container box-report-child ' + _Employee2.default['container'] },
          this.props.children
        )
      );
    }
  }]);
  return Employee;
}(React.Component);

exports.default = Employee;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Header = __webpack_require__(2087);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Header2.default['wrapper'] },
        this.props.title
      );
    }
  }]);
  return Header;
}(React.Component);

Header.propTypes = {
  title: React.PropTypes.string
};

exports.default = Header;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _list = __webpack_require__(200);

var _ConfirmDeleteModal = __webpack_require__(2088);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDeleteModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDeleteModal, _React$Component);

  function ConfirmDeleteModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmDeleteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmDeleteModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDeleteModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _list.cancelDeleteEmployee)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          deletedEmployee = _this$props.deletedEmployee,
          dispatch = _this$props.dispatch;

      dispatch((0, _list.confirmDeleteEmployee)(deletedEmployee));
    }, _this._isJSONFromEmployee = function (json) {
      return json.hasOwnProperty('user');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmDeleteModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteEmployeeModal = _props.showDeleteEmployeeModal,
          deletedEmployee = _props.deletedEmployee;


      if (!deletedEmployee) return React.createElement('div', null);

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showDeleteEmployeeModal, onHide: this._onHide, bsClass: 'employee-list-delete-modal margin-top-modal modal' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmDeleteModal2.default.header },
          'Delete Employee'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          this._isJSONFromEmployee(deletedEmployee) && 'Are you sure want to remove ' + deletedEmployee.user.first_name + ' ' + deletedEmployee.user.last_name + ' ?',
          !this._isJSONFromEmployee(deletedEmployee) && 'Are you sure want to remove ' + deletedEmployee.first_name + ' ' + deletedEmployee.last_name + ' ?'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { onClick: this._onConfirm, className: 'btn btn-danger' },
            'Delete'
          )
        )
      );
    }
  }]);
  return ConfirmDeleteModal;
}(React.Component);

ConfirmDeleteModal.propTypes = {
  showDeleteEmployeeModal: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  deletedEmployee: React.PropTypes.object
};

exports.default = ConfirmDeleteModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmDeleteModal = __webpack_require__(1337);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ConfirmDeleteModal2.default;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AssignOutletModal = __webpack_require__(2089);

var _AssignOutletModal2 = _interopRequireDefault(_AssignOutletModal);

var _reactBootstrap = __webpack_require__(10);

var _reduxForm = __webpack_require__(7);

var _list = __webpack_require__(200);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selector = (0, _reduxForm.formValueSelector)('invite');

var _renderName = function _renderName(_ref) {
  var value = _ref.input.value;

  return React.createElement(
    'p',
    null,
    value
  );
};

var OutletField = function (_React$Component) {
  (0, _inherits3.default)(OutletField, _React$Component);

  function OutletField() {
    (0, _classCallCheck3.default)(this, OutletField);
    return (0, _possibleConstructorReturn3.default)(this, (OutletField.__proto__ || (0, _getPrototypeOf2.default)(OutletField)).apply(this, arguments));
  }

  (0, _createClass3.default)(OutletField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          member = _props.member,
          outlet = _props.outlet;

      return outlet.show && React.createElement(
        'li',
        { className: _AssignOutletModal2.default.row },
        React.createElement(
          'div',
          { className: 'col-xs-12' },
          React.createElement(
            'div',
            { className: 'col-xs-10' },
            React.createElement(_reduxForm.Field, {
              name: member + '.name',
              component: _renderName
            })
          ),
          React.createElement(
            'div',
            { className: 'col-xs-2' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(_reduxForm.Field, {
                name: member + '.checked',
                component: 'input',
                type: 'checkbox'
              })
            )
          )
        )
      );
    }
  }]);
  return OutletField;
}(React.Component);

var OutletFieldArray = function (_React$Component2) {
  (0, _inherits3.default)(OutletFieldArray, _React$Component2);

  function OutletFieldArray() {
    var _ref2;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, OutletFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = OutletFieldArray.__proto__ || (0, _getPrototypeOf2.default)(OutletFieldArray)).call.apply(_ref2, [this].concat(args))), _this2), _this2._onChange = function (e) {
      var _this2$props = _this2.props,
          dispatch = _this2$props.dispatch,
          outlets = _this2$props.outlets;

      var value = e.target.value;
      dispatch((0, _list.searchOutlet)(outlets, 'invite', 'outlets', value));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(OutletFieldArray, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          fields = _props2.fields,
          outlets = _props2.outlets;


      return React.createElement(
        _reactBootstrap.Modal.Body,
        { bsClass: 'modal-body ' + _AssignOutletModal2.default['modal-body'] },
        React.createElement(
          'div',
          { className: 'col-md-12', style: { 'margin-bottom': '20px' } },
          React.createElement(
            'div',
            { className: 'right-inner-addon' },
            React.createElement('i', { className: 'fa fa-search' }),
            React.createElement('input', { className: 'form-control', placeholder: 'Search', onChange: this._onChange })
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'ul',
            null,
            fields.map(function (member, index) {
              return React.createElement(OutletField, { member: member, index: index, outlet: outlets[index] });
            })
          )
        )
      );
    }
  }]);
  return OutletFieldArray;
}(React.Component);

// function mapStateToOutletFieldArrayProps(state){
//   return {
//     data: {
//       inviteForm: {
//         outlets: selector(state,'outlets')
//       }
//     }
//   }
// }

OutletFieldArray.propTypes = {
  dispatch: React.PropTypes.func
};

var AssignOutletModal = function (_React$Component3) {
  (0, _inherits3.default)(AssignOutletModal, _React$Component3);

  function AssignOutletModal() {
    var _ref3;

    var _temp2, _this3, _ret2;

    (0, _classCallCheck3.default)(this, AssignOutletModal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = AssignOutletModal.__proto__ || (0, _getPrototypeOf2.default)(AssignOutletModal)).call.apply(_ref3, [this].concat(args))), _this3), _this3._onCancel = function () {
      var checkedOutlets = _this3.props.data.employee.list.checkedOutlets;

      _this3.props.dispatch((0, _list.cancelAssignOutlets)(checkedOutlets, 'invite', 'outlets'));
    }, _this3._onConfirm = function () {
      var outlets = _this3.props.data.inviteForm.outlets;

      _this3.props.dispatch((0, _list.confirmAssignOutlets)(outlets));
    }, _this3._onClickCheckAll = function () {
      var outlets = _this3.props.data.inviteForm.outlets;

      _this3.props.dispatch((0, _list.checkAllOutlets)(outlets, 'invite', 'outlets'));
    }, _this3._onClickUncheckAll = function () {
      var outlets = _this3.props.data.inviteForm.outlets;

      _this3.props.dispatch((0, _list.uncheckAllOutlets)(outlets, 'invite', 'outlets'));
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret2);
  }

  (0, _createClass3.default)(AssignOutletModal, [{
    key: 'render',
    value: function render() {
      var showAssignOutletModal = this.props.data.employee.list.showAssignOutletModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAssignOutletModal, dialogClassName: _AssignOutletModal2.default['modal-dialog'] },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _AssignOutletModal2.default.header },
          'Assign Outlet To Employee'
        ),
        React.createElement(_reduxForm.FieldArray, {
          name: 'outlets',
          component: OutletFieldArray,
          outlets: this.props.data.inviteForm.outlets,
          dispatch: this.props.dispatch
        }),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { onClick: this._onCancel, className: 'btn btn-default' },
              'Cancel'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-success', onClick: this._onClickCheckAll },
              'Check All'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickUncheckAll },
              'Uncheck All'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { onClick: this._onConfirm, className: 'btn btn-primary' },
              'Assign to Employee'
            )
          )
        )
      );
    }

    // _onHide = () => {
    //   this.props.dispatch(hideAssignOutletModal())
    // };

  }]);
  return AssignOutletModal;
}(React.Component);

AssignOutletModal.propTypes = {
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  return {
    data: {
      inviteForm: {
        outlets: selector(state, 'outlets')
      },
      employee: {
        list: state.employee.list
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AssignOutletModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _AssignOutletModal = __webpack_require__(1339);

var _AssignOutletModal2 = _interopRequireDefault(_AssignOutletModal);

var _reactRedux = __webpack_require__(6);

var _list = __webpack_require__(200);

var _InviteForm = __webpack_require__(2090);

var _InviteForm2 = _interopRequireDefault(_InviteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};

  var message = 'This field is required';
  if (!values.firstName) {
    errors.firstName = message;
  }

  if (!values.lastName) {
    errors.lastName = message;
  }

  if (!values.email) {
    errors.email = 'This field is required';
  } else {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'The value is not a valid email address';
    }
  }

  return errors;
};

var Wrapper = function (_React$Component) {
  (0, _inherits3.default)(Wrapper, _React$Component);

  function Wrapper() {
    (0, _classCallCheck3.default)(this, Wrapper);
    return (0, _possibleConstructorReturn3.default)(this, (Wrapper.__proto__ || (0, _getPrototypeOf2.default)(Wrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Wrapper, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-lg-6 col-md-6 col-sm-6' },
        React.createElement(
          'div',
          { className: _InviteForm2.default['form-group'] },
          this.props.children
        )
      );
    }
  }]);
  return Wrapper;
}(React.Component);

var WrapperBlock = function (_React$Component2) {
  (0, _inherits3.default)(WrapperBlock, _React$Component2);

  function WrapperBlock() {
    (0, _classCallCheck3.default)(this, WrapperBlock);
    return (0, _possibleConstructorReturn3.default)(this, (WrapperBlock.__proto__ || (0, _getPrototypeOf2.default)(WrapperBlock)).apply(this, arguments));
  }

  (0, _createClass3.default)(WrapperBlock, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-sm-12' },
        React.createElement(
          'div',
          { className: _InviteForm2.default['form-group'] },
          this.props.children
        )
      );
    }
  }]);
  return WrapperBlock;
}(React.Component);

var InviteForm = function (_React$Component3) {
  (0, _inherits3.default)(InviteForm, _React$Component3);

  function InviteForm() {
    var _ref;

    var _temp, _this3, _ret;

    (0, _classCallCheck3.default)(this, InviteForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = InviteForm.__proto__ || (0, _getPrototypeOf2.default)(InviteForm)).call.apply(_ref, [this].concat(args))), _this3), _this3._onClickAssignOutlet = function () {
      var checkedOutlets = _this3.props.data.employee.list.checkedOutlets;

      _this3.props.dispatch((0, _list.assignOutlets)(checkedOutlets, _this3.props.data.inviteForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(InviteForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          handleSubmit = _props.handleSubmit,
          _props$data$employee$ = _props.data.employee.list,
          checkedOutlets = _props$data$employee$.checkedOutlets,
          profile = _props$data$employee$.profile;


      var selectedOutlets = 0;
      // outlets undefined means the redux form is still loading
      checkedOutlets.forEach(function (co) {
        if (co.checked) selectedOutlets++;
      });

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            Wrapper,
            null,
            React.createElement(_reduxForm.Field, {
              component: _SettingField2.default,
              name: 'firstName',
              placeholder: 'First Name'
            })
          ),
          React.createElement(
            Wrapper,
            null,
            React.createElement(_reduxForm.Field, {
              component: _SettingField2.default,
              name: 'lastName',
              placeholder: 'Last Name'
            })
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            Wrapper,
            null,
            React.createElement(_reduxForm.Field, {
              component: _SettingField2.default,
              name: 'email',
              placeholder: 'Email'
            })
          ),
          React.createElement(
            Wrapper,
            null,
            React.createElement(_reduxForm.Field, {
              component: _SettingField2.default,
              name: 'title',
              placeholder: 'Title'
            })
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            Wrapper,
            null,
            React.createElement(
              'button',
              { className: 'btn btn-primary btn-block', type: 'button', onClick: this._onClickAssignOutlet },
              !selectedOutlets && 'Assign Outlet',
              selectedOutlets > 0 && selectedOutlets + ' outlets'
            )
          ),
          React.createElement(
            Wrapper,
            null,
            profile && profile.is_owner && React.createElement(
              _reduxForm.Field,
              {
                component: 'select',
                name: 'permission',
                className: 'form-control' },
              React.createElement(
                'option',
                { selected: 'true', value: '-1' },
                'Please Select Permissions'
              ),
              React.createElement(
                'option',
                { value: '0' },
                'App Only'
              ),
              React.createElement(
                'option',
                { value: '1' },
                'App and Backoffice'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            WrapperBlock,
            null,
            React.createElement(_reduxForm.Field, {
              component: 'input',
              name: 'password',
              readOnly: 'true',
              className: 'form-control' })
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            WrapperBlock,
            null,
            React.createElement(
              'button',
              { className: 'btn btn-primary btn-block' },
              'Send Invitation'
            )
          )
        ),
        React.createElement(_AssignOutletModal2.default, { dispatch: dispatch })
      );
    }
  }]);
  return InviteForm;
}(React.Component);

InviteForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

var mapForm = {
  form: 'invite',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

var selector = (0, _reduxForm.formValueSelector)('invite');

function mapStateToProps(state) {
  return {
    data: {
      inviteForm: {
        outlets: selector(state, 'outlets')
      },
      employee: {
        list: state.employee.list
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(InviteForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InviteForm = __webpack_require__(1340);

var _InviteForm2 = _interopRequireDefault(_InviteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InviteForm2.default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _Header = __webpack_require__(672);

var _Header2 = _interopRequireDefault(_Header);

var _InviteForm = __webpack_require__(1341);

var _InviteForm2 = _interopRequireDefault(_InviteForm);

var _StaffList = __webpack_require__(1344);

var _StaffList2 = _interopRequireDefault(_StaffList);

var _ConfirmDeleteModal = __webpack_require__(1338);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

var _list = __webpack_require__(200);

var _notifications = __webpack_require__(23);

var _reactRouter = __webpack_require__(15);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var profile = _this.props.data.employee.list.profile;


      var outletIds = [];
      values.outlets.forEach(function (outlet) {
        if (outlet.checked) {
          outletIds.push(outlet.id);
        }
      });
      // 0 is app only
      var permission = profile.is_owner ? values.permission : 0;

      var data = {
        email: values.email.toLowerCase(),
        first_name: values.firstName,
        last_name: values.lastName,
        outlet_ids: outletIds,
        password: values.password,
        password_confirmation: values.password,
        title: values.title,
        access_type: 1, // don't know why this values is 1 either
        user_type: permission
      };
      if (outletIds.length === 0) {
        var checkedOutlets = _this.props.data.employee.list.checkedOutlets;

        _this.props.dispatch((0, _notifications.error)('You must select at least 1 outlet'));
        _this.props.dispatch((0, _list.assignOutlets)(checkedOutlets, _this.props.data.inviteForm));
      } else if (data.user_type < 0 || data.user_type === undefined) {
        _this.props.dispatch((0, _notifications.error)('You must select a permission for the employee'));
      } else {
        _this.props.dispatch((0, _list.submitForm)(data, {}));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      var expireTime = 365; // expire time 1 year
      if (!expired) {
        this.props.dispatch((0, _list.pageRequest)());
        if (Cookies.get('labelNew') === 'true') {
          Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
        }
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$employee$ = this.props.data.employee.list,
          showDeleteEmployeeModal = _props$data$employee$.showDeleteEmployeeModal,
          deletedEmployee = _props$data$employee$.deletedEmployee,
          employees = _props$data$employee$.employees;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-8 col-sm-12 col-lg-6' },
            React.createElement(_Header2.default, { title: 'Invite Staff' }),
            React.createElement(_InviteForm2.default, { onSubmit: this._onSubmit, dispatch: this.props.dispatch })
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-xs-12' },
            React.createElement(_Header2.default, { title: 'Staff List' }),
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: employees.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_StaffList2.default, null)
          )
        ),
        React.createElement(_ConfirmDeleteModal2.default, {
          showDeleteEmployeeModal: showDeleteEmployeeModal,
          deletedEmployee: deletedEmployee,
          dispatch: this.props.dispatch
        })
      );
    }
  }]);
  return List;
}(React.Component);

List.propTypes = {};

function mapStateToProps(state) {
  return {
    data: {
      inviteForm: (0, _reduxForm.getFormValues)('invite')(state),
      employee: {
        list: state.employee.list
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _StaffList = __webpack_require__(2091);

var _StaffList2 = _interopRequireDefault(_StaffList);

var _reactRedux = __webpack_require__(6);

var _reactBootstrap = __webpack_require__(10);

var _list = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaffList = function (_React$Component) {
  (0, _inherits3.default)(StaffList, _React$Component);

  function StaffList() {
    (0, _classCallCheck3.default)(this, StaffList);
    return (0, _possibleConstructorReturn3.default)(this, (StaffList.__proto__ || (0, _getPrototypeOf2.default)(StaffList)).apply(this, arguments));
  }

  (0, _createClass3.default)(StaffList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$data$employee$ = this.props.data.employee.list,
          employees = _props$data$employee$.employees,
          profile = _props$data$employee$.profile;

      return employees.length > 0 && React.createElement(
        'div',
        { className: _StaffList2.default.wrapper + ' table-responsive' },
        React.createElement(
          'table',
          { className: 'table table-collapse ' + _StaffList2.default.table },
          React.createElement(
            'thead',
            { className: _StaffList2.default.thead },
            React.createElement(
              'tr',
              { className: _StaffList2.default.tr },
              React.createElement(
                'th',
                { className: _StaffList2.default.name },
                'Name'
              ),
              React.createElement(
                'th',
                { className: _StaffList2.default.email },
                'Email'
              ),
              React.createElement(
                'th',
                { className: _StaffList2.default.title },
                'Title'
              ),
              profile && profile.is_owner && React.createElement(
                'th',
                { className: _StaffList2.default.permissions },
                'Permissions'
              ),
              React.createElement(
                'th',
                { className: _StaffList2.default.access },
                'Access'
              ),
              React.createElement(
                'th',
                { className: _StaffList2.default.resend },
                '\xA0'
              ),
              React.createElement(
                'th',
                { className: _StaffList2.default.delete },
                '\xA0'
              )
            )
          ),
          React.createElement(
            'tbody',
            { className: _StaffList2.default.tbody },
            profile.is_manager && employees.map(function (user) {
              var popover = React.createElement(
                _reactBootstrap.Popover,
                { title: 'Assigned Outlet' },
                React.createElement(
                  'ul',
                  null,
                  user.outlets.map(function (outlet) {
                    return React.createElement(
                      'li',
                      { className: 'word-break-all ' + _StaffList2.default['popover-outlet-name'] },
                      '\u2022 ',
                      outlet.name
                    );
                  })
                )
              );

              return React.createElement(
                'tr',
                { className: _StaffList2.default.tr },
                React.createElement(
                  'td',
                  { className: _StaffList2.default.name },
                  user.first_name,
                  ' ',
                  user.last_name
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.email },
                  user.email
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.title },
                  user.title
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.access },
                  user.outlets.length > 1 && React.createElement(
                    _reactBootstrap.OverlayTrigger,
                    { placement: 'top', overlay: popover },
                    React.createElement(
                      'button',
                      { className: 'btn btn-info' },
                      user.outlets.length,
                      ' Outlets'
                    )
                  ),
                  user.outlets.length === 1 && user.outlets[0].name
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.resend },
                  !user.is_confirmed && React.createElement(
                    'button',
                    { onClick: function onClick() {
                        return _this2._resendInvitation(user.email);
                      }, className: 'btn btn-primary' },
                    'Resend Invitation'
                  )
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.delete },
                  React.createElement(
                    'button',
                    { onClick: function onClick() {
                        return _this2._askConfirmDelete(user);
                      }, className: 'btn btn-danger' },
                    React.createElement('i', { className: 'glyphicon glyphicon-trash' })
                  )
                )
              );
            }),
            profile.is_owner && employees.map(function (emp) {
              var user = emp.user;

              var employeeOutlet = user.employee_outlets.sort(function (a, b) {
                return a.outlet.name < b.outlet.name ? -1 : a.outlet.name > b.outlet.name ? 1 : 0;
              });
              var popover = React.createElement(
                _reactBootstrap.Popover,
                { title: 'Assigned Outlet' },
                React.createElement(
                  'ul',
                  null,
                  employeeOutlet.map(function (eo) {
                    return React.createElement(
                      'li',
                      { className: 'word-break-all ' + _StaffList2.default['popover-outlet-name'] },
                      '\u2022 ',
                      eo.outlet.name
                    );
                  })
                )
              );

              return React.createElement(
                'tr',
                { className: _StaffList2.default.tr },
                React.createElement(
                  'td',
                  { className: _StaffList2.default.name },
                  user.first_name,
                  ' ',
                  user.last_name
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.email },
                  user.email
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.title },
                  emp.employee_title
                ),
                profile && profile.is_owner && React.createElement(
                  'td',
                  { className: _StaffList2.default.permissions },
                  _this2._userTypeLabel(emp)
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.access },
                  user.employee_outlets.length > 1 && React.createElement(
                    _reactBootstrap.OverlayTrigger,
                    { placement: 'top', overlay: popover },
                    React.createElement(
                      'button',
                      { className: 'btn btn-info' },
                      user.employee_outlets.length,
                      ' Outlets'
                    )
                  ),
                  user.employee_outlets.length === 1 && user.employee_outlets[0].outlet.name
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.resend },
                  !emp.is_confirmed && React.createElement(
                    'button',
                    { onClick: function onClick() {
                        return _this2._resendInvitation(user.email);
                      }, className: 'btn btn-primary' },
                    'Resend Invitation'
                  )
                ),
                React.createElement(
                  'td',
                  { className: _StaffList2.default.delete },
                  React.createElement(
                    'button',
                    { onClick: function onClick() {
                        return _this2._askConfirmDelete(emp);
                      }, className: 'btn btn-danger' },
                    React.createElement('i', { className: 'glyphicon glyphicon-trash' })
                  )
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: '_resendInvitation',
    value: function _resendInvitation(email) {
      this.props.dispatch((0, _list.resendInvitation)(email));
    }
  }, {
    key: '_askConfirmDelete',
    value: function _askConfirmDelete(deletedEmployee) {
      this.props.dispatch((0, _list.askDeleteEmployee)(deletedEmployee));
    }

    /**
     * @see https://github.com/mokapos/moka-rails/blob/master/app/assets/javascripts/moka/controllers/employees_controller.js#L310
     * @param emp
     * @return {*}
     * @private
     */

  }, {
    key: '_userTypeLabel',
    value: function _userTypeLabel(emp) {
      if (!emp) {
        return null;
      }
      var userType = 0;
      emp.user.employee_outlets.forEach(function (eo) {
        userType = eo.user_type;
      });
      return ['App only', 'App and Backoffice'][userType];
    }
  }]);
  return StaffList;
}(React.Component);

StaffList.propTypes = {};

function mapStateToProps(state) {
  return {
    data: {
      employee: {
        list: state.employee.list
      }
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StaffList);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaffList = __webpack_require__(1343);

var _StaffList2 = _interopRequireDefault(_StaffList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _StaffList2.default;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(1342);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _List2.default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _Header = __webpack_require__(672);

var _Header2 = _interopRequireDefault(_Header);

var _PermissionForm = __webpack_require__(1348);

var _PermissionForm2 = _interopRequireDefault(_PermissionForm);

var _permission = __webpack_require__(610);

var actPermission = _interopRequireWildcard(_permission);

var _Permission = __webpack_require__(2092);

var _Permission2 = _interopRequireDefault(_Permission);

var _reduxForm = __webpack_require__(7);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _confirmAction = __webpack_require__(29);

var _reactRouter = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Permission = function (_React$Component) {
  (0, _inherits3.default)(Permission, _React$Component);

  function Permission() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Permission);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Permission.__proto__ || (0, _getPrototypeOf2.default)(Permission)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var data = (0, _extends3.default)({}, _this.props.data.employee.permission.setting);
      data.auth_code = values.authCode;
      data.allow_staff_refund = values.allowStaffRefund;
      data.staff_delete_bill = values.staffDeleteBill;
      data.staff_resend_receipt = values.staffResendReceipt;
      _this.props.dispatch(actPermission.submitForm({ settings: data }, {}));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Permission, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch(actPermission.pageRequest());

        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.data.isDirtyForm && _this2.props.data.confirmAction.nextAction === null) {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)(actPermission.changePage(location.pathname)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Permission2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-sm-6 no-padding' },
          React.createElement(_Header2.default, { title: 'Permission' }),
          React.createElement(_PermissionForm2.default, { onSubmit: this._onSubmit })
        ),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Permission;
}(React.Component);

Permission.propTypes = {
  dispatch: React.PropTypes.func,
  history: React.PropTypes.object
};

function mapStateToProps(state) {
  return {
    data: {
      confirmAction: state.confirmAction,
      isDirtyForm: (0, _reduxForm.isDirty)('permission')(state),
      employee: {
        permission: state.employee.permission
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Permission);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _PermissionForm = __webpack_require__(2093);

var _PermissionForm2 = _interopRequireDefault(_PermissionForm);

var _DescriptiveSwitchField = __webpack_require__(636);

var _DescriptiveSwitchField2 = _interopRequireDefault(_DescriptiveSwitchField);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};

  if (!values.authCode) {
    // error if allowStaffRefund , staffDeleteBill, staffResendReceipt is not empty
    if (values.allowStaffRefund || values.staffDeleteBill || values.staffResendReceipt) {
      errors.authCode = 'This field is required';
    }
  } else if (values.authCode.length < 4) {
    errors.authCode = 'Please enter at least 4 characters';
  } else if (!/^[0-9]+$/.test(values.authCode)) {
    errors.authCode = 'Please enter a valid number';
  }

  return errors;
};

var renderInput = function renderInput(field) {
  return React.createElement(
    'div',
    null,
    React.createElement('input', (0, _extends3.default)({}, field.input, {
      placeholder: field.placeholder,
      className: field.className,
      maxLength: field.maxLength,
      type: field.type })),
    field.meta.touched && field.meta.error && React.createElement(
      'label',
      { className: 'error' },
      field.meta.error
    )
  );
};

var PermissionForm = function (_React$Component) {
  (0, _inherits3.default)(PermissionForm, _React$Component);

  function PermissionForm(props) {
    (0, _classCallCheck3.default)(this, PermissionForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionForm.__proto__ || (0, _getPrototypeOf2.default)(PermissionForm)).call(this, props));

    _this.showPasswordButton = function () {
      _this.setState({ showPassword: !_this.state.showPassword });
    };

    _this.state = {
      showPassword: false
    };
    return _this;
  }

  (0, _createClass3.default)(PermissionForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(_DescriptiveSwitchField2.default, {
          label: 'Ask staff to enter authorization code to issue refund',
          sublabel: '',
          name: 'allowStaffRefund'
        }),
        React.createElement(_DescriptiveSwitchField2.default, {
          label: 'Ask staff to enter authorization code to delete or modify bill',
          sublabel: '',
          name: 'staffDeleteBill'
        }),
        React.createElement(_DescriptiveSwitchField2.default, {
          label: 'Ask staff to enter authorization code to resend / reprint receipt',
          sublabel: '',
          name: 'staffResendReceipt'
        }),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12 ' + _PermissionForm2.default['authorization-code-wrapper'] },
            React.createElement(
              'p',
              null,
              'Authorization Code'
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 no-padding' },
              React.createElement(_reduxForm.Field, {
                name: 'authCode',
                component: renderInput,
                className: 'form-control',
                placeholder: '4-digit PIN',
                maxLength: '4',
                type: this.state.showPassword ? 'text' : 'password'
              }),
              React.createElement('i', { type: 'button', onClick: this.showPasswordButton, className: _PermissionForm2.default['eye-button'] + ' ' + (this.state.showPassword ? 'glyphicon glyphicon-eye-close' : 'glyphicon glyphicon-eye-open') })
            )
          )
        ),
        React.createElement(
          'p',
          { className: _PermissionForm2.default.description },
          'Employees will be able to take payments but will not be able to edit on the iPad. Employees will also not have access to the web back office.'
        ),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'button',
              { className: 'btn btn-primary pull-right' },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return PermissionForm;
}(React.Component);

var mapForm = {
  form: 'permission',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

PermissionForm.propTypes = {
  onSubmit: React.PropTypes.func
};

function mapStateToProps(state) {
  return {
    isDirtyForm: (0, _reduxForm.isDirty)('permission')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(PermissionForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PermissionForm = __webpack_require__(1347);

var _PermissionForm2 = _interopRequireDefault(_PermissionForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PermissionForm2.default;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Permission = __webpack_require__(1346);

var _Permission2 = _interopRequireDefault(_Permission);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Permission2.default;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.Permission = undefined;

var _Employee = __webpack_require__(1335);

var _Employee2 = _interopRequireDefault(_Employee);

var _Permission = __webpack_require__(1349);

var _Permission2 = _interopRequireDefault(_Permission);

var _List = __webpack_require__(1345);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Permission = _Permission2.default;
exports.List = _List2.default;
exports.default = _Employee2.default;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _FeedbackForm = __webpack_require__(766);

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerFeedbackForm = function (_React$Component) {
  (0, _inherits3.default)(CustomerFeedbackForm, _React$Component);

  function CustomerFeedbackForm() {
    (0, _classCallCheck3.default)(this, CustomerFeedbackForm);
    return (0, _possibleConstructorReturn3.default)(this, (CustomerFeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(CustomerFeedbackForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomerFeedbackForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit, className: _FeedbackForm2.default['form-cust-feedback'] },
        React.createElement(
          'div',
          { className: _FeedbackForm2.default['feedback-options'] },
          React.createElement(
            'div',
            { className: _FeedbackForm2.default['radio-option'] },
            React.createElement(_reduxForm.Field, {
              name: 'feedbackType',
              component: 'input',
              type: 'radio',
              value: 'wait_time' }),
            React.createElement(
              'span',
              { className: _FeedbackForm2.default['label-radio'] },
              'Wait Time'
            )
          ),
          React.createElement(
            'div',
            { className: _FeedbackForm2.default['radio-option'] },
            React.createElement(_reduxForm.Field, {
              name: 'feedbackType',
              component: 'input',
              type: 'radio',
              value: 'quality' }),
            React.createElement(
              'span',
              { className: _FeedbackForm2.default['label-radio'] },
              'Quality'
            )
          ),
          React.createElement(
            'div',
            { className: _FeedbackForm2.default['radio-option'] },
            React.createElement(_reduxForm.Field, {
              name: 'feedbackType',
              component: 'input',
              type: 'radio',
              value: 'customer_service' }),
            React.createElement(
              'span',
              { className: _FeedbackForm2.default['label-radio'] },
              'Customer Service'
            )
          ),
          React.createElement(
            'div',
            { className: _FeedbackForm2.default['radio-option'] },
            React.createElement(_reduxForm.Field, {
              name: 'feedbackType',
              component: 'input',
              type: 'radio',
              value: 'other' }),
            React.createElement(
              'span',
              { className: _FeedbackForm2.default['label-radio'] },
              'Other'
            )
          )
        ),
        React.createElement(
          'div',
          { className: _FeedbackForm2.default['comment-field'] },
          React.createElement(_reduxForm.Field, {
            name: 'comment',
            component: 'textarea',
            className: 'form-control',
            placeholder: 'Leave a comment'
          })
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-primary ' + _FeedbackForm2.default['submit-btn'] },
            'SUBMIT'
          )
        )
      );
    }
  }]);
  return CustomerFeedbackForm;
}(React.Component);

var mapForm = {
  form: 'customerFeedbackForm'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)(CustomerFeedbackForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _FeedbackForm = __webpack_require__(766);

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

var _CustomerFeedbackForm = __webpack_require__(1351);

var _CustomerFeedbackForm2 = _interopRequireDefault(_CustomerFeedbackForm);

var _feedbackForm = __webpack_require__(611);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackForm = function (_React$Component) {
  (0, _inherits3.default)(FeedbackForm, _React$Component);

  function FeedbackForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var feedbackType = values.feedbackType,
          comment = values.comment;
      var _this$props$params = _this.props.params,
          token = _this$props$params.token,
          quality = _this$props$params.quality;
      var query = _this.props.location.query;

      _this.props.dispatch((0, _feedbackForm.submitFeedback)({
        feedback_type: feedbackType,
        comment: comment,
        feedback_token: token,
        mode: quality,
        customer_id: query.cid ? query.cid : '',
        feedback_from: query.feedback_form ? query.feedback_form : null
      }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeedbackForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$params = this.props.params,
          token = _props$params.token,
          quality = _props$params.quality;

      this.props.dispatch((0, _feedbackForm.feedbackFormPageRequest)({ feedback_token: token, quality: quality }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          invalidFeedback = _props.invalidFeedback,
          submitSuccess = _props.submitSuccess,
          dataFeedbackToken = _props.dataFeedbackToken,
          showFeedbackForm = _props.showFeedbackForm;
      var quality = this.props.params.quality;

      return dataFeedbackToken && React.createElement(
        'div',
        { className: _FeedbackForm2.default['feedback-wrapper'] },
        invalidFeedback && React.createElement(
          'div',
          { className: _FeedbackForm2.default.title },
          dataFeedbackToken.business_and_outlet_info
        ),
        invalidFeedback ? dataFeedbackToken.feedback_mode === 'sad' ? React.createElement(
          'div',
          { className: _FeedbackForm2.default['image-mode'] },
          React.createElement('img', { src: 'https://dev.mokapos.com/assets/sad-icon.png', className: _FeedbackForm2.default.emoji })
        ) : React.createElement(
          'div',
          { className: _FeedbackForm2.default['image-mode'] },
          React.createElement('img', { src: 'https://dev.mokapos.com/assets/smile-icon.png', className: _FeedbackForm2.default.emoji })
        ) : quality === 'sad' ? React.createElement(
          'div',
          { className: _FeedbackForm2.default['image-mode'] },
          React.createElement('img', { src: 'https://dev.mokapos.com/assets/sad-icon.png', className: _FeedbackForm2.default.emoji })
        ) : React.createElement(
          'div',
          { className: _FeedbackForm2.default['image-mode'] },
          React.createElement('img', { src: 'https://dev.mokapos.com/assets/smile-icon.png', className: _FeedbackForm2.default.emoji })
        ),
        invalidFeedback && React.createElement(
          'div',
          null,
          React.createElement(
            'p',
            { className: _FeedbackForm2.default['invalid-message'] },
            'You\'ve already left feedback for this transaction.'
          )
        ),
        showFeedbackForm && React.createElement(
          'div',
          { className: _FeedbackForm2.default['wrapper-form'] },
          quality === 'happy' ? React.createElement(
            'div',
            { className: _FeedbackForm2.default.subtitle },
            React.createElement(
              'h2',
              null,
              'That\'s Great'
            ),
            React.createElement(
              'p',
              null,
              'Tell us what we got right'
            )
          ) : React.createElement(
            'div',
            { className: _FeedbackForm2.default.subtitle },
            React.createElement(
              'h2',
              null,
              'We\'re really sorry'
            ),
            React.createElement(
              'p',
              null,
              'Tell us what\'s wrong'
            )
          ),
          React.createElement(
            'div',
            { className: _FeedbackForm2.default['feed-form'] },
            React.createElement(_CustomerFeedbackForm2.default, { onSubmit: this.handleSubmit })
          )
        ),
        submitSuccess && React.createElement(
          'div',
          { className: _FeedbackForm2.default['success-message'] },
          React.createElement(
            'h2',
            null,
            'Thank you!'
          )
        )
      );
    }
  }]);
  return FeedbackForm;
}(React.Component);

function mapStateToProps(state) {
  var _state$feedbackForm = state.feedbackForm,
      invalidFeedback = _state$feedbackForm.invalidFeedback,
      submitSuccess = _state$feedbackForm.submitSuccess,
      dataFeedbackToken = _state$feedbackForm.dataFeedbackToken,
      showFeedbackForm = _state$feedbackForm.showFeedbackForm;

  return {
    invalidFeedback: invalidFeedback,
    submitSuccess: submitSuccess,
    dataFeedbackToken: dataFeedbackToken,
    showFeedbackForm: showFeedbackForm
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeedbackForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _feedbackReplyForm = __webpack_require__(612);

__webpack_require__(2094);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _messageForm = __webpack_require__(1354);

var _messageForm2 = _interopRequireDefault(_messageForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackReplyForm = function (_React$Component) {
  (0, _inherits3.default)(FeedbackReplyForm, _React$Component);

  function FeedbackReplyForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackReplyForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackReplyForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackReplyForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var comment = values.comment;

      var token = _this.props.params.token;
      _this.props.dispatch((0, _feedbackReplyForm.sendFeedbackReplyForm)(comment, token));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeedbackReplyForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var token = this.props.params.token;
      this.props.dispatch((0, _feedbackReplyForm.requestFeedbackReply)(token));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          data = _props$data.data,
          isInvalidToken = _props$data.isInvalidToken;

      var feedbackList = data;
      return React.createElement(
        'section',
        { className: 'base-content-reply-feedback' },
        React.createElement(
          'div',
          { className: 'container' },
          React.createElement(
            'div',
            { className: 'col-md-12 col-xs-12' },
            isInvalidToken ? 'invalid' : React.createElement(
              'div',
              { className: 'maincontent-feedback-reply-detail col-md-7 col-xs-12' },
              React.createElement(
                'div',
                { className: 'title-content' },
                React.createElement('img', { className: 'img-circle', width: '140px', height: '140px', src: feedbackList && feedbackList.business_logo_url }),
                React.createElement(
                  'div',
                  { className: 'store-name' },
                  feedbackList && feedbackList.business_name
                )
              ),
              React.createElement('hr', null),
              React.createElement(
                'div',
                { className: 'reply-content' },
                feedbackList ? feedbackList.messages.map(function (message) {
                  return React.createElement(
                    'div',
                    null,
                    message.is_customer ? React.createElement(
                      'div',
                      { className: 'user' },
                      React.createElement(
                        'div',
                        { className: 'customer-message' },
                        React.createElement(
                          'div',
                          { className: 'left-content have-avatar pull-left' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('img', { alt: 'Account profile default', className: 'avatar', src: 'https://dev.mokapos.com/assets/account-profile-default.jpg' })
                          ),
                          React.createElement(
                            'span',
                            null,
                            data.customer_name !== '-' ? data.customer_name : data.customer_email
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'right-content have-box pull-right' },
                          React.createElement(
                            'div',
                            { className: 'title' },
                            '(',
                            message.feedback_type,
                            ') - ',
                            (0, _moment2.default)(message.created_at).format('DD MMM YYYY HH:mm'),
                            React.createElement(
                              'span',
                              { className: 'icon-thumb' },
                              React.createElement('img', { alt: 'Smile icon thumb', src: message.mode === 'happy' ? 'https://dev.mokapos.com/assets/smile-icon-thumb.png' : 'https://dev.mokapos.com/assets/sad-icon-thumb.png' })
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'content' },
                            message.comment
                          )
                        )
                      )
                    ) : React.createElement(
                      'div',
                      { className: 'business' },
                      React.createElement(
                        'div',
                        { className: 'admin-message' },
                        React.createElement(
                          'div',
                          { className: 'left-content have-box pull-left' },
                          React.createElement(
                            'div',
                            { className: 'title ng-binding' },
                            (0, _moment2.default)(message.created_at).format('DD MMM YYYY HH:mm')
                          ),
                          React.createElement(
                            'div',
                            { className: 'admin-message-wrapper ng-binding' },
                            message.comment
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'right-content have-avatar pull-right' },
                          React.createElement(
                            'div',
                            { className: 'image-thumb-box ng-scope' },
                            React.createElement('img', { className: 'avatar-business', src: message.profile_pict_url || 'https://mokapos-production.s3.amazonaws.com/uploads/business/logo/2451/1450670597-clash-of-clans-gold-bedcd386.png' })
                          )
                        )
                      )
                    )
                  );
                }) : ''
              ),
              React.createElement(
                'div',
                { className: 'customer-reply-form' },
                React.createElement(_messageForm2.default, {
                  onSubmit: this.handleSubmit,
                  data: data
                })
              )
            )
          )
        )
      );
    }
  }]);
  return FeedbackReplyForm;
}(React.Component);

(0, _reduxForm.formValueSelector)('feedbackReplyForm'); // <-- same as form name

function mapStateToProps(state) {
  return {
    data: state.feedback.replyForm,
    form: state.form.feedbackReplyForm,
    moka: state.moka
  };
}

var mapFormValidation = {
  form: 'feedbackReplyForm'
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)((0, _reactRedux.connect)(mapStateToProps)(FeedbackReplyForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderField = function renderField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      placeholder = _ref.placeholder,
      _ref$meta = _ref.meta,
      submitFailed = _ref$meta.submitFailed,
      error = _ref$meta.error;
  return React.createElement(
    'div',
    null,
    React.createElement('textarea', (0, _extends3.default)({}, input, { placeholder: placeholder, type: 'text', rows: '4', cols: '50', maxLength: '250' })),
    submitFailed && error && React.createElement(
      'span',
      { className: 'error' },
      error
    )
  );
};

var validate = function validate(values) {
  var errors = {};
  if (values.comment) {
    if (values.comment.trim() === '') {
      errors.comment = 'This field is required';
    }
  } else {
    errors.comment = 'This field is required';
  }
  return errors;
};

var messageForm = function messageForm(props) {
  var error = props.error,
      handleSubmit = props.handleSubmit,
      data = props.data;


  return React.createElement(
    'form',
    { onSubmit: handleSubmit, className: 'messageForm', name: 'messageForm' },
    React.createElement(
      'div',
      { className: 'form-content' },
      React.createElement(
        'div',
        { className: 'left-content' },
        React.createElement(
          'div',
          null,
          React.createElement('img', { alt: 'Account profile default', className: 'avatar', src: 'https://www.mokapos.com/assets/account-profile-default-16e73004f9284381ca77f13a3457f43d.jpg' })
        ),
        React.createElement(
          'span',
          { className: 'striped text-center' },
          data && data.customer_name
        )
      ),
      React.createElement(
        'div',
        { className: 'right-content' },
        React.createElement(_reduxForm.Field, {
          component: renderField,
          name: 'comment',
          autoCorrect: 'off',
          autoCapitalize: 'off',
          placeholder: 'Write a reply...'
        }),
        error && React.createElement(
          'strong',
          null,
          error
        )
      )
    ),
    React.createElement(
      'div',
      { className: 'reply-btn-wrapper pull-right' },
      React.createElement(
        'button',
        { className: 'btn btn-primary', id: 'submit-feedback', type: 'submit' },
        'Submit'
      )
    )
  );
};
messageForm = (0, _reduxForm.reduxForm)({
  form: 'messageForm',
  validate: validate
})(messageForm);

exports.default = (0, _reactRedux.connect)()(messageForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactGcaptcha = __webpack_require__(375);

var _reactGcaptcha2 = _interopRequireDefault(_reactGcaptcha);

var _Recaptcha = __webpack_require__(2095);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Captcha = function (_React$Component) {
  (0, _inherits3.default)(Captcha, _React$Component);

  function Captcha(props) {
    (0, _classCallCheck3.default)(this, Captcha);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Captcha.__proto__ || (0, _getPrototypeOf2.default)(Captcha)).call(this, props));

    var input = _this.props.input;
    var onChange = input.onChange;

    _this.state = {
      onChange: onChange
    };
    return _this;
  }

  (0, _createClass3.default)(Captcha, [{
    key: 'callback',
    value: function callback(key) {
      this.state.onChange(key);
    }
  }, {
    key: 'loaded',
    value: function loaded() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        { className: _Recaptcha2.default['recaptcha'] },
        React.createElement(_reactGcaptcha2.default, (0, _extends3.default)({}, input, {
          sitekey: '6LesGA4UAAAAAMQ4EgXcvuxeJOXdIo217ldryOms',
          onloadCallback: this.loaded,
          verifyCallback: this.callback.bind(this)
        })),
        React.createElement(
          'small',
          { className: 'error' },
          touched ? error : ''
        )
      );
    }
  }]);
  return Captcha;
}(React.Component);

exports.default = Captcha;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(2096);

var _style2 = _interopRequireDefault(_style);

var _ForgotPasswordForm = __webpack_require__(1357);

var _ForgotPasswordForm2 = _interopRequireDefault(_ForgotPasswordForm);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPassword = function (_React$Component) {
  (0, _inherits3.default)(ForgotPassword, _React$Component);

  function ForgotPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ForgotPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var email = values.email;

      _this.props.dispatch((0, _actions.forgotPassword)({ email: email }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'render',
    value: function render() {
      var dispatch = this.props.dispatch;
      var _props$data$moka = this.props.data.moka,
          currentlySending = _props$data$moka.currentlySending,
          error = _props$data$moka.error;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'container' },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-6 col-sm-offset-3' },
              React.createElement(
                'div',
                { className: _style2.default.root },
                React.createElement(
                  'h1',
                  { className: _style2.default.title },
                  'Forgot Password?'
                ),
                React.createElement('hr', null),
                React.createElement(_ForgotPasswordForm2.default, {
                  dispatch: dispatch,
                  history: this.props.history,
                  onSubmit: this.handleSubmit,
                  error: error,
                  currentlySending: currentlySending
                }),
                React.createElement(
                  'div',
                  { className: 'visible-lg visible-md' },
                  React.createElement(
                    'p',
                    { id: 'sign-in', className: _style2.default['no-account'] },
                    'Don\'t have a Moka account?',
                    React.createElement(
                      _reactRouter.Link,
                      { to: '/register' },
                      ' Sign Up '
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(React.Component);

ForgotPassword.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function select(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(select)(ForgotPassword);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _Captcha = __webpack_require__(1355);

var _Captcha2 = _interopRequireDefault(_Captcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'The value is not a valid email address';
  }
  if (!values.captcha) {
    errors.captcha = 'The captcha is not valid';
  }
  return errors;
};

var inputField = function inputField(field) {
  return React.createElement(
    'div',
    null,
    React.createElement('input', (0, _extends3.default)({}, field.input, {
      type: 'text',
      maxLength: field.maxLength,
      className: 'form-control',
      placeholder: 'Registered email address' })),
    React.createElement(
      'small',
      { className: 'error' },
      field.meta.touched ? field.meta.error : ''
    )
  );
};

var ForgotPasswordForm = function (_React$Component) {
  (0, _inherits3.default)(forgotPasswordForm, _React$Component);

  function forgotPasswordForm() {
    (0, _classCallCheck3.default)(this, forgotPasswordForm);
    return (0, _possibleConstructorReturn3.default)(this, (forgotPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(forgotPasswordForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(forgotPasswordForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;


      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(
          'p',
          { className: 'visible-md visible-lg' },
          'To reset your account password. Enter the email address you registered with and we\'ll send you instructions.'
        ),
        React.createElement(
          'p',
          { className: 'visible-xs visible-sm text-center' },
          'To reset your account password. Enter the email address you registered with and we\'ll send you instructions.'
        ),
        React.createElement('br', null),
        React.createElement(_reduxForm.Field, {
          component: inputField,
          name: 'email',
          maxLength: '40',
          autoCorrect: 'off',
          autoCapitalize: 'off',
          spellCheck: 'false' }),
        React.createElement('br', null),
        React.createElement(_reduxForm.Field, {
          component: _Captcha2.default,
          name: 'captcha'
        }),
        React.createElement(
          'button',
          { type: 'submit', className: 'btn btn-primary pull-right visible-lg visible-md' },
          'Submit'
        ),
        React.createElement(
          'button',
          { type: 'submit', className: 'btn btn-primary btn-block visible-xs visible-sm' },
          'Submit'
        ),
        React.createElement(
          'div',
          { className: 'visible-xs visible-sm' },
          React.createElement('br', null),
          React.createElement(
            'p',
            { id: 'sign-in', className: 'text-center' },
            'Don\'t have a Moka account?',
            React.createElement(
              _reactRouter.Link,
              { to: '/register' },
              ' Sign Up '
            )
          )
        )
      );
    }
  }]);
  return forgotPasswordForm;
}(React.Component);

ForgotPasswordForm.propTypes = {
  data: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool
};

ForgotPasswordForm = (0, _reduxForm.reduxForm)({
  form: 'forgotPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(ForgotPasswordForm);

exports.default = ForgotPasswordForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _reduxForm = __webpack_require__(7);

var _pages = __webpack_require__(38);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _category = __webpack_require__(124);

var _confirmAction = __webpack_require__(29);

var _ActionBar = __webpack_require__(2097);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutletIds = function (outletIds) {
      var isDirtyForm = _this.props.isDirtyForm;

      if (isDirtyForm) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _category.onChangeOutletIds)(outletIds)));
      } else {
        _this.props.dispatch((0, _category.onChangeOutletIds)(outletIds));
      }
    }, _this._onChangeKeyword = function (event, keyword) {
      _this.props.dispatch((0, _category.onChangeKeyword)(keyword));
    }, _this._onClickCreateCategory = function () {
      var isDirtyForm = _this.props.isDirtyForm;

      if (isDirtyForm) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _category.onClickCreateCategory)()));
      } else {
        _this.props.dispatch((0, _category.onClickCreateCategory)());
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-8', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline ' + _ActionBar2.default['action-bar'] },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutletIds
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'keyword',
                component: _SearchBar2.default,
                onChange: this._onChangeKeyword,
                placeholder: 'Search'
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickCreateCategory },
              'Create Ingredient Category'
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.ingredients.category.outlets;

  return {
    outlets: outlets,
    isDirtyForm: (0, _reduxForm.isDirty)('ingCategory')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _category = __webpack_require__(124);

var _Ingredients = __webpack_require__(1360);

var _Ingredients2 = _interopRequireDefault(_Ingredients);

var _style = __webpack_require__(2100);

var _style2 = _interopRequireDefault(_style);

var _Search = __webpack_require__(1361);

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignToIngredientModal = function (_React$Component) {
  (0, _inherits3.default)(AssignToIngredientModal, _React$Component);

  function AssignToIngredientModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AssignToIngredientModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AssignToIngredientModal.__proto__ || (0, _getPrototypeOf2.default)(AssignToIngredientModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      dispatch((0, _category.cancelAssignToIngredient)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AssignToIngredientModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showAssignToIngredientModal = _props.showAssignToIngredientModal,
          isPristineForm = _props.isPristineForm,
          IngForm = _props.IngForm;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAssignToIngredientModal, onHide: this._onHide, className: '' + _style2.default.modalingredient },
        React.createElement(_ModalHeader2.default, { title: 'Assign To Ingredient' }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'ingredientIds' }),
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(_Search2.default, null),
            React.createElement(_Ingredients2.default, null)
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', disabled: isPristineForm && !(IngForm.ingredientIds.length > 0) },
                'Move Selected Ingredients'
              )
            )
          )
        )
      );
    }
  }]);
  return AssignToIngredientModal;
}(React.Component);

function mapStateToProps(state) {
  var showAssignToIngredientModal = state.ingredients.category.showAssignToIngredientModal;

  return {
    showAssignToIngredientModal: showAssignToIngredientModal,
    isPristineForm: (0, _reduxForm.isPristine)('assignToIngredient')(state),
    IngForm: (0, _reduxForm.getFormInitialValues)('assignToIngredient')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'assignToIngredient'
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssignToIngredientModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _style = __webpack_require__(2098);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _category = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ingredients = function (_React$Component) {
  (0, _inherits3.default)(Ingredients, _React$Component);

  function Ingredients() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ingredients);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ingredients.__proto__ || (0, _getPrototypeOf2.default)(Ingredients)).call.apply(_ref, [this].concat(args))), _this), _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage,
          keyword = _this$props2.assignToIngredients.keyword,
          ingredients = _this$props2.ingredients,
          dispatch = _this$props2.dispatch;

      if (currentPage < totalPage) {
        dispatch((0, _category.assignToIngredientGetIngredientsRequest)({ keyword: keyword, page: currentPage + 1, with_batch: true }, ingredients));
      }
    }, _this._onChangeCheckbox = function (event, id) {
      var _this$props3 = _this.props,
          ingredientIds = _this$props3.assignToIngredients.ingredientIds,
          dispatch = _this$props3.dispatch;

      var idxPosition = -1;
      if (ingredientIds) {
        ingredientIds.forEach(function (ingredientId, index) {
          if (parseInt(ingredientId) === id) {
            idxPosition = index;
          }
        });
      }
      if (event.target.checked) {
        dispatch((0, _reduxForm.arrayPush)('assignToIngredient', 'ingredientIds', id));
      } else {
        if (idxPosition !== -1) {
          dispatch((0, _reduxForm.arrayRemove)('assignToIngredient', 'ingredientIds', idxPosition));
        }
      }
    }, _this._checked = function (id) {
      var ingredientIds = _this.props.assignToIngredients.ingredientIds;

      var checked = false;
      if (ingredientIds) {
        ingredientIds.forEach(function (ingredientId) {
          checked = checked || parseInt(id) === ingredientId;
        });
      }
      return checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ingredients, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ingredients = this.props.ingredients;

      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          _reactInfiniteScroller2.default,
          {
            pageStart: 1,
            loadMore: this._onReachBottom,
            hasMore: this._hasMore(),
            useWindow: false,
            threshold: 10,
            initialLoad: false },
          ingredients.map(function (ingredient, idx) {
            return React.createElement(
              'div',
              { className: 'row ' + _style2.default['row-wrapper'] },
              React.createElement(
                'div',
                { className: 'col-sm-2 ' + _style2.default['ingredient-image-wrapper'] },
                React.createElement('img', { src: ingredient.image.url, className: _style2.default.image })
              ),
              React.createElement(
                'div',
                { className: 'col-sm-9 ' + _style2.default['ingredient-name-wrapper'] },
                React.createElement(
                  'p',
                  null,
                  ingredient.name
                )
              ),
              React.createElement(
                'div',
                { className: 'col-sm-1 pull-right ' + _style2.default['padding-checkbox'] },
                React.createElement('input', {
                  type: 'checkbox',
                  checked: _this2._checked(ingredient.id),
                  onChange: function onChange(event) {
                    return _this2._onChangeCheckbox(event, ingredient.id);
                  }
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Ingredients;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('assignToIngredient');

function mapStateToProps(state) {
  var _state$ingredients$ca = state.ingredients.category.assignToIngredients,
      ingredients = _state$ingredients$ca.ingredients,
      currentPage = _state$ingredients$ca.currentPage,
      totalPage = _state$ingredients$ca.totalPage;

  return {
    assignToIngredients: {
      ingredientIds: selector(state, 'ingredientIds'),
      keyword: selector(state, 'keyword')
    },
    ingredients: ingredients,
    currentPage: currentPage,
    totalPage: totalPage
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Ingredients);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(2099);

var _style2 = _interopRequireDefault(_style);

var _category = __webpack_require__(124);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function (_React$Component) {
  (0, _inherits3.default)(Search, _React$Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref, [this].concat(args))), _this), _this._onChange = function (event, value) {
      _this.props.dispatch((0, _category.assignToIngredientGetIngredientsRequest)({ page: 1, keyword: value, with_batch: true }, []));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row ' + _style2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'div',
            { className: 'right-inner-addon' },
            React.createElement('i', { className: 'fa fa-search ' + _style2.default.right }),
            React.createElement(_reduxForm.Field, {
              component: 'input',
              name: 'keyword',
              className: 'form-control',
              placeholder: 'search',
              onChange: this._onChange
            })
          )
        )
      );
    }
  }]);
  return Search;
}(React.Component);

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1365);

var _List2 = _interopRequireDefault(_List);

var _ActionBar = __webpack_require__(1358);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _category = __webpack_require__(124);

var _CategoryDetail = __webpack_require__(1363);

var _CategoryDetail2 = _interopRequireDefault(_CategoryDetail);

var _AssignToIngredientModal = __webpack_require__(1359);

var _AssignToIngredientModal2 = _interopRequireDefault(_AssignToIngredientModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = function (_React$Component) {
  (0, _inherits3.default)(Category, _React$Component);

  function Category() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Category);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var assignToIngredients = _this.props.assignToIngredients;

      _this.props.dispatch((0, _category.submitAssignToIngredient)({ ingredient_ids: values.ingredientIds }, assignToIngredients.category));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Category, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _category.pageRequest)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showRightColumn = _props.showRightColumn,
          showAssignToIngredientModal = _props.showAssignToIngredientModal;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: showRightColumn },
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: showRightColumn },
            React.createElement(_CategoryDetail2.default, null)
          )
        ),
        showAssignToIngredientModal && React.createElement(_AssignToIngredientModal2.default, { onSubmit: this._onSubmit }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Category;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$ca = state.ingredients.category,
      showRightColumn = _state$ingredients$ca.showRightColumn,
      showAssignToIngredientModal = _state$ingredients$ca.showAssignToIngredientModal,
      assignToIngredients = _state$ingredients$ca.assignToIngredients;

  return {
    showRightColumn: showRightColumn,
    showAssignToIngredientModal: showAssignToIngredientModal,
    assignToIngredients: assignToIngredients
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Category);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CategoryForm = __webpack_require__(1364);

var _CategoryForm2 = _interopRequireDefault(_CategoryForm);

var _CategoryDetail = __webpack_require__(2101);

var _CategoryDetail2 = _interopRequireDefault(_CategoryDetail);

var _category = __webpack_require__(124);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryDetail = function (_React$Component) {
  (0, _inherits3.default)(CategoryDetail, _React$Component);

  function CategoryDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryDetail.__proto__ || (0, _getPrototypeOf2.default)(CategoryDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onDelete = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          categoryDetail = _this$props.categoryDetail,
          categories = _this$props.categories;

      dispatch((0, _category.deleteCategory)(categoryDetail, categories));
    }, _this._onHide = function () {
      _this.props.dispatch((0, _category.hideDeleteModal)());
    }, _this._onSubmit = function (values) {
      var createAllOutlet = values.action === 'save_to_all_outlet';
      var _this$props2 = _this.props,
          categories = _this$props2.categories,
          dispatch = _this$props2.dispatch,
          outletIds = _this$props2.search.outletIds;

      delete values.action;
      dispatch((0, _category.submitForm)({ ingredient_category: values }, createAllOutlet, categories, outletIds));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteModal = _props.showDeleteModal,
          categoryDetail = _props.categoryDetail;

      return React.createElement(
        'div',
        { className: _CategoryDetail2.default.wrapper },
        React.createElement(_CategoryForm2.default, { onSubmit: this._onSubmit }),
        !!categoryDetail && React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: showDeleteModal,
          onHide: this._onHide,
          title: 'Category',
          name: categoryDetail.name,
          onDelete: this._onDelete
        })
      );
    }
  }]);
  return CategoryDetail;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  var _state$ingredients$ca = state.ingredients.category,
      categories = _state$ingredients$ca.categories,
      showDeleteModal = _state$ingredients$ca.showDeleteModal,
      categoryDetail = _state$ingredients$ca.categoryDetail;

  return {
    categories: categories,
    categoryDetail: categoryDetail,
    showDeleteModal: showDeleteModal,
    search: {
      outletIds: selector(state, 'outletIds')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoryDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _ActionBarDetailWrapper = __webpack_require__(449);

var _ActionBarDetailWrapper2 = _interopRequireDefault(_ActionBarDetailWrapper);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _CategoryForm = __webpack_require__(2102);

var _CategoryForm2 = _interopRequireDefault(_CategoryForm);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _category = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.name) {
    errors.name = 'Please enter a value';
  }
  return errors;
};

var CategoryForm = function (_React$Component) {
  (0, _inherits3.default)(CategoryForm, _React$Component);

  function CategoryForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryForm.__proto__ || (0, _getPrototypeOf2.default)(CategoryForm)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _category.onClickCancel)());
    }, _this._onSubmitCreateAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet', name: values.name.trim() }));
    }, _this._onSubmitSave = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save', name: values.name.trim() }));
    }, _this._onClickDelete = function () {
      _this.props.dispatch((0, _category.showDeleteModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ingCategory = _props.ingCategory,
          handleSubmit = _props.handleSubmit,
          outlets = _props.outlets,
          isSubmitting = _props.isSubmitting;

      return React.createElement(
        'form',
        { className: _CategoryForm2.default.wrapper, onSubmit: function onSubmit(e) {
            e.preventDefault();
          } },
        React.createElement(
          'div',
          { className: _CategoryForm2.default['content-wrapper'] },
          React.createElement(_LabelSection2.default, { title: 'ingredient category' }),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  name: 'name',
                  type: 'text',
                  placeholder: 'Ingredient Category Name'
                })
              )
            )
          )
        ),
        React.createElement(
          _ActionBarDetailWrapper2.default,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            ingCategory.id && React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickDelete, type: 'button', disabled: isSubmitting },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default mr-10px', onClick: this._onCancel, type: 'button', disabled: isSubmitting },
              'Cancel'
            ),
            outlets.length > 1 && !ingCategory.id && React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary mr-10px',
                onClick: handleSubmit(this._onSubmitCreateAllOutlet),
                disabled: isSubmitting },
              'Save to All Outlet'
            ),
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                disabled: isSubmitting,
                onClick: handleSubmit(this._onSubmitSave) },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return CategoryForm;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('ingCategory');

function mapStateToProps(state) {
  var _state$ingredients$ca = state.ingredients.category,
      outlets = _state$ingredients$ca.outlets,
      isSubmitting = _state$ingredients$ca.isSubmitting;

  return {
    outlets: outlets,
    isSubmitting: isSubmitting,
    ingCategory: {
      id: selector(state, 'id')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'ingCategory',
  validate: validate,
  touchOnBlur: false,
  touchOnChange: false
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(CategoryForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2103);

var _List2 = _interopRequireDefault(_List);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _category = __webpack_require__(124);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          currentPage = _this$props2.currentPage,
          categories = _this$props2.categories;

      dispatch((0, _category.categoriesRequest)({ page: currentPage + 1 }, categories));
    }, _this._onClickRow = function (category) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          isDirtyForm = _this$props3.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _category.onClickRow)(category)));
      } else {
        dispatch((0, _category.onClickRow)(category));
      }
    }, _this._onClickAssignToIngredient = function (event, category) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.dispatch((0, _category.onClickAssignToIngredient)(category));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          categories = _props.categories,
          categoryDetail = _props.categoryDetail,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      if (categories.length > 0) {
        return React.createElement(
          'div',
          { className: _List2.default['wrapper'] },
          React.createElement(
            'table',
            { className: _List2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  null,
                  'Ingredient Category Name'
                ),
                React.createElement(
                  'th',
                  null,
                  'Ingredient Stocks'
                ),
                React.createElement('th', null)
              )
            )
          ),
          React.createElement(
            'div',
            { className: _List2.default['table-content-wrapper'] },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore(),
                useWindow: false,
                threshold: 10,
                initialLoad: false
              },
              React.createElement(
                'table',
                { className: '' + _List2.default['table-content'] },
                React.createElement(
                  'tbody',
                  null,
                  categories.map(function (category) {
                    var className = categoryDetail && category.id === categoryDetail.id ? _List2.default.selected : '';
                    return React.createElement(
                      'tr',
                      { onClick: function onClick() {
                          _this2._onClickRow(category);
                        }, className: className },
                      React.createElement(
                        'td',
                        null,
                        category.name
                      ),
                      React.createElement(
                        'td',
                        null,
                        category.ingredient_count,
                        ' ingredients'
                      ),
                      React.createElement(
                        'td',
                        { className: 'text-right' },
                        React.createElement(
                          'a',
                          {
                            className: 'btn btn-default',
                            onClick: function onClick(event) {
                              return _this2._onClickAssignToIngredient(event, category);
                            } },
                          'Assign to Ingredient'
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        );
      } else {
        return React.createElement(_NoDataAndLoading2.default, {
          showLoadingSpinner: showLoadingSpinnerPage,
          noDataToDisplay: categories.length === 0,
          title: 'No Data To Display',
          description: '' });
      }
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$ca = state.ingredients.category,
      categories = _state$ingredients$ca.categories,
      totalPage = _state$ingredients$ca.totalPage,
      currentPage = _state$ingredients$ca.currentPage,
      categoryDetail = _state$ingredients$ca.categoryDetail;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    categories: categories,
    totalPage: totalPage,
    currentPage: currentPage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    categoryDetail: categoryDetail,
    isDirtyForm: (0, _reduxForm.isDirty)('ingCategory')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Cookies, React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _reactRouter = __webpack_require__(15);

var _reactRedux = __webpack_require__(6);

var _ingredientSubscription = __webpack_require__(614);

var _Ingredient = __webpack_require__(2104);

var _Ingredient2 = _interopRequireDefault(_Ingredient);

var _FeatureTutorialPage = __webpack_require__(1129);

var _FeatureTutorialPage2 = _interopRequireDefault(_FeatureTutorialPage);

var _FeatureBillingPage = __webpack_require__(1126);

var _FeatureBillingPage2 = _interopRequireDefault(_FeatureBillingPage);

var _FeatureTrialPage = __webpack_require__(1128);

var _FeatureTrialPage2 = _interopRequireDefault(_FeatureTrialPage);

var _FeatureBlockerPage = __webpack_require__(635);

var _FeatureBlockerPage2 = _interopRequireDefault(_FeatureBlockerPage);

var _ic_ingredient = __webpack_require__(2862);

var _ic_ingredient2 = _interopRequireDefault(_ic_ingredient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISCOUNT_PRICE_LOWER_BOUND = 150000;

var Ingredient = function (_Component) {
  (0, _inherits3.default)(Ingredient, _Component);

  function Ingredient() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ingredient);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ingredient.__proto__ || (0, _getPrototypeOf2.default)(Ingredient)).call.apply(_ref, [this].concat(args))), _this), _this._endTutorial = function () {
      var isOwner = _this.props.isOwner;

      if (isOwner) _this.props.dispatch((0, _ingredientSubscription.endTutorial)({ feature_name: 'Ingredient Inventory' }));
    }, _this._onHide = function () {
      var isOwner = _this.props.isOwner;

      if (isOwner) _this.props.dispatch((0, _ingredientSubscription.hideDetailTransactionModal)());
    }, _this._onShow = function () {
      var isOwner = _this.props.isOwner;

      if (isOwner) _this.props.dispatch((0, _ingredientSubscription.showDetailTransactionModal)());
    }, _this._verifyBilling = function () {
      var _this$props = _this.props,
          featureName = _this$props.featureName,
          featurePrice = _this$props.featurePrice,
          isOwner = _this$props.isOwner;

      if (isOwner) {
        var featureData = {
          type: 'FeatureBilling',
          feature_name: featureName,
          total_amount: featurePrice.final_price
        };
        _this.props.dispatch((0, _ingredientSubscription.verifyBilling)(featureData));
      }
    }, _this._hidePaymentGatewayErrorModal = function () {
      var isOwner = _this.props.isOwner;

      if (isOwner) _this.props.dispatch((0, _ingredientSubscription.hidePaymentGatewayErrorModal)());
    }, _this._startTrial = function () {
      var isOwner = _this.props.isOwner;

      if (isOwner) _this.props.dispatch((0, _ingredientSubscription.startTrial)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ingredient, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          trialEndAt = _props.trialEndAt,
          outletSlot = _props.outletSlot,
          expired = _props.expired,
          billingNotification = _props.billingNotification,
          already_subscribed = _props.already_subscribed;


      if (!expired) {
        this.props.dispatch((0, _ingredientSubscription.pageRequest)(trialEndAt, outletSlot, billingNotification, already_subscribed));
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          isIngredientActive = _props2.isIngredientActive,
          isOnTutorial = _props2.isOnTutorial,
          pageOnLoading = _props2.pageOnLoading,
          featureName = _props2.featureName,
          alreadySubscribed = _props2.alreadySubscribed,
          featurePrice = _props2.featurePrice,
          featurePricePerMonths = _props2.featurePricePerMonths,
          currentOutletCount = _props2.currentOutletCount,
          buttonMessage = _props2.buttonMessage,
          isButtonDisabled = _props2.isButtonDisabled,
          pendingPaymentMessage = _props2.pendingPaymentMessage,
          pendingOutletMessage = _props2.pendingOutletMessage,
          showDetailModal = _props2.showDetailModal,
          outletList = _props2.outletList,
          showPaymentGatewayErrorModal = _props2.showPaymentGatewayErrorModal,
          trialEndAt = _props2.trialEndAt,
          isOwner = _props2.isOwner;


      var expireTime = 365; // expire time 1 year
      var messages = pendingPaymentMessage !== null ? pendingPaymentMessage : pendingOutletMessage !== null ? pendingOutletMessage : null;
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
      }
      return React.createElement(
        'div',
        { className: 'container ' + _Ingredient2.default['container'] },
        !pageOnLoading && !isOwner && !isIngredientActive && React.createElement(_FeatureBlockerPage2.default, null),
        !pageOnLoading && !isIngredientActive && !alreadySubscribed && !isOnTutorial && isOwner && React.createElement(_FeatureTrialPage2.default, {
          featureName: featureName,
          featurePricePerMonths: featurePricePerMonths,
          discountPriceLowerBound: DISCOUNT_PRICE_LOWER_BOUND,
          description: 'Keep track the ingredients of your items, and get notified when the ingredient is running out.',
          featureIcon: _ic_ingredient2.default,
          featureVideo: 'https://www.youtube.com/embed/0K_4_PeV4x8',
          startTrial: function startTrial() {
            _this2._startTrial();
          },
          trialEndAt: trialEndAt
        }),
        !pageOnLoading && !isIngredientActive && alreadySubscribed && !isOnTutorial && isOwner && React.createElement(_FeatureBillingPage2.default, {
          featureName: featureName,
          discountPriceLowerBound: DISCOUNT_PRICE_LOWER_BOUND,
          videoLink: 'https://www.youtube.com/embed/0K_4_PeV4x8',
          featureMessage: 'Keep track the ingredients of your items, and get notified when the ingredient is running out.',
          featureLogo: _ic_ingredient2.default,
          featurePrice: featurePrice,
          featurePricePerMonths: featurePricePerMonths,
          currentOutletCount: currentOutletCount,
          buttonMessage: buttonMessage,
          isButtonDisabled: isButtonDisabled,
          billingMessages: messages,
          showDetailModal: showDetailModal,
          onHide: function onHide() {
            _this2._onHide();
          },
          onShow: function onShow() {
            _this2._onShow();
          },
          outletList: outletList,
          verifyBilling: function verifyBilling() {
            _this2._verifyBilling();
          },
          showPaymentGatewayErrorModal: showPaymentGatewayErrorModal,
          hidePaymentGatewayErrorModal: function hidePaymentGatewayErrorModal() {
            _this2._hidePaymentGatewayErrorModal();
          }
        }),
        !pageOnLoading && isOnTutorial && isOwner && React.createElement(_FeatureTutorialPage2.default, {
          featureName: 'Welcome to ' + featureName,
          isSubscribedAccount: alreadySubscribed,
          videoLink: 'https://www.youtube.com/embed/dSVg0quPPjo?ecver=1',
          endTutorial: function endTutorial() {
            _this2._endTutorial();
          }
        }),
        !pageOnLoading && isIngredientActive && !isOnTutorial && this.props.children
      );
    }
  }]);
  return Ingredient;
}(_react.Component);

function mapStateToProps(state) {
  var _state$moka$user = state.moka.user,
      already_subscribed = _state$moka$user.already_subscribed,
      _state$moka$user$busi = _state$moka$user.business,
      trial_end_at = _state$moka$user$busi.trial_end_at,
      outlet_slot = _state$moka$user$busi.outlet_slot,
      is_owner = _state$moka$user.is_owner;
  var _state$ingredients$in = state.ingredients.ingredientSubscription,
      isOnTutorial = _state$ingredients$in.isOnTutorial,
      pageOnLoading = _state$ingredients$in.pageOnLoading,
      _state$ingredients$in2 = _state$ingredients$in.subscriptionDetail,
      name = _state$ingredients$in2.name,
      is_active = _state$ingredients$in2.is_active,
      featurePrice = _state$ingredients$in.featurePrice,
      featurePricePerMonths = _state$ingredients$in.featurePricePerMonths,
      currentOutletCount = _state$ingredients$in.currentOutletCount,
      isButtonDisabled = _state$ingredients$in.isButtonDisabled,
      buttonMessage = _state$ingredients$in.buttonMessage,
      pendingPaymentMessage = _state$ingredients$in.pendingPaymentMessage,
      pendingOutletMessage = _state$ingredients$in.pendingOutletMessage,
      showDetailModal = _state$ingredients$in.showDetailModal,
      outletList = _state$ingredients$in.outletList,
      showPaymentGatewayErrorModal = _state$ingredients$in.showPaymentGatewayErrorModal;
  var expired = state.subscriptionExpired.expired;
  var billingNotification = state.billingNotification;

  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,
    isOnTutorial: isOnTutorial,
    isIngredientActive: is_active,
    pageOnLoading: pageOnLoading,
    featureName: name,
    featurePrice: featurePrice,
    featurePricePerMonths: featurePricePerMonths,
    currentOutletCount: currentOutletCount,
    isButtonDisabled: isButtonDisabled,
    buttonMessage: buttonMessage,
    pendingPaymentMessage: pendingPaymentMessage,
    pendingOutletMessage: pendingOutletMessage,
    showDetailModal: showDetailModal,
    outletList: outletList,
    showPaymentGatewayErrorModal: showPaymentGatewayErrorModal,
    expired: expired,
    billingNotification: billingNotification
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Ingredient);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(0)))

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(2105);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownSelect = __webpack_require__(436);

var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _reactBootstrap = __webpack_require__(10);

var _library = __webpack_require__(93);

var actIngredientLibrary = _interopRequireWildcard(_library);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateItem = function () {
      var _this$props = _this.props,
          uncategorized = _this$props.uncategorized,
          isDirtyLibrary = _this$props.isDirtyLibrary;

      if (isDirtyLibrary) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actIngredientLibrary.onClickCreateLibrary(uncategorized)));
      } else {
        _this.props.dispatch(actIngredientLibrary.onClickCreateLibrary(uncategorized));
      }
    }, _this._onChangeFilterCategory = function (event, categoryId) {
      var _this$props$filterFor = _this.props.filterForm,
          typeInventoryId = _this$props$filterFor.typeInventoryId,
          search = _this$props$filterFor.search,
          outletIds = _this$props$filterFor.outletIds;

      _this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds));
    }, _this._onChangeFilterInventory = function (event, typeInventoryId) {
      var _this$props$filterFor2 = _this.props.filterForm,
          categoryId = _this$props$filterFor2.categoryId,
          search = _this$props$filterFor2.search,
          outletIds = _this$props$filterFor2.outletIds;

      _this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds));
    }, _this._onChangeFilterKeyword = function (event, search) {
      var _this$props$filterFor3 = _this.props.filterForm,
          categoryId = _this$props$filterFor3.categoryId,
          typeInventoryId = _this$props$filterFor3.typeInventoryId,
          outletIds = _this$props$filterFor3.outletIds;

      _this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds));
    }, _this._onChangeOutletIds = function (outletIds) {
      var isDirtyLibrary = _this.props.isDirtyLibrary;
      var _this$props$filterFor4 = _this.props.filterForm,
          categoryId = _this$props$filterFor4.categoryId,
          typeInventoryId = _this$props$filterFor4.typeInventoryId;

      if (isDirtyLibrary) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actIngredientLibrary.onChangeOutletIds(outletIds, categoryId, typeInventoryId)));
      } else {
        _this.props.dispatch(actIngredientLibrary.onChangeOutletIds(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          inventories = _props.inventories,
          categories = _props.categories,
          summary = _props.summary,
          onClickImport = _props.onClickImport,
          onClickExport = _props.onClickExport;

      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding' },
          React.createElement(
            'div',
            { className: 'col-md-7 col-sm-7 col-xs-12 no-padding left-filter' },
            React.createElement(
              'ul',
              { className: _ActionBar2.default['ul-filter'] },
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-dropdown-outlet visible-md visible-lg' },
                React.createElement(_reduxForm.Field, {
                  name: 'outletIds',
                  component: _DropdownOutlet2.default,
                  outlets: outlets,
                  onChangeOutletIds: this._onChangeOutletIds
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-dropdown-category' },
                React.createElement(_reduxForm.Field, {
                  name: 'categoryId',
                  component: _DropdownSelect2.default,
                  options: categories,
                  defaultOption: { id: 0, name: 'All Categories' },
                  className: 'dropdown-select-categories',
                  id: 'filterSelectCategory',
                  onChange: this._onChangeFilterCategory
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-dropdown-type-inventory' },
                React.createElement(_reduxForm.Field, {
                  name: 'typeInventoryId',
                  component: _DropdownSelect2.default,
                  options: inventories,
                  className: 'dropdown-select-inventories',
                  id: 'filterSelectInventory',
                  onChange: this._onChangeFilterInventory
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-searching' },
                React.createElement(_reduxForm.Field, {
                  name: 'search',
                  component: _SearchBar2.default,
                  placeholder: 'Search',
                  onChange: this._onChangeFilterKeyword
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-5 col-sm-5 col-xs-12 no-padding right-filter' },
            React.createElement(
              'ul',
              { className: _ActionBar2.default['ul-filter'] + ' ' + _ActionBar2.default['filter-right'] },
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item visible-md visible-lg' },
                React.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this._onClickCreateItem },
                  'Create Ingredient'
                )
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item' },
                React.createElement(
                  _reactBootstrap.DropdownButton,
                  { title: 'Import / Export', bsStyle: 'primary' },
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickImport },
                    'Import Ingredients'
                  ),
                  React.createElement(_reactBootstrap.MenuItem, { divider: true }),
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickExport },
                    'Export Ingredients'
                  )
                )
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item' },
                React.createElement(
                  'a',
                  { className: _ActionBar2.default['btn-total'] + ' btn btn-default' },
                  'Total : ',
                  summary.total_count
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      libraries = _state$ingredients$li.libraries,
      summary = _state$ingredients$li.summary,
      categories = _state$ingredients$li.categories,
      itemDetail = _state$ingredients$li.itemDetail,
      deletedLibrary = _state$ingredients$li.deletedLibrary,
      showDeleteLibraryModal = _state$ingredients$li.showDeleteLibraryModal,
      currentPage = _state$ingredients$li.currentPage,
      totalPage = _state$ingredients$li.totalPage,
      inventories = _state$ingredients$li.inventories,
      currentInventoryId = _state$ingredients$li.currentInventoryId,
      currentCategoryId = _state$ingredients$li.currentCategoryId,
      outlets = _state$ingredients$li.outlets,
      uncategorized = _state$ingredients$li.uncategorized;

  var _selector = selector(state, 'categoryId', 'typeInventoryId', 'search', 'outletIds'),
      categoryId = _selector.categoryId,
      typeInventoryId = _selector.typeInventoryId,
      search = _selector.search,
      outletIds = _selector.outletIds;

  var isDirtyLibrary = (0, _reduxForm.isDirty)('library')(state);
  return {
    uncategorized: uncategorized,
    categories: categories,
    outlets: outlets,
    libraries: libraries,
    itemDetail: itemDetail,
    deletedLibrary: deletedLibrary,
    showDeleteLibraryModal: showDeleteLibraryModal,
    currentPage: currentPage,
    totalPage: totalPage,
    inventories: inventories,
    currentInventoryId: currentInventoryId,
    currentCategoryId: currentCategoryId,
    summary: summary,
    isDirtyLibrary: isDirtyLibrary,
    filterForm: { categoryId: categoryId, typeInventoryId: typeInventoryId, search: search, outletIds: outletIds }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _library = __webpack_require__(93);

var actIngredientLibrary = _interopRequireWildcard(_library);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(1367);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _List = __webpack_require__(1379);

var _List2 = _interopRequireDefault(_List);

var _uploaders = __webpack_require__(236);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _pages = __webpack_require__(38);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _LibraryDetail = __webpack_require__(1369);

var _LibraryDetail2 = _interopRequireDefault(_LibraryDetail);

var _LibraryImportModal = __webpack_require__(1378);

var _LibraryImportModal2 = _interopRequireDefault(_LibraryImportModal);

var _SaveToAllOutletsModal = __webpack_require__(1380);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Library = function (_React$Component) {
  (0, _inherits3.default)(Library, _React$Component);

  function Library() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Library);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Library.__proto__ || (0, _getPrototypeOf2.default)(Library)).call.apply(_ref, [this].concat(args))), _this), _this._onClickTryBtn = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(true));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
    }, _this._onClear = function () {
      _this.props.dispatch((0, _uploaders.showModalImport)(false));
      _this.props.dispatch((0, _uploaders.showModalErrorImport)(false, []));
      _this.props.dispatch(actIngredientLibrary.showSectionUploader(false));
    }, _this._onClickExport = function () {
      var _this$props$data = _this.props.data,
          ingredients = _this$props$data.ingredients,
          user = _this$props$data.user;

      var library = ingredients.library;
      var prefix = 'Ingredients - ';
      var _library$filterState = library.filterState,
          categoryId = _library$filterState.categoryId,
          typeInventoryId = _library$filterState.typeInventoryId,
          keyword = _library$filterState.keyword;

      var formatCategory = categoryId;
      _this.props.dispatch(actIngredientLibrary.libraryExportRequest(prefix, user.email, library.outlets, formatCategory, _this._formatExportbyInventoryId(typeInventoryId), keyword));
    }, _this._formatExportbyInventoryId = function (inventoryId) {
      var result = void 0;
      var parseInventoryId = parseInt(inventoryId);
      if (parseInventoryId) {
        if (parseInventoryId === 1) {
          result = 'low';
        } else {
          result = 'out';
        }
      } else {
        result = 'all';
      }
      return result;
    }, _this._onClickImport = function () {
      _this.props.dispatch(actIngredientLibrary.showImportModal());
    }, _this._onClickUploadButton = function (file, importType) {
      _this.props.dispatch((0, _uploaders.doImportItem)(file, importType));
    }, _this._onClickDownloadTemplate = function () {
      var library = _this.props.data.ingredients.library;
      var user = _this.props.data.user;

      var prefix = 'Ingredients Library - ';
      _this.props.dispatch(actIngredientLibrary.downloadLibraryTemplate(prefix, user.email, library.outlets));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Library, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch(actIngredientLibrary.pageRequest());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.isDirtyLibrary && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$ingredien = this.props.data.ingredients.library,
          showImportModal = _props$data$ingredien.showImportModal,
          openRightColumn = _props$data$ingredien.openRightColumn,
          libraries = _props$data$ingredien.libraries;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;


      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, {
          onClickImport: this._onClickImport,
          onClickExport: this._onClickExport }),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: libraries.length === 0,
              title: 'No Data To Display',
              description: '' }),
            libraries.length > 0 && !showLoadingSpinnerPage && React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_LibraryDetail2.default, null)
          )
        ),
        React.createElement(_LibraryImportModal2.default, { show: showImportModal, dispatch: this.props.dispatch }),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_SaveToAllOutletsModal2.default, null)
      );
    }
  }]);
  return Library;
}(React.Component);

function select(state) {
  // only fetch some state
  var ingredientState = state.ingredients;
  return {
    data: {
      ingredients: {
        library: ingredientState.library
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyLibrary: (0, _reduxForm.isDirty)('library')(state)
  };
}
exports.default = (0, _reactRedux.connect)(select)(Library);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LibraryDetail = __webpack_require__(2106);

var _LibraryDetail2 = _interopRequireDefault(_LibraryDetail);

var _library = __webpack_require__(93);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _LibraryForm = __webpack_require__(1374);

var _LibraryForm2 = _interopRequireDefault(_LibraryForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryDetail = function (_React$Component) {
  (0, _inherits3.default)(LibraryDetail, _React$Component);

  function LibraryDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryDetail.__proto__ || (0, _getPrototypeOf2.default)(LibraryDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeSwitch = function () {
      _this.props.dispatch((0, _library.clearAmountField)());
    }, _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          libraries = _this$props.libraries,
          summary = _this$props.summary,
          outletIds = _this$props.search.outletIds;

      var formatValues = _this._formatOnSave(values);
      // we must delete the 'action' property so it doesn't sent to server.
      var allOutlet = values.action !== 'save';
      delete values.action;
      // if it is create, the api wants 'remote_image_url' to be sent
      if (!values.id) {
        if (values.image && values.image.url) {
          values.remote_image_url = values.image.url;
        } else {
          values.remote_image_url = '';
        }
      }
      if (values.id) {
        dispatch((0, _library.submitFormUpdate)(values.id, { library: formatValues }, allOutlet, libraries));
      } else {
        dispatch((0, _library.submitFormCreate)({ library: formatValues }, allOutlet, libraries, outletIds[0], summary));
      }
    }, _this._formatOnSave = function (values) {
      var _this$props2 = _this.props,
          units = _this$props2.units,
          categories = _this$props2.categories;
      var id = values.id,
          name = values.name,
          image = values.image,
          in_stock = values.in_stock,
          alert = values.alert,
          stock_alert = values.stock_alert,
          cogs = values.cogs,
          track_cogs = values.track_cogs,
          unit_cost = values.unit_cost,
          time_synchronized = values.time_synchronized,
          is_recipe = values.is_recipe,
          category_name = values.category_name,
          description = values.description,
          business_id = values.business_id,
          outlet_id = values.outlet_id;

      var ingredientCategoryId = values.ingredient_category_id;
      var unitId = values.unit_id;
      var idUncategorized = categories.find(function (category) {
        return category.name === 'Uncategorized';
      }).id;
      var result = {
        'ingredient': {
          'id': id,
          'ingredient_category_id': ingredientCategoryId > 0 ? ingredientCategoryId : idUncategorized,
          'ingredient_category_name': categories.find(function (category) {
            return category.id === ingredientCategoryId;
          }).name,
          'name': name,
          'image': image.url === '' || image.url === null ? 'https://placehold.it/100&text=%20' : image.url,
          'unit_id': unitId,
          'remove_image': values.image.url === '',
          'remote_image_url': image.url,
          'unit_name': unitId ? units.find(function (unit) {
            return unit.id === unitId;
          }).name : '',
          'in_stock': in_stock,
          'alert': alert,
          'stock_alert': stock_alert,
          'cogs': values.track_cogs ? cogs : null,
          'track_cogs': track_cogs,
          'unit_cost': unit_cost,
          'time_synchronized': time_synchronized,
          'is_recipe': is_recipe,
          'category_name': category_name,
          'description': description,
          'business_id': business_id,
          'outlet_id': outlet_id
        }
      };
      if (!id) {
        delete result.remote_image_url;
      }
      return result;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _LibraryDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _LibraryDetail2.default.form },
          React.createElement(_LibraryForm2.default, {
            onSubmit: this._onSubmit,
            onChangeSwitch: this._onChangeSwitch
          })
        )
      );
    }
  }]);
  return LibraryDetail;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      libraries = _state$ingredients$li.libraries,
      libraryDetail = _state$ingredients$li.libraryDetail,
      units = _state$ingredients$li.units,
      categories = _state$ingredients$li.categories,
      summary = _state$ingredients$li.summary;
  var business = state.moka.user.business;

  return {
    libraries: libraries,
    libraryDetail: libraryDetail,
    search: (0, _reduxForm.getFormValues)('search')(state),
    units: units,
    categories: categories,
    summary: summary,
    business_id: business.id
  };
}

LibraryDetail.propTypes = {
  Library: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LibraryDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateCategoryModal = function (_React$Component) {
  (0, _inherits3.default)(CreateCategoryModal, _React$Component);

  function CreateCategoryModal() {
    (0, _classCallCheck3.default)(this, CreateCategoryModal);
    return (0, _possibleConstructorReturn3.default)(this, (CreateCategoryModal.__proto__ || (0, _getPrototypeOf2.default)(CreateCategoryModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(CreateCategoryModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onConfirm = _props.onConfirm,
          onCancel = _props.onCancel,
          show = _props.show,
          newCategory = _props.newCategory;

      if (!newCategory) {
        newCategory = '';
      }
      return React.createElement(
        _reactBootstrap.Modal,
        { show: show, bsClass: 'create-category-modal margin-top-modal modal' },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            null,
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Are you sure want to create ',
            React.createElement(
              'span',
              null,
              newCategory
            ),
            '?'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: onCancel },
              'Cancel'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: onConfirm },
              'Ok'
            )
          )
        )
      );
    }
  }]);
  return CreateCategoryModal;
}(React.Component);

exports.default = CreateCategoryModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _LibraryCOGS = __webpack_require__(2107);

var _LibraryCOGS2 = _interopRequireDefault(_LibraryCOGS);

var _library = __webpack_require__(93);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryCOGS = function (_React$Component) {
  (0, _inherits3.default)(LibraryCOGS, _React$Component);

  function LibraryCOGS() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryCOGS);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryCOGS.__proto__ || (0, _getPrototypeOf2.default)(LibraryCOGS)).call.apply(_ref, [this].concat(args))), _this), _this._onClickStartTrackingCOGS = function (event) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          libraryForm = _this$props.libraryForm;

      dispatch((0, _library.onClickBtnTrackingCOGS)(libraryForm));
      event.stopPropagation();
      event.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryCOGS, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          libraryForm = _props.libraryForm,
          showInputCOGS = _props.showInputCOGS,
          initValuesForm = _props.initValuesForm,
          isInventoryTracked = _props.isInventoryTracked;

      var initDisabledColumn = initValuesForm && initValuesForm.id && initValuesForm.track_cogs;

      return React.createElement(
        'div',
        { className: 'row' },
        showInputCOGS && libraryForm && React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: 'col-sm-8' }),
            React.createElement(
              'div',
              { className: 'col-sm-4 ' + _LibraryCOGS2.default['label-avg-cost'] },
              'AVG COST'
            )
          ),
          React.createElement(
            'div',
            { className: 'mk-grouped-input' },
            React.createElement(
              'div',
              { className: 'form-group col-sm-8' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                name: 'name',
                className: initDisabledColumn ? 'form-control ' + _LibraryCOGS2.default['cost-name'] : 'form-control ' + _LibraryCOGS2.default['cost-name'] + ' ' + _LibraryCOGS2.default['col-name-cogs'],
                disabled: initDisabledColumn,
                placeholder: 'Ingredient Name'
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group col-sm-4' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'cogs',
                className: 'form-control text-right',
                readOnly: initDisabledColumn,
                positiveNumberOnly: true,
                maxFractionDigits: 0,
                inputClassName: 'text-right ' + _LibraryCOGS2.default['input-avgCost'] + ' ' + _LibraryCOGS2.default['avg-cost'],
                prefixText: 'Rp',
                prefixTextClassName: _LibraryCOGS2.default['rp-avgCost'],
                prefixTextClassNameError: _LibraryCOGS2.default['rp-avgCost-error']
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-12', id: _LibraryCOGS2.default['cogs-btn'] },
          React.createElement(
            'button',
            { onClick: this._onClickStartTrackingCOGS, className: 'btn btn-primary btn-block no-border-radius-top', disabled: !isInventoryTracked },
            showInputCOGS ? 'Manage Cost of Good Sold (COGS)' : 'Start Tracking Cost of Goods Sold (COGS)'
          ),
          React.createElement(
            'div',
            { className: _LibraryCOGS2.default['label-cogs-btn'] },
            React.createElement('i', { className: isInventoryTracked ? 'fa fa-exclamation-circle ' + _LibraryCOGS2.default['info-icon'] : 'fa fa-lock ' + _LibraryCOGS2.default['lock-icon'] }),
            React.createElement(
              'label',
              null,
              isInventoryTracked ? 'Avg cost can not be changed after saving the item, so please make sure that is correct!' : 'This ingredient can not be tracked because the inventory stock is not tracked.'
            )
          )
        )
      );
    }
  }]);
  return LibraryCOGS;
}(React.Component);

function mapStateToProps(state) {
  return {
    libraryForm: (0, _reduxForm.getFormValues)('library')(state),
    initValuesForm: (0, _reduxForm.getFormInitialValues)('library')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LibraryCOGS);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _LibraryCOGSModal = __webpack_require__(767);

var _LibraryCOGSModal2 = _interopRequireDefault(_LibraryCOGSModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  // have no validation in experiment
  return errors;
};

var LibraryCOGSForm = function (_React$Component) {
  (0, _inherits3.default)(LibraryCOGSForm, _React$Component);

  function LibraryCOGSForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryCOGSForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryCOGSForm.__proto__ || (0, _getPrototypeOf2.default)(LibraryCOGSForm)).call.apply(_ref, [this].concat(args))), _this), _this._setOnlyNumber = function (e) {
      var regex = /[0-9:]+/g;
      if (!regex.test(e.key)) {
        e.preventDefault();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryCOGSForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          initDisabledColumn = _props.initDisabledColumn,
          libraryForm = _props.libraryForm,
          units = _props.units;

      return React.createElement(
        'form',
        { id: 'form-library-cogs' },
        React.createElement(
          'table',
          { className: 'table table-responsive ' + _LibraryCOGSModal2.default.table },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Ingredient'
              ),
              React.createElement(
                'th',
                null,
                'Track COGS'
              ),
              React.createElement(
                'th',
                null,
                'Avg Cost'
              ),
              React.createElement(
                'th',
                null,
                'Unit'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { className: '' + _LibraryCOGSModal2.default['text-elipsis'] },
                React.createElement(
                  'span',
                  { name: 'name' },
                  libraryForm && libraryForm.name
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'checkbox checkbox-primary checkbox-item checkbox-circle' },
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: 'track_cogs',
                    type: 'checkbox',
                    id: 'checkbox-track-cogs'
                  }),
                  React.createElement('label', { 'for': 'checkbox-track-cogs' })
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'form-group' },
                  React.createElement(
                    'div',
                    { className: _LibraryCOGSModal2.default['rp-avgCost'] },
                    'Rp'
                  ),
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: 'cogs',
                    type: 'text',
                    className: 'form-control text-right ' + _LibraryCOGSModal2.default['input-avgCost'],
                    onKeyPress: this._setOnlyNumber,
                    disabled: initDisabledColumn
                  })
                )
              ),
              React.createElement(
                'td',
                null,
                libraryForm && libraryForm.unit_id ? 'Per ' + units.find(function (unit) {
                  return parseInt(unit.id) === parseInt(libraryForm.unit_id);
                }).name : ''
              )
            )
          )
        )
      );
    }
  }]);
  return LibraryCOGSForm;
}(React.Component);

exports.default = (0, _reduxForm.reduxForm)({
  form: 'libraryCOGS',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(LibraryCOGSForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _library = __webpack_require__(93);

var _reactRedux = __webpack_require__(6);

var _LibraryCOGSModal = __webpack_require__(767);

var _LibraryCOGSModal2 = _interopRequireDefault(_LibraryCOGSModal);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _LibraryCOGSForm = __webpack_require__(1372);

var _LibraryCOGSForm2 = _interopRequireDefault(_LibraryCOGSForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryCOGSModal = function (_React$Component) {
  (0, _inherits3.default)(LibraryCOGSModal, _React$Component);

  function LibraryCOGSModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryCOGSModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryCOGSModal.__proto__ || (0, _getPrototypeOf2.default)(LibraryCOGSModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      _this.props.dispatch((0, _library.onCancelCOGSModal)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          initialValuesCOGS = _this$props.initialValuesCOGS,
          libraryCOGSForm = _this$props.libraryCOGSForm,
          validFormCOGS = _this$props.validFormCOGS,
          showInputCOGS = _this$props.showInputCOGS;

      if (validFormCOGS) {
        _this.props.dispatch((0, _library.onConfirmCOGSModal)(libraryCOGSForm, initialValuesCOGS, showInputCOGS));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryCOGSModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showCOGSModal = _props.showCOGSModal,
          initialValuesCOGS = _props.initialValuesCOGS,
          libraryForm = _props.libraryForm,
          units = _props.units;

      var initDisabledColumn = initialValuesCOGS && initialValuesCOGS.id && initialValuesCOGS.track_cogs;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showCOGSModal, backdrop: 'static', onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _LibraryCOGSModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Manage Cost of Goods Sold (COGS)' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(_LibraryCOGSForm2.default, {
            initDisabledColumn: initDisabledColumn,
            libraryForm: libraryForm,
            units: units })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: this._onCancel },
              'Cancel'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onConfirm },
              'Confirm'
            )
          ),
          React.createElement(
            'i',
            { className: _LibraryCOGSModal2.default['footer-info'] },
            '*Use the ',
            React.createElement(
              _reactRouter.Link,
              { to: '/inventory/purchase_orders', target: 'blank' },
              'Purchase Order Page'
            ),
            ' to manage Avg Cost'
          )
        )
      );
    }
  }]);
  return LibraryCOGSModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      showCOGSModal = _state$ingredients$li.showCOGSModal,
      units = _state$ingredients$li.units,
      showInputCOGS = _state$ingredients$li.showInputCOGS;

  return {
    showCOGSModal: showCOGSModal,
    libraryForm: (0, _reduxForm.getFormValues)('library')(state),
    initialValuesCOGS: (0, _reduxForm.getFormInitialValues)('library')(state),
    libraryCOGSForm: (0, _reduxForm.getFormValues)('libraryCOGS')(state),
    units: units,
    validFormCOGS: (0, _reduxForm.isValid)('libraryCOGS')(state),
    showInputCOGS: showInputCOGS
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LibraryCOGSModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _LibraryForm = __webpack_require__(2108);

var _LibraryForm2 = _interopRequireDefault(_LibraryForm);

var _library = __webpack_require__(93);

var _UploadImage = __webpack_require__(438);

var _UploadImage2 = _interopRequireDefault(_UploadImage);

var _reactSelect = __webpack_require__(145);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(262);

var _LibraryInventoryAlert = __webpack_require__(1375);

var _LibraryInventoryAlert2 = _interopRequireDefault(_LibraryInventoryAlert);

var _LibraryInventoryAlertModal = __webpack_require__(1376);

var _LibraryInventoryAlertModal2 = _interopRequireDefault(_LibraryInventoryAlertModal);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _CreateCategoryModal = __webpack_require__(1370);

var _CreateCategoryModal2 = _interopRequireDefault(_CreateCategoryModal);

var _LibraryCOGS = __webpack_require__(1371);

var _LibraryCOGS2 = _interopRequireDefault(_LibraryCOGS);

var _LibraryCOGSModal = __webpack_require__(1373);

var _LibraryCOGSModal2 = _interopRequireDefault(_LibraryCOGSModal);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.name) {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount <= 0) {
    errors.amount = 'Please enter a value > 0';
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input Library amount less than 100%';
  } else if (values.amount > 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input Library amount less than 100.000.000.000';
  }

  if (values.in_stock === '') {
    errors.in_stock = 'Stock is required';
  } else if (values.in_stock && values.in_stock.length > 6) {
    errors.in_stock = 'Stock must be less than 6 digits';
  }

  if (!values.cogs) {
    errors.cogs = 'Avg Cost is required';
  } else if (values.cogs.length > 11) {
    errors.cogs = 'Avg Cost must be less than 11 digits';
  }

  if (!values.stock_alert) {
    errors.stock_alert = 'The stock alert is required';
  }
  return errors;
};

var renderSelectFieldWithoutCreate = function renderSelectFieldWithoutCreate(_ref) {
  var _ref$input = _ref.input,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      dispatch = _ref.meta.dispatch,
      placeholder = _ref.placeholder,
      options = _ref.options,
      units = _ref.units;

  var onChangeSelect = function onChangeSelect(newval) {
    onChange(newval.value);
  };
  return React.createElement(_reactSelect2.default, {
    value: value,
    className: 'selectCategories',
    placeholder: placeholder,
    onChange: onChangeSelect,
    options: options,
    clearable: false
  });
};

var RenderSelectField = function (_React$Component) {
  (0, _inherits3.default)(RenderSelectField, _React$Component);

  function RenderSelectField(props) {
    (0, _classCallCheck3.default)(this, RenderSelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderSelectField.__proto__ || (0, _getPrototypeOf2.default)(RenderSelectField)).call(this, props));

    _this.onChangeSelect = function (newval) {
      var isNewCategory = true;
      var _this$props = _this.props,
          _this$props$input = _this$props.input,
          value = _this$props$input.value,
          onChange = _this$props$input.onChange,
          dispatch = _this$props.meta.dispatch,
          options = _this$props.options,
          categories = _this$props.categories;

      options.forEach(function (cat) {
        if (cat.value === newval.value && typeof newval.value === 'number') {
          isNewCategory = false;
        }
      });
      if (isNewCategory) {
        dispatch((0, _library.onClickCreateNewCategory)(newval.value, categories, value));
        onChange(newval.value);
      } else {
        onChange(newval.value);
      }
    };

    _this.state = {
      selectInstance: 1
    };
    return _this;
  }

  (0, _createClass3.default)(RenderSelectField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.input.value,
          placeholder = _props.placeholder,
          options = _props.options;

      var selectProps = {
        addLabelText: '{label} (create new)',
        value: value,
        className: 'selectCategories',
        placeholder: placeholder,
        onChange: this.onChangeSelect,
        options: options,
        clearable: false,
        backspaceRemoves: false,
        promptTextCreator: function promptTextCreator(label) {
          return label + ' (create new)';
        },
        onClose: function onClose() {
          _this2.setState({ selectInstance: 1 - _this2.state.selectInstance });
        }
        // TODO HACK buat nyamain behaviour kode lama:
        // harus dalam html tag yang beda
        // harus dua komponen yang beda
      };if (this.state.selectInstance === 1) {
        return React.createElement(
          'div',
          null,
          React.createElement(_reactSelect.Creatable, selectProps)
        );
      } else {
        return React.createElement(
          'span',
          null,
          React.createElement(_reactSelect.Creatable, selectProps)
        );
      }
    }
  }]);
  return RenderSelectField;
}(React.Component);

var tooltipDeleteBtn = React.createElement(
  _reactBootstrap.Popover,
  { id: 'popover-trigger-hover-focus' },
  'This Ingredient can not be deleted because it has been associated with a recipe. Please disconnect the Ingredient from the Recipe and try again.'
);

var LibraryForm = function (_React$Component2) {
  (0, _inherits3.default)(LibraryForm, _React$Component2);

  function LibraryForm() {
    var _ref2;

    var _temp, _this3, _ret;

    (0, _classCallCheck3.default)(this, LibraryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = LibraryForm.__proto__ || (0, _getPrototypeOf2.default)(LibraryForm)).call.apply(_ref2, [this].concat(args))), _this3), _this3._onCancelCreateCategoryModal = function () {
      var _this3$props = _this3.props,
          dispatch = _this3$props.dispatch,
          previousCategories = _this3$props.previousCategories,
          previousCategoryId = _this3$props.previousCategoryId;

      dispatch((0, _library.onCancelCreateNewCategory)(previousCategories, previousCategoryId));
    }, _this3._onConfirmCreateCategoryModal = function () {
      var _this3$props2 = _this3.props,
          dispatch = _this3$props2.dispatch,
          newCategory = _this3$props2.newCategory;

      dispatch((0, _library.onConfirmCreateNewCategory)(newCategory));
    }, _this3._onHideDeleteModal = function () {
      var dispatch = _this3.props.dispatch;

      dispatch((0, _library.hideDeleteModal)());
    }, _this3._confirmDelete = function () {
      var _this3$props3 = _this3.props,
          dispatch = _this3$props3.dispatch,
          libraryDetail = _this3$props3.libraryDetail,
          libraries = _this3$props3.libraries,
          summary = _this3$props3.summary;

      dispatch((0, _library.deleteLibrary)(libraryDetail, libraries, summary));
    }, _this3._formatObj = function (values) {
      var results = [];
      values.map(function (value) {
        if (value.id > 0) {
          results.push({ value: value.id, label: value.name });
        }
      });
      return results;
    }, _this3._onClickDelete = function (e) {
      var dispatch = _this3.props.dispatch;

      dispatch((0, _library.showDeleteModal)());
      e.preventDefault();
      e.stopPropagation();
    }, _this3._onClickCancel = function (e) {
      _this3.props.dispatch((0, _library.onClickCancel)());
      e.preventDefault();
      e.stopPropagation();
    }, _this3._onChangeCategories = function (val, newVal) {}, _this3._onChangeUnits = function (val, newVal) {}, _this3._onSubmitCreateAllOutlet = function (values) {
      _this3.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet' }));
    }, _this3._onSubmitSave = function (values) {
      _this3.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _this3._onChangeSwitch = function () {
      _this3.props.onChangeSwitch();
    }, _this3._findUncategorized = function (categories) {
      var idUncategory = void 0;
      categories.map(function (category, index) {
        if (category.name === 'Uncategorized') {
          idUncategory = category.id;
        }
      });
      return idUncategory;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(LibraryForm, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          libraryDetail = _props2.libraryDetail,
          handleSubmit = _props2.handleSubmit,
          categories = _props2.categories,
          libraryForm = _props2.libraryForm,
          showDeleteModal = _props2.showDeleteModal,
          units = _props2.units,
          showInputCOGS = _props2.showInputCOGS,
          showInputInventory = _props2.showInputInventory,
          isSubmittingForm = _props2.isSubmittingForm,
          outlets = _props2.outlets;

      var uploadImagePlaceholder = libraryForm && libraryForm.name ? libraryForm.name.substring(0, 2) : '';

      return React.createElement(
        'form',
        { onSubmit: handleSubmit, className: 'full-height' },
        React.createElement(
          'div',
          { className: '' + _LibraryForm2.default['library-fieldset'] },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
            React.createElement(
              'div',
              { className: 'col-lg-2 col-md-3 col-sm-3' },
              React.createElement(_reduxForm.Field, {
                name: 'image.url',
                component: _UploadImage2.default,
                placeholder: uploadImagePlaceholder,
                className: _LibraryForm2.default['upload-image'],
                backgroundColor: libraryDetail ? libraryDetail.background_color : null
              })
            ),
            React.createElement(
              'div',
              { className: 'col-lg-10 col-md-9 col-sm-9' },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: _SettingField2.default,
                      className: 'form-control',
                      name: 'name',
                      maxLength: '40',
                      placeholder: 'Ingredient Name',
                      type: 'text'
                    })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: RenderSelectField,
                      className: 'selectCategories',
                      name: 'ingredient_category_id',
                      options: this._formatObj(categories),
                      categories: categories,
                      onChange: this._onChangeCategories,
                      placeholder: 'Uncategorized'
                    })
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _LibraryForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _LibraryForm2.default['label-input'] },
                  'UNIT'
                ),
                React.createElement(
                  'p',
                  null,
                  React.createElement(
                    'span',
                    { className: 'form-group text-left label-instock' },
                    'Unit in stock (e.g Litre, Kg, Pieces, etc)'
                  )
                ),
                React.createElement(_reduxForm.Field, {
                  component: renderSelectFieldWithoutCreate,
                  className: 'selectCategories',
                  name: 'unit_id',
                  options: this._formatObj(units),
                  units: units,
                  onChange: this._onChangeUnits,
                  placeholder: 'Unit Name'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _LibraryForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _LibraryForm2.default['label-input'] },
                  'Inventory'
                ),
                React.createElement(_LibraryInventoryAlert2.default, { showInputInventory: showInputInventory })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _LibraryForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _LibraryForm2.default['label-input'] },
                  'Cost'
                ),
                React.createElement(_LibraryCOGS2.default, { showInputCOGS: showInputCOGS, isInventoryTracked: showInputInventory })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _LibraryForm2.default.footer },
          libraryDetail && libraryDetail.id && React.createElement(
            'span',
            { className: 'pull-left' },
            libraryForm && !libraryForm.is_recipe ? React.createElement(
              'button',
              { className: 'btn btn-danger no-outline', onClick: this._onClickDelete, disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            ) : React.createElement(
              _reactBootstrap.OverlayTrigger,
              { trigger: ['hover', 'focus'], placement: 'top', overlay: tooltipDeleteBtn },
              React.createElement(
                'button',
                { className: 'btn ' + _LibraryForm2.default['btn-delete-disabled'], onClick: function onClick(e) {
                    return e.preventDefault();
                  } },
                React.createElement('i', { className: 'fa fa-trash' })
              )
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: this._onClickCancel, disabled: isSubmittingForm },
              'Cancel'
            ),
            libraryForm && !libraryForm.id && outlets && outlets.length > 1 && React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: handleSubmit(this._onSubmitCreateAllOutlet), disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'submit', onClick: handleSubmit(this._onSubmitSave), disabled: isSubmittingForm },
              'Save'
            )
          )
        ),
        React.createElement(_LibraryInventoryAlertModal2.default, null),
        React.createElement(_LibraryCOGSModal2.default, null),
        libraryDetail && libraryDetail.id && React.createElement(_LibraryDeleteModal2.default, {
          name: libraryDetail.name,
          onHide: this._onHideDeleteModal,
          showDeleteModal: showDeleteModal,
          title: 'Library',
          onDelete: this._confirmDelete
        }),
        React.createElement(_CreateCategoryModal2.default, {
          dispatch: this.props.dispatch,
          newCategory: this.props.newCategory,
          show: this.props.showNewCategoryModal,
          onCancel: this._onCancelCreateCategoryModal,
          onConfirm: this._onConfirmCreateCategoryModal
        })
      );
    }
  }]);
  return LibraryForm;
}(React.Component);

LibraryForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var library = state.ingredients.library;

  return {
    outlets: library.outlets,
    libraryDetail: library.libraryDetail,
    units: library.units,
    libraryForm: (0, _reduxForm.getFormValues)('library')(state),
    categories: library.categories,
    showDeleteModal: library.showDeleteModal,
    libraries: library.libraries,
    showNewCategoryModal: library.showNewCategoryModal,
    newCategory: library.newCategory,
    previousCategories: library.previousCategories,
    previousCategoryId: library.previousCategoryId,
    showInputCOGS: library.showInputCOGS,
    showInputInventory: library.showInputInventory,
    isSubmittingForm: library.isSubmittingForm,
    summary: library.summary
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'library',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate,
  // https://mokapos.atlassian.net/browse/FD-1669
  // Form isi -> 2 field name
  // form kosong -> 1 field name
  // di redux-form ni kalo kayak gitu kejadiannya
  // bakal diunregister field
  // yang bakal ngerusak hasil validasi
  destroyOnUnmount: false
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(LibraryForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _library = __webpack_require__(93);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _LibraryInventoryAlert = __webpack_require__(2109);

var _LibraryInventoryAlert2 = _interopRequireDefault(_LibraryInventoryAlert);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryInventoryAlert = function (_React$Component) {
  (0, _inherits3.default)(LibraryInventoryAlert, _React$Component);

  function LibraryInventoryAlert() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryInventoryAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryInventoryAlert.__proto__ || (0, _getPrototypeOf2.default)(LibraryInventoryAlert)).call.apply(_ref, [this].concat(args))), _this), _this._onClickStartTracking = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          libraryForm = _this$props.libraryForm;

      dispatch((0, _library.onClickBtnStartTracking)(libraryForm));
      e.stopPropagation();
      e.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryInventoryAlert, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showInputInventory = _props.showInputInventory,
          libraryForm = _props.libraryForm;

      return React.createElement(
        'div',
        { className: 'row' },
        showInputInventory && libraryForm && React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: 'col-sm-8' }),
            React.createElement(
              'div',
              { className: 'col-sm-4 ' + _LibraryInventoryAlert2.default['label-in-stock'] },
              'IN STOCK'
            )
          ),
          React.createElement(
            'div',
            { className: 'mk-grouped-input' },
            React.createElement(
              'div',
              { className: 'form-group col-sm-8' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                name: 'name',
                className: libraryForm.id ? 'form-control ' + _LibraryInventoryAlert2.default['inv-name'] : 'form-control ' + _LibraryInventoryAlert2.default['inv-name'] + ' ' + _LibraryInventoryAlert2.default['col-name'],
                disabled: libraryForm.id,
                placeholder: 'Ingredient Name'
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group col-sm-4' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'in_stock',
                inputClassName: 'text-right ' + _LibraryInventoryAlert2.default['inv-stock'],
                readOnly: libraryForm.id,
                positiveNumberOnly: true,
                maxFractionDigits: 2
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-12' },
          React.createElement(
            'button',
            { onClick: this._onClickStartTracking, className: 'btn btn-primary btn-block no-border-radius-top' },
            showInputInventory ? 'Manage Ingredient Inventory and Alerts' : 'Start Tracking Ingredient Inventory and Alerts'
          ),
          React.createElement(
            'div',
            { className: _LibraryInventoryAlert2.default['label-inner'] },
            React.createElement('i', { className: 'fa fa-exclamation-circle' }),
            React.createElement(
              'label',
              null,
              'Ingredient stock is automatically tracked and can not be changed after saving the item, so please make sure that it is correct!'
            )
          )
        )
      );
    }
  }]);
  return LibraryInventoryAlert;
}(React.Component);

function mapStateToProps(state) {
  return {
    libraryForm: (0, _reduxForm.getFormValues)('library')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LibraryInventoryAlert);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _library = __webpack_require__(93);

var _LibraryInventoryAlertModal = __webpack_require__(768);

var _LibraryInventoryAlertModal2 = _interopRequireDefault(_LibraryInventoryAlertModal);

var _reactRouter = __webpack_require__(15);

var _LibraryInventoryForm = __webpack_require__(1377);

var _LibraryInventoryForm2 = _interopRequireDefault(_LibraryInventoryForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryInventoryAlertModal = function (_React$Component) {
  (0, _inherits3.default)(LibraryInventoryAlertModal, _React$Component);

  function LibraryInventoryAlertModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryInventoryAlertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryInventoryAlertModal.__proto__ || (0, _getPrototypeOf2.default)(LibraryInventoryAlertModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _library.onCancelLibraryInventoryAlertModal)());
    }, _this._onSave = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          libraryInventoryForm = _this$props.libraryInventoryForm,
          validForm = _this$props.validForm,
          libraryForm = _this$props.libraryForm;

      if (validForm) {
        dispatch((0, _library.onConfirmLibraryInventoryAlertModal)(libraryInventoryForm, libraryForm));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryInventoryAlertModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showLibraryInventoryAlertModal = _props.showLibraryInventoryAlertModal,
          units = _props.units,
          libraryForm = _props.libraryForm;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showLibraryInventoryAlertModal, backdrop: 'static', onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _LibraryInventoryAlertModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Manage Ingredient Inventory' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(_LibraryInventoryForm2.default, { libraryForm: libraryForm, units: units })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: this._onCancel },
              'Cancel'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onSave },
              'Confirm'
            )
          ),
          React.createElement(
            'i',
            { className: _LibraryInventoryAlertModal2.default['footer-info'] },
            '*Use the ',
            React.createElement(
              _reactRouter.Link,
              { to: '/inventory/summary', target: 'blank' },
              'Inventory page'
            ),
            ' to manage stock'
          )
        )
      );
    }
  }]);
  return LibraryInventoryAlertModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      showLibraryInventoryAlertModal = _state$ingredients$li.showLibraryInventoryAlertModal,
      previousLibraryForm = _state$ingredients$li.previousLibraryForm,
      units = _state$ingredients$li.units;

  return {
    showLibraryInventoryAlertModal: showLibraryInventoryAlertModal,
    previousLibraryForm: previousLibraryForm,
    units: units,
    libraryForm: (0, _reduxForm.getFormValues)('library')(state),
    libraryInventoryForm: (0, _reduxForm.getFormValues)('libraryInventory')(state),
    validForm: (0, _reduxForm.isValid)('libraryInventory')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LibraryInventoryAlertModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _LibraryInventoryAlertModal = __webpack_require__(768);

var _LibraryInventoryAlertModal2 = _interopRequireDefault(_LibraryInventoryAlertModal);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (values.stock_alert === '') {
    errors.stock_alert = 'The stock alert is required';
  } else if (values.stock_alert.length > 1 && !_validator2.default.isDecimal(values.stock_alert)) {
    errors.stock_alert = 'Please enter a valid number';
  }
  return errors;
};

var LibraryInventoryForm = function (_React$Component) {
  (0, _inherits3.default)(LibraryInventoryForm, _React$Component);

  function LibraryInventoryForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LibraryInventoryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LibraryInventoryForm.__proto__ || (0, _getPrototypeOf2.default)(LibraryInventoryForm)).call.apply(_ref, [this].concat(args))), _this), _this._setDecimal = function (event) {
      var nextVal = event.target.value;
      var maxFractionDigits = 2;
      if (isNaN(nextVal)) {
        // case if one digit < 0 integer
        if (nextVal === '-') {
          _this.props.dispatch((0, _reduxForm.change)('libraryInventory', 'in_stock', ''));
        } else {
          // no op. invalid change
        }
      } else if (maxFractionDigits !== undefined) {
        var dotPosition = nextVal.indexOf('.');
        if (dotPosition !== -1 && nextVal.length - dotPosition - 1 > maxFractionDigits) {
          // no op. invalid change
        } else {
          _this.props.dispatch((0, _reduxForm.change)('libraryInventory', 'in_stock', nextVal));
        }
      } else {
        _this.props.dispatch((0, _reduxForm.change)('libraryInventory', 'in_stock', nextVal));
      }
      event.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LibraryInventoryForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          libraryForm = _props.libraryForm,
          units = _props.units;


      return React.createElement(
        'form',
        { id: 'form-library-inventory' },
        React.createElement(
          'table',
          { className: 'table table-responsive ' + _LibraryInventoryAlertModal2.default.table },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Ingredient'
              ),
              React.createElement(
                'th',
                null,
                'Track Stock'
              ),
              React.createElement(
                'th',
                null,
                'In Stock'
              ),
              React.createElement(
                'th',
                null,
                'Alert'
              ),
              React.createElement(
                'th',
                null,
                'Alert at'
              ),
              React.createElement(
                'th',
                null,
                'Unit'
              )
            )
          ),
          React.createElement(
            'tbody',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { className: '' + _LibraryInventoryAlertModal2.default['text-elipsis'] },
                React.createElement(
                  'span',
                  { name: 'name' },
                  libraryForm && libraryForm.name
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'checkbox checkbox-primary checkbox-item checkbox-circle checkbox-grey' },
                    React.createElement('input', { type: 'checkbox', checked: 'true', disabled: 'true' }),
                    React.createElement('label', { 'for': '' })
                  )
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'form-group' },
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: 'in_stock',
                    type: 'text',
                    className: 'form-control',
                    readOnly: libraryForm ? !!libraryForm.id : true,
                    onChange: this._setDecimal
                  })
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'checkbox checkbox-primary checkbox-item checkbox-circle' },
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: 'alert',
                    type: 'checkbox',
                    id: 'checkbox-alert-ingredient'
                  }),
                  React.createElement('label', { 'for': 'checkbox-alert-ingredient' })
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'form-group' },
                  React.createElement(_reduxForm.Field, {
                    component: _SettingField2.default,
                    name: 'stock_alert',
                    type: 'text',
                    className: 'form-control',
                    positiveNumberOnly: true,
                    maxFractionDigits: 2
                  })
                )
              ),
              React.createElement(
                'td',
                null,
                libraryForm && libraryForm.unit_id ? units.find(function (unit) {
                  return parseInt(unit.id) === parseInt(libraryForm.unit_id);
                }).name : ''
              )
            )
          )
        )
      );
    }
  }]);
  return LibraryInventoryForm;
}(React.Component);

LibraryInventoryForm.propTypes = {
  libraryForm: React.PropTypes.object,
  units: React.PropTypes.array
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'libraryInventory', // a unique identifier for this form,
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(LibraryInventoryForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ImportModal2 = __webpack_require__(439);

var _ImportModal3 = _interopRequireDefault(_ImportModal2);

var _reactBootstrap = __webpack_require__(10);

var _constants = __webpack_require__(431);

var _library = __webpack_require__(93);

__webpack_require__(2110);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _ingredients = __webpack_require__(205);

var apiIng = _interopRequireWildcard(_ingredients);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryImportModal = function (_ImportModal) {
  (0, _inherits3.default)(LibraryImportModal, _ImportModal);

  function LibraryImportModal(props) {
    (0, _classCallCheck3.default)(this, LibraryImportModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LibraryImportModal.__proto__ || (0, _getPrototypeOf2.default)(LibraryImportModal)).call(this, props));

    _this._header = function () {
      if (_this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          _reactBootstrap.Modal.Title,
          null,
          'Choose Import Type'
        );
      }
    };

    _this._footer = function () {
      if (_this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { onClick: _this._onCancel, className: 'btn btn-default' },
              'Cancel'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { onClick: _this._onNext, className: 'btn btn-primary' },
              'Next'
            )
          )
        );
      }
    };

    _this._body = function () {
      if (_this.state.act === LibraryImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          'div',
          { className: 'modal-below-header' },
          React.createElement(
            'div',
            { className: 'choose-import-box', onClick: function onClick() {
                _this._onClickType('modify');
              } },
            React.createElement(
              'div',
              { className: 'circle' },
              _this.state.type === 'modify' ? '✓' : ''
            ),
            React.createElement(
              'div',
              { className: 'label-modify-item-library' },
              'Modify Ingredient Library'
            ),
            React.createElement(
              'div',
              { className: 'description' },
              'Add new ingredients and update your existing ones. Ingredients cannot be deleted, only altered'
            )
          ),
          React.createElement(
            'div',
            { className: 'choose-import-box', onClick: function onClick() {
                _this._onClickType('replace');
              } },
            React.createElement(
              'div',
              { className: 'circle' },
              _this.state.type === 'replace' ? '✓' : ''
            ),
            React.createElement(
              'div',
              { className: 'label-modify-item-library' },
              'Replace Ingredient Library'
            ),
            React.createElement(
              'div',
              { className: 'description' },
              'Overwrite your existing ingredients. All ingredients will be deleted and replaced'
            )
          )
        );
      }
    };

    _this._confirmImportBody = function () {
      return React.createElement(
        'p',
        null,
        'Are you sure you want to replace the ingredient library?',
        React.createElement('br', null),
        'If you replace the ingredient library, all recipes will be deleted'
      );
    };

    _this._confirmImportHeader = function () {
      return 'Replace Ingredient Library';
    };

    _this._confirmFunction = function () {
      return new _promise2.default(function (resolve, reject) {
        if (_this.state.type === 'modify') {
          resolve(false);
        }
        act.showLoadingSpinner(true);
        apiIng.getHaveRecipe({}).then(function (response) {
          act.showLoadingSpinner(false);
          resolve(response.data.is_recipe);
        }).catch(function (error) {
          act.showLoadingSpinner(false);
          reject(error.message);
        });
      });
    };

    _this._onCancel = function () {
      _this.props.dispatch((0, _library.hideImportModal)());
    };

    _this._onNext = function () {
      _this.setState({
        act: LibraryImportModal.SHOW_IMPORT_MODAL
      });
    };

    _this._onClickType = function (type) {
      _this.setState({
        type: type
      });
    };

    _this.state = {
      act: LibraryImportModal.SHOW_IMPORT_MODAL,
      type: 'modify'
    };
    return _this;
  }

  (0, _createClass3.default)(LibraryImportModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.props.show) {
        this.setState({
          act: LibraryImportModal.SELECT_TYPE,
          type: 'modify'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var replace = this.state.type === 'replace';
      var modify = this.state.type === 'modify';

      return React.createElement(_ImportModal3.default, {
        validate: validateValueStock,
        dispatch: this.props.dispatch,
        templateImportUrl: _constants.V1_IMPORT_LIBRARY_TEMPLATE,
        temporaryImportUrl: _constants.V1_IMPORT_LIBRARY_TEMPORARY,
        importUrl: _constants.V1_IMPORT_LIBRARY + '?replace=' + replace + '&modify=' + modify,
        namespace: 'libraries',
        onCancel: this._onCancel,
        className: 'library-import-modal',
        onBack: function onBack() {
          _this2.setState({ act: LibraryImportModal.SELECT_TYPE });
        },
        show: this.props.show,
        afterSuccessCallback: function afterSuccessCallback() {
          _this2.props.dispatch((0, _library.onSuccessImport)());
        },
        onErrorCallback: function onErrorCallback(errors) {
          _this2.props.dispatch(actNotif.error(errors[0]));
        },
        templatePrefix: 'Ingredients - ',
        body: this._body(),
        header: this._header(),
        footer: this._footer(),
        filterNamespace: 'items',
        csvHeaders: ['Internal ID (DO NOT EDIT)', 'Name', 'Category', 'In Stock (DO NOT EDIT)', 'Unit', 'Alert', 'Stock Alert'],
        confirmImportBody: this._confirmImportBody(),
        confirmImportHeader: this._confirmImportHeader(),
        confirmPromiseFunction: this._confirmFunction
      });
    }

    /**
     * return true if ingredients have recipe, it means user must confirm all ingredient must be deleted first
     * @return {Promise}
     * @private
     */

  }]);
  return LibraryImportModal;
}(_ImportModal3.default);

LibraryImportModal.SELECT_TYPE = 'select_type';
LibraryImportModal.SHOW_IMPORT_MODAL = 'show_import_modal';


function validateValueStock(resultOBject) {
  var valueStockCell = 6;

  for (var i = 1; i <= resultOBject.length - 1; i++) {
    if (resultOBject[i].length < 7) {
      return [{ cell: resultOBject[i][valueStockCell], message: 'invalid format' }];
    }
    var splitedValueStock = resultOBject[i][valueStockCell].split('.');
    if (splitedValueStock.length > 1 && splitedValueStock[1].length > 2) {
      return [{ cell: resultOBject[i][valueStockCell], message: 'max two digits behind the decimal' }];
    }
  }
}

exports.default = LibraryImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(2111);

var _List2 = _interopRequireDefault(_List);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _reduxForm = __webpack_require__(7);

var _library = __webpack_require__(93);

var actIngredientLibrary = _interopRequireWildcard(_library);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (library) {
      var isDirtyItem = _this.props.isDirtyItem;

      if (isDirtyItem) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actIngredientLibrary.onClickRow(library)));
      } else {
        _this.props.dispatch(actIngredientLibrary.onClickRow(library));
      }
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          libraries = _this$props.libraries,
          filterState = _this$props.filterState;

      dispatch(actIngredientLibrary.librariesRequest({ page: currentPage + 1, filterState: filterState }, libraries));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._stockAlertFormatter = function (ingredient) {
      var result = { status: '', color: '' };
      if (ingredient.stock_alert >= ingredient.in_stock && ingredient.in_stock > 0 && ingredient.alert) {
        result = { status: 'Low', className: 'low-stock' };
      } else if (ingredient.in_stock <= 0 && ingredient.alert) {
        result = { status: 'Out', className: 'out-stock' };
      }
      return React.createElement(
        'span',
        { className: result.className },
        result.status
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          libraries = _props.libraries,
          libraryDetail = _props.libraryDetail;


      return React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        libraries.length > 0 && React.createElement(
          'div',
          { className: _List2.default['full-height'] },
          React.createElement(
            'div',
            { className: _List2.default['leftcol'] + ' no-padding', id: 'mk-col-left' },
            React.createElement(
              'table',
              { className: _List2.default['table-header'] },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'th',
                    { className: _List2.default.headerName + ' text-left' },
                    'Name'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerCategory + ' text-left' },
                    'Category'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerInStock + ' text-left' },
                    'In Stock'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerUnit + ' text-left' },
                    'Unit'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerStockAlert + ' text-center' },
                    'Stock Alert'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: _List2.default['table-content-wrapper'] },
              React.createElement(
                _reactInfiniteScroller2.default,
                {
                  pageStart: 1,
                  loadMore: this._onReachBottom,
                  hasMore: this._hasMore(),
                  useWindow: false,
                  threshold: 10,
                  initialLoad: false },
                React.createElement(
                  'table',
                  { className: _List2.default['table-content'] },
                  React.createElement(
                    'tbody',
                    null,
                    libraries.length > 0 && libraries.map(function (library) {
                      return React.createElement(
                        'tr',
                        { className: '' + (libraryDetail && libraryDetail.id === library.id ? _List2.default.selected : ''),
                          onClick: function onClick() {
                            return _this2._onClickRow(library);
                          } },
                        React.createElement(
                          'td',
                          { className: _List2.default.headerName },
                          library.name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerCategory },
                          library.category_name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerInStock },
                          library.in_stock
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerUnit },
                          library.unit_name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerStockAlert },
                          _this2._stockAlertFormatter(library)
                        )
                      );
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      libraries = _state$ingredients$li.libraries,
      libraryDetail = _state$ingredients$li.libraryDetail,
      currentPage = _state$ingredients$li.currentPage,
      totalPage = _state$ingredients$li.totalPage,
      showDetail = _state$ingredients$li.showDetail,
      filterState = _state$ingredients$li.filterState;

  return {
    libraries: libraries,
    libraryDetail: libraryDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showDetail: showDetail,
    isDirtyItem: (0, _reduxForm.isDirty)('library')(state),
    filterState: filterState
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  libraries: React.PropTypes.array,
  libraryDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  showDetail: React.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _SaveToAllOutletsModal = __webpack_require__(2112);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _library = __webpack_require__(93);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveToAllOutletsModal = function (_React$Component) {
  (0, _inherits3.default)(SaveToAllOutletsModal, _React$Component);

  function SaveToAllOutletsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SaveToAllOutletsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SaveToAllOutletsModal.__proto__ || (0, _getPrototypeOf2.default)(SaveToAllOutletsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDone = function () {
      _this.props.dispatch((0, _library.hideSaveToAllOutletsModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SaveToAllOutletsModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showSaveToAllOutletsModal = _props.showSaveToAllOutletsModal,
          createdOutlets = _props.createdOutlets;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showSaveToAllOutletsModal, backdrop: 'static', onHide: this._onClickDone, dialogClassName: 'modal-dialog ' + _SaveToAllOutletsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Save to All Outlets' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            { className: _SaveToAllOutletsModal2.default['sub-title'] },
            'Ingredient successfully saved to:'
          ),
          createdOutlets && createdOutlets.outletsSuccess.map(function (outlet) {
            return React.createElement(
              'div',
              { className: _SaveToAllOutletsModal2.default['block-outlets'] },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-md-11' },
                  outlet.name
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-1' },
                  React.createElement('i', { className: 'fa fa-check-circle' })
                )
              )
            );
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          createdOutlets && createdOutlets.outletsFailed.length > 0 && React.createElement(
            'span',
            { className: _SaveToAllOutletsModal2.default['failed-all-outlets'] },
            'Ingredient failed to be saved on one or several outlets. There may be one or more conflict in your ingredient attributes (Ingredient name and unit)'
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickDone },
              'Done'
            )
          )
        )
      );
    }
  }]);
  return SaveToAllOutletsModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$li = state.ingredients.library,
      showSaveToAllOutletsModal = _state$ingredients$li.showSaveToAllOutletsModal,
      createdOutlets = _state$ingredients$li.createdOutlets;

  return {
    showSaveToAllOutletsModal: showSaveToAllOutletsModal,
    createdOutlets: createdOutlets
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SaveToAllOutletsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _pages = __webpack_require__(38);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _recipes = __webpack_require__(125);

var _confirmAction = __webpack_require__(29);

var _ActionBar = __webpack_require__(2113);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickExport = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          search = _this$props.search;

      var prefix = 'Recipes - ';
      dispatch((0, _recipes.exportRecipes)({ keyword: search.search }, prefix, search.outletIds[0]));
    }, _this._onClickCreateRecipes = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          search = _this$props2.search,
          isDirtyForm = _this$props2.isDirtyForm;
      var outletIds = search.outletIds;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _recipes.onClickCreateRecipes)(outletIds[0])));
      } else {
        dispatch((0, _recipes.onClickCreateRecipes)(outletIds[0]));
      }
    }, _this._onChangeFilterKeyword = function (event, search) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.setFilterRecipes)(search));
    }, _this._onChangeOutletIds = function (outletIds) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          isDirtyForm = _this$props3.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _recipes.onChangeOutletIds)(outletIds)));
      } else {
        dispatch((0, _recipes.onChangeOutletIds)(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-8 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline ' + _ActionBar2.default['action-bar'], onSubmit: function onSubmit(e) {
                e.preventDefault();
              } },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutletIds,
                allOutletOption: false
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'search',
                component: _SearchBar2.default,
                placeholder: 'Search',
                onChange: this._onChangeFilterKeyword
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { onClick: this._onClickExport, className: 'btn btn-primary ml-10px' },
              'Export'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ml-10px', onClick: this._onClickCreateRecipes },
              'Create Recipe'
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

ActionBar.NAMESPACE_OPTIONS = [{
  id: 'recipes', name: 'recipes'
}];


var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      outlets = _state$ingredients$re.outlets,
      showImportModal = _state$ingredients$re.showImportModal;

  return {
    outlets: outlets,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('recipes')(state),
    showImportModal: showImportModal
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2114);

var _List2 = _interopRequireDefault(_List);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _recipes = __webpack_require__(125);

var _reduxForm = __webpack_require__(7);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _confirmAction = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._renderRecipesHeader = function () {
      return React.createElement(
        'thead',
        null,
        React.createElement(
          'tr',
          null,
          React.createElement(
            'th',
            null,
            'Item name'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Variant'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Ingredient'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Ingredient Stock Alert'
          )
        )
      );
    }, _this._renderRecipesTable = function () {
      var _this$props = _this.props,
          recipes = _this$props.recipes,
          recipesDetail = _this$props.recipesDetail;


      return React.createElement(
        'tbody',
        null,
        recipes.map(function (recipe) {
          var className = '' + (recipesDetail && recipesDetail.id === recipe.id ? _List2.default.selected : '');
          var stockAlerts = _this._stockAlertFormatter(recipe.recipe_ingredients);
          return React.createElement(
            'tr',
            { onClick: function onClick() {
                _this._onClickRowRecipes(recipe);
              }, className: className },
            React.createElement(
              'td',
              null,
              recipe.item_name
            ),
            React.createElement(
              'td',
              { className: 'text-center' },
              recipe.item_variant_name
            ),
            React.createElement(
              'td',
              { className: 'text-center' },
              (recipe.recipe_ingredients && recipe.recipe_ingredients.length) + ' ingredients'
            ),
            React.createElement(
              'td',
              { className: 'text-center' },
              stockAlerts && stockAlerts.map(function (stockAlert, index) {
                return React.createElement(
                  'span',
                  null,
                  React.createElement(
                    'span',
                    { className: '' + stockAlert.className },
                    stockAlert.content
                  ),
                  index === 0 && stockAlerts.length > 1 ? ', ' : ''
                );
              })
            )
          );
        })
      );
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          currentPage = _this$props3.currentPage,
          recipes = _this$props3.recipes,
          search = _this$props3.search.search;

      var params = {
        page: currentPage + 1,
        keyword: search
      };
      dispatch((0, _recipes.recipesRequest)(params, recipes));
    }, _this._itemNameRecipes = function (recipes) {
      // check apakah semua itemnya sama
      var itemIds = _lodash2.default.countBy(recipes.history_details, 'item_id');
      if ((0, _keys2.default)(itemIds).length > 1) {
        return recipes.history_details.length + ' items';
      } else {
        if (!recipes.history_details[0].item_variant_name) {
          return '' + recipes.history_details[0].item_name;
        } else {
          return recipes.history_details[0].item_name + ' (' + recipes.history_details.length + ' variants)';
        }
      }
    }, _this._onClickRowRecipes = function (recipes) {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          isDirtyForm = _this$props4.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _recipes.onClickRow)(recipes)));
      } else {
        dispatch((0, _recipes.onClickRow)(recipes));
      }
    }, _this._hasData = function () {
      var recipes = _this.props.recipes;

      return recipes.length > 0;
    }, _this._stockAlertFormatter = function (ingredients) {
      if (ingredients && ingredients.length <= 0) return '';
      var lowStock = 0;
      var outStock = 0;
      var result = [];
      $.each(ingredients, function (i, ingredient) {
        if (ingredient.alert && ingredient.in_stock > 0 && ingredient.in_stock <= ingredient.stock_alert) lowStock += 1;
        if (ingredient.alert && ingredient.in_stock <= 0) outStock += 1;
      });
      if (lowStock > 0) {
        result.push({ content: lowStock + ' Low', className: 'stockAllertLow' });
      }
      if (outStock > 0) {
        result.push({ content: outStock + ' Out', className: 'stockAllertOut' });
      }
      return result;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      return this._hasData() && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          this._renderRecipesHeader()
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              this._renderRecipesTable()
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

List.INGREDIENTS = 'ingredients';
List.ITEMS = 'items';


function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      recipes = _state$ingredients$re.recipes,
      recipesDetail = _state$ingredients$re.recipesDetail,
      currentPage = _state$ingredients$re.currentPage,
      totalPage = _state$ingredients$re.totalPage,
      outlets = _state$ingredients$re.outlets;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    recipes: recipes,
    recipesDetail: recipesDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('recipes')(state),
    outlets: outlets
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1381);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1382);

var _List2 = _interopRequireDefault(_List);

var _recipes = __webpack_require__(125);

var _reactRedux = __webpack_require__(6);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _RecipesDetail = __webpack_require__(1385);

var _RecipesDetail2 = _interopRequireDefault(_RecipesDetail);

var _SaveToAllOutletsModal = __webpack_require__(1388);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

__webpack_require__(2115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recipes = function (_React$Component) {
  (0, _inherits3.default)(Recipes, _React$Component);

  function Recipes() {
    (0, _classCallCheck3.default)(this, Recipes);
    return (0, _possibleConstructorReturn3.default)(this, (Recipes.__proto__ || (0, _getPrototypeOf2.default)(Recipes)).apply(this, arguments));
  }

  (0, _createClass3.default)(Recipes, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          recipes = _props.recipes;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: recipes.length === 0,
              title: 'No Data To Display',
              description: '' }),
            !showLoadingSpinnerPage && React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_RecipesDetail2.default, null)
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_SaveToAllOutletsModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _recipes.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          var _props3 = _this2.props,
              isDirtyRecipes = _props3.isDirtyRecipes,
              nextAction = _props3.nextAction;

          if (isDirtyRecipes && !nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Recipes;
}(React.Component);

function mapStateToProps(state) {
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;
  var _state$ingredients$re = state.ingredients.recipes,
      openRightColumn = _state$ingredients$re.openRightColumn,
      recipes = _state$ingredients$re.recipes;

  return {
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
    isDirtyRecipes: (0, _reduxForm.isDirty)('recipes')(state),
    expired: expired,
    recipes: recipes
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Recipes);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _recipes = __webpack_require__(125);

var _AddItemsModal = __webpack_require__(2116);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

__webpack_require__(262);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

var _formatter = __webpack_require__(11);

var _SearchModal = __webpack_require__(293);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var normalizeNumber = function normalizeNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var previousValue = arguments[1];

  if (value === '') {
    return value;
  } else {
    if (!isNaN(value)) {
      return value;
    } else {
      return previousValue;
    }
  }
};

var validate = function validate(values, props) {
  var errors = {};
  var itemsErrors = [];
  if (values.items) {
    values.items.forEach(function (member, index) {
      var memberErrors = {};
      if (!member.quantity && '' + member.quantity !== '0') {
        memberErrors.quantity = 'Please enter a value';
        itemsErrors[index] = memberErrors;
      } else if (!_validator2.default.isNumeric(member.quantity + '')) {
        memberErrors.quantity = 'Please enter a valid Number';
        itemsErrors[index] = memberErrors;
      } else if (parseFloat(member.quantity) - 999999 > 0.000001) {
        memberErrors.quantity = 'Quantity must be less than 999999';
        itemsErrors[index] = memberErrors;
      }
    });
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors;
  }
  return errors;
};

var AddItemsModal = function (_React$Component) {
  (0, _inherits3.default)(AddItemsModal, _React$Component);

  function AddItemsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddItemsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddItemsModal.__proto__ || (0, _getPrototypeOf2.default)(AddItemsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values, e) {
      var _this$props = _this.props,
          ingredient = _this$props.addIngredients.ingredient,
          dispatch = _this$props.dispatch,
          recipesForm = _this$props.recipesForm;
      // kalo gak ada item yang diselect, don't do anything

      if (ingredient) {
        dispatch((0, _recipes.addIngredientRecipesDetail)(values, recipesForm));
      }
      e.preventDefault();
      e.stopPropagation();
    }, _this._onOpen = function () {
      _this.props.dispatch((0, _reduxForm.initialize)('addIngredients', {}));
    }, _this._onChangeSelect = function (dropdownVal) {
      var _this$props2 = _this.props,
          ingredients = _this$props2.addIngredients.ingredients,
          dispatch = _this$props2.dispatch,
          recipesForm = _this$props2.recipesForm;

      var selected = null;
      ingredients.results.forEach(function (i, index) {
        if (dropdownVal.value === i.id) {
          selected = ingredients.results[index];
        }
      });
      if (selected) {
        dispatch((0, _recipes.addIngredientsOnChangeSelectModal)(selected, recipesForm));
      }
    }, _this._onChangeKeyword = function (value) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.addIngredientsOnSearchModal)(value));
    }, _this._onSearchReachBottom = function () {
      var _this$props3 = _this.props,
          _this$props3$addIngre = _this$props3.addIngredients,
          _this$props3$addIngre2 = _this$props3$addIngre.ingredients,
          currentPage = _this$props3$addIngre2.currentPage,
          total = _this$props3$addIngre2.total_pages,
          results = _this$props3$addIngre2.results,
          keyword = _this$props3$addIngre.keyword,
          dispatch = _this$props3.dispatch;

      if (total > currentPage) {
        dispatch((0, _recipes.addIngredientsGetingredientRequest)({
          page: currentPage + 1,
          per_page: 100,
          no_categories: true,
          keyword: keyword,
          previousItems: results
        }));
      }
    }, _this._hasMore = function () {
      var _this$props$addIngred = _this.props.addIngredients.ingredients,
          currentPage = _this$props$addIngred.currentPage,
          totalPage = _this$props$addIngred.totalPage;

      return currentPage < totalPage;
    }, _this._onHide = function (event) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.cancelAddIngredientsModal)());
    }, _this._title = function () {
      return 'Add Ingredient';
    }, _this._selectPlaceholder = function () {
      return 'Search Ingredients';
    }, _this._renderIngredientFields = function () {
      var ingredient = _this.props.addIngredients.ingredient;

      return React.createElement(
        'div',
        { className: 'mk-grouped-list-input' },
        React.createElement(
          'div',
          { className: 'mk-grouped-input' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-3' },
            React.createElement(_reduxForm.Field, {
              name: 'ingredient_id',
              component: 'input',
              readOnly: true,
              className: 'form-control hidden',
              type: 'hidden',
              disabled: true
            }),
            React.createElement(_reduxForm.Field, {
              name: 'ingredient_name',
              component: 'input',
              className: 'form-control',
              placeholder: 'Ingredient Name',
              disabled: true
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group col-sm-3' },
            React.createElement(_reduxForm.Field, {
              component: _SettingField2.default,
              positiveNumberOnly: true,
              maxFractionDigits: 2,
              name: 'quantity',
              className: 'form-control',
              placeholder: '0.00',
              normalize: normalizeNumber,
              onChange: function onChange(event, value) {
                var quantity = parseFloat(value);
                quantity = !isNaN(quantity) ? quantity : null;
                _this.props.dispatch((0, _reduxForm.change)('addIngredients', 'quantity', quantity));
                if (ingredient && ingredient.track_cogs) {
                  _this.props.dispatch((0, _reduxForm.change)('addIngredients', 'ingredient_avg', ingredient.cogs * quantity));
                }
                return value;
              }
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group col-sm-3' },
            React.createElement(_reduxForm.Field, {
              name: 'unit_name',
              component: 'input',
              placeholder: 'Unit Name',
              className: 'form-control',
              disabled: true
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group col-sm-3' },
            React.createElement(_reduxForm.Field, {
              name: 'ingredient_avg',
              component: 'input',
              disabled: true,
              placeholder: ingredient && ingredient.track_cogs ? 'Rp. 0' : '',
              className: 'form-control',
              format: ingredient && ingredient.track_cogs ? function (value) {
                return (0, _formatter.currencyFormatter)(value);
              } : ''
              // prevent default behavior because this field will trigger reducer change on on the redux
              , onFocus: function onFocus(e) {
                e.preventDefault();
              },
              onBlur: function onBlur(e) {
                e.preventDefault();
              }
            })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AddItemsModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showAddItemsModal = _props.showAddItemsModal,
          addIngredients = _props.addIngredients,
          addIngredientsForm = _props.addIngredientsForm;

      var options = void 0;
      var disableBtn = void 0;
      if (!addIngredientsForm) {
        disableBtn = true;
      } else {
        if (addIngredientsForm.ingredient_id === undefined) {
          disableBtn = true;
        } else {
          disableBtn = false;
        }
      }
      if (addIngredients.ingredients.results) {
        options = addIngredients.ingredients.results.map(function (ingredient) {
          return { value: ingredient.id, label: ingredient.name };
        });
      } else {
        options = [];
      }
      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAddItemsModal, backdrop: 'static', dialogClassName: _AddItemsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: this._title() }),
        React.createElement(
          'form',
          { onSubmit: this._onSubmit.bind(this, addIngredientsForm) },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: _AddItemsModal2.default.modalBody },
            React.createElement(_reduxForm.Field, {
              component: _SearchModal2.default,
              type: 'text',
              name: 'search-item',
              placeholder: this._selectPlaceholder(),
              options: options,
              onClickItem: this._onChangeSelect,
              onInputChange: this._onChangeKeyword,
              inputValue: addIngredients.ingredient ? addIngredients.ingredient.id : null,
              onMenuScrollToBottom: this._onSearchReachBottom,
              isHasMore: this._hasMore,
              isLoading: addIngredients.isLoading
            }),
            React.createElement(
              'div',
              { className: 'mt-10px' },
              addIngredients.ingredient && React.createElement(
                'table',
                { className: _AddItemsModal2.default['table-header'] + ' table table-truncate' },
                React.createElement(
                  'thead',
                  null,
                  React.createElement(
                    'tr',
                    null,
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '25%' },
                      'Ingredient'
                    ),
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '25%' },
                      'Quantity'
                    ),
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '25%' },
                      'Unit'
                    ),
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '25%' },
                      'Avg Cost'
                    )
                  )
                ),
                React.createElement('tbody', null)
              ),
              addIngredients.ingredient && this._renderIngredientFields()
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: disableBtn ? 'btn ' + _AddItemsModal2.default['disableBtnAddItem'] : 'btn btn-primary', disabled: disableBtn, onClick: this._onSubmit.bind(this, addIngredientsForm) },
                'Add'
              )
            )
          )
        )
      );
    }
  }]);
  return AddItemsModal;
}(React.Component);

(0, _reduxForm.formValueSelector)('addIngredients');

function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      showAddItemsModal = _state$ingredients$re.showAddItemsModal,
      addIngredients = _state$ingredients$re.addIngredients,
      outlets = _state$ingredients$re.outlets;

  return {
    showAddItemsModal: showAddItemsModal,
    addIngredients: addIngredients,
    outlets: outlets,
    recipesForm: (0, _reduxForm.getFormValues)('recipes')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    addIngredientsForm: (0, _reduxForm.getFormValues)('addIngredients')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'addIngredients',
  validate: validate,
  touchOnBlur: false,
  touchOnChange: false,
  touchOnValidate: false
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddItemsModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _RecipesDetail = __webpack_require__(2117);

var _RecipesDetail2 = _interopRequireDefault(_RecipesDetail);

var _recipes = __webpack_require__(125);

var _RecipesForm = __webpack_require__(1387);

var _RecipesForm2 = _interopRequireDefault(_RecipesForm);

var _AddItemsModal = __webpack_require__(1384);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

var _reduxForm = __webpack_require__(7);

var _notifications = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipesDetail = function (_React$Component) {
  (0, _inherits3.default)(RecipesDetail, _React$Component);

  function RecipesDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RecipesDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RecipesDetail.__proto__ || (0, _getPrototypeOf2.default)(RecipesDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmitAddItems = function (addIngredientsFormValues) {
      var recipesForm = _this.props.recipesForm;

      _this.props.dispatch((0, _recipes.addIngredientsConfirmAddItems)(addIngredientsFormValues, recipesForm.recipes));
    }, _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          recipes = _this$props.recipes,
          itemsDropdowns = _this$props.itemsDropdowns,
          itemVariant = _this$props.itemVariant,
          search = _this$props.search,
          business = _this$props.business;
      var action = values.action,
          itemVariantTemp = values.itemVariantTemp;

      delete values.action;
      delete values.itemVariantTemp;
      var allVariantIsRecipes = _this._allVariantIsrecipes(itemVariantTemp);
      var varID = '' + values.item_variant_id;
      if (!values.id) {
        if (!values.item_id) {
          // when user not select a item
          dispatch((0, _notifications.error)('Please add Item.'));
        } else if (!values.recipe_ingredients.length) {
          // when user not add a ingredient
          dispatch((0, _notifications.error)('Please add Ingredients'));
        } else if (itemVariantTemp.length === 1 && itemVariantTemp[0].name === 'No Variant' && itemVariantTemp[0].is_recipe) {
          // when item is an recipe
          dispatch((0, _notifications.error)('This item has been used for recipe.'));
        } else if ((!values.item_variant_id || values.item_variant_id === 'Variant Option') && allVariantIsRecipes && itemVariantTemp[0].name !== 'No Variant') {
          // when all item variant is an recipe
          dispatch((0, _notifications.error)('All variants for this item has been used for recipe.'));
        } else if ((!values.item_variant_id || values.item_variant_id === 'Variant Option') && !allVariantIsRecipes && itemVariantTemp[0].name !== 'No Variant') {
          // when user not select an item variant
          dispatch((0, _notifications.error)('Please add item variant.'));
        } else {
          if (!values.item_variant_id) {
            values.item_variant_id = itemVariantTemp[0].value;
          }
          if (itemVariant.length === 1) {
            values.sku = itemVariant[0].sku;
          } else {
            itemVariant.forEach(function (iv) {
              var ivID = '' + iv.value;
              console.log(ivID === varID);
              if (ivID === varID) {
                values.sku = iv.sku;
              }
            });
          }
          // force value to update item_name because redux-form won't update its form reducers
          itemsDropdowns.forEach(function (item) {
            if (item.id === values.item_id) values.item_name = item.label;
          });

          if (action === 'save') {
            dispatch((0, _recipes.onSaveRecipes)(values, recipes));
          } else if (action === 'save_to_all_outlet') {
            if (values.item_variant_name === null) {
              values.item_variant_name = '';
            }
            values.recipe_ingredients.map(function (recipe) {
              recipe.id = recipe.ingredient_id;
            });
            dispatch((0, _recipes.onSaveRecipesAllOutlet)(values, recipes));
          }
        }
      } else {
        if (!values.item_variant_id) {
          values.item_variant_id = itemVariantTemp[0].value;
        }
        if (!values.recipe_ingredients.length) {
          // when user not add a ingredient
          dispatch((0, _notifications.error)('Please add Ingredients'));
        } else {
          values.outlet_id = search.outletIds[0];
          values.business_id = business.id;
          if (action === 'update') {
            dispatch((0, _recipes.onUpdateRecipes)(values, recipes));
          } else if (action === 'update_to_all_outlet') {
            if (values.item_variant_name === 'No Variant') {
              values.item_variant_name = '';
            }
            dispatch((0, _recipes.onUpdateRecipesAllOutlet)(values, recipes));
          }
        }
      }
    }, _this._allVariantIsrecipes = function (itemVariant) {
      var result = true;
      if (itemVariant.length > 1) {
        itemVariant.map(function (item) {
          if (!item.is_recipe && item.value !== 'Variant Option') {
            result = false;
          }
        });
      }
      return result;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RecipesDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _RecipesDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _RecipesDetail2.default['form-wrapper'] },
          React.createElement(_RecipesForm2.default, { onSubmit: this._onSubmit }),
          React.createElement(_AddItemsModal2.default, { onSubmit: this._onSubmitAddItems })
        )
      );
    }
  }]);
  return RecipesDetail;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      recipes = _state$ingredients$re.recipes,
      recipesDetail = _state$ingredients$re.recipesDetail,
      showAddItemsModal = _state$ingredients$re.showAddItemsModal,
      ingredientRecipesDetail = _state$ingredients$re.ingredientRecipesDetail,
      itemsDropdowns = _state$ingredients$re.itemsDropdowns,
      itemVariant = _state$ingredients$re.itemVariant;
  var business = state.moka.user.business;

  return {
    recipes: recipes,
    recipesDetail: recipesDetail,
    showAddItemsModal: showAddItemsModal,
    ingredientRecipesDetail: ingredientRecipesDetail,
    itemVariant: itemVariant,
    recipesForm: (0, _reduxForm.getFormValues)('recipes')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    business: business,
    itemsDropdowns: itemsDropdowns
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RecipesDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _recipes = __webpack_require__(125);

var _ConfirmSubmitModal = __webpack_require__(2118);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmSubmitModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmSubmitModal, _React$Component);

  function ConfirmSubmitModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmSubmitModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmSubmitModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmSubmitModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.hideConfirmSubmitModal)());
    }, _this._onClickCreate = function () {
      var _this$props = _this.props,
          recipesForm = _this$props.recipesForm,
          dispatch = _this$props.dispatch,
          date = _this$props.search.date;

      var namespace = _this._namespace();
      dispatch((0, _recipes.confirmSubmit)(recipesForm, namespace, date));
    }, _this._namespace = function () {
      var search = _this.props.search;

      if (search) {
        return search.namespace;
      } else {
        return '';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmSubmitModal, [{
    key: 'render',
    value: function render() {
      var showConfirmSubmitModal = this.props.showConfirmSubmitModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showConfirmSubmitModal, dialogClassName: _ConfirmSubmitModal2.default['modal-dialog'] },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmSubmitModal2.default['modal-header'] },
          'Information'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Do you want to save the recipes? You will not be able to modify after changes are made.'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { type: 'button', onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary',
              onClick: this._onClickCreate
            },
            'Create'
          )
        )
      );
    }
  }]);
  return ConfirmSubmitModal;
}(React.Component);

function mapStateToProps(state) {
  var showConfirmSubmitModal = state.ingredients.recipes.showConfirmSubmitModal;

  return {
    recipesForm: (0, _reduxForm.getFormValues)('recipes')(state),
    showConfirmSubmitModal: showConfirmSubmitModal,
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmSubmitModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _RecipesForm = __webpack_require__(2119);

var _RecipesForm2 = _interopRequireDefault(_RecipesForm);

var _reactRouter = __webpack_require__(15);

var _recipes = __webpack_require__(125);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _ConfirmSubmitModal = __webpack_require__(1386);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

var _reactSelect = __webpack_require__(145);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var recipesErrors = [];
  if (values.recipe_ingredients) {
    values.recipe_ingredients.forEach(function (member, index) {
      var memberErrors = {};
      if (!member.quantity && '' + member.quantity !== '0') {
        memberErrors.quantity = 'The quantity is required';
        recipesErrors[index] = memberErrors;
      } else if (member.quantity > 999999) {
        memberErrors.quantity = 'Quantity must be less than 999999';
        recipesErrors[index] = memberErrors;
      } else if (parseFloat(member.quantity) < 0.01) {
        memberErrors.quantity = 'Quantity must be greater than 0.01';
        recipesErrors[index] = memberErrors;
      }
    });
  }
  if (recipesErrors.length) {
    errors.recipe_ingredients = recipesErrors;
  }
  return errors;
};

var normalizeNumber = function normalizeNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var previousValue = arguments[1];

  if (value === '') {
    return value;
  } else {
    if (!isNaN(value)) {
      return value;
    } else {
      return previousValue;
    }
  }
};

var renderFieldArrayIngredients = function renderFieldArrayIngredients(_ref) {
  var fields = _ref.fields,
      dispatch = _ref.dispatch,
      recipeIngredients = _ref.recipeIngredients;

  var doms = [];
  fields.map(function (member, index, field) {
    var cogsTracked = recipeIngredients.length && recipeIngredients[index].track_cogs;
    doms.push(React.createElement(
      'div',
      { className: 'col-md-12 ' + _RecipesForm2.default['box-ingredient-recipes'] },
      React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-3' },
          React.createElement(_reduxForm.Field, {
            name: 'ingredient_id',
            component: 'input',
            readOnly: true,
            className: 'form-control hidden',
            type: 'hidden',
            disabled: true
          }),
          React.createElement(_reduxForm.Field, {
            name: member + '.ingredient_name',
            component: 'input',
            readOnly: true,
            className: 'form-control ' + _RecipesForm2.default.grey_box,
            disabled: true
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-3' },
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            positiveNumberOnly: true,
            maxFractionDigits: 2,
            className: 'form-control',
            name: member + '.quantity',
            placeholder: '0.00',
            normalize: normalizeNumber,
            onChange: function onChange(event, value) {
              var quantity = parseFloat(value);
              quantity = !isNaN(quantity) ? quantity : null;
              dispatch((0, _reduxForm.change)('recipes', member + '.quantity', quantity));
              if (cogsTracked) {
                dispatch((0, _reduxForm.change)('recipes', member + '.ingredient_avg', recipeIngredients[index].cogs * quantity));
              }
              return value;
            }
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-3' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'form-control ' + _RecipesForm2.default.grey_box,
            name: member + '.unit_name',
            disabled: true,
            placeholder: 'Unit Name'
          }),
          React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'form-control ' + _RecipesForm2.default.grey_box,
            name: member + '.unit_id',
            placeholder: 'unit',
            disabled: true,
            type: 'hidden'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-3' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'form-control ' + _RecipesForm2.default.grey_box,
            name: member + '.ingredient_avg',
            disabled: true,
            placeholder: cogsTracked ? 'Rp. 0' : '',
            format: function format(value) {
              return cogsTracked ? (0, _formatter.currencyFormatter)(value) : '';
            }
          }),
          React.createElement(
            'span',
            { onClick: function onClick() {
                fields.remove(index);
              }, className: _RecipesForm2.default['btn-delete-wrapper'] },
            React.createElement('i', { className: 'fa fa-times-circle' })
          )
        )
      )
    ));
  });
  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input ' + _RecipesForm2.default['recipes-item-wrapper'] },
    fields.length ? React.createElement(
      'div',
      { className: 'col-md-12' },
      React.createElement(
        'div',
        { className: 'col-md-3 text-center ' + _RecipesForm2.default.recipes_header },
        'Ingredient'
      ),
      React.createElement(
        'div',
        { className: 'col-md-3 text-center ' + _RecipesForm2.default.recipes_header },
        'Quantity'
      ),
      React.createElement(
        'div',
        { className: 'col-md-3 text-center ' + _RecipesForm2.default.recipes_header },
        'Unit'
      ),
      React.createElement(
        'div',
        { className: 'col-md-3 text-center ' + _RecipesForm2.default.recipes_header },
        'Avg Cost'
      )
    ) : '',
    doms,
    fields.length ? React.createElement(
      'div',
      { className: 'col-md-12 mt-20px' },
      React.createElement(
        'div',
        { className: 'col-md-9 text-left no-padding' },
        'TOTAL AVG COST'
      ),
      React.createElement(
        'div',
        { className: 'col-md-3 text-left ' + _RecipesForm2.default.padding_left_avg_cost },
        (0, _formatter.currencyFormatter)(totalAvgCost(recipeIngredients))
      )
    ) : ''
  );

  function totalAvgCost(recipeIngredients) {
    var total = 0;
    recipeIngredients.forEach(function (ing) {
      if (ing.ingredient_avg) {
        total += ing.ingredient_avg;
      }
    });
    return total;
  }
};

var formatIngredientInStock = function formatIngredientInStock(_ref2) {
  var value = _ref2.input.value,
      dispatch = _ref2.meta.dispatch,
      placeholder = _ref2.placeholder,
      options = _ref2.options,
      units = _ref2.units,
      className = _ref2.className;

  return React.createElement('input', {
    value: value,
    className: className ? 'form-control ' + className.className : 'form-control',
    placeholder: placeholder,
    disabled: true
  });
};

var renderFieldArrayInventory = function renderFieldArrayInventory(_ref3) {
  var fields = _ref3.fields,
      recipeIngredients = _ref3.recipeIngredients;

  var doms = [];
  var lowStock = 0;
  var outStock = 0;
  var result = [];
  $.each(recipeIngredients, function (i, ingredient) {
    lowStock = 0;
    outStock = 0;
    if (ingredient.alert && ingredient.in_stock > 0 && ingredient.in_stock <= ingredient.stock_alert) lowStock += 1;
    if (ingredient.alert && ingredient.in_stock <= 0) outStock += 1;
    if (lowStock > 0) {
      result.push({ className: 'stockAllertLow' });
    } else if (outStock > 0) {
      result.push({ className: 'stockAllertOut' });
    } else {
      result.push({ className: '' });
    }
  });
  fields.map(function (member, index, field) {
    doms.push(React.createElement(
      'div',
      { className: 'col-md-12 ' + _RecipesForm2.default['box-ingredient-recipes'] },
      React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'form-control',
            name: member + '.ingredient_name',
            disabled: true,
            placeholder: 'Name'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: formatIngredientInStock,
            className: result[index],
            name: member + '.in_stock',
            placeholder: '0'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            className: 'form-control',
            name: member + '.unit_name',
            disabled: true,
            placeholder: 'Unit Name'
          })
        )
      )
    ));
  });
  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input ' + _RecipesForm2.default['recipes-item-wrapper'] },
    fields.length ? React.createElement(
      'div',
      { className: 'col-md-12' },
      React.createElement(_LabelSection2.default, { title: 'INVENTORY' }),
      React.createElement('div', { className: 'col-md-4 text-center ' + _RecipesForm2.default.recipes_header }),
      React.createElement(
        'div',
        { className: 'col-md-4 text-left ' + _RecipesForm2.default.recipes_header },
        'In Stock'
      ),
      React.createElement('div', { className: 'col-md-4 text-center ' + _RecipesForm2.default.recipes_header })
    ) : '',
    doms
  );
};

var renderSelectFieldWithoutCreate = function renderSelectFieldWithoutCreate(_ref4) {
  var _ref4$input = _ref4.input,
      value = _ref4$input.value,
      onChange = _ref4$input.onChange,
      disabled = _ref4$input.disabled,
      dispatch = _ref4.meta.dispatch,
      placeholder = _ref4.placeholder,
      options = _ref4.options;

  var onChangeSelect = function onChangeSelect(newval) {
    onChange(newval.value);
  };
  return React.createElement(_reactSelect2.default, {
    value: value,
    name: 'itemsDropdownObj',
    className: 'itemsDropdownObj',
    placeholder: placeholder,
    onChange: onChangeSelect,
    options: options,
    clearable: false,
    disabled: disabled
  });
};

var RecipesForm = function (_React$Component) {
  (0, _inherits3.default)(RecipesForm, _React$Component);

  function RecipesForm() {
    var _ref5;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RecipesForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref5 = RecipesForm.__proto__ || (0, _getPrototypeOf2.default)(RecipesForm)).call.apply(_ref5, [this].concat(args))), _this), _this._onClickCancel = function () {
      _this.props.dispatch((0, _recipes.recipesFormOnClickCancel)());
    }, _this._onChangeVariant = function (itemVariant, e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          recipesForm = _this$props.recipesForm;

      (0, _reduxForm.change)('recipes', 'item_variant_id', e.target.value);
      if (e.target.value === 'Variant Option' || e.target.value === 'No Variant') {
        dispatch((0, _recipes.unSetIngredientByItemVariant)());
      } else {
        var flagRecipe = { items: [], isRecipe: false };
        itemVariant.map(function (item) {
          if (item.is_recipe) {
            flagRecipe.isRecipe = true;
            flagRecipe.items.push(item);
          }
        });
        if (flagRecipe.isRecipe && flagRecipe.items.length) {
          dispatch((0, _recipes.setIngredientByItemVariant)(flagRecipe.items[flagRecipe.items.length - 1], recipesForm, e.target.value));
        }
      }
    }, _this._onChangeItemId = function (event, outletId) {
      _this.props.dispatch((0, _recipes.recipesFormOnChangeOutlet)(outletId));
    }, _this._onClickAddIngredients = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var recipesForm = _this.props.recipesForm;

      _this.props.dispatch((0, _recipes.onClickAddIngredients)(recipesForm.outlet_id));
    }, _this._onChangeSelectDropdown = function (val, dropdownVal) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          itemsDropdowns = _this$props2.itemsDropdowns,
          recipesForm = _this$props2.recipesForm;

      var selected = null;
      itemsDropdowns.forEach(function (item, index) {
        if (dropdownVal === item.value) {
          selected = itemsDropdowns[index];
        }
      });
      if (selected) {
        (0, _reduxForm.change)('recipes', 'item_name', selected.label);
        dispatch((0, _recipes.addItemVariantOnChangeItems)(selected, recipesForm));
      }
    }, _this._onChangeKeywordDropdown = function (value) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          recipesForm = _this$props3.recipesForm;

      dispatch((0, _recipes.addIngredientsOnSearch)(value, recipesForm.itemsDropdownObj));
    }, _this._onClickDelete = function (e) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.showDeleteModal)());
      e.preventDefault();
      e.stopPropagation();
    }, _this._onHideDeleteModal = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _recipes.hideDeleteModal)());
    }, _this._confirmDelete = function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          recipesDetail = _this$props4.recipesDetail,
          recipes = _this$props4.recipes;

      dispatch((0, _recipes.deleteRecipes)(recipesDetail, recipes));
    }, _this._onSubmitCreateAllOutlet = function (values) {
      var itemVariant = _this.props.itemVariant;

      values.itemVariantTemp = itemVariant;

      if (!values.item_name) {
        if (values.item_id) {
          var itemDropdownObj = _this._findItemDropdownById(values.item_id);
          values.item_name = itemDropdownObj.name;
        } else {
          values.item_name = null;
        }
      }
      if (!values.item_variant_name && values.item_variant_id && values.item_variant_id !== 'No Variant' && values.item_variant_id !== 'Variant Option') {
        var itemVariantObj = _this._findItemVariantById(values.item_variant_id);
        values.item_variant_name = itemVariantObj.name;
        values.sku = itemVariantObj.sku;
      }
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: values.id ? 'update_to_all_outlet' : 'save_to_all_outlet' }));
    }, _this._onSubmitSave = function (values) {
      var itemVariant = _this.props.itemVariant;

      values.itemVariantTemp = itemVariant;
      if (!values.item_name) {
        if (values.item_id) {
          var itemDropdownObj = _this._findItemDropdownById(values.item_id);
          values.item_name = itemDropdownObj.name;
        } else {
          values.item_name = null;
        }
      }
      if (!values.item_variant_name && values.item_variant_id && values.item_variant_id !== 'No Variant' && values.item_variant_id !== 'Variant Option') {
        var itemVariantObj = _this._findItemVariantById(values.item_variant_id);
        values.item_variant_name = itemVariantObj.name;
      }
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: values.id ? 'update' : 'save' }));
    }, _this._findItemDropdownById = function (id) {
      var itemsDropdowns = _this.props.itemsDropdowns;

      return itemsDropdowns.find(function (itemDropdown) {
        if (itemDropdown.id === id) {
          return itemDropdown;
        }
      });
    }, _this._findItemVariantById = function (id) {
      var itemVariant = _this.props.itemVariant;

      return itemVariant.find(function (item) {
        if ((0, _stringify2.default)(item.value) === id) {
          return item;
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RecipesForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          itemsDropdowns = _props.itemsDropdowns,
          itemVariant = _props.itemVariant,
          recipesDetail = _props.recipesDetail,
          recipesForm = _props.recipesForm,
          showDeleteModal = _props.showDeleteModal,
          handleSubmit = _props.handleSubmit,
          isSubmittingForm = _props.isSubmittingForm,
          outlets = _props.outlets;

      return React.createElement(
        'form',
        { className: _RecipesForm2.default.wrapper, onSubmit: handleSubmit },
        React.createElement(
          'div',
          { className: _RecipesForm2.default['form-content'] },
          React.createElement(_LabelSection2.default, { title: 'CHOOSE ITEM' }),
          React.createElement(_reduxForm.Field, {
            name: 'id',
            component: 'input',
            readOnly: true,
            className: 'form-control hidden',
            type: 'hidden',
            disabled: true
          }),
          React.createElement(_reduxForm.Field, {
            name: 'sku',
            component: 'input',
            readOnly: true,
            className: 'form-control hidden',
            type: 'hidden',
            disabled: true
          }),
          React.createElement(
            'div',
            { className: 'form-group' },
            recipesDetail ? React.createElement(_reduxForm.Field, { name: 'item_name',
              component: 'input',
              disabled: true,
              className: 'form-control' }) : React.createElement(_reduxForm.Field, {
              component: renderSelectFieldWithoutCreate,
              className: 'item_id ' + (!recipesDetail && 'hidden'),
              name: 'item_id',
              options: itemsDropdowns,
              onChange: this._onChangeSelectDropdown,
              placeholder: 'Select an Item',
              clearable: false,
              disabled: recipesDetail && recipesDetail.id,
              hidden: !recipesDetail })
          ),
          React.createElement(_LabelSection2.default, { title: 'CHOOSE VARIANT' }),
          React.createElement(
            'div',
            { className: 'form-group' },
            recipesDetail ? React.createElement(
              'div',
              null,
              React.createElement(_reduxForm.Field, { name: 'item_variant_name',
                component: 'input',
                disabled: true,
                value: recipesDetail.item_variant_name,
                className: 'form-control' }),
              React.createElement(_reduxForm.Field, { name: 'item_variant_id',
                component: 'input',
                readOnly: true,
                className: 'form-control hidden',
                type: 'hidden',
                disabled: true,
                value: recipesDetail.item_variant_id })
            ) : React.createElement(
              _reduxForm.Field,
              {
                name: 'item_variant_id',
                component: 'select',
                onChange: this._onChangeVariant.bind(this, itemVariant),
                className: 'form-control item-variant-select',
                disabled: itemVariant && itemVariant.length <= 1 || recipesDetail && recipesDetail.id },
              itemVariant.map(function (item) {
                return React.createElement(
                  'option',
                  {
                    value: item.value,
                    hidden: recipesForm && item.value === 'Variant Option' && recipesForm.item_id,
                    disabled: item.isDisable,
                    selected: recipesForm && item.value === recipesForm.item_variant_id,
                    className: recipesForm && item.is_recipe && item.value !== recipesForm.item_variant_id && 'is_recipe' },
                  item.name
                );
              })
            )
          ),
          React.createElement(_LabelSection2.default, { title: 'RECIPE' }),
          recipesForm && React.createElement(
            'div',
            { className: 'mb-20px' },
            React.createElement(_reduxForm.FieldArray, {
              name: 'recipe_ingredients',
              component: renderFieldArrayIngredients,
              dispatch: this.props.dispatch,
              recipeIngredients: recipesForm.recipe_ingredients
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group' },
            React.createElement(
              'button',
              { className: 'btn btn-primary ' + _RecipesForm2.default['btn-addIngredients'],
                onClick: this._onClickAddIngredients },
              'Add Ingredient'
            )
          ),
          recipesDetail && React.createElement(
            'div',
            { className: 'mb-20px' },
            React.createElement(_reduxForm.FieldArray, {
              name: 'ingredientsInventory',
              component: renderFieldArrayInventory,
              recipeIngredients: recipesDetail && recipesDetail.recipe_ingredients
            })
          )
        ),
        React.createElement(
          'div',
          { className: _RecipesForm2.default['form-footer'] },
          recipesDetail && recipesDetail.id && React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-danger no-outline', onClick: this._onClickDelete, disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          recipesForm && React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              _reactRouter.Link,
              {
                className: 'btn btn-default ' + _RecipesForm2.default['btn-done'] + ' mr-10px',
                onClick: this._onClickCancel,
                disabled: isSubmittingForm
              },
              'Cancel'
            ),
            recipesForm && outlets && outlets.length > 1 && React.createElement(
              'button',
              {
                className: 'btn btn-primary no-outline',
                type: 'button',
                style: { 'margin-right': '10px' },
                onClick: handleSubmit(this._onSubmitCreateAllOutlet),
                disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            recipesForm && React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _RecipesForm2.default['btn-done'],
                onClick: handleSubmit(this._onSubmitSave),
                disabled: isSubmittingForm },
              'Save'
            )
          )
        ),
        recipesDetail && recipesDetail.id && React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: showDeleteModal,
          onHide: this._onHideDeleteModal,
          disableHideOnOuterModal: true,
          title: 'Recipe',
          name: !recipesDetail.item_variant_name ? recipesDetail.item_name : recipesDetail.item_name + ' - ' + recipesDetail.item_variant_name,
          onDelete: this._confirmDelete
        }),
        React.createElement(_ConfirmSubmitModal2.default, null)
      );
    }
  }]);
  return RecipesForm;
}(React.Component);

var mapForm = {
  form: 'recipes',
  touchOnBlur: true,
  touchOnChange: true,
  validate: validate
};

function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      recipes = _state$ingredients$re.recipes,
      showDeleteModal = _state$ingredients$re.showDeleteModal,
      recipesDetail = _state$ingredients$re.recipesDetail,
      outlets = _state$ingredients$re.outlets,
      showAddItemsModal = _state$ingredients$re.showAddItemsModal,
      addIngredientsButtonDisabledState = _state$ingredients$re.addIngredientsButtonDisabledState,
      itemsDropdowns = _state$ingredients$re.itemsDropdowns,
      itemVariant = _state$ingredients$re.itemVariant,
      addIngredients = _state$ingredients$re.addIngredients,
      isSubmittingForm = _state$ingredients$re.isSubmittingForm;

  return {
    recipes: recipes,
    showDeleteModal: showDeleteModal,
    outlets: outlets,
    recipesDetail: recipesDetail,
    itemVariant: itemVariant,
    showAddItemsModal: showAddItemsModal,
    itemsDropdowns: itemsDropdowns,
    addIngredientsButtonDisabledState: addIngredientsButtonDisabledState,
    search: (0, _reduxForm.getFormValues)('search')(state),
    recipesForm: (0, _reduxForm.getFormValues)('recipes')(state),
    addIngredients: addIngredients,
    isSubmittingForm: isSubmittingForm
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(RecipesForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _SaveToAllOutletsModal = __webpack_require__(2120);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _recipes = __webpack_require__(125);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveToAllOutletsModal = function (_React$Component) {
  (0, _inherits3.default)(SaveToAllOutletsModal, _React$Component);

  function SaveToAllOutletsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SaveToAllOutletsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SaveToAllOutletsModal.__proto__ || (0, _getPrototypeOf2.default)(SaveToAllOutletsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDone = function () {
      _this.props.dispatch((0, _recipes.hideSaveToAllOutletsModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SaveToAllOutletsModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showSaveToAllOutletsModal = _props.showSaveToAllOutletsModal,
          createdOutlets = _props.createdOutlets;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showSaveToAllOutletsModal, backdrop: 'static', onHide: this._onClickDone, dialogClassName: 'modal-dialog ' + _SaveToAllOutletsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Save to All Outlets' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            { className: _SaveToAllOutletsModal2.default['sub-title'] },
            'Recipe successfully saved to:'
          ),
          createdOutlets && createdOutlets.outletsSuccess.map(function (outlet) {
            return React.createElement(
              'div',
              { className: _SaveToAllOutletsModal2.default['block-outlets'] },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-md-11' },
                  outlet.name
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-1' },
                  React.createElement('i', { className: 'fa fa-check-circle' })
                )
              )
            );
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          createdOutlets && createdOutlets.outletsFailed.length > 0 && React.createElement(
            'span',
            { className: _SaveToAllOutletsModal2.default['failed-all-outlets'] },
            'Recipe failed to be saved on one or several outlets. There may be one or more conflict in your item attributes (item name, variant, category and SKU).'
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickDone },
              'Done'
            )
          )
        )
      );
    }
  }]);
  return SaveToAllOutletsModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$ingredients$re = state.ingredients.recipes,
      showSaveToAllOutletsModal = _state$ingredients$re.showSaveToAllOutletsModal,
      createdOutlets = _state$ingredients$re.createdOutlets;

  return {
    showSaveToAllOutletsModal: showSaveToAllOutletsModal,
    createdOutlets: createdOutlets
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SaveToAllOutletsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recipes = exports.Category = exports.Library = undefined;

var _Ingredient = __webpack_require__(1366);

var _Ingredient2 = _interopRequireDefault(_Ingredient);

var _Library = __webpack_require__(1368);

var _Library2 = _interopRequireDefault(_Library);

var _Category = __webpack_require__(1362);

var _Category2 = _interopRequireDefault(_Category);

var _Recipes = __webpack_require__(1383);

var _Recipes2 = _interopRequireDefault(_Recipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Library = _Library2.default;
exports.Category = _Category2.default;
exports.Recipes = _Recipes2.default;
exports.default = _Ingredient2.default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _pages = __webpack_require__(38);

var _reactBootstrap = __webpack_require__(10);

var _DropdownButtonSelectIcon = __webpack_require__(292);

var _DropdownButtonSelectIcon2 = _interopRequireDefault(_DropdownButtonSelectIcon);

var _adjustment = __webpack_require__(146);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _confirmAction = __webpack_require__(29);

var _ImportModal = __webpack_require__(439);

var _ImportModal2 = _interopRequireDefault(_ImportModal);

var _constants = __webpack_require__(626);

var _constants2 = __webpack_require__(625);

var _adjustment2 = __webpack_require__(650);

var mpInvAdjustment = _interopRequireWildcard(_adjustment2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar(props) {
    (0, _classCallCheck3.default)(this, ActionBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call(this, props));

    _this._importAfterSuccessCallback = function () {
      _this.props.dispatch((0, _adjustment.onSuccessImport)());
      var namespace = _this.props.search.namespace;

      mpInvAdjustment.inventoryAdjustmentImport({ namespace: namespace });
    };

    _this._importOnErrorCallback = function (errors, errorCode) {
      if (parseInt(errorCode / 100) === 5) {
        _this.props.dispatch((0, _adjustment.hideImportModal)());
      }
      _this.props.dispatch(actNotif.error(errors[0]));
      var namespace = _this.props.search.namespace;

      mpInvAdjustment.inventoryAdjustmentImport({ namespace: namespace });
    };

    _this._onClickImport = function () {
      _this.props.dispatch((0, _adjustment.showImportModal)());
    };

    _this._onClickExport = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          _this$props$search = _this$props.search,
          _this$props$search$da = _this$props$search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate,
          namespace = _this$props$search.namespace,
          outletIds = _this$props$search.outletIds;

      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = '';
      mpInvAdjustment.inventoryAdjustmentExport({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      if (namespace === 'items') {
        filename = 'Inventory Adjustment - ' + dateLabel;
        dispatch((0, _adjustment.exportAdjustment)({
          start: startDate.format('D/M/YYYY'),
          end: endDate.format('D/M/YYYY')
        }, filename, outletIds[0]));
      } else {
        filename = 'Ingredient Inventory Adjustment - ' + dateLabel;
        dispatch((0, _adjustment.exportIngredientAdjustment)({
          start: startDate.format('D/M/YYYY'),
          end: endDate.format('D/M/YYYY')
        }, filename, outletIds[0]));
      }
    };

    _this._onClickCreateAdjustment = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          search = _this$props2.search,
          isDirtyForm = _this$props2.isDirtyForm;
      var outletIds = search.outletIds;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onClickCreateAdjustment)(outletIds[0])));
      } else {
        dispatch((0, _adjustment.onClickCreateAdjustment)(outletIds[0]));
      }
    };

    _this._onChangeKeyword = function (event, keyword) {};

    _this._namespace = function () {
      var search = _this.props.search;

      if (search) {
        return search.namespace;
      } else {
        return '';
      }
    };

    _this._onChangeOutletIds = function (outletIds) {
      var _this$props3 = _this.props,
          _this$props3$search = _this$props3.search,
          _this$props3$search$d = _this$props3$search.date,
          startDate = _this$props3$search$d.startDate,
          endDate = _this$props3$search$d.endDate,
          namespace = _this$props3$search.namespace,
          dispatch = _this$props3.dispatch,
          isDirtyForm = _this$props3.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onChangeOutletIds)(outletIds, startDate, endDate, namespace)));
      } else {
        dispatch((0, _adjustment.onChangeOutletIds)(outletIds, startDate, endDate, namespace));
      }
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          isDirtyForm = _this$props4.isDirtyForm,
          _this$props4$search = _this$props4.search,
          namespace = _this$props4$search.namespace,
          outletIds = _this$props4$search.outletIds;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onChangeDate)(startDate, endDate, namespace, outletIds)));
      } else {
        dispatch((0, _adjustment.onChangeDate)(startDate, endDate, namespace, outletIds));
      }
    };

    _this._onChangeNamespace = function (event, namespace, previousNamespace) {
      // previousNamespace is reserved for mixpanel tracking
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          isDirtyForm = _this$props5.isDirtyForm,
          _this$props5$search = _this$props5.search,
          _this$props5$search$d = _this$props5$search.date,
          startDate = _this$props5$search$d.startDate,
          endDate = _this$props5$search$d.endDate,
          outletIds = _this$props5$search.outletIds,
          keyword = _this$props5.keyword;

      var params = {
        page: 1,
        start: startDate.format('D/M/Y'),
        end: endDate.format('D/M/Y'),
        keyword: keyword
      };
      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onChangeNamespace)(namespace, params, outletIds, startDate, endDate)));
      } else {
        dispatch((0, _adjustment.onChangeNamespace)(namespace, params, outletIds, startDate, endDate));
      }
    };

    _this.state = {
      showImportModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          outlets = _props.outlets,
          isDirtyForm = _props.isDirtyForm,
          isIngredientActive = _props.isIngredientActive,
          search = _props.search;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-8 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline' },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutletIds,
                allOutletOption: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                isDirtyForm: isDirtyForm,
                onDirtyFormCallback: this._onChangeDate,
                onChange: this._onChangeDate,
                updateServerOnChange: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownButtonSelectIcon2.default,
                name: 'namespace',
                options: ActionBar.NAMESPACE_OPTIONS,
                onChange: this._onChangeNamespace,
                isDirtyForm: isDirtyForm,
                onDirtyFormCallback: this._onChangeNamespace,
                disabled: !isIngredientActive
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              _reactBootstrap.DropdownButton,
              { title: 'Import / Export', bsStyle: 'primary' },
              React.createElement(
                _reactBootstrap.MenuItem,
                { onSelect: this._onClickImport },
                'Import Adjustment'
              ),
              React.createElement(_reactBootstrap.MenuItem, { divider: true }),
              React.createElement(
                _reactBootstrap.MenuItem,
                { onSelect: this._onClickExport },
                'Export Adjustment'
              )
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ml-10px', onClick: this._onClickCreateAdjustment },
              'Create Adjustment'
            )
          )
        ),
        this._namespace() === 'items' && React.createElement(_ImportModal2.default, {
          dispatch: this.props.dispatch,
          pathImporting: 'outlet',
          templateImportUrl: _constants.V1_IMPORT_ADJUSTMENT_TEMPLATE,
          temporaryImportUrl: _constants.V1_IMPORT_ADJUSTMENT_TEMPORARY,
          importUrl: _constants.V1_IMPORT_ADJUSTMENTS,
          namespace: 'adjustment',
          selectedOutletIds: search ? search.outletIds : [],
          onCancel: function onCancel() {
            _this2.props.dispatch((0, _adjustment.hideImportModal)());
          },
          show: this.props.showImportModal,
          afterSuccessCallback: this._importAfterSuccessCallback,
          onErrorCallback: this._importOnErrorCallback,
          templatePrefix: 'Inventory Adjustment Template - ',
          filterNamespace: 'items',
          csvHeaders: ['Internal ID (DO NOT EDIT)', 'Outlet Name (DO NOT EDIT)', 'Item Name (DO NOT EDIT)', 'Variant Name (DO NOT EDIT)', 'SKU (DO NOT EDIT)', 'In Stock (DO NOT EDIT)', 'Actual Stock', 'Note']
        }),
        this._namespace() === 'ingredients' && React.createElement(_ImportModal2.default, {
          dispatch: this.props.dispatch,
          pathImporting: 'outlet',
          templateImportUrl: _constants2.V1_IMPORT_ADJUSTMENT_TEMPLATE,
          temporaryImportUrl: _constants.V1_IMPORT_ADJUSTMENT_TEMPORARY,
          importUrl: _constants2.V1_IMPORT_ADJUSTMENTS,
          namespace: 'adjustment',
          selectedOutletIds: search ? search.outletIds : [],
          onCancel: function onCancel() {
            _this2.props.dispatch((0, _adjustment.hideImportModal)());
          },
          show: this.props.showImportModal,
          afterSuccessCallback: this._importAfterSuccessCallback,
          onErrorCallback: this._importOnErrorCallback,
          templatePrefix: 'Ingredient Inventory Adjustment Template - ',
          filterNamespace: 'ingredients',
          csvHeaders: ['Internal ID (DO NOT EDIT)', 'Outlet Name (DO NOT EDIT)', 'Ingredient Name (DO NOT EDIT)', 'In Stock (DO NOT EDIT)', 'Actual Stock', 'Unit (DO NOT EDIT)', 'Note']
        })
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIds
     */

  }]);
  return ActionBar;
}(React.Component);

ActionBar.NAMESPACE_OPTIONS = [{
  id: 'items', name: 'Item Library'
}, {
  id: 'ingredients', name: 'Ingredients'
}];


var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      outlets = _state$inventory$adju.outlets,
      showImportModal = _state$inventory$adju.showImportModal;
  var is_active = state.inventory.ingredientSubscription.subscriptionStatus.is_active;

  return {
    outlets: outlets,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('adjustment')(state),
    showImportModal: showImportModal,
    isIngredientActive: is_active
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1390);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1398);

var _List2 = _interopRequireDefault(_List);

var _adjustment = __webpack_require__(146);

var _reactRedux = __webpack_require__(6);

var _AdjustmentDetail = __webpack_require__(1393);

var _AdjustmentDetail2 = _interopRequireDefault(_AdjustmentDetail);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _SummaryAdjustment = __webpack_require__(1399);

var _SummaryAdjustment2 = _interopRequireDefault(_SummaryAdjustment);

var _Adjustment = __webpack_require__(2121);

var _Adjustment2 = _interopRequireDefault(_Adjustment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Adjustment = function (_React$Component) {
  (0, _inherits3.default)(Adjustment, _React$Component);

  function Adjustment() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Adjustment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Adjustment.__proto__ || (0, _getPrototypeOf2.default)(Adjustment)).call.apply(_ref, [this].concat(args))), _this), _this._showNoDataToDisplay = function () {
      var _this$props = _this.props,
          search = _this$props.search,
          adjustments = _this$props.adjustments,
          ingredientAdjustments = _this$props.ingredientAdjustments;

      if (search) {
        var namespace = search.namespace;

        if (namespace === 'items') {
          return adjustments.length === 0;
        } else {
          return ingredientAdjustments.length === 0;
        }
      } else {
        return false;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Adjustment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: this._showNoDataToDisplay(),
              title: 'No Data To Display',
              description: '' }),
            !showLoadingSpinnerPage && !this._showNoDataToDisplay() && React.createElement(
              'div',
              { className: _Adjustment2.default['content-wrapper'] },
              React.createElement(_SummaryAdjustment2.default, null),
              React.createElement(_List2.default, null)
            )
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_AdjustmentDetail2.default, null)
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _adjustment.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          var _props3 = _this2.props,
              isDirtyAdjustment = _props3.isDirtyAdjustment,
              nextAction = _props3.nextAction;

          if (isDirtyAdjustment && !nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Adjustment;
}(React.Component);

function mapStateToProps(state) {
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;
  var _state$inventory$adju = state.inventory.adjustment,
      openRightColumn = _state$inventory$adju.openRightColumn,
      adjustments = _state$inventory$adju.adjustments,
      ingredientAdjustments = _state$inventory$adju.ingredientAdjustments;

  return {
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
    isDirtyAdjustment: (0, _reduxForm.isDirty)('adjustment')(state),
    expired: expired,
    adjustments: adjustments,
    ingredientAdjustments: ingredientAdjustments,
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Adjustment);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _adjustment = __webpack_require__(146);

var _AddItemsModal = __webpack_require__(2122);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

__webpack_require__(262);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _WarningMessage = __webpack_require__(444);

var _WarningMessage2 = _interopRequireDefault(_WarningMessage);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

var _ItemHasRecipe = __webpack_require__(440);

var _ItemHasRecipe2 = _interopRequireDefault(_ItemHasRecipe);

var _confirmAction = __webpack_require__(29);

var _SearchModal = __webpack_require__(293);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nameField = function nameField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: 'form-control ' + _AddItemsModal2.default.name }));
};

var stockField = function stockField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { placeholder: input.value, readOnly: true, className: _AddItemsModal2.default.stock + ' form-control' }));
};

var toNonNegative = function toNonNegative(value) {
  if (isNaN(value)) {
    return '';
  } else if (value === '') {
    return '';
  } else {
    // ni gak pake fungsi abs karena kalo ngetik 100.0 di abs jatuhnya 100
    if (value < 0) {
      return -value;
    } else {
      return value;
    }
  }
};

var validate = function validate(values, props) {
  var errors = {};
  if (props.namespace === 'items') {
    var itemsErrors = [];
    if (values.items) {
      values.items.forEach(function (member, index) {
        var memberErrors = {};
        if (!member.quantity && '' + member.quantity !== '0') {
          memberErrors.quantity = 'Please enter a value';
          itemsErrors[index] = memberErrors;
        } else if (!_validator2.default.isNumeric(member.quantity + '')) {
          memberErrors.quantity = 'Please enter a valid Number';
          itemsErrors[index] = memberErrors;
        } else if (parseFloat(member.quantity) - 999999 > 0.000001) {
          memberErrors.quantity = 'Quantity must be less than 999999';
          itemsErrors[index] = memberErrors;
        }
      });
    }
    if (itemsErrors.length) {
      errors.items = itemsErrors;
    }
  } else {
    if (!values.quantity && values.quantity !== '0' && values.quantity !== 0) {
      errors.quantity = 'Please enter a value';
    } else if (parseFloat(values.quantity) - 999999 > 0.000001) {
      errors.quantity = 'Quantity must be less than 999999';
    }
  }

  return errors;
};

var renderField = function renderField(member, index, fields) {
  var adjustmentObject = fields.get(index);
  return React.createElement(
    'div',
    { className: 'mk-grouped-input' },
    adjustmentObject.item_variant_name && React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: nameField,
        name: member + '.item_variant_name'
      })
    ),
    !adjustmentObject.item_variant_name && React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: nameField,
        name: member + '.item_name'
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: stockField,
        name: member + '.beginning_stock'
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4', style: { paddingRight: 0 } },
      React.createElement(_reduxForm.Field, {
        component: _SettingField2.default,
        name: member + '.quantity',
        className: 'form-control',
        positiveNumberOnly: true,
        maxFractionDigits: 0,
        normalize: toNonNegative
      })
    )
  );
};

var renderFieldArrayItems = function renderFieldArrayItems(_ref) {
  var fields = _ref.fields;

  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input' },
    React.createElement(
      'div',
      { className: 'col-xs-12' },
      fields.map(renderField)
    )
  );
};

var AddItemsModal = function (_React$Component) {
  (0, _inherits3.default)(AddItemsModal, _React$Component);

  function AddItemsModal() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddItemsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = AddItemsModal.__proto__ || (0, _getPrototypeOf2.default)(AddItemsModal)).call.apply(_ref2, [this].concat(args))), _this), _this._onSearchReachBottom = function () {
      var _this$props = _this.props,
          namespace = _this$props.namespace,
          dispatch = _this$props.dispatch,
          _this$props$addItems = _this$props.addItems,
          currentPage = _this$props$addItems.currentPage,
          totalPage = _this$props$addItems.totalPage,
          items = _this$props$addItems.items,
          ingredients = _this$props$addItems.ingredients,
          keyword = _this$props$addItems.keyword,
          adjustmentForm = _this$props.adjustmentForm;

      if (currentPage < totalPage) {
        if (namespace === 'items') {
          dispatch((0, _adjustment.addItemsGetItemsRequest)({
            outlet_id: adjustmentForm.outlet_id,
            page: currentPage + 1,
            per_page: 100,
            no_categories: true,
            keyword: keyword
          }, items));
        } else {
          dispatch((0, _adjustment.addItemsGetIngredientsRequest)({
            outlet_id: adjustmentForm.outlet_id,
            page: currentPage + 1,
            per_page: 100,
            keyword: keyword
          }, ingredients));
        }
      }
    }, _this._onSubmit = function (values) {
      var selectedId = _this.props.addItems.selectedId;
      // kalo gak ada item yang diselect, don't do anything

      if (selectedId) {
        return _this.props.onSubmit(values);
      }
    }, _this._onOpen = function () {
      _this.props.dispatch((0, _adjustment.addItemsHideAlreadyAddedAlert)());
      _this.props.dispatch((0, _reduxForm.initialize)('addItems', {}));
    }, _this._onChangeSelect = function (dropdownVal) {
      var _this$props2 = _this.props,
          _this$props2$addItems = _this$props2.addItems,
          items = _this$props2$addItems.items,
          ingredients = _this$props2$addItems.ingredients,
          dispatch = _this$props2.dispatch,
          namespace = _this$props2.namespace,
          adjustmentForm = _this$props2.adjustmentForm;

      var selected = null;
      if (namespace === 'items') {
        items.forEach(function (i, index) {
          if (dropdownVal.value === i.id) {
            selected = items[index];
          }
        });
      } else {
        ingredients.forEach(function (i, index) {
          if (dropdownVal.value === i.id) {
            selected = ingredients[index];
          }
        });
      }

      if (selected) {
        dispatch((0, _adjustment.addItemsOnChangeSelect)(selected, namespace, adjustmentForm));
      }
    }, _this._onChangeKeyword = function (value) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          adjustmentForm = _this$props3.adjustmentForm,
          namespace = _this$props3.namespace;

      dispatch((0, _adjustment.addItemsOnSearch)(value, adjustmentForm.outlet_id, namespace));
    }, _this._onHide = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      dispatch((0, _adjustment.cancelAddItems)());
    }, _this._title = function () {
      var namespace = _this.props.namespace;

      if (namespace === 'items') {
        return 'Add Items';
      } else {
        return 'Add Ingredients';
      }
    }, _this._selectPlaceholder = function () {
      var namespace = _this.props.namespace;

      if (namespace === 'items') {
        return 'Search items';
      } else {
        return 'Search ingredients';
      }
    }, _this._shouldRenderForm = function () {
      var _this$props4 = _this.props,
          namespace = _this$props4.namespace,
          selectedId = _this$props4.addItems.selectedId,
          addItemsForm = _this$props4.addItemsForm;

      if (namespace === 'items') {
        return !!selectedId && addItemsForm.items && addItemsForm.items.length > 0;
      } else {
        return !!selectedId && addItemsForm.ingredient_id;
      }
    }, _this._renderIngredientFields = function () {
      return React.createElement(
        'div',
        { className: 'mk-grouped-list-input' },
        React.createElement(
          'div',
          { className: 'mk-grouped-input' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-4' },
            React.createElement(_reduxForm.Field, {
              name: 'unit_name',
              component: nameField
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group col-sm-4' },
            React.createElement(_reduxForm.Field, {
              name: 'beginning_stock',
              component: stockField
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group col-sm-4' },
            React.createElement(_reduxForm.Field, {
              name: 'quantity',
              component: _SettingField2.default,
              positiveNumberOnly: true,
              maxFractionDigits: 2,
              normalize: toNonNegative
            })
          )
        )
      );
    }, _this._clickIngredient = function () {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          _this$props5$search$d = _this$props5.search.date,
          startDate = _this$props5$search$d.startDate,
          endDate = _this$props5$search$d.endDate,
          keyword = _this$props5.keyword;

      var params = {
        page: 1,
        start: startDate.format('D/M/Y'),
        end: endDate.format('D/M/Y'),
        keyword: keyword
      };
      dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onChangeNamespace)('ingredients', params)));
    }, _this._hasMore = function () {
      var _this$props$addItems2 = _this.props.addItems,
          currentPage = _this$props$addItems2.currentPage,
          totalPage = _this$props$addItems2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AddItemsModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showAddItemsModal = _props.showAddItemsModal,
          addItems = _props.addItems,
          namespace = _props.namespace,
          addItemsForm = _props.addItemsForm;

      var disableBtn = !addItemsForm.items || !addItemsForm.items.length || addItems.itemHasRecipe;
      var options = void 0;
      if (namespace === 'items') {
        options = addItems.items.map(function (item) {
          return { value: item.id, label: item.name };
        });
      } else if (namespace === 'ingredients') {
        options = addItems.ingredients.map(function (ing) {
          return { value: ing.id, label: ing.name };
        });
      }

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAddItemsModal, backdrop: 'static', dialogClassName: _AddItemsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: this._title() }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: _AddItemsModal2.default.modalBody },
            React.createElement(_reduxForm.Field, {
              component: _SearchModal2.default,
              type: 'text',
              name: 'search-item',
              placeholder: this._selectPlaceholder(),
              options: options,
              onClickItem: this._onChangeSelect,
              onInputChange: this._onChangeKeyword,
              inputValue: addItems.selectedId,
              onMenuScrollToBottom: this._onSearchReachBottom,
              isHasMore: this._hasMore,
              isLoading: addItems.isLoading
            }),
            React.createElement(_ItemHasRecipe2.default, { hasRecipe: addItems.itemHasRecipe, onClickIngredient: this._clickIngredient }),
            !addItems.itemHasRecipe && React.createElement(
              'div',
              { className: 'mt-10px' },
              addItems.alreadyAddedAlert && React.createElement(
                'div',
                { className: _AddItemsModal2.default['warning-message'] },
                React.createElement(
                  _WarningMessage2.default,
                  null,
                  'This ',
                  namespace,
                  ' already added, go to ',
                  React.createElement(
                    'a',
                    { onClick: this._onHide },
                    React.createElement(
                      'i',
                      null,
                      'Adjustment stock table'
                    )
                  ),
                  ' to edit'
                )
              ),
              this._shouldRenderForm() && React.createElement(
                'table',
                { className: _AddItemsModal2.default['table-header'] + ' table table-truncate' },
                React.createElement(
                  'thead',
                  null,
                  React.createElement(
                    'tr',
                    null,
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '30%' },
                      addItemsForm.items && addItemsForm.items.length > 1 && namespace === 'items' && 'Variant',
                      addItemsForm.items && addItemsForm.items.length === 1 && namespace === 'items' && 'Item',
                      namespace === 'ingredients' && 'UNIT'
                    ),
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '30%' },
                      'In Stock'
                    ),
                    React.createElement(
                      'th',
                      { className: 'text-center', width: '30%' },
                      'Actual Stock'
                    )
                  )
                )
              ),
              namespace === 'items' && this._shouldRenderForm() && React.createElement(_reduxForm.FieldArray, {
                name: 'items',
                component: renderFieldArrayItems
              }),
              namespace === 'ingredients' && this._shouldRenderForm() && this._renderIngredientFields()
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', type: 'button', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              namespace === 'items' && React.createElement(
                'button',
                { className: disableBtn ? 'btn ' + _AddItemsModal2.default['disableBtnAddItem'] : 'btn btn-primary', disabled: disableBtn, onClick: this.props.handleSubmit(this._onSubmit) },
                'Add'
              ),
              namespace === 'ingredients' && React.createElement(
                'button',
                { className: !addItemsForm.ingredient_id ? 'btn ' + _AddItemsModal2.default['disableBtnAddItem'] : 'btn btn-primary', disabled: !addItemsForm.ingredient_id, onClick: this.props.handleSubmit(this._onSubmit) },
                'Add'
              )
            )
          )
        )
      );
    }
  }]);
  return AddItemsModal;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('addItems');

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      showAddItemsModal = _state$inventory$adju.showAddItemsModal,
      addItems = _state$inventory$adju.addItems,
      outlets = _state$inventory$adju.outlets;

  return {
    showAddItemsModal: showAddItemsModal,
    addItems: addItems,
    outlets: outlets,
    adjustmentForm: (0, _reduxForm.getFormValues)('adjustment')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    addItemsForm: {
      items: selector(state, 'items'),
      ingredient_id: selector(state, 'ingredient_id')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'addItems',
  validate: validate,
  touchOnBlur: true,
  touchOnChange: true,
  touchOnValidate: false
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddItemsModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _AdjustmentDetail = __webpack_require__(508);

var _AdjustmentDetail2 = _interopRequireDefault(_AdjustmentDetail);

var _ItemDetails = __webpack_require__(1397);

var _ItemDetails2 = _interopRequireDefault(_ItemDetails);

var _InventoryAdjustment = __webpack_require__(1396);

var _InventoryAdjustment2 = _interopRequireDefault(_InventoryAdjustment);

var _adjustment = __webpack_require__(146);

var _AdjustmentForm = __webpack_require__(1394);

var _AdjustmentForm2 = _interopRequireDefault(_AdjustmentForm);

var _AddItemsModal = __webpack_require__(1392);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

var _reduxForm = __webpack_require__(7);

var _notifications = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdjustmentDetail = function (_React$Component) {
  (0, _inherits3.default)(AdjustmentDetail, _React$Component);

  function AdjustmentDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdjustmentDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdjustmentDetail.__proto__ || (0, _getPrototypeOf2.default)(AdjustmentDetail)).call.apply(_ref, [this].concat(args))), _this), _this._closeRightColumn = function (event) {
      _this.props.dispatch((0, _adjustment.onClickDone)());
    }, _this._onSubmitAddItems = function (addItemsFormValues) {
      var adjustmentForm = _this.props.adjustmentForm;

      var values = (0, _extends3.default)({}, addItemsFormValues);
      values.quantity = String(parseFloat(addItemsFormValues.quantity).toFixed(2));
      _this.props.dispatch((0, _adjustment.addItemsConfirmAddItems)(addItemsFormValues, adjustmentForm.adjustments, _this._namespace()));
    }, _this._onSubmitAdjustmentForm = function (values) {
      var hasDifference = false;
      values.adjustments.forEach(function (adjustment) {
        if (Math.abs(parseFloat(adjustment.beginning_stock) - parseFloat(adjustment.quantity)) > 0.001) {
          hasDifference = true;
        }
      });
      if (hasDifference) {
        _this.props.dispatch((0, _adjustment.showConfirmSubmitModal)());
      } else {
        _this.props.dispatch((0, _notifications.error)('Please add Adjustment Stock before saving'));
      }
    }, _this._namespace = function () {
      var search = _this.props.search;

      if (search) {
        return search.namespace;
      } else {
        return '';
      }
    }, _this._shouldRenderDetail = function () {
      var namespace = _this._namespace();
      var _this$props = _this.props,
          adjustmentDetail = _this$props.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props.ingredientAdjustmentDetail;

      if (namespace === 'items') {
        return !!adjustmentDetail;
      } else {
        return !!ingredientAdjustmentDetail;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdjustmentDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          adjustmentDetail = _props.adjustmentDetail,
          ingredientAdjustmentDetail = _props.ingredientAdjustmentDetail,
          search = _props.search;

      return this._shouldRenderDetail() ? React.createElement(
        'div',
        { className: _AdjustmentDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _AdjustmentDetail2.default['field-wrapper'] },
          React.createElement(_ItemDetails2.default, {
            adjustmentDetail: adjustmentDetail,
            ingredientAdjustmentDetail: ingredientAdjustmentDetail,
            namespace: this._namespace(),
            renderOutlet: search && search.outletIds && search.outletIds.length > 1
          }),
          React.createElement(_InventoryAdjustment2.default, {
            adjustmentDetail: adjustmentDetail,
            ingredientAdjustmentDetail: ingredientAdjustmentDetail,
            namespace: this._namespace()
          })
        ),
        React.createElement(
          'div',
          { className: _AdjustmentDetail2.default.footer },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary ' + _AdjustmentDetail2.default['btn-done'],
                onClick: this._closeRightColumn },
              'Done'
            )
          )
        )
      ) : React.createElement(
        'div',
        { className: _AdjustmentDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _AdjustmentDetail2.default['form-wrapper'] },
          React.createElement(_AdjustmentForm2.default, { onSubmit: this._onSubmitAdjustmentForm, namespace: this._namespace() }),
          React.createElement(_AddItemsModal2.default, { onSubmit: this._onSubmitAddItems, namespace: this._namespace() })
        )
      );
    }

    /**
     * Either should render detail or form
     * @private
     */

  }]);
  return AdjustmentDetail;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      adjustments = _state$inventory$adju.adjustments,
      adjustmentDetail = _state$inventory$adju.adjustmentDetail,
      showAddItemsModal = _state$inventory$adju.showAddItemsModal,
      ingredientAdjustmentDetail = _state$inventory$adju.ingredientAdjustmentDetail;

  return {
    adjustments: adjustments,
    adjustmentDetail: adjustmentDetail,
    showAddItemsModal: showAddItemsModal,
    ingredientAdjustmentDetail: ingredientAdjustmentDetail,
    adjustmentForm: (0, _reduxForm.getFormValues)('adjustment')(state),
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AdjustmentDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _AdjustmentForm = __webpack_require__(2123);

var _AdjustmentForm2 = _interopRequireDefault(_AdjustmentForm);

var _adjustment = __webpack_require__(146);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _ConfirmSubmitModal = __webpack_require__(1395);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

var _reactBootstrap = __webpack_require__(10);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values, props) {
  var errors = {};
  var adjustmentErrors = [];
  if (values.adjustments) {
    values.adjustments.forEach(function (member, index) {
      var memberErrors = {};
      if (!member.quantity && '' + member.quantity !== '0') {
        memberErrors.quantity = 'Please enter a value';
        adjustmentErrors[index] = memberErrors;
      } else if (props.namespace === 'ingredients' && !_validator2.default.isDecimal(member.quantity + '')) {
        memberErrors.quantity = 'Please enter a valid Number';
        adjustmentErrors[index] = memberErrors;
      } else if (props.namespace === 'items' && !_validator2.default.isNumeric(member.quantity + '')) {
        memberErrors.quantity = 'Please enter a valid Number';
        adjustmentErrors[index] = memberErrors;
      } else if (parseFloat(member.quantity) - 999999 > 0.000001) {
        memberErrors.quantity = 'Quantity must be less than 999999';
        adjustmentErrors[index] = memberErrors;
      }
    });
  }
  if (adjustmentErrors.length) {
    errors.adjustments = adjustmentErrors;
  }
  return errors;
};
var popoverFocus = function popoverFocus(_ref) {
  var content = _ref.content;
  return React.createElement(
    _reactBootstrap.Popover,
    { id: 'adjustment' },
    content
  );
};

var toNonNegative = function toNonNegative(value) {
  if (isNaN(value)) {
    return '';
  } else if (value === '') {
    return '';
  } else {
    // ni gak pake fungsi abs karena kalo ngetik 100.0 di abs jatuhnya 100
    if (value < 0) {
      return -value;
    } else {
      return value;
    }
  }
};

var renderAdjustment = function renderAdjustment(member, index, fields) {
  var adjustmentObject = fields.get(index);
  var adjustmentValue = adjustmentObject.quantity - adjustmentObject.beginning_stock;
  if (isNaN(adjustmentValue)) {
    adjustmentValue = 0;
  }
  var formattedAdjustmentValue = adjustmentValue > 0 ? '+' + adjustmentValue : '' + adjustmentValue;
  // kalo nemu value yang dirender pake <input> tag
  // tapi bingung di mana dia di set valuenya
  // silakan cek saga-effect confirmAddItems sama Form pada komponent AddItemsModal
  return React.createElement(
    'div',
    { className: 'col-sm-12 mk-grouped-input' },
    React.createElement(
      'div',
      { className: 'form-group col-sm-3' },
      !adjustmentObject.is_item && React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: popoverFocus({ content: adjustmentObject.item_variant_name }) },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.item_variant_name',
          className: 'form-control ' + _AdjustmentForm2.default['item-variant-name'],
          disabled: true
        })
      ),
      adjustmentObject.is_item && React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: popoverFocus({ content: adjustmentObject.item_name }) },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.item_name',
          className: 'form-control ' + _AdjustmentForm2.default['item-name'],
          disabled: true
        })
      )
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-3' },
      React.createElement(_reduxForm.Field, {
        component: 'input',
        name: member + '.beginning_stock',
        className: 'form-control ' + _AdjustmentForm2.default['beginning-stock'],
        disabled: true
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-3' },
      React.createElement(_reduxForm.Field, {
        component: _SettingField2.default,
        name: member + '.quantity',
        className: 'form-control',
        positiveNumberOnly: true,
        maxFractionDigits: 0,
        normalize: toNonNegative
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-3' },
      React.createElement('input', {
        className: 'form-control ' + _AdjustmentForm2.default['adjustment'],
        value: formattedAdjustmentValue,
        disabled: true
      }),
      adjustmentObject.is_item && React.createElement(
        'span',
        { onClick: function onClick() {
            var i = 0;
            fields.getAll().forEach(function (item, idx) {
              if (item.item_id === adjustmentObject.item_id) {
                fields.remove(idx - i);
                i++;
              }
            });
          }, className: _AdjustmentForm2.default['btn-delete-wrapper'] },
        React.createElement('i', { className: 'fa fa-times-circle' })
      )
    )
  );
};

var renderIngredientArray = function renderIngredientArray(_ref2) {
  var fields = _ref2.fields;

  return React.createElement(
    'div',
    null,
    fields.map(function (member, index, fields) {
      var values = fields.get(index);
      var diff = Number(values.quantity - values.beginning_stock).toFixed(2);
      var formattedAdjustmentValue = !isNaN(diff) ? diff > 0 ? '+' + diff : '-' + diff : 0;
      return React.createElement(
        'div',
        { className: 'row mb-20px' },
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          React.createElement(
            'div',
            { className: 'col-sm-3 text-center' },
            'UNIT'
          ),
          React.createElement(
            'div',
            { className: 'col-sm-3 text-center' },
            'IN STOCK'
          ),
          React.createElement(
            'div',
            { className: 'col-sm-3 text-center' },
            'ACTUAL STOCK'
          ),
          React.createElement(
            'div',
            { className: 'col-sm-3 text-center' },
            'ADJUSTMENT'
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          React.createElement(
            'div',
            { className: 'mk-grouped-input' },
            React.createElement(
              'div',
              { className: 'form-group col-sm-12' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                name: member + '.ingredient_name',
                className: 'form-control ' + _AdjustmentForm2.default['ingredient-name'],
                disabled: true
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'mk-grouped-input' },
            React.createElement(
              'div',
              { className: 'form-group col-sm-3' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                name: member + '.unit_name',
                className: 'form-control ' + _AdjustmentForm2.default['unit-name'],
                disabled: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group col-sm-3' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                name: member + '.beginning_stock',
                className: 'form-control ' + _AdjustmentForm2.default['beginning-stock'],
                disabled: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group col-sm-3' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: member + '.quantity',
                className: 'form-control ' + _AdjustmentForm2.default['end-stock'],
                positiveNumberOnly: true,
                maxFractionDigits: 2,
                normalize: toNonNegative
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group col-sm-3' },
              React.createElement('input', {
                className: 'form-control ' + _AdjustmentForm2.default['adjustment'],
                disabled: true,
                value: formattedAdjustmentValue
              }),
              React.createElement(
                'span',
                { onClick: function onClick() {
                    fields.remove(index);
                  }, className: _AdjustmentForm2.default['btn-delete-wrapper'] },
                React.createElement('i', { className: 'fa fa-times-circle' })
              )
            )
          )
        )
      );
    })
  );
};

var renderAdjustmentArray = function renderAdjustmentArray(_ref3) {
  var fields = _ref3.fields,
      adjustmentForm = _ref3.adjustmentForm;

  var lastItemId = 0;
  var doms = [];
  var inputdoms = [];
  fields.forEach(function () {
    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    var member = props[0],
        index = props[1];

    var field = fields.get(index);
    var shouldRenderHeader = lastItemId === 0 || field.item_id !== lastItemId;
    var shouldRenderItemNameRow = !field.is_item;
    lastItemId = field.item_id;

    if (shouldRenderHeader) {
      if (inputdoms.length) {
        doms.push(React.createElement(
          'div',
          { className: 'row mb-20px' },
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            inputdoms
          )
        ));
        inputdoms = [];
      }
      doms.push(React.createElement(
        'div',
        { className: 'col-sm-12 mt-10px' },
        React.createElement(
          'div',
          { className: 'col-sm-3 text-center' },
          !field.is_item && 'VARIANT',
          field.is_item && 'ITEM'
        ),
        React.createElement(
          'div',
          { className: 'col-sm-3 text-center' },
          'IN STOCK'
        ),
        React.createElement(
          'div',
          { className: 'col-sm-3 text-center' },
          'ACTUAL STOCK'
        ),
        React.createElement(
          'div',
          { className: 'col-sm-3 text-center' },
          'ADJUSTMENT'
        )
      ));
    }

    if (shouldRenderHeader && shouldRenderItemNameRow) {
      inputdoms.push(React.createElement(
        'div',
        { className: 'col-sm-12 mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-12' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            name: member + '.item_name',
            className: 'form-control ' + _AdjustmentForm2.default['item-name-header'],
            disabled: true
          }),
          !field.is_item && React.createElement(
            'span',
            { onClick: function onClick() {
                var i = 0;
                fields.getAll().forEach(function (item, idx) {
                  if (item.item_id === field.item_id) {
                    fields.remove(idx - i);
                    i++;
                  }
                });
              }, className: _AdjustmentForm2.default['btn-delete-wrapper'] },
            React.createElement('i', { className: 'fa fa-times-circle' })
          )
        )
      ));
    }
    inputdoms.push(renderAdjustment.apply(undefined, props));
  });
  if (inputdoms.length) {
    doms.push(React.createElement(
      'div',
      { className: 'row mb-20px' },
      React.createElement(
        'div',
        { className: 'col-sm-12' },
        inputdoms
      )
    ));
  }
  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input ' + _AdjustmentForm2.default['adjustment-item-wrapper'] },
    doms
  );
};

var AdjustmentForm = function (_React$Component) {
  (0, _inherits3.default)(AdjustmentForm, _React$Component);

  function AdjustmentForm() {
    var _ref4;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdjustmentForm);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = AdjustmentForm.__proto__ || (0, _getPrototypeOf2.default)(AdjustmentForm)).call.apply(_ref4, [this].concat(args))), _this), _this._onClickCancel = function () {
      _this.props.dispatch((0, _adjustment.adjustmentFormOnClickCancel)());
    }, _this._onChangeOutletId = function (event, outletId) {
      _this.props.dispatch((0, _adjustment.adjustmentFormOnChangeOutlet)(outletId));
    }, _this._onClickAddItems = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          adjustmentForm = _this$props.adjustmentForm,
          namespace = _this$props.namespace;

      _this.props.dispatch((0, _adjustment.onClickAddItems)(adjustmentForm.outlet_id, namespace));
    }, _this._outletDropdowns = function () {
      var _this$props2 = _this.props,
          outlets = _this$props2.outlets,
          search = _this$props2.search;

      if (!search || !search.outletIds) {
        return [];
      } else if (search.outletIds.length > 1) {
        return outlets;
      } else {
        var data = [];
        outlets.forEach(function (d) {
          if (search.outletIds[0] === d.id) {
            data.push(d);
          }
        });
        return data;
      }
    }, _this._addItemsLabel = function () {
      var search = _this.props.search;

      if (search && search.namespace === 'items') {
        return 'Add Items';
      } else {
        return 'Add Ingredients';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdjustmentForm, [{
    key: 'render',
    value: function render() {
      var outletDropdowns = this._outletDropdowns();
      var outletDropdownClassName = '';
      if (outletDropdowns.length === 1) {
        outletDropdownClassName = _AdjustmentForm2.default['outlet-dropdown'] + ' ' + _AdjustmentForm2.default.single;
      } else {
        outletDropdownClassName = _AdjustmentForm2.default['outlet-dropdown'] + ' ' + _AdjustmentForm2.default.multiple;
      }
      return React.createElement(
        'form',
        { className: _AdjustmentForm2.default.wrapper, onSubmit: this.props.handleSubmit },
        React.createElement(
          'div',
          { className: _AdjustmentForm2.default['form-content'] },
          React.createElement(_LabelSection2.default, { title: 'choose outlet' }),
          React.createElement(
            'div',
            { className: 'form-group' },
            React.createElement(
              _reduxForm.Field,
              {
                name: 'outlet_id',
                component: 'select',
                onChange: this._onChangeOutletId,
                className: 'form-control ' + outletDropdownClassName,
                disabled: outletDropdowns.length === 1
              },
              outletDropdowns.map(function (o) {
                return React.createElement(
                  'option',
                  { value: o.id },
                  o.name
                );
              })
            )
          ),
          React.createElement(_LabelSection2.default, { title: 'note' }),
          React.createElement(
            'div',
            { className: 'form-group mb-20px' },
            React.createElement(_reduxForm.Field, {
              component: 'textarea',
              placeholder: 'Notes',
              name: 'note',
              className: 'form-control',
              rows: 5
            })
          ),
          React.createElement(_LabelSection2.default, { title: 'adjustment stock table' }),
          React.createElement(
            'div',
            { className: 'mb-20px' },
            this.props.namespace === 'items' && React.createElement(_reduxForm.FieldArray, {
              name: 'adjustments',
              component: renderAdjustmentArray,
              adjustmentForm: this.props.adjustmentForm
            }),
            this.props.namespace === 'ingredients' && React.createElement(_reduxForm.FieldArray, {
              name: 'adjustments',
              component: renderIngredientArray
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group' },
            this._isMaxItems() && React.createElement(
              _reactBootstrap.OverlayTrigger,
              { placement: 'top', overlay: popoverFocus({ content: React.createElement(
                    'span',
                    null,
                    'You can only make adjustment to 50 items at a time. Please use ',
                    React.createElement(
                      'strong',
                      null,
                      'Import Adjustment'
                    ),
                    ' if you want to make Adjustment for more than 50 items.'
                  ) }) },
              React.createElement(
                'button',
                { className: 'btn btn-primary ' + _AdjustmentForm2.default['btn-addItems-disabled'],
                  onClick: function onClick(event) {
                    event.preventDefault();event.stopPropagation();
                  } },
                this._addItemsLabel()
              )
            ),
            !this._isMaxItems() && React.createElement(
              'button',
              { className: 'btn btn-primary ' + _AdjustmentForm2.default['btn-addItems'],
                onClick: this._onClickAddItems },
              this._addItemsLabel()
            )
          )
        ),
        React.createElement(
          'div',
          { className: _AdjustmentForm2.default['form-footer'] },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default ' + _AdjustmentForm2.default['btn-done'] + ' mr-10px',
                onClick: this._onClickCancel,
                type: 'button' },
              'Cancel'
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _AdjustmentForm2.default['btn-done']
              },
              'Create'
            )
          )
        ),
        React.createElement(_ConfirmSubmitModal2.default, null)
      );
    }
  }, {
    key: '_isMaxItems',
    value: function _isMaxItems() {
      var adjustmentForm = this.props.adjustmentForm;

      if (adjustmentForm) {
        var totalItems = _lodash2.default.uniqBy(adjustmentForm.adjustments, 'item_id').length;
        if (totalItems >= 50) {
          return true;
        }
      }
      return false;
    }
  }]);
  return AdjustmentForm;
}(React.Component);

var mapForm = {
  form: 'adjustment',
  validate: validate,
  touchOnBlur: true,
  touchOnChange: true
};

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      outlets = _state$inventory$adju.outlets,
      showAddItemsModal = _state$inventory$adju.showAddItemsModal,
      addItemsButtonDisabledState = _state$inventory$adju.addItemsButtonDisabledState;

  return {
    outlets: outlets,
    showAddItemsModal: showAddItemsModal,
    addItemsButtonDisabledState: addItemsButtonDisabledState,
    search: (0, _reduxForm.getFormValues)('search')(state),
    adjustmentForm: (0, _reduxForm.getFormValues)('adjustment')(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(AdjustmentForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _adjustment = __webpack_require__(146);

var _ConfirmSubmitModal = __webpack_require__(2124);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmSubmitModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmSubmitModal, _React$Component);

  function ConfirmSubmitModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmSubmitModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmSubmitModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmSubmitModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _adjustment.hideConfirmSubmitModal)());
    }, _this._onClickCreate = function () {
      var _this$props = _this.props,
          adjustmentForm = _this$props.adjustmentForm,
          dispatch = _this$props.dispatch,
          date = _this$props.search.date,
          outlets = _this$props.outlets;

      var outlet = {};
      outlets.forEach(function (o) {
        if (o.id === adjustmentForm.outlet_id) {
          outlet = o;
        }
      });
      var namespace = _this._namespace();
      dispatch((0, _adjustment.confirmSubmit)(adjustmentForm, namespace, date, outlet));
    }, _this._namespace = function () {
      var search = _this.props.search;

      if (search) {
        return search.namespace;
      } else {
        return '';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmSubmitModal, [{
    key: 'render',
    value: function render() {
      var showConfirmSubmitModal = this.props.showConfirmSubmitModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showConfirmSubmitModal, dialogClassName: _ConfirmSubmitModal2.default['modal-dialog'] },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmSubmitModal2.default['modal-header'] },
          'Information'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Do you want to save the adjustment? You will not be able to modify after changes are made.'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { type: 'button', onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary',
              onClick: this._onClickCreate
            },
            'Create'
          )
        )
      );
    }
  }]);
  return ConfirmSubmitModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      showConfirmSubmitModal = _state$inventory$adju.showConfirmSubmitModal,
      outlets = _state$inventory$adju.outlets;

  return {
    adjustmentForm: (0, _reduxForm.getFormValues)('adjustment')(state),
    showConfirmSubmitModal: showConfirmSubmitModal,
    search: (0, _reduxForm.getFormValues)('search')(state),
    outlets: outlets
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmSubmitModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AdjustmentDetail = __webpack_require__(508);

var _AdjustmentDetail2 = _interopRequireDefault(_AdjustmentDetail);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InventoryAdjustment = function (_React$Component) {
  (0, _inherits3.default)(InventoryAdjustment, _React$Component);

  function InventoryAdjustment() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InventoryAdjustment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InventoryAdjustment.__proto__ || (0, _getPrototypeOf2.default)(InventoryAdjustment)).call.apply(_ref, [this].concat(args))), _this), _this._getTotalAdjustment = function (historyDetails) {
      var total = 0;
      for (var i = 0; i < historyDetails.length; i++) {
        total += historyDetails[i].adjustment;
      }
      return total;
    }, _this._shouldRender = function () {
      var _this$props = _this.props,
          namespace = _this$props.namespace,
          adjustmentDetail = _this$props.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props.ingredientAdjustmentDetail;

      if (namespace === 'items') {
        return !!adjustmentDetail;
      } else {
        return !!ingredientAdjustmentDetail;
      }
    }, _this._header = function () {
      var namespace = _this.props.namespace;

      if (namespace === 'items') {
        return React.createElement(
          'div',
          { className: 'row mt-40px mb-5px ml-0px mr-0px' },
          React.createElement(
            'div',
            { className: 'col-sm-5 pl-0px' },
            _this._headerCol('inventory adjustment')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 text-center' },
            _this._headerCol('in stock')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-3 text-center' },
            _this._headerCol('actual stock')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 pr-0px text-center' },
            _this._headerCol('adjustment')
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: 'row mt-40px mb-5px ml-0px mr-0px' },
          React.createElement(
            'div',
            { className: 'col-sm-4 pl-0px' },
            _this._headerCol('inventory adjustment')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 text-center' },
            _this._headerCol('in stock')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 text-center' },
            _this._headerCol('actual stock')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 text-center' },
            _this._headerCol('adjustment')
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 pr-0px text-center' },
            _this._headerCol('unit')
          )
        );
      }
    }, _this._headerCol = function (title) {
      return React.createElement(
        'div',
        { className: _AdjustmentDetail2.default['label-adj-detail'] },
        title
      );
    }, _this._renderIngredientHistoryDetails = function () {
      var ingredientAdjustmentDetail = _this.props.ingredientAdjustmentDetail;

      var historyDetails = _lodash2.default.sortBy(ingredientAdjustmentDetail.ingredient_history_details, ['unit_name']);
      var doms = [];
      var total = {
        quantity: 0,
        unit_name: ''
      };
      historyDetails.forEach(function (history, idx) {
        var dom = React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: _AdjustmentDetail2.default['row-inventory'] },
              React.createElement(
                'div',
                { className: 'col-sm-4' },
                history.ingredient_name
              ),
              React.createElement(
                'div',
                { className: 'col-sm-2 text-center' },
                history.beginning_stock
              ),
              React.createElement(
                'div',
                { className: 'col-sm-2 text-center' },
                history.end_stock
              ),
              React.createElement(
                'div',
                { className: 'col-sm-2 text-center' },
                history.adjustment_quantity
              ),
              React.createElement(
                'div',
                { className: 'col-sm-2 text-center' },
                history.unit_name
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
            )
          )
        );
        doms.push(dom);
        total.quantity += history.adjustment_quantity;
        total.unit_name = history.unit_name;
        // give 'total row' if the next unit name is different or this is last row
        if (idx + 1 >= historyDetails.length || historyDetails[idx + 1].unit_name !== total.unit_name) {
          doms.push(React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              { className: 'row mb-30px' },
              React.createElement(
                'div',
                { className: _AdjustmentDetail2.default['row-inventory'] },
                React.createElement(
                  'div',
                  { className: 'col-sm-4 ' + _AdjustmentDetail2.default['label-total'] },
                  'TOTAL'
                ),
                React.createElement(
                  'div',
                  { className: 'col-sm-2 col-sm-offset-4 text-center ' + _AdjustmentDetail2.default['label-total'] },
                  total.quantity
                ),
                React.createElement(
                  'div',
                  { className: 'col-sm-2 text-center ' + _AdjustmentDetail2.default['label-unit-total'] },
                  total.unit_name
                )
              )
            ),
            idx + 1 < historyDetails.length && React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
              )
            )
          ));
          total.quantity = 0;
        }
      });
      return doms;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(InventoryAdjustment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          adjustmentDetail = _props.adjustmentDetail,
          namespace = _props.namespace;

      var lastItemId = 0;
      return this._shouldRender() && React.createElement(
        'div',
        null,
        this._header(),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
          )
        ),
        namespace === 'ingredients' && this._renderIngredientHistoryDetails(),
        namespace === 'items' && adjustmentDetail.history_details.map(function (history, idx) {
          var dom = React.createElement(
            'div',
            null,
            history.item_variant_name && React.createElement(
              'div',
              null,
              lastItemId !== history.item_id && React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-sm-12' },
                  React.createElement(
                    'div',
                    null,
                    history.item_name
                  ),
                  React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
                )
              ),
              React.createElement(
                'div',
                { className: 'col-sm-5 pl-0px ' + _AdjustmentDetail2.default['variant-name'] },
                React.createElement(
                  'div',
                  null,
                  '\xA0 \xA0 ',
                  history.item_variant_name
                )
              )
            ),
            !history.item_variant_name && React.createElement(
              'div',
              { className: 'col-sm-5 pl-0px' },
              React.createElement(
                'div',
                null,
                history.item_name
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-2 text-center' },
              React.createElement(
                'div',
                null,
                history.beginning_stock
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-3 text-center' },
              React.createElement(
                'div',
                null,
                history.end_stock
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-2 pr-0px text-center' },
              React.createElement(
                'div',
                null,
                history.adjustment
              )
            ),
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
              )
            )
          );
          lastItemId = history.item_id;
          return dom;
        }),
        namespace === 'items' && React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-10 ' + _AdjustmentDetail2.default['label-total'] },
            'TOTAL'
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 ' + _AdjustmentDetail2.default['total-adj'] },
            this._getTotalAdjustment(adjustmentDetail.history_details)
          )
        )
      );
    }
  }]);
  return InventoryAdjustment;
}(React.Component);

InventoryAdjustment.propTypes = {
  adjustmentDetail: React.PropTypes.Object
};

exports.default = InventoryAdjustment;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _AdjustmentDetail = __webpack_require__(508);

var _AdjustmentDetail2 = _interopRequireDefault(_AdjustmentDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetails = function (_React$Component) {
  (0, _inherits3.default)(ItemDetails, _React$Component);

  function ItemDetails() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemDetails.__proto__ || (0, _getPrototypeOf2.default)(ItemDetails)).call.apply(_ref, [this].concat(args))), _this), _this._labelTitle = function () {
      var namespace = _this.props.namespace;

      if (namespace === 'items') {
        return 'Item Details';
      } else {
        return 'Ingredient Details';
      }
    }, _this._date = function () {
      var _this$props = _this.props,
          namespace = _this$props.namespace,
          adjustmentDetail = _this$props.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props.ingredientAdjustmentDetail;

      var FORMAT = 'D MMMM YYYY HH:mm';
      if (namespace === 'items') {
        return (0, _moment2.default)(adjustmentDetail.created_at).format(FORMAT);
      } else {
        return (0, _moment2.default)(ingredientAdjustmentDetail.created_at).format(FORMAT);
      }
    }, _this._outletName = function () {
      var _this$props2 = _this.props,
          namespace = _this$props2.namespace,
          adjustmentDetail = _this$props2.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props2.ingredientAdjustmentDetail;

      if (namespace === 'items') {
        return adjustmentDetail.outlet.name;
      } else {
        return ingredientAdjustmentDetail.outlet.name;
      }
    }, _this._note = function () {
      var _this$props3 = _this.props,
          namespace = _this$props3.namespace,
          adjustmentDetail = _this$props3.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props3.ingredientAdjustmentDetail;

      if (namespace === 'items') {
        return adjustmentDetail.note;
      } else {
        return ingredientAdjustmentDetail.note;
      }
    }, _this._shouldRender = function () {
      var _this$props4 = _this.props,
          namespace = _this$props4.namespace,
          adjustmentDetail = _this$props4.adjustmentDetail,
          ingredientAdjustmentDetail = _this$props4.ingredientAdjustmentDetail;

      if (namespace === 'items') {
        return !!adjustmentDetail;
      } else {
        return !!ingredientAdjustmentDetail;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemDetails, [{
    key: 'render',
    value: function render() {
      return this._shouldRender() && React.createElement(
        'div',
        null,
        React.createElement(_LabelSection2.default, { title: this._labelTitle() }),
        React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-2' },
            React.createElement(
              'span',
              null,
              'Date'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-10' },
            React.createElement(
              'div',
              { className: 'text-right' },
              React.createElement(
                'span',
                null,
                this._date()
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
          )
        ),
        this.props.renderOutlet && React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-2' },
            React.createElement(
              'span',
              null,
              'Outlet'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-10' },
            React.createElement(
              'div',
              { className: 'text-right ' + _AdjustmentDetail2.default['break-word'] },
              this._outletName()
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
          )
        ),
        React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-2' },
            React.createElement(
              'span',
              null,
              'Note'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-10' },
            React.createElement(
              'div',
              { className: 'text-right' },
              this._note()
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _AdjustmentDetail2.default['separator-row'] })
          )
        )
      );
    }
  }]);
  return ItemDetails;
}(React.Component);

ItemDetails.propTypes = {
  adjustmentDetail: React.PropTypes.Object,
  ingredientAdjustmentDetail: React.PropTypes.Object,
  namespace: React.PropTypes.string,
  renderOutlet: React.PropTypes.bool
};

exports.default = ItemDetails;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2125);

var _List2 = _interopRequireDefault(_List);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _adjustment = __webpack_require__(146);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _confirmAction = __webpack_require__(29);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._renderAdjustmentHeader = function () {
      var search = _this.props.search;

      return React.createElement(
        'thead',
        null,
        React.createElement(
          'tr',
          null,
          React.createElement(
            'th',
            null,
            'Date'
          ),
          React.createElement(
            'th',
            null,
            search && search.outletIds.length > 1 && 'Outlet'
          ),
          React.createElement(
            'th',
            null,
            'Note'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Items'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Adjustment'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Expense/Income'
          )
        )
      );
    }, _this._renderIngredientAdjustmentHeader = function () {
      var search = _this.props.search;

      return React.createElement(
        'thead',
        null,
        React.createElement(
          'tr',
          null,
          React.createElement(
            'th',
            null,
            'Date'
          ),
          React.createElement(
            'th',
            null,
            search && search.outletIds.length > 1 && 'Outlet'
          ),
          React.createElement(
            'th',
            null,
            'Note'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Ingredient'
          ),
          React.createElement(
            'th',
            { className: 'text-right' },
            'Adjustment'
          ),
          React.createElement(
            'th',
            { className: 'text-center' },
            'Expense/Income'
          )
        )
      );
    }, _this._renderAdjustmentTable = function () {
      var _this$props = _this.props,
          adjustments = _this$props.adjustments,
          adjustmentDetail = _this$props.adjustmentDetail,
          search = _this$props.search;


      return React.createElement(
        'tbody',
        null,
        adjustments.map(function (adjustment) {
          var className = '' + (adjustmentDetail && adjustmentDetail.id === adjustment.id ? _List2.default.selected : '');
          if (adjustment.isdaterow) {
            return React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { colSpan: 6, className: _List2.default.parentRow },
                (0, _moment2.default)(adjustment.created_at).format('ddd MMM DD YYYY')
              )
            );
          } else {
            return React.createElement(
              'tr',
              { onClick: function onClick() {
                  _this._onClickRowAdjustment(adjustment);
                }, className: className },
              React.createElement(
                'td',
                null,
                (0, _moment2.default)(adjustment.created_at).format('HH:mm')
              ),
              React.createElement(
                'td',
                null,
                search && search.outletIds.length > 1 && adjustment.outlet.name
              ),
              React.createElement(
                'td',
                null,
                _this._noteAdjustment(adjustment)
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                _this._itemNameAdjustment(adjustment)
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                _this._totalAdjustment(adjustment)
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                _this._totalExpenseIncome(adjustment) !== 0 && (0, _formatter.currencyFormatter)(_this._totalExpenseIncome(adjustment))
              )
            );
          }
        })
      );
    }, _this._renderIngredientAdjustmentTable = function () {
      var _this$props2 = _this.props,
          ingredientAdjustments = _this$props2.ingredientAdjustments,
          ingredientAdjustmentDetail = _this$props2.ingredientAdjustmentDetail,
          search = _this$props2.search;


      return React.createElement(
        'tbody',
        null,
        ingredientAdjustments.map(function (ingAdj) {
          var className = '' + (ingredientAdjustmentDetail && ingredientAdjustmentDetail.id === ingAdj.id ? _List2.default.selected : '');
          if (ingAdj.isdaterow) {
            return React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { colSpan: 6, className: _List2.default.parentRow },
                (0, _moment2.default)(ingAdj.created_at).format('ddd MMM DD YYYY')
              )
            );
          } else {
            return React.createElement(
              'tr',
              { onClick: function onClick() {
                  _this._onClickRowIngredientAdjustment(ingAdj);
                }, className: className },
              React.createElement(
                'td',
                null,
                (0, _moment2.default)(ingAdj.created_at).format('HH:mm')
              ),
              React.createElement(
                'td',
                null,
                search && search.outletIds.length > 1 && ingAdj.outlet.name
              ),
              React.createElement(
                'td',
                null,
                _this._noteIngredientAdjustment(ingAdj)
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                _this._ingredientName(ingAdj)
              ),
              React.createElement(
                'td',
                { className: 'text-right' },
                _this._totalIngredientAdjustment(ingAdj)
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                (0, _formatter.currencyFormatter)(_this._totalExpenseIncomeIngredient(ingAdj))
              )
            );
          }
        })
      );
    }, _this._hasMore = function () {
      var _this$props3 = _this.props,
          currentPage = _this$props3.currentPage,
          totalPage = _this$props3.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          currentPage = _this$props4.currentPage,
          adjustments = _this$props4.adjustments,
          ingredientAdjustments = _this$props4.ingredientAdjustments,
          _this$props4$search = _this$props4.search,
          date = _this$props4$search.date,
          namespace = _this$props4$search.namespace;
      var startDate = date.startDate,
          endDate = date.endDate;

      var params = {
        page: currentPage + 1,
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD')
      };
      if (namespace === List.INGREDIENTS) {
        dispatch((0, _adjustment.ingredientAdjustmentsRequest)(params, ingredientAdjustments));
      } else {
        dispatch((0, _adjustment.adjustmentsRequest)(params, adjustments));
      }
    }, _this._itemNameAdjustment = function (adjustment) {
      // check apakah semua itemnya sama
      var itemIds = _lodash2.default.countBy(adjustment.history_details, 'item_id');
      if ((0, _keys2.default)(itemIds).length > 1) {
        return adjustment.history_details.length + ' items';
      } else {
        if (!adjustment.history_details[0].item_variant_name) {
          return '' + adjustment.history_details[0].item_name;
        } else {
          return adjustment.history_details[0].item_name + ' (' + adjustment.history_details.length + ' variants)';
        }
      }
    }, _this._ingredientName = function (ingredientAdjustment) {
      if (ingredientAdjustment.ingredient_history_details.length === 1) {
        return ingredientAdjustment.ingredient_history_details[0].ingredient_name;
      } else {
        return ingredientAdjustment.ingredient_history_details.length + ' ingredients';
      }
    }, _this._totalAdjustment = function (adjustment) {
      var total = 0;
      adjustment && adjustment.history_details.forEach(function (hd) {
        total += hd.end_stock - hd.beginning_stock;
      });
      return total;
    }, _this._totalIngredientAdjustment = function (ingredientAdjustment) {
      var total = 0;
      // check apakah semua unitnya sama
      var unitIds = _lodash2.default.countBy(ingredientAdjustment.ingredient_history_details, 'unit_id');
      var unitName = '';
      if ((0, _keys2.default)(unitIds).length > 1) {
        return 'Multiple Adjusted';
      } else {
        ingredientAdjustment.ingredient_history_details.forEach(function (hd) {
          total += hd.adjustment_quantity;
          unitName = hd.unit_name;
        });
        return Number(total).toFixed(2) + ' ' + unitName;
      }
    }, _this._noteAdjustment = function (adjustment) {
      if (adjustment.note) {
        return adjustment.note;
      } else {
        return '-';
      }
    }, _this._noteIngredientAdjustment = function (ingredientAdjustment) {
      if (ingredientAdjustment.note) {
        return ingredientAdjustment.note;
      } else {
        return '-';
      }
    }, _this._onClickRowAdjustment = function (adjustment) {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          isDirtyForm = _this$props5.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onClickRow)(adjustment)));
      } else {
        dispatch((0, _adjustment.onClickRow)(adjustment));
      }
    }, _this._onClickRowIngredientAdjustment = function (ingredientAdjustment) {
      var _this$props6 = _this.props,
          dispatch = _this$props6.dispatch,
          isDirtyForm = _this$props6.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _adjustment.onClickRowIngredientAdjustment)(ingredientAdjustment)));
      } else {
        dispatch((0, _adjustment.onClickRowIngredientAdjustment)(ingredientAdjustment));
      }
    }, _this._hasData = function () {
      var _this$props7 = _this.props,
          adjustments = _this$props7.adjustments,
          ingredientAdjustments = _this$props7.ingredientAdjustments;

      if (_this._namespace() === List.INGREDIENTS) {
        return ingredientAdjustments.length > 0;
      } else if (_this._namespace() === List.ITEMS) {
        return adjustments.length > 0;
      } else {
        return adjustments.length > 0;
      }
    }, _this._namespace = function () {
      var search = _this.props.search;

      if (search) {
        var namespace = search.namespace;

        return namespace;
      } else {
        return '';
      }
    }, _this._totalExpenseIncome = function (adjustment) {
      var expenseIncome = 0;
      adjustment.history_details.forEach(function (hd) {
        if (hd.cogs) {
          expenseIncome += hd.cogs * hd.adjustment;
        }
      });
      return expenseIncome;
    }, _this._totalExpenseIncomeIngredient = function (ingAdj) {
      var expenseIncomeIngredient = 0;
      ingAdj.ingredient_history_details.forEach(function (hd) {
        if (hd.cogs) {
          expenseIncomeIngredient += hd.cogs * hd.adjustment_quantity;
        }
      });
      return expenseIncomeIngredient;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      return this._hasData() && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          this._namespace() === List.ITEMS && this._renderAdjustmentHeader(),
          this._namespace() === List.INGREDIENTS && this._renderIngredientAdjustmentHeader()
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              this._namespace() === List.ITEMS && this._renderAdjustmentTable(),
              this._namespace() === List.INGREDIENTS && this._renderIngredientAdjustmentTable()
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

List.INGREDIENTS = 'ingredients';
List.ITEMS = 'items';


function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      adjustments = _state$inventory$adju.adjustments,
      adjustmentDetail = _state$inventory$adju.adjustmentDetail,
      currentPage = _state$inventory$adju.currentPage,
      totalPage = _state$inventory$adju.totalPage,
      outlets = _state$inventory$adju.outlets,
      ingredientAdjustments = _state$inventory$adju.ingredientAdjustments,
      ingredientAdjustmentDetail = _state$inventory$adju.ingredientAdjustmentDetail;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    adjustments: adjustments,
    ingredientAdjustments: ingredientAdjustments,
    ingredientAdjustmentDetail: ingredientAdjustmentDetail,
    adjustmentDetail: adjustmentDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('adjustment')(state),
    outlets: outlets
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SummaryAdjustment = __webpack_require__(2126);

var _SummaryAdjustment2 = _interopRequireDefault(_SummaryAdjustment);

var _reduxForm = __webpack_require__(7);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SummaryAdjustment = function (_React$Component) {
  (0, _inherits3.default)(SummaryAdjustment, _React$Component);

  function SummaryAdjustment() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SummaryAdjustment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SummaryAdjustment.__proto__ || (0, _getPrototypeOf2.default)(SummaryAdjustment)).call.apply(_ref, [this].concat(args))), _this), _this._renderSummaryInvAdjustment = function () {
      var summaryAdjustment = _this.props.summaryAdjustment;
      var totalCount = summaryAdjustment.totalCount,
          totalExpense = summaryAdjustment.totalExpense,
          totalIncome = summaryAdjustment.totalIncome,
          totalItems = summaryAdjustment.totalItems;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-xs-2' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              totalCount
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'ADJUSTMENTS'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-2' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              totalItems || 0
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'ITEM ADJUSTED'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              (0, _formatter.currencyFormatter)(totalExpense)
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'TOTAL ADJUSTMENT EXPENSE'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              (0, _formatter.currencyFormatter)(totalIncome)
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'TOTAL ADJUSTMENT INCOME'
            )
          )
        )
      );
    }, _this._renderSummaryIngInvAdjustment = function () {
      var summaryIngredientAdjustment = _this.props.summaryIngredientAdjustment;
      var totalCount = summaryIngredientAdjustment.totalCount,
          totalExpense = summaryIngredientAdjustment.totalExpense,
          totalIncome = summaryIngredientAdjustment.totalIncome,
          totalIngredients = summaryIngredientAdjustment.totalIngredients;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-xs-2' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              totalCount
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'ADJUSTMENTS'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-2' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              totalIngredients || 0
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'INGREDIENT ADJUSTED'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              (0, _formatter.currencyFormatter)(totalExpense)
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'TOTAL ADJUSTMENT EXPENSE'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-xs-4' },
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['amount'] },
              (0, _formatter.currencyFormatter)(totalIncome)
            ),
            React.createElement(
              'div',
              { className: _SummaryAdjustment2.default['title'] },
              'TOTAL ADJUSTMENT INCOME'
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SummaryAdjustment, [{
    key: 'render',
    value: function render() {
      var search = this.props.search;


      return React.createElement(
        'div',
        { className: _SummaryAdjustment2.default['summary-adjustment'] + ' visible-md visible-lg' },
        search && search.namespace === 'items' ? this._renderSummaryInvAdjustment() : this._renderSummaryIngInvAdjustment()
      );
    }
  }]);
  return SummaryAdjustment;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$adju = state.inventory.adjustment,
      summaryAdjustment = _state$inventory$adju.summaryAdjustment,
      summaryIngredientAdjustment = _state$inventory$adju.summaryIngredientAdjustment;

  return {
    search: (0, _reduxForm.getFormValues)('search')(state),
    summaryAdjustment: summaryAdjustment,
    summaryIngredientAdjustment: summaryIngredientAdjustment
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SummaryAdjustment);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Inventory = __webpack_require__(2127);

var _Inventory2 = _interopRequireDefault(_Inventory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Inventory = function (_React$Component) {
  (0, _inherits3.default)(Inventory, _React$Component);

  function Inventory() {
    (0, _classCallCheck3.default)(this, Inventory);
    return (0, _possibleConstructorReturn3.default)(this, (Inventory.__proto__ || (0, _getPrototypeOf2.default)(Inventory)).apply(this, arguments));
  }

  (0, _createClass3.default)(Inventory, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'container ' + _Inventory2.default['container'] },
        this.props.children
      );
    }
  }]);
  return Inventory;
}(React.Component);

exports.default = Inventory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _pages = __webpack_require__(38);

var _DropdownButtonSelectIcon = __webpack_require__(292);

var _DropdownButtonSelectIcon2 = _interopRequireDefault(_DropdownButtonSelectIcon);

var _purchaseOrder = __webpack_require__(147);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _confirmAction = __webpack_require__(29);

var _purchaseOrders = __webpack_require__(451);

var mpPurchaseOrders = _interopRequireWildcard(_purchaseOrders);

var _ActionBar = __webpack_require__(2128);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickExport = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          _this$props$search = _this$props.search,
          status = _this$props$search.status,
          keyword = _this$props$search.keyword,
          _this$props$search$da = _this$props$search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate,
          namespace = _this$props$search.namespace,
          outletIds = _this$props$search.outletIds;

      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Inventory Purchase Order - ' + dateLabel;
      mpPurchaseOrders.inventoryPOExport({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      dispatch((0, _purchaseOrder.exportPurchaseOrder)({
        start: (0, _moment2.default)(startDate).format('D/M/YYYY'),
        end: (0, _moment2.default)(endDate).format('D/M/YYYY'),
        status: status,
        keyword: keyword,
        namespace: namespace
      }, filename, outletIds[0]));
    }, _this._onClickCreatePurchaseOrder = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          outletIds = _this$props2.search.outletIds,
          isDirtyForm = _this$props2.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onClickCreatePO)(outletIds)));
      } else {
        dispatch((0, _purchaseOrder.onClickCreatePO)(outletIds));
      }
    }, _this._onChangeOutletIds = function (outletIds) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          _this$props3$search = _this$props3.search,
          _this$props3$search$d = _this$props3$search.date,
          startDate = _this$props3$search$d.startDate,
          endDate = _this$props3$search$d.endDate,
          status = _this$props3$search.status,
          namespace = _this$props3$search.namespace,
          keyword = _this$props3$search.keyword,
          isDirtyForm = _this$props3.isDirtyForm;

      mpPurchaseOrders.inventoryPOChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeOutletIds)(outletIds, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        })));
      } else {
        dispatch((0, _purchaseOrder.onChangeOutletIds)(outletIds, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        }));
      }
    }, _this._onChangeStatus = function (event, status) {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          _this$props4$search = _this$props4.search,
          _this$props4$search$d = _this$props4$search.date,
          startDate = _this$props4$search$d.startDate,
          endDate = _this$props4$search$d.endDate,
          namespace = _this$props4$search.namespace,
          keyword = _this$props4$search.keyword,
          isDirtyForm = _this$props4.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeStatus)(status, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        })));
      } else {
        dispatch((0, _purchaseOrder.onChangeStatus)(status, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        }));
      }
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          _this$props5$search = _this$props5.search,
          outletIds = _this$props5$search.outletIds,
          status = _this$props5$search.status,
          namespace = _this$props5$search.namespace,
          keyword = _this$props5$search.keyword,
          isDirtyForm = _this$props5.isDirtyForm;

      mpPurchaseOrders.inventoryPOChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeDate)(startDate, endDate, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        })));
      } else {
        dispatch((0, _purchaseOrder.onChangeDate)(startDate, endDate, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        }));
      }
    }, _this._onChangeNamespace = function (event, namespace, previousNamespace) {
      // previousNamespace is reserved for mixpanel tracking
      var _this$props6 = _this.props,
          dispatch = _this$props6.dispatch,
          _this$props6$search = _this$props6.search,
          outletIds = _this$props6$search.outletIds,
          status = _this$props6$search.status,
          _this$props6$search$d = _this$props6$search.date,
          startDate = _this$props6$search$d.startDate,
          endDate = _this$props6$search$d.endDate,
          keyword = _this$props6$search.keyword,
          isDirtyForm = _this$props6.isDirtyForm;

      mpPurchaseOrders.inventoryPOChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeNamespace)(namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        })));
      } else {
        dispatch((0, _purchaseOrder.onChangeNamespace)(namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        }));
      }
    }, _this._onChangeKeyword = function (event, keyword) {
      var _this$props7 = _this.props,
          dispatch = _this$props7.dispatch,
          _this$props7$search = _this$props7.search,
          status = _this$props7$search.status,
          namespace = _this$props7$search.namespace,
          _this$props7$search$d = _this$props7$search.date,
          startDate = _this$props7$search$d.startDate,
          endDate = _this$props7$search$d.endDate,
          isDirtyForm = _this$props7.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeKeyword)(keyword, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        })));
      } else {
        dispatch((0, _purchaseOrder.onChangeKeyword)(keyword, namespace, {
          page: 1,
          start: startDate.format('D/M/Y'),
          end: endDate.format('D/M/Y'),
          status: status,
          keyword: keyword
        }));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          isDirtyForm = _props.isDirtyForm,
          isIngredientActive = _props.isIngredientActive;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-10 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline ' + _ActionBar2.default['action-bar'] },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                allOutletOption: true,
                onChangeOutletIds: this._onChangeOutletIds
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                onChange: this._onChangeDate,
                isDirtyForm: isDirtyForm,
                onDirtyFormCallback: this._onChangeDate
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownButtonSelectIcon2.default,
                name: 'namespace',
                options: ActionBar.NAMESPACE_OPTIONS,
                onChange: this._onChangeNamespace,
                isDirtyForm: isDirtyForm,
                onDirtyFormCallback: this._onChangeNamespace,
                disabled: !isIngredientActive
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownButtonSelectIcon2.default,
                name: 'status',
                options: ActionBar.STATUS_OPTIONS,
                onChange: this._onChangeStatus
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _SearchBar2.default,
                name: 'keyword',
                onChange: this._onChangeKeyword,
                placeholder: 'Search'
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-2 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickExport },
              'Export'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ml-10px', onClick: this._onClickCreatePurchaseOrder },
              'Create PO'
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

ActionBar.NAMESPACE_OPTIONS = [{
  id: 'items', name: 'Item Library'
}, {
  id: 'ingredients', name: 'Ingredients'
}];
ActionBar.STATUS_OPTIONS = [{
  id: '', name: 'All Status'
}, {
  id: 'Updated', name: 'Updated', icon: 'glyphicon glyphicon-plus btn btn-warning'
}, {
  id: 'Created', name: 'Created', icon: 'glyphicon glyphicon-plus btn btn-warning '
}, {
  id: 'Fulfilled', name: 'Fulfilled', icon: 'glyphicon glyphicon-ok btn btn-success fulfilled'
}, {
  id: 'Cancelled', name: 'Cancelled', icon: 'glyphicon glyphicon-minus btn btn-danger'
}];


var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.inventory.purchaseOrder.outlets;
  var is_active = state.inventory.ingredientSubscription.subscriptionStatus.is_active;

  return {
    outlets: outlets,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('purchaseOrder')(state),
    isIngredientActive: is_active
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _purchaseOrder = __webpack_require__(147);

var _ConfirmSubmitModal = __webpack_require__(2129);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

var _purchaseOrders = __webpack_require__(451);

var mpPurchaseOrders = _interopRequireWildcard(_purchaseOrders);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmSubmitModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmSubmitModal, _React$Component);

  function ConfirmSubmitModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmSubmitModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmSubmitModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmSubmitModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _purchaseOrder.hideConfirmSubmitModal)());
    }, _this._onClickCreate = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          POForm = _this$props.POForm,
          confirmSubmitModal = _this$props.confirmSubmitModal,
          _this$props$search = _this$props.search,
          namespace = _this$props$search.namespace,
          date = _this$props$search.date,
          suppliers = _this$props.suppliers,
          outlets = _this$props.outlets;
      // TODO seharusnya supplierid insteadof name

      var supplierId = POForm.supplierName;
      var supplier = {};
      var outlet = {};
      // search supplier name
      suppliers.forEach(function (s) {
        if (s.id === parseInt(supplierId)) {
          supplier = s;
        }
      });
      // search outlet name
      outlets.forEach(function (o) {
        if (o.id === POForm.outlet) {
          outlet = o;
        }
      });
      if (confirmSubmitModal.action) {
        if (confirmSubmitModal.action === 'create' || confirmSubmitModal.action === 'createFulfilled') {
          mpPurchaseOrders.inventoryPOCreate({
            fulfilled: confirmSubmitModal.action === 'createFulfilled',
            namespace: namespace,
            supplier: supplier,
            outlet: outlet,
            items: POForm.itemPurchase
          });
        }
        if (confirmSubmitModal.action === 'create') {
          dispatch((0, _purchaseOrder.createPO)(namespace, POForm, date));
        } else if (confirmSubmitModal.action === 'createFulfilled') {
          dispatch((0, _purchaseOrder.createAndFulfilledPO)(namespace, POForm, date));
        } else {
          dispatch((0, _purchaseOrder.editPO)(namespace, POForm));
        }
      }
      dispatch((0, _purchaseOrder.hideConfirmSubmitModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmSubmitModal, [{
    key: 'render',
    value: function render() {
      var confirmSubmitModal = this.props.confirmSubmitModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: confirmSubmitModal.show, dialogClassName: _ConfirmSubmitModal2.default['modal-dialog'] },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmSubmitModal2.default['modal-header'] },
          'Information'
        ),
        confirmSubmitModal.action !== 'createFulfilled' && React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Are you sure you want to proceed?'
        ),
        confirmSubmitModal.action === 'createFulfilled' && React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Are you sure you want to proceed? You cannot edit or cancel this Purchase Order after creating.'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { type: 'button', onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary',
              onClick: this._onClickCreate
            },
            'OK'
          )
        )
      );
    }
  }]);
  return ConfirmSubmitModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$purc = state.inventory.purchaseOrder,
      confirmSubmitModal = _state$inventory$purc.confirmSubmitModal,
      outlets = _state$inventory$purc.outlets,
      suppliers = _state$inventory$purc.suppliers;

  return {
    POForm: (0, _reduxForm.getFormValues)('purchaseOrder')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    confirmSubmitModal: confirmSubmitModal,
    outlets: outlets,
    suppliers: suppliers
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmSubmitModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _FormPurchaseOrder = __webpack_require__(2130);

var _FormPurchaseOrder2 = _interopRequireDefault(_FormPurchaseOrder);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _reactRedux = __webpack_require__(6);

var _purchaseOrder = __webpack_require__(147);

var _formatter = __webpack_require__(11);

var _notifications = __webpack_require__(23);

var _reactBootstrap = __webpack_require__(10);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _constants = __webpack_require__(81);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var itemPurchaseErrors = [];
  if (values.itemPurchase) {
    values.itemPurchase.forEach(function (member, index) {
      var order = member.order + '';
      var unitcost = member.unitcost + '';
      var memberErrors = {};
      if (!member.order) {
        if ('' + member.order !== '0') {
          memberErrors.order = 'Please enter a value';
          itemPurchaseErrors[index] = memberErrors;
        }
      } else {
        if (order.match(/^0\d/)) {
          memberErrors.order = 'Please enter a valid Number';
          itemPurchaseErrors[index] = memberErrors;
        }
        if (parseInt(member.order) > 999999) {
          memberErrors.order = 'Order must be less than 999999';
          itemPurchaseErrors[index] = memberErrors;
        }
      }
      if (!member.unitcost) {
        if ('' + member.unitcost !== '0') {
          memberErrors.unitcost = 'Please enter a value';
          itemPurchaseErrors[index] = memberErrors;
        }
      } else {
        if (unitcost.match(/^0\d/)) {
          memberErrors.unitcost = 'Please enter a valid Number';
          itemPurchaseErrors[index] = memberErrors;
        }
        if (parseInt(member.unitcost) > 99999999999) {
          memberErrors.unitcost = 'Unit cost must be less than 99.999.999.999';
          itemPurchaseErrors[index] = memberErrors;
        }
      }
    });
  }
  if (itemPurchaseErrors.length) {
    errors.itemPurchase = itemPurchaseErrors;
  }
  return errors;
};

var popoverFocus = function popoverFocus(_ref) {
  var content = _ref.content;
  return React.createElement(
    _reactBootstrap.Popover,
    { id: 'purchaseOrder' },
    content
  );
};

var normalizeNumber = function normalizeNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';

  if (typeof value === 'string') {
    return value.replace(/[^\d]/g, '');
  } else {
    return value;
  }
};

var HeaderField = function HeaderField(member, index, fields) {
  var isOneItem = fields.get(index).is_item;
  return React.createElement(
    'div',
    { className: 'row mk-grouped-input mb-10px' },
    React.createElement(
      'div',
      { className: 'col-sm-3 text-center ' + _FormPurchaseOrder2.default['header-item'] },
      isOneItem ? 'ITEM' : 'VARIANT'
    ),
    React.createElement(
      'div',
      { className: 'col-sm-2 text-center ' + _FormPurchaseOrder2.default['header-item'] },
      'IN STOCK'
    ),
    React.createElement(
      'div',
      { className: 'col-sm-2 text-center ' + _FormPurchaseOrder2.default['header-item'] },
      'ORDER'
    ),
    React.createElement(
      'div',
      { className: 'col-sm-2 text-center ' + _FormPurchaseOrder2.default['header-item'] },
      'UNIT COST'
    ),
    React.createElement(
      'div',
      { className: 'col-sm-3 text-center' },
      'TOTAL'
    )
  );
};

var HeaderTable = function HeaderTable(member, index, fields) {
  var itemName = fields.get(index).item_name;
  return React.createElement(
    'div',
    { className: 'form-group col-sm-12 mb-0px' },
    React.createElement('input', { value: itemName, readOnly: true, className: 'input-border-right item-name text-center form-control' }),
    React.createElement(
      'span',
      { className: 'btn-addon trans-1 ' + _FormPurchaseOrder2.default['remove-item'], onClick: function onClick() {
          // use counter because when remove index, fields immediately shifts up
          var i = 0;
          fields.getAll().forEach(function (tmp, idx) {
            if (tmp.item_id === fields.get(index).item_id) {
              fields.remove(idx - i);
              i++;
            }
          });
        } },
      React.createElement('i', { className: 'fa fa-times-circle' })
    )
  );
};

var nameField = function nameField(props) {
  var input = props.input,
      isItem = props.isItem,
      isLast = props.isLast;

  if (isItem) {
    return React.createElement(
      _reactBootstrap.OverlayTrigger,
      { placement: 'top', trigger: 'hover', overlay: popoverFocus({ content: input.value }) },
      React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: _FormPurchaseOrder2.default.itemDetailLeft + ' form-control' }))
    );
  } else if (isLast) {
    return React.createElement(
      _reactBootstrap.OverlayTrigger,
      { placement: 'top', trigger: 'hover', overlay: popoverFocus({ content: input.value }) },
      React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: _FormPurchaseOrder2.default.itemDetailLeftDown + ' form-control' }))
    );
  } else {
    return React.createElement(
      _reactBootstrap.OverlayTrigger,
      { placement: 'top', trigger: 'hover', overlay: popoverFocus({ content: input.value }) },
      React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: _FormPurchaseOrder2.default.itemDetail + ' form-control' }))
    );
  }
};

var stockField = function stockField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { placeholder: input.value, readOnly: true, className: _FormPurchaseOrder2.default.itemStock + ' form-control' }));
};

var totalField = function totalField(props) {
  var input = props.input,
      classNameField = props.classNameField;

  return React.createElement('input', (0, _extends3.default)({}, input, { readOnly: true, placeholder: 'Total', className: classNameField + ' form-control' }));
};

var Form = function (_React$Component) {
  (0, _inherits3.default)(Form, _React$Component);

  function Form(props) {
    (0, _classCallCheck3.default)(this, Form);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = { openErrorAlert: false, errorItemName: null };
    return _this;
  }

  (0, _createClass3.default)(Form, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          suppliers = _props.suppliers,
          outlets = _props.outlets,
          selectedOutlet = _props.selected_outlet,
          handleSubmit = _props.handleSubmit,
          purchaseOrderDetail = _props.purchaseOrderDetail,
          search = _props.search;

      var namespace = 'item';
      if (search) {
        namespace = search.namespace;
      }
      var isEdit = purchaseOrderDetail !== null;
      // TODO harusnya supplierid insteadof supplier name
      return React.createElement(
        'form',
        { className: _FormPurchaseOrder2.default.wrapper },
        React.createElement(
          'div',
          { className: _FormPurchaseOrder2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: 'row' },
            !isEdit && React.createElement(
              'div',
              { className: 'col-sm-12 form-group' },
              React.createElement(_LabelSection2.default, { title: 'choose outlet' }),
              React.createElement(
                _reduxForm.Field,
                {
                  component: 'select',
                  name: 'outlet',
                  onChange: this._onChangeOutletId,
                  className: 'form-control',
                  disabled: selectedOutlet.length === 1 || isEdit
                },
                outlets.map(function (o) {
                  return React.createElement(
                    'option',
                    { value: o.id },
                    o.name
                  );
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-12 form-group' },
              React.createElement(_LabelSection2.default, { title: 'choose supplier' }),
              React.createElement(
                _reduxForm.Field,
                {
                  component: 'select',
                  name: 'supplierName',
                  className: 'form-control',
                  disabled: isEdit
                },
                suppliers.map(function (s) {
                  return React.createElement(
                    'option',
                    { value: s.id },
                    s.name
                  );
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-12 form-group' },
              React.createElement(_LabelSection2.default, { title: 'note' }),
              React.createElement(_reduxForm.Field, {
                component: 'textarea',
                name: 'note',
                className: 'form-control',
                placeholder: 'Notes',
                rows: '5'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-sm-12 form-group' },
              React.createElement(_LabelSection2.default, { title: 'Purchase Order' }),
              React.createElement(
                'div',
                { className: _FormPurchaseOrder2.default['warning-style'] },
                this.state.openErrorAlert && React.createElement(
                  _reactBootstrap.Alert,
                  { bsStyle: 'danger' },
                  React.createElement('span', { onClick: this._dismissError, className: 'glyphicon glyphicon-remove ' + _FormPurchaseOrder2.default['dismiss-warning-button'], 'aria-hidden': 'true' }),
                  React.createElement(
                    'h5',
                    { className: 'ml-30px' },
                    'Maximum ',
                    this.state.errorItemName,
                    ' in stock 999999'
                  )
                )
              ),
              React.createElement(_reduxForm.FieldArray, {
                name: 'itemPurchase',
                component: this._renderItemPurchase
              }),
              React.createElement(
                'button',
                { className: 'btn btn-primary mt-20px ' + _FormPurchaseOrder2.default['btn-addItems'],
                  onClick: this._onClickAddItems },
                namespace === _constants.NAMESPACE_INGREDIENTS ? 'Add Ingredients' : 'Add Items'
              ),
              React.createElement(
                'div',
                { className: _FormPurchaseOrder2.default['label-track-item'] },
                React.createElement('i', { className: 'fa fa-exclamation-circle ' + _FormPurchaseOrder2.default['info-icon'] }),
                namespace === _constants.NAMESPACE_INGREDIENTS ? React.createElement(
                  'label',
                  null,
                  'Make sure the ingredients have been tracked on ',
                  React.createElement(
                    _reactRouter.Link,
                    { to: '/ingredient/list', className: _FormPurchaseOrder2.default['link-library'] },
                    'Ingredient'
                  ),
                  ' page!'
                ) : React.createElement(
                  'label',
                  null,
                  'Make sure the items have been tracked on ',
                  React.createElement(
                    _reactRouter.Link,
                    { to: '/library/list', className: _FormPurchaseOrder2.default['link-library'] },
                    'Library'
                  ),
                  ' page!'
                )
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _FormPurchaseOrder2.default.footer },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default ' + _FormPurchaseOrder2.default['btn-cancel'], type: 'button', onClick: this._onClickCancel },
              'Cancel'
            ),
            !purchaseOrderDetail && React.createElement(
              'button',
              { className: 'btn btn-primary ' + _FormPurchaseOrder2.default['btn-save'], onClick: handleSubmit(this._onClickCreateAndFulfill) },
              'Create and Fulfill'
            ),
            !purchaseOrderDetail && React.createElement(
              'button',
              { className: 'btn btn-primary ' + _FormPurchaseOrder2.default['btn-save'], onClick: handleSubmit(this._onClickCreate) },
              'Create'
            ),
            purchaseOrderDetail && React.createElement(
              'button',
              { className: 'btn btn-primary ' + _FormPurchaseOrder2.default['btn-save'], onClick: handleSubmit(this._onClickSave) },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return Form;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._dismissError = function () {
    _this2.setState({ openErrorAlert: false, errorItemName: null });
  };

  this._onClickCancel = function (e) {
    _this2.props.dispatch((0, _purchaseOrder.onClickCancel)());
    e.preventDefault();
    e.stopPropagation();
  };

  this._onClickAddItems = function (e) {
    var dispatch = _this2.props.dispatch;

    dispatch((0, _purchaseOrder.showModalItemPurchase)());
    e.preventDefault();
    e.stopPropagation();
  };

  this._onClickCreateAndFulfill = function (values) {
    var _props2 = _this2.props,
        dispatch = _props2.dispatch,
        search = _props2.search;

    var notZero = false;
    values.itemPurchase.forEach(function (item) {
      if (parseInt(item.order) > 0) {
        notZero = true;
      }
    });
    if (values.itemPurchase.length > 0) {
      if (notZero) {
        _this2.props.onSubmit((0, _extends3.default)({}, values, { action: 'createFulfilled' }));
      } else {
        dispatch((0, _notifications.error)('Total order must be greater than 0'));
      }
    } else {
      if (search.namespace !== _constants.NAMESPACE_INGREDIENTS) {
        dispatch((0, _notifications.error)('Please add purchase item before saving'));
      } else {
        dispatch((0, _notifications.error)('Please add purchase ingredient before saving'));
      }
    }
  };

  this._onChangeOutletId = function (event) {
    var dispatch = _this2.props.dispatch;

    dispatch((0, _purchaseOrder.onChangeOutletForm)());
  };

  this._onClickCreate = function (values) {
    var _props3 = _this2.props,
        dispatch = _props3.dispatch,
        onSubmit = _props3.onSubmit,
        search = _props3.search;

    var notZero = false;
    values.itemPurchase.forEach(function (item) {
      if (parseInt(item.order) > 0) {
        notZero = true;
      }
    });

    if (values.itemPurchase.length > 0) {
      if (notZero) {
        onSubmit((0, _extends3.default)({}, values, { action: 'create' }));
      } else {
        dispatch((0, _notifications.error)('Total order must be greater than 0'));
      }
    } else {
      if (search.namespace !== _constants.NAMESPACE_INGREDIENTS) {
        dispatch((0, _notifications.error)('Please add purchase item before saving'));
      } else {
        dispatch((0, _notifications.error)('Please add purchase ingredient before saving'));
      }
    }
  };

  this._onClickSave = function (values) {
    var _props4 = _this2.props,
        dispatch = _props4.dispatch,
        onSubmit = _props4.onSubmit,
        search = _props4.search;

    var notZero = false;
    values.itemPurchase.forEach(function (item) {
      if (parseInt(item.order) > 0) {
        notZero = true;
      }
    });
    if (notZero) {
      if (values.itemPurchase.length > 0) {
        onSubmit((0, _extends3.default)({}, values, { action: 'saved' }));
      } else {
        if (search.namespace !== _constants.NAMESPACE_INGREDIENTS) {
          dispatch((0, _notifications.error)('Please add purchase item before saving'));
        } else {
          dispatch((0, _notifications.error)('Please add purchase ingredient before saving'));
        }
      }
    } else {
      dispatch((0, _notifications.error)('Total order must be greater than 0'));
    }
  };

  this._renderItemPurchase = function (_ref2) {
    var fields = _ref2.fields;

    var total = 0;
    var itemId = 0;
    return React.createElement(
      'div',
      null,
      fields.map(function () {
        for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
          props[_key] = arguments[_key];
        }

        var index = props[1];

        var field = fields.get(index);
        var qty = !field.order ? 0 : field.order;
        var price = !field.unitcost ? 0 : field.unitcost;
        var subTotal = normalizeNumber(qty * price);
        var shouldRenderHeader = itemId === 0 || itemId !== field.item_id;
        var isItem = field.is_item;
        itemId = field.item_id;
        total += parseFloat(subTotal);
        return React.createElement(
          'div',
          null,
          shouldRenderHeader && React.createElement(
            'div',
            { className: 'row mk-grouped-list-input' },
            HeaderField.apply(undefined, props)
          ),
          React.createElement(
            'div',
            { className: 'row mk-grouped-list-input' },
            shouldRenderHeader && !isItem && HeaderTable.apply(undefined, props),
            _this2._itemPurchase.apply(_this2, props)
          )
        );
      }),
      React.createElement(
        'div',
        { className: 'pull-left mt-30px' },
        'TOTAL'
      ),
      React.createElement(
        'div',
        { className: 'pull-right mt-30px' },
        (0, _formatter.rupiah)(Math.round(total))
      )
    );
  };

  this._itemPurchase = function (member, index, fields) {
    var namespace = _this2.props.search.namespace;

    var isItem = fields.get(index).is_item;
    var isLast = !fields.get(index + 1) ? true : fields.get(index + 1).item_id !== fields.get(index).item_id;

    var _fields$get = fields.get(index),
        order = _fields$get.order,
        unitcost = _fields$get.unitcost;

    var total = unitcost * order;
    if (isNaN(total)) {
      total = 0;
    }
    return React.createElement(
      'div',
      { className: 'mk-grouped-input grouped-form' },
      React.createElement(
        'div',
        { className: 'form-group col-md-3 ' + (isLast ? _FormPurchaseOrder2.default['mb-25px'] : '') },
        isItem && React.createElement(_reduxForm.Field, {
          component: nameField,
          name: member + '.item_name',
          type: 'text',
          isItem: isItem,
          isLast: isLast
        }),
        !isItem && React.createElement(_reduxForm.Field, {
          component: nameField,
          name: member + '.item_var_name',
          type: 'text',
          isItem: isItem,
          isLast: isLast
        })
      ),
      React.createElement(
        'div',
        { className: 'form-group col-md-2' },
        React.createElement(_reduxForm.Field, {
          component: stockField,
          name: member + '.instock',
          type: 'text'
        })
      ),
      React.createElement(
        'div',
        { className: 'form-group col-md-2' },
        React.createElement(_reduxForm.Field, {
          component: _SettingField2.default,
          name: member + '.order',
          className: 'form-control',
          inputClassName: _FormPurchaseOrder2.default['input-field-30px'],
          placeholder: 'Order',
          normalize: _this2._normalizeOrder(index),
          onChange: function onChange(event, value) {
            if (namespace === _constants.NAMESPACE_INGREDIENTS) {
              total = parseFloat(value) * parseInt(unitcost);
            } else {
              total = parseInt(value) * parseInt(unitcost);
            }
            total = !isNaN(total) ? total : 0;
            _this2.props.dispatch((0, _reduxForm.change)('purchaseOrder', member + '.total', (0, _formatter.rupiah)(total)));
            return value;
          },
          positiveNumberOnly: true,
          maxFractionDigits: namespace === _constants.NAMESPACE_INGREDIENTS ? 2 : 0
        })
      ),
      React.createElement(
        'div',
        { className: 'form-group col-md-2' },
        React.createElement(_reduxForm.Field, {
          component: _SettingField2.default,
          name: member + '.unitcost',
          className: 'form-control',
          placeholder: 'Unit Cost',
          positiveNumberOnly: true,
          inputClassName: _FormPurchaseOrder2.default['input-field-30px'],
          onChange: function onChange(event, value) {
            if (namespace === _constants.NAMESPACE_INGREDIENTS) {
              total = parseInt(value) * parseFloat(order);
            } else {
              total = parseInt(value) * parseInt(order);
            }
            total = !isNaN(total) ? total : 0;
            _this2.props.dispatch((0, _reduxForm.change)('purchaseOrder', member + '.total', (0, _formatter.rupiah)(total)));
            return value;
          }
        })
      ),
      React.createElement(
        'div',
        { className: 'form-group col-md-3' },
        isItem && React.createElement(_reduxForm.Field, {
          component: totalField,
          name: member + '.total',
          classNameField: _FormPurchaseOrder2.default.itemDetailRight,
          type: 'text'
        }),
        !isItem && isLast && React.createElement(_reduxForm.Field, {
          component: totalField,
          name: member + '.total',
          classNameField: _FormPurchaseOrder2.default.itemDetailRightDown,
          type: 'text'
        }),
        !isLast && !isItem && React.createElement(_reduxForm.Field, {
          component: totalField,
          name: member + '.total',
          classNameField: _FormPurchaseOrder2.default.itemDetail,
          type: 'text'
        }),
        isItem && React.createElement(
          'span',
          { className: 'btn-addon trans-1', onClick: function onClick() {
              return fields.remove(index);
            } },
          React.createElement('i', { className: 'fa fa-times-circle' })
        )
      )
    );
  };

  this._normalizeOrder = function (index) {
    return function (value, previousValue, allValues) {
      var namespace = _this2.props.search.namespace;

      if (value === '') {
        return value;
      } else {
        if (!isNaN(value)) {
          if (parseInt(value) + parseInt(allValues.itemPurchase[index].instock) <= 999999) {
            return value;
          } else {
            _this2._onErrorOrder(namespace === _constants.NAMESPACE_INGREDIENTS ? allValues.itemPurchase[index].item_name : !allValues.itemPurchase[index].item_var_name ? allValues.itemPurchase[index].item_name : allValues.itemPurchase[index].item_var_name);
            return 999999 - parseInt(allValues.itemPurchase[index].instock);
          }
        } else {
          return previousValue;
        }
      }
    };
  };

  this._onErrorOrder = function (item) {
    _this2.setState({ openErrorAlert: true, errorItemName: item });
    setTimeout(function () {
      this.setState({ openErrorAlert: false });
    }.bind(_this2), 1000);
  };
};

var mapForm = {
  form: 'purchaseOrder',
  touchOnBlur: true,
  touchOnChange: true,
  validate: validate
};

function mapStateToProps(state) {
  var _state$inventory$purc = state.inventory.purchaseOrder,
      suppliers = _state$inventory$purc.suppliers,
      outlets = _state$inventory$purc.outlets,
      selected_outlet = _state$inventory$purc.selected_outlet,
      purchaseOrderDetail = _state$inventory$purc.purchaseOrderDetail;

  return {
    suppliers: suppliers,
    outlets: outlets,
    selected_outlet: selected_outlet,
    purchaseOrderDetail: purchaseOrderDetail,
    POForm: (0, _reduxForm.getFormValues)('purchaseOrder')(state),
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(Form));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _List = __webpack_require__(2131);

var _List2 = _interopRequireDefault(_List);

var _purchaseOrder = __webpack_require__(147);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _formatter = __webpack_require__(11);

var _confirmAction = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// noinspection JSUnresolvedVariable
var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onReachBottom = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          purchaseOrders = _this$props.purchaseOrders,
          dispatch = _this$props.dispatch,
          _this$props$search = _this$props.search,
          _this$props$search$da = _this$props$search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate,
          keyword = _this$props$search.keyword,
          status = _this$props$search.status,
          namespace = _this$props$search.namespace;

      dispatch((0, _purchaseOrder.purchaseOrderRequest)(namespace, {
        page: currentPage + 1,
        start: startDate.toString(),
        end: endDate.toString(),
        keyword: keyword,
        status: status
      }, purchaseOrders));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._onClickRow = function (purchaseOrder) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          namespace = _this$props3.search.namespace,
          isDirtyForm = _this$props3.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onClickRow)(purchaseOrder, namespace)));
      } else {
        dispatch((0, _purchaseOrder.onClickRow)(purchaseOrder, namespace));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          purchaseOrders = _props.purchaseOrders,
          purchaseOrderDetail = _props.purchaseOrderDetail,
          search = _props.search;

      var outletIds = null;
      if (search) {
        outletIds = search.outletIds;
      }
      var showOutlet = outletIds && outletIds.length > 1;

      return purchaseOrders.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Date'
              ),
              showOutlet && React.createElement(
                'th',
                null,
                'Outlet'
              ),
              React.createElement(
                'th',
                null,
                'Supplier'
              ),
              React.createElement(
                'th',
                null,
                'Order No.'
              ),
              React.createElement(
                'th',
                null,
                'Total'
              ),
              React.createElement(
                'th',
                null,
                'Status'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                purchaseOrders.length > 0 && purchaseOrders.map(function (purchaseOrder) {
                  if (purchaseOrder.isdaterow) {
                    return React.createElement(
                      'tr',
                      null,
                      React.createElement(
                        'td',
                        { colSpan: showOutlet ? 6 : 5, className: _List2.default.parentRow },
                        (0, _moment2.default)(purchaseOrder.created_at).format('ddd MMM DD YYYY')
                      )
                    );
                  } else {
                    var statusIcon = '';
                    if (purchaseOrder.status === 'Created' || purchaseOrder.status === 'Updated') {
                      statusIcon = 'btn-warning glyphicon-plus';
                    } else if (purchaseOrder.status === 'Fulfilled') {
                      statusIcon = 'btn-success glyphicon-ok';
                    } else if (purchaseOrder.status === 'Cancelled') {
                      statusIcon = 'btn-danger glyphicon-minus';
                    }
                    return React.createElement(
                      'tr',
                      { className: '' + (purchaseOrderDetail && purchaseOrder.id === purchaseOrderDetail.id ? _List2.default.selected : ''),
                        onClick: function onClick() {
                          return _this2._onClickRow(purchaseOrder);
                        } },
                      React.createElement(
                        'td',
                        null,
                        (0, _moment2.default)(purchaseOrder.created_at).format('HH:mm')
                      ),
                      outletIds && outletIds.length > 1 && React.createElement(
                        'td',
                        null,
                        purchaseOrder.outlet.name
                      ),
                      React.createElement(
                        'td',
                        null,
                        purchaseOrder.supplier_name
                      ),
                      React.createElement(
                        'td',
                        null,
                        '#',
                        purchaseOrder.order_no
                      ),
                      React.createElement(
                        'td',
                        null,
                        (0, _formatter.rupiah)(purchaseOrder.total)
                      ),
                      React.createElement(
                        'td',
                        null,
                        React.createElement('i', { className: 'glyphicon btn ' + statusIcon + ' ' + _List2.default.icon }),
                        React.createElement(
                          'span',
                          { className: _List2.default.status },
                          purchaseOrder.status
                        )
                      )
                    );
                  }
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$purc = state.inventory.purchaseOrder,
      purchaseOrders = _state$inventory$purc.purchaseOrders,
      purchaseOrderDetail = _state$inventory$purc.purchaseOrderDetail,
      currentPage = _state$inventory$purc.currentPage,
      totalPage = _state$inventory$purc.totalPage;

  return {
    purchaseOrders: purchaseOrders,
    purchaseOrderDetail: purchaseOrderDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    isDirtyForm: (0, _reduxForm.isDirty)('purchaseOrder')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _purchaseOrder = __webpack_require__(147);

var _ModalAddItem = __webpack_require__(2132);

var _ModalAddItem2 = _interopRequireDefault(_ModalAddItem);

var _formatter = __webpack_require__(11);

var _WarningMessage = __webpack_require__(444);

var _WarningMessage2 = _interopRequireDefault(_WarningMessage);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _constants = __webpack_require__(81);

var _ItemHasRecipe = __webpack_require__(440);

var _ItemHasRecipe2 = _interopRequireDefault(_ItemHasRecipe);

var _confirmAction = __webpack_require__(29);

var _SearchModal = __webpack_require__(293);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var itemsErrors = [];
  if (values.items) {
    values.items.forEach(function (member, index) {
      var unitCostString = member.unitcost + '';
      var orderString = member.order + '';
      var memberErrors = {};
      if (member.order && orderString.match(/^0\d/)) {
        memberErrors.order = 'Please enter a valid Number';
        itemsErrors[index] = memberErrors;
      }
      if (parseInt(member.order) > 999999) {
        memberErrors.order = 'Order must be less than 999999';
        itemsErrors[index] = memberErrors;
      }
      if (member.unitcost && unitCostString.match(/^0\d/)) {
        memberErrors.unitcost = 'Please enter a valid Number';
        itemsErrors[index] = memberErrors;
      }
      if (parseInt(member.unitcost) > 99999999999) {
        memberErrors.unitcost = 'Unit cost must be less than 99.999.999.999';
        itemsErrors[index] = memberErrors;
      }
    });
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors;
  }
  return errors;
}; /**
    * Created by emhaje-workspace on 5/18/17.
    */


var normalizeNumber = function normalizeNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var previousValue = arguments[1];

  if (value === '') {
    return value;
  } else {
    if (!isNaN(value)) {
      return value;
    } else {
      return previousValue;
    }
  }
};

var nameField = function nameField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: _ModalAddItem2.default.itemDetail + ' form-control' }));
};

var stockField = function stockField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { placeholder: input.value, readOnly: true, className: _ModalAddItem2.default.itemStock + ' form-control' }));
};

var totalField = function totalField(props) {
  var input = props.input;

  return React.createElement('input', (0, _extends3.default)({}, input, { readOnly: true, placeholder: 'Order', className: _ModalAddItem2.default.itemDetail + ' form-control' }));
};

var ModalAddItem = function (_React$Component) {
  (0, _inherits3.default)(ModalAddItem, _React$Component);

  function ModalAddItem(props) {
    (0, _classCallCheck3.default)(this, ModalAddItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalAddItem.__proto__ || (0, _getPrototypeOf2.default)(ModalAddItem)).call(this, props));

    _this._hasMore = function () {
      var _this$props$items = _this.props.items,
          currentPage = _this$props$items.currentPage,
          totalPage = _this$props$items.totalPage;

      return currentPage < totalPage;
    };

    _this._onErrorOrder = function (name) {
      _this.setState({ openErrorAlert: true, errorItemName: name });
      setTimeout(function () {
        this.setState({ openErrorAlert: false, errorItemName: null });
      }.bind(_this), 1000);
    };

    _this._onClickSave = function (values) {
      _this.setState({ selectValue: null });
      _this.props.onSubmit(values);
    };

    _this._onHide = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      _this.setState({ selectValue: null, errorItemName: null });
      dispatch((0, _purchaseOrder.onCancelModalAddItem)());
    };

    _this._onKeywordChange = function (value) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          POForm = _this$props.POForm,
          namespace = _this$props.search.namespace;

      _this.setState({ selectValue: value });
      dispatch((0, _reduxForm.change)('addItemPurchase', 'items', []));
      dispatch((0, _purchaseOrder.getItemsFromAPI)({
        outlet_id: POForm.outlet,
        page: 1,
        per_page: 100,
        no_categories: true,
        keyword: value,
        namespace: namespace,
        first: false
      }));
    };

    _this._onSearchReachBottom = function () {
      var _this$props2 = _this.props,
          _this$props2$items = _this$props2.items,
          currentPage = _this$props2$items.currentPage,
          total = _this$props2$items.total_pages,
          results = _this$props2$items.results,
          dispatch = _this$props2.dispatch,
          POForm = _this$props2.POForm,
          namespace = _this$props2.search.namespace;

      if (total > currentPage) {
        dispatch((0, _purchaseOrder.getItemsFromAPI)({
          outlet_id: POForm.outlet,
          page: currentPage + 1,
          per_page: 100,
          no_categories: true,
          keyword: _this.state.selectValue,
          previousItems: results,
          namespace: namespace,
          first: false
        }));
      }
    };

    _this._onSelectedItem = function (value) {
      var _this$props3 = _this.props,
          items = _this$props3.items,
          dispatch = _this$props3.dispatch,
          POForm = _this$props3.POForm,
          namespace = _this$props3.search.namespace;

      var data = null;
      items.results.forEach(function (i) {
        if (i.id === value.value) {
          data = i;
        }
      });
      if (data) {
        dispatch((0, _purchaseOrder.setModalDataForm)(namespace, data, POForm.itemPurchase));
        _this.setState({ selectValue: value.value });
        if (namespace !== _constants.NAMESPACE_INGREDIENTS) {
          _this.setState({ itemHasRecipe: data.is_recipe });
        }
      } else {
        _this.setState({ selectValue: null });
      }
    };

    _this._dismissError = function () {
      _this.setState({ openErrorAlert: false, errorItemName: null });
    };

    _this._normalizeOrder = function (index) {
      return function (value, previousValue, allValues) {
        var namespace = _this.props.search.namespace;

        if (value === '') {
          return value;
        } else {
          if (!isNaN(value)) {
            if (value) {
              if (parseInt(value) + parseInt(allValues.items[index].instock) <= 999999) {
                return value;
              } else {
                _this._onErrorOrder(namespace === _constants.NAMESPACE_INGREDIENTS ? allValues.items[index].item_name : !allValues.items[index].item_var_name ? allValues.items[index].item_name : allValues.items[index].item_var_name);
                return 999999 - parseInt(allValues.items[index].instock);
              }
            } else {
              return value;
            }
          }
        }
      };
    };

    _this._headerField = function (_ref) {
      var isOneItem = _ref.isOneItem;
      var namespace = _this.props.search.namespace;

      return React.createElement(
        'div',
        { className: 'row ' + _ModalAddItem2.default.item },
        namespace !== _constants.NAMESPACE_INGREDIENTS && React.createElement(
          'div',
          { className: 'col-md-3 text-center ' + _ModalAddItem2.default.itemHeader },
          isOneItem ? 'Item' : 'Variant'
        ),
        namespace === _constants.NAMESPACE_INGREDIENTS && React.createElement(
          'div',
          { className: 'col-md-3 text-center ' + _ModalAddItem2.default.itemHeader },
          'Unit'
        ),
        React.createElement(
          'div',
          { className: 'col-md-2 text-center ' + _ModalAddItem2.default.itemHeader },
          'In Stock'
        ),
        React.createElement(
          'div',
          { className: 'col-md-2 text-left ' + _ModalAddItem2.default.itemHeader },
          'Order'
        ),
        React.createElement(
          'div',
          { className: 'col-md-2 text-left ' + _ModalAddItem2.default.itemHeader },
          'Unit Cost'
        ),
        React.createElement(
          'div',
          { className: 'col-md-3 text-center ' + _ModalAddItem2.default.itemHeader },
          'Total'
        )
      );
    };

    _this._fieldItem = function (_ref2) {
      var fields = _ref2.fields;

      return React.createElement(
        'div',
        { className: 'mk-grouped-list-input' },
        fields.map(_this._itemVariant)
      );
    };

    _this._itemVariant = function (member, index, fields) {
      var namespace = _this.props.search.namespace;

      var isItem = fields.get(index).is_item;

      var _fields$get = fields.get(index),
          order = _fields$get.order,
          unitcost = _fields$get.unitcost;

      var total = order * unitcost;
      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-md-3 ' + _ModalAddItem2.default.name },
          isItem && React.createElement(_reduxForm.Field, {
            component: nameField,
            name: member + '.item_name',
            type: 'text'
          }),
          !isItem && React.createElement(_reduxForm.Field, {
            component: nameField,
            name: member + '.item_var_name',
            type: 'text'
          })
        ),
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.item_id',
          type: 'hidden'
        }),
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.item_var_id',
          type: 'hidden'
        }),
        React.createElement(
          'div',
          { className: 'form-group col-md-2 ' + _ModalAddItem2.default.middleTable },
          React.createElement(_reduxForm.Field, {
            component: stockField,
            name: member + '.instock',
            type: 'text'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-md-1 ' + _ModalAddItem2.default.middleTable },
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            name: member + '.order',
            inputClassName: _ModalAddItem2.default.itemDetail,
            type: 'text',
            placeholder: 'Order',
            normalize: _this._normalizeOrder(index),
            onChange: function onChange(event, value) {
              if (namespace === _constants.NAMESPACE_INGREDIENTS) {
                total = parseFloat(value) * parseInt(unitcost);
              } else {
                total = parseInt(value) * parseInt(unitcost);
              }
              total = !isNaN(total) ? total : 0;
              _this.props.dispatch((0, _reduxForm.change)('addItemPurchase', member + '.total', (0, _formatter.rupiah)(total)));
              return value;
            },
            positiveNumberOnly: true,
            maxFractionDigits: namespace === _constants.NAMESPACE_INGREDIENTS ? 2 : 0
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-md-3 ' + _ModalAddItem2.default.middleTable + ' ' + _ModalAddItem2.default.unitCostContainer },
          React.createElement(
            'div',
            { className: _ModalAddItem2.default.rpfield },
            'Rp.'
          ),
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            name: member + '.unitcost',
            type: 'text',
            placeholder: 'Unit Cost',
            inputClassName: _ModalAddItem2.default.unitCost,
            normalize: normalizeNumber,
            onChange: function onChange(event, value) {
              if (namespace === _constants.NAMESPACE_INGREDIENTS) {
                total = parseInt(value) * parseFloat(order);
              } else {
                total = parseInt(value) * parseInt(order);
              }
              total = !isNaN(total) ? total : 0;
              _this.props.dispatch((0, _reduxForm.change)('addItemPurchase', member + '.total', (0, _formatter.rupiah)(total)));
              return value;
            },
            positiveNumberOnly: true,
            maxFractionDigits: 0
          })
        ),
        React.createElement(
          'div',
          { className: _ModalAddItem2.default.total + ' form-group col-md-3' },
          React.createElement(_reduxForm.Field, {
            component: totalField,
            name: member + '.total',
            type: 'text',
            disabled: true
          })
        )
      );
    };

    _this._clickIngredient = function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          _this$props4$search$d = _this$props4.search.date,
          startDate = _this$props4$search$d.startDate,
          endDate = _this$props4$search$d.endDate,
          keyword = _this$props4.keyword;

      var params = {
        page: 1,
        start: startDate.format('D/M/Y'),
        end: endDate.format('D/M/Y'),
        keyword: keyword
      };
      dispatch((0, _confirmAction.askConfirmAction)((0, _purchaseOrder.onChangeNamespace)('ingredients', params)));
    };

    _this.state = {
      openErrorAlert: false,
      selectValue: null,
      errorItemName: null,
      itemHasRecipe: false
    };
    return _this;
  }

  (0, _createClass3.default)(ModalAddItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          POForm = _props.POForm,
          namespace = _props.search.namespace;

      dispatch((0, _purchaseOrder.getItemsFromAPI)({
        outlet_id: POForm.outlet,
        page: 1,
        per_page: 100,
        no_categories: true,
        keyword: '',
        namespace: namespace,
        first: true
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          showModalItem = _props2.showModalItem,
          isLoading = _props2.isLoading,
          items = _props2.items,
          temporaryItem = _props2.temporaryItem,
          alreadyAddedItem = _props2.alreadyAddedItem,
          handleSubmit = _props2.handleSubmit,
          namespace = _props2.search.namespace;

      var options = [];
      if (items.results) {
        options = items.results.map(function (item) {
          return { value: item.id, label: item.name };
        });
      }
      return React.createElement(
        _reactBootstrap.Modal,
        { show: showModalItem, className: '' + _ModalAddItem2.default.modalitem },
        React.createElement(_ModalHeader2.default, { title: namespace === _constants.NAMESPACE_INGREDIENTS ? 'Add Ingredients' : 'Add Items' }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: _ModalAddItem2.default.modalBody },
            this.state.openErrorAlert && React.createElement(
              'div',
              { className: _ModalAddItem2.default['warning-style'] },
              React.createElement(
                _reactBootstrap.Alert,
                { bsStyle: 'danger' },
                React.createElement('span', { onClick: this._dismissError, className: 'glyphicon glyphicon-remove ' + _ModalAddItem2.default['dismiss-warning-button'], 'aria-hidden': 'true' }),
                React.createElement(
                  'h5',
                  { className: 'ml-30px' },
                  'Maximum ',
                  this.state.errorItemName,
                  ' in stock 999999'
                )
              )
            ),
            React.createElement(_reduxForm.Field, {
              component: _SearchModal2.default,
              type: 'text',
              name: 'search-item',
              placeholder: namespace === _constants.NAMESPACE_INGREDIENTS ? 'Search ingredients' : 'Search items',
              options: options,
              onClickItem: this._onSelectedItem,
              onInputChange: this._onKeywordChange,
              inputValue: this.state.selectValue,
              onMenuScrollToBottom: this._onSearchReachBottom,
              isHasMore: this._hasMore,
              isLoading: isLoading
            }),
            React.createElement(_ItemHasRecipe2.default, { hasRecipe: this.state.itemHasRecipe, onClickIngredient: this._clickIngredient }),
            temporaryItem && namespace !== _constants.NAMESPACE_INGREDIENTS && !this.state.itemHasRecipe && React.createElement(_reduxForm.Field, {
              component: this._headerField,
              name: 'header',
              isOneItem: temporaryItem.item_variants.length === 1 && temporaryItem.item_variants[0].name === ''
            }),
            temporaryItem && namespace === _constants.NAMESPACE_INGREDIENTS && !this.state.itemHasRecipe && React.createElement(_reduxForm.Field, {
              component: this._headerField,
              name: 'header',
              isOneItem: false
            }),
            alreadyAddedItem && !this.state.itemHasRecipe && React.createElement(
              'div',
              { className: _ModalAddItem2.default['warning-message-wrapper'] },
              React.createElement(
                _WarningMessage2.default,
                null,
                '\xA0\xA0\xA0This ',
                namespace === _constants.NAMESPACE_INGREDIENTS ? 'ingredients' : 'items',
                ' already added, go to ',
                React.createElement(
                  'a',
                  { href: 'javascript:void(0)', onClick: this._onHide },
                  React.createElement(
                    'u',
                    null,
                    React.createElement(
                      'i',
                      null,
                      'Purchase order table'
                    )
                  )
                ),
                ' to edit'
              )
            ),
            React.createElement(
              'div',
              { className: 'row' },
              temporaryItem && !this.state.itemHasRecipe && React.createElement(_reduxForm.FieldArray, {
                component: this._fieldItem,
                name: 'items'
              })
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                {
                  className: !temporaryItem || this.state.itemHasRecipe ? 'btn ' + _ModalAddItem2.default['disableBtnAddItem'] : 'btn btn-primary',
                  disabled: !temporaryItem || this.state.itemHasRecipe,
                  onClick: handleSubmit(this._onClickSave) },
                'Add'
              )
            )
          )
        )
      );
    }
  }]);
  return ModalAddItem;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$purc = state.inventory.purchaseOrder,
      showModalItem = _state$inventory$purc.showModalItem,
      temporaryItem = _state$inventory$purc.temporaryItem,
      alreadyAddedItem = _state$inventory$purc.alreadyAddedItem,
      _state$inventory$purc2 = _state$inventory$purc.addItems,
      isLoading = _state$inventory$purc2.isLoading,
      items = _state$inventory$purc2.items,
      firstItems = _state$inventory$purc2.firstItems;

  return {
    showModalItem: showModalItem,
    isLoading: isLoading,
    items: items,
    temporaryItem: temporaryItem,
    alreadyAddedItem: alreadyAddedItem,
    firstItems: firstItems,
    POForm: (0, _reduxForm.getFormValues)('purchaseOrder')(state),
    addItemPurchase: (0, _reduxForm.getFormValues)('addItemPurchase')(state),
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'addItemPurchase',
  touchOnBlur: true,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalAddItem));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1401);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1404);

var _List2 = _interopRequireDefault(_List);

var _purchaseOrder = __webpack_require__(147);

var _reactRedux = __webpack_require__(6);

var _PurchaseOrderDetail = __webpack_require__(1409);

var _PurchaseOrderDetail2 = _interopRequireDefault(_PurchaseOrderDetail);

var _FormPurchaseOrder = __webpack_require__(1403);

var _FormPurchaseOrder2 = _interopRequireDefault(_FormPurchaseOrder);

var _ModalAddItem = __webpack_require__(1405);

var _ModalAddItem2 = _interopRequireDefault(_ModalAddItem);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _reduxForm = __webpack_require__(7);

var _ConfirmSubmitModal = __webpack_require__(1402);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseOrder = function (_React$Component) {
  (0, _inherits3.default)(PurchaseOrder, _React$Component);

  function PurchaseOrder() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PurchaseOrder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PurchaseOrder.__proto__ || (0, _getPrototypeOf2.default)(PurchaseOrder)).call.apply(_ref, [this].concat(args))), _this), _this._onModalSubmit = function (itemVariantValue) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          formPO = _this$props.formPO,
          namespace = _this$props.search.namespace;

      dispatch((0, _purchaseOrder.addItemtoPOForm)(itemVariantValue, formPO.itemPurchase, namespace));
    }, _this._onFormSubmit = function (values) {
      _this.props.dispatch((0, _purchaseOrder.showConfirmSubmitModal)(values.action));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PurchaseOrder, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRightColumn = _props.openRightColumn,
          purchaseOrderDetail = _props.purchaseOrderDetail,
          rightColumnState = _props.rightColumnState,
          showModalItem = _props.showModalItem,
          purchaseOrders = _props.purchaseOrders,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: purchaseOrders.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            rightColumnState === 'detail' && purchaseOrderDetail && React.createElement(_PurchaseOrderDetail2.default, null),
            rightColumnState === 'form' && React.createElement(_FormPurchaseOrder2.default, { onSubmit: this._onFormSubmit }),
            rightColumnState === 'form' && showModalItem && React.createElement(_ModalAddItem2.default, { onSubmit: this._onModalSubmit })
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_ConfirmSubmitModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _purchaseOrder.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          var _props3 = _this2.props,
              isDirtyPO = _props3.isDirtyPO,
              nextAction = _props3.nextAction;

          if (isDirtyPO && !nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return PurchaseOrder;
}(React.Component);

function mapStateToProps(state) {
  var expired = state.subscriptionExpired.expired;
  var _state$inventory$purc = state.inventory.purchaseOrder,
      openRightColumn = _state$inventory$purc.openRightColumn,
      purchaseOrderDetail = _state$inventory$purc.purchaseOrderDetail,
      rightColumnState = _state$inventory$purc.rightColumnState,
      showModalItem = _state$inventory$purc.showModalItem,
      purchaseOrders = _state$inventory$purc.purchaseOrders;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    openRightColumn: openRightColumn,
    purchaseOrderDetail: purchaseOrderDetail,
    rightColumnState: rightColumnState,
    showModalItem: showModalItem,
    nextAction: state.confirmAction.nextAction,
    formPO: (0, _reduxForm.getFormValues)('purchaseOrder')(state),
    isDirtyPO: (0, _reduxForm.isDirty)('purchaseOrder')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    expired: expired,
    purchaseOrders: purchaseOrders,
    showLoadingSpinnerPage: showLoadingSpinnerPage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PurchaseOrder);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Activities = __webpack_require__(2133);

var _Activities2 = _interopRequireDefault(_Activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activities = function (_React$Component) {
  (0, _inherits3.default)(Activities, _React$Component);

  function Activities() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Activities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Activities.__proto__ || (0, _getPrototypeOf2.default)(Activities)).call.apply(_ref, [this].concat(args))), _this), _this._activity = function (activity) {
      var purchaseOrderDetail = _this.props.purchaseOrderDetail;

      var key = activity.key.substr(activity.key.indexOf('.') + 1);
      return React.createElement(
        'tr',
        null,
        React.createElement(
          'td',
          { className: _Activities2.default.activity },
          'At ',
          (0, _moment2.default)(activity.created_at).format('MM/DD/YYYY HH:mm'),
          ' #',
          purchaseOrderDetail.order_no,
          ' is ',
          key,
          _this._symbol(activity)
        )
      );
    }, _this._symbol = function (activity) {
      if (activity.key === 'purchase_order.created' || activity.key === 'ingredient_purchase_order.created') {
        return React.createElement('span', { className: 'glyphicon glyphicon-plus pull-right btn btn-warning ' + _Activities2.default.symbol });
      } else if (activity.key === 'purchase_order.fulfilled' || activity.key === 'ingredient_purchase_order.fulfilled') {
        return React.createElement('span', { className: 'glyphicon glyphicon-ok pull-right btn btn-success ' + _Activities2.default.symbol });
      } else if (activity.key === 'purchase_order.cancelled' || activity.key === 'ingredient_purchase_order.cancelled') {
        return React.createElement('span', { className: 'glyphicon glyphicon-minus pull-right btn btn-danger ' + _Activities2.default.symbol });
      } else if (activity.key === 'purchase_order.updated' || activity.key === 'ingredient_purchase_order.updated') {
        return React.createElement('span', { className: 'glyphicon glyphicon-plus pull-right btn btn-warning ' + _Activities2.default.symbol });
      } else {
        return React.createElement('span', null);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Activities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var purchaseOrderDetail = this.props.purchaseOrderDetail;

      return React.createElement(
        'table',
        { className: 'table table-bordered' },
        React.createElement(
          'tbody',
          null,
          purchaseOrderDetail.activities.map(function (act) {
            return _this2._activity(act);
          })
        )
      );
    }
  }]);
  return Activities;
}(React.Component);

Activities.propTypes = {
  purchaseOrderDetail: React.PropTypes.object
};
exports.default = Activities;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _PurchaseItemList = __webpack_require__(2134);

var _PurchaseItemList2 = _interopRequireDefault(_PurchaseItemList);

var _reactBootstrap = __webpack_require__(10);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by emhaje-workspace on 5/16/17.
 */
var popoverFocus = function popoverFocus(_ref) {
  var content = _ref.content;
  return React.createElement(
    _reactBootstrap.Popover,
    { id: 'purchaseOrder' },
    content
  );
};

var PurchaseItemList = function (_React$Component) {
  (0, _inherits3.default)(PurchaseItemList, _React$Component);

  function PurchaseItemList() {
    (0, _classCallCheck3.default)(this, PurchaseItemList);
    return (0, _possibleConstructorReturn3.default)(this, (PurchaseItemList.__proto__ || (0, _getPrototypeOf2.default)(PurchaseItemList)).apply(this, arguments));
  }

  (0, _createClass3.default)(PurchaseItemList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$detail = _props.detail,
          detail = _props$detail === undefined ? [] : _props$detail,
          total = _props.total,
          isIngredient = _props.isIngredient;

      var result = _lodash2.default.chain(detail).groupBy('item_id').map(function (currentItem) {
        return currentItem;
      }).value();
      return React.createElement(
        'div',
        null,
        !isIngredient && React.createElement(
          'div',
          null,
          result.map(function (hai) {
            if (hai.length > 1) {
              return React.createElement(
                'div',
                { className: 'col-md-12 ' + _PurchaseItemList2.default.item },
                React.createElement(
                  'div',
                  { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                  'VARIANT'
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                  'IN STOCK'
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                  'ORDER'
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                  'UNIT COST'
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                  'TOTAL'
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                  React.createElement('input', {
                    className: 'form-control text-center ' + _PurchaseItemList2.default.itemDetailUp, value: hai[0].item_name, disabled: true })
                ),
                hai.map(function (each, index) {
                  return React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                    React.createElement(
                      _reactBootstrap.OverlayTrigger,
                      { placement: 'top', overlay: popoverFocus({ content: each.item_variant_name }) },
                      React.createElement(
                        'div',
                        { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                        React.createElement('input', {
                          className: 'form-control ' + (index === hai.length - 1 ? _PurchaseItemList2.default.itemDetailLeftDown : _PurchaseItemList2.default.itemDetail), value: each.item_variant_name, disabled: true })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetailBeginingStock, value: each.beginning_stock, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: each.quantity, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: (0, _formatter.rupiah)(each.price), disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + (index === hai.length - 1 ? _PurchaseItemList2.default.itemDetailRightDown : _PurchaseItemList2.default.itemDetail), value: (0, _formatter.rupiah)(each.price * each.quantity), disabled: true })
                    )
                  );
                })
              );
            } else {
              var each = hai[0];
              if (each.item_variant_name) {
                return React.createElement(
                  'div',
                  { className: 'col-md-12 ' + _PurchaseItemList2.default.item },
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'VARIANT'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'IN STOCK'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'ORDER'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'UNIT COST'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'TOTAL'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                    React.createElement('input', {
                      className: 'form-control text-center ' + _PurchaseItemList2.default.itemDetailUp, value: hai[0].item_name, disabled: true })
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                    React.createElement(
                      _reactBootstrap.OverlayTrigger,
                      { placement: 'top', overlay: popoverFocus({ content: each.item_variant_name }) },
                      React.createElement(
                        'div',
                        { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                        React.createElement('input', {
                          className: 'form-control ' + _PurchaseItemList2.default.itemDetailLeftDown, value: each.item_variant_name, disabled: true })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetailBeginingStock, value: each.beginning_stock, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: each.quantity, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: (0, _formatter.rupiah)(each.price), disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetailRightDown, value: (0, _formatter.rupiah)(each.price * each.quantity), disabled: true })
                    )
                  )
                );
              } else {
                return React.createElement(
                  'div',
                  { className: 'col-md-12 ' + _PurchaseItemList2.default.item },
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'ITEM'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'IN STOCK'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'ORDER'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'UNIT COST'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                    'TOTAL'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                    React.createElement(
                      _reactBootstrap.OverlayTrigger,
                      { placement: 'top', overlay: popoverFocus({ content: each.item_name }) },
                      React.createElement(
                        'div',
                        { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                        React.createElement('input', {
                          className: 'form-control ' + _PurchaseItemList2.default.itemDetailLeft, value: each.item_name, disabled: true })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetailBeginingStock, value: each.beginning_stock, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: each.quantity, disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: (0, _formatter.rupiah)(each.price), disabled: true })
                    ),
                    React.createElement(
                      'div',
                      { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                      React.createElement('input', {
                        className: 'form-control ' + _PurchaseItemList2.default.itemDetailRight, value: (0, _formatter.rupiah)(each.price * each.quantity), disabled: true })
                    )
                  )
                );
              }
            }
          })
        ),
        isIngredient && React.createElement(
          'div',
          null,
          ' ',
          detail.map(function (ingredient) {
            return React.createElement(
              'div',
              { className: 'col-md-12 ' + _PurchaseItemList2.default.item },
              React.createElement(
                'div',
                { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                'UNIT'
              ),
              React.createElement(
                'div',
                { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                'IN STOCK'
              ),
              React.createElement(
                'div',
                { className: 'col-md-2 text-center ' + _PurchaseItemList2.default.itemHeader },
                'ORDER'
              ),
              React.createElement(
                'div',
                { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                'UNIT COST'
              ),
              React.createElement(
                'div',
                { className: 'col-md-3 text-center ' + _PurchaseItemList2.default.itemHeader },
                'TOTAL'
              ),
              React.createElement(
                'div',
                { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                React.createElement('input', {
                  className: 'form-control text-center ' + _PurchaseItemList2.default.itemDetailUp, value: ingredient.ingredient_name, disabled: true })
              ),
              React.createElement(
                'div',
                { className: 'col-md-12 ' + _PurchaseItemList2.default.padding0 },
                React.createElement(
                  _reactBootstrap.OverlayTrigger,
                  { placement: 'top', overlay: popoverFocus({ content: ingredient.unit_name }) },
                  React.createElement(
                    'div',
                    { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                    React.createElement('input', {
                      className: 'form-control ' + _PurchaseItemList2.default.itemDetailLeftDown, value: ingredient.unit_name, disabled: true })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                  React.createElement('input', {
                    className: 'form-control ' + _PurchaseItemList2.default.itemDetailBeginingStock, value: ingredient.beginning_stock, disabled: true })
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-2 ' + _PurchaseItemList2.default.padding0 },
                  React.createElement('input', {
                    className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: ingredient.quantity, disabled: true })
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                  React.createElement('input', {
                    className: 'form-control ' + _PurchaseItemList2.default.itemDetail, value: (0, _formatter.rupiah)(ingredient.unit_price), disabled: true })
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-3 ' + _PurchaseItemList2.default.padding0 },
                  React.createElement('input', {
                    className: 'form-control ' + _PurchaseItemList2.default.itemDetailRightDown, value: (0, _formatter.rupiah)(ingredient.unit_price * ingredient.quantity), disabled: true })
                )
              )
            );
          })
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'pull-left' },
            'TOTAL'
          ),
          React.createElement(
            'div',
            { className: 'text-right' },
            (0, _formatter.rupiah)(total)
          )
        )
      );
    }
  }]);
  return PurchaseItemList;
}(React.Component);

exports.default = PurchaseItemList;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _PurchaseOrderDetail = __webpack_require__(2135);

var _PurchaseOrderDetail2 = _interopRequireDefault(_PurchaseOrderDetail);

var _purchaseOrder = __webpack_require__(147);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _reactBootstrap = __webpack_require__(10);

var _Separator = __webpack_require__(1410);

var _Separator2 = _interopRequireDefault(_Separator);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Activities = __webpack_require__(1407);

var _Activities2 = _interopRequireDefault(_Activities);

var _PurchaseItemList = __webpack_require__(1408);

var _PurchaseItemList2 = _interopRequireDefault(_PurchaseItemList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PurchaseOrderDetail = function (_React$Component) {
  (0, _inherits3.default)(PurchaseOrderDetail, _React$Component);

  function PurchaseOrderDetail(props) {
    (0, _classCallCheck3.default)(this, PurchaseOrderDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PurchaseOrderDetail.__proto__ || (0, _getPrototypeOf2.default)(PurchaseOrderDetail)).call(this, props));

    _this._onClickDone = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _purchaseOrder.onClickDone)());
    };

    _this._onSelectMore = function (eventKey, event) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          purchaseOrderDetail = _this$props.purchaseOrderDetail;

      if (eventKey === 'print') {
        dispatch((0, _purchaseOrder.onClickPrint)(purchaseOrderDetail));
      } else if (eventKey === 'resend_email') {
        dispatch((0, _purchaseOrder.onClickResendEmail)(purchaseOrderDetail));
      } else if (eventKey === 'cancel') {
        var _this$props2 = _this.props,
            _dispatch = _this$props2.dispatch,
            _purchaseOrderDetail = _this$props2.purchaseOrderDetail;

        _dispatch((0, _purchaseOrder.updatePurchaseOrders)(_purchaseOrderDetail, 'Cancelled'));
      } else if (eventKey === 'edit') {
        dispatch((0, _purchaseOrder.onClickEdit)(purchaseOrderDetail));
      }
    };

    _this._onClickMarkAsFulfilled = function () {
      _this.setState({ markAsFulfilledBtnDisabledStatus: true });
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          purchaseOrderDetail = _this$props3.purchaseOrderDetail;

      dispatch((0, _purchaseOrder.updatePurchaseOrders)(purchaseOrderDetail, 'Fulfilled'));
    };

    _this.state = {
      markAsFulfilledBtnDisabledStatus: false
    };
    return _this;
  }

  (0, _createClass3.default)(PurchaseOrderDetail, [{
    key: 'render',
    value: function render() {
      var purchaseOrderDetail = this.props.purchaseOrderDetail;

      var numPhone = void 0;
      if (purchaseOrderDetail.supplier_phone === null) {
        numPhone = '';
      } else {
        if (purchaseOrderDetail.supplier_phone.charAt(0) === '0') {
          numPhone = replaceNumPhone(purchaseOrderDetail.supplier_phone, 0, '+62');
        } else {
          numPhone = '+62' + purchaseOrderDetail.supplier_phone;
        }
      }
      return React.createElement(
        'div',
        { className: _PurchaseOrderDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _PurchaseOrderDetail2.default.content },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(
                'div',
                { className: 'pull-right' },
                (purchaseOrderDetail.status === 'Created' || purchaseOrderDetail.status === 'Updated') && React.createElement(
                  'button',
                  { className: 'btn btn-primary ' + _PurchaseOrderDetail2.default.buttonFulfilled, disabled: this.state.markAsFulfilledBtnDisabledStatus, onClick: this._onClickMarkAsFulfilled },
                  'Mark as Fulfilled'
                ),
                React.createElement(
                  _reactBootstrap.DropdownButton,
                  { title: 'More', onSelect: this._onSelectMore, pullRight: true },
                  purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.supplier_email && React.createElement(
                    _reactBootstrap.MenuItem,
                    { eventKey: 'resend_email' },
                    'Resend'
                  ),
                  purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.status !== 'Cancelled' && React.createElement(
                    _reactBootstrap.MenuItem,
                    { eventKey: 'cancel' },
                    'Cancel Order ',
                    React.createElement('i', { className: 'glyphicon btn btn-danger glyphicon-minus ' + _PurchaseOrderDetail2.default.icon_cancel })
                  ),
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { eventKey: 'print' },
                    'Print'
                  ),
                  purchaseOrderDetail.status !== 'Fulfilled' && purchaseOrderDetail.status !== 'Cancelled' && React.createElement(
                    _reactBootstrap.MenuItem,
                    { eventKey: 'edit' },
                    'Edit'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'mt-20px col-sm-12' },
              React.createElement(_LabelSection2.default, { title: 'Purchase Order Details' })
            ),
            purchaseOrderDetail.supplier_id !== 0 && React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(
                'div',
                { className: _PurchaseOrderDetail2.default['supplier-name'] },
                purchaseOrderDetail.supplier_name
              ),
              React.createElement(
                'table',
                { className: 'table table-bordered' },
                React.createElement(
                  'tbody',
                  null,
                  React.createElement(
                    'tr',
                    null,
                    React.createElement(
                      'td',
                      null,
                      React.createElement(
                        'div',
                        null,
                        numPhone
                      )
                    ),
                    React.createElement(
                      'td',
                      { colSpan: 4 },
                      React.createElement(
                        'div',
                        null,
                        ' ',
                        purchaseOrderDetail.supplier_email
                      )
                    )
                  ),
                  React.createElement(
                    'tr',
                    null,
                    React.createElement(
                      'td',
                      { colSpan: 4 },
                      React.createElement(
                        'div',
                        { className: _PurchaseOrderDetail2.default.break },
                        purchaseOrderDetail.supplier_address
                      )
                    )
                  ),
                  React.createElement(
                    'tr',
                    null,
                    React.createElement(
                      'td',
                      null,
                      React.createElement(
                        'div',
                        { className: _PurchaseOrderDetail2.default.break },
                        purchaseOrderDetail.supplier_city
                      )
                    ),
                    React.createElement(
                      'td',
                      null,
                      React.createElement(
                        'div',
                        { className: _PurchaseOrderDetail2.default.break },
                        purchaseOrderDetail.supplier_state
                      )
                    ),
                    React.createElement(
                      'td',
                      null,
                      React.createElement(
                        'div',
                        null,
                        purchaseOrderDetail.supplier_postal_code
                      )
                    )
                  )
                )
              )
            ),
            purchaseOrderDetail.note && React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(
                'div',
                null,
                'Note'
              ),
              React.createElement(_Separator2.default, null),
              React.createElement(
                'div',
                null,
                purchaseOrderDetail.note
              )
            ),
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_Separator2.default, null),
              React.createElement(
                'div',
                null,
                'PO Number #',
                purchaseOrderDetail.order_no
              ),
              React.createElement(
                'div',
                null,
                'Created at : ',
                (0, _moment2.default)(purchaseOrderDetail.created_at).format('MM/DD/YYYY HH:mm')
              ),
              React.createElement(
                'div',
                null,
                'Created by: ',
                purchaseOrderDetail.creator.first_name,
                ' ',
                purchaseOrderDetail.creator.last_name
              ),
              purchaseOrderDetail.updater && React.createElement(
                'div',
                null,
                'Updated by: ',
                purchaseOrderDetail.updater.first_name,
                ' ',
                purchaseOrderDetail.updater.last_name
              ),
              React.createElement(
                'div',
                null,
                'Email: ',
                purchaseOrderDetail.creator.email
              ),
              React.createElement(
                'div',
                null,
                'Outlet Name: ',
                purchaseOrderDetail.outlet.name
              ),
              React.createElement(
                'div',
                null,
                'Phone: ',
                purchaseOrderDetail.outlet.phone_number
              ),
              React.createElement(
                'div',
                null,
                'Address: ',
                purchaseOrderDetail.outlet.address,
                ', ',
                purchaseOrderDetail.outlet.city,
                ', ',
                purchaseOrderDetail.outlet.province,
                ', ',
                purchaseOrderDetail.outlet.postal_code
              )
            ),
            React.createElement(
              'div',
              { className: 'mt-20px col-sm-12' },
              React.createElement(_LabelSection2.default, { title: 'Status Activity' }),
              React.createElement(_Activities2.default, { purchaseOrderDetail: purchaseOrderDetail }),
              purchaseOrderDetail.history_details && React.createElement(_LabelSection2.default, { title: 'Purchase Items' }),
              purchaseOrderDetail.ingredient_history_details && React.createElement(_LabelSection2.default, { title: 'Purchase Ingredients' }),
              purchaseOrderDetail.history_details && React.createElement(_PurchaseItemList2.default, { total: purchaseOrderDetail.total, detail: purchaseOrderDetail.history_details }),
              purchaseOrderDetail.ingredient_history_details && React.createElement(_PurchaseItemList2.default, { total: purchaseOrderDetail.total, detail: purchaseOrderDetail.ingredient_history_details, isIngredient: 'true' })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _PurchaseOrderDetail2.default.footer },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { onClick: this._onClickDone, className: 'btn btn-primary' },
              'Done'
            )
          )
        )
      );
    }
  }]);
  return PurchaseOrderDetail;
}(React.Component);

function replaceNumPhone(stringNumb, index, replacement) {
  return stringNumb.substr(0, index) + replacement + stringNumb.substr(index + replacement.length);
}

function mapStateToProps(state) {
  var purchaseOrderDetail = state.inventory.purchaseOrder.purchaseOrderDetail;

  return { purchaseOrderDetail: purchaseOrderDetail };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PurchaseOrderDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Separator = __webpack_require__(2136);

var _Separator2 = _interopRequireDefault(_Separator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Separator = function (_React$Component) {
  (0, _inherits3.default)(Separator, _React$Component);

  function Separator() {
    (0, _classCallCheck3.default)(this, Separator);
    return (0, _possibleConstructorReturn3.default)(this, (Separator.__proto__ || (0, _getPrototypeOf2.default)(Separator)).apply(this, arguments));
  }

  (0, _createClass3.default)(Separator, [{
    key: 'render',
    value: function render() {
      return React.createElement('div', { className: _Separator2.default.wrapper });
    }
  }]);
  return Separator;
}(React.Component);

exports.default = Separator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PurchaseOrder = __webpack_require__(1406);

var _PurchaseOrder2 = _interopRequireDefault(_PurchaseOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PurchaseOrder2.default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _pages = __webpack_require__(38);

var _DropdownButtonSelectIcon = __webpack_require__(292);

var _DropdownButtonSelectIcon2 = _interopRequireDefault(_DropdownButtonSelectIcon);

var _summary = __webpack_require__(234);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _summary2 = __webpack_require__(651);

var mpInvSummary = _interopRequireWildcard(_summary2);

var _ActionBar = __webpack_require__(2137);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutletIds = function (outletIds) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          _this$props$search = _this$props.search,
          date = _this$props$search.date,
          namespace = _this$props$search.namespace;

      mpInvSummary.inventorySummaryChangeFilter({
        outletIds: outletIds,
        startDate: date.startDate,
        endDate: date.endDate,
        namespace: namespace
      });
      dispatch((0, _summary.onChangeOutletIds)(outletIds, date, namespace));
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          _this$props2$search = _this$props2.search,
          keyword = _this$props2$search.keyword,
          namespace = _this$props2$search.namespace,
          outletIds = _this$props2$search.outletIds;

      mpInvSummary.inventorySummaryChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      dispatch((0, _summary.onChangeDate)({ startDate: startDate, endDate: endDate }, keyword, namespace));
    }, _this._onChangeKeyword = function (event, keyword) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          _this$props3$search = _this$props3.search,
          date = _this$props3$search.date,
          namespace = _this$props3$search.namespace;

      dispatch((0, _summary.onChangeKeyword)(keyword, date, namespace));
    }, _this._onClickExport = function () {
      var _this$props4 = _this.props,
          _this$props4$search = _this$props4.search,
          status = _this$props4$search.status,
          namespace = _this$props4$search.namespace,
          keyword = _this$props4$search.keyword,
          _this$props4$search$d = _this$props4$search.date,
          startDate = _this$props4$search$d.startDate,
          endDate = _this$props4$search$d.endDate,
          outletIds = _this$props4$search.outletIds,
          dispatch = _this$props4.dispatch;

      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Inventory Summary - ' + dateLabel;

      dispatch((0, _summary.exportSummary)({
        start_date: (0, _moment2.default)(startDate).format('D/M/YYYY'),
        end_date: (0, _moment2.default)(endDate).format('D/M/YYYY'),
        status: status,
        keyword: keyword,
        namespace: namespace
      }, filename, outletIds[0]));
    }, _this._onChangeNamespace = function (event, namespace) {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          _this$props5$search = _this$props5.search,
          _this$props5$search$d = _this$props5$search.date,
          startDate = _this$props5$search$d.startDate,
          endDate = _this$props5$search$d.endDate,
          keyword = _this$props5$search.keyword,
          outletIds = _this$props5$search.outletIds;

      mpInvSummary.inventorySummaryChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
      dispatch((0, _summary.onChangeNamespace)(namespace, {
        page: 1,
        start: startDate.format('D/M/Y'),
        end: endDate.format('D/M/Y'),
        keyword: keyword
      }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          isIngredientActive = _props.isIngredientActive;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-10 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline ' + _ActionBar2.default['action-bar'] },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutletIds,
                allOutletOption: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                onChange: this._onChangeDate,
                updateServerOnChange: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownButtonSelectIcon2.default,
                name: 'namespace',
                options: ActionBar.NAMESPACE_OPTIONS,
                onChange: this._onChangeNamespace,
                disabled: !isIngredientActive
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _SearchBar2.default,
                name: 'keyword',
                onChange: this._onChangeKeyword,
                placeholder: 'Search'
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-2 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickExport },
              'Export'
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

ActionBar.NAMESPACE_OPTIONS = [{
  id: 'items', name: 'Item Library'
}, {
  id: 'ingredients', name: 'Ingredients'
}];


var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.inventory.summary.outlets;

  var search = (0, _reduxForm.getFormValues)('search')(state);
  var is_active = state.inventory.ingredientSubscription.subscriptionStatus.is_active;

  return { outlets: outlets, search: search, isIngredientActive: is_active };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2138);

var _List2 = _interopRequireDefault(_List);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _summary = __webpack_require__(234);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._renderRowItem = function (ri) {
      var search = _this.props.search;

      if (ri.isParent && search) {
        if (ri.hasChildren) {
          return React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: _List2.default.c20 },
              ri.item_name
            ),
            React.createElement(
              'td',
              { className: '' + _List2.default.c12 },
              ri.category
            ),
            search.outletIds.length > 1 && React.createElement(
              'td',
              { className: '' + _List2.default.c12 },
              ri.outlet
            ),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 }),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 }),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 }),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 }),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 }),
            React.createElement('td', { className: 'text-center ' + _List2.default.c12 })
          );
        } else {
          return React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: _List2.default.c20 },
              ri.item_name
            ),
            React.createElement(
              'td',
              { className: '' + _List2.default.c12 },
              ri.category
            ),
            search.outletIds.length > 1 && React.createElement(
              'td',
              { className: '' + _List2.default.c12 },
              ri.outlet
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.beginning
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.purchase_order
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.sales
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.transfer
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.adjustment
            ),
            React.createElement(
              'td',
              { className: 'text-center ' + _List2.default.c12 },
              ri.ending
            )
          );
        }
      } else {
        return React.createElement(
          'tr',
          null,
          React.createElement(
            'td',
            null,
            '\xA0\xA0 ',
            ri.item_variant_name
          ),
          React.createElement('td', null),
          search.outletIds.length > 1 && React.createElement('td', null),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.beginning
          ),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.purchase_order
          ),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.sales
          ),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.transfer
          ),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.adjustment
          ),
          React.createElement(
            'td',
            { className: 'text-center' },
            ri.ending
          )
        );
      }
    }, _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage,
          dispatch = _this$props2.dispatch,
          _this$props2$search = _this$props2.search,
          _this$props2$search$d = _this$props2$search.date,
          startDate = _this$props2$search$d.startDate,
          endDate = _this$props2$search$d.endDate,
          keyword = _this$props2$search.keyword,
          items = _this$props2.items,
          rowItems = _this$props2.rowItems;

      if (currentPage < totalPage) {
        dispatch((0, _summary.summaryRequest)({
          page: currentPage + 1,
          start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
          end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
          keyword: keyword
        }, items, rowItems));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rowItems = _props.rowItems,
          search = _props.search;


      return rowItems.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _List2.default.c20 },
                'Name - Variant'
              ),
              React.createElement(
                'th',
                { className: _List2.default.c12 },
                'Category'
              ),
              search && search.outletIds.length > 1 && React.createElement(
                'th',
                { className: _List2.default.c12 },
                'Outlet'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Beginning'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Purchase Order'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Sales'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Transfer'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Adjustment'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _List2.default.c12 },
                'Ending'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                rowItems.map(this._renderRowItem)
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$summ = state.inventory.summary,
      rowItems = _state$inventory$summ.rowItems,
      currentPage = _state$inventory$summ.currentPage,
      totalPage = _state$inventory$summ.totalPage,
      items = _state$inventory$summ.items;

  return {
    rowItems: rowItems,
    currentPage: currentPage,
    totalPage: totalPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    items: items
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ListSummaryIngredients = __webpack_require__(2139);

var _ListSummaryIngredients2 = _interopRequireDefault(_ListSummaryIngredients);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _summary = __webpack_require__(234);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListSummaryIngredients = function (_React$Component) {
  (0, _inherits3.default)(ListSummaryIngredients, _React$Component);

  function ListSummaryIngredients() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListSummaryIngredients);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListSummaryIngredients.__proto__ || (0, _getPrototypeOf2.default)(ListSummaryIngredients)).call.apply(_ref, [this].concat(args))), _this), _this._renderRowIngredient = function (rowIng) {
      var search = _this.props.search;

      return React.createElement(
        'tr',
        null,
        React.createElement(
          'td',
          { className: _ListSummaryIngredients2.default.c20 },
          rowIng.ingredient_name
        ),
        React.createElement(
          'td',
          { className: '' + _ListSummaryIngredients2.default.c12 },
          rowIng.category_name
        ),
        search && search.outletIds && search.outletIds.length > 1 && React.createElement(
          'td',
          { className: _ListSummaryIngredients2.default.c12 },
          rowIng.outlet_name
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.beginning
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.purchase_order
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.usage
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.transfer
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.adjustment
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_summary.ending
        ),
        React.createElement(
          'td',
          { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
          rowIng.ingredient_unit
        )
      );
    }, _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage,
          dispatch = _this$props2.dispatch,
          _this$props2$search = _this$props2.search,
          _this$props2$search$d = _this$props2$search.date,
          startDate = _this$props2$search$d.startDate,
          endDate = _this$props2$search$d.endDate,
          keyword = _this$props2$search.keyword,
          ingredients = _this$props2.ingredients;

      if (currentPage < totalPage) {
        dispatch((0, _summary.ingInvSummaryRequest)({
          page: currentPage + 1,
          start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
          end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
          keyword: keyword
        }, ingredients));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListSummaryIngredients, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ingredients = _props.ingredients,
          search = _props.search;


      return ingredients.length > 0 && React.createElement(
        'div',
        { className: _ListSummaryIngredients2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _ListSummaryIngredients2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _ListSummaryIngredients2.default.c20 },
                'Ingredient'
              ),
              React.createElement(
                'th',
                { className: _ListSummaryIngredients2.default.c12 },
                'Category'
              ),
              search && search.outletIds && search.outletIds.length > 1 && React.createElement(
                'th',
                { className: _ListSummaryIngredients2.default.c12 },
                'Outlet'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Beginning'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Purchase Order'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Usage'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Transfer'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Adjustment'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Ending'
              ),
              React.createElement(
                'th',
                { className: 'text-center ' + _ListSummaryIngredients2.default.c12 },
                'Unit'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _ListSummaryIngredients2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _ListSummaryIngredients2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                ingredients.map(this._renderRowIngredient)
              )
            )
          )
        )
      );
    }
  }]);
  return ListSummaryIngredients;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$summ = state.inventory.summary,
      currentPage = _state$inventory$summ.currentPage,
      totalPage = _state$inventory$summ.totalPage,
      ingredients = _state$inventory$summ.ingredients;

  return {
    currentPage: currentPage,
    totalPage: totalPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    ingredients: ingredients
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ListSummaryIngredients);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1412);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1413);

var _List2 = _interopRequireDefault(_List);

var _summary = __webpack_require__(234);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _ListSummaryIngredients = __webpack_require__(1414);

var _ListSummaryIngredients2 = _interopRequireDefault(_ListSummaryIngredients);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Summary = function (_React$Component) {
  (0, _inherits3.default)(Summary, _React$Component);

  function Summary() {
    (0, _classCallCheck3.default)(this, Summary);
    return (0, _possibleConstructorReturn3.default)(this, (Summary.__proto__ || (0, _getPrototypeOf2.default)(Summary)).apply(this, arguments));
  }

  (0, _createClass3.default)(Summary, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          search = _props.search,
          items = _props.items,
          ingredients = _props.ingredients;

      var expireTime = 365; // expire time 1 year
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
      }
      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            null,
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: search && search.namespace !== 'ingredients' ? items.length === 0 : ingredients.length === 0,
              title: 'No Data To Display',
              description: '' }),
            search && search.namespace !== 'ingredients' ? React.createElement(_List2.default, null) : React.createElement(_ListSummaryIngredients2.default, null)
          ),
          React.createElement(_pages.RightColumnWrapper, null)
        )
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _summary.pageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Summary;
}(React.Component);

function mapStateToProps(state) {
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var _state$inventory$summ = state.inventory.summary,
      items = _state$inventory$summ.items,
      ingredients = _state$inventory$summ.ingredients;
  var expired = state.subscriptionExpired.expired;

  return {
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    search: (0, _reduxForm.getFormValues)('search')(state),
    items: items,
    ingredients: ingredients,
    expired: expired
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Summary);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Summary = __webpack_require__(1415);

var _Summary2 = _interopRequireDefault(_Summary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Summary2.default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _pages = __webpack_require__(38);

var _supplier = __webpack_require__(201);

var _confirmAction = __webpack_require__(29);

var _suppliers = __webpack_require__(652);

var mpInvSupplier = _interopRequireWildcard(_suppliers);

var _ActionBar = __webpack_require__(2140);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickExport = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          email = _this$props.profile.email;

      mpInvSupplier.inventorySupplierExport();
      var filename = 'Inventory Suppliers - ' + email;

      dispatch((0, _supplier.exportSupplier)({}, filename));
    }, _this._onClickCreateSupplier = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          isDirtySupplier = _this$props2.isDirtySupplier;

      if (isDirtySupplier) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _supplier.onClickCreateSupplier)()));
      } else {
        dispatch((0, _supplier.onClickCreateSupplier)());
      }
    }, _this._onChangeOutletIds = function (outletIdsAsObject) {
      (0, _keys2.default)(outletIdsAsObject).map(function (i) {
        return outletIdsAsObject[i];
      });
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
    }, _this._onChangeKeyword = function (event, keyword) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _supplier.onChangeKeyword)(keyword));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-8 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline ' + _ActionBar2.default['action-bar'] },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _SearchBar2.default,
                name: 'keyword',
                onChange: this._onChangeKeyword,
                placeholder: 'Search'
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickExport },
              'Export'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ml-10px', onClick: this._onClickCreateSupplier },
              'Create Supplier'
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var _state$inventory$supp = state.inventory.supplier,
      outlets = _state$inventory$supp.outlets,
      outletIds = _state$inventory$supp.outletIds,
      profile = _state$inventory$supp.profile;

  return {
    outlets: outlets,
    outletIds: outletIds,
    profile: profile,
    isDirtySupplier: (0, _reduxForm.isDirty)('supplier')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(2141);

var _List2 = _interopRequireDefault(_List);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _supplier = __webpack_require__(201);

var _confirmAction = __webpack_require__(29);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._hasMore = function () {
      // since the suppliers api doesn't support pagination
      // this method is no use
      return false;
    }, _this._onReachBottom = function () {
      // since the suppliers api doesn't support pagination
      // this method is no use
      return false;
    }, _this._onClickRow = function (supplier) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isDirtySupplier = _this$props.isDirtySupplier;

      if (isDirtySupplier) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _supplier.onClickRow)(supplier)));
      } else {
        dispatch((0, _supplier.onClickRow)(supplier));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          suppliers = _props.suppliers,
          supplierDetail = _props.supplierDetail;

      return suppliers.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Name'
              ),
              React.createElement(
                'th',
                null,
                'Address'
              ),
              React.createElement(
                'th',
                null,
                'Phone'
              ),
              React.createElement(
                'th',
                null,
                'Email'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                suppliers.map(function (supplier) {
                  var className = '' + (supplierDetail && supplierDetail.id === supplier.id ? _List2.default.selected : '');
                  return React.createElement(
                    'tr',
                    { onClick: function onClick() {
                        _this2._onClickRow(supplier);
                      }, className: className },
                    React.createElement(
                      'td',
                      null,
                      supplier.name
                    ),
                    React.createElement(
                      'td',
                      null,
                      supplier.address
                    ),
                    React.createElement(
                      'td',
                      null,
                      supplier.phone
                    ),
                    React.createElement(
                      'td',
                      null,
                      supplier.email
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$supp = state.inventory.supplier,
      suppliers = _state$inventory$supp.suppliers,
      supplierDetail = _state$inventory$supp.supplierDetail;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    suppliers: suppliers,
    supplierDetail: supplierDetail,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    isDirtySupplier: (0, _reduxForm.isDirty)('supplier')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1417);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1418);

var _List2 = _interopRequireDefault(_List);

var _SupplierDetail = __webpack_require__(1420);

var _SupplierDetail2 = _interopRequireDefault(_SupplierDetail);

var _supplier = __webpack_require__(201);

var _reactRedux = __webpack_require__(6);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reduxForm = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(49);

var _confirmAction = __webpack_require__(29);

var _reactRouter = __webpack_require__(15);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Supplier = function (_React$Component) {
  (0, _inherits3.default)(Supplier, _React$Component);

  function Supplier() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Supplier);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Supplier.__proto__ || (0, _getPrototypeOf2.default)(Supplier)).call.apply(_ref, [this].concat(args))), _this), _this._onHideModal = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _supplier.cancelDeleteSupplier)());
    }, _this._onDelete = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          supplierDetail = _this$props.supplierDetail,
          suppliers = _this$props.suppliers;

      dispatch((0, _supplier.deleteSupplier)(supplierDetail, suppliers));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Supplier, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRightColumn = _props.openRightColumn,
          openDeleteSupplierModal = _props.openDeleteSupplierModal,
          supplierDetail = _props.supplierDetail,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          suppliers = _props.suppliers;

      var deleteModalName = supplierDetail ? supplierDetail.name : '';
      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: suppliers.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_SupplierDetail2.default, null)
          )
        ),
        React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: openDeleteSupplierModal,
          onHide: this._onHideModal,
          title: 'Supplier',
          name: deleteModalName,
          onDelete: this._onDelete
        }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _supplier.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          var _props3 = _this2.props,
              isDirtySupplier = _props3.isDirtySupplier,
              nextAction = _props3.nextAction;

          if (isDirtySupplier && !nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Supplier;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$supp = state.inventory.supplier,
      openRightColumn = _state$inventory$supp.openRightColumn,
      openDeleteSupplierModal = _state$inventory$supp.openDeleteSupplierModal,
      supplierDetail = _state$inventory$supp.supplierDetail,
      suppliers = _state$inventory$supp.suppliers;
  var nextAction = state.confirmAction.nextAction;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;

  return {
    openRightColumn: openRightColumn,
    openDeleteSupplierModal: openDeleteSupplierModal,
    supplierDetail: supplierDetail,
    suppliers: suppliers,
    isDirtySupplier: (0, _reduxForm.isDirty)('supplier')(state),
    nextAction: nextAction,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    expired: expired
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Supplier);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SupplierDetail = __webpack_require__(2142);

var _SupplierDetail2 = _interopRequireDefault(_SupplierDetail);

var _SupplierForm = __webpack_require__(1421);

var _SupplierForm2 = _interopRequireDefault(_SupplierForm);

var _reactRedux = __webpack_require__(6);

var _supplier = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SupplierDetail = function (_React$Component) {
  (0, _inherits3.default)(SupplierDetail, _React$Component);

  function SupplierDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SupplierDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SupplierDetail.__proto__ || (0, _getPrototypeOf2.default)(SupplierDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          suppliers = _this$props.suppliers;

      if (values.id) {
        dispatch((0, _supplier.submitFormUpdate)(values.id, { supplier: values }, suppliers));
      } else {
        dispatch((0, _supplier.submitFormCreate)({ supplier: values }, suppliers));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SupplierDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _SupplierDetail2.default.wrapper },
        React.createElement(_SupplierForm2.default, { onSubmit: this._onSubmit })
      );
    }
  }]);
  return SupplierDetail;
}(React.Component);

function mapStateToProps(state) {
  var suppliers = state.inventory.supplier.suppliers;

  return {
    suppliers: suppliers
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SupplierDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SupplierForm = __webpack_require__(2143);

var _SupplierForm2 = _interopRequireDefault(_SupplierForm);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _PhoneNumberField = __webpack_require__(242);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

var _reactRedux = __webpack_require__(6);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _supplier = __webpack_require__(201);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var NOT_BLANK_ERROR = 'This field is required';
  var errors = {};
  if (!values.name) {
    errors.name = NOT_BLANK_ERROR;
  } else if (!_validator2.default.isLength(values.name, { max: 100 })) {
    errors.name = 'Name too long';
  }

  if (!values.phone) {
    errors.phone = NOT_BLANK_ERROR;
  }

  if (!values.email) {
    errors.email = NOT_BLANK_ERROR;
  } else if (!_validator2.default.isEmail(values.email)) {
    errors.email = 'Enter a valid email address';
  }

  if (!values.address) {
    errors.address = NOT_BLANK_ERROR;
  }

  if (!values.city) {
    errors.city = NOT_BLANK_ERROR;
  }

  if (!values.state) {
    errors.state = NOT_BLANK_ERROR;
  }

  if (!values.postal_code) {
    errors.postal_code = NOT_BLANK_ERROR;
  } else if (!_validator2.default.isLength(values.postal_code, { min: 5, max: 5 }) || !_validator2.default.isNumeric(values.postal_code)) {
    errors.postal_code = 'Please enter a valid format';
  }

  return errors;
};

var SupplierForm = function (_React$Component) {
  (0, _inherits3.default)(SupplierForm, _React$Component);

  function SupplierForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SupplierForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SupplierForm.__proto__ || (0, _getPrototypeOf2.default)(SupplierForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCancel = function (e) {
      _this.props.dispatch((0, _supplier.onClickCancel)());
      e.preventDefault();
      e.stopPropagation();
    }, _this._onClickDelete = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          supplierDetail = _this$props.supplierDetail;

      dispatch((0, _supplier.askDeleteSupplier)(supplierDetail));
      e.preventDefault();
      e.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SupplierForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          supplierForm = _props.supplierForm,
          isSubmittingForm = _props.isSubmittingForm;

      return React.createElement(
        'form',
        { className: _SupplierForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _SupplierForm2.default['field-wrapper'] },
          React.createElement(_LabelSection2.default, { title: 'supplier details' }),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(_reduxForm.Field, {
              component: 'input',
              type: 'hidden',
              name: 'id'
            }),
            React.createElement(
              'div',
              { className: 'col-sm-12 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'name',
                className: 'form-control',
                placeholder: 'Supplier Name'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _PhoneNumberField2.default,
                name: 'phone',
                type: 'tel',
                placeholder: '812'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'email',
                className: 'form-control',
                placeholder: 'Supplier Email'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-12' },
              React.createElement(_LabelSection2.default, { title: '    ' })
            ),
            React.createElement(
              'div',
              { className: 'col-md-12 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'address',
                className: 'form-control',
                placeholder: 'Supplier Address'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'city',
                className: 'form-control',
                placeholder: 'City'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'state',
                className: 'form-control',
                placeholder: 'State'
              })
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'postal_code',
                className: 'form-control',
                placeholder: 'Zip',
                positiveNumberOnly: true,
                maxFractionDigits: 0,
                maxLength: 5
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _SupplierForm2.default.footer },
          supplierForm && supplierForm.id && React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickDelete, type: 'button', disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default ' + _SupplierForm2.default['btn-cancel'], onClick: this._onClickCancel, type: 'button', disabled: isSubmittingForm },
              'Cancel'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ' + _SupplierForm2.default['btn-save'], type: 'button', onClick: this.props.handleSubmit, disabled: isSubmittingForm },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return SupplierForm;
}(React.Component);

function mapStateToProps(state) {
  var _state$inventory$supp = state.inventory.supplier,
      supplierDetail = _state$inventory$supp.supplierDetail,
      isSubmittingForm = _state$inventory$supp.isSubmittingForm;

  return {
    supplierDetail: supplierDetail,
    supplierForm: (0, _reduxForm.getFormValues)('supplier')(state),
    isSubmittingForm: isSubmittingForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'supplier',
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(SupplierForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Supplier = __webpack_require__(1419);

var _Supplier2 = _interopRequireDefault(_Supplier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Supplier2.default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _DropdownButtonSelectIcon = __webpack_require__(292);

var _DropdownButtonSelectIcon2 = _interopRequireDefault(_DropdownButtonSelectIcon);

var _pages = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAMESPACE_OPTIONS = [{
  id: 'items', name: 'Item Library'
}, {
  id: 'ingredients', name: 'Ingredients'
}];

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickExport = function () {
      var actionBarOnClickExport = _this.props.actionBarOnClickExport;

      actionBarOnClickExport();
    }, _this._onClickCreateTransfer = function () {
      var actionBarOnClickCreateTransfer = _this.props.actionBarOnClickCreateTransfer;

      actionBarOnClickCreateTransfer();
    }, _this._onChangeOutletIds = function (outletIds) {
      var actionBarOnChangeOutletIds = _this.props.actionBarOnChangeOutletIds;

      actionBarOnChangeOutletIds(outletIds);
    }, _this._onChangeDate = function (values) {
      var actionBarOnChangeDate = _this.props.actionBarOnChangeDate;

      actionBarOnChangeDate(values);
    }, _this._onChangeNamespace = function (event, namespace, previousNamespace) {
      // previousNamespace is reserved for mixpanel tracking
      var actionBarOnChangeNamespace = _this.props.actionBarOnChangeNamespace;

      actionBarOnChangeNamespace(namespace);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          isDirtyForm = _props.isDirtyForm,
          exportButtonStatus = _props.exportButtonStatus,
          isIngredientActive = _props.isIngredientActive;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-8 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(
            'form',
            { className: 'form-inline' },
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                name: 'outletIds',
                component: _DropdownOutlet2.default,
                outlets: outlets,
                onChangeOutletIds: this._onChangeOutletIds,
                allOutletOption: true
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                isDirtyForm: isDirtyForm,
                onChange: this._onChangeDate,
                onDirtyFormCallback: this._onChangeDate
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group mr-5px' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownButtonSelectIcon2.default,
                name: 'namespace',
                options: NAMESPACE_OPTIONS,
                onChange: this._onChangeNamespace,
                isDirtyForm: isDirtyForm,
                onDirtyFormCallback: this._onChangeNamespace,
                disabled: !isIngredientActive
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { disabled: !exportButtonStatus, className: 'btn btn-primary', onClick: this._onClickExport },
              'Export'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary ml-10px', onClick: this._onClickCreateTransfer },
              'Create Transfer'
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)(ActionBar);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _List = __webpack_require__(2144);

var _List2 = _interopRequireDefault(_List);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (transfer) {
      var listOnClickRow = _this.props.listOnClickRow;

      listOnClickRow(transfer);
    }, _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var listOnReachBottom = _this.props.listOnReachBottom;

      listOnReachBottom();
    }, _this._itemName = function (transfer) {
      if (transfer.history_details.length === 1) {
        if (!transfer.history_details[0].item_variant_name) {
          return transfer.history_details[0].item_name;
        } else {
          return transfer.history_details[0].item_name + ' (' + transfer.history_details.length + ' variants) ';
        }
      }

      if (transfer.history_details.length > 1) {
        var itemIds = [];

        transfer.history_details.forEach(function (hd, index) {
          if (!itemIds.includes(hd.item_id)) {
            itemIds.push(hd.item_id);
          }
        });

        if (itemIds.length === 1) {
          var itemName = transfer.history_details[0].item_name;
          return itemName + ' (' + transfer.history_details.length + ' variants) ';
        }

        if (itemIds.length > 1) {
          return itemIds.length + ' items';
        }
      }
    }, _this._quantity = function (transfer) {
      var total = 0;

      transfer.history_details.forEach(function (hd, index) {
        total += hd.quantity;
      });

      return transfer.is_sender ? -total : total;
    }, _this._note = function (transfer) {
      if (transfer.note) {
        return transfer.note;
      } else {
        return '-';
      }
    }, _this._ingredientName = function (_ref2) {
      var history_details = _ref2.history_details;

      if (history_details.length < 0) {
        return '';
      }
      return history_details.length > 1 ? history_details.length + ' Ingredients' : history_details[0].ingredient_name;
    }, _this._ingredientQuantity = function (transfer) {
      var historyDetails = transfer.history_details;
      if (historyDetails.length < 0) return '';

      return _lodash2.default.uniqBy(historyDetails, 'unit_id').length === 1 ? _this._calculateIngredientQuantity(transfer.is_sender, historyDetails) : 'Multiple Transfered';
    }, _this._calculateIngredientQuantity = function (isSender, historyDetails) {
      var totalQuantity = _lodash2.default.reduce(historyDetails, function (s, historyDetail) {
        return s + historyDetail.quantity;
      }, 0);

      var stringTotal = totalQuantity + ' ' + historyDetails[0].unit_name;
      if (isSender) return '-' + stringTotal;

      return stringTotal;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          transfers = _props.transfers,
          transferDetail = _props.transferDetail,
          searchForm = _props.searchForm;


      return transfers.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                'Date'
              ),
              React.createElement(
                'th',
                null,
                'From Outlet'
              ),
              React.createElement(
                'th',
                null,
                'To Outlet'
              ),
              React.createElement(
                'th',
                null,
                'Note'
              ),
              React.createElement(
                'th',
                { className: 'text-center' },
                searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'Items' : 'Ingredient'
              ),
              React.createElement(
                'th',
                { className: 'text-center' },
                'Quantity'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                transfers.map(function (transfer) {
                  var className = '' + (transferDetail && transferDetail.id === transfer.id ? _List2.default.selected : '');
                  if (transfer.isdaterow) {
                    return React.createElement(
                      'tr',
                      null,
                      React.createElement(
                        'td',
                        { colSpan: 6, className: _List2.default.parentRow },
                        (0, _moment2.default)(transfer.created_at).format('ddd MMM DD YYYY')
                      )
                    );
                  } else {
                    return React.createElement(
                      'tr',
                      { onClick: function onClick() {
                          _this2._onClickRow(transfer);
                        }, className: className },
                      React.createElement(
                        'td',
                        null,
                        (0, _moment2.default)(transfer.created_at).format('HH:mm')
                      ),
                      React.createElement(
                        'td',
                        null,
                        transfer.from_outlet.name
                      ),
                      React.createElement(
                        'td',
                        null,
                        transfer.to_outlet.name
                      ),
                      React.createElement(
                        'td',
                        null,
                        _this2._note(transfer)
                      ),
                      React.createElement(
                        'td',
                        { className: 'text-center' },
                        searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? _this2._itemName(transfer) : _this2._ingredientName(transfer)
                      ),
                      React.createElement(
                        'td',
                        { className: 'text-center' },
                        searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? _this2._quantity(transfer) : _this2._ingredientQuantity(transfer)
                      )
                    );
                  }
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

exports.default = List;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(49);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ActionBar = __webpack_require__(1423);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _List = __webpack_require__(1424);

var _List2 = _interopRequireDefault(_List);

var _TransferDetail = __webpack_require__(1429);

var _TransferDetail2 = _interopRequireDefault(_TransferDetail);

var _transfer = __webpack_require__(615);

var actInvTrf = _interopRequireWildcard(_transfer);

var _confirmAction = __webpack_require__(29);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _transfer2 = __webpack_require__(653);

var mpTransfers = _interopRequireWildcard(_transfer2);

var _constants = __webpack_require__(81);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Transfer = function (_React$Component) {
  (0, _inherits3.default)(Transfer, _React$Component);

  function Transfer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Transfer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Transfer.__proto__ || (0, _getPrototypeOf2.default)(Transfer)).call.apply(_ref, [this].concat(args))), _this), _this._listOnClickRow = function (transfer) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isDirtyTransfer = _this$props.isDirtyTransfer;

      if (isDirtyTransfer) {
        dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onClickRow(transfer)));
      } else {
        dispatch(actInvTrf.onClickRow(transfer));
      }
    }, _this._listOnReachBottom = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          currentPage = _this$props2.currentPage,
          transfers = _this$props2.transfers,
          _this$props2$searchFo = _this$props2.searchForm,
          date = _this$props2$searchFo.date,
          namespace = _this$props2$searchFo.namespace;
      var startDate = date.startDate,
          endDate = date.endDate;

      dispatch(actInvTrf.transfersRequest({
        page: currentPage + 1,
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD')
      }, transfers, namespace));
    }, _this._actionBarOnClickExport = function () {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          _this$props3$searchFo = _this$props3.searchForm,
          outletIds = _this$props3$searchFo.outletIds,
          _this$props3$searchFo2 = _this$props3$searchFo.date,
          startDate = _this$props3$searchFo2.startDate,
          endDate = _this$props3$searchFo2.endDate,
          namespace = _this$props3$searchFo.namespace;


      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');

      var title = '';
      if (namespace === _constants.NAMESPACE_ITEMS) {
        title = 'Inventory Transfer - ';
      } else if (namespace === _constants.NAMESPACE_INGREDIENTS) {
        title = 'Ingredient Inventory Transfer - ';
      }

      var filename = title + dateLabel;

      dispatch(actInvTrf.exportTransfer({
        start_date: startDate.format('DD/MM/YYYY'),
        end_date: endDate.format('DD/MM/YYYY')
      }, filename, outletIds[0], namespace));

      mpTransfers.inventoryTransferExport({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
    }, _this._actionBarOnClickCreateTransfer = function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          searchForm = _this$props4.searchForm,
          isDirtyTransfer = _this$props4.isDirtyTransfer,
          outlets = _this$props4.outlets;

      if (outlets.length > 1) {
        if (searchForm) {
          if (isDirtyTransfer) {
            dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onClickCreateTransfer(searchForm.outletIds[0])));
          } else {
            dispatch(actInvTrf.onClickCreateTransfer(searchForm.outletIds[0]));
          }
        }
      } else {
        dispatch(actNotif.error("Transfer is unavailable because you don't have more than 1 outlet"));
      }
    }, _this._actionBarOnChangeOutletIds = function (outletIds) {
      var _this$props5 = _this.props,
          _this$props5$searchFo = _this$props5.searchForm,
          _this$props5$searchFo2 = _this$props5$searchFo.date,
          startDate = _this$props5$searchFo2.startDate,
          endDate = _this$props5$searchFo2.endDate,
          namespace = _this$props5$searchFo.namespace,
          dispatch = _this$props5.dispatch,
          isDirtyTransfer = _this$props5.isDirtyTransfer;

      if (isDirtyTransfer) {
        dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onChangeOutletIds(outletIds, startDate, endDate, namespace)));
      } else {
        dispatch(actInvTrf.onChangeOutletIds(outletIds, startDate, endDate, namespace));
      }

      mpTransfers.inventoryTransferChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
    }, _this._actionBarOnChangeDate = function (values) {
      var startDate = values.startDate,
          endDate = values.endDate;
      var _this$props6 = _this.props,
          dispatch = _this$props6.dispatch,
          isDirtyTransfer = _this$props6.isDirtyTransfer,
          _this$props6$searchFo = _this$props6.searchForm,
          outletIds = _this$props6$searchFo.outletIds,
          namespace = _this$props6$searchFo.namespace;

      if (isDirtyTransfer) {
        dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onChangeDate(startDate, endDate, namespace)));
      } else {
        dispatch(actInvTrf.onChangeDate(startDate, endDate, namespace));
      }

      mpTransfers.inventoryTransferChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
    }, _this._actionBarOnChangeNamespace = function (namespace) {
      var _this$props7 = _this.props,
          dispatch = _this$props7.dispatch,
          isDirtyTransfer = _this$props7.isDirtyTransfer,
          _this$props7$searchFo = _this$props7.searchForm,
          outletIds = _this$props7$searchFo.outletIds,
          _this$props7$searchFo2 = _this$props7$searchFo.date,
          startDate = _this$props7$searchFo2.startDate,
          endDate = _this$props7$searchFo2.endDate;

      if (isDirtyTransfer) {
        dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onNamespaceChange(namespace)));
      } else {
        dispatch(actInvTrf.onNamespaceChange(namespace));
      }

      mpTransfers.inventoryTransferChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        namespace: namespace
      });
    }, _this._onDetailTransferClickDone = function () {
      var dispatch = _this.props.dispatch;

      dispatch(actInvTrf.closeRightColumn());
      dispatch(actInvTrf.setTransferDetail(null));
    }, _this._onClickAddItem = function () {
      var _this$props8 = _this.props,
          transferItem = _this$props8.transferItem,
          searchForm = _this$props8.searchForm,
          dispatch = _this$props8.dispatch;

      dispatch(actInvTrf.setSearchItemsInit([]));
      dispatch(actInvTrf.getItems(transferItem.fromOutlet, '', 1, searchForm.namespace, true, false, [], null, []));
      dispatch(actInvTrf.onClickAddItem());
    }, _this._onModalClickCancel = function () {
      var dispatch = _this.props.dispatch;

      dispatch(actInvTrf.onModalClickCancel());
      dispatch(actInvTrf.setIsItemAlreadyAdded(false));
    }, _this._onFromOutletChange = function () {
      _this.props.dispatch(actInvTrf.resetAddItems());
      _this.props.dispatch(actInvTrf.resetTransfersForm());
    }, _this._onModalSelectChange = function (selectedItemId, items, transfers) {
      var _this$props9 = _this.props,
          searchForm = _this$props9.searchForm,
          dispatch = _this$props9.dispatch;

      dispatch(actInvTrf.onModalSelectChange(selectedItemId, items, transfers, searchForm.namespace));
    }, _this._onModalSelectInputChange = function (keyword) {
      var _this$props10 = _this.props,
          fromOutlet = _this$props10.transferItem.fromOutlet,
          searchForm = _this$props10.searchForm,
          dispatch = _this$props10.dispatch;

      dispatch(actInvTrf.setIsItemAlreadyAdded(false));
      dispatch(actInvTrf.getItems(fromOutlet, keyword, 1, searchForm.namespace, false, false, [], null, []));
    }, _this._onModalSearchReachBottom = function (keyword) {
      var _this$props11 = _this.props,
          fromOutlet = _this$props11.transferItem.fromOutlet,
          searchForm = _this$props11.searchForm,
          addItems = _this$props11.addItems,
          dispatch = _this$props11.dispatch;

      if (addItems.items.length > 0 && addItems.currentPage <= addItems.totalPage) {
        dispatch(actInvTrf.getItems(fromOutlet, keyword, addItems.currentPage + 1, searchForm.namespace, false, false, addItems.items, addItems.totalPage, []));
      }
    }, _this._onModalGetFromInit = function () {
      var _this$props12 = _this.props,
          searchItemsInit = _this$props12.searchItemsInit,
          dispatch = _this$props12.dispatch;

      dispatch(actInvTrf.setAddItems(searchItemsInit));
    }, _this._onModalAddItems = function (items) {
      // const {dispatch, transferItem} = this.props
      // dispatch(actInvTrf.onModalAddItems(items, transferItem.transfers))
      var dispatch = _this.props.dispatch;

      dispatch(actInvTrf.onModalAddItems(items));
    }, _this._onSubmitCreateTransferForm = function (values) {
      _this.props.dispatch(actInvTrf.onSubmitCreateTransfer(values));
    }, _this._setShowConfirmSubmitModal = function (isShowConfirmSubmitModal) {
      _this.props.dispatch(actInvTrf.setShowConfirmSubmitModal(isShowConfirmSubmitModal));
    }, _this._onConfirmCreateTransfer = function () {
      var _this$props13 = _this.props,
          transferItem = _this$props13.transferItem,
          dispatch = _this$props13.dispatch,
          _this$props13$searchF = _this$props13.searchForm,
          date = _this$props13$searchF.date,
          namespace = _this$props13$searchF.namespace;

      dispatch(actInvTrf.onConfirmCreateTransfer(transferItem, date, namespace));
    }, _this._onClickLinkIngredient = function () {
      _this.props.dispatch((0, _confirmAction.askConfirmAction)(actInvTrf.onNamespaceChange(_constants.NAMESPACE_INGREDIENTS)));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Transfer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          expired = _props.expired;

      if (!expired) {
        dispatch(actInvTrf.pageRequest());

        _reactRouter.browserHistory.listenBefore(function (location) {
          var _props2 = _this2.props,
              isDirtyTransfer = _props2.isDirtyTransfer,
              nextAction = _props2.nextAction;

          if (isDirtyTransfer && !nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          transfers = _props3.transfers,
          currentPage = _props3.currentPage,
          totalPage = _props3.totalPage,
          showLoadingSpinnerPage = _props3.showLoadingSpinnerPage,
          transferDetail = _props3.transferDetail,
          openRightColumn = _props3.openRightColumn,
          outlets = _props3.outlets,
          selectedOutlets = _props3.selectedOutlets,
          showAddItemsModal = _props3.showAddItemsModal,
          showConfirmSubmitModal = _props3.showConfirmSubmitModal,
          addItems = _props3.addItems,
          itemOptionIsLoading = _props3.itemOptionIsLoading,
          transferItem = _props3.transferItem,
          searchForm = _props3.searchForm,
          isItemAlreadyAdded = _props3.isItemAlreadyAdded,
          isDirtyTransfer = _props3.isDirtyTransfer,
          exportButtonStatus = _props3.exportButtonStatus,
          confirmCreateButtonStatus = _props3.confirmCreateButtonStatus,
          addTransferItems = _props3.addTransferItems,
          isIngredientActive = _props3.isIngredientActive;


      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, {
          outlets: outlets,
          isDirtyForm: isDirtyTransfer,
          exportButtonStatus: exportButtonStatus,
          actionBarOnClickExport: this._actionBarOnClickExport,
          actionBarOnClickCreateTransfer: this._actionBarOnClickCreateTransfer,
          actionBarOnChangeOutletIds: this._actionBarOnChangeOutletIds,
          actionBarOnChangeDate: this._actionBarOnChangeDate,
          actionBarOnChangeNamespace: this._actionBarOnChangeNamespace,
          isIngredientActive: isIngredientActive }),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: transfers.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, {
              searchForm: searchForm,
              transfers: transfers,
              transferDetail: transferDetail,
              currentPage: currentPage,
              totalPage: totalPage,
              listOnClickRow: this._listOnClickRow,
              listOnReachBottom: this._listOnReachBottom,
              showLoadingSpinner: showLoadingSpinnerPage })
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_TransferDetail2.default, {
              searchForm: searchForm,
              transferDetail: transferDetail,
              onClickDone: this._onDetailTransferClickDone,
              outlets: outlets,
              selectedOutlets: selectedOutlets,
              showAddItemsModal: showAddItemsModal,
              addItems: addItems,
              onClickAddItem: this._onClickAddItem,
              onModalClickCancel: this._onModalClickCancel,
              onFromOutletChange: this._onFromOutletChange,
              itemOptionIsLoading: itemOptionIsLoading,
              onModalSelectChange: this._onModalSelectChange,
              onModalAddItems: this._onModalAddItems,
              setShowConfirmSubmitModal: this._setShowConfirmSubmitModal,
              onSubmitCreateTransferForm: this._onSubmitCreateTransferForm,
              showConfirmSubmitModal: showConfirmSubmitModal,
              onConfirmCreateTransfer: this._onConfirmCreateTransfer,
              transferItemForm: transferItem,
              addTransferItemsForm: addTransferItems,
              isItemAlreadyAdded: isItemAlreadyAdded,
              onModalSelectInputChange: this._onModalSelectInputChange,
              confirmCreateButtonStatus: confirmCreateButtonStatus,
              onModalSearchReachBottom: this._onModalSearchReachBottom,
              onModalGetFromInit: this._onModalGetFromInit,
              clickLinkIngredient: this._onClickLinkIngredient })
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }

    // LIST COMPONENT START

    // LIST COMPONENT END

    // ACTIONBAR COMPONENT START

    // ACTIONBAR COMPONENT END

    // when close right column


    // when clicked add items in create transfer form


    // when clicked cancel in addItems modal


    // when fromOutlet filed value in create transfer form change


    // when select in add item modal change


    // when submit add item modal


    // when submit craete transfer form


    // to show/hide create transfer confirmAction modal

  }]);
  return Transfer;
}(React.Component);

function mapStateToProps(state) {
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var _state$inventory$tran = state.inventory.transfer,
      transfers = _state$inventory$tran.transfers,
      transferDetail = _state$inventory$tran.transferDetail,
      currentPage = _state$inventory$tran.currentPage,
      totalPage = _state$inventory$tran.totalPage,
      openRightColumn = _state$inventory$tran.openRightColumn,
      outlets = _state$inventory$tran.outlets,
      selectedOutlets = _state$inventory$tran.selectedOutlets,
      showAddItemsModal = _state$inventory$tran.showAddItemsModal,
      showConfirmSubmitModal = _state$inventory$tran.showConfirmSubmitModal,
      addItems = _state$inventory$tran.addItems,
      itemOptionIsLoading = _state$inventory$tran.itemOptionIsLoading,
      isItemAlreadyAdded = _state$inventory$tran.isItemAlreadyAdded,
      exportButtonStatus = _state$inventory$tran.exportButtonStatus,
      confirmCreateButtonStatus = _state$inventory$tran.confirmCreateButtonStatus,
      searchItemsInit = _state$inventory$tran.searchItemsInit,
      searchItems = _state$inventory$tran.searchItems;
  var expired = state.subscriptionExpired.expired;
  var is_active = state.inventory.ingredientSubscription.subscriptionStatus.is_active;


  return {
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    transfers: transfers,
    transferDetail: transferDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    openRightColumn: openRightColumn,
    outlets: outlets,
    selectedOutlets: selectedOutlets,
    showAddItemsModal: showAddItemsModal,
    showConfirmSubmitModal: showConfirmSubmitModal,
    addItems: addItems,
    itemOptionIsLoading: itemOptionIsLoading,
    isItemAlreadyAdded: isItemAlreadyAdded,
    exportButtonStatus: exportButtonStatus,
    confirmCreateButtonStatus: confirmCreateButtonStatus,
    searchItemsInit: searchItemsInit,
    searchItems: searchItems,
    searchForm: (0, _reduxForm.getFormValues)('search')(state),
    transferItem: (0, _reduxForm.getFormValues)('transferItem')(state),
    addTransferItems: (0, _reduxForm.getFormValues)('addTransferItems')(state),
    isDirtyTransfer: (0, _reduxForm.isDirty)('transferItem')(state),
    nextAction: state.confirmAction.nextAction,
    expired: expired,
    isIngredientActive: is_active
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Transfer);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _reactBootstrap = __webpack_require__(10);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _AddItemsModal = __webpack_require__(2145);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _WarningMessage = __webpack_require__(444);

var _WarningMessage2 = _interopRequireDefault(_WarningMessage);

var _ItemHasRecipe = __webpack_require__(440);

var _ItemHasRecipe2 = _interopRequireDefault(_ItemHasRecipe);

var _constants = __webpack_require__(81);

var _SearchModal = __webpack_require__(293);

var _SearchModal2 = _interopRequireDefault(_SearchModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values, props) {
  var items = values.items;

  var errors = {};
  var itemsErrors = [];

  if (items) {
    items.forEach(function (item, index) {
      var itemErrors = {};
      if (!item.quantity && '' + item.quantity !== '0') {
        itemErrors.quantity = 'Please enter a valid value';
        itemsErrors[index] = itemErrors;
      } else if (props.searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && parseFloat(item.quantity) < 0.01) {
        itemErrors.quantity = 'Quantity must greater than or equal 0.01';
        itemsErrors[index] = itemErrors;
      }
    });
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors;
  }
  return errors;
};

var nameField = function nameField(props) {
  var input = props.input;


  return React.createElement('input', (0, _extends3.default)({}, input, { defaultValue: input.value, readOnly: true, className: 'form-control' }));
};

var nameFieldDisabled = function nameFieldDisabled(props) {
  var input = props.input;


  var style = {
    color: '#ddd',
    background: '#fff',
    cursor: 'not-allowed'
  };

  return React.createElement('input', (0, _extends3.default)({ style: style }, input, { defaultValue: input.value, readOnly: true, className: 'form-control' }));
};

var AddItemsModal = function (_React$Component) {
  (0, _inherits3.default)(AddItemsModal, _React$Component);

  function AddItemsModal(props) {
    (0, _classCallCheck3.default)(this, AddItemsModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddItemsModal.__proto__ || (0, _getPrototypeOf2.default)(AddItemsModal)).call(this, props));

    _this._onSubmit = function (values) {
      var _this$props = _this.props,
          reset = _this$props.reset,
          onModalAddItems = _this$props.onModalAddItems;

      onModalAddItems(values.items);
      _this.setState({ selectValue: null });
      reset();
    };

    _this._onHide = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props2 = _this.props,
          reset = _this$props2.reset,
          onModalClickCancel = _this$props2.onModalClickCancel;

      _this.setState({ selectValue: null });
      reset();
      onModalClickCancel();
    };

    _this._selectOnInputChange = function (value) {
      var onModalSelectInputChange = _this.props.onModalSelectInputChange;

      _this.setState({ selectValue: null, keyword: value });
      onModalSelectInputChange(value);
      _this.props.reset();
    };

    _this._selectOnChange = function (val) {
      var _this$props3 = _this.props,
          onModalSelectChange = _this$props3.onModalSelectChange,
          addItems = _this$props3.addItems,
          transferItemForm = _this$props3.transferItemForm,
          searchForm = _this$props3.searchForm;

      var hasRecipe = false;
      if (val) {
        onModalSelectChange(val.value, addItems.items, transferItemForm.transfers);
        _this.setState({ selectValue: val.value });
        addItems.items.forEach(function (item) {
          if (item.id === val.value) {
            hasRecipe = item.is_recipe;
          }
        });

        if (hasRecipe && searchForm.namespace === _constants.NAMESPACE_ITEMS) {
          _this.setState({ itemHasRecipe: true });
        } else {
          _this.setState({ itemHasRecipe: false });
        }
      } else {
        _this.setState({ selectValue: null });
        _this.props.onModalGetFromInit();
      }
    };

    _this._selectOnClick = function () {
      _this.setState({ keyword: '' });
      if (!_this.state.selectValue) {
        _this.props.onModalGetFromInit();
      }
    };

    _this._onSearchReachBottom = function () {
      _this.props.onModalSearchReachBottom(_this.state.keyword);
    };

    _this._dismissError = function () {
      _this.setState({ openErrorAlert: false });
    };

    _this._onErrorQuantity = function () {
      _this.setState({ openErrorAlert: true });
      setTimeout(function () {
        this.setState({ openErrorAlert: false });
      }.bind(_this), 1000);
    };

    _this._renderField = function (member, index, fields) {
      var searchForm = _this.props.searchForm;

      var transferObject = fields.get(index);

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS && transferObject.isItem && React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: nameField,
            type: !transferObject.isItem ? 'hidden' : '',
            name: member + '.itemName'
          })
        ),
        searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS && !transferObject.isItem && React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: nameField,
            name: member + '.itemVariantName'
          })
        ),
        searchForm && searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: nameField,
            name: member + '.unitName'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: nameFieldDisabled,
            name: member + '.inStock'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4', style: { paddingRight: 0 } },
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            name: member + '.quantity',
            className: 'form-control',
            normalize: _this._lessThanEqualInStock(index),
            positiveNumberOnly: true,
            maxFractionDigits: searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 0 : 2
          })
        )
      );
    };

    _this._renderFieldArray = function (_ref) {
      var fields = _ref.fields;
      var searchForm = _this.props.searchForm;

      var doms = [];

      if (fields.length) {
        doms.push(React.createElement(
          'table',
          { className: _AddItemsModal2.default['table-header'] + ' table table-truncate' },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS && React.createElement(
                'th',
                { className: 'text-center', width: '30%' },
                fields.length > 1 ? 'Variant' : 'Item'
              ),
              searchForm && searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && React.createElement(
                'th',
                { className: 'text-center', width: '30%' },
                'Unit'
              ),
              React.createElement(
                'th',
                { className: 'text-center', width: '30%' },
                'In Stock'
              ),
              React.createElement(
                'th',
                { className: 'text-center', width: '30%' },
                'Transfer Quantity'
              )
            )
          )
        ));
      }

      return React.createElement(
        'div',
        { className: _AddItemsModal2.default['list-item-input'] },
        doms,
        React.createElement(
          'div',
          { className: 'row mk-grouped-list-input ' + _AddItemsModal2.default['list-item-input-detail'] },
          React.createElement(
            'div',
            { className: 'col-xs-12' },
            fields.map(_this._renderField)
          )
        )
      );
    };

    _this._lessThanEqualInStock = function (index) {
      return function (value, previousValue, allValues) {
        if (value) {
          // only allow number
          if (isNaN(value)) {
            return previousValue;
          }
          if (parseFloat(value) <= parseFloat(allValues.items[index].inStock)) {
            return value;
          } else {
            _this._onErrorQuantity();
            return allValues.items[index].inStock < 0 ? 0 : allValues.items[index].inStock;
          }
        } else {
          return value;
        }
      };
    };

    _this._hasMore = function () {
      var _this$props$addItems = _this.props.addItems,
          currentPage = _this$props$addItems.currentPage,
          totalPage = _this$props$addItems.totalPage;

      return currentPage < totalPage;
    };

    _this.state = {
      openErrorAlert: false,
      selectValue: null,
      keyword: '',
      itemHasRecipe: false
    };
    return _this;
  }

  (0, _createClass3.default)(AddItemsModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.showAddItemsModal && !this.props.showAddItemsModal) {
        this.setState({ itemHasRecipe: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showAddItemsModal = _props.showAddItemsModal,
          addItems = _props.addItems,
          itemOptionIsLoading = _props.itemOptionIsLoading,
          isItemAlreadyAdded = _props.isItemAlreadyAdded,
          searchForm = _props.searchForm,
          handleSubmit = _props.handleSubmit,
          addTransferItemsForm = _props.addTransferItemsForm,
          clickLinkIngredient = _props.clickLinkIngredient;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAddItemsModal, backdrop: 'static', dialogClassName: _AddItemsModal2.default.dialog, className: '' + _AddItemsModal2.default.modalitem },
        React.createElement(_ModalHeader2.default, { title: searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'Add Items' : 'Add Ingredients' }),
        React.createElement(
          'form',
          { onSubmit: handleSubmit(this._onSubmit) },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: _AddItemsModal2.default.modalBody },
            React.createElement(
              'div',
              { className: _AddItemsModal2.default['warning-style'] },
              this.state.openErrorAlert && React.createElement(
                _reactBootstrap.Alert,
                { bsStyle: 'danger' },
                React.createElement('span', { onClick: this._dismissError, className: 'glyphicon glyphicon-remove ' + _AddItemsModal2.default['dismiss-warning-button'], 'aria-hidden': 'true' }),
                React.createElement(
                  'h5',
                  { className: 'ml-30px' },
                  'Cannot add more ',
                  searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'items' : 'ingredients',
                  ' than current stock'
                )
              )
            ),
            React.createElement(_reduxForm.Field, {
              component: _SearchModal2.default,
              type: 'text',
              name: 'search-item',
              placeholder: searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'Search items' : 'Search ingredients',
              options: addItems.itemOptions,
              onClickItem: this._selectOnChange,
              onInputChange: this._selectOnInputChange,
              inputValue: this.state.selectValue,
              onMenuScrollToBottom: this._onSearchReachBottom,
              isHasMore: this._hasMore,
              isLoading: itemOptionIsLoading
            }),
            React.createElement(_ItemHasRecipe2.default, { hasRecipe: this.state.itemHasRecipe, onClickIngredient: clickLinkIngredient }),
            isItemAlreadyAdded && !this.state.itemHasRecipe && React.createElement(
              'div',
              { className: _AddItemsModal2.default['warning-message-wrapper'] },
              React.createElement(
                _WarningMessage2.default,
                null,
                '\xA0\xA0\xA0This ',
                searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'items' : 'ingredients',
                ' already added, go to ',
                React.createElement(
                  'a',
                  { href: 'javascript:void(0)', onClick: this._onHide },
                  React.createElement(
                    'u',
                    null,
                    React.createElement(
                      'i',
                      null,
                      'Transfer stock table'
                    )
                  )
                ),
                ' to edit'
              )
            ),
            !this.state.itemHasRecipe && React.createElement(_reduxForm.FieldArray, {
              name: 'items',
              component: this._renderFieldArray
            })
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { type: 'button', className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { type: 'submit',
                  className: addTransferItemsForm && !addTransferItemsForm.items.length || this.state.itemHasRecipe ? 'btn ' + _AddItemsModal2.default['disableBtnAddItem'] : 'btn btn-primary',
                  disabled: isItemAlreadyAdded || addTransferItemsForm && !addTransferItemsForm.items.length || this.state.itemHasRecipe },
                'Add'
              )
            )
          )
        )
      );
    }

    // on this modal submit


    // when Select onChange

  }]);
  return AddItemsModal;
}(React.Component);

var mapForm = {
  form: 'addTransferItems',
  touchOnBlur: true,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)(AddItemsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TransferDetail = __webpack_require__(330);

var _TransferDetail2 = _interopRequireDefault(_TransferDetail);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapTransferDetailData = function mapTransferDetailData(historyDetails) {
  var ingredientUnitIds = [];
  var groupedIngredients = [];
  historyDetails.forEach(function (hd, index) {
    if (!ingredientUnitIds.includes(hd.unit_id)) {
      ingredientUnitIds.push(hd.unit_id);
      groupedIngredients.push({ unit_id: hd.unit_id, unit_name: hd.unit_name, total: 0, ingredientHistoryDetails: [] });
    }

    groupedIngredients.forEach(function (ing, index) {
      if (ing.unit_id === hd.unit_id) {
        ing.ingredientHistoryDetails.push(hd);
        ing.total = ing.total + hd.quantity;
      }
    });
  });
  return groupedIngredients.sort(function (a, b) {
    return (a.unit_name > b.unit_name) - (a.unit_name < b.unit_name);
  });
};

var IngredientTransferStock = function (_React$Component) {
  (0, _inherits3.default)(IngredientTransferStock, _React$Component);

  function IngredientTransferStock() {
    (0, _classCallCheck3.default)(this, IngredientTransferStock);
    return (0, _possibleConstructorReturn3.default)(this, (IngredientTransferStock.__proto__ || (0, _getPrototypeOf2.default)(IngredientTransferStock)).apply(this, arguments));
  }

  (0, _createClass3.default)(IngredientTransferStock, [{
    key: 'render',
    value: function render() {
      var transferDetail = this.props.transferDetail;


      return transferDetail && React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row mt-40px mb-5px ml-0px mr-0px' },
          React.createElement('div', { className: 'col-sm-5 pl-0px' })
        ),
        React.createElement(_LabelSection2.default, { title: 'transfer stock table' }),
        mapTransferDetailData(transferDetail.history_details).map(function (ing, index) {
          return React.createElement(
            'div',
            null,
            ing.ingredientHistoryDetails.map(function (ihd, index) {
              return React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'row' },
                  React.createElement(
                    'div',
                    { className: 'col-sm-9 ml-5px ' },
                    React.createElement(
                      'div',
                      null,
                      ihd.ingredient_name
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-sm-3 pl-0px ' + _TransferDetail2.default['variant-quantity'] },
                    React.createElement(
                      'div',
                      null,
                      transferDetail.is_sender ? -ihd.quantity : ihd.quantity,
                      ' ' + ihd.unit_name
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'row' },
                  React.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
                  )
                )
              );
            }),
            React.createElement(
              'div',
              { className: 'row mb-30px' },
              React.createElement(
                'div',
                { className: 'col-sm-8 ' + _TransferDetail2.default['label-total'] },
                'TOTAL'
              ),
              React.createElement(
                'div',
                { className: 'col-sm-4 ' + _TransferDetail2.default['total-ing-trf'] },
                transferDetail.is_sender ? -ing.total : ing.total,
                ' ' + ing.unit_name
              )
            )
          );
        })
      );
    }
  }]);
  return IngredientTransferStock;
}(React.Component);

exports.default = IngredientTransferStock;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _TransferDetail = __webpack_require__(330);

var _TransferDetail2 = _interopRequireDefault(_TransferDetail);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetails = function (_React$Component) {
  (0, _inherits3.default)(ItemDetails, _React$Component);

  function ItemDetails() {
    (0, _classCallCheck3.default)(this, ItemDetails);
    return (0, _possibleConstructorReturn3.default)(this, (ItemDetails.__proto__ || (0, _getPrototypeOf2.default)(ItemDetails)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemDetails, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          transferDetail = _props.transferDetail,
          searchForm = _props.searchForm;


      return transferDetail && React.createElement(
        'div',
        null,
        searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS && React.createElement(_LabelSection2.default, { title: 'item details' }),
        searchForm && searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && React.createElement(_LabelSection2.default, { title: 'ingredient details' }),
        React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-2' },
            React.createElement(
              'span',
              null,
              'Date'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-10' },
            React.createElement(
              'div',
              { className: 'text-right' },
              React.createElement(
                'span',
                null,
                (0, _moment2.default)(transferDetail.created_at).format('DD MMMM YYYY HH:mm')
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
          )
        ),
        searchForm && searchForm.outletIds.length > 1 && React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-3' },
            React.createElement(
              'span',
              null,
              'From Outlet'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-9' },
            React.createElement(
              'div',
              { className: 'text-right' },
              transferDetail.from_outlet.name
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
          )
        ),
        React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-3' },
            React.createElement(
              'span',
              null,
              'To Outlet'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-9' },
            React.createElement(
              'div',
              { className: 'text-right' },
              transferDetail.to_outlet.name
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
          )
        ),
        React.createElement(
          'div',
          { className: 'row mb-5px' },
          React.createElement(
            'div',
            { className: 'col-sm-2' },
            React.createElement(
              'span',
              null,
              'Note'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-10' },
            React.createElement(
              'div',
              { className: 'text-right' },
              transferDetail.note
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
          )
        )
      );
    }
  }]);
  return ItemDetails;
}(React.Component);

exports.default = ItemDetails;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TransferDetail = __webpack_require__(330);

var _TransferDetail2 = _interopRequireDefault(_TransferDetail);

var _ItemDetails = __webpack_require__(1428);

var _ItemDetails2 = _interopRequireDefault(_ItemDetails);

var _TransferStock = __webpack_require__(1432);

var _TransferStock2 = _interopRequireDefault(_TransferStock);

var _IngredientTransferStock = __webpack_require__(1427);

var _IngredientTransferStock2 = _interopRequireDefault(_IngredientTransferStock);

var _TransferForm = __webpack_require__(1431);

var _TransferForm2 = _interopRequireDefault(_TransferForm);

var _AddItemsModal = __webpack_require__(1426);

var _AddItemsModal2 = _interopRequireDefault(_AddItemsModal);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferDetail = function (_React$Component) {
  (0, _inherits3.default)(TransferDetail, _React$Component);

  function TransferDetail() {
    (0, _classCallCheck3.default)(this, TransferDetail);
    return (0, _possibleConstructorReturn3.default)(this, (TransferDetail.__proto__ || (0, _getPrototypeOf2.default)(TransferDetail)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransferDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          searchForm = _props.searchForm,
          transferDetail = _props.transferDetail,
          onClickDone = _props.onClickDone,
          outlets = _props.outlets,
          selectedOutlets = _props.selectedOutlets,
          showAddItemsModal = _props.showAddItemsModal,
          onClickAddItem = _props.onClickAddItem,
          addItems = _props.addItems,
          onModalClickCancel = _props.onModalClickCancel,
          onFromOutletChange = _props.onFromOutletChange,
          itemOptionIsLoading = _props.itemOptionIsLoading,
          onModalSelectChange = _props.onModalSelectChange,
          onModalAddItems = _props.onModalAddItems,
          showConfirmSubmitModal = _props.showConfirmSubmitModal,
          setShowConfirmSubmitModal = _props.setShowConfirmSubmitModal,
          onConfirmCreateTransfer = _props.onConfirmCreateTransfer,
          transferItemForm = _props.transferItemForm,
          addTransferItemsForm = _props.addTransferItemsForm,
          isItemAlreadyAdded = _props.isItemAlreadyAdded,
          onModalSelectInputChange = _props.onModalSelectInputChange,
          onSubmitCreateTransferForm = _props.onSubmitCreateTransferForm,
          confirmCreateButtonStatus = _props.confirmCreateButtonStatus,
          onModalSearchReachBottom = _props.onModalSearchReachBottom,
          onModalGetFromInit = _props.onModalGetFromInit,
          clickLinkIngredient = _props.clickLinkIngredient;


      return transferDetail ? React.createElement(
        'div',
        { className: _TransferDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _TransferDetail2.default['field-wrapper'] },
          React.createElement(_ItemDetails2.default, {
            transferDetail: transferDetail,
            searchForm: searchForm }),
          searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS && React.createElement(_TransferStock2.default, { transferDetail: transferDetail }),
          searchForm && searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && React.createElement(_IngredientTransferStock2.default, { transferDetail: transferDetail })
        ),
        React.createElement(
          'div',
          { className: _TransferDetail2.default.footer },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary ' + _TransferDetail2.default['btn-done'],
                onClick: onClickDone },
              'Done'
            )
          )
        )
      ) : React.createElement(
        'div',
        { className: _TransferDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _TransferDetail2.default['form-wrapper'] },
          React.createElement(_TransferForm2.default, {
            outlets: outlets,
            selectedOutlets: selectedOutlets,
            onClickAddItem: onClickAddItem,
            onFromOutletChange: onFromOutletChange,
            showConfirmSubmitModal: showConfirmSubmitModal,
            setShowConfirmSubmitModal: setShowConfirmSubmitModal,
            onConfirmCreateTransfer: onConfirmCreateTransfer,
            isItemAlreadyAdded: isItemAlreadyAdded,
            onClickDone: onClickDone,
            onSubmitCreateTransferForm: onSubmitCreateTransferForm,
            searchForm: searchForm,
            confirmCreateButtonStatus: confirmCreateButtonStatus }),
          React.createElement(_AddItemsModal2.default, {
            showAddItemsModal: showAddItemsModal,
            addItems: addItems,
            onModalClickCancel: onModalClickCancel,
            itemOptionIsLoading: itemOptionIsLoading,
            onModalSelectChange: onModalSelectChange,
            onModalAddItems: onModalAddItems,
            transferItemForm: transferItemForm,
            addTransferItemsForm: addTransferItemsForm,
            isItemAlreadyAdded: isItemAlreadyAdded,
            onModalSelectInputChange: onModalSelectInputChange,
            searchForm: searchForm,
            onModalSearchReachBottom: onModalSearchReachBottom,
            onModalGetFromInit: onModalGetFromInit,
            clickLinkIngredient: clickLinkIngredient })
        )
      );
    }
  }]);
  return TransferDetail;
}(React.Component);

exports.default = TransferDetail;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ConfirmSubmitModal = __webpack_require__(2146);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmSubmitModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmSubmitModal, _React$Component);

  function ConfirmSubmitModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmSubmitModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmSubmitModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmSubmitModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreate = function () {
      _this.props.onConfirmCreateTransfer();
    }, _this._onHide = function () {
      _this.props.setShowConfirmSubmitModal(false);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmSubmitModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showConfirmSubmitModal = _props.showConfirmSubmitModal,
          confirmCreateButtonStatus = _props.confirmCreateButtonStatus;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showConfirmSubmitModal, dialogClassName: _ConfirmSubmitModal2.default['modal-dialog'] },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmSubmitModal2.default['modal-header'] },
          'Information'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          'Are you sure you want to proceed? You cannot edit or delete this entry after saving.'
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { type: 'button', onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            {
              type: 'button',
              className: 'btn btn-primary',
              onClick: this._onClickCreate,
              disabled: confirmCreateButtonStatus
            },
            'OK'
          )
        )
      );
    }
  }]);
  return ConfirmSubmitModal;
}(React.Component);

exports.default = ConfirmSubmitModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactBootstrap = __webpack_require__(10);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _TransferForm = __webpack_require__(2147);

var _TransferForm2 = _interopRequireDefault(_TransferForm);

var _ConfirmSubmitModal = __webpack_require__(1430);

var _ConfirmSubmitModal2 = _interopRequireDefault(_ConfirmSubmitModal);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lessThanEqualInStock = function lessThanEqualInStock(index) {
  return function (value, previousValue, allValues) {
    if (value) {
      if (parseFloat(value) < parseFloat(allValues.transfers[index].inStock)) {
        return value;
      } else {
        return allValues.transfers[index].inStock < 0 ? 0 : allValues.transfers[index].inStock;
      }
    } else {
      return value;
    }
  };
};

var validate = function validate(values, props) {
  var transfers = values.transfers;

  var errors = {};
  var transferErrors = [];

  if (transfers) {
    transfers.forEach(function (trf, index) {
      var transferError = {};
      if (!trf.quantity && '' + trf.quantity !== '0') {
        transferError.quantity = 'Please enter a valid value';
        transferErrors[index] = transferError;
      } else if (props.searchForm.namespace === _constants.NAMESPACE_INGREDIENTS && parseFloat(trf.quantity) < 0.01) {
        transferError.quantity = 'Quantity must greater than or equal 0.01';
        transferErrors[index] = transferError;
      }
    });
  }
  if (transferErrors.length) {
    errors.transfers = transferErrors;
  }
  return errors;
};

var popoverFocus = function popoverFocus(_ref) {
  var content = _ref.content;
  return React.createElement(
    _reactBootstrap.Popover,
    { id: 'transfer' },
    content
  );
};

var renderTransfer = function renderTransfer(member, index, fields) {
  var transferObject = fields.get(index);
  return React.createElement(
    'div',
    { className: 'col-sm-12 mk-grouped-input' },
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      !transferObject.isItem && React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: popoverFocus({ content: transferObject.itemVariantName }) },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.itemVariantName',
          className: 'form-control ' + _TransferForm2.default['item-variant-name'],
          disabled: true
        })
      ),
      transferObject.isItem && React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: popoverFocus({ content: transferObject.itemName }) },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.itemName',
          className: 'form-control ' + _TransferForm2.default['item-name'],
          disabled: true
        })
      )
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: 'input',
        name: member + '.inStock',
        className: 'form-control ' + _TransferForm2.default['in-stock'],
        disabled: true
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: _SettingField2.default,
        name: member + '.quantity',
        className: 'form-control',
        normalize: lessThanEqualInStock(index),
        inputClassName: transferObject.isItem ? '' + _TransferForm2.default['last-input'] : '',
        feedbackClassName: transferObject.isItem ? '' + _TransferForm2.default['feedback'] : '',
        positiveNumberOnly: true,
        maxFractionDigits: 0
      }),
      transferObject.isItem && React.createElement(
        'span',
        { onClick: function onClick() {
            fields.remove(index);
          }, className: _TransferForm2.default['btn-delete-wrapper'] },
        React.createElement('i', { className: 'fa fa-times-circle' })
      )
    )
  );
};

var renderTransferArray = function renderTransferArray(_ref2) {
  var fields = _ref2.fields,
      meta = _ref2.meta;

  var lastItemId = 0;
  var doms = [];
  var inputdoms = [];

  fields.forEach(function () {
    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    var member = props[0],
        index = props[1];

    var field = fields.get(index);
    var shouldRenderHeader = lastItemId === 0 || field.itemId !== lastItemId;
    var shouldRenderItemNameRow = !field.isItem;
    lastItemId = field.itemId;

    if (shouldRenderHeader) {
      if (inputdoms.length) {
        doms.push(React.createElement(
          'div',
          { className: 'row mb-20px' },
          React.createElement(
            'div',
            { className: 'col-sm-12' },
            inputdoms
          )
        ));
        inputdoms = [];
      }
      doms.push(React.createElement(
        'div',
        { className: 'col-sm-12 mt-10px mb-10px' },
        React.createElement(
          'div',
          { className: 'col-sm-4 text-center' },
          !field.isItem && 'VARIANT',
          field.isItem && 'ITEM'
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 text-center' },
          'IN STOCK'
        ),
        React.createElement(
          'div',
          { className: 'col-sm-4 text-center' },
          'QUANTITY'
        )
      ));
    }

    if (shouldRenderHeader && shouldRenderItemNameRow) {
      inputdoms.push(React.createElement(
        'div',
        { className: 'col-sm-12 mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-12', style: { paddingRight: 1 } },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            name: member + '.itemName',
            className: 'form-control ' + _TransferForm2.default['item-name-header'],
            disabled: true
          }),
          React.createElement(
            'span',
            { onClick: function onClick() {
                // use counter because when remove index, fields immediately shifts up
                var i = 0;
                fields.getAll().forEach(function (tmp, idx) {
                  if (tmp.itemId === field.itemId) {
                    fields.remove(idx - i);
                    i++;
                  }
                });
              }, className: _TransferForm2.default['btn-delete-wrapper'] },
            React.createElement('i', { className: 'fa fa-times-circle' })
          )
        )
      ));
    }
    inputdoms.push(renderTransfer.apply(undefined, props));
  });
  if (inputdoms.length) {
    doms.push(React.createElement(
      'div',
      { className: 'row mb-20px' },
      React.createElement(
        'div',
        { className: 'col-sm-12' },
        inputdoms
      )
    ));
  }
  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input ' + _TransferForm2.default['transfer-item-wrapper'] },
    doms
  );
};

var renderIngredientTransfer = function renderIngredientTransfer(member, index, fields) {
  var transferObject = fields.get(index);
  return React.createElement(
    'div',
    { className: 'col-sm-12 mk-grouped-input' },
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(
        _reactBootstrap.OverlayTrigger,
        { placement: 'top', overlay: popoverFocus({ content: transferObject.unitName }) },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.unitName',
          className: 'form-control ' + _TransferForm2.default['ingredient-unit-name'],
          disabled: true
        })
      )
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: 'input',
        name: member + '.inStock',
        className: 'form-control ' + _TransferForm2.default['in-stock'],
        disabled: true
      })
    ),
    React.createElement(
      'div',
      { className: 'form-group col-sm-4' },
      React.createElement(_reduxForm.Field, {
        component: _SettingField2.default,
        name: member + '.quantity',
        className: 'form-control',
        positiveNumberOnly: true,
        normalize: lessThanEqualInStock(index),
        inputClassName: '' + _TransferForm2.default['last-input'],
        feedbackClassName: '' + _TransferForm2.default['feedback'],
        maxFractionDigits: 2
      }),
      React.createElement(
        'span',
        { onClick: function onClick() {
            fields.remove(index);
          }, className: _TransferForm2.default['btn-delete-wrapper'] },
        React.createElement('i', { className: 'fa fa-times-circle' })
      )
    )
  );
};

var renderIngredientTransferArray = function renderIngredientTransferArray(_ref3) {
  var fields = _ref3.fields,
      meta = _ref3.meta;

  var doms = [];

  fields.forEach(function () {
    for (var _len2 = arguments.length, props = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      props[_key2] = arguments[_key2];
    }

    var member = props[0];


    doms.push(React.createElement(
      'div',
      { className: 'col-sm-12 mt-10px mb-10px' },
      React.createElement(
        'div',
        { className: 'col-sm-4 text-center' },
        'UNIT'
      ),
      React.createElement(
        'div',
        { className: 'col-sm-4 text-center' },
        'IN STOCK'
      ),
      React.createElement(
        'div',
        { className: 'col-sm-4 text-center' },
        'QUANTITY'
      )
    ));
    doms.push(React.createElement(
      'div',
      { className: 'col-sm-12 mk-grouped-input', style: { paddingRight: 16 } },
      React.createElement(
        'div',
        { className: 'form-group col-sm-12' },
        React.createElement(_reduxForm.Field, {
          component: 'input',
          name: member + '.ingredientName',
          className: 'form-control ' + _TransferForm2.default['ingredient-name-header'],
          disabled: true
        })
      )
    ));

    doms.push(React.createElement(
      'div',
      { className: 'row mb-20px' },
      React.createElement(
        'div',
        { className: 'col-sm-12' },
        renderIngredientTransfer.apply(undefined, props)
      )
    ));
  });

  return React.createElement(
    'div',
    { className: 'row mk-grouped-list-input ' + _TransferForm2.default['transfer-item-wrapper'] },
    doms
  );
};

var TransferForm = function (_React$Component) {
  (0, _inherits3.default)(TransferForm, _React$Component);

  function TransferForm() {
    var _ref4;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransferForm);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = TransferForm.__proto__ || (0, _getPrototypeOf2.default)(TransferForm)).call.apply(_ref4, [this].concat(args))), _this), _this._renderSelectOutlet = function (field) {
      var label = field.label,
          outlets = field.outlets,
          selectedOutlets = field.selectedOutlets;


      if (outlets.length === 0 || selectedOutlets.length === 0) {
        return React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            null,
            label
          ),
          React.createElement(
            'select',
            (0, _extends3.default)({}, field.input, {
              className: 'form-control',
              disabled: true }),
            React.createElement(
              'option',
              { value: '', disabled: true, selected: true },
              'Loading...'
            )
          )
        );
      }

      return React.createElement(
        'div',
        { className: 'form-group' },
        React.createElement(
          'label',
          null,
          label
        ),
        React.createElement(
          'select',
          (0, _extends3.default)({}, field.input, {
            className: 'form-control',
            disabled: selectedOutlets.length === 1 && label === 'FROM' }),
          label === 'FROM' && selectedOutlets.length === 1 && React.createElement(
            'option',
            { value: selectedOutlets[0].id },
            selectedOutlets[0].name
          ),
          label === 'FROM' && selectedOutlets.length > 1 && outlets.map(function (outlet) {
            return React.createElement(
              'option',
              {
                value: outlet.id },
              outlet.name
            );
          }),
          label === 'TO' && outlets.map(function (outlet) {
            return React.createElement(
              'option',
              {
                selected: selectedOutlets[0].id === outlet.id,
                value: outlet.id },
              outlet.name
            );
          })
        )
      );
    }, _this._onClickAddItems = function (event) {
      var onClickAddItem = _this.props.onClickAddItem;

      event.preventDefault();
      event.stopPropagation();
      onClickAddItem();
    }, _this._onSubmit = function (values) {
      var onSubmitCreateTransferForm = _this.props.onSubmitCreateTransferForm;

      onSubmitCreateTransferForm(values);
    }, _this._onClickCancel = function () {
      var _this$props = _this.props,
          reset = _this$props.reset,
          onClickDone = _this$props.onClickDone;

      reset();
      onClickDone();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransferForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          selectedOutlets = _props.selectedOutlets,
          onFromOutletChange = _props.onFromOutletChange,
          showConfirmSubmitModal = _props.showConfirmSubmitModal,
          setShowConfirmSubmitModal = _props.setShowConfirmSubmitModal,
          onConfirmCreateTransfer = _props.onConfirmCreateTransfer,
          searchForm = _props.searchForm,
          confirmCreateButtonStatus = _props.confirmCreateButtonStatus,
          handleSubmit = _props.handleSubmit;


      return React.createElement(
        'form',
        { onSubmit: handleSubmit(this._onSubmit), className: _TransferForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _TransferForm2.default['form-content'] },
          React.createElement(_LabelSection2.default, { title: 'choose outlet' }),
          React.createElement(
            'div',
            { className: 'form-group' },
            React.createElement(_reduxForm.Field, {
              label: 'FROM',
              name: 'fromOutlet',
              outlets: outlets,
              selectedOutlets: selectedOutlets,
              onChange: onFromOutletChange,
              component: this._renderSelectOutlet }),
            React.createElement(_reduxForm.Field, {
              label: 'TO',
              name: 'toOutlet',
              outlets: outlets,
              selectedOutlets: selectedOutlets,
              component: this._renderSelectOutlet })
          ),
          React.createElement(_LabelSection2.default, { title: 'note' }),
          React.createElement(
            'div',
            { className: 'form-group mb-20px' },
            React.createElement(_reduxForm.Field, {
              component: 'textarea',
              placeholder: 'Notes',
              name: 'notes',
              className: 'form-control',
              rows: 5
            })
          ),
          React.createElement(_LabelSection2.default, { title: 'transfer stock table' }),
          React.createElement(
            'div',
            { className: 'mb-20px' },
            React.createElement(_reduxForm.FieldArray, { name: 'transfers', component: searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? renderTransferArray : renderIngredientTransferArray })
          ),
          React.createElement(
            'div',
            { className: 'form-group' },
            React.createElement(
              'button',
              { className: 'btn btn-primary ' + _TransferForm2.default['btn-addItems'],
                onClick: this._onClickAddItems },
              searchForm && searchForm.namespace === _constants.NAMESPACE_ITEMS ? 'Add Items' : 'Add Ingredients'
            )
          )
        ),
        React.createElement(
          'div',
          { className: _TransferForm2.default['form-footer'] },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default ' + _TransferForm2.default['btn-done'] + ' mr-10px',
                onClick: this._onClickCancel,
                type: 'button' },
              'Cancel'
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _TransferForm2.default['btn-done'],
                type: 'submit' },
              'Create'
            )
          )
        ),
        React.createElement(_ConfirmSubmitModal2.default, {
          showConfirmSubmitModal: showConfirmSubmitModal,
          setShowConfirmSubmitModal: setShowConfirmSubmitModal,
          onConfirmCreateTransfer: onConfirmCreateTransfer,
          confirmCreateButtonStatus: confirmCreateButtonStatus })
      );
    }

    // when clicked add items in create transfer form


    // when clicked cancel in create transfer form

  }]);
  return TransferForm;
}(React.Component);

var mapForm = {
  form: 'transferItem',
  validate: validate,
  touchOnBlur: true,
  touchOnChange: true
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)(TransferForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TransferDetail = __webpack_require__(330);

var _TransferDetail2 = _interopRequireDefault(_TransferDetail);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferStock = function (_React$Component) {
  (0, _inherits3.default)(TransferStock, _React$Component);

  function TransferStock() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransferStock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransferStock.__proto__ || (0, _getPrototypeOf2.default)(TransferStock)).call.apply(_ref, [this].concat(args))), _this), _this._mapTransferDetailData = function (historyDetails) {
      var items = [];
      historyDetails.forEach(function (hd, index) {
        var found = false;
        items.forEach(function (item, index) {
          if (item.id === hd.item_id) {
            found = true;
          }
        });
        if (!found) {
          items.push({ id: hd.item_id, name: hd.item_name, historyDetails: [] });
        }
      });

      historyDetails.forEach(function (hd, index) {
        items.forEach(function (item, index) {
          var found = false;
          if (item.id === hd.item_id) {
            item.historyDetails.forEach(function (ihd, index) {
              if (ihd.item_variant_id === hd.item_variant_id) {
                found = true;
              }
            });
            if (!found) {
              item.historyDetails.push(hd);
            }
          }
        });
      });

      return items;
    }, _this._calculateTransferDetailTotal = function (items) {
      var total = 0;
      items.forEach(function (item, index) {
        item.historyDetails.forEach(function (ihd, index) {
          total += ihd.quantity;
        });
      });

      return total;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransferStock, [{
    key: 'render',
    value: function render() {
      var transferDetail = this.props.transferDetail;


      return transferDetail && React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row mt-40px mb-5px ml-0px mr-0px' },
          React.createElement('div', { className: 'col-sm-5 pl-0px' })
        ),
        React.createElement(_LabelSection2.default, { title: 'transfer stock table' }),
        this._mapTransferDetailData(transferDetail.history_details).map(function (item, index) {
          return React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  null,
                  item.name
                ),
                React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
              )
            ),
            item.historyDetails.map(function (hd, index) {
              return React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'row' },
                  React.createElement(
                    'div',
                    { className: 'col-sm-10 pl-0px ' + _TransferDetail2.default['variant-name'] },
                    React.createElement(
                      'div',
                      null,
                      '\xA0 \xA0 \xA0 \xA0 ',
                      hd.item_variant_name
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-sm-2 pl-0px ' + _TransferDetail2.default['variant-quantity'] },
                    React.createElement(
                      'div',
                      null,
                      transferDetail.is_sender ? -hd.quantity : hd.quantity
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'row' },
                  React.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    React.createElement('div', { className: _TransferDetail2.default['separator-row'] })
                  )
                )
              );
            })
          );
        }),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-10 ' + _TransferDetail2.default['label-total'] },
            'TOTAL'
          ),
          React.createElement(
            'div',
            { className: 'col-sm-2 ' + _TransferDetail2.default['total-trf'] },
            transferDetail.is_sender ? -this._calculateTransferDetailTotal(this._mapTransferDetailData(transferDetail.history_details)) : this._calculateTransferDetailTotal(this._mapTransferDetailData(transferDetail.history_details))
          )
        )
      );
    }
  }]);
  return TransferStock;
}(React.Component);

exports.default = TransferStock;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Transfer = __webpack_require__(1425);

var _Transfer2 = _interopRequireDefault(_Transfer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Transfer2.default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Supplier = exports.Transfer = exports.Summary = exports.PurchaseOrder = exports.Adjustment = undefined;

var _Inventory = __webpack_require__(1400);

var _Inventory2 = _interopRequireDefault(_Inventory);

var _Adjustment = __webpack_require__(1391);

var _Adjustment2 = _interopRequireDefault(_Adjustment);

var _PurchaseOrder = __webpack_require__(1411);

var _PurchaseOrder2 = _interopRequireDefault(_PurchaseOrder);

var _Summary = __webpack_require__(1416);

var _Summary2 = _interopRequireDefault(_Summary);

var _Transfer = __webpack_require__(1433);

var _Transfer2 = _interopRequireDefault(_Transfer);

var _Supplier = __webpack_require__(1422);

var _Supplier2 = _interopRequireDefault(_Supplier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Adjustment = _Adjustment2.default;
exports.PurchaseOrder = _PurchaseOrder2.default;
exports.Summary = _Summary2.default;
exports.Transfer = _Transfer2.default;
exports.Supplier = _Supplier2.default;
exports.default = _Inventory2.default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2148);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _category = __webpack_require__(126);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _confirmAction = __webpack_require__(29);

var _pages = __webpack_require__(38);

var _loadingSpinner = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutletIds = function (outletIds) {
      var isDirtyCategory = _this.props.isDirtyCategory;

      if (isDirtyCategory) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _category.onChangeOutletIds)(outletIds)));
      } else {
        _this.props.dispatch((0, _category.onChangeOutletIds)(outletIds));
      }
    }, _this._onChangeKeyword = function (event, keyword) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _category.setListCategories)([]));
      dispatch((0, _loadingSpinner.showPageLoadingSpinner)(true));
      dispatch((0, _category.categoriesRequest)({ keyword: keyword }));
    }, _this._onClickCreateCategory = function () {
      var isDirtyCategory = _this.props.isDirtyCategory;

      if (isDirtyCategory) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _category.onClickCreateCategory)()));
      } else {
        _this.props.dispatch((0, _category.onClickCreateCategory)());
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;


      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-8 col-xs-12' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12' },
                React.createElement(_reduxForm.Field, {
                  name: 'outletIds',
                  component: _DropdownOutlet2.default,
                  outlets: outlets,
                  onChangeOutletIds: this._onChangeOutletIds
                })
              ),
              React.createElement(
                'div',
                { className: 'col-sm-4 col-xs-12 ' + _style2.default['btn-search'] },
                React.createElement(_reduxForm.Field, {
                  name: 'keyword',
                  component: _SearchBar2.default,
                  onChange: this._onChangeKeyword,
                  placeholder: 'Search'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-4 hidden-xs' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', onClick: this._onClickCreateCategory },
                'Create Category'
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.library.category.outlets;

  var isDirtyCategory = (0, _reduxForm.isDirty)('category')(state);
  return {
    outlets: outlets,
    isDirtyCategory: isDirtyCategory
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _category = __webpack_require__(126);

var _Search = __webpack_require__(1438);

var _Search2 = _interopRequireDefault(_Search);

var _Items = __webpack_require__(1437);

var _Items2 = _interopRequireDefault(_Items);

var _style = __webpack_require__(2151);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignToItemModal = function (_React$Component) {
  (0, _inherits3.default)(AssignToItemModal, _React$Component);

  function AssignToItemModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AssignToItemModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AssignToItemModal.__proto__ || (0, _getPrototypeOf2.default)(AssignToItemModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      dispatch((0, _category.cancelAssignToItem)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AssignToItemModal, [{
    key: 'render',
    value: function render() {
      var showAssignToItemModal = this.props.showAssignToItemModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showAssignToItemModal, backdrop: 'static', onHide: this._onHide, className: '' + _style2.default.modalitem },
        React.createElement(_ModalHeader2.default, { title: 'Assign To Item' }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'itemIds' }),
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(_Search2.default, null),
            React.createElement(_Items2.default, null)
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary' },
                'Move Selected Items'
              )
            )
          )
        )
      );
    }
  }]);
  return AssignToItemModal;
}(React.Component);

function mapStateToProps(state) {
  var showAssignToItemModal = state.library.category.showAssignToItemModal;

  return {
    showAssignToItemModal: showAssignToItemModal
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'assignToItem'
};
exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssignToItemModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _style = __webpack_require__(2149);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _category = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Items = function (_React$Component) {
  (0, _inherits3.default)(Items, _React$Component);

  function Items() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Items);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Items.__proto__ || (0, _getPrototypeOf2.default)(Items)).call.apply(_ref, [this].concat(args))), _this), _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      return currentPage < totalPage;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage,
          keyword = _this$props2.assignToItem.keyword,
          items = _this$props2.items,
          dispatch = _this$props2.dispatch;

      if (currentPage < totalPage) {
        dispatch((0, _category.assignToItemGetItemsRequest)({ keyword: keyword, page: currentPage + 1, with_batch: true }, items));
      }
    }, _this._onChangeCheckbox = function (event, item) {
      var _this$props3 = _this.props,
          itemIds = _this$props3.assignToItem.itemIds,
          dispatch = _this$props3.dispatch;

      var idxPosition = -1;
      if (itemIds) {
        itemIds.forEach(function (itemId, index) {
          if (parseInt(itemId) === item.id) {
            idxPosition = index;
          }
        });
      }

      if (event.target.checked) {
        dispatch((0, _reduxForm.arrayPush)('assignToItem', 'itemIds', item.id));
      } else {
        if (idxPosition !== -1) {
          dispatch((0, _reduxForm.arrayRemove)('assignToItem', 'itemIds', idxPosition));
        }
      }
    }, _this._checked = function (item) {
      var itemIds = _this.props.assignToItem.itemIds;

      var checked = false;
      if (itemIds) {
        itemIds.forEach(function (itemId) {
          checked = checked || parseInt(itemId) === item.id;
        });
      }
      return checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Items, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items;

      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          _reactInfiniteScroller2.default,
          {
            pageStart: 1,
            loadMore: this._onReachBottom,
            hasMore: this._hasMore(),
            useWindow: false,
            threshold: 10,
            initialLoad: false },
          items.map(function (item, idx) {
            return React.createElement(
              'div',
              { className: 'row ' + _style2.default['row-wrapper'] },
              React.createElement(
                'div',
                { className: 'col-sm-2 ' + _style2.default['item-image-wrapper'] },
                React.createElement('img', { src: item.image.url, className: _style2.default.image })
              ),
              React.createElement(
                'div',
                { className: 'col-sm-9 ' + _style2.default['item-name-wrapper'] },
                React.createElement(
                  'p',
                  null,
                  item.name
                )
              ),
              React.createElement(
                'div',
                { className: 'col-sm-1 pull-right ' + _style2.default['padding-checkbox'] },
                React.createElement('input', {
                  type: 'checkbox',
                  checked: _this2._checked(item),
                  onChange: function onChange(event) {
                    return _this2._onChangeCheckbox(event, item);
                  }
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Items;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('assignToItem');

function mapStateToProps(state) {
  var _state$library$catego = state.library.category,
      _state$library$catego2 = _state$library$catego.assignToItems,
      items = _state$library$catego2.items,
      currentPage = _state$library$catego2.currentPage,
      totalPage = _state$library$catego2.totalPage,
      categoryDetail = _state$library$catego.categoryDetail;

  return {
    categoryDetail: categoryDetail,
    assignToItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword')
    },
    items: items,
    currentPage: currentPage,
    totalPage: totalPage
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Items);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(2150);

var _style2 = _interopRequireDefault(_style);

var _category = __webpack_require__(126);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function (_React$Component) {
  (0, _inherits3.default)(Search, _React$Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref, [this].concat(args))), _this), _this._onChange = function (event, value) {
      _this.props.dispatch((0, _category.assignToItemGetItemsRequest)({ page: 1, keyword: value, with_batch: true }, []));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row ' + _style2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'div',
            { className: 'right-inner-addon' },
            React.createElement('i', { className: 'fa fa-search ' + _style2.default.right }),
            React.createElement(_reduxForm.Field, {
              component: 'input',
              name: 'keyword',
              className: 'form-control',
              placeholder: 'search',
              onChange: this._onChange
            })
          )
        )
      );
    }
  }]);
  return Search;
}(React.Component);

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1435);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _List = __webpack_require__(1442);

var _List2 = _interopRequireDefault(_List);

var _CategoryDetail = __webpack_require__(1440);

var _CategoryDetail2 = _interopRequireDefault(_CategoryDetail);

var _reactRedux = __webpack_require__(6);

var _category = __webpack_require__(126);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _AssignToItemModal = __webpack_require__(1436);

var _AssignToItemModal2 = _interopRequireDefault(_AssignToItemModal);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reduxForm = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(49);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _pages = __webpack_require__(38);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _category2 = __webpack_require__(452);

var mpLibraryCategory = _interopRequireWildcard(_category2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = function (_React$Component) {
  (0, _inherits3.default)(Category, _React$Component);

  function Category() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Category);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call.apply(_ref, [this].concat(args))), _this), _this._onHideModal = function () {
      _this.props.dispatch((0, _category.cancelDelete)());
    }, _this._onDelete = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          categories = _this$props.categories,
          deletedCategory = _this$props.deletedCategory;

      mpLibraryCategory.libraryCategoryDelete({ name: deletedCategory.name });
      dispatch((0, _category.deleteCategory)(deletedCategory.id, categories));
    }, _this._onSubmit = function (values) {
      var _this$props2 = _this.props,
          categories = _this$props2.categories,
          items = _this$props2.items;

      var name = null;
      var itemName = [];
      categories.forEach(function (category) {
        if (category.id === values.id) name = category.name;
      });
      values.itemIds.forEach(function (id) {
        items.forEach(function (item) {
          if ('' + id === '' + item.id) {
            itemName.push(item.name);
          }
        });
      });
      mpLibraryCategory.libraryCategoryAssignToItems({ name: name, itemNames: itemName });
      _this.props.dispatch((0, _category.submitAssignToItem)({ item_ids: values.itemIds }, values.id));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Category, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteModal = _props.showDeleteModal,
          deletedCategory = _props.deletedCategory,
          showAssignToItemModal = _props.showAssignToItemModal,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          categories = _props.categories;

      var categoryName = deletedCategory ? deletedCategory.name : '';
      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: categories.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_CategoryDetail2.default, null)
          )
        ),
        showAssignToItemModal && React.createElement(_AssignToItemModal2.default, { onSubmit: this._onSubmit }),
        React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: showDeleteModal,
          onHide: this._onHideModal,
          title: 'Category',
          name: categoryName,
          onDelete: this._onDelete
        }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.expired;

      if (!expired) {
        this.props.dispatch((0, _category.categoriesPageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.isDirtyCategory && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Category;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$catego = state.library.category,
      categories = _state$library$catego.categories,
      showDeleteModal = _state$library$catego.showDeleteModal,
      deletedCategory = _state$library$catego.deletedCategory,
      showAssignToItemModal = _state$library$catego.showAssignToItemModal,
      openRightColumn = _state$library$catego.openRightColumn,
      items = _state$library$catego.assignToItems.items;

  var isDirtyCategory = (0, _reduxForm.isDirty)('category')(state);
  var nextAction = state.confirmAction.nextAction;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;

  return {
    categories: categories,
    showDeleteModal: showDeleteModal,
    deletedCategory: deletedCategory,
    showAssignToItemModal: showAssignToItemModal,
    isDirtyCategory: isDirtyCategory,
    nextAction: nextAction,
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    expired: expired,
    items: items
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Category);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CategoryForm = __webpack_require__(1441);

var _CategoryForm2 = _interopRequireDefault(_CategoryForm);

var _style = __webpack_require__(769);

var _style2 = _interopRequireDefault(_style);

var _reactRedux = __webpack_require__(6);

var _category = __webpack_require__(126);

var _category2 = __webpack_require__(452);

var mpLibraryCategory = _interopRequireWildcard(_category2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryDetail = function (_React$Component) {
  (0, _inherits3.default)(CategoryDetail, _React$Component);

  function CategoryDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryDetail.__proto__ || (0, _getPrototypeOf2.default)(CategoryDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          categories = _this$props.categories;

      if (values.action === 'save') {
        delete values.action;
        if (values.id) {
          dispatch((0, _category.submitFormUpdate)(values.id, values, categories));
        } else {
          mpLibraryCategory.libraryCategoryCreate({ category: values, allOutlet: false });
          dispatch((0, _category.submitFormCreate)(values, categories));
        }
      } else {
        delete values.action;
        mpLibraryCategory.libraryCategoryCreate({ category: values, allOutlet: true });
        dispatch((0, _category.submitFormCreateAllOutlets)(values, categories));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(_CategoryForm2.default, { onSubmit: this._onSubmit })
      );
    }
  }]);
  return CategoryDetail;
}(React.Component);

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

function mapStateToProps(state) {
  var categories = state.library.category.categories;

  return {
    categories: categories
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CategoryDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(769);

var _style2 = _interopRequireDefault(_style);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reactRedux = __webpack_require__(6);

var _category = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  }
  return errors;
};

var CategoryForm = function (_React$Component) {
  (0, _inherits3.default)(CategoryForm, _React$Component);

  function CategoryForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryForm.__proto__ || (0, _getPrototypeOf2.default)(CategoryForm)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _this._onSubmitToAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'saveToAllOutlet' }));
    }, _this._onClickCancel = function (event) {
      _this.props.dispatch((0, _category.onClickCancel)());
      event.preventDefault();
      event.stopPropagation();
    }, _this._onClickDelete = function (event) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          categoryDetail = _this$props.categoryDetail;

      dispatch((0, _category.deleteCategoryRequest)(categoryDetail));
      event.preventDefault();
      event.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          isSubmittingForm = _props.isSubmittingForm;

      return React.createElement(
        'form',
        { className: _style2.default.wrapper, onSubmit: function onSubmit(e) {
            e.preventDefault();
          } },
        React.createElement(
          'div',
          { className: _style2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: _style2.default.title },
            'Category'
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_reduxForm.Field, {
                component: _SettingField2.default,
                name: 'name',
                className: 'form-control',
                placeholder: 'Category Name'
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _style2.default.footer },
          this.props.category.id && React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickDelete, type: 'button', disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default ' + _style2.default['btn-cancel'],
                type: 'button',
                onClick: this._onClickCancel,
                disabled: isSubmittingForm },
              'Cancel'
            ),
            !this.props.category.id && this.props.outlets.length > 1 && React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _style2.default['btn-save'],
                type: 'button',
                onClick: handleSubmit(this._onSubmitToAllOutlet),
                disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _style2.default['btn-save'],
                type: 'button',
                onClick: handleSubmit(this._onSubmit),
                disabled: isSubmittingForm },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return CategoryForm;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('category');

var mapForm = {
  form: 'category',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

function mapStateToProps(state) {
  var _state$library$catego = state.library.category,
      categories = _state$library$catego.categories,
      categoryDetail = _state$library$catego.categoryDetail,
      outlets = _state$library$catego.outlets,
      isSubmittingForm = _state$library$catego.isSubmittingForm;

  return {
    categories: categories,
    categoryDetail: categoryDetail,
    category: { id: selector(state, 'id') },
    data: {
      form: state.form
    },
    outlets: outlets,
    isSubmittingForm: isSubmittingForm
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(CategoryForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _style = __webpack_require__(2152);

var _style2 = _interopRequireDefault(_style);

var _category = __webpack_require__(126);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          categories = _this$props.categories;

      dispatch((0, _category.categoriesRequest)({ with_items: true, page: currentPage + 1 }, categories));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._categoryItemStockFormatter = function (category) {
      var total = 0;
      if (category.items) {
        total = category.items.length || 0;
      }
      return total + ' items';
    }, _this._onClickRow = function (category) {
      var isDirtyCategory = _this.props.isDirtyCategory;

      if (isDirtyCategory) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)((0, _category.onClickRow)(category)));
      } else {
        _this.props.dispatch((0, _category.onClickRow)(category));
      }
    }, _this._onClickAssignToItem = function (event, category) {
      event.preventDefault();
      event.stopPropagation();
      _this.props.dispatch((0, _category.onClickAssignToItem)(category));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          categories = _props.categories,
          categoryDetail = _props.categoryDetail;


      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        categories.length > 0 && React.createElement(
          'div',
          { className: _style2.default['div-table'] },
          React.createElement(
            'table',
            { className: _style2.default['table-header'] },
            React.createElement(
              'thead',
              null,
              React.createElement(
                'tr',
                null,
                React.createElement(
                  'th',
                  { className: _style2.default.name },
                  'Category Name'
                ),
                React.createElement(
                  'th',
                  { className: _style2.default.stocks },
                  'Item Stocks'
                ),
                React.createElement('th', { className: _style2.default.assign })
              )
            )
          ),
          React.createElement(
            'div',
            { className: _style2.default['table-content-wrapper'] },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore(),
                useWindow: false,
                threshold: 10,
                initialLoad: false },
              React.createElement(
                'table',
                { className: _style2.default['table-content'] },
                React.createElement(
                  'tbody',
                  null,
                  categories.map(function (category) {
                    return React.createElement(
                      'tr',
                      { className: categoryDetail && category.id === categoryDetail.id ? _style2.default.selected : '',
                        onClick: function onClick() {
                          return _this2._onClickRow(category);
                        } },
                      React.createElement(
                        'td',
                        { className: _style2.default.name },
                        category.name
                      ),
                      React.createElement(
                        'td',
                        { className: _style2.default.stocks },
                        _this2._categoryItemStockFormatter(category)
                      ),
                      React.createElement(
                        'td',
                        { className: _style2.default.assign },
                        React.createElement(
                          'a',
                          {
                            className: 'btn btn-default btn-sm',
                            onClick: function onClick(event) {
                              return _this2._onClickAssignToItem(event, category);
                            } },
                          'Assign To Item'
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$catego = state.library.category,
      categories = _state$library$catego.categories,
      categoryDetail = _state$library$catego.categoryDetail,
      currentPage = _state$library$catego.currentPage,
      totalPage = _state$library$catego.totalPage;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    categories: categories,
    categoryDetail: categoryDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    isDirtyCategory: (0, _reduxForm.isDirty)('category')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  categories: React.PropTypes.array,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  categoryDetail: React.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(2153);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _discount = __webpack_require__(168);

var actDiscount = _interopRequireWildcard(_discount);

var _confirmAction = __webpack_require__(29);

var _discount2 = __webpack_require__(453);

var mpLibraryDiscount = _interopRequireWildcard(_discount2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateDiscount = function () {
      var isDirtyDiscount = _this.props.isDirtyDiscount;

      if (isDirtyDiscount) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actDiscount.onClickCreateDiscount()));
      } else {
        _this.props.dispatch(actDiscount.onClickCreateDiscount());
      }
    }, _this._onChangeOutletIds = function (outletIds) {
      var _this$props = _this.props,
          isDirtyDiscount = _this$props.isDirtyDiscount,
          searchvalues = _this$props.searchvalues;

      var prevOutlet = searchvalues.outletIds[0];
      mpLibraryDiscount.libraryDiscountChangeOutlet({ prevOutlet: prevOutlet, currOutlet: outletIds });
      if (isDirtyDiscount) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actDiscount.onChangeOutletIds(outletIds)));
      } else {
        _this.props.dispatch(actDiscount.onChangeOutletIds(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            React.createElement(_reduxForm.Field, {
              name: 'outletIds',
              component: _DropdownOutlet2.default,
              outlets: outlets,
              onChangeOutletIds: this._onChangeOutletIds
            })
          ),
          React.createElement(
            'div',
            { className: 'col-sm-8 hidden-xs' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', onClick: this._onClickCreateDiscount },
                'Create Discount'
              )
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.library.discount.outlets;

  var isDirtyDiscount = (0, _reduxForm.isDirty)('discount')(state);
  return {
    isDirtyDiscount: isDirtyDiscount,
    outlets: outlets,
    searchvalues: (0, _reduxForm.getFormValues)('search')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _discount = __webpack_require__(168);

var _ConfirmDeleteModal = __webpack_require__(2154);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDeleteModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDeleteModal, _React$Component);

  function ConfirmDeleteModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmDeleteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmDeleteModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDeleteModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _discount.cancelDeleteDiscount)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          deletedDiscount = _this$props.deletedDiscount,
          dispatch = _this$props.dispatch,
          discounts = _this$props.discounts;

      dispatch((0, _discount.deleteDiscount)(deletedDiscount.id, discounts));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmDeleteModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteDiscountModal = _props.showDeleteDiscountModal,
          deletedDiscount = _props.deletedDiscount;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showDeleteDiscountModal, onHide: this._onHide, dialogClassName: 'modal-dialog ' + _ConfirmDeleteModal2.default.dialog },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmDeleteModal2.default.header },
          'Delete Discount'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          deletedDiscount && React.createElement(
            'p',
            null,
            'Are you sure want to delete ',
            React.createElement(
              'b',
              null,
              deletedDiscount.name
            ),
            ' ? This action cannot be undone'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { onClick: this._onConfirm, className: 'btn btn-danger' },
            'Delete'
          )
        )
      );
    }
  }]);
  return ConfirmDeleteModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$discou = state.library.discount,
      deletedDiscount = _state$library$discou.deletedDiscount,
      showDeleteDiscountModal = _state$library$discou.showDeleteDiscountModal,
      discounts = _state$library$discou.discounts;

  return {
    deletedDiscount: deletedDiscount,
    showDeleteDiscountModal: showDeleteDiscountModal,
    discounts: discounts
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmDeleteModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1443);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _discount = __webpack_require__(168);

var actDiscount = _interopRequireWildcard(_discount);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(1448);

var _List2 = _interopRequireDefault(_List);

var _Discount = __webpack_require__(2155);

var _Discount2 = _interopRequireDefault(_Discount);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _ConfirmDeleteModal = __webpack_require__(1444);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discount = function (_React$Component) {
  (0, _inherits3.default)(Discount, _React$Component);

  function Discount() {
    (0, _classCallCheck3.default)(this, Discount);
    return (0, _possibleConstructorReturn3.default)(this, (Discount.__proto__ || (0, _getPrototypeOf2.default)(Discount)).apply(this, arguments));
  }

  (0, _createClass3.default)(Discount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.expired;

      if (!expired) {
        this.props.dispatch(actDiscount.pageRequest());
        _reactRouter.browserHistory.listenBefore(function (location) {
          // this is still hacky, don't copy paste this
          if (_this2.props.isDirtyDiscount && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Discount2.default.wrapper },
        React.createElement(_ActionBar2.default, null),
        React.createElement(_List2.default, null),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_ConfirmDeleteModal2.default, null)
      );
    }
  }]);
  return Discount;
}(React.Component);

Discount.propTypes = {
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var isDirtyDiscount = (0, _reduxForm.isDirty)('discount')(state);
  var nextAction = state.confirmAction.nextAction;
  var expired = state.subscriptionExpired.expired;

  return { isDirtyDiscount: isDirtyDiscount, nextAction: nextAction, expired: expired };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Discount);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DiscountDetail = __webpack_require__(2156);

var _DiscountDetail2 = _interopRequireDefault(_DiscountDetail);

var _DiscountForm = __webpack_require__(1447);

var _DiscountForm2 = _interopRequireDefault(_DiscountForm);

var _discount = __webpack_require__(168);

var _reactRedux = __webpack_require__(6);

var _discount2 = __webpack_require__(453);

var mpLibraryDiscount = _interopRequireWildcard(_discount2);

var _reduxForm = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountDetail = function (_React$Component) {
  (0, _inherits3.default)(DiscountDetail, _React$Component);

  function DiscountDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DiscountDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscountDetail.__proto__ || (0, _getPrototypeOf2.default)(DiscountDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCancel = function () {
      _this.props.dispatch((0, _discount.onClickCancel)());
    }, _this._onChangeSwitch = function () {
      _this.props.dispatch((0, _discount.clearAmountField)());
    }, _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          discounts = _this$props.discounts;
      // we must delete the 'action' property so it doesn't sent to server.

      if (values) {
        values.type = values.typeAmount ? 'percentage' : 'cash';
        delete values.typeAmount;
      }
      if (values.action === 'save') {
        delete values.action;
        if (values.id) {
          var currentDiscount = _this.props.currentDiscount;

          mpLibraryDiscount.libraryDiscountUpdate({ oldDiscount: currentDiscount, newDiscount: values });
          dispatch((0, _discount.submitFormUpdate)(values.id, values, discounts));
        } else {
          mpLibraryDiscount.libraryDiscountCreate({ discount: values, allOutlet: false });
          dispatch((0, _discount.submitFormCreate)(values, discounts));
        }
      } else {
        delete values.action;
        mpLibraryDiscount.libraryDiscountCreate({ discount: values, allOutlet: true });
        dispatch((0, _discount.submitFormCreateAllOutlet)(values, discounts));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DiscountDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _DiscountDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _DiscountDetail2.default.form },
          React.createElement(_DiscountForm2.default, {
            onSubmit: this._onSubmit,
            onClickCancel: this._onClickCancel,
            type: this.props.statusAction,
            onChangeSwitch: this._onChangeSwitch,
            newDiscount: this.props.newDiscount
          })
        )
      );
    }
  }]);
  return DiscountDetail;
}(React.Component);

function mapStateToProps(state) {
  return { currentDiscount: (0, _reduxForm.getFormValues)('discount')(state) };
}

DiscountDetail.propTypes = {
  discount: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DiscountDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DiscountForm = __webpack_require__(2157);

var _DiscountForm2 = _interopRequireDefault(_DiscountForm);

var _SwitchField = __webpack_require__(437);

var _SwitchField2 = _interopRequireDefault(_SwitchField);

var _discount = __webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1';
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input discount amount less than 100%';
  } else if (values.amount >= 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input discount amount less than 100.000.000.000';
  }

  if (!values.typeAmount) {
    errors.typeAmount = '';
  }

  return errors;
};

var DiscountForm = function (_React$Component) {
  (0, _inherits3.default)(DiscountForm, _React$Component);

  function DiscountForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DiscountForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscountForm.__proto__ || (0, _getPrototypeOf2.default)(DiscountForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDelete = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          discountDetail = _this$props.discountDetail;

      dispatch((0, _discount.askDeleteDiscount)(discountDetail));
      e.preventDefault();
      e.stopPropagation();
    }, _this._onClickCancel = function () {
      _this.props.onClickCancel();
    }, _this._onSubmitCreateAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet' }));
    }, _this._onSubmitSave = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _this._onChangeSwitch = function () {
      _this.props.onChangeSwitch();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DiscountForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          discountDetail = _props.discountDetail,
          handleSubmit = _props.handleSubmit,
          newDiscount = _props.newDiscount,
          outlets = _props.outlets,
          isSubmittingForm = _props.isSubmittingForm;

      return React.createElement(
        'form',
        { name: 'discount', onSubmit: handleSubmit, className: _DiscountForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _DiscountForm2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'p',
                { className: 'discount-title ' + _DiscountForm2.default['label-section'] },
                'DISCOUNT INFORMATION'
              ),
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'hidden',
                name: 'id'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-5' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, { component: _SettingField2.default, placeholder: 'Name', name: 'name' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-3 no-padding' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  placeholder: 'Amount',
                  name: 'amount',
                  positiveNumberOnly: true,
                  maxFractionDigits: 3
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SwitchField2.default,
                  name: 'typeAmount',
                  type: 'checkbox',
                  onText: '%',
                  offText: 'Rp',
                  discount: true,
                  onChange: this._onChangeSwitch
                })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _DiscountForm2.default.footer },
          discountDetail && discountDetail.id && !newDiscount && React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-danger no-outline', type: 'button', onClick: this._onClickDelete, disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: this._onClickCancel, disabled: isSubmittingForm },
              'Cancel'
            ),
            outlets.length > 1 && newDiscount && React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: handleSubmit(this._onSubmitCreateAllOutlet), disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'button', onClick: handleSubmit(this._onSubmitSave), disabled: isSubmittingForm },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return DiscountForm;
}(React.Component);

DiscountForm.propTypes = {
  onClickCancel: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

var selector = (0, _reduxForm.formValueSelector)('discount');

function mapStateToProps(state) {
  var _state$library$discou = state.library.discount,
      discounts = _state$library$discou.discounts,
      discountDetail = _state$library$discou.discountDetail,
      outlets = _state$library$discou.outlets,
      isSubmittingForm = _state$library$discou.isSubmittingForm;

  return {
    discountDetail: discountDetail,
    discount: {
      id: selector(state, 'id')
    },
    discounts: discounts,
    outlets: outlets,
    formDiscount: state.form.discount,
    isSubmittingForm: isSubmittingForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'discount',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(DiscountForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(2158);

var _List2 = _interopRequireDefault(_List);

var _discount = __webpack_require__(168);

var actDiscount = _interopRequireWildcard(_discount);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _DiscountDetail = __webpack_require__(1446);

var _DiscountDetail2 = _interopRequireDefault(_DiscountDetail);

var _reduxForm = __webpack_require__(7);

var _pages = __webpack_require__(38);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (discount) {
      _this.props.dispatch(actDiscount.onClickRow(discount));
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          discounts = _this$props.discounts;

      dispatch(actDiscount.discountsRequest({ page: currentPage + 1 }, discounts));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          discounts = _props.discounts,
          discountDetail = _props.discountDetail,
          showDetail = _props.showDetail,
          newDiscount = _props.newDiscount,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage;


      return React.createElement(
        _pages.ContentWrapper,
        null,
        React.createElement(
          _pages.LeftColumnWrapper,
          { openRightColumn: showDetail },
          React.createElement(_NoDataAndLoading2.default, {
            showLoadingSpinner: showLoadingSpinnerPage,
            noDataToDisplay: discounts.length === 0,
            title: 'No Data To Display',
            description: '' }),
          discounts.length > 0 && React.createElement(
            'div',
            { className: _List2.default['table-wrapper'] },
            React.createElement(
              'table',
              { className: _List2.default['table-header'] },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'th',
                    { className: _List2.default.name },
                    'Discount Name'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.amount },
                    'Amount'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: _List2.default['table-content-wrapper'] },
              React.createElement(
                _reactInfiniteScroller2.default,
                {
                  pageStart: 1,
                  loadMore: this._onReachBottom,
                  hasMore: this._hasMore(),
                  useWindow: false,
                  threshold: 10,
                  initialLoad: false },
                React.createElement(
                  'table',
                  { className: _List2.default['table-content'] },
                  React.createElement(
                    'tbody',
                    null,
                    discounts.length > 0 && discounts.map(function (discount) {
                      return React.createElement(
                        'tr',
                        { className: '' + (discountDetail && discountDetail.id === discount.id ? _List2.default.selected : ''),
                          onClick: function onClick() {
                            return _this2._onClickRow(discount);
                          } },
                        React.createElement(
                          'td',
                          { className: _List2.default.name },
                          discount.name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.amount },
                          discount.amount_format
                        )
                      );
                    })
                  )
                )
              )
            )
          )
        ),
        React.createElement(
          _pages.RightColumnWrapper,
          { openRightColumn: showDetail },
          React.createElement(_DiscountDetail2.default, {
            discount: discountDetail,
            dispatch: this.props.dispatch,
            newDiscount: newDiscount,
            discounts: discounts
          })
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$discou = state.library.discount,
      discounts = _state$library$discou.discounts,
      discountDetail = _state$library$discou.discountDetail,
      currentPage = _state$library$discou.currentPage,
      totalPage = _state$library$discou.totalPage,
      showDetail = _state$library$discou.showDetail,
      newDiscount = _state$library$discou.newDiscount;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    discounts: discounts,
    discountDetail: discountDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showDetail: showDetail,
    newDiscount: newDiscount,
    isDirtyDiscount: (0, _reduxForm.isDirty)('discount')(state),
    showLoadingSpinnerPage: showLoadingSpinnerPage
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  discounts: React.PropTypes.array,
  discountDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  showDetail: React.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(2159);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _gratuity = __webpack_require__(169);

var actGratuity = _interopRequireWildcard(_gratuity);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateGratuity = function () {
      var isDirtyGratuity = _this.props.isDirtyGratuity;

      if (isDirtyGratuity) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actGratuity.onClickCreateGratuity()));
      } else {
        _this.props.dispatch(actGratuity.onClickCreateGratuity());
      }
    }, _this._onChangeOutletIds = function (outletIds) {
      var isDirtyGratuity = _this.props.isDirtyGratuity;

      if (isDirtyGratuity) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actGratuity.onChangeOutletIds(outletIds)));
      } else {
        _this.props.dispatch(actGratuity.onChangeOutletIds(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            React.createElement(_reduxForm.Field, {
              name: 'outletIds',
              component: _DropdownOutlet2.default,
              outlets: outlets,
              onChangeOutletIds: this._onChangeOutletIds
            })
          ),
          React.createElement(
            'div',
            { className: 'col-sm-8 hidden-xs' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', onClick: this._onClickCreateGratuity },
                'Create Gratuity'
              )
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.library.gratuity.outlets;

  return {
    isDirtyGratuity: (0, _reduxForm.isDirty)('gratuity')(state),
    outlets: outlets
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _gratuity = __webpack_require__(169);

var _ConfirmDeleteModal = __webpack_require__(2160);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDeleteModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDeleteModal, _React$Component);

  function ConfirmDeleteModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmDeleteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmDeleteModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDeleteModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _gratuity.cancelDeleteGratuity)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          deletedGratuity = _this$props.deletedGratuity,
          dispatch = _this$props.dispatch,
          gratuities = _this$props.gratuities;

      dispatch((0, _gratuity.deleteGratuity)(deletedGratuity.id, gratuities));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmDeleteModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteGratuityModal = _props.showDeleteGratuityModal,
          deletedGratuity = _props.deletedGratuity;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showDeleteGratuityModal, onHide: this._onHide, dialogClassName: 'modal-dialog ' + _ConfirmDeleteModal2.default.dialog },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: 'modal-header ' + _ConfirmDeleteModal2.default.header },
          'Delete Gratuity'
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          deletedGratuity && React.createElement(
            'p',
            null,
            'Are you sure want to delete ',
            React.createElement(
              'b',
              null,
              deletedGratuity.name
            ),
            ' ? This action cannot be undone'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'button',
            { onClick: this._onHide, className: 'btn btn-default' },
            'Cancel'
          ),
          React.createElement(
            'button',
            { onClick: this._onConfirm, className: 'btn btn-danger' },
            'Delete'
          )
        )
      );
    }
  }]);
  return ConfirmDeleteModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$gratui = state.library.gratuity,
      deletedGratuity = _state$library$gratui.deletedGratuity,
      showDeleteGratuityModal = _state$library$gratui.showDeleteGratuityModal,
      gratuities = _state$library$gratui.gratuities;

  return {
    deletedGratuity: deletedGratuity,
    showDeleteGratuityModal: showDeleteGratuityModal,
    gratuities: gratuities
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmDeleteModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1449);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _gratuity = __webpack_require__(169);

var actGratuity = _interopRequireWildcard(_gratuity);

var _reactRedux = __webpack_require__(6);

var _List = __webpack_require__(1454);

var _List2 = _interopRequireDefault(_List);

var _GratuityDetail = __webpack_require__(1452);

var _GratuityDetail2 = _interopRequireDefault(_GratuityDetail);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _ConfirmDeleteModal = __webpack_require__(1450);

var _ConfirmDeleteModal2 = _interopRequireDefault(_ConfirmDeleteModal);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _pages = __webpack_require__(38);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

__webpack_require__(2161);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gratuity = function (_React$Component) {
  (0, _inherits3.default)(Gratuity, _React$Component);

  function Gratuity() {
    (0, _classCallCheck3.default)(this, Gratuity);
    return (0, _possibleConstructorReturn3.default)(this, (Gratuity.__proto__ || (0, _getPrototypeOf2.default)(Gratuity)).apply(this, arguments));
  }

  (0, _createClass3.default)(Gratuity, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          gratuities = _props.gratuities;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: gratuities.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_GratuityDetail2.default, null)
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_ConfirmDeleteModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.expired;

      if (!expired) {
        this.props.dispatch(actGratuity.pageRequest());
        _reactRouter.browserHistory.listenBefore(function (location) {
          // this is still hacky, don't copy paste this
          if (_this2.props.isDirtyGratuity && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Gratuity;
}(React.Component);

Gratuity.propTypes = {
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var _state$library$gratui = state.library.gratuity,
      openRightColumn = _state$library$gratui.openRightColumn,
      gratuities = _state$library$gratui.gratuities;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;

  return {
    isDirtyGratuity: (0, _reduxForm.isDirty)('gratuity')(state),
    nextAction: state.confirmAction.nextAction,
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    gratuities: gratuities,
    expired: expired
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Gratuity);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _GratuityDetail = __webpack_require__(2162);

var _GratuityDetail2 = _interopRequireDefault(_GratuityDetail);

var _GratuityForm = __webpack_require__(1453);

var _GratuityForm2 = _interopRequireDefault(_GratuityForm);

var _reactRedux = __webpack_require__(6);

var _gratuity = __webpack_require__(169);

var _gratuity2 = __webpack_require__(654);

var mpLibraryGratuity = _interopRequireWildcard(_gratuity2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GratuityDetail = function (_React$Component) {
  (0, _inherits3.default)(GratuityDetail, _React$Component);

  function GratuityDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GratuityDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GratuityDetail.__proto__ || (0, _getPrototypeOf2.default)(GratuityDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          gratuities = _this$props.gratuities;
      // we must delete the 'action' property so it doesn't sent to server.

      if (values.action === 'save') {
        delete values.action;
        if (values.id) {
          mpLibraryGratuity.libraryGratuityUpdate({ newValue: values });
          dispatch((0, _gratuity.submitFormUpdate)(values.id, values, gratuities));
        } else {
          mpLibraryGratuity.libraryGratuityCreate({ values: values, isAllOutlet: false });
          dispatch((0, _gratuity.submitFormCreate)(values, gratuities));
        }
      } else {
        delete values.action;
        mpLibraryGratuity.libraryGratuityCreate({ values: values, isAllOutlet: true });
        dispatch((0, _gratuity.submitFormCreateAllOutlet)(values, gratuities));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GratuityDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _GratuityDetail2.default.wrapper },
        React.createElement(_GratuityForm2.default, { onSubmit: this._onSubmit })
      );
    }
  }]);
  return GratuityDetail;
}(React.Component);

function mapStateToProps(state) {
  var gratuities = state.library.gratuity.gratuities;

  return {
    gratuities: gratuities
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GratuityDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _GratuityForm = __webpack_require__(2163);

var _GratuityForm2 = _interopRequireDefault(_GratuityForm);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _SettingFieldWithIcon = __webpack_require__(637);

var _SettingFieldWithIcon2 = _interopRequireDefault(_SettingFieldWithIcon);

var _gratuity = __webpack_require__(169);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }
  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1';
  } else if (values.amount > 100) {
    errors.amount = 'Please input gratuity amount less than 100%';
  }
  return errors;
};

var GratuityForm = function (_React$Component) {
  (0, _inherits3.default)(GratuityForm, _React$Component);

  function GratuityForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GratuityForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GratuityForm.__proto__ || (0, _getPrototypeOf2.default)(GratuityForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCancel = function (e) {
      _this.props.dispatch((0, _gratuity.onClickCancel)());
      e.preventDefault();
      e.stopPropagation();
    }, _this._onSubmitCreateAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet' }));
    }, _this._onSubmitSave = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _this._onClickDelete = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          gratuityDetail = _this$props.gratuityDetail;

      dispatch((0, _gratuity.askDeleteGratuity)(gratuityDetail));
      e.preventDefault();
      e.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GratuityForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          outlets = _props.outlets,
          isSubmittingForm = _props.isSubmittingForm;

      return React.createElement(
        'form',
        { onSubmit: this.props.handleSubmit, className: _GratuityForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _GratuityForm2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: _GratuityForm2.default.title },
            'Gratuity Information'
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_reduxForm.Field, {
                component: 'input',
                type: 'hidden',
                name: 'id'
              }),
              React.createElement(
                'div',
                { className: 'col-sm-6 col-md-4', style: { paddingLeft: 0 } },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  name: 'name',
                  className: 'form-control',
                  placeholder: 'Name'
                })
              ),
              React.createElement(
                'div',
                { className: 'col-sm-6 col-md-4', style: { paddingLeft: 0 } },
                React.createElement(_reduxForm.Field, {
                  component: _SettingFieldWithIcon2.default,
                  name: 'amount',
                  icon: '%',
                  className: 'form-control',
                  placeholder: 'Amount',
                  positiveNumberOnly: true,
                  maxFractionDigits: 3
                })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _GratuityForm2.default.footer },
          this.props.gratuity.id && React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickDelete, type: 'button', disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default ' + _GratuityForm2.default['btn-cancel'],
                onClick: this._onClickCancel,
                type: 'button',
                disabled: isSubmittingForm
              },
              'Cancel'
            ),
            outlets && outlets.length > 1 && !this.props.gratuity.id && React.createElement(
              'button',
              {
                type: 'button',
                name: 'submit',
                onClick: handleSubmit(this._onSubmitCreateAllOutlet),
                className: 'btn btn-primary ' + _GratuityForm2.default['btn-save-all'],
                disabled: isSubmittingForm
              },
              'Save to All Outlet'
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _GratuityForm2.default['btn-save'],
                onClick: handleSubmit(this._onSubmitSave),
                type: 'button',
                disabled: isSubmittingForm
              },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return GratuityForm;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('gratuity');

function mapStateToProps(state) {
  var _state$library$gratui = state.library.gratuity,
      gratuities = _state$library$gratui.gratuities,
      gratuityDetail = _state$library$gratui.gratuityDetail,
      outlets = _state$library$gratui.outlets,
      isSubmittingForm = _state$library$gratui.isSubmittingForm;


  return {
    gratuityDetail: gratuityDetail,
    gratuity: {
      id: selector(state, 'id')
    },
    gratuities: gratuities,
    outlets: outlets,
    isSubmittingForm: isSubmittingForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'gratuity',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(GratuityForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(2164);

var _List2 = _interopRequireDefault(_List);

var _gratuity = __webpack_require__(169);

var actGratuity = _interopRequireWildcard(_gratuity);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (gratuity) {
      var isDirtyGratuity = _this.props.isDirtyGratuity;

      if (isDirtyGratuity) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actGratuity.onClickRow(gratuity)));
      } else {
        _this.props.dispatch(actGratuity.onClickRow(gratuity));
      }
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          gratuities = _this$props.gratuities;

      dispatch(actGratuity.gratuitiesRequest({ page: currentPage + 1 }, gratuities));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          gratuities = _props.gratuities,
          gratuityDetail = _props.gratuityDetail;


      return gratuities.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _List2.default.name },
                'Name'
              ),
              React.createElement(
                'th',
                { className: _List2.default.amount },
                'Amount'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                gratuities.length === 0 && React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    { colSpan: '5', style: { textAlign: 'center' } },
                    'No data to display'
                  )
                ),
                gratuities.length > 0 && gratuities.map(function (gratuity) {
                  return React.createElement(
                    'tr',
                    { className: '' + (gratuityDetail && gratuity.id === gratuityDetail.id ? _List2.default.selected : ''),
                      onClick: function onClick() {
                        return _this2._onClickRow(gratuity);
                      } },
                    React.createElement(
                      'td',
                      { className: _List2.default.name },
                      gratuity.name
                    ),
                    React.createElement(
                      'td',
                      { className: _List2.default.amount },
                      gratuity.amount
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$gratui = state.library.gratuity,
      gratuities = _state$library$gratui.gratuities,
      gratuityDetail = _state$library$gratui.gratuityDetail,
      currentPage = _state$library$gratui.currentPage,
      totalPage = _state$library$gratui.totalPage;

  return {
    gratuities: gratuities,
    gratuityDetail: gratuityDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    isDirtyGratuity: (0, _reduxForm.isDirty)('gratuity')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  gratuities: React.PropTypes.array,
  gratuityDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(2165);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownSelect = __webpack_require__(436);

var _DropdownSelect2 = _interopRequireDefault(_DropdownSelect);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _reactBootstrap = __webpack_require__(10);

var _item = __webpack_require__(76);

var actItem = _interopRequireWildcard(_item);

var _confirmAction = __webpack_require__(29);

var _list = __webpack_require__(246);

var mpItemList = _interopRequireWildcard(_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateItem = function () {
      var isDirtyItem = _this.props.isDirtyItem;

      if (isDirtyItem) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actItem.onClickCreateItem()));
      } else {
        _this.props.dispatch(actItem.onClickCreateItem());
      }
    }, _this._onChangeFilterCategory = function (event, categoryId) {
      var _this$props$filterFor = _this.props.filterForm,
          typeInventoryId = _this$props$filterFor.typeInventoryId,
          search = _this$props$filterFor.search,
          outletIds = _this$props$filterFor.outletIds;

      mpItemList.libraryItemChangeFilter({
        outletIds: outletIds,
        category: categoryId,
        inventory: typeInventoryId
      });
      _this.props.dispatch(actItem.setFilterItem(categoryId, typeInventoryId, search));
    }, _this._onChangeFilterInventory = function (event, typeInventoryId) {
      var _this$props$filterFor2 = _this.props.filterForm,
          categoryId = _this$props$filterFor2.categoryId,
          search = _this$props$filterFor2.search,
          outletIds = _this$props$filterFor2.outletIds;

      mpItemList.libraryItemChangeFilter({
        outletIds: outletIds,
        category: categoryId,
        inventory: typeInventoryId
      });
      _this.props.dispatch(actItem.setFilterItem(categoryId, typeInventoryId, search));
    }, _this._onChangeFilterKeyword = function (event, search) {
      var _this$props$filterFor3 = _this.props.filterForm,
          categoryId = _this$props$filterFor3.categoryId,
          typeInventoryId = _this$props$filterFor3.typeInventoryId;

      _this.props.dispatch(actItem.setFilterItem(categoryId, typeInventoryId, search));
    }, _this._onChangeOutletIds = function (outletIds) {
      var isDirtyItem = _this.props.isDirtyItem;

      if (isDirtyItem) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actItem.onChangeOutletIds(outletIds)));
      } else {
        _this.props.dispatch(actItem.onChangeOutletIds(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          inventories = _props.inventories,
          categories = _props.categories,
          summary = _props.summary,
          onClickImport = _props.onClickImport,
          onClickExport = _props.onClickExport;

      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper + ' library-action-bar' },
        React.createElement(
          'div',
          { className: 'col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding' },
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'ul',
              { className: _ActionBar2.default['ul-filter'] },
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' visible-md visible-lg' },
                React.createElement(_reduxForm.Field, {
                  name: 'outletIds',
                  component: _DropdownOutlet2.default,
                  outlets: outlets,
                  onChangeOutletIds: this._onChangeOutletIds
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-dropdown-category' },
                React.createElement(_reduxForm.Field, {
                  name: 'categoryId',
                  component: _DropdownSelect2.default,
                  options: categories,
                  defaultOption: { id: 0, name: 'All Categories' },
                  className: 'dropdown-select-categories',
                  id: 'filterSelectCategory',
                  onChange: this._onChangeFilterCategory
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-dropdown-type-inventory' },
                React.createElement(_reduxForm.Field, {
                  name: 'typeInventoryId',
                  component: _DropdownSelect2.default,
                  options: inventories,
                  className: 'dropdown-select-inventories',
                  id: 'filterSelectInventory',
                  onChange: this._onChangeFilterInventory
                })
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter'] + ' li-searching' },
                React.createElement(_reduxForm.Field, {
                  name: 'search',
                  component: _SearchBar2.default,
                  placeholder: 'Search',
                  onChange: this._onChangeFilterKeyword
                })
              )
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'ul',
              { className: _ActionBar2.default['ul-filter'] + ' ' + _ActionBar2.default['filter-right'] },
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item visible-md visible-lg' },
                React.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this._onClickCreateItem },
                  'Create Item'
                )
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item' },
                React.createElement(
                  _reactBootstrap.DropdownButton,
                  { title: 'Import / Export', bsStyle: 'primary' },
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickImport },
                    'Import items'
                  ),
                  React.createElement(_reactBootstrap.MenuItem, { divider: true }),
                  React.createElement(
                    _reactBootstrap.MenuItem,
                    { onSelect: onClickExport },
                    'Export items'
                  )
                )
              ),
              React.createElement(
                'li',
                { className: _ActionBar2.default['li-filter-right'] + ' li-total-item' },
                React.createElement(
                  'a',
                  { className: 'btn btn-default ng-binding' },
                  'Total : ',
                  summary.total_items
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      items = _state$library$item.items,
      summary = _state$library$item.summary,
      categories = _state$library$item.categories,
      itemDetail = _state$library$item.itemDetail,
      deletedItem = _state$library$item.deletedItem,
      showDeleteItemModal = _state$library$item.showDeleteItemModal,
      currentPage = _state$library$item.currentPage,
      totalPage = _state$library$item.totalPage,
      inventories = _state$library$item.inventories,
      currentInventoryId = _state$library$item.currentInventoryId,
      currentCategoryId = _state$library$item.currentCategoryId,
      outlets = _state$library$item.outlets;

  var _selector = selector(state, 'categoryId', 'typeInventoryId', 'search', 'outletIds'),
      categoryId = _selector.categoryId,
      typeInventoryId = _selector.typeInventoryId,
      search = _selector.search,
      outletIds = _selector.outletIds;

  var isDirtyItem = (0, _reduxForm.isDirty)('item')(state);
  return {
    categories: categories,
    outlets: outlets,
    items: items,
    itemDetail: itemDetail,
    deletedItem: deletedItem,
    showDeleteItemModal: showDeleteItemModal,
    currentPage: currentPage,
    totalPage: totalPage,
    inventories: inventories,
    currentInventoryId: currentInventoryId,
    currentCategoryId: currentCategoryId,
    summary: summary,
    isDirtyItem: isDirtyItem,
    filterForm: { categoryId: categoryId, typeInventoryId: typeInventoryId, search: search, outletIds: outletIds }
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _item = __webpack_require__(76);

var actItem = _interopRequireWildcard(_item);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(1455);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _List = __webpack_require__(1480);

var _List2 = _interopRequireDefault(_List);

var _ItemImportModal = __webpack_require__(1479);

var _ItemImportModal2 = _interopRequireDefault(_ItemImportModal);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _pages = __webpack_require__(38);

var _ItemDetail = __webpack_require__(1457);

var _ItemDetail2 = _interopRequireDefault(_ItemDetail);

var _reactRouter = __webpack_require__(15);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _list = __webpack_require__(246);

var mpLibrary = _interopRequireWildcard(_list);

__webpack_require__(2166);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_React$Component) {
  (0, _inherits3.default)(Item, _React$Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call.apply(_ref, [this].concat(args))), _this), _this._onClickExport = function () {
      var dataLibrary = _this.props.data;
      var library = dataLibrary.library,
          user = dataLibrary.user;
      var item = library.item;

      var prefix = 'Item Library - ';
      mpLibrary.libraryItemExport();
      _this.props.dispatch(actItem.itemExportRequest(prefix, user.email, item.outlets));
    }, _this._onClickImport = function () {
      _this.props.dispatch(actItem.showImportModal());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Item, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;

      var expireTime = 365; // expire time 1 year
      if (!expired) {
        this.props.dispatch(actItem.pageRequest());
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.isDirtyItem && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
        if (Cookies.get('labelNew') === 'true') {
          Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
        }
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          library = _props$data.library,
          loadingSpinner = _props$data.loadingSpinner,
          search = _props$data.search;
      var _library$item = library.item,
          openRightColumn = _library$item.openRightColumn,
          showImportModal = _library$item.showImportModal,
          items = _library$item.items;
      var showLoadingSpinnerPage = loadingSpinner.showLoadingSpinnerPage;

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, {
          onClickImport: this._onClickImport,
          onClickExport: this._onClickExport }),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: items.length === 0,
              title: 'No Data To Display',
              description: '' }),
            !showLoadingSpinnerPage && React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_ItemDetail2.default, null)
          )
        ),
        React.createElement(_ItemImportModal2.default, { show: showImportModal, dispatch: this.props.dispatch, selectedOutletIds: search ? search.outletIds : [] }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }]);
  return Item;
}(React.Component);

function select(state) {
  // only fetch some state
  return {
    data: {
      library: {
        item: state.library.item
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired,
      search: (0, _reduxForm.getFormValues)('search')(state)
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyItem: (0, _reduxForm.isDirty)('item')(state)
  };
}
exports.default = (0, _reactRedux.connect)(select)(Item);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemDetail = __webpack_require__(2167);

var _ItemDetail2 = _interopRequireDefault(_ItemDetail);

var _ItemForm = __webpack_require__(1464);

var _ItemForm2 = _interopRequireDefault(_ItemForm);

var _item = __webpack_require__(76);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetail = function (_React$Component) {
  (0, _inherits3.default)(ItemDetail, _React$Component);

  function ItemDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemDetail.__proto__ || (0, _getPrototypeOf2.default)(ItemDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeSwitch = function () {
      _this.props.dispatch((0, _item.clearAmountField)());
    }, _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          items = _this$props.items,
          search = _this$props.search;
      // add modifier ids value and remove active_modifiers for the api

      values.modifier_ids = values.active_modifiers.map(function (am) {
        return am.id;
      });

      // add modifier ids value and remove active_taxes for the api
      values.tax_ids = values.taxes.map(function (at) {
        return at.id;
      });

      // update updated at
      // kode ini ngikut yang di moka-rails aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L1003

      // we must delete the 'action' property so it doesn't sent to server.
      var allOutlet = values.action !== 'save';
      delete values.action;

      // if it is create, the api wants 'remote_image_url' to be sent
      if (!values.id) {
        if (values.image && values.image.url) {
          values.remote_image_url = values.image.url;
        } else {
          values.remote_image_url = '';
        }
      }

      if (values.id) {
        dispatch((0, _item.submitFormUpdate)(values.id, { item: values }, allOutlet, items));
      } else {
        // ini nambahin juga, kelupaan, emang harusnya nambahin pas create seperti di moka-rails
        // kode ini ngikut yang dev aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L985
        dispatch((0, _item.submitFormCreate)({ item: values }, allOutlet, items, search));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _ItemDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _ItemDetail2.default.form },
          React.createElement(_ItemForm2.default, {
            onSubmit: this._onSubmit,
            onChangeSwitch: this._onChangeSwitch
          })
        )
      );
    }
  }]);
  return ItemDetail;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      items = _state$library$item.items,
      itemDetail = _state$library$item.itemDetail;

  return {
    items: items,
    itemDetail: itemDetail,
    search: (0, _reduxForm.getFormValues)('search')(state)
  };
}

ItemDetail.propTypes = {
  Item: React.PropTypes.object,
  dispatch: React.PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _COGSFieldArray = __webpack_require__(1460);

var _COGSFieldArray2 = _interopRequireDefault(_COGSFieldArray);

__webpack_require__(2168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COGS = function (_React$Component) {
  (0, _inherits3.default)(COGS, _React$Component);

  function COGS() {
    (0, _classCallCheck3.default)(this, COGS);
    return (0, _possibleConstructorReturn3.default)(this, (COGS.__proto__ || (0, _getPrototypeOf2.default)(COGS)).apply(this, arguments));
  }

  (0, _createClass3.default)(COGS, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classButton = _props.classButton,
          disabled = _props.disabled,
          itemDetail = _props.itemDetail;

      var defaultValue = { price: undefined, sku: undefined };
      return React.createElement(_reduxForm.FieldArray, {
        name: 'item_variants',
        component: _COGSFieldArray2.default,
        defaultValue: defaultValue,
        disabled: disabled,
        classButton: classButton,
        itemDetail: itemDetail
      });
    }
  }]);
  return COGS;
}(React.Component);

exports.default = COGS;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _COGSField = __webpack_require__(2169);

var _COGSField2 = _interopRequireDefault(_COGSField);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemInventoryAlertField = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlertField, _React$Component);

  function ItemInventoryAlertField() {
    (0, _classCallCheck3.default)(this, ItemInventoryAlertField);
    return (0, _possibleConstructorReturn3.default)(this, (ItemInventoryAlertField.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlertField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemInventoryAlertField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          member = _props.member,
          isSaved = _props.isSaved;

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-8' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            disabled: true,
            name: member + '.name',
            className: 'form-control ' + (isSaved ? '' : _COGSField2.default['bg-white'])
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            positiveNumberOnly: true,
            dis: isSaved,
            name: member + '.cogs',
            inputClassName: 'text-right ' + _COGSField2.default['input-cogs'],
            prefixText: 'Rp',
            prefixTextClassName: _COGSField2.default['rp-cogs'],
            prefixTextClassNameError: _COGSField2.default['rp-cogs-error']
          })
        )
      );
    }
  }]);
  return ItemInventoryAlertField;
}(React.Component);

ItemInventoryAlertField.propTypes = {
  member: React.PropTypes.object
};

exports.default = ItemInventoryAlertField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _COGSField = __webpack_require__(1459);

var _COGSField2 = _interopRequireDefault(_COGSField);

var _item = __webpack_require__(76);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _WarningLabel = __webpack_require__(673);

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COGSFieldArray = function (_React$Component) {
  (0, _inherits3.default)(COGSFieldArray, _React$Component);

  function COGSFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, COGSFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = COGSFieldArray.__proto__ || (0, _getPrototypeOf2.default)(COGSFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onClickStartTracking = function (e, isTrack) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          itemForm = _this$props.itemForm;

      dispatch((0, _item.onClickBtnStartTrackingCOGS)(itemForm, isTrack));
      e.stopPropagation();
      e.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(COGSFieldArray, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          fields = _props.fields,
          disabled = _props.disabled,
          classButton = _props.classButton;

      var isTrack = false;
      var isTrackCOGS = false;
      var COGS = [];
      fields.forEach(function (member, index, fields) {
        var fieldValues = fields.get(index);
        if (fieldValues.track_cogs) {
          isTrackCOGS = true;
        }
        if (fieldValues.track_stock) {
          isTrack = true;
        }
        if (fieldValues.track_stock && fieldValues.track_cogs || fieldValues.is_recipe && fieldValues.cogs !== null) {
          COGS.push(React.createElement(_COGSField2.default, { member: member, isSaved: fieldValues.saved_cogs }));
        }
      });
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'row' },
          COGS.length > 0 && React.createElement(
            'span',
            { className: 'col-sm-offset-8 col-sm-4 text-left pl-0px label-instock' },
            'AVG COST'
          ),
          COGS,
          !disabled && React.createElement(
            'div',
            { className: 'form-group col-sm-12' },
            React.createElement(
              'button',
              { onClick: function onClick(e) {
                  _this2._onClickStartTracking(e, isTrackCOGS);
                }, className: 'btn btn-primary btn-block no-border-radius-top ' + (!isTrack ? classButton : ''), disabled: !isTrack },
              !isTrackCOGS ? 'Start Tracking Cost of Goods Sold (COGS)' : 'Manage Cost of Goods Sold (COGS)'
            )
          )
        ),
        !disabled && isTrack && React.createElement(_WarningLabel2.default, {
          content: 'Avg cost can not be changed after saving the item, so please make sure that is correct!',
          type: 'info'
        }),
        disabled && React.createElement(
          _WarningLabel2.default,
          {
            type: 'warning',
            link: true,
            recepie: true
          },
          'This item is associated with ingredients. Use the ',
          React.createElement(
            _reactRouter.Link,
            { to: '/ingredient/recipes' },
            React.createElement(
              'i',
              null,
              'Ingredient Page'
            )
          ),
          ' to manage Cost of Goods Sold (COGS).'
        ),
        !disabled && !isTrack && React.createElement(_WarningLabel2.default, {
          content: 'This item can not be tracked because the inventory stock is not tracked.',
          type: 'warning'
        })
      );
    }
  }]);
  return COGSFieldArray;
}(React.Component);

function mapStateToProps(state) {
  return {
    itemForm: (0, _reduxForm.getFormValues)('item')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(COGSFieldArray);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _item = __webpack_require__(76);

var _COGSModal = __webpack_require__(2170);

var _COGSModal2 = _interopRequireDefault(_COGSModal);

var _COGSModalFieldArray = __webpack_require__(1462);

var _COGSModalFieldArray2 = _interopRequireDefault(_COGSModalFieldArray);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COGSModal = function (_React$Component) {
  (0, _inherits3.default)(COGSModal, _React$Component);

  function COGSModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, COGSModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = COGSModal.__proto__ || (0, _getPrototypeOf2.default)(COGSModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          previousItemForm = _this$props.previousItemForm;

      dispatch((0, _item.onCancelCOGSModal)(previousItemForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(COGSModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showCOGSModal = _props.showCOGSModal,
          handleSubmit = _props.handleSubmit;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showCOGSModal, onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _COGSModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Manage Cost of Goods Sold (COGS)' }),
        React.createElement(
          'form',
          { onSubmit: handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(
              'table',
              { className: 'table table-responsive ' + _COGSModal2.default.table },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'th',
                    null,
                    'Variant'
                  ),
                  React.createElement(
                    'th',
                    { className: 'text-center' },
                    'Track COGS'
                  ),
                  React.createElement(
                    'th',
                    { className: 'text-center' },
                    'Avg Cost'
                  )
                )
              ),
              React.createElement(_reduxForm.FieldArray, {
                component: _COGSModalFieldArray2.default,
                name: 'item_variants'
              })
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', type: 'button', onClick: this._onCancel },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', type: 'submit' },
                'Confirm'
              )
            ),
            React.createElement(
              'i',
              { className: _COGSModal2.default['footer-info'] },
              '*Use the ',
              React.createElement(
                _reactRouter.Link,
                { to: '/inventory/purchase_orders', target: 'blank' },
                'Purchase Order page'
              ),
              ' to manage Avg Cost'
            )
          )
        )
      );
    }
  }]);
  return COGSModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      showCOGSModal = _state$library$item.showCOGSModal,
      previousItemForm = _state$library$item.previousItemForm;

  return {
    showCOGSModal: showCOGSModal,
    previousItemForm: previousItemForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: true
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(COGSModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _COGSModalFieldArray = __webpack_require__(2171);

var _COGSModalFieldArray2 = _interopRequireDefault(_COGSModalFieldArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberOnly = function numberOnly() {
  return function (value, previousValue, allValues) {
    if (value) {
      if (isNaN(value) || value.includes('.')) {
        return previousValue;
      }
    }
    return value;
  };
};

var COGSModalFieldArray = function (_React$Component) {
  (0, _inherits3.default)(COGSModalFieldArray, _React$Component);

  function COGSModalFieldArray() {
    (0, _classCallCheck3.default)(this, COGSModalFieldArray);
    return (0, _possibleConstructorReturn3.default)(this, (COGSModalFieldArray.__proto__ || (0, _getPrototypeOf2.default)(COGSModalFieldArray)).apply(this, arguments));
  }

  (0, _createClass3.default)(COGSModalFieldArray, [{
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return React.createElement(
        'tbody',
        null,
        fields.map(function (member, index, fields) {
          var fieldValues = fields.get(index);
          if (fieldValues.track_stock) {
            return React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                null,
                fieldValues.name
              ),
              React.createElement(
                'td',
                { className: 'text-center' },
                React.createElement(
                  'div',
                  { className: 'checkbox checkbox-primary checkbox-item checkbox-circle' },
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: member + '.track_cogs',
                    type: 'checkbox',
                    id: 'checkbox-track-cogs-' + index
                  }),
                  React.createElement('label', { 'for': 'checkbox-track-cogs-' + index })
                )
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'form-group' },
                  React.createElement(
                    'div',
                    { className: _COGSModalFieldArray2.default['rp-cogs'] },
                    'Rp'
                  ),
                  React.createElement(_reduxForm.Field, {
                    component: 'input',
                    name: member + '.cogs',
                    type: 'text',
                    className: 'form-control text-right ' + _COGSModalFieldArray2.default['input-cogs'],
                    disabled: fieldValues.saved_cogs,
                    normalize: numberOnly()
                  })
                )
              )
            );
          }
        })
      );
    }
  }]);
  return COGSModalFieldArray;
}(React.Component);

exports.default = COGSModalFieldArray;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _CreateCategoryModal = __webpack_require__(2172);

var _CreateCategoryModal2 = _interopRequireDefault(_CreateCategoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateCategoryModal = function (_React$Component) {
  (0, _inherits3.default)(CreateCategoryModal, _React$Component);

  function CreateCategoryModal() {
    (0, _classCallCheck3.default)(this, CreateCategoryModal);
    return (0, _possibleConstructorReturn3.default)(this, (CreateCategoryModal.__proto__ || (0, _getPrototypeOf2.default)(CreateCategoryModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(CreateCategoryModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onConfirm = _props.onConfirm,
          onCancel = _props.onCancel,
          show = _props.show,
          newCategory = _props.newCategory;

      if (!newCategory) {
        newCategory = '';
      }
      return React.createElement(
        _reactBootstrap.Modal,
        { className: _CreateCategoryModal2.default['modal-container'], show: show },
        React.createElement(
          _reactBootstrap.Modal.Header,
          null,
          React.createElement(
            _reactBootstrap.Modal.Title,
            { className: _CreateCategoryModal2.default['modal-title'] },
            'Information'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Are you sure want to create ',
            React.createElement(
              'span',
              null,
              newCategory
            ),
            '?'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: onCancel },
              'Cancel'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: onConfirm },
              'Ok'
            )
          )
        )
      );
    }
  }]);
  return CreateCategoryModal;
}(React.Component);

exports.default = CreateCategoryModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reduxForm = __webpack_require__(7);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _ItemForm = __webpack_require__(2173);

var _ItemForm2 = _interopRequireDefault(_ItemForm);

var _item = __webpack_require__(76);

var _UploadImage = __webpack_require__(438);

var _UploadImage2 = _interopRequireDefault(_UploadImage);

var _reactSelect = __webpack_require__(145);

__webpack_require__(262);

var _ItemVariant = __webpack_require__(1472);

var _ItemVariant2 = _interopRequireDefault(_ItemVariant);

var _ItemInventoryAlert = __webpack_require__(1465);

var _ItemInventoryAlert2 = _interopRequireDefault(_ItemInventoryAlert);

var _COGS = __webpack_require__(1458);

var _COGS2 = _interopRequireDefault(_COGS);

var _ItemTax = __webpack_require__(1471);

var _ItemTax2 = _interopRequireDefault(_ItemTax);

var _ItemModifier = __webpack_require__(1470);

var _ItemModifier2 = _interopRequireDefault(_ItemModifier);

var _ItemVariantModal = __webpack_require__(1477);

var _ItemVariantModal2 = _interopRequireDefault(_ItemVariantModal);

var _ItemInventoryAlertModal = __webpack_require__(1468);

var _ItemInventoryAlertModal2 = _interopRequireDefault(_ItemInventoryAlertModal);

var _COGSModal = __webpack_require__(1461);

var _COGSModal2 = _interopRequireDefault(_COGSModal);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _CreateCategoryModal = __webpack_require__(1463);

var _CreateCategoryModal2 = _interopRequireDefault(_CreateCategoryModal);

var _SaveToAllOutletsModal = __webpack_require__(1478);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _WarningLabel = __webpack_require__(673);

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

var _list = __webpack_require__(246);

var mpLibrary = _interopRequireWildcard(_list);

var _reactRouter = __webpack_require__(15);

var _validator = __webpack_require__(166);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tooltipDeleteBtn = React.createElement(
  _reactBootstrap.Popover,
  { id: 'popover-trigger-hover-focus' },
  'This item cannot be deleted because it has been associated with a Recipe. Please first delete the Recipe and try again.'
);

var validate = function validate(values) {
  var errors = {};
  if (!values.name) {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount <= 0) {
    errors.amount = 'Please enter a value > 0';
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100%';
  } else if (values.amount > 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100.000.000.000';
  }

  var itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach(function (iv, index) {
      var memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please enter a value';
      }
      if (!iv.in_stock && '' + iv.in_stock !== '0') {
        memberError.in_stock = 'Stock is required';
      } else if (!_validator2.default.isNumeric('' + iv.in_stock)) {
        memberError.in_stock = 'Please enter a valid Number';
      } else if (iv.in_stock > 999999) {
        memberError.in_stock = 'In stock must be less than 6 digits';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if (!iv.cogs && '' + iv.cogs !== '0') {
        memberError.cogs = 'Avg. cost is required';
      }
      if (iv.cogs > 99999999999) {
        memberError.cogs = 'Avg. Cost must be less than 11 digits';
      }
      if ((0, _keys2.default)(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

var RenderSelectField = function (_React$Component) {
  (0, _inherits3.default)(RenderSelectField, _React$Component);

  function RenderSelectField(props) {
    (0, _classCallCheck3.default)(this, RenderSelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderSelectField.__proto__ || (0, _getPrototypeOf2.default)(RenderSelectField)).call(this, props));

    _this.onChangeSelect = function (newval) {
      var _this$props = _this.props,
          _this$props$input = _this$props.input,
          value = _this$props$input.value,
          onChange = _this$props$input.onChange,
          dispatch = _this$props.meta.dispatch,
          options = _this$props.options,
          categories = _this$props.categories;

      var isNewCategory = true;
      options.forEach(function (cat) {
        if (cat.value === newval.value && typeof newval.value === 'number') {
          isNewCategory = false;
        }
      });
      if (isNewCategory) {
        dispatch((0, _item.onClickCreateNewCategory)(newval.value, categories, value));
        onChange(newval.value);
      } else {
        onChange(newval.value);
      }
    };

    _this.state = {
      selectInstance: 1
    };
    return _this;
  }

  (0, _createClass3.default)(RenderSelectField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.input.value,
          placeholder = _props.placeholder,
          options = _props.options;

      var selectProps = {
        addLabelText: '{label} (create new)',
        value: value,
        className: _ItemForm2.default['select-dropdown'],
        placeholder: placeholder,
        onChange: this.onChangeSelect,
        options: options,
        clearable: false,
        backspaceRemoves: false,
        promptTextCreator: function promptTextCreator(label) {
          return label + ' (create new)';
        },
        onClose: function onClose() {
          _this2.setState({ selectInstance: 1 - _this2.state.selectInstance });
        }
        // TODO HACK buat nyamain behaviour kode lama:
        // harus dalam html tag yang beda
        // harus dua komponen yang beda
      };if (this.state.selectInstance === 1) {
        return React.createElement(
          'div',
          null,
          React.createElement(_reactSelect.Creatable, selectProps)
        );
      } else {
        return React.createElement(
          'span',
          null,
          React.createElement(_reactSelect.Creatable, selectProps)
        );
      }
    }
  }]);
  return RenderSelectField;
}(React.Component);

var ItemForm = function (_React$Component2) {
  (0, _inherits3.default)(ItemForm, _React$Component2);

  function ItemForm(props) {
    (0, _classCallCheck3.default)(this, ItemForm);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (ItemForm.__proto__ || (0, _getPrototypeOf2.default)(ItemForm)).call(this, props));

    _this3._onSaveVariant = function (value) {
      var _this3$props = _this3.props,
          dispatch = _this3$props.dispatch,
          isDirtyForm = _this3$props.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _item.onConfirmItemVariantModal)(value));
      } else {
        dispatch((0, _item.onCancelItemVariantModal)());
      }
    };

    _this3._onSaveTrackInv = function (value) {
      var _this3$props2 = _this3.props,
          dispatch = _this3$props2.dispatch,
          itemForm = _this3$props2.itemForm,
          isDirtyForm = _this3$props2.isDirtyForm;

      var isTrack = false;
      itemForm.item_variants.forEach(function (iv) {
        if (iv.track_stock) {
          isTrack = true;
        }
      });
      // HACKY CODE
      // ini hack untuk yang FD-1471, karena validasi form entah hilang ketika melakukan remove array dan push kembali array yang kemungkinan sama
      // karena redux form tidak melakukan validasi kembali ketika proses push array baru berlangsung, untuk mengatasi keterbatasan itu,
      // maka dibuatlah logic:
      // jika tidak memberikan perubahan apa apa terhadap form maka tidak usah melakukan rangkaian confirm, cucup tutup modal saja
      if (isDirtyForm || !isTrack) {
        dispatch((0, _item.onConfirmItemInventoryAlertModal)(value, itemForm));
      } else {
        dispatch((0, _item.onCancelItemInventoryAlertModal)());
      }
    };

    _this3._onSaveCOGS = function (value) {
      var _this3$props3 = _this3.props,
          dispatch = _this3$props3.dispatch,
          isTrack = _this3$props3.isTrack,
          isDirtyForm = _this3$props3.isDirtyForm;

      if (isDirtyForm || !isTrack) {
        dispatch((0, _item.onConfirmCOGSModal)(value, isTrack));
      } else {
        dispatch((0, _item.onCancelCOGSModal)());
      }
    };

    _this3._onCancelCreateCategoryModal = function () {
      var _this3$props4 = _this3.props,
          dispatch = _this3$props4.dispatch,
          previousCategories = _this3$props4.previousCategories,
          previousCategoryId = _this3$props4.previousCategoryId;

      dispatch((0, _item.onCancelCreateNewCategory)(previousCategories, previousCategoryId));
    };

    _this3._onConfirmCreateCategoryModal = function () {
      var _this3$props5 = _this3.props,
          dispatch = _this3$props5.dispatch,
          newCategory = _this3$props5.newCategory;

      dispatch((0, _item.onConfirmCreateNewCategory)(newCategory));
    };

    _this3._onHideDeleteModal = function () {
      var dispatch = _this3.props.dispatch;

      dispatch((0, _item.hideDeleteModal)());
    };

    _this3._confirmDelete = function () {
      var _this3$props6 = _this3.props,
          dispatch = _this3$props6.dispatch,
          itemDetail = _this3$props6.itemDetail,
          items = _this3$props6.items,
          search = _this3$props6.search;

      mpLibrary.libraryItemDelete({ item: itemDetail });
      dispatch((0, _item.deleteItem)(itemDetail, items, search));
    };

    _this3._formatCategories = function (categories) {
      var formatCategory = [];
      categories.map(function (category) {
        if (category.id > 0) {
          formatCategory.push({ value: category.id, label: category.name });
        }
      });
      return formatCategory;
    };

    _this3._onClickDelete = function (e) {
      var dispatch = _this3.props.dispatch;

      dispatch((0, _item.showDeleteModal)());
      e.preventDefault();
      e.stopPropagation();
    };

    _this3._onClickCancel = function (e) {
      _this3.props.dispatch((0, _item.onClickCancel)());
      e.preventDefault();
      e.stopPropagation();
    };

    _this3._onSubmitCreateAllOutlet = function (values) {
      _this3.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet' }));
    };

    _this3._onSubmitSave = function (values) {
      _this3.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    };

    _this3._onChangeSwitch = function () {
      _this3.props.onChangeSwitch();
    };

    _this3._onChangeCategories = function (val, newVal) {};

    _this3._findUncategorized = function (categories) {
      var idUncategory = void 0;
      categories.map(function (category, index) {
        if (category.name === 'Uncategorized') {
          idUncategory = category.id;
        }
      });
      return idUncategory;
    };

    _this3.scrollArea = null;
    return _this3;
  }

  (0, _createClass3.default)(ItemForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.mustScrollTop) {
        this.scrollArea.scrollTop = 0;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          itemDetail = _props2.itemDetail,
          handleSubmit = _props2.handleSubmit,
          categories = _props2.categories,
          modifiers = _props2.modifiers,
          taxes = _props2.taxes,
          itemForm = _props2.itemForm,
          showDeleteModal = _props2.showDeleteModal,
          isSubmittingForm = _props2.isSubmittingForm,
          outlets = _props2.outlets;

      var uploadImagePlaceholder = itemForm && itemForm.name ? itemForm.name.substring(0, 2) : '';
      return React.createElement(
        'form',
        { onSubmit: handleSubmit, className: 'full-height' },
        React.createElement(
          'div',
          { ref: function ref(a) {
              _this4.scrollArea = a;
            }, className: '' + _ItemForm2.default['item-fieldset'] },
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
            React.createElement(
              'div',
              { className: 'col-lg-2 col-md-3 col-sm-3' },
              React.createElement(_reduxForm.Field, {
                name: 'image.url',
                component: _UploadImage2.default,
                placeholder: uploadImagePlaceholder,
                className: _ItemForm2.default['upload-image'],
                backgroundColor: itemDetail ? itemDetail.background_color : null
              })
            ),
            React.createElement(
              'div',
              { className: 'col-lg-10 col-md-9 col-sm-9' },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: _SettingField2.default,
                      className: 'form-control',
                      name: 'name',
                      maxLength: '40',
                      placeholder: 'Item Name',
                      type: 'text'
                    })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-lg-12' },
                  React.createElement(
                    'div',
                    { className: 'form-group' },
                    React.createElement(_reduxForm.Field, {
                      component: RenderSelectField,
                      className: 'selectCategories',
                      name: 'category_id',
                      options: this._formatCategories(categories),
                      categories: categories,
                      onChange: this._onChangeCategories,
                      placeholder: 'Select an option'
                    })
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group', style: { marginBottom: 0 } },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Price'
                ),
                React.createElement(_ItemVariant2.default, null)
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              itemDetail && React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Inventory'
                ),
                React.createElement(_ItemInventoryAlert2.default, { disabled: itemDetail.is_recipe, classButton: '' + _ItemForm2.default['disabled-button'] }),
                !itemDetail.is_recipe && React.createElement(_WarningLabel2.default, {
                  content: 'Item stock can not be changed after saving the item, so please make sure that it is correct!',
                  type: 'info'
                }),
                itemDetail.is_recipe && React.createElement(
                  _WarningLabel2.default,
                  {
                    type: 'warning',
                    link: true
                  },
                  'This item can not be tracked because it has a recipe. Use the ',
                  React.createElement(
                    _reactRouter.Link,
                    { to: '/ingredient/recipes' },
                    React.createElement(
                      'i',
                      null,
                      'Ingredient Page'
                    )
                  ),
                  ' to manage recipes.'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Cost'
                ),
                itemDetail && React.createElement(_COGS2.default, { disabled: itemDetail.is_recipe, classButton: '' + _ItemForm2.default['disabled-button'] })
              )
            )
          ),
          modifiers.length > 0 && React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Modifier'
                ),
                React.createElement(_reduxForm.FieldArray, {
                  name: 'active_modifiers',
                  component: _ItemModifier2.default,
                  modifiers: modifiers
                })
              )
            )
          ),
          taxes.length > 0 && React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Assigned Tax'
                ),
                React.createElement(_reduxForm.FieldArray, {
                  comment: '{/*fka active_taxes */}',
                  itemDetail: itemDetail,
                  name: 'taxes',
                  component: _ItemTax2.default,
                  taxes: taxes
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _ItemForm2.default['margin-top-30'] },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(
                  'label',
                  { className: '' + _ItemForm2.default['label-input'] },
                  'Description'
                ),
                React.createElement(_reduxForm.Field, {
                  component: 'textarea',
                  className: 'form-control',
                  placeholder: 'Item Description',
                  maxLength: '70',
                  name: 'description',
                  type: 'text',
                  rows: '3'
                })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _ItemForm2.default.footer },
          itemDetail && itemDetail.id && React.createElement(
            'span',
            { className: 'pull-left' },
            itemDetail && !itemDetail.is_recipe ? React.createElement(
              'button',
              { className: 'btn btn-danger no-outline', onClick: this._onClickDelete, disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            ) : React.createElement(
              _reactBootstrap.OverlayTrigger,
              { trigger: ['hover', 'focus'], placement: 'top', overlay: tooltipDeleteBtn },
              React.createElement(
                'button',
                { className: 'btn ' + _ItemForm2.default['disabled-button'], onClick: function onClick(e) {
                    return e.preventDefault();
                  } },
                React.createElement('i', { className: 'fa fa-trash' })
              )
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: this._onClickCancel, disabled: isSubmittingForm },
              'Cancel'
            ),
            itemForm && !itemForm.id && outlets && outlets.length > 1 && React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'button', style: { 'margin-right': '10px' }, onClick: handleSubmit(this._onSubmitCreateAllOutlet), disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary no-outline', type: 'submit', onClick: handleSubmit(this._onSubmitSave), disabled: isSubmittingForm },
              'Save'
            )
          )
        ),
        React.createElement(_ItemVariantModal2.default, { onSubmit: this._onSaveVariant }),
        React.createElement(_ItemInventoryAlertModal2.default, { onSubmit: this._onSaveTrackInv }),
        React.createElement(_SaveToAllOutletsModal2.default, null),
        React.createElement(_COGSModal2.default, { onSubmit: this._onSaveCOGS }),
        itemDetail && itemDetail.id && React.createElement(_LibraryDeleteModal2.default, {
          name: itemDetail.name,
          onHide: this._onHideDeleteModal,
          showDeleteModal: showDeleteModal,
          title: 'Item',
          onDelete: this._confirmDelete
        }),
        React.createElement(_CreateCategoryModal2.default, {
          dispatch: this.props.dispatch,
          newCategory: this.props.newCategory,
          show: this.props.showNewCategoryModal,
          onCancel: this._onCancelCreateCategoryModal,
          onConfirm: this._onConfirmCreateCategoryModal
        })
      );
    }
  }]);
  return ItemForm;
}(React.Component);

ItemForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var item = state.library.item;

  return {
    outlets: item.outlets,
    modifiers: item.modifiers,
    itemDetail: item.itemDetail,
    itemForm: (0, _reduxForm.getFormValues)('item')(state),
    categories: item.categories,
    showDeleteModal: item.showDeleteModal,
    items: item.items,
    showNewCategoryModal: item.showNewCategoryModal,
    newCategory: item.newCategory,
    previousCategories: item.previousCategories,
    previousCategoryId: item.previousCategoryId,
    isTrack: item.isTrack,
    mustScrollTop: item.mustScrollTop,
    isSubmittingForm: item.isSubmittingForm,
    isDirtyForm: (0, _reduxForm.isDirty)('modal_item_variants')(state),
    search: (0, _reduxForm.getFormValues)('search')(state),
    taxes: item.taxes
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'item',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ItemForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ItemInventoryAlertFieldArray = __webpack_require__(1467);

var _ItemInventoryAlertFieldArray2 = _interopRequireDefault(_ItemInventoryAlertFieldArray);

__webpack_require__(2174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemInventoryAlert = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlert, _React$Component);

  function ItemInventoryAlert() {
    (0, _classCallCheck3.default)(this, ItemInventoryAlert);
    return (0, _possibleConstructorReturn3.default)(this, (ItemInventoryAlert.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlert)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemInventoryAlert, [{
    key: 'render',
    value: function render() {
      var defaultValue = { price: undefined, sku: undefined };
      return React.createElement(_reduxForm.FieldArray, {
        name: 'item_variants',
        component: _ItemInventoryAlertFieldArray2.default,
        defaultValue: defaultValue,
        disabled: this.props.disabled,
        classButton: this.props.classButton
      });
    }
  }]);
  return ItemInventoryAlert;
}(React.Component);

exports.default = ItemInventoryAlert;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ItemInventoryAlertField = __webpack_require__(2175);

var _ItemInventoryAlertField2 = _interopRequireDefault(_ItemInventoryAlertField);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemInventoryAlertField = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlertField, _React$Component);

  function ItemInventoryAlertField() {
    (0, _classCallCheck3.default)(this, ItemInventoryAlertField);
    return (0, _possibleConstructorReturn3.default)(this, (ItemInventoryAlertField.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlertField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemInventoryAlertField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          member = _props.member,
          isEditable = _props.isEditable;

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-8' },
          React.createElement(_reduxForm.Field, {
            component: 'input',
            disabled: true,
            name: member + '.name',
            className: 'form-control ' + (!isEditable ? '' : _ItemInventoryAlertField2.default['bg-white'])
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            component: _SettingField2.default,
            positiveNumberOnly: true,
            maxFractionDigits: 3,
            dis: !isEditable,
            name: member + '.in_stock',
            inputClassName: 'text-right'
          })
        )
      );
    }
  }]);
  return ItemInventoryAlertField;
}(React.Component);

ItemInventoryAlertField.propTypes = {
  member: React.PropTypes.object
};

exports.default = ItemInventoryAlertField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemInventoryAlertField = __webpack_require__(1466);

var _ItemInventoryAlertField2 = _interopRequireDefault(_ItemInventoryAlertField);

var _item = __webpack_require__(76);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemInventoryAlertFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlertFieldArray, _React$Component);

  function ItemInventoryAlertFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemInventoryAlertFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemInventoryAlertFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlertFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onClickStartTracking = function (e, isTrack) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          itemForm = _this$props.itemForm;

      dispatch((0, _item.onClickBtnStartTracking)(itemForm, isTrack));
      e.stopPropagation();
      e.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemInventoryAlertFieldArray, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          fields = _props.fields,
          disabled = _props.disabled,
          classButton = _props.classButton;

      var isTrack = false;
      var ItemInventoryAlert = [];
      fields.forEach(function (member, index, fields) {
        var fieldValues = fields.get(index);
        if (fieldValues.track_stock) {
          isTrack = true;
          ItemInventoryAlert.push(React.createElement(_ItemInventoryAlertField2.default, { member: member, isEditable: fieldValues.is_editable }));
        }
      });
      return React.createElement(
        'div',
        { className: 'row' },
        !disabled && isTrack && React.createElement(
          'span',
          { className: 'col-sm-offset-8 col-sm-4 text-left pl-0px label-instock' },
          'IN STOCK'
        ),
        !disabled ? ItemInventoryAlert : [],
        React.createElement(
          'div',
          { className: 'form-group col-sm-12' },
          React.createElement(
            'button',
            { onClick: function onClick(e) {
                _this2._onClickStartTracking(e, isTrack);
              }, className: 'btn btn-primary btn-block no-border-radius-top ' + (disabled ? classButton : ''), disabled: disabled },
            !isTrack ? 'Start Tracking Item Inventory and Alerts' : 'Manage Item Inventory and Alerts'
          )
        )
      );
    }
  }]);
  return ItemInventoryAlertFieldArray;
}(React.Component);

function mapStateToProps(state) {
  return {
    itemForm: (0, _reduxForm.getFormValues)('item')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemInventoryAlertFieldArray);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _item = __webpack_require__(76);

var _ItemInventoryAlertModal = __webpack_require__(2176);

var _ItemInventoryAlertModal2 = _interopRequireDefault(_ItemInventoryAlertModal);

var _ItemInventoryAlertModalFieldArray = __webpack_require__(1469);

var _ItemInventoryAlertModalFieldArray2 = _interopRequireDefault(_ItemInventoryAlertModalFieldArray);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemInventoryAlertModal = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlertModal, _React$Component);

  function ItemInventoryAlertModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemInventoryAlertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemInventoryAlertModal.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlertModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          previousItemForm = _this$props.previousItemForm;

      dispatch((0, _item.onCancelItemInventoryAlertModal)(previousItemForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemInventoryAlertModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showItemInventoryAlertModal = _props.showItemInventoryAlertModal,
          handleSubmit = _props.handleSubmit;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showItemInventoryAlertModal, onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _ItemInventoryAlertModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Manage Inventory' }),
        React.createElement(
          'form',
          { onSubmit: handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            null,
            React.createElement(
              'table',
              { className: 'table table-responsive ' + _ItemInventoryAlertModal2.default.table },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'th',
                    null,
                    'Variant'
                  ),
                  React.createElement(
                    'th',
                    null,
                    'Track Stock'
                  ),
                  React.createElement(
                    'th',
                    null,
                    'In Stock'
                  ),
                  React.createElement(
                    'th',
                    null,
                    'Alert'
                  ),
                  React.createElement(
                    'th',
                    null,
                    'Alert at'
                  )
                )
              ),
              React.createElement(_reduxForm.FieldArray, {
                component: _ItemInventoryAlertModalFieldArray2.default,
                name: 'item_variants'
              })
            )
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', type: 'button', onClick: this._onCancel },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', type: 'submit' },
                'Confirm'
              )
            ),
            React.createElement(
              'i',
              { className: _ItemInventoryAlertModal2.default['footer-info'] },
              '*Use the ',
              React.createElement(
                _reactRouter.Link,
                { to: '/inventory/summary', target: 'blank' },
                'Inventory page'
              ),
              ' to manage stock'
            )
          )
        )
      );
    }
  }]);
  return ItemInventoryAlertModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      showItemInventoryAlertModal = _state$library$item.showItemInventoryAlertModal,
      previousItemForm = _state$library$item.previousItemForm;

  return {
    showItemInventoryAlertModal: showItemInventoryAlertModal,
    previousItemForm: previousItemForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: false
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemInventoryAlertModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberOnly = function numberOnly() {
  return function (value, previousValue, allValues) {
    if (value) {
      if (isNaN(value)) {
        return previousValue;
      }
    }
    return value;
  };
};

var ItemInventoryAlertModalFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ItemInventoryAlertModalFieldArray, _React$Component);

  function ItemInventoryAlertModalFieldArray() {
    (0, _classCallCheck3.default)(this, ItemInventoryAlertModalFieldArray);
    return (0, _possibleConstructorReturn3.default)(this, (ItemInventoryAlertModalFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ItemInventoryAlertModalFieldArray)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemInventoryAlertModalFieldArray, [{
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return React.createElement(
        'tbody',
        null,
        fields.map(function (member, index, fields) {
          var fieldValues = fields.get(index);
          return React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              fieldValues.name
            ),
            React.createElement(
              'td',
              null,
              React.createElement(
                'div',
                { className: 'checkbox checkbox-primary checkbox-item checkbox-circle' },
                React.createElement(_reduxForm.Field, {
                  component: 'input',
                  name: member + '.track_stock',
                  type: 'checkbox',
                  id: 'checkbox-track-stock-' + index
                }),
                React.createElement('label', { 'for': 'checkbox-track-stock-' + index })
              )
            ),
            React.createElement(
              'td',
              null,
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  positiveNumberOnly: true,
                  maxFractionDigits: 3,
                  dis: !fieldValues.is_editable,
                  name: member + '.in_stock',
                  inputClassName: 'text-left'
                })
              )
            ),
            React.createElement(
              'td',
              null,
              React.createElement(
                'div',
                { className: 'checkbox checkbox-primary checkbox-item checkbox-circle' },
                React.createElement(_reduxForm.Field, {
                  component: 'input',
                  name: member + '.alert',
                  type: 'checkbox',
                  id: 'checkbox-alert-' + index
                }),
                React.createElement('label', { 'for': 'checkbox-alert-' + index })
              )
            ),
            React.createElement(
              'td',
              null,
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: 'input',
                  name: member + '.stock_alert',
                  type: 'text',
                  className: 'form-control',
                  normalize: numberOnly()
                })
              )
            )
          );
        })
      );
    }
  }]);
  return ItemInventoryAlertModalFieldArray;
}(React.Component);

exports.default = ItemInventoryAlertModalFieldArray;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemModifier = function (_React$Component) {
  (0, _inherits3.default)(ItemModifier, _React$Component);

  function ItemModifier() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemModifier);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemModifier.__proto__ || (0, _getPrototypeOf2.default)(ItemModifier)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeCheckbox = function (e, id) {
      var _this$props = _this.props,
          fields = _this$props.fields,
          modifiers = _this$props.modifiers;

      var values = fields.getAll(); // Take Note

      var indexPosition = -1;
      values.forEach(function (value, index) {
        if (value.id === id) {
          indexPosition = index;
        }
      });
      if (indexPosition === -1) {
        // the value doesn't exist, insert data
        modifiers.forEach(function (modifier) {
          if (modifier.id === id) {
            fields.push(modifier);
          }
        });
      } else {
        // remove the value
        fields.remove(indexPosition);
      }
    }, _this._checked = function (id) {
      var fields = _this.props.fields;

      var values = fields.getAll();
      var checked = false;
      if (values) {
        values.forEach(function (val) {
          checked = checked || val.id === id;
        });
      }
      return checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemModifier, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modifiers = this.props.modifiers;

      return React.createElement(
        'div',
        { className: 'checkbox checkbox-primary checkbox-item checkbox-circle ng-scope checkbox-circle no-padding' },
        modifiers.map(function (modifier, index) {
          return React.createElement(
            'div',
            { className: 'top-8 checkbox-input' },
            React.createElement('input', {
              type: 'checkbox',
              checked: _this2._checked(modifier.id),
              onChange: function onChange(e) {
                return _this2._onChangeCheckbox(e, modifier.id);
              },
              id: 'modifier-' + modifier.id,
              className: 'item-form-checkbox'
            }),
            React.createElement(
              'label',
              { 'for': 'modifier-' + modifier.id },
              modifier.name
            )
          );
        })
      );
    }
  }]);
  return ItemModifier;
}(React.Component);

exports.default = ItemModifier;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemTax = __webpack_require__(2177);

var _ItemTax2 = _interopRequireDefault(_ItemTax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTax = function (_React$Component) {
  (0, _inherits3.default)(ItemTax, _React$Component);

  function ItemTax() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemTax);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemTax.__proto__ || (0, _getPrototypeOf2.default)(ItemTax)).call.apply(_ref, [this].concat(args))), _this), _this._onTextClick = function (e, id) {
      e.preventDefault();
      e.stopPropagation();
      _this._onChangeCheckbox(e, id);
    }, _this._onChangeCheckbox = function (e, id) {
      var _this$props = _this.props,
          fields = _this$props.fields,
          taxes = _this$props.taxes;

      var values = fields.getAll();
      var indexPosition = -1;
      values.forEach(function (value, index) {
        if (value.id === id) {
          indexPosition = index;
        }
      });
      if (indexPosition === -1) {
        // the value doesn't exist, insert data
        taxes.forEach(function (tax) {
          if (tax.id === id) {
            fields.push(tax);
          }
        });
      } else {
        // remove the value
        fields.remove(indexPosition);
      }
    }, _this._checked = function (id, itemDetail) {
      var fields = _this.props.fields;

      var values = fields.getAll();
      var checked = false;
      if (values) {
        values.forEach(function (val) {
          checked = checked || val.id === id;
        });
      }
      return checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemTax, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          fields = _props.fields,
          taxes = _props.taxes,
          itemDetail = _props.itemDetail;

      if (itemDetail.id === null) {
        // In create mode, confirm using itemId === null, so set as checked
        taxes.forEach(function (tax) {
          fields.push(tax);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          taxes = _props2.taxes,
          itemDetail = _props2.itemDetail;

      return React.createElement(
        'div',
        null,
        taxes.map(function (tax, index) {
          return React.createElement(
            'div',
            { className: 'row ' + _ItemTax2.default['row-wrapper'] },
            React.createElement(
              'div',
              { className: 'col-xs-10 ' + _ItemTax2.default['tax-name-wrapper'] },
              React.createElement(
                'a',
                { href: '#', onClick: function onClick(e) {
                    return _this2._onTextClick(e, tax.id);
                  } },
                tax.name
              )
            ),
            React.createElement(
              'div',
              { className: 'col-xs-2 ' + _ItemTax2.default['tax-checkbox-wrapper'] },
              React.createElement(
                'div',
                { className: 'checkbox ' + _ItemTax2.default['checkbox-moka'] },
                React.createElement('input', {
                  className: 'pull-right ' + _ItemTax2.default['tax-checkbox-input'],
                  type: 'checkbox',
                  checked: _this2._checked(tax.id, itemDetail),
                  onChange: function onChange(e) {
                    return _this2._onChangeCheckbox(e, tax.id);
                  },
                  id: 'tax-' + tax.id
                }),
                React.createElement(
                  'label',
                  { className: 'float-left ' + _ItemTax2.default['tax-amount-label'], 'for': 'tax-' + tax.id },
                  tax.amount,
                  '%'
                )
              )
            )
          );
        })
      );
    }
  }]);
  return ItemTax;
}(React.Component);

exports.default = ItemTax;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ItemVariantsFieldArray = __webpack_require__(1473);

var _ItemVariantsFieldArray2 = _interopRequireDefault(_ItemVariantsFieldArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemVariants = function (_React$Component) {
  (0, _inherits3.default)(ItemVariants, _React$Component);

  function ItemVariants() {
    (0, _classCallCheck3.default)(this, ItemVariants);
    return (0, _possibleConstructorReturn3.default)(this, (ItemVariants.__proto__ || (0, _getPrototypeOf2.default)(ItemVariants)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemVariants, [{
    key: 'render',
    value: function render() {
      var defaultValue = { price: undefined, sku: undefined };
      return React.createElement(_reduxForm.FieldArray, {
        name: 'item_variants',
        component: _ItemVariantsFieldArray2.default,
        defaultValue: defaultValue,
        placeholder: 'price'
      });
    }
  }]);
  return ItemVariants;
}(React.Component);

exports.default = ItemVariants;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemVariantsFields = __webpack_require__(1474);

var _ItemVariantsFields2 = _interopRequireDefault(_ItemVariantsFields);

var _item = __webpack_require__(76);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemVariantsFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ItemVariantsFieldArray, _React$Component);

  function ItemVariantsFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemVariantsFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemVariantsFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ItemVariantsFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onClickBtnItemVariant = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          item = _this$props.item;

      dispatch((0, _item.onClickBtnItemVariant)(item));
      e.stopPropagation();
      e.preventDefault();
    }, _this._buttonLabel = function () {
      var fields = _this.props.fields;

      if (fields.length > 1) {
        return 'Manage Variant';
      } else {
        return 'Add Variant';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemVariantsFieldArray, [{
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return React.createElement(
        'div',
        { className: 'row' },
        fields.map(function (member, index) {
          return React.createElement(_ItemVariantsFields2.default, { fields: fields, member: member });
        }),
        React.createElement(
          'div',
          { className: 'form-group col-sm-12' },
          React.createElement(
            'button',
            { onClick: this._onClickBtnItemVariant, className: 'btn btn-primary btn-block no-border-radius-top' },
            this._buttonLabel()
          )
        )
      );
    }
  }]);
  return ItemVariantsFieldArray;
}(React.Component);

function mapStateToProps(state) {
  return {
    item: (0, _reduxForm.getFormValues)('item')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemVariantsFieldArray);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemVariantsFields = function (_React$Component) {
  (0, _inherits3.default)(ItemVariantsFields, _React$Component);

  function ItemVariantsFields() {
    (0, _classCallCheck3.default)(this, ItemVariantsFields);
    return (0, _possibleConstructorReturn3.default)(this, (ItemVariantsFields.__proto__ || (0, _getPrototypeOf2.default)(ItemVariantsFields)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemVariantsFields, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          member = _props.member,
          fields = _props.fields;

      var isHide = fields.length === 1 ? 'hide' : 'show';
      var cssColumn = isHide === 'hide' ? 'col-md-6' : 'col-md-4';
      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        isHide !== 'hide' && React.createElement(
          'div',
          { className: 'form-group col-md-4' },
          React.createElement(_reduxForm.Field, {
            name: member + '.name',
            component: _SettingField2.default,
            className: 'form-control',
            placeholder: 'Name'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group ' + (cssColumn === 'col-md-6' ? 'col-md-6' : 'col-md-4 no-padding') },
          React.createElement(_reduxForm.Field, {
            name: member + '.price',
            component: _SettingField2.default,
            placeholder: 'Price',
            inputClassName: 'text-right',
            positiveNumberOnly: true
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group ' + cssColumn },
          React.createElement(_reduxForm.Field, {
            name: member + '.sku',
            component: 'input',
            className: 'form-control text-align-last-left',
            placeholder: 'SKU'
          })
        )
      );
    }
  }]);
  return ItemVariantsFields;
}(React.Component);

ItemVariantsFields.propTypes = {
  member: React.PropTypes.object
};

exports.default = ItemVariantsFields;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ItemVariantField = __webpack_require__(2178);

var _ItemVariantField2 = _interopRequireDefault(_ItemVariantField);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reactBootstrap = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popoverFocus = function popoverFocus(_ref) {
  var content = _ref.content;
  return React.createElement(
    _reactBootstrap.Popover,
    { id: 'purchaseOrder' },
    content
  );
};

var ItemVariantField = function (_React$Component) {
  (0, _inherits3.default)(ItemVariantField, _React$Component);

  function ItemVariantField() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemVariantField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ItemVariantField.__proto__ || (0, _getPrototypeOf2.default)(ItemVariantField)).call.apply(_ref2, [this].concat(args))), _this), _this._onDelete = function () {
      _this.props.onDelete();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemVariantField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          member = _props.member,
          showDelete = _props.showDelete,
          isRecipe = _props.isRecipe;

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            name: member + '.name',
            component: _SettingField2.default,
            className: 'form-control',
            placeholder: 'Name'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            name: member + '.price',
            component: _SettingField2.default,
            inputClassName: 'text-right',
            positiveNumberOnly: true,
            placeholder: 'Rp. 0'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            name: member + '.sku',
            component: _SettingField2.default,
            className: 'form-control ' + _ItemVariantField2.default['text-align-last-right'],
            placeholder: 'SKU',
            feedbackClassName: '' + _ItemVariantField2.default['feedback'],
            inputClassName: '' + _ItemVariantField2.default['last-input']
          }),
          showDelete && !isRecipe && React.createElement(
            'div',
            { className: '' + _ItemVariantField2.default['btn-delete-wrapper'] },
            React.createElement(
              'span',
              { className: '' + _ItemVariantField2.default['btn-delete'],
                onClick: this._onDelete,
                type: 'button' },
              React.createElement('i', { className: 'fa fa-times-circle' })
            )
          ),
          isRecipe && React.createElement(
            _reactBootstrap.OverlayTrigger,
            { placement: 'top', overlay: popoverFocus({ content: 'The item variant cannot be deleted because it has been associated with a Recipe. Please first delete the Recipe and try again.' }) },
            React.createElement(
              'div',
              { className: '' + _ItemVariantField2.default['btn-delete-wrapper'] },
              React.createElement(
                'span',
                { className: '' + _ItemVariantField2.default['btn-warning'], type: 'button' },
                React.createElement('i', { className: 'fa fa-exclamation-circle' })
              )
            )
          )
        )
      );
    }
  }]);
  return ItemVariantField;
}(React.Component);

ItemVariantField.propTypes = {
  member: React.PropTypes.object,
  onDelete: React.PropTypes.func
};

exports.default = ItemVariantField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ItemVariantField = __webpack_require__(1475);

var _ItemVariantField2 = _interopRequireDefault(_ItemVariantField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemVariantFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ItemVariantFieldArray, _React$Component);

  function ItemVariantFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemVariantFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemVariantFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ItemVariantFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onDelete = function (index) {
      var fields = _this.props.fields;

      fields.remove(index);
    }, _this._onClickAdd = function () {
      var fields = _this.props.fields;

      fields.push({
        name: '',
        price: null,
        sku: '',
        in_stock: 0,
        stock_alert: 0,
        cogs: null,
        saved_cogs: false,
        is_saved: false,
        is_editable: true,
        is_new: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemVariantFieldArray, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var fields = this.props.fields;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-12 mb-0px' },
          React.createElement(
            'a',
            { className: 'btn btn-primary btn-block', onClick: this._onClickAdd },
            'Add Variant'
          )
        ),
        fields.map(function (member, index) {
          return React.createElement(_ItemVariantField2.default, { member: member, isRecipe: fields.get(index).is_recipe, showDelete: fields.length > 1, onDelete: function onDelete() {
              return _this2._onDelete(index);
            } });
        })
      );
    }
  }]);
  return ItemVariantFieldArray;
}(React.Component);

exports.default = ItemVariantFieldArray;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reduxForm = __webpack_require__(7);

var _ItemVariantFieldArray = __webpack_require__(1476);

var _ItemVariantFieldArray2 = _interopRequireDefault(_ItemVariantFieldArray);

var _reactRedux = __webpack_require__(6);

var _item = __webpack_require__(76);

var _ItemVariantModal = __webpack_require__(2179);

var _ItemVariantModal2 = _interopRequireDefault(_ItemVariantModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};

  var itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach(function (iv, index) {
      var memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please enter a value';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if ((0, _keys2.default)(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

var ItemVariantModal = function (_React$Component) {
  (0, _inherits3.default)(ItemVariantModal, _React$Component);

  function ItemVariantModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemVariantModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemVariantModal.__proto__ || (0, _getPrototypeOf2.default)(ItemVariantModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          previousItemForm = _this$props.previousItemForm;

      dispatch((0, _item.onCancelItemVariantModal)(previousItemForm));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemVariantModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showItemVariantModal = _props.showItemVariantModal,
          handleSubmit = _props.handleSubmit;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showItemVariantModal, onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _ItemVariantModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Add Variant' }),
        React.createElement(
          'form',
          { onSubmit: handleSubmit },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { bsClass: 'modal-body ' + _ItemVariantModal2.default.body },
            React.createElement(_reduxForm.FieldArray, {
              name: 'item_variants',
              component: _ItemVariantFieldArray2.default
            })
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', type: 'button', onClick: this._onCancel },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', type: 'submit' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return ItemVariantModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      showItemVariantModal = _state$library$item.showItemVariantModal,
      previousItemForm = _state$library$item.previousItemForm;

  return {
    showItemVariantModal: showItemVariantModal, previousItemForm: previousItemForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

ItemVariantModal.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func
};

var mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemVariantModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _SaveToAllOutletsModal = __webpack_require__(2180);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _item = __webpack_require__(76);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveToAllOutletsModal = function (_React$Component) {
  (0, _inherits3.default)(SaveToAllOutletsModal, _React$Component);

  function SaveToAllOutletsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SaveToAllOutletsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SaveToAllOutletsModal.__proto__ || (0, _getPrototypeOf2.default)(SaveToAllOutletsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickOK = function () {
      _this.props.dispatch((0, _item.hideSaveToAllOutletsModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SaveToAllOutletsModal, [{
    key: 'render',
    value: function render() {
      var showSaveToAllOutletsModal = this.props.showSaveToAllOutletsModal;


      return React.createElement(
        _reactBootstrap.Modal,
        { className: _SaveToAllOutletsModal2.default['container'], show: showSaveToAllOutletsModal, backdrop: 'static', onHide: this._onClickOK, dialogClassName: 'modal-dialog ' + _SaveToAllOutletsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { className: _SaveToAllOutletsModal2.default['title'], title: 'Information' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            null,
            'Create item is in process. This process may take a few minutes.'
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: this._onClickOK },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return SaveToAllOutletsModal;
}(React.Component);

function mapStateToProps(state) {
  var showSaveToAllOutletsModal = state.library.item.showSaveToAllOutletsModal;

  return {
    showSaveToAllOutletsModal: showSaveToAllOutletsModal
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SaveToAllOutletsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ImportModal2 = __webpack_require__(439);

var _ImportModal3 = _interopRequireDefault(_ImportModal2);

var _reactBootstrap = __webpack_require__(10);

var _constants = __webpack_require__(433);

var _item = __webpack_require__(76);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _ingredients = __webpack_require__(205);

var apiIng = _interopRequireWildcard(_ingredients);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemImportModal = function (_ImportModal) {
  (0, _inherits3.default)(ItemImportModal, _ImportModal);

  function ItemImportModal(props) {
    (0, _classCallCheck3.default)(this, ItemImportModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemImportModal.__proto__ || (0, _getPrototypeOf2.default)(ItemImportModal)).call(this, props));

    _this._header = function () {
      if (_this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          _reactBootstrap.Modal.Title,
          null,
          'Choose Import Type'
        );
      }
    };

    _this._footer = function () {
      if (_this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { onClick: _this._onCancel, className: 'btn btn-default' },
              'Cancel'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { onClick: _this._onNext, className: 'btn btn-primary' },
              'Next'
            )
          )
        );
      }
    };

    _this._body = function () {
      if (_this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
        return null;
      } else {
        return React.createElement(
          'div',
          { className: 'modal-below-header' },
          React.createElement(
            'div',
            { className: 'choose-import-box', onClick: function onClick() {
                _this._onClickType('modify');
              } },
            React.createElement(
              'div',
              { className: 'circle' },
              _this.state.type === 'modify' ? '✓' : ''
            ),
            React.createElement(
              'div',
              { className: 'label-modify-item-library' },
              'Modify Item Library'
            ),
            React.createElement(
              'div',
              { className: 'description' },
              'Add new items and update your existing ones. Items cannot be deleted, only altered'
            )
          ),
          React.createElement(
            'div',
            { className: 'choose-import-box', onClick: function onClick() {
                _this._onClickType('replace');
              } },
            React.createElement(
              'div',
              { className: 'circle' },
              _this.state.type === 'replace' ? '✓' : ''
            ),
            React.createElement(
              'div',
              { className: 'label-modify-item-library' },
              'Replace Item Library'
            ),
            React.createElement(
              'div',
              { className: 'description' },
              'Overwrite your existing items. All items will be deleted and replaced'
            )
          )
        );
      }
    };

    _this._confirmImportBody = function () {
      return React.createElement(
        'p',
        null,
        'Are you sure you want to replace the item library?',
        React.createElement('br', null),
        'If you replace the item library, all recipes will be deleted'
      );
    };

    _this._confirmImportHeader = function () {
      return 'Replace Item';
    };

    _this._confirmFunction = function () {
      return new _promise2.default(function (resolve, reject) {
        if (_this.state.type === 'modify') {
          resolve(false);
        }
        act.showLoadingSpinner(true);
        apiIng.getHaveRecipe({}).then(function (response) {
          act.showLoadingSpinner(false);
          resolve(response.data.is_recipe);
        }).catch(function (error) {
          act.showLoadingSpinner(false);
          reject(error.message);
        });
      });
    };

    _this._onCancel = function () {
      _this.props.dispatch((0, _item.hideImportModal)());
    };

    _this._onNext = function () {
      _this.setState({
        act: ItemImportModal.SHOW_IMPORT_MODAL
      });
    };

    _this._onClickType = function (type) {
      _this.setState({
        type: type
      });
    };

    _this.state = {
      act: ItemImportModal.SHOW_IMPORT_MODAL,
      type: 'modify'
    };
    return _this;
  }

  (0, _createClass3.default)(ItemImportModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.props.show) {
        this.setState({
          act: ItemImportModal.SELECT_TYPE,
          type: 'modify'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var replace = this.state.type === 'replace';
      var modify = this.state.type === 'modify';
      return React.createElement(_ImportModal3.default, {
        pathImporting: 'outlet',
        selectedOutletIds: this.props.selectedOutletIds,
        dispatch: this.props.dispatch,
        templateImportUrl: _constants.V1_IMPORT_ITEMS_TEMPLATE,
        temporaryImportUrl: _constants.V1_IMPORT_ITEMS_TEMPORARY,
        importUrl: _constants.V1_IMPORT_ITEMS + '?replace=' + replace + '&modify=' + modify,
        namespace: 'items',
        onCancel: this._onCancel,
        onBack: function onBack() {
          _this2.setState({ act: ItemImportModal.SELECT_TYPE });
        },
        show: this.props.show,
        afterSuccessCallback: function afterSuccessCallback() {
          _this2.props.dispatch((0, _item.onSuccessImport)());
        },
        onErrorCallback: function onErrorCallback(errors) {
          _this2.props.dispatch(actNotif.error(errors[0]));
        },
        templatePrefix: 'Item Library - ',
        body: this._body(),
        header: this._header(),
        footer: this._footer(),
        eventName: this.state.type,
        filterNamespace: 'items',
        csvHeaders: ['Name', 'Category', 'Description'],
        confirmImportBody: this._confirmImportBody(),
        confirmImportHeader: this._confirmImportHeader(),
        confirmPromiseFunction: this._confirmFunction
      });
    }

    /**
     * return true if items have recipe, it means user must confirm all recipes must be deleted first
     * @return {Promise}
     * @private
     */

  }]);
  return ItemImportModal;
}(_ImportModal3.default);

ItemImportModal.SELECT_TYPE = 'select_type';
ItemImportModal.SHOW_IMPORT_MODAL = 'show_import_modal';
exports.default = ItemImportModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(2182);

var _List2 = _interopRequireDefault(_List);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _reduxForm = __webpack_require__(7);

var _item = __webpack_require__(76);

var actItem = _interopRequireWildcard(_item);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (item) {
      var isDirtyItem = _this.props.isDirtyItem;

      if (isDirtyItem) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actItem.onClickRow(item)));
      } else {
        _this.props.dispatch(actItem.onClickRow(item));
      }
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          items = _this$props.items,
          filterState = _this$props.filterState;

      dispatch(actItem.itemsRequest({ page: currentPage + 1, filterState: filterState }, items));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._priceFormatter = function (item) {
      var itemVariants = item.item_variants;

      if (itemVariants.length > 1) {
        return itemVariants.length + ' Prices';
      }

      if (itemVariants.length < 2 && itemVariants.length !== 0) {
        var price = itemVariants[0].price;

        if (price === null) {
          return 'Variable';
        }
        return _this._currencyFormatter(price);
      }
    }, _this._currencyFormatter = function (data) {
      if (isNaN(data)) return 'Rp. 0';
      var currency = 'Rp. ';
      var result = '';
      data = data || 0;
      if (data < 0) {
        data *= -1;
        result = '(' + currency + data.toString() + ')';
      } else {
        result = currency + data.toString();
      }
      return result.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
    }, _this._inStockFormatter = function (item) {
      var itemVariants = item.item_variants;
      var total = 0;
      var count = 0;

      for (var i = 0; i < itemVariants.length; i++) {
        var itemVariant = itemVariants[i];

        if (itemVariant.track_stock) {
          count += 1;
          total += parseInt(itemVariant.in_stock);
        }
      }

      if (count > 0) {
        return total;
      } else {
        return total === 0 ? '' : total;
      }
    }, _this._stockAlertFormatter = function (item, itemDetail) {
      var itemVariants = item.item_variants;
      var text = '';
      var color = '#FFD700';
      var whiteColor = '#FFFFFF';
      var lowTotal = 0;
      var outTotal = 0;
      var counter = 0;
      if (itemVariants.length > 0) {
        for (var i = 0; i < itemVariants.length; i++) {
          var itemVariant = itemVariants[i];
          if (itemVariant.track_stock && itemVariant.alert) {
            counter += 1;
            if (itemVariant.in_stock <= itemVariant.stock_alert && itemVariant.in_stock > 0) {
              lowTotal += 1;
            } else if (itemVariant.in_stock <= 0) {
              outTotal += 1;
            }
          }
        }

        if (outTotal > 0) {
          color = '#FF0000';
        }
        // $scope.color = color;

        if (outTotal === 0 && lowTotal > 0) {
          text = lowTotal + ' Low';
        } else if (outTotal > 0 && lowTotal === 0) {
          text = outTotal + ' Out';
        } else {
          text = lowTotal + ' Low, ' + outTotal + ' Out';
        }
      }

      if (counter > 0) {
        if (outTotal > 0 || lowTotal > 0) {
          var style = { color: color };
          var styleWhite = { whiteColor: whiteColor };
          if (itemDetail && itemDetail.id === item.id) {
            return React.createElement(
              'span',
              { style: styleWhite },
              text
            );
          } else {
            return React.createElement(
              'span',
              { style: style },
              text
            );
          }
        }
      }

      return '';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemDetail = _props.itemDetail;


      return items.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'div',
          { className: 'full-height' },
          React.createElement(
            'div',
            { className: _List2.default['leftcol'] + ' no-padding', id: 'mk-col-left' },
            React.createElement(
              'table',
              { className: _List2.default['table-header'] },
              React.createElement(
                'thead',
                null,
                React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'th',
                    { className: _List2.default.headerName },
                    'Name'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerCategory },
                    'Category'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerPrice },
                    'Price'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerInStock },
                    'In Stock'
                  ),
                  React.createElement(
                    'th',
                    { className: _List2.default.headerStockAlert },
                    'Stock Alert'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: _List2.default['table-content-wrapper'] },
              React.createElement(
                _reactInfiniteScroller2.default,
                {
                  pageStart: 1,
                  loadMore: this._onReachBottom,
                  hasMore: this._hasMore(),
                  useWindow: false,
                  threshold: 10,
                  initialLoad: false },
                React.createElement(
                  'table',
                  { className: _List2.default['table-content'] },
                  React.createElement(
                    'tbody',
                    null,
                    items.length > 0 && items.map(function (item) {
                      return React.createElement(
                        'tr',
                        { className: '' + (itemDetail && itemDetail.id === item.id ? _List2.default.selected : ''),
                          onClick: function onClick() {
                            return _this2._onClickRow(item);
                          } },
                        React.createElement(
                          'td',
                          { className: _List2.default.headerName },
                          item.name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerCategory },
                          item.category.name
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerPrice },
                          _this2._priceFormatter(item)
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerInStock },
                          _this2._inStockFormatter(item)
                        ),
                        React.createElement(
                          'td',
                          { className: _List2.default.headerStockAlert },
                          _this2._stockAlertFormatter(item, itemDetail)
                        )
                      );
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$item = state.library.item,
      items = _state$library$item.items,
      itemDetail = _state$library$item.itemDetail,
      currentPage = _state$library$item.currentPage,
      totalPage = _state$library$item.totalPage,
      showDetail = _state$library$item.showDetail,
      filterState = _state$library$item.filterState;

  return {
    items: items,
    itemDetail: itemDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showDetail: showDetail,
    isDirtyItem: (0, _reduxForm.isDirty)('item')(state),
    filterState: filterState
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  items: React.PropTypes.array,
  itemDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  showDetail: React.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Library = __webpack_require__(2183);

var _Library2 = _interopRequireDefault(_Library);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Library = function (_React$Component) {
  (0, _inherits3.default)(Library, _React$Component);

  function Library() {
    (0, _classCallCheck3.default)(this, Library);
    return (0, _possibleConstructorReturn3.default)(this, (Library.__proto__ || (0, _getPrototypeOf2.default)(Library)).apply(this, arguments));
  }

  (0, _createClass3.default)(Library, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'container ' + _Library2.default['container'] },
        this.props.children
      );
    }
  }]);
  return Library;
}(React.Component);

exports.default = Library;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _pages = __webpack_require__(38);

var _modifier = __webpack_require__(102);

var _confirmAction = __webpack_require__(29);

var _modifier2 = __webpack_require__(297);

var mpLibraryModifier = _interopRequireWildcard(_modifier2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateModifier = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isDirtyModifier = _this$props.isDirtyModifier;

      if (isDirtyModifier) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _modifier.onClickCreateModifier)()));
      } else {
        dispatch((0, _modifier.onClickCreateModifier)());
      }
    }, _this._onChangeOutletIds = function (outletIds) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          isDirtyModifier = _this$props2.isDirtyModifier,
          searchValue = _this$props2.searchValue;

      var prevOutlets = searchValue.outletIds[0];
      mpLibraryModifier.libraryModifierChangeOutlet({ prevOutlet: prevOutlets, currOutlet: outletIds });
      if (isDirtyModifier) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _modifier.onChangeOutletIds)(outletIds)));
      } else {
        dispatch((0, _modifier.onChangeOutletIds)(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;

      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'col-sm-4 col-xs-12', style: { paddingLeft: 0 } },
          React.createElement(_reduxForm.Field, {
            name: 'outletIds',
            component: _DropdownOutlet2.default,
            outlets: outlets,
            onChangeOutletIds: this._onChangeOutletIds
          })
        ),
        React.createElement(
          'div',
          { className: 'col-sm-8 hidden-xs', style: { paddingRight: 0 } },
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickCreateModifier },
              'Create Modifier'
            )
          )
        )
      );
    }

    /**
     * Redux form auto convert array to objects, so we change it back to array
     * @private
     * @param outletIdsAsObject
     */

  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var outlets = state.library.modifier.outlets;

  return {
    outlets: outlets,
    isDirtyModifier: (0, _reduxForm.isDirty)('modifier')(state),
    searchValue: (0, _reduxForm.getFormValues)('search')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _Search = __webpack_require__(1485);

var _Search2 = _interopRequireDefault(_Search);

var _Items = __webpack_require__(1484);

var _Items2 = _interopRequireDefault(_Items);

var _reduxForm = __webpack_require__(7);

var _modifier = __webpack_require__(102);

var _ApplySetItemModal = __webpack_require__(2184);

var _ApplySetItemModal2 = _interopRequireDefault(_ApplySetItemModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApplySetItemModal = function (_React$Component) {
  (0, _inherits3.default)(ApplySetItemModal, _React$Component);

  function ApplySetItemModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ApplySetItemModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ApplySetItemModal.__proto__ || (0, _getPrototypeOf2.default)(ApplySetItemModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var dispatch = _this.props.dispatch;

      dispatch((0, _modifier.cancelApplySetItem)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ApplySetItemModal, [{
    key: 'render',
    value: function render() {
      var showApplySetItemModal = this.props.showApplySetItemModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showApplySetItemModal, onHide: this._onHide, backdrop: 'static', dialogClassName: 'modal-dialog ' + _ApplySetItemModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Apply Set to Items' }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'itemIds' }),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { bsClass: _ApplySetItemModal2.default.body + ' modal-body' },
            React.createElement(_Search2.default, null),
            React.createElement(_Items2.default, null)
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              )
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary' },
                'Apply to Items'
              )
            )
          )
        )
      );
    }
  }]);
  return ApplySetItemModal;
}(React.Component);

function mapStateToProps(state) {
  var showApplySetItemModal = state.library.modifier.showApplySetItemModal;

  return { showApplySetItemModal: showApplySetItemModal };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'applySetItem'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ApplySetItemModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _Items = __webpack_require__(2185);

var _Items2 = _interopRequireDefault(_Items);

var _reduxForm = __webpack_require__(7);

var _modifier = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Items = function (_React$Component) {
  (0, _inherits3.default)(Items, _React$Component);

  function Items() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Items);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Items.__proto__ || (0, _getPrototypeOf2.default)(Items)).call.apply(_ref, [this].concat(args))), _this), _this._hasMore = function () {
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPage = _this$props.totalPage;

      var ret = currentPage < totalPage;
      return ret;
    }, _this._onReachBottom = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage,
          keyword = _this$props2.applySetItem.keyword,
          items = _this$props2.items,
          dispatch = _this$props2.dispatch;

      if (currentPage < totalPage) {
        dispatch((0, _modifier.applySetItemItemsRequest)({ keyword: keyword, page: currentPage + 1, with_batch: true }, items));
      }
    }, _this._onChangeCheckbox = function (e, item) {
      var _this$props3 = _this.props,
          itemIds = _this$props3.applySetItem.itemIds,
          dispatch = _this$props3.dispatch;

      var indexPositions = {};

      itemIds.forEach(function (itemId, index) {
        if (itemId === item.id) {
          indexPositions[index] = true;
        }
      });
      if (e.target.checked) {
        dispatch((0, _reduxForm.arrayPush)('applySetItem', 'itemIds', item.id));
      } else {
        // remove all if exists (don't know why server has more than one
        var newItemIds = [];
        itemIds.forEach(function (itemId, index) {
          if (!indexPositions[index]) {
            newItemIds.push(itemId);
          }
        });
        dispatch((0, _reduxForm.change)('applySetItem', 'itemIds', newItemIds));
      }
    }, _this._checked = function (targetItem) {
      var itemIds = _this.props.applySetItem.itemIds;

      var checked = false;
      itemIds.forEach(function (itemId) {
        checked = checked || itemId === targetItem.id;
      });
      return checked;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Items, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items;

      return React.createElement(
        'div',
        { className: _Items2.default.wrapper },
        React.createElement(
          _reactInfiniteScroller2.default,
          {
            pageStart: 1,
            loadMore: this._onReachBottom,
            hasMore: this._hasMore(),
            useWindow: false,
            threshold: 10,
            initialLoad: false
          },
          items.map(function (item, idx) {
            return React.createElement(
              'div',
              { className: 'row ' + _Items2.default['row-wrapper'] },
              React.createElement(
                'div',
                { className: 'col-xs-2 ' + _Items2.default['item-image-wrapper'] },
                React.createElement('img', { src: item.image.url, className: _Items2.default.image })
              ),
              React.createElement(
                'div',
                { className: 'col-xs-9 ' + _Items2.default['item-name-wrapper'] },
                item.name
              ),
              React.createElement(
                'div',
                { className: 'col-xs-1 pull-right ' + _Items2.default['item-checkbox-wrapper'] },
                React.createElement('input', { type: 'checkbox', checked: _this2._checked(item), onChange: function onChange(e) {
                    return _this2._onChangeCheckbox(e, item);
                  } })
              )
            );
          })
        )
      );
    }
  }]);
  return Items;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('applySetItem');

function mapStateToProps(state) {
  var _state$library$modifi = state.library.modifier,
      _state$library$modifi2 = _state$library$modifi.applySetItems,
      items = _state$library$modifi2.items,
      currentPage = _state$library$modifi2.currentPage,
      totalPage = _state$library$modifi2.totalPage,
      modifierDetail = _state$library$modifi.modifierDetail;

  return {
    modifierDetail: modifierDetail,
    applySetItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword')
    },
    items: items,
    currentPage: currentPage,
    totalPage: totalPage
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Items);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SearchForm = __webpack_require__(2186);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _reactRedux = __webpack_require__(6);

var _modifier = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function (_React$Component) {
  (0, _inherits3.default)(Search, _React$Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref, [this].concat(args))), _this), _this._onChange = function (event, value) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _modifier.applySetItemItemsRequest)({ page: 1, keyword: value, with_batch: true }, []));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row ' + _SearchForm2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-md-12' },
          React.createElement(
            'div',
            { className: 'right-inner-addon' },
            React.createElement('i', { className: 'fa fa-search' }),
            React.createElement(_reduxForm.Field, {
              component: 'input',
              name: 'keyword',
              className: 'form-control',
              placeholder: 'search',
              onChange: this._onChange
            })
          )
        )
      );
    }
  }]);
  return Search;
}(React.Component);

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ModifierForm = __webpack_require__(1487);

var _ModifierForm2 = _interopRequireDefault(_ModifierForm);

var _Detail = __webpack_require__(2187);

var _Detail2 = _interopRequireDefault(_Detail);

var _modifier = __webpack_require__(102);

var _reactRedux = __webpack_require__(6);

var _modifier2 = __webpack_require__(297);

var mpLibraryModifier = _interopRequireWildcard(_modifier2);

var _reduxForm = __webpack_require__(7);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Detail = function (_React$Component) {
  (0, _inherits3.default)(Detail, _React$Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          modifiers = _this$props.modifiers;

      values.name = values.name ? values.name.trim() : '';
      values.options.forEach(function (opt, idx) {
        values.options[idx].name = opt.name ? opt.name.trim() : '';
        values.options[idx].price = opt.price ? opt.price : '0';
      });
      if (values.id) {
        var prevName = _this.props.initialModifier.name;
        var prevOptions = _this.props.initialModifier.options;
        mpLibraryModifier.libraryModifierUpdateOneOutlet({ prevName: prevName, prevOptions: prevOptions, newName: values.name, newOptions: values.options });
        dispatch((0, _modifier.submitFormUpdate)(values.id, { modifier: values }, modifiers));
      } else {
        if (values.action === 'save') {
          mpLibraryModifier.libraryModifierCreate({ modifier: values, allOutlet: false });
          dispatch((0, _modifier.submitFormCreate)({ modifier: values }, modifiers));
        } else {
          mpLibraryModifier.libraryModifierCreate({ modifier: values, allOutlet: true });
          dispatch((0, _modifier.submitFormCreateAllOutlet)({ modifier: values }, modifiers));
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Detail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _Detail2.default.wrapper },
        React.createElement(_ModifierForm2.default, { onSubmit: this._onSubmit })
      );
    }
  }]);
  return Detail;
}(React.Component);

function mapStateToProps(state) {
  var modifiers = state.library.modifier.modifiers;

  return { modifiers: modifiers, initialModifier: (0, _reduxForm.getFormInitialValues)('modifier')(state) };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Detail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _ActionBarDetailWrapper = __webpack_require__(449);

var _ActionBarDetailWrapper2 = _interopRequireDefault(_ActionBarDetailWrapper);

var _ModifierForm = __webpack_require__(2188);

var _ModifierForm2 = _interopRequireDefault(_ModifierForm);

var _modifier = __webpack_require__(102);

var _reactRedux = __webpack_require__(6);

var _ModifierOptions = __webpack_require__(1488);

var _ModifierOptions2 = _interopRequireDefault(_ModifierOptions);

var _ModifierOptionsModal = __webpack_require__(1493);

var _ModifierOptionsModal2 = _interopRequireDefault(_ModifierOptionsModal);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This validation is commented out because PM wants to use the back-end validation
 * Reason : match moka-rails
 * https://mokapos.atlassian.net/browse/PS-527
 */
var validate = function validate(values) {
  var errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'This field is required';
  } else if (values.name.length > 100) {
    errors.name = 'Name max 100 char';
  }
  // let optionsError = []
  // if (values.options) {
  //   values.options.forEach((member, index) => {
  //     const memberErrors = {}
  //     if ((!member.name) || (member.name.trim() === '')) {
  //       memberErrors.name = 'Please enter a value'
  //     }
  //     if (parseInt(member.price) > 99999999999) {
  //       memberErrors.price = 'Price must be less than or equal to 99999999999'
  //     }
  //     optionsError[index] = memberErrors
  //   })
  // }
  // errors.options = optionsError
  return errors;
};

var ModifierForm = function (_React$Component) {
  (0, _inherits3.default)(ModifierForm, _React$Component);

  function ModifierForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModifierForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModifierForm.__proto__ || (0, _getPrototypeOf2.default)(ModifierForm)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmitCreateAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save_to_all_outlet' }));
    }, _this._onSubmitSave = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _this._onClickDelete = function (event) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          modifierDetail = _this$props.modifierDetail;

      dispatch((0, _modifier.askDeleteModifier)(modifierDetail));
      // prevent form from submitting
      event.preventDefault();
      event.stopPropagation();
    }, _this._onCancel = function (e) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _modifier.onClickCancel)());
      e.preventDefault();
      e.stopPropagation();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModifierForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          modifier = _props.modifier,
          outlets = _props.outlets,
          isSubmittingForm = _props.isSubmittingForm;


      return React.createElement(
        'form',
        { className: _ModifierForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _ModifierForm2.default['content-wrapper'] },
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
              React.createElement(_LabelSection2.default, { title: 'modifier set' }),
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingField2.default,
                  name: 'name',
                  type: 'text',
                  placeholder: 'Name',
                  className: 'form-control'
                })
              )
            )
          ),
          React.createElement(_LabelSection2.default, { title: 'modifier options' }),
          React.createElement(_ModifierOptions2.default, null)
        ),
        React.createElement(
          _ActionBarDetailWrapper2.default,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            modifier.id && React.createElement(
              'button',
              { className: 'btn btn-danger', onClick: this._onClickDelete, disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' }),
              ' '
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default mr-10px', onClick: this._onCancel, disabled: isSubmittingForm },
              'Cancel'
            ),
            outlets.length > 1 && !modifier.id && React.createElement(
              'button',
              { className: 'btn btn-primary mr-10px', onClick: handleSubmit(this._onSubmitCreateAllOutlet), disabled: isSubmittingForm },
              'Save to All Outlet'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: handleSubmit(this._onSubmitSave), disabled: isSubmittingForm },
              'Save'
            )
          )
        ),
        React.createElement(_ModifierOptionsModal2.default, null)
      );
    }
  }]);
  return ModifierForm;
}(React.Component);

var mapForm = {
  form: 'modifier',
  touchOnBlur: false,
  touchOnChange: false,
  validate: validate,
  // TODO refactor
  // ni karena ada dua field yang sama ('options') di form dan modal,
  // kalo modalnya diclose, sama react bakal jadi 'unmounted'
  // dan kalo diunmount, redux form bakal destroy state reduxnya
  // akibatnya field yang ada di list options form bakal hilang validasinya
  // harusnya: dibikin dua field aja
  destroyOnUnmount: false
};

var selector = (0, _reduxForm.formValueSelector)('modifier');

function mapStateToProps(state) {
  var _state$library$modifi = state.library.modifier,
      modifierDetail = _state$library$modifi.modifierDetail,
      outlets = _state$library$modifi.outlets,
      isSubmittingForm = _state$library$modifi.isSubmittingForm;

  return {
    modifier: {
      id: selector(state, 'id')
    },
    modifierDetail: modifierDetail,
    outlets: outlets,
    isSubmittingForm: isSubmittingForm
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ModifierForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ModifierOptionsFieldArray = __webpack_require__(1490);

var _ModifierOptionsFieldArray2 = _interopRequireDefault(_ModifierOptionsFieldArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptions = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptions, _React$Component);

  function ModifierOptions() {
    (0, _classCallCheck3.default)(this, ModifierOptions);
    return (0, _possibleConstructorReturn3.default)(this, (ModifierOptions.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptions)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModifierOptions, [{
    key: 'render',
    value: function render() {
      return React.createElement(_reduxForm.FieldArray, {
        name: 'options',
        component: _ModifierOptionsFieldArray2.default
      });
    }
  }]);
  return ModifierOptions;
}(React.Component);

exports.default = ModifierOptions;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ModifierInputWithoutValidation = __webpack_require__(674);

var _ModifierInputWithoutValidation2 = _interopRequireDefault(_ModifierInputWithoutValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptionsField = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptionsField, _React$Component);

  function ModifierOptionsField() {
    (0, _classCallCheck3.default)(this, ModifierOptionsField);
    return (0, _possibleConstructorReturn3.default)(this, (ModifierOptionsField.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptionsField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModifierOptionsField, [{
    key: 'render',
    value: function render() {
      var member = this.props.member;

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-8' },
          React.createElement(_reduxForm.Field, {
            name: member + '.name',
            component: _ModifierInputWithoutValidation2.default,
            className: 'form-control',
            placeholder: 'Name'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-4' },
          React.createElement(_reduxForm.Field, {
            name: member + '.price',
            component: _ModifierInputWithoutValidation2.default,
            positiveNumberOnly: true,
            maxFractionDigits: 3,
            placeholder: 'Rp. 0',
            onChange: function onChange(e) {
              if (isNaN(e.target.value)) {
                e.preventDefault();
              }
            },
            className: 'form-control'
          })
        )
      );
    }
  }]);
  return ModifierOptionsField;
}(React.Component);

ModifierOptionsField.propTypes = {
  member: React.PropTypes.object
};

exports.default = ModifierOptionsField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ModifierOptionsField = __webpack_require__(1489);

var _ModifierOptionsField2 = _interopRequireDefault(_ModifierOptionsField);

var _modifier = __webpack_require__(102);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptionsFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptionsFieldArray, _React$Component);

  function ModifierOptionsFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModifierOptionsFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModifierOptionsFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptionsFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onClickManageOptions = function (e) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          modifier = _this$props.modifier;

      dispatch((0, _modifier.onClickManageModifierOptions)(modifier));
      e.stopPropagation();
      e.preventDefault();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModifierOptionsFieldArray, [{
    key: 'render',
    value: function render() {
      var fields = this.props.fields;

      return React.createElement(
        'div',
        { className: 'row' },
        fields.map(function (member, index) {
          return React.createElement(_ModifierOptionsField2.default, { member: member });
        }),
        React.createElement(
          'div',
          { className: 'form-group col-sm-12' },
          React.createElement(
            'button',
            { onClick: this._onClickManageOptions, className: 'btn btn-primary btn-block' },
            'Add or Manage Options'
          )
        )
      );
    }
  }]);
  return ModifierOptionsFieldArray;
}(React.Component);

function mapStateToProps(state) {
  return {
    modifier: (0, _reduxForm.getFormValues)('modifier')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModifierOptionsFieldArray);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _ModifierOptionsField = __webpack_require__(2189);

var _ModifierOptionsField2 = _interopRequireDefault(_ModifierOptionsField);

var _ModifierInputWithoutValidation = __webpack_require__(674);

var _ModifierInputWithoutValidation2 = _interopRequireDefault(_ModifierInputWithoutValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptionsField = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptionsField, _React$Component);

  function ModifierOptionsField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModifierOptionsField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModifierOptionsField.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptionsField)).call.apply(_ref, [this].concat(args))), _this), _this._onDelete = function () {
      _this.props.onDelete();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModifierOptionsField, [{
    key: 'render',
    value: function render() {
      var member = this.props.member;

      return React.createElement(
        'div',
        { className: 'mk-grouped-input' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-6' },
          React.createElement(_reduxForm.Field, {
            name: member + '.name',
            component: _ModifierInputWithoutValidation2.default,
            className: 'form-control',
            placeholder: 'Name'
          })
        ),
        React.createElement(
          'div',
          { className: 'form-group col-sm-5' },
          React.createElement(_reduxForm.Field, {
            name: member + '.price',
            component: _ModifierInputWithoutValidation2.default,
            positiveNumberOnly: true,
            maxFractionDigits: 3,
            placeholder: 'Rp. 0',
            onChange: function onChange(e) {
              if (isNaN(e.target.value)) {
                e.preventDefault();
              }
            },
            className: 'form-control'
          })
        ),
        React.createElement(
          'div',
          { className: 'col-sm-1', style: { marginTop: '7px' } },
          React.createElement(
            'span',
            { className: '' + _ModifierOptionsField2.default['btn-delete'],
              onClick: this._onDelete,
              type: 'button' },
            React.createElement('i', { className: 'fa fa-times-circle' })
          )
        )
      );
    }
  }]);
  return ModifierOptionsField;
}(React.Component);

ModifierOptionsField.propTypes = {
  member: React.PropTypes.object,
  onDelete: React.PropTypes.func
};

exports.default = ModifierOptionsField;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ModifierOptionsField = __webpack_require__(1491);

var _ModifierOptionsField2 = _interopRequireDefault(_ModifierOptionsField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptionsFieldArray = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptionsFieldArray, _React$Component);

  function ModifierOptionsFieldArray() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModifierOptionsFieldArray);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModifierOptionsFieldArray.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptionsFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this._onDelete = function (index) {
      var fields = _this.props.fields;

      fields.remove(index);
    }, _this._onClickAdd = function () {
      var fields = _this.props.fields;

      fields.push({
        name: null,
        price: null
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModifierOptionsFieldArray, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var fields = this.props.fields;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'form-group col-sm-12 mb-0px' },
          React.createElement(
            'button',
            { className: 'btn btn-primary btn-block', onClick: this._onClickAdd },
            'Add Options'
          )
        ),
        fields.map(function (member, index) {
          return React.createElement(_ModifierOptionsField2.default, { member: member, onDelete: function onDelete() {
              return _this2._onDelete(index);
            } });
        })
      );
    }
  }]);
  return ModifierOptionsFieldArray;
}(React.Component);

exports.default = ModifierOptionsFieldArray;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reduxForm = __webpack_require__(7);

var _ModifierOptionsFieldArray = __webpack_require__(1492);

var _ModifierOptionsFieldArray2 = _interopRequireDefault(_ModifierOptionsFieldArray);

var _reactRedux = __webpack_require__(6);

var _modifier = __webpack_require__(102);

var _ModifierOptionsModal = __webpack_require__(2190);

var _ModifierOptionsModal2 = _interopRequireDefault(_ModifierOptionsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierOptionsModal = function (_React$Component) {
  (0, _inherits3.default)(ModifierOptionsModal, _React$Component);

  function ModifierOptionsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModifierOptionsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModifierOptionsModal.__proto__ || (0, _getPrototypeOf2.default)(ModifierOptionsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onCancel = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          previousModifierForm = _this$props.previousModifierForm;

      dispatch((0, _modifier.onCancelManageModifierOptions)(previousModifierForm));
    }, _this._onSave = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          options = _this$props2.modifier.options;

      dispatch((0, _modifier.onConfirmManageModifierOptions)(options));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModifierOptionsModal, [{
    key: 'render',
    value: function render() {
      var showModifierOptionsModal = this.props.showModifierOptionsModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showModifierOptionsModal, onHide: this._onCancel, dialogClassName: 'modal-dialog ' + _ModifierOptionsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Add Option' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: 'modal-body ' + _ModifierOptionsModal2.default.body },
          React.createElement(_reduxForm.FieldArray, {
            name: 'options',
            component: _ModifierOptionsFieldArray2.default
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            React.createElement(
              'button',
              { className: 'btn btn-default', onClick: this._onCancel },
              'Cancel'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onSave },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return ModifierOptionsModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$modifi = state.library.modifier,
      showModifierOptionsModal = _state$library$modifi.showModifierOptionsModal,
      previousModifierForm = _state$library$modifi.previousModifierForm;

  return {
    showModifierOptionsModal: showModifierOptionsModal,
    previousModifierForm: previousModifierForm,
    modifier: (0, _reduxForm.getFormValues)('modifier')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModifierOptionsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Detail = __webpack_require__(1486);

var _Detail2 = _interopRequireDefault(_Detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Detail2.default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _List = __webpack_require__(2191);

var _List2 = _interopRequireDefault(_List);

var _modifier = __webpack_require__(102);

var actModifier = _interopRequireWildcard(_modifier);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _reduxForm = __webpack_require__(7);

var _confirmAction = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// noinspection JSUnresolvedVariable
var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (modifier) {
      var isDirtyModifier = _this.props.isDirtyModifier;

      if (isDirtyModifier) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actModifier.onClickRow(modifier)));
      } else {
        _this.props.dispatch(actModifier.onClickRow(modifier));
      }
    }, _this._onClickApplySetItem = function (e, modifier) {
      // we don't want the row to be clicked
      e.stopPropagation();
      e.preventDefault();
      var dispatch = _this.props.dispatch;

      dispatch(actModifier.onClickApplySetItem(modifier));
    }, _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          modifiers = _this$props.modifiers;

      dispatch(actModifier.modifiersRequest({ page: currentPage + 1 }, modifiers));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._renderOptionCell = function (modifier) {
      return modifier.active_options.map(function (opt, idx) {
        if (idx > 0) {
          return ', ' + opt.name;
        } else {
          return opt.name;
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          modifiers = _props.modifiers,
          modifierDetail = _props.modifierDetail;


      return modifiers.length > 0 && React.createElement(
        'div',
        { className: _List2.default['wrapper'] },
        React.createElement(
          'table',
          { className: _List2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _List2.default.name },
                'Modifier Set Name'
              ),
              React.createElement(
                'th',
                { className: _List2.default.option },
                'Options'
              ),
              React.createElement('th', { className: _List2.default.apply })
            )
          )
        ),
        React.createElement(
          'div',
          { className: _List2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { className: '' + _List2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                modifiers.length === 0 && React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    { colSpan: '5', style: { textAlign: 'center' } },
                    'No data to display'
                  )
                ),
                modifiers.length > 0 && modifiers.map(function (modifier) {
                  return React.createElement(
                    'tr',
                    { className: '' + (modifierDetail && modifier.id === modifierDetail.id ? _List2.default.selected : ''),
                      onClick: function onClick() {
                        return _this2._onClickRow(modifier);
                      } },
                    React.createElement(
                      'td',
                      { className: _List2.default.name },
                      modifier.name
                    ),
                    React.createElement(
                      'td',
                      { className: _List2.default.option },
                      _this2._renderOptionCell(modifier)
                    ),
                    React.createElement(
                      'td',
                      { className: _List2.default.apply },
                      React.createElement(
                        'a',
                        { className: 'btn btn-default', onClick: function onClick(e) {
                            _this2._onClickApplySetItem(e, modifier);
                          } },
                        'Apply Set Item'
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$modifi = state.library.modifier,
      modifiers = _state$library$modifi.modifiers,
      modifierDetail = _state$library$modifi.modifierDetail,
      currentPage = _state$library$modifi.currentPage,
      totalPage = _state$library$modifi.totalPage;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return {
    modifiers: modifiers,
    modifierDetail: modifierDetail,
    currentPage: currentPage,
    totalPage: totalPage,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    isDirtyModifier: (0, _reduxForm.isDirty)('modifier')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  modifiers: React.PropTypes.array,
  modifierDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1482);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _pages = __webpack_require__(38);

var _List = __webpack_require__(1495);

var _List2 = _interopRequireDefault(_List);

var _Detail = __webpack_require__(1494);

var _Detail2 = _interopRequireDefault(_Detail);

var _ApplySetItemModal = __webpack_require__(1483);

var _ApplySetItemModal2 = _interopRequireDefault(_ApplySetItemModal);

var _modifier = __webpack_require__(102);

var _reactRedux = __webpack_require__(6);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _modifier2 = __webpack_require__(297);

var mpLibraryModifier = _interopRequireWildcard(_modifier2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modifier = function (_React$Component) {
  (0, _inherits3.default)(Modifier, _React$Component);

  function Modifier() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Modifier);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modifier.__proto__ || (0, _getPrototypeOf2.default)(Modifier)).call.apply(_ref, [this].concat(args))), _this), _this._onHideModal = function () {
      _this.props.dispatch((0, _modifier.cancelDeleteModifier)());
    }, _this._onDelete = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          deletedModifier = _this$props.deletedModifier,
          modifiers = _this$props.modifiers;

      mpLibraryModifier.libraryModifierDelete({ name: deletedModifier.name, options: deletedModifier.active_options });
      dispatch((0, _modifier.deleteModifier)(deletedModifier.id, modifiers));
    }, _this._onSubmitApplySetItem = function (values) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          modifiers = _this$props2.modifiers;

      var properties = {};
      _lodash2.default.forEach(modifiers, function (modifier) {
        if (modifier.id === values.id) {
          properties = {
            name: modifier.name,
            options: _lodash2.default.map(modifier.active_options, 'id'),
            itemNames: values.itemIds
          };
        }
      });
      mpLibraryModifier.libraryModifierApplyToItems(properties);
      dispatch((0, _modifier.confirmApplySetItem)({ item_ids: values.itemIds }, values.id));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Modifier, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteModifierModal = _props.showDeleteModifierModal,
          deletedModifier = _props.deletedModifier,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          modifiers = _props.modifiers;

      var modifierName = deletedModifier ? deletedModifier.name : '';
      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: modifiers.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_Detail2.default, null)
          )
        ),
        React.createElement(_ApplySetItemModal2.default, { onSubmit: this._onSubmitApplySetItem }),
        React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: showDeleteModifierModal,
          onHide: this._onHideModal,
          title: 'Modifier',
          name: modifierName,
          onDelete: this._onDelete
        }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          expired = _props2.expired;

      if (!expired) {
        dispatch((0, _modifier.pageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          // this is still hacky, don't copy paste this
          if (_this2.props.isDirtyModifier && !_this2.props.nextAction) {
            dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Modifier;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$modifi = state.library.modifier,
      showDeleteModifierModal = _state$library$modifi.showDeleteModifierModal,
      modifiers = _state$library$modifi.modifiers,
      deletedModifier = _state$library$modifi.deletedModifier,
      openRightColumn = _state$library$modifi.openRightColumn;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;

  return {
    isDirtyModifier: (0, _reduxForm.isDirty)('modifier')(state),
    nextAction: state.confirmAction.nextAction,
    showDeleteModifierModal: showDeleteModifierModal,
    modifiers: modifiers,
    deletedModifier: deletedModifier,
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    expired: expired
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Modifier);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2192);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _tax = __webpack_require__(112);

var _confirmAction = __webpack_require__(29);

var _isEqual2 = __webpack_require__(547);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _without2 = __webpack_require__(269);

var _without3 = _interopRequireDefault(_without2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCreateTax = function () {
      var _this$props = _this.props,
          isDirtyTax = _this$props.isDirtyTax,
          dispatch = _this$props.dispatch,
          taxDetail = _this$props.taxDetail,
          taxAssignToItem = _this$props.taxAssignToItem;


      var isDirtyAssign = false; // do our own dirty checking
      if (taxAssignToItem && taxDetail) {
        var initialItemIds = (0, _without3.default)((0, _map3.default)(taxDetail.loaded_items, 'item_id'), undefined);
        var currentItemIds = taxAssignToItem.values.itemIds;
        isDirtyAssign = !(0, _isEqual3.default)(initialItemIds.sort(), currentItemIds.sort());
      }

      if (isDirtyTax || isDirtyAssign) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _tax.onClickCreateTax)()));
      } else {
        dispatch((0, _tax.onClickCreateTax)());
      }
    }, _this._onChangeOutletIds = function (outletIds) {
      var _this$props2 = _this.props,
          isDirtyTax = _this$props2.isDirtyTax,
          dispatch = _this$props2.dispatch,
          taxDetail = _this$props2.taxDetail,
          taxAssignToItem = _this$props2.taxAssignToItem;


      var isDirtyAssign = false; // do our own dirty checking
      if (taxAssignToItem && taxDetail) {
        var initialItemIds = (0, _without3.default)((0, _map3.default)(taxDetail.loaded_items, 'item_id'), undefined);
        var currentItemIds = taxAssignToItem.values.itemIds;
        isDirtyAssign = !(0, _isEqual3.default)(initialItemIds.sort(), currentItemIds.sort());
      }

      if (isDirtyTax || isDirtyAssign) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _tax.onChangeOutletIds)(outletIds)));
      } else {
        dispatch((0, _tax.onChangeOutletIds)(outletIds));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;


      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-4 col-xs-12' },
            React.createElement(_reduxForm.Field, {
              name: 'outletIds',
              component: _DropdownOutlet2.default,
              outlets: outlets,
              onChangeOutletIds: this._onChangeOutletIds
            })
          ),
          React.createElement(
            'div',
            { className: 'col-sm-8 hidden-xs' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-primary', onClick: this._onClickCreateTax },
                'Create Tax'
              )
            )
          )
        )
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      outlets = _state$library$tax.outlets,
      taxDetail = _state$library$tax.taxDetail;
  var taxAssignToItem = state.form.taxAssignToItem;

  var isDirtyTax = (0, _reduxForm.isDirty)('tax')(state);
  return {
    outlets: outlets,
    isDirtyTax: isDirtyTax,
    taxDetail: taxDetail,
    taxAssignToItem: taxAssignToItem
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _style = __webpack_require__(2193);

var _style2 = _interopRequireDefault(_style);

var _tax = __webpack_require__(112);

var actTax = _interopRequireWildcard(_tax);

var _confirmAction = __webpack_require__(29);

var _reduxForm = __webpack_require__(7);

var _isEqual2 = __webpack_require__(547);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _without2 = __webpack_require__(269);

var _without3 = _interopRequireDefault(_without2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          currentPage = _this$props.currentPage,
          taxes = _this$props.taxes;

      dispatch(actTax.taxesRequest({ page: currentPage + 1 }, taxes));
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      return currentPage < totalPage;
    }, _this._onClickRow = function (tax) {
      var _this$props3 = _this.props,
          isDirtyTax = _this$props3.isDirtyTax,
          taxDetail = _this$props3.taxDetail,
          taxAssignToItem = _this$props3.taxAssignToItem;

      var isDirtyAssign = false;
      if (taxAssignToItem && taxDetail) {
        var initialItemIds = (0, _without3.default)((0, _map3.default)(taxDetail.loaded_items, 'item_id'), undefined);
        var currentItemIds = taxAssignToItem.values.itemIds;
        isDirtyAssign = !(0, _isEqual3.default)(initialItemIds.sort(), currentItemIds.sort());
      }

      if (isDirtyTax || isDirtyAssign) {
        _this.props.dispatch((0, _confirmAction.askConfirmAction)(actTax.onClickRow(tax)));
      } else {
        _this.props.dispatch(actTax.onClickRow(tax));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          taxes = _props.taxes,
          taxDetail = _props.taxDetail;


      return taxes && taxes.length > 0 && React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(
          'table',
          { className: _style2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _style2.default.name },
                'Name'
              ),
              React.createElement(
                'th',
                { className: _style2.default.amount },
                'Amount'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _style2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false },
            React.createElement(
              'table',
              { className: _style2.default['table-content'] },
              React.createElement(
                'tbody',
                null,
                taxes.map(function (tax) {
                  return React.createElement(
                    'tr',
                    { className: '' + (taxDetail && tax.id === taxDetail.id ? _style2.default.selected : ''),
                      onClick: function onClick() {
                        return _this2._onClickRow(tax);
                      } },
                    React.createElement(
                      'td',
                      { className: _style2.default.name },
                      tax.name
                    ),
                    React.createElement(
                      'td',
                      { className: _style2.default.amount },
                      tax.amount,
                      ' %'
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return List;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      taxes = _state$library$tax.taxes,
      currentPage = _state$library$tax.currentPage,
      totalPage = _state$library$tax.totalPage,
      taxDetail = _state$library$tax.taxDetail;
  var taxAssignToItem = state.form.taxAssignToItem;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  var isDirtyTax = (0, _reduxForm.isDirty)('tax')(state);
  return {
    taxes: taxes,
    currentPage: currentPage,
    totalPage: totalPage,
    taxDetail: taxDetail,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    isDirtyTax: isDirtyTax,
    taxAssignToItem: taxAssignToItem
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  taxes: React.PropTypes.array,
  taxDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _SaveToAllOutletsModal = __webpack_require__(2194);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _tax = __webpack_require__(112);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveToAllOutletsModal = function (_React$Component) {
  (0, _inherits3.default)(SaveToAllOutletsModal, _React$Component);

  function SaveToAllOutletsModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SaveToAllOutletsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SaveToAllOutletsModal.__proto__ || (0, _getPrototypeOf2.default)(SaveToAllOutletsModal)).call.apply(_ref, [this].concat(args))), _this), _this._onClickDone = function () {
      _this.props.dispatch((0, _tax.hideSaveToAllOutletsModal)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SaveToAllOutletsModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showSaveToAllOutletsModal = _props.showSaveToAllOutletsModal,
          createdOutlets = _props.createdOutlets;


      return React.createElement(
        _reactBootstrap.Modal,
        { show: showSaveToAllOutletsModal, backdrop: 'static', onHide: this._onClickDone, dialogClassName: 'modal-dialog ' + _SaveToAllOutletsModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Save to All Outlets' }),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'div',
            { className: _SaveToAllOutletsModal2.default['sub-title'] },
            'Tax successfully saved to:'
          ),
          createdOutlets && createdOutlets.outletsSuccess.map(function (outlet) {
            return React.createElement(
              'div',
              { className: _SaveToAllOutletsModal2.default['block-outlets'] },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-md-11' },
                  outlet.name
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-1' },
                  React.createElement('i', { className: 'fa fa-check-circle' })
                )
              )
            );
          })
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          createdOutlets && createdOutlets.outletsFailed.length > 0 && React.createElement(
            'span',
            { className: _SaveToAllOutletsModal2.default['failed-all-outlets'] },
            'One or more items does not exist in another outlet'
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-primary', onClick: this._onClickDone },
              'Done'
            )
          )
        )
      );
    }
  }]);
  return SaveToAllOutletsModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      showSaveToAllOutletsModal = _state$library$tax.showSaveToAllOutletsModal,
      createdOutlets = _state$library$tax.createdOutlets;

  return {
    showSaveToAllOutletsModal: showSaveToAllOutletsModal,
    createdOutlets: createdOutlets
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SaveToAllOutletsModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1497);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _List = __webpack_require__(1498);

var _List2 = _interopRequireDefault(_List);

var _TaxDetail = __webpack_require__(1504);

var _TaxDetail2 = _interopRequireDefault(_TaxDetail);

var _reactRedux = __webpack_require__(6);

var _tax = __webpack_require__(112);

var _LibraryDeleteModal = __webpack_require__(148);

var _LibraryDeleteModal2 = _interopRequireDefault(_LibraryDeleteModal);

var _confirmAction = __webpack_require__(29);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _reactRouterRedux = __webpack_require__(49);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _pages = __webpack_require__(38);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _SaveToAllOutletsModal = __webpack_require__(1499);

var _SaveToAllOutletsModal2 = _interopRequireDefault(_SaveToAllOutletsModal);

var _TaxAssignToItemModal = __webpack_require__(1503);

var _TaxAssignToItemModal2 = _interopRequireDefault(_TaxAssignToItemModal);

var _tax2 = __webpack_require__(247);

var mpLibraryTax = _interopRequireWildcard(_tax2);

var _isEqual2 = __webpack_require__(547);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _without2 = __webpack_require__(269);

var _without3 = _interopRequireDefault(_without2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tax = function (_React$Component) {
  (0, _inherits3.default)(Tax, _React$Component);

  function Tax() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tax);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tax.__proto__ || (0, _getPrototypeOf2.default)(Tax)).call.apply(_ref, [this].concat(args))), _this), _this._onDelete = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          taxes = _this$props.taxes,
          deletedTax = _this$props.deletedTax,
          taxDetail = _this$props.taxDetail,
          categories = _this$props.categories;

      dispatch((0, _tax.deleteTax)(deletedTax.id, taxes, taxDetail, categories));
    }, _this._onHideModal = function () {
      _this.props.dispatch((0, _tax.cancelDelete)());
    }, _this._onSubmitTaxAssignToItem = function (values) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          taxDetail = _this$props2.taxDetail,
          tax = _this$props2.tax;

      if (taxDetail.id === null) {
        mpLibraryTax.libraryTaxCreateAssignItemApply(taxDetail);
      } else {
        mpLibraryTax.libraryTaxEditAssignItemApply(taxDetail);
      }
      dispatch((0, _tax.confirmTaxAssignToItem)(taxDetail, tax));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tax, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showDeleteModal = _props.showDeleteModal,
          deletedTax = _props.deletedTax,
          openRightColumn = _props.openRightColumn,
          showLoadingSpinnerPage = _props.showLoadingSpinnerPage,
          taxes = _props.taxes;

      var taxName = deletedTax ? deletedTax.name : '';

      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, null),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: taxes.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_List2.default, null)
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_TaxDetail2.default, null)
          )
        ),
        React.createElement(_TaxAssignToItemModal2.default, { onSubmit: this._onSubmitTaxAssignToItem }),
        React.createElement(_SaveToAllOutletsModal2.default, null),
        React.createElement(_LibraryDeleteModal2.default, {
          showDeleteModal: showDeleteModal,
          onHide: this._onHideModal,
          title: 'Tax',
          name: taxName,
          onDelete: this._onDelete
        }),
        React.createElement(_ConfirmActionModal2.default, null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.expired;

      if (!expired) {
        this.props.dispatch((0, _tax.taxesPageRequest)());
        _reactRouter.browserHistory.listenBefore(function (location) {
          var taxDetail = _this2.props.taxDetail;
          var taxAssignToItem = _this2.props.taxAssignToItem;

          var isDirtyAssign = false;
          if (taxAssignToItem && taxDetail) {
            var initialItemIds = (0, _without3.default)((0, _map3.default)(taxDetail.loaded_items, 'item_id'), undefined);
            var currentItemIds = taxAssignToItem.values.itemIds;
            isDirtyAssign = !(0, _isEqual3.default)(initialItemIds.sort(), currentItemIds.sort());
          } else {} // Do nothing


          // this is still hacky, don't copy paste this
          if ((_this2.props.isDirtyTax || isDirtyAssign) && !_this2.props.nextAction) {
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location)));
            return false;
          }
        });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);
  return Tax;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      taxes = _state$library$tax.taxes,
      taxDetail = _state$library$tax.taxDetail,
      showDeleteModal = _state$library$tax.showDeleteModal,
      deletedTax = _state$library$tax.deletedTax,
      openRightColumn = _state$library$tax.openRightColumn,
      setting = _state$library$tax.setting,
      categories = _state$library$tax.categories,
      taxAssignToItems = _state$library$tax.taxAssignToItems;
  var _state$form = state.form,
      taxAssignToItem = _state$form.taxAssignToItem,
      tax = _state$form.tax;

  var isDirtyTax = (0, _reduxForm.isDirty)('tax')(state);
  var nextAction = state.confirmAction.nextAction;
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;
  var expired = state.subscriptionExpired.expired;

  return {
    taxes: taxes,
    taxDetail: taxDetail,
    showDeleteModal: showDeleteModal,
    deletedTax: deletedTax,
    isDirtyTax: isDirtyTax,
    nextAction: nextAction,
    openRightColumn: openRightColumn,
    showLoadingSpinnerPage: showLoadingSpinnerPage,
    expired: expired,
    setting: setting,
    categories: categories,
    taxAssignToItems: taxAssignToItems,
    taxAssignToItem: taxAssignToItem,
    tax: tax
    // state
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Tax);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _Items = __webpack_require__(2195);

var _Items2 = _interopRequireDefault(_Items);

var _reduxForm = __webpack_require__(7);

var _tax = __webpack_require__(112);

var _intersection2 = __webpack_require__(2481);

var _intersection3 = _interopRequireDefault(_intersection2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Items = function (_React$Component) {
  (0, _inherits3.default)(Items, _React$Component);

  function Items() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Items);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Items.__proto__ || (0, _getPrototypeOf2.default)(Items)).call.apply(_ref, [this].concat(args))), _this), _this._itemsAssigned = function () {
      var _this$props = _this.props,
          itemIds = _this$props.taxAssignToItem.itemIds,
          taxDetail = _this$props.taxDetail;
      // const {items} = this.props // the loaded items

      var categoryId = _this.props.taxAssignToItem.category_id;
      var keyword = _this.props.taxAssignToItem.keyword;
      if (!keyword && categoryId === 0) {
        return itemIds.length;
      } else if (categoryId !== 0 && !keyword) {
        var temp = taxDetail.items.filter(function (item) {
          return item.category_id === categoryId;
        }); // make a copy
        var itemsAsId = (0, _map3.default)(temp, 'item_id');
        return itemsAsId.length;
      } else if (categoryId === 0 && !keyword) {
        var re = new RegExp(keyword, 'i');
        var _temp2 = taxDetail.items.filter(function (item) {
          return item.name.search(re) !== -1;
        }); // make a copy
        var _itemsAsId = (0, _map3.default)(_temp2, 'item_id');
        return _itemsAsId.length;
      } else {
        // have keyword & category
        var _re = new RegExp(keyword, 'i');
        var _temp3 = taxDetail.items.filter(function (item) {
          return item.category_id === categoryId && item.name.search(_re) !== -1;
        }); // make a copy
        var _itemsAsId2 = (0, _map3.default)(_temp3, 'item_id');
        return _itemsAsId2.length;
      }
    }, _this._allChecked = function (isAdd, itemId) {
      var dispatch = _this.props.dispatch;

      if (isAdd === false) {
        dispatch((0, _tax.uncheckSelectAllTaxItems)());
      } else {
        var itemIds = _this.props.taxAssignToItem.itemIds;
        var items = _this.props.items; // the loaded items

        var itemsAsId = (0, _map3.default)(items, 'id');
        var temp = itemIds.filter(function (item) {
          return true;
        }); // make a copy of the array for temporary use

        if (itemId !== undefined) temp.push(itemId);

        var intersect = (0, _intersection3.default)(itemsAsId, temp);
        if (intersect.length === itemsAsId.length) {
          dispatch((0, _tax.checkSelectAllTaxItems)());
        } else {
          dispatch((0, _tax.uncheckSelectAllTaxItems)());
        }
      }
    }, _this._hasMore = function () {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          totalPage = _this$props2.totalPage;

      var ret = currentPage < totalPage;
      return ret;
    }, _this._onReachBottom = function () {
      var _this$props3 = _this.props,
          currentPage = _this$props3.currentPage,
          totalPage = _this$props3.totalPage,
          _this$props3$taxAssig = _this$props3.taxAssignToItem,
          itemIds = _this$props3$taxAssig.itemIds,
          keyword = _this$props3$taxAssig.keyword,
          category_id = _this$props3$taxAssig.category_id,
          items = _this$props3.items,
          dispatch = _this$props3.dispatch;

      if (currentPage < totalPage) {
        dispatch((0, _tax.taxAssignToItemItemsRequest)({ keyword: keyword, page: currentPage + 1, with_batch: true, categoryId: category_id, itemIds: itemIds }, items));
      }
    }, _this._selectAllNone = function (e, selectAll) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props4 = _this.props,
          _this$props4$taxAssig = _this$props4.taxAssignToItem,
          itemIds = _this$props4$taxAssig.itemIds,
          category_id = _this$props4$taxAssig.category_id,
          keyword = _this$props4$taxAssig.keyword,
          dispatch = _this$props4.dispatch,
          taxDetail = _this$props4.taxDetail,
          outletIds = _this$props4.outletIds,
          setting = _this$props4.setting; // the selected category or all

      var businessId = setting.business_id;
      var outletId = outletIds[0];
      dispatch((0, _tax.taxAssignToItemSelectAllNone)(businessId, outletId, taxDetail, itemIds, category_id, keyword, selectAll));
      if (selectAll) {
        dispatch((0, _tax.checkSelectAllTaxItems)());
      } else {
        dispatch((0, _tax.uncheckSelectAllTaxItems)());
      }
    }, _this._onTextClick = function (e, item) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props5 = _this.props,
          itemIds = _this$props5.taxAssignToItem.itemIds,
          dispatch = _this$props5.dispatch,
          taxDetail = _this$props5.taxDetail;

      var found = itemIds.find(function (element) {
        return element === item.id;
      });
      if (found === undefined) {
        // unchecked so add
        dispatch((0, _tax.taxAssignToItemToggleOne)(taxDetail, item, true)); // add to taxDetail.items
        dispatch((0, _reduxForm.arrayPush)('taxAssignToItem', 'itemIds', item.id));
        _this._allChecked(true, item.id);
      } else {
        // checked so remove
        var newItemIds = itemIds.filter(function (element) {
          return element !== item.id;
        });
        dispatch((0, _tax.taxAssignToItemToggleOne)(taxDetail, item, false)); // remove from taxDetail.items
        dispatch((0, _reduxForm.change)('taxAssignToItem', 'itemIds', newItemIds));
        _this._allChecked(false, item.id);
      }
    }, _this._onChangeCheckbox = function (e, item) {
      var _this$props6 = _this.props,
          itemIds = _this$props6.taxAssignToItem.itemIds,
          dispatch = _this$props6.dispatch,
          taxDetail = _this$props6.taxDetail;

      var indexPositions = {};

      // find index of the item being checked / unchecked
      itemIds.forEach(function (itemId, index) {
        if (itemId === item.id) {
          indexPositions[index] = true;
        }
      });
      if (e.target.checked) {
        dispatch((0, _tax.taxAssignToItemToggleOne)(taxDetail, item, true)); // add to taxDetail.items
        dispatch((0, _reduxForm.arrayPush)('taxAssignToItem', 'itemIds', item.id));
        _this._allChecked(true, item.id);
      } else {
        // remove all if exists (don't know why server has more than one
        var newItemIds = [];
        itemIds.forEach(function (itemId, index) {
          // rebuild...
          if (!indexPositions[index]) {
            newItemIds.push(itemId);
          }
        });
        dispatch((0, _tax.taxAssignToItemToggleOne)(taxDetail, item, false)); // remove from taxDetail.items
        dispatch((0, _reduxForm.change)('taxAssignToItem', 'itemIds', newItemIds));
        _this._allChecked(false, item.id);
      }
    }, _this._checked = function (targetItem) {
      var itemIds = _this.props.taxAssignToItem.itemIds;

      var checked = false;
      itemIds.forEach(function (itemId) {
        checked = checked || itemId === targetItem.id;
      });
      return checked;
    }, _this._gotoLibraryItems = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props7 = _this.props,
          dispatch = _this$props7.dispatch,
          taxDetail = _this$props7.taxDetail;

      var url = '/library/list';
      // close the modal, url decides if moving to another route, if empty, then no browserHistory.push is done
      dispatch((0, _tax.cancelTaxAssignToItem)(taxDetail, url));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Items, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._allChecked(true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items;

      if (items.length > 0) {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'row ' + _Items2.default['row-wrapper-first'] },
            React.createElement(
              'div',
              { className: 'col-xs-7 ' + _Items2.default['item-assign-all-result-header'] },
              this._itemsAssigned(),
              ' items assigned'
            ),
            React.createElement('div', { className: 'col-xs-1 ' + _Items2.default['item-assign-all-result-header'] }),
            React.createElement(
              'div',
              { className: 'col-xs-4 ' + _Items2.default['item-checkbox-header'] },
              this.props.checkSelectAllTaxItemsFlag ? React.createElement(
                'a',
                { href: '#', onClick: function onClick(e) {
                    return _this2._selectAllNone(e, false);
                  } },
                'Deselect All'
              ) : React.createElement(
                'a',
                { href: '#', onClick: function onClick(e) {
                    return _this2._selectAllNone(e, true);
                  } },
                'Select All'
              )
              // <input type='checkbox' checked={this.props.checkSelectAllTaxItemsFlag} onChange={(e) => this._selectAllNone(e, e.target.checked)} />

            )
          ),
          React.createElement(
            'div',
            { className: _Items2.default.wrapper },
            React.createElement(
              _reactInfiniteScroller2.default,
              {
                pageStart: 1,
                loadMore: this._onReachBottom,
                hasMore: this._hasMore(),
                useWindow: false,
                threshold: 10,
                initialLoad: false
              },
              items.map(function (item, idx) {
                return React.createElement(
                  'div',
                  { className: 'row ' + _Items2.default['row-wrapper'] },
                  React.createElement(
                    'div',
                    { className: 'col-xs-7 ' + _Items2.default['item-name-wrapper'] },
                    React.createElement(
                      'a',
                      { href: '#', onClick: function onClick(e) {
                          return _this2._onTextClick(e, item);
                        } },
                      item.name
                    )
                  ),
                  React.createElement('div', { className: 'col-xs-1 ' + _Items2.default['item-name-wrapper'] }),
                  React.createElement(
                    'div',
                    { className: 'col-xs-4 ' + _Items2.default['item-checkbox-wrapper'] },
                    React.createElement(
                      'div',
                      { className: 'checkbox ' + _Items2.default['checkbox-moka'] },
                      React.createElement('input', { type: 'checkbox', checked: _this2._checked(item), onChange: function onChange(e) {
                          return _this2._onChangeCheckbox(e, item);
                        } }),
                      React.createElement('label', null)
                    )
                  )
                );
              })
            )
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: _Items2.default['text-notif'] },
          'No Items Found. Go to ',
          React.createElement(
            'a',
            { href: '#', onClick: this._gotoLibraryItems },
            'items page'
          ),
          ' to manage items.'
        );
      }
    }
  }]);
  return Items;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('taxAssignToItem');

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      _state$library$tax$ta = _state$library$tax.taxAssignToItems,
      items = _state$library$tax$ta.items,
      currentPage = _state$library$tax$ta.currentPage,
      totalPage = _state$library$tax$ta.totalPage,
      taxDetail = _state$library$tax.taxDetail,
      checkSelectAllTaxItemsFlag = _state$library$tax.checkSelectAllTaxItemsFlag,
      setting = _state$library$tax.setting;
  /* Please leave this here for now
    const {outlets} = state.library.tax
    let outletIds = []
    if (outlets.length) {
      outletIds.push(outlets[0].id)
    }
    if (state.form.search.values !== undefined) {
      outletIds = state.form.search.values.outletIds
    }
  */

  var outletIds = state.form.search.values.outletIds;

  return {
    taxDetail: taxDetail,
    taxAssignToItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword'),
      category_id: selector(state, 'category_id')
    },
    items: items,
    currentPage: currentPage,
    totalPage: totalPage,
    checkSelectAllTaxItemsFlag: checkSelectAllTaxItemsFlag,
    outletIds: outletIds,
    setting: setting
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Items);

// applySetItem -> taxAssignToItem
// applySetItemItemsRequest -> taxAssignToItemItemsRequest
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _SearchForm = __webpack_require__(2196);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _reactRedux = __webpack_require__(6);

var _tax = __webpack_require__(112);

var _reactSelect = __webpack_require__(145);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderSelectField = function (_React$Component) {
  (0, _inherits3.default)(RenderSelectField, _React$Component);

  function RenderSelectField(props) {
    (0, _classCallCheck3.default)(this, RenderSelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderSelectField.__proto__ || (0, _getPrototypeOf2.default)(RenderSelectField)).call(this, props));

    _this.onChangeSelect = function (newval) {
      // const {input: {value, onChange}, meta: {dispatch}, options, categories} = this.props
      var onChange = _this.props.input.onChange;

      onChange(newval.value);
    };

    _this.state = {
      selectInstance: 1 // TOREMOVE TODELETE
    };
    return _this;
  }

  (0, _createClass3.default)(RenderSelectField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.input.value,
          placeholder = _props.placeholder,
          options = _props.options;

      if (value === '') {
        value = 0; // for initial when value not specified, set all All Categories
      }
      var selectProps = {
        // TODELETE addLabelText: '{label} (create new)',
        value: value,
        className: _SearchForm2.default['select-dropdown'],
        placeholder: placeholder,
        onChange: this.onChangeSelect,
        options: options,
        clearable: false,
        backspaceRemoves: false,
        // TODELETE promptTextCreator: (label) => (`${label} (create new)`),
        onClose: function onClose() {
          _this2.setState({ selectInstance: 1 - _this2.state.selectInstance });
        }
      };
      return React.createElement(
        'span',
        null,
        React.createElement(_reactSelect2.default, selectProps)
      );
    }
  }]);
  return RenderSelectField;
}(React.Component);

var Search = function (_React$Component2) {
  (0, _inherits3.default)(Search, _React$Component2);

  function Search() {
    var _ref;

    var _temp, _this3, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref, [this].concat(args))), _this3), _this3._formatCategories = function (categories) {
      var formatCategory = [];
      formatCategory.push({ value: 0, label: 'All Categories' }); // create All Categories
      categories.map(function (category) {
        if (category.id > 0) {
          formatCategory.push({ value: category.id, label: category.name });
        }
      });
      return formatCategory;
    }, _this3._onChangeFilterKeyword = function (event, keyword) {
      var _this3$props = _this3.props,
          taxAssignToItem = _this3$props.taxAssignToItem,
          dispatch = _this3$props.dispatch;

      dispatch((0, _reduxForm.change)('taxAssignToItem', 'keyword', keyword));
      dispatch((0, _tax.taxAssignToItemItemsRequest)({ page: 1, keyword: keyword, with_batch: true, categoryId: taxAssignToItem.category_id, itemIds: taxAssignToItem.itemIds }, []));
    }, _this3._onChangeFilterCategory = function (event, categoryId) {
      var _this3$props2 = _this3.props,
          itemIds = _this3$props2.taxAssignToItem.itemIds,
          dispatch = _this3$props2.dispatch;

      dispatch((0, _reduxForm.change)('taxAssignToItem', 'category_id', categoryId));
      dispatch((0, _reduxForm.change)('taxAssignToItem', 'keyword', '')); // reset the keyword, taxAssignToItem.keyword to ''
      dispatch((0, _tax.taxAssignToItemItemsRequest)({ page: 1, keyword: '', with_batch: true, categoryId: categoryId, itemIds: itemIds }, []));
      // mpItemList.libraryItemChangeFilter({ category: categoryId }) // for reference for now.
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(Search, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // initialize each time it opens
      var dispatch = this.props.dispatch;
      // dispatch(change('taxAssignToItem', 'category_id', 0)) // No need will be set by action

      dispatch((0, _reduxForm.change)('taxAssignToItem', 'keyword', ''));
    }
  }, {
    key: 'render',
    value: function render() {
      var categories = this.props.categories;

      return React.createElement(
        'div',
        { className: 'row ' + _SearchForm2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-md-4 ' + _SearchForm2.default['search-select'] },
          React.createElement(
            'div',
            { className: 'form-group' },
            React.createElement(_reduxForm.Field, {
              component: RenderSelectField,
              className: 'selectCategories',
              name: 'category_id',
              options: this._formatCategories(categories),
              categories: categories,
              onChange: this._onChangeFilterCategory,
              placeholder: 'Select an option'
            })
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-8' },
          React.createElement(
            'div',
            { className: 'right-inner-addon' },
            React.createElement('i', { className: 'fa fa-search' }),
            React.createElement(_reduxForm.Field, {
              component: 'input',
              name: 'keyword',
              className: 'form-control',
              placeholder: 'Search items',
              onChange: this._onChangeFilterKeyword,
              value: ''
            })
          )
        )
      );
    }
  }]);
  return Search;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('taxAssignToItem');

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      _state$library$tax$ta = _state$library$tax.taxAssignToItems,
      items = _state$library$tax$ta.items,
      currentPage = _state$library$tax$ta.currentPage,
      totalPage = _state$library$tax$ta.totalPage,
      taxDetail = _state$library$tax.taxDetail,
      categories = _state$library$tax.categories,
      checkSelectAllTaxItemsFlag = _state$library$tax.checkSelectAllTaxItemsFlag;

  return {
    taxDetail: taxDetail,
    taxAssignToItem: {
      itemIds: selector(state, 'itemIds'),
      keyword: selector(state, 'keyword'),
      category_id: selector(state, 'category_id')
    },
    items: items,
    currentPage: currentPage,
    totalPage: totalPage,
    categories: categories,
    checkSelectAllTaxItemsFlag: checkSelectAllTaxItemsFlag
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _ModalHeader = __webpack_require__(53);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _reactRedux = __webpack_require__(6);

var _Search = __webpack_require__(1502);

var _Search2 = _interopRequireDefault(_Search);

var _Items = __webpack_require__(1501);

var _Items2 = _interopRequireDefault(_Items);

var _reduxForm = __webpack_require__(7);

var _tax = __webpack_require__(112);

var _TaxAssignToItemModal = __webpack_require__(2197);

var _TaxAssignToItemModal2 = _interopRequireDefault(_TaxAssignToItemModal);

var _tax2 = __webpack_require__(247);

var mpLibraryTax = _interopRequireWildcard(_tax2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'

var TaxAssignToItemModal = function (_React$Component) {
  (0, _inherits3.default)(TaxAssignToItemModal, _React$Component);

  function TaxAssignToItemModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaxAssignToItemModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaxAssignToItemModal.__proto__ || (0, _getPrototypeOf2.default)(TaxAssignToItemModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          taxDetail = _this$props.taxDetail;

      if (taxDetail.id === null) {
        mpLibraryTax.libraryTaxCreateAssignItemCancel();
      } else {
        mpLibraryTax.libraryTaxEditAssignItemCancel();
      }
      dispatch((0, _tax.cancelTaxAssignToItem)(taxDetail, ''));
    }, _this._VisibleItemCount = function () {
      if (_this.props.items !== undefined && _this.props.taxAssignToItems !== undefined && _this.props.items.length > 0) {
        return React.createElement(
          'span',
          null,
          React.createElement(
            'b',
            null,
            '1-',
            _this.props.items.length
          ),
          ' of ',
          React.createElement(
            'b',
            null,
            _this.props.taxAssignToItems.totalCount
          )
        );
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TaxAssignToItemModal, [{
    key: 'render',
    value: function render() {
      var showTaxAssignToItemModal = this.props.showTaxAssignToItemModal;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: showTaxAssignToItemModal, onHide: this._onHide, backdrop: 'static', dialogClassName: 'modal-dialog ' + _TaxAssignToItemModal2.default.dialog },
        React.createElement(_ModalHeader2.default, { title: 'Assign Items' }),
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'id' }),
          React.createElement(_reduxForm.Field, { component: 'input', type: 'hidden', name: 'itemIds' }),
          React.createElement(
            _reactBootstrap.Modal.Body,
            { bsClass: _TaxAssignToItemModal2.default.body + ' modal-body' },
            React.createElement(_Search2.default, null),
            React.createElement(_Items2.default, null)
          ),
          React.createElement(
            _reactBootstrap.Modal.Footer,
            null,
            React.createElement(
              'span',
              { className: 'pull-left' },
              this._VisibleItemCount()
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              React.createElement(
                'button',
                { className: 'btn btn-default', onClick: this._onHide },
                'Cancel'
              ),
              React.createElement(
                'button',
                { className: 'btn btn-primary' },
                'Apply'
              )
            )
          )
        )
      );
    }
  }]);
  return TaxAssignToItemModal;
}(React.Component);

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      showTaxAssignToItemModal = _state$library$tax.showTaxAssignToItemModal,
      categories = _state$library$tax.categories,
      taxDetail = _state$library$tax.taxDetail;
  var taxAssignToItem = state.form.taxAssignToItem;

  var taxAssignToItems = null; // note plural...
  var items = [];
  if (state.library.tax.taxAssignToItems !== undefined) {
    items = state.library.tax.taxAssignToItems.items;
    taxAssignToItems = state.library.tax.taxAssignToItems;
  }
  return {
    showTaxAssignToItemModal: showTaxAssignToItemModal,
    taxAssignToItem: taxAssignToItem,
    taxAssignToItems: taxAssignToItems,
    items: items,
    categories: categories,
    taxDetail: taxDetail
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'taxAssignToItem',
  keepDirtyOnReinitialize: false,
  enableReinitialize: true
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TaxAssignToItemModal));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TaxForm = __webpack_require__(1505);

var _TaxForm2 = _interopRequireDefault(_TaxForm);

var _style = __webpack_require__(770);

var _style2 = _interopRequireDefault(_style);

var _reactRedux = __webpack_require__(6);

var _tax = __webpack_require__(112);

var _tax2 = __webpack_require__(247);

var mpLibraryTax = _interopRequireWildcard(_tax2);

var _without2 = __webpack_require__(269);

var _without3 = _interopRequireDefault(_without2);

var _map2 = __webpack_require__(191);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxDetail = function (_React$Component) {
  (0, _inherits3.default)(TaxDetail, _React$Component);

  function TaxDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaxDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaxDetail.__proto__ || (0, _getPrototypeOf2.default)(TaxDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onSubmit = function (values) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          taxes = _this$props.taxes,
          taxDetail = _this$props.taxDetail,
          outletIds = _this$props.outletIds,
          outlets = _this$props.outlets,
          categories = _this$props.categories;

      var itemIds = (0, _without3.default)((0, _map3.default)(taxDetail.items, 'item_id'), undefined); // checked...
      var selectedOutletIds = outletIds[0];
      if (values.action === 'save') {
        delete values.action;
        if (values.id) {
          mpLibraryTax.libraryUpdateOneOutlet({ newName: values }, taxDetail, categories);
          dispatch((0, _tax.submitFormUpdate)(values.id, values, taxes, itemIds, selectedOutletIds, outlets));
        } else {
          mpLibraryTax.libraryCreateTax({ tax: values, isAllOutlet: false, taxDetail: taxDetail, categories: categories });
          dispatch((0, _tax.submitFormCreate)(values, taxes, itemIds, selectedOutletIds, outlets));
        }
      } else {
        delete values.action;
        mpLibraryTax.libraryCreateTax({ tax: values, isAllOutlet: true, taxDetail: taxDetail, categories: categories });
        dispatch((0, _tax.submitFormCreateAllOutlets)(values, taxes, itemIds, selectedOutletIds, outlets));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TaxDetail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _style2.default.wrapper },
        React.createElement(_TaxForm2.default, {
          onSubmit: this._onSubmit
        })
      );
    }
  }]);
  return TaxDetail;
}(React.Component);

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      taxes = _state$library$tax.taxes,
      taxDetail = _state$library$tax.taxDetail,
      outlets = _state$library$tax.outlets,
      categories = _state$library$tax.categories;

  var outletIds = [];
  if (outlets.length) {
    outletIds.push(outlets[0].id);
  }
  if (state.form.search.values !== undefined) {
    outletIds = state.form.search.values.outletIds;
  }
  return {
    taxes: taxes,
    taxDetail: taxDetail,
    outletIds: outletIds, // selected
    outlets: outlets,
    categories: categories
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TaxDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _reduxForm = __webpack_require__(7);

var _style = __webpack_require__(770);

var _style2 = _interopRequireDefault(_style);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _SettingFieldWithIcon = __webpack_require__(637);

var _SettingFieldWithIcon2 = _interopRequireDefault(_SettingFieldWithIcon);

var _LabelSection = __webpack_require__(83);

var _LabelSection2 = _interopRequireDefault(_LabelSection);

var _ActionBarDetailWrapper = __webpack_require__(449);

var _ActionBarDetailWrapper2 = _interopRequireDefault(_ActionBarDetailWrapper);

var _tax = __webpack_require__(112);

var actTax = _interopRequireWildcard(_tax);

var _tax2 = __webpack_require__(247);

var mpLibraryTax = _interopRequireWildcard(_tax2);

var _warningIcon = __webpack_require__(2871);

var _warningIcon2 = _interopRequireDefault(_warningIcon);

var _warningIcon2x = __webpack_require__(2872);

var _warningIcon2x2 = _interopRequireDefault(_warningIcon2x);

var _groupBy2 = __webpack_require__(821);

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _values2 = __webpack_require__(828);

var _values3 = _interopRequireDefault(_values2);

var _keyBy2 = __webpack_require__(827);

var _keyBy3 = _interopRequireDefault(_keyBy2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// change
var validate = function validate(values) {
  var errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  }
  if (!values.amount) {
    errors.amount = 'Please enter a value';
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1';
  } else if (values.amount > 100) {
    errors.amount = 'Please input tax less 100%';
  }
  return errors;
};

var TaxForm = function (_React$Component) {
  (0, _inherits3.default)(TaxForm, _React$Component);

  function TaxForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaxForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaxForm.__proto__ || (0, _getPrototypeOf2.default)(TaxForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickTaxAssignToItem = function (e, categoryId) {
      e.stopPropagation();
      e.preventDefault();
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          outletIds = _this$props.outletIds;

      if (!_this.props.tax.id) {
        mpLibraryTax.libraryTaxCreateAssignItemStart(outletIds[0]);
      } else {
        mpLibraryTax.libraryTaxEditAssignItemStart(outletIds[0]);
      }
      dispatch(actTax.onClickTaxAssignToItem(_this.props, categoryId)); // tax
    }, _this._onClickCancel = function (event) {
      _this.props.dispatch(actTax.onClickCancel());
      event.preventDefault();
      event.stopPropagation();
    }, _this._onClickDelete = function (event) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          taxDetail = _this$props2.taxDetail;

      dispatch(actTax.deleteTaxRequest(taxDetail));
      event.preventDefault();
      event.stopPropagation();
    }, _this._onSubmitToAllOutlet = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'saveToAllOutlet' }));
    }, _this._onSubmit = function (values) {
      _this.props.onSubmit((0, _extends3.default)({}, values, { action: 'save' }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TaxForm, [{
    key: 'renderCategoryItemsList',
    value: function renderCategoryItemsList() {
      var _this2 = this;

      var categoryCount = React.createElement(
        'tr',
        null,
        React.createElement(
          'td',
          { className: _style2.default['no-items'] },
          'No Items Assigned to this tax'
        )
      );
      var _props = this.props,
          taxDetail = _props.taxDetail,
          categories = _props.categories;

      if (taxDetail !== null && Array.isArray(taxDetail.items) === true && taxDetail.items.length > 0) {
        var groupedObj = (0, _groupBy3.default)(taxDetail.items, 'category_id');
        var groupedArr = (0, _values3.default)(groupedObj);
        var categoriesMap = (0, _keyBy3.default)(categories, 'id');
        categoryCount = groupedArr.map(function (item) {
          var categoryId = item[0].category_id;
          var categoryName = categoriesMap[categoryId] === undefined ? categoryId : categoriesMap[categoryId].name;
          return React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: _style2.default.name },
              categoryName
            ),
            React.createElement(
              'td',
              { className: _style2.default.amount },
              React.createElement(
                'a',
                { href: '#', onClick: function onClick(e) {
                    return _this2._onClickTaxAssignToItem(e, categoryId);
                  } },
                item.length,
                ' items applied'
              )
            )
          );
        });
      }
      return React.createElement(
        'table',
        { className: _style2.default['table-content'] },
        React.createElement(
          'tbody',
          null,
          categoryCount
        )
      );
    }
  }, {
    key: 'renderEnableTax',
    value: function renderEnableTax() {
      if (this.props.setting.enable_tax === false) {
        return React.createElement(
          _reactBootstrap.Alert,
          { bsStyle: 'warning' },
          React.createElement('img', { src: _warningIcon2.default,
            srcSet: _warningIcon2x2.default,
            className: _style2.default['Warning-Icon'] }),
          ' Your Tax Setting is disabled. Tax will not be applied to the transactions.'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          handleSubmit = _props2.handleSubmit,
          isSubmittingForm = _props2.isSubmittingForm;

      return React.createElement(
        'form',
        { className: _style2.default.wrapper },
        React.createElement(
          'div',
          { className: _style2.default['field-wrapper'] },
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_LabelSection2.default, { title: 'Tax Information' }),
              React.createElement(
                'div',
                { className: 'col-sm-6 col-md-4 no-padding' },
                React.createElement(_reduxForm.Field, {
                  inputClassName: '',
                  component: _SettingField2.default,
                  name: 'name',
                  className: 'form-control',
                  placeholder: 'Name'
                })
              ),
              React.createElement(
                'div',
                { className: 'col-sm-6 col-md-4' },
                React.createElement(_reduxForm.Field, {
                  component: _SettingFieldWithIcon2.default,
                  name: 'amount',
                  icon: '%',
                  className: 'form-control',
                  placeholder: 'Amount',
                  positiveNumberOnly: true,
                  maxFractionDigits: 3
                })
              ),
              React.createElement(
                'div',
                { className: 'col-xs-12 no-padding' },
                React.createElement(
                  'label',
                  { className: '' + _style2.default['custom-amount-cb'] },
                  React.createElement(_reduxForm.Field, {
                    name: 'custom_amount_flag',
                    component: 'input',
                    type: 'checkbox',
                    className: 'form-check-input'
                  }),
                  ' ',
                  'Applied to Custom Amount'
                )
              )
            )
          ),
          this.renderEnableTax(),
          React.createElement(
            'div',
            { className: 'row mb-20px' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(_LabelSection2.default, { title: 'Assign To Selected Items' }),
              React.createElement(
                'div',
                { className: _style2.default.wrapper },
                React.createElement(
                  'div',
                  { className: _style2.default['table-content-wrapper'] },
                  React.createElement(
                    'button',
                    { onClick: function onClick(e) {
                        return _this3._onClickTaxAssignToItem(e, '');
                      },
                      className: 'btn btn-primary btn-block ' + _style2.default['btn-assign']
                    },
                    'Assign To Items'
                  ),
                  this.renderCategoryItemsList()
                )
              )
            )
          )
        ),
        React.createElement(
          _ActionBarDetailWrapper2.default,
          null,
          React.createElement(
            'span',
            { className: 'pull-left' },
            this.props.tax.id && React.createElement(
              'button',
              { className: 'btn btn-danger',
                onClick: this._onClickDelete,
                type: 'button',
                disabled: isSubmittingForm },
              React.createElement('i', { className: 'fa fa-trash' })
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default ' + _style2.default['btn-save'],
                onClick: this._onClickCancel,
                disabled: isSubmittingForm },
              'Cancel'
            ),
            !this.props.tax.id && this.props.outlets.length > 1 && React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary mr-10px',
                onClick: handleSubmit(this._onSubmitToAllOutlet),
                disabled: isSubmittingForm },
              'Save to All Outlets'
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary ' + _style2.default['btn-save'],
                onClick: handleSubmit(this._onSubmit),
                type: 'button',
                disabled: isSubmittingForm },
              'Save'
            )
          )
        )
      );
    }

    /* TODELETE
      _onChangeAmount = (event, nextVal, prevVal) => {
        if (!isNaN(nextVal)) {
          this.props.dispatch(change('taxForm', 'amount', nextVal))
        }
      }
    */

  }]);
  return TaxForm;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('tax');

var mapForm = {
  form: 'tax',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

function mapStateToProps(state) {
  var _state$library$tax = state.library.tax,
      taxes = _state$library$tax.taxes,
      taxDetail = _state$library$tax.taxDetail,
      outlets = _state$library$tax.outlets,
      isSubmittingForm = _state$library$tax.isSubmittingForm,
      categories = _state$library$tax.categories,
      setting = _state$library$tax.setting;


  var outletIds = [];
  if (outlets.length) {
    outletIds.push(outlets[0].id);
  }
  if (state.form.search.values !== undefined) {
    outletIds = state.form.search.values.outletIds;
  }

  return {
    taxes: taxes,
    taxDetail: taxDetail,
    outlets: outlets,
    tax: { id: selector(state, 'id') },
    data: {
      form: state.form
    },
    isSubmittingForm: isSubmittingForm,
    categories: categories,
    setting: setting,
    outletIds: outletIds
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(TaxForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tax = exports.Modifier = exports.Item = exports.Gratuity = exports.Discount = exports.Category = undefined;

var _Category = __webpack_require__(1439);

var _Category2 = _interopRequireDefault(_Category);

var _Discount = __webpack_require__(1445);

var _Discount2 = _interopRequireDefault(_Discount);

var _Gratuity = __webpack_require__(1451);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _Item = __webpack_require__(1456);

var _Item2 = _interopRequireDefault(_Item);

var _Modifier = __webpack_require__(1496);

var _Modifier2 = _interopRequireDefault(_Modifier);

var _Tax = __webpack_require__(1500);

var _Tax2 = _interopRequireDefault(_Tax);

var _Library = __webpack_require__(1481);

var _Library2 = _interopRequireDefault(_Library);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Library2.default;
exports.Category = _Category2.default;
exports.Discount = _Discount2.default;
exports.Gratuity = _Gratuity2.default;
exports.Item = _Item2.default;
exports.Modifier = _Modifier2.default;
exports.Tax = _Tax2.default;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(15);

var _actions = __webpack_require__(18);

var _LoginForm = __webpack_require__(1508);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _style = __webpack_require__(2198);

var _style2 = _interopRequireDefault(_style);

var _AuthTitle = __webpack_require__(443);

var _AuthTitle2 = _interopRequireDefault(_AuthTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function (_React$Component) {
  (0, _inherits3.default)(Login, _React$Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var email = values.email,
          password = values.password;

      var trimEmail = email.trim();
      var nextURL = _this.props.location.query.next;
      if (nextURL) {
        _this.props.dispatch((0, _actions.loginRequest)({ email: trimEmail, password: password }, nextURL));
      } else {
        _this.props.dispatch((0, _actions.loginRequest)({ email: trimEmail, password: password }));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var dispatch = this.props.dispatch;
      var currentlySending = this.props.data.moka.currentlySending;

      return React.createElement(
        'div',
        { className: _style2.default.root, id: 'login-page' },
        React.createElement(_AuthTitle2.default, { title: 'Sign In' }),
        React.createElement(_LoginForm2.default, {
          dispatch: dispatch,
          history: this.props.history,
          onSubmit: this.handleSubmit,
          btnText: 'Sign In',
          currentlySending: currentlySending
        }),
        React.createElement(
          'div',
          { className: _style2.default['margin-link'] },
          React.createElement(
            _reactRouter.Link,
            { className: _style2.default.left + ' forgot-password-link', to: '/forgot' },
            'Forgot Your Password?'
          ),
          React.createElement(
            _reactRouter.Link,
            { className: _style2.default.right, to: '/register' },
            'Sign Up Today'
          )
        )
      );
    }

    /**
     * Handle submission of login form
     * @param values the JSON containing {email,password}
     */

  }]);
  return Login;
}(React.Component);

Login.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func

  // Which props do we want to inject, given the global state?
};function select(state) {
  return {
    data: state
  };
}

// Wrap the component to inject dispatch and state into it
exports.default = (0, _reactRedux.connect)(select)(Login);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _styleForm = __webpack_require__(2199);

var _styleForm2 = _interopRequireDefault(_styleForm);

var _reduxForm = __webpack_require__(7);

var _AuthField = __webpack_require__(435);

var _AuthField2 = _interopRequireDefault(_AuthField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var email = values.email,
      password = values.password;

  if (!email) {
    errors.email = 'The email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim())) {
    errors.email = 'The value is not a valid email address';
  }
  if (!password) {
    errors.password = 'The password is required';
  } else if (password.length < 6) {
    errors.password = 'Password at least have to be 6 characters long';
  }
  return errors;
};

var LoginForm = function (_React$Component) {
  (0, _inherits3.default)(LoginForm, _React$Component);

  function LoginForm() {
    (0, _classCallCheck3.default)(this, LoginForm);
    return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          currentlySending = _props.currentlySending;

      var statusButton = currentlySending ? 'active' : '';

      return React.createElement(
        'div',
        null,
        React.createElement(
          'form',
          { onSubmit: handleSubmit, className: _styleForm2.default['login-form'] },
          React.createElement(_reduxForm.Field, {
            component: _AuthField2.default,
            name: 'email',
            type: 'text',
            placeholder: 'Email',
            autoCorrect: 'off',
            maxLength: '40',
            autoCapitalize: 'off',
            icon: 'fa fa-envelope-o',
            spellCheck: 'false'
          }),
          React.createElement(_reduxForm.Field, {
            component: _AuthField2.default,
            icon: 'fa fa-lock',
            name: 'password',
            maxLength: '40',
            type: 'password',
            placeholder: 'Password'
          }),
          React.createElement(
            'div',
            { className: _styleForm2.default['submit-btn'] },
            React.createElement(
              'button',
              {
                className: 'btn btn-primary btn-block has-spinner ' + statusButton,
                disabled: currentlySending },
              this.props.btnText
            )
          )
        )
      );
    }
  }]);
  return LoginForm;
}(React.Component);

LoginForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  changeForm: React.PropTypes.func,
  btnText: React.PropTypes.string,
  currentlySending: React.PropTypes.bool
};

var mapFormValidation = {
  form: 'loginForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)(LoginForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2200);

var _style2 = _interopRequireDefault(_style);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function (_React$Component) {
  (0, _inherits3.default)(NotFound, _React$Component);

  function NotFound() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NotFound);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call.apply(_ref, [this].concat(args))), _this), _this._handleScroll = function () {
      var divScroll = $('.div-scroll');
      document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft();
    }, _this._handleTableScroll = function () {
      var tableScroll = $('.table-scroll');
      var widthDiv = tableScroll.scrollLeft() + tableScroll.width();
      document.getElementById('tbodyinner').style.width = widthDiv + 'px';
    }, _this._handleTbodyInner = function () {
      var tbodyInner = $('#tbodyinner');
      document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop();
    }, _this._onClickBackToDashboard = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var loggedIn = _this.props.data.loggedIn.loggedIn;

      if (!loggedIn) {
        _this.props.dispatch((0, _reactRouterRedux.push)('/'));
      } else {
        _this.props.dispatch((0, _reactRouterRedux.push)('/dashboard'));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var divScroll = $('.div-scroll');
      var tableScroll = $('.table-scroll');
      var tbodyInner = $('#tbodyinner');
      divScroll.scroll(this._handleScroll);
      tableScroll.scroll(this._handleTableScroll);
      tbodyInner.scroll(this._handleTbodyInner);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: _style2.default['dialog'] },
          React.createElement(
            'h1',
            { className: _style2.default['textNotFound'] },
            'The page you were looking for doesnt exist.'
          ),
          React.createElement(
            'p',
            null,
            'You may have mistyped the address or the page may have moved.'
          )
        ),
        React.createElement(
          'p',
          { className: _style2.default['pageNotFound'] },
          React.createElement(
            'button',
            {
              className: 'btn btn-default ' + _style2.default['btn-back'] + ' mr-10px',
              onClick: this._onClickBackToDashboard,
              type: 'button' },
            'Back to Dashboard'
          )
        )
      );
    }
  }]);
  return NotFound;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: state.moka
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NotFound);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ActionBar = __webpack_require__(2201);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _list = __webpack_require__(127);

var _reduxForm = __webpack_require__(7);

var _pages = __webpack_require__(38);

var _confirmAction = __webpack_require__(29);

var _list2 = __webpack_require__(454);

var mpLibraryOutlet = _interopRequireWildcard(_list2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeKeyword = function (event, newValue) {
      _this.props.dispatch((0, _list.search)({ q: newValue }));
    }, _this._onClickCreateOutlet = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isDirtyForm = _this$props.data.isDirtyForm;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _list.clickCreateOutlet)()));
      } else {
        dispatch((0, _list.clickCreateOutlet)());
      }
    }, _this._onClickAddOutlet = function () {
      _this.props.dispatch((0, _list.clickAddOutlet)());
    }, _this._createOrAddButtonLabel = function () {
      var _this$props$data$outl = _this.props.data.outletPages.list,
          outletSlots = _this$props$data$outl.outletSlots,
          usedOutletSlots = _this$props$data$outl.usedOutletSlots;
      var isTrial = _this.props.data.isTrial;

      if (outletSlots > usedOutletSlots || isTrial) {
        return 'Create Outlet';
      } else {
        return 'Add Outlet';
      }
    }, _this._onClickCreateOrAddButtonLabel = function () {
      var _this$props$data$outl2 = _this.props.data.outletPages.list,
          outletSlots = _this$props$data$outl2.outletSlots,
          usedOutletSlots = _this$props$data$outl2.usedOutletSlots;
      var isTrial = _this.props.data.isTrial;

      if (!outletSlots) {
        // do nothing
      } else if (outletSlots > usedOutletSlots || isTrial) {
        _this._onClickCreateOutlet();
      } else {
        mpLibraryOutlet.outletStart();
        _this._onClickAddOutlet();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props$data$outletPag = this.props.data.outletPages.list,
          outletSlots = _props$data$outletPag.outletSlots,
          usedOutletSlots = _props$data$outletPag.usedOutletSlots;
      var isTrial = this.props.data.isTrial;


      return React.createElement(
        _pages.ActionBarWrapper,
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-3 col-md-3 col-xs-12' },
            React.createElement(_reduxForm.Field, {
              component: _SearchBar2.default,
              placeholder: 'Search',
              name: 'keyword',
              className: 'searchbar-outletlist',
              onChange: this._onChangeKeyword
            })
          ),
          React.createElement(
            'div',
            { className: 'col-sm-9 hidden-xs' },
            React.createElement(
              'span',
              { className: 'pull-right' },
              usedOutletSlots && isTrial && React.createElement(
                'button',
                { className: 'btn btn-default no-outline ' + _ActionBar2.default['btn-outlet'] },
                'Outlet: ',
                usedOutletSlots
              ),
              outletSlots && !isTrial && React.createElement(
                'button',
                { className: 'btn btn-default no-outline ' + _ActionBar2.default['btn-outlet'] },
                'Outlet: ',
                usedOutletSlots,
                ' out of ',
                outletSlots
              ),
              React.createElement(
                'button',
                { className: 'btn btn-primary', onClick: this._onClickCreateOrAddButtonLabel },
                this._createOrAddButtonLabel()
              )
            )
          )
        )
      );
    }

    /**
     * Create outlet: if outlet quota > current active outlet. Will show form
     * @private
     */


    /**
     * Add outlet: if outlet quota === curent active outlet. Will show payment modal
     * @private
     */

  }]);
  return ActionBar;
}(React.Component);

ActionBar.propTypes = {
  dispatch: React.PropTypes.func
};

var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  var is_trial = state.moka.user.business.is_trial;

  return {
    data: {
      isDirtyForm: (0, _reduxForm.isDirty)('outlet')(state),
      outletPages: {
        list: state.outletPages.list
      },
      isTrial: is_trial
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactBootstrap = __webpack_require__(10);

var _reduxForm = __webpack_require__(7);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _AddOutletModal = __webpack_require__(2202);

var _AddOutletModal2 = _interopRequireDefault(_AddOutletModal);

var _list = __webpack_require__(127);

var _list2 = __webpack_require__(454);

var mpOutlet = _interopRequireWildcard(_list2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by alvinoktavianus on 6/19/17.
 */

var AddOutletModal = function (_Component) {
  (0, _inherits3.default)(AddOutletModal, _Component);

  function AddOutletModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddOutletModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddOutletModal.__proto__ || (0, _getPrototypeOf2.default)(AddOutletModal)).call.apply(_ref, [this].concat(args))), _this), _this._hideModal = function () {
      _this.props.dispatch((0, _list.hideAddOutletModal)());
    }, _this._upButton = function () {
      var _this$props = _this.props,
          countOutlet = _this$props.outletCount.countOutlet,
          usedOutletSlots = _this$props.usedOutletSlots;

      var value = countOutlet;

      value++;
      if (!isNaN(value) && value < 10000 - usedOutletSlots) {
        _this.props.dispatch((0, _reduxForm.change)('AddOutletModalForm', 'countOutlet', value));
      }
    }, _this._downButton = function () {
      var countOutlet = _this.props.outletCount.countOutlet;

      var value = countOutlet;

      value--;
      if (!isNaN(value) && value > 0) {
        _this.props.dispatch((0, _reduxForm.change)('AddOutletModalForm', 'countOutlet', value));
      }
    }, _this._payOutlet = function () {
      var _this$props2 = _this.props,
          countOutlet = _this$props2.outletCount.countOutlet,
          outletPrice = _this$props2.outletPrice;

      var billingData = {
        type: 'OutletBilling',
        total_amount: outletPrice['final_price'] * parseInt(countOutlet),
        add_outlet_count: parseInt(countOutlet)
      };
      mpOutlet.outletPay({ billingData: billingData });
      _this.props.dispatch((0, _list.verifyAddOutletBilling)(billingData));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AddOutletModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showAddOutletModal = _props.showAddOutletModal,
          outletPrice = _props.outletPrice,
          payButtonMessage = _props.payButtonMessage,
          outletCount = _props.outletCount,
          disablePayButton = _props.disablePayButton,
          pendingPaymentMessage = _props.pendingPaymentMessage,
          onLoadingPayButton = _props.onLoadingPayButton,
          usedOutletSlots = _props.usedOutletSlots;


      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          onHide: function onHide() {
            return _this2._hideModal();
          }, show: showAddOutletModal,
          dialogClassName: _AddOutletModal2.default['add-outlet-modal-wrapper'] + ' modal-dialog' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: _AddOutletModal2.default['modal-wrapper'] },
          _react2.default.createElement(
            'div',
            { className: 'add-outlet-modal-wrapper' },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'close', onClick: function onClick() {
                  _this2._hideModal();
                } },
              _react2.default.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Add Outlet'
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row', style: { verticalAlign: 'middle' } },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-4' },
                _react2.default.createElement(
                  'span',
                  { style: { lineHeight: '34px' } },
                  'Number of Outlets'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-2 col-xs-4' },
                _react2.default.createElement(
                  'div',
                  { className: 'input-group ' + _AddOutletModal2.default['spinner'] },
                  _react2.default.createElement(_reduxForm.Field, { id: 'count-outlet',
                    type: 'text', name: 'countOutlet', component: 'input',
                    className: 'form-control ' + _AddOutletModal2.default['add-outlet-value'],
                    onChange: function onChange(e) {
                      var value = e.target.value;
                      if (!isNaN(value) && value > 0 && value < 10000 - usedOutletSlots) {
                        _this2.props.dispatch((0, _reduxForm.change)('AddOutletModalForm', 'countOutlet', value));
                      } else if (value >= 9999 - usedOutletSlots) {
                        _this2.props.dispatch((0, _reduxForm.change)('AddOutletModalForm', 'countOutlet', 9999 - usedOutletSlots));
                      }
                      e.preventDefault();
                    }
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: _AddOutletModal2.default['input-group-btn-vertical'] },
                    _react2.default.createElement(
                      'button',
                      { className: 'btn btn-default', type: 'button', onClick: function onClick() {
                          _this2._upButton();
                        } },
                      _react2.default.createElement('i', { className: 'fa fa-caret-up' })
                    ),
                    _react2.default.createElement(
                      'button',
                      { className: 'btn btn-default', type: 'button', onClick: function onClick() {
                          return _this2._downButton();
                        } },
                      _react2.default.createElement('i', { className: 'fa fa-caret-down' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-1' },
                _react2.default.createElement(
                  'strong',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _AddOutletModal2.default['times-text'] },
                    '*'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-5' },
                outletPrice['MOKA'] && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: _AddOutletModal2.default['pricing-text'] },
                      (0, _formatter.currencyFormatter)(outletPrice['MOKA'].final_price)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: _AddOutletModal2.default['pro-rated-period-text'] },
                      'pro-rated for period from ',
                      (0, _moment2.default)().format('DD/MM/YYYY'),
                      ' - ',
                      (0, _moment2.default)(outletPrice['MOKA'].end_date).format('DD/MM/YYYY')
                    )
                  )
                )
              )
            ),
            outletPrice && _lodash2.default.map(outletPrice, function (featureDetail, featureName) {
              if (featureName !== 'MOKA' && featureName !== 'final_price' && featureDetail.total_price !== 0) {
                return _react2.default.createElement(
                  'div',
                  { className: 'row ' + _AddOutletModal2.default['outlet-features'], style: { verticalAlign: 'middle' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    _react2.default.createElement(
                      'span',
                      { style: { lineHeight: '34px' } },
                      featureName
                    )
                  ),
                  _react2.default.createElement('div', { className: 'col-sm-2 col-xs-4' }),
                  _react2.default.createElement('div', { className: 'col-xs-1' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-5' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: _AddOutletModal2.default['pricing-text'] },
                        (0, _formatter.currencyFormatter)(outletPrice[featureName].final_price)
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: _AddOutletModal2.default['pro-rated-period-text'] },
                        'pro-rated for period from ',
                        (0, _moment2.default)().format('DD/MM/YYYY'),
                        ' - ',
                        (0, _moment2.default)(outletPrice[featureName].end_date).format('DD/MM/YYYY')
                      )
                    )
                  )
                );
              }
            }),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row text-primary' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-7' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Total Payment'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-5' },
                outletCount && outletPrice && _react2.default.createElement(
                  'h3',
                  { className: 'totalCount' },
                  (0, _formatter.currencyFormatter)((outletPrice['final_price'] * parseInt(outletCount.countOutlet)).toString())
                )
              )
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { className: 'row ' + _AddOutletModal2.default['pay-button-wrapper'] },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'button',
                  { id: 'pay-outlet-button', className: 'btn btn-block btn-lg ' + (disablePayButton ? 'btn-disabled' : 'btn-primary') + ' ' + (onLoadingPayButton ? _AddOutletModal2.default['on-loading-button'] : ''), onClick: function onClick() {
                      return _this2._payOutlet();
                    }, disabled: disablePayButton },
                  payButtonMessage
                )
              )
            ),
            pendingPaymentMessage && _react2.default.createElement(
              'div',
              { className: 'row ' + _AddOutletModal2.default['pending-message'] + ' ' + _AddOutletModal2.default['text-xs'] },
              _react2.default.createElement(
                'div',
                { className: 'col-md-12' },
                _react2.default.createElement(
                  'em',
                  null,
                  pendingPaymentMessage
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AddOutletModal;
}(_react.Component);

var mapForm = {
  form: 'AddOutletModalForm'
};

function mapStateToProps(state) {
  var _state$outletPages$li = state.outletPages.list,
      showAddOutletModal = _state$outletPages$li.showAddOutletModal,
      outletPrice = _state$outletPages$li.outletPrice,
      payButtonMessage = _state$outletPages$li.payButtonMessage,
      disablePayButton = _state$outletPages$li.disablePayButton,
      pendingPaymentMessage = _state$outletPages$li.pendingPaymentMessage,
      onLoadingPayButton = _state$outletPages$li.onLoadingPayButton,
      usedOutletSlots = _state$outletPages$li.usedOutletSlots;

  return {
    showAddOutletModal: showAddOutletModal,
    outletCount: (0, _reduxForm.getFormValues)('AddOutletModalForm')(state),
    outletPrice: outletPrice,
    payButtonMessage: payButtonMessage,
    disablePayButton: disablePayButton,
    pendingPaymentMessage: pendingPaymentMessage,
    onLoadingPayButton: onLoadingPayButton,
    usedOutletSlots: usedOutletSlots
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(mapForm)(AddOutletModal));

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _list = __webpack_require__(127);

var _ConfirmReactivateOutletModal = __webpack_require__(2203);

var _ConfirmReactivateOutletModal2 = _interopRequireDefault(_ConfirmReactivateOutletModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmReactivateOutletModal = function (_React$Component) {
  (0, _inherits3.default)(ConfirmReactivateOutletModal, _React$Component);

  function ConfirmReactivateOutletModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmReactivateOutletModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmReactivateOutletModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmReactivateOutletModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _list.cancelReactivateOutlet)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          reactivatedOutlet = _this$props.reactivatedOutlet,
          dispatch = _this$props.dispatch,
          outletPrice = _this$props.outletPrice;

      var billingData = {
        type: 'OutletBilling',
        total_amount: outletPrice['final_price'],
        add_outlet_count: 1,
        outlet: reactivatedOutlet
      };
      dispatch((0, _list.confirmReactivateOutlet)(billingData));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmReactivateOutletModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showConfirmReactivateOutletModal = _props.showConfirmReactivateOutletModal,
          reactivatedOutlet = _props.reactivatedOutlet,
          outletPrice = _props.outletPrice,
          payButtonMessage = _props.payButtonMessage,
          disablePayButton = _props.disablePayButton,
          pendingPaymentMessage = _props.pendingPaymentMessage,
          onLoadingPayButton = _props.onLoadingPayButton;

      return React.createElement(
        _reactBootstrap.Modal,
        {
          onHide: this._onHide, show: showConfirmReactivateOutletModal,
          dialogClassName: _ConfirmReactivateOutletModal2.default['reactivate-outlet-modal-wrapper'] + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: _ConfirmReactivateOutletModal2.default['modal-wrapper'] },
          React.createElement(
            'div',
            { className: 'reactivate-outlet-modal-wrapper' },
            React.createElement(
              'button',
              { type: 'button', className: 'close', onClick: function onClick() {
                  _this2._onHide();
                } },
              React.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            React.createElement(
              'h4',
              null,
              'Reactivate Outlet'
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: 'row', style: { verticalAlign: 'middle' } },
              React.createElement(
                'div',
                { className: 'col-xs-7' },
                React.createElement(
                  'strong',
                  null,
                  reactivatedOutlet && React.createElement(
                    'span',
                    { style: { lineHeight: '34px' } },
                    reactivatedOutlet.name
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'col-xs-5' },
                outletPrice['MOKA'] && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      { className: _ConfirmReactivateOutletModal2.default['pricing-text'] },
                      (0, _formatter.currencyFormatter)(outletPrice['MOKA'].final_price)
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      { className: _ConfirmReactivateOutletModal2.default['pro-rated-period-text'] },
                      'pro-rated for period from ',
                      React.createElement('br', null),
                      (0, _moment2.default)().format('DD/MM/YYYY'),
                      ' - ',
                      (0, _moment2.default)(outletPrice['MOKA'].end_date).format('DD/MM/YYYY')
                    )
                  )
                )
              )
            ),
            outletPrice && _lodash2.default.map(outletPrice, function (featureDetail, featureName) {
              if (featureName !== 'MOKA' && featureName !== 'final_price' && featureDetail.total_price !== 0) {
                return React.createElement(
                  'div',
                  { className: 'row ' + _ConfirmReactivateOutletModal2.default['outlet-features'], style: { verticalAlign: 'middle' } },
                  React.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    React.createElement(
                      'span',
                      { style: { lineHeight: '34px' } },
                      featureName
                    )
                  ),
                  React.createElement('div', { className: 'col-sm-2 col-xs-4' }),
                  React.createElement('div', { className: 'col-xs-1' }),
                  React.createElement(
                    'div',
                    { className: 'col-xs-5' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'span',
                        { className: _ConfirmReactivateOutletModal2.default['pricing-text'] },
                        (0, _formatter.currencyFormatter)(outletPrice[featureName].final_price)
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'span',
                        { className: _ConfirmReactivateOutletModal2.default['pro-rated-period-text'] },
                        'pro-rated for period from ',
                        React.createElement('br', null),
                        (0, _moment2.default)().format('DD/MM/YYYY'),
                        ' - ',
                        (0, _moment2.default)(outletPrice[featureName].end_date).format('DD/MM/YYYY')
                      )
                    )
                  )
                );
              }
            }),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: 'row text-primary' },
              React.createElement(
                'div',
                { className: 'col-xs-7' },
                React.createElement(
                  'h3',
                  null,
                  'Total Payment'
                )
              ),
              React.createElement(
                'div',
                { className: 'col-xs-5' },
                outletPrice && React.createElement(
                  'h3',
                  { className: 'totalCount' },
                  (0, _formatter.currencyFormatter)((outletPrice['final_price'] * 1).toString())
                )
              )
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: 'row ' + _ConfirmReactivateOutletModal2.default['pay-button-wrapper'] },
              React.createElement(
                'div',
                { className: 'col-xs-12' },
                React.createElement(
                  'button',
                  { id: 'pay-reactivate-outlet-button',
                    className: 'btn btn-block btn-lg ' + (disablePayButton ? 'btn-disabled' : 'btn-primary') + ' ' + (onLoadingPayButton ? _ConfirmReactivateOutletModal2.default['on-loading-button'] : ''),
                    onClick: function onClick() {
                      return _this2._onConfirm();
                    }, disabled: disablePayButton },
                  payButtonMessage
                )
              )
            ),
            pendingPaymentMessage && React.createElement(
              'div',
              { className: 'row ' + _ConfirmReactivateOutletModal2.default['pending-message'] + ' ' + _ConfirmReactivateOutletModal2.default['text-xs'] },
              React.createElement(
                'div',
                { className: 'col-md-12' },
                React.createElement(
                  'em',
                  null,
                  pendingPaymentMessage
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ConfirmReactivateOutletModal;
}(React.Component);

ConfirmReactivateOutletModal.propTypes = {
  showConfirmReactivateOutletModal: React.PropTypes.bool,
  reactivatedOutlet: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
};

function mapStateToProps(state) {
  var _state$outletPages$li = state.outletPages.list,
      showConfirmReactivateOutletModal = _state$outletPages$li.showConfirmReactivateOutletModal,
      reactivatedOutlet = _state$outletPages$li.reactivatedOutlet,
      outlets = _state$outletPages$li.outlets,
      outletPrice = _state$outletPages$li.outletPrice,
      payButtonMessage = _state$outletPages$li.payButtonMessage,
      disablePayButton = _state$outletPages$li.disablePayButton,
      pendingPaymentMessage = _state$outletPages$li.pendingPaymentMessage,
      onLoadingPayButton = _state$outletPages$li.onLoadingPayButton;

  return {
    showConfirmReactivateOutletModal: showConfirmReactivateOutletModal,
    reactivatedOutlet: reactivatedOutlet,
    outlets: outlets,
    outletPrice: outletPrice,
    payButtonMessage: payButtonMessage,
    disablePayButton: disablePayButton,
    pendingPaymentMessage: pendingPaymentMessage,
    onLoadingPayButton: onLoadingPayButton
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfirmReactivateOutletModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _list = __webpack_require__(127);

var _ActionBar = __webpack_require__(1510);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _Table = __webpack_require__(1517);

var _Table2 = _interopRequireDefault(_Table);

var _OutletDetail = __webpack_require__(1514);

var _OutletDetail2 = _interopRequireDefault(_OutletDetail);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(15);

var _confirmAction = __webpack_require__(29);

var _reactRouterRedux = __webpack_require__(49);

var _reduxForm = __webpack_require__(7);

var _ConfirmActionModal = __webpack_require__(55);

var _ConfirmActionModal2 = _interopRequireDefault(_ConfirmActionModal);

var _ConfirmReactivateOutletModal = __webpack_require__(1512);

var _ConfirmReactivateOutletModal2 = _interopRequireDefault(_ConfirmReactivateOutletModal);

var _AddOutletModal = __webpack_require__(1511);

var _AddOutletModal2 = _interopRequireDefault(_AddOutletModal);

var _pages = __webpack_require__(38);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _PaymentGatewayErrorModal = __webpack_require__(441);

var _PaymentGatewayErrorModal2 = _interopRequireDefault(_PaymentGatewayErrorModal);

var _ReactiveOutletWithoutPayModal = __webpack_require__(1516);

var _ReactiveOutletWithoutPayModal2 = _interopRequireDefault(_ReactiveOutletWithoutPayModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._onHideModal = function () {
      _this.props.dispatch((0, _list.hidePaymentGatewayError)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var expired = this.props.data.subscriptionExpired.expired;
      var billingNotification = this.props.billingNotification;

      var expireTime = 365; // expire time 1 year
      if (!expired) {
        this.props.dispatch((0, _list.pageRequest)(billingNotification));
        _reactRouter.browserHistory.listenBefore(function (location) {
          if (_this2.props.data.isDirtyForm && _this2.props.data.confirmAction.nextAction === null) {
            // negate the change location, instead use sagas to handle the change location
            _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location.pathname)));
            return false;
          }
        });
        if (Cookies.get('labelNew') === 'true') {
          Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
        }
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$data$outletPag = this.props.data.outletPages.list,
          outlets = _props$data$outletPag.outlets,
          outletDetail = _props$data$outletPag.outletDetail,
          openRightColumn = _props$data$outletPag.openRightColumn;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;
      var _props$data = this.props.data,
          outletCount = _props$data.outletCount,
          outletPrice = _props$data.outletPrice,
          showPaymentGatewayErrorModal = _props$data.showPaymentGatewayErrorModal;


      return React.createElement(
        _pages.PageWrapper,
        null,
        React.createElement(_ActionBar2.default, { dispatch: this.props.dispatch }),
        React.createElement(
          _pages.ContentWrapper,
          null,
          React.createElement(
            _pages.LeftColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_NoDataAndLoading2.default, {
              showLoadingSpinner: showLoadingSpinnerPage,
              noDataToDisplay: outlets.length === 0,
              title: 'No Data To Display',
              description: '' }),
            React.createElement(_Table2.default, {
              outlets: outlets,
              dispatch: this.props.dispatch,
              outletDetail: outletDetail,
              isDirtyForm: this.props.data.isDirtyForm
            })
          ),
          React.createElement(
            _pages.RightColumnWrapper,
            { openRightColumn: openRightColumn },
            React.createElement(_OutletDetail2.default, {
              outlet: outletDetail,
              dispatch: this.props.dispatch,
              outlets: outlets
            })
          )
        ),
        React.createElement(_ConfirmActionModal2.default, null),
        React.createElement(_ConfirmReactivateOutletModal2.default, null),
        React.createElement(_ReactiveOutletWithoutPayModal2.default, null),
        React.createElement(_AddOutletModal2.default, null),
        outletPrice && outletCount && React.createElement(_PaymentGatewayErrorModal2.default, {
          totalPrice: (outletPrice['final_price'] * parseInt(outletCount.countOutlet)).toString(),
          showModal: showPaymentGatewayErrorModal, onHide: function onHide() {
            _this3._onHideModal();
          } })
      );
    }
  }]);
  return List;
}(React.Component);

List.propTypes = {
  dispatch: React.PropTypes.func
};

function mapStateToProps(state) {
  var _state$outletPages$li = state.outletPages.list,
      outletPrice = _state$outletPages$li.outletPrice,
      showPaymentGatewayErrorModal = _state$outletPages$li.showPaymentGatewayErrorModal;
  var billingNotification = state.billingNotification;

  return {
    data: {
      isDirtyForm: (0, _reduxForm.isDirty)('outlet')(state),
      confirmAction: state.confirmAction,
      outletPages: {
        list: state.outletPages.list
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired,
      outletCount: (0, _reduxForm.getFormValues)('AddOutletModalForm')(state),
      outletPrice: outletPrice,
      showPaymentGatewayErrorModal: showPaymentGatewayErrorModal
    },
    billingNotification: billingNotification
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(List);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _OutletDetail = __webpack_require__(2204);

var _OutletDetail2 = _interopRequireDefault(_OutletDetail);

var _list = __webpack_require__(127);

var _OutletForm = __webpack_require__(1515);

var _OutletForm2 = _interopRequireDefault(_OutletForm);

var _confirmAction = __webpack_require__(29);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(15);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutletDetail = function (_React$Component) {
  (0, _inherits3.default)(OutletDetail, _React$Component);

  function OutletDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OutletDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OutletDetail.__proto__ || (0, _getPrototypeOf2.default)(OutletDetail)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCancel = function () {
      _this.props.dispatch((0, _list.clickCancel)());
    }, _this._onSubmit = function (values) {
      var outlets = _this.props.outlets;

      var data = {};
      data.is_deleted = false;
      data.name = values.name.trim();
      data.address = values.address.trim();
      data.phone_number = '0' + values.phone.trim();
      data.city = values.city.trim();
      data.province = values.province.trim();
      data.postal_code = values.postal.trim();
      data.business_id = values.businessId;
      if (values.id) {
        _this.props.dispatch((0, _list.submitFormUpdate)(values.id, { outlet: data }, {}, outlets));
      } else {
        _this.props.dispatch((0, _list.submitFormCreate)({ outlet: data }, {}, outlets));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OutletDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _reactRouter.browserHistory.listenBefore(function (location) {
        if (_this2.props.isDirtyForm && !_this2.props.nextAction) {
          // negate the change location, instead use sagas to handle the change location
          _this2.props.dispatch((0, _confirmAction.askConfirmAction)((0, _reactRouterRedux.push)(location.pathname)));
          return false;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _OutletDetail2.default.wrapper },
        React.createElement(
          'div',
          { className: _OutletDetail2.default.form },
          React.createElement(_OutletForm2.default, {
            onSubmit: this._onSubmit,
            onClickCancel: this._onClickCancel
          })
        )
      );
    }
  }]);
  return OutletDetail;
}(React.Component);

OutletDetail.propTypes = {
  outlet: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array,
  isDirtyForm: React.PropTypes.bool,
  nextAction: React.PropTypes.object
};

function mapStateToProps(state) {
  return {
    isDirtyForm: (0, _reduxForm.isDirty)('outlet')(state),
    nextAction: state.confirmAction.nextAction
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(OutletDetail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingField = __webpack_require__(37);

var _SettingField2 = _interopRequireDefault(_SettingField);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _OutletForm = __webpack_require__(2205);

var _OutletForm2 = _interopRequireDefault(_OutletForm);

var _list = __webpack_require__(127);

var _PhoneNumberField = __webpack_require__(242);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  var FIELD_REQUIRED_ERROR = 'This field is required';

  if (!values.name || values.name.trim() === '') {
    errors.name = FIELD_REQUIRED_ERROR;
  }

  if (!values.address || values.address.trim() === '') {
    errors.address = FIELD_REQUIRED_ERROR;
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR;
  }

  if (!values.city || values.city.trim() === '') {
    errors.city = FIELD_REQUIRED_ERROR;
  }

  if (!values.province || values.province.trim() === '') {
    errors.province = FIELD_REQUIRED_ERROR;
  }

  if (!values.postal || !/^\d{5}$/.test(values.postal) || values.postal.trim() === '') {
    errors.postal = FIELD_REQUIRED_ERROR;
  }

  return errors;
};

var renderOutletStatus = function renderOutletStatus(outlet) {
  if (outlet.is_deleted) {
    return React.createElement(
      'span',
      { className: _OutletForm2.default['outlet-inactive'] },
      'Expired'
    );
  } else {
    return React.createElement(
      'span',
      { className: _OutletForm2.default['outlet-active'] },
      'Active'
    );
  }
};

var OutletForm = function (_React$Component) {
  (0, _inherits3.default)(OutletForm, _React$Component);

  function OutletForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OutletForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OutletForm.__proto__ || (0, _getPrototypeOf2.default)(OutletForm)).call.apply(_ref, [this].concat(args))), _this), _this._onClickCancel = function () {
      _this.props.onClickCancel();
    }, _this._onClickReactivateOutlet = function () {
      var _this$props = _this.props,
          editedOutlet = _this$props.editedOutlet,
          dispatch = _this$props.dispatch,
          outletSlots = _this$props.outletSlots,
          usedOutletSlots = _this$props.usedOutletSlots;

      if (outletSlots > usedOutletSlots) {
        dispatch((0, _list.askReactivateOutletWithoutPay)(editedOutlet));
      } else {
        dispatch((0, _list.askReactivateOutlet)(editedOutlet));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OutletForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          editedOutlet = _props.editedOutlet,
          disableSaveOutletButton = _props.disableSaveOutletButton;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit, className: _OutletForm2.default.wrapper },
        React.createElement(
          'div',
          { className: _OutletForm2.default['field-wrapper'] },
          editedOutlet && React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'p',
                null,
                'Outlet Status\xA0\xA0\xA0\xA0\xA0:\xA0\xA0',
                renderOutletStatus(editedOutlet)
              )
            )
          ),
          React.createElement(_reduxForm.Field, { name: 'id', component: 'input', type: 'hidden' }),
          React.createElement(_reduxForm.Field, { name: 'businessId', component: 'input', type: 'hidden' }),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, { name: 'name', component: _SettingField2.default, placeholder: 'Outlet Name' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, { name: 'address', component: _SettingField2.default, placeholder: 'Address' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-lg-12' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  component: _PhoneNumberField2.default,
                  name: 'phone',
                  type: 'tel',
                  placeholder: '812'
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, { name: 'city', component: _SettingField2.default, placeholder: 'City' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, { name: 'province', component: _SettingField2.default, placeholder: 'State' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4' },
              React.createElement(
                'div',
                { className: 'form-group' },
                React.createElement(_reduxForm.Field, {
                  name: 'postal',
                  component: _SettingField2.default,
                  placeholder: 'Zip',
                  maxLength: '5',
                  positiveNumberOnly: true
                })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _OutletForm2.default.footer },
          React.createElement(
            'span',
            { className: 'pull-left' },
            editedOutlet && editedOutlet.is_deleted && React.createElement(
              'button',
              { className: 'btn btn-primary', type: 'button', onClick: this._onClickReactivateOutlet },
              'Reactivate'
            )
          ),
          React.createElement(
            'span',
            { className: 'pull-right' },
            React.createElement(
              'button',
              { className: 'btn btn-default', type: 'button', style: { 'margin-right': '10px' }, onClick: this._onClickCancel },
              'Cancel'
            ),
            React.createElement(
              'button',
              { className: 'btn btn-primary', type: 'submit', disabled: disableSaveOutletButton },
              'Save'
            )
          )
        )
      );
    }
  }]);
  return OutletForm;
}(React.Component);

OutletForm.propTypes = {
  onClickCancel: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func,
  isDirtyForm: React.PropTypes.bool,
  editedOutlet: React.PropTypes.object
};

var mapForm = {
  form: 'outlet',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

function mapStateTopProps(state) {
  var _state$outletPages$li = state.outletPages.list,
      outletSlots = _state$outletPages$li.outletSlots,
      usedOutletSlots = _state$outletPages$li.usedOutletSlots;

  return {
    isDirtyForm: (0, _reduxForm.isDirty)('outlet')(state),
    editedOutlet: state.outletPages.list.outletDetail,
    disableSaveOutletButton: state.outletPages.list.disableSaveOutletButton,
    outletSlots: outletSlots,
    usedOutletSlots: usedOutletSlots
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reactRedux.connect)(mapStateTopProps, mapDispatchToProps)((0, _reduxForm.reduxForm)(mapForm)(OutletForm));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _reactRedux = __webpack_require__(6);

var _list = __webpack_require__(127);

var _ReactivateOutletWithoutPayModal = __webpack_require__(2206);

var _ReactivateOutletWithoutPayModal2 = _interopRequireDefault(_ReactivateOutletWithoutPayModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivateOutletWithoutPayModal = function (_Component) {
  (0, _inherits3.default)(ReactivateOutletWithoutPayModal, _Component);

  function ReactivateOutletWithoutPayModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReactivateOutletWithoutPayModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReactivateOutletWithoutPayModal.__proto__ || (0, _getPrototypeOf2.default)(ReactivateOutletWithoutPayModal)).call.apply(_ref, [this].concat(args))), _this), _this._onHide = function () {
      _this.props.dispatch((0, _list.hideReactivateOutletWithoutPay)());
    }, _this._onConfirm = function () {
      var _this$props = _this.props,
          reactivatedOutlet = _this$props.reactivatedOutlet,
          outlets = _this$props.outlets;

      _this.props.dispatch((0, _list.confirmReactivateOutletWithoutPay)(reactivatedOutlet, outlets));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReactivateOutletWithoutPayModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          showReactivateOutletWithoutPayModal = _props.showReactivateOutletWithoutPayModal,
          isOnLoading = _props.isOnLoading;

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { onHide: function onHide() {
            _this2._onHide();
          }, show: showReactivateOutletWithoutPayModal, dialogClassName: _ReactivateOutletWithoutPayModal2.default.dialog + ' modal-dialog' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          null,
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            'Reactivate Outlet'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Are you sure want to reactivate this outlet? This action cannot be reversed.'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-default', onClick: function onClick() {
                  _this2._onHide();
                } },
              'Cancel'
            ),
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary pull-right', onClick: function onClick() {
                  _this2._onConfirm();
                }, disabled: isOnLoading },
              'Reactivate'
            )
          )
        )
      );
    }
  }]);
  return ReactivateOutletWithoutPayModal;
}(_react.Component); /**
                      * Created by alvinoktavianus on 7/4/17.
                      */

function mapStateToProps(state) {
  var _state$outletPages$li = state.outletPages.list,
      showReactivateOutletWithoutPayModal = _state$outletPages$li.showReactivateOutletWithoutPayModal,
      reactivatedOutlet = _state$outletPages$li.reactivatedOutlet,
      outlets = _state$outletPages$li.outlets,
      isOnLoadingReactivateOutletWithoutPayModal = _state$outletPages$li.isOnLoadingReactivateOutletWithoutPayModal;

  return { showReactivateOutletWithoutPayModal: showReactivateOutletWithoutPayModal, reactivatedOutlet: reactivatedOutlet, outlets: outlets, isOnLoading: isOnLoadingReactivateOutletWithoutPayModal };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReactivateOutletWithoutPayModal);

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Table = __webpack_require__(2207);

var _Table2 = _interopRequireDefault(_Table);

var _list = __webpack_require__(127);

var _confirmAction = __webpack_require__(29);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = function (_React$Component) {
  (0, _inherits3.default)(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this._renderRow = function (outlet) {
      return React.createElement(
        'tr',
        { onClick: function onClick() {
            return _this._onClickOutlet(outlet);
          }, className: _this._isSelected(outlet) ? _Table2.default.selected : '' },
        React.createElement(
          'td',
          { className: _Table2.default.name },
          outlet.name
        ),
        React.createElement(
          'td',
          { className: _Table2.default.address },
          outlet.address
        ),
        React.createElement(
          'td',
          { className: _Table2.default.phone },
          outlet.phone_number
        ),
        React.createElement(
          'td',
          { className: _Table2.default.city },
          outlet.city
        ),
        React.createElement(
          'td',
          { className: _Table2.default.province },
          outlet.province
        ),
        React.createElement(
          'td',
          { className: _Table2.default.status },
          _this._renderOutletStatus(outlet)
        )
      );
    }, _this._renderOutletStatus = function (outlet) {
      if (!outlet.is_deleted) {
        return React.createElement(
          'span',
          { className: _Table2.default['outlet-active'] },
          'Active'
        );
      } else {
        return React.createElement(
          'span',
          { className: _Table2.default['outlet-inactive'] },
          'Expired'
        );
      }
    }, _this._onClickOutlet = function (outlet) {
      var _this$props = _this.props,
          isDirtyForm = _this$props.isDirtyForm,
          dispatch = _this$props.dispatch;

      if (isDirtyForm) {
        dispatch((0, _confirmAction.askConfirmAction)((0, _list.clickOutletRow)(outlet.id)));
      } else {
        dispatch((0, _list.clickOutletRow)(outlet.id));
      }
    }, _this._isSelected = function (outlet) {
      var outletDetail = _this.props.outletDetail;

      return outletDetail && outlet.id === outletDetail.id;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Table, [{
    key: 'render',
    value: function render() {
      var outlets = this.props.outlets;


      return outlets.length > 0 && React.createElement(
        'div',
        { className: _Table2.default.wrapper },
        React.createElement(
          'table',
          { className: 'table ' + _Table2.default['table-header'] },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                { className: _Table2.default.name },
                'Outlet Name'
              ),
              React.createElement(
                'th',
                { className: _Table2.default.address },
                'Address'
              ),
              React.createElement(
                'th',
                { className: _Table2.default.phone },
                'Phone'
              ),
              React.createElement(
                'th',
                { className: _Table2.default.city },
                'City'
              ),
              React.createElement(
                'th',
                { className: _Table2.default.province },
                'Province'
              ),
              React.createElement(
                'th',
                { className: _Table2.default.status },
                'Status'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _Table2.default.scroll },
          React.createElement(
            'table',
            { className: 'table ' + _Table2.default['table-body'] },
            React.createElement(
              'tbody',
              { className: _Table2.default.tbody },
              outlets.map(this._renderRow)
            )
          )
        )
      );
    }
  }]);
  return Table;
}(React.Component);

Table.propTypes = {
  outlets: React.PropTypes.array,
  dispatch: React.PropTypes.func,
  outletDetail: React.PropTypes.object,
  isDirtyForm: React.PropTypes.bool
};

function mapStateToProps(state) {
  var showLoadingSpinnerPage = state.loadingSpinner.showLoadingSpinnerPage;

  return { showLoadingSpinnerPage: showLoadingSpinnerPage };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Table);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Outlet = __webpack_require__(2208);

var _Outlet2 = _interopRequireDefault(_Outlet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Outlet = function (_React$Component) {
  (0, _inherits3.default)(Outlet, _React$Component);

  function Outlet() {
    (0, _classCallCheck3.default)(this, Outlet);
    return (0, _possibleConstructorReturn3.default)(this, (Outlet.__proto__ || (0, _getPrototypeOf2.default)(Outlet)).apply(this, arguments));
  }

  (0, _createClass3.default)(Outlet, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'container box-report-child ' + _Outlet2.default.container },
        this.props.children
      );
    }
  }]);
  return Outlet;
}(React.Component);

Outlet.propTypes = {};

exports.default = Outlet;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = undefined;

var _List = __webpack_require__(1513);

var _List2 = _interopRequireDefault(_List);

var _Outlet = __webpack_require__(1518);

var _Outlet2 = _interopRequireDefault(_Outlet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Outlet2.default;
exports.List = _List2.default;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactGcaptcha = __webpack_require__(375);

var _reactGcaptcha2 = _interopRequireDefault(_reactGcaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Captcha = function (_React$Component) {
  (0, _inherits3.default)(Captcha, _React$Component);

  function Captcha(props) {
    (0, _classCallCheck3.default)(this, Captcha);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Captcha.__proto__ || (0, _getPrototypeOf2.default)(Captcha)).call(this, props));

    var input = _this.props.input;
    var onChange = input.onChange;

    _this.state = {
      onChange: onChange
    };
    return _this;
  }

  (0, _createClass3.default)(Captcha, [{
    key: 'callback',
    value: function callback(key) {
      this.state.onChange(key);
    }
  }, {
    key: 'loaded',
    value: function loaded() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          meta = _props.meta;
      var touched = meta.touched,
          error = meta.error;

      return React.createElement(
        'div',
        null,
        React.createElement(_reactGcaptcha2.default, (0, _extends3.default)({}, input, {
          sitekey: '6LesGA4UAAAAAMQ4EgXcvuxeJOXdIo217ldryOms',
          onloadCallback: this.loaded,
          verifyCallback: this.callback.bind(this)
        })),
        React.createElement(
          'small',
          { className: 'error' },
          touched ? error : ''
        )
      );
    }
  }]);
  return Captcha;
}(React.Component);

exports.default = Captcha;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(18);

var _style = __webpack_require__(771);

var _style2 = _interopRequireDefault(_style);

var _PhoneNumberField = __webpack_require__(242);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.businessName) {
    errors.businessName = 'This field is required';
  }
  if (!values.businessType) {
    errors.businessType = 'This field is required';
  }
  if (!values.businessCategory) {
    errors.businessCategory = 'This field is required';
  }
  if (!values.businessAddress) {
    errors.businessAddress = 'This field is required';
  }
  if (!values.businessCity) {
    errors.businessCity = 'This field is required';
  }
  if (!values.businessProvince) {
    errors.businessProvince = 'This field is required';
  }
  if (!values.businessPostalCode) {
    errors.businessPostalCode = 'This field is required';
  } else if (!/^\d{5}$/.test(values.businessPostalCode)) {
    errors.businessPostalCode = 'Please enter a valid format';
  }
  if (!values.userFirstName) {
    errors.userFirstName = 'This field is required';
  }
  if (!values.userLastName) {
    errors.userLastName = 'This field is required';
  }
  if (!values.userPhone) {
    errors.userPhone = 'This field is required';
  }
  return errors;
};

var inputField = function inputField(field) {
  return React.createElement(
    'div',
    null,
    React.createElement('input', (0, _extends3.default)({}, field.input, {
      type: field.type || 'text',
      maxLength: field.maxLength,
      className: 'form-control',
      placeholder: field.placeholder,
      onKeyPress: function onKeyPress(e) {
        return field.onKeyPress ? field.setOnlyNumber(e) : '';
      },
      keyboardType: field.keyboardType
    })),
    React.createElement(
      'small',
      { className: 'error' },
      field.meta.touched ? field.meta.error : ''
    )
  );
};

var renderSelectField = function renderSelectField(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      children = _ref.children;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      null,
      React.createElement(
        'select',
        (0, _extends3.default)({}, input, { className: 'form-control' }),
        children
      ),
      React.createElement(
        'small',
        { className: 'error' },
        touched ? error : ''
      )
    )
  );
};

var ProfileSetupForm = function (_React$Component) {
  (0, _inherits3.default)(profileSetupForm, _React$Component);

  function profileSetupForm() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, profileSetupForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = profileSetupForm.__proto__ || (0, _getPrototypeOf2.default)(profileSetupForm)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChangeBusinessType = function (event) {
      _this.props.change('businessCategory', '');
      _this.props.dispatch((0, _actions.businessCategories)(event.target.value));
      _this.props.change('businessType', event.target.value);
    }, _this._handleSubmit = function () {
      _this.props.handleSubmit();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(profileSetupForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var userRegState = this.props.data.moka.formRegState;
      if (!userRegState.email || !userRegState.password || !userRegState.confpassword) {
        this.props.dispatch((0, _actions.redirectTo)('register'));
      }
      this.props.dispatch((0, _actions.businessTypes)());
    }
  }, {
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      return React.createElement(
        'form',
        { onSubmit: handleSubmit },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'div',
              { className: _style2.default['mk-sub-section-header'] },
              'business information '
            )
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessName', className: 'sr-only' },
                  'Business Name'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'businessName',
                  maxLength: '100',
                  placeholder: 'Business Name',
                  autoCorrect: 'off',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] + ' ' + _style2.default['margin-bottom-5'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessType', className: 'sr-only' },
                  'Business Type'
                ),
                React.createElement(
                  _reduxForm.Field,
                  {
                    name: 'businessType',
                    className: 'form-control',
                    onChange: this.handleChangeBusinessType,
                    id: 'business_type_id',
                    component: renderSelectField },
                  React.createElement(
                    'option',
                    { key: 0, value: '' },
                    '- Business Type -'
                  ),
                  this.props.businessTypes.map(function (option) {
                    return React.createElement(
                      'option',
                      { value: option.id, key: option.id },
                      option.name
                    );
                  })
                ),
                React.createElement('br', null)
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] + ' ' + _style2.default['margin-bottom-5'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessCategory', className: 'sr-only' },
                  'Business Category'
                ),
                React.createElement(
                  _reduxForm.Field,
                  {
                    name: 'businessCategory',
                    className: 'form-control',
                    id: 'business_category_id',
                    component: renderSelectField },
                  React.createElement(
                    'option',
                    { key: 0, value: '' },
                    '- Category -'
                  ),
                  this.props.businessCategories.map(function (option) {
                    return React.createElement(
                      'option',
                      { value: option.id, key: option.id },
                      option.name
                    );
                  })
                ),
                React.createElement('br', null)
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessAddress', className: 'sr-only' },
                  'Address'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'businessAddress',
                  placeholder: 'Address',
                  maxLength: '255',
                  autoCorrect: 'off',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row ' + _style2.default['divider-business-information'] },
            React.createElement(
              'div',
              { className: 'col-md-4 col-lg-4 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessCity', className: 'sr-only' },
                  'Business City'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'businessCity',
                  placeholder: 'City',
                  maxLength: '50',
                  autoCorrect: 'off',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 col-lg-4 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessState', className: 'sr-only' },
                  'Business State'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'businessProvince',
                  maxLength: '50',
                  placeholder: 'State',
                  autoCorrect: 'off',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-4 col-lg-4 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'businessZipCode', className: 'sr-only' },
                  'Business Zip Code'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'businessPostalCode',
                  maxLength: '5',
                  placeholder: 'Zip',
                  autoCorrect: 'off',
                  type: 'tel',
                  autoCapitalize: 'off',
                  onKeyPress: true,
                  setOnlyNumber: this.setOnlyNumber,
                  spellCheck: 'false',
                  keyboardType: 'numeric' })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement('div', { className: _style2.default['mk-divider-section-line'] })
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'div',
              { className: _style2.default['mk-sub-section-header'] },
              'user information'
            )
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'row' },
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'firstName', className: 'sr-only' },
                  'First Name'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'userFirstName',
                  placeholder: 'First Name',
                  autoCorrect: 'off',
                  maxLength: '30',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-6 col-lg-6 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'lastName', className: 'sr-only' },
                  'Last Name'
                ),
                React.createElement(_reduxForm.Field, {
                  component: inputField,
                  name: 'userLastName',
                  placeholder: 'Last Name',
                  autoCorrect: 'off',
                  maxLength: '30',
                  autoCapitalize: 'off',
                  spellCheck: 'false' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row mb-20px;' },
            React.createElement(
              'div',
              { className: 'col-md-12 col-lg-12 col-sm-12' },
              React.createElement(
                'div',
                { className: _style2.default['form-group'] },
                React.createElement(
                  'label',
                  { htmlFor: 'Phone', className: 'sr-only' },
                  'Phone'
                ),
                React.createElement(_reduxForm.Field, {
                  component: _PhoneNumberField2.default,
                  name: 'userPhone',
                  type: 'tel',
                  placeholder: '812',
                  showTextError: true })
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement('div', { className: _style2.default['mk-divider-section-line'] })
          )
        ),
        React.createElement(
          'div',
          { className: 'row ' + _style2.default['row-continue'] },
          React.createElement(
            'div',
            { className: 'col-lg-12' },
            React.createElement(
              'button',
              { className: 'btn btn-primary pull-right', type: 'submit', onClick: this._onClickSubmitButton },
              'Continue'
            )
          )
        )
      );
    }
  }, {
    key: 'setOnlyNumber',
    value: function setOnlyNumber(e) {
      var regex = /[0-9:]+/g;
      if (!regex.test(e.key)) {
        e.preventDefault();
      }
    }
  }]);
  return profileSetupForm;
}(React.Component);

ProfileSetupForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool,
  businessTypes: React.PropTypes.array,
  businessCategories: React.PropTypes.array
};

ProfileSetupForm = (0, _reduxForm.reduxForm)({
  form: 'profileSetupForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(ProfileSetupForm);

function select(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(select)(ProfileSetupForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _RegisterForm = __webpack_require__(1523);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _ProfileSetupForm = __webpack_require__(1521);

var _ProfileSetupForm2 = _interopRequireDefault(_ProfileSetupForm);

var _actions = __webpack_require__(18);

var _auth = __webpack_require__(605);

var _style = __webpack_require__(771);

var _style2 = _interopRequireDefault(_style);

var _AuthTitle = __webpack_require__(443);

var _AuthTitle2 = _interopRequireDefault(_AuthTitle);

var _register = __webpack_require__(655);

var mpRegister = _interopRequireWildcard(_register);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global fbq:true */
var Register = function (_React$Component) {
  (0, _inherits3.default)(Register, _React$Component);

  function Register() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Register);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).call.apply(_ref, [this].concat(args))), _this), _this.handleRegisterSubmit = function (values) {
      var email = values.email,
          password = values.password,
          confpassword = values.confpassword;

      _this.props.dispatch((0, _actions.registerRequest)({ email: email, password: password, confpassword: confpassword }));
    }, _this.handleProfileSetupSubmit = function (values) {
      var moka = _this.props.data.moka;
      var formRegState = moka.formRegState;

      _this.props.dispatch((0, _actions.registerBusinessRequest)({
        business: {
          business_type_id: values.businessType,
          business_category_id: values.businessCategory,
          name: values.businessName,
          address: values.businessAddress,
          city: values.businessCity,
          province: values.businessProvince,
          postal_code: values.businessPostalCode
        },
        user: {
          email: formRegState.email,
          password: formRegState.password,
          password_confirmation: formRegState.confpassword,
          first_name: values.userFirstName,
          last_name: values.userLastName,
          phone: '0' + values.userPhone
        },
        agent: 'browser'
      }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Register, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatch((0, _actions.setIsRegistered)(false));
      var ref = this.props.location.query.ref;
      var referral = this.props.data.auth.referral;
      // if the new code is different from old referral in state

      if (ref && ref !== referral.code) {
        this.props.dispatch((0, _auth.referralRequest)(ref));
      } else {
        this.props.dispatch((0, _auth.changeReferralData)({}));
      }
      mpRegister.registrationStart({});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Facebook Pixel
      fbq('init', '1661541900796850');
      fbq('track', 'Lead');

      // Google Adwords Conversion Tracking
      // The CDATA tag is required for testing the track plugin in local browser
      window.google_trackConversion({
        google_conversion_id: 950464113,
        google_conversion_label: 'XMqECJva4mQQ8dybxQM',
        google_remarketing_only: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var dispatch = this.props.dispatch;
      var ref = this.props.location.query.ref;
      var _props$data$moka = this.props.data.moka,
          currentlySending = _props$data$moka.currentlySending,
          error = _props$data$moka.error,
          isRegistered = _props$data$moka.isRegistered;
      var referral = this.props.data.auth.referral;
      var name = referral.name;

      return React.createElement(
        'div',
        null,
        !isRegistered ? React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: _style2.default.root },
            React.createElement(_AuthTitle2.default, { title: name && ref ? 'Referral Sign Up - ' + name : 'Sign Up' }),
            React.createElement(_RegisterForm2.default, {
              dispatch: dispatch,
              history: this.props.history,
              onSubmit: this.handleRegisterSubmit,
              btnText: 'Create Account',
              error: error,
              currentlySending: currentlySending,
              showChapcha: this.props.params.chapcha })
          ),
          ref && referral.code && React.createElement(
            'div',
            { className: 'mk-referral-banner ng-scope' },
            React.createElement(
              'div',
              { className: 'col-md-12' },
              React.createElement('img', { alt: 'Telkomsel', className: 'img img-responsive', src: referral.logo_url })
            )
          )
        ) : React.createElement(
          'section',
          { className: 'profile-setup-form ' },
          React.createElement(
            'div',
            { className: 'container' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-md-7 col-lg-7 col-sm-12' },
                React.createElement(
                  'div',
                  { className: _style2.default['mk-section-header'] },
                  'PROFILE SETUP'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-md-7 col-lg-7 col-sm-12' },
                React.createElement(_ProfileSetupForm2.default, {
                  dispatch: dispatch,
                  history: this.props.history,
                  onSubmit: this.handleProfileSetupSubmit,
                  businessTypes: this.props.data.moka.businessTypesState,
                  businessCategories: this.props.data.moka.businessCategoriesState,
                  error: error,
                  currentlySending: currentlySending }),
                ref && referral.code && React.createElement(
                  'div',
                  { className: 'mk-referral-banner' },
                  React.createElement('img', { alt: 'Telkomsel', className: 'img img-responsive', src: referral.logo_url })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Register;
}(React.Component);

Register.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  location: React.PropTypes.object
};

function select(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(select)(Register);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Captcha = __webpack_require__(1520);

var _Captcha2 = _interopRequireDefault(_Captcha);

var _reduxForm = __webpack_require__(7);

var _AuthField = __webpack_require__(435);

var _AuthField2 = _interopRequireDefault(_AuthField);

var _styleForm = __webpack_require__(2209);

var _styleForm2 = _interopRequireDefault(_styleForm);

var _reactRedux = __webpack_require__(6);

var _env = __webpack_require__(1201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values, props) {
  var errors = {};
  if (!props.data.bars.length) {
    if (!values.email) {
      errors.email = 'The email address is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'The value is not a valid email address';
    }
    if (!values.password) {
      errors.password = 'The password is required';
    } else if (values.password.length < 6) {
      errors.password = 'Password at least have to be 6 characters long';
    }
    if (!values.confpassword) {
      errors.confpassword = 'The password is required';
    } else if (values.confpassword !== values.password) {
      errors.confpassword = 'The password and its confirm are not the same';
    }
    if (!values.captcha) {
      errors.captcha = 'The captcha is not valid';
    }
  }
  return errors;
};

var RegisterForm = function (_React$Component) {
  (0, _inherits3.default)(registerForm, _React$Component);

  function registerForm() {
    (0, _classCallCheck3.default)(this, registerForm);
    return (0, _possibleConstructorReturn3.default)(this, (registerForm.__proto__ || (0, _getPrototypeOf2.default)(registerForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(registerForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          showChapcha = _props.showChapcha;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'form',
          { onSubmit: handleSubmit, className: _styleForm2.default['register-form'], name: 'registerForm' },
          React.createElement(_reduxForm.Field, {
            component: _AuthField2.default,
            name: 'email',
            type: 'text',
            placeholder: 'Email',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            icon: 'fa fa-envelope-o',
            spellCheck: 'false' }),
          React.createElement(_reduxForm.Field, {
            icon: 'fa fa-key',
            component: _AuthField2.default,
            name: 'password',
            type: 'password',
            placeholder: 'Password' }),
          React.createElement(_reduxForm.Field, {
            icon: 'fa fa-lock',
            component: _AuthField2.default,
            name: 'confpassword',
            type: 'password',
            placeholder: 'Confirm Password' }),
          showChapcha === 'disablechapcha' && _env.NODE_ENV === 'development' ? '' : React.createElement(_reduxForm.Field, {
            component: _Captcha2.default,
            name: 'captcha'
          }),
          React.createElement(
            'div',
            { className: _styleForm2.default['submit-btn'] },
            React.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary btn-block', id: 'btn-create-account', disabled: this.props.currentlySending },
              this.props.btnText
            )
          )
        )
      );
    }
  }]);
  return registerForm;
}(React.Component);

RegisterForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  changeForm: React.PropTypes.func,
  btnText: React.PropTypes.string,
  error: React.PropTypes.object,
  currentlySending: React.PropTypes.bool
};

RegisterForm = (0, _reduxForm.reduxForm)({
  form: 'registerForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(RegisterForm);

function select(state) {
  return {
    data: state.notification
  };
}

exports.default = (0, _reactRedux.connect)(select)(RegisterForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(509);

var _style2 = _interopRequireDefault(_style);

var _googlePlayButton = __webpack_require__(2859);

var _googlePlayButton2 = _interopRequireDefault(_googlePlayButton);

var _appStoreLogo = __webpack_require__(2855);

var _appStoreLogo2 = _interopRequireDefault(_appStoreLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadApp = function (_React$Component) {
  (0, _inherits3.default)(DownloadApp, _React$Component);

  function DownloadApp() {
    (0, _classCallCheck3.default)(this, DownloadApp);
    return (0, _possibleConstructorReturn3.default)(this, (DownloadApp.__proto__ || (0, _getPrototypeOf2.default)(DownloadApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(DownloadApp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var userAgentString = navigator.userAgent;
      var linkAndroid = $('#googlePlayLink');
      var linkIos = $('#appstoreLink');
      if (userAgentString.indexOf('iPhone') > -1 || userAgentString.indexOf('iPod') > -1 || userAgentString.indexOf('iPad') > -1) {
        linkIos.attr('href', 'itms-apps://itunes.apple.com/app/id955811575');
        linkAndroid.attr('href', 'https://play.google.com/store/apps/details?id=com.mokapos.android');
        linkIos.attr('target', '');
      } else if (/Android/.test(userAgentString)) {
        linkIos.attr('href', 'https://itunes.apple.com/us/app/moka-pos/id955811575');
        linkAndroid.attr('href', 'market://details?id=com.mokapos.android');
        linkAndroid.attr('target', '');
      } else {
        linkIos.attr('href', 'https://itunes.apple.com/us/app/moka-pos/id955811575');
        linkAndroid.attr('href', 'https://play.google.com/store/apps/details?id=com.mokapos.android');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _style2.default.bold },
          'DOWNLOAD THE APP'
        ),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'col-md-8 no-padding' },
          React.createElement(
            'p',
            null,
            'Download the Moka app for iPad from the App Store or for Android smartphones from the Google Play Store. Start selling today!'
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-4' },
          React.createElement(
            'a',
            { href: '#', id: 'appstoreLink', target: '_blank' },
            React.createElement('img', { src: _appStoreLogo2.default, className: _style2.default['logoButton'] })
          ),
          React.createElement('br', null),
          React.createElement('br', null),
          React.createElement(
            'a',
            { href: '#', id: 'googlePlayLink', target: '_blank' },
            React.createElement('img', { src: _googlePlayButton2.default, className: _style2.default['logoButton'] })
          ),
          React.createElement('br', null),
          React.createElement('br', null),
          React.createElement('br', null)
        )
      );
    }
  }]);
  return DownloadApp;
}(React.Component);

exports.default = DownloadApp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DownloadApp = __webpack_require__(1524);

var _DownloadApp2 = _interopRequireDefault(_DownloadApp);

var _SignIn = __webpack_require__(1526);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(509);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global fbq:true */
var RegisterComplete = function (_React$Component) {
  (0, _inherits3.default)(RegisterComplete, _React$Component);

  function RegisterComplete() {
    (0, _classCallCheck3.default)(this, RegisterComplete);
    return (0, _possibleConstructorReturn3.default)(this, (RegisterComplete.__proto__ || (0, _getPrototypeOf2.default)(RegisterComplete)).apply(this, arguments));
  }

  (0, _createClass3.default)(RegisterComplete, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Facebook Pixel
      fbq('init', '1661541900796850');
      fbq('track', 'CompleteRegistration');

      // Google Adwords Conversion Tracking
      /* <![CDATA[ */
      window.google_trackConversion({
        google_conversion_id: 950464113,
        google_conversion_label: 'tialCPGY7WQQ8dybxQM',
        google_remarketing_only: false
      });
      // ]]>
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row', id: 'registerComplete' },
          React.createElement(
            'div',
            { className: 'col-md-2' },
            '\xA0'
          ),
          React.createElement(
            'div',
            { className: 'col-md-8', id: 'all-set' },
            React.createElement(
              'center',
              null,
              React.createElement(
                'h2',
                null,
                'All Set'
              ),
              React.createElement('br', null)
            ),
            React.createElement(
              'div',
              { className: _style2.default['bold'] },
              'VERIFY YOUR ACCOUNT'
            ),
            React.createElement('hr', null),
            React.createElement(
              'div',
              { className: 'col-md-12 no-padding mb-40px' },
              React.createElement(
                'p',
                null,
                'Go to your email and click on the link we provide to verify your account.'
              ),
              React.createElement(
                'p',
                null,
                'Not received an email? ',
                React.createElement(
                  _reactRouter.Link,
                  { to: '/resend' },
                  'Resend email.'
                )
              )
            ),
            React.createElement(_DownloadApp2.default, null),
            React.createElement(_SignIn2.default, null)
          ),
          React.createElement(
            'div',
            { className: 'col-md-2' },
            '\xA0'
          ),
          React.createElement('div', { className: 'clear' })
        )
      );
    }
  }]);
  return RegisterComplete;
}(React.Component);

exports.default = RegisterComplete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(509);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignIn = function (_React$Component) {
  (0, _inherits3.default)(SignIn, _React$Component);

  function SignIn() {
    (0, _classCallCheck3.default)(this, SignIn);
    return (0, _possibleConstructorReturn3.default)(this, (SignIn.__proto__ || (0, _getPrototypeOf2.default)(SignIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignIn, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _style2.default.bold },
          'SIGN IN TO YOUR DASHBOARD'
        ),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'col-md-8 no-padding' },
          'Sign in to your Moka dashboard to manage your store'
        ),
        React.createElement(
          'div',
          { className: 'col-md-4' },
          React.createElement(
            _reactRouter.Link,
            { to: '/login', className: 'btn btn-primary pull-right sign-in' },
            'Sign In'
          )
        ),
        React.createElement('br', null)
      );
    }
  }]);
  return SignIn;
}(React.Component);

exports.default = SignIn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _MultipleDropdownSelect = __webpack_require__(1136);

var _MultipleDropdownSelect2 = _interopRequireDefault(_MultipleDropdownSelect);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _OutletModal = __webpack_require__(241);

var _OutletModal2 = _interopRequireDefault(_OutletModal);

var _ActionBar = __webpack_require__(2210);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar(props) {
    (0, _classCallCheck3.default)(this, ActionBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call(this, props));

    _this._onChangeOutlet = function (outletIds) {
      _this.props.onChangeOutlet(outletIds);
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      _this.props.onChangeDate({ startDate: startDate, endDate: endDate });
    };

    _this._onChangeStatuses = function (event, statuses) {
      _this.props.onChangeStatuses(statuses);
    };

    _this._onChangeKeyword = function (event, keyword) {
      _this.props.onChangeKeyword(keyword);
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          showModalOutletMobileState = _props.showModalOutletMobileState;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: _ActionBar2.default['form-group'] + ' form-group pull-left visible-md visible-lg no-margin' },
          React.createElement(_reduxForm.Field, {
            component: _DropdownOutlet2.default,
            outlets: outlets,
            onChangeOutletIds: this._onChangeOutlet,
            name: 'outlet',
            allOutletOption: true
          })
        ),
        React.createElement(
          'div',
          { className: _ActionBar2.default['form-group'] + ' calendar-dashboard pull-left' },
          React.createElement(_reduxForm.Field, {
            component: _DropdownCalendar2.default,
            name: 'date',
            onChange: this._onChangeDate,
            updateServerOnChange: true
          })
        ),
        React.createElement(
          'div',
          { className: _ActionBar2.default['form-group'] + '  visible-md visible-lg pull-left' },
          React.createElement(_reduxForm.Field, {
            component: _MultipleDropdownSelect2.default,
            name: 'statuses',
            onChange: this._onChangeStatuses,
            options: ActionBar.INVOICE_STATUS,
            placeholder: 'Select Status'
          })
        ),
        React.createElement(
          'div',
          { className: _ActionBar2.default['form-group'] + '  visible-md visible-lg pull-left' },
          React.createElement(_reduxForm.Field, {
            component: _SearchBar2.default,
            name: 'keyword',
            onChange: this._onChangeKeyword,
            placeholder: 'Search'
          })
        ),
        React.createElement(_reduxForm.Field, {
          component: _OutletModal2.default,
          name: 'outlet',
          outlets: outlets,
          onChangeOutletIds: this._onChangeOutlet,
          allOutletOption: true,
          show: showModalOutletMobileState
        })
      );
    }
  }]);
  return ActionBar;
}(React.Component);

ActionBar.INVOICE_STATUS = {
  'cancelled': 'Cancelled',
  'unpaid': 'Unpaid',
  'overdue': 'Overdue',
  'paid': 'Paid',
  'partially_paid': 'Partially Paid'
};


var mapForm = {
  form: 'search'
};

function mapStateToProps(state) {
  return {
    outlets: state.reports.invoices.outlets,
    showModalOutletMobileState: state.moka.showModalOutletMobile
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func,
  onChangeDate: React.PropTypes.func,
  onChangeStatuses: React.PropTypes.func,
  onChangeKeyword: React.PropTypes.func
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _invoices = __webpack_require__(170);

var _style = __webpack_require__(2211);

var _style2 = _interopRequireDefault(_style);

var _formatter = __webpack_require__(11);

var _ReceiptInvoices = __webpack_require__(299);

var _ReceiptInvoices2 = _interopRequireDefault(_ReceiptInvoices);

var _ReceiptButtonGroup = __webpack_require__(641);

var _ReceiptButtonGroup2 = _interopRequireDefault(_ReceiptButtonGroup);

var _RecordPaymentModal = __webpack_require__(1173);

var _RecordPaymentModal2 = _interopRequireDefault(_RecordPaymentModal);

var _CancelInvoiceModal = __webpack_require__(1179);

var _CancelInvoiceModal2 = _interopRequireDefault(_CancelInvoiceModal);

var _OldCancelInvoiceModal = __webpack_require__(1180);

var _OldCancelInvoiceModal2 = _interopRequireDefault(_OldCancelInvoiceModal);

var _ReceiptInvoicesModal = __webpack_require__(1529);

var _ReceiptInvoicesModal2 = _interopRequireDefault(_ReceiptInvoicesModal);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(1527);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reactRouter = __webpack_require__(15);

var _loadingSpinner = __webpack_require__(46);

var _invoices2 = __webpack_require__(661);

var mpReportsInvoices = _interopRequireWildcard(_invoices2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Invoices = function (_React$Component) {
  (0, _inherits3.default)(Invoices, _React$Component);

  function Invoices(props) {
    (0, _classCallCheck3.default)(this, Invoices);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Invoices.__proto__ || (0, _getPrototypeOf2.default)(Invoices)).call(this, props));

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search = _this.props.search,
          _this$props$search$da = _this$props$search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate,
          keyword = _this$props$search.keyword,
          statuses = _this$props$search.statuses;

      mpReportsInvoices.reportsInvoiceChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate,
        statuses: statuses
      });
      _this.props.dispatch((0, _invoices.changeOutletInvoices)(outletIds, startDate, endDate, statuses, keyword));
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var _this$props$search2 = _this.props.search,
          keyword = _this$props$search2.keyword,
          statuses = _this$props$search2.statuses,
          outlet = _this$props$search2.outlet;

      mpReportsInvoices.reportsInvoiceChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate,
        statuses: statuses
      });
      _this.props.dispatch((0, _invoices.changeDateInvoices)(startDate, endDate, statuses, keyword));
    };

    _this._onChangeStatuses = function (statuses) {
      var _this$props$search3 = _this.props.search,
          _this$props$search3$d = _this$props$search3.date,
          startDate = _this$props$search3$d.startDate,
          endDate = _this$props$search3$d.endDate,
          keyword = _this$props$search3.keyword,
          outlet = _this$props$search3.outlet;

      mpReportsInvoices.reportsInvoiceChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate,
        statuses: statuses
      });
      _this.props.dispatch((0, _invoices.changeStatusInvoices)(statuses, startDate, endDate, keyword));
    };

    _this._onSearch = function (keyword) {
      // close right column
      var toggledClass = 'col-sm-12 col-md-6 col-xs-6';
      $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
      $('#mk-col-left').addClass('col-sm-12');
      $('#mk-col-right').hide();

      var _this$props$search4 = _this.props.search,
          _this$props$search4$d = _this$props$search4.date,
          startDate = _this$props$search4$d.startDate,
          endDate = _this$props$search4$d.endDate,
          statuses = _this$props$search4.statuses;

      var startDateFormatted = startDate.format('D/M/YYYY');
      var endDateFormatted = endDate.format('D/M/YYYY');
      var dispatch = _this.props.dispatch;

      dispatch((0, _invoices.setListInvoice)(null));
      dispatch((0, _loadingSpinner.showPageLoadingSpinner)(true));
      dispatch((0, _invoices.listInvoiceRequest)({
        startDate: startDateFormatted, endDate: endDateFormatted, keyword: keyword, status: statuses, page: 1
      }));
    };

    _this._hideReceipt = function () {
      var isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null;
      _this.setState({
        invoice: null,
        invoiceDetailOpened: false,
        isMobile: isMobile,
        showModal: false
      });
      _this.props.dispatch((0, _invoices.hideReceiptInvoice)(isMobile));
    };

    _this._onClickResendButton = function (invoiceId) {
      _this.props.dispatch((0, _invoices.resendEmail)(invoiceId));
    };

    _this._onClickRecordPayment = function () {
      _this.props.dispatch((0, _invoices.onClickRecordPayment)());
    };

    _this._onHideRecordPayment = function () {
      _this.props.dispatch((0, _invoices.onCancelRecordPayment)());
    };

    _this._showReceiptInvoicePdf = function (invoiceId) {
      _this.props.dispatch((0, _invoices.printReceiptInvoicePdf)(invoiceId));
    };

    _this._onClickCancelInvoiceRefundBreakdown = function () {
      _this.props.dispatch((0, _invoices.showCancelInvoiceModal)());
    };

    _this._onClickCancelInvoiceOldRefund = function () {
      _this.props.dispatch((0, _invoices.showOldCancelInvoiceModal)());
    };

    _this._onClickExportButton = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;
      var statuses = _this.props.search.statuses;
      var keyword = _this.props.search.keyword;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y'), status: statuses, keyword: keyword };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Invoices - ' + dateLabel;
      _this.props.dispatch((0, _invoices.exportInvoices)(query, filename, outlet[0]));
    };

    _this._showReceiptInvoices = function (invoice, event) {
      var isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null;
      _this.setState({
        invoice: invoice,
        invoiceDetailOpened: !isMobile,
        isMobile: isMobile,
        showModal: isMobile
      });
      _this.props.dispatch((0, _invoices.receiptInvoicesRequest)(invoice, isMobile));
    };

    _this._showOutletColumn = function () {
      var outlet = _this.props.search.outlet;

      return outlet && outlet.length > 1;
    };

    _this._dateFormatColumn = function (invoice) {
      var today = new Date();
      var yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      var formattedToday = (0, _moment2.default)(today).format('DD/MM/YYYY');
      var formattedYesterday = (0, _moment2.default)(yesterday).format('DD/MM/YYYY');
      var invoiceDate = invoice.is_refunded ? invoice.refunded_date : invoice.created_at;
      var formattedCreatedAt = (0, _moment2.default)(invoiceDate).format('DD/MM/YYYY');
      return formattedCreatedAt === formattedToday ? 'Today' : formattedCreatedAt === formattedYesterday ? 'Yesterday' : (0, _moment2.default)(invoice.created_at).format('DD MMM YYYY');
    };

    _this._onReachBottom = function () {
      var _this$props$data$repo = _this.props.data.reports.invoices,
          currentPage = _this$props$data$repo.currentPage,
          invoices = _this$props$data$repo.invoices;
      var _this$props$search$da3 = _this.props.search.date,
          startDate = _this$props$search$da3.startDate,
          endDate = _this$props$search$da3.endDate;
      var _this$props$search5 = _this.props.search,
          keyword = _this$props$search5.keyword,
          statuses = _this$props$search5.statuses;

      _this.props.dispatch((0, _invoices.listInvoiceRequest)({ startDate: startDate, endDate: endDate, keyword: keyword, page: currentPage + 1, status: statuses }, invoices));
    };

    _this._hasMore = function () {
      var _this$props$data$repo2 = _this.props.data.reports.invoices,
          currentPage = _this$props$data$repo2.currentPage,
          totalPage = _this$props$data$repo2.totalPage;

      return currentPage < totalPage;
    };

    _this.state = {
      openRecordPayment: false,
      openRefundBreakdownModal: false,
      invoice: null,
      invoiceDetailOpened: false,
      isMobile: false,
      showModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(Invoices, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _invoices.invoicesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$data$reports$i = this.props.data.reports.invoices,
          invoices = _props$data$reports$i.invoices,
          receiptInvoices = _props$data$reports$i.receiptInvoices;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;


      return React.createElement(
        'div',
        { className: 'container-full-nosub ' + _style2.default['invoice-report'], id: 'invoice-content' },
        React.createElement(
          'div',
          { className: 'container no-padding invoice-container' },
          React.createElement(
            'div',
            { className: 'mk-action-bar' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'col-sm-12 col-xs-12 col-md-11 col-lg-10 no-padding' },
                React.createElement(_ActionBar2.default, { onChangeOutlet: this._onChangeOutlet,
                  onChangeDate: this._onChangeDate,
                  onChangeStatuses: this._onChangeStatuses,
                  onChangeKeyword: this._onSearch
                })
              ),
              React.createElement(
                'div',
                { className: 'col-md-1 col-lg-2 col-xs-2 col-sm-2 no-padding visible-md visible-lg' },
                React.createElement(
                  'div',
                  { className: 'pull-right' },
                  React.createElement(
                    'a',
                    { className: 'btn btn-primary btn-export',
                      onClick: this._onClickExportButton },
                    'Export'
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: _style2.default['invoice-table'] },
            React.createElement(
              'div',
              { className: _style2.default['mk-report-invoice'] },
              React.createElement(
                'div',
                { className: _style2.default['row-invoice'] },
                React.createElement(
                  'div',
                  { className: 'col-sm-12 trans-1 no-padding', id: 'mk-col-left' },
                  React.createElement(_NoDataAndLoading2.default, {
                    showLoadingSpinner: showLoadingSpinnerPage,
                    noDataToDisplay: invoices && invoices.length === 0,
                    title: 'No Data To Display',
                    description: '' }),
                  invoices && invoices.length > 0 && React.createElement(
                    'div',
                    { className: _style2.default['div-invoice-table'] + ' ' + (showLoadingSpinnerPage ? _style2.default['hide-table'] : '') },
                    React.createElement(
                      'table',
                      { id: 'invoice-table', className: _style2.default['table-header'] },
                      React.createElement(
                        'thead',
                        null,
                        React.createElement(
                          'tr',
                          null,
                          React.createElement(
                            'th',
                            { className: 'text-center' },
                            'Date'
                          ),
                          React.createElement(
                            'th',
                            { className: 'visible-md visible-lg' },
                            'Invoice Number'
                          ),
                          this._showOutletColumn() && React.createElement(
                            'th',
                            null,
                            'Outlet'
                          ),
                          React.createElement(
                            'th',
                            { className: true },
                            'Customer Name'
                          ),
                          React.createElement(
                            'th',
                            null,
                            'Status'
                          ),
                          React.createElement(
                            'th',
                            null,
                            'Amount'
                          )
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: _style2.default['table-content-wrapper'] },
                      React.createElement(
                        _reactInfiniteScroller2.default,
                        {
                          pageStart: 1,
                          loadMore: this._onReachBottom,
                          hasMore: this._hasMore(),
                          useWindow: false,
                          threshold: 10,
                          initialLoad: false },
                        React.createElement(
                          'table',
                          { className: _style2.default['table-content'] },
                          React.createElement(
                            'tbody',
                            { id: 'invoice-table-tbody' },
                            invoices.map(function (invoice, idx) {
                              var boundRowClick = _this2._showReceiptInvoices.bind(_this2, invoice.id);
                              return React.createElement(
                                'tr',
                                {
                                  className: receiptInvoices !== null && invoice.parent_payment_id === receiptInvoices.id ? 'invoice-row selected' : 'invoice-row',
                                  key: idx,
                                  onClick: boundRowClick },
                                React.createElement(
                                  'td',
                                  { className: 'text-center' },
                                  _this2._dateFormatColumn(invoice)
                                ),
                                React.createElement(
                                  'td',
                                  { className: 'visible-md visible-lg' },
                                  invoice.invoice_no
                                ),
                                _this2._showOutletColumn() && React.createElement(
                                  'td',
                                  { className: _style2.default['col-outlet'] },
                                  invoice.outlet_name
                                ),
                                React.createElement(
                                  'td',
                                  null,
                                  invoice.customer_name,
                                  !invoice.customer_name && invoice.customer_email
                                ),
                                React.createElement('td', { className: _style2.default['col-status'], dangerouslySetInnerHTML: { __html: invoice.status_formatter } }),
                                React.createElement(
                                  'td',
                                  null,
                                  invoice.is_refunded ? '(' + (0, _formatter.currencyFormatter)(invoice.total_collected) + ')' : (0, _formatter.currencyFormatter)(invoice.total_collected)
                                )
                              );
                            })
                          )
                        )
                      )
                    )
                  )
                ),
                receiptInvoices !== null && !this.state.isMobile && this.state.invoiceDetailOpened && React.createElement(
                  'div',
                  { className: 'col-sm-12 trans-1', id: 'mk-col-right' },
                  React.createElement(_ReceiptButtonGroup2.default, {
                    clickResendButton: function clickResendButton() {
                      return _this2._onClickResendButton(receiptInvoices.id);
                    },
                    invoiceDetail: receiptInvoices,
                    onClickRecordPayment: this._onClickRecordPayment,
                    onClickPrintButton: function onClickPrintButton() {
                      return _this2._showReceiptInvoicePdf(receiptInvoices.id);
                    },
                    onCancelInvoice: receiptInvoices.is_refund_breakdown ? this._onClickCancelInvoiceRefundBreakdown : this._onClickCancelInvoiceOldRefund
                  }),
                  React.createElement(
                    'div',
                    { className: 'mk-col-right-box' },
                    React.createElement(_ReceiptInvoices2.default, { invoiceDetail: receiptInvoices })
                  ),
                  React.createElement(
                    'div',
                    { className: 'mk-col-right-action-box bottom invoice-done' },
                    React.createElement(
                      'button',
                      {
                        className: 'btn btn-primary pull-right',
                        id: 'btn-close',
                        onClick: this._hideReceipt },
                      'Done'
                    )
                  )
                ),
                this.state.isMobile && receiptInvoices !== null && React.createElement(_ReceiptInvoicesModal2.default, {
                  onClickDoneButton: this._hideReceipt,
                  _onClickResendButton: function _onClickResendButton() {
                    return _this2._onClickResendButton(receiptInvoices.id);
                  },
                  receiptInvoices: receiptInvoices,
                  _onClickRecordPayment: this._onClickRecordPayment,
                  _showReceiptInvoicePdf: function _showReceiptInvoicePdf() {
                    return _this2._showReceiptInvoicePdf(receiptInvoices.id);
                  },
                  onCancelInvoice: !receiptInvoices.is_refund_breakdown ? this._onClickCancelInvoiceOldRefund : this._onClickCancelInvoiceRefundBreakdown,
                  show: this.state.showModal,
                  onHide: this._hideReceipt
                })
              )
            )
          )
        ),
        receiptInvoices !== null && React.createElement(_RecordPaymentModal2.default, {
          closeRecordPaymentModal: this._onHideRecordPayment,
          onClickCancel: this._onHideRecordPayment
        }),
        receiptInvoices !== null && React.createElement(_CancelInvoiceModal2.default, null),
        receiptInvoices !== null && React.createElement(_OldCancelInvoiceModal2.default, null)
      );
    }

    /**
     *
     * @param {string} date from server
     * @private
     */

  }]);
  return Invoices;
}(React.Component);

Invoices.INVOICE_STATUS = {
  'cancelled': 'Cancelled',
  'unpaid': 'Unpaid',
  'overdue': 'Overdue',
  'paid': 'Paid',
  'partially_paid': 'Partially Paid'
};


var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
      keyword: selector(state, 'keyword'),
      statuses: selector(state, 'statuses')
    },
    data: {
      category: state.category,
      reports: state.reports,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Invoices);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(43)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReceiptInvoices = __webpack_require__(299);

var _ReceiptInvoices2 = _interopRequireDefault(_ReceiptInvoices);

var _ReceiptButtonGroup = __webpack_require__(641);

var _ReceiptButtonGroup2 = _interopRequireDefault(_ReceiptButtonGroup);

var _reactBootstrap = __webpack_require__(10);

var _styleReceipt = __webpack_require__(772);

var _styleReceipt2 = _interopRequireDefault(_styleReceipt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptInvoicesModal = function (_React$Component) {
  (0, _inherits3.default)(ReceiptInvoicesModal, _React$Component);

  function ReceiptInvoicesModal() {
    (0, _classCallCheck3.default)(this, ReceiptInvoicesModal);
    return (0, _possibleConstructorReturn3.default)(this, (ReceiptInvoicesModal.__proto__ || (0, _getPrototypeOf2.default)(ReceiptInvoicesModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReceiptInvoicesModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var receiptInvoices = this.props.receiptInvoices;

      return React.createElement(
        'div',
        null,
        React.createElement(
          _reactBootstrap.Modal,
          { show: this.props.show, bsClass: 'receipt-invoice-modal box-detail-modal modal', backdrop: false },
          React.createElement(
            _reactBootstrap.Modal.Body,
            { className: _styleReceipt2.default['modal-body'] },
            React.createElement(_ReceiptButtonGroup2.default, {
              clickResendButton: function clickResendButton() {
                return _this2.props._onClickResendButton(receiptInvoices.id);
              },
              invoiceDetail: this.props.receiptInvoices,
              onClickRecordPayment: this.props._onClickRecordPayment,
              onClickPrintButton: function onClickPrintButton() {
                return _this2.props._showReceiptInvoicePdf(receiptInvoices.id);
              },
              onCancelInvoice: this.props.onCancelInvoice
            }),
            React.createElement(
              'div',
              { className: 'mk-col-right-box ' + _styleReceipt2.default.details },
              React.createElement(_ReceiptInvoices2.default, { invoiceDetail: this.props.receiptInvoices })
            ),
            React.createElement(
              _reactBootstrap.Modal.Footer,
              null,
              React.createElement(
                _reactBootstrap.Button,
                { className: 'btn btn-primary',
                  onClick: this.props.onHide },
                'Done'
              )
            )
          )
        )
      );
    }
  }]);
  return ReceiptInvoicesModal;
}(React.Component);

exports.default = ReceiptInvoicesModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2238);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Report = function (_React$Component) {
  (0, _inherits3.default)(Report, _React$Component);

  function Report() {
    (0, _classCallCheck3.default)(this, Report);
    return (0, _possibleConstructorReturn3.default)(this, (Report.__proto__ || (0, _getPrototypeOf2.default)(Report)).apply(this, arguments));
  }

  (0, _createClass3.default)(Report, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _style2.default['container-full-nosub'], id: 'reports' },
        React.createElement(
          'div',
          { className: 'container box-report-child ' + _style2.default['container'] },
          this.props.children
        )
      );
    }
  }]);
  return Report;
}(React.Component);

exports.default = Report;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _sales = __webpack_require__(94);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableScrollHorizontalVertical = __webpack_require__(442);

var _TableScrollHorizontalVertical2 = _interopRequireDefault(_TableScrollHorizontalVertical);

var _formatter = __webpack_require__(11);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _CategorySales = __webpack_require__(2213);

var _CategorySales2 = _interopRequireDefault(_CategorySales);

var _reactRouter = __webpack_require__(15);

var _categorySales = __webpack_require__(656);

var mpCategorySales = _interopRequireWildcard(_categorySales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategorySales = function (_React$Component) {
  (0, _inherits3.default)(CategorySales, _React$Component);

  function CategorySales(props) {
    (0, _classCallCheck3.default)(this, CategorySales);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CategorySales.__proto__ || (0, _getPrototypeOf2.default)(CategorySales)).call(this, props));

    _this._formatDataForList = function (categorySales) {
      var parentBody = [];
      var childBody = [];
      var childFoot = {
        total_items_sold: null,
        total_gross_sales: null,
        total_discount: null,
        total_refund: null,
        total_net_sales: null,
        total_cogs: null,
        total_gross_profit: null,
        total_gross_margin: null
      };

      categorySales.map(function (categorySale) {
        var getGrossMargin = categorySale.gross_profit / categorySale.net_sales;
        var calculatedDiscount = this._getDiscount(categorySale);
        parentBody.push(categorySale.name);
        childBody.push({
          items_sold: categorySale.items_sold,
          gross_sales: (0, _formatter.rupiahWithNegative)(categorySale.gross_sales),
          discount: calculatedDiscount !== null ? (0, _formatter.rupiahWithNegativeNumber)(-calculatedDiscount) : '',
          refund: categorySale.refund !== null ? (0, _formatter.rupiahWithNegativeNumber)(-categorySale.refund) : '',
          net_sales: (0, _formatter.rupiahWithNegative)(categorySale.net_sales),
          cogs: categorySale.cogs === null ? '' : (0, _formatter.rupiahWithNegative)(-1 * categorySale.cogs),
          gross_profit: categorySale.gross_profit === null ? '' : (0, _formatter.rupiahWithNegative)(categorySale.gross_profit),
          gross_margin: categorySale.net_sales !== 0 && !isNaN(Math.round(getGrossMargin)) ? (0, _formatter.percentWithNegative)(Math.round(getGrossMargin * 100)) : ''
        });
        childFoot.total_items_sold = childFoot.total_items_sold + categorySale.items_sold;
        childFoot.total_gross_sales = childFoot.total_gross_sales + categorySale.gross_sales;
        childFoot.total_discount = childFoot.total_discount + Math.round(calculatedDiscount);
        childFoot.total_refund = childFoot.total_refund + Math.round(categorySale.refund);
        childFoot.total_net_sales = childFoot.total_net_sales + Math.round(categorySale.net_sales);
        childFoot.total_cogs = childFoot.total_cogs + Math.round(categorySale.cogs);
        childFoot.total_gross_profit = childFoot.total_gross_profit + Math.round(categorySale.gross_profit);
        childFoot.total_gross_margin = childFoot.total_net_sales !== 0 && !isNaN(Math.round(childFoot.total_gross_profit / childFoot.total_net_sales)) ? (0, _formatter.percentWithNegative)(Math.round(childFoot.total_gross_profit / childFoot.total_net_sales * 100)) : ''; // Math.round((childFoot.total_gross_profit / childFoot.total_net_sales) * 100)
      }.bind(_this));

      childFoot.total_gross_sales = (0, _formatter.rupiahWithNegative)(childFoot.total_gross_sales);
      childFoot.total_discount = childFoot.total_discount === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_discount);
      childFoot.total_refund = childFoot.total_refund === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_refund);
      childFoot.total_net_sales = (0, _formatter.rupiahWithNegative)(childFoot.total_net_sales);
      childFoot.total_cogs = childFoot.total_cogs === 0 || isNaN(childFoot.total_cogs) ? '' : (0, _formatter.rupiahWithNegative)(-1 * childFoot.total_cogs);
      childFoot.total_gross_profit = childFoot.total_gross_profit === 0 || isNaN(childFoot.total_gross_profit) ? '' : (0, _formatter.rupiahWithNegative)(childFoot.total_gross_profit);
      childFoot.total_gross_margin = childFoot.total_gross_margin;
      return [parentBody, childBody, childFoot];
    };

    _this._getDiscount = function (categorySale) {
      var discount = null;
      if (categorySale.discount !== null) {
        if (categorySale.redemption !== null) {
          discount = categorySale.discount + categorySale.redemption;
        } else {
          discount = categorySale.discount;
        }
      } else {
        if (categorySale.redemption !== null) {
          discount = categorySale.redemption;
        }
      }
      return discount;
    };

    _this._formatDataForListResponsive = function (categorySales) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        total_items_sold: null,
        total_gross_sales: null
      };
      if (categorySales) {
        categorySales.map(function (categorySale) {
          childBody.push({
            name: categorySale.name,
            items_sold: categorySale.items_sold,
            gross_sales: (0, _formatter.rupiahWithNegative)(categorySale.gross_sales)
          });
          footBody.total_items_sold = footBody.total_items_sold + categorySale.items_sold;
          footBody.total_gross_sales = footBody.total_gross_sales + categorySale.gross_sales;
        });
        footBody.total_gross_sales = (0, _formatter.rupiahWithNegative)(footBody.total_gross_sales);
      }
      return [footBody, childBody];
    };

    _this._onChangeOutlet = function (outletIds) {
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpCategorySales.reportsCategorySalesChangeFilter({
        outletIds: outletIds, startDate: startDate, endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletCategorySales)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._hideHeaderPane = function () {
      Cookies.set('headerPaneCategory', false, { path: '/', domain: '.mokapos.com' });
      _this.setState({ headerPaneCategory: false });
      mpCategorySales.reportsCategorySalesFTUE();
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      var outlet = _this.props.search.outlet;
      mpCategorySales.reportsCategorySalesChangeFilter({
        outletIds: outlet, startDate: startDate, endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateCategorySales)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search = _this.props.search,
          outlet = _this$props$search.outlet,
          _this$props$search$da2 = _this$props$search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Category Sales - ' + dateLabel;
      mpCategorySales.reportsCategorySalesExport({
        outletIds: outlet, startDate: startDate, endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportCategorySales)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false,
      headerPaneCategory: Cookies.get('headerPaneCategory')
    };
    return _this;
  }

  (0, _createClass3.default)(CategorySales, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.categorySalesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$reports$c = this.props.data.reports.categorySales,
          categorySales = _props$data$reports$c.categorySales,
          showLoadingSpinnerReport = _props$data$reports$c.showLoadingSpinnerReport;

      var _formatDataForList = this._formatDataForList(categorySales),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 3),
          parentBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1],
          childFoot = _formatDataForList2[2];

      var _formatDataForListRes = this._formatDataForListResponsive(categorySales),
          _formatDataForListRes2 = (0, _slicedToArray3.default)(_formatDataForListRes, 2),
          childFootResponsive = _formatDataForListRes2[0],
          childBodyResponsive = _formatDataForListRes2[1];

      var fTueStatusCategory = void 0;
      if (Cookies.get('headerPaneCategory') === undefined) {
        fTueStatusCategory = true;
      } else {
        fTueStatusCategory = false;
      }
      return React.createElement(
        'div',
        { id: 'reports-sales-category-sales', className: _CategorySales2.default.wrapper },
        React.createElement(_ActionBar2.default, { onExport: this._onClickExport,
          onChangeOutlet: this._onChangeOutlet,
          onChangeDate: this._onChangeDate
        }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _CategorySales2.default.tableWrapper + ' category-sales-table visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  this.state.headerPaneCategory === undefined && React.createElement(
                    'div',
                    { className: _CategorySales2.default.header_panel + ' panel panel-default' },
                    React.createElement(
                      'div',
                      { className: 'panel-body' },
                      React.createElement(
                        'button',
                        { type: 'button', className: 'close', onClick: this._hideHeaderPane },
                        React.createElement(
                          'span',
                          { 'aria-hidden': 'true' },
                          '\xD7'
                        ),
                        React.createElement(
                          'span',
                          { className: 'sr-only' },
                          'Close'
                        )
                      ),
                      React.createElement(
                        'h5',
                        { className: '' + _CategorySales2.default.thickTitle },
                        'Gross Profit'
                      ),
                      React.createElement(
                        'p',
                        null,
                        'To report gross profit accurately per category, please make sure all items have a COGS.'
                      )
                    )
                  ),
                  categorySales.length > 0 && React.createElement(_TableScrollHorizontalVertical2.default, {
                    parentHeader: 'Category',
                    parentBody: parentBody,
                    parentFoot: 'Total',
                    fTueStatusCategory: fTueStatusCategory,
                    parentClassName: ['p-header', 'p-body', 'p-foot'],
                    childHeaders: ['Items Sold', 'Gross Sales', 'Discount', 'Refund', 'Net Sales', 'COGS', 'Gross Profit', 'Gross Margin'],
                    childBody: childBody,
                    childFoot: childFoot,
                    childHeaderClassName: ['header-item-sold', 'header-gross-sales', 'header-discount', 'header-refund', 'header-net-sales', 'header-cogs', 'header-gross-profit', 'header-gross-margin'],
                    childBodyClassName: ['body-item-sold', 'body-gross-sales', 'body-discount', 'body-refund', 'body-net-sales', 'body-cogs', 'body-gross-profit', '' + _CategorySales2.default.body_gross_margin],
                    childFootClassName: ['foot-item-sold', 'foot-gross-sales', 'foot-discount', 'foot-refund', 'foot-net-sales', 'foot-cogs', 'foot-gross-profit', '' + _CategorySales2.default.body_gross_margin]
                  }),
                  !categorySales.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _CategorySales2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  this.state.headerPaneCategory === undefined && React.createElement(
                    'div',
                    { className: _CategorySales2.default.header_panel + ' panel panel-default' },
                    React.createElement(
                      'div',
                      { className: 'panel-body' },
                      React.createElement(
                        'button',
                        { type: 'button', className: 'close', onClick: this._hideHeaderPane },
                        React.createElement(
                          'span',
                          { 'aria-hidden': 'true' },
                          '\xD7'
                        ),
                        React.createElement(
                          'span',
                          { className: 'sr-only' },
                          'Close'
                        )
                      ),
                      React.createElement(
                        'h5',
                        { className: '' + _CategorySales2.default.thickTitle },
                        'Gross Profit'
                      ),
                      React.createElement(
                        'p',
                        null,
                        'To report gross profit accurately per category, please make sure all items have a COGS.'
                      )
                    )
                  ),
                  categorySales.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Items Sold', 'Gross Sales'],
                    childBody: childBodyResponsive,
                    footBody: childFootResponsive,
                    tableClass: 'category-sales-table-responsive',
                    headerBodyClassName: ['header-name', 'header-items-sold', 'header-gross-sales'],
                    childBodyClassName: ['body-name', 'body-items-sold', 'body-gross-sales'],
                    footBodyClassName: ['foot-name', 'foot-items-sold', 'foot-gross-sales'] }),
                  !categorySales.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CategorySales;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        categorySales: state.reports.categorySales
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(CategorySales);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _CollectedBy = __webpack_require__(2214);

var _CollectedBy2 = _interopRequireDefault(_CollectedBy);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__(15);

var _collected = __webpack_require__(657);

var mpCollectedBy = _interopRequireWildcard(_collected);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectedBy = function (_React$Component) {
  (0, _inherits3.default)(CollectedBy, _React$Component);

  function CollectedBy(props) {
    (0, _classCallCheck3.default)(this, CollectedBy);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CollectedBy.__proto__ || (0, _getPrototypeOf2.default)(CollectedBy)).call(this, props));

    _this._formatDataForList = function (staffReports, staffs) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        title: null,
        total_transaction_count: staffs.total_transaction_count,
        total_transaction_amount: (0, _formatter.rupiahWithNegativeWithoutBracket)(staffs.total_transaction_amount)
      };
      if (staffReports) {
        staffReports.map(function (staffReport) {
          childBody.push({
            staff_name: staffReport.staff_name,
            staff_title: staffReport.staff_title,
            staff_transaction_count: staffReport.staff_transaction_count,
            staff_transaction_amount: (0, _formatter.rupiahWithNegativeWithoutBracket)(staffReport.staff_transaction_amount)
          });
        });
      }
      return [footBody, childBody];
    };

    _this._formatFootBody = function (footBody) {
      delete footBody.title;
      return footBody;
    };

    _this._formatChildBody = function (childBody) {
      var result = [];
      childBody.map(function (val) {
        delete val.staff_title;
        result.push(val);
      });
      return result;
    };

    _this._onChangeOutlet = function (outletIds) {
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpCollectedBy.reportCollectedChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletCollectedBy)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpCollectedBy.reportCollectedChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateCollectedBy)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search = _this.props.search,
          outlet = _this$props$search.outlet,
          _this$props$search$da2 = _this$props$search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Staff - ' + dateLabel;
      mpCollectedBy.reportCollectedExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportCollectedBy)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(CollectedBy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.collectedByPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$reports$s = this.props.data.reports.staffs,
          staffs = _props$data$reports$s.staffs,
          showLoadingSpinnerReport = _props$data$reports$s.showLoadingSpinnerReport;

      var staffData = [];
      for (var key in staffs.staff_reports) {
        staffData.push(staffs.staff_reports[key]);
      }
      // dari server udah sorted by id harusnya
      // just to make sure
      staffData = staffData.sort(function (a, b) {
        return a.staff_id - b.staff_id;
      });

      var _formatDataForList = this._formatDataForList(staffData, staffs),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 2),
          footBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1];

      var footBodyResponsive = this._formatFootBody(_lodash2.default.cloneDeep(footBody));
      var childBodyResponsive = this._formatChildBody(_lodash2.default.cloneDeep(childBody));

      return React.createElement(
        'div',
        { id: 'reports-sales-collected-by', className: '' + _CollectedBy2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _CollectedBy2.default.tableWrapper + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  staffData.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Title', 'Number of Transactions', 'Total Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'collected-by-table',
                    headerBodyClassName: ['header-name', 'header-titla', 'header-number-of-transaction', 'header-total-collected'],
                    childBodyClassName: ['body-name', 'body-titla', 'body-number-of-transaction', 'body-total-collected'],
                    footBodyClassName: ['foot-name', 'foot-titla', 'foot-number-of-transaction', 'foot-total-collected'] }),
                  !staffData.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _CollectedBy2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  staffData.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Number of Transactions', 'Total Collected'],
                    childBody: childBodyResponsive,
                    footBody: footBodyResponsive,
                    tableClass: 'collected-by-table-responsive',
                    headerBodyClassName: ['header-name', 'header-number-of-transaction', 'header-total-collected'],
                    childBodyClassName: ['body-name', 'body-number-of-transaction', 'body-total-collected'],
                    footBodyClassName: ['foot-name', 'foot-number-of-transaction', 'foot-total-collected'] }),
                  !staffData.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CollectedBy;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        staffs: state.reports.staffs
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(CollectedBy);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _sales = __webpack_require__(94);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _Discounts = __webpack_require__(2215);

var _Discounts2 = _interopRequireDefault(_Discounts);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableScrollHorizontalVertical = __webpack_require__(442);

var _TableScrollHorizontalVertical2 = _interopRequireDefault(_TableScrollHorizontalVertical);

var _formatter = __webpack_require__(11);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _reactRouter = __webpack_require__(15);

var _discounts = __webpack_require__(658);

var mpDiscounts = _interopRequireWildcard(_discounts);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discounts = function (_React$Component) {
  (0, _inherits3.default)(Discounts, _React$Component);
  (0, _createClass3.default)(Discounts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.discountsPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function Discounts(props) {
    (0, _classCallCheck3.default)(this, Discounts);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Discounts.__proto__ || (0, _getPrototypeOf2.default)(Discounts)).call(this, props));

    _this._formatDataForList = function (discounts) {
      var parentBody = [];
      var childBody = [];
      var childFoot = {
        total_discount_amount: null,
        total_count: null,
        total_discount_applied: null,
        total_discount_refunded: null,
        total_net_discount: null
      };
      discounts.map(function (discount) {
        parentBody.push(discount.name);
        childBody.push({
          amount: discount.discount_type === 'cash' ? 'Rp. ' + Math.round(discount.amount) : discount.amount + '%',
          count: discount.count,
          discount_applied: (0, _formatter.rupiahWithNegative)(-discount.discount_applied),
          refund: (0, _formatter.currencyFormatterWithoutFloat)(discount.refund),
          net_discount: (0, _formatter.rupiahWithNegative)(-discount.net_discount)
        });
        childFoot.total_count = childFoot.total_count + discount.count;
        childFoot.total_discount_applied = childFoot.total_discount_applied + Math.round(discount.discount_applied);
        childFoot.total_discount_refunded = childFoot.total_discount_refunded + Math.round(discount.refund);
        childFoot.total_net_discount = childFoot.total_net_discount + Math.round(discount.net_discount);
      });

      childFoot.total_count = childFoot.total_count;
      childFoot.total_discount_applied = (0, _formatter.rupiahWithNegative)(-childFoot.total_discount_applied);
      childFoot.total_discount_refunded = childFoot.total_discount_refunded === 0 ? null : (0, _formatter.rupiahWithNegative)(childFoot.total_discount_refunded);
      childFoot.total_net_discount = childFoot.total_net_discount === 0 ? null : (0, _formatter.rupiahWithNegative)(-childFoot.total_net_discount);

      return [parentBody, childBody, childFoot];
    };

    _this._formatDataForListResponsive = function (discounts) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        total_discount_amount: null,
        total_discount_count: null
      };
      if (discounts) {
        discounts.map(function (discount) {
          childBody.push({
            name: discount.name,
            amount: discount.discount_type === 'cash' ? 'Rp. ' + Math.round(discount.amount) : discount.amount + '%',
            count: discount.count
          });
          footBody.total_discount_count = footBody.total_discount_count + discount.count;
        });
      }
      return [footBody, childBody];
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpDiscounts.reportsDiscountChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletDiscounts)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpDiscounts.reportsDiscountChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      var outletIds = _this.props.search.outlet.join(',');
      _this.props.dispatch((0, _sales.changeDateDiscounts)(startDate.toDate(), endDate.toDate(), outletIds));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;
      mpDiscounts.reportsDiscountExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y'), outletIds: outlet.join(',') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var outletName = outlet.length > 1 ? 'All Outlets' : _this.props.data.reports.discounts.outlets.find(function (e) {
        return e.id === outlet[0];
      }).name;
      var filename = 'Report Discounts -   ' + dateLabel + ' - ' + outletName;
      _this.props.dispatch((0, _sales.exportDiscount)(query, filename));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(Discounts, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$d = this.props.data.reports.discounts,
          discounts = _props$data$reports$d.discounts,
          showLoadingSpinnerReport = _props$data$reports$d.showLoadingSpinnerReport;

      var _formatDataForList = this._formatDataForList(discounts),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 3),
          parentBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1],
          childFoot = _formatDataForList2[2];

      var _formatDataForListRes = this._formatDataForListResponsive(discounts),
          _formatDataForListRes2 = (0, _slicedToArray3.default)(_formatDataForListRes, 2),
          childFootResponsive = _formatDataForListRes2[0],
          childBodyResponsive = _formatDataForListRes2[1];

      return React.createElement(
        'div',
        { id: 'reports-sales-discounts', className: _Discounts2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Discounts2.default.tableWrapper + ' discount-sales-table visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  discounts.length > 0 && React.createElement(_TableScrollHorizontalVertical2.default, {
                    parentHeader: 'Name',
                    parentBody: parentBody,
                    parentFoot: 'Total',
                    parentClassName: ['p-header', 'p-body', 'p-foot'],
                    childHeaders: ['Discount Amount', 'Count', 'Gross Discount', 'Discount Refunded', 'Net Discount'],
                    childBody: childBody,
                    childFoot: childFoot,
                    childHeaderClassName: ['header-discount-amount', 'header-count', 'header-gross-discount', 'header-discount-refunded', 'header-net-discount'],
                    childBodyClassName: ['body-discount-amount', 'body-count', 'body-gross-discount', 'body-discount-refunded', 'body-net-discount'],
                    childFootClassName: ['foot-discount-amount', 'foot-count', 'foot-gross-discount', 'foot-discount-refunded', 'foot-net-discount']
                  }),
                  !discounts.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Discounts2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  discounts.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Discount Amount', 'Count'],
                    childBody: childBodyResponsive,
                    footBody: childFootResponsive,
                    tableClass: 'discount-sales-table-responsive',
                    headerBodyClassName: ['header-name', 'header-discount-amount', 'header-count'],
                    childBodyClassName: ['body-name', 'body-discount-amount', 'body-count'],
                    footBodyClassName: ['foot-name', 'foot-discount-amount', 'foot-count'] }),
                  !discounts.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Discounts;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        discounts: state.reports.discounts
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(Discounts);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _sales = __webpack_require__(94);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _Gratuity = __webpack_require__(2216);

var _Gratuity2 = _interopRequireDefault(_Gratuity);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _formatter = __webpack_require__(11);

var _reactRouter = __webpack_require__(15);

var _gratuity = __webpack_require__(659);

var mpReportGratuity = _interopRequireWildcard(_gratuity);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Gratuity = function (_React$Component) {
  (0, _inherits3.default)(Gratuity, _React$Component);

  function Gratuity(props) {
    (0, _classCallCheck3.default)(this, Gratuity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Gratuity.__proto__ || (0, _getPrototypeOf2.default)(Gratuity)).call(this, props));

    _this._formatDataForList = function (gratuities, totalGratuityCollected) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        total_amount: null,
        totalGratuityCollected: (0, _formatter.rupiahWithNegativeWithoutBracket)(totalGratuityCollected)
      };
      if (gratuities) {
        gratuities.map(function (gratuity) {
          childBody.push({
            name: gratuity.name,
            amount: gratuity.amount + '%',
            gratuity_collected: (0, _formatter.rupiahWithNegativeWithoutBracket)(gratuity.gratuity_collected)
          });
        });
      }
      return [footBody, childBody];
    };

    _this._onChangeOutlet = function (outletIds) {
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpReportGratuity.reportsGratuityChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletGratuity)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpReportGratuity.reportsGratuityChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateGratuity)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search = _this.props.search,
          outlet = _this$props$search.outlet,
          _this$props$search$da2 = _this$props$search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Gratuity - ' + dateLabel;
      mpReportGratuity.reportsGratuityExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportGratuity)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(Gratuity, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.gratuityPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$reports$g = this.props.data.reports.gratuities.gratuities,
          reportsGratuities = _props$data$reports$g.reports_gratuities,
          totalGratuityCollected = _props$data$reports$g.total_gratuity_collected;
      var gratuities = this.props.data.reports.gratuities;

      var _formatDataForList = this._formatDataForList(reportsGratuities, totalGratuityCollected),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 2),
          footBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1];

      return React.createElement(
        'div',
        { id: 'reports-sales-gratuity', className: _Gratuity2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate,
          onChangeOutlet: this._onChangeOutlet,
          onExport: this._onClickExport
        }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Gratuity2.default.tableWrapper + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: gratuities.showLoadingSpinnerReport }),
                  reportsGratuities && reportsGratuities.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Rate', 'Gratuity Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'gratuity-table',
                    headerBodyClassName: ['header-name', 'header-rate', 'header-gratuity-collected'],
                    childBodyClassName: ['body-name', 'body-rate', 'body-gratuity-collected'],
                    footBodyClassName: ['foot-name', 'foot-rate', 'foot-gratuity-collected'] }),
                  reportsGratuities && !reportsGratuities.length && !gratuities.showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Gratuity2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: gratuities.showLoadingSpinnerReport }),
                  reportsGratuities && reportsGratuities.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Rate', 'Gratuity Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'gratuity-table-responsive',
                    headerBodyClassName: ['header-name', 'header-rate', 'header-gratuity-collected'],
                    childBodyClassName: ['body-name', 'body-rate', 'body-gratuity-collected'],
                    footBodyClassName: ['foot-name', 'foot-rate', 'foot-gratuity-collected'] }),
                  reportsGratuities && !reportsGratuities.length && !gratuities.showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Gratuity;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        gratuities: state.reports.gratuities
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(Gratuity);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _GrossProfit = __webpack_require__(2217);

var _GrossProfit2 = _interopRequireDefault(_GrossProfit);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _reactRouter = __webpack_require__(15);

var _WarningLabel = __webpack_require__(1537);

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

var _reactBootstrap = __webpack_require__(10);

var _grossProfit = __webpack_require__(660);

var mpGrossProfit = _interopRequireWildcard(_grossProfit);

var _InformationModal = __webpack_require__(1536);

var _InformationModal2 = _interopRequireDefault(_InformationModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GrossProfit = function (_React$Component) {
  (0, _inherits3.default)(GrossProfit, _React$Component);
  (0, _createClass3.default)(GrossProfit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      var expireTime = 365;
      if (!expired) {
        this.props.dispatch((0, _sales.grossProfitPageRequest)());
        var statusLabelNew = Cookies.get('labelNew') === undefined || Cookies.get('labelNew') === 'true';
        statusLabelNew ? Cookies.set('labelNew', 'true', { path: '/', domain: '.mokapos.com', expires: expireTime }) : Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime });
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function GrossProfit(props) {
    (0, _classCallCheck3.default)(this, GrossProfit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GrossProfit.__proto__ || (0, _getPrototypeOf2.default)(GrossProfit)).call(this, props));

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpGrossProfit.reportGrossProfitChangeFilter({ outletIds: outletIds, startDate: startDate, endDate: endDate });
      _this.props.dispatch((0, _sales.changeOutletGrossProfit)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpGrossProfit.reportGrossProfitChangeFilter({ outletIds: outlet, startDate: startDate, endDate: endDate });
      _this.props.dispatch((0, _sales.changeDateGrossProfit)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Gross Profit - ' + dateLabel;
      _this.props.dispatch((0, _sales.exportGrossProfit)(query, filename, outlet[0]));
    };

    _this._renderTable = function () {
      var gross_profit = _this.props.data.reports.grossProfit.gross_profit;

      var cogsAdjusmentInfo = gross_profit.cogs_adjusment === 0;
      var marginInfo = gross_profit.cogs !== 0 && gross_profit.net_sales > 0;
      var cogsPercent = Math.round(gross_profit.cogs / gross_profit.net_sales * 100);
      var grossProfPercent = Math.round(gross_profit.gross_profit / gross_profit.net_sales * 100);
      var cogsAdjusmentPercent = Math.round(gross_profit.cogs_adjusment / gross_profit.net_sales * 100);

      var discount = _this._getDiscount();
      var popover = React.createElement(
        _reactBootstrap.Popover,
        null,
        React.createElement(
          'p',
          { className: _GrossProfit2.default['tooltip-message'] },
          'COGS adjustment happens when you create a Purchase Order, Refund or have an Incoming Transfer for an item that previously had negative inventory.'
        )
      );
      return React.createElement(
        'table',
        { className: 'table table-responsive mk-table-summary no-margin' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'th',
              null,
              '\xA0'
            ),
            React.createElement(
              'th',
              null,
              '\xA0'
            )
          )
        ),
        React.createElement(
          'tbody',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Gross Sales'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(gross_profit.gross_sales),
              marginInfo && React.createElement('span', { className: _GrossProfit2.default.precent_label_none + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' })
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Discounts'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              discount === 0 ? (0, _formatter.currencyFormatter)(discount) : '(' + (0, _formatter.currencyFormatter)(discount) + ')',
              marginInfo && React.createElement('span', { className: _GrossProfit2.default.precent_label_none + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' })
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Refunds'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(-gross_profit.refund),
              marginInfo && React.createElement('span', { className: _GrossProfit2.default.precent_label_none + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' })
            )
          ),
          React.createElement(
            'tr',
            { className: 'divider' },
            React.createElement(
              'td',
              null,
              React.createElement(
                'strong',
                null,
                'Net Sales'
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right' },
              React.createElement(
                'strong',
                null,
                (0, _formatter.currencyFormatter)(gross_profit.net_sales)
              ),
              marginInfo && React.createElement(
                'span',
                { className: gross_profit.net_sales < 0 ? _GrossProfit2.default.precent_label_danger + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' : _GrossProfit2.default.precent_label + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                '100%'
              )
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              React.createElement(
                'span',
                { className: 'hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                'Cost of Goods Sold (COGS)'
              ),
              React.createElement(
                'span',
                { className: 'visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down' },
                'COGS'
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              gross_profit.cogs > 0 && gross_profit.cogs !== 0 ? (0, _formatter.currencyFormatter)(-gross_profit.cogs) : (0, _formatter.rupiah)(Math.abs(gross_profit.cogs)),
              marginInfo && React.createElement(
                'span',
                { className: gross_profit.cogs >= 0 ? _GrossProfit2.default.precent_label_danger + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' : _GrossProfit2.default.precent_label + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                !isNaN(cogsPercent) ? cogsPercent + '%' : '0%'
              )
            )
          ),
          !cogsAdjusmentInfo && React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              React.createElement(
                'span',
                { className: 'hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                'Cost of Goods Sold (COGS) Adjustment'
              ),
              React.createElement(
                'span',
                { className: 'visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down' },
                'COGS Adjustment'
              ),
              React.createElement(
                'div',
                { className: 'visible-md-inline-block visible-lg-inline-block hidden-sm-down' },
                React.createElement(
                  _reactBootstrap.OverlayTrigger,
                  { trigger: ['click', 'hover', 'focus'], rootClose: true, placement: 'top', overlay: popover },
                  React.createElement(
                    'button',
                    { className: _GrossProfit2.default.btn_warning + ' hidden-xs-down visible-sm-inline-block visible-md-inline-block visible-lg-inline-block', onMouseEnter: _this._onMouseEnterCOGSAdjInfo },
                    React.createElement(_WarningLabel2.default, null)
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down' },
                React.createElement(
                  'button',
                  { className: '' + _GrossProfit2.default.btn_warning, onClick: _this._onClickInfoButton },
                  React.createElement(_WarningLabel2.default, null)
                )
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              gross_profit.cogs_adjusment > 0 && gross_profit.cogs_adjusment !== 0 ? (0, _formatter.currencyFormatter)(-gross_profit.cogs_adjusment) : (0, _formatter.rupiah)(Math.abs(gross_profit.cogs_adjusment)),
              marginInfo && React.createElement(
                'span',
                { className: gross_profit.cogs_adjusment >= 0 ? _GrossProfit2.default.precent_label_danger + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' : _GrossProfit2.default.precent_label + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                !isNaN(cogsAdjusmentPercent) ? Math.abs(cogsAdjusmentPercent) + '%' : '0%'
              )
            )
          )
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'text-total' },
            React.createElement(
              'td',
              null,
              React.createElement(
                'strong',
                null,
                'Gross Profit'
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right' },
              React.createElement(
                'strong',
                null,
                (0, _formatter.currencyFormatter)(gross_profit.gross_profit)
              ),
              marginInfo && React.createElement(
                'span',
                { className: gross_profit.gross_profit < 0 ? _GrossProfit2.default.precent_label_danger + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' : _GrossProfit2.default.precent_label + ' label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block' },
                !isNaN(grossProfPercent) ? grossProfPercent + '%' : '0%'
              )
            )
          )
        )
      );
    };

    _this._onMouseEnterCOGSAdjInfo = function () {
      mpGrossProfit.reportGrossProfitHoverCOGSAdj();
    };

    _this._onClickInfoButton = function () {
      _this.setState({ openInfoModal: true });
    };

    _this._onClickInfoButtonHideModal = function () {
      _this.setState({ openInfoModal: false });
    };

    _this._getDiscount = function () {
      var gross_profit = _this.props.data.reports.grossProfit.gross_profit;

      return gross_profit.discount + gross_profit.redemption;
    };

    _this.state = {
      openSidebar: false,
      openInfoModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(GrossProfit, [{
    key: 'render',
    value: function render() {
      var showLoadingSpinnerReport = this.props.data.reports.grossProfit.showLoadingSpinnerReport;

      return React.createElement(
        'div',
        { id: 'reports-sales-gross-profit', className: _GrossProfit2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _GrossProfit2.default['table-wrapper-responsive'] + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: _GrossProfit2.default.header_panel + ' panel panel-default' },
                    React.createElement(
                      'div',
                      { className: 'panel-body' },
                      React.createElement(
                        'h5',
                        { className: '' + _GrossProfit2.default.thickTitle },
                        'Gross Profit'
                      ),
                      React.createElement(
                        'p',
                        null,
                        'Gross Profit is your Net Sales minus Cost of Goods Sold (COGS). ',
                        React.createElement(
                          'strong',
                          null,
                          'To report gross profit accurately, please make sure all items have a COGS.'
                        )
                      )
                    )
                  ),
                  showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && this._renderTable()
                ),
                React.createElement(
                  'div',
                  { className: _GrossProfit2.default['table-wrapper'] + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  React.createElement(
                    'div',
                    { className: _GrossProfit2.default.header_panel + ' panel panel-default' },
                    React.createElement(
                      'div',
                      { className: 'panel-body' },
                      React.createElement(
                        'h5',
                        { className: '' + _GrossProfit2.default.thickTitle },
                        'Gross Profit'
                      ),
                      React.createElement(
                        'p',
                        null,
                        'Gross Profit is your Net Sales minus Cost of Goods Sold (COGS). ',
                        React.createElement(
                          'strong',
                          null,
                          'To report gross profit accurately, please make sure all items have a COGS.'
                        )
                      )
                    )
                  ),
                  !showLoadingSpinnerReport && this._renderTable()
                )
              )
            )
          )
        ),
        React.createElement(_InformationModal2.default, { onShow: this.state.openInfoModal, click: this._onClickInfoButtonHideModal })
      );
    }
  }]);
  return GrossProfit;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        grossProfit: state.reports.grossProfit
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}
exports.default = (0, _reactRedux.connect)(select)(GrossProfit);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(10);

var _InformationModal = __webpack_require__(2218);

var _InformationModal2 = _interopRequireDefault(_InformationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InformationModal = function (_Component) {
  (0, _inherits3.default)(InformationModal, _Component);

  function InformationModal() {
    (0, _classCallCheck3.default)(this, InformationModal);
    return (0, _possibleConstructorReturn3.default)(this, (InformationModal.__proto__ || (0, _getPrototypeOf2.default)(InformationModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(InformationModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onShow = _props.onShow,
          click = _props.click;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: onShow, dialogClassName: _InformationModal2.default['dialog'] + ' ' + _InformationModal2.default['info-modal-wrapper'] + ' modal-dialog', onHide: click },
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                { className: 'text-center ' + _InformationModal2.default['no-mtop'] },
                'Information'
              ),
              _react2.default.createElement(
                'p',
                { className: 'text-center' },
                'COGS adjustment happens when you create a Purchase Order, Refund or have an Incoming Transfer for an item that previously had negative inventory.'
              ),
              _react2.default.createElement(
                'a',
                { onClick: click, className: 'btn btn-default btn-block btn-sm ' + _InformationModal2.default['blue-button'] },
                _react2.default.createElement(
                  'strong',
                  null,
                  'OK'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return InformationModal;
}(_react.Component); /**
                      * Created by alvinoktavianus on 8/11/17.
                      */

exports.default = InformationModal;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WarningLabel = __webpack_require__(2219);

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningLabel = function WarningLabel(_ref) {
  var content = _ref.content;

  return React.createElement(
    'div',
    { className: _WarningLabel2.default['wrapper'] },
    React.createElement('i', { className: 'fa fa-exclamation-circle ' + _WarningLabel2.default.circle }),
    React.createElement(
      'label',
      { className: '' + _WarningLabel2.default.content },
      content
    )
  );
};

exports.default = WarningLabel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Cookies) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _ItemSales = __webpack_require__(2220);

var _ItemSales2 = _interopRequireDefault(_ItemSales);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableScrollHorizontalVertical = __webpack_require__(442);

var _TableScrollHorizontalVertical2 = _interopRequireDefault(_TableScrollHorizontalVertical);

var _formatter = __webpack_require__(11);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _reactRouter = __webpack_require__(15);

var _itemSales = __webpack_require__(662);

var mpItemSales = _interopRequireWildcard(_itemSales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSales = function (_React$Component) {
  (0, _inherits3.default)(ItemSales, _React$Component);

  function ItemSales(props) {
    (0, _classCallCheck3.default)(this, ItemSales);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemSales.__proto__ || (0, _getPrototypeOf2.default)(ItemSales)).call(this, props));

    _this._formatDataForList = function (itemSales) {
      var parentBody = [];
      var childBody = [];
      var childFoot = {
        sku: null,
        category_name: null,
        total_items_sold: null,
        total_gross_sales: null,
        total_discount: null,
        total_refund: null,
        total_net_sales: null,
        total_cogs: null,
        total_gross_profit: null,
        total_gross_margin: null

      };
      itemSales.map(function (itemSale) {
        var getGrossMargin = itemSale.gross_profit / itemSale.net_sales;
        var calculatedDiscount = this._getDiscount(itemSale);
        parentBody.push(itemSale.name);
        childBody.push({
          sku: itemSale.sku,
          category_name: itemSale.category_name,
          items_sold: itemSale.items_sold,
          gross_sales: (0, _formatter.rupiahWithNegativeWithoutBracket)(itemSale.gross_sales),
          discount: calculatedDiscount !== null ? (0, _formatter.rupiahWithNegativeNumber)(-calculatedDiscount) : '',
          refund: itemSale.refund !== null ? (0, _formatter.rupiahWithNegativeNumber)(-itemSale.refund) : '',
          net_sales: (0, _formatter.rupiahWithNegative)(itemSale.net_sales),
          cogs: itemSale.cogs === null ? '' : (0, _formatter.rupiahWithNegative)(-1 * itemSale.cogs),
          gross_profit: itemSale.gross_profit === null ? '' : (0, _formatter.rupiahWithNegative)(itemSale.gross_profit),
          gross_margin: itemSale.net_sales !== 0 && !isNaN(Math.round(getGrossMargin)) ? (0, _formatter.percentWithNegative)(Math.round(getGrossMargin * 100)) : ''
        });

        childFoot.total_items_sold = childFoot.total_items_sold + itemSale.items_sold;
        childFoot.total_gross_sales = childFoot.total_gross_sales + itemSale.gross_sales;
        childFoot.total_discount = childFoot.total_discount + Math.round(calculatedDiscount);
        childFoot.total_refund = childFoot.total_refund + Math.round(itemSale.refund);
        childFoot.total_net_sales = childFoot.total_net_sales + Math.round(itemSale.net_sales);
        childFoot.total_cogs = childFoot.total_cogs + Math.round(itemSale.cogs);
        childFoot.total_gross_profit = childFoot.total_gross_profit + Math.round(itemSale.gross_profit);
        childFoot.total_gross_margin = childFoot.total_net_sales !== 0 && !isNaN(Math.round(childFoot.total_gross_profit / childFoot.total_net_sales)) ? (0, _formatter.percentWithNegative)(Math.round(childFoot.total_gross_profit / childFoot.total_net_sales * 100)) : '';
      }.bind(_this));

      childFoot.total_gross_sales = (0, _formatter.rupiahWithNegativeWithoutBracket)(childFoot.total_gross_sales);
      childFoot.total_discount = childFoot.total_discount === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_discount);
      childFoot.total_refund = childFoot.total_refund === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_refund);
      childFoot.total_net_sales = childFoot.total_net_sales === 0 ? '' : (0, _formatter.rupiahWithNegative)(childFoot.total_net_sales);
      childFoot.total_cogs = childFoot.total_cogs === 0 || isNaN(childFoot.total_cogs) ? '' : (0, _formatter.rupiahWithNegative)(-1 * childFoot.total_cogs);
      childFoot.total_gross_profit = childFoot.total_gross_profit === 0 || isNaN(childFoot.total_gross_profit) ? '' : (0, _formatter.rupiahWithNegative)(childFoot.total_gross_profit);
      childFoot.total_gross_margin = childFoot.total_gross_margin;
      return [parentBody, childBody, childFoot];
    };

    _this._getDiscount = function (itemSale) {
      var discount = null;
      if (itemSale.discount !== null) {
        if (itemSale.redemption !== null) {
          discount = itemSale.discount + itemSale.redemption;
        } else {
          discount = itemSale.discount;
        }
      } else {
        if (itemSale.redemption !== null) {
          discount = itemSale.redemption;
        }
      }
      return discount;
    };

    _this._formatDataForListResponsive = function (itemSales) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        total_items_sold: null,
        total_gross_sales: null
      };

      if (itemSales) {
        itemSales.map(function (itemSale) {
          childBody.push({
            name: itemSale.name,
            items_sold: itemSale.items_sold,
            gross_sales: (0, _formatter.rupiahWithNegativeWithoutBracket)(itemSale.gross_sales)
          });
          footBody.total_gross_sales = footBody.total_gross_sales + itemSale.gross_sales;
          footBody.total_items_sold = footBody.total_items_sold + itemSale.items_sold;
        });
        footBody.total_gross_sales = (0, _formatter.rupiahWithNegativeWithoutBracket)(footBody.total_gross_sales);
      }
      return [footBody, childBody];
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpItemSales.reportsItemSalesChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletItemSales)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._hideHeaderPane = function () {
      Cookies.set('headerPaneSales', false, { path: '/', domain: '.mokapos.com' });
      _this.setState({ headerPaneSales: false });
      mpItemSales.reportsItemSalesFTUE();
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      var outlet = _this.props.search.outlet;
      mpItemSales.reportsItemSalesChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateItemSales)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Item Sales - ' + dateLabel;
      mpItemSales.reportsItemSalesExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportItemSales)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false,
      headerPaneSales: Cookies.get('headerPaneSales')
    };
    return _this;
  }

  (0, _createClass3.default)(ItemSales, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.itemSalesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data$reports$i = this.props.data.reports.itemSales,
          itemSales = _props$data$reports$i.itemSales,
          showLoadingSpinnerReport = _props$data$reports$i.showLoadingSpinnerReport;

      var _formatDataForList = this._formatDataForList(itemSales),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 3),
          parentBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1],
          childFoot = _formatDataForList2[2];

      var _formatDataForListRes = this._formatDataForListResponsive(itemSales),
          _formatDataForListRes2 = (0, _slicedToArray3.default)(_formatDataForListRes, 2),
          childFootResponsive = _formatDataForListRes2[0],
          childBodyResponsive = _formatDataForListRes2[1];

      var fTueStatus = void 0;
      if (Cookies.get('headerPaneSales') === undefined) {
        fTueStatus = true;
      } else {
        fTueStatus = false;
      }
      return React.createElement(
        'div',
        { id: 'reports-sales-item-sales' },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(
              'div',
              { id: 'summary-reports', className: 'full-height' },
              React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
              React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
              React.createElement(
                'div',
                { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-report-sales-content full-height' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger-box visible-xs visible-sm' },
                    React.createElement(
                      'div',
                      { className: 'mk-burger' },
                      React.createElement(
                        'button',
                        { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                        React.createElement(
                          'span',
                          { className: 'sr-only' },
                          'Toggle navigation'
                        ),
                        React.createElement('span', { className: 'icon-bar' }),
                        React.createElement('span', { className: 'icon-bar' }),
                        React.createElement('span', { className: 'icon-bar' })
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemSales2.default.tableWrapper + ' item-sales-table visible-lg visible-md' },
                    React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                    this.state.headerPaneSales === undefined && React.createElement(
                      'div',
                      { className: _ItemSales2.default.header_panel + ' panel panel-default' },
                      React.createElement(
                        'div',
                        { className: 'panel-body' },
                        React.createElement(
                          'button',
                          { type: 'button', className: 'close', onClick: this._hideHeaderPane },
                          React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '\xD7'
                          ),
                          React.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Close'
                          )
                        ),
                        React.createElement(
                          'h5',
                          { className: '' + _ItemSales2.default.thickTitle },
                          'Gross Profit'
                        ),
                        React.createElement(
                          'p',
                          null,
                          'Gross profit for items that do not have a Cost of Goods Sold (COGS) will not be tracked.'
                        )
                      )
                    ),
                    itemSales.length > 0 && React.createElement(_TableScrollHorizontalVertical2.default, {
                      parentHeader: 'Name',
                      parentBody: parentBody,
                      parentFoot: 'Total',
                      parentClassName: ['p-header', 'p-body', 'p-foot'],
                      fTueStatus: fTueStatus,
                      childHeaders: ['SKU', 'Category', 'Items Sold', 'Gross Sales', 'Discount', 'Refund', 'Net Sales', 'COGS', 'Gross Profit', 'Gross Margin'],
                      childBody: childBody,
                      childFoot: childFoot,
                      childHeaderClassName: ['header-sku', 'header-category', 'header-item-sold', 'header-gross-sales', 'header-discount', 'header-refund', 'header-net-sales', 'header-cogs', 'header-gross-profit', 'header-gross-margin'],
                      childBodyClassName: ['body-sku', 'body-category', 'body-item-sold', 'body-gross-sales', 'body-discount', 'body-refund', 'body-net-sales', 'body-cogs', 'body-gross-profit', '' + _ItemSales2.default.body_gross_margin],
                      childFootClassName: ['foot-sku', 'foot-category', 'foot-item-sold', 'foot-gross-sales', 'foot-discount', 'foot-refund', 'foot-net-sales', 'foot-cogs', 'foot-gross-profit', '' + _ItemSales2.default.foot_gross_margin]
                    }),
                    !itemSales.length && !showLoadingSpinnerReport && React.createElement(
                      'div',
                      { className: 'no-data-display-container' },
                      React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: _ItemSales2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                    React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                    this.state.headerPaneSales === undefined && React.createElement(
                      'div',
                      { className: _ItemSales2.default.header_panel + ' panel panel-default' },
                      React.createElement(
                        'div',
                        { className: 'panel-body' },
                        React.createElement(
                          'button',
                          { type: 'button', className: 'close', onClick: this._hideHeaderPane },
                          React.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '\xD7'
                          ),
                          React.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Close'
                          )
                        ),
                        React.createElement(
                          'h5',
                          { className: '' + _ItemSales2.default.thickTitle },
                          'Gross Profit'
                        ),
                        React.createElement(
                          'p',
                          null,
                          'Gross profit for items that do not have a Cost of Goods Sold (COGS) will not be tracked.'
                        )
                      )
                    ),
                    itemSales.length > 0 && React.createElement(_TableWithoutChild2.default, {
                      headerBody: ['Name', 'Item Sold', 'Gross Sales'],
                      childBody: childBodyResponsive,
                      footBody: childFootResponsive,
                      tableClass: 'item-sales-table-responsive',
                      headerBodyClassName: ['header-name', 'header-item-sold', 'header-gross-sales'],
                      childBodyClassName: ['body-name', 'body-item-sold', 'body-gross-sales'],
                      footBodyClassName: ['foot-name', 'foot-item-sold', 'foot-gross-sales'] }),
                    !itemSales.length && !showLoadingSpinnerReport && React.createElement(
                      'div',
                      { className: 'no-data-display-container' },
                      React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ItemSales;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        itemSales: state.reports.itemSales
      },
      outlet: state.outlet,
      calendar: state.calendar,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(ItemSales);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(65)))

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _sales = __webpack_require__(94);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _ModifierSales = __webpack_require__(2221);

var _ModifierSales2 = _interopRequireDefault(_ModifierSales);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableScrollWithChildHorizontalVertical = __webpack_require__(1158);

var _TableScrollWithChildHorizontalVertical2 = _interopRequireDefault(_TableScrollWithChildHorizontalVertical);

var _formatter = __webpack_require__(11);

var _TableWithChild = __webpack_require__(1540);

var _TableWithChild2 = _interopRequireDefault(_TableWithChild);

var _reactRouter = __webpack_require__(15);

var _modifierSales = __webpack_require__(663);

var mpModifierSales = _interopRequireWildcard(_modifierSales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifierSales = function (_React$Component) {
  (0, _inherits3.default)(ModifierSales, _React$Component);
  (0, _createClass3.default)(ModifierSales, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.modifierSalesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function ModifierSales(props) {
    (0, _classCallCheck3.default)(this, ModifierSales);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModifierSales.__proto__ || (0, _getPrototypeOf2.default)(ModifierSales)).call(this, props));

    _this._formatDataForList = function (modifiers) {
      var parentBody = [];
      var childBody = [];
      var childFoot = {
        total_quantity: null,
        total_gross_sales: null,
        total_discount: null,
        total_refund: null,
        total_net_sales: null
      };
      modifiers.map(function (modifier) {
        var calculatedDiscount = this._getDiscount(modifier);
        parentBody.push({ name: modifier.name, isParent: modifier.parent });
        childBody.push({
          data: {
            quantity: modifier.quantity,
            gross_sales: (0, _formatter.rupiahWithNegative)(modifier.gross_sales),
            discount: calculatedDiscount !== null ? (0, _formatter.rupiahWithNegativeNumber)(-calculatedDiscount) : '',
            refund: modifier.refund !== null ? (0, _formatter.rupiahWithNegativeNumber)(-modifier.refund) : '',
            net_sales: (0, _formatter.rupiahWithNegative)(modifier.net_sales)
          },
          isParent: modifier.parent });
        if (modifier.parent) {
          childFoot.total_quantity = childFoot.total_quantity + modifier.quantity;
          childFoot.total_gross_sales = childFoot.total_gross_sales + Math.round(modifier.gross_sales);
          childFoot.total_discount = childFoot.total_discount + Math.round(calculatedDiscount);
          childFoot.total_refund = childFoot.total_refund + Math.round(modifier.refund);
          childFoot.total_net_sales = childFoot.total_net_sales + Math.round(modifier.net_sales);
        }
      }.bind(_this));

      childFoot.total_gross_sales = (0, _formatter.rupiahWithNegative)(Math.round(childFoot.total_gross_sales));
      childFoot.total_discount = childFoot.total_discount === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_discount);
      childFoot.total_refund = childFoot.total_refund === 0 ? null : (0, _formatter.rupiahWithNegativeNumber)(-childFoot.total_refund);
      childFoot.total_net_sales = (0, _formatter.rupiahWithNegative)(childFoot.total_net_sales);

      return [parentBody, childBody, childFoot];
    };

    _this._getDiscount = function (modifier) {
      var discount = null;
      if (modifier.discount !== null) {
        if (modifier.redemption !== null) {
          discount = modifier.discount + modifier.redemption;
        } else {
          discount = modifier.discount;
        }
      } else {
        if (modifier.redemption !== null) {
          discount = modifier.redemption;
        }
      }
      return discount;
    };

    _this._formatDataForListResponsive = function (modifiers) {
      var childBody = [];
      var childFoot = {
        name: 'Total',
        total_quantity: null,
        total_gross_sales: null
      };
      modifiers.map(function (modifier) {
        childBody.push({
          data: {
            name: modifier.name,
            quantity: modifier.quantity,
            gross_sales: (0, _formatter.rupiahWithNegative)(modifier.gross_sales)
          },
          isParent: modifier.parent });
        if (modifier.parent) {
          childFoot.total_quantity = childFoot.total_quantity + modifier.quantity;
          childFoot.total_gross_sales = childFoot.total_gross_sales + Math.round(modifier.gross_sales);
        }
      });

      childFoot.total_gross_sales = (0, _formatter.rupiahWithNegative)(Math.round(childFoot.total_gross_sales));
      return [childBody, childFoot];
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpModifierSales.reportsModifierSalesChangeFilter({
        outletIds: outletIds, startDate: startDate, endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletModifierSales)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpModifierSales.reportsModifierSalesChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateModifierSales)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Modifiers - ' + dateLabel;
      mpModifierSales.reportsModifierSalesExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportModifierSales)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(ModifierSales, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$m = this.props.data.reports.modifierSales,
          modifierSales = _props$data$reports$m.modifierSales,
          showLoadingSpinnerReport = _props$data$reports$m.showLoadingSpinnerReport;

      var data = [];
      modifierSales.forEach(function (m) {
        data.push({
          parent: true,
          name: m.modifier_name,
          quantity: m.quantity,
          gross_sales: m.gross_sales,
          discount: m.discount,
          redemption: m.redemption,
          refund: m.refund,
          net_sales: m.net_sales
        });
        m.modifier_options.forEach(function (mo) {
          data.push({
            parent: false,
            name: mo.option_name,
            quantity: mo.quantity,
            gross_sales: mo.gross_sales,
            discount: mo.discount,
            redemption: mo.redemption,
            refund: mo.refund,
            net_sales: mo.net_sales
          });
        });
      });

      var _formatDataForList = this._formatDataForList(data),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 3),
          parentBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1],
          childFoot = _formatDataForList2[2];

      var _formatDataForListRes = this._formatDataForListResponsive(data),
          _formatDataForListRes2 = (0, _slicedToArray3.default)(_formatDataForListRes, 2),
          childBodyResponsive = _formatDataForListRes2[0],
          childFootResponsive = _formatDataForListRes2[1];

      return React.createElement(
        'div',
        { id: 'reports-sales-modifier-sales', className: _ModifierSales2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _ModifierSales2.default.tableWrapper + ' modifier-sales-table visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  data.length > 0 && React.createElement(_TableScrollWithChildHorizontalVertical2.default, {
                    parentHeader: 'Name',
                    parentBody: parentBody,
                    parentFoot: 'Total',
                    parentClassName: ['p-header', 'p-body', 'p-foot'],
                    childHeaders: ['Quantity Sold', 'Gross Sales', 'Discount', 'Refund', 'Net Sales'],
                    childBody: childBody,
                    childFoot: childFoot,
                    childHeaderClassName: ['header-quantity-sold', 'header-gross-sales', 'header-discount', 'header-refund', 'header-net-sales'],
                    childBodyClassName: ['body-quantity-sold', 'body-gross-sales', 'body-discount', 'body-refund', 'body-net-sales'],
                    childFootClassName: ['foot-quantity-sold', 'foot-gross-sales', 'foot-discount', 'foot-refund', 'foot-net-sales']
                  }),
                  !data.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _ModifierSales2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  data.length > 0 && React.createElement(_TableWithChild2.default, {
                    paymentMethods: data,
                    headerBody: ['Name', 'Quantity Sold', 'Gross Sales'],
                    childBody: childBodyResponsive,
                    footBody: childFootResponsive,
                    tableClass: 'modifier-sales-table-responsive',
                    headerBodyClassName: ['header-name', 'header-quantity-sold', 'header-gross-sales'],
                    childBodyClassName: ['body-name', 'body-quantity-sold', 'body-gross-sales'],
                    footBodyClassName: ['foot-name', 'foot-quantity-sold', 'foot-gross-sales'] }),
                  !data.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ModifierSales;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        modifierSales: state.reports.modifierSales
      },
      outlet: state.outlet,
      calendar: state.calendar,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(ModifierSales);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(106);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(2222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableWithChild = function (_React$Component) {
  (0, _inherits3.default)(TableWithChild, _React$Component);

  function TableWithChild() {
    (0, _classCallCheck3.default)(this, TableWithChild);
    return (0, _possibleConstructorReturn3.default)(this, (TableWithChild.__proto__ || (0, _getPrototypeOf2.default)(TableWithChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableWithChild, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerBody = _props.headerBody,
          childBody = _props.childBody,
          footBody = _props.footBody,
          tableClass = _props.tableClass,
          headerBodyClassName = _props.headerBodyClassName,
          childBodyClassName = _props.childBodyClassName,
          footBodyClassName = _props.footBodyClassName;

      return React.createElement(
        'table',
        { className: 'table mk-table-summary mk-table-fixed-hf report-table ' + tableClass },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            headerBody.map(function (val, pidx) {
              return React.createElement(
                'th',
                { className: headerBodyClassName[pidx] },
                val
              );
            })
          )
        ),
        React.createElement(
          'tbody',
          null,
          childBody.map(function (val, pidx) {
            var valObj = (0, _values2.default)(val.data);
            return React.createElement(
              'tr',
              null,
              valObj.map(function (value, pidx) {
                return React.createElement(
                  'td',
                  { className: childBodyClassName[pidx] + ' ' + (!val.isParent ? 'child' : '') + ' ' + (val.isParent ? 'parent' : '') },
                  value
                );
              })
            );
          })
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'divider text-total' },
            (0, _values2.default)(footBody).map(function (value, pidx) {
              return React.createElement(
                'td',
                { className: footBodyClassName[pidx] },
                React.createElement(
                  'b',
                  null,
                  value
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TableWithChild;
}(React.Component);

exports.default = TableWithChild;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultPaymentTable = function (_React$Component) {
  (0, _inherits3.default)(DefaultPaymentTable, _React$Component);

  function DefaultPaymentTable() {
    (0, _classCallCheck3.default)(this, DefaultPaymentTable);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultPaymentTable.__proto__ || (0, _getPrototypeOf2.default)(DefaultPaymentTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultPaymentTable, [{
    key: 'render',
    value: function render() {
      var paymentMethods = this.props.paymentMethods;
      var _paymentMethods$repor = paymentMethods.reports,
          cash_or_card = _paymentMethods$repor.cash_or_card,
          invoice = _paymentMethods$repor.invoice,
          other = _paymentMethods$repor.other;


      return paymentMethods && React.createElement(
        'table',
        { className: 'table mk-table-summary mk-table-fixed-hf report-table payment-table' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'th',
              { className: 'header-payment-method' },
              'Payment Method'
            ),
            React.createElement(
              'th',
              { className: 'header-number-of-transactions' },
              'Number of Transactions'
            ),
            React.createElement(
              'th',
              { className: 'header-total-collected' },
              'Total Collected'
            )
          )
        ),
        React.createElement(
          'tbody',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method parent' },
              'Cash'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              cash_or_card[0].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(cash_or_card[0].collected) : 'Rp. 0'
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method parent' },
              'Debit / Credit'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              cash_or_card[1].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(cash_or_card[1].collected) : 'Rp. 0'
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method parent' },
              'Invoice'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              invoice[0].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(invoice[0].collected) : 'Rp. 0'
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method parent' },
              'Other'
            ),
            React.createElement('td', { className: 'body-number-of-transactions' }),
            React.createElement('td', { className: 'body-total-collected' })
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method child' },
              'EDC'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              other[0].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(other[0].collected) : 'Rp. 0'
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method child' },
              'Gift Card'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              other[1].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(other[1].collected) : 'Rp. 0'
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              { className: 'body-payment-method child' },
              'Other'
            ),
            React.createElement(
              'td',
              { className: 'body-number-of-transactions' },
              '0'
            ),
            React.createElement(
              'td',
              { className: 'body-total-collected' },
              other[2].collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(other[2].collected) : 'Rp. 0'
            )
          )
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'divider text-total' },
            React.createElement(
              'td',
              { className: 'foot-payment-method' },
              React.createElement(
                'b',
                null,
                'Total'
              )
            ),
            React.createElement(
              'td',
              { className: 'foot-number-of-transactions' },
              React.createElement(
                'b',
                null,
                '0'
              )
            ),
            React.createElement(
              'td',
              { className: 'foot-total-collected' },
              React.createElement(
                'b',
                null,
                paymentMethods.total_collected < 0 ? (0, _formatter.rupiahWithNegativeWithoutBracket)(paymentMethods.total_collected) : 'Rp. 0'
              )
            )
          )
        )
      );
    }
  }]);
  return DefaultPaymentTable;
}(React.Component);

DefaultPaymentTable.propTypes = {
  paymentMethods: React.PropTypes.object
};

exports.default = DefaultPaymentTable;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _PaymentMethods = __webpack_require__(2223);

var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);

var _TableWithChild = __webpack_require__(1157);

var _TableWithChild2 = _interopRequireDefault(_TableWithChild);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _formatter = __webpack_require__(11);

var _DefaultPaymentTable = __webpack_require__(1541);

var _DefaultPaymentTable2 = _interopRequireDefault(_DefaultPaymentTable);

var _reactRouter = __webpack_require__(15);

var _paymentMethods = __webpack_require__(664);

var mpReportPayments = _interopRequireWildcard(_paymentMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentMethods = function (_React$Component) {
  (0, _inherits3.default)(PaymentMethods, _React$Component);
  (0, _createClass3.default)(PaymentMethods, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.paymentMethodsPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function PaymentMethods(props) {
    (0, _classCallCheck3.default)(this, PaymentMethods);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentMethods.__proto__ || (0, _getPrototypeOf2.default)(PaymentMethods)).call(this, props));

    _this._formatDataForList = function (paymentMethods, totalNumberOfTransactions, totalCollected) {
      var childBody = [];
      var footBody = {
        total: 'Total',
        totalNumberOfTransactions: totalNumberOfTransactions,
        totalCollected: (0, _formatter.rupiahWithNegativeWithoutBracket)(totalCollected)
      };
      paymentMethods.map(function (paymentMethod) {
        childBody.push({ data: {
            paymentMethod: paymentMethod.payment_type,
            number_of_transactions: paymentMethod.number_of_transactions,
            collected: (0, _formatter.rupiahWithNegativeWithoutBracket)(paymentMethod.collected)
          },
          isParent: paymentMethod.parent });
      });
      return [footBody, childBody];
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpReportPayments.reportsPaymentMethodsChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletPaymentMethods)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpReportPayments.reportsPaymentMethodsChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDatePaymentMethods)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Payment Methods - ' + dateLabel;
      mpReportPayments.reportsPaymentMethodsExportData({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportPaymentMethod)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentMethods, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$p = this.props.data.reports.paymentMethods,
          paymentMethods = _props$data$reports$p.paymentMethods,
          showLoadingSpinnerReport = _props$data$reports$p.showLoadingSpinnerReport;
      var totalNumberOfTransactions = paymentMethods.total_number_of_transactions;
      var totalCollected = paymentMethods.total_collected;

      var data = [];
      paymentMethods.reports.cash_or_card.forEach(function (p) {
        data.push((0, _extends3.default)({
          parent: true
        }, p));
      });
      paymentMethods.reports.invoice.forEach(function (p) {
        data.push((0, _extends3.default)({
          parent: true
        }, p));
      });
      data.push({
        parent: true,
        payment_type: 'Other',
        number_of_transactions: '',
        collected: ''
      });
      paymentMethods.reports.other.forEach(function (p) {
        data.push((0, _extends3.default)({
          parent: false
        }, p));
      });

      var _formatDataForList = this._formatDataForList(data, totalNumberOfTransactions, totalCollected),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 2),
          footBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1];

      return React.createElement(
        'div',
        { id: 'reports-sales-payment-methods', className: _PaymentMethods2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content  full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _PaymentMethods2.default.tableWrapper + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  data.length > 0 && paymentMethods.total_collected !== null && paymentMethods.total_collected >= 0 && !showLoadingSpinnerReport && React.createElement(_TableWithChild2.default, {
                    headerBody: ['Payment Method', 'Number of Transactions', 'Total Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'payment-table',
                    headerBodyClassName: ['header-payment-method', 'header-number-of-transactions', 'header-total-collected'],
                    childBodyClassName: ['body-payment-method', 'body-number-of-transactions', 'body-total-collected'],
                    footBodyClassName: ['foot-payment-method', 'foot-number-of-transactions', 'foot-total-collected'] }),
                  paymentMethods.total_collected !== null && paymentMethods.total_collected < 0 && React.createElement(_DefaultPaymentTable2.default, { paymentMethods: paymentMethods })
                ),
                React.createElement(
                  'div',
                  { className: _PaymentMethods2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  data.length > 0 && paymentMethods.total_collected !== null && paymentMethods.total_collected >= 0 && !showLoadingSpinnerReport && React.createElement(_TableWithChild2.default, {
                    paymentMethods: data,
                    totalNumberOfTransactions: totalNumberOfTransactions,
                    totalCollected: totalCollected,
                    headerBody: ['Payment Method', 'Number of Transactions', 'Total Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'payment-table',
                    headerBodyClassName: ['header-payment-method', 'header-number-of-transactions', 'header-total-collected'],
                    childBodyClassName: ['body-payment-method', 'body-number-of-transactions', 'body-total-collected'],
                    footBodyClassName: ['foot-payment-method', 'foot-number-of-transactions', 'foot-total-collected'] }),
                  paymentMethods.total_collected !== null && paymentMethods.total_collected < 0 && React.createElement(_DefaultPaymentTable2.default, { paymentMethods: paymentMethods })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PaymentMethods;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        paymentMethods: state.reports.paymentMethods
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(PaymentMethods);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _ReportSummary = __webpack_require__(2224);

var _ReportSummary2 = _interopRequireDefault(_ReportSummary);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _reactRouter = __webpack_require__(15);

var _summary = __webpack_require__(667);

var mpReportSummary = _interopRequireWildcard(_summary);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportSummary = function (_React$Component) {
  (0, _inherits3.default)(ReportSummary, _React$Component);
  (0, _createClass3.default)(ReportSummary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.salesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function ReportSummary(props) {
    (0, _classCallCheck3.default)(this, ReportSummary);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportSummary.__proto__ || (0, _getPrototypeOf2.default)(ReportSummary)).call(this, props));

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpReportSummary.reportSummaryChangeFilter({ outletIds: outletIds, startDate: startDate, endDate: endDate });
      _this.props.dispatch((0, _sales.changeOutletSalesSummary)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpReportSummary.reportSummaryChangeFilter({ outletIds: outlet, startDate: startDate, endDate: endDate });
      _this.props.dispatch((0, _sales.changeDateSalesSummary)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Sales Summary - ' + dateLabel;
      mpReportSummary.summaryExport({ outletIds: outlet, startDate: startDate, endDate: endDate });
      _this.props.dispatch((0, _sales.exportSummary)(query, filename, outlet[0]));
    };

    _this._renderTable = function () {
      var sales = _this.props.data.reports.sales.sales;

      return React.createElement(
        'table',
        { className: 'table table-responsive mk-table-summary' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'th',
              null,
              '\xA0'
            ),
            React.createElement(
              'th',
              null,
              '\xA0'
            )
          )
        ),
        React.createElement(
          'tbody',
          null,
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Gross Sales'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(sales.gross_sales)
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Discount'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(-(sales.discounts + sales.redemptions))
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Refund'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              '(',
              (0, _formatter.currencyFormatter)(sales.refunds),
              ')'
            )
          ),
          React.createElement(
            'tr',
            { className: 'divider' },
            React.createElement(
              'td',
              null,
              React.createElement(
                'strong',
                null,
                'Net Sales'
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right' },
              React.createElement(
                'strong',
                null,
                (0, _formatter.currencyFormatter)(sales.net_sales)
              )
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Gratuity'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(sales.gratuity)
            )
          ),
          React.createElement(
            'tr',
            null,
            React.createElement(
              'td',
              null,
              'Tax'
            ),
            React.createElement(
              'td',
              { className: 'text-right text-unimportant' },
              (0, _formatter.currencyFormatter)(sales.tax)
            )
          )
        ),
        React.createElement(
          'tfoot',
          null,
          React.createElement(
            'tr',
            { className: 'text-total' },
            React.createElement(
              'td',
              null,
              React.createElement(
                'strong',
                null,
                'Total Collected'
              )
            ),
            React.createElement(
              'td',
              { className: 'text-right' },
              React.createElement(
                'strong',
                null,
                (0, _formatter.currencyFormatter)(sales.total_collected)
              )
            )
          )
        )
      );
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(ReportSummary, [{
    key: 'render',
    value: function render() {
      var showLoadingSpinnerReport = this.props.data.reports.sales.showLoadingSpinnerReport;

      return React.createElement(
        'div',
        { id: 'reports-sales-summary', className: _ReportSummary2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _ReportSummary2.default['table-wrapper-responsive'] + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && this._renderTable()
                ),
                React.createElement(
                  'div',
                  { className: _ReportSummary2.default['table-wrapper'] + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  this._renderTable()
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ReportSummary;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        sales: state.reports.sales
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}
exports.default = (0, _reactRedux.connect)(select)(ReportSummary);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _ServedBy = __webpack_require__(2225);

var _ServedBy2 = _interopRequireDefault(_ServedBy);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__(15);

var _served = __webpack_require__(665);

var mpServedBy = _interopRequireWildcard(_served);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServedBy = function (_React$Component) {
  (0, _inherits3.default)(ServedBy, _React$Component);
  (0, _createClass3.default)(ServedBy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.servedByPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function ServedBy(props) {
    (0, _classCallCheck3.default)(this, ServedBy);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServedBy.__proto__ || (0, _getPrototypeOf2.default)(ServedBy)).call(this, props));

    _this._formatDataForList = function (servers) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        title: null,
        total_number_transaction: servers.total_number_transaction,
        total_collected: (0, _formatter.rupiahWithNegativeWithoutBracket)(servers.total_collected)
      };
      if (servers.servers) {
        servers.servers.map(function (server) {
          childBody.push({
            server_name: server.server_name,
            server_title: server.server_title,
            number_transaction: server.number_transaction,
            collected: (0, _formatter.rupiahWithNegativeWithoutBracket)(server.collected)
          });
        });
      }
      return [footBody, childBody];
    };

    _this._formatFootBody = function (footBody) {
      delete footBody.title;
      return footBody;
    };

    _this._formatChildBody = function (childBody) {
      var result = [];
      childBody.map(function (val) {
        delete val.server_title;
        result.push(val);
      });
      return result;
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpServedBy.reportServedChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletServedBy)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpServedBy.reportServedChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateServedBy)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Server - ' + dateLabel;
      mpServedBy.reportServedExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportServedBy)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServedBy, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$s = this.props.data.reports.servers,
          servers = _props$data$reports$s.servers,
          showLoadingSpinnerReport = _props$data$reports$s.showLoadingSpinnerReport;

      var _formatDataForList = this._formatDataForList(servers),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 2),
          footBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1];

      var footBodyResponsive = this._formatFootBody(_lodash2.default.cloneDeep(footBody));
      var childBodyResponsive = this._formatChildBody(_lodash2.default.cloneDeep(childBody));

      return React.createElement(
        'div',
        { id: 'reports-sales-served-by', className: '' + _ServedBy2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _ServedBy2.default.tableWrapper + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  servers.servers && servers.servers.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Title', 'Number of Transactions', 'Total Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'server-by-table',
                    headerBodyClassName: ['header-name', 'header-titla', 'header-number-of-transaction', 'header-total-collected'],
                    childBodyClassName: ['body-name', 'body-titla', 'body-number-of-transaction', 'body-total-collected'],
                    footBodyClassName: ['foot-name', 'foot-titla', 'foot-number-of-transaction', 'foot-total-collected'] }),
                  servers.servers && !servers.servers.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _ServedBy2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  servers.servers && servers.servers.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Number of Transactions', 'Total Collected'],
                    childBody: childBodyResponsive,
                    footBody: footBodyResponsive,
                    tableClass: 'server-by-table-responsive',
                    headerBodyClassName: ['header-name', 'header-number-of-transaction', 'header-total-collected'],
                    childBodyClassName: ['body-name', 'body-number-of-transaction', 'body-total-collected'],
                    footBodyClassName: ['foot-name', 'foot-number-of-transaction', 'foot-total-collected'] }),
                  servers.servers && !servers.servers.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ServedBy;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        servers: state.reports.servers
      },
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(ServedBy);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(130);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _SidebarReports = __webpack_require__(103);

var _SidebarReports2 = _interopRequireDefault(_SidebarReports);

var _sales = __webpack_require__(94);

var _Taxes = __webpack_require__(2226);

var _Taxes2 = _interopRequireDefault(_Taxes);

var _NoDataDisplay = __webpack_require__(129);

var _NoDataDisplay2 = _interopRequireDefault(_NoDataDisplay);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(7);

var _ActionBar = __webpack_require__(104);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _LoadingSpinner = __webpack_require__(66);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _TableWithoutChild = __webpack_require__(172);

var _TableWithoutChild2 = _interopRequireDefault(_TableWithoutChild);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__(15);

var _taxes = __webpack_require__(668);

var mpTaxes = _interopRequireWildcard(_taxes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Taxes = function (_React$Component) {
  (0, _inherits3.default)(Taxes, _React$Component);
  (0, _createClass3.default)(Taxes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _sales.taxesPageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }]);

  function Taxes(props) {
    (0, _classCallCheck3.default)(this, Taxes);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Taxes.__proto__ || (0, _getPrototypeOf2.default)(Taxes)).call(this, props));

    _this._formatDataForList = function (taxes, totalTaxCollected) {
      var childBody = [];
      var footBody = {
        name: 'Total',
        total_tax_rate: null,
        total_taxable_amount: null,
        totalTaxCollected: (0, _formatter.rupiahWithNegativeWithoutBracket)(totalTaxCollected)
      };
      if (taxes.reports_taxes) {
        taxes.reports_taxes.map(function (tax) {
          childBody.push({
            name: tax.name,
            amount: tax.amount + '%',
            taxable_amount: (0, _formatter.rupiahWithNegativeWithoutBracket)(tax.taxable_amount),
            tax_collected: (0, _formatter.rupiahWithNegativeWithoutBracket)(tax.tax_collected)
          });
        });
      }
      return [footBody, childBody];
    };

    _this._formatFootBody = function (footBody) {
      delete footBody.total_taxable_amount;
      return footBody;
    };

    _this._formatChildBody = function (childBody) {
      var result = [];
      childBody.map(function (val) {
        delete val.taxable_amount;
        result.push(val);
      });
      return result;
    };

    _this._onChangeOutlet = function () {
      var outletIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpTaxes.reportsTaxChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeOutletTaxes)({ outletIds: outletIds, startDate: startDate, endDate: endDate }));
    };

    _this._showSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._toogleSidebar = function () {
      _this.setState({ openSidebar: !_this.state.openSidebar });
    };

    _this._onChangeDate = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var outlet = _this.props.search.outlet;

      mpTaxes.reportsTaxChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.changeDateTaxes)(startDate.toDate(), endDate.toDate()));
    };

    _this._onClickExport = function () {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      var outlet = _this.props.search.outlet;

      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Taxes - ' + dateLabel;
      mpTaxes.reportsTaxExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _sales.exportTaxes)(query, filename, outlet[0]));
    };

    _this.state = {
      openSidebar: false
    };
    return _this;
  }

  (0, _createClass3.default)(Taxes, [{
    key: 'render',
    value: function render() {
      var _props$data$reports$t = this.props.data.reports.taxes,
          taxes = _props$data$reports$t.taxes,
          showLoadingSpinnerReport = _props$data$reports$t.showLoadingSpinnerReport;

      var _formatDataForList = this._formatDataForList(taxes, taxes.total_tax_collected),
          _formatDataForList2 = (0, _slicedToArray3.default)(_formatDataForList, 2),
          footBody = _formatDataForList2[0],
          childBody = _formatDataForList2[1];

      var footBodyResponsive = this._formatFootBody(_lodash2.default.cloneDeep(footBody));
      var childBodyResponsive = this._formatChildBody(_lodash2.default.cloneDeep(childBody));

      return React.createElement(
        'div',
        { id: 'reports-sales-taxes', className: _Taxes2.default.wrapper },
        React.createElement(_ActionBar2.default, { onChangeDate: this._onChangeDate, onChangeOutlet: this._onChangeOutlet, onExport: this._onClickExport }),
        React.createElement(
          'div',
          { className: 'mk-report-sales full-height' },
          React.createElement(
            'div',
            { className: 'row full-height' },
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-lg visible-md slideMenuWeb', location: this.props.location }),
            React.createElement(_SidebarReports2.default, { elementClass: 'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : ''), onToggle: this._toogleSidebar, location: this.props.location }),
            React.createElement(
              'div',
              { className: 'col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height' },
              React.createElement(
                'div',
                { className: 'mk-report-sales-content full-height' },
                React.createElement(
                  'div',
                  { className: 'mk-burger-box visible-xs visible-sm' },
                  React.createElement(
                    'div',
                    { className: 'mk-burger' },
                    React.createElement(
                      'button',
                      { type: 'button', className: 'navbar-toggle collapsed navbar-burger', onClick: this._showSidebar, 'data-toggle': 'collapse' },
                      React.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Toggle navigation'
                      ),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' }),
                      React.createElement('span', { className: 'icon-bar' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Taxes2.default.tableWrapper + ' visible-md visible-lg' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  taxes.reports_taxes && taxes.reports_taxes.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Tax Rate', 'Taxable Amount', 'Tax Collected'],
                    childBody: childBody,
                    footBody: footBody,
                    tableClass: 'tax-table',
                    headerBodyClassName: ['header-name', 'header-tax-rate', 'header-taxable-amount', 'header-tax-collected'],
                    childBodyClassName: ['body-name', 'body-tax-rate', 'body-taxable-amount', 'body-tax-collected'],
                    footBodyClassName: ['foot-name', 'foot-tax-rate', 'foot-taxable-amount', 'foot-tax-collected'] }),
                  taxes.reports_taxes && !taxes.reports_taxes.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: _Taxes2.default.tableWrapperResponsive + ' visible-xs visible-sm' },
                  React.createElement(_LoadingSpinner2.default, { showLoadingSpinner: showLoadingSpinnerReport }),
                  taxes.reports_taxes && taxes.reports_taxes.length > 0 && React.createElement(_TableWithoutChild2.default, {
                    headerBody: ['Name', 'Tax Rate', 'Tax Collected'],
                    childBody: childBodyResponsive,
                    footBody: footBodyResponsive,
                    tableClass: 'tax-table-responsive',
                    headerBodyClassName: ['header-name', 'header-tax-rate', 'header-tax-collected'],
                    childBodyClassName: ['body-name', 'body-tax-rate', 'body-tax-collected'],
                    footBodyClassName: ['foot-name', 'foot-tax-rate', 'foot-tax-collected'] }),
                  taxes.reports_taxes && !taxes.reports_taxes.length && !showLoadingSpinnerReport && React.createElement(
                    'div',
                    { className: 'no-data-display-container' },
                    React.createElement(_NoDataDisplay2.default, { title: 'No Data to Display' })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Taxes;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        taxes: state.reports.taxes
      },
      outlet: state.outlet,
      calendar: state.calendar,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(select)(Taxes);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _shifts = __webpack_require__(417);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ActionBar = __webpack_require__(2227);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _OutletModal = __webpack_require__(241);

var _OutletModal2 = _interopRequireDefault(_OutletModal);

var _shifts2 = __webpack_require__(666);

var mpReportsShifts = _interopRequireWildcard(_shifts2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function (outletIds) {
      var isMobile = _this.props.isMobile;
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpReportsShifts.reportsShiftsChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _shifts.changeOutletShift)(outletIds, startDate, endDate, isMobile));
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var _this$props = _this.props,
          isMobile = _this$props.isMobile,
          outlet = _this$props.search.outlet;

      mpReportsShifts.reportsShiftsChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _shifts.changeDate)(startDate, endDate, isMobile));
    }, _this._onClickExportButton = function () {
      var _this$props$search = _this.props.search,
          _this$props$search$da2 = _this$props$search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate,
          outlet = _this$props$search.outlet;

      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Shifts - ' + dateLabel;

      _this.props.dispatch((0, _shifts.exportShiftRequest)({
        start: startDate.format('D/M/YYYY'),
        end: endDate.format('D/M/YYYY')
      }, filename, outlet[0]));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          outlets = _props.outlets,
          showModalOutletMobileState = _props.showModalOutletMobileState;

      return React.createElement(
        'div',
        { className: _ActionBar2.default.wrapper },
        React.createElement(
          'div',
          { className: 'col-sm-12 col-xs-12 col-md-8 col-lg-8 no-padding' },
          React.createElement(
            'div',
            { className: 'form-group pull-left visible-md visible-lg no-margin ng-scope ' + _ActionBar2.default['form-group'] },
            React.createElement(_reduxForm.Field, {
              component: _DropdownOutlet2.default,
              outlets: outlets,
              onChangeOutletIds: this._onChangeOutlet,
              name: 'outlet',
              allOutletOption: true
            })
          ),
          React.createElement(
            'div',
            { className: 'form-group no-margin' },
            React.createElement(_reduxForm.Field, {
              component: _DropdownCalendar2.default,
              name: 'date',
              onChange: this._onChangeDate,
              updateServerOnChange: true
            })
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-4 col-lg-4 visible-md visible-lg no-padding' },
          React.createElement(
            'div',
            { className: 'pull-right' },
            React.createElement(
              'a',
              { className: 'btn btn-primary btn-export', onClick: this._onClickExportButton },
              'Export'
            )
          )
        ),
        React.createElement(_reduxForm.Field, {
          component: _OutletModal2.default,
          name: 'outlet',
          outlets: outlets || [],
          onChangeOutletIds: this._onChangeOutlet,
          allOutletOption: true,
          show: showModalOutletMobileState
        })
      );
    }
  }]);
  return ActionBar;
}(React.Component);

var mapForm = {
  form: 'search'
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  return {
    outlets: state.reports.shifts.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _shifts = __webpack_require__(417);

var _ShiftDetail = __webpack_require__(1548);

var _ShiftDetail2 = _interopRequireDefault(_ShiftDetail);

var _ShiftDetailModal = __webpack_require__(1552);

var _ShiftDetailModal2 = _interopRequireDefault(_ShiftDetailModal);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _shift = __webpack_require__(2233);

var _shift2 = _interopRequireDefault(_shift);

var _ActionBar = __webpack_require__(1546);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactInfiniteScroller = __webpack_require__(45);

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Shift = function (_React$Component) {
  (0, _inherits3.default)(Shift, _React$Component);

  function Shift(props) {
    (0, _classCallCheck3.default)(this, Shift);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Shift.__proto__ || (0, _getPrototypeOf2.default)(Shift)).call(this, props));

    _this._closeModal = function () {
      var isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null;
      _this.setState({
        shiftDetailOpened: false,
        isMobile: isMobile,
        showModal: false
      });
      _this.props.dispatch((0, _shifts.hideShiftDetail)(isMobile));
    };

    _this._onClickShiftRow = function (shift) {
      var isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null;
      _this.setState({
        shiftDetailOpened: !isMobile,
        isMobile: isMobile,
        showModal: isMobile
      });
      _this.props.dispatch((0, _shifts.shiftDetailsRequest)(shift.id, isMobile));
    };

    _this._onClickShiftDetailDoneButton = function () {
      var isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null;
      _this.setState({
        shiftDetailOpened: false,
        isMobile: isMobile,
        showModal: false
      });
      _this.props.dispatch((0, _shifts.hideShiftDetail)(isMobile));
    };

    _this._onReachBottom = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          reports = _this$props.data.reports,
          _this$props$search$da = _this$props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;
      var _reports$shifts = reports.shifts,
          shifts = _reports$shifts.shifts,
          page = _reports$shifts.page;

      var currentPage = page === 0 ? page + 1 : page;
      dispatch((0, _shifts.shiftSummaryLoadMoreData)({ page: currentPage + 1, startDate: startDate, endDate: endDate }, shifts));
    };

    _this._hasMore = function () {
      var reports = _this.props.data.reports;
      var _reports$shifts2 = reports.shifts,
          shiftSummary = _reports$shifts2.shiftSummary,
          page = _reports$shifts2.page;

      var totalPage = shiftSummary.total_pages;
      return page < totalPage;
    };

    _this.state = {
      shiftDetailOpened: false,
      isMobile: false,
      showModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(Shift, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _shifts.pageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'renderShiftTable',
    value: function renderShiftTable() {
      var _this2 = this;

      var _props$data = this.props.data,
          reports = _props$data.reports,
          currentOutlet = _props$data.currentOutlet,
          showLoadingSpinnerPage = _props$data.loadingSpinner.showLoadingSpinnerPage;
      var _reports$shifts3 = reports.shifts,
          shifts = _reports$shifts3.shifts,
          shiftDetails = _reports$shifts3.shiftDetails;


      return React.createElement(
        'div',
        { className: _shift2.default['wrapper'] + ' ' + (showLoadingSpinnerPage ? _shift2.default['hide-table'] : '') },
        React.createElement(
          'table',
          { id: 'shift-table', className: 'moka-table table-truncate table-responsive mk-table-fixed mk-table-clickable table ' + (!shifts.length ? 'no-data' : _shift2.default['shift-left-table']) },
          React.createElement(
            'thead',
            { className: _shift2.default['thead-shift-table'] },
            React.createElement(
              'tr',
              { className: 'shift-row' },
              React.createElement(
                'th',
                { className: 'text-center' },
                'Name'
              ),
              React.createElement(
                'th',
                { className: 'visible-md visible-lg text-center' },
                'Start Time'
              ),
              React.createElement(
                'th',
                { className: 'end-time text-center' },
                'End Time'
              ),
              currentOutlet.length > 1 && React.createElement(
                'th',
                { className: 'visible-md visible-lg text-center' },
                'Access'
              ),
              React.createElement(
                'th',
                { className: 'visible-md visible-lg text-center' },
                'Total Expected'
              ),
              React.createElement(
                'th',
                { className: 'visible-md visible-lg text-center' },
                'Total Actual'
              ),
              React.createElement(
                'th',
                { className: 'visible-md visible-lg text-center' },
                'Difference'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: _shift2.default['table-content-wrapper'] },
          React.createElement(
            _reactInfiniteScroller2.default,
            {
              pageStart: 1,
              loadMore: this._onReachBottom,
              hasMore: this._hasMore(),
              useWindow: false,
              threshold: 10,
              initialLoad: false
            },
            React.createElement(
              'table',
              { id: 'shift-table', className: 'moka-table table-truncate table-responsive mk-table-fixed mk-table-clickable table ' + (!shifts.length ? 'no-data' : _shift2.default['shift-left-table-max']) },
              React.createElement(
                'tbody',
                { className: _shift2.default['tbody-shift-table'] },
                shifts.map(function (shift, idx) {
                  var klassNames = [];
                  if (shiftDetails && shiftDetails.id === shift.id) klassNames.push('selected');
                  return React.createElement(
                    'tr',
                    { key: idx, onClick: function onClick() {
                        return _this2._onClickShiftRow(shift);
                      }, className: 'shift-row ' + klassNames.join(' ') },
                    React.createElement(
                      'td',
                      { className: 'text-center' },
                      shift.employee_name
                    ),
                    React.createElement(
                      'td',
                      { className: 'visible-md visible-lg text-center' },
                      _moment2.default.parseZone(shift.created_at).format('D/MM/YYYY HH:mm')
                    ),
                    React.createElement(
                      'td',
                      { className: 'end-time text-center' },
                      shift.ended_at === null ? '-' : _moment2.default.parseZone(shift.ended_at).format('D/MM/YYYY HH:mm')
                    ),
                    currentOutlet.length > 1 && React.createElement(
                      'td',
                      { className: 'visible-md visible-lg text-center' },
                      shift.outlet_name
                    ),
                    React.createElement(
                      'td',
                      { className: 'visible-md visible-lg text-center' },
                      shift.ended_at === null ? '-' : (0, _formatter.currencyFormatter)(shift.total_expected)
                    ),
                    React.createElement(
                      'td',
                      { className: 'visible-md visible-lg text-center' },
                      shift.ended_at === null ? '-' : (0, _formatter.currencyFormatter)(shift.total_actual)
                    ),
                    React.createElement(
                      'td',
                      { className: 'visible-md visible-lg text-center' },
                      shift.ended_at === null ? '-' : (0, _formatter.currencyFormatter)(shift.total_difference)
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$data2 = this.props.data,
          reports = _props$data2.reports,
          loadingSpinner = _props$data2.loadingSpinner;
      var _reports$shifts4 = reports.shifts,
          shifts = _reports$shifts4.shifts,
          shiftDetails = _reports$shifts4.shiftDetails;


      return React.createElement(
        'div',
        { className: 'container-full-nosub ' + _shift2.default['shift-report'], id: 'shifts' },
        React.createElement(
          'div',
          { className: 'container no-padding shift-container' },
          React.createElement(
            'div',
            { className: 'mk-action-bar' },
            React.createElement(_ActionBar2.default, { isMobile: this.state.isMobile })
          ),
          React.createElement(
            'div',
            { className: _shift2.default['shift-table'] },
            React.createElement(
              'div',
              { className: _shift2.default['mk-report-transaction'] },
              React.createElement(
                'div',
                { className: _shift2.default['row-shift'] },
                React.createElement(
                  'div',
                  { className: 'col-sm-12 col-md-12 trans-1 box-customers no-padding ' + _shift2.default['box-table'], id: 'mk-col-left' },
                  React.createElement(
                    'div',
                    { className: _shift2.default['transaction-table'] },
                    React.createElement(_NoDataAndLoading2.default, {
                      showLoadingSpinner: loadingSpinner.showLoadingSpinnerPage,
                      noDataToDisplay: shifts.length === 0,
                      title: 'No Data To Display',
                      description: '' }),
                    shifts.length > 0 && this.renderShiftTable()
                  )
                ),
                shiftDetails !== null && this.state.isMobile && React.createElement(_ShiftDetailModal2.default, {
                  onClickDoneButton: this._onClickShiftDetailDoneButton,
                  shift: shiftDetails,
                  show: this.state.showModal,
                  onHide: this._closeModal
                }),
                shiftDetails !== null && this.state.shiftDetailOpened && !this.state.isMobile && React.createElement(_ShiftDetail2.default, {
                  onClickDoneButton: this._onClickShiftDetailDoneButton,
                  shift: shiftDetails })
              )
            )
          )
        )
      );
    }
  }]);
  return Shift;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: state.reports,
      currentOutlet: state.outlet.currentOutlet,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Shift);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShiftDetailRow = __webpack_require__(301);

var _ShiftDetailRow2 = _interopRequireDefault(_ShiftDetailRow);

var _ShiftDetailTotalExpense = __webpack_require__(1559);

var _ShiftDetailTotalExpense2 = _interopRequireDefault(_ShiftDetailTotalExpense);

var _ShiftDetailTotalIncome = __webpack_require__(1560);

var _ShiftDetailTotalIncome2 = _interopRequireDefault(_ShiftDetailTotalIncome);

var _ShiftDetailCard = __webpack_require__(1549);

var _ShiftDetailCard2 = _interopRequireDefault(_ShiftDetailCard);

var _ShiftDetailOther = __webpack_require__(1557);

var _ShiftDetailOther2 = _interopRequireDefault(_ShiftDetailOther);

var _ShiftDetailTotal = __webpack_require__(1558);

var _ShiftDetailTotal2 = _interopRequireDefault(_ShiftDetailTotal);

var _formatter = __webpack_require__(11);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(2232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetail = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetail, _React$Component);

  function ShiftDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShiftDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShiftDetail.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetail)).call.apply(_ref, [this].concat(args))), _this), _this._printCashRefund = function (shift) {
      if (shift.cash_refund > 0) {
        return '(' + (0, _formatter.currencyFormatter)(shift.cash_refund) + ')';
      } else {
        return (0, _formatter.currencyFormatter)(shift.cash_refund);
      }
    }, _this._formatValueShift = function (shift, value) {
      return _this._checkEndDate(shift) ? value : '-';
    }, _this._checkEndDate = function (shift) {
      return shift.ended_at !== null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShiftDetail, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'col-sm-12 trans-1', id: 'mk-col-right' },
        React.createElement(
          'div',
          { className: 'mk-col-right-box' },
          React.createElement(
            'div',
            { className: 'scrolled-area' },
            React.createElement(
              'div',
              { className: 'col-right-inner' },
              React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                  'div',
                  { className: 'col-sm-12' },
                  React.createElement(
                    'div',
                    { className: 'label-section' },
                    'SHIFT DETAILS'
                  ),
                  React.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    React.createElement(
                      'div',
                      { className: 'row list-detail' },
                      React.createElement(_ShiftDetailRow2.default, { label: 'Name', value: shift.employee_name }),
                      React.createElement(_ShiftDetailRow2.default, { label: 'Access', value: shift.outlet_name }),
                      React.createElement(_ShiftDetailRow2.default, { label: 'Starting Shift', value: _moment2.default.parseZone(shift.created_at).format('DD MMM YYYY HH:mm') }),
                      React.createElement(_ShiftDetailRow2.default, { label: 'Ending Shift', value: shift.ended_at ? _moment2.default.parseZone(shift.ended_at).format('DD MMM YYYY HH:mm') : '-' }),
                      React.createElement(
                        'div',
                        { className: 'row' },
                        React.createElement(
                          'div',
                          { className: 'col-sm-12' },
                          React.createElement('div', null)
                        )
                      ),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'col-sm-12 shift-content' },
                          React.createElement(
                            'div',
                            { className: 'row' },
                            React.createElement(
                              'div',
                              { className: 'col-sm-12' },
                              React.createElement(
                                'div',
                                { className: 'form-group col-sm-12 label-section' },
                                React.createElement(
                                  'label',
                                  null,
                                  'Cash'
                                )
                              ),
                              React.createElement(
                                'div',
                                { className: 'col-sm-12 cash_detail no-padding-right' },
                                React.createElement(_ShiftDetailRow2.default, { label: 'Starting Cash', value: (0, _formatter.currencyFormatter)(shift.starting_cash) }),
                                React.createElement(_ShiftDetailRow2.default, { label: 'Cash Sales', value: (0, _formatter.currencyFormatter)(shift.cash_sales) }),
                                React.createElement(_ShiftDetailRow2.default, { label: 'Cash from Invoice', value: (0, _formatter.currencyFormatter)(shift.cash_invoice) }),
                                React.createElement(_ShiftDetailRow2.default, { label: 'Cash Refunds', value: this._printCashRefund(shift) }),
                                React.createElement(_ShiftDetailTotalExpense2.default, { shift: shift }),
                                React.createElement(_ShiftDetailTotalIncome2.default, { shift: shift }),
                                React.createElement(_ShiftDetailRow2.default, { label: 'Expected Ending Cash', value: (0, _formatter.currencyFormatter)(shift.expected_ending_cash) }),
                                React.createElement(_ShiftDetailRow2.default, { label: 'Actual Ending Cash', value: shift.ended_at ? (0, _formatter.currencyFormatter)(shift.actual_ending_cash) : '-' })
                              )
                            )
                          ),
                          React.createElement(_ShiftDetailCard2.default, { shift: shift }),
                          React.createElement(_ShiftDetailOther2.default, { shift: shift }),
                          React.createElement(_ShiftDetailTotal2.default, { shift: shift })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'mk-col-right-action-box bottom' },
          React.createElement(
            'button',
            { className: 'btn btn-primary pull-right', onClick: this.props.onClickDoneButton },
            'Done'
          )
        )
      );
    }
  }]);
  return ShiftDetail;
}(React.Component);

ShiftDetail.propTypes = {
  shift: React.PropTypes.object,
  onClickDoneButton: React.PropTypes.func
};

exports.default = ShiftDetail;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShiftDetailRow = __webpack_require__(301);

var _ShiftDetailRow2 = _interopRequireDefault(_ShiftDetailRow);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailCard = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailCard, _React$Component);

  function ShiftDetailCard() {
    (0, _classCallCheck3.default)(this, ShiftDetailCard);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailCard.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailCard, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Card'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 card_detail no-padding-right' },
            React.createElement(_ShiftDetailRow2.default, { label: 'Debit / Credit', value: (0, _formatter.currencyFormatter)(shift.total_debit_credit) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Voided', value: (0, _formatter.currencyFormatter)('-' + shift.total_voided) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Expected Card Payment', value: (0, _formatter.currencyFormatter)(shift.expected_card_payment) })
          )
        )
      );
    }
  }]);
  return ShiftDetailCard;
}(React.Component);

ShiftDetailCard.propTypes = {
  shift: React.PropTypes.object
};

exports.default = ShiftDetailCard;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NameRow = __webpack_require__(2228);

var _NameRow2 = _interopRequireDefault(_NameRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameRow = function (_React$Component) {
  (0, _inherits3.default)(NameRow, _React$Component);

  function NameRow() {
    (0, _classCallCheck3.default)(this, NameRow);
    return (0, _possibleConstructorReturn3.default)(this, (NameRow.__proto__ || (0, _getPrototypeOf2.default)(NameRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(NameRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          value = _props.value;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12 box-divider' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              { className: _NameRow2.default.label },
              label
            ),
            React.createElement(
              'div',
              { className: _NameRow2.default.value + ' pull-right' },
              value
            )
          )
        )
      );
    }
  }]);
  return NameRow;
}(React.Component);

NameRow.propTypes = {
  label: React.PropTypes.string,
  value: React.PropTypes.string
};

exports.default = NameRow;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CashRow = __webpack_require__(300);

var _CashRow2 = _interopRequireDefault(_CashRow);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailCard = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailCard, _React$Component);

  function ShiftDetailCard() {
    (0, _classCallCheck3.default)(this, ShiftDetailCard);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailCard.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailCard, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Card'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 card_detail no-padding-right' },
            React.createElement(_CashRow2.default, { label: 'Debit / Credit', value: (0, _formatter.currencyFormatter)(shift.total_debit_credit) }),
            React.createElement(_CashRow2.default, { label: 'Voided', value: (0, _formatter.rupiahWithNegative)('-' + shift.total_voided) }),
            React.createElement(_CashRow2.default, { label: 'Expected Card Payment', value: (0, _formatter.currencyFormatter)(shift.expected_card_payment) })
          )
        )
      );
    }
  }]);
  return ShiftDetailCard;
}(React.Component);

ShiftDetailCard.propTypes = {
  shift: React.PropTypes.object
};

exports.default = ShiftDetailCard;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NameRow = __webpack_require__(1550);

var _NameRow2 = _interopRequireDefault(_NameRow);

var _CashRow = __webpack_require__(300);

var _CashRow2 = _interopRequireDefault(_CashRow);

var _ShiftDetailTotalExpense = __webpack_require__(1555);

var _ShiftDetailTotalExpense2 = _interopRequireDefault(_ShiftDetailTotalExpense);

var _ShiftDetailTotalIncome = __webpack_require__(1556);

var _ShiftDetailTotalIncome2 = _interopRequireDefault(_ShiftDetailTotalIncome);

var _ShiftDetailCard = __webpack_require__(1551);

var _ShiftDetailCard2 = _interopRequireDefault(_ShiftDetailCard);

var _ShiftDetailOther = __webpack_require__(1553);

var _ShiftDetailOther2 = _interopRequireDefault(_ShiftDetailOther);

var _ShiftDetailTotal = __webpack_require__(1554);

var _ShiftDetailTotal2 = _interopRequireDefault(_ShiftDetailTotal);

var _formatter = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(10);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ShiftDetailModal = __webpack_require__(2229);

var _ShiftDetailModal2 = _interopRequireDefault(_ShiftDetailModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailModal = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailModal, _React$Component);

  function ShiftDetailModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShiftDetailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShiftDetailModal.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailModal)).call.apply(_ref, [this].concat(args))), _this), _this._printCashRefund = function (shift) {
      if (shift.cash_refund > 0) {
        return '(' + (0, _formatter.currencyFormatter)(shift.cash_refund) + ')';
      } else {
        return (0, _formatter.currencyFormatter)(shift.cash_refund);
      }
    }, _this._formatValueShift = function (shift, value) {
      return _this._checkEndDate(shift) ? value : '-';
    }, _this._checkEndDate = function (shift) {
      return shift.ended_at !== null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShiftDetailModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          shift = _props.shift,
          shiftDetails = _props.shiftDetails;

      return React.createElement(
        _reactBootstrap.Modal,
        { backdrop: 'true', show: this.props.show, bsClass: _ShiftDetailModal2.default.modal + ' shift-modal modal', dialogClassName: _ShiftDetailModal2.default.dialog + ' modal-dialog' },
        React.createElement(
          _reactBootstrap.Modal.Body,
          { bsClass: 'modal-body ' + _ShiftDetailModal2.default['modal-body'] },
          React.createElement(
            'div',
            { className: 'col-right-inner' },
            React.createElement(
              'div',
              { className: 'col-sm-12' },
              React.createElement(
                'div',
                { className: 'label-section' },
                'SHIFT DETAILS'
              ),
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  { className: 'row list-detail' },
                  React.createElement(_NameRow2.default, { label: 'Name', value: shift.employee_name }),
                  React.createElement(_NameRow2.default, { label: 'Access', value: shift.outlet_name }),
                  React.createElement(_NameRow2.default, { label: 'Starting Shift', value: _moment2.default.parseZone(shift.created_at).format('DD MMM YYYY HH:mm') }),
                  React.createElement(_NameRow2.default, { label: 'Ending Shift', value: shift.ended_at ? _moment2.default.parseZone(shift.ended_at).format('DD MMM YYYY HH:mm') : '-' }),
                  React.createElement(
                    'div',
                    { className: 'row' },
                    React.createElement(
                      'div',
                      { className: 'col-sm-12' },
                      React.createElement('div', null)
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { className: 'col-sm-12 shift-content' },
                      React.createElement(
                        'div',
                        { className: 'row' },
                        React.createElement(
                          'div',
                          { className: 'col-sm-12' },
                          React.createElement(
                            'div',
                            { className: 'form-group col-sm-12 label-section' },
                            React.createElement(
                              'label',
                              null,
                              'Cash'
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'col-sm-12 cash_detail no-padding-right' },
                            React.createElement(_CashRow2.default, { label: 'Starting Cash', value: (0, _formatter.currencyFormatter)(shift.starting_cash) }),
                            React.createElement(_CashRow2.default, { label: 'Cash Sales', value: (0, _formatter.currencyFormatter)(shift.cash_sales) }),
                            React.createElement(_CashRow2.default, { label: 'Cash from Invoice', value: (0, _formatter.currencyFormatter)(shift.cash_invoice) }),
                            React.createElement(_CashRow2.default, { label: 'Cash Refunds', value: this._printCashRefund(shift) }),
                            React.createElement(_ShiftDetailTotalExpense2.default, { shift: shift, shiftDetails: shiftDetails }),
                            React.createElement(_ShiftDetailTotalIncome2.default, { shift: shift, shiftDetails: shiftDetails }),
                            React.createElement(_CashRow2.default, { label: 'Expected Ending Cash', value: (0, _formatter.currencyFormatter)(shift.expected_ending_cash) }),
                            React.createElement(_CashRow2.default, { label: 'Actual Ending Cash', value: shift.ended_at ? (0, _formatter.currencyFormatter)(shift.actual_ending_cash) : '-' })
                          )
                        )
                      ),
                      React.createElement(_ShiftDetailCard2.default, { shift: shift }),
                      React.createElement(_ShiftDetailOther2.default, { shift: shift }),
                      React.createElement(_ShiftDetailTotal2.default, { shift: shift })
                    )
                  )
                )
              )
            )
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          React.createElement(
            _reactBootstrap.Button,
            { onClick: this.props.onHide },
            'Close'
          )
        )
      );
    }
  }]);
  return ShiftDetailModal;
}(React.Component);

ShiftDetailModal.propTypes = {
  shift: React.PropTypes.object,
  onHide: React.PropTypes.func,
  shiftDetails: React.PropTypes.array,
  onClickDoneButton: React.PropTypes.func
};

exports.default = ShiftDetailModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CashRow = __webpack_require__(300);

var _CashRow2 = _interopRequireDefault(_CashRow);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailOther = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailOther, _React$Component);

  function ShiftDetailOther() {
    (0, _classCallCheck3.default)(this, ShiftDetailOther);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailOther.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailOther)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailOther, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Other'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 other_detail no-padding-right' },
            React.createElement(_CashRow2.default, { label: 'EDC', value: (0, _formatter.currencyFormatter)(shift.total_edc) }),
            React.createElement(_CashRow2.default, { label: 'Gift Card', value: (0, _formatter.currencyFormatter)(shift.total_gift_card) }),
            React.createElement(_CashRow2.default, { label: 'Other', value: (0, _formatter.currencyFormatter)(shift.total_other) }),
            React.createElement(_CashRow2.default, { label: 'Refunds', value: (0, _formatter.rupiahWithNegative)('-' + shift.other_refunds) }),
            React.createElement(_CashRow2.default, { label: 'Expected Other Payment', value: (0, _formatter.currencyFormatter)(shift.expected_other_payment) })
          )
        )
      );
    }
  }]);
  return ShiftDetailOther;
}(React.Component);

ShiftDetailOther.propTypes = {
  shift: React.PropTypes.object
};

exports.default = ShiftDetailOther;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _CashRow = __webpack_require__(300);

var _CashRow2 = _interopRequireDefault(_CashRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotal = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotal, _React$Component);

  function ShiftDetailTotal() {
    (0, _classCallCheck3.default)(this, ShiftDetailTotal);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotal.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailTotal, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Total'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 total_detail no-padding-right' },
            React.createElement(_CashRow2.default, { label: 'Total Expected', value: (0, _formatter.currencyFormatter)(shift.total_expected) }),
            React.createElement(_CashRow2.default, { label: 'Total Actual', value: shift.ended_at ? (0, _formatter.currencyFormatter)(shift.total_actual) : '-' }),
            React.createElement(_CashRow2.default, { label: 'Difference', value: shift.ended_at ? (0, _formatter.currencyFormatter)(shift.total_difference) : '-' })
          )
        )
      );
    }
  }]);
  return ShiftDetailTotal;
}(React.Component);

ShiftDetailTotal.propTypes = {
  shift: React.PropTypes.object
};
exports.default = ShiftDetailTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotalExpense = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotalExpense, _React$Component);

  function ShiftDetailTotalExpense(props) {
    (0, _classCallCheck3.default)(this, ShiftDetailTotalExpense);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotalExpense.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotalExpense)).call(this, props));

    _this._onClickCollapseExpense = function () {
      _this.setState({ collapseExpense: !_this.state.collapseExpense });
    };

    _this.state = {
      collapseExpense: false
    };
    return _this;
  }

  (0, _createClass3.default)(ShiftDetailTotalExpense, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ collapseExpense: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          shift.total_expense <= 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleExpense' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'a',
                { className: 'collapsed disable' },
                React.createElement(
                  'label',
                  null,
                  'TOTAL EXPENSE'
                ),
                React.createElement(
                  'div',
                  null,
                  (0, _formatter.currencyFormatter)(shift.total_expense)
                )
              )
            )
          ),
          shift.total_expense > 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleExpense' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'a',
                { className: !this.state.collapseExpense && 'collapsed', 'data-toggle': 'collapse', onClick: this._onClickCollapseExpense },
                React.createElement(
                  'label',
                  null,
                  'TOTAL EXPENSE'
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '('
                  ),
                  (0, _formatter.currencyFormatter)(shift.total_expense),
                  React.createElement(
                    'span',
                    null,
                    ')'
                  )
                )
              )
            ),
            this.state.collapseExpense && React.createElement(
              'div',
              null,
              React.createElement(
                'ul',
                null,
                shift.shift_details.map(function (detail, idx) {
                  return detail.type === 'Expense' && React.createElement(
                    'li',
                    { key: idx },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'label',
                        { className: 'detail-description text-elipsis' },
                        (0, _formatter.formatTime)(detail.created_at),
                        ' - ',
                        detail.description
                      ),
                      React.createElement(
                        'div',
                        { className: '' },
                        React.createElement(
                          'span',
                          null,
                          ' (',
                          (0, _formatter.rupiah)(detail.amount),
                          ')'
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailTotalExpense;
}(React.Component);

ShiftDetailTotalExpense.propTypes = {
  shift: React.PropTypes.object,
  shiftDetails: React.PropTypes.array
};

exports.default = ShiftDetailTotalExpense;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotalIncome = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotalIncome, _React$Component);

  function ShiftDetailTotalIncome(props) {
    (0, _classCallCheck3.default)(this, ShiftDetailTotalIncome);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotalIncome.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotalIncome)).call(this, props));

    _this._onClickCollapseIncomeLink = function () {
      _this.setState({ collapseIncome: !_this.state.collapseIncome });
    };

    _this.state = { collapseIncome: false };
    return _this;
  }

  (0, _createClass3.default)(ShiftDetailTotalIncome, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ collapseIncome: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          shift.total_income <= 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleIncome' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'a',
                { className: 'collapsed disable' },
                React.createElement(
                  'label',
                  null,
                  'TOTAL INCOME'
                ),
                React.createElement(
                  'div',
                  null,
                  'Rp. 0'
                )
              )
            )
          ),
          shift.total_income > 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleIncome' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'a',
                { className: '' + (!this.state.collapseIncome ? 'collapsed' : ''), onClick: this._onClickCollapseIncomeLink },
                React.createElement(
                  'label',
                  null,
                  'TOTAL INCOME'
                ),
                React.createElement(
                  'div',
                  { className: '' },
                  (0, _formatter.currencyFormatter)(shift.total_income)
                )
              )
            ),
            this.state.collapseIncome && React.createElement(
              'div',
              { id: 'collapseIncome' },
              React.createElement(
                'ul',
                null,
                shift.shift_details.map(function (detail, idx) {
                  return detail.type === 'Income' && React.createElement(
                    'li',
                    { key: idx },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'label',
                        { className: 'detail-description' },
                        (0, _formatter.formatTime)(detail.created_at),
                        ' - ',
                        detail.description
                      ),
                      React.createElement(
                        'div',
                        { className: '' },
                        React.createElement(
                          'span',
                          { className: '' },
                          (0, _formatter.rupiah)(detail.amount)
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailTotalIncome;
}(React.Component);

ShiftDetailTotalIncome.propTypes = {
  shift: React.PropTypes.object
};
exports.default = ShiftDetailTotalIncome;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShiftDetailRow = __webpack_require__(301);

var _ShiftDetailRow2 = _interopRequireDefault(_ShiftDetailRow);

var _formatter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailOther = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailOther, _React$Component);

  function ShiftDetailOther() {
    (0, _classCallCheck3.default)(this, ShiftDetailOther);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailOther.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailOther)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailOther, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Other'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 other_detail no-padding-right' },
            React.createElement(_ShiftDetailRow2.default, { label: 'EDC', value: (0, _formatter.currencyFormatter)(shift.total_edc) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Gift Card', value: (0, _formatter.currencyFormatter)(shift.total_gift_card) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Other', value: (0, _formatter.currencyFormatter)(shift.total_other) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Refunds', value: (0, _formatter.currencyFormatter)('-' + shift.other_refunds) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Expected Other Payment', value: (0, _formatter.currencyFormatter)(shift.expected_other_payment) })
          )
        )
      );
    }
  }]);
  return ShiftDetailOther;
}(React.Component);

ShiftDetailOther.propTypes = {
  shift: React.PropTypes.object
};

exports.default = ShiftDetailOther;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _ShiftDetailRow = __webpack_require__(301);

var _ShiftDetailRow2 = _interopRequireDefault(_ShiftDetailRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotal = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotal, _React$Component);

  function ShiftDetailTotal() {
    (0, _classCallCheck3.default)(this, ShiftDetailTotal);
    return (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotal.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotal)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShiftDetailTotal, [{
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-lg-12' },
          React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section' },
            React.createElement(
              'label',
              null,
              'Total'
            )
          ),
          React.createElement(
            'div',
            { className: 'col-sm-12 total_detail no-padding-right' },
            React.createElement(_ShiftDetailRow2.default, { label: 'Total Expected', value: (0, _formatter.currencyFormatter)(shift.total_expected) }),
            React.createElement(_ShiftDetailRow2.default, { label: 'Total Actual', value: shift.ended_at ? (0, _formatter.currencyFormatter)(shift.total_actual) : '-' }),
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-sm-12' },
                React.createElement(
                  'div',
                  { className: 'form-group col-sm-12 label-section end_detail' },
                  React.createElement(
                    'label',
                    null,
                    'Difference'
                  ),
                  React.createElement(
                    'div',
                    { className: 'pull-right' },
                    shift.ended_at ? (0, _formatter.currencyFormatter)(shift.total_difference) : '-'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailTotal;
}(React.Component);

ShiftDetailTotal.propTypes = {
  shift: React.PropTypes.object
};
exports.default = ShiftDetailTotal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _ShiftDetailTotalExpense = __webpack_require__(2230);

var _ShiftDetailTotalExpense2 = _interopRequireDefault(_ShiftDetailTotalExpense);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotalExpense = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotalExpense, _React$Component);

  function ShiftDetailTotalExpense(props) {
    (0, _classCallCheck3.default)(this, ShiftDetailTotalExpense);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotalExpense.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotalExpense)).call(this, props));

    _this._onClickCollapseExpense = function () {
      _this.setState({ collapseExpense: !_this.state.collapseExpense });
    };

    _this.state = {
      collapseExpense: false
    };
    return _this;
  }

  (0, _createClass3.default)(ShiftDetailTotalExpense, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ collapseExpense: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          shift.total_expense <= 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleExpense' },
            React.createElement(
              'a',
              { className: 'collapsed disable' },
              React.createElement(
                'label',
                null,
                'Total Expense'
              ),
              React.createElement(
                'div',
                { className: 'pull-right' },
                (0, _formatter.currencyFormatter)(shift.total_expense)
              )
            )
          ),
          shift.total_expense > 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleExpense' },
            React.createElement(
              'a',
              { className: !this.state.collapseExpense && 'collapsed', 'data-toggle': 'collapse', onClick: this._onClickCollapseExpense },
              React.createElement(
                'label',
                null,
                'Total Expense'
              ),
              React.createElement(
                'div',
                { className: 'pull-right' },
                React.createElement(
                  'span',
                  null,
                  '('
                ),
                (0, _formatter.currencyFormatter)(shift.total_expense),
                React.createElement(
                  'span',
                  null,
                  ')'
                )
              )
            ),
            this.state.collapseExpense && React.createElement(
              'div',
              null,
              React.createElement(
                'ul',
                null,
                shift.shift_details.map(function (detail, idx) {
                  return detail.type === 'Expense' && React.createElement(
                    'li',
                    { key: idx },
                    React.createElement(
                      'label',
                      { className: 'detail-description text-elipsis ' + _ShiftDetailTotalExpense2.default['total-expense-label'] },
                      (0, _formatter.formatTime)(detail.created_at),
                      ' - ',
                      detail.description
                    ),
                    React.createElement(
                      'div',
                      { className: '' + _ShiftDetailTotalExpense2.default['total-expense-amount'] },
                      React.createElement(
                        'span',
                        { className: 'pull-right' },
                        ' (',
                        (0, _formatter.rupiah)(detail.amount),
                        ')'
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailTotalExpense;
}(React.Component);

ShiftDetailTotalExpense.propTypes = {
  shift: React.PropTypes.object,
  shiftDetails: React.PropTypes.array
};

exports.default = ShiftDetailTotalExpense;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _ShiftDetailTotalIncome = __webpack_require__(2231);

var _ShiftDetailTotalIncome2 = _interopRequireDefault(_ShiftDetailTotalIncome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiftDetailTotalIncome = function (_React$Component) {
  (0, _inherits3.default)(ShiftDetailTotalIncome, _React$Component);

  function ShiftDetailTotalIncome(props) {
    (0, _classCallCheck3.default)(this, ShiftDetailTotalIncome);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiftDetailTotalIncome.__proto__ || (0, _getPrototypeOf2.default)(ShiftDetailTotalIncome)).call(this, props));

    _this._onClickCollapseIncomeLink = function () {
      _this.setState({ collapseIncome: !_this.state.collapseIncome });
    };

    _this.state = { collapseIncome: false };
    return _this;
  }

  (0, _createClass3.default)(ShiftDetailTotalIncome, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ collapseIncome: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var shift = this.props.shift;

      return React.createElement(
        'div',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-sm-12' },
          shift.total_income <= 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleIncome' },
            React.createElement(
              'a',
              { className: 'collapsed disable' },
              React.createElement(
                'label',
                null,
                'Total Income'
              ),
              React.createElement(
                'div',
                { className: 'pull-right' },
                'Rp. 0'
              )
            )
          ),
          shift.total_income > 0 && React.createElement(
            'div',
            { className: 'form-group col-sm-12 label-section', id: 'collapsibleIncome' },
            React.createElement(
              'a',
              { className: '' + (!this.state.collapseIncome ? 'collapsed' : ''), onClick: this._onClickCollapseIncomeLink },
              React.createElement(
                'label',
                null,
                'Total Income'
              ),
              React.createElement(
                'div',
                { className: 'pull-right' },
                (0, _formatter.currencyFormatter)(shift.total_income)
              )
            ),
            this.state.collapseIncome && React.createElement(
              'div',
              { id: 'collapseIncome' },
              React.createElement(
                'ul',
                null,
                shift.shift_details.map(function (detail, idx) {
                  return detail.type === 'Income' && React.createElement(
                    'li',
                    { key: idx },
                    React.createElement(
                      'label',
                      { className: 'detail-description ' + _ShiftDetailTotalIncome2.default['total-income-label'] },
                      (0, _formatter.formatTime)(detail.created_at),
                      ' - ',
                      detail.description
                    ),
                    React.createElement(
                      'div',
                      { className: '' + _ShiftDetailTotalIncome2.default['total-income-amount'] },
                      React.createElement(
                        'span',
                        { className: 'pull-right' },
                        (0, _formatter.rupiah)(detail.amount)
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ShiftDetailTotalIncome;
}(React.Component);

ShiftDetailTotalIncome.propTypes = {
  shift: React.PropTypes.object
};
exports.default = ShiftDetailTotalIncome;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _DropdownOutlet = __webpack_require__(62);

var _DropdownOutlet2 = _interopRequireDefault(_DropdownOutlet);

var _DropdownCalendar = __webpack_require__(113);

var _DropdownCalendar2 = _interopRequireDefault(_DropdownCalendar);

var _SearchBar = __webpack_require__(82);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _OutletModal = __webpack_require__(241);

var _OutletModal2 = _interopRequireDefault(_OutletModal);

var _ActionBar = __webpack_require__(2234);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reduxForm = __webpack_require__(7);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _transactions2 = __webpack_require__(298);

var mpTransactions = _interopRequireWildcard(_transactions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = function (_React$Component) {
  (0, _inherits3.default)(ActionBar, _React$Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this._onChangeOutlet = function (outletIds) {
      var _this$props$search$da = _this.props.search.date,
          startDate = _this$props$search$da.startDate,
          endDate = _this$props$search$da.endDate;

      mpTransactions.reportsTransactionsChangeFilter({
        outletIds: outletIds,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _transactions.changeOutlet)(outletIds));
    }, _this._onChangeDate = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var outlet = _this.props.search.outlet;

      mpTransactions.reportsTransactionsChangeFilter({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _transactions.changeDate)(startDate, endDate));
    }, _this._onChangeKeyword = function (event, keyword) {
      var _this$props$search$da2 = _this.props.search.date,
          startDate = _this$props$search$da2.startDate,
          endDate = _this$props$search$da2.endDate;

      _this.props.dispatch((0, _transactions.changeKeyword)({ keyword: keyword, startDate: startDate, endDate: endDate }));
    }, _this._onClickExportButton = function () {
      var _this$props$search = _this.props.search,
          _this$props$search$da3 = _this$props$search.date,
          startDate = _this$props$search$da3.startDate,
          endDate = _this$props$search$da3.endDate,
          outlet = _this$props$search.outlet;


      var query = { start: (0, _moment2.default)(startDate).format('D/M/Y'), end: (0, _moment2.default)(endDate).format('D/M/Y') };
      var dateLabel = startDate.isSame(endDate, 'days') ? (0, _moment2.default)(startDate).format('DD-MM-YYYY') : [(0, _moment2.default)(startDate).format('DD-MM-YYYY'), (0, _moment2.default)(endDate).format('DD-MM-YYYY')].join(' - ');
      var filename = 'Report Transaction - ' + dateLabel;
      mpTransactions.reportsTransactionsExport({
        outletIds: outlet,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.dispatch((0, _transactions.exportTransaction)(query, filename, outlet[0]));
    }, _this._onSubmit = function (e) {
      e.preventDefault();
      e.stopPropagation();
    }, _this._onClickSearchBar = function () {
      mpTransactions.reportsTransactionsSearchBarInit({});
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var showModalOutletMobileState = this.props.showModalOutletMobileState;

      return React.createElement(
        'div',
        { className: _ActionBar2.default['mk-action-bar'] },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-9 col-xs-12 col-sm-12' },
            React.createElement(
              'div',
              { className: _ActionBar2.default['form-group'] + ' form-group pull-left visible-md visible-lg no-margin' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownOutlet2.default,
                name: 'outlet',
                onChangeOutletIds: this._onChangeOutlet,
                outlets: this.props.outlets,
                allOutletOption: true
              })
            ),
            React.createElement(
              'div',
              { className: _ActionBar2.default['form-group'] + ' form-group pull-left no-margin' },
              React.createElement(_reduxForm.Field, {
                component: _DropdownCalendar2.default,
                name: 'date',
                onChange: this._onChangeDate,
                updateServerOnChange: true
              })
            ),
            React.createElement(
              'div',
              { className: _ActionBar2.default['form-group'] + ' form-group pull-left visible-md visible-lg no-margin' },
              React.createElement(_reduxForm.Field, {
                component: _SearchBar2.default,
                name: 'keyword',
                onChange: this._onChangeKeyword,
                onClick: this._onClickSearchBar,
                placeholder: 'Receipt number',
                className: _ActionBar2.default['search-receipt']
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 element-non-mobi' },
            React.createElement(
              'div',
              { className: 'pull-right' },
              React.createElement(
                'a',
                { className: 'btn btn-primary btn-export', onClick: this._onClickExportButton },
                'Export'
              )
            )
          )
        ),
        React.createElement(_reduxForm.Field, {
          component: _OutletModal2.default,
          name: 'outlet',
          outlets: this.props.outlets || [],
          onChangeOutletIds: this._onChangeOutlet,
          allOutletOption: true,
          show: showModalOutletMobileState
        })
      );
    }
  }]);
  return ActionBar;
}(React.Component);

ActionBar.propTypes = {
  outlets: React.PropTypes.array,
  dispatch: React.PropTypes.func,
  onChangeKeyword: React.PropTypes.func
};

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  var outlets = state.reports.transactions.outlets;

  return {
    outlets: outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

var mapForm = {
  form: 'search'
};

exports.default = (0, _reduxForm.reduxForm)(mapForm)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActionBar));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _formatter = __webpack_require__(11);

var _formatter2 = __webpack_require__(1564);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _Table = __webpack_require__(2235);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = function (_React$Component) {
  (0, _inherits3.default)(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this._onClickRow = function (payment) {
      _this.props.onChangePayment(payment);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Table, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$data$reports$t = this.props.data.reports.transactions,
          transactions = _props$data$reports$t.transactions,
          transactionDetail = _props$data$reports$t.transactionDetail;

      return React.createElement(
        'div',
        { className: _Table2.default['table-list'], id: 'transaction-table-list' },
        transactions.map(function (transaction, tidx) {
          return React.createElement(
            'table',
            { key: tidx, className: 'table table-responsive ' + _Table2.default['table'] + ' ' + _this2.props.className },
            React.createElement(
              'thead',
              { className: _Table2.default['table-head'] },
              React.createElement(
                'tr',
                { className: 'visible-md visible-lg' },
                React.createElement(
                  'th',
                  { colSpan: '3' },
                  transaction.date_label
                ),
                React.createElement(
                  'th',
                  { colSpan: '2', className: 'text-right' },
                  React.createElement(
                    'span',
                    null,
                    (0, _formatter.rupiahWithNegative)(transaction.total_collected)
                  )
                )
              ),
              React.createElement(
                'tr',
                { className: 'visible-xs visible-sm' },
                React.createElement(
                  'th',
                  null,
                  (0, _moment2.default)(transaction.date_label).format('ddd, MMM DD, YYYY')
                ),
                React.createElement(
                  'th',
                  { className: 'text-right' },
                  React.createElement(
                    'span',
                    null,
                    (0, _formatter.rupiahWithNegative)(transaction.total_collected)
                  )
                )
              )
            ),
            React.createElement(
              'tbody',
              null,
              transaction.payments.map(function (payment, pidx) {
                return React.createElement(
                  'tr',
                  { key: pidx, onClick: function onClick() {
                      return _this2._onClickRow(payment);
                    },
                    className: _Table2.default['table-row'] + ' ' + (transactionDetail !== null && payment.parent_payment_id === transactionDetail.id ? _Table2.default['selected'] : '') },
                  React.createElement(
                    'td',
                    { className: 'text-left visible-md visible-lg' },
                    payment.outlet_name
                  ),
                  React.createElement(
                    'td',
                    null,
                    React.createElement(
                      'span',
                      null,
                      (0, _formatter2.getCreatedAt)(payment.created_at)
                    )
                  ),
                  React.createElement(
                    'td',
                    { className: 'text-left visible-md visible-lg' },
                    payment.created_by
                  ),
                  React.createElement(
                    'td',
                    { className: 'text-left visible-md visible-lg' },
                    payment.name
                  ),
                  React.createElement(
                    'td',
                    { className: 'text-right ' + _Table2.default.total },
                    !payment.is_refunded && (0, _formatter.rupiahWithNegative)(payment.total_collected),
                    payment.is_refunded && '(' + (0, _formatter.rupiahWithNegative)(payment.refund_amount) + ')'
                  )
                );
              })
            )
          );
        })
      );
    }
  }]);
  return Table;
}(React.Component);

Table.propTypes = {
  onChangePayment: React.PropTypes.func
};

function mapStateToProps(state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Table);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ActionBar = __webpack_require__(1561);

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _reactRedux = __webpack_require__(6);

var _transactions = __webpack_require__(128);

var _Summary = __webpack_require__(1193);

var _Summary2 = _interopRequireDefault(_Summary);

var _Table = __webpack_require__(1562);

var _Table2 = _interopRequireDefault(_Table);

var _TransactionDetail = __webpack_require__(648);

var _TransactionDetail2 = _interopRequireDefault(_TransactionDetail);

var _ResendEmailModal = __webpack_require__(1192);

var _ResendEmailModal2 = _interopRequireDefault(_ResendEmailModal);

var _TransactionRefundModal = __webpack_require__(1183);

var _TransactionRefundModal2 = _interopRequireDefault(_TransactionRefundModal);

var _TransactionDetailModal = __webpack_require__(1196);

var _TransactionDetailModal2 = _interopRequireDefault(_TransactionDetailModal);

var _OldRefundTransactionModal = __webpack_require__(1181);

var _OldRefundTransactionModal2 = _interopRequireDefault(_OldRefundTransactionModal);

__webpack_require__(2237);

var _Transaction = __webpack_require__(2236);

var _Transaction2 = _interopRequireDefault(_Transaction);

var _reduxForm = __webpack_require__(7);

var _NoDataAndLoading = __webpack_require__(54);

var _NoDataAndLoading2 = _interopRequireDefault(_NoDataAndLoading);

var _reactRouter = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Transaction = function (_React$Component) {
  (0, _inherits3.default)(Transaction, _React$Component);

  function Transaction() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Transaction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Transaction.__proto__ || (0, _getPrototypeOf2.default)(Transaction)).call.apply(_ref, [this].concat(args))), _this), _this._onChangePaymentNonMobile = function (payment) {
      _this.props.dispatch((0, _transactions.showTransactionDetailRequestNonMobile)(payment.parent_payment_id, {}));
    }, _this._onChangePaymentMobile = function (payment) {
      _this.props.dispatch((0, _transactions.showTransactionDetailRequestMobile)(payment.parent_payment_id, {}));
    }, _this._onClickDoneButton = function () {
      _this.props.dispatch((0, _transactions.hideTransactionDetail)());
    }, _this._onSubmitResendEmailForm = function (values) {
      var transactionDetail = _this.props.data.reports.transactions.transactionDetail;

      var data = {
        customer_email: values.email,
        payment_id: transactionDetail.id,
        resend_email: true
      };
      _this.props.dispatch((0, _transactions.sendEmailReceipt)(data));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Transaction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var expired = this.props.data.subscriptionExpired.expired;

      if (!expired) {
        this.props.dispatch((0, _transactions.pageRequest)());
      } else {
        _reactRouter.browserHistory.push('/settings/billing');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // transactions == the reducer state. not to be confused with transactions.transactions
      var _props$data$reports$t = this.props.data.reports.transactions,
          transactions = _props$data$reports$t.transactions,
          transactionDetail = _props$data$reports$t.transactionDetail,
          netSales = _props$data$reports$t.netSales,
          totalCollected = _props$data$reports$t.totalCollected,
          totalTransactions = _props$data$reports$t.totalTransactions;
      var showLoadingSpinnerPage = this.props.data.loadingSpinner.showLoadingSpinnerPage;


      return React.createElement(
        'div',
        { className: 'transaction-list' },
        React.createElement(
          'div',
          { className: 'box-transaction-list' },
          React.createElement(_ActionBar2.default, null),
          React.createElement(
            'div',
            { className: _Transaction2.default['report-transaction'] },
            React.createElement(
              'div',
              { style: { 'height': '100%' } },
              React.createElement(
                'div',
                { className: 'col-sm-12 col-md-12 no-padding ' + _Transaction2.default['left-column'], id: 'mk-col-left' },
                React.createElement(_NoDataAndLoading2.default, {
                  showLoadingSpinner: showLoadingSpinnerPage,
                  noDataToDisplay: transactions && transactions.length === 0,
                  title: 'No Transactions',
                  description: 'You can make transactions through your device, or select different time frame.' }),
                transactions && transactions.length > 0 && React.createElement(
                  'div',
                  { className: _Transaction2.default['transaction-wrapper'] },
                  React.createElement(_Summary2.default, {
                    netSales: netSales,
                    totalCollected: totalCollected,
                    totalTransactions: totalTransactions
                  }),
                  React.createElement(
                    'div',
                    { className: 'visible-md visible-lg ' + _Transaction2.default['table-wrapper'] },
                    React.createElement(_Table2.default, { onChangePayment: this._onChangePaymentNonMobile, className: 'table-dekstop' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'visible-xs visible-sm full-height' },
                    React.createElement(_Table2.default, { onChangePayment: this._onChangePaymentMobile, onClose: this._onClickDoneButton, className: 'table-mobile' })
                  )
                )
              ),
              transactions && transactions.length > 0 && React.createElement(
                'div',
                { className: 'col-sm-12 ' + _Transaction2.default['right-column'], id: 'mk-col-right' },
                React.createElement(_TransactionDetail2.default, {
                  onClickDoneButton: this._onClickDoneButton,
                  dispatch: this.props.dispatch
                })
              )
            )
          )
        ),
        React.createElement(_ResendEmailModal2.default, { dispatch: this.props.dispatch, onSubmit: this._onSubmitResendEmailForm }),
        transactionDetail !== null && React.createElement(_TransactionRefundModal2.default, null),
        React.createElement(_TransactionDetailModal2.default, { dispatch: this.props.dispatch }),
        transactionDetail !== null && React.createElement(_OldRefundTransactionModal2.default, null)
      );
    }
  }]);
  return Transaction;
}(React.Component);

var selector = (0, _reduxForm.formValueSelector)('search');

function mapStateToProps(state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
      keyword: selector(state, 'keyword')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Transaction);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateLabel = formatDateLabel;
exports.getCreatedAt = getCreatedAt;
function formatDateLabel(dateLabel) {
  var dateLabelToArray = dateLabel.split(',');
  dateLabelToArray[0] = dateLabelToArray[0].substr(0, 3);
  var dayAndDateToArray = dateLabelToArray[1].split(' ');
  dayAndDateToArray[1] = dayAndDateToArray[1].substr(0, 3);
  dateLabelToArray[1] = dayAndDateToArray.join(' ');

  return dateLabelToArray.join(',');
}

function getCreatedAt(paymentCreatedAt) {
  var date = new Date(paymentCreatedAt);
  return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactBootstrap = __webpack_require__(10);

var _NotificationModal = __webpack_require__(2239);

var _NotificationModal2 = _interopRequireDefault(_NotificationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationModal = function (_React$Component) {
  (0, _inherits3.default)(NotificationModal, _React$Component);

  function NotificationModal() {
    (0, _classCallCheck3.default)(this, NotificationModal);
    return (0, _possibleConstructorReturn3.default)(this, (NotificationModal.__proto__ || (0, _getPrototypeOf2.default)(NotificationModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotificationModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isShow = _props.isShow,
          headerMessage = _props.headerMessage,
          bodyMessage = _props.bodyMessage,
          btnConfirm = _props.btnConfirm,
          btnHide = _props.btnHide,
          onHide = _props.onHide,
          onConfirm = _props.onConfirm,
          isNotificationError = _props.isNotificationError;

      return React.createElement(
        _reactBootstrap.Modal,
        { show: isShow, onHide: this._onHide, dialogClassName: 'modal-dialog ' + _NotificationModal2.default.dialog },
        React.createElement(
          _reactBootstrap.Modal.Header,
          { bsClass: isNotificationError !== 'success' ? 'modal-header ' + _NotificationModal2.default.error : 'modal-header ' + _NotificationModal2.default.notification },
          React.createElement(
            'div',
            { className: 'title' },
            headerMessage
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Body,
          null,
          React.createElement(
            'p',
            null,
            bodyMessage
          )
        ),
        React.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          isNotificationError !== 'success' && React.createElement(
            'button',
            { onClick: function onClick() {
                return onHide();
              }, className: 'btn btn-default' },
            btnHide
          ),
          isNotificationError !== 'success' && React.createElement(
            'button',
            { onClick: function onClick() {
                return onConfirm();
              }, className: 'btn btn-primary' },
            isNotificationError !== 'unregistered' ? btnConfirm : 'Sign Up'
          ),
          isNotificationError === 'success' && React.createElement(
            'button',
            { onClick: function onClick() {
                return onConfirm();
              }, className: 'btn btn-default' },
            'Ok'
          )
        )
      );
    }
  }]);
  return NotificationModal;
}(React.Component);

exports.default = NotificationModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ResendVerificationEmailForm = __webpack_require__(1567);

var _ResendVerificationEmailForm2 = _interopRequireDefault(_ResendVerificationEmailForm);

var _reactRedux = __webpack_require__(6);

var _style = __webpack_require__(2240);

var _style2 = _interopRequireDefault(_style);

var _AuthTitle = __webpack_require__(443);

var _AuthTitle2 = _interopRequireDefault(_AuthTitle);

var _NotificationModal = __webpack_require__(1565);

var _NotificationModal2 = _interopRequireDefault(_NotificationModal);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResendVerificationEmail = function (_React$Component) {
  (0, _inherits3.default)(ResendVerificationEmail, _React$Component);

  function ResendVerificationEmail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResendVerificationEmail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResendVerificationEmail.__proto__ || (0, _getPrototypeOf2.default)(ResendVerificationEmail)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (values) {
      var email = values.email;

      _this.props.dispatch((0, _actions.resendVerificationEmail)(email));
    }, _this.onEmailAlreadyRegisteredModalConfirm = function () {
      _this.props.dispatch((0, _actions.setResendEmailVerificationState)({ isModalShow: false }));
      if (_this.props.resendVerificationEmail.modalStatus === 'unregistered') {
        _this.props.dispatch((0, _actions.toSignUpPage)());
      } else {
        _this.props.dispatch((0, _actions.toLoginPage)());
      }
    }, _this.onEmailAlreadyRegisteredModalHide = function () {
      _this.props.dispatch((0, _actions.setResendEmailVerificationState)({ isModalShow: false }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResendVerificationEmail, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: _style2.default.root },
        React.createElement(_AuthTitle2.default, { title: 'Resend Verification Email' }),
        React.createElement(
          'div',
          { className: 'text-center mb-40px ' + _style2.default['text-margin-resend'] },
          React.createElement(
            'p',
            { className: 'no-margin' },
            'Please enter your email address and we will'
          ),
          React.createElement(
            'p',
            { className: 'no-margin' },
            're-send you a verification email.'
          )
        ),
        React.createElement(_ResendVerificationEmailForm2.default, {
          history: this.props.history,
          onSubmit: this.handleSubmit
        }),
        React.createElement(_NotificationModal2.default, {
          isShow: this.props.resendVerificationEmail.isModalShow,
          headerMessage: this.props.resendVerificationEmail.headerMessage,
          bodyMessage: this.props.resendVerificationEmail.bodyMessage,
          btnConfirm: 'Sign In',
          btnHide: 'Close',
          onHide: this.onEmailAlreadyRegisteredModalHide,
          onConfirm: this.onEmailAlreadyRegisteredModalConfirm,
          isNotificationError: this.props.resendVerificationEmail.modalStatus
        })
      );
    }

    /**
     * Handle submit from redux from
     * @param values json object contains {email}
     */

  }]);
  return ResendVerificationEmail;
}(React.Component);

// ResendVerificationEmail.propTypes = {
//   form: React.PropTypes.object,
//   history: React.PropTypes.object,
//   dispatch: React.PropTypes.func
// }

function mapStateToProps(state) {
  return {
    form: state.form,
    resendVerificationEmail: state.moka.resendVerificationEmail
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
}

// Wrap the component to inject dispatch and state into it
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResendVerificationEmail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AuthField = __webpack_require__(435);

var _AuthField2 = _interopRequireDefault(_AuthField);

var _reduxForm = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Please enter a valid email address';
  }
  return errors;
};

var ResendVerificationEmailForm = function (_React$Component) {
  (0, _inherits3.default)(ResendVerificationEmailForm, _React$Component);

  function ResendVerificationEmailForm() {
    (0, _classCallCheck3.default)(this, ResendVerificationEmailForm);
    return (0, _possibleConstructorReturn3.default)(this, (ResendVerificationEmailForm.__proto__ || (0, _getPrototypeOf2.default)(ResendVerificationEmailForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResendVerificationEmailForm, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'form',
        { onSubmit: this.props.handleSubmit },
        React.createElement(_reduxForm.Field, {
          component: _AuthField2.default,
          name: 'email',
          type: 'text',
          placeholder: 'Email',
          autoCorrect: 'off',
          autoCapitalize: 'off',
          icon: 'fa fa-envelope-o',
          spellCheck: 'false' }),
        React.createElement(
          'button',
          { type: 'submit', className: 'btn btn-primary btn-block' },
          'Resend'
        )
      );
    }
  }]);
  return ResendVerificationEmailForm;
}(React.Component);

ResendVerificationEmailForm.propTypes = {
  handleSubmit: React.PropTypes.func
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'resendVerificationEmail',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
})(ResendVerificationEmailForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _ResetPasswordForm = __webpack_require__(1569);

var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);

var _ResetPasswordFormInvalid = __webpack_require__(1570);

var _ResetPasswordFormInvalid2 = _interopRequireDefault(_ResetPasswordFormInvalid);

var _style = __webpack_require__(510);

var _style2 = _interopRequireDefault(_style);

var _actions = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = function (_React$Component) {
  (0, _inherits3.default)(ResetPassword, _React$Component);

  function ResetPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.sendForgotPassword = function (values) {
      var email = values.email;

      _this.props.dispatch((0, _actions.forgotPassword)({ email: email }));
    }, _this.handleSubmit = function (values) {
      var resetPasswordToken = _this.props.params.token;
      _this.props.dispatch((0, _actions.resetPassword)(values, resetPasswordToken));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resetPasswordToken = this.props.params.token;
      this.props.dispatch((0, _actions.loadResetPassword)(resetPasswordToken));
      this.props.dispatch((0, _actions.loadPrepareEncryption)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          data = _props.data;

      var resetState = data.moka.resetPasswordState;
      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: _style2.default.root, id: 'reset-password-page' },
            resetState.tokenError ? React.createElement(
              'div',
              null,
              React.createElement(
                'h3',
                { className: _style2.default['title-panel'] },
                'Link Expired :('
              ),
              React.createElement(_ResetPasswordFormInvalid2.default, {
                dispatch: dispatch,
                history: this.props.history,
                onSubmit: this.sendForgotPassword,
                btnText: 'Submit'
              })
            ) : React.createElement(
              'div',
              null,
              React.createElement(
                'h3',
                { className: _style2.default['title-panel'] },
                'Reset your password'
              ),
              React.createElement(_ResetPasswordForm2.default, {
                dispatch: dispatch,
                fullName: resetState.fullName,
                history: this.props.history,
                onSubmit: this.handleSubmit,
                btnText: 'Reset Password'
              })
            )
          )
        )
      );
    }

    /**
     * Handle submission of login form
     * @param values the JSON containing {email,password}
     */

  }]);
  return ResetPassword;
}(React.Component);

// Which props do we want to inject, given the global state?


function select(state) {
  return {
    data: state
  };
}

// Wrap the component to inject dispatch and state into it
exports.default = (0, _reactRedux.connect)(select)(ResetPassword);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _LoadingButton = __webpack_require__(1139);

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _style = __webpack_require__(510);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _ResetPasswordField = __webpack_require__(638);

var _ResetPasswordField2 = _interopRequireDefault(_ResetPasswordField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};

  if (!values.newPassword) {
    errors.newPassword = 'The password is required';
  } else if (values.newPassword.length < 6) {
    errors.newPassword = 'Password at least have to be 6 characters long';
  }
  if (!values.confPassword) {
    errors.confPassword = 'The password is required';
  } else if (values.newPassword !== values.confPassword) {
    errors.confPassword = 'The password and its confirm are not the same';
  }
  return errors;
};

var ResetPasswordForm = function (_React$Component) {
  (0, _inherits3.default)(ResetPasswordForm, _React$Component);

  function ResetPasswordForm() {
    (0, _classCallCheck3.default)(this, ResetPasswordForm);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPasswordForm, [{
    key: 'render',
    value: function render() {
      var handleSubmit = this.props.handleSubmit;

      var userFullName = this.props.fullName;
      return React.createElement(
        'div',
        { className: 'col-md-12 no-padding' },
        React.createElement(
          'form',
          { onSubmit: handleSubmit },
          React.createElement(
            'p',
            { className: _style2.default['description-reset-password'] },
            'Hello ',
            userFullName,
            '. Please create a new password that is at least 6 characters long.'
          ),
          React.createElement(_reduxForm.Field, {
            component: _ResetPasswordField2.default,
            name: 'newPassword',
            type: 'password',
            placeholder: 'New Password',
            autoCorrect: 'off',
            maxLength: '40',
            autoCapitalize: 'off',
            spellCheck: 'false'
          }),
          React.createElement(_reduxForm.Field, {
            component: _ResetPasswordField2.default,
            name: 'confPassword',
            type: 'password',
            placeholder: 'Confirm New Password',
            autoCorrect: 'off',
            maxLength: '40',
            autoCapitalize: 'off',
            spellCheck: 'false'
          }),
          React.createElement(
            'div',
            { className: _style2.default['submit-btn-container'] },
            this.props.currentlySending ? React.createElement(_LoadingButton2.default, null) : React.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary center ' + _style2.default['submit-btn'] },
              this.props.btnText
            )
          )
        )
      );
    }
  }]);
  return ResetPasswordForm;
}(React.Component);

ResetPasswordForm.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  btnText: React.PropTypes.string
};

var mapFormValidation = {
  form: 'ResetPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)(ResetPasswordForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(510);

var _style2 = _interopRequireDefault(_style);

var _reduxForm = __webpack_require__(7);

var _reactRouter = __webpack_require__(15);

var _ResetPasswordField = __webpack_require__(638);

var _ResetPasswordField2 = _interopRequireDefault(_ResetPasswordField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};
  if (!values.email) {
    errors.email = 'The email address is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'The value is not a valid email address';
  }
  return errors;
};

var ResetPasswordFormInvalid = function (_React$Component) {
  (0, _inherits3.default)(ResetPasswordFormInvalid, _React$Component);

  function ResetPasswordFormInvalid() {
    (0, _classCallCheck3.default)(this, ResetPasswordFormInvalid);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordFormInvalid.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordFormInvalid)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPasswordFormInvalid, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'col-md-12 no-padding' },
        React.createElement(
          'form',
          { onSubmit: this.props.handleSubmit },
          React.createElement(
            'p',
            { className: 'text-center ' + _style2.default['description-reset-password'] },
            'The link provided is already expired or no longer match, please resubmit your email and try again.'
          ),
          React.createElement(_reduxForm.Field, {
            component: _ResetPasswordField2.default,
            name: 'email',
            maxLength: '40',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            placeholder: 'Registered email address',
            spellCheck: 'false'
          }),
          React.createElement(
            'div',
            { className: _style2.default['submit-btn-container'] },
            React.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary ' + _style2.default['submit-btn'] },
              this.props.btnText
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'col-md-12 col-xs-12 text-center ' + _style2.default['back-to-login'] },
          React.createElement(
            _reactRouter.Link,
            { to: '/login', className: 'text-center' },
            'Back to login'
          )
        )
      );
    }
  }]);
  return ResetPasswordFormInvalid;
}(React.Component);

ResetPasswordFormInvalid.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  btnText: React.PropTypes.string
};

var mapFormValidation = {
  form: 'ResetPasswordFormInvalid',
  touchOnBlur: false,
  touchOnChange: true,
  validate: validate
};

exports.default = (0, _reduxForm.reduxForm)(mapFormValidation)(ResetPasswordFormInvalid);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = __webpack_require__(2241);

var _style2 = _interopRequireDefault(_style);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessForgotPassword = function (_React$Component) {
  (0, _inherits3.default)(SuccessForgotPassword, _React$Component);

  function SuccessForgotPassword() {
    (0, _classCallCheck3.default)(this, SuccessForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (SuccessForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(SuccessForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(SuccessForgotPassword, [{
    key: 'render',
    value: function render() {
      var forgotState = this.props.data.moka.forgotState;
      var email = forgotState.email;

      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-6 col-sm-offset-3' },
            React.createElement(
              'div',
              { className: _style2.default['success-forgot-password'] },
              React.createElement(
                'h1',
                { className: 'text-center' },
                'Instructions have been sent'
              ),
              React.createElement('hr', null),
              React.createElement(
                'div',
                { className: 'text-center' },
                React.createElement('img', { alt: 'Email logo', src: __webpack_require__(2857) }),
                React.createElement('br', null),
                'Password reset instruction has been sent to ',
                React.createElement(
                  'span',
                  { className: _style2.default['text-email'] },
                  email
                ),
                '.',
                React.createElement('br', null),
                React.createElement('br', null),
                'Don\'t forget to check your spam and junk filters if they don\'t arrive.'
              )
            )
          )
        )
      );
    }
  }]);
  return SuccessForgotPassword;
}(React.Component);

function select(state) {
  return {
    data: state
  };
}

exports.default = (0, _reactRedux.connect)(select)(SuccessForgotPassword);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRouter = __webpack_require__(15);

var _style = __webpack_require__(2242);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessResetPassword = function (_React$Component) {
  (0, _inherits3.default)(SuccessResetPassword, _React$Component);

  function SuccessResetPassword() {
    (0, _classCallCheck3.default)(this, SuccessResetPassword);
    return (0, _possibleConstructorReturn3.default)(this, (SuccessResetPassword.__proto__ || (0, _getPrototypeOf2.default)(SuccessResetPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(SuccessResetPassword, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-sm-6 col-sm-offset-3' },
            React.createElement(
              'div',
              { className: _style2.default['box-success'] },
              React.createElement(
                'p',
                { className: 'text-center ' + _style2.default['title'] },
                'Your password is updated!'
              ),
              React.createElement(
                'div',
                { className: 'text-center ' + _style2.default['desc-title'] },
                'Please click the button below and login with your new password'
              ),
              React.createElement(
                'p',
                { className: 'text-center' },
                React.createElement(
                  _reactRouter.Link,
                  { to: '/login', className: 'btn btn-primary ' + _style2.default['btn-login'] },
                  'Login'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SuccessResetPassword;
}(React.Component);

exports.default = SuccessResetPassword;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _verifyEmail = __webpack_require__(620);

var _VerifyEmail = __webpack_require__(2243);

var _VerifyEmail2 = _interopRequireDefault(_VerifyEmail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerifyEmail = function (_React$Component) {
  (0, _inherits3.default)(VerifyEmail, _React$Component);

  function VerifyEmail() {
    (0, _classCallCheck3.default)(this, VerifyEmail);
    return (0, _possibleConstructorReturn3.default)(this, (VerifyEmail.__proto__ || (0, _getPrototypeOf2.default)(VerifyEmail)).apply(this, arguments));
  }

  (0, _createClass3.default)(VerifyEmail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var accessToken = this.props.params.token;
      this.props.dispatch((0, _verifyEmail.sendVerifyEmail)(accessToken));
    }
  }, {
    key: 'render',
    value: function render() {
      var invalidTokenVerifyEmail = this.props.data.verifyEmail.invalidTokenVerifyEmail;

      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          invalidTokenVerifyEmail && React.createElement(
            'div',
            { className: _VerifyEmail2.default['invalid-message'] },
            'Your access token is invalid or expired'
          )
        )
      );
    }
  }]);
  return VerifyEmail;
}(React.Component);

function mapStateToProps(state) {
  return {
    data: {
      verifyEmail: state.verifyEmail
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(VerifyEmail);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(6);

var _verifyEmailAlertRecipient = __webpack_require__(621);

var _VerifyEmailAlertRecipient = __webpack_require__(2244);

var _VerifyEmailAlertRecipient2 = _interopRequireDefault(_VerifyEmailAlertRecipient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerifyEmailAlertRecipient = function (_React$Component) {
  (0, _inherits3.default)(VerifyEmailAlertRecipient, _React$Component);

  function VerifyEmailAlertRecipient() {
    (0, _classCallCheck3.default)(this, VerifyEmailAlertRecipient);
    return (0, _possibleConstructorReturn3.default)(this, (VerifyEmailAlertRecipient.__proto__ || (0, _getPrototypeOf2.default)(VerifyEmailAlertRecipient)).apply(this, arguments));
  }

  (0, _createClass3.default)(VerifyEmailAlertRecipient, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var token = this.props.params.token;

      this.props.dispatch((0, _verifyEmailAlertRecipient.sendVerifyEmailAlertRecipient)(token));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          invalidTokenVerifyEmailAlertRecipient = _props.invalidTokenVerifyEmailAlertRecipient,
          message = _props.message;

      return React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: !invalidTokenVerifyEmailAlertRecipient ? _VerifyEmailAlertRecipient2.default['success-message'] : _VerifyEmailAlertRecipient2.default['invalid-message'] },
            message
          )
        )
      );
    }
  }]);
  return VerifyEmailAlertRecipient;
}(React.Component);

function mapStateToProps(state) {
  var _state$verifyEmailAle = state.verifyEmailAlertRecipient,
      invalidTokenVerifyEmailAlertRecipient = _state$verifyEmailAle.invalidTokenVerifyEmailAlertRecipient,
      message = _state$verifyEmailAle.message;

  return {
    invalidTokenVerifyEmailAlertRecipient: invalidTokenVerifyEmailAlertRecipient,
    message: message
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(VerifyEmailAlertRecipient);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Version = function (_React$Component) {
  (0, _inherits3.default)(Version, _React$Component);

  function Version() {
    (0, _classCallCheck3.default)(this, Version);
    return (0, _possibleConstructorReturn3.default)(this, (Version.__proto__ || (0, _getPrototypeOf2.default)(Version)).apply(this, arguments));
  }

  (0, _createClass3.default)(Version, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        null,
        "81d5d42d\n"
      );
    }
  }]);
  return Version;
}(React.Component);

exports.default = Version;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(386);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  feedbacks: {
    results: [],
    total_count: 0,
    total_pages: 0
  },
  feedbackMessages: {
    business_logo_url: '',
    business_name: '',
    customer_email: '',
    customer_name: '',
    messages: []
  },
  feedbackData: {
    comment: '',
    feedback_id: 0
  },
  transactionDetail: null,
  currentPage: null,
  totalPage: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.CUSTOMERS_FEEDBACK_SET_LIST_FEEDBACK:
      return (0, _extends3.default)({}, state, { feedbacks: payload.feedbacks });
    case _constants.CUSTOMERS_FEEDBACK_SET_FEEDBACK_MESSAGES:
      return (0, _extends3.default)({}, state, { feedbackMessages: payload.feedbackMessages });
    case _constants.CUSTOMERS_FEEDBACK_CHANGE_FORM_REPLY:
      return (0, _extends3.default)({}, state, { feedbackData: payload.feedbackData });
    case _constants.CUSTOMERS_FEEDBACK_SET_RECEIPT:
      return (0, _extends3.default)({}, state, { transactionDetail: payload.transactionDetail });
    case _constants.CUSTOMERS_FEEDBACK_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.CUSTOMERS_FEEDBACK_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  customers: [],
  currentPage: null,
  totalPage: null,
  customerDetail: null,
  summary: {
    total_customer: 0,
    total_loyalty_member: 0,
    total_rewards_redeemed: 0
  },
  redemptionHistories: null,
  pointActivities: null,
  receiptData: null,
  keyword: null,
  showImportingModeModal: false,
  type: null,
  hasLoyalty: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var payload = action.payload;

  switch (action.type) {
    case _constants.CUSTOMER_LIST_SET_CUSTOMERS:
      return (0, _extends3.default)({}, state, { customers: payload.customers });
    case _constants.CUSTOMER_LIST_SET_CUSTOMER_DETAIL:
      return (0, _extends3.default)({}, state, { customerDetail: payload.customer });
    case _constants.CUSTOMER_LIST_SET_RECEIPT:
      return (0, _extends3.default)({}, state, { receiptData: payload.receiptData });
    case _constants.CUSTOMER_LIST_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.CUSTOMER_LIST_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.CUSTOMER_LIST_SET_KEYWORD:
      return (0, _extends3.default)({}, state, { keyword: payload.keyword });
    case _constants.CUSTOMER_LIST_SET_SUMMARY:
      return (0, _extends3.default)({}, state, { summary: payload.summary });
    case _constants.CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL:
      return (0, _extends3.default)({}, state, { showImportingModeModal: true });
    case _constants.CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL:
      return (0, _extends3.default)({}, state, { showImportingModeModal: false });
    case _constants.CUSTOMER_LIST_SET_TYPE:
      return (0, _extends3.default)({}, state, { type: payload.type });
    case _constants.CUSTOMER_LIST_SET_REDEMPTION_HISTORIES:
      return (0, _extends3.default)({}, state, { redemptionHistories: payload.redemptionHistories });
    case _constants.CUSTOMER_LIST_SET_POINT_ACTIVITIES:
      return (0, _extends3.default)({}, state, { pointActivities: payload.pointActivities });
    case _constants.CUSTOMER_LIST_SET_HAS_LOYALTY:
      return (0, _extends3.default)({}, state, { hasLoyalty: payload.hasLoyalty });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _fluxStandardAction = __webpack_require__(28);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  hasLoyalty: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  switch (action.type) {
    case _constants.SET_LOYALTY:
      return (0, _extends3.default)({}, state, action.payload);
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(391);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  employees: [],
  outlets: [],
  checkedOutlets: [],
  showDeleteEmployeeModal: false,
  showAssignOutletModal: false,
  deletedEmployee: null,
  profile: null

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var payload = action.payload;


  switch (action.type) {
    case _constants.EMPLOYEE_LIST_SET_EMPLOYEES:
      return (0, _extends3.default)({}, state, { employees: payload.employees });
    case _constants.EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteEmployeeModal: true });
    case _constants.EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteEmployeeModal: false });
    case _constants.EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showAssignOutletModal: true });
    case _constants.EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showAssignOutletModal: false });
    case _constants.EMPLOYEE_LIST_SET_DELETED_EMPLOYEE:
      return (0, _extends3.default)({}, state, { deletedEmployee: payload.deletedEmployee });
    case _constants.EMPLOYEE_LIST_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.EMPLOYEE_LIST_SET_CHECKED_OUTLETS:
      var outlets = payload.outlets;

      return (0, _extends3.default)({}, state, { checkedOutlets: outlets.map(function (o) {
          return (0, _extends3.default)({}, o);
        }) });
    case _constants.EMPLOYEE_LIST_SET_PROFILE:
      return (0, _extends3.default)({}, state, { profile: payload.profile });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(392);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  setting: null

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var payload = action.payload;


  switch (action.type) {
    case _constants.EMPLOYEE_PERMISSION_SET_SETTING:
      return (0, _extends3.default)({}, state, { setting: payload.setting });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(395);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  openRightColumn: false,
  outlets: [],
  categories: [],
  categoryDetail: null,
  totalPage: null,
  currentPage: null,
  showAssignToIngredientModal: false,
  assignToIngredients: {
    category: null,
    ingredients: [],
    currentPage: 0,
    totalPage: 0
  },
  showRightColumn: false,
  showDeleteModal: false,
  isSubmitting: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.INGREDIENT_CATEGORY_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INGREDIENT_CATEGORY_SET_CATEGORIES:
      return (0, _extends3.default)({}, state, { categories: payload.categories });
    case _constants.INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL:
      return (0, _extends3.default)({}, state, { categoryDetail: payload.category });
    case _constants.INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { showRightColumn: true });
    case _constants.INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { showRightColumn: false });
    case _constants.INGREDIENT_CATEGORY_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.page });
    case _constants.INGREDIENT_CATEGORY_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.page });
    case _constants.INGREDIENT_CATEGORY_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.INGREDIENT_CATEGORY_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL:
      return (0, _extends3.default)({}, state, { showAssignToIngredientModal: true });
    case _constants.INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL:
      return (0, _extends3.default)({}, state, { showAssignToIngredientModal: false });
    case _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS:
      return (0, _extends3.default)({}, state, { assignToIngredients: (0, _extends3.default)({}, state.assignToIngredients, { ingredients: payload.ingredients }) });
    case _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { assignToIngredients: (0, _extends3.default)({}, state.assignToIngredients, { currentPage: payload.currentPage }) });
    case _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { assignToIngredients: (0, _extends3.default)({}, state.assignToIngredients, { totalPage: payload.totalPage }) });
    case _constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY:
      return (0, _extends3.default)({}, state, { assignToIngredients: (0, _extends3.default)({}, state.assignToIngredients, { category: payload.category }) });
    case _constants.INGREDIENT_CATEGORY_SET_IS_SUBMITTING:
      return (0, _extends3.default)({}, state, { isSubmitting: payload.isSubmitting });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constant = __webpack_require__(396);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  featurePrice: {},
  featurePricePerMonths: 0,
  isOnTutorial: null,
  pendingPaymentMessage: null,
  pendingOutletMessage: null,
  isButtonDisabled: false,
  buttonMessage: 'Pay',
  subscriptionDetail: {},
  pageOnLoading: true,
  currentOutletCount: 0,
  showDetailModal: false,
  outletList: [],
  showPaymentGatewayErrorModal: false
}; /**
    * Created by alvinoktavianus on 6/27/17.
    */

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constant.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS:
      return (0, _extends3.default)({}, state, { featurePricePerMonths: payload.featurePricePerMonths });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE:
      return (0, _extends3.default)({}, state, { featurePrice: payload.featurePrice });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE:
      return (0, _extends3.default)({}, state, { pendingPaymentMessage: payload.pendingPaymentMessage });
    case _constant.INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON:
      return (0, _extends3.default)({}, state, { isButtonDisabled: false });
    case _constant.INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON:
      return (0, _extends3.default)({}, state, { isButtonDisabled: true });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL:
      return (0, _extends3.default)({}, state, { subscriptionDetail: payload.subscriptionDetail });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL:
      return (0, _extends3.default)({}, state, { isOnTutorial: payload.isOnTutorial });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE:
      return (0, _extends3.default)({}, state, { pendingOutletMessage: payload.pendingOutletMessage });
    case _constant.INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE:
      return (0, _extends3.default)({}, state, { pageOnLoading: false });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT:
      return (0, _extends3.default)({}, state, { currentOutletCount: payload.currentOutletCount });
    case _constant.INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL:
      return (0, _extends3.default)({}, state, { showDetailModal: true });
    case _constant.INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL:
      return (0, _extends3.default)({}, state, { showDetailModal: false });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outletList: payload.outlets });
    case _constant.INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE:
      return (0, _extends3.default)({}, state, { buttonMessage: payload.buttonMessage });
    case _constant.INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: true });
    case _constant.INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: false });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(397);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  libraries: [],
  libraryDetail: null,
  currentPage: null,
  totalPage: null,
  inventories: [{ id: '0', name: 'All Inventory' }, { id: '1', name: 'Low Stock Alert' }, { id: '2', name: 'Out of Stock Alert' }],
  units: [],
  currentInventoryId: 0,
  currentCategoryId: 0,
  search: '',
  outlets: [],
  categories: [],
  summary: { total_pages: 0, total_libraries: 0 },
  filterState: { categoryId: 0, typeInventoryId: 0, keyword: '' },
  importType: 'modify',
  showSectionUploader: false,
  openRightColumn: false,
  showDeleteModal: false,
  files: null,
  tempFiles: {},
  gravatar: null,
  removeImage: false,
  showUploadValidationModal: false,
  textModal: '',
  deletedLibrary: null,
  showDeleteLibraryModal: false,
  showLibraryVariantModal: false,
  showLibraryInventoryAlertModal: false,
  previousLibraryForm: {
    name: null,
    category: null,
    libraryVariant: [],
    libraryInventory: [],
    libraryModifier: [],
    description: null
  },
  modifiers: [],
  modifierIds: [],
  newCategory: null,
  showNewCategoryModal: false,
  previousCategoryId: null,
  previousCategories: [],
  uncategorized: {},
  showImportModal: false,
  showCOGSModal: false,
  showSaveToAllOutletsModal: false,
  createdOutlets: null,
  showInputCOGS: false,
  showInputInventory: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.INGREDIENT_LIBRARY_SET_ITEM_LIST:
      return (0, _extends3.default)({}, state, { libraries: payload.libraries });
    case _constants.INGREDIENT_LIBRARY_SET_CATEGORY_LIST:
      return (0, _extends3.default)({}, state, { categories: payload.categories });
    case _constants.INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID:
      return (0, _extends3.default)({}, state, { currentCategoryId: payload.categoryId });
    case _constants.INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID:
      return (0, _extends3.default)({}, state, { currentItemId: payload.currentItemId });
    case _constants.INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID:
      return (0, _extends3.default)({}, state, { currentInventoryId: payload.inventoryId });
    case _constants.INGREDIENT_LIBRARY_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INGREDIENT_LIBRARY_SET_ITEM_SUMMARY:
      return (0, _extends3.default)({}, state, { summary: payload.librarySummary });
    case _constants.INGREDIENT_LIBRARY_SET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { categoryId: payload.categoryId, typeInventoryId: payload.typeInventoryId, keyword: payload.keyword } });
    case _constants.INGREDIENT_LIBRARY_UNSET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { categoryId: 0, typeInventoryId: 0, keyword: '' } });
    case _constants.INGREDIENT_LIBRARY_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.INGREDIENT_LIBRARY_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.INGREDIENT_LIBRARY_SET_TYPE_IMPORT:
      return (0, _extends3.default)({}, state, { importType: payload.importType });
    case _constants.INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER:
      return (0, _extends3.default)({}, state, { showSectionUploader: payload.showSectionUploader });
    case _constants.INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INGREDIENT_LIBRARY_SET_ITEM_DETAIL:
      return (0, _extends3.default)({}, state, { libraryDetail: payload.library });
    case _constants.INGREDIENT_LIBRARY_ON_DROP_IMAGE:
      return (0, _extends3.default)({}, state, { files: payload.fileStateacceptedFiles, removeImage: payload.fileStateremoveImage });
    case _constants.INGREDIENT_LIBRARY_ON_DELETE_IMAGE:
      return (0, _extends3.default)({}, state, { files: payload.fileStateacceptedFiles, gravatar: payload.fileStategravatar, removeImage: payload.fileStateremoveImage });
    case _constants.INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL:
      return (0, _extends3.default)({}, state, { showLibraryVariantModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL:
      return (0, _extends3.default)({}, state, { showLibraryVariantModal: false });
    case _constants.INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL:
      return (0, _extends3.default)({}, state, { showLibraryInventoryAlertModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL:
      return (0, _extends3.default)({}, state, { showLibraryInventoryAlertModal: false });
    case _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM:
      return (0, _extends3.default)({}, state, { previousLibraryForm: (0, _extends3.default)({}, payload.previousLibraryForm) });
    case _constants.INGREDIENT_LIBRARY_SET_MODIFIERS:
      return (0, _extends3.default)({}, state, { modifiers: payload.modifiers });
    case _constants.INGREDIENT_LIBRARY_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL:
      return (0, _extends3.default)({}, state, { showNewCategoryModal: true });
    case _constants.INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL:
      return (0, _extends3.default)({}, state, { showNewCategoryModal: false });
    case _constants.INGREDIENT_LIBRARY_SET_NEW_CATEGORY:
      return (0, _extends3.default)({}, state, { newCategory: payload.category });
    case _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES:
      return (0, _extends3.default)({}, state, { previousCategories: payload.categories });
    case _constants.INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID:
      return (0, _extends3.default)({}, state, { previousCategoryId: payload.categoryId });
    case _constants.INGREDIENT_LIBRARY_SET_UNITS:
      return (0, _extends3.default)({}, state, { units: payload.units });
    case _constants.INGREDIENT_LIBRARY_STORE_UNCATEGORIZED:
      return (0, _extends3.default)({}, state, { uncategorized: payload.uncategorized });
    case _constants.INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: false });
    case _constants.INGREDIENT_LIBRARY_SHOW_COGS_MODAL:
      return (0, _extends3.default)({}, state, { showCOGSModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_COGS_MODAL:
      return (0, _extends3.default)({}, state, { showCOGSModal: false });
    case _constants.INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: true });
    case _constants.INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: false });
    case _constants.INGREDIENT_LIBRARY_SET_CREATED_OUTLETS:
      return (0, _extends3.default)({}, state, { createdOutlets: payload.createdOutlets });
    case _constants.INGREDIENT_LIBRARY_SHOW_INPUT_COGS:
      return (0, _extends3.default)({}, state, { showInputCOGS: payload.showInputCOGS });
    case _constants.INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY:
      return (0, _extends3.default)({}, state, { showInputInventory: payload.showInputInventory });
    case _constants.INGREDIENT_LIBRARY_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(398);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  recipes: [],
  ingredientRecipes: [],
  openRightColumn: false,
  recipesDetail: null,
  ingredientAdjustmentDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  addIngredients: {
    ingredients: [],
    ingredient: [],
    isLoading: false,
    selectedId: null,
    alreadyAddedAlert: false,
    ingredientQuantity: null,
    keyword: null
  },
  showConfirmSubmitModal: false,
  filterState: { keyword: '' },
  itemsDropdowns: [],
  itemVariant: [],
  showDeleteModal: false,
  recipesForm: {
    recipe_ingredients: [],
    item_id: null,
    item_name: null,
    item_variant_id: null,
    item_variant_name: null,
    sku: null
  },
  showSaveToAllOutletsModal: false,
  createdOutlets: null,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INGREDIENT_RECIPES_SET_RECIPES:
      return (0, _extends3.default)({}, state, { recipes: payload.recipes });
    case _constants.INGREDIENT_RECIPES_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INGREDIENT_RECIPES_SET_RECIPES_DETAIL:
      return (0, _extends3.default)({}, state, { recipesDetail: payload.recipes });
    case _constants.INGREDIENT_RECIPES_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.page });
    case _constants.INGREDIENT_RECIPES_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.page });
    case _constants.INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: true });
    case _constants.INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: false });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { ingredients: payload.ingredients }) });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { ingredients: payload.ingredients }) });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { isLoading: true }) });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { isLoading: false }) });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { alreadyAddedAlert: true }) });
    case _constants.INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { alreadyAddedAlert: false }) });
    case _constants.INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmSubmitModal: true });
    case _constants.INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmSubmitModal: false });
    case _constants.INGREDIENT_RECIPES_SHOW_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: true });
    case _constants.INGREDIENT_RECIPES_HIDE_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: false });
    case _constants.INGREDIENT_RECIPES_UNSET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { keyword: '' } });
    case _constants.INGREDIENT_RECIPES_SET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { keyword: payload.keyword } });
    case _constants.INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN:
      return (0, _extends3.default)({}, state, { itemsDropdowns: payload.itemsDropdowns });
    case _constants.INGREDIENT_RECIPES_SET_ITEM_VARIANT:
      return (0, _extends3.default)({}, state, { itemVariant: payload.itemVariant });
    case _constants.INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD:
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { keyword: payload.keyword }) });
    case _constants.INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT:
      var ingredient = payload.ingredient;
      return (0, _extends3.default)({}, state, { addIngredients: (0, _extends3.default)({}, state.addIngredients, { ingredient: ingredient, selectedId: ingredient ? ingredient.id : null, ingredientQuantity: payload.ingredientQuantity }) });
    case _constants.INGREDIENT_RECIPES_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.INGREDIENT_RECIPES_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.INGREDIENT_RECIPES_SET_RECIPES_FORM:
      return (0, _extends3.default)({}, state, { recipesForm: payload.recipesForm });
    case _constants.INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: true });
    case _constants.INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: false });
    case _constants.INGREDIENT_RECIPES_SET_CREATED_OUTLETS:
      return (0, _extends3.default)({}, state, { createdOutlets: payload.createdOutlets });
    case _constants.INGREDIENT_RECIPES_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(399);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  adjustments: [],
  ingredientAdjustments: [],
  openRightColumn: false,
  adjustmentDetail: null,
  ingredientAdjustmentDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  addItems: {
    items: [],
    ingredients: [],
    isLoading: false,
    selectedId: null,
    alreadyAddedAlert: false,
    currentPage: null,
    totalPage: null,
    keyword: null,
    itemHasRecipe: false
  },
  showConfirmSubmitModal: false,
  showImportModal: false,
  summaryAdjustment: {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalItems: 0
  },
  summaryIngredientAdjustment: {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalIngredients: 0
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS:
      return (0, _extends3.default)({}, state, { adjustments: payload.adjustments });
    case _constants.INVENTORY_ADJUSTMENT_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL:
      return (0, _extends3.default)({}, state, { adjustmentDetail: payload.adjustment });
    case _constants.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL:
      return (0, _extends3.default)({}, state, { ingredientAdjustmentDetail: payload.ingredientAdjustment });
    case _constants.INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.page });
    case _constants.INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.page });
    case _constants.INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: true });
    case _constants.INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: false });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { items: payload.items }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { ingredients: payload.ingredients }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { isLoading: true }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { isLoading: false }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { selectedId: payload.id }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { alreadyAddedAlert: true }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { alreadyAddedAlert: false }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { totalPage: payload.page }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { currentPage: payload.page }) });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { keyword: payload.keyword }) });
    case _constants.INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmSubmitModal: true });
    case _constants.INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmSubmitModal: false });
    case _constants.INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS:
      return (0, _extends3.default)({}, state, { ingredientAdjustments: payload.ingredientAdjustments });
    case _constants.INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: true });
    case _constants.INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: false });
    case _constants.INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT:
      return (0, _extends3.default)({}, state, { summaryAdjustment: payload.summaryAdjustment });
    case _constants.INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT:
      return (0, _extends3.default)({}, state, { summaryIngredientAdjustment: payload.summaryIngredientAdjustment });
    case _constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { itemHasRecipe: payload.itemHasRecipe }) });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constant = __webpack_require__(400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  subscriptionStatus: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constant.INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS:
      return (0, _extends3.default)({}, state, { subscriptionStatus: payload.status });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  selected_outlet: null,
  purchaseOrders: [],
  currentPage: null,
  totalPage: null,
  openRightColumn: false,
  purchaseOrderDetail: null,
  suppliers: [],
  rightColumnState: '', // for create po purpose
  showModalItem: false,
  addItems: {
    isLoading: false,
    items: [],
    firstItems: []
  },
  temporaryItem: null,
  confirmSubmitModal: {
    show: false,
    action: null
  },
  alreadyAddedItem: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INVENTORY_PURCHASE_ORDER_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER:
      return (0, _extends3.default)({}, state, { purchaseOrders: payload.purchaseOrders });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.page });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.page });
    case _constants.INVENTORY_PURCHASE_ORDER_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true, rightColumnState: payload.rightColumnState });
    case _constants.INVENTORY_PURCHASE_ORDER_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_PURCHASE_ORDER_DETAIL:
      return (0, _extends3.default)({}, state, { purchaseOrderDetail: payload.purchaseOrder });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_SUPPLIERS:
      return (0, _extends3.default)({}, state, { suppliers: payload.suppliers });
    case _constants.INVENTORY_PURCHASE_ORDER_SHOW_MODAL_ITEM:
      return (0, _extends3.default)({}, state, { showModalItem: true });
    case _constants.INVENTORY_PURCHASE_ORDER_CLOSE_MODAL_ITEM:
      return (0, _extends3.default)({}, state, { showModalItem: false });
    case _constants.INVENTORY_PURCHASE_ORDER_IS_LOADING:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { isLoading: payload.isLoading }) });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_DATA_SEARCH:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { items: payload.items }) });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_FIRST_ITEMS:
      return (0, _extends3.default)({}, state, { addItems: (0, _extends3.default)({}, state.addItems, { firstItems: payload.firstItems }) });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_SELECTED_OUTLET:
      return (0, _extends3.default)({}, state, { selected_outlet: payload.outletId });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_ADDED_ITEM:
      return (0, _extends3.default)({}, state, { temporaryItem: payload.item });
    case _constants.INVENTORY_PURCHASE_ORDER_HIDE_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { confirmSubmitModal: { show: false, action: null } });
    case _constants.INVENTORY_PURCHASE_ORDER_SHOW_CONFIRM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { confirmSubmitModal: { show: true, action: payload.action } });
    case _constants.INVENTORY_PURCHASE_ORDER_SET_IS_ITEM_ADDED:
      return (0, _extends3.default)({}, state, { alreadyAddedItem: payload.isAdded });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(402);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  items: [],
  rowItems: [],
  totalPage: null,
  currentPage: null,
  outlets: [],
  ingredients: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INVENTORY_SUMMARY_SET_ROW_ITEMS:
      return (0, _extends3.default)({}, state, { rowItems: payload.items });
    case _constants.INVENTORY_SUMMARY_SET_ITEMS:
      return (0, _extends3.default)({}, state, { items: payload.items });
    case _constants.INVENTORY_SUMMARY_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.page });
    case _constants.INVENTORY_SUMMARY_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.page });
    case _constants.INVENTORY_SUMMARY_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INVENTORY_SUMMARY_SET_INGREDIENTS:
      return (0, _extends3.default)({}, state, { ingredients: payload.ingredients });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  // all outlet options available
  outlets: [],
  suppliers: [],
  profile: {},
  openRightColumn: false,
  supplierDetail: null,
  openDeleteSupplierModal: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INVENTORY_SUPPLIER_SET_SUPPLIERS:
      return (0, _extends3.default)({}, state, { suppliers: payload.suppliers });
    case _constants.INVENTORY_SUPPLIER_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INVENTORY_SUPPLIER_SET_PROFILE:
      return (0, _extends3.default)({}, state, { profile: payload.profile });
    case _constants.INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL:
      return (0, _extends3.default)({}, state, { supplierDetail: payload.supplier });
    case _constants.INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL:
      return (0, _extends3.default)({}, state, { openDeleteSupplierModal: true });
    case _constants.INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL:
      return (0, _extends3.default)({}, state, { openDeleteSupplierModal: false });
    case _constants.INVENTORY_SUPPLIER_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  selectedOutlets: [],
  transfers: [],
  openRightColumn: false,
  transferDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  showConfirmSubmitModal: false,
  itemOptionIsLoading: false,
  isItemAlreadyAdded: false,
  addItems: {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0
  },
  exportButtonStatus: true,
  confirmCreateButtonStatus: false,
  searchItemsInit: {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.INVENTORY_TRANSFER_RESET_STATE:
      return (0, _extends3.default)({}, state, {
        outlets: [],
        selectedOutlets: [],
        transfers: [],
        openRightColumn: false,
        transferDetail: null,
        currentPage: null,
        totalPage: null,
        showAddItemsModal: false,
        showConfirmSubmitModal: false,
        itemOptionIsLoading: false,
        isItemAlreadyAdded: false,
        addItems: {
          items: [],
          itemOptions: [],
          currentPage: 0,
          totalPage: 0
        },
        exportButtonStatus: true,
        searchItemsInit: {
          items: [],
          itemOptions: [],
          currentPage: 0,
          totalPage: 0
        }
      });
    case _constants.INVENTORY_TRANSFER_SET_TRANSFERS:
      return (0, _extends3.default)({}, state, { transfers: payload.transfers });
    case _constants.INVENTORY_TRANSFER_SET_TRANSFER_DETAIL:
      return (0, _extends3.default)({}, state, { transferDetail: payload.transfer });
    case _constants.INVENTORY_TRANSFER_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.INVENTORY_TRANSFER_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.INVENTORY_TRANSFER_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.INVENTORY_TRANSFER_SET_SELECTED_OUTLETS:
      return (0, _extends3.default)({}, state, { selectedOutlets: payload.selectedOutlets });
    case _constants.INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM:
      return (0, _extends3.default)({}, state, { showAddItemsModal: true });
    case _constants.INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: false });
    case _constants.INVENTORY_TRANSFER_SET_ADD_ITEMS:
      return (0, _extends3.default)({}, state, { addItems: payload.addItems });
    case _constants.INVENTORY_TRANSFER_RESET_ADD_ITEMS:
      return (0, _extends3.default)({}, state, { addItems: { items: [], itemOptions: [], currentPage: 0, totalPage: 0 } });
    case _constants.INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING:
      return (0, _extends3.default)({}, state, { itemOptionIsLoading: payload.itemOptionIsLoading });
    case _constants.INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showAddItemsModal: false });
    case _constants.INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmSubmitModal: payload.isShowConfirmSubmitModal });
    case _constants.INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED:
      return (0, _extends3.default)({}, state, { isItemAlreadyAdded: payload.isItemAlreadyAdded });
    case _constants.INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS:
      return (0, _extends3.default)({}, state, { exportButtonStatus: payload.exportButtonStatus });
    case _constants.INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS:
      return (0, _extends3.default)({}, state, { confirmCreateButtonStatus: payload.isClicked });
    case _constants.INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT:
      return (0, _extends3.default)({}, state, { searchItemsInit: payload.itemInit });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  categories: [],
  currentPage: null,
  totalPage: null,
  keyword: null,
  categoryDetail: null,
  deletedCategory: null,
  showDeleteModal: false,
  showAssignToItemModal: false,
  assignToItems: {
    items: [],
    currentPage: 0,
    totalPage: 0
  },
  openRightColumn: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.LIBRARY_CATEGORIES_SET_LIST_CATEGORIES:
      return (0, _extends3.default)({}, state, { categories: payload.categories });
    case _constants.LIBRARY_CATEGORIES_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_CATEGORIES_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_CATEGORIES_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_CATEGORIES_SET_KEYWORD:
      return (0, _extends3.default)({}, state, { keyword: payload.keyword });
    case _constants.LIBRARY_CATEGORIES_SET_CATEGORY_DETAIL:
      return (0, _extends3.default)({}, state, { categoryDetail: payload.category });
    case _constants.LIBRARY_CATEGORIES_SET_DELETED_CATEGORY:
      return (0, _extends3.default)({}, state, { deletedCategory: payload.deletedCategory });
    case _constants.LIBRARY_CATEGORIES_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.LIBRARY_CATEGORIES_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.LIBRARY_CATEGORIES_SHOW_ASSIGN_TO_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showAssignToItemModal: true });
    case _constants.LIBRARY_CATEGORIES_HIDE_ASSIGN_TO_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showAssignToItemModal: false });
    case _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_ITEMS:
      return (0, _extends3.default)({}, state, { assignToItems: (0, _extends3.default)({}, state.assignToItems, { items: payload.items }) });
    case _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { assignToItems: (0, _extends3.default)({}, state.assignToItems, { currentPage: payload.currentPage }) });
    case _constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { assignToItems: (0, _extends3.default)({}, state.assignToItems, { totalPage: payload.totalPage }) });
    case _constants.LIBRARY_CATEGORIES_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.LIBRARY_CATEGORIES_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.LIBRARY_CATEGORIES_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  discounts: [],
  discountDetail: null,
  currentPage: null,
  totalPage: null,
  showDetail: false,
  newDiscount: undefined,
  deletedDiscount: null,
  showDeleteDiscountModal: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.LIBRARY_DISCOUNT_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_DISCOUNT_SET_DISCOUNTS:
      return (0, _extends3.default)({}, state, { discounts: payload.discounts });
    case _constants.LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT:
      return (0, _extends3.default)({}, state, { discountDetail: null, showDetail: true, newDiscount: true });
    case _constants.LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL:
      return (0, _extends3.default)({}, state, { discountDetail: payload.discount, showDetail: true, newDiscount: false });
    case _constants.LIBRARY_DISCOUNT_UNSET_DISCOUNT:
      return (0, _extends3.default)({}, state, { discountDetail: null, showDetail: false, newDiscount: undefined });
    case _constants.LIBRARY_DISCOUNT_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_DISCOUNT_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteDiscountModal: true });
    case _constants.LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteDiscountModal: false });
    case _constants.LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT:
      return (0, _extends3.default)({}, state, { deletedDiscount: payload.deletedDiscount });
    case _constants.LIBRARY_DISCOUNT_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  gratuities: [],
  gratuityDetail: null,
  deletedGratuity: null,
  showDeleteGratuityModal: false,
  currentPage: null,
  totalPage: null,
  openRightColumn: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.LIBRARY_GRATUITY_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_GRATUITY_SET_GRATUITIES:
      return (0, _extends3.default)({}, state, { gratuities: payload.gratuities });
    case _constants.LIBRARY_GRATUITY_SET_GRATUITY_DETAIL:
      return (0, _extends3.default)({}, state, { gratuityDetail: payload.gratuity });
    case _constants.LIBRARY_GRATUITY_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_GRATUITY_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteGratuityModal: true });
    case _constants.LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteGratuityModal: false });
    case _constants.LIBRARY_GRATUITY_SET_DELETED_GRATUITY:
      return (0, _extends3.default)({}, state, { deletedGratuity: payload.deletedGratuity });
    case _constants.LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.LIBRARY_GRATUITY_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(408);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  items: [],
  itemDetail: null,
  currentPage: null,
  totalPage: null,
  inventories: [{ id: '0', name: 'All Inventory' }, { id: '1', name: 'Low Stock Alert' }, { id: '2', name: 'Out of Stock Alert' }],
  currentInventoryId: 0,
  currentCategoryId: 0,
  search: '',
  outlets: [],
  categories: [],
  summary: { total_pages: 0, total_items: 0 },
  filterState: { categoryId: 0, typeInventoryId: 0, keyword: '' },
  importType: 'modify',
  showSectionUploader: false,
  openRightColumn: false,
  showDeleteModal: false,
  files: null,
  tempFiles: {},
  gravatar: null,
  removeImage: false,
  showUploadValidationModal: false,
  textModal: '',
  deletedItem: null,
  showDeleteItemModal: false,
  showItemVariantModal: false,
  showItemInventoryAlertModal: false,
  showSaveToAllOutletsModal: false,
  showCOGSModal: false,
  mustScrollTop: false,
  previousItemForm: {
    name: null,
    category: null,
    itemVariant: [],
    itemInventory: [],
    itemModifier: [],
    description: null
  },
  modifiers: [],
  modifierIds: [],
  newCategory: null,
  showNewCategoryModal: false,
  previousCategoryId: null,
  previousCategories: [],
  showImportModal: false,
  isTrack: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));
  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;

  switch (action.type) {
    case _constants.LIBRARY_ITEM_SET_MUST_SCROLL_TOP:
      return (0, _extends3.default)({}, state, { mustScrollTop: payload.mustScrollTop });
    case _constants.LIBRARY_ITEM_SET_ITEM_LIST:
      return (0, _extends3.default)({}, state, { items: payload.items });
    case _constants.LIBRARY_ITEM_SET_CATEGORY_LIST:
      return (0, _extends3.default)({}, state, { categories: payload.categories });
    case _constants.LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID:
      return (0, _extends3.default)({}, state, { currentCategoryId: payload.categoryId });
    case _constants.LIBRARY_ITEM_SET_CURRENT_ITEM_ID:
      return (0, _extends3.default)({}, state, { currentItemId: payload.currentItemId });
    case _constants.LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID:
      return (0, _extends3.default)({}, state, { currentInventoryId: payload.inventoryId });
    case _constants.LIBRARY_ITEM_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_ITEM_SET_ITEM_SUMMARY:
      return (0, _extends3.default)({}, state, { summary: payload.itemSummary });
    case _constants.LIBRARY_ITEM_SET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { categoryId: payload.categoryId, typeInventoryId: payload.typeInventoryId, keyword: payload.keyword } });
    case _constants.LIBRARY_ITEM_UNSET_FILTER_STATE:
      return (0, _extends3.default)({}, state, { filterState: { categoryId: 0, typeInventoryId: 0, keyword: '' } });
    case _constants.LIBRARY_ITEM_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_ITEM_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_ITEM_SET_TYPE_IMPORT:
      return (0, _extends3.default)({}, state, { importType: payload.importType });
    case _constants.LIBRARY_ITEM_SHOW_SECTION_UPLOADER:
      return (0, _extends3.default)({}, state, { showSectionUploader: payload.showSectionUploader });
    case _constants.LIBRARY_ITEM_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.LIBRARY_ITEM_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.LIBRARY_ITEM_SET_ITEM_DETAIL:
      return (0, _extends3.default)({}, state, { itemDetail: payload.item });
    case _constants.LIBRARY_ITEM_ON_DROP_IMAGE:
      return (0, _extends3.default)({}, state, { files: payload.fileStateacceptedFiles, removeImage: payload.fileStateremoveImage });
    case _constants.LIBRARY_ITEM_ON_DELETE_IMAGE:
      return (0, _extends3.default)({}, state, { files: payload.fileStateacceptedFiles, gravatar: payload.fileStategravatar, removeImage: payload.fileStateremoveImage });
    case _constants.LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL:
      return (0, _extends3.default)({}, state, { showItemVariantModal: true });
    case _constants.LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL:
      return (0, _extends3.default)({}, state, { showItemVariantModal: false });
    case _constants.LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: true });
    case _constants.LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: false });
    case _constants.LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL:
      return (0, _extends3.default)({}, state, { showItemInventoryAlertModal: true });
    case _constants.LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL:
      return (0, _extends3.default)({}, state, { showItemInventoryAlertModal: false });
    case _constants.LIBRARY_ITEM_SHOW_COGS_MODAL:
      return (0, _extends3.default)({}, state, { showCOGSModal: true, isTrack: payload.isTrack });
    case _constants.LIBRARY_ITEM_HIDE_COGS_MODAL:
      return (0, _extends3.default)({}, state, { showCOGSModal: false });
    case _constants.LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM:
      return (0, _extends3.default)({}, state, { previousItemForm: (0, _extends3.default)({}, payload.previousItemForm) });
    case _constants.LIBRARY_ITEM_SET_MODIFIERS:
      return (0, _extends3.default)({}, state, { modifiers: payload.modifiers });
    case _constants.LIBRARY_ITEM_SET_TAXES:
      return (0, _extends3.default)({}, state, { taxes: payload.taxes });
    case _constants.LIBRARY_ITEM_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.LIBRARY_ITEM_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL:
      return (0, _extends3.default)({}, state, { showNewCategoryModal: true });
    case _constants.LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL:
      return (0, _extends3.default)({}, state, { showNewCategoryModal: false });
    case _constants.LIBRARY_ITEM_SET_NEW_CATEGORY:
      return (0, _extends3.default)({}, state, { newCategory: payload.category });
    case _constants.LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES:
      return (0, _extends3.default)({}, state, { previousCategories: payload.categories });
    case _constants.LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID:
      return (0, _extends3.default)({}, state, { previousCategoryId: payload.categoryId });
    case _constants.LIBRARY_ITEM_SHOW_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: true });
    case _constants.LIBRARY_ITEM_HIDE_IMPORT_MODAL:
      return (0, _extends3.default)({}, state, { showImportModal: false });
    case _constants.LIBRARY_ITEM_SET_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  modifiers: [],
  modifierDetail: null,
  deletedModifier: null,
  showDeleteModifierModal: false,
  showApplySetItemModal: false,
  showModifierOptionsModal: false,
  currentPage: null,
  totalPage: null,
  applySetItems: {
    items: [],
    currentPage: 0,
    totalPage: 0
  },
  previousModifierForm: {
    name: null,
    options: []
  },
  openRightColumn: false,
  isSubmittingForm: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.LIBRARY_MODIFIER_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_MODIFIER_SET_MODIFIERS:
      return (0, _extends3.default)({}, state, { modifiers: payload.modifiers });
    case _constants.LIBRARY_MODIFIER_SET_MODIFIER_DETAIL:
      return (0, _extends3.default)({}, state, { modifierDetail: payload.modifier });
    case _constants.LIBRARY_MODIFIER_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_MODIFIER_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModifierModal: true });
    case _constants.LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModifierModal: false });
    case _constants.LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showApplySetItemModal: true });
    case _constants.LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showApplySetItemModal: false });
    case _constants.LIBRARY_MODIFIER_SET_DELETED_MODIFIER:
      return (0, _extends3.default)({}, state, { deletedModifier: payload.deletedModifier });
    case _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS:
      return (0, _extends3.default)({}, state, { applySetItems: (0, _extends3.default)({}, state.applySetItems, { items: payload.items }) });
    case _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { applySetItems: (0, _extends3.default)({}, state.applySetItems, { currentPage: payload.currentPage }) });
    case _constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { applySetItems: (0, _extends3.default)({}, state.applySetItems, { totalPage: payload.totalPage }) });
    case _constants.LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL:
      return (0, _extends3.default)({}, state, { showModifierOptionsModal: true });
    case _constants.LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL:
      return (0, _extends3.default)({}, state, { showModifierOptionsModal: false });
    case _constants.LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM:
      return (0, _extends3.default)({}, state, { previousModifierForm: (0, _extends3.default)({}, payload.previousModifierForm) });
    case _constants.LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.LIBRARY_MODIFIER_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  outlets: [],
  taxes: [],
  currentPage: null,
  totalPage: null,
  taxDetail: null,
  deletedTax: null,
  showDeleteModal: false,
  openRightColumn: false,
  isSubmittingForm: false,

  showTaxAssignToItemModal: false,
  showSaveToAllOutletsModal: false,
  checkSelectAllTaxItemsFlag: false,
  categories: [],
  taxAssignToItems: {
    items: [],
    currentPage: 0,
    totalPage: 0
  },
  setting: {},
  createdOutlets: null // for create all outlets result modal
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var type = action.type,
      payload = action.payload;


  switch (type) {
    case _constants.LIBRARY_TAXES_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.LIBRARY_TAXES_SET_LIST_TAXES:
      return (0, _extends3.default)({}, state, { taxes: payload.taxes });
    case _constants.LIBRARY_TAXES_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { currentPage: payload.currentPage });
    case _constants.LIBRARY_TAXES_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { totalPage: payload.totalPage });
    case _constants.LIBRARY_TAXES_SET_TAX_DETAIL:
      return (0, _extends3.default)({}, state, { taxDetail: payload.tax });
    case _constants.LIBRARY_TAXES_SET_DELETED_TAX:
      return (0, _extends3.default)({}, state, { deletedTax: payload.deletedTax });
    case _constants.LIBRARY_TAXES_SHOW_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: true });
    case _constants.LIBRARY_TAXES_HIDE_DELETE_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteModal: false });
    case _constants.LIBRARY_TAXES_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.LIBRARY_TAXES_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.LIBRARY_TAXES_IS_SUBMITTING_FORM:
      return (0, _extends3.default)({}, state, { isSubmittingForm: payload.isSubmittingForm });

    case _constants.LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showTaxAssignToItemModal: true });
    case _constants.LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL:
      return (0, _extends3.default)({}, state, { showTaxAssignToItemModal: false });
    case _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS:
      return (0, _extends3.default)({}, state, { taxAssignToItems: (0, _extends3.default)({}, state.taxAssignToItems, { items: payload.items }) });
    case _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE:
      return (0, _extends3.default)({}, state, { taxAssignToItems: (0, _extends3.default)({}, state.taxAssignToItems, { currentPage: payload.currentPage }) });
    case _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE:
      return (0, _extends3.default)({}, state, { taxAssignToItems: (0, _extends3.default)({}, state.taxAssignToItems, { totalPage: payload.totalPage }) });
    case _constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT:
      return (0, _extends3.default)({}, state, { taxAssignToItems: (0, _extends3.default)({}, state.taxAssignToItems, { totalCount: payload.totalCount }) });
    case _constants.LIBRARY_TAXES_SET_SETTING:
      return (0, _extends3.default)({}, state, { setting: payload.setting });
    case _constants.LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: true });
    case _constants.LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return (0, _extends3.default)({}, state, { showSaveToAllOutletsModal: false });
    case _constants.LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS:
      return (0, _extends3.default)({}, state, { checkSelectAllTaxItemsFlag: true });
    case _constants.LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS:
      return (0, _extends3.default)({}, state, { checkSelectAllTaxItemsFlag: false });
    case _constants.LIBRARY_TAXES_SET_CATEGORY_LIST:
      return (0, _extends3.default)({}, state, { categories: payload.categories });
    case _constants.LIBRARY_TAXES_SET_CREATED_OUTLETS:
      return (0, _extends3.default)({}, state, { createdOutlets: payload.createdOutlets });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _fluxStandardAction = __webpack_require__(28);

var _constants = __webpack_require__(413);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  outlets: [],
  outletDetail: null,
  profile: null,
  outletSlots: null,
  usedOutletSlots: null,
  showConfirmReactivateOutletModal: false,
  reactivatedOutlet: null,
  openRightColumn: false,
  showAddOutletModal: false,
  outletPrice: {},
  featureSubscriptions: [],
  showPaymentGatewayErrorModal: false,
  disablePayButton: false,
  payButtonMessage: 'Pay',
  pendingPaymentMessage: null,
  onLoadingPayButton: false,
  disableSaveOutletButton: false,
  showReactivateOutletWithoutPayModal: false,
  isOnLoadingReactivateOutletWithoutPayModal: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var payload = action.payload;


  switch (action.type) {
    case _constants.OUTLET_PAGE_LIST_SET_OUTLETS:
      return (0, _extends3.default)({}, state, { outlets: payload.outlets });
    case _constants.OUTLET_PAGE_LIST_SET_PROFILE:
      return (0, _extends3.default)({}, state, { profile: payload.profile });
    case _constants.OUTLET_PAGE_LIST_SET_OUTLET_DETAIL:
      return (0, _extends3.default)({}, state, { outletDetail: payload.outletDetail });
    case _constants.OUTLET_PAGE_LIST_SET_OUTLET_SLOTS:
      return (0, _extends3.default)({}, state, { outletSlots: payload.slots });
    case _constants.OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS:
      return (0, _extends3.default)({}, state, { usedOutletSlots: payload.slots });
    case _constants.OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmReactivateOutletModal: true });
    case _constants.OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showConfirmReactivateOutletModal: false });
    case _constants.OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET:
      return (0, _extends3.default)({}, state, { reactivatedOutlet: payload.outlet });
    case _constants.OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: true });
    case _constants.OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN:
      return (0, _extends3.default)({}, state, { openRightColumn: false });
    case _constants.OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showAddOutletModal: true });
    case _constants.OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL:
      return (0, _extends3.default)({}, state, { showAddOutletModal: false });
    case _constants.OUTLET_PAGE_LIST_SET_OUTLET_PRICE:
      return (0, _extends3.default)({}, state, { outletPrice: payload.outletPrice });
    case _constants.OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS:
      return (0, _extends3.default)({}, state, { featureSubscriptions: payload.featureSubscriptions });
    case _constants.OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: true });
    case _constants.OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return (0, _extends3.default)({}, state, { showPaymentGatewayErrorModal: false });
    case _constants.OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE:
      return (0, _extends3.default)({}, state, { payButtonMessage: payload.buttonMessage });
    case _constants.OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON:
      return (0, _extends3.default)({}, state, { disablePayButton: false });
    case _constants.OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON:
      return (0, _extends3.default)({}, state, { disablePayButton: true });
    case _constants.OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE:
      return (0, _extends3.default)({}, state, { pendingPaymentMessage: payload.pendingMessage });
    case _constants.OUTLET_PAGE_LIST_SET_ON_LOADING:
      return (0, _extends3.default)({}, state, { onLoadingPayButton: payload.onLoading });
    case _constants.OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON:
      return (0, _extends3.default)({}, state, { disableSaveOutletButton: payload.disabled });
    case _constants.OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY:
      return (0, _extends3.default)({}, state, { showReactivateOutletWithoutPayModal: true });
    case _constants.OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY:
      return (0, _extends3.default)({}, state, { showReactivateOutletWithoutPayModal: false });
    case _constants.OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL:
      return (0, _extends3.default)({}, state, { isOnLoadingReactivateOutletWithoutPayModal: payload.isOnLoading });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(421);

var _fluxStandardAction = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The initial application state
var initialState = {
  profile: null,
  showRecipientModal: false,
  showSettingAlertRecipientsErrors: false,
  previousEmailNotificationForm: {},
  deletedRecipient: null,
  showDeleteRecipientModal: false

  // Takes care of changing the application state
};function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  (0, _invariant2.default)((0, _fluxStandardAction.isFSA)(action), 'Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ' + (0, _stringify2.default)(action));

  var _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;


  switch (action.type) {
    case _constants.SETTING_EMAIL_SET_PROFILE:
      return (0, _extends3.default)({}, state, { profile: payload.profile });
    case _constants.SETTING_EMAIL_SHOW_RECIPIENT_MODAL:
      return (0, _extends3.default)({}, state, { showRecipientModal: true });
    case _constants.SETTING_EMAIL_HIDE_RECIPIENT_MODAL:
      return (0, _extends3.default)({}, state, { showRecipientModal: false });
    case _constants.SETTING_EMAIL_SET_PREVIOUS_EMAIL_NOTIFICATION_FORM:
      return (0, _extends3.default)({}, state, { previousEmailNotificationForm: payload.previousEmailNotificationForm });
    case _constants.SETTING_EMAIL_SHOW_SETTING_ALERT_RECIPIENTS_ERRORS:
      return (0, _extends3.default)({}, state, { showSettingAlertRecipientsErrors: true });
    case _constants.SETTING_EMAIL_HIDE_SETTING_ALERT_RECIPIENTS_ERRORS:
      return (0, _extends3.default)({}, state, { showSettingAlertRecipientsErrors: false });
    case _constants.SETTING_EMAIL_SHOW_DELETE_RECIPIENT_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteRecipientModal: true });
    case _constants.SETTING_EMAIL_HIDE_DELETE_RECIPIENT_MODAL:
      return (0, _extends3.default)({}, state, { showDeleteRecipientModal: false });
    case _constants.SETTING_EMAIL_SET_DELETED_RECIPIENT:
      return (0, _extends3.default)({}, state, { deletedRecipient: payload.deletedRecipient });
    default:
      return (0, _extends3.default)({}, state);
  }
}

exports.default = reducer;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.settingAccount = settingAccount;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _account = __webpack_require__(1057);

var api = _interopRequireWildcard(_account);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [settingAccount].map(_regenerator2.default.mark);

function settingAccount(data) {
  var response;
  return _regenerator2.default.wrap(function settingAccount$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.settingAccount, data);

        case 7:
          response = _context.sent;
          _context.next = 10;
          return (0, _effects.put)(actNotif.success('Your account was successfully saved.'));

        case 10:
          return _context.abrupt('return', response.data);

        case 13:
          _context.prev = 13;
          _context.t0 = _context['catch'](4);
          _context.next = 17;
          return (0, _effects.put)(actNotif.error('Your current password is incorrect'));

        case 17:
          return _context.abrupt('return', false);

        case 18:
          _context.prev = 18;
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          _context.next = 23;
          return (0, _effects.put)(action.sendingRequest(false));

        case 23:
          return _context.finish(18);

        case 24:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 13, 18, 24]]);
}

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getShiftDetails = getShiftDetails;
exports.getSummary = getSummary;
exports.getShifts = getShifts;
exports.exportShift = exportShift;

var _shifts = __webpack_require__(1062);

var api = _interopRequireWildcard(_shifts);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _effects = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getShiftDetails, getSummary, getShifts, exportShift].map(_regenerator2.default.mark);

function getShiftDetails(shiftId, query) {
  var response;
  return _regenerator2.default.wrap(function getShiftDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getShiftDetails, shiftId, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

function getSummary(queryParams) {
  var response;
  return _regenerator2.default.wrap(function getSummary$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getSummary, queryParams);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          return _context2.abrupt('return', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context2.finish(16);

        case 22:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 16, 22]]);
}

function getShifts(queryParams) {
  var response;
  return _regenerator2.default.wrap(function getShifts$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(api.getShifts, queryParams);

        case 7:
          response = _context3.sent;
          return _context3.abrupt('return', response.data);

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](4);
          _context3.next = 15;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 15:
          return _context3.abrupt('return', false);

        case 16:
          _context3.prev = 16;
          _context3.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context3.finish(16);

        case 22:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 11, 16, 22]]);
}

function exportShift(query) {
  var response;
  return _regenerator2.default.wrap(function exportShift$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(api.exportShift, query);

        case 7:
          response = _context4.sent;
          return _context4.abrupt('return', response.data);

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](4);
          _context4.next = 15;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 15:
          return _context4.abrupt('return', false);

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context4.finish(16);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getCategories = getCategories;
exports.getCategoriesWithUncategorized = getCategoriesWithUncategorized;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _category = __webpack_require__(1064);

var api = _interopRequireWildcard(_category);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getCategories, getCategoriesWithUncategorized].map(_regenerator2.default.mark);

/**
 * Fetch categories from API and return its response
 * Invoke related action if the API fetch result is failed.
 * @returns {*}
 */
function getCategories() {
  var response;
  return _regenerator2.default.wrap(function getCategories$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getCategories);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch categories from API and return its response
 * Invoke related action if the API fetch result is failed.
 * @returns {*}
 */
function getCategoriesWithUncategorized() {
  var response;
  return _regenerator2.default.wrap(function getCategoriesWithUncategorized$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getCategoriesWithUncategorized);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          return _context2.abrupt('return', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context2.finish(16);

        case 22:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getCheckoutSetting = getCheckoutSetting;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _checkoutSetting = __webpack_require__(1065);

var apiCheckoutSetting = _interopRequireWildcard(_checkoutSetting);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getCheckoutSetting].map(_regenerator2.default.mark);

function getCheckoutSetting(query) {
  var response;
  return _regenerator2.default.wrap(function getCheckoutSetting$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(apiCheckoutSetting.getCheckoutSetting, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getOutletById = getOutletById;

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getOutletById].map(_regenerator2.default.mark);

/**
 * @param outletId
 * @param query
 * @return {object|boolean} json from server if successful, false if failed
 */
function getOutletById(outletId, query) {
  var response;
  return _regenerator2.default.wrap(function getOutletById$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(apiOutlet.getOutletById, outletId, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getSalesSummary = getSalesSummary;
exports.getGrossProfit = getGrossProfit;
exports.getPaymentMethods = getPaymentMethods;
exports.getItemSales = getItemSales;
exports.getCategorySales = getCategorySales;
exports.getModifierSales = getModifierSales;
exports.getDiscounts = getDiscounts;
exports.getTaxes = getTaxes;
exports.getGratuities = getGratuities;
exports.getStaffs = getStaffs;
exports.getServers = getServers;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _sales = __webpack_require__(632);

var api = _interopRequireWildcard(_sales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getSalesSummary, getGrossProfit, getPaymentMethods, getItemSales, getCategorySales, getModifierSales, getDiscounts, getTaxes, getGratuities, getStaffs, getServers].map(_regenerator2.default.mark);

/**
 * Fetch sales summary from the server
 * @param {object} params
 * @returns {*} sales from server, or false if the request fails
 */
function getSalesSummary(params) {
  var response;
  return _regenerator2.default.wrap(function getSalesSummary$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.getSalesSummary, params);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch sales summary from the server
 * @param {object} params
 * @returns {*} sales from server, or false if the request fails
 */
function getGrossProfit(params) {
  var response;
  return _regenerator2.default.wrap(function getGrossProfit$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.getGrossProfit, params);

        case 7:
          response = _context2.sent;
          return _context2.abrupt('return', response.data);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 15;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 15:
          return _context2.abrupt('return', false);

        case 16:
          _context2.prev = 16;
          _context2.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context2.finish(16);

        case 22:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch payment methods from the server
 * @param {object} params
 * @returns {*} payment methods from server, or false if the request fails
 */
function getPaymentMethods(params) {
  var response;
  return _regenerator2.default.wrap(function getPaymentMethods$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(api.getPaymentMethods, params);

        case 7:
          response = _context3.sent;
          return _context3.abrupt('return', response.data);

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](4);
          _context3.next = 15;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 15:
          return _context3.abrupt('return', false);

        case 16:
          _context3.prev = 16;
          _context3.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context3.finish(16);

        case 22:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch item sales from the server
 * @param {object} params
 * @returns {*} item sales from server, or false if the request fails
 */
function getItemSales(params) {
  var response;
  return _regenerator2.default.wrap(function getItemSales$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(api.getItemSales, params);

        case 7:
          response = _context4.sent;
          return _context4.abrupt('return', response.data);

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](4);
          _context4.next = 15;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 15:
          return _context4.abrupt('return', false);

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context4.finish(16);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch category sales from the server
 * @param {object} params
 * @returns {*} category sales from server, or false if the request fails
 */
function getCategorySales(params) {
  var response;
  return _regenerator2.default.wrap(function getCategorySales$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context5.prev = 4;
          _context5.next = 7;
          return (0, _effects.call)(api.getCategorySales, params);

        case 7:
          response = _context5.sent;
          return _context5.abrupt('return', response.data);

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5['catch'](4);
          _context5.next = 15;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 15:
          return _context5.abrupt('return', false);

        case 16:
          _context5.prev = 16;
          _context5.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context5.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context5.finish(16);

        case 22:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch modifier sales from the server
 * @param {object} params
 * @returns {*} modifier sales from server, or false if the request fails
 */
function getModifierSales(params) {
  var response;
  return _regenerator2.default.wrap(function getModifierSales$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(api.getModifierSales, params);

        case 7:
          response = _context6.sent;
          return _context6.abrupt('return', response.data);

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6['catch'](4);
          _context6.next = 15;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 15:
          return _context6.abrupt('return', false);

        case 16:
          _context6.prev = 16;
          _context6.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context6.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context6.finish(16);

        case 22:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch discounts from the server
 * @param {object} params
 * @returns {*} discounts from server, or false if the request fails
 */
function getDiscounts(params) {
  var response;
  return _regenerator2.default.wrap(function getDiscounts$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context7.prev = 4;
          _context7.next = 7;
          return (0, _effects.call)(api.getDiscounts, params);

        case 7:
          response = _context7.sent;
          return _context7.abrupt('return', response.data);

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7['catch'](4);
          _context7.next = 15;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 15:
          return _context7.abrupt('return', false);

        case 16:
          _context7.prev = 16;
          _context7.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context7.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context7.finish(16);

        case 22:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch taxes from the server
 * @param {object} params
 * @returns {*} taxes from server, or false if the request fails
 */
function getTaxes(params) {
  var response;
  return _regenerator2.default.wrap(function getTaxes$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context8.prev = 4;
          _context8.next = 7;
          return (0, _effects.call)(api.getTaxes, params);

        case 7:
          response = _context8.sent;
          return _context8.abrupt('return', response.data);

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8['catch'](4);
          _context8.next = 15;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 15:
          return _context8.abrupt('return', false);

        case 16:
          _context8.prev = 16;
          _context8.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context8.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context8.finish(16);

        case 22:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch gratuity from the server
 * @param {object} params
 * @returns {*} gratuities from server, or false if the request fails
 */
function getGratuities(params) {
  var response;
  return _regenerator2.default.wrap(function getGratuities$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context9.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context9.prev = 4;
          _context9.next = 7;
          return (0, _effects.call)(api.getGratuities, params);

        case 7:
          response = _context9.sent;
          return _context9.abrupt('return', response.data);

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9['catch'](4);
          _context9.next = 15;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 15:
          return _context9.abrupt('return', false);

        case 16:
          _context9.prev = 16;
          _context9.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context9.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context9.finish(16);

        case 22:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch staffs from the server
 * @param {object} params
 * @returns {*} staffs from server, or false if the request fails
 */
function getStaffs(params) {
  var response;
  return _regenerator2.default.wrap(function getStaffs$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context10.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context10.prev = 4;
          _context10.next = 7;
          return (0, _effects.call)(api.getStaffs, params);

        case 7:
          response = _context10.sent;
          return _context10.abrupt('return', response.data);

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10['catch'](4);
          _context10.next = 15;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 15:
          return _context10.abrupt('return', false);

        case 16:
          _context10.prev = 16;
          _context10.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context10.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context10.finish(16);

        case 22:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[4, 11, 16, 22]]);
}

/**
 * Fetch servers from the server
 * @param {object} params
 * @returns {*} servers from server, or false if the request fails
 */
function getServers(params) {
  var response;
  return _regenerator2.default.wrap(function getServers$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context11.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context11.prev = 4;
          _context11.next = 7;
          return (0, _effects.call)(api.getServers, params);

        case 7:
          response = _context11.sent;
          return _context11.abrupt('return', response.data);

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11['catch'](4);
          _context11.next = 15;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 15:
          return _context11.abrupt('return', false);

        case 16:
          _context11.prev = 16;
          _context11.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context11.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context11.finish(16);

        case 22:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.putUpdateSetting = putUpdateSetting;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _settings = __webpack_require__(290);

var apiSetting = _interopRequireWildcard(_settings);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [putUpdateSetting].map(_regenerator2.default.mark);

function putUpdateSetting(data) {
  var response;
  return _regenerator2.default.wrap(function putUpdateSetting$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(apiSetting.putUpdateSetting, data);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.updateFilteredDate = updateFilteredDate;
exports.updateFilteredDateFromMoment = updateFilteredDateFromMoment;

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _updateFilteredDate = __webpack_require__(240);

var api = _interopRequireWildcard(_updateFilteredDate);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [updateFilteredDate, updateFilteredDateFromMoment].map(_regenerator2.default.mark);

function updateFilteredDate(query) {
  var response;
  return _regenerator2.default.wrap(function updateFilteredDate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.updateFilteredDate, query);

        case 7:
          response = _context.sent;
          return _context.abrupt('return', response.data);

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](4);
          _context.next = 15;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 15:
          return _context.abrupt('return', false);

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          _context.next = 21;
          return (0, _effects.put)(action.sendingRequest(false));

        case 21:
          return _context.finish(16);

        case 22:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 11, 16, 22]]);
}

/**
 * @param {Moment} startDate
 * @param {Moment} endDate
 */
function updateFilteredDateFromMoment(startDate, endDate) {
  var query;
  return _regenerator2.default.wrap(function updateFilteredDateFromMoment$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          query = { from: startDate.toString(), to: endDate.startOf('day').toString() };
          _context2.next = 3;
          return (0, _effects.call)(updateFilteredDate, query);

        case 3:
          return _context2.abrupt('return', _context2.sent);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.feedbackPageRequestFlow = feedbackPageRequestFlow;
exports.getCustomerFeedbacksFlow = getCustomerFeedbacksFlow;
exports.changeDateFeedbackFlow = changeDateFeedbackFlow;
exports.getFeedbackMessagesFlow = getFeedbackMessagesFlow;
exports.getFeedbackReceiptFlow = getFeedbackReceiptFlow;
exports.submitReplyRequestFlow = submitReplyRequestFlow;
exports.onClickRowFlow = onClickRowFlow;
exports.cancelAction = cancelAction;
exports.default = customersFeedbackSaga;

var _effects = __webpack_require__(22);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(386);

var _constants2 = __webpack_require__(91);

var _feedback = __webpack_require__(286);

var _getFilteredDate = __webpack_require__(171);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _reports = __webpack_require__(434);

var _reduxForm = __webpack_require__(7);

var _loadingSpinner = __webpack_require__(46);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _customerFeedbacks = __webpack_require__(1069);

var _feedback2 = __webpack_require__(1203);

var mpCustFeedback = _interopRequireWildcard(_feedback2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillSearchForm, feedbackPageRequestFlow, getCustomerFeedbacksFlow, changeDateFeedbackFlow, getFeedbackMessagesFlow, getFeedbackReceiptFlow, submitReplyRequestFlow, onClickRowFlow, cancelAction, customersFeedbackSaga].map(_regenerator2.default.mark);

function fillSearchForm(startDate, endDate) {
  return _regenerator2.default.wrap(function fillSearchForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', { date: { startDate: startDate, endDate: endDate } }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function feedbackPageRequestFlow(request) {
  var filteredDate, startDate, endDate, startDateFormatted, endDateFormatted;
  return _regenerator2.default.wrap(function feedbackPageRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _feedback.setListFeedback)([]));

        case 2:
          mpCustFeedback.customerFeedbackStart();
          // will be set false by feedback request saga
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _effects.put)(action.showProgressBar());

        case 6:
          _context2.next = 8;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 8:
          _context2.next = 10;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 10:
          filteredDate = _context2.sent;
          startDate = (0, _moment2.default)(filteredDate.data.start_date, 'YYYY-MM-DD');
          endDate = (0, _moment2.default)(filteredDate.data.end_date, 'YYYY-MM-DD');
          // set calendar state

          _context2.next = 15;
          return (0, _effects.call)(fillSearchForm, startDate, endDate);

        case 15:
          startDateFormatted = startDate.format('D/M/YYYY');
          endDateFormatted = endDate.format('D/M/YYYY');
          _context2.next = 19;
          return (0, _effects.put)((0, _feedback.listFeedbackRequest)({ start: startDateFormatted, end: endDateFormatted, page: 1 }));

        case 19:
          $('#customer-feedback-detail').hide();
          _context2.next = 26;
          break;

        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 26;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 26:
          _context2.prev = 26;
          _context2.next = 29;
          return (0, _effects.put)(action.hideProgressBar());

        case 29:
          return _context2.finish(26);

        case 30:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[3, 22, 26, 30]]);
}

function getCustomerFeedbacksFlow(request) {
  var _request$payload, query, previousFeedback, startDate, endDate, page, feedbacksRes, resFeedbacks, feedbacks;

  return _regenerator2.default.wrap(function getCustomerFeedbacksFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(action.showProgressBar());

        case 3:
          _request$payload = request.payload, query = _request$payload.query, previousFeedback = _request$payload.previousFeedback;
          startDate = query.start;
          endDate = query.end;
          page = query.page;
          _context3.next = 9;
          return (0, _effects.call)(_customerFeedbacks.getCustomerFeedbacks, { start: startDate, end: endDate, page: page });

        case 9:
          feedbacksRes = _context3.sent;
          resFeedbacks = feedbacksRes.data;

          if (!resFeedbacks) {
            _context3.next = 20;
            break;
          }

          feedbacks = void 0;

          if (previousFeedback) {
            feedbacks = previousFeedback.concat(resFeedbacks.results);
          } else {
            feedbacks = resFeedbacks.results;
          }
          _context3.next = 16;
          return (0, _effects.put)((0, _feedback.setCurrentPage)(page));

        case 16:
          _context3.next = 18;
          return (0, _effects.put)((0, _feedback.setTotalPage)(resFeedbacks.total_pages));

        case 18:
          _context3.next = 20;
          return (0, _effects.put)((0, _feedback.setListFeedback)(feedbacks));

        case 20:
          _context3.next = 26;
          break;

        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 26;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 26:
          _context3.prev = 26;
          _context3.next = 29;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 29:
          _context3.next = 31;
          return (0, _effects.put)(action.hideProgressBar());

        case 31:
          return _context3.finish(26);

        case 32:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 22, 26, 32]]);
}

function changeDateFeedbackFlow(request) {
  var payload, startDate, endDate, startDateFormatted, endDateFormatted;
  return _regenerator2.default.wrap(function changeDateFeedbackFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _feedback.setListFeedback)([]));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          payload = request.payload;
          startDate = payload.startDate, endDate = payload.endDate;
          startDateFormatted = (0, _moment2.default)(startDate).format('D/M/YYYY');
          endDateFormatted = (0, _moment2.default)(endDate).format('D/M/YYYY');
          _context4.next = 10;
          return (0, _effects.put)((0, _feedback.listFeedbackRequest)({
            start: startDateFormatted, end: endDateFormatted, page: 1
          }));

        case 10:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/**
 * TODO remove
 * @param request
 */
function getFeedbackMessagesFlow(request) {
  var payload, id, feedbackBusinessName, feedbackMessagesRes, feedbackMessages;
  return _regenerator2.default.wrap(function getFeedbackMessagesFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.put)(action.showProgressBar());

        case 3:
          _context5.next = 5;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 5:
          payload = request.payload;
          id = payload.id;
          feedbackBusinessName = '';
          _context5.next = 10;
          return (0, _effects.call)(_customerFeedbacks.getFeedbackMessages, id);

        case 10:
          feedbackMessagesRes = _context5.sent;
          feedbackMessages = feedbackMessagesRes.data;

          if (!feedbackMessages) {
            _context5.next = 18;
            break;
          }

          _context5.next = 15;
          return (0, _effects.put)((0, _feedback.setFeedbackMessages)(feedbackMessages));

        case 15:
          if (feedbackMessages.business_name.length > 12) {
            feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + '...- ';
          } else {
            feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + ' - ';
          }
          _context5.next = 18;
          return (0, _effects.put)((0, _reduxForm.initialize)('feedbackReplyForm', {
            feedbackfrom: feedbackMessages.feedback_from,
            comment: feedbackMessages.feedback_from === 'sms' ? feedbackBusinessName : '',
            business_name: feedbackBusinessName
          }));

        case 18:
          _context5.next = 24;
          break;

        case 20:
          _context5.prev = 20;
          _context5.t0 = _context5['catch'](0);
          _context5.next = 24;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 24:
          _context5.prev = 24;
          _context5.next = 27;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 27:
          _context5.next = 29;
          return (0, _effects.put)(action.hideProgressBar());

        case 29:
          return _context5.finish(24);

        case 30:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[0, 20, 24, 30]]);
}

/**
 * TODO remove
 * @param request
 */
function getFeedbackReceiptFlow(request) {
  var payload, id, transactionDetail;
  return _regenerator2.default.wrap(function getFeedbackReceiptFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.put)(action.showProgressBar());

        case 3:
          _context6.next = 5;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 5:
          payload = request.payload;
          id = payload.id;
          _context6.next = 9;
          return (0, _effects.call)(_reports.getTransactionDetail, id);

        case 9:
          transactionDetail = _context6.sent;

          if (!transactionDetail.data) {
            _context6.next = 13;
            break;
          }

          _context6.next = 13;
          return (0, _effects.put)((0, _feedback.setReceiptFeedback)(transactionDetail.data));

        case 13:
          _context6.next = 19;
          break;

        case 15:
          _context6.prev = 15;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 19;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 19:
          _context6.prev = 19;
          _context6.next = 22;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 22:
          _context6.next = 24;
          return (0, _effects.put)(action.hideProgressBar());

        case 24:
          return _context6.finish(19);

        case 25:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[0, 15, 19, 25]]);
}

function submitReplyRequestFlow(request) {
  var data, feedbackMessages;
  return _regenerator2.default.wrap(function submitReplyRequestFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          data = request.payload.data;

          mpCustFeedback.customerFeedbackReply({ feedback: data });
          _context7.prev = 2;
          _context7.next = 5;
          return (0, _effects.put)(action.showProgressBar());

        case 5:
          _context7.next = 7;
          return (0, _effects.call)(_customerFeedbacks.submitReply, data);

        case 7:
          _context7.next = 9;
          return (0, _effects.call)(_customerFeedbacks.getFeedbackMessages, data.feedback_id);

        case 9:
          feedbackMessages = _context7.sent;
          _context7.next = 12;
          return (0, _effects.put)((0, _feedback.setFeedbackMessages)(feedbackMessages.data));

        case 12:
          _context7.next = 14;
          return (0, _effects.put)((0, _reduxForm.reset)('feedbackReplyForm'));

        case 14:
          _context7.next = 20;
          break;

        case 16:
          _context7.prev = 16;
          _context7.t0 = _context7['catch'](2);
          _context7.next = 20;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 20:
          _context7.prev = 20;
          _context7.next = 23;
          return (0, _effects.put)(action.hideProgressBar());

        case 23:
          return _context7.finish(20);

        case 24:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[2, 16, 20, 24]]);
}

function onClickRowFlow(request) {
  var feedback, transactionDetail, feedbackBusinessName, feedbackMessagesRes, feedbackMessages;
  return _regenerator2.default.wrap(function onClickRowFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          feedback = request.payload.feedback;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context8.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _context8.next = 8;
          return (0, _effects.call)(_reports.getTransactionDetail, feedback.payment_id);

        case 8:
          transactionDetail = _context8.sent;

          if (!transactionDetail.data) {
            _context8.next = 12;
            break;
          }

          _context8.next = 12;
          return (0, _effects.put)((0, _feedback.setReceiptFeedback)(transactionDetail.data));

        case 12:
          feedbackBusinessName = '';
          _context8.next = 15;
          return (0, _effects.call)(_customerFeedbacks.getFeedbackMessages, feedback.id);

        case 15:
          feedbackMessagesRes = _context8.sent;
          feedbackMessages = feedbackMessagesRes.data;

          if (!feedbackMessages) {
            _context8.next = 23;
            break;
          }

          _context8.next = 20;
          return (0, _effects.put)((0, _feedback.setFeedbackMessages)(feedbackMessages));

        case 20:
          if (feedbackMessages.business_name.length > 12) {
            feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + '...- ';
          } else {
            feedbackBusinessName = feedbackMessages.business_name.slice(0, 12) + ' - ';
          }
          _context8.next = 23;
          return (0, _effects.put)((0, _reduxForm.initialize)('feedbackReplyForm', {
            feedbackfrom: feedbackMessages.feedback_from,
            comment: feedbackMessages.feedback_from === 'sms' ? feedbackBusinessName : '',
            business_name: feedbackBusinessName
          }));

        case 23:
          mpCustFeedback.customerFeedbackSelect({
            feedback: feedback, transaction: transactionDetail.data, feedbackMessages: feedbackMessages
          });
          _context8.next = 30;
          break;

        case 26:
          _context8.prev = 26;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 30;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 30:
          _context8.prev = 30;
          _context8.next = 33;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 33:
          _context8.next = 35;
          return (0, _effects.put)(action.hideProgressBar());

        case 35:
          return _context8.finish(30);

        case 36:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 26, 30, 36]]);
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function customersFeedbackSaga() {
  var feedbackPage, feedbackList, changeDate, feedbackMessages, feedbackReceipt;
  return _regenerator2.default.wrap(function customersFeedbackSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_PAGE_REQUEST, feedbackPageRequestFlow);

        case 2:
          feedbackPage = _context10.sent;
          _context10.next = 5;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_LIST_FEEDBACK_REQUEST, getCustomerFeedbacksFlow);

        case 5:
          feedbackList = _context10.sent;
          _context10.next = 8;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_CHANGE_DATE, changeDateFeedbackFlow);

        case 8:
          changeDate = _context10.sent;
          _context10.next = 11;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_MESSAGES_REQUEST, getFeedbackMessagesFlow);

        case 11:
          feedbackMessages = _context10.sent;
          _context10.next = 14;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_RECEIPT_REQUEST, getFeedbackReceiptFlow);

        case 14:
          feedbackReceipt = _context10.sent;
          _context10.next = 17;
          return (0, _effects.takeEvery)(_constants.CUSTOMERS_FEEDBACK_SUBMIT_REPLY_REQUEST, submitReplyRequestFlow);

        case 17:
          _context10.next = 19;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_FEEDBACK_ON_CLICK_ROW, onClickRowFlow);

        case 19:
          _context10.next = 21;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [feedbackPage, feedbackList, changeDate, feedbackMessages, feedbackReceipt]);

        case 21:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.wait = wait;
exports.pageRequest = pageRequest;
exports.customersRequest = customersRequest;
exports.customerDetailRequest = customerDetailRequest;
exports.closeCustomerDetail = closeCustomerDetail;
exports.receiptCustomerRequestFlow = receiptCustomerRequestFlow;
exports.downloadCustomersTemplate = downloadCustomersTemplate;
exports.getExportCustomer = getExportCustomer;
exports.customerRedemptionHistoriesRequest = customerRedemptionHistoriesRequest;
exports.customerPointActivitiesRequest = customerPointActivitiesRequest;
exports.cancelAction = cancelAction;
exports.changeModalVisibilityFlow = changeModalVisibilityFlow;
exports.default = saga;

var _constants = __webpack_require__(387);

var _effects = __webpack_require__(22);

var _customers = __webpack_require__(622);

var apiCustomers = _interopRequireWildcard(_customers);

var _list = __webpack_require__(75);

var actCustomerList = _interopRequireWildcard(_list);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _report = __webpack_require__(677);

var _invoices = __webpack_require__(675);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _constants2 = __webpack_require__(91);

var _loadingSpinner = __webpack_require__(46);

var _list2 = __webpack_require__(450);

var mpCustomerList = _interopRequireWildcard(_list2);

var _reactFileDownload = __webpack_require__(374);

var _reactFileDownload2 = _interopRequireDefault(_reactFileDownload);

var _getSubscriptionStatus = __webpack_require__(289);

var _uploaders = __webpack_require__(236);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, customersRequest, customerDetailRequest, closeCustomerDetail, receiptCustomerRequestFlow, downloadCustomersTemplate, getExportCustomer, customerRedemptionHistoriesRequest, customerPointActivitiesRequest, cancelAction, changeModalVisibilityFlow, saga].map(_regenerator2.default.mark);

function wait(millis) {
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      resolve(true);
    }, millis);
  });
}
function pageRequest(request) {
  var customersReqParam, _ref, data, hasLoyalty;

  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          customersReqParam = { page: 1 };

          mpCustomerList.customerListStart();
          _context.next = 4;
          return (0, _effects.put)(actCustomerList.setCustomers([]));

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_getSubscriptionStatus.getSubscriptionStatus, { 'feature_names': ['Loyalty'] });

        case 8:
          _ref = _context.sent;
          data = _ref.data;
          hasLoyalty = Boolean(data && data[0] && data[0].is_subscribing);

          if (hasLoyalty) {
            customersReqParam.type = 'ALL';
          }
          _context.next = 14;
          return (0, _effects.put)(actCustomerList.setHasLoyalty(hasLoyalty));

        case 14:
          _context.next = 16;
          return (0, _effects.put)(actCustomerList.customersRequest(customersReqParam, []));

        case 16:
          _context.next = 18;
          return (0, _effects.put)(actCustomerList.setCustomerDetail(null));

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function customersRequest(action) {
  var _action$payload, query, previousCustomers, page, keyword, type, _ref2, data, total_customer, total_loyalty_member, total_rewards_redeemed, customers;

  return _regenerator2.default.wrap(function customersRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, query = _action$payload.query, previousCustomers = _action$payload.previousCustomers;
          page = query.page, keyword = query.keyword, type = query.type;

          if (!keyword) {
            keyword = '';
          } else {
            if (keyword[0] === '+') {
              // TODO HACK
              // kalo di mokapos versi lama, input '+62' tidak diencode
              // jadinya '+62' bakal dikirim as is '+62'
              // sementara yang sekarang '+62' bakal diencode jadi '%2B62';
              // karena ngirim '%2B62' bakal error di server (ada tiket PS terkait)
              // jadinya buat mimic pengiriman '+62' insteadof '%2B62'
              // ganti karakter pertama dengan spasi
              // supaya hasil encodingnya '+62'
              query.keyword = ' ' + keyword.substr(1);
            }
          }

          _context2.next = 5;
          return (0, _effects.put)(actCustomerList.closeCustomerDetail());

        case 5:
          _context2.prev = 5;
          _context2.next = 8;
          return (0, _effects.put)(act.sendingRequest(true));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context2.next = 12;
          return (0, _effects.call)(wait, 300);

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(apiCustomers.getCustomers, query);

        case 14:
          _ref2 = _context2.sent;
          data = _ref2.data;
          total_customer = data.total_customer, total_loyalty_member = data.total_loyalty_member, total_rewards_redeemed = data.total_rewards_redeemed;
          customers = previousCustomers.concat(data.results);
          _context2.next = 20;
          return (0, _effects.put)(actCustomerList.setCurrentPage(page));

        case 20:
          _context2.next = 22;
          return (0, _effects.put)(actCustomerList.setTotalPage(data.total_pages));

        case 22:
          _context2.next = 24;
          return (0, _effects.put)(actCustomerList.setCustomers(customers));

        case 24:
          _context2.next = 26;
          return (0, _effects.put)(actCustomerList.setKeyword(keyword));

        case 26:
          _context2.next = 28;
          return (0, _effects.put)(actCustomerList.setType(type));

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actCustomerList.setSummary({ total_customer: total_customer, total_loyalty_member: total_loyalty_member, total_rewards_redeemed: total_rewards_redeemed }));

        case 30:
          _context2.next = 36;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t0 = _context2['catch'](5);
          _context2.next = 36;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 36:
          _context2.prev = 36;
          _context2.next = 39;
          return (0, _effects.put)(act.sendingRequest(false));

        case 39:
          _context2.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          _context2.next = 43;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 43:
          return _context2.finish(36);

        case 44:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[5, 32, 36, 44]]);
}

function customerDetailRequest(request) {
  var _request$payload, customer, query, _ref3, data;

  return _regenerator2.default.wrap(function customerDetailRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          // noinspection InfiniteLoopJS
          _request$payload = request.payload, customer = _request$payload.customer, query = _request$payload.query;

          if (!query) {
            query = {};
          }
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.put)(act.sendingRequest(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(act.showProgressBar());

        case 7:
          _context3.next = 9;
          return (0, _effects.call)(apiCustomers.getCustomerDetail, customer.id, query);

        case 9:
          _ref3 = _context3.sent;
          data = _ref3.data;

          if (!data) {
            _context3.next = 15;
            break;
          }

          _context3.next = 14;
          return (0, _effects.put)(actCustomerList.setCustomerDetail(data));

        case 14:
          mpCustomerList.customerListSelect({ customer: data });

        case 15:

          // show/hide receipt
          $('#customer-detail').show();
          $('#receipt-invoice-customer').hide();
          $('#receipt-transaction-customer').hide();

          // animate
          if ($('#mk-col-left').hasClass('col-sm-12')) {
            $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6');
            setTimeout(function () {
              $('#mk-col-right').fadeIn(200);
              $('[data-toggle="popover"]').popover();
            }, 600);
          }
          _context3.next = 25;
          break;

        case 21:
          _context3.prev = 21;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 25;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 25:
          _context3.prev = 25;
          _context3.next = 28;
          return (0, _effects.put)(act.sendingRequest(false));

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          return _context3.finish(25);

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[2, 21, 25, 31]]);
}

function closeCustomerDetail(request) {
  var toggledClass;
  return _regenerator2.default.wrap(function closeCustomerDetail$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actCustomerList.setCustomerDetail(null));

        case 2:
          // animation
          toggledClass = 'col-sm-12 col-md-6 col-xs-6';

          $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
          $('#mk-col-left').addClass('col-sm-12');

        case 5:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function receiptCustomerRequestFlow(request) {
  var payload, paymentType, parentId, customer, receiptInvoice, receiptTransaction;
  return _regenerator2.default.wrap(function receiptCustomerRequestFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = request.payload;
          paymentType = payload.payment.payment_type;
          parentId = payload.payment.parent_payment_id;
          customer = payload.customer;


          $('#customer-detail').hide();

          if (!(paymentType === 'invoice')) {
            _context5.next = 16;
            break;
          }

          _context5.next = 8;
          return (0, _effects.call)(_invoices.getReceiptInvoices, parentId);

        case 8:
          receiptInvoice = _context5.sent;

          $('#receipt-transaction-customer').hide();
          $('#receipt-invoice-customer').show();
          _context5.next = 13;
          return (0, _effects.put)(actCustomerList.setReceiptCustomer(receiptInvoice));

        case 13:
          mpCustomerList.customerListSelectPurchaseHistoryInvoice({ invoice: receiptInvoice });
          _context5.next = 24;
          break;

        case 16:
          _context5.next = 18;
          return (0, _effects.call)(_report.getTransactionDetail, parentId);

        case 18:
          receiptTransaction = _context5.sent;

          $('#receipt-invoice-customer').hide();
          $('#receipt-transaction-customer').show();
          _context5.next = 23;
          return (0, _effects.put)(actCustomerList.setReceiptCustomer(receiptTransaction));

        case 23:
          mpCustomerList.customerListSelectPurchaseHistoryTransaction({ transaction: receiptTransaction, customer: customer });

        case 24:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function downloadCustomersTemplate(request) {
  var payload, response;
  return _regenerator2.default.wrap(function downloadCustomersTemplate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = request.payload;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.call)(apiCustomers.getCustomerTemplate);

        case 4:
          response = _context6.sent;

          if (!(response.data.message === 'ok')) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)(actGetExportedFile.getExportedWithoutOutlet(payload.filename));

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _effects.put)(actNotif.error(response.data.message));

        case 12:
          _context6.next = 18;
          break;

        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6['catch'](1);
          _context6.next = 18;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 18:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[1, 14]]);
}

function getExportCustomer(request) {
  var payload, fileName, hasLoyalty, response;
  return _regenerator2.default.wrap(function getExportCustomer$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = request.payload;
          fileName = payload.fileName, hasLoyalty = payload.hasLoyalty;
          _context7.prev = 2;
          _context7.next = 5;
          return (0, _effects.put)(act.sendingRequest(true));

        case 5:
          _context7.next = 7;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 7:
          _context7.next = 9;
          return (0, _effects.call)(apiCustomers.getCustomerExport, { hasLoyalty: hasLoyalty });

        case 9:
          response = _context7.sent;
          _context7.next = 12;
          return (0, _effects.call)(_reactFileDownload2.default, response.data, fileName + '.csv');

        case 12:
          _context7.next = 18;
          break;

        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7['catch'](2);
          _context7.next = 18;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 18:
          _context7.prev = 18;
          _context7.next = 21;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 21:
          _context7.next = 23;
          return (0, _effects.put)(act.sendingRequest(false));

        case 23:
          return _context7.finish(18);

        case 24:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[2, 14, 18, 24]]);
}

function customerRedemptionHistoriesRequest(request) {
  var _request$payload$quer, customerId, params, _ref4, data;

  return _regenerator2.default.wrap(function customerRedemptionHistoriesRequest$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload$quer = request.payload.query, customerId = _request$payload$quer.customerId, params = (0, _objectWithoutProperties3.default)(_request$payload$quer, ['customerId']);
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context8.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context8.next = 8;
          return (0, _effects.call)(apiCustomers.getRedemptionHistories, customerId, params);

        case 8:
          _ref4 = _context8.sent;
          data = _ref4.data;
          _context8.next = 12;
          return (0, _effects.put)(actCustomerList.setRedemptionHistories(data));

        case 12:
          _context8.next = 18;
          break;

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 18;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 18:
          _context8.prev = 18;
          _context8.next = 21;
          return (0, _effects.put)(act.sendingRequest(false));

        case 21:
          _context8.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          return _context8.finish(18);

        case 24:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 14, 18, 24]]);
}

function customerPointActivitiesRequest(request) {
  var _request$payload$quer2, customerId, params, _ref5, data;

  return _regenerator2.default.wrap(function customerPointActivitiesRequest$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload$quer2 = request.payload.query, customerId = _request$payload$quer2.customerId, params = (0, _objectWithoutProperties3.default)(_request$payload$quer2, ['customerId']);
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context9.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context9.next = 8;
          return (0, _effects.call)(apiCustomers.getPointActivities, customerId, params);

        case 8:
          _ref5 = _context9.sent;
          data = _ref5.data;
          _context9.next = 12;
          return (0, _effects.put)(actCustomerList.setPointActivities(data));

        case 12:
          _context9.next = 18;
          break;

        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9['catch'](1);
          _context9.next = 18;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 18:
          _context9.prev = 18;
          _context9.next = 21;
          return (0, _effects.put)(act.sendingRequest(false));

        case 21:
          _context9.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          return _context9.finish(18);

        case 24:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[1, 14, 18, 24]]);
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function changeModalVisibilityFlow(request) {
  return _regenerator2.default.wrap(function changeModalVisibilityFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)((0, _uploaders.showModalImport)(request.payload.modalVisibility));

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function saga() {
  var customerRequestTask, pageReqTask, customerDetailReqTask, receiptCustomerReqTask, downloadCustomersTemplateTask, exportTask, redemptionHistoriesRequestTask, pointActivitiesRequestTask;
  return _regenerator2.default.wrap(function saga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_CUSTOMERS_REQUEST, customersRequest);

        case 2:
          customerRequestTask = _context12.sent;
          _context12.next = 5;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_PAGE_REQUEST, pageRequest);

        case 5:
          pageReqTask = _context12.sent;
          _context12.next = 8;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST, customerDetailRequest);

        case 8:
          customerDetailReqTask = _context12.sent;
          _context12.next = 11;
          return (0, _effects.takeEvery)(_constants.CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL, closeCustomerDetail);

        case 11:
          _context12.next = 13;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_RECEIPT_REQUEST, receiptCustomerRequestFlow);

        case 13:
          receiptCustomerReqTask = _context12.sent;
          _context12.next = 16;
          return (0, _effects.takeLatest)(_constants.CUSTOMERS_DOWNLOAD_TEMPLATE, downloadCustomersTemplate);

        case 16:
          downloadCustomersTemplateTask = _context12.sent;
          _context12.next = 19;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_EXPORT, getExportCustomer);

        case 19:
          exportTask = _context12.sent;
          _context12.next = 22;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST, customerRedemptionHistoriesRequest);

        case 22:
          redemptionHistoriesRequestTask = _context12.sent;
          _context12.next = 25;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST, customerPointActivitiesRequest);

        case 25:
          pointActivitiesRequestTask = _context12.sent;
          _context12.next = 28;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [customerRequestTask, redemptionHistoriesRequestTask, pointActivitiesRequestTask, pageReqTask, customerDetailReqTask, receiptCustomerReqTask, downloadCustomersTemplateTask, exportTask]);

        case 28:
          _context12.next = 30;
          return (0, _effects.takeLatest)(_constants.CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY, changeModalVisibilityFlow);

        case 30:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBusinessId = undefined;

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initLoyaltyDataFlow = initLoyaltyDataFlow;
exports.createLoyaltyFlow = createLoyaltyFlow;
exports.editLoyaltyFlow = editLoyaltyFlow;
exports.resetLoyaltyFlow = resetLoyaltyFlow;
exports.deactivateLoyaltyFlow = deactivateLoyaltyFlow;
exports.reactivateLoyaltyFlow = reactivateLoyaltyFlow;
exports.default = customersLoyaltySaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(388);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _loyalty = __webpack_require__(609);

var loyaltyAction = _interopRequireWildcard(_loyalty);

var _loyalty2 = __webpack_require__(1072);

var api = _interopRequireWildcard(_loyalty2);

var _endTutorial = __webpack_require__(623);

var _loyalty3 = __webpack_require__(206);

var mpLoyalty = _interopRequireWildcard(_loyalty3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initLoyaltyDataFlow, createLoyaltyFlow, editLoyaltyFlow, resetLoyaltyFlow, deactivateLoyaltyFlow, reactivateLoyaltyFlow, customersLoyaltySaga].map(_regenerator2.default.mark);

var getBusinessId = exports.getBusinessId = function getBusinessId(state) {
  return state.moka.user.business.id;
};

function initLoyaltyDataFlow() {
  var payload, businessId, response;
  return _regenerator2.default.wrap(function initLoyaltyDataFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = void 0;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.put)(action.sendingRequest(true));

        case 4:
          _context.next = 6;
          return (0, _effects.put)(action.showProgressBar());

        case 6:
          _context.next = 8;
          return (0, _effects.select)(getBusinessId);

        case 8:
          businessId = _context.sent;
          _context.next = 11;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 11:
          response = _context.sent;

          payload = response.data;
          payload.hasLoyalty = true;
          _context.next = 19;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context['catch'](1);

          payload = { hasLoyalty: false };

        case 19:
          _context.prev = 19;
          _context.next = 22;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 22:
          _context.next = 24;
          return (0, _effects.put)(action.sendingRequest(false));

        case 24:
          _context.next = 26;
          return (0, _effects.put)(action.hideProgressBar());

        case 26:
          return _context.finish(19);

        case 27:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[1, 16, 19, 27]]);
}

function createLoyaltyFlow(request) {
  var data, payload, businessId, response, displayErrorMessage;
  return _regenerator2.default.wrap(function createLoyaltyFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          data = request.payload;
          payload = void 0;
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _effects.put)(action.sendingRequest(true));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(action.showProgressBar());

        case 7:
          _context2.next = 9;
          return (0, _effects.select)(getBusinessId);

        case 9:
          businessId = _context2.sent;
          _context2.next = 12;
          return (0, _effects.call)(api.createLoyalty, businessId, data);

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 14:
          response = _context2.sent;

          payload = response.data;
          payload.hasLoyalty = true;
          _context2.next = 19;
          return (0, _effects.call)(api.addSubscription);

        case 19:
          _context2.next = 21;
          return (0, _effects.call)(_endTutorial.endTutorial, { feature_name: 'Loyalty' });

        case 21:
          _context2.next = 23;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 23:
          _context2.next = 25;
          return (0, _effects.call)(mpLoyalty.createLoyaltySuccess);

        case 25:
          _context2.next = 34;
          break;

        case 27:
          _context2.prev = 27;
          _context2.t0 = _context2['catch'](2);
          displayErrorMessage = 'Internal server error. Please try again later.';
          _context2.next = 32;
          return (0, _effects.call)(mpLoyalty.createLoyaltyFail, displayErrorMessage, _context2.t0);

        case 32:
          _context2.next = 34;
          return (0, _effects.put)(actNotif.error(displayErrorMessage));

        case 34:
          _context2.prev = 34;
          _context2.next = 37;
          return (0, _effects.put)(action.sendingRequest(false));

        case 37:
          _context2.next = 39;
          return (0, _effects.put)(action.hideProgressBar());

        case 39:
          return _context2.finish(34);

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[2, 27, 34, 40]]);
}

function editLoyaltyFlow(request) {
  var data, payload, businessId, response;
  return _regenerator2.default.wrap(function editLoyaltyFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          data = request.payload;
          payload = void 0;
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.put)(action.sendingRequest(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(action.showLoadingSpinner(true));

        case 7:
          _context3.next = 9;
          return (0, _effects.select)(getBusinessId);

        case 9:
          businessId = _context3.sent;
          _context3.next = 12;
          return (0, _effects.call)(api.editLoyalty, businessId, data);

        case 12:
          _context3.next = 14;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 14:
          response = _context3.sent;

          payload = response.data;
          _context3.next = 18;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 18:
          _context3.next = 20;
          return (0, _effects.put)(actNotif.success('Loyalty program is saved successfully.'));

        case 20:
          _context3.next = 26;
          break;

        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 26;
          return (0, _effects.put)(actNotif.error('Internal server error. Please try again later.'));

        case 26:
          _context3.prev = 26;
          _context3.next = 29;
          return (0, _effects.put)(action.sendingRequest(false));

        case 29:
          _context3.next = 31;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 31:
          return _context3.finish(26);

        case 32:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[2, 22, 26, 32]]);
}

function resetLoyaltyFlow(request) {
  var data, payload, businessId, response;
  return _regenerator2.default.wrap(function resetLoyaltyFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          data = request.payload;
          payload = void 0;
          _context4.prev = 2;
          _context4.next = 5;
          return (0, _effects.put)(action.sendingRequest(true));

        case 5:
          _context4.next = 7;
          return (0, _effects.put)(action.showLoadingSpinner(true));

        case 7:
          _context4.next = 9;
          return (0, _effects.select)(getBusinessId);

        case 9:
          businessId = _context4.sent;
          _context4.next = 12;
          return (0, _effects.call)(api.resetLoyalty, businessId, data);

        case 12:
          _context4.next = 14;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 14:
          response = _context4.sent;

          payload = response.data;
          _context4.next = 18;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 18:
          _context4.next = 20;
          return (0, _effects.put)(actNotif.success('Loyalty program is saved successfully.'));

        case 20:
          _context4.next = 26;
          break;

        case 22:
          _context4.prev = 22;
          _context4.t0 = _context4['catch'](2);
          _context4.next = 26;
          return (0, _effects.put)(actNotif.error('Internal server error. Please try again later.'));

        case 26:
          _context4.prev = 26;
          _context4.next = 29;
          return (0, _effects.put)(action.sendingRequest(false));

        case 29:
          _context4.next = 31;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 31:
          return _context4.finish(26);

        case 32:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[2, 22, 26, 32]]);
}

function deactivateLoyaltyFlow() {
  var payload, businessId, response;
  return _regenerator2.default.wrap(function deactivateLoyaltyFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = void 0;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.put)(action.sendingRequest(true));

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(action.showLoadingSpinner(true));

        case 6:
          _context5.next = 8;
          return (0, _effects.select)(getBusinessId);

        case 8:
          businessId = _context5.sent;
          _context5.next = 11;
          return (0, _effects.call)(api.deactivateLoyalty, businessId);

        case 11:
          _context5.next = 13;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 13:
          response = _context5.sent;

          payload = response.data;
          _context5.next = 17;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 17:
          _context5.next = 19;
          return (0, _effects.put)(actNotif.success('Loyalty program is saved successfully.'));

        case 19:
          _context5.next = 25;
          break;

        case 21:
          _context5.prev = 21;
          _context5.t0 = _context5['catch'](1);
          _context5.next = 25;
          return (0, _effects.put)(actNotif.error('Internal server error. Please try again later.'));

        case 25:
          _context5.prev = 25;
          _context5.next = 28;
          return (0, _effects.put)(action.sendingRequest(false));

        case 28:
          _context5.next = 30;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 30:
          return _context5.finish(25);

        case 31:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[1, 21, 25, 31]]);
}

function reactivateLoyaltyFlow(request) {
  var data, payload, businessId, response;
  return _regenerator2.default.wrap(function reactivateLoyaltyFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          data = request.payload;
          payload = void 0;
          _context6.prev = 2;
          _context6.next = 5;
          return (0, _effects.put)(action.sendingRequest(true));

        case 5:
          _context6.next = 7;
          return (0, _effects.put)(action.showLoadingSpinner(true));

        case 7:
          _context6.next = 9;
          return (0, _effects.select)(getBusinessId);

        case 9:
          businessId = _context6.sent;
          _context6.next = 12;
          return (0, _effects.call)(api.reactivateLoyalty, businessId, data);

        case 12:
          _context6.next = 14;
          return (0, _effects.call)(api.getLoyalty, businessId);

        case 14:
          response = _context6.sent;

          payload = response.data;
          _context6.next = 18;
          return (0, _effects.put)(loyaltyAction.setLoyalty(payload));

        case 18:
          _context6.next = 20;
          return (0, _effects.put)(actNotif.success('Loyalty program is saved successfully.'));

        case 20:
          _context6.next = 26;
          break;

        case 22:
          _context6.prev = 22;
          _context6.t0 = _context6['catch'](2);
          _context6.next = 26;
          return (0, _effects.put)(actNotif.error('Internal server error. Please try again later.'));

        case 26:
          _context6.prev = 26;
          _context6.next = 29;
          return (0, _effects.put)(action.sendingRequest(false));

        case 29:
          _context6.next = 31;
          return (0, _effects.put)(action.showLoadingSpinner(false));

        case 31:
          return _context6.finish(26);

        case 32:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[2, 22, 26, 32]]);
}

function customersLoyaltySaga() {
  return _regenerator2.default.wrap(function customersLoyaltySaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.INIT_LOYALTY_DATA, initLoyaltyDataFlow);

        case 2:
          _context7.next = 4;
          return (0, _effects.takeLatest)(_constants.CREATE_LOYALTY, createLoyaltyFlow);

        case 4:
          _context7.next = 6;
          return (0, _effects.takeLatest)(_constants.EDIT_LOYALTY, editLoyaltyFlow);

        case 6:
          _context7.next = 8;
          return (0, _effects.takeLatest)(_constants.RESET_LOYALTY, resetLoyaltyFlow);

        case 8:
          _context7.next = 10;
          return (0, _effects.takeLatest)(_constants.DEACTIVATE_LOYALTY, deactivateLoyaltyFlow);

        case 10:
          _context7.next = 12;
          return (0, _effects.takeLatest)(_constants.REACTIVATE_LOYALTY, reactivateLoyaltyFlow);

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillForm = fillForm;
exports.resetCheckedOutlets = resetCheckedOutlets;
exports.pageRequest = pageRequest;
exports.resendInvitation = resendInvitation;
exports.cancelDeleteEmployee = cancelDeleteEmployee;
exports.askDeleteEmployee = askDeleteEmployee;
exports.confirmDeleteEmployee = confirmDeleteEmployee;
exports.assignOutlets = assignOutlets;
exports.confirmAssignOutlets = confirmAssignOutlets;
exports.cancelAssignOutlets = cancelAssignOutlets;
exports.checkAllOutlets = checkAllOutlets;
exports.uncheckAllOutlets = uncheckAllOutlets;
exports.searchOutlet = searchOutlet;
exports.submitForm = submitForm;
exports.cancelAction = cancelAction;
exports.default = saga;

var _reduxForm = __webpack_require__(7);

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(391);

var _constants2 = __webpack_require__(91);

var _employees = __webpack_require__(1076);

var apiEmployee = _interopRequireWildcard(_employees);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _list = __webpack_require__(200);

var actEmployeeList = _interopRequireWildcard(_list);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _loadingSpinner = __webpack_require__(46);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, resetCheckedOutlets, pageRequest, resendInvitation, cancelDeleteEmployee, askDeleteEmployee, confirmDeleteEmployee, assignOutlets, confirmAssignOutlets, cancelAssignOutlets, checkAllOutlets, uncheckAllOutlets, searchOutlet, submitForm, cancelAction, saga].map(_regenerator2.default.mark); /**
                                                                                                                                                                                                                                                                                                                           * @param outlets
                                                                                                                                                                                                                                                                                                                           */


function fillForm(outlets) {
  var form;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          form = {
            password: generateRandomPassword(),
            outlets: outlets.map(function (o) {
              return { id: o.id, name: o.name, checked: false, show: true };
            })
          };
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('invite', form));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function resetCheckedOutlets(outlets) {
  var checkedOutlets;
  return _regenerator2.default.wrap(function resetCheckedOutlets$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          checkedOutlets = outlets.map(function (o) {
            return { id: o.id, name: o.name, checked: false, show: true };
          });
          _context2.next = 3;
          return (0, _effects.put)(actEmployeeList.setCheckedOutlets(checkedOutlets));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function reorderEmployees(employees) {
  var pendingEmployees = [];
  var confirmedEmployees = [];
  employees.forEach(function (e) {
    if (e.is_confirmed) {
      confirmedEmployees.push(e);
    }
  });
  employees.forEach(function (e) {
    if (!e.is_confirmed) {
      pendingEmployees.push(e);
    }
  });
  return confirmedEmployees.concat(pendingEmployees);
}

function reorderStaff(staffs) {
  var pendingEmployees = [];
  var confirmedEmployees = [];
  // staffs index 0 always manager that currently logged in
  var manager = staffs[0];
  var managerOutletId = [];
  _.forEach(manager.outlets, function (outlet) {
    managerOutletId.push(outlet.id);
  });
  _.forEach(staffs, function (stf) {
    var user = stf;
    var userAssignedOutlet = [];

    _.forEach(user.outlets, function (outlet) {
      if (_.includes(managerOutletId, outlet.id)) userAssignedOutlet.push(outlet);
    });
    if (_.isEmpty(userAssignedOutlet)) user = null;

    if (user && !user.is_deleted && user.outlets.length !== 0 && !user.is_manager) {
      user.outlets = userAssignedOutlet;
      user.title = user.employee_business.employee_title;
      if (user.is_confirmed) {
        confirmedEmployees.push(user);
      } else {
        pendingEmployees.push(user);
      }
    }
  });
  return confirmedEmployees.concat(pendingEmployees);
}

function isJSONFromAssignStaff(employee) {
  return employee.hasOwnProperty('user_id');
}

function pageRequest() {
  var resProfile, _ref, data, orderedEmployees, _ref2, _data, orderedStaff, response;

  return _regenerator2.default.wrap(function pageRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actEmployeeList.setEmployees([]));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.put)(act.sendingRequest(true));

        case 7:
          _context3.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context3.next = 11;
          return (0, _effects.call)(apiProfile.getProfile);

        case 11:
          resProfile = _context3.sent;
          _context3.next = 14;
          return (0, _effects.put)(actEmployeeList.setProfile(resProfile.data));

        case 14:
          if (!resProfile.data.is_owner) {
            _context3.next = 24;
            break;
          }

          _context3.next = 17;
          return (0, _effects.call)(apiEmployee.getEmployees, {});

        case 17:
          _ref = _context3.sent;
          data = _ref.data;

          // reorder
          orderedEmployees = reorderEmployees(data);
          _context3.next = 22;
          return (0, _effects.put)(actEmployeeList.setEmployees(orderedEmployees));

        case 22:
          _context3.next = 31;
          break;

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(apiEmployee.getAssignedStaffV1, {});

        case 26:
          _ref2 = _context3.sent;
          _data = _ref2.data;
          orderedStaff = reorderStaff(_data);
          _context3.next = 31;
          return (0, _effects.put)(actEmployeeList.setEmployees(orderedStaff));

        case 31:
          _context3.next = 33;
          return (0, _effects.call)(apiOutlets.outlets);

        case 33:
          response = _context3.sent;
          _context3.next = 36;
          return (0, _effects.put)(actEmployeeList.setOutlets(response.data));

        case 36:
          _context3.next = 38;
          return (0, _effects.call)(resetCheckedOutlets, response.data);

        case 38:
          _context3.next = 40;
          return (0, _effects.call)(fillForm, response.data);

        case 40:
          _context3.next = 46;
          break;

        case 42:
          _context3.prev = 42;
          _context3.t0 = _context3['catch'](4);
          _context3.next = 46;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 46:
          _context3.prev = 46;
          _context3.next = 49;
          return (0, _effects.put)(act.hideProgressBar());

        case 49:
          _context3.next = 51;
          return (0, _effects.put)(act.sendingRequest(false));

        case 51:
          _context3.next = 53;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 53:
          return _context3.finish(46);

        case 54:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 42, 46, 54]]);
}

function resendInvitation(request) {
  var email;
  return _regenerator2.default.wrap(function resendInvitation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          // noinspection InfiniteLoopJS
          email = request.payload.email;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context4.next = 8;
          return (0, _effects.call)(apiEmployee.resendInvitation, { pending_employee_email: email }, {});

        case 8:
          _context4.next = 10;
          return (0, _effects.put)(actNotif.success('Employee invitation sent.'));

        case 10:
          _context4.next = 16;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4['catch'](1);
          _context4.next = 16;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(act.hideProgressBar());

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(act.sendingRequest(false));

        case 21:
          return _context4.finish(16);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[1, 12, 16, 22]]);
}

function cancelDeleteEmployee(request) {
  return _regenerator2.default.wrap(function cancelDeleteEmployee$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actEmployeeList.setDeletedEmployee(null));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(actEmployeeList.hideDeleteEmployeeModal());

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function askDeleteEmployee(request) {
  var deletedEmployee;
  return _regenerator2.default.wrap(function askDeleteEmployee$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          deletedEmployee = request.payload.deletedEmployee;
          _context6.next = 3;
          return (0, _effects.put)(actEmployeeList.setDeletedEmployee(deletedEmployee));

        case 3:
          _context6.next = 5;
          return (0, _effects.put)(actEmployeeList.showDeleteEmployeeModal());

        case 5:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function confirmDeleteEmployee(request) {
  var deletedEmployee, userId;
  return _regenerator2.default.wrap(function confirmDeleteEmployee$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          deletedEmployee = request.payload.deletedEmployee;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          userId = isJSONFromAssignStaff(deletedEmployee) ? deletedEmployee.user_id : deletedEmployee.id;
          _context7.next = 9;
          return (0, _effects.call)(apiEmployee.deleteEmployee, userId, {});

        case 9:
          _context7.next = 11;
          return (0, _effects.put)(actNotif.success('Employee successfully deleted'));

        case 11:
          _context7.next = 13;
          return (0, _effects.put)(actEmployeeList.hideDeleteEmployeeModal());

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(actEmployeeList.setDeletedEmployee(null));

        case 15:
          _context7.next = 17;
          return (0, _effects.put)(actEmployeeList.pageRequest());

        case 17:
          _context7.next = 23;
          break;

        case 19:
          _context7.prev = 19;
          _context7.t0 = _context7['catch'](1);
          _context7.next = 23;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 23:
          _context7.prev = 23;
          _context7.next = 26;
          return (0, _effects.put)(act.hideProgressBar());

        case 26:
          _context7.next = 28;
          return (0, _effects.put)(act.sendingRequest(false));

        case 28:
          return _context7.finish(23);

        case 29:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[1, 19, 23, 29]]);
}

function assignOutlets(request) {
  var outlets, idx, formName, fieldName;
  return _regenerator2.default.wrap(function assignOutlets$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          outlets = request.payload.inviteForm.outlets;
          _context8.next = 3;
          return (0, _effects.put)(actEmployeeList.showAssignOutletModal());

        case 3:
          idx = 0;

        case 4:
          if (!(idx < outlets.length)) {
            _context8.next = 12;
            break;
          }

          formName = 'invite';
          fieldName = 'outlets';
          _context8.next = 9;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].show', true));

        case 9:
          idx++;
          _context8.next = 4;
          break;

        case 12:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function confirmAssignOutlets(request) {
  var outlets;
  return _regenerator2.default.wrap(function confirmAssignOutlets$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          outlets = request.payload.outlets;
          _context9.next = 3;
          return (0, _effects.put)(actEmployeeList.setCheckedOutlets(outlets));

        case 3:
          _context9.next = 5;
          return (0, _effects.put)(actEmployeeList.hideAssignOutletModal());

        case 5:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function cancelAssignOutlets(request) {
  var _request$payload, previousOutlets, formName, fieldName, idx;

  return _regenerator2.default.wrap(function cancelAssignOutlets$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload = request.payload, previousOutlets = _request$payload.previousOutlets, formName = _request$payload.formName, fieldName = _request$payload.fieldName;
          idx = 0;

        case 2:
          if (!(idx < previousOutlets.length)) {
            _context10.next = 10;
            break;
          }

          _context10.next = 5;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].checked', previousOutlets[idx].checked));

        case 5:
          _context10.next = 7;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].show', true));

        case 7:
          idx++;
          _context10.next = 2;
          break;

        case 10:
          _context10.next = 12;
          return (0, _effects.put)(actEmployeeList.hideAssignOutletModal());

        case 12:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function checkAllOutlets(request) {
  var _request$payload2, fields, formName, fieldName, idx;

  return _regenerator2.default.wrap(function checkAllOutlets$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload2 = request.payload, fields = _request$payload2.fields, formName = _request$payload2.formName, fieldName = _request$payload2.fieldName;
          // A little hacky though
          // https://github.com/erikras/redux-form/issues/2058

          idx = 0;

        case 2:
          if (!(idx < fields.length)) {
            _context11.next = 9;
            break;
          }

          if (!fields[idx].show) {
            _context11.next = 6;
            break;
          }

          _context11.next = 6;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].checked', true));

        case 6:
          idx++;
          _context11.next = 2;
          break;

        case 9:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function uncheckAllOutlets(request) {
  var _request$payload3, fields, formName, fieldName, idx;

  return _regenerator2.default.wrap(function uncheckAllOutlets$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _request$payload3 = request.payload, fields = _request$payload3.fields, formName = _request$payload3.formName, fieldName = _request$payload3.fieldName;
          // https://github.com/erikras/redux-form/issues/2058

          idx = 0;

        case 2:
          if (!(idx < fields.length)) {
            _context12.next = 9;
            break;
          }

          if (!fields[idx].show) {
            _context12.next = 6;
            break;
          }

          _context12.next = 6;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].checked', false));

        case 6:
          idx++;
          _context12.next = 2;
          break;

        case 9:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function searchOutlet(action) {
  var _action$payload, outlets, formName, fieldName, keyword, idx, result;

  return _regenerator2.default.wrap(function searchOutlet$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _action$payload = action.payload, outlets = _action$payload.outlets, formName = _action$payload.formName, fieldName = _action$payload.fieldName, keyword = _action$payload.keyword;
          idx = 0;

        case 2:
          if (!(idx < outlets.length)) {
            _context13.next = 14;
            break;
          }

          result = outlets[idx].name.search(new RegExp(keyword, 'i'));

          if (!(result !== -1)) {
            _context13.next = 9;
            break;
          }

          _context13.next = 7;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].show', true));

        case 7:
          _context13.next = 11;
          break;

        case 9:
          _context13.next = 11;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName + '[' + idx + '].show', false));

        case 11:
          idx++;
          _context13.next = 2;
          break;

        case 14:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function submitForm(request) {
  var data;
  return _regenerator2.default.wrap(function submitForm$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          data = request.payload.data;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context14.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context14.next = 8;
          return (0, _effects.call)(apiEmployee.postEmployee, data);

        case 8:
          _context14.next = 10;
          return (0, _effects.call)(apiEmployee.resendInvitation, { pending_employee_email: data.email }, {});

        case 10:
          _context14.next = 12;
          return (0, _effects.put)(actNotif.success('Employee invitation sent.'));

        case 12:
          _context14.next = 14;
          return (0, _effects.put)(actEmployeeList.pageRequest());

        case 14:
          _context14.next = 20;
          break;

        case 16:
          _context14.prev = 16;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 20;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 20:
          _context14.prev = 20;
          _context14.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          _context14.next = 25;
          return (0, _effects.put)(act.sendingRequest(false));

        case 25:
          return _context14.finish(20);

        case 26:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[1, 16, 20, 26]]);
}

function generateRandomPassword() {
  var passwordLen = 6;
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  for (var i = 0; i < passwordLen; ++i) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

function cancelAction(cancelledTasks, request) {
  return _regenerator2.default.wrap(function cancelAction$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return _effects.cancel.apply(undefined, (0, _toConsumableArray3.default)(cancelledTasks));

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function saga() {
  var pageReqTask, resendInvitationTask, confirmDelEmployeeTask, searchOutletTask;
  return _regenerator2.default.wrap(function saga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_SUBMIT_FORM, submitForm);

        case 2:
          _context16.next = 4;
          return (0, _effects.takeLatest)(_constants.EMPLOYEE_LIST_PAGE_REQUEST, pageRequest);

        case 4:
          pageReqTask = _context16.sent;
          _context16.next = 7;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_RESEND_INVITATION, resendInvitation);

        case 7:
          resendInvitationTask = _context16.sent;
          _context16.next = 10;
          return (0, _effects.takeLatest)(_constants.EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE, cancelDeleteEmployee);

        case 10:
          _context16.next = 12;
          return (0, _effects.takeLatest)(_constants.EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE, askDeleteEmployee);

        case 12:
          _context16.next = 14;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE, confirmDeleteEmployee);

        case 14:
          confirmDelEmployeeTask = _context16.sent;
          _context16.next = 17;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_CHECK_ALL_OUTLETS, checkAllOutlets);

        case 17:
          _context16.next = 19;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS, uncheckAllOutlets);

        case 19:
          _context16.next = 21;
          return (0, _effects.takeLatest)(_constants.EMPLOYEE_LIST_SEARCH_OUTLET, searchOutlet);

        case 21:
          searchOutletTask = _context16.sent;
          _context16.next = 24;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_ASSIGN_OUTLETS, assignOutlets);

        case 24:
          _context16.next = 26;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS, confirmAssignOutlets);

        case 26:
          _context16.next = 28;
          return (0, _effects.takeEvery)(_constants.EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS, cancelAssignOutlets);

        case 28:
          _context16.next = 30;
          return (0, _effects.takeEvery)(_constants2.LOGOUT, cancelAction, [pageReqTask, resendInvitationTask, confirmDelEmployeeTask, searchOutletTask]);

        case 30:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillForm = fillForm;
exports.pageRequest = pageRequest;
exports.submitForm = submitForm;
exports.changePage = changePage;
exports.default = saga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(392);

var _reduxForm = __webpack_require__(7);

var _settings = __webpack_require__(290);

var apiSetting = _interopRequireWildcard(_settings);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _permission = __webpack_require__(610);

var actPermission = _interopRequireWildcard(_permission);

var _reactRouterRedux = __webpack_require__(49);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, pageRequest, submitForm, changePage, saga].map(_regenerator2.default.mark);

function fillForm(setting) {
  var form;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          form = {
            allowStaffRefund: setting.allow_staff_refund,
            authCode: setting.auth_code,
            staffDeleteBill: setting.staff_delete_bill,
            staffResendReceipt: setting.staff_resend_receipt
          };
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('permission', form));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function pageRequest() {
  var response;
  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (false) {
            _context2.next = 29;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_constants.EMPLOYEE_PERMISSION_PAGE_REQUEST);

        case 3:
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _effects.put)(act.sendingRequest(true));

        case 6:
          _context2.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context2.next = 10;
          return (0, _effects.call)(apiSetting.getSettings);

        case 10:
          response = _context2.sent;
          _context2.next = 13;
          return (0, _effects.put)(actPermission.setSetting(response.data[0]));

        case 13:
          _context2.next = 15;
          return (0, _effects.call)(fillForm, response.data[0]);

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 21;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 21:
          _context2.prev = 21;
          _context2.next = 24;
          return (0, _effects.put)(act.sendingRequest(false));

        case 24:
          _context2.next = 26;
          return (0, _effects.put)(act.hideProgressBar());

        case 26:
          return _context2.finish(21);

        case 27:
          _context2.next = 0;
          break;

        case 29:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[3, 17, 21, 27]]);
}

function submitForm() {
  var _ref, data, response;

  return _regenerator2.default.wrap(function submitForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (false) {
            _context3.next = 31;
            break;
          }

          _context3.next = 3;
          return (0, _effects.take)(_constants.EMPLOYEE_PERMISSION_SUBMIT_FORM);

        case 3:
          _ref = _context3.sent;
          data = _ref.payload.data;
          _context3.prev = 5;
          _context3.next = 8;
          return (0, _effects.put)(act.sendingRequest(true));

        case 8:
          _context3.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context3.next = 12;
          return (0, _effects.call)(apiSetting.putUpdateSetting, data);

        case 12:
          response = _context3.sent;
          _context3.next = 15;
          return (0, _effects.put)(actNotif.success(response.data.message));

        case 15:
          _context3.next = 17;
          return (0, _effects.call)(fillForm, response.data);

        case 17:
          _context3.next = 23;
          break;

        case 19:
          _context3.prev = 19;
          _context3.t0 = _context3['catch'](5);
          _context3.next = 23;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 23:
          _context3.prev = 23;
          _context3.next = 26;
          return (0, _effects.put)(act.sendingRequest(false));

        case 26:
          _context3.next = 28;
          return (0, _effects.put)(act.hideProgressBar());

        case 28:
          return _context3.finish(23);

        case 29:
          _context3.next = 0;
          break;

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[5, 19, 23, 29]]);
}

function changePage() {
  var _ref2, pathname;

  return _regenerator2.default.wrap(function changePage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (false) {
            _context4.next = 11;
            break;
          }

          _context4.next = 3;
          return (0, _effects.take)(_constants.EMPLOYEE_PERMISSION_CHANGE_PAGE);

        case 3:
          _ref2 = _context4.sent;
          pathname = _ref2.payload.pathname;
          _context4.next = 7;
          return (0, _effects.put)((0, _reduxForm.reset)('permission'));

        case 7:
          _context4.next = 9;
          return (0, _effects.put)((0, _reactRouterRedux.push)(pathname));

        case 9:
          _context4.next = 0;
          break;

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(pageRequest);

        case 2:
          _context5.next = 4;
          return (0, _effects.fork)(submitForm);

        case 4:
          _context5.next = 6;
          return (0, _effects.fork)(changePage);

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.default = saga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(1053);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _getFilteredDate = __webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, saga].map(_regenerator2.default.mark);

function pageRequest() {
  var _ref, data, form;

  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_getFilteredDate.getFilteredDate);

        case 2:
          _ref = _context.sent;
          data = _ref.data;
          form = {
            'date': {
              startDate: (0, _moment2.default)(data.start_date, 'YYYY-MM-DD'),
              endDate: (0, _moment2.default)(data.end_date, 'YYYY-MM-DD')
            }
          };
          _context.next = 7;
          return (0, _effects.put)((0, _reduxForm.initialize)('dropdownCalendar', form));

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST, pageRequest);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.forgotPasswordFlow = forgotPasswordFlow;
exports.default = saga;

var _effects = __webpack_require__(22);

var _notifications = __webpack_require__(23);

var actionNotification = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _users = __webpack_require__(1120);

var apiUsers = _interopRequireWildcard(_users);

var _constants = __webpack_require__(91);

var _reactRouter = __webpack_require__(15);

var _forgot = __webpack_require__(1204);

var mpForgotPass = _interopRequireWildcard(_forgot);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [forgotPasswordFlow, saga].map(_regenerator2.default.mark);

function forgotPasswordFlow(request) {
  var email;
  return _regenerator2.default.wrap(function forgotPasswordFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          email = request.payload.data.email;
          _context.prev = 5;
          _context.next = 8;
          return (0, _effects.call)(apiUsers.forgotPassword, { email: email });

        case 8:
          _context.next = 10;
          return (0, _effects.put)(action.changeFormForgot({ email: email }));

        case 10:
          _reactRouter.browserHistory.push('/success-forgot-password');
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context['catch'](5);
          _context.next = 17;
          return (0, _effects.put)(actionNotification.error(_context.t0.message));

        case 17:
          _context.prev = 17;
          _context.next = 20;
          return (0, _effects.put)(action.hideProgressBar());

        case 20:
          _context.next = 22;
          return (0, _effects.put)(action.sendingRequest(false));

        case 22:
          return _context.finish(17);

        case 23:
          mpForgotPass.forgotPasswordStart({
            email: email
          });

        case 24:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[5, 13, 17, 23]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_constants.FORGOT_PASSWORD, forgotPasswordFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeKeyword = onChangeKeyword;
exports.categoriesRequest = categoriesRequest;
exports.onClickCreateCategoryFlow = onClickCreateCategoryFlow;
exports.onClickCancel = onClickCancel;
exports.onClickRow = onClickRow;
exports.submitForm = submitForm;
exports.deleteCategory = deleteCategory;
exports.onClickAssignToIngredientFlow = onClickAssignToIngredientFlow;
exports.cancelAssignToIngredientFlow = cancelAssignToIngredientFlow;
exports.submitAssignToIngredientFlow = submitAssignToIngredientFlow;
exports.fillFormAssignToIngredientFlow = fillFormAssignToIngredientFlow;
exports.assignToIngredientGetIngredientsRequestFlow = assignToIngredientGetIngredientsRequestFlow;
exports.default = saga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(395);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _category = __webpack_require__(124);

var actIngCat = _interopRequireWildcard(_category);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _ingredients = __webpack_require__(205);

var apiIng = _interopRequireWildcard(_ingredients);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _reduxForm = __webpack_require__(7);

var _loadingSpinner = __webpack_require__(46);

var _ingredientCategories = __webpack_require__(1086);

var apiIngCat = _interopRequireWildcard(_ingredientCategories);

var _reduxSaga = __webpack_require__(68);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _categories = __webpack_require__(1206);

var mpIngCat = _interopRequireWildcard(_categories);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, onChangeOutletIds, onChangeKeyword, categoriesRequest, onClickCreateCategoryFlow, onClickCancel, onClickRow, submitForm, deleteCategory, onClickAssignToIngredientFlow, cancelAssignToIngredientFlow, submitAssignToIngredientFlow, fillFormAssignToIngredientFlow, assignToIngredientGetIngredientsRequestFlow, saga].map(_regenerator2.default.mark);

function pageRequest(request) {
  var response, resProfile;
  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context.next = 6;
          return (0, _effects.put)(actIngCat.setOutlets([]));

        case 6:
          _context.next = 8;
          return (0, _effects.put)(actIngCat.setCategories([]));

        case 8:
          _context.next = 10;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 10:
          _context.next = 12;
          return (0, _effects.put)(actIngCat.closeRightColumn());

        case 12:
          _context.prev = 12;
          _context.next = 15;
          return (0, _effects.call)(apiOutlets.outlets);

        case 15:
          response = _context.sent;
          _context.next = 18;
          return (0, _effects.put)(actIngCat.setOutlets(response.data));

        case 18:
          _context.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          resProfile = _context.sent;
          _context.next = 23;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: [resProfile.data.outlet_id[0]]
          }));

        case 23:
          _context.next = 25;
          return (0, _effects.put)(actIngCat.categoriesRequest({
            page: 1
          }, []));

        case 25:
          mpIngCat.ingredientCategoryStart({ outletIds: [resProfile.data.outlet_id[0]] });
          _context.next = 32;
          break;

        case 28:
          _context.prev = 28;
          _context.t0 = _context['catch'](12);
          _context.next = 32;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 32:
          _context.prev = 32;
          _context.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          return _context.finish(32);

        case 36:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[12, 28, 32, 36]]);
}

function onChangeOutletIds(request) {
  var outletIds;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          outletIds = request.payload.outletIds;

          mpIngCat.ingredientCategoryChangeOutlet({ outletIds: outletIds });
          _context2.next = 4;
          return (0, _effects.put)(actIngCat.closeRightColumn());

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _context2.next = 8;
          return (0, _effects.put)(actIngCat.setCategories([]));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 10:
          _context2.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context2.next = 14;
          return (0, _effects.put)((0, _reduxForm.reset)('ingCategory'));

        case 14:
          _context2.prev = 14;
          _context2.next = 17;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 17:
          _context2.next = 19;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: outletIds
          }));

        case 19:
          _context2.next = 25;
          break;

        case 21:
          _context2.prev = 21;
          _context2.t0 = _context2['catch'](14);
          _context2.next = 25;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 25:
          _context2.prev = 25;
          _context2.next = 28;
          return (0, _effects.put)(act.hideProgressBar());

        case 28:
          return _context2.finish(25);

        case 29:
          _context2.next = 31;
          return (0, _effects.put)(actIngCat.categoriesRequest({
            page: 1
          }, []));

        case 31:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[14, 21, 25, 29]]);
}

function onChangeKeyword(request) {
  var keyword;
  return _regenerator2.default.wrap(function onChangeKeyword$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 100);

        case 2:
          keyword = request.payload.keyword;
          _context3.next = 5;
          return (0, _effects.put)(actIngCat.setCategories([]));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(actIngCat.categoriesRequest({
            page: 1,
            keyword: keyword
          }, []));

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function categoriesRequest(request) {
  var _request$payload, query, previousCategories, response, categories;

  return _regenerator2.default.wrap(function categoriesRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _request$payload = request.payload, query = _request$payload.query, previousCategories = _request$payload.previousCategories;

          if (!(previousCategories.length === 0)) {
            _context4.next = 4;
            break;
          }

          _context4.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context4.prev = 6;
          _context4.next = 9;
          return (0, _effects.call)(apiIngCat.getCategories, query);

        case 9:
          response = _context4.sent;
          categories = previousCategories.concat(response.data.results);
          _context4.next = 13;
          return (0, _effects.put)(actIngCat.setCategories(categories));

        case 13:
          _context4.next = 15;
          return (0, _effects.put)(actIngCat.setCurrentPage(query.page));

        case 15:
          _context4.next = 17;
          return (0, _effects.put)(actIngCat.setTotalPage(response.data.meta.total_pages));

        case 17:
          _context4.next = 23;
          break;

        case 19:
          _context4.prev = 19;
          _context4.t0 = _context4['catch'](6);
          _context4.next = 23;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 23:
          _context4.prev = 23;
          _context4.next = 26;
          return (0, _effects.put)(act.hideProgressBar());

        case 26:
          _context4.next = 28;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 28:
          return _context4.finish(23);

        case 29:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[6, 19, 23, 29]]);
}

function onClickCreateCategoryFlow(request) {
  return _regenerator2.default.wrap(function onClickCreateCategoryFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(actIngCat.openRightColumn());

        case 4:
          _context5.next = 6;
          return (0, _effects.put)((0, _reduxForm.initialize)('ingCategory', {}));

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function onClickCancel() {
  return _regenerator2.default.wrap(function onClickCancel$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _reduxForm.reset)('ingCategory'));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(actIngCat.closeRightColumn());

        case 6:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function onClickRow(request) {
  var category;
  return _regenerator2.default.wrap(function onClickRow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          category = request.payload.category;
          // only fetch some data

          _context7.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('ingCategory', {
            id: category.id,
            name: category.name
          }));

        case 3:
          mpIngCat.ingredientCategorySelect({ category: category });
          _context7.next = 6;
          return (0, _effects.put)(actIngCat.setCategoryDetail(category));

        case 6:
          _context7.next = 8;
          return (0, _effects.put)(actIngCat.openRightColumn());

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function submitForm(request) {
  var _request$payload2, category, createAllOutlet, previousCategories, outletIds, categoryId, newCategory, newCategories, flag, res, outletId, _res, _res2;

  return _regenerator2.default.wrap(function submitForm$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload2 = request.payload, category = _request$payload2.category, createAllOutlet = _request$payload2.createAllOutlet, previousCategories = _request$payload2.previousCategories, outletIds = _request$payload2.outletIds;
          categoryId = category.ingredient_category.id;
          _context8.next = 4;
          return (0, _effects.put)(actIngCat.setIsSubmitting(true));

        case 4:
          _context8.prev = 4;
          newCategory = {};
          _context8.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          newCategories = [];

          if (categoryId) {
            _context8.next = 30;
            break;
          }

          // create category
          flag = false;

          if (!createAllOutlet) {
            _context8.next = 22;
            break;
          }

          _lodash2.default.forEach(previousCategories, function (prevCat) {
            if (category.ingredient_category.name === prevCat.name) flag = true;
          });
          _context8.next = 15;
          return (0, _effects.call)(apiIngCat.postCreateAllOutlet, category, {});

        case 15:
          res = _context8.sent;

          newCategories = res.data;
          outletId = outletIds[0];

          _lodash2.default.forEach(newCategories, function (cat) {
            if (cat.outlet_id === outletId) {
              newCategory = cat;
            }
          });
          mpIngCat.ingredientCategoryCreate({ category: category.ingredient_category, allOutlet: true });
          _context8.next = 27;
          break;

        case 22:
          _context8.next = 24;
          return (0, _effects.call)(apiIngCat.postCategory, category, {});

        case 24:
          _res = _context8.sent;

          newCategory = _res.data;
          mpIngCat.ingredientCategoryCreate({ category: category.ingredient_category, allOutlet: false });

        case 27:
          newCategories = flag ? [].concat((0, _toConsumableArray3.default)(previousCategories)) : [newCategory].concat((0, _toConsumableArray3.default)(previousCategories));
          _context8.next = 36;
          break;

        case 30:
          _context8.next = 32;
          return (0, _effects.call)(apiIngCat.putCategory, categoryId, category, {});

        case 32:
          _res2 = _context8.sent;

          newCategory = _res2.data;
          _lodash2.default.forEach(previousCategories, function (cat, idx) {
            if (newCategory.id === cat.id) {
              previousCategories[idx] = newCategory;
            }
          });
          newCategories = [].concat((0, _toConsumableArray3.default)(previousCategories));

        case 36:
          _context8.next = 38;
          return (0, _effects.put)(actIngCat.setCategoryDetail(newCategory));

        case 38:
          _context8.next = 40;
          return (0, _effects.put)(actIngCat.setCategories(newCategories));

        case 40:
          if (!categoryId) {
            _context8.next = 45;
            break;
          }

          _context8.next = 43;
          return (0, _effects.put)(actNotif.success('Ingredient Category was successfully updated.'));

        case 43:
          _context8.next = 47;
          break;

        case 45:
          _context8.next = 47;
          return (0, _effects.put)(actNotif.success('Ingredient Category successfully created.'));

        case 47:
          _context8.next = 49;
          return (0, _effects.put)((0, _reduxForm.initialize)('ingCategory', {
            id: newCategory.id,
            name: newCategory.name
          }));

        case 49:
          _context8.next = 55;
          break;

        case 51:
          _context8.prev = 51;
          _context8.t0 = _context8['catch'](4);
          _context8.next = 55;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 55:
          _context8.prev = 55;
          _context8.next = 58;
          return (0, _effects.put)(actIngCat.setIsSubmitting(false));

        case 58:
          _context8.next = 60;
          return (0, _effects.put)(act.hideProgressBar());

        case 60:
          return _context8.finish(55);

        case 61:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[4, 51, 55, 61]]);
}

function deleteCategory(request) {
  var _request$payload3, category, categories, newCategories;

  return _regenerator2.default.wrap(function deleteCategory$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload3 = request.payload, category = _request$payload3.category, categories = _request$payload3.categories;
          _context9.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          mpIngCat.ingredientCategoryDelete({ category: category });
          _context9.prev = 4;
          _context9.next = 7;
          return (0, _effects.call)(apiIngCat.deleteCategory, category.id, {});

        case 7:
          newCategories = [];

          categories.forEach(function (cat) {
            if (cat.id !== category.id) {
              newCategories.push(cat);
            }
          });
          _context9.next = 11;
          return (0, _effects.put)(actIngCat.setCategories(newCategories));

        case 11:
          _context9.next = 13;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 13:
          _context9.next = 15;
          return (0, _effects.put)(actIngCat.closeRightColumn());

        case 15:
          _context9.next = 17;
          return (0, _effects.put)(actIngCat.hideDeleteModal());

        case 17:
          _context9.next = 19;
          return (0, _effects.put)(actNotif.success('Category was successfully removed.'));

        case 19:
          _context9.next = 25;
          break;

        case 21:
          _context9.prev = 21;
          _context9.t0 = _context9['catch'](4);
          _context9.next = 25;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 25:
          _context9.prev = 25;
          _context9.next = 28;
          return (0, _effects.put)(act.hideProgressBar());

        case 28:
          return _context9.finish(25);

        case 29:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[4, 21, 25, 29]]);
}

function onClickAssignToIngredientFlow(request) {
  var category, resIngredients, ingredients;
  return _regenerator2.default.wrap(function onClickAssignToIngredientFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          category = request.payload.category;
          _context10.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context10.prev = 3;
          _context10.next = 6;
          return (0, _effects.put)(actIngCat.assignToIngredientSetCategory(category));

        case 6:
          _context10.next = 8;
          return (0, _effects.call)(apiIng.getIngredients, { page: 1, meta_ingredient_category_id: category.id });

        case 8:
          resIngredients = _context10.sent;
          ingredients = resIngredients.data;
          _context10.next = 12;
          return (0, _effects.put)(actIngCat.assignToIngredientFillForm(category, ingredients.meta.ingredient_ids));

        case 12:
          _context10.next = 14;
          return (0, _effects.put)(actIngCat.assignToIngredientSetCurrentPage(1));

        case 14:
          _context10.next = 16;
          return (0, _effects.put)(actIngCat.assignToIngredientSetTotalPage(ingredients.meta.total_pages));

        case 16:
          _context10.next = 18;
          return (0, _effects.put)(actIngCat.assignToIngredientSetIngredients(ingredients.results));

        case 18:
          _context10.next = 20;
          return (0, _effects.put)(actIngCat.showAssignToIngredientModal());

        case 20:
          _context10.next = 26;
          break;

        case 22:
          _context10.prev = 22;
          _context10.t0 = _context10['catch'](3);
          _context10.next = 26;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 26:
          _context10.prev = 26;
          _context10.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context10.finish(26);

        case 30:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[3, 22, 26, 30]]);
}

function cancelAssignToIngredientFlow(request) {
  return _regenerator2.default.wrap(function cancelAssignToIngredientFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)(actIngCat.hideAssignToIngredientModal());

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function submitAssignToIngredientFlow(request) {
  var _request$payload4, data, category, resCategories, categories;

  return _regenerator2.default.wrap(function submitAssignToIngredientFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _request$payload4 = request.payload, data = _request$payload4.data, category = _request$payload4.category;
          _context12.prev = 1;

          mpIngCat.ingredientCategoryAssign({ category: category, data: data });
          _context12.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context12.next = 7;
          return (0, _effects.put)(actIngCat.hideAssignToIngredientModal());

        case 7:
          _context12.next = 9;
          return (0, _effects.call)(apiIngCat.assignToIngredient, category.id, data);

        case 9:
          _context12.next = 11;
          return (0, _effects.put)(actIngCat.setCategoryDetail(null));

        case 11:
          _context12.next = 13;
          return (0, _effects.put)(actIngCat.closeRightColumn());

        case 13:
          _context12.next = 15;
          return (0, _effects.call)(apiIngCat.getCategories, { with_items: true, page: 1 });

        case 15:
          resCategories = _context12.sent;
          categories = resCategories.data.results;
          _context12.next = 19;
          return (0, _effects.put)(actIngCat.setCategories(categories));

        case 19:
          _context12.next = 21;
          return (0, _effects.put)(actIngCat.setTotalPage(resCategories.data.total_pages));

        case 21:
          _context12.next = 23;
          return (0, _effects.put)(actIngCat.setCurrentPage(1));

        case 23:
          _context12.next = 25;
          return (0, _effects.put)(actIngCat.assignToIngredientSetCategory(null));

        case 25:
          _context12.next = 27;
          return (0, _effects.put)(actNotif.success('Successfully move selected ingredients.'));

        case 27:
          _context12.next = 33;
          break;

        case 29:
          _context12.prev = 29;
          _context12.t0 = _context12['catch'](1);
          _context12.next = 33;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 33:
          _context12.prev = 33;
          _context12.next = 36;
          return (0, _effects.put)(act.hideProgressBar());

        case 36:
          return _context12.finish(33);

        case 37:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[1, 29, 33, 37]]);
}

function fillFormAssignToIngredientFlow(request) {
  var _request$payload5, category, ingredients, form;

  return _regenerator2.default.wrap(function fillFormAssignToIngredientFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload5 = request.payload, category = _request$payload5.category, ingredients = _request$payload5.ingredients;
          form = {
            id: category.id,
            ingredientIds: !ingredients ? [] : ingredients
          };
          _context13.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('assignToIngredient', form));

        case 4:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function assignToIngredientGetIngredientsRequestFlow(request) {
  var _request$payload6, params, previousIngredients, resIngredients, ingredients;

  return _regenerator2.default.wrap(function assignToIngredientGetIngredientsRequestFlow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _request$payload6 = request.payload, params = _request$payload6.params, previousIngredients = _request$payload6.previousIngredients;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context14.next = 6;
          return (0, _effects.call)(apiIng.getIngredients, params);

        case 6:
          resIngredients = _context14.sent;
          _context14.next = 9;
          return (0, _effects.put)(actIngCat.assignToIngredientSetCurrentPage(params.page));

        case 9:
          _context14.next = 11;
          return (0, _effects.put)(actIngCat.assignToIngredientSetTotalPage(resIngredients.data.meta.total_pages));

        case 11:
          ingredients = previousIngredients.concat(resIngredients.data.results);
          _context14.next = 14;
          return (0, _effects.put)(actIngCat.assignToIngredientSetIngredients(ingredients));

        case 14:
          _context14.next = 16;
          return (0, _effects.put)(actIngCat.showAssignToIngredientModal());

        case 16:
          _context14.next = 22;
          break;

        case 18:
          _context14.prev = 18;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 22;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 22:
          _context14.prev = 22;
          _context14.next = 25;
          return (0, _effects.put)(act.hideProgressBar());

        case 25:
          return _context14.finish(22);

        case 26:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[1, 18, 22, 26]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_PAGE_REQUEST, pageRequest);

        case 2:
          _context15.next = 4;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 4:
          _context15.next = 6;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD, onChangeKeyword);

        case 6:
          _context15.next = 8;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_CATEGORIES_REQUEST, categoriesRequest);

        case 8:
          _context15.next = 10;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY, onClickCreateCategoryFlow);

        case 10:
          _context15.next = 12;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CLICK_CANCEL, onClickCancel);

        case 12:
          _context15.next = 14;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CLICK_ROW, onClickRow);

        case 14:
          _context15.next = 16;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_SUBMIT_FORM, submitForm);

        case 16:
          _context15.next = 18;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_DELETE_CATEGORY, deleteCategory);

        case 18:
          _context15.next = 20;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT, onClickAssignToIngredientFlow);

        case 20:
          _context15.next = 22;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT, cancelAssignToIngredientFlow);

        case 22:
          _context15.next = 24;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT, submitAssignToIngredientFlow);

        case 24:
          _context15.next = 26;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM, fillFormAssignToIngredientFlow);

        case 26:
          _context15.next = 28;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST, assignToIngredientGetIngredientsRequestFlow);

        case 28:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getBillingsFlow = getBillingsFlow;
exports.pageRequestFlow = pageRequestFlow;
exports.getFeaturePricePerMonthsFlow = getFeaturePricePerMonthsFlow;
exports.getSubscriptionStatusFlow = getSubscriptionStatusFlow;
exports.getFeaturePriceFlow = getFeaturePriceFlow;
exports.endTutorialFlow = endTutorialFlow;
exports.getOutletsFlow = getOutletsFlow;
exports.verifyBillingFlow = verifyBillingFlow;
exports.startTrialFlow = startTrialFlow;
exports.default = saga;

var _effects = __webpack_require__(22);

var _actions = __webpack_require__(18);

var action = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _ingredientSubscription = __webpack_require__(614);

var _getFeaturePricePerMonths = __webpack_require__(1078);

var _getFeaturePrice = __webpack_require__(1077);

var _getSubscriptionStatus = __webpack_require__(289);

var _endTutorial = __webpack_require__(623);

var _startTrial = __webpack_require__(1079);

var _billing = __webpack_require__(428);

var apiBilling = _interopRequireWildcard(_billing);

var _constant = __webpack_require__(396);

var _billingNotification = __webpack_require__(381);

var _index = __webpack_require__(232);

var _is_js = __webpack_require__(372);

var is = _interopRequireWildcard(_is_js);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getBillingsFlow, pageRequestFlow, getFeaturePricePerMonthsFlow, getSubscriptionStatusFlow, getFeaturePriceFlow, endTutorialFlow, getOutletsFlow, verifyBillingFlow, startTrialFlow, saga].map(_regenerator2.default.mark); /**
                                                                                                                                                                                                                                           * Created by alvinoktavianus on 6/27/17.
                                                                                                                                                                                                                                           */

function getBillingsFlow() {
  var response, pendingPaymentMessage;
  return _regenerator2.default.wrap(function getBillingsFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(apiBilling.getBillings);

        case 7:
          response = _context.sent;
          pendingPaymentMessage = null;

          _lodash2.default.forEach(response.data, function (invoice) {
            if (invoice.status === 'pending') {
              if (invoice.payment_type === 'credit_card') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please wait 24 hours before making a new payment.';
              } else if (invoice.payment_type === 'bank_transfer' || invoice.payment_type === 'echannel') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please transfer full amount of the invoice within 3 days before making a new payment.';
              }
              return false;
            }
          });

          if (!(pendingPaymentMessage !== null)) {
            _context.next = 15;
            break;
          }

          _context.next = 13;
          return (0, _effects.put)((0, _ingredientSubscription.setPendingPaymentMessage)(pendingPaymentMessage));

        case 13:
          _context.next = 15;
          return (0, _effects.put)((0, _ingredientSubscription.disablePayButton)());

        case 15:
          _context.next = 19;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context['catch'](4);

        case 19:
          _context.prev = 19;
          _context.next = 22;
          return (0, _effects.put)(action.sendingRequest(false));

        case 22:
          _context.next = 24;
          return (0, _effects.put)(action.hideProgressBar());

        case 24:
          return _context.finish(19);

        case 25:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 17, 19, 25]]);
}

function pageRequestFlow(request) {
  var _request$payload, trialEndAt, outletSlot, billingNotification, alreadySubscribed;

  return _regenerator2.default.wrap(function pageRequestFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _request$payload = request.payload, trialEndAt = _request$payload.trialEndAt, outletSlot = _request$payload.outletSlot, billingNotification = _request$payload.billingNotification, alreadySubscribed = _request$payload.alreadySubscribed;
          _context2.next = 3;
          return (0, _effects.put)((0, _ingredientSubscription.featurePricePerMonths)());

        case 3:
          _context2.next = 5;
          return (0, _effects.put)((0, _ingredientSubscription.featurePrice)(trialEndAt, outletSlot, alreadySubscribed));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)((0, _ingredientSubscription.getBillings)());

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _ingredientSubscription.getOutlets)());

        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _billingNotification.showBillingNotification)(billingNotification));

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _ingredientSubscription.subscriptionStatus)());

        case 13:
          _context2.next = 15;
          return (0, _effects.put)((0, _index.setNotificationType)(null));

        case 15:
          _context2.next = 17;
          return (0, _effects.put)((0, _index.setNotificationMessage)(null));

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function getFeaturePricePerMonthsFlow() {
  var response;
  return _regenerator2.default.wrap(function getFeaturePricePerMonthsFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(_getFeaturePricePerMonths.getFeaturePricePerMonths, { feature_names: ['Ingredient Inventory'] });

        case 7:
          response = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)((0, _ingredientSubscription.setFeaturePricePerMonths)(response.data['Ingredient Inventory']));

        case 10:
          _context3.next = 14;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](4);

        case 14:
          _context3.prev = 14;
          _context3.next = 17;
          return (0, _effects.put)(action.sendingRequest(false));

        case 17:
          _context3.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          return _context3.finish(14);

        case 20:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[4, 12, 14, 20]]);
}

function getSubscriptionStatusFlow() {
  var response;
  return _regenerator2.default.wrap(function getSubscriptionStatusFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(_getSubscriptionStatus.getSubscriptionStatus, { feature_names: ['Ingredient Inventory'] });

        case 7:
          response = _context4.sent;
          _context4.next = 10;
          return (0, _effects.put)((0, _ingredientSubscription.setIsOnTutorial)(response.data[0].on_tutorial));

        case 10:
          _context4.next = 12;
          return (0, _effects.put)((0, _ingredientSubscription.setSubscriptionDetail)(response.data[0]));

        case 12:
          _context4.next = 16;
          break;

        case 14:
          _context4.prev = 14;
          _context4.t0 = _context4['catch'](4);

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(action.sendingRequest(false));

        case 19:
          _context4.next = 21;
          return (0, _effects.put)(action.hideProgressBar());

        case 21:
          return _context4.finish(16);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)((0, _ingredientSubscription.finishLoadingPage)());

        case 24:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[4, 14, 16, 22]]);
}

function getFeaturePriceFlow(request) {
  var response, _request$payload2, trialEndAt, outletSlot, alreadySubscribed, subscriptionPriceDetail, currentOutlet, today, trialEndDate, outletLeft;

  return _regenerator2.default.wrap(function getFeaturePriceFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context5.prev = 4;
          _context5.next = 7;
          return (0, _effects.call)(_getFeaturePrice.getFeaturePrice, { feature_name: 'Ingredient Inventory' });

        case 7:
          response = _context5.sent;
          _request$payload2 = request.payload, trialEndAt = _request$payload2.trialEndAt, outletSlot = _request$payload2.outletSlot, alreadySubscribed = _request$payload2.alreadySubscribed;
          subscriptionPriceDetail = {};
          currentOutlet = 0;
          today = new Date().getTime();
          trialEndDate = new Date((0, _moment2.default)(trialEndAt).format('YYYY-MM-DD')).getTime();


          _lodash2.default.map(response.data, function (value, key) {
            if (key !== 'final_price' && value.final_price !== 0) {
              currentOutlet++;
              subscriptionPriceDetail[key] = {};
              subscriptionPriceDetail[key]['start_date'] = today < trialEndDate ? new Date() : value.start_date;
              subscriptionPriceDetail[key]['final_price'] = value.final_price;
              subscriptionPriceDetail[key]['end_date'] = value.end_date;
            } else {
              subscriptionPriceDetail[key] = value;
            }
          });

          outletLeft = !alreadySubscribed ? 0 : outletSlot - currentOutlet;
          _context5.next = 17;
          return (0, _effects.put)((0, _ingredientSubscription.setCurrentOutletCount)(currentOutlet));

        case 17:
          if (!(outletLeft > 0)) {
            _context5.next = 22;
            break;
          }

          _context5.next = 20;
          return (0, _effects.put)((0, _ingredientSubscription.setPendingOutletMessage)('You still have slots for additional ' + outletLeft + ' ' + (outletLeft === 1 ? 'outlet' : 'outlets') + '. Please create the outlets before making a payment.'));

        case 20:
          _context5.next = 22;
          return (0, _effects.put)((0, _ingredientSubscription.disablePayButton)());

        case 22:
          _context5.next = 24;
          return (0, _effects.put)((0, _ingredientSubscription.setFeaturePrice)(subscriptionPriceDetail));

        case 24:
          _context5.next = 28;
          break;

        case 26:
          _context5.prev = 26;
          _context5.t0 = _context5['catch'](4);

        case 28:
          _context5.prev = 28;
          _context5.next = 31;
          return (0, _effects.put)(action.sendingRequest(false));

        case 31:
          _context5.next = 33;
          return (0, _effects.put)(action.hideProgressBar());

        case 33:
          return _context5.finish(28);

        case 34:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[4, 26, 28, 34]]);
}

function endTutorialFlow(request) {
  return _regenerator2.default.wrap(function endTutorialFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(_endTutorial.endTutorial, request.payload.featureName);

        case 7:
          window.location.reload();
          _context6.next = 14;
          break;

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6['catch'](4);
          _context6.next = 14;
          return (0, _effects.put)(actNotif.error('Please try again'));

        case 14:
          _context6.prev = 14;
          _context6.next = 17;
          return (0, _effects.put)(action.sendingRequest(false));

        case 17:
          _context6.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          return _context6.finish(14);

        case 20:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[4, 10, 14, 20]]);
}

function getOutletsFlow() {
  var response;
  return _regenerator2.default.wrap(function getOutletsFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context7.prev = 4;
          _context7.next = 7;
          return (0, _effects.call)(apiBilling.getAllOutlets);

        case 7:
          response = _context7.sent;
          _context7.next = 10;
          return (0, _effects.put)((0, _ingredientSubscription.setOutlets)(response.data));

        case 10:
          _context7.next = 14;
          break;

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7['catch'](4);

        case 14:
          _context7.prev = 14;
          _context7.next = 17;
          return (0, _effects.put)(action.sendingRequest(false));

        case 17:
          _context7.next = 19;
          return (0, _effects.put)(action.hideProgressBar());

        case 19:
          return _context7.finish(14);

        case 20:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[4, 12, 14, 20]]);
}

function verifyBillingFlow(request) {
  var response;
  return _regenerator2.default.wrap(function verifyBillingFlow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context8.next = 6;
          return (0, _effects.put)((0, _ingredientSubscription.disablePayButton)());

        case 6:
          response = {};
          _context8.prev = 7;
          _context8.next = 10;
          return (0, _effects.call)(apiBilling.verifyBilling, request.payload.billingData);

        case 10:
          response = _context8.sent;
          _context8.next = 24;
          break;

        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8['catch'](7);
          _context8.next = 17;
          return (0, _effects.put)((0, _ingredientSubscription.enablePayButton)());

        case 17:
          if (!(!_context8.t0.data || _context8.t0.data === ' ' || _context8.t0.status >= 500)) {
            _context8.next = 22;
            break;
          }

          _context8.next = 20;
          return (0, _effects.put)((0, _ingredientSubscription.showPaymentGatewayErrorModal)());

        case 20:
          _context8.next = 24;
          break;

        case 22:
          _context8.next = 24;
          return (0, _effects.put)(actNotif.error(_context8.t0.data.message));

        case 24:
          _context8.prev = 24;
          _context8.next = 27;
          return (0, _effects.put)(action.sendingRequest(false));

        case 27:
          _context8.next = 29;
          return (0, _effects.put)(action.hideProgressBar());

        case 29:
          if (!response.data) {
            _context8.next = 38;
            break;
          }

          _context8.next = 32;
          return (0, _effects.put)((0, _ingredientSubscription.setPayButtonMessage)('Redirecting to Veritrans'));

        case 32:
          if (!is.safari()) {
            _context8.next = 37;
            break;
          }

          _context8.next = 35;
          return (0, _effects.put)((0, _ingredientSubscription.enablePayButton)());

        case 35:
          _context8.next = 37;
          return (0, _effects.put)((0, _ingredientSubscription.setPayButtonMessage)('Pay'));

        case 37:
          window.location.href = response.data.data.redirect_url;

        case 38:
          return _context8.finish(24);

        case 39:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[7, 13, 24, 39]]);
}

function startTrialFlow() {
  return _regenerator2.default.wrap(function startTrialFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(action.sendingRequest(true));

        case 2:
          _context9.next = 4;
          return (0, _effects.put)(action.showProgressBar());

        case 4:
          _context9.prev = 4;
          _context9.next = 7;
          return (0, _effects.call)(_startTrial.startTrial, { feature_name: 'Ingredient Inventory' });

        case 7:
          _context9.next = 9;
          return (0, _effects.put)(actNotif.success('Ingredient Inventory feature is unlocked.'));

        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _ingredientSubscription.setIsOnTutorial)(true));

        case 11:
          _context9.next = 17;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9['catch'](4);
          _context9.next = 17;
          return (0, _effects.put)(actNotif.error('Please try again later.'));

        case 17:
          _context9.prev = 17;
          _context9.next = 20;
          return (0, _effects.put)(action.sendingRequest(false));

        case 20:
          _context9.next = 22;
          return (0, _effects.put)(action.hideProgressBar());

        case 22:
          return _context9.finish(17);

        case 23:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[4, 13, 17, 23]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_PAGE_REQUEST, pageRequestFlow);

        case 2:
          _context10.next = 4;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS, getFeaturePricePerMonthsFlow);

        case 4:
          _context10.next = 6;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_FEATURE_PRICE, getFeaturePriceFlow);

        case 6:
          _context10.next = 8;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_GET_BILLINGS, getBillingsFlow);

        case 8:
          _context10.next = 10;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS, getSubscriptionStatusFlow);

        case 10:
          _context10.next = 12;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_END_TUTORIAL, endTutorialFlow);

        case 12:
          _context10.next = 14;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_GET_OUTLETS, getOutletsFlow);

        case 14:
          _context10.next = 16;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_VERIFY_BILLING, verifyBillingFlow);

        case 16:
          _context10.next = 18;
          return (0, _effects.takeLatest)(_constant.INGREDIENT_SUBSCRIPTION_START_TRIAL, startTrialFlow);

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillFormDetail = fillFormDetail;
exports.fillFormLibraryInventory = fillFormLibraryInventory;
exports.fillFormCOGS = fillFormCOGS;
exports.fetchSummary = fetchSummary;
exports.onChangeOutletIds = onChangeOutletIds;
exports.pageRequestFlow = pageRequestFlow;
exports.getLibraries = getLibraries;
exports.librariesRequest = librariesRequest;
exports.getCategoriesWithUncategorizedFlow = getCategoriesWithUncategorizedFlow;
exports.getExportLibrary = getExportLibrary;
exports.downloadLibrariesTemplate = downloadLibrariesTemplate;
exports.clickCreateLibrary = clickCreateLibrary;
exports.clickCancel = clickCancel;
exports.clickLibraryRow = clickLibraryRow;
exports.formatLibrary = formatLibrary;
exports.onClickBtnLibraryTracking = onClickBtnLibraryTracking;
exports.onCancelLibraryInventoryAlertModal = onCancelLibraryInventoryAlertModal;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.onConfirmLibraryInventoryAlertModal = onConfirmLibraryInventoryAlertModal;
exports.deleteLibrary = deleteLibrary;
exports.onClickCreateCategory = onClickCreateCategory;
exports.onClickCancelCreateCategory = onClickCancelCreateCategory;
exports.onClickConfirmCreateCategory = onClickConfirmCreateCategory;
exports.setUncategorized = setUncategorized;
exports.onSuccessImport = onSuccessImport;
exports.onClickBtnTrackCOGS = onClickBtnTrackCOGS;
exports.onClickCancelCOGS = onClickCancelCOGS;
exports.onConfirmCOGS = onConfirmCOGS;
exports.default = librarySaga;

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _constants = __webpack_require__(397);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _library = __webpack_require__(93);

var actIngredientLibrary = _interopRequireWildcard(_library);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _library2 = __webpack_require__(1094);

var apiIngredientLibrary = _interopRequireWildcard(_library2);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _library3 = __webpack_require__(1207);

var mpIngCat = _interopRequireWildcard(_library3);

var _lodash = __webpack_require__(32);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, fillFormDetail, fillFormLibraryInventory, fillFormCOGS, fetchSummary, setFilterLibrary, fillSearch, onChangeOutletIds, pageRequestFlow, getLibraries, librariesRequest, getCategoriesWithUncategorizedFlow, getExportLibrary, downloadLibrariesTemplate, clickCreateLibrary, openRightColumn, closeRightColumn, clickCancel, clickLibraryRow, formatLibrary, onClickBtnLibraryTracking, onCancelLibraryInventoryAlertModal, submitFormCreate, submitFormUpdate, onConfirmLibraryInventoryAlertModal, deleteLibrary, onClickCreateCategory, onClickCancelCreateCategory, onClickConfirmCreateCategory, setUncategorized, onSuccessImport, onClickBtnTrackCOGS, onClickCancelCOGS, onConfirmCOGS, librarySaga].map(_regenerator2.default.mark);

/****************************************
 * API Request saga
 ****************************************/

function fillForm(library) {
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            categoryId: library.categoryId,
            typeInventoryId: library.typeInventoryId,
            search: library.search
          }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillFormDetail(request) {
  var formatFormDetail;
  return _regenerator2.default.wrap(function fillFormDetail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          formatFormDetail = request.payload.formatFormDetail;
          _context2.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('library', {
            id: formatFormDetail.id,
            name: formatFormDetail.name,
            unit_id: formatFormDetail.id,
            ingredient_category_id: formatFormDetail.ingredient_category_id,
            in_stock: formatFormDetail.in_stock,
            alert: formatFormDetail.alert,
            stock_alert: formatFormDetail.stock_alert,
            unit_cost: formatFormDetail.unit_cost,
            track_cogs: formatFormDetail.track_cogs,
            cogs: formatFormDetail.cogs,
            time_synchronized: formatFormDetail.time_synchronized,
            is_recipe: formatFormDetail.is_recipe,
            category_name: formatFormDetail.category_name,
            description: formatFormDetail.description,
            business_id: formatFormDetail.business_id,
            outlet_id: formatFormDetail.outlet_id
          }));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function fillFormLibraryInventory(library) {
  return _regenerator2.default.wrap(function fillFormLibraryInventory$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('libraryInventory', {
            in_stock: library.in_stock,
            alert: library.alert,
            stock_alert: library.stock_alert
          }));

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function fillFormCOGS(library) {
  return _regenerator2.default.wrap(function fillFormCOGS$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('libraryCOGS', {
            track_cogs: library.id ? library.track_cogs : true,
            cogs: library.cogs
          }));

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function fetchSummary(params) {
  var response;
  return _regenerator2.default.wrap(function fetchSummary$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context5.prev = 2;
          _context5.next = 5;
          return (0, _effects.call)(apiIngredientLibrary.getSummary, params);

        case 5:
          response = _context5.sent;
          return _context5.abrupt('return', response.data);

        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5['catch'](2);
          _context5.next = 13;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 13:
          return _context5.abrupt('return', false);

        case 14:
          _context5.prev = 14;
          _context5.next = 17;
          return (0, _effects.put)(act.hideProgressBar());

        case 17:
          return _context5.finish(14);

        case 18:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[2, 9, 14, 18]]);
}

function setFilterLibrary(request) {
  var _request$payload, categoryId, typeInventoryId, keyword, outletIds;

  return _regenerator2.default.wrap(function setFilterLibrary$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actIngredientLibrary.setLibraries([]));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload = request.payload, categoryId = _request$payload.categoryId, typeInventoryId = _request$payload.typeInventoryId, keyword = _request$payload.keyword, outletIds = _request$payload.outletIds;
          _context6.next = 7;
          return (0, _effects.put)(actIngredientLibrary.setFilterState(categoryId, typeInventoryId, keyword));

        case 7:
          _context6.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context6.prev = 9;
          _context6.next = 12;
          return (0, _effects.call)(librariesRequest, { page: 1, categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword });

        case 12:
          mpIngCat.ingredientLibraryChangeFilter({ outletIds: outletIds, categoryIds: categoryId, inventoryIds: typeInventoryId });
          _context6.next = 19;
          break;

        case 15:
          _context6.prev = 15;
          _context6.t0 = _context6['catch'](9);
          _context6.next = 19;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 19:
          _context6.prev = 19;
          _context6.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          _context6.next = 24;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 24:
          return _context6.finish(19);

        case 25:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[9, 15, 19, 25]]);
}

function fillSearch(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearch$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          assignedOutletIds = [];

          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context7.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function onChangeOutletIds(request) {
  var _request$payload2, outletIds, categoryId, typeInventoryId, resProfile;

  return _regenerator2.default.wrap(function onChangeOutletIds$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(actIngredientLibrary.setLibraries([]));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)(actIngredientLibrary.setLibrarySummary([]));

        case 4:
          _context8.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
          _context8.next = 8;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 8:
          _request$payload2 = request.payload, outletIds = _request$payload2.outletIds, categoryId = _request$payload2.categoryId, typeInventoryId = _request$payload2.typeInventoryId;
          _context8.prev = 9;
          _context8.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context8.next = 14;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 14:
          _context8.next = 16;
          return (0, _effects.call)(apiProfile.getProfile);

        case 16:
          resProfile = _context8.sent;
          _context8.next = 19;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 19:
          _context8.next = 21;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 21:
          _context8.next = 23;
          return (0, _effects.put)(actIngredientLibrary.unSetFilterState());

        case 23:
          _context8.next = 25;
          return (0, _effects.call)(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });

        case 25:
          _context8.next = 27;
          return (0, _effects.call)(fillSearch, resProfile.data);

        case 27:
          _context8.next = 29;
          return (0, _effects.put)(actIngredientLibrary.listCategoryWithUncategorizedRequest());

        case 29:
          _context8.next = 31;
          return (0, _effects.call)(librariesRequest, { page: 1, categoryId: 0, typeInventoryId: 0, keyword: '' });

        case 31:
          mpIngCat.ingredientLibraryChangeFilter({ outletIds: outletIds, categoryIds: categoryId, inventoryIds: typeInventoryId });
          _context8.next = 38;
          break;

        case 34:
          _context8.prev = 34;
          _context8.t0 = _context8['catch'](9);
          _context8.next = 38;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 38:
          _context8.prev = 38;
          _context8.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          _context8.next = 43;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 43:
          return _context8.finish(38);

        case 44:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[9, 34, 38, 44]]);
}

/**
 * Listen for page request of librarylibrary. This just works like wrapper
 */
function pageRequestFlow() {
  var response, resProfile;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context9.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context9.next = 6;
          return (0, _effects.put)(actIngredientLibrary.setLibraries([]));

        case 6:
          _context9.next = 8;
          return (0, _effects.put)(actIngredientLibrary.setLibrarySummary([]));

        case 8:
          _context9.next = 10;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(null));

        case 10:
          _context9.next = 12;
          return (0, _effects.put)(actIngredientLibrary.setOutlets([]));

        case 12:
          _context9.next = 14;
          return (0, _effects.put)(actIngredientLibrary.setUnits([]));

        case 14:
          _context9.next = 16;
          return (0, _effects.put)(actIngredientLibrary.showColInputInventory(false));

        case 16:
          _context9.next = 18;
          return (0, _effects.put)(actIngredientLibrary.showColInputCOGS(false));

        case 18:
          _context9.next = 20;
          return (0, _effects.put)((0, _reduxForm.reset)('library'));

        case 20:
          _context9.next = 22;
          return (0, _effects.call)(closeRightColumn);

        case 22:
          _context9.prev = 22;
          _context9.next = 25;
          return (0, _effects.call)(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });

        case 25:
          _context9.next = 27;
          return (0, _effects.call)(librariesRequest, { page: 1, categoryId: 0, typeInventoryId: 0, keyword: '' });

        case 27:
          _context9.next = 29;
          return (0, _effects.call)(apiOutlets.outlets);

        case 29:
          response = _context9.sent;
          _context9.next = 32;
          return (0, _effects.put)(actIngredientLibrary.setOutlets(response.data));

        case 32:
          _context9.next = 34;
          return (0, _effects.call)(apiProfile.getProfile);

        case 34:
          resProfile = _context9.sent;
          _context9.next = 37;
          return (0, _effects.call)(fillSearch, resProfile.data);

        case 37:
          _context9.next = 39;
          return (0, _effects.put)(actIngredientLibrary.listCategoryWithUncategorizedRequest());

        case 39:
          mpIngCat.ingredientLibraryStart({ outletIds: [resProfile.data.outlet_id[0]], categoryIds: 0, inventoryIds: 0, totalItems: 0 });
          _context9.next = 46;
          break;

        case 42:
          _context9.prev = 42;
          _context9.t0 = _context9['catch'](22);
          _context9.next = 46;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 46:
          _context9.prev = 46;
          _context9.next = 49;
          return (0, _effects.put)(act.hideProgressBar());

        case 49:
          return _context9.finish(46);

        case 50:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[22, 42, 46, 50]]);
}

function getLibraries(params) {
  var response;
  return _regenerator2.default.wrap(function getLibraries$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context10.prev = 2;
          _context10.next = 5;
          return (0, _effects.call)(apiIngredientLibrary.getLibraries, params);

        case 5:
          response = _context10.sent;
          return _context10.abrupt('return', response);

        case 9:
          _context10.prev = 9;
          _context10.t0 = _context10['catch'](2);
          _context10.next = 13;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 13:
          return _context10.abrupt('return', false);

        case 14:
          _context10.prev = 14;
          _context10.next = 17;
          return (0, _effects.put)(act.hideProgressBar());

        case 17:
          return _context10.finish(14);

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[2, 9, 14, 18]]);
}

function librariesRequest(request) {
  var categoryId, typeInventoryId, keyword, page, previousLibraries, libraries, requestPayload, filterState, query, response, librariesResponse, summary;
  return _regenerator2.default.wrap(function librariesRequest$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          categoryId = void 0, typeInventoryId = void 0, keyword = void 0, page = void 0, previousLibraries = void 0, libraries = void 0;

          if (request.payload) {
            requestPayload = request.payload.query;
            filterState = requestPayload.filterState;

            previousLibraries = request.payload.previousLibraries;
            categoryId = filterState.categoryId;
            typeInventoryId = filterState.typeInventoryId;
            keyword = filterState.keyword;
            page = requestPayload.page;
          } else {
            categoryId = request.categoryId;
            typeInventoryId = request.typeInventoryId;
            keyword = request.keyword;
            page = request.page;
          }
          query = {
            page: page,
            category_id: !parseInt(categoryId) ? '' : categoryId,
            inventory: !parseInt(typeInventoryId) ? 'all' : typeInventoryId === '1' ? 'low' : 'out',
            keyword: !keyword ? '' : keyword
          };
          _context11.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context11.prev = 5;
          _context11.next = 8;
          return (0, _effects.call)(getLibraries, query);

        case 8:
          response = _context11.sent;
          librariesResponse = response;

          if (previousLibraries) {
            libraries = previousLibraries.concat(librariesResponse);
          } else {
            libraries = librariesResponse;
          }
          _context11.next = 13;
          return (0, _effects.put)(actIngredientLibrary.setLibraries(libraries));

        case 13:
          if (!(page <= 1)) {
            _context11.next = 21;
            break;
          }

          _context11.next = 16;
          return (0, _effects.call)(fetchSummary, query);

        case 16:
          summary = _context11.sent;
          _context11.next = 19;
          return (0, _effects.put)(actIngredientLibrary.setLibrarySummary(summary.meta));

        case 19:
          _context11.next = 21;
          return (0, _effects.put)(actIngredientLibrary.setTotalPage(summary.meta.total_pages));

        case 21:
          _context11.next = 23;
          return (0, _effects.put)(actIngredientLibrary.setCurrentPage(page));

        case 23:
          _context11.next = 29;
          break;

        case 25:
          _context11.prev = 25;
          _context11.t0 = _context11['catch'](5);
          _context11.next = 29;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 29:
          _context11.prev = 29;
          _context11.next = 32;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 32:
          _context11.next = 34;
          return (0, _effects.put)(act.hideProgressBar());

        case 34:
          return _context11.finish(29);

        case 35:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[5, 25, 29, 35]]);
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
function getCategoriesWithUncategorizedFlow() {
  var categories;
  return _regenerator2.default.wrap(function getCategoriesWithUncategorizedFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.call)(apiIngredientLibrary.getCategoriesWithUncategorized);

        case 2:
          categories = _context12.sent;

          if (!categories) {
            _context12.next = 8;
            break;
          }

          _context12.next = 6;
          return (0, _effects.put)(actIngredientLibrary.setUncategorized(categories.data));

        case 6:
          _context12.next = 8;
          return (0, _effects.put)(actIngredientLibrary.setCategories(categories.data));

        case 8:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function getExportLibrary(request) {
  var _request$payload3, prefix, inventoryId, categoryId, keyword, params, response;

  return _regenerator2.default.wrap(function getExportLibrary$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload3 = request.payload, prefix = _request$payload3.prefix, inventoryId = _request$payload3.inventoryId, categoryId = _request$payload3.categoryId, keyword = _request$payload3.keyword;
          _context13.next = 3;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 3:
          _context13.prev = 3;
          params = { inventory: inventoryId };

          if (categoryId && categoryId !== '0') {
            params.category_id = categoryId;
          }
          if (keyword) {
            params.keyword = keyword;
          }
          _context13.next = 9;
          return (0, _effects.call)(apiIngredientLibrary.getExportLibrary, params);

        case 9:
          response = _context13.sent;

          if (!(response.statusText === 'OK')) {
            _context13.next = 15;
            break;
          }

          _context13.next = 13;
          return (0, _effects.put)(actGetExportedFile.getExportedWithoutOutlet(prefix));

        case 13:
          _context13.next = 17;
          break;

        case 15:
          _context13.next = 17;
          return (0, _effects.put)(actNotif.error(response.data.message));

        case 17:
          _context13.next = 23;
          break;

        case 19:
          _context13.prev = 19;
          _context13.t0 = _context13['catch'](3);
          _context13.next = 23;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 23:
          _context13.prev = 23;
          _context13.next = 26;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 26:
          return _context13.finish(23);

        case 27:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[3, 19, 23, 27]]);
}

function downloadLibrariesTemplate(request) {
  var prefix, response, responseData;
  return _regenerator2.default.wrap(function downloadLibrariesTemplate$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          prefix = request.payload.prefix;
          _context14.next = 3;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 3:
          _context14.prev = 3;
          _context14.next = 6;
          return (0, _effects.call)(apiIngredientLibrary.getLibraryTemplate);

        case 6:
          response = _context14.sent;
          responseData = response.data;

          if (!(responseData.message === 'ok')) {
            _context14.next = 13;
            break;
          }

          _context14.next = 11;
          return (0, _effects.put)(actGetExportedFile.getExportedWithoutOutlet(prefix));

        case 11:
          _context14.next = 15;
          break;

        case 13:
          _context14.next = 15;
          return (0, _effects.put)(actNotif.error(responseData.message));

        case 15:
          _context14.next = 21;
          break;

        case 17:
          _context14.prev = 17;
          _context14.t0 = _context14['catch'](3);
          _context14.next = 21;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 21:
          _context14.prev = 21;
          _context14.next = 24;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 24:
          return _context14.finish(21);

        case 25:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[3, 17, 21, 25]]);
}

function clickCreateLibrary(request) {
  var uncategorized, units;
  return _regenerator2.default.wrap(function clickCreateLibrary$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          uncategorized = request.payload.uncategorized;
          _context15.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context15.next = 5;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail({}));

        case 5:
          _context15.next = 7;
          return (0, _effects.call)(openRightColumn);

        case 7:
          _context15.next = 9;
          return (0, _effects.put)(actIngredientLibrary.showColInputCOGS(false));

        case 9:
          _context15.next = 11;
          return (0, _effects.put)(actIngredientLibrary.showColInputInventory(false));

        case 11:
          _context15.next = 13;
          return (0, _effects.put)((0, _reduxForm.initialize)('library', {
            id: null,
            name: null,
            unit_id: null,
            ingredient_category_id: uncategorized.id,
            in_stock: 0,
            alert: true,
            stock_alert: 0,
            image: {},
            track_cogs: false,
            cogs: null,
            unit_cost: 0,
            time_synchronized: null,
            is_recipe: false,
            category_name: null,
            description: null,
            business_id: null,
            outlet_id: null
          }));

        case 13:
          _context15.next = 15;
          return (0, _effects.put)((0, _reduxForm.reset)('libraryInventory'));

        case 15:
          _context15.t0 = _lodash.sortBy;
          _context15.next = 18;
          return (0, _effects.call)(apiIngredientLibrary.getUnits);

        case 18:
          _context15.t1 = _context15.sent;
          units = (0, _context15.t0)(_context15.t1, 'name');
          _context15.next = 22;
          return (0, _effects.put)(actIngredientLibrary.setUnits(units));

        case 22:
          _context15.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actIngredientLibrary.openRightColumn());

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.put)(actIngredientLibrary.closeRightColumn());

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function clickCancel() {
  return _regenerator2.default.wrap(function clickCancel$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)((0, _reduxForm.reset)('library'));

        case 2:
          _context18.next = 4;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(null));

        case 4:
          _context18.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function clickLibraryRow(request) {
  var library, units, libraryFormat;
  return _regenerator2.default.wrap(function clickLibraryRow$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          library = request.payload.library;
          _context19.prev = 1;
          _context19.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('library'));

        case 4:
          _context19.next = 6;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(null));

        case 6:
          _context19.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context19.next = 10;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(library));

        case 10:
          _context19.t0 = _lodash.sortBy;
          _context19.next = 13;
          return (0, _effects.call)(apiIngredientLibrary.getUnits);

        case 13:
          _context19.t1 = _context19.sent;
          units = (0, _context19.t0)(_context19.t1, 'name');
          _context19.next = 17;
          return (0, _effects.put)(actIngredientLibrary.setUnits(units));

        case 17:
          _context19.next = 19;
          return (0, _effects.call)(formatLibrary, library);

        case 19:
          libraryFormat = _context19.sent;
          _context19.next = 22;
          return (0, _effects.put)((0, _reduxForm.initialize)('library', (0, _extends3.default)({}, libraryFormat)));

        case 22:
          _context19.next = 24;
          return (0, _effects.call)(openRightColumn);

        case 24:
          if (!library.id) {
            _context19.next = 34;
            break;
          }

          _context19.next = 27;
          return (0, _effects.put)(actIngredientLibrary.showColInputInventory(true));

        case 27:
          if (!library.track_cogs) {
            _context19.next = 32;
            break;
          }

          _context19.next = 30;
          return (0, _effects.put)(actIngredientLibrary.showColInputCOGS(true));

        case 30:
          _context19.next = 34;
          break;

        case 32:
          _context19.next = 34;
          return (0, _effects.put)(actIngredientLibrary.showColInputCOGS(false));

        case 34:
          mpIngCat.ingredientLibrarySelect({ outletIds: library.outlet_id, name: library.name, category: library.category_name, unit: library.unit_name });
          _context19.next = 41;
          break;

        case 37:
          _context19.prev = 37;
          _context19.t2 = _context19['catch'](1);
          _context19.next = 41;
          return (0, _effects.put)(actNotif.error(_context19.t2.message));

        case 41:
          _context19.prev = 41;
          _context19.next = 44;
          return (0, _effects.put)(act.hideProgressBar());

        case 44:
          return _context19.finish(41);

        case 45:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this, [[1, 37, 41, 45]]);
}

function formatLibrary(library) {
  var libraryFormat;
  return _regenerator2.default.wrap(function formatLibrary$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          libraryFormat = {
            id: library.id,
            name: library.name,
            unit_id: library.unit_id,
            ingredient_category_id: library.ingredient_category_id,
            in_stock: library.in_stock,
            alert: library.alert,
            stock_alert: library.stock_alert,
            image: library.image,
            unit_cost: library.unit_cost,
            track_cogs: library.track_cogs,
            cogs: library.cogs,
            unit_name: library.unit_name,
            time_synchronized: library.time_synchronized,
            is_recipe: library.is_recipe,
            category_name: library.category_name,
            description: library.description,
            business_id: library.business_id,
            outlet_id: library.outlet_id
          };
          return _context20.abrupt('return', libraryFormat);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function onClickBtnLibraryTracking(request) {
  var previousLibraryForm;
  return _regenerator2.default.wrap(function onClickBtnLibraryTracking$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          previousLibraryForm = request.payload.previousLibraryForm;
          _context21.next = 3;
          return (0, _effects.put)(actIngredientLibrary.showLibraryInventoryAleryModal());

        case 3:
          _context21.next = 5;
          return (0, _effects.put)(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm));

        case 5:
          _context21.next = 7;
          return (0, _effects.call)(fillFormLibraryInventory, { in_stock: previousLibraryForm.in_stock, alert: previousLibraryForm.alert, stock_alert: previousLibraryForm.stock_alert });

        case 7:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function onCancelLibraryInventoryAlertModal() {
  return _regenerator2.default.wrap(function onCancelLibraryInventoryAlertModal$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.put)(actIngredientLibrary.hideLibraryInventoryAleryModal());

        case 2:
          _context22.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('libraryInventory'));

        case 4:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

function submitFormCreate(request) {
  var _request$payload4, values, libraries, allOutlet, outletId, summary, valueLibrary, postLibraryRes, updatedLibrary, createdLibraries, i, libraryFormat;

  return _regenerator2.default.wrap(function submitFormCreate$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _request$payload4 = request.payload, values = _request$payload4.values, libraries = _request$payload4.libraries, allOutlet = _request$payload4.allOutlet, outletId = _request$payload4.outletId, summary = _request$payload4.summary;
          _context23.prev = 1;
          valueLibrary = values.library;

          delete valueLibrary.ingredient.id;
          _context23.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context23.next = 8;
          return (0, _effects.put)(actIngredientLibrary.isSubmittingForm(true));

        case 8:
          postLibraryRes = void 0;
          updatedLibrary = void 0;

          if (!allOutlet) {
            _context23.next = 22;
            break;
          }

          _context23.next = 13;
          return (0, _effects.call)(apiIngredientLibrary.postCreateAllOutletLibrary, valueLibrary);

        case 13:
          postLibraryRes = _context23.sent;
          createdLibraries = postLibraryRes.data.ingredients;

          for (i = 0; i < createdLibraries.length; i++) {
            if (createdLibraries[i].outlet_id === outletId) {
              updatedLibrary = createdLibraries[i];
              libraries.unshift(createdLibraries[i]);
            }
          }

          _context23.next = 18;
          return (0, _effects.put)(actIngredientLibrary.setCreatedOutlets({
            outletsFailed: postLibraryRes.data.outlet_failed,
            outletsSuccess: postLibraryRes.data.outlet_success }));

        case 18:
          _context23.next = 20;
          return (0, _effects.put)(actIngredientLibrary.showSaveToAllOutletsModal());

        case 20:
          _context23.next = 27;
          break;

        case 22:
          _context23.next = 24;
          return (0, _effects.call)(apiIngredientLibrary.postLibrary, valueLibrary);

        case 24:
          postLibraryRes = _context23.sent;

          updatedLibrary = postLibraryRes.data;
          libraries.unshift(postLibraryRes.data);

        case 27:
          _context23.next = 29;
          return (0, _effects.call)(formatLibrary, updatedLibrary);

        case 29:
          libraryFormat = _context23.sent;
          _context23.next = 32;
          return (0, _effects.put)((0, _reduxForm.initialize)('library', (0, _extends3.default)({}, libraryFormat)));

        case 32:
          _context23.next = 34;
          return (0, _effects.put)(actIngredientLibrary.setLibraries(libraries));

        case 34:
          _context23.next = 36;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(libraryFormat));

        case 36:
          _context23.next = 38;
          return (0, _effects.put)(actIngredientLibrary.setLibrarySummary((0, _extends3.default)({}, summary, { total_count: summary.total_count + 1 })));

        case 38:
          _context23.next = 40;
          return (0, _effects.put)(actNotif.success('Ingredient successfully created.'));

        case 40:
          _context23.next = 42;
          return (0, _effects.put)(actIngredientLibrary.onClickRow(libraryFormat));

        case 42:
          mpIngCat.ingredientLibraryCreate({ allOutlet: allOutlet, ingredient: valueLibrary.ingredient });
          _context23.next = 49;
          break;

        case 45:
          _context23.prev = 45;
          _context23.t0 = _context23['catch'](1);
          _context23.next = 49;
          return (0, _effects.put)(actNotif.error(_context23.t0.message));

        case 49:
          _context23.prev = 49;
          _context23.next = 52;
          return (0, _effects.put)(actIngredientLibrary.isSubmittingForm(false));

        case 52:
          _context23.next = 54;
          return (0, _effects.put)(act.hideProgressBar());

        case 54:
          return _context23.finish(49);

        case 55:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this, [[1, 45, 49, 55]]);
}

function submitFormUpdate(request) {
  var _request$payload5, libraryId, values, libraries, updatedLibraryRes, libraryFormat;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _request$payload5 = request.payload, libraryId = _request$payload5.libraryId, values = _request$payload5.values, libraries = _request$payload5.libraries;
          _context24.prev = 1;
          _context24.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context24.next = 6;
          return (0, _effects.put)(actIngredientLibrary.isSubmittingForm(true));

        case 6:
          if (!values.library.ingredient.image.url) {
            _context24.next = 9;
            break;
          }

          _context24.next = 9;
          return (0, _effects.call)(apiIngredientLibrary.updateImageById, libraryId, {
            ingredient: {
              image: values.library.ingredient.image.url
            }
          });

        case 9:
          _context24.next = 11;
          return (0, _effects.call)(apiIngredientLibrary.putLibraryById, libraryId, values.library);

        case 11:
          _context24.next = 13;
          return (0, _effects.call)(apiIngredientLibrary.getLibraryById, libraryId);

        case 13:
          updatedLibraryRes = _context24.sent;

          libraries.forEach(function (library, index) {
            if (updatedLibraryRes.id === library.id) {
              libraries[index] = (0, _extends3.default)({}, updatedLibraryRes);
            }
          });
          _context24.next = 17;
          return (0, _effects.call)(formatLibrary, updatedLibraryRes);

        case 17:
          libraryFormat = _context24.sent;
          _context24.next = 20;
          return (0, _effects.put)((0, _reduxForm.initialize)('library', (0, _extends3.default)({}, libraryFormat)));

        case 20:
          _context24.next = 22;
          return (0, _effects.put)(actIngredientLibrary.setLibraries(libraries));

        case 22:
          _context24.next = 24;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(updatedLibraryRes));

        case 24:
          _context24.next = 26;
          return (0, _effects.put)(actNotif.success('Ingredient was successfully updated.'));

        case 26:
          _context24.next = 32;
          break;

        case 28:
          _context24.prev = 28;
          _context24.t0 = _context24['catch'](1);
          _context24.next = 32;
          return (0, _effects.put)(actNotif.error(_context24.t0.message));

        case 32:
          _context24.prev = 32;
          _context24.next = 35;
          return (0, _effects.put)(actIngredientLibrary.isSubmittingForm(false));

        case 35:
          _context24.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          return _context24.finish(32);

        case 38:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this, [[1, 28, 32, 38]]);
}

function onConfirmLibraryInventoryAlertModal(request) {
  var libraryInventoryForm;
  return _regenerator2.default.wrap(function onConfirmLibraryInventoryAlertModal$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          libraryInventoryForm = request.payload.libraryInventoryForm;
          _context25.next = 3;
          return (0, _effects.put)(actIngredientLibrary.showColInputInventory(true));

        case 3:
          _context25.next = 5;
          return (0, _effects.put)(actIngredientLibrary.hideLibraryInventoryAleryModal());

        case 5:
          _context25.next = 7;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'in_stock', libraryInventoryForm.in_stock));

        case 7:
          _context25.next = 9;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'alert', libraryInventoryForm.alert));

        case 9:
          _context25.next = 11;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'stock_alert', libraryInventoryForm.stock_alert));

        case 11:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this);
}

function deleteLibrary(request) {
  var _request$payload6, library, previousLibraries, summary, deletedIndex;

  return _regenerator2.default.wrap(function deleteLibrary$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _request$payload6 = request.payload, library = _request$payload6.library, previousLibraries = _request$payload6.previousLibraries, summary = _request$payload6.summary;
          _context26.prev = 1;
          _context26.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          // remove libraries
          deletedIndex = -1;

          previousLibraries.forEach(function (plibrary, index) {
            if (plibrary.id === library.id) {
              deletedIndex = index;
            }
          });
          if (deletedIndex !== -1) {
            previousLibraries.splice(deletedIndex, 1);
          }
          _context26.next = 9;
          return (0, _effects.call)(apiIngredientLibrary.deleteLibraryByIdV1, library.id);

        case 9:
          _context26.next = 11;
          return (0, _effects.call)(closeRightColumn);

        case 11:
          _context26.next = 13;
          return (0, _effects.put)(actIngredientLibrary.setLibraryDetail(null));

        case 13:
          _context26.next = 15;
          return (0, _effects.put)((0, _reduxForm.reset)('library'));

        case 15:
          _context26.next = 17;
          return (0, _effects.put)(actIngredientLibrary.hideDeleteModal());

        case 17:
          _context26.next = 19;
          return (0, _effects.put)(actIngredientLibrary.setLibrarySummary((0, _extends3.default)({}, summary, { total_count: summary.total_count - 1 })));

        case 19:
          _context26.next = 21;
          return (0, _effects.put)(actNotif.success('Ingredient was successfully removed.'));

        case 21:
          mpIngCat.ingredientLibraryDelete({ outletIds: library.outlet_id, name: library.name, category: library.category_name, unit: library.unit_name });
          _context26.next = 28;
          break;

        case 24:
          _context26.prev = 24;
          _context26.t0 = _context26['catch'](1);
          _context26.next = 28;
          return (0, _effects.put)(actNotif.error(_context26.t0.message));

        case 28:
          _context26.prev = 28;
          _context26.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context26.finish(28);

        case 32:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this, [[1, 24, 28, 32]]);
}

function onClickCreateCategory(request) {
  var _request$payload7, category, previousCategories, previousCategoryId, categories;

  return _regenerator2.default.wrap(function onClickCreateCategory$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _request$payload7 = request.payload, category = _request$payload7.category, previousCategories = _request$payload7.previousCategories, previousCategoryId = _request$payload7.previousCategoryId;
          _context27.next = 3;
          return (0, _effects.put)(actIngredientLibrary.setNewCategory(category));

        case 3:
          _context27.next = 5;
          return (0, _effects.put)(actIngredientLibrary.setPreviousCategories(previousCategories));

        case 5:
          // push new category since we want to 'manipulate' the view using redux,
          // using id == 0 as 'dummy id' for category
          categories = [].concat((0, _toConsumableArray3.default)(previousCategories));

          categories.push({
            id: 0,
            name: category
          });
          _context27.next = 9;
          return (0, _effects.put)(actIngredientLibrary.setCategories(categories));

        case 9:
          _context27.next = 11;
          return (0, _effects.put)(actIngredientLibrary.setPreviousCategoryId(previousCategoryId));

        case 11:
          _context27.next = 13;
          return (0, _effects.call)(_reduxSaga.delay, 50);

        case 13:
          _context27.next = 15;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'ingredient_category_id', 0));

        case 15:
          if (!category) {
            _context27.next = 18;
            break;
          }

          _context27.next = 18;
          return (0, _effects.put)(actIngredientLibrary.showNewCategoryModal());

        case 18:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked[26], this);
}

function onClickCancelCreateCategory(request) {
  var _request$payload8, previousCategories, previousCategoryId;

  return _regenerator2.default.wrap(function onClickCancelCreateCategory$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _request$payload8 = request.payload, previousCategories = _request$payload8.previousCategories, previousCategoryId = _request$payload8.previousCategoryId;
          _context28.next = 3;
          return (0, _effects.put)(actIngredientLibrary.setCategories(previousCategories));

        case 3:
          _context28.next = 5;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'ingredient_category_id', previousCategoryId));

        case 5:
          _context28.next = 7;
          return (0, _effects.put)(actIngredientLibrary.hideNewCategoryModal());

        case 7:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked[27], this);
}

function onClickConfirmCreateCategory(request) {
  var category, createCategoryRes;
  return _regenerator2.default.wrap(function onClickConfirmCreateCategory$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          category = request.payload.category;
          _context29.prev = 1;
          _context29.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context29.next = 6;
          return (0, _effects.call)(apiIngredientLibrary.createIngredientCategory, { name: category });

        case 6:
          createCategoryRes = _context29.sent;
          _context29.next = 9;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'ingredient_category_id', createCategoryRes.data.id));

        case 9:
          _context29.next = 11;
          return (0, _effects.put)(actIngredientLibrary.listCategoryWithUncategorizedRequest());

        case 11:
          _context29.next = 17;
          break;

        case 13:
          _context29.prev = 13;
          _context29.t0 = _context29['catch'](1);
          _context29.next = 17;
          return (0, _effects.put)(actNotif.error(_context29.t0.message));

        case 17:
          _context29.prev = 17;
          _context29.next = 20;
          return (0, _effects.put)(act.hideProgressBar());

        case 20:
          _context29.next = 22;
          return (0, _effects.put)(actIngredientLibrary.hideNewCategoryModal());

        case 22:
          return _context29.finish(17);

        case 23:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked[28], this, [[1, 13, 17, 23]]);
}

function setUncategorized(request) {
  var categories, uncategorized;
  return _regenerator2.default.wrap(function setUncategorized$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          categories = request.payload.categories;
          uncategorized = categories.find(function (category) {
            return category.name === 'Uncategorized';
          });
          _context30.next = 4;
          return (0, _effects.put)(actIngredientLibrary.storeUncategorized(uncategorized));

        case 4:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked[29], this);
}

function onSuccessImport() {
  return _regenerator2.default.wrap(function onSuccessImport$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return (0, _effects.put)(actIngredientLibrary.hideImportModal());

        case 2:
          _context31.next = 4;
          return (0, _effects.put)(actIngredientLibrary.closeRightColumn());

        case 4:
          _context31.next = 6;
          return (0, _effects.put)(actNotif.success('Ingredient successfully imported'));

        case 6:
          _context31.next = 8;
          return (0, _effects.put)(actIngredientLibrary.pageRequest());

        case 8:
        case 'end':
          return _context31.stop();
      }
    }
  }, _marked[30], this);
}

function onClickBtnTrackCOGS(request) {
  var previousLibraryForm;
  return _regenerator2.default.wrap(function onClickBtnTrackCOGS$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          previousLibraryForm = request.payload.previousLibraryForm;
          _context32.next = 3;
          return (0, _effects.put)(actIngredientLibrary.showTrackingCOGSModal());

        case 3:
          _context32.next = 5;
          return (0, _effects.put)(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm));

        case 5:
          _context32.next = 7;
          return (0, _effects.call)(fillFormCOGS, previousLibraryForm);

        case 7:
        case 'end':
          return _context32.stop();
      }
    }
  }, _marked[31], this);
}

function onClickCancelCOGS() {
  return _regenerator2.default.wrap(function onClickCancelCOGS$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return (0, _effects.put)(actIngredientLibrary.hideTrackingCOGSModal());

        case 2:
          _context33.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('libraryCOGS'));

        case 4:
        case 'end':
          return _context33.stop();
      }
    }
  }, _marked[32], this);
}

function onConfirmCOGS(request) {
  var _request$payload9, libraryCOGSForm, previousLibraryForm, showInputCOGS, show;

  return _regenerator2.default.wrap(function onConfirmCOGS$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          _request$payload9 = request.payload, libraryCOGSForm = _request$payload9.libraryCOGSForm, previousLibraryForm = _request$payload9.previousLibraryForm, showInputCOGS = _request$payload9.showInputCOGS;
          show = false;
          _context34.next = 4;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'track_cogs', libraryCOGSForm.track_cogs));

        case 4:
          _context34.next = 6;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'cogs', libraryCOGSForm.cogs));

        case 6:
          if (!previousLibraryForm.id) {
            _context34.next = 16;
            break;
          }

          if (!libraryCOGSForm.track_cogs) {
            _context34.next = 11;
            break;
          }

          show = true;
          _context34.next = 14;
          break;

        case 11:
          if (!(libraryCOGSForm.cogs && !previousLibraryForm.track_cogs)) {
            _context34.next = 14;
            break;
          }

          _context34.next = 14;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'cogs', null));

        case 14:
          _context34.next = 23;
          break;

        case 16:
          if (!libraryCOGSForm.track_cogs) {
            _context34.next = 20;
            break;
          }

          show = true;
          _context34.next = 23;
          break;

        case 20:
          if (!(libraryCOGSForm.cogs && !previousLibraryForm.track_cogs)) {
            _context34.next = 23;
            break;
          }

          _context34.next = 23;
          return (0, _effects.put)((0, _reduxForm.change)('library', 'cogs', null));

        case 23:
          _context34.next = 25;
          return (0, _effects.put)(actIngredientLibrary.showColInputCOGS(show));

        case 25:
          _context34.next = 27;
          return (0, _effects.put)(actIngredientLibrary.hideTrackingCOGSModal());

        case 27:
          mpIngCat.cogsTrackingIngredient({ ingredientList: previousLibraryForm, libraryCOGSForm: libraryCOGSForm, showInputCOGS: showInputCOGS });

        case 28:
        case 'end':
          return _context34.stop();
      }
    }
  }, _marked[33], this);
}

function librarySaga() {
  return _regenerator2.default.wrap(function librarySaga$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST, getCategoriesWithUncategorizedFlow);

        case 2:
          _context35.next = 4;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_SET_FILTER_ITEM, setFilterLibrary);

        case 4:
          _context35.next = 6;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_PAGE_REQUEST, pageRequestFlow);

        case 6:
          _context35.next = 8;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 8:
          _context35.next = 10;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_LIST_ITEM_REQUEST, librariesRequest);

        case 10:
          _context35.next = 12;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ITEM_LIST_EXPORT, getExportLibrary);

        case 12:
          _context35.next = 14;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE, downloadLibrariesTemplate);

        case 14:
          _context35.next = 16;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM, clickCreateLibrary);

        case 16:
          _context35.next = 18;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_CANCEL, clickCancel);

        case 18:
          _context35.next = 20;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_ROW, clickLibraryRow);

        case 20:
          _context35.next = 22;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING, onClickBtnLibraryTracking);

        case 22:
          _context35.next = 24;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, onCancelLibraryInventoryAlertModal);

        case 24:
          _context35.next = 26;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, onConfirmLibraryInventoryAlertModal);

        case 26:
          _context35.next = 28;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM, fillFormDetail);

        case 28:
          _context35.next = 30;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE, submitFormCreate);

        case 30:
          _context35.next = 32;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 32:
          _context35.next = 34;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_DELETE_ITEM, deleteLibrary);

        case 34:
          _context35.next = 36;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY, onClickCreateCategory);

        case 36:
          _context35.next = 38;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY, onClickConfirmCreateCategory);

        case 38:
          _context35.next = 40;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY, onClickCancelCreateCategory);

        case 40:
          _context35.next = 42;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_SET_UNCATEGORIZED, setUncategorized);

        case 42:
          _context35.next = 44;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT, onSuccessImport);

        case 44:
          _context35.next = 46;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS, onClickBtnTrackCOGS);

        case 46:
          _context35.next = 48;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL, onClickCancelCOGS);

        case 48:
          _context35.next = 50;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL, onConfirmCOGS);

        case 50:
        case 'end':
          return _context35.stop();
      }
    }
  }, _marked[34], this);
}

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

exports.pageRequest = pageRequest;
exports.recipesRequest = recipesRequest;
exports.recipesFormOnChangeOutlet = recipesFormOnChangeOutlet;
exports.recipesFormOnClickCancel = recipesFormOnClickCancel;
exports.onChangeOutletIdsFlow = onChangeOutletIdsFlow;
exports.exportRecipes = exportRecipes;
exports.onClickRow = onClickRow;
exports.onClickCreateRecipes = onClickCreateRecipes;
exports.onClickAddItems = onClickAddItems;
exports.addIngredientsGetItemsRequestFlow = addIngredientsGetItemsRequestFlow;
exports.createRecipes = createRecipes;
exports.addIngredientsOnSearchItems = addIngredientsOnSearchItems;
exports.addItemVariantOnChangeItems = addItemVariantOnChangeItems;
exports.onClickDone = onClickDone;
exports.confirmSubmit = confirmSubmit;
exports.addItemsOnSearchIngredientsModal = addItemsOnSearchIngredientsModal;
exports.addIngredientsOnCancelAddIngredients = addIngredientsOnCancelAddIngredients;
exports.addItemsOnChangeIngredientsModal = addItemsOnChangeIngredientsModal;
exports.addIngredientDetailRecipes = addIngredientDetailRecipes;
exports.deleteItem = deleteItem;
exports.onSaveRecipes = onSaveRecipes;
exports.onSaveRecipesAllOutlet = onSaveRecipesAllOutlet;
exports.onUpdateRecipes = onUpdateRecipes;
exports.onUpdateRecipesAllOutlet = onUpdateRecipesAllOutlet;
exports.setIngredientByVariantId = setIngredientByVariantId;
exports.unSetIngredientByItemVariant = unSetIngredientByItemVariant;
exports.default = saga;

var _constants = __webpack_require__(398);

var _recipes = __webpack_require__(125);

var actIngredientRecipes = _interopRequireWildcard(_recipes);

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _loadingSpinner = __webpack_require__(46);

var actLoadingSpinner = _interopRequireWildcard(_loadingSpinner);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _recipes2 = __webpack_require__(1096);

var apiIngredientRecipes = _interopRequireWildcard(_recipes2);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _reduxForm = __webpack_require__(7);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _recipes3 = __webpack_require__(1208);

var mpIngRecipe = _interopRequireWildcard(_recipes3);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, recipesRequest, recipesFormOnChangeOutlet, recipesFormOnClickCancel, onChangeOutletIdsFlow, exportRecipes, onClickRow, onClickCreateRecipes, onClickAddItems, addIngredientsGetItemsRequestFlow, createRecipes, addIngredientsOnSearchItems, addItemVariantOnChangeItems, onClickDone, confirmSubmit, setFilterRecipes, addItemsOnSearchIngredientsModal, addIngredientsOnCancelAddIngredients, addItemsOnChangeIngredientsModal, addIngredientDetailRecipes, deleteItem, onSaveRecipes, onSaveRecipesAllOutlet, onUpdateRecipes, onUpdateRecipesAllOutlet, setIngredientByVariantId, unSetIngredientByItemVariant, saga].map(_regenerator2.default.mark);

function pageRequest() {
  var response, responseItem, formatResponseItem, resProfile, params;
  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 4:
          _context.next = 6;
          return (0, _effects.put)(actIngredientRecipes.setOutlets([]));

        case 6:
          _context.next = 8;
          return (0, _effects.put)(actIngredientRecipes.unSetFilterState());

        case 8:
          _context.next = 10;
          return (0, _effects.put)(actIngredientRecipes.setRecipes([]));

        case 10:
          _context.next = 12;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 12:
          _context.next = 14;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 14:
          _context.next = 16;
          return (0, _effects.put)(act.showProgressBar());

        case 16:
          _context.prev = 16;
          _context.next = 19;
          return (0, _effects.call)(apiOutlets.outlets);

        case 19:
          response = _context.sent;
          _context.next = 22;
          return (0, _effects.put)(actIngredientRecipes.setOutlets(response.data));

        case 22:
          _context.next = 24;
          return (0, _effects.call)(apiIngredientRecipes.getItemDropdown);

        case 24:
          responseItem = _context.sent;
          formatResponseItem = [];

          responseItem.data.map(function (val) {
            formatResponseItem.push((0, _extends3.default)({ value: val.id, label: val.name }, val));
          });
          _context.next = 29;
          return (0, _effects.put)(actIngredientRecipes.setItemDropdown(formatResponseItem));

        case 29:
          _context.next = 31;
          return (0, _effects.call)(apiProfile.getProfile);

        case 31:
          resProfile = _context.sent;
          params = {
            page: 1,
            keyword: ''
          };
          _context.next = 35;
          return (0, _effects.put)(actIngredientRecipes.recipesRequest(params, []));

        case 35:
          _context.next = 37;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: [resProfile.data.outlet_id[0]]
          }));

        case 37:
          mpIngRecipe.ingredientRecipesStart({ outletIds: [resProfile.data.outlet_id[0]] });
          _context.next = 44;
          break;

        case 40:
          _context.prev = 40;
          _context.t0 = _context['catch'](16);
          _context.next = 44;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 44:
          _context.prev = 44;
          _context.next = 47;
          return (0, _effects.put)(act.hideProgressBar());

        case 47:
          return _context.finish(44);

        case 48:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[16, 40, 44, 48]]);
}

function recipesRequest(request) {
  var _request$payload, params, previousRecipes, resRecipes, resRecipesData, recipes;

  return _regenerator2.default.wrap(function recipesRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousRecipes = _request$payload.previousRecipes;
          _context2.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _effects.call)(apiIngredientRecipes.getRecipes, params);

        case 6:
          resRecipes = _context2.sent;
          resRecipesData = resRecipes.data;
          recipes = previousRecipes.concat(resRecipesData.results);
          _context2.next = 11;
          return (0, _effects.put)(actIngredientRecipes.setTotalPage(resRecipesData.meta.total_pages));

        case 11:
          _context2.next = 13;
          return (0, _effects.put)(actIngredientRecipes.setRecipes(recipes));

        case 13:
          _context2.next = 15;
          return (0, _effects.put)(actIngredientRecipes.setCurrentPage(params.page));

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 21;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 21:
          _context2.prev = 21;
          _context2.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
          _context2.next = 26;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(false));

        case 26:
          return _context2.finish(21);

        case 27:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[3, 17, 21, 27]]);
}

function recipesFormOnChangeOutlet() {
  return _regenerator2.default.wrap(function recipesFormOnChangeOutlet$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _reduxForm.change)('recipes', 'recipes', []));

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function recipesFormOnClickCancel() {
  return _regenerator2.default.wrap(function recipesFormOnClickCancel$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function onChangeOutletIdsFlow(request) {
  var outletIds;
  return _regenerator2.default.wrap(function onChangeOutletIdsFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          outletIds = request.payload.outletIds;

          mpIngRecipe.ingredientRecipesChangeFilter({ outletIds: outletIds });
          _context5.next = 4;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 6:
          _context5.next = 8;
          return (0, _effects.put)(actIngredientRecipes.setRecipes([]));

        case 8:
          _context5.next = 10;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 10:
          _context5.next = 12;
          return (0, _effects.put)(actIngredientRecipes.unSetFilterState());

        case 12:
          _context5.next = 14;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 14:
          _context5.next = 16;
          return (0, _effects.put)(act.showProgressBar());

        case 16:
          _context5.prev = 16;
          _context5.next = 19;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 19:
          _context5.next = 21;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: outletIds
          }));

        case 21:
          _context5.next = 23;
          return (0, _effects.put)(actIngredientRecipes.pageRequest());

        case 23:
          _context5.next = 29;
          break;

        case 25:
          _context5.prev = 25;
          _context5.t0 = _context5['catch'](16);
          _context5.next = 29;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 29:
          _context5.prev = 29;
          _context5.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context5.finish(29);

        case 33:
          _context5.next = 35;
          return (0, _effects.put)(actIngredientRecipes.recipesRequest({
            page: 1
          }, []));

        case 35:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[16, 25, 29, 33]]);
}

function exportRecipes(request) {
  var _request$payload2, filename, outletId, params, response;

  return _regenerator2.default.wrap(function exportRecipes$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _request$payload2 = request.payload, filename = _request$payload2.filename, outletId = _request$payload2.outletId, params = _request$payload2.params;
          _context6.prev = 1;
          _context6.next = 4;
          return (0, _effects.call)(apiIngredientRecipes.getExportRecipes, params);

        case 4:
          response = _context6.sent;

          if (!(response.statusText === 'OK')) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Recipes'));

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _effects.put)(actNotif.error(response.data.message));

        case 12:
          _context6.next = 18;
          break;

        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6['catch'](1);
          _context6.next = 18;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 18:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[1, 14]]);
}

function onClickRow(request) {
  var recipes, recipe_ingredients, formatIngredientRecipes;
  return _regenerator2.default.wrap(function onClickRow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          recipes = request.payload.recipes;

          mpIngRecipe.ingredientRecipesSelect({ recipe: recipes });
          recipe_ingredients = recipes.recipe_ingredients;
          formatIngredientRecipes = [];

          recipe_ingredients.map(function (recipeIngredient) {
            formatIngredientRecipes.push((0, _extends3.default)({}, recipeIngredient, {
              ingredient_avg: recipeIngredient.track_cogs ? recipeIngredient.cogs * recipeIngredient.quantity : null
            }));
          });
          _context7.next = 7;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(recipes));

        case 7:
          _context7.next = 9;
          return (0, _effects.put)(actIngredientRecipes.openRightColumn());

        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: recipes.id,
            item_id: recipes.item_id,
            item_name: recipes.item_name,
            item_variant_name: recipes.item_variant_name || 'No Variant',
            item_variant_id: recipes.item_variant_id,
            recipe_ingredients: formatIngredientRecipes,
            ingredientsInventory: formatIngredientRecipes,
            sku: recipes.sku
          }));

        case 11:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function onClickCreateRecipes(request) {
  return _regenerator2.default.wrap(function onClickCreateRecipes$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('addIngredients'));

        case 4:
          _context8.next = 6;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: null,
            item_id: null,
            item_name: null,
            item_variant_id: null,
            item_variant_name: null,
            recipe_ingredients: [],
            ingredientsInventory: []
          }));

        case 6:
          _context8.next = 8;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 8:
          _context8.next = 10;
          return (0, _effects.put)(actIngredientRecipes.setItemVariant([{ value: 'Variant Option', name: 'Variant Option', is_recipe: false, isDisable: false }]));

        case 10:
          _context8.next = 12;
          return (0, _effects.put)(actIngredientRecipes.openRightColumn());

        case 12:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function onClickAddItems(request) {
  return _regenerator2.default.wrap(function onClickAddItems$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsGetingredientRequest({
            page: 1,
            per_page: 100,
            keyword: ''
          }));

        case 2:
          _context9.next = 4;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 4:
          _context9.next = 6;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());

        case 6:
          _context9.next = 8;
          return (0, _effects.put)(actIngredientRecipes.showAddItemsModal());

        case 8:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function addIngredientsGetItemsRequestFlow(request) {
  var _request$payload$para, previousItems, restParams, resItems, items;

  return _regenerator2.default.wrap(function addIngredientsGetItemsRequestFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload$para = request.payload.params, previousItems = _request$payload$para.previousItems, restParams = (0, _objectWithoutProperties3.default)(_request$payload$para, ['previousItems']);

          if (!restParams.keyword) {
            _context10.next = 4;
            break;
          }

          _context10.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 4:
          _context10.prev = 4;
          _context10.next = 7;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsShowLoading());

        case 7:
          _context10.next = 9;
          return (0, _effects.call)(apiIngredientRecipes.getItemIngredient, restParams);

        case 9:
          resItems = _context10.sent;
          items = {
            results: resItems.data.results,
            total_pages: 9999,
            total_counts: 0
          };

          if (restParams.page > 1) {
            if (items.results.length === 0) {
              items.total_pages = restParams.page - 1;
              items.currentPage = restParams.page - 1;
            } else {
              items.currentPage = restParams.page;
            }
            items.results = previousItems.concat(items.results);
          } else {
            items.currentPage = 1;
          }
          _context10.next = 14;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetItems(items));

        case 14:
          _context10.next = 20;
          break;

        case 16:
          _context10.prev = 16;
          _context10.t0 = _context10['catch'](4);
          _context10.next = 20;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 20:
          _context10.prev = 20;
          _context10.next = 23;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsHideLoading());

        case 23:
          return _context10.finish(20);

        case 24:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[4, 16, 20, 24]]);
}

function createRecipes() {
  return _regenerator2.default.wrap(function createRecipes$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function addIngredientsOnSearchItems(request) {
  var _request$payload3, keyword, outletId;

  return _regenerator2.default.wrap(function addIngredientsOnSearchItems$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 100);

        case 2:
          _request$payload3 = request.payload, keyword = _request$payload3.keyword, outletId = _request$payload3.outletId;
          _context12.next = 5;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsGetingredientRequest({
            outlet_id: outletId,
            page: 1,
            per_page: 100,
            keyword: keyword
          }));

        case 5:
          _context12.next = 7;
          return (0, _effects.put)((0, _reduxForm.initialize)('addIngredients', {}));

        case 7:
          _context12.next = 9;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 9:
          _context12.next = 11;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());

        case 11:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function addItemVariantOnChangeItems(request) {
  var selectedItem, response, formatResponseData, responseItemVariant;
  return _regenerator2.default.wrap(function addItemVariantOnChangeItems$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          selectedItem = request.payload.selectedItem;
          _context13.next = 3;
          return (0, _effects.call)(apiIngredientRecipes.getItemVariant, selectedItem.value);

        case 3:
          response = _context13.sent;
          formatResponseData = [];
          responseItemVariant = response.data;

          if (!responseItemVariant.length) {
            _context13.next = 17;
            break;
          }

          if (!(responseItemVariant.length === 1 && !responseItemVariant[0].name)) {
            _context13.next = 13;
            break;
          }

          formatResponseData.push({ name: 'No Variant', value: responseItemVariant[0].id, isDisable: true, is_recipe: responseItemVariant[0].is_recipe, sku: responseItemVariant[0].sku });
          _context13.next = 11;
          return (0, _effects.put)((0, _reduxForm.change)('recipes', 'sku', responseItemVariant[0].sku));

        case 11:
          _context13.next = 15;
          break;

        case 13:
          formatResponseData.push({ name: 'Variant Option', value: 'Variant Option', isDisable: false });
          responseItemVariant.map(function (item) {
            formatResponseData.push({ name: item.name, value: item.id, isDisable: item.is_recipe, is_recipe: item.is_recipe, sku: item.sku });
          });

        case 15:
          _context13.next = 18;
          break;

        case 17:
          formatResponseData.push({ name: 'Variant Option', value: 'Variant Option', isDisable: true });

        case 18:
          _context13.next = 20;
          return (0, _effects.put)((0, _reduxForm.change)('recipes', 'item_variant_id', null));

        case 20:
          _context13.next = 22;
          return (0, _effects.put)(actIngredientRecipes.setItemVariant(formatResponseData));

        case 22:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function onClickDone(request) {
  return _regenerator2.default.wrap(function onClickDone$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 2:
          _context14.next = 4;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 4:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function confirmSubmit(request) {
  var values, formData, recipes;
  return _regenerator2.default.wrap(function confirmSubmit$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          values = request.payload.values;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context15.next = 6;
          return (0, _effects.put)(actIngredientRecipes.hideConfirmSubmitModal());

        case 6:
          formData = { recipes: { note: values.note, outlet_id: values.outlet_id } };
          recipes = values.recipes;

          formData.recipes.history_details = [];
          recipes.forEach(function (a) {
            if (Math.abs(parseFloat(a.quantity) - parseFloat(a.beginning_stock)) > 0.0000001) {
              formData.recipes.history_details.push((0, _extends3.default)({}, a, {
                end_stock: a.quantity - a.beginning_stock,
                recipes: a.quantity - a.beginning_stock
              }));
            }
          });
          _context15.next = 12;
          return (0, _effects.call)(apiIngredientRecipes.postRecipes, formData);

        case 12:
          _context15.next = 14;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 14:
          _context15.next = 16;
          return (0, _effects.put)(actIngredientRecipes.pageRequest());

        case 16:
          _context15.next = 18;
          return (0, _effects.put)(actNotif.success('Recipes has been created'));

        case 18:
          _context15.next = 24;
          break;

        case 20:
          _context15.prev = 20;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 24;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 24:
          _context15.prev = 24;
          _context15.next = 27;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 27:
          _context15.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context15.finish(24);

        case 30:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 20, 24, 30]]);
}

function setFilterRecipes(request) {
  var keyword, params;
  return _regenerator2.default.wrap(function setFilterRecipes$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 2:
          _context16.next = 4;
          return (0, _effects.put)(actIngredientRecipes.setRecipes([]));

        case 4:
          keyword = request.payload.keyword;
          _context16.next = 7;
          return (0, _effects.put)(actIngredientRecipes.setFilterState(keyword));

        case 7:
          _context16.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context16.prev = 9;
          params = {
            page: 1,
            keyword: keyword
          };
          _context16.next = 13;
          return (0, _effects.put)(actIngredientRecipes.recipesRequest(params, []));

        case 13:
          _context16.next = 19;
          break;

        case 15:
          _context16.prev = 15;
          _context16.t0 = _context16['catch'](9);
          _context16.next = 19;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 19:
          _context16.prev = 19;
          _context16.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          return _context16.finish(19);

        case 23:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[9, 15, 19, 23]]);
}

function addItemsOnSearchIngredientsModal(request) {
  var keyword;
  return _regenerator2.default.wrap(function addItemsOnSearchIngredientsModal$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetItems([]));

        case 2:
          _context17.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 100);

        case 4:
          keyword = request.payload.keyword;
          _context17.next = 7;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsGetIngredientsRequestModal({
            page: 1,
            per_page: 100,
            keyword: keyword
          }));

        case 7:
          _context17.next = 9;
          return (0, _effects.put)((0, _reduxForm.initialize)('addIngredients', {}));

        case 9:
          _context17.next = 11;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 11:
          _context17.next = 13;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetKeyword(keyword));

        case 13:
          _context17.next = 15;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());

        case 15:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function addIngredientsOnCancelAddIngredients(request) {
  return _regenerator2.default.wrap(function addIngredientsOnCancelAddIngredients$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('addIngredients', {
            ingredients: []
          }));

        case 2:
          _context18.next = 4;
          return (0, _effects.put)(actIngredientRecipes.hideAddIngredientsModal());

        case 4:
          _context18.next = 6;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function addItemsOnChangeIngredientsModal(request) {
  var _request$payload4, ingredient, recipesForm, recipeIngredients, formatQuantity, formatAvgCost;

  return _regenerator2.default.wrap(function addItemsOnChangeIngredientsModal$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _request$payload4 = request.payload, ingredient = _request$payload4.ingredient, recipesForm = _request$payload4.recipesForm;
          recipeIngredients = recipesForm.recipe_ingredients;
          formatQuantity = null;
          formatAvgCost = null;
          _context19.next = 6;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 6:
          _context19.next = 8;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(ingredient));

        case 8:
          _context19.next = 10;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'ingredient_id', ingredient.id));

        case 10:
          _context19.next = 12;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'ingredient_name', ingredient.name));

        case 12:
          _context19.next = 14;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'unit_id', ingredient.unit_id));

        case 14:
          _context19.next = 16;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'unit_name', ingredient.unit_name));

        case 16:
          _context19.next = 18;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'cogs', ingredient.cogs));

        case 18:
          _context19.next = 20;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'track_cogs', ingredient.track_cogs));

        case 20:

          if (recipeIngredients) {
            recipeIngredients.map(function (ingredientRecipe) {
              if (ingredientRecipe.ingredient_id === ingredient.id) {
                formatQuantity = ingredientRecipe.quantity;
                formatAvgCost = ingredientRecipe.ingredient_avg;
              }
            });
          }

          _context19.next = 23;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'ingredient_avg', formatAvgCost));

        case 23:
          _context19.next = 25;
          return (0, _effects.put)((0, _reduxForm.change)('addIngredients', 'quantity', formatQuantity));

        case 25:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function addIngredientDetailRecipes(request) {
  var _request$payload5, values, recipesForm, recipeIngredients, copyValues, replace, newIngredientsRecipes, i;

  return _regenerator2.default.wrap(function addIngredientDetailRecipes$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _request$payload5 = request.payload, values = _request$payload5.values, recipesForm = _request$payload5.recipesForm;
          recipeIngredients = recipesForm.recipe_ingredients;
          copyValues = [values];
          replace = false;

          if (!recipeIngredients) {
            _context20.next = 23;
            break;
          }

          recipeIngredients.map(function (ingredient) {
            if (ingredient.ingredient_id === values.ingredient_id) {
              replace = true;
            }
          });

          if (!replace) {
            _context20.next = 19;
            break;
          }

          newIngredientsRecipes = recipeIngredients.map(function (obj) {
            return copyValues.find(function (o) {
              return o.ingredient_id === obj.ingredient_id;
            }) || obj;
          });
          _context20.next = 10;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('recipes', 'recipe_ingredients'));

        case 10:
          i = 0;

        case 11:
          if (!(i < newIngredientsRecipes.length)) {
            _context20.next = 17;
            break;
          }

          _context20.next = 14;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('recipes', 'recipe_ingredients', newIngredientsRecipes[i]));

        case 14:
          i++;
          _context20.next = 11;
          break;

        case 17:
          _context20.next = 21;
          break;

        case 19:
          _context20.next = 21;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('recipes', 'recipe_ingredients', values));

        case 21:
          _context20.next = 25;
          break;

        case 23:
          _context20.next = 25;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('recipes', 'recipe_ingredients', values));

        case 25:
          _context20.next = 27;
          return (0, _effects.put)(actIngredientRecipes.hideAddIngredientsModal());

        case 27:
          _context20.next = 29;
          return (0, _effects.put)(actIngredientRecipes.addIngredientsSetIngredient(null));

        case 29:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function deleteItem(request) {
  var _request$payload6, recipe, previousRecipes, deletedIndex;

  return _regenerator2.default.wrap(function deleteItem$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _request$payload6 = request.payload, recipe = _request$payload6.recipe, previousRecipes = _request$payload6.previousRecipes;
          _context21.prev = 1;

          mpIngRecipe.ingredientRecipesDelete({ recipe: recipe });
          _context21.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          // remove items
          deletedIndex = -1;

          previousRecipes.forEach(function (pRecipes, index) {
            if (pRecipes.id === recipe.id) {
              deletedIndex = index;
            }
          });
          if (deletedIndex !== -1) {
            previousRecipes.splice(deletedIndex, 1);
          }
          _context21.next = 10;
          return (0, _effects.call)(apiIngredientRecipes.deleteRecipesById, recipe.id);

        case 10:
          _context21.next = 12;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 12:
          _context21.next = 14;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(null));

        case 14:
          _context21.next = 16;
          return (0, _effects.put)(actIngredientRecipes.hideDeleteModal());

        case 16:
          _context21.next = 18;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 18:
          _context21.next = 20;
          return (0, _effects.put)(actNotif.success('Recipes was successfully removed.'));

        case 20:
          _context21.next = 26;
          break;

        case 22:
          _context21.prev = 22;
          _context21.t0 = _context21['catch'](1);
          _context21.next = 26;
          return (0, _effects.put)(actNotif.error(_context21.t0.message));

        case 26:
          _context21.prev = 26;
          _context21.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context21.finish(26);

        case 30:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this, [[1, 22, 26, 30]]);
}

function onSaveRecipes(request) {
  var _request$payload7, recipe, previousRecipes, responseCreateRecipes, updatedRecipes, newIngredientsInventory;

  return _regenerator2.default.wrap(function onSaveRecipes$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _request$payload7 = request.payload, recipe = _request$payload7.recipe, previousRecipes = _request$payload7.previousRecipes;
          _context22.prev = 1;
          _context22.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context22.next = 6;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(true));

        case 6:
          mpIngRecipe.ingredientRecipesCreate({ recipe: recipe, allOutlet: false });
          _context22.next = 9;
          return (0, _effects.call)(apiIngredientRecipes.createRecipes, recipe);

        case 9:
          responseCreateRecipes = _context22.sent;
          updatedRecipes = responseCreateRecipes.data;

          previousRecipes.unshift(updatedRecipes);
          _context22.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', recipe));

        case 14:
          _context22.next = 16;
          return (0, _effects.put)(actIngredientRecipes.setRecipes(previousRecipes));

        case 16:
          _context22.next = 18;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 18:
          newIngredientsInventory = [].concat((0, _toConsumableArray3.default)(recipe.recipe_ingredients));

          _.forEach(newIngredientsInventory, function (val) {
            _.forEach(updatedRecipes.recipe_ingredients, function (val2) {
              if (val2.ingredient_id === val.ingredient_id) {
                val['in_stock'] = val2.in_stock;
              }
            });
          });
          _context22.next = 22;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: responseCreateRecipes.data.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: newIngredientsInventory,
            ingredientsInventory: newIngredientsInventory
          }));

        case 22:
          _context22.next = 24;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(responseCreateRecipes.data));

        case 24:
          _context22.next = 26;
          return (0, _effects.put)(actNotif.success('Recipes was successfully saved.'));

        case 26:
          _context22.next = 32;
          break;

        case 28:
          _context22.prev = 28;
          _context22.t0 = _context22['catch'](1);
          _context22.next = 32;
          return (0, _effects.put)(actNotif.error(_context22.t0.message));

        case 32:
          _context22.prev = 32;
          _context22.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          _context22.next = 37;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(false));

        case 37:
          return _context22.finish(32);

        case 38:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this, [[1, 28, 32, 38]]);
}

function onSaveRecipesAllOutlet(request) {
  var _request$payload8, recipe, previousRecipes, responseCreateRecipes, responseData, newRecipes, newIngredientsInventory;

  return _regenerator2.default.wrap(function onSaveRecipesAllOutlet$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _request$payload8 = request.payload, recipe = _request$payload8.recipe, previousRecipes = _request$payload8.previousRecipes;
          _context23.prev = 1;
          _context23.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context23.next = 6;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(true));

        case 6:
          mpIngRecipe.ingredientRecipesCreate({ recipe: recipe, allOutlet: true });
          _context23.next = 9;
          return (0, _effects.call)(apiIngredientRecipes.createRecipesAllOutlet, recipe);

        case 9:
          responseCreateRecipes = _context23.sent;
          responseData = responseCreateRecipes.data;
          newRecipes = responseData.current_recipe;

          if (!(responseData.outlet_success && responseData.outlet_success.length > 0)) {
            _context23.next = 35;
            break;
          }

          _context23.next = 15;
          return (0, _effects.put)(actIngredientRecipes.setCreatedOutlets({
            outletsFailed: responseData.outlet_failed,
            outletsSuccess: responseData.outlet_success
          }));

        case 15:
          _context23.next = 17;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 17:
          if (!newRecipes) {
            _context23.next = 29;
            break;
          }

          newIngredientsInventory = [].concat((0, _toConsumableArray3.default)(recipe.recipe_ingredients));

          _.forEach(newIngredientsInventory, function (val) {
            _.forEach(newRecipes.recipe_ingredients, function (val2) {
              if (val2.ingredient_id === val.ingredient_id) {
                val['in_stock'] = val2.in_stock;
              }
            });
          });
          previousRecipes.unshift(newRecipes);
          _context23.next = 23;
          return (0, _effects.put)(actIngredientRecipes.setRecipes(previousRecipes));

        case 23:
          _context23.next = 25;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: newRecipes.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: newIngredientsInventory,
            ingredientsInventory: newIngredientsInventory
          }));

        case 25:
          _context23.next = 27;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(newRecipes));

        case 27:
          _context23.next = 31;
          break;

        case 29:
          _context23.next = 31;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 31:
          _context23.next = 33;
          return (0, _effects.put)(actIngredientRecipes.showSaveToAllOutletsModal());

        case 33:
          _context23.next = 37;
          break;

        case 35:
          _context23.next = 37;
          return (0, _effects.put)(actNotif.error('Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).'));

        case 37:
          _context23.next = 43;
          break;

        case 39:
          _context23.prev = 39;
          _context23.t0 = _context23['catch'](1);
          _context23.next = 43;
          return (0, _effects.put)(actNotif.error(_context23.t0.message));

        case 43:
          _context23.prev = 43;
          _context23.next = 46;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(false));

        case 46:
          _context23.next = 48;
          return (0, _effects.put)(act.hideProgressBar());

        case 48:
          return _context23.finish(43);

        case 49:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this, [[1, 39, 43, 49]]);
}

function onUpdateRecipes(request) {
  var _request$payload9, recipe, previousRecipes, responseUpdateRecipes, newRecipes;

  return _regenerator2.default.wrap(function onUpdateRecipes$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _request$payload9 = request.payload, recipe = _request$payload9.recipe, previousRecipes = _request$payload9.previousRecipes;
          _context24.prev = 1;
          _context24.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context24.next = 6;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(true));

        case 6:
          _context24.next = 8;
          return (0, _effects.call)(apiIngredientRecipes.updateRecipes, recipe.id, recipe);

        case 8:
          responseUpdateRecipes = _context24.sent;
          newRecipes = responseUpdateRecipes.data;

          previousRecipes.forEach(function (previousRecipe, index) {
            if (newRecipes.id === previousRecipe.id) {
              previousRecipes[index] = (0, _extends3.default)({}, newRecipes);
            }
          });
          _context24.next = 13;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', recipe));

        case 13:
          _context24.next = 15;
          return (0, _effects.put)(actIngredientRecipes.setRecipes(previousRecipes));

        case 15:
          _context24.next = 17;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 17:
          _context24.next = 19;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: newRecipes.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: recipe.recipe_ingredients,
            ingredientsInventory: recipe.recipe_ingredients
          }));

        case 19:
          _context24.next = 21;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(newRecipes));

        case 21:
          _context24.next = 23;
          return (0, _effects.put)(actNotif.success('Recipes was successfully updated.'));

        case 23:
          _context24.next = 25;
          return (0, _effects.put)(actIngredientRecipes.onClickRow(newRecipes));

        case 25:
          mpIngRecipe.ingredientRecipesUpdate({ recipe: recipe });
          _context24.next = 32;
          break;

        case 28:
          _context24.prev = 28;
          _context24.t0 = _context24['catch'](1);
          _context24.next = 32;
          return (0, _effects.put)(actNotif.error(_context24.t0.message));

        case 32:
          _context24.prev = 32;
          _context24.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          _context24.next = 37;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(false));

        case 37:
          return _context24.finish(32);

        case 38:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this, [[1, 28, 32, 38]]);
}

function onUpdateRecipesAllOutlet(request) {
  var _request$payload10, recipe, previousRecipes, responseUpdateRecipes, responseData, updatedRecipes;

  return _regenerator2.default.wrap(function onUpdateRecipesAllOutlet$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _request$payload10 = request.payload, recipe = _request$payload10.recipe, previousRecipes = _request$payload10.previousRecipes;
          _context25.prev = 1;
          _context25.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context25.next = 6;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(true));

        case 6:
          _context25.next = 8;
          return (0, _effects.call)(apiIngredientRecipes.updateRecipesAllOutlet, recipe.id, recipe);

        case 8:
          responseUpdateRecipes = _context25.sent;
          responseData = responseUpdateRecipes.data;

          if (!(responseData.outlet_success && responseData.outlet_success.length > 0)) {
            _context25.next = 32;
            break;
          }

          _context25.next = 13;
          return (0, _effects.put)(actIngredientRecipes.setCreatedOutlets({
            outletsFailed: responseData.outlet_failed,
            outletsSuccess: responseData.outlet_success
          }));

        case 13:
          _context25.next = 15;
          return (0, _effects.put)((0, _reduxForm.reset)('recipes'));

        case 15:
          _context25.next = 17;
          return (0, _effects.put)(actIngredientRecipes.showSaveToAllOutletsModal());

        case 17:
          updatedRecipes = responseData.current_recipe;

          if (!updatedRecipes) {
            _context25.next = 28;
            break;
          }

          previousRecipes.forEach(function (previousRecipe, index) {
            if (updatedRecipes.id === previousRecipe.id) {
              previousRecipes[index] = (0, _extends3.default)({}, updatedRecipes);
            }
          });
          _context25.next = 22;
          return (0, _effects.put)(actIngredientRecipes.setRecipes(previousRecipes));

        case 22:
          _context25.next = 24;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            id: updatedRecipes.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: recipe.recipe_ingredients,
            ingredientsInventory: recipe.recipe_ingredients
          }));

        case 24:
          _context25.next = 26;
          return (0, _effects.put)(actIngredientRecipes.setRecipesDetail(updatedRecipes));

        case 26:
          _context25.next = 30;
          break;

        case 28:
          _context25.next = 30;
          return (0, _effects.put)(actIngredientRecipes.closeRightColumn());

        case 30:
          _context25.next = 34;
          break;

        case 32:
          _context25.next = 34;
          return (0, _effects.put)(actNotif.error('Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).'));

        case 34:
          _context25.next = 40;
          break;

        case 36:
          _context25.prev = 36;
          _context25.t0 = _context25['catch'](1);
          _context25.next = 40;
          return (0, _effects.put)(actNotif.error(_context25.t0.message));

        case 40:
          _context25.prev = 40;
          _context25.next = 43;
          return (0, _effects.put)(act.hideProgressBar());

        case 43:
          _context25.next = 45;
          return (0, _effects.put)(actIngredientRecipes.isSubmittingForm(false));

        case 45:
          return _context25.finish(40);

        case 46:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this, [[1, 36, 40, 46]]);
}

function setIngredientByVariantId(request) {
  var _request$payload11, itemVariant, recipesForm, selectedVariant, response, recipe, recipeIngredient, formatIngredientRecipes;

  return _regenerator2.default.wrap(function setIngredientByVariantId$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _request$payload11 = request.payload, itemVariant = _request$payload11.itemVariant, recipesForm = _request$payload11.recipesForm, selectedVariant = _request$payload11.selectedVariant;
          _context26.prev = 1;
          _context26.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context26.next = 6;
          return (0, _effects.call)(apiIngredientRecipes.getRecipesByVariantId, itemVariant.value);

        case 6:
          response = _context26.sent;
          recipe = response.data;
          recipeIngredient = recipe.recipe_ingredients;
          formatIngredientRecipes = [];

          recipeIngredient.map(function (ing) {
            formatIngredientRecipes.push({
              ingredient_id: ing.ingredient_id,
              ingredient_name: ing.ingredient_name,
              quantity: ing.quantity,
              unit_name: ing.unit_name,
              ingredient_avg: ing.track_cogs ? ing.cogs * ing.quantity : null,
              in_stock: ing.in_stock,
              cogs: ing.cogs,
              track_cogs: ing.track_cogs,
              recipe_id: ing.recipe_id,
              unit_id: ing.unit_id
            });
          });
          _context26.next = 13;
          return (0, _effects.put)((0, _reduxForm.initialize)('recipes', {
            item_id: recipesForm.item_id,
            item_name: recipesForm.item_name,
            item_variant_id: selectedVariant,
            item_variant_name: recipesForm.item_variant_name,
            recipe_ingredients: formatIngredientRecipes
          }));

        case 13:
          _context26.next = 19;
          break;

        case 15:
          _context26.prev = 15;
          _context26.t0 = _context26['catch'](1);
          _context26.next = 19;
          return (0, _effects.put)(actNotif.error(_context26.t0.message));

        case 19:
          _context26.prev = 19;
          _context26.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          return _context26.finish(19);

        case 23:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this, [[1, 15, 19, 23]]);
}

function unSetIngredientByItemVariant() {
  return _regenerator2.default.wrap(function unSetIngredientByItemVariant$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context27.next = 4;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('recipes', 'recipe_ingredients'));

        case 4:
          _context27.next = 6;
          return (0, _effects.put)(act.hideProgressBar());

        case 6:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked[26], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_PAGE_REQUEST, pageRequest);

        case 2:
          _context28.next = 4;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_RECIPES_REQUEST, recipesRequest);

        case 4:
          _context28.next = 6;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_SET_FILTER_ITEM, setFilterRecipes);

        case 6:
          _context28.next = 8;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow);

        case 8:
          _context28.next = 10;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_EXPORT_RECIPES, exportRecipes);

        case 10:
          _context28.next = 12;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ON_CLICK_ROW, onClickRow);

        case 12:
          _context28.next = 14;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES, onClickCreateRecipes);

        case 14:
          _context28.next = 16;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS, onClickAddItems);

        case 16:
          _context28.next = 18;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_SUBMIT_FORM_CREATE, createRecipes);

        case 18:
          _context28.next = 20;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ON_CLICK_DONE, onClickDone);

        case 20:
          _context28.next = 22;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET, recipesFormOnChangeOutlet);

        case 22:
          _context28.next = 24;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL, recipesFormOnClickCancel);

        case 24:
          _context28.next = 26;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_CONFIRM_SUBMIT, confirmSubmit);

        case 26:
          _context28.next = 28;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST, addIngredientsGetItemsRequestFlow);

        case 28:
          _context28.next = 30;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS, addIngredientsOnSearchItems);

        case 30:
          _context28.next = 32;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS, addItemVariantOnChangeItems);

        case 32:
          _context28.next = 34;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS, addItemsOnChangeIngredientsModal);

        case 34:
          _context28.next = 36;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS, addItemsOnSearchIngredientsModal);

        case 36:
          _context28.next = 38;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS, addIngredientsOnCancelAddIngredients);

        case 38:
          _context28.next = 40;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT, confirmSubmit);

        case 40:
          _context28.next = 42;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST, addIngredientsGetItemsRequestFlow);

        case 42:
          _context28.next = 44;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS, addItemsOnChangeIngredientsModal);

        case 44:
          _context28.next = 46;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES, addIngredientDetailRecipes);

        case 46:
          _context28.next = 48;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_DELETE_ITEM, deleteItem);

        case 48:
          _context28.next = 50;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_SAVE_RECIPES, onSaveRecipes);

        case 50:
          _context28.next = 52;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET, onSaveRecipesAllOutlet);

        case 52:
          _context28.next = 54;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_UPDATE_RECIPES, onUpdateRecipes);

        case 54:
          _context28.next = 56;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET, onUpdateRecipesAllOutlet);

        case 56:
          _context28.next = 58;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID, setIngredientByVariantId);

        case 58:
          _context28.next = 60;
          return (0, _effects.takeLatest)(_constants.INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID, unSetIngredientByItemVariant);

        case 60:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked[27], this);
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.adjustmentsRequest = adjustmentsRequest;
exports.ingredientAdjustmentRequest = ingredientAdjustmentRequest;
exports.adjustmentFormOnChangeOutlet = adjustmentFormOnChangeOutlet;
exports.adjustmentFormOnClickCancel = adjustmentFormOnClickCancel;
exports.onChangeOutletIdsFlow = onChangeOutletIdsFlow;
exports.onChangeDate = onChangeDate;
exports.exportAdjustment = exportAdjustment;
exports.exportIngredientAdjustment = exportIngredientAdjustment;
exports.onClickRow = onClickRow;
exports.onClickRowIngredientAdjustment = onClickRowIngredientAdjustment;
exports.onClickCreateAdjustment = onClickCreateAdjustment;
exports.onClickAddItems = onClickAddItems;
exports.addItemsCancelAddItems = addItemsCancelAddItems;
exports.addItemsGetItemsRequestFlow = addItemsGetItemsRequestFlow;
exports.addItemsGetIngredientsRequestFlow = addItemsGetIngredientsRequestFlow;
exports.createAdjustment = createAdjustment;
exports.addItemsOnSearchItems = addItemsOnSearchItems;
exports.addItemsOnChangeItems = addItemsOnChangeItems;
exports.addItemsConfirmAddItems = addItemsConfirmAddItems;
exports.onClickDone = onClickDone;
exports.confirmSubmit = confirmSubmit;
exports.onChangeNamespace = onChangeNamespace;
exports.onSuccessImport = onSuccessImport;
exports.default = saga;

var _constants = __webpack_require__(399);

var _adjustment = __webpack_require__(146);

var actInvAdj = _interopRequireWildcard(_adjustment);

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _loadingSpinner = __webpack_require__(46);

var actLoadingSpinner = _interopRequireWildcard(_loadingSpinner);

var _currentInventoryDropdown = __webpack_require__(288);

var apiCurrentInventory = _interopRequireWildcard(_currentInventoryDropdown);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _adjustment2 = __webpack_require__(1087);

var apiIngInvAdj = _interopRequireWildcard(_adjustment2);

var _adjustment3 = __webpack_require__(1097);

var apiInvAdj = _interopRequireWildcard(_adjustment3);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getFilteredDate = __webpack_require__(171);

var apiGetFilteredDate = _interopRequireWildcard(_getFilteredDate);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _items = __webpack_require__(239);

var apiItems = _interopRequireWildcard(_items);

var _ingredients = __webpack_require__(205);

var apiIng = _interopRequireWildcard(_ingredients);

var _updateFilteredDate = __webpack_require__(240);

var apiUpdateFilteredDate = _interopRequireWildcard(_updateFilteredDate);

var _adjustment4 = __webpack_require__(650);

var mpInvAdj = _interopRequireWildcard(_adjustment4);

var _ingredientSubscription = __webpack_require__(233);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, adjustmentsRequest, ingredientAdjustmentRequest, adjustmentFormOnChangeOutlet, adjustmentFormOnClickCancel, onChangeOutletIdsFlow, onChangeDate, exportAdjustment, exportIngredientAdjustment, onClickRow, onClickRowIngredientAdjustment, onClickCreateAdjustment, onClickAddItems, addItemsCancelAddItems, addItemsGetItemsRequestFlow, addItemsGetIngredientsRequestFlow, createAdjustment, addItemsOnSearchItems, addItemsOnChangeItems, addItemsConfirmAddItems, onClickDone, confirmSubmit, onChangeNamespace, onSuccessImport, saga].map(_regenerator2.default.mark);

function pageRequest() {
  var response, resProfile, resGetFilteredDate, startDate, endDate, resCurrentInventoryDropdown, currentInventoryDropdown, params;
  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 4:
          _context.next = 6;
          return (0, _effects.put)(actInvAdj.setAdjustments([]));

        case 6:
          _context.next = 8;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 8:
          _context.next = 10;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(null));

        case 10:
          _context.next = 12;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 12:
          _context.next = 14;
          return (0, _effects.put)(act.showProgressBar());

        case 14:
          _context.prev = 14;
          _context.next = 17;
          return (0, _effects.call)(apiOutlets.outlets);

        case 17:
          response = _context.sent;
          _context.next = 20;
          return (0, _effects.put)(actInvAdj.setOutlets(response.data));

        case 20:
          _context.next = 22;
          return (0, _effects.call)(apiProfile.getProfile);

        case 22:
          resProfile = _context.sent;
          _context.next = 25;
          return (0, _effects.call)(apiGetFilteredDate.getFilteredDate);

        case 25:
          resGetFilteredDate = _context.sent;
          startDate = (0, _moment2.default)(resGetFilteredDate.data.start_date);
          endDate = (0, _moment2.default)(resGetFilteredDate.data.end_date);

          // get current dropdown

          _context.next = 30;
          return (0, _effects.call)(apiCurrentInventory.getCurrentInventoryDropdown);

        case 30:
          resCurrentInventoryDropdown = _context.sent;
          currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown;
          params = {
            page: 1,
            start: resGetFilteredDate.data.start_date,
            end: resGetFilteredDate.data.end_date
          };

          if (!(currentInventoryDropdown === 'ingredients')) {
            _context.next = 38;
            break;
          }

          _context.next = 36;
          return (0, _effects.put)(actInvAdj.ingredientAdjustmentsRequest(params, []));

        case 36:
          _context.next = 40;
          break;

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actInvAdj.adjustmentsRequest(params, []));

        case 40:
          _context.next = 42;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: resProfile.data.outlet_id,
            date: { startDate: startDate, endDate: endDate },
            namespace: currentInventoryDropdown
          }));

        case 42:
          mpInvAdj.inventoryAdjustmentStart({
            outletIds: resProfile.data.outlet_id,
            startDate: startDate,
            endDate: endDate,
            namespace: currentInventoryDropdown
          });

          _context.next = 45;
          return (0, _effects.put)((0, _ingredientSubscription.subscriptionStatus)());

        case 45:
          _context.next = 51;
          break;

        case 47:
          _context.prev = 47;
          _context.t0 = _context['catch'](14);
          _context.next = 51;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 51:
          _context.prev = 51;
          _context.next = 54;
          return (0, _effects.put)(act.hideProgressBar());

        case 54:
          return _context.finish(51);

        case 55:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[14, 47, 51, 55]]);
}

function adjustmentsRequest(request) {
  var _request$payload, params, previousAdjustments, showLoadingSpinner, resAdjustments, adjustments, _resAdjustments$data, total_count, total_expense, total_income, total_items, newAdjustments;

  return _regenerator2.default.wrap(function adjustmentsRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousAdjustments = _request$payload.previousAdjustments;
          showLoadingSpinner = previousAdjustments.length === 0;

          if (!showLoadingSpinner) {
            _context2.next = 5;
            break;
          }

          _context2.next = 5;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(act.showProgressBar());

        case 7:
          _context2.prev = 7;
          _context2.next = 10;
          return (0, _effects.call)(apiInvAdj.getAdjustments, params);

        case 10:
          resAdjustments = _context2.sent;
          adjustments = resAdjustments.data.results;
          _resAdjustments$data = resAdjustments.data, total_count = _resAdjustments$data.total_count, total_expense = _resAdjustments$data.total_expense, total_income = _resAdjustments$data.total_income, total_items = _resAdjustments$data.total_items;

          // copy array

          newAdjustments = previousAdjustments.map(function (a) {
            return a;
          });


          adjustments.forEach(function (adj, idx) {
            var lastAdjustment = newAdjustments[newAdjustments.length - 1];
            if (newAdjustments.length === 0 || !(0, _moment2.default)(adj.created_at).isSame((0, _moment2.default)(lastAdjustment.created_at), 'days')) {
              newAdjustments.push({
                created_at: adj.created_at,
                isdaterow: true
              });
            }
            newAdjustments.push((0, _extends3.default)({}, adj, {
              isdaterow: false
            }));
          });
          _context2.next = 17;
          return (0, _effects.put)(actInvAdj.setAdjustments(newAdjustments));

        case 17:
          _context2.next = 19;
          return (0, _effects.put)(actInvAdj.setCurrentPage(params.page));

        case 19:
          _context2.next = 21;
          return (0, _effects.put)(actInvAdj.setTotalPage(resAdjustments.data.total_pages));

        case 21:
          _context2.next = 23;
          return (0, _effects.put)(actInvAdj.setSummaryAdjustment({
            totalCount: total_count,
            totalExpense: total_expense,
            totalIncome: total_income,
            totalItems: total_items
          }));

        case 23:
          _context2.next = 29;
          break;

        case 25:
          _context2.prev = 25;
          _context2.t0 = _context2['catch'](7);
          _context2.next = 29;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 29:
          _context2.prev = 29;
          _context2.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          _context2.next = 34;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(false));

        case 34:
          return _context2.finish(29);

        case 35:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[7, 25, 29, 35]]);
}

function ingredientAdjustmentRequest(request) {
  var _request$payload2, params, previousIngredientAdjustments, showLoadingSpinner, resIngAdjustments, ingAdjustments, _resIngAdjustments$da, total_count, total_expense, total_income, total_ingredients, newAdjustments;

  return _regenerator2.default.wrap(function ingredientAdjustmentRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _request$payload2 = request.payload, params = _request$payload2.params, previousIngredientAdjustments = _request$payload2.previousIngredientAdjustments;
          showLoadingSpinner = previousIngredientAdjustments.length === 0;

          if (!showLoadingSpinner) {
            _context3.next = 5;
            break;
          }

          _context3.next = 5;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(act.showProgressBar());

        case 7:
          _context3.prev = 7;
          _context3.next = 10;
          return (0, _effects.call)(apiIngInvAdj.getAdjustments, params);

        case 10:
          resIngAdjustments = _context3.sent;
          ingAdjustments = resIngAdjustments.data.results;
          _resIngAdjustments$da = resIngAdjustments.data, total_count = _resIngAdjustments$da.total_count, total_expense = _resIngAdjustments$da.total_expense, total_income = _resIngAdjustments$da.total_income, total_ingredients = _resIngAdjustments$da.total_ingredients;
          // copy array

          newAdjustments = previousIngredientAdjustments.map(function (a) {
            return a;
          });
          //

          ingAdjustments.forEach(function (adj, idx) {
            var lastAdjustment = newAdjustments[newAdjustments.length - 1];
            if (newAdjustments.length === 0 || !(0, _moment2.default)(adj.created_at).isSame((0, _moment2.default)(lastAdjustment.created_at), 'days')) {
              newAdjustments.push({
                created_at: adj.created_at,
                isdaterow: true
              });
            }
            newAdjustments.push((0, _extends3.default)({}, adj, {
              isdaterow: false
            }));
          });
          _context3.next = 17;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustments(newAdjustments));

        case 17:
          _context3.next = 19;
          return (0, _effects.put)(actInvAdj.setCurrentPage(params.page));

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(actInvAdj.setTotalPage(resIngAdjustments.data.total_pages));

        case 21:
          _context3.next = 23;
          return (0, _effects.put)(actInvAdj.setSummaryIngredientAdjustment({
            totalCount: total_count,
            totalExpense: total_expense,
            totalIncome: total_income,
            totalIngredients: total_ingredients
          }));

        case 23:
          _context3.next = 29;
          break;

        case 25:
          _context3.prev = 25;
          _context3.t0 = _context3['catch'](7);
          _context3.next = 29;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 29:
          _context3.prev = 29;
          _context3.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          _context3.next = 34;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(false));

        case 34:
          return _context3.finish(29);

        case 35:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[7, 25, 29, 35]]);
}

function adjustmentFormOnChangeOutlet() {
  return _regenerator2.default.wrap(function adjustmentFormOnChangeOutlet$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _reduxForm.change)('adjustment', 'adjustments', []));

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function adjustmentFormOnClickCancel() {
  return _regenerator2.default.wrap(function adjustmentFormOnClickCancel$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function onChangeOutletIdsFlow(request) {
  var _request$payload3, outletIds, startDate, endDate, namespace;

  return _regenerator2.default.wrap(function onChangeOutletIdsFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _request$payload3 = request.payload, outletIds = _request$payload3.outletIds, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate, namespace = _request$payload3.namespace;

          mpInvAdj.inventoryAdjustmentChangeFilter({
            outletIds: outletIds,
            startDate: startDate,
            endDate: endDate,
            namespace: namespace
          });
          _context6.next = 4;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actInvAdj.setAdjustments([]));

        case 8:
          _context6.next = 10;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustments([]));

        case 10:
          _context6.next = 12;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 12:
          _context6.next = 14;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(null));

        case 14:
          _context6.next = 16;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 16:
          _context6.next = 18;
          return (0, _effects.put)(act.showProgressBar());

        case 18:
          _context6.prev = 18;
          _context6.next = 21;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 21:
          _context6.next = 23;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: outletIds,
            date: { startDate: startDate, endDate: endDate },
            namespace: namespace
          }));

        case 23:
          _context6.next = 29;
          break;

        case 25:
          _context6.prev = 25;
          _context6.t0 = _context6['catch'](18);
          _context6.next = 29;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 29:
          _context6.prev = 29;
          _context6.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context6.finish(29);

        case 33:
          if (!(namespace === 'ingredients')) {
            _context6.next = 38;
            break;
          }

          _context6.next = 36;
          return (0, _effects.put)(actInvAdj.ingredientAdjustmentsRequest({
            page: 1,
            start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, []));

        case 36:
          _context6.next = 40;
          break;

        case 38:
          _context6.next = 40;
          return (0, _effects.put)(actInvAdj.adjustmentsRequest({
            page: 1,
            start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, []));

        case 40:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[18, 25, 29, 33]]);
}

function onChangeDate(request) {
  var _request$payload4, startDate, endDate, namespace, outletIds;

  return _regenerator2.default.wrap(function onChangeDate$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _request$payload4 = request.payload, startDate = _request$payload4.startDate, endDate = _request$payload4.endDate, namespace = _request$payload4.namespace, outletIds = _request$payload4.outletIds;

          mpInvAdj.inventoryAdjustmentChangeFilter({
            outletIds: outletIds,
            startDate: startDate,
            endDate: endDate,
            namespace: namespace
          });
          _context7.next = 4;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'date', { startDate: startDate, endDate: endDate }));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 6:
          _context7.next = 8;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 8:
          _context7.next = 10;
          return (0, _effects.put)(actInvAdj.setAdjustments([]));

        case 10:
          _context7.next = 12;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustments([]));

        case 12:
          _context7.next = 14;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 14:
          _context7.next = 16;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(null));

        case 16:
          _context7.next = 18;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 18:
          if (!(namespace === 'ingredients')) {
            _context7.next = 23;
            break;
          }

          _context7.next = 21;
          return (0, _effects.put)(actInvAdj.ingredientAdjustmentsRequest({
            page: 1,
            start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, []));

        case 21:
          _context7.next = 25;
          break;

        case 23:
          _context7.next = 25;
          return (0, _effects.put)(actInvAdj.adjustmentsRequest({
            page: 1,
            start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, []));

        case 25:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function exportAdjustment(request) {
  var _request$payload5, params, filename, outletId;

  return _regenerator2.default.wrap(function exportAdjustment$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload5 = request.payload, params = _request$payload5.params, filename = _request$payload5.filename, outletId = _request$payload5.outletId;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.call)(apiInvAdj.getExportAdjustment, params);

        case 4:
          _context8.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Adjustment'));

        case 6:
          _context8.next = 12;
          break;

        case 8:
          _context8.prev = 8;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 12;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 12:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 8]]);
}

function exportIngredientAdjustment(request) {
  var _request$payload6, params, filename, outletId;

  return _regenerator2.default.wrap(function exportIngredientAdjustment$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload6 = request.payload, params = _request$payload6.params, filename = _request$payload6.filename, outletId = _request$payload6.outletId;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.call)(apiIngInvAdj.getExportAdjustment, params);

        case 4:
          _context9.next = 6;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Ingredient Adjustment'));

        case 6:
          _context9.next = 12;
          break;

        case 8:
          _context9.prev = 8;
          _context9.t0 = _context9['catch'](1);
          _context9.next = 12;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 12:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[1, 8]]);
}

function onClickRow(request) {
  var adjustment;
  return _regenerator2.default.wrap(function onClickRow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          adjustment = request.payload.adjustment;
          _context10.next = 3;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(adjustment));

        case 3:
          _context10.next = 5;
          return (0, _effects.put)(actInvAdj.openRightColumn());

        case 5:
          _context10.next = 7;
          return (0, _effects.put)((0, _reduxForm.initialize)('adjustment', {
            outlet_id: adjustment.outlet_id,
            note: ''
          }));

        case 7:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function onClickRowIngredientAdjustment(request) {
  var ingredientAdjustment;
  return _regenerator2.default.wrap(function onClickRowIngredientAdjustment$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          ingredientAdjustment = request.payload.ingredientAdjustment;
          _context11.next = 3;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(ingredientAdjustment));

        case 3:
          _context11.next = 5;
          return (0, _effects.put)(actInvAdj.openRightColumn());

        case 5:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function onClickCreateAdjustment(request) {
  var outletId;
  return _regenerator2.default.wrap(function onClickCreateAdjustment$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          outletId = request.payload.outletId;
          _context12.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('adjustment', {
            outlet_id: outletId,
            note: '',
            adjustments: []
          }));

        case 3:
          _context12.next = 5;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 5:
          _context12.next = 7;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(null));

        case 7:
          _context12.next = 9;
          return (0, _effects.put)(actInvAdj.openRightColumn());

        case 9:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function onClickAddItems(request) {
  var _request$payload7, outletId, namespace;

  return _regenerator2.default.wrap(function onClickAddItems$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload7 = request.payload, outletId = _request$payload7.outletId, namespace = _request$payload7.namespace;

          if (!(namespace === 'items')) {
            _context13.next = 6;
            break;
          }

          _context13.next = 4;
          return (0, _effects.put)(actInvAdj.addItemsGetItemsRequest({
            outlet_id: outletId,
            page: 1,
            per_page: 100,
            no_categories: true,
            keyword: ''
          }, []));

        case 4:
          _context13.next = 8;
          break;

        case 6:
          _context13.next = 8;
          return (0, _effects.put)(actInvAdj.addItemsGetIngredientsRequest({
            outlet_id: outletId,
            page: 1,
            per_page: 100,
            keyword: ''
          }, []));

        case 8:
          _context13.next = 10;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(null));

        case 10:
          _context13.next = 12;
          return (0, _effects.put)(actInvAdj.addItemsHideAlreadyAddedAlert());

        case 12:
          _context13.next = 14;
          return (0, _effects.put)(actInvAdj.showAddItemsModal());

        case 14:
          _context13.next = 16;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(false));

        case 16:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function addItemsCancelAddItems(request) {
  return _regenerator2.default.wrap(function addItemsCancelAddItems$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {
            items: []
          }));

        case 2:
          _context14.next = 4;
          return (0, _effects.put)(actInvAdj.hideAddItemsModal());

        case 4:
          _context14.next = 6;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(null));

        case 6:
          _context14.next = 8;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(false));

        case 8:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function addItemsGetItemsRequestFlow(request) {
  var _request$payload8, params, previousItems, resItems, items, mergedItems;

  return _regenerator2.default.wrap(function addItemsGetItemsRequestFlow$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _request$payload8 = request.payload, params = _request$payload8.params, previousItems = _request$payload8.previousItems;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.put)(actInvAdj.addItemsShowLoading());

        case 4:
          _context15.next = 6;
          return (0, _effects.call)(apiItems.getItemsV1, params);

        case 6:
          resItems = _context15.sent;
          items = resItems.data;
          mergedItems = previousItems.concat(items);
          _context15.next = 11;
          return (0, _effects.put)(actInvAdj.addItemsSetItems(mergedItems));

        case 11:
          if (!(items.length === 0)) {
            _context15.next = 16;
            break;
          }

          _context15.next = 14;
          return (0, _effects.put)(actInvAdj.addItemsSetTotalPage(params.page));

        case 14:
          _context15.next = 18;
          break;

        case 16:
          _context15.next = 18;
          return (0, _effects.put)(actInvAdj.addItemsSetTotalPage(params.page + 1));

        case 18:
          _context15.next = 20;
          return (0, _effects.put)(actInvAdj.addItemsSetCurrentPage(params.page));

        case 20:
          _context15.next = 26;
          break;

        case 22:
          _context15.prev = 22;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 26;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 26:
          _context15.prev = 26;
          _context15.next = 29;
          return (0, _effects.put)(actInvAdj.addItemsHideLoading());

        case 29:
          return _context15.finish(26);

        case 30:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 22, 26, 30]]);
}

function addItemsGetIngredientsRequestFlow(request) {
  var _request$payload9, params, previousIngredients, resIngs, ingredients, mergedIngredients;

  return _regenerator2.default.wrap(function addItemsGetIngredientsRequestFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _request$payload9 = request.payload, params = _request$payload9.params, previousIngredients = _request$payload9.previousIngredients;
          _context16.prev = 1;
          _context16.next = 4;
          return (0, _effects.put)(actInvAdj.addItemsShowLoading());

        case 4:
          _context16.next = 6;
          return (0, _effects.call)(apiIng.getAll, params);

        case 6:
          resIngs = _context16.sent;
          ingredients = resIngs.data;
          mergedIngredients = previousIngredients.concat(ingredients);
          _context16.next = 11;
          return (0, _effects.put)(actInvAdj.addItemsSetIngredients(mergedIngredients));

        case 11:
          if (!(ingredients.length === 0)) {
            _context16.next = 16;
            break;
          }

          _context16.next = 14;
          return (0, _effects.put)(actInvAdj.addItemsSetTotalPage(params.page));

        case 14:
          _context16.next = 18;
          break;

        case 16:
          _context16.next = 18;
          return (0, _effects.put)(actInvAdj.addItemsSetTotalPage(params.page + 1));

        case 18:
          _context16.next = 20;
          return (0, _effects.put)(actInvAdj.addItemsSetCurrentPage(params.page));

        case 20:
          _context16.next = 26;
          break;

        case 22:
          _context16.prev = 22;
          _context16.t0 = _context16['catch'](1);
          _context16.next = 26;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 26:
          _context16.prev = 26;
          _context16.next = 29;
          return (0, _effects.put)(actInvAdj.addItemsHideLoading());

        case 29:
          return _context16.finish(26);

        case 30:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[1, 22, 26, 30]]);
}

function createAdjustment() {
  return _regenerator2.default.wrap(function createAdjustment$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function addItemsOnSearchItems(request) {
  var _request$payload10, keyword, outletId, namespace;

  return _regenerator2.default.wrap(function addItemsOnSearchItems$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)(actInvAdj.addItemsSetItems([]));

        case 2:
          _context18.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 100);

        case 4:
          _request$payload10 = request.payload, keyword = _request$payload10.keyword, outletId = _request$payload10.outletId, namespace = _request$payload10.namespace;

          if (!(namespace === 'items')) {
            _context18.next = 10;
            break;
          }

          _context18.next = 8;
          return (0, _effects.put)(actInvAdj.addItemsGetItemsRequest({
            outlet_id: outletId,
            page: 1,
            per_page: 100,
            no_categories: true,
            keyword: keyword
          }, []));

        case 8:
          _context18.next = 12;
          break;

        case 10:
          _context18.next = 12;
          return (0, _effects.put)(actInvAdj.addItemsGetIngredientsRequest({
            outlet_id: outletId,
            page: 1,
            per_page: 100,
            keyword: keyword
          }, []));

        case 12:
          _context18.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {}));

        case 14:
          _context18.next = 16;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(null));

        case 16:
          _context18.next = 18;
          return (0, _effects.put)(actInvAdj.addItemsSetKeyword(keyword));

        case 18:
          _context18.next = 20;
          return (0, _effects.put)(actInvAdj.addItemsHideAlreadyAddedAlert());

        case 20:
          _context18.next = 22;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(false));

        case 22:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function addItemsOnChangeItems(request) {
  var _request$payload11, item, namespace, adjustmentForm, adjustments, alreadyExist, fields, ingredients, _alreadyExist;

  return _regenerator2.default.wrap(function addItemsOnChangeItems$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _request$payload11 = request.payload, item = _request$payload11.item, namespace = _request$payload11.namespace, adjustmentForm = _request$payload11.adjustmentForm;

          if (!(namespace === 'items')) {
            _context19.next = 23;
            break;
          }

          adjustments = adjustmentForm.adjustments;
          alreadyExist = false;

          adjustments.forEach(function (adj) {
            if (item.id === adj.item_id) {
              alreadyExist = true;
            }
          });
          _context19.next = 7;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(item.id));

        case 7:
          if (!(namespace === 'items')) {
            _context19.next = 10;
            break;
          }

          _context19.next = 10;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(item.is_recipe));

        case 10:
          if (!alreadyExist) {
            _context19.next = 17;
            break;
          }

          _context19.next = 13;
          return (0, _effects.put)(actInvAdj.addItemsShowAlreadyAddedAlert());

        case 13:
          _context19.next = 15;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {}));

        case 15:
          _context19.next = 21;
          break;

        case 17:
          // reorder item_variants based on position
          item.item_variants = item.item_variants.sort(function (iva, ivb) {
            if (iva.position < ivb.position) {
              return -1;
            } else if (iva.position > ivb.position) {
              return 1;
            } else {
              return 0;
            }
          });
          fields = item.item_variants.map(function (iv, index) {
            return {
              item_variant_name: iv.name,
              beginning_stock: iv.in_stock,
              quantity: iv.in_stock,
              item_id: item.id,
              item_name: item.name,
              item_variant_id: iv.id,
              position: iv.position,
              is_item: item.item_variants.length <= 1
            };
          });
          _context19.next = 21;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {
            items: fields
          }));

        case 21:
          _context19.next = 38;
          break;

        case 23:
          ingredients = adjustmentForm.adjustments;
          _alreadyExist = false;

          ingredients.forEach(function (ing) {
            if (item.id === ing.ingredient_id) {
              _alreadyExist = true;
            }
          });
          _context19.next = 28;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(item.id));

        case 28:
          if (!(namespace === 'items')) {
            _context19.next = 31;
            break;
          }

          _context19.next = 31;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(item.is_recipe));

        case 31:
          if (!_alreadyExist) {
            _context19.next = 36;
            break;
          }

          _context19.next = 34;
          return (0, _effects.put)(actInvAdj.addItemsShowAlreadyAddedAlert());

        case 34:
          _context19.next = 38;
          break;

        case 36:
          _context19.next = 38;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {
            adjustment_quantity: 0,
            beginning_stock: item.in_stock.toFixed(2),
            end_stock: item.in_stock.toFixed(2),
            ingredient_category_id: item.ingredient_category_id,
            ingredient_id: item.id,
            ingredient_name: item.name,
            position: 0, // diset manual karena butuh dikirim ke server juga
            quantity: item.in_stock.toFixed(2),
            timestamp: new Date().getTime(),
            total_price: 0, // diset manual karena butuh dikirim ke server juga
            unit_id: item.unit_id,
            unit_name: item.unit_name,
            unit_price: 0 // diset manual karena butuh dikirim ke server juga
          }));

        case 38:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function addItemsConfirmAddItems(request) {
  var _request$payload12, addItemsFormValues, adjustments, namespace, items, itemIdsOrderCounter, itemIdsOrder, newAdjustmetObjectsByItemVariantIds, newAdjustments, i;

  return _regenerator2.default.wrap(function addItemsConfirmAddItems$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _request$payload12 = request.payload, addItemsFormValues = _request$payload12.addItemsFormValues, adjustments = _request$payload12.adjustments, namespace = _request$payload12.namespace;

          if (!(namespace === 'items')) {
            _context20.next = 24;
            break;
          }

          items = addItemsFormValues.items;
          // grouping items

          itemIdsOrderCounter = 0;
          itemIdsOrder = {};
          // order itemIds based of

          adjustments.forEach(function (adjustment) {
            if (!itemIdsOrder[adjustment.item_id]) {
              itemIdsOrder[adjustment.item_id] = ++itemIdsOrderCounter;
            }
          });
          items.forEach(function (item) {
            if (!itemIdsOrder[item.item_id]) {
              itemIdsOrder[item.item_id] = ++itemIdsOrderCounter;
            }
          });

          // data-merging
          newAdjustmetObjectsByItemVariantIds = {};

          adjustments.forEach(function (adjustment) {
            if (!newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id]) {
              newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id] = adjustment;
            } else {
              newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id].quantity = parseInt(newAdjustmetObjectsByItemVariantIds[adjustment.item_variant_id].quantity) + parseInt(adjustment.quantity);
            }
          });

          items.forEach(function (item) {
            if (!newAdjustmetObjectsByItemVariantIds[item.item_variant_id]) {
              newAdjustmetObjectsByItemVariantIds[item.item_variant_id] = item;
            } else {
              newAdjustmetObjectsByItemVariantIds[item.item_variant_id].quantity = parseInt(newAdjustmetObjectsByItemVariantIds[item.item_variant_id].quantity) + parseInt(item.quantity);
            }
          });

          // convert to array
          newAdjustments = [];


          (0, _keys2.default)(newAdjustmetObjectsByItemVariantIds).forEach(function (key) {
            newAdjustments.push(newAdjustmetObjectsByItemVariantIds[key]);
          });
          newAdjustments = newAdjustments.sort(function (a, b) {
            if (itemIdsOrder[a.item_id] !== itemIdsOrder[b.item_id]) {
              if (itemIdsOrder[a.item_id] < itemIdsOrder[b.item_id]) {
                return -1;
              } else {
                return 1;
              }
            } else if (a.position !== b.position) {
              if (a.position < b.position) {
                return -1;
              } else {
                return 1;
              }
            } else {
              return 0;
            }
          });

          _context20.next = 15;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('adjustment', 'adjustments'));

        case 15:
          i = 0;

        case 16:
          if (!(i < newAdjustments.length)) {
            _context20.next = 22;
            break;
          }

          _context20.next = 19;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('adjustment', 'adjustments', newAdjustments[i]));

        case 19:
          i++;
          _context20.next = 16;
          break;

        case 22:
          _context20.next = 26;
          break;

        case 24:
          _context20.next = 26;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('adjustment', 'adjustments', addItemsFormValues));

        case 26:
          _context20.next = 28;
          return (0, _effects.put)(actInvAdj.hideAddItemsModal());

        case 28:
          _context20.next = 30;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItems', {
            items: []
          }));

        case 30:
          _context20.next = 32;
          return (0, _effects.put)(actInvAdj.addItemsSetSelectedId(null));

        case 32:
          _context20.next = 34;
          return (0, _effects.put)(actInvAdj.addItemsHideAlreadyAddedAlert());

        case 34:
          _context20.next = 36;
          return (0, _effects.put)(actInvAdj.addItemsSetItemHasRecipe(false));

        case 36:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function onClickDone(request) {
  return _regenerator2.default.wrap(function onClickDone$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 2:
          _context21.next = 4;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 4:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function confirmSubmit(request) {
  var _request$payload13, values, namespace, date, outlet, formData, adjustments, _formData, _adjustments;

  return _regenerator2.default.wrap(function confirmSubmit$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _request$payload13 = request.payload, values = _request$payload13.values, namespace = _request$payload13.namespace, date = _request$payload13.date, outlet = _request$payload13.outlet;
          _context22.prev = 1;
          _context22.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context22.next = 6;
          return (0, _effects.put)(actInvAdj.hideConfirmSubmitModal());

        case 6:
          if (!(namespace === 'items')) {
            _context22.next = 16;
            break;
          }

          formData = { adjustment: { note: values.note, outlet_id: values.outlet_id } };
          adjustments = values.adjustments;

          formData.adjustment.history_details = [];
          adjustments.forEach(function (a) {
            if (Math.abs(parseFloat(a.quantity) - parseFloat(a.beginning_stock)) > 0.0000001) {
              formData.adjustment.history_details.push((0, _extends3.default)({}, a, {
                end_stock: a.quantity - a.beginning_stock,
                adjustment: a.quantity - a.beginning_stock
              }));
            }
          });
          mpInvAdj.inventoryAdjustmentCreate({ adjustment: formData.adjustment, outlet: outlet });
          _context22.next = 14;
          return (0, _effects.call)(apiInvAdj.postAdjustment, formData);

        case 14:
          _context22.next = 23;
          break;

        case 16:
          _formData = { ingredient_adjustment: { note: values.note, outlet_id: values.outlet_id } };
          _adjustments = values.adjustments;

          _formData.ingredient_adjustment.ingredient_history_details = [];
          _adjustments.forEach(function (a) {
            _formData.ingredient_adjustment.ingredient_history_details.push((0, _extends3.default)({}, a, {
              adjustment_quantity: Math.round((a.quantity - a.beginning_stock) * 100) / 100, // hack utk rounding, kalo ga diround nanti akan ngimirin value spt 0.03999999997
              end_stock: 0, // gatau dari contoh yang lama kenapa dikasih 0 dan instead pake adjustment_quantity
              timestamp: new Date().getTime(),
              total_price: 0 // ni juga kenapa dah dikasih 0,
            }));
          });
          mpInvAdj.inventoryAdjustmentCreate({ adjustment: _formData.ingredient_adjustment, outlet: outlet });
          _context22.next = 23;
          return (0, _effects.call)(apiIngInvAdj.postAdjustment, _formData);

        case 23:
          if ((0, _moment2.default)().isBetween(date.startDate, date.endDate, 'day', '[]')) {
            _context22.next = 26;
            break;
          }

          _context22.next = 26;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, {
            from: (0, _moment2.default)().format('D/M/YYYY'), to: (0, _moment2.default)().format('D/M/YYYY')
          });

        case 26:
          _context22.next = 28;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 28:
          _context22.next = 30;
          return (0, _effects.put)(actInvAdj.pageRequest());

        case 30:
          _context22.next = 32;
          return (0, _effects.put)(actNotif.success('Adjustment has been created'));

        case 32:
          _context22.next = 38;
          break;

        case 34:
          _context22.prev = 34;
          _context22.t0 = _context22['catch'](1);
          _context22.next = 38;
          return (0, _effects.put)(actNotif.error(_context22.t0.message));

        case 38:
          _context22.prev = 38;
          _context22.next = 41;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 41:
          _context22.next = 43;
          return (0, _effects.put)(act.hideProgressBar());

        case 43:
          return _context22.finish(38);

        case 44:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this, [[1, 34, 38, 44]]);
}

function onChangeNamespace(request) {
  var _request$payload14, namespace, params, startDate, endDate, outletIds;

  return _regenerator2.default.wrap(function onChangeNamespace$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _request$payload14 = request.payload, namespace = _request$payload14.namespace, params = _request$payload14.params, startDate = _request$payload14.startDate, endDate = _request$payload14.endDate, outletIds = _request$payload14.outletIds;

          mpInvAdj.inventoryAdjustmentChangeFilter({
            outletIds: outletIds,
            startDate: startDate,
            endDate: endDate,
            namespace: namespace
          });
          // update dropdown
          _context23.next = 4;
          return (0, _effects.put)(actInvAdj.closeRightColumn());

        case 4:
          _context23.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context23.next = 8;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 8:
          _context23.next = 10;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustments([]));

        case 10:
          _context23.next = 12;
          return (0, _effects.put)(actInvAdj.setAdjustments([]));

        case 12:
          _context23.next = 14;
          return (0, _effects.put)(actInvAdj.setAdjustmentDetail(null));

        case 14:
          _context23.next = 16;
          return (0, _effects.put)(actInvAdj.setIngredientAdjustmentDetail(null));

        case 16:
          _context23.next = 18;
          return (0, _effects.put)(actInvAdj.cancelAddItems());

        case 18:
          _context23.next = 20;
          return (0, _effects.put)((0, _reduxForm.reset)('adjustment'));

        case 20:
          _context23.next = 22;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'namespace', namespace));

        case 22:
          _context23.prev = 22;
          _context23.next = 25;
          return (0, _effects.call)(apiCurrentInventory.putCurrentInventoryDropdown, { current_inventory_dropdown: namespace });

        case 25:
          _context23.next = 31;
          break;

        case 27:
          _context23.prev = 27;
          _context23.t0 = _context23['catch'](22);
          _context23.next = 31;
          return (0, _effects.put)(actNotif.error(_context23.t0.message));

        case 31:
          _context23.prev = 31;

          if (!(namespace === 'ingredients')) {
            _context23.next = 37;
            break;
          }

          _context23.next = 35;
          return (0, _effects.put)(actInvAdj.ingredientAdjustmentsRequest(params, []));

        case 35:
          _context23.next = 39;
          break;

        case 37:
          _context23.next = 39;
          return (0, _effects.put)(actInvAdj.adjustmentsRequest(params, []));

        case 39:
          _context23.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          return _context23.finish(31);

        case 42:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this, [[22, 27, 31, 42]]);
}

function onSuccessImport() {
  return _regenerator2.default.wrap(function onSuccessImport$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.put)(actInvAdj.hideImportModal());

        case 2:
          _context24.next = 4;
          return (0, _effects.put)(actNotif.success('Adjustment successfully imported'));

        case 4:
          _context24.next = 6;
          return (0, _effects.put)(actInvAdj.pageRequest());

        case 6:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_PAGE_REQUEST, pageRequest);

        case 2:
          _context25.next = 4;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST, adjustmentsRequest);

        case 4:
          _context25.next = 6;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow);

        case 6:
          _context25.next = 8;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE, onChangeNamespace);

        case 8:
          _context25.next = 10;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CHANGE_DATE, onChangeDate);

        case 10:
          _context25.next = 12;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT, exportAdjustment);

        case 12:
          _context25.next = 14;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT, exportIngredientAdjustment);

        case 14:
          _context25.next = 16;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CLICK_ROW, onClickRow);

        case 16:
          _context25.next = 18;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT, onClickRowIngredientAdjustment);

        case 18:
          _context25.next = 20;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT, onClickCreateAdjustment);

        case 20:
          _context25.next = 22;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS, onClickAddItems);

        case 22:
          _context25.next = 24;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS, addItemsCancelAddItems);

        case 24:
          _context25.next = 26;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE, createAdjustment);

        case 26:
          _context25.next = 28;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST, addItemsGetItemsRequestFlow);

        case 28:
          _context25.next = 30;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST, addItemsGetIngredientsRequestFlow);

        case 30:
          _context25.next = 32;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS, addItemsOnSearchItems);

        case 32:
          _context25.next = 34;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS, addItemsOnChangeItems);

        case 34:
          _context25.next = 36;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS, addItemsConfirmAddItems);

        case 36:
          _context25.next = 38;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_CLICK_DONE, onClickDone);

        case 38:
          _context25.next = 40;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET, adjustmentFormOnChangeOutlet);

        case 40:
          _context25.next = 42;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL, adjustmentFormOnClickCancel);

        case 42:
          _context25.next = 44;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT, confirmSubmit);

        case 44:
          _context25.next = 46;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST, ingredientAdjustmentRequest);

        case 46:
          _context25.next = 48;
          return (0, _effects.takeLatest)(_constants.INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT, onSuccessImport);

        case 48:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this);
}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getSubscriptionStatusFlow = getSubscriptionStatusFlow;
exports.default = saga;

var _effects = __webpack_require__(22);

var _ingredientSubscription = __webpack_require__(233);

var _getSubscriptionStatus = __webpack_require__(289);

var _constant = __webpack_require__(400);

var _constants = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getSubscriptionStatusFlow, saga].map(_regenerator2.default.mark);

function getSubscriptionStatusFlow() {
  var response;
  return _regenerator2.default.wrap(function getSubscriptionStatusFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_getSubscriptionStatus.getSubscriptionStatus, { feature_names: [_constants.INGREDIENT_FEATURE] });

        case 2:
          response = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _ingredientSubscription.setSubscriptionStatus)(response.data[0]));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constant.INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS, getSubscriptionStatusFlow);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(105);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.emptyForm = emptyForm;
exports.onchangeOutletForm = onchangeOutletForm;
exports.purchaseOrderRequest = purchaseOrderRequest;
exports.pageRequest = pageRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onChangeDate = onChangeDate;
exports.onChangeNamespace = onChangeNamespace;
exports.onChangeStatus = onChangeStatus;
exports.onChangeKeyword = onChangeKeyword;
exports.exportPurchaseOrder = exportPurchaseOrder;
exports.onClickRow = onClickRow;
exports.onClickDone = onClickDone;
exports.onClickCancel = onClickCancel;
exports.onClickPrint = onClickPrint;
exports.onClickResendEmail = onClickResendEmail;
exports.onClickCreatePO = onClickCreatePO;
exports.updatePurchaseOrder = updatePurchaseOrder;
exports.getItemsfromAPI = getItemsfromAPI;
exports.setModalItemForm = setModalItemForm;
exports.addItemToForm = addItemToForm;
exports.onCancelModalAddItem = onCancelModalAddItem;
exports.createPO = createPO;
exports.createFulfilledPO = createFulfilledPO;
exports.editPO = editPO;
exports.onClickEdit = onClickEdit;
exports.default = saga;

var _purchaseOrder = __webpack_require__(147);

var actInvPO = _interopRequireWildcard(_purchaseOrder);

var _effects = __webpack_require__(22);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _items = __webpack_require__(239);

var apiItems = _interopRequireWildcard(_items);

var _ingredients = __webpack_require__(205);

var apiIngredients = _interopRequireWildcard(_ingredients);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _purchaseOrder2 = __webpack_require__(1099);

var apiInvPO = _interopRequireWildcard(_purchaseOrder2);

var _suppliers = __webpack_require__(627);

var apiInvSup = _interopRequireWildcard(_suppliers);

var _purchaseOrder3 = __webpack_require__(1090);

var apiIngInv = _interopRequireWildcard(_purchaseOrder3);

var _getFilteredDate = __webpack_require__(171);

var apiGetFilteredDate = _interopRequireWildcard(_getFilteredDate);

var _updateFilteredDate = __webpack_require__(240);

var apiUpdateFilteredDate = _interopRequireWildcard(_updateFilteredDate);

var _currentInventoryDropdown = __webpack_require__(288);

var apiCurrentInventory = _interopRequireWildcard(_currentInventoryDropdown);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxSaga = __webpack_require__(68);

var _constants = __webpack_require__(401);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _purchaseOrders = __webpack_require__(451);

var mpPurchaseOrders = _interopRequireWildcard(_purchaseOrders);

var _ingredientSubscription = __webpack_require__(233);

var _constants2 = __webpack_require__(81);

var _loadingSpinner = __webpack_require__(46);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [emptyForm, onchangeOutletForm, purchaseOrderRequest, pageRequest, onChangeOutletIds, onChangeDate, onChangeNamespace, onChangeStatus, onChangeKeyword, exportPurchaseOrder, onClickRow, onClickDone, onClickCancel, onClickPrint, onClickResendEmail, onClickCreatePO, updatePurchaseOrder, getItemsfromAPI, setModalItemForm, addItemToForm, onCancelModalAddItem, createPO, createFulfilledPO, editPO, onClickEdit, saga].map(_regenerator2.default.mark);

function emptyForm() {
  return _regenerator2.default.wrap(function emptyForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.reset)('purchaseOrder'));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function onchangeOutletForm() {
  return _regenerator2.default.wrap(function onchangeOutletForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _reduxForm.change)('purchaseOrder', 'itemPurchase', []));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}
function purchaseOrderRequest(request) {
  var _request$payload, params, previousPurchaseOrders, namespace, resPurchaseOrders, purchaseOrders, totalPage, currentPage;

  return _regenerator2.default.wrap(function purchaseOrderRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousPurchaseOrders = _request$payload.previousPurchaseOrders, namespace = _request$payload.namespace;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          resPurchaseOrders = void 0;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context3.next = 11;
            break;
          }

          _context3.next = 8;
          return (0, _effects.call)(apiInvPO.getSearchPurchaseOrders, params);

        case 8:
          resPurchaseOrders = _context3.sent;
          _context3.next = 14;
          break;

        case 11:
          _context3.next = 13;
          return (0, _effects.call)(apiIngInv.getSearchPurchaseOrders, params);

        case 13:
          resPurchaseOrders = _context3.sent;

        case 14:
          purchaseOrders = previousPurchaseOrders.concat([]);

          resPurchaseOrders.data.results.forEach(function (po) {
            var lastPO = purchaseOrders[purchaseOrders.length - 1];
            if (purchaseOrders.length === 0 || !(0, _moment2.default)(po.created_at).isSame((0, _moment2.default)(lastPO.created_at), 'days')) {
              purchaseOrders.push({
                created_at: po.created_at,
                isdaterow: true
              });
            }
            purchaseOrders.push((0, _extends3.default)({}, po, { isdaterow: false }));
          });
          totalPage = resPurchaseOrders.data.total_pages;
          currentPage = params.page;
          _context3.next = 20;
          return (0, _effects.put)(actInvPO.setPurchaseOrders(purchaseOrders));

        case 20:
          _context3.next = 22;
          return (0, _effects.put)(actInvPO.setTotalPage(totalPage));

        case 22:
          _context3.next = 24;
          return (0, _effects.put)(actInvPO.setCurrentPage(currentPage));

        case 24:
          _context3.next = 30;
          break;

        case 26:
          _context3.prev = 26;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 30;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 30:
          _context3.prev = 30;
          _context3.next = 33;
          return (0, _effects.put)(act.hideProgressBar());

        case 33:
          _context3.next = 35;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 35:
          return _context3.finish(30);

        case 36:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[1, 26, 30, 36]]);
}

function pageRequest() {
  var response, resProfile, resGetFilteredDate, startDate, endDate, resCurrentInventoryDropdown, currentInventoryDropdown;
  return _regenerator2.default.wrap(function pageRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 6:
          _context4.next = 8;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 8:
          _context4.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context4.prev = 10;
          _context4.next = 13;
          return (0, _effects.call)(apiOutlets.outlets);

        case 13:
          response = _context4.sent;
          _context4.next = 16;
          return (0, _effects.put)(actInvPO.setOutlets(response.data));

        case 16:
          _context4.next = 18;
          return (0, _effects.call)(apiProfile.getProfile);

        case 18:
          resProfile = _context4.sent;
          _context4.next = 21;
          return (0, _effects.call)(apiGetFilteredDate.getFilteredDate);

        case 21:
          resGetFilteredDate = _context4.sent;
          startDate = (0, _moment2.default)(resGetFilteredDate.data.start_date);
          endDate = (0, _moment2.default)(resGetFilteredDate.data.end_date);
          _context4.next = 26;
          return (0, _effects.call)(apiCurrentInventory.getCurrentInventoryDropdown);

        case 26:
          resCurrentInventoryDropdown = _context4.sent;
          currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown;
          _context4.next = 30;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(currentInventoryDropdown, {
            page: 1,
            start: (0, _moment2.default)(resGetFilteredDate.data.start_date).format('D/M/YYYY'),
            end: (0, _moment2.default)(resGetFilteredDate.data.end_date).format('D/M/YYYY'),
            status: ''
          }, []));

        case 30:
          _context4.next = 32;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: resProfile.data.outlet_id,
            date: { startDate: startDate, endDate: endDate },
            namespace: currentInventoryDropdown
          }));

        case 32:
          _context4.next = 34;
          return (0, _effects.put)(actInvPO.setSelectedOutlet(resProfile.data.outlet_id));

        case 34:
          mpPurchaseOrders.inventoryPOStart({
            outletIds: resProfile.data.outlet_id,
            startDate: startDate,
            endDate: endDate,
            namespace: currentInventoryDropdown
          });
          _context4.next = 37;
          return (0, _effects.put)((0, _ingredientSubscription.subscriptionStatus)());

        case 37:
          _context4.next = 43;
          break;

        case 39:
          _context4.prev = 39;
          _context4.t0 = _context4['catch'](10);
          _context4.next = 43;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 43:
          _context4.prev = 43;
          _context4.next = 46;
          return (0, _effects.put)(act.hideProgressBar());

        case 46:
          return _context4.finish(43);

        case 47:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[10, 39, 43, 47]]);
}

function onChangeOutletIds(request) {
  var _request$payload2, outletIds, params, namespace;

  return _regenerator2.default.wrap(function onChangeOutletIds$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload2 = request.payload, outletIds = _request$payload2.outletIds, params = _request$payload2.params, namespace = _request$payload2.namespace;
          _context5.next = 7;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 7:
          _context5.next = 9;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 9:
          _context5.next = 11;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 11:
          _context5.next = 13;
          return (0, _effects.put)(act.showProgressBar());

        case 13:
          _context5.next = 15;
          return (0, _effects.call)(emptyForm);

        case 15:
          _context5.prev = 15;
          _context5.next = 18;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 18:
          _context5.next = 20;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 20:
          _context5.next = 22;
          return (0, _effects.put)(actInvPO.setSelectedOutlet(outletIds));

        case 22:
          _context5.next = 28;
          break;

        case 24:
          _context5.prev = 24;
          _context5.t0 = _context5['catch'](15);
          _context5.next = 28;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 28:
          _context5.prev = 28;
          _context5.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context5.finish(28);

        case 32:
          _context5.next = 34;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(namespace, params, []));

        case 34:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[15, 24, 28, 32]]);
}

function onChangeDate(request) {
  var _request$payload3, startDate, endDate, params, namespace;

  return _regenerator2.default.wrap(function onChangeDate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload3 = request.payload, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate, params = _request$payload3.params, namespace = _request$payload3.namespace;
          _context6.next = 7;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 7:
          _context6.next = 9;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 9:
          _context6.next = 11;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 11:
          _context6.next = 13;
          return (0, _effects.put)(act.showProgressBar());

        case 13:
          _context6.next = 15;
          return (0, _effects.call)(emptyForm);

        case 15:
          _context6.next = 17;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'date', { startDate: startDate, endDate: endDate }));

        case 17:
          _context6.prev = 17;
          _context6.next = 20;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, { from: startDate.toString(), to: endDate.toString() });

        case 20:
          _context6.next = 26;
          break;

        case 22:
          _context6.prev = 22;
          _context6.t0 = _context6['catch'](17);
          _context6.next = 26;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 26:
          _context6.prev = 26;
          _context6.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context6.finish(26);

        case 30:
          _context6.next = 32;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(namespace, params, []));

        case 32:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[17, 22, 26, 30]]);
}

function onChangeNamespace(request) {
  var _request$payload4, namespace, params;

  return _regenerator2.default.wrap(function onChangeNamespace$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload4 = request.payload, namespace = _request$payload4.namespace, params = _request$payload4.params;
          _context7.next = 7;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 7:
          _context7.next = 9;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 9:
          _context7.next = 11;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 11:
          _context7.next = 13;
          return (0, _effects.put)(actInvPO.onCancelModalAddItem());

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(act.showProgressBar());

        case 15:
          _context7.next = 17;
          return (0, _effects.call)(emptyForm);

        case 17:
          _context7.next = 19;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'namespace', namespace));

        case 19:
          _context7.prev = 19;
          _context7.next = 22;
          return (0, _effects.call)(apiCurrentInventory.putCurrentInventoryDropdown, { current_inventory_dropdown: namespace });

        case 22:
          _context7.next = 28;
          break;

        case 24:
          _context7.prev = 24;
          _context7.t0 = _context7['catch'](19);
          _context7.next = 28;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 28:
          _context7.prev = 28;
          _context7.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context7.finish(28);

        case 32:
          _context7.next = 34;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(namespace, params, []));

        case 34:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[19, 24, 28, 32]]);
}

function onChangeStatus(request) {
  var _request$payload5, namespace, params;

  return _regenerator2.default.wrap(function onChangeStatus$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          // currently we don't use 'status' from request
          _request$payload5 = request.payload, namespace = _request$payload5.namespace, params = _request$payload5.params;
          // delay to prevent too fast ajax

          _context8.next = 7;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 7:
          _context8.next = 9;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 9:
          _context8.next = 11;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 11:
          _context8.next = 13;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 13:
          _context8.next = 15;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(namespace, params, []));

        case 15:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function onChangeKeyword(request) {
  var _request$payload6, namespace, params;

  return _regenerator2.default.wrap(function onChangeKeyword$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 2:
          _context9.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload6 = request.payload, namespace = _request$payload6.namespace, params = _request$payload6.params;
          _context9.next = 7;
          return (0, _effects.put)(actInvPO.setPurchaseOrders([]));

        case 7:
          _context9.next = 9;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 9:
          _context9.next = 11;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 11:
          _context9.next = 13;
          return (0, _effects.put)(actInvPO.purchaseOrderRequest(namespace, params, []));

        case 13:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function exportPurchaseOrder(request) {
  var _request$payload7, _request$payload7$par, namespace, restParams, filename, outletId;

  return _regenerator2.default.wrap(function exportPurchaseOrder$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload7 = request.payload, _request$payload7$par = _request$payload7.params, namespace = _request$payload7$par.namespace, restParams = (0, _objectWithoutProperties3.default)(_request$payload7$par, ['namespace']), filename = _request$payload7.filename, outletId = _request$payload7.outletId;
          _context10.prev = 1;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context10.next = 7;
            break;
          }

          _context10.next = 5;
          return (0, _effects.call)(apiInvPO.getExportPurchaseOrder, restParams);

        case 5:
          _context10.next = 10;
          break;

        case 7:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context10.next = 10;
            break;
          }

          _context10.next = 10;
          return (0, _effects.call)(apiIngInv.getExportPurchaseOrder, restParams);

        case 10:
          _context10.next = 12;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Purchase Order'));

        case 12:
          _context10.next = 18;
          break;

        case 14:
          _context10.prev = 14;
          _context10.t0 = _context10['catch'](1);
          _context10.next = 18;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 18:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[1, 14]]);
}

function onClickRow(request) {
  var _request$payload8, namespace, purchaseOrder, resPO, newIngHistoryDetails, sortedPO;

  return _regenerator2.default.wrap(function onClickRow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload8 = request.payload, namespace = _request$payload8.namespace, purchaseOrder = _request$payload8.purchaseOrder;
          _context11.prev = 1;
          _context11.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          resPO = void 0;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context11.next = 13;
            break;
          }

          _context11.next = 8;
          return (0, _effects.call)(apiInvPO.getPurchaseOrderById, purchaseOrder.id);

        case 8:
          resPO = _context11.sent;
          _context11.next = 11;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(resPO.data));

        case 11:
          _context11.next = 20;
          break;

        case 13:
          _context11.next = 15;
          return (0, _effects.call)(apiIngInv.getPurchaseOrderById, purchaseOrder.id);

        case 15:
          resPO = _context11.sent;
          newIngHistoryDetails = resPO.data.ingredient_history_details.sort(function (a, b) {
            if (a.ingredient_name !== b.ingredient_name) {
              if (a.ingredient_name < b.ingredient_name) {
                return -1;
              } else {
                return 1;
              }
            } else {
              return 0;
            }
          });
          sortedPO = (0, _extends3.default)({}, resPO.data, { ingredient_history_details: newIngHistoryDetails });
          _context11.next = 20;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(sortedPO));

        case 20:
          mpPurchaseOrders.inventoryPOSelect({ purchaseOrder: resPO.data });
          _context11.next = 23;
          return (0, _effects.put)(actInvPO.openRightColumnAsDetail());

        case 23:
          _context11.next = 29;
          break;

        case 25:
          _context11.prev = 25;
          _context11.t0 = _context11['catch'](1);
          _context11.next = 29;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 29:
          _context11.prev = 29;
          _context11.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context11.finish(29);

        case 33:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[1, 25, 29, 33]]);
}

function onClickDone(request) {
  return _regenerator2.default.wrap(function onClickDone$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 2:
          _context12.next = 4;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 4:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function onClickCancel(request) {
  return _regenerator2.default.wrap(function onClickCancel$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 2:
          _context13.next = 4;
          return (0, _effects.call)(emptyForm);

        case 4:
          _context13.next = 6;
          return (0, _effects.put)(actInvPO.closeRightColumn());

        case 6:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function onClickPrint(request) {
  var purchaseOrder;
  return _regenerator2.default.wrap(function onClickPrint$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          purchaseOrder = request.payload.purchaseOrder;

          if (!purchaseOrder.ingredient_history_details) {
            _context14.next = 6;
            break;
          }

          _context14.next = 4;
          return (0, _effects.call)(apiIngInv.printPurchaseOrder, purchaseOrder.id);

        case 4:
          _context14.next = 8;
          break;

        case 6:
          _context14.next = 8;
          return (0, _effects.call)(apiInvPO.printPurchaseOrder, purchaseOrder.id);

        case 8:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function onClickResendEmail(request) {
  var purchaseOrder, resResendEmail;
  return _regenerator2.default.wrap(function onClickResendEmail$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          purchaseOrder = request.payload.purchaseOrder;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context15.next = 6;
          return (0, _effects.call)(apiInvPO.resendEmailPurchaseOrder, purchaseOrder.id);

        case 6:
          resResendEmail = _context15.sent;
          _context15.next = 9;
          return (0, _effects.put)(actNotif.success(resResendEmail.data.message));

        case 9:
          _context15.next = 15;
          break;

        case 11:
          _context15.prev = 11;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 15;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 15:
          _context15.prev = 15;
          _context15.next = 18;
          return (0, _effects.put)(act.hideProgressBar());

        case 18:
          return _context15.finish(15);

        case 19:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 11, 15, 19]]);
}

function onClickCreatePO(request) {
  var outletIds, resSuppliers;
  return _regenerator2.default.wrap(function onClickCreatePO$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 2:
          outletIds = request.payload.outletIds;
          _context16.prev = 3;
          _context16.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context16.next = 8;
          return (0, _effects.call)(apiInvSup.getSuppliers, { with_default: true });

        case 8:
          resSuppliers = _context16.sent;
          _context16.next = 11;
          return (0, _effects.put)(actInvPO.setSuppliers(resSuppliers.data));

        case 11:
          _context16.next = 13;
          return (0, _effects.put)((0, _reduxForm.initialize)('purchaseOrder', {
            outlet: outletIds[0],
            supplierName: '0',
            note: '',
            itemPurchase: []
          }));

        case 13:
          _context16.next = 15;
          return (0, _effects.put)(actInvPO.openRightColumnAsForm());

        case 15:
          _context16.next = 21;
          break;

        case 17:
          _context16.prev = 17;
          _context16.t0 = _context16['catch'](3);
          _context16.next = 21;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 21:
          _context16.prev = 21;
          _context16.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
          return _context16.finish(21);

        case 25:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[3, 17, 21, 25]]);
}

function updatePurchaseOrder(request) {
  var _request$payload9, purchaseOrder, status;

  return _regenerator2.default.wrap(function updatePurchaseOrder$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _request$payload9 = request.payload, purchaseOrder = _request$payload9.purchaseOrder, status = _request$payload9.status;
          _context17.prev = 1;
          _context17.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          purchaseOrder.status = status;

          if (!purchaseOrder.ingredient_history_details) {
            _context17.next = 10;
            break;
          }

          _context17.next = 8;
          return (0, _effects.call)(apiIngInv.updateDataPO, purchaseOrder.id, { ingredient_purchase_order: purchaseOrder });

        case 8:
          _context17.next = 12;
          break;

        case 10:
          _context17.next = 12;
          return (0, _effects.call)(apiInvPO.updateDataPO, purchaseOrder.id, { purchase_order: purchaseOrder });

        case 12:
          if (!(status === 'Fulfilled')) {
            _context17.next = 17;
            break;
          }

          _context17.next = 15;
          return (0, _effects.put)(actNotif.success('Purchase order has been mark as fulfilled'));

        case 15:
          _context17.next = 20;
          break;

        case 17:
          if (!(status === 'Cancelled')) {
            _context17.next = 20;
            break;
          }

          _context17.next = 20;
          return (0, _effects.put)(actNotif.success('Purchase order has been mark as cancelled'));

        case 20:
          mpPurchaseOrders.inventoryPOUpdateStatus({ purchaseOrder: purchaseOrder, status: status });
          _context17.next = 23;
          return (0, _effects.put)(actInvPO.pageRequest());

        case 23:
          _context17.next = 29;
          break;

        case 25:
          _context17.prev = 25;
          _context17.t0 = _context17['catch'](1);
          _context17.next = 29;
          return (0, _effects.put)(actNotif.error(_context17.t0.message));

        case 29:
          _context17.prev = 29;
          _context17.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context17.finish(29);

        case 33:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[1, 25, 29, 33]]);
}

function getItemsfromAPI(request) {
  var _request$payload$para, previousItems, first, namespace, restParams, resItems, items;

  return _regenerator2.default.wrap(function getItemsfromAPI$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _request$payload$para = request.payload.params, previousItems = _request$payload$para.previousItems, first = _request$payload$para.first, namespace = _request$payload$para.namespace, restParams = (0, _objectWithoutProperties3.default)(_request$payload$para, ['previousItems', 'first', 'namespace']);
          _context18.next = 3;
          return (0, _effects.put)(actInvPO.isLoadingItem(true));

        case 3:
          _context18.next = 5;
          return (0, _effects.put)(actInvPO.setAddedItem(null));

        case 5:
          _context18.next = 7;
          return (0, _effects.put)(actInvPO.setIsItemAdded(false));

        case 7:
          _context18.next = 9;
          return (0, _effects.put)(actInvPO.setDataSearch([]));

        case 9:
          if (!restParams.keyword) {
            _context18.next = 12;
            break;
          }

          _context18.next = 12;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 12:
          _context18.prev = 12;
          resItems = null;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context18.next = 20;
            break;
          }

          _context18.next = 17;
          return (0, _effects.call)(apiItems.getItemsV1, restParams);

        case 17:
          resItems = _context18.sent;
          _context18.next = 23;
          break;

        case 20:
          _context18.next = 22;
          return (0, _effects.call)(apiIngredients.getAll, restParams);

        case 22:
          resItems = _context18.sent;

        case 23:
          items = {
            results: resItems.data,
            total_pages: 9999,
            total_counts: 0
          };

          if (!first) {
            _context18.next = 27;
            break;
          }

          _context18.next = 27;
          return (0, _effects.put)(actInvPO.setFirstItems(items));

        case 27:
          if (restParams.page > 1) {
            if (items.results.length === 0) {
              items.total_pages = restParams.page - 1;
              items.currentPage = restParams.page - 1;
            } else {
              items.currentPage = restParams.page;
            }
            items.results = previousItems.concat(items.results);
          } else {
            items.currentPage = 1;
          }
          _context18.next = 30;
          return (0, _effects.put)(actInvPO.setDataSearch(items));

        case 30:
          _context18.next = 36;
          break;

        case 32:
          _context18.prev = 32;
          _context18.t0 = _context18['catch'](12);
          _context18.next = 36;
          return (0, _effects.put)(actNotif.error(_context18.t0.message));

        case 36:
          _context18.prev = 36;
          _context18.next = 39;
          return (0, _effects.put)(actInvPO.isLoadingItem(false));

        case 39:
          return _context18.finish(36);

        case 40:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this, [[12, 32, 36, 40]]);
}

function ignoreRp(value, namespace) {
  if (namespace === _constants2.NAMESPACE_ITEMS) {
    return value.replace(/[^\d]/g, '');
  } else {
    return value;
  }
}

function setModalItemForm(request) {
  var _request$payload10, namespace, data, itemPurchase, itemPurchaseMap, isItemExist, itemVars;

  return _regenerator2.default.wrap(function setModalItemForm$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _request$payload10 = request.payload, namespace = _request$payload10.namespace, data = _request$payload10.data, itemPurchase = _request$payload10.itemPurchase;
          itemPurchaseMap = [];
          isItemExist = false;
          itemVars = [];

          if (namespace === _constants2.NAMESPACE_ITEMS) {
            itemPurchaseMap = _lodash2.default.mapKeys(itemPurchase, function (value, key) {
              return value.item_id.toString();
            });
            if (itemPurchaseMap[data.id]) {
              isItemExist = true;
            } else {
              itemVars = data.item_variants.map(function (iv) {
                var unitcost = itemPurchaseMap[iv.id] ? itemPurchaseMap[iv.id].unitcost : '0';
                var total = 0 * unitcost;
                return {
                  item_var_name: iv.name,
                  item_var_id: iv.id,
                  instock: iv.in_stock,
                  order: '0',
                  unitcost: unitcost,
                  item_name: data.name,
                  item_id: data.id,
                  is_item: data.item_variants.length === 1 && iv.name === '',
                  total: (0, _formatter.rupiah)(total)
                };
              });
            }
          } else {
            itemPurchaseMap = _lodash2.default.mapKeys(itemPurchase, function (value, key) {
              return value.item_id.toString();
            });
            if (itemPurchaseMap[data.id]) {
              isItemExist = true;
            }
            itemVars = [{
              item_var_name: data.unit_name,
              item_var_id: data.unit_id,
              instock: data.in_stock,
              order: '0',
              unitcost: '0',
              item_name: data.name,
              item_id: data.id,
              is_item: false,
              total: (0, _formatter.rupiah)(0),
              category_name: data.category_name,
              category_id: data.ingredient_category_id
            }];
          }
          _context19.next = 7;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItemPurchase', {
            header: '',
            items: !isItemExist ? itemVars : []
          }));

        case 7:
          _context19.next = 9;
          return (0, _effects.put)(actInvPO.setAddedItem(!isItemExist ? data : null));

        case 9:
          _context19.next = 11;
          return (0, _effects.put)(actInvPO.setIsItemAdded(isItemExist));

        case 11:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function addItemToForm(request) {
  var _request$payload11, items, formPO, namespace, itemIdsOrderCounter, itemIdsOrder, newPOObjectvarianItemList, newItemPurchase, i;

  return _regenerator2.default.wrap(function addItemToForm$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _request$payload11 = request.payload, items = _request$payload11.itemVariantValue.items, formPO = _request$payload11.formPO, namespace = _request$payload11.namespace;
          // grouping items

          itemIdsOrderCounter = 0;
          itemIdsOrder = {};
          // order itemIds based of

          formPO.forEach(function (PO) {
            if (!itemIdsOrder[PO.item_id]) {
              itemIdsOrder[PO.item_id] = ++itemIdsOrderCounter;
            }
          });
          items.forEach(function (item) {
            if (!itemIdsOrder[item.item_id]) {
              itemIdsOrder[item.item_id] = ++itemIdsOrderCounter;
            }
          });

          // data merging
          newPOObjectvarianItemList = {};

          if (namespace === _constants2.NAMESPACE_INGREDIENTS) {
            formPO.forEach(function (PO) {
              newPOObjectvarianItemList[PO.item_id] = PO;
            });

            items.forEach(function (item) {
              newPOObjectvarianItemList[item.item_id] = item;
              newPOObjectvarianItemList[item.item_id].unitcost = '' + item.unitcost === '' ? '0' : ignoreRp(item.unitcost, namespace);
              newPOObjectvarianItemList[item.item_id].order = '' + item.order === '' ? '0' : ignoreRp(item.order, namespace);
            });
          } else if (namespace === _constants2.NAMESPACE_ITEMS) {
            formPO.forEach(function (PO) {
              newPOObjectvarianItemList[PO.item_var_id] = PO;
            });

            items.forEach(function (item) {
              newPOObjectvarianItemList[item.item_var_id] = item;
              newPOObjectvarianItemList[item.item_var_id].unitcost = '' + item.unitcost === '' ? '0' : ignoreRp(item.unitcost, namespace);
              newPOObjectvarianItemList[item.item_var_id].order = '' + item.order === '' ? '0' : ignoreRp(item.order, namespace);
            });
          }

          // convert to array
          newItemPurchase = [];


          (0, _keys2.default)(newPOObjectvarianItemList).forEach(function (key) {
            newItemPurchase.push(newPOObjectvarianItemList[key]);
          });
          newItemPurchase = newItemPurchase.sort(function (a, b) {
            if (itemIdsOrder[a.item_id] !== itemIdsOrder[b.item_id]) {
              if (itemIdsOrder[a.item_id] < itemIdsOrder[b.item_id]) {
                return -1;
              } else {
                return 1;
              }
            } else if (a.position !== b.position) {
              if (a.position < b.position) {
                return -1;
              } else {
                return 1;
              }
            } else {
              return 0;
            }
          });

          _context20.next = 12;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('purchaseOrder', 'itemPurchase'));

        case 12:
          i = 0;

        case 13:
          if (!(i < newItemPurchase.length)) {
            _context20.next = 19;
            break;
          }

          _context20.next = 16;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('purchaseOrder', 'itemPurchase', newItemPurchase[i]));

        case 16:
          i++;
          _context20.next = 13;
          break;

        case 19:
          _context20.next = 21;
          return (0, _effects.put)(actInvPO.onCancelModalAddItem());

        case 21:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}
function onCancelModalAddItem() {
  return _regenerator2.default.wrap(function onCancelModalAddItem$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.put)(actInvPO.closeModalItemPurchase());

        case 2:
          _context21.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('addItemPurchase', {
            items: []
          }));

        case 4:
          _context21.next = 6;
          return (0, _effects.put)(actInvPO.setIsItemAdded(false));

        case 6:
          _context21.next = 8;
          return (0, _effects.put)(actInvPO.setAddedItem(null));

        case 8:
          _context21.next = 10;
          return (0, _effects.put)(actInvPO.setFirstItems([]));

        case 10:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function createPO(request) {
  var _request$payload12, namespace, data, date, reqPayload;

  return _regenerator2.default.wrap(function createPO$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _request$payload12 = request.payload, namespace = _request$payload12.namespace, data = _request$payload12.data, date = _request$payload12.date;
          reqPayload = {};

          if (namespace === _constants2.NAMESPACE_ITEMS) {
            reqPayload = {
              purchase_order: {
                outlet_id: data.outlet,
                note: data.note,
                status: 'Created',
                supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
                total: 0,
                history_details: [],
                history_details_attributes: []
              }
            };
            data.itemPurchase.forEach(function (item) {
              reqPayload.purchase_order.total += parseInt(item.order) * parseInt(item.unitcost);
              if (parseInt(item.order) > 0) {
                var itemPO = {
                  beginning_stock: item.instock,
                  end_stock: item.instock + parseInt(item.order),
                  item_id: item.item_id,
                  item_name: item.item_name,
                  item_variant_id: item.item_var_id,
                  item_variant_name: item.item_var_name,
                  price: item.unitcost,
                  quantity: item.order
                };
                reqPayload.purchase_order.history_details_attributes.push(itemPO);
              }
            });
            reqPayload.purchase_order.history_details = reqPayload.purchase_order.history_details_attributes;
          } else {
            reqPayload = {
              ingredient_purchase_order: {
                outlet_id: data.outlet,
                note: data.note,
                status: 'Created',
                supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
                total: 0,
                ingredient_history_details: [],
                ingredient_history_details_attributes: []
              }
            };
            data.itemPurchase.forEach(function (ingredient) {
              reqPayload.ingredient_purchase_order.total += Math.round(parseFloat(ingredient.order) * parseInt(ingredient.unitcost));
              if (parseFloat(ingredient.order) > 0) {
                var itemPO = {
                  beginning_stock: ingredient.instock,
                  end_stock: ingredient.instock + parseFloat(ingredient.order),
                  ingredient_category_id: ingredient.category_id,
                  ingredient_category_name: ingredient.category_name,
                  ingredient_id: ingredient.item_id,
                  ingredient_name: ingredient.item_name,
                  unit_id: ingredient.item_var_id,
                  unit_name: ingredient.item_var_name,
                  unit_price: ingredient.unitcost,
                  total_price: Math.round(parseFloat(ingredient.order) * parseInt(ingredient.unitcost)),
                  quantity: ingredient.order
                };
                reqPayload.ingredient_purchase_order.ingredient_history_details_attributes.push(itemPO);
              }
            });
            reqPayload.ingredient_purchase_order.ingredient_history_details = reqPayload.ingredient_purchase_order.ingredient_history_details_attributes;
          }
          _context22.prev = 3;
          _context22.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context22.next = 11;
            break;
          }

          _context22.next = 9;
          return (0, _effects.call)(apiIngInv.postPurchaseOrder, reqPayload);

        case 9:
          _context22.next = 13;
          break;

        case 11:
          _context22.next = 13;
          return (0, _effects.call)(apiInvPO.postPurchaseOrder, reqPayload);

        case 13:
          _context22.next = 15;
          return (0, _effects.put)(actNotif.success('Purchase order has been created'));

        case 15:
          _context22.next = 17;
          return (0, _effects.call)(emptyForm);

        case 17:
          if ((0, _moment2.default)().isBetween(date.startDate, date.endDate, 'day', '[]')) {
            _context22.next = 20;
            break;
          }

          _context22.next = 20;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, {
            from: (0, _moment2.default)().format('D/M/YYYY'),
            to: (0, _moment2.default)().format('D/M/YYYY')
          });

        case 20:
          _context22.next = 22;
          return (0, _effects.put)(actInvPO.pageRequest());

        case 22:
          _context22.next = 28;
          break;

        case 24:
          _context22.prev = 24;
          _context22.t0 = _context22['catch'](3);
          _context22.next = 28;
          return (0, _effects.put)(actNotif.error(_context22.t0.message));

        case 28:
          _context22.prev = 28;
          _context22.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context22.finish(28);

        case 32:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this, [[3, 24, 28, 32]]);
}

function createFulfilledPO(request) {
  var _request$payload13, namespace, data, date, reqPayload;

  return _regenerator2.default.wrap(function createFulfilledPO$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _request$payload13 = request.payload, namespace = _request$payload13.namespace, data = _request$payload13.data, date = _request$payload13.date;
          reqPayload = {};

          if (namespace === _constants2.NAMESPACE_ITEMS) {
            reqPayload = {
              purchase_order: {
                outlet_id: data.outlet,
                note: data.note,
                status: 'Created',
                supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
                total: 0,
                history_details: [],
                history_details_attributes: []
              }
            };
            data.itemPurchase.forEach(function (item) {
              reqPayload.purchase_order.total += parseInt(item.order) * parseInt(item.unitcost);
              if (parseInt(item.order) > 0) {
                var itemPO = {
                  beginning_stock: item.instock,
                  end_stock: item.instock + parseInt(item.order),
                  item_id: item.item_id,
                  item_name: item.item_name,
                  item_variant_id: item.item_var_id,
                  item_variant_name: item.item_var_name,
                  price: item.unitcost,
                  quantity: item.order
                };
                reqPayload.purchase_order.history_details_attributes.push(itemPO);
              }
            });
            reqPayload.purchase_order.history_details = reqPayload.purchase_order.history_details_attributes;
          } else {
            reqPayload = {
              ingredient_purchase_order: {
                outlet_id: data.outlet,
                note: data.note,
                status: 'Created',
                supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
                total: 0,
                ingredient_history_details: [],
                ingredient_history_details_attributes: []
              }
            };
            data.itemPurchase.forEach(function (ingredient) {
              reqPayload.ingredient_purchase_order.total += Math.round(parseFloat(ingredient.order) * parseFloat(ingredient.unitcost));
              if (parseInt(ingredient.order) > 0) {
                var itemPO = {
                  beginning_stock: ingredient.instock,
                  end_stock: ingredient.instock + parseInt(ingredient.order),
                  ingredient_category_id: ingredient.category_id,
                  ingredient_category_name: ingredient.category_name,
                  ingredient_id: ingredient.item_id,
                  ingredient_name: ingredient.item_name,
                  unit_id: ingredient.item_var_id,
                  unit_name: ingredient.item_var_name,
                  unit_price: ingredient.unitcost,
                  total_price: parseInt(ingredient.order) * parseInt(ingredient.unitcost),
                  quantity: ingredient.order
                };
                reqPayload.ingredient_purchase_order.ingredient_history_details_attributes.push(itemPO);
              }
            });
            reqPayload.ingredient_purchase_order.ingredient_history_details = reqPayload.ingredient_purchase_order.ingredient_history_details_attributes;
          }
          _context23.prev = 3;
          _context23.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context23.next = 11;
            break;
          }

          _context23.next = 9;
          return (0, _effects.call)(apiIngInv.createAndfullfilled, reqPayload);

        case 9:
          _context23.next = 13;
          break;

        case 11:
          _context23.next = 13;
          return (0, _effects.call)(apiInvPO.createAndfullfilled, reqPayload);

        case 13:
          _context23.next = 15;
          return (0, _effects.put)(actNotif.success('Purchase order has been created and mark as fulfilled'));

        case 15:
          _context23.next = 17;
          return (0, _effects.call)(emptyForm);

        case 17:
          if ((0, _moment2.default)().isBetween(date.startDate, date.endDate, 'day', '[]')) {
            _context23.next = 20;
            break;
          }

          _context23.next = 20;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, {
            from: (0, _moment2.default)().format('D/M/YYYY'),
            to: (0, _moment2.default)().format('D/M/YYYY')
          });

        case 20:
          _context23.next = 22;
          return (0, _effects.put)(actInvPO.pageRequest());

        case 22:
          _context23.next = 28;
          break;

        case 24:
          _context23.prev = 24;
          _context23.t0 = _context23['catch'](3);
          _context23.next = 28;
          return (0, _effects.put)(actNotif.error(_context23.t0.message));

        case 28:
          _context23.prev = 28;
          _context23.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context23.finish(28);

        case 32:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this, [[3, 24, 28, 32]]);
}

function editPO(request) {
  var _request$payload14, namespace, data, reqPayload;

  return _regenerator2.default.wrap(function editPO$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _request$payload14 = request.payload, namespace = _request$payload14.namespace, data = _request$payload14.data;
          reqPayload = {};

          if (namespace === _constants2.NAMESPACE_ITEMS) {
            reqPayload = {
              purchase_order: data.purchase_order
            };
            reqPayload.purchase_order.total = 0;
            reqPayload.purchase_order.note = data.note;
            reqPayload.purchase_order.status = 'Created';
            reqPayload.purchase_order.history_details_attributes = [];
            data.itemPurchase.forEach(function (item) {
              reqPayload.purchase_order.total += parseInt(item.order) * parseInt(item.unitcost);
              if (parseInt(item.order) > 0) {
                var itemPO = {};
                if (item.item_var_name !== '') {
                  itemPO = {
                    beginning_stock: parseInt(item.instock),
                    end_stock: parseInt(item.instock) + parseInt(item.order),
                    item_id: item.item_id,
                    item_variant_id: item.item_var_id,
                    item_variant_name: item.item_var_name,
                    price: item.unitcost,
                    quantity: item.order
                  };
                } else {
                  itemPO = {
                    beginning_stock: parseInt(item.instock),
                    end_stock: parseInt(item.instock) + parseInt(item.order),
                    item_id: item.item_id,
                    item_name: item.item_name,
                    item_variant_id: item.item_var_id,
                    item_variant_name: item.item_name,
                    price: item.unitcost,
                    quantity: item.order
                  };
                }
                reqPayload.purchase_order.history_details_attributes.push(itemPO);
              }
            });
            reqPayload.purchase_order.history_details = reqPayload.purchase_order.history_details_attributes;
          } else {
            reqPayload = {
              ingredient_purchase_order: data.purchase_order
            };
            reqPayload.ingredient_purchase_order.total = 0;
            reqPayload.ingredient_purchase_order.note = data.note;
            reqPayload.ingredient_purchase_order.status = 'Created';
            reqPayload.ingredient_purchase_order.ingredient_history_details_attributes = [];
            data.itemPurchase.forEach(function (ingredient, idx) {
              reqPayload.ingredient_purchase_order.total += parseInt(ingredient.order) * parseInt(ingredient.unitcost);
              if (parseInt(ingredient.order) > 0) {
                var ingredientPO = {
                  beginning_stock: parseInt(ingredient.instock),
                  end_stock: parseInt(ingredient.instock) + parseInt(ingredient.order),
                  ingredient_category_id: ingredient.category_id,
                  ingredient_category_name: ingredient.category_name,
                  ingredient_id: ingredient.item_id,
                  ingredient_name: ingredient.item_name,
                  unit_id: ingredient.item_var_id,
                  unit_name: ingredient.item_var_name,
                  unit_price: ingredient.unitcost,
                  quantity: ingredient.order,
                  total_price: parseInt(ingredient.order) * parseInt(ingredient.unitcost)
                };
                reqPayload.ingredient_purchase_order.ingredient_history_details_attributes.push(ingredientPO);
              }
            });
            reqPayload.ingredient_purchase_order.ingredient_history_details = reqPayload.ingredient_purchase_order.ingredient_history_details_attributes;
          }
          _context24.prev = 3;
          _context24.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context24.next = 11;
            break;
          }

          _context24.next = 9;
          return (0, _effects.call)(apiIngInv.updateDataPO, reqPayload.ingredient_purchase_order.id, reqPayload);

        case 9:
          _context24.next = 13;
          break;

        case 11:
          _context24.next = 13;
          return (0, _effects.call)(apiInvPO.updateDataPO, reqPayload.purchase_order.id, reqPayload);

        case 13:
          _context24.next = 15;
          return (0, _effects.put)(actNotif.success('Purchase order has been updated'));

        case 15:
          _context24.next = 17;
          return (0, _effects.put)(actInvPO.setPurchaseOrderDetail(null));

        case 17:
          _context24.next = 19;
          return (0, _effects.call)(emptyForm);

        case 19:
          _context24.next = 21;
          return (0, _effects.put)(actInvPO.pageRequest());

        case 21:
          _context24.next = 27;
          break;

        case 23:
          _context24.prev = 23;
          _context24.t0 = _context24['catch'](3);
          _context24.next = 27;
          return (0, _effects.put)(actNotif.error(_context24.t0.message));

        case 27:
          _context24.prev = 27;
          _context24.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          return _context24.finish(27);

        case 31:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this, [[3, 23, 27, 31]]);
}

function onClickEdit(request) {
  var purchaseOrder, resSuppliers, purchaseO, itemVars, _purchaseO, _itemVars;

  return _regenerator2.default.wrap(function onClickEdit$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          purchaseOrder = request.payload.purchaseOrder;
          _context25.prev = 1;
          _context25.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context25.next = 6;
          return (0, _effects.call)(apiInvSup.getSuppliers, { with_default: true });

        case 6:
          resSuppliers = _context25.sent;

          if (!purchaseOrder.ingredient_history_details) {
            _context25.next = 20;
            break;
          }

          _context25.next = 10;
          return (0, _effects.call)(apiIngInv.getEditDataPO, purchaseOrder.id);

        case 10:
          purchaseO = _context25.sent;
          _context25.next = 13;
          return (0, _effects.put)(actInvPO.setSuppliers(resSuppliers.data));

        case 13:
          itemVars = purchaseO.data.ingredient_history_details.map(function (iv) {
            return {
              item_var_name: iv.unit_name,
              item_var_id: iv.unit_id,
              instock: iv.beginning_stock,
              order: iv.quantity + '',
              unitcost: iv.unit_price + '',
              item_name: iv.ingredient_name,
              item_id: iv.ingredient_id,
              is_item: false,
              category_id: iv.ingredient_category_id,
              category_name: iv.ingredient_category_name,
              total: (0, _formatter.rupiah)(iv.quantity * iv.unit_price)
            };
          });
          _context25.next = 16;
          return (0, _effects.put)((0, _reduxForm.initialize)('purchaseOrder', {
            outlet: purchaseOrder.outlet.id,
            supplierName: purchaseOrder.supplier_id,
            note: purchaseOrder.note,
            itemPurchase: itemVars,
            purchase_order: purchaseO.data
          }));

        case 16:
          _context25.next = 18;
          return (0, _effects.put)(actInvPO.openRightColumnAsForm());

        case 18:
          _context25.next = 30;
          break;

        case 20:
          _context25.next = 22;
          return (0, _effects.call)(apiInvPO.getEditDataPO, purchaseOrder.id);

        case 22:
          _purchaseO = _context25.sent;
          _context25.next = 25;
          return (0, _effects.put)(actInvPO.setSuppliers(resSuppliers.data));

        case 25:
          _itemVars = _purchaseO.data.unfulfilled_history_details.map(function (iv) {
            return {
              item_var_name: iv.item_variant_name,
              item_var_id: iv.item_variant_id,
              instock: iv.beginning_stock,
              order: iv.quantity + '',
              unitcost: iv.price + '',
              item_name: iv.item_name,
              item_id: iv.item_id,
              is_item: iv.is_item,
              total: (0, _formatter.rupiah)(iv.quantity * iv.price)
            };
          });
          _context25.next = 28;
          return (0, _effects.put)((0, _reduxForm.initialize)('purchaseOrder', {
            outlet: purchaseOrder.outlet.id,
            supplierName: purchaseOrder.supplier_id,
            note: purchaseOrder.note,
            itemPurchase: _itemVars,
            purchase_order: _purchaseO.data
          }));

        case 28:
          _context25.next = 30;
          return (0, _effects.put)(actInvPO.openRightColumnAsForm());

        case 30:
          _context25.next = 36;
          break;

        case 32:
          _context25.prev = 32;
          _context25.t0 = _context25['catch'](1);
          _context25.next = 36;
          return (0, _effects.put)(actNotif.error(_context25.t0.message));

        case 36:
          _context25.prev = 36;
          _context25.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          return _context25.finish(36);

        case 40:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this, [[1, 32, 36, 40]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_PAGE_REQUEST, pageRequest);

        case 2:
          _context26.next = 4;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST, purchaseOrderRequest);

        case 4:
          _context26.next = 6;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 6:
          _context26.next = 8;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE, onChangeDate);

        case 8:
          _context26.next = 10;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE, onChangeNamespace);

        case 10:
          _context26.next = 12;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS, onChangeStatus);

        case 12:
          _context26.next = 14;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD, onChangeKeyword);

        case 14:
          _context26.next = 16;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER, exportPurchaseOrder);

        case 16:
          _context26.next = 18;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW, onClickRow);

        case 18:
          _context26.next = 20;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE, onClickDone);

        case 20:
          _context26.next = 22;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL, onClickCancel);

        case 22:
          _context26.next = 24;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT, onClickPrint);

        case 24:
          _context26.next = 26;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO, onClickCreatePO);

        case 26:
          _context26.next = 28;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER, updatePurchaseOrder);

        case 28:
          _context26.next = 30;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API, getItemsfromAPI);

        case 30:
          _context26.next = 32;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM, setModalItemForm);

        case 32:
          _context26.next = 34;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM, addItemToForm);

        case 34:
          _context26.next = 36;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM, onCancelModalAddItem);

        case 36:
          _context26.next = 38;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER, createPO);

        case 38:
          _context26.next = 40;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER, createFulfilledPO);

        case 40:
          _context26.next = 42;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER, editPO);

        case 42:
          _context26.next = 44;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM, onchangeOutletForm);

        case 44:
          _context26.next = 46;
          return (0, _effects.takeLatest)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT, onClickEdit);

        case 46:
          _context26.next = 48;
          return (0, _effects.takeEvery)(_constants.INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL, onClickResendEmail);

        case 48:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this);
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

exports.summaryRequestFlow = summaryRequestFlow;
exports.pageRequest = pageRequest;
exports.onChangeOutletIdsFlow = onChangeOutletIdsFlow;
exports.onChangeDate = onChangeDate;
exports.onChangeKeyword = onChangeKeyword;
exports.onChangeNamespace = onChangeNamespace;
exports.ingInvSummaryRequest = ingInvSummaryRequest;
exports.exportSummary = exportSummary;
exports.default = saga;

var _constants = __webpack_require__(402);

var _summary = __webpack_require__(234);

var actInvSummary = _interopRequireWildcard(_summary);

var _effects = __webpack_require__(22);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _summary2 = __webpack_require__(1101);

var apiInvSummary = _interopRequireWildcard(_summary2);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getFilteredDate = __webpack_require__(171);

var apiGetFilteredDate = _interopRequireWildcard(_getFilteredDate);

var _reduxForm = __webpack_require__(7);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _currentInventoryDropdown = __webpack_require__(288);

var apiCurrentInventory = _interopRequireWildcard(_currentInventoryDropdown);

var _loadingSpinner = __webpack_require__(46);

var _getSubscriptionStatus = __webpack_require__(289);

var _ingredientInventory = __webpack_require__(1088);

var apiIngInvSummary = _interopRequireWildcard(_ingredientInventory);

var _ingredientSubscription = __webpack_require__(233);

var _constants2 = __webpack_require__(81);

var _summary3 = __webpack_require__(651);

var mpInvSummary = _interopRequireWildcard(_summary3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [summaryRequestFlow, pageRequest, onChangeOutletIdsFlow, onChangeDate, onChangeKeyword, onChangeNamespace, ingInvSummaryRequest, exportSummary, saga].map(_regenerator2.default.mark);

function mapItemsToRowItems(items) {
  var rows = [];
  items.forEach(function (item) {
    if (item.has_item_variants) {
      // push parent
      rows.push({
        item_name: item.item_name,
        category: item.category,
        outlet: item.outlet,
        isParent: true,
        hasChildren: true
      });
      item.item_variants.forEach(function (itemVariant) {
        rows.push((0, _extends3.default)({}, itemVariant, {
          isParent: false
        }));
      });
    } else {
      rows.push((0, _extends3.default)({}, item.item_variants[0], {
        item_name: item.item_name,
        category: item.category,
        outlet: item.outlet,
        isParent: true,
        hasChildren: false
      }));
    }
  });
  return rows;
}

function summaryRequestFlow(request) {
  var _request$payload, params, previousItems, previousRowItems, resSummary, items, newItems, newRowItems;

  return _regenerator2.default.wrap(function summaryRequestFlow$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousItems = _request$payload.previousItems, previousRowItems = _request$payload.previousRowItems;
          _context.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(apiInvSummary.getSummary, params);

        case 6:
          resSummary = _context.sent;
          items = resSummary.data.results;
          newItems = previousItems.concat(items);
          newRowItems = previousRowItems.concat(mapItemsToRowItems(items));
          _context.next = 12;
          return (0, _effects.put)(actInvSummary.setItems(newItems));

        case 12:
          _context.next = 14;
          return (0, _effects.put)(actInvSummary.setRowItems(newRowItems));

        case 14:
          _context.next = 16;
          return (0, _effects.put)(actInvSummary.setCurrentPage(params.page));

        case 16:
          _context.next = 18;
          return (0, _effects.put)(actInvSummary.setTotalPage(resSummary.data.total_pages));

        case 18:
          _context.next = 24;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context['catch'](3);
          _context.next = 24;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 24:
          _context.prev = 24;
          _context.next = 27;
          return (0, _effects.put)(act.hideProgressBar());

        case 27:
          _context.next = 29;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 29:
          return _context.finish(24);

        case 30:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[3, 20, 24, 30]]);
}

function pageRequest() {
  var response, resProfile, resGetFilteredDate, startDate, endDate, resCurrentInventoryDropdown, currentInventoryDropdown;
  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actInvSummary.setItems([]));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(actInvSummary.setRowItems([]));

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(actInvSummary.setIngredients([]));

        case 6:
          _context2.next = 8;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 8:
          _context2.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context2.prev = 10;
          _context2.next = 13;
          return (0, _effects.call)(apiOutlets.outlets);

        case 13:
          response = _context2.sent;
          _context2.next = 16;
          return (0, _effects.put)(actInvSummary.setOutlets(response.data));

        case 16:
          _context2.next = 18;
          return (0, _effects.call)(apiProfile.getProfile);

        case 18:
          resProfile = _context2.sent;
          _context2.next = 21;
          return (0, _effects.call)(apiGetFilteredDate.getFilteredDate);

        case 21:
          resGetFilteredDate = _context2.sent;
          startDate = (0, _moment2.default)(resGetFilteredDate.data.start_date);
          endDate = (0, _moment2.default)(resGetFilteredDate.data.end_date);
          _context2.next = 26;
          return (0, _effects.call)(apiCurrentInventory.getCurrentInventoryDropdown);

        case 26:
          resCurrentInventoryDropdown = _context2.sent;
          currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown;

          if (!(currentInventoryDropdown !== 'ingredients')) {
            _context2.next = 33;
            break;
          }

          _context2.next = 31;
          return (0, _effects.put)(actInvSummary.summaryRequest({
            page: 1,
            start_date: resGetFilteredDate.data.start_date,
            end_date: resGetFilteredDate.data.end_date
          }, [], [], currentInventoryDropdown));

        case 31:
          _context2.next = 35;
          break;

        case 33:
          _context2.next = 35;
          return (0, _effects.put)(actInvSummary.ingInvSummaryRequest({
            page: 1,
            start_date: resGetFilteredDate.data.start_date,
            end_date: resGetFilteredDate.data.end_date
          }, [], currentInventoryDropdown));

        case 35:
          _context2.next = 37;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: resProfile.data.outlet_id,
            date: { startDate: startDate, endDate: endDate },
            namespace: currentInventoryDropdown
          }));

        case 37:
          mpInvSummary.inventorySummaryStart({
            outletIds: resProfile.data.outlet_id,
            startDate: startDate,
            endDate: endDate,
            namespace: currentInventoryDropdown
          });

          _context2.next = 40;
          return (0, _effects.put)((0, _ingredientSubscription.subscriptionStatus)());

        case 40:
          _context2.next = 46;
          break;

        case 42:
          _context2.prev = 42;
          _context2.t0 = _context2['catch'](10);
          _context2.next = 46;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 46:
          _context2.prev = 46;
          _context2.next = 49;
          return (0, _effects.put)(act.hideProgressBar());

        case 49:
          return _context2.finish(46);

        case 50:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[10, 42, 46, 50]]);
}

function onChangeOutletIdsFlow(request) {
  var _request$payload2, outletIds, startDate, endDate, namespace;

  return _regenerator2.default.wrap(function onChangeOutletIdsFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actInvSummary.setRowItems([]));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(actInvSummary.setIngredients([]));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload2 = request.payload, outletIds = _request$payload2.outletIds, startDate = _request$payload2.startDate, endDate = _request$payload2.endDate, namespace = _request$payload2.namespace;
          _context3.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context3.prev = 9;
          _context3.next = 12;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 12:
          _context3.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: outletIds,
            date: { startDate: startDate, endDate: endDate },
            namespace: namespace
          }));

        case 14:
          _context3.next = 20;
          break;

        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3['catch'](9);
          _context3.next = 20;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 20:
          _context3.prev = 20;
          _context3.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          return _context3.finish(20);

        case 24:
          if (!(namespace !== 'ingredients')) {
            _context3.next = 29;
            break;
          }

          _context3.next = 27;
          return (0, _effects.put)(actInvSummary.summaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, [], []));

        case 27:
          _context3.next = 31;
          break;

        case 29:
          _context3.next = 31;
          return (0, _effects.put)(actInvSummary.ingInvSummaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, []));

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[9, 16, 20, 24]]);
}

function onChangeDate(request) {
  var _request$payload3, keyword, startDate, endDate, namespace;

  return _regenerator2.default.wrap(function onChangeDate$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actInvSummary.setRowItems([]));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)(actInvSummary.setIngredients([]));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload3 = request.payload, keyword = _request$payload3.keyword, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate, namespace = _request$payload3.namespace;

          if (!(namespace !== 'ingredients')) {
            _context4.next = 12;
            break;
          }

          _context4.next = 10;
          return (0, _effects.put)(actInvSummary.summaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
            keyword: keyword
          }, [], [], namespace));

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.put)(actInvSummary.ingInvSummaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
            keyword: keyword
          }, [], namespace));

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function onChangeKeyword(request) {
  var _request$payload4, keyword, startDate, endDate, namespace;

  return _regenerator2.default.wrap(function onChangeKeyword$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actInvSummary.setRowItems([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(actInvSummary.setIngredients([]));

        case 4:
          _context5.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload4 = request.payload, keyword = _request$payload4.keyword, startDate = _request$payload4.startDate, endDate = _request$payload4.endDate, namespace = _request$payload4.namespace;

          if (!(namespace !== 'ingredients')) {
            _context5.next = 12;
            break;
          }

          _context5.next = 10;
          return (0, _effects.put)(actInvSummary.summaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
            keyword: keyword
          }, [], []));

        case 10:
          _context5.next = 14;
          break;

        case 12:
          _context5.next = 14;
          return (0, _effects.put)(actInvSummary.ingInvSummaryRequest({
            page: 1,
            start_date: (0, _moment2.default)(startDate).format('YYYY/MM/DD'),
            end_date: (0, _moment2.default)(endDate).format('YYYY/MM/DD'),
            keyword: keyword
          }, [], namespace));

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function onChangeNamespace(request) {
  var _request$payload5, namespace, params;

  return _regenerator2.default.wrap(function onChangeNamespace$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actInvSummary.setRowItems([]));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)(actInvSummary.setIngredients([]));

        case 4:
          _context6.next = 6;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 6:
          _request$payload5 = request.payload, namespace = _request$payload5.namespace, params = _request$payload5.params;
          _context6.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context6.prev = 9;
          _context6.next = 12;
          return (0, _effects.call)(apiCurrentInventory.putCurrentInventoryDropdown, { current_inventory_dropdown: namespace });

        case 12:
          _context6.next = 14;
          return (0, _effects.call)(_getSubscriptionStatus.getSubscriptionStatus, { feature_names: ['Ingredient Inventory'] });

        case 14:
          _context6.next = 16;
          return (0, _effects.call)(apiCurrentInventory.getCurrentInventoryDropdown, {});

        case 16:
          _context6.next = 22;
          break;

        case 18:
          _context6.prev = 18;
          _context6.t0 = _context6['catch'](9);
          _context6.next = 22;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 22:
          _context6.prev = 22;

          if (!(namespace !== 'ingredients')) {
            _context6.next = 28;
            break;
          }

          _context6.next = 26;
          return (0, _effects.put)(actInvSummary.summaryRequest(params, [], [], namespace));

        case 26:
          _context6.next = 30;
          break;

        case 28:
          _context6.next = 30;
          return (0, _effects.put)(actInvSummary.ingInvSummaryRequest(params, [], namespace));

        case 30:
          _context6.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context6.finish(22);

        case 33:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[9, 18, 22, 33]]);
}

function ingInvSummaryRequest(request) {
  var _request$payload6, params, previousIngredients, resSummary, ingredients, newIngredients;

  return _regenerator2.default.wrap(function ingInvSummaryRequest$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _request$payload6 = request.payload, params = _request$payload6.params, previousIngredients = _request$payload6.previousIngredients;
          _context7.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context7.prev = 3;
          _context7.next = 6;
          return (0, _effects.call)(apiIngInvSummary.getSummary, params);

        case 6:
          resSummary = _context7.sent;
          ingredients = resSummary.data.results;
          newIngredients = previousIngredients.concat(ingredients);
          _context7.next = 11;
          return (0, _effects.put)(actInvSummary.setIngredients(newIngredients));

        case 11:
          _context7.next = 13;
          return (0, _effects.put)(actInvSummary.setCurrentPage(params.page));

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(actInvSummary.setTotalPage(resSummary.data.total_pages));

        case 15:
          _context7.next = 21;
          break;

        case 17:
          _context7.prev = 17;
          _context7.t0 = _context7['catch'](3);
          _context7.next = 21;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 21:
          _context7.prev = 21;
          _context7.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
          _context7.next = 26;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 26:
          return _context7.finish(21);

        case 27:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[3, 17, 21, 27]]);
}

function exportSummary(request) {
  var _request$payload7, _request$payload7$par, namespace, restParams, filename, outletId;

  return _regenerator2.default.wrap(function exportSummary$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _request$payload7 = request.payload, _request$payload7$par = _request$payload7.params, namespace = _request$payload7$par.namespace, restParams = (0, _objectWithoutProperties3.default)(_request$payload7$par, ['namespace']), filename = _request$payload7.filename, outletId = _request$payload7.outletId;
          _context8.prev = 1;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context8.next = 7;
            break;
          }

          _context8.next = 5;
          return (0, _effects.call)(apiInvSummary.getExportSummary, restParams);

        case 5:
          _context8.next = 10;
          break;

        case 7:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context8.next = 10;
            break;
          }

          _context8.next = 10;
          return (0, _effects.call)(apiIngInvSummary.getExportSummary, restParams);

        case 10:
          _context8.next = 12;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Summary'));

        case 12:
          _context8.next = 18;
          break;

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 18;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 18:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 14]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_PAGE_REQUEST, pageRequest);

        case 2:
          _context9.next = 4;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_SUMMARY_REQUEST, summaryRequestFlow);

        case 4:
          _context9.next = 6;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow);

        case 6:
          _context9.next = 8;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_ON_CHANGE_DATE, onChangeDate);

        case 8:
          _context9.next = 10;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_ON_CHANGE_KEYWORD, onChangeKeyword);

        case 10:
          _context9.next = 12;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_EXPORT_SUMMARY, exportSummary);

        case 12:
          _context9.next = 14;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE, onChangeNamespace);

        case 14:
          _context9.next = 16;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST, ingInvSummaryRequest);

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initializeForm = initializeForm;
exports.emptyForm = emptyForm;
exports.pageRequestFlow = pageRequestFlow;
exports.suppliersRequest = suppliersRequest;
exports.onChangeKeyword = onChangeKeyword;
exports.exportSupplier = exportSupplier;
exports.onClickRow = onClickRow;
exports.onClickCancel = onClickCancel;
exports.askDeleteSupplier = askDeleteSupplier;
exports.deleteSupplier = deleteSupplier;
exports.cancelDeleteSupplier = cancelDeleteSupplier;
exports.onClickCreateSupplier = onClickCreateSupplier;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.default = saga;

var _constants = __webpack_require__(403);

var _effects = __webpack_require__(22);

var _supplier = __webpack_require__(201);

var actSupplier = _interopRequireWildcard(_supplier);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _suppliers = __webpack_require__(627);

var apiInvSupplier = _interopRequireWildcard(_suppliers);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _reduxForm = __webpack_require__(7);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _reduxSaga = __webpack_require__(68);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _loadingSpinner = __webpack_require__(46);

var _suppliers2 = __webpack_require__(652);

var mpInvSupplier = _interopRequireWildcard(_suppliers2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initializeForm, emptyForm, pageRequestFlow, suppliersRequest, onChangeKeyword, exportSupplier, onClickRow, onClickCancel, askDeleteSupplier, deleteSupplier, cancelDeleteSupplier, onClickCreateSupplier, submitFormCreate, submitFormUpdate, saga].map(_regenerator2.default.mark);

function initializeForm(supplier) {
  return _regenerator2.default.wrap(function initializeForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('supplier', {
            id: supplier.id,
            name: supplier.name,
            address: supplier.address,
            city: supplier.city,
            email: supplier.email,
            phone: supplier.phone,
            postal_code: supplier.postal_code,
            state: supplier.state
          }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function emptyForm() {
  return _regenerator2.default.wrap(function emptyForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('supplier', {}));

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function pageRequestFlow(request) {
  var response, resProfile;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actSupplier.setSuppliers([]));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(actSupplier.setSupplierDetail(null));

        case 6:
          _context3.next = 8;
          return (0, _effects.put)(actSupplier.closeRightColumn());

        case 8:
          _context3.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context3.prev = 10;
          _context3.next = 13;
          return (0, _effects.call)(apiOutlets.outlets);

        case 13:
          response = _context3.sent;
          _context3.next = 16;
          return (0, _effects.put)(actSupplier.setOutlets(response.data));

        case 16:
          _context3.next = 18;
          return (0, _effects.call)(apiProfile.getProfile);

        case 18:
          resProfile = _context3.sent;
          _context3.next = 21;
          return (0, _effects.put)(actSupplier.setProfile(resProfile.data));

        case 21:
          _context3.next = 23;
          return (0, _effects.put)(actSupplier.suppliersRequest({}));

        case 23:
          _context3.next = 25;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            keyword: ''
          }));

        case 25:
          mpInvSupplier.inventorySupplierStart();
          _context3.next = 32;
          break;

        case 28:
          _context3.prev = 28;
          _context3.t0 = _context3['catch'](10);
          _context3.next = 32;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 32:
          _context3.prev = 32;
          _context3.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          return _context3.finish(32);

        case 36:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[10, 28, 32, 36]]);
}

function suppliersRequest(request) {
  var params, resSuppliers, suppliers;
  return _regenerator2.default.wrap(function suppliersRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          params = request.payload.params;
          _context4.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _effects.call)(apiInvSupplier.getSuppliers, params);

        case 6:
          resSuppliers = _context4.sent;
          suppliers = resSuppliers.data;
          _context4.next = 10;
          return (0, _effects.put)(actSupplier.setSuppliers(suppliers));

        case 10:
          _context4.next = 16;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4['catch'](3);
          _context4.next = 16;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.put)(act.hideProgressBar());

        case 19:
          _context4.next = 21;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 21:
          return _context4.finish(16);

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[3, 12, 16, 22]]);
}

function onChangeKeyword(request) {
  var keyword;
  return _regenerator2.default.wrap(function onChangeKeyword$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actSupplier.setSuppliers([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          keyword = request.payload.keyword;
          // delay to prevent too fast ajax request

          _context5.next = 7;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 7:
          _context5.next = 9;
          return (0, _effects.put)(actSupplier.suppliersRequest({ keyword: keyword }));

        case 9:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function exportSupplier(request) {
  var _request$payload, params, filename, stop, resProfile, profile, pattern;

  return _regenerator2.default.wrap(function exportSupplier$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, filename = _request$payload.filename;
          _context6.next = 3;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 3:
          _context6.prev = 3;
          _context6.next = 6;
          return (0, _effects.call)(apiInvSupplier.getExportSupplier, params);

        case 6:
          // fetch the result
          // we don't use saga-effects of get-exported-file since this kind use email
          stop = false;

        case 7:
          if (stop) {
            _context6.next = 24;
            break;
          }

          _context6.next = 10;
          return (0, _effects.call)(_reduxSaga.delay, 5000);

        case 10:
          _context6.next = 12;
          return (0, _effects.call)(apiProfile.getProfile);

        case 12:
          resProfile = _context6.sent;
          profile = resProfile.data;
          pattern = new RegExp(filename, 'i');

          if (pattern.test(profile.export_items_file)) {
            _context6.next = 20;
            break;
          }

          _context6.next = 18;
          return (0, _effects.put)(actNotif.error('Failed to export Suppliers'));

        case 18:
          _context6.next = 22;
          break;

        case 20:
          stop = true;
          window.location.href = profile.export_items_file;

        case 22:
          _context6.next = 7;
          break;

        case 24:
          _context6.next = 30;
          break;

        case 26:
          _context6.prev = 26;
          _context6.t0 = _context6['catch'](3);
          _context6.next = 30;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 30:
          _context6.prev = 30;
          _context6.next = 33;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 33:
          return _context6.finish(30);

        case 34:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[3, 26, 30, 34]]);
}

function onClickRow(request) {
  var supplier;
  return _regenerator2.default.wrap(function onClickRow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          supplier = request.payload.supplier;

          mpInvSupplier.inventorySupplierSelect({ supplier: supplier });
          _context7.next = 4;
          return (0, _effects.put)(actSupplier.setSupplierDetail(supplier));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(actSupplier.openRightColumn());

        case 6:
          _context7.next = 8;
          return (0, _effects.call)(initializeForm, supplier);

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function onClickCancel(request) {
  return _regenerator2.default.wrap(function onClickCancel$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(actSupplier.setSupplierDetail(null));

        case 2:
          _context8.next = 4;
          return (0, _effects.call)(emptyForm);

        case 4:
          _context8.next = 6;
          return (0, _effects.put)(actSupplier.closeRightColumn());

        case 6:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function askDeleteSupplier(request) {
  return _regenerator2.default.wrap(function askDeleteSupplier$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)(actSupplier.openDeleteSupplierModal());

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function deleteSupplier(request) {
  var _request$payload2, supplier, suppliers, newSuppliers;

  return _regenerator2.default.wrap(function deleteSupplier$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload2 = request.payload, supplier = _request$payload2.supplier, suppliers = _request$payload2.suppliers;

          mpInvSupplier.inventorySupplierDelete({ supplier: supplier });
          _context10.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context10.prev = 4;
          _context10.next = 7;
          return (0, _effects.call)(apiInvSupplier.deleteSupplier, supplier.id);

        case 7:
          _context10.next = 9;
          return (0, _effects.put)(actSupplier.closeRightColumn());

        case 9:
          _context10.next = 11;
          return (0, _effects.put)(actSupplier.setSupplierDetail(null));

        case 11:
          _context10.next = 13;
          return (0, _effects.put)(actSupplier.closeDeleteSupplierModal());

        case 13:
          // remove supplier from list of suppliers
          newSuppliers = [];

          suppliers.forEach(function (s) {
            if (s.id !== supplier.id) {
              newSuppliers.push(s);
            }
          });
          _context10.next = 17;
          return (0, _effects.put)(actSupplier.setSuppliers(newSuppliers));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)(actNotif.success('Supplier successfully deleted.'));

        case 19:
          _context10.next = 25;
          break;

        case 21:
          _context10.prev = 21;
          _context10.t0 = _context10['catch'](4);
          _context10.next = 25;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 25:
          _context10.prev = 25;
          _context10.next = 28;
          return (0, _effects.put)(act.hideProgressBar());

        case 28:
          return _context10.finish(25);

        case 29:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[4, 21, 25, 29]]);
}

function cancelDeleteSupplier(request) {
  return _regenerator2.default.wrap(function cancelDeleteSupplier$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)(actSupplier.closeDeleteSupplierModal());

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function onClickCreateSupplier(request) {
  return _regenerator2.default.wrap(function onClickCreateSupplier$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)(actSupplier.openRightColumn());

        case 2:
          _context12.next = 4;
          return (0, _effects.put)(actSupplier.setSupplierDetail(null));

        case 4:
          _context12.next = 6;
          return (0, _effects.call)(emptyForm);

        case 6:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function submitFormCreate(request) {
  var _request$payload3, data, previousSuppliers, email, checkEmailResponse, emailExist, supResponse, supplier;

  return _regenerator2.default.wrap(function submitFormCreate$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload3 = request.payload, data = _request$payload3.data, previousSuppliers = _request$payload3.previousSuppliers;

          mpInvSupplier.inventorySupplierCreate({ supplier: data.supplier });
          _context13.prev = 2;
          _context13.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context13.next = 7;
          return (0, _effects.put)(actSupplier.isSubmittingForm(true));

        case 7:
          // TODO should be return error message from backend instead of api call like this
          email = data.supplier.email;
          // check email uniqueness

          _context13.next = 10;
          return (0, _effects.call)(apiInvSupplier.getSuppliers, { keyword: email });

        case 10:
          checkEmailResponse = _context13.sent;
          emailExist = false;

          checkEmailResponse.data.forEach(function (sup) {
            if (sup.email === email) emailExist = true;
          });

          if (!emailExist) {
            _context13.next = 15;
            break;
          }

          throw new Error('Supplier email must be unique');

        case 15:
          _context13.next = 17;
          return (0, _effects.call)(apiInvSupplier.postSuppliers, data, {});

        case 17:
          supResponse = _context13.sent;
          supplier = supResponse.data;
          _context13.next = 21;
          return (0, _effects.call)(initializeForm, supplier);

        case 21:
          previousSuppliers.unshift(supplier);
          _context13.next = 24;
          return (0, _effects.put)(actSupplier.setSupplierDetail(supplier));

        case 24:
          _context13.next = 26;
          return (0, _effects.put)(actSupplier.setSuppliers(previousSuppliers));

        case 26:
          _context13.next = 28;
          return (0, _effects.put)(actNotif.success('Supplier successfully created.'));

        case 28:
          _context13.next = 34;
          break;

        case 30:
          _context13.prev = 30;
          _context13.t0 = _context13['catch'](2);
          _context13.next = 34;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 34:
          _context13.prev = 34;
          _context13.next = 37;
          return (0, _effects.put)(actSupplier.isSubmittingForm(false));

        case 37:
          _context13.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          return _context13.finish(34);

        case 40:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[2, 30, 34, 40]]);
}

function submitFormUpdate(request) {
  var _request$payload4, data, supplierId, previousSuppliers, email, checkEmailResponse, emailExist, supResponse, supplier, newSuppliers;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _request$payload4 = request.payload, data = _request$payload4.data, supplierId = _request$payload4.supplierId, previousSuppliers = _request$payload4.previousSuppliers;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context14.next = 6;
          return (0, _effects.put)(actSupplier.isSubmittingForm(true));

        case 6:
          // TODO should be return error message from backend instead of api call like this
          email = data.supplier.email;
          // check email uniqueness

          _context14.next = 9;
          return (0, _effects.call)(apiInvSupplier.getSuppliers, { keyword: email });

        case 9:
          checkEmailResponse = _context14.sent;
          emailExist = false;

          checkEmailResponse.data.forEach(function (sup) {
            if (sup.email === email && sup.id !== supplierId) {
              emailExist = true;
            }
          });

          if (!emailExist) {
            _context14.next = 14;
            break;
          }

          throw new Error('Supplier email must be unique');

        case 14:
          _context14.next = 16;
          return (0, _effects.call)(apiInvSupplier.putSupplier, supplierId, data, {});

        case 16:
          supResponse = _context14.sent;
          supplier = supResponse.data;
          _context14.next = 20;
          return (0, _effects.call)(initializeForm, supplier);

        case 20:
          newSuppliers = previousSuppliers.map(function (s) {
            if (s.id === supplier.id) {
              // return updated supplier
              return supplier;
            } else {
              return s;
            }
          });
          _context14.next = 23;
          return (0, _effects.put)(actSupplier.setSupplierDetail(supplier));

        case 23:
          _context14.next = 25;
          return (0, _effects.put)(actSupplier.setSuppliers(newSuppliers));

        case 25:
          _context14.next = 27;
          return (0, _effects.put)(actNotif.success('Supplier successfully updated.'));

        case 27:
          _context14.next = 33;
          break;

        case 29:
          _context14.prev = 29;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 33;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 33:
          _context14.prev = 33;
          _context14.next = 36;
          return (0, _effects.put)(act.hideProgressBar());

        case 36:
          _context14.next = 38;
          return (0, _effects.put)(actSupplier.isSubmittingForm(false));

        case 38:
          return _context14.finish(33);

        case 39:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[1, 29, 33, 39]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_PAGE_REQUEST, pageRequestFlow);

        case 2:
          _context15.next = 4;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_SUPPLIERS_REQUEST, suppliersRequest);

        case 4:
          _context15.next = 6;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_EXPORT_SUPPLIER, exportSupplier);

        case 6:
          _context15.next = 8;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD, onChangeKeyword);

        case 8:
          _context15.next = 10;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_ON_CLICK_ROW, onClickRow);

        case 10:
          _context15.next = 12;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_ON_CLICK_CANCEL, onClickCancel);

        case 12:
          _context15.next = 14;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER, askDeleteSupplier);

        case 14:
          _context15.next = 16;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_DELETE_SUPPLIER, deleteSupplier);

        case 16:
          _context15.next = 18;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER, cancelDeleteSupplier);

        case 18:
          _context15.next = 20;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER, onClickCreateSupplier);

        case 20:
          _context15.next = 22;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE, submitFormCreate);

        case 22:
          _context15.next = 24;
          return (0, _effects.takeLatest)(_constants.INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 24:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.transfersRequest = transfersRequest;
exports.onClickRow = onClickRow;
exports.onChangeOutletIdsFlow = onChangeOutletIdsFlow;
exports.onChangeDate = onChangeDate;
exports.onClickCreateTransfer = onClickCreateTransfer;
exports.setSelectedOutlets = setSelectedOutlets;
exports.getItems = getItems;
exports.formOnClickAddItems = formOnClickAddItems;
exports.onModalSelectChange = onModalSelectChange;
exports.onModalAddItem = onModalAddItem;
exports.resetTransfersForm = resetTransfersForm;
exports.onSubmitCreateTransferForm = onSubmitCreateTransferForm;
exports.onConfirmCreateTransfer = onConfirmCreateTransfer;
exports.exportTransfer = exportTransfer;
exports.onNamespaceChange = onNamespaceChange;
exports.default = saga;

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _reduxForm = __webpack_require__(7);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(14);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(404);

var _transfer = __webpack_require__(615);

var actInvTrf = _interopRequireWildcard(_transfer);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _loadingSpinner = __webpack_require__(46);

var actLoadingSpinner = _interopRequireWildcard(_loadingSpinner);

var _ingredientSubscription = __webpack_require__(233);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _transfer2 = __webpack_require__(1104);

var apiTrf = _interopRequireWildcard(_transfer2);

var _items = __webpack_require__(239);

var apiItem = _interopRequireWildcard(_items);

var _currentInventoryDropdown = __webpack_require__(288);

var apiCurrentInventory = _interopRequireWildcard(_currentInventoryDropdown);

var _getFilteredDate = __webpack_require__(171);

var apiGetFilteredDate = _interopRequireWildcard(_getFilteredDate);

var _updateFilteredDate = __webpack_require__(240);

var apiUpdateFilteredDate = _interopRequireWildcard(_updateFilteredDate);

var _transfer3 = __webpack_require__(1092);

var apiIngTrf = _interopRequireWildcard(_transfer3);

var _ingredients = __webpack_require__(205);

var apiIngredients = _interopRequireWildcard(_ingredients);

var _transfer4 = __webpack_require__(653);

var mpTransfers = _interopRequireWildcard(_transfer4);

var _constants2 = __webpack_require__(81);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [pageRequest, transfersRequest, onClickRow, onChangeOutletIdsFlow, onChangeDate, onClickCreateTransfer, setSelectedOutlets, getItems, formOnClickAddItems, onModalSelectChange, onModalAddItem, resetTransfersForm, onSubmitCreateTransferForm, onConfirmCreateTransfer, exportTransfer, onNamespaceChange, saga].map(_regenerator2.default.mark);

function pageRequest() {
  var respOutlets, resProfile, resGetFilteredDate, startDate, endDate, resCurrentInventoryDropdown, currentInventoryDropdown;
  return _regenerator2.default.wrap(function pageRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 2:
          _context.next = 4;
          return (0, _effects.put)(actInvTrf.resetState());

        case 4:
          _context.next = 6;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(false));

        case 6:
          _context.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context.prev = 8;
          _context.next = 11;
          return (0, _effects.call)(apiOutlets.outlets);

        case 11:
          respOutlets = _context.sent;
          _context.next = 14;
          return (0, _effects.put)(actInvTrf.setOutlets(respOutlets.data));

        case 14:
          _context.next = 16;
          return (0, _effects.call)(apiProfile.getProfile);

        case 16:
          resProfile = _context.sent;
          _context.next = 19;
          return (0, _effects.call)(apiGetFilteredDate.getFilteredDate);

        case 19:
          resGetFilteredDate = _context.sent;
          startDate = (0, _moment2.default)(resGetFilteredDate.data.start_date);
          endDate = (0, _moment2.default)(resGetFilteredDate.data.end_date);
          _context.next = 24;
          return (0, _effects.call)(apiCurrentInventory.getCurrentInventoryDropdown);

        case 24:
          resCurrentInventoryDropdown = _context.sent;
          currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown;
          _context.next = 28;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: resProfile.data.outlet_id,
            date: { startDate: startDate, endDate: endDate },
            namespace: currentInventoryDropdown
          }));

        case 28:
          _context.next = 30;
          return (0, _effects.call)(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id);

        case 30:
          _context.next = 32;
          return (0, _effects.put)(actInvTrf.transfersRequest({
            page: 1, start: startDate, end: endDate
          }, [], currentInventoryDropdown));

        case 32:
          _context.next = 34;
          return (0, _effects.put)((0, _reduxForm.reset)('transferItem'));

        case 34:

          mpTransfers.inventoryTransferStart({
            outletIds: resProfile.data.outlet_id,
            startDate: startDate,
            endDate: endDate,
            namespace: currentInventoryDropdown
          });
          _context.next = 37;
          return (0, _effects.put)((0, _ingredientSubscription.subscriptionStatus)());

        case 37:
          _context.next = 43;
          break;

        case 39:
          _context.prev = 39;
          _context.t0 = _context['catch'](8);
          _context.next = 43;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 43:
          _context.prev = 43;
          _context.next = 46;
          return (0, _effects.put)(act.hideProgressBar());

        case 46:
          _context.next = 48;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(true));

        case 48:
          return _context.finish(43);

        case 49:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[8, 39, 43, 49]]);
}

function transfersRequest(request) {
  var _request$payload, params, previuosTransfers, namespace, respTransfers, transfers, newTransfers;

  return _regenerator2.default.wrap(function transfersRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previuosTransfers = _request$payload.previuosTransfers, namespace = _request$payload.namespace;
          _context2.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context2.prev = 3;
          respTransfers = null;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 8;
          return (0, _effects.call)(apiTrf.getTransfers, params);

        case 8:
          respTransfers = _context2.sent;
          _context2.next = 15;
          break;

        case 11:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context2.next = 15;
            break;
          }

          _context2.next = 14;
          return (0, _effects.call)(apiIngTrf.getTransfers, params);

        case 14:
          respTransfers = _context2.sent;

        case 15:
          transfers = respTransfers.data.results;
          // copy array

          newTransfers = previuosTransfers.map(function (a) {
            return a;
          });


          transfers.forEach(function (trf, index) {
            var lastTransfer = newTransfers[newTransfers.length - 1];
            if (newTransfers.length === 0 || !(0, _moment2.default)(trf.created_at).isSame((0, _moment2.default)(lastTransfer.created_at), 'days')) {
              newTransfers.push({
                created_at: trf.created_at,
                isdaterow: true
              });
            }
            newTransfers.push((0, _extends3.default)({}, trf, {
              isdaterow: false
            }));
          });
          _context2.next = 20;
          return (0, _effects.put)(actInvTrf.setTransfers(newTransfers));

        case 20:
          _context2.next = 22;
          return (0, _effects.put)(actInvTrf.setCurrentPage(params.page));

        case 22:
          _context2.next = 24;
          return (0, _effects.put)(actInvTrf.setTotalPage(respTransfers.data.total_pages));

        case 24:
          _context2.next = 30;
          break;

        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 30;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 30:
          _context2.prev = 30;
          _context2.next = 33;
          return (0, _effects.put)(act.hideProgressBar());

        case 33:
          _context2.next = 35;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(false));

        case 35:
          return _context2.finish(30);

        case 36:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[3, 26, 30, 36]]);
}

function onClickRow(request) {
  var transfer;
  return _regenerator2.default.wrap(function onClickRow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          transfer = request.payload.transfer;
          _context3.next = 3;
          return (0, _effects.put)(actInvTrf.setTransferDetail(transfer));

        case 3:
          _context3.next = 5;
          return (0, _effects.put)(actInvTrf.openRightColumn());

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function onChangeOutletIdsFlow(request) {
  var _request$payload2, outletIds, startDate, endDate, namespace, respOutlets, resProfile;

  return _regenerator2.default.wrap(function onChangeOutletIdsFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _request$payload2 = request.payload, outletIds = _request$payload2.outletIds, startDate = _request$payload2.startDate, endDate = _request$payload2.endDate, namespace = _request$payload2.namespace;
          _context4.next = 3;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 3:
          _context4.next = 5;
          return (0, _effects.put)(actInvTrf.resetState());

        case 5:
          _context4.next = 7;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(false));

        case 7:
          _context4.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context4.prev = 9;
          _context4.next = 12;
          return (0, _effects.call)(apiOutlets.outlets);

        case 12:
          respOutlets = _context4.sent;
          _context4.next = 15;
          return (0, _effects.put)(actInvTrf.setOutlets(respOutlets.data));

        case 15:
          _context4.next = 17;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 17:
          _context4.next = 19;
          return (0, _effects.call)(apiProfile.getProfile);

        case 19:
          resProfile = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: outletIds,
            date: { startDate: startDate, endDate: endDate },
            namespace: namespace
          }));

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actInvTrf.transfersRequest({
            page: 1, start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'), end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, [], namespace));

        case 26:
          _context4.next = 28;
          return (0, _effects.put)((0, _reduxForm.reset)('transferItem'));

        case 28:
          _context4.next = 34;
          break;

        case 30:
          _context4.prev = 30;
          _context4.t0 = _context4['catch'](9);
          _context4.next = 34;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 34:
          _context4.prev = 34;
          _context4.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          _context4.next = 39;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(true));

        case 39:
          return _context4.finish(34);

        case 40:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[9, 30, 34, 40]]);
}

function onChangeDate(request) {
  var _request$payload3, startDate, endDate, namespace, respOutlets, resProfile;

  return _regenerator2.default.wrap(function onChangeDate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _request$payload3 = request.payload, startDate = _request$payload3.startDate, endDate = _request$payload3.endDate, namespace = _request$payload3.namespace;
          _context5.next = 3;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 3:
          _context5.next = 5;
          return (0, _effects.put)(actInvTrf.resetState());

        case 5:
          _context5.next = 7;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(false));

        case 7:
          _context5.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context5.prev = 9;
          _context5.next = 12;
          return (0, _effects.call)(apiOutlets.outlets);

        case 12:
          respOutlets = _context5.sent;
          _context5.next = 15;
          return (0, _effects.put)(actInvTrf.setOutlets(respOutlets.data));

        case 15:
          _context5.next = 17;
          return (0, _effects.call)(apiProfile.getProfile);

        case 17:
          resProfile = _context5.sent;
          _context5.next = 20;
          return (0, _effects.call)(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id);

        case 20:
          _context5.next = 22;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, {
            from: (0, _moment2.default)(startDate).format('D/M/YYYY'),
            to: (0, _moment2.default)(endDate).format('D/M/YYYY')
          });

        case 22:
          _context5.next = 24;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'date', { startDate: startDate, endDate: endDate }));

        case 24:
          _context5.next = 26;
          return (0, _effects.put)(actInvTrf.transfersRequest({
            page: 1, start: (0, _moment2.default)(startDate).format('YYYY/MM/DD'), end: (0, _moment2.default)(endDate).format('YYYY/MM/DD')
          }, [], namespace));

        case 26:
          _context5.next = 28;
          return (0, _effects.put)((0, _reduxForm.reset)('transferItem'));

        case 28:
          _context5.next = 34;
          break;

        case 30:
          _context5.prev = 30;
          _context5.t0 = _context5['catch'](9);
          _context5.next = 34;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 34:
          _context5.prev = 34;
          _context5.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          _context5.next = 39;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(true));

        case 39:
          return _context5.finish(34);

        case 40:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[9, 30, 34, 40]]);
}

function onClickCreateTransfer(request) {
  var outletIds;
  return _regenerator2.default.wrap(function onClickCreateTransfer$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          outletIds = request.payload.outletIds;
          _context6.next = 3;
          return (0, _effects.put)(actInvTrf.setTransferDetail(null));

        case 3:
          _context6.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('transferItem', {
            fromOutlet: outletIds.toString(),
            toOutlet: outletIds.toString(),
            transfers: []
          }));

        case 5:
          _context6.next = 7;
          return (0, _effects.put)(actInvTrf.openRightColumn());

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function setSelectedOutlets(outlets, selectedOutlets) {
  var result;
  return _regenerator2.default.wrap(function setSelectedOutlets$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          result = [];

          if (!(selectedOutlets.length > 1)) {
            _context7.next = 6;
            break;
          }

          _context7.next = 4;
          return (0, _effects.put)(actInvTrf.setSelectedOutlets(outlets));

        case 4:
          _context7.next = 9;
          break;

        case 6:
          outlets.forEach(function (outlet, index) {
            if (outlet.id === selectedOutlets[0]) {
              result.push(outlet);
            }
          });
          _context7.next = 9;
          return (0, _effects.put)(actInvTrf.setSelectedOutlets(result));

        case 9:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function getItems(request) {
  var _request$payload4, fromOutletId, keyword, page, namespace, isInit, isGetFromInit, previousAddItems, previousTotalPage, initData, perPage, itemOptions, respItems, searchItemsdata, currentPage, totalPage, data;

  return _regenerator2.default.wrap(function getItems$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(actInvTrf.setItemsOptionIsLoading(true));

        case 2:
          _request$payload4 = request.payload, fromOutletId = _request$payload4.fromOutletId, keyword = _request$payload4.keyword, page = _request$payload4.page, namespace = _request$payload4.namespace, isInit = _request$payload4.isInit, isGetFromInit = _request$payload4.isGetFromInit, previousAddItems = _request$payload4.previousAddItems, previousTotalPage = _request$payload4.previousTotalPage, initData = _request$payload4.initData;
          perPage = 100;
          itemOptions = [];
          // let items = []

          respItems = null;
          searchItemsdata = null;
          currentPage = void 0;
          totalPage = previousTotalPage;
          _context8.prev = 9;

          if (!isGetFromInit) {
            _context8.next = 14;
            break;
          }

          if (initData) {
            data = { data: initData };

            respItems = data;
          }
          _context8.next = 27;
          break;

        case 14:
          if (!keyword) {
            _context8.next = 17;
            break;
          }

          _context8.next = 17;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 17:
          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context8.next = 23;
            break;
          }

          _context8.next = 20;
          return (0, _effects.call)(apiItem.getItemsV1, {
            outlet_id: fromOutletId,
            no_categories: true,
            keyword: keyword,
            page: page,
            per_page: perPage
          });

        case 20:
          respItems = _context8.sent;
          _context8.next = 27;
          break;

        case 23:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context8.next = 27;
            break;
          }

          _context8.next = 26;
          return (0, _effects.call)(apiIngredients.getAll, {
            outlet_id: fromOutletId,
            no_categories: true,
            keyword: keyword,
            page: page,
            per_page: perPage
          });

        case 26:
          respItems = _context8.sent;

        case 27:

          searchItemsdata = respItems.data;

          if (page > 1) {
            if (searchItemsdata.length > 0) {
              totalPage = page;
            }
            currentPage = page;
          } else {
            currentPage = 1;
            totalPage = 1;
          }

          searchItemsdata = previousAddItems.concat(searchItemsdata);

          searchItemsdata.forEach(function (item, index) {
            itemOptions.push({ value: item.id, label: item.name });
          });

          if (!isInit) {
            _context8.next = 34;
            break;
          }

          _context8.next = 34;
          return (0, _effects.put)(actInvTrf.setSearchItemsInit({ items: searchItemsdata, itemOptions: itemOptions, currentPage: currentPage, totalPage: totalPage }));

        case 34:
          _context8.next = 36;
          return (0, _effects.put)(actInvTrf.setAddItems({ items: searchItemsdata, itemOptions: itemOptions, currentPage: currentPage, totalPage: totalPage }));

        case 36:
          _context8.next = 42;
          break;

        case 38:
          _context8.prev = 38;
          _context8.t0 = _context8['catch'](9);
          _context8.next = 42;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 42:
          _context8.prev = 42;
          _context8.next = 45;
          return (0, _effects.put)(actInvTrf.setItemsOptionIsLoading(false));

        case 45:
          return _context8.finish(42);

        case 46:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[9, 38, 42, 46]]);
}

function formOnClickAddItems() {
  return _regenerator2.default.wrap(function formOnClickAddItems$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('addTransferItems', { items: [] }));

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function onModalSelectChange(request) {
  var _request$payload5, selectedItemId, items, transfers, namespace, isItemFound, temporaryItem, fields, i;

  return _regenerator2.default.wrap(function onModalSelectChange$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload5 = request.payload, selectedItemId = _request$payload5.selectedItemId, items = _request$payload5.items, transfers = _request$payload5.transfers, namespace = _request$payload5.namespace;

          if (!(selectedItemId === undefined)) {
            _context10.next = 5;
            break;
          }

          _context10.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('addTransferItems', {
            items: []
          }));

        case 4:
          return _context10.abrupt('return');

        case 5:
          isItemFound = false;
          _context10.next = 8;
          return (0, _effects.put)((0, _reduxForm.initialize)('addTransferItems', { items: [] }));

        case 8:
          _context10.next = 10;
          return (0, _effects.put)(actInvTrf.setIsItemAlreadyAdded(false));

        case 10:

          if (transfers.length) {
            transfers.forEach(function (trf, index) {
              if (namespace === _constants2.NAMESPACE_ITEMS && trf.itemId === selectedItemId) {
                isItemFound = true;
              }
              if (namespace === _constants2.NAMESPACE_INGREDIENTS && trf.ingredientId === selectedItemId) {
                isItemFound = true;
              }
            });
          }

          if (!(!transfers.length || !isItemFound)) {
            _context10.next = 24;
            break;
          }

          temporaryItem = _lodash2.default.find(items, { 'id': selectedItemId });
          fields = [];

          if (namespace === _constants2.NAMESPACE_ITEMS) {
            temporaryItem.item_variants.forEach(function (iv, index) {
              if (!iv.is_deleted) {
                fields.push({
                  isItem: temporaryItem.item_variants.length === 1,
                  itemId: temporaryItem.id,
                  itemName: temporaryItem.name,
                  itemIsRecipe: temporaryItem.is_recipe,
                  itemVariantId: iv.id,
                  itemVariantName: iv.name,
                  inStock: iv.in_stock,
                  quantity: 0,
                  sku: iv.sku,
                  price: iv.price
                });
              }
            });
          } else if (namespace === _constants2.NAMESPACE_INGREDIENTS) {
            fields.push({
              ingredientId: temporaryItem.id,
              ingredientName: temporaryItem.name,
              unitId: temporaryItem.unit_id,
              unitName: temporaryItem.unit_name,
              inStock: temporaryItem.in_stock,
              quantity: 0
            });
          }

          // yield put(initialize('addTransferItems', {
          //   items: fields
          // }))
          i = 0;

        case 16:
          if (!(i < fields.length)) {
            _context10.next = 22;
            break;
          }

          _context10.next = 19;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('addTransferItems', 'items', fields[i]));

        case 19:
          i++;
          _context10.next = 16;
          break;

        case 22:
          _context10.next = 26;
          break;

        case 24:
          _context10.next = 26;
          return (0, _effects.put)(actInvTrf.setIsItemAlreadyAdded(true));

        case 26:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function onModalAddItem(request) {
  var items, i;
  return _regenerator2.default.wrap(function onModalAddItem$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          // const {payload: {items, transfers}} = request
          items = request.payload.items;

          // let oldTransfers = transfers.slice(0)
          // let newTransfers = []
          // let isFound = false
          // let isPushed = false
          //
          // items.forEach((item, index) => {
          //   if (oldTransfers.length === 0) {
          //     newTransfers.push(item)
          //     isPushed = true
          //   } else {
          //     oldTransfers.forEach((trf, index) => {
          //       if (trf.itemId === item.itemId && trf.itemVariantId === item.itemVariantId) {
          //         trf.quantity = parseInt(trf.quantity.toString()) + parseInt(item.quantity.toString())
          //         isFound = true
          //       }
          //     })
          //   }
          //
          //   if (!isFound && !isPushed) {
          //     newTransfers.push(item)
          //   }
          //
          //   isFound = false
          //   isPushed = false
          // })

          // yield put(arrayRemoveAll('transferItem', 'transfers'))

          // for (let i = 0; i < oldTransfers.length; i++) {
          //   yield put(arrayPush('transferItem', 'transfers', oldTransfers[i]))
          // }
          //
          // for (let i = 0; i < newTransfers.length; i++) {
          //   yield put(arrayPush('transferItem', 'transfers', newTransfers[i]))
          // }

          i = 0;

        case 2:
          if (!(i < items.length)) {
            _context11.next = 8;
            break;
          }

          _context11.next = 5;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('transferItem', 'transfers', items[i]));

        case 5:
          i++;
          _context11.next = 2;
          break;

        case 8:
          _context11.next = 10;
          return (0, _effects.put)(actInvTrf.closeAddItemModal());

        case 10:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function resetTransfersForm() {
  return _regenerator2.default.wrap(function resetTransfersForm$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('transferItem', 'transfers'));

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function onSubmitCreateTransferForm(request) {
  var values, hasError, total;
  return _regenerator2.default.wrap(function onSubmitCreateTransferForm$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          values = request.payload.values;
          hasError = false;

          if (!(values.fromOutlet === null || values.fromOutlet === '')) {
            _context13.next = 6;
            break;
          }

          _context13.next = 5;
          return (0, _effects.put)(actNotif.error('Please choose from outlet'));

        case 5:
          hasError = true;

        case 6:
          if (!(values.toOutlet === null || values.toOutlet === '')) {
            _context13.next = 10;
            break;
          }

          _context13.next = 9;
          return (0, _effects.put)(actNotif.error('Please choose to outlet'));

        case 9:
          hasError = true;

        case 10:
          if (!(values.transfers.length === 0)) {
            _context13.next = 14;
            break;
          }

          _context13.next = 13;
          return (0, _effects.put)(actNotif.error('Please add Transfer Stock before saving'));

        case 13:
          hasError = true;

        case 14:
          if (!(values.fromOutlet === values.toOutlet)) {
            _context13.next = 18;
            break;
          }

          _context13.next = 17;
          return (0, _effects.put)(actNotif.error('Destination outlet must be different from origin outlet'));

        case 17:
          hasError = true;

        case 18:
          if (!values.transfers.length) {
            _context13.next = 25;
            break;
          }

          total = 0;

          values.transfers.forEach(function (trf, index) {
            total = total + parseFloat(trf.quantity);
          });

          if (!(total <= 0)) {
            _context13.next = 25;
            break;
          }

          _context13.next = 24;
          return (0, _effects.put)(actNotif.error('Total transfer must be greater than 0'));

        case 24:
          hasError = true;

        case 25:
          if (hasError) {
            _context13.next = 28;
            break;
          }

          _context13.next = 28;
          return (0, _effects.put)(actInvTrf.setShowConfirmSubmitModal(true));

        case 28:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function onConfirmCreateTransfer(request) {
  var _request$payload6, values, date, namespace, total, transferData, resTransfer;

  return _regenerator2.default.wrap(function onConfirmCreateTransfer$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _request$payload6 = request.payload, values = _request$payload6.values, date = _request$payload6.date, namespace = _request$payload6.namespace;
          _context14.next = 3;
          return (0, _effects.put)(actInvTrf.setConfirmCreateButtonStatus(true));

        case 3:
          total = 0;
          transferData = null;


          if (namespace === _constants2.NAMESPACE_ITEMS) {
            transferData = {
              from_outlet_id: parseInt(values.fromOutlet),
              outlet_id: parseInt(values.fromOutlet),
              to_outlet_id: parseInt(values.toOutlet),
              total: '',
              history_details: [],
              history_details_attributes: [],
              note: values.notes ? values.notes : ''
            };

            values.transfers.forEach(function (trf, index) {
              if (trf.quantity > 0) {
                var details = {
                  beginning_stock: trf.inStock,
                  end_stock: trf.inStock - parseInt(trf.quantity),
                  item_id: trf.itemId,
                  item_variant_id: trf.itemVariantId,
                  item_variant_name: trf.itemVariantName ? trf.itemVariantName : trf.itemName,
                  name: trf.itemName,
                  quantity: trf.quantity
                };

                transferData.history_details.push(details);
                transferData.history_details_attributes.push(details);

                total = total + parseInt(trf.quantity);
              }
            });

            transferData.total = total;
          } else if (namespace === _constants2.NAMESPACE_INGREDIENTS) {
            transferData = {
              from_outlet_id: parseInt(values.fromOutlet),
              outlet_id: parseInt(values.fromOutlet),
              to_outlet_id: parseInt(values.toOutlet),
              history_details: [],
              history_details_attributes: [],
              note: values.notes ? values.notes : '',
              outlet_receiver_id: parseInt(values.toOutlet),
              outlet_sender_id: parseInt(values.fromOutlet)
            };

            values.transfers.forEach(function (trf, index) {
              if (trf.quantity > 0) {
                var details = {
                  beginning_stock: trf.inStock,
                  end_stock: trf.inStock - parseFloat(trf.quantity),
                  ingredient_id: trf.ingredientId,
                  ingredient_name: trf.ingredientName,
                  quantity: trf.quantity,
                  unit_id: trf.unitId,
                  unit_name: trf.unitName
                };

                transferData.history_details.push(details);
                transferData.history_details_attributes.push(details);
              }
            });
          }

          _context14.prev = 6;
          _context14.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          resTransfer = {};

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context14.next = 16;
            break;
          }

          _context14.next = 13;
          return (0, _effects.call)(apiTrf.postTransfers, { transfer: transferData });

        case 13:
          resTransfer = _context14.sent;
          _context14.next = 20;
          break;

        case 16:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context14.next = 20;
            break;
          }

          _context14.next = 19;
          return (0, _effects.call)(apiIngTrf.postTransfers, { ingredient_transfer: transferData });

        case 19:
          resTransfer = _context14.sent;

        case 20:
          _context14.next = 22;
          return (0, _effects.put)((0, _reduxForm.reset)('transferItem'));

        case 22:
          _context14.next = 24;
          return (0, _effects.put)(actNotif.success(resTransfer.data.success_msg));

        case 24:
          if ((0, _moment2.default)().isBetween(date.startDate, date.endDate, 'day', '[]')) {
            _context14.next = 27;
            break;
          }

          _context14.next = 27;
          return (0, _effects.call)(apiUpdateFilteredDate.updateFilteredDate, {
            from: (0, _moment2.default)().format('D/M/YYYY'),
            to: (0, _moment2.default)().format('D/M/YYYY')
          });

        case 27:

          mpTransfers.inventoryTransferCreate({
            outletFromName: transferData.from_outlet_id,
            outletToName: transferData.to_outlet_id,
            namespace: namespace,
            items: transferData.history_details
          });

          _context14.next = 30;
          return (0, _effects.call)(pageRequest);

        case 30:
          _context14.next = 36;
          break;

        case 32:
          _context14.prev = 32;
          _context14.t0 = _context14['catch'](6);
          _context14.next = 36;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 36:
          _context14.prev = 36;
          _context14.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          _context14.next = 41;
          return (0, _effects.put)(actInvTrf.setShowConfirmSubmitModal(false));

        case 41:
          _context14.next = 43;
          return (0, _effects.put)(actInvTrf.setConfirmCreateButtonStatus(false));

        case 43:
          return _context14.finish(36);

        case 44:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[6, 32, 36, 44]]);
}

function exportTransfer(request) {
  var _request$payload7, date, filename, outletId, namespace;

  return _regenerator2.default.wrap(function exportTransfer$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _request$payload7 = request.payload, date = _request$payload7.date, filename = _request$payload7.filename, outletId = _request$payload7.outletId, namespace = _request$payload7.namespace;
          _context15.prev = 1;

          if (!(namespace === _constants2.NAMESPACE_ITEMS)) {
            _context15.next = 9;
            break;
          }

          _context15.next = 5;
          return (0, _effects.call)(apiTrf.getExportTransfer, date);

        case 5:
          _context15.next = 7;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Inventory Transfer'));

        case 7:
          _context15.next = 14;
          break;

        case 9:
          if (!(namespace === _constants2.NAMESPACE_INGREDIENTS)) {
            _context15.next = 14;
            break;
          }

          _context15.next = 12;
          return (0, _effects.call)(apiIngTrf.getExportTransfer, date);

        case 12:
          _context15.next = 14;
          return (0, _effects.put)(actGetExportedFile.getExportedFile(filename, outletId, 'Ingredient Inventory Transfer'));

        case 14:
          _context15.next = 20;
          break;

        case 16:
          _context15.prev = 16;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 20;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 20:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 16]]);
}

function onNamespaceChange(request) {
  var namespace, respOutlets, resProfile, resGetFilteredDate, startDate, endDate;
  return _regenerator2.default.wrap(function onNamespaceChange$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          namespace = request.payload.namespace;
          _context16.next = 3;
          return (0, _effects.put)(actLoadingSpinner.showPageLoadingSpinner(true));

        case 3:
          _context16.next = 5;
          return (0, _effects.put)(actInvTrf.resetState());

        case 5:
          _context16.next = 7;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(false));

        case 7:
          _context16.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context16.prev = 9;
          _context16.next = 12;
          return (0, _effects.call)(apiOutlets.outlets);

        case 12:
          respOutlets = _context16.sent;
          _context16.next = 15;
          return (0, _effects.put)(actInvTrf.setOutlets(respOutlets.data));

        case 15:
          _context16.next = 17;
          return (0, _effects.call)(apiProfile.getProfile);

        case 17:
          resProfile = _context16.sent;
          _context16.next = 20;
          return (0, _effects.call)(apiGetFilteredDate.getFilteredDate);

        case 20:
          resGetFilteredDate = _context16.sent;
          startDate = (0, _moment2.default)(resGetFilteredDate.data.start_date);
          endDate = (0, _moment2.default)(resGetFilteredDate.data.end_date);
          _context16.next = 25;
          return (0, _effects.call)(apiCurrentInventory.putCurrentInventoryDropdown, { current_inventory_dropdown: namespace });

        case 25:
          _context16.next = 27;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            outletIds: resProfile.data.outlet_id,
            date: { startDate: startDate, endDate: endDate },
            namespace: namespace
          }));

        case 27:
          _context16.next = 29;
          return (0, _effects.call)(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id);

        case 29:
          _context16.next = 31;
          return (0, _effects.put)(actInvTrf.transfersRequest({
            page: 1, start: startDate, end: endDate
          }, [], namespace));

        case 31:
          _context16.next = 33;
          return (0, _effects.put)((0, _reduxForm.reset)('transferItem'));

        case 33:
          _context16.next = 39;
          break;

        case 35:
          _context16.prev = 35;
          _context16.t0 = _context16['catch'](9);
          _context16.next = 39;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 39:
          _context16.prev = 39;
          _context16.next = 42;
          return (0, _effects.put)(act.hideProgressBar());

        case 42:
          _context16.next = 44;
          return (0, _effects.put)(actInvTrf.setExportButtonStatus(true));

        case 44:
          return _context16.finish(39);

        case 45:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[9, 35, 39, 45]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_PAGE_REQUEST, pageRequest);

        case 2:
          _context17.next = 4;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_TRANSFERS_REQUEST, transfersRequest);

        case 4:
          _context17.next = 6;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CLICK_ROW, onClickRow);

        case 6:
          _context17.next = 8;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow);

        case 8:
          _context17.next = 10;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CHANGE_DATE, onChangeDate);

        case 10:
          _context17.next = 12;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER, onClickCreateTransfer);

        case 12:
          _context17.next = 14;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_GET_ITEMS, getItems);

        case 14:
          _context17.next = 16;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE, onModalSelectChange);

        case 16:
          _context17.next = 18;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM, onModalAddItem);

        case 18:
          _context17.next = 20;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_RESET_TRANSFERS_FORM, resetTransfersForm);

        case 20:
          _context17.next = 22;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM, onSubmitCreateTransferForm);

        case 22:
          _context17.next = 24;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER, onConfirmCreateTransfer);

        case 24:
          _context17.next = 26;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_EXPORT, exportTransfer);

        case 26:
          _context17.next = 28;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM, formOnClickAddItems);

        case 28:
          _context17.next = 30;
          return (0, _effects.takeLatest)(_constants.INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE, onNamespaceChange);

        case 30:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.categoriesPageRequestFlow = categoriesPageRequestFlow;
exports.categoriesRequestFlow = categoriesRequestFlow;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onClickRowFlow = onClickRowFlow;
exports.onClickCancelFlow = onClickCancelFlow;
exports.updateCategoryFlow = updateCategoryFlow;
exports.onClickCreateCategoryFlow = onClickCreateCategoryFlow;
exports.createCategoryFlow = createCategoryFlow;
exports.createCategoryAllOutletsFlow = createCategoryAllOutletsFlow;
exports.deleteCategoryRequest = deleteCategoryRequest;
exports.deleteCategoryFlow = deleteCategoryFlow;
exports.cancelDeleteCategoryFlow = cancelDeleteCategoryFlow;
exports.onClickAssignToItemFlow = onClickAssignToItemFlow;
exports.cancelAssignToItemFlow = cancelAssignToItemFlow;
exports.assignToItemGetItemsRequestFlow = assignToItemGetItemsRequestFlow;
exports.submitAssignToItemFlow = submitAssignToItemFlow;
exports.default = saga;

var _constants = __webpack_require__(405);

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _category = __webpack_require__(126);

var actCategory = _interopRequireWildcard(_category);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _categories2 = __webpack_require__(429);

var apiCategory = _interopRequireWildcard(_categories2);

var _items2 = __webpack_require__(239);

var apiItems = _interopRequireWildcard(_items2);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _category2 = __webpack_require__(452);

var mpLibraryCategory = _interopRequireWildcard(_category2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillSearchFormFromProfile, fillFormCategoryDetail, openRightColumn, closeRightColumn, fillFormAssignToItemFlow, categoriesPageRequestFlow, categoriesRequestFlow, onChangeOutletIds, onClickRowFlow, onClickCancelFlow, updateCategoryFlow, onClickCreateCategoryFlow, createCategoryFlow, createCategoryAllOutletsFlow, deleteCategoryRequest, deleteCategoryFlow, cancelDeleteCategoryFlow, onClickAssignToItemFlow, cancelAssignToItemFlow, assignToItemGetItemsRequestFlow, submitAssignToItemFlow, saga].map(_regenerator2.default.mark);

var CATEGORY_SUCCESSFULLY_CREATED_MESSAGE = 'Category successfully created.';

function fillSearchFormFromProfile(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearchFormFromProfile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          assignedOutletIds = [];

          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillFormCategoryDetail(category) {
  var formCategoryDetail;
  return _regenerator2.default.wrap(function fillFormCategoryDetail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          formCategoryDetail = {
            id: category.id,
            name: category.name
          };
          _context2.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('category', formCategoryDetail));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actCategory.openRightColumn());

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actCategory.closeRightColumn());

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function fillFormAssignToItemFlow(request) {
  var category, form;
  return _regenerator2.default.wrap(function fillFormAssignToItemFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          category = request.payload.category;
          form = {
            id: category.id,
            itemIds: category.items && category.items.map(function (itemCategory) {
              return itemCategory.id;
            })
          };
          _context5.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('assignToItem', form));

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function categoriesPageRequestFlow() {
  var response, profile;
  return _regenerator2.default.wrap(function categoriesPageRequestFlow$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actCategory.setListCategories([]));

        case 2:
          _context6.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(actCategory.setOutlets([]));

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context6.next = 10;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 10:
          _context6.next = 12;
          return (0, _effects.put)(actCategory.closeRightColumn());

        case 12:
          _context6.prev = 12;
          _context6.next = 15;
          return (0, _effects.call)(apiOutlets.outlets);

        case 15:
          response = _context6.sent;
          _context6.next = 18;
          return (0, _effects.put)(actCategory.setOutlets(response.data));

        case 18:
          _context6.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          profile = _context6.sent;
          _context6.next = 23;
          return (0, _effects.call)(fillSearchFormFromProfile, profile.data);

        case 23:
          mpLibraryCategory.libraryCategoryStart({ currentOutlet: profile.data.outlet_id[0] });
          _context6.next = 26;
          return (0, _effects.put)(actCategory.categoriesRequest({ with_items: true, page: 1 }));

        case 26:
          _context6.next = 32;
          break;

        case 28:
          _context6.prev = 28;
          _context6.t0 = _context6['catch'](12);
          _context6.next = 32;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 32:
          _context6.prev = 32;
          _context6.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          return _context6.finish(32);

        case 36:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[12, 28, 32, 36]]);
}

function categoriesRequestFlow(request) {
  var _request$payload, params, previousCategories, response, categories, resCategories, _categories;

  return _regenerator2.default.wrap(function categoriesRequestFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousCategories = _request$payload.previousCategories;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          if (!(params && params.keyword)) {
            _context7.next = 17;
            break;
          }

          _context7.next = 7;
          return (0, _effects.call)(apiCategory.getCategoriesV1, params);

        case 7:
          response = _context7.sent;
          categories = response.data;
          _context7.next = 11;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 11:
          _context7.next = 13;
          return (0, _effects.put)(actCategory.setTotalPage(1));

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(actCategory.setCurrentPage(1));

        case 15:
          _context7.next = 28;
          break;

        case 17:
          _context7.next = 19;
          return (0, _effects.call)(apiCategory.getCategories, { with_items: true, page: params.page });

        case 19:
          resCategories = _context7.sent;
          _categories = void 0;

          if (previousCategories) {
            _categories = previousCategories.concat(resCategories.data.results);
          } else {
            _categories = resCategories.data.results;
          }
          _context7.next = 24;
          return (0, _effects.put)(actCategory.setListCategories(_categories));

        case 24:
          _context7.next = 26;
          return (0, _effects.put)(actCategory.setTotalPage(resCategories.data.total_pages));

        case 26:
          _context7.next = 28;
          return (0, _effects.put)(actCategory.setCurrentPage(params.page));

        case 28:
          _context7.next = 34;
          break;

        case 30:
          _context7.prev = 30;
          _context7.t0 = _context7['catch'](1);
          _context7.next = 34;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 34:
          _context7.prev = 34;
          _context7.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          _context7.next = 39;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 39:
          return _context7.finish(34);

        case 40:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[1, 30, 34, 40]]);
}

function onChangeOutletIds(action) {
  var outletIds;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(actCategory.setListCategories([]));

        case 2:
          _context8.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          outletIds = action.payload.outletIds;

          mpLibraryCategory.libraryCategoryChangeOutlet({ currentOutlet: outletIds });
          _context8.prev = 6;
          _context8.next = 9;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 9:
          _context8.next = 11;
          return (0, _effects.call)(closeRightColumn);

        case 11:
          _context8.next = 13;
          return (0, _effects.call)(fillFormCategoryDetail, { id: null, name: null });

        case 13:
          _context8.next = 15;
          return (0, _effects.put)(act.showProgressBar());

        case 15:
          _context8.next = 17;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 17:
          _context8.next = 19;
          return (0, _effects.put)(actCategory.categoriesRequest({ with_items: true, page: 1 }));

        case 19:
          _context8.next = 21;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 21:
          _context8.next = 23;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 23:
          _context8.next = 29;
          break;

        case 25:
          _context8.prev = 25;
          _context8.t0 = _context8['catch'](6);
          _context8.next = 29;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 29:
          _context8.prev = 29;
          _context8.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context8.finish(29);

        case 33:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[6, 25, 29, 33]]);
}

function onClickRowFlow(request) {
  var category, categoryDetail;
  return _regenerator2.default.wrap(function onClickRowFlow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          category = request.payload.category;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context9.next = 6;
          return (0, _effects.call)(apiCategory.getCategoryDetail, category.id);

        case 6:
          categoryDetail = _context9.sent;
          _context9.next = 9;
          return (0, _effects.put)(actCategory.setCategoryDetail(categoryDetail.data));

        case 9:
          _context9.next = 11;
          return (0, _effects.call)(fillFormCategoryDetail, categoryDetail.data);

        case 11:
          _context9.next = 13;
          return (0, _effects.call)(openRightColumn);

        case 13:
          _context9.next = 19;
          break;

        case 15:
          _context9.prev = 15;
          _context9.t0 = _context9['catch'](1);
          _context9.next = 19;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 19:
          _context9.prev = 19;
          _context9.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          return _context9.finish(19);

        case 23:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[1, 15, 19, 23]]);
}

function onClickCancelFlow() {
  return _regenerator2.default.wrap(function onClickCancelFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 2:
          _context10.next = 4;
          return (0, _effects.call)(fillFormCategoryDetail, { id: null, name: null });

        case 4:
          _context10.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function updateCategoryFlow(request) {
  var _request$payload2, id, data, previousCategories, keyword, type, oldCategoryName, response, categoryData, categories, categoryExisted;

  return _regenerator2.default.wrap(function updateCategoryFlow$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload2 = request.payload, id = _request$payload2.id, data = _request$payload2.data, previousCategories = _request$payload2.previousCategories;
          keyword = data.name;
          type = 'edit';
          oldCategoryName = null;

          previousCategories.forEach(function (category) {
            if (category.id === id) oldCategoryName = category.name;
          });
          mpLibraryCategory.libraryCategoryUpdateOneOutlet({ oldName: oldCategoryName, newName: data.name });
          _context11.prev = 6;
          _context11.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context11.next = 11;
          return (0, _effects.put)(actCategory.isSubmittingForm(true));

        case 11:
          _context11.next = 13;
          return (0, _effects.call)(apiCategory.categoryRequestWithKeywordAndType, { keyword: keyword, type: type });

        case 13:
          _context11.next = 15;
          return (0, _effects.call)(apiCategory.updateCategory, id, data);

        case 15:
          response = _context11.sent;
          categoryData = response.data;
          categories = [];
          categoryExisted = false;

          previousCategories.forEach(function (category) {
            if (category.id === id) {
              categories.push(categoryData);
            } else {
              if (keyword !== category.name) {
                categories.push(category);
              } else {
                categoryExisted = true;
              }
            }
          });

          if (!categoryExisted) {
            _context11.next = 25;
            break;
          }

          _context11.next = 23;
          return (0, _effects.put)(actNotif.error('The name of the Category must be unique'));

        case 23:
          _context11.next = 33;
          break;

        case 25:
          _context11.next = 27;
          return (0, _effects.put)(actNotif.success('Category was successfully updated.'));

        case 27:
          _context11.next = 29;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 29:
          _context11.next = 31;
          return (0, _effects.put)(actCategory.setCategoryDetail(categoryData));

        case 31:
          _context11.next = 33;
          return (0, _effects.call)(fillFormCategoryDetail, categoryData);

        case 33:
          _context11.next = 39;
          break;

        case 35:
          _context11.prev = 35;
          _context11.t0 = _context11['catch'](6);
          _context11.next = 39;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 39:
          _context11.prev = 39;
          _context11.next = 42;
          return (0, _effects.put)(act.hideProgressBar());

        case 42:
          _context11.next = 44;
          return (0, _effects.put)(actCategory.isSubmittingForm(false));

        case 44:
          return _context11.finish(39);

        case 45:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[6, 35, 39, 45]]);
}

function onClickCreateCategoryFlow() {
  return _regenerator2.default.wrap(function onClickCreateCategoryFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 2:
          _context12.next = 4;
          return (0, _effects.call)(fillFormCategoryDetail, { id: null, name: null });

        case 4:
          _context12.next = 6;
          return (0, _effects.call)(openRightColumn);

        case 6:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function createCategoryFlow(request) {
  var _request$payload3, data, previousCategories, keyword, type, response, categoryData, categoryExist, categories;

  return _regenerator2.default.wrap(function createCategoryFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload3 = request.payload, data = _request$payload3.data, previousCategories = _request$payload3.previousCategories;
          keyword = data.name;
          type = 'new';
          _context13.prev = 3;
          _context13.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context13.next = 8;
          return (0, _effects.put)(actCategory.isSubmittingForm(true));

        case 8:
          _context13.next = 10;
          return (0, _effects.call)(apiCategory.categoryRequestWithKeywordAndType, { keyword: keyword, type: type });

        case 10:
          _context13.next = 12;
          return (0, _effects.call)(apiCategory.createCategory, data);

        case 12:
          response = _context13.sent;
          categoryData = response.data;
          categoryExist = false;
          categories = [categoryData];

          previousCategories.forEach(function (category) {
            if (keyword !== category.name) {
              categories.push(category);
            } else {
              categoryExist = true;
            }
          });

          if (!categoryExist) {
            _context13.next = 22;
            break;
          }

          _context13.next = 20;
          return (0, _effects.put)(actNotif.error('The name of the Category must be unique'));

        case 20:
          _context13.next = 30;
          break;

        case 22:
          _context13.next = 24;
          return (0, _effects.put)(actNotif.success(CATEGORY_SUCCESSFULLY_CREATED_MESSAGE));

        case 24:
          _context13.next = 26;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 26:
          _context13.next = 28;
          return (0, _effects.put)(actCategory.setCategoryDetail(categoryData));

        case 28:
          _context13.next = 30;
          return (0, _effects.call)(fillFormCategoryDetail, categoryData);

        case 30:
          _context13.next = 36;
          break;

        case 32:
          _context13.prev = 32;
          _context13.t0 = _context13['catch'](3);
          _context13.next = 36;
          return (0, _effects.put)(actNotif.error('Failed to create category.'));

        case 36:
          _context13.prev = 36;
          _context13.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          _context13.next = 41;
          return (0, _effects.put)(actCategory.isSubmittingForm(false));

        case 41:
          return _context13.finish(36);

        case 42:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[3, 32, 36, 42]]);
}

function createCategoryAllOutletsFlow(request) {
  var _request$payload4, data, previousCategories, response, categoryData, categories;

  return _regenerator2.default.wrap(function createCategoryAllOutletsFlow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _request$payload4 = request.payload, data = _request$payload4.data, previousCategories = _request$payload4.previousCategories;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context14.next = 6;
          return (0, _effects.put)(actCategory.isSubmittingForm(true));

        case 6:
          _context14.next = 8;
          return (0, _effects.call)(apiCategory.createCategoryAllOutlets, data);

        case 8:
          response = _context14.sent;
          categoryData = response.data;
          categories = [categoryData];

          previousCategories.forEach(function (category) {
            categories.push(category);
          });
          _context14.next = 14;
          return (0, _effects.put)(actNotif.success(CATEGORY_SUCCESSFULLY_CREATED_MESSAGE));

        case 14:
          _context14.next = 16;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 16:
          _context14.next = 18;
          return (0, _effects.put)(actCategory.setCategoryDetail(categoryData));

        case 18:
          _context14.next = 20;
          return (0, _effects.call)(fillFormCategoryDetail, categoryData);

        case 20:
          _context14.next = 26;
          break;

        case 22:
          _context14.prev = 22;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 26;
          return (0, _effects.put)(actNotif.error('Failed to save category to all outlets'));

        case 26:
          _context14.prev = 26;
          _context14.next = 29;
          return (0, _effects.put)(actCategory.isSubmittingForm(false));

        case 29:
          _context14.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context14.finish(26);

        case 32:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[1, 22, 26, 32]]);
}

function deleteCategoryRequest(request) {
  var deletedCategory;
  return _regenerator2.default.wrap(function deleteCategoryRequest$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          deletedCategory = request.payload.deletedCategory;
          _context15.next = 3;
          return (0, _effects.put)(actCategory.setDeletedCategory(deletedCategory));

        case 3:
          _context15.next = 5;
          return (0, _effects.put)(actCategory.showDeleteModal());

        case 5:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function deleteCategoryFlow(request) {
  var _request$payload5, id, previousCategories, categories;

  return _regenerator2.default.wrap(function deleteCategoryFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _request$payload5 = request.payload, id = _request$payload5.id, previousCategories = _request$payload5.previousCategories;
          _context16.prev = 1;
          _context16.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context16.next = 6;
          return (0, _effects.call)(apiCategory.deleteCategory, id);

        case 6:
          categories = [];

          previousCategories.forEach(function (category) {
            if (category.id !== id) {
              categories.push(category);
            }
          });
          _context16.next = 10;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 10:
          _context16.next = 12;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 12:
          _context16.next = 14;
          return (0, _effects.put)(actCategory.setDeletedCategory(null));

        case 14:
          _context16.next = 16;
          return (0, _effects.put)(actCategory.hideDeleteModal());

        case 16:
          _context16.next = 18;
          return (0, _effects.call)(closeRightColumn);

        case 18:
          _context16.next = 20;
          return (0, _effects.put)(actNotif.success('Category was successfully removed.'));

        case 20:
          _context16.next = 26;
          break;

        case 22:
          _context16.prev = 22;
          _context16.t0 = _context16['catch'](1);
          _context16.next = 26;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 26:
          _context16.prev = 26;
          _context16.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context16.finish(26);

        case 30:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[1, 22, 26, 30]]);
}

function cancelDeleteCategoryFlow() {
  return _regenerator2.default.wrap(function cancelDeleteCategoryFlow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.put)(actCategory.setDeletedCategory(null));

        case 2:
          _context17.next = 4;
          return (0, _effects.put)(actCategory.hideDeleteModal());

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

function onClickAssignToItemFlow(request) {
  var category, resItems, items;
  return _regenerator2.default.wrap(function onClickAssignToItemFlow$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          category = request.payload.category;
          _context18.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context18.prev = 3;
          _context18.next = 6;
          return (0, _effects.call)(apiItems.getItems, {});

        case 6:
          resItems = _context18.sent;
          items = resItems.data;
          _context18.next = 10;
          return (0, _effects.put)(actCategory.assignToItemFillForm(category));

        case 10:
          _context18.next = 12;
          return (0, _effects.put)(actCategory.assignToItemSetCurrentPage(1));

        case 12:
          _context18.next = 14;
          return (0, _effects.put)(actCategory.assignToItemSetTotalPage(items.total_pages));

        case 14:
          _context18.next = 16;
          return (0, _effects.put)(actCategory.assignToItemSetItems(items.results));

        case 16:
          _context18.next = 18;
          return (0, _effects.put)(actCategory.showAssignToItemModal());

        case 18:
          _context18.next = 24;
          break;

        case 20:
          _context18.prev = 20;
          _context18.t0 = _context18['catch'](3);
          _context18.next = 24;
          return (0, _effects.put)(actNotif.error(_context18.t0.message));

        case 24:
          _context18.prev = 24;
          _context18.next = 27;
          return (0, _effects.put)(act.hideProgressBar());

        case 27:
          return _context18.finish(24);

        case 28:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this, [[3, 20, 24, 28]]);
}

function cancelAssignToItemFlow() {
  return _regenerator2.default.wrap(function cancelAssignToItemFlow$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)(actCategory.hideAssignToItemModal());

        case 2:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function assignToItemGetItemsRequestFlow(request) {
  var _request$payload6, params, previousItems, resItems, items, _resItems, _items;

  return _regenerator2.default.wrap(function assignToItemGetItemsRequestFlow$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _request$payload6 = request.payload, params = _request$payload6.params, previousItems = _request$payload6.previousItems;
          _context20.prev = 1;
          _context20.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          if (!(params && params.keyword)) {
            _context20.next = 18;
            break;
          }

          // V1 API includes params with_batch to support pagination
          params.with_batch = true;
          _context20.next = 8;
          return (0, _effects.call)(apiItems.getItemsV1, params);

        case 8:
          resItems = _context20.sent;
          _context20.next = 11;
          return (0, _effects.put)(actCategory.assignToItemSetCurrentPage(1));

        case 11:
          _context20.next = 13;
          return (0, _effects.put)(actCategory.assignToItemSetTotalPage(1));

        case 13:
          items = resItems.data.results;
          _context20.next = 16;
          return (0, _effects.put)(actCategory.assignToItemSetItems(items));

        case 16:
          _context20.next = 28;
          break;

        case 18:
          _context20.next = 20;
          return (0, _effects.call)(apiItems.getItems, params);

        case 20:
          _resItems = _context20.sent;
          _context20.next = 23;
          return (0, _effects.put)(actCategory.assignToItemSetCurrentPage(params.page));

        case 23:
          _context20.next = 25;
          return (0, _effects.put)(actCategory.assignToItemSetTotalPage(_resItems.data.total_pages));

        case 25:
          _items = previousItems.concat(_resItems.data.results);
          _context20.next = 28;
          return (0, _effects.put)(actCategory.assignToItemSetItems(_items));

        case 28:
          _context20.next = 30;
          return (0, _effects.put)(actCategory.showAssignToItemModal());

        case 30:
          _context20.next = 36;
          break;

        case 32:
          _context20.prev = 32;
          _context20.t0 = _context20['catch'](1);
          _context20.next = 36;
          return (0, _effects.put)(actNotif.error(_context20.t0.message));

        case 36:
          _context20.prev = 36;
          _context20.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          return _context20.finish(36);

        case 40:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this, [[1, 32, 36, 40]]);
}

function submitAssignToItemFlow(request) {
  var _request$payload7, data, categoryId, resCategories, categories;

  return _regenerator2.default.wrap(function submitAssignToItemFlow$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _request$payload7 = request.payload, data = _request$payload7.data, categoryId = _request$payload7.categoryId;
          _context21.prev = 1;
          _context21.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context21.next = 6;
          return (0, _effects.put)(actCategory.hideAssignToItemModal());

        case 6:
          _context21.next = 8;
          return (0, _effects.call)(apiCategory.assignToItem, categoryId, data);

        case 8:
          _context21.next = 10;
          return (0, _effects.put)(actCategory.setCategoryDetail(null));

        case 10:
          _context21.next = 12;
          return (0, _effects.call)(closeRightColumn);

        case 12:
          _context21.next = 14;
          return (0, _effects.call)(apiCategory.getCategories, { with_items: true, page: 1 });

        case 14:
          resCategories = _context21.sent;
          categories = resCategories.data.results;
          _context21.next = 18;
          return (0, _effects.put)(actCategory.setListCategories(categories));

        case 18:
          _context21.next = 20;
          return (0, _effects.put)(actCategory.setTotalPage(resCategories.data.total_pages));

        case 20:
          _context21.next = 22;
          return (0, _effects.put)(actCategory.setCurrentPage(1));

        case 22:
          _context21.next = 24;
          return (0, _effects.put)(actNotif.success('Successfully move selected items.'));

        case 24:
          _context21.next = 30;
          break;

        case 26:
          _context21.prev = 26;
          _context21.t0 = _context21['catch'](1);
          _context21.next = 30;
          return (0, _effects.put)(actNotif.error(_context21.t0.message));

        case 30:
          _context21.prev = 30;
          _context21.next = 33;
          return (0, _effects.put)(act.hideProgressBar());

        case 33:
          return _context21.finish(30);

        case 34:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this, [[1, 26, 30, 34]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_PAGE_REQUEST, categoriesPageRequestFlow);

        case 2:
          _context22.next = 4;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_LIST_REQUEST, categoriesRequestFlow);

        case 4:
          _context22.next = 6;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 6:
          _context22.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ON_CLICK_ROW, onClickRowFlow);

        case 8:
          _context22.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ON_CLICK_CANCEL, onClickCancelFlow);

        case 10:
          _context22.next = 12;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_SUBMIT_FORM_UPDATE, updateCategoryFlow);

        case 12:
          _context22.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE, createCategoryFlow);

        case 14:
          _context22.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ON_CLICK_CREATE_CATEGORY, onClickCreateCategoryFlow);

        case 16:
          _context22.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_SUBMIT_FORM_CREATE_ALL_OUTLETS, createCategoryAllOutletsFlow);

        case 18:
          _context22.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_DELETE_CATEGORY_REQUEST, deleteCategoryRequest);

        case 20:
          _context22.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_DELETE_CATEGORY, deleteCategoryFlow);

        case 22:
          _context22.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_CANCEL_DELETE, cancelDeleteCategoryFlow);

        case 24:
          _context22.next = 26;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ON_CLICK_ASSIGN_TO_ITEM, onClickAssignToItemFlow);

        case 26:
          _context22.next = 28;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_CANCEL_ASSIGN_TO_ITEM, cancelAssignToItemFlow);

        case 28:
          _context22.next = 30;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_SUBMIT_ASSIGN_TO_ITEM, submitAssignToItemFlow);

        case 30:
          _context22.next = 32;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_FILL_FORM, fillFormAssignToItemFlow);

        case 32:
          _context22.next = 34;
          return (0, _effects.takeLatest)(_constants.LIBRARY_CATEGORIES_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST, assignToItemGetItemsRequestFlow);

        case 34:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.discountsRequest = discountsRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.setDetailsDiscount = setDetailsDiscount;
exports.unSetDetailsDiscount = unSetDetailsDiscount;
exports.onClickCreateDiscount = onClickCreateDiscount;
exports.onChangeSwitchField = onChangeSwitchField;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteDiscount = deleteDiscount;
exports.askDeleteDiscount = askDeleteDiscount;
exports.cancelDeleteDiscount = cancelDeleteDiscount;
exports.onClickCancel = onClickCancel;
exports.default = saga;

var _constants = __webpack_require__(406);

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _discount = __webpack_require__(168);

var actDiscount = _interopRequireWildcard(_discount);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _discounts = __webpack_require__(1106);

var apiDiscount = _interopRequireWildcard(_discounts);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _discount2 = __webpack_require__(453);

var mpLibraryDiscount = _interopRequireWildcard(_discount2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillSearchFormProfile, fillForm, pageRequest, discountsRequest, onChangeOutletIds, setDetailsDiscount, unSetDetailsDiscount, onClickCreateDiscount, onChangeSwitchField, submitFormCreate, submitFormCreateAllOutlet, submitFormUpdate, deleteDiscount, askDeleteDiscount, cancelDeleteDiscount, onClickCancel, saga].map(_regenerator2.default.mark);

function fillSearchFormProfile(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearchFormProfile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          assignedOutletIds = [];

          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillForm(discount) {
  var formName;
  return _regenerator2.default.wrap(function fillForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          formName = 'discount';
          _context2.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)(formName, {
            id: discount.id,
            name: discount.name,
            amount: discount.amount ? discount.amount.toString() : discount.amount,
            typeAmount: discount.type === 'percentage'
          }));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function pageRequest() {
  var response, resProfile, resDiscounts, discounts;
  return _regenerator2.default.wrap(function pageRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actDiscount.setDiscounts([]));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(actDiscount.unSetDiscountDetail(null));

        case 6:
          _context3.next = 8;
          return (0, _effects.put)(actDiscount.setOutlets([]));

        case 8:
          _context3.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context3.prev = 10;
          _context3.next = 13;
          return (0, _effects.call)(apiOutlets.outlets);

        case 13:
          response = _context3.sent;
          _context3.next = 16;
          return (0, _effects.put)(actDiscount.setOutlets(response.data));

        case 16:
          _context3.next = 18;
          return (0, _effects.call)(apiProfile.getProfile);

        case 18:
          resProfile = _context3.sent;

          mpLibraryDiscount.libraryDiscountStart({ outletId: resProfile.data.outlet_id[0] });

          _context3.next = 22;
          return (0, _effects.call)(fillSearchFormProfile, resProfile.data);

        case 22:
          _context3.next = 24;
          return (0, _effects.call)(apiDiscount.getDiscounts, { page: 1 });

        case 24:
          resDiscounts = _context3.sent;
          discounts = resDiscounts.data.results;
          _context3.next = 28;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actDiscount.setTotalPage(resDiscounts.data.total_pages));

        case 30:
          _context3.next = 32;
          return (0, _effects.put)(actDiscount.setCurrentPage(1));

        case 32:
          _context3.next = 38;
          break;

        case 34:
          _context3.prev = 34;
          _context3.t0 = _context3['catch'](10);
          _context3.next = 38;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 38:
          _context3.prev = 38;
          _context3.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          _context3.next = 43;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 43:
          return _context3.finish(38);

        case 44:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[10, 34, 38, 44]]);
}

function discountsRequest(action) {
  var _action$payload, params, previousDiscounts, response, discounts;

  return _regenerator2.default.wrap(function discountsRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload = action.payload, params = _action$payload.params, previousDiscounts = _action$payload.previousDiscounts;
          _context4.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _effects.call)(apiDiscount.getDiscounts, params);

        case 6:
          response = _context4.sent;
          discounts = previousDiscounts.concat(response.data.results);
          _context4.next = 10;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 10:
          _context4.next = 12;
          return (0, _effects.put)(actDiscount.setTotalPage(response.data.total_pages));

        case 12:
          _context4.next = 14;
          return (0, _effects.put)(actDiscount.setCurrentPage(params.page));

        case 14:
          _context4.next = 20;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4['catch'](3);
          _context4.next = 20;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 20:
          _context4.prev = 20;
          _context4.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          _context4.next = 25;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 25:
          return _context4.finish(20);

        case 26:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[3, 16, 20, 26]]);
}

function onChangeOutletIds(action) {
  var outletIds, res;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actDiscount.setDiscounts([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          outletIds = action.payload.outletIds;
          _context5.prev = 5;
          _context5.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context5.next = 10;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 10:
          _context5.next = 12;
          return (0, _effects.call)(apiDiscount.getDiscounts, { page: 1 });

        case 12:
          res = _context5.sent;
          _context5.next = 15;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 15:
          _context5.next = 17;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 17:
          _context5.next = 19;
          return (0, _effects.put)(actDiscount.setDiscounts(res.data.results));

        case 19:
          _context5.next = 21;
          return (0, _effects.put)(actDiscount.setTotalPage(res.data.total_pages));

        case 21:
          _context5.next = 23;
          return (0, _effects.put)(actDiscount.setCurrentPage(1));

        case 23:
          _context5.next = 25;
          return (0, _effects.call)(fillForm, { id: null, amount: null, name: null, type: 'percentage' });

        case 25:
          _context5.next = 31;
          break;

        case 27:
          _context5.prev = 27;
          _context5.t0 = _context5['catch'](5);
          _context5.next = 31;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 31:
          _context5.prev = 31;
          _context5.next = 34;
          return (0, _effects.call)(unSetDetailsDiscount);

        case 34:
          _context5.next = 36;
          return (0, _effects.put)(act.hideProgressBar());

        case 36:
          return _context5.finish(31);

        case 37:
          _context5.next = 39;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 39:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[5, 27, 31, 37]]);
}

function setDetailsDiscount(action) {
  var discount;
  return _regenerator2.default.wrap(function setDetailsDiscount$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          discount = action.payload.discount;
          _context6.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context6.next = 5;
          return (0, _effects.put)(actDiscount.setDiscountDetail(discount));

        case 5:
          _context6.next = 7;
          return (0, _effects.call)(_reduxSaga.delay, 750);

        case 7:
          _context6.next = 9;
          return (0, _effects.call)(fillForm, discount);

        case 9:
          _context6.next = 11;
          return (0, _effects.put)(act.hideProgressBar());

        case 11:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function unSetDetailsDiscount() {
  return _regenerator2.default.wrap(function unSetDetailsDiscount$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actDiscount.unSetDiscountDetail());

        case 5:
          _context7.prev = 5;
          _context7.next = 8;
          return (0, _effects.put)(act.hideProgressBar());

        case 8:
          return _context7.finish(5);

        case 9:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0,, 5, 9]]);
}

function onClickCreateDiscount(action) {
  return _regenerator2.default.wrap(function onClickCreateDiscount$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.put)((0, _reduxForm.reset)('discount'));

        case 3:
          _context8.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context8.next = 7;
          return (0, _effects.put)(actDiscount.setNewDiscount());

        case 7:
          _context8.next = 9;
          return (0, _effects.call)(_reduxSaga.delay, 750);

        case 9:
          _context8.next = 11;
          return (0, _effects.call)(fillForm, { id: null, amount: null, name: null, type: 'percentage' });

        case 11:
          _context8.prev = 11;
          _context8.next = 14;
          return (0, _effects.put)(act.hideProgressBar());

        case 14:
          return _context8.finish(11);

        case 15:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[0,, 11, 15]]);
}

function onChangeSwitchField() {
  var formName;
  return _regenerator2.default.wrap(function onChangeSwitchField$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          formName = 'discount';
          _context9.next = 3;
          return (0, _effects.put)((0, _reduxForm.change)(formName, 'amount', ''));

        case 3:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function submitFormCreate(request) {
  var _request$payload, data, previousDiscounts, response, discount, discounts;

  return _regenerator2.default.wrap(function submitFormCreate$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload = request.payload, data = _request$payload.data, previousDiscounts = _request$payload.previousDiscounts;
          _context10.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context10.next = 5;
          return (0, _effects.put)(actDiscount.isSubmittingForm(true));

        case 5:
          mpLibraryDiscount.libraryDiscountCreate({ discount: data, allOutlet: false });
          _context10.prev = 6;
          _context10.next = 9;
          return (0, _effects.call)(apiDiscount.postDiscount, data);

        case 9:
          response = _context10.sent;

          // set to reducers
          discount = response.data;
          discounts = [discount];

          previousDiscounts.forEach(function (g) {
            return discounts.push(g);
          });

          _context10.next = 15;
          return (0, _effects.put)(actNotif.success('Discount successfully created.'));

        case 15:
          _context10.next = 17;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)(actDiscount.setDiscountDetail(discount));

        case 19:
          _context10.next = 21;
          return (0, _effects.call)(fillForm, discount);

        case 21:
          _context10.next = 27;
          break;

        case 23:
          _context10.prev = 23;
          _context10.t0 = _context10['catch'](6);
          _context10.next = 27;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 27:
          _context10.prev = 27;
          _context10.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          _context10.next = 32;
          return (0, _effects.put)(actDiscount.isSubmittingForm(false));

        case 32:
          return _context10.finish(27);

        case 33:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[6, 23, 27, 33]]);
}

function submitFormCreateAllOutlet(request) {
  var _request$payload2, data, previousDiscounts, response, discount, discounts;

  return _regenerator2.default.wrap(function submitFormCreateAllOutlet$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload2 = request.payload, data = _request$payload2.data, previousDiscounts = _request$payload2.previousDiscounts;

          mpLibraryDiscount.libraryDiscountCreate({ discount: data, allOutlet: true });
          _context11.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context11.next = 6;
          return (0, _effects.put)(actDiscount.isSubmittingForm(true));

        case 6:
          _context11.prev = 6;
          _context11.next = 9;
          return (0, _effects.call)(apiDiscount.postCreateAllOutlet, data);

        case 9:
          response = _context11.sent;

          // set to reducers
          discount = response.data;
          discounts = [discount];

          previousDiscounts.forEach(function (g) {
            return discounts.push(g);
          });

          _context11.next = 15;
          return (0, _effects.put)(actNotif.success('Discount successfully created.'));

        case 15:
          _context11.next = 17;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 17:
          _context11.next = 19;
          return (0, _effects.put)(actDiscount.setDiscountDetail(discount));

        case 19:
          _context11.next = 21;
          return (0, _effects.call)(fillForm, discount);

        case 21:
          _context11.next = 27;
          break;

        case 23:
          _context11.prev = 23;
          _context11.t0 = _context11['catch'](6);
          _context11.next = 27;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 27:
          _context11.prev = 27;
          _context11.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          _context11.next = 32;
          return (0, _effects.put)(actDiscount.isSubmittingForm(false));

        case 32:
          return _context11.finish(27);

        case 33:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[6, 23, 27, 33]]);
}

function submitFormUpdate(request) {
  var _request$payload3, data, discountId, previousDiscounts, response, discount, discounts;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _request$payload3 = request.payload, data = _request$payload3.data, discountId = _request$payload3.discountId, previousDiscounts = _request$payload3.previousDiscounts;
          _context12.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context12.next = 5;
          return (0, _effects.put)(actDiscount.isSubmittingForm(true));

        case 5:
          _context12.prev = 5;
          _context12.next = 8;
          return (0, _effects.call)(apiDiscount.putDiscount, discountId, data);

        case 8:
          response = _context12.sent;

          // set to reducers
          discount = response.data;
          discounts = [];

          previousDiscounts.forEach(function (g) {
            if (g.id === discountId) {
              discounts.push(discount);
            } else {
              discounts.push(g);
            }
          });

          _context12.next = 14;
          return (0, _effects.put)(actNotif.success('Discount successfully updated.'));

        case 14:
          _context12.next = 16;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 16:
          _context12.next = 18;
          return (0, _effects.put)(actDiscount.setDiscountDetail(discount));

        case 18:
          _context12.next = 20;
          return (0, _effects.call)(fillForm, discount);

        case 20:
          _context12.next = 26;
          break;

        case 22:
          _context12.prev = 22;
          _context12.t0 = _context12['catch'](5);
          _context12.next = 26;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 26:
          _context12.prev = 26;
          _context12.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          _context12.next = 31;
          return (0, _effects.put)(actDiscount.isSubmittingForm(false));

        case 31:
          return _context12.finish(26);

        case 32:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[5, 22, 26, 32]]);
}

function deleteDiscount(request) {
  var _request$payload4, discountId, previousDiscounts, discounts;

  return _regenerator2.default.wrap(function deleteDiscount$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _request$payload4 = request.payload, discountId = _request$payload4.discountId, previousDiscounts = _request$payload4.previousDiscounts;
          _context13.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context13.prev = 3;
          _context13.next = 6;
          return (0, _effects.call)(apiDiscount.deleteDiscount, discountId);

        case 6:
          // set to reducers
          discounts = [];

          previousDiscounts.forEach(function (discount) {
            if (discount.id !== discountId) {
              discounts.push(discount);
            } else {
              // this is the deleted discount, track to mixpanel
              mpLibraryDiscount.libraryDiscountDelete({ discount: discount });
            }
          });
          _context13.next = 10;
          return (0, _effects.put)(actDiscount.setDiscounts(discounts));

        case 10:
          _context13.next = 12;
          return (0, _effects.put)(actDiscount.setDeletedDiscount(null));

        case 12:
          _context13.next = 14;
          return (0, _effects.put)(actDiscount.hideDeleteDiscountModal());

        case 14:
          _context13.next = 16;
          return (0, _effects.call)(unSetDetailsDiscount);

        case 16:
          _context13.next = 18;
          return (0, _effects.call)(fillForm, { id: null, name: '', amount: null, typeAmount: 'percentage' });

        case 18:
          _context13.next = 20;
          return (0, _effects.put)(actNotif.success('Discount successfully deleted.'));

        case 20:
          _context13.next = 26;
          break;

        case 22:
          _context13.prev = 22;
          _context13.t0 = _context13['catch'](3);
          _context13.next = 26;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 26:
          _context13.prev = 26;
          _context13.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          return _context13.finish(26);

        case 30:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[3, 22, 26, 30]]);
}

function askDeleteDiscount(request) {
  var deletedDiscount;
  return _regenerator2.default.wrap(function askDeleteDiscount$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          deletedDiscount = request.payload.deletedDiscount;
          _context14.next = 3;
          return (0, _effects.put)(actDiscount.setDeletedDiscount(deletedDiscount));

        case 3:
          _context14.next = 5;
          return (0, _effects.put)(actDiscount.showDeleteDiscountModal());

        case 5:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function cancelDeleteDiscount() {
  return _regenerator2.default.wrap(function cancelDeleteDiscount$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)(actDiscount.setDeletedDiscount(null));

        case 2:
          _context15.next = 4;
          return (0, _effects.put)(actDiscount.hideDeleteDiscountModal());

        case 4:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function onClickCancel(action) {
  return _regenerator2.default.wrap(function onClickCancel$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actDiscount.unSetDiscountDetail());

        case 2:
          _context16.next = 4;
          return (0, _effects.call)(fillForm, { id: null, name: '', amount: null, typeAmount: 'percentage' });

        case 4:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_PAGE_REQUEST, pageRequest);

        case 2:
          _context17.next = 4;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_ON_CLICK_ROW, setDetailsDiscount);

        case 4:
          _context17.next = 6;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 6:
          _context17.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT, onClickCreateDiscount);

        case 8:
          _context17.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD, onChangeSwitchField);

        case 10:
          _context17.next = 12;
          return (0, _effects.takeEvery)(_constants.LIBRARY_DISCOUNT_DISCOUNTS_REQUEST, discountsRequest);

        case 12:
          _context17.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE, submitFormCreate);

        case 14:
          _context17.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 16:
          _context17.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET, submitFormCreateAllOutlet);

        case 18:
          _context17.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT, askDeleteDiscount);

        case 20:
          _context17.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_DELETE_DISCOUNT, deleteDiscount);

        case 22:
          _context17.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT, cancelDeleteDiscount);

        case 24:
          _context17.next = 26;
          return (0, _effects.takeLatest)(_constants.LIBRARY_DISCOUNT_ON_CLICK_CANCEL, onClickCancel);

        case 26:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.gratuitiesRequest = gratuitiesRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.clickGratuityRow = clickGratuityRow;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteGratuity = deleteGratuity;
exports.clickCancel = clickCancel;
exports.clickCreateGratuity = clickCreateGratuity;
exports.askDeleteGratuity = askDeleteGratuity;
exports.cancelDeleteGratuity = cancelDeleteGratuity;
exports.default = saga;

var _constants = __webpack_require__(407);

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _gratuity = __webpack_require__(169);

var actGratuity = _interopRequireWildcard(_gratuity);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _gratuities = __webpack_require__(1084);

var apiGratuity = _interopRequireWildcard(_gratuities);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _gratuity2 = __webpack_require__(654);

var mpLibraryGratuity = _interopRequireWildcard(_gratuity2);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillSearchFormFromProfile, fillForm, openRightColumn, closeRightColumn, pageRequest, gratuitiesRequest, onChangeOutletIds, clickGratuityRow, submitFormCreate, submitFormCreateAllOutlet, submitFormUpdate, deleteGratuity, clickCancel, clickCreateGratuity, askDeleteGratuity, cancelDeleteGratuity, saga].map(_regenerator2.default.mark);

function fillSearchFormFromProfile(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearchFormFromProfile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          assignedOutletIds = [];


          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillForm(gratuity) {
  var form;
  return _regenerator2.default.wrap(function fillForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          form = {
            id: gratuity.id,
            name: gratuity.name,
            amount: gratuity.amount ? gratuity.amount.toString() : gratuity.amount
          };
          _context2.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('gratuity', form));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actGratuity.openRightColumn());

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actGratuity.closeRightColumn());

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function pageRequest() {
  var response, resProfile, resGratuities, gratuities;
  return _regenerator2.default.wrap(function pageRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actGratuity.setGratuities([]));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(actGratuity.setGratuityDetail(null));

        case 6:
          _context5.next = 8;
          return (0, _effects.put)(actGratuity.setOutlets([]));

        case 8:
          _context5.next = 10;
          return (0, _effects.call)(closeRightColumn);

        case 10:
          _context5.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context5.prev = 12;
          _context5.next = 15;
          return (0, _effects.call)(apiOutlets.outlets);

        case 15:
          response = _context5.sent;
          _context5.next = 18;
          return (0, _effects.put)(actGratuity.setOutlets(response.data));

        case 18:
          _context5.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          resProfile = _context5.sent;

          mpLibraryGratuity.libraryGratuityStart({ currOutlet: resProfile.data.outlet_id[0] });

          _context5.next = 24;
          return (0, _effects.call)(fillSearchFormFromProfile, resProfile.data);

        case 24:
          _context5.next = 26;
          return (0, _effects.call)(apiGratuity.getGratuities, { page: 1 });

        case 26:
          resGratuities = _context5.sent;
          gratuities = resGratuities.data.results;
          _context5.next = 30;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 30:
          _context5.next = 32;
          return (0, _effects.put)(actGratuity.setTotalPage(resGratuities.data.total_pages));

        case 32:
          _context5.next = 34;
          return (0, _effects.put)(actGratuity.setCurrentPage(1));

        case 34:
          _context5.next = 40;
          break;

        case 36:
          _context5.prev = 36;
          _context5.t0 = _context5['catch'](12);
          _context5.next = 40;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 40:
          _context5.prev = 40;
          _context5.next = 43;
          return (0, _effects.put)(act.hideProgressBar());

        case 43:
          _context5.next = 45;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 45:
          return _context5.finish(40);

        case 46:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[12, 36, 40, 46]]);
}

function gratuitiesRequest(action) {
  var _action$payload, params, previousGratuities, response, gratuities;

  return _regenerator2.default.wrap(function gratuitiesRequest$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload = action.payload, params = _action$payload.params, previousGratuities = _action$payload.previousGratuities;
          _context6.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context6.prev = 3;
          _context6.next = 6;
          return (0, _effects.call)(apiGratuity.getGratuities, params);

        case 6:
          response = _context6.sent;
          gratuities = previousGratuities.concat(response.data.results);
          _context6.next = 10;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 10:
          _context6.next = 12;
          return (0, _effects.put)(actGratuity.setTotalPage(response.data.total_pages));

        case 12:
          _context6.next = 14;
          return (0, _effects.put)(actGratuity.setCurrentPage(params.page));

        case 14:
          _context6.next = 20;
          break;

        case 16:
          _context6.prev = 16;
          _context6.t0 = _context6['catch'](3);
          _context6.next = 20;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 20:
          _context6.prev = 20;
          _context6.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          _context6.next = 25;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 25:
          return _context6.finish(20);

        case 26:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[3, 16, 20, 26]]);
}

function onChangeOutletIds(action) {
  var outletIds, res;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(actGratuity.setGratuities([]));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          outletIds = action.payload.outletIds;

          mpLibraryGratuity.libraryGratuityChangeOutlet({ currOutlet: outletIds });
          _context7.prev = 6;
          _context7.next = 9;
          return (0, _effects.put)(actGratuity.setGratuityDetail(null));

        case 9:
          _context7.next = 11;
          return (0, _effects.call)(closeRightColumn);

        case 11:
          _context7.next = 13;
          return (0, _effects.call)(fillForm, { id: null, amount: null, quantity: null });

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(act.showProgressBar());

        case 15:
          _context7.next = 17;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 17:
          _context7.next = 19;
          return (0, _effects.call)(apiGratuity.getGratuities, { page: 1 });

        case 19:
          res = _context7.sent;
          _context7.next = 22;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 22:
          _context7.next = 24;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 24:
          _context7.next = 26;
          return (0, _effects.put)(actGratuity.setGratuities(res.data.results));

        case 26:
          _context7.next = 28;
          return (0, _effects.put)(actGratuity.setTotalPage(res.data.total_pages));

        case 28:
          _context7.next = 30;
          return (0, _effects.put)(actGratuity.setCurrentPage(1));

        case 30:
          _context7.next = 36;
          break;

        case 32:
          _context7.prev = 32;
          _context7.t0 = _context7['catch'](6);
          _context7.next = 36;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 36:
          _context7.prev = 36;
          _context7.next = 39;
          return (0, _effects.put)(act.hideProgressBar());

        case 39:
          _context7.next = 41;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 41:
          return _context7.finish(36);

        case 42:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[6, 32, 36, 42]]);
}

function clickGratuityRow(request) {
  var gratuity, res;
  return _regenerator2.default.wrap(function clickGratuityRow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          gratuity = request.payload.gratuity;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context8.next = 6;
          return (0, _effects.call)(apiGratuity.getGratutityById, gratuity.id);

        case 6:
          res = _context8.sent;
          _context8.next = 9;
          return (0, _effects.put)(actGratuity.setGratuityDetail(res.data));

        case 9:
          _context8.next = 11;
          return (0, _effects.call)(fillForm, res.data);

        case 11:
          _context8.next = 13;
          return (0, _effects.call)(openRightColumn);

        case 13:
          _context8.next = 19;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 19;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 19:
          _context8.prev = 19;
          _context8.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          return _context8.finish(19);

        case 23:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 15, 19, 23]]);
}

function submitFormCreate(request) {
  var _request$payload, data, previousGratuities, response, gratuity, gratuities;

  return _regenerator2.default.wrap(function submitFormCreate$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload = request.payload, data = _request$payload.data, previousGratuities = _request$payload.previousGratuities;
          _context9.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context9.next = 5;
          return (0, _effects.put)(actGratuity.isSubmittingForm(true));

        case 5:
          _context9.prev = 5;
          _context9.next = 8;
          return (0, _effects.call)(apiGratuity.postGratuity, data);

        case 8:
          response = _context9.sent;

          // set to reducers
          gratuity = response.data;
          gratuities = [gratuity];

          previousGratuities.forEach(function (g) {
            return gratuities.push(g);
          });

          _context9.next = 14;
          return (0, _effects.put)(actNotif.success('Gratuity successfully created.'));

        case 14:
          _context9.next = 16;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 16:
          _context9.next = 18;
          return (0, _effects.put)(actGratuity.setGratuityDetail(gratuity));

        case 18:
          _context9.next = 20;
          return (0, _effects.call)(fillForm, gratuity);

        case 20:
          _context9.next = 26;
          break;

        case 22:
          _context9.prev = 22;
          _context9.t0 = _context9['catch'](5);
          _context9.next = 26;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 26:
          _context9.prev = 26;
          _context9.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          _context9.next = 31;
          return (0, _effects.put)(actGratuity.isSubmittingForm(false));

        case 31:
          return _context9.finish(26);

        case 32:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[5, 22, 26, 32]]);
}

function submitFormCreateAllOutlet(request) {
  var _request$payload2, data, previousGratuities, response, gratuity, gratuities;

  return _regenerator2.default.wrap(function submitFormCreateAllOutlet$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _request$payload2 = request.payload, data = _request$payload2.data, previousGratuities = _request$payload2.previousGratuities;
          _context10.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context10.next = 5;
          return (0, _effects.put)(actGratuity.isSubmittingForm(true));

        case 5:
          _context10.prev = 5;
          _context10.next = 8;
          return (0, _effects.call)(apiGratuity.postCreateAllOutlet, data);

        case 8:
          response = _context10.sent;

          // set to reducers
          gratuity = response.data;
          gratuities = [gratuity];

          previousGratuities.forEach(function (g) {
            return gratuities.push(g);
          });

          _context10.next = 14;
          return (0, _effects.put)(actNotif.success('Gratuity successfully created.'));

        case 14:
          _context10.next = 16;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 16:
          _context10.next = 18;
          return (0, _effects.put)(actGratuity.setGratuityDetail(gratuity));

        case 18:
          _context10.next = 20;
          return (0, _effects.call)(fillForm, gratuity);

        case 20:
          _context10.next = 26;
          break;

        case 22:
          _context10.prev = 22;
          _context10.t0 = _context10['catch'](5);
          _context10.next = 26;
          return (0, _effects.put)(actNotif.error(_context10.t0.message));

        case 26:
          _context10.prev = 26;
          _context10.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          _context10.next = 31;
          return (0, _effects.put)(actGratuity.isSubmittingForm(false));

        case 31:
          return _context10.finish(26);

        case 32:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[5, 22, 26, 32]]);
}

function submitFormUpdate(request) {
  var _request$payload3, data, gratuityId, previousGratuities, response, gratuity, gratuities;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload3 = request.payload, data = _request$payload3.data, gratuityId = _request$payload3.gratuityId, previousGratuities = _request$payload3.previousGratuities;
          _context11.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context11.next = 5;
          return (0, _effects.put)(actGratuity.isSubmittingForm(true));

        case 5:
          _context11.prev = 5;
          _context11.next = 8;
          return (0, _effects.call)(apiGratuity.putGratuity, gratuityId, data);

        case 8:
          response = _context11.sent;

          // set to reducers
          gratuity = response.data;
          gratuities = [];

          previousGratuities.forEach(function (g) {
            if (g.id === gratuityId) {
              gratuities.push(gratuity);
            } else {
              gratuities.push(g);
            }
          });

          _context11.next = 14;
          return (0, _effects.put)(actNotif.success('Gratuity successfully updated.'));

        case 14:
          _context11.next = 16;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 16:
          _context11.next = 18;
          return (0, _effects.put)(actGratuity.setGratuityDetail(gratuity));

        case 18:
          _context11.next = 20;
          return (0, _effects.call)(fillForm, gratuity);

        case 20:
          _context11.next = 26;
          break;

        case 22:
          _context11.prev = 22;
          _context11.t0 = _context11['catch'](5);
          _context11.next = 26;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 26:
          _context11.prev = 26;
          _context11.next = 29;
          return (0, _effects.put)(act.hideProgressBar());

        case 29:
          _context11.next = 31;
          return (0, _effects.put)(actGratuity.isSubmittingForm(false));

        case 31:
          return _context11.finish(26);

        case 32:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[5, 22, 26, 32]]);
}

function deleteGratuity(request) {
  var _request$payload4, gratuityId, previousGratuities, gratuities;

  return _regenerator2.default.wrap(function deleteGratuity$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _request$payload4 = request.payload, gratuityId = _request$payload4.gratuityId, previousGratuities = _request$payload4.previousGratuities;
          _context12.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _.forEach(previousGratuities, function (gratuity) {
            if (gratuityId === gratuity.id) mpLibraryGratuity.libraryGratuityDelete({ gratuity: gratuity });
          });
          _context12.prev = 4;
          _context12.next = 7;
          return (0, _effects.call)(apiGratuity.deleteGratuity, gratuityId);

        case 7:
          // set to reducers

          gratuities = [];

          previousGratuities.forEach(function (g) {
            if (g.id !== gratuityId) {
              gratuities.push(g);
            }
          });
          _context12.next = 11;
          return (0, _effects.put)(actGratuity.setGratuities(gratuities));

        case 11:
          _context12.next = 13;
          return (0, _effects.put)(actGratuity.setGratuityDetail(null));

        case 13:
          _context12.next = 15;
          return (0, _effects.put)(actGratuity.setDeletedGratuity(null));

        case 15:
          _context12.next = 17;
          return (0, _effects.put)(actGratuity.hideDeleteGratuityModal());

        case 17:
          _context12.next = 19;
          return (0, _effects.call)(closeRightColumn);

        case 19:
          _context12.next = 21;
          return (0, _effects.call)(fillForm, { id: null, amount: null, quantity: null });

        case 21:
          _context12.next = 23;
          return (0, _effects.put)(actNotif.success('Gratuity successfully deleted.'));

        case 23:
          _context12.next = 29;
          break;

        case 25:
          _context12.prev = 25;
          _context12.t0 = _context12['catch'](4);
          _context12.next = 29;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 29:
          _context12.prev = 29;
          _context12.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context12.finish(29);

        case 33:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[4, 25, 29, 33]]);
}

function clickCancel(request) {
  return _regenerator2.default.wrap(function clickCancel$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)(actGratuity.setGratuityDetail(null));

        case 2:
          _context13.next = 4;
          return (0, _effects.call)(fillForm, { id: null, amount: null, name: null });

        case 4:
          _context13.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function clickCreateGratuity() {
  return _regenerator2.default.wrap(function clickCreateGratuity$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)(actGratuity.setGratuityDetail(null));

        case 2:
          _context14.next = 4;
          return (0, _effects.call)(fillForm, { id: null, amount: null, name: null });

        case 4:
          _context14.next = 6;
          return (0, _effects.call)(openRightColumn);

        case 6:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function askDeleteGratuity(request) {
  var deletedGratuity;
  return _regenerator2.default.wrap(function askDeleteGratuity$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          deletedGratuity = request.payload.deletedGratuity;
          _context15.next = 3;
          return (0, _effects.put)(actGratuity.setDeletedGratuity(deletedGratuity));

        case 3:
          _context15.next = 5;
          return (0, _effects.put)(actGratuity.showDeleteGratuityModal());

        case 5:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function cancelDeleteGratuity() {
  return _regenerator2.default.wrap(function cancelDeleteGratuity$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actGratuity.setDeletedGratuity(null));

        case 2:
          _context16.next = 4;
          return (0, _effects.put)(actGratuity.hideDeleteGratuityModal());

        case 4:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_PAGE_REQUEST, pageRequest);

        case 2:
          _context17.next = 4;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 4:
          _context17.next = 6;
          return (0, _effects.takeEvery)(_constants.LIBRARY_GRATUITY_GRATUITIES_REQUEST, gratuitiesRequest);

        case 6:
          _context17.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_ON_CLICK_CANCEL, clickCancel);

        case 8:
          _context17.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_ON_CLICK_ROW, clickGratuityRow);

        case 10:
          _context17.next = 12;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE, submitFormCreate);

        case 12:
          _context17.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY, clickCreateGratuity);

        case 14:
          _context17.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_DELETE_GRATUITY, deleteGratuity);

        case 16:
          _context17.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_ASK_DELETE_GRATUITY, askDeleteGratuity);

        case 18:
          _context17.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 20:
          _context17.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY, cancelDeleteGratuity);

        case 22:
          _context17.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET, submitFormCreateAllOutlet);

        case 24:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fillFormDetail = fillFormDetail;
exports.fetchSummary = fetchSummary;
exports.onChangeOutletIds = onChangeOutletIds;
exports.pageRequestFlow = pageRequestFlow;
exports.getItems = getItems;
exports.itemsRequest = itemsRequest;
exports.getCategoriesWithUncategorizedFlow = getCategoriesWithUncategorizedFlow;
exports.getExportItem = getExportItem;
exports.downloadItemsTemplate = downloadItemsTemplate;
exports.clickCreateItem = clickCreateItem;
exports.clickCancel = clickCancel;
exports.clickItemRow = clickItemRow;
exports.onClickBtnItemVariant = onClickBtnItemVariant;
exports.onCancelItemVariantModal = onCancelItemVariantModal;
exports.onConfirmItemVariantModal = onConfirmItemVariantModal;
exports.onClickBtnItemTracking = onClickBtnItemTracking;
exports.onClickBtnCOGSTracking = onClickBtnCOGSTracking;
exports.onCancelItemInventoryAlertModal = onCancelItemInventoryAlertModal;
exports.onCancelCOGSModal = onCancelCOGSModal;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.onConfirmItemInventoryAlertModal = onConfirmItemInventoryAlertModal;
exports.onConfirmCOGSModal = onConfirmCOGSModal;
exports.deleteItem = deleteItem;
exports.onClickCreateCategory = onClickCreateCategory;
exports.onClickCancelCreateCategory = onClickCancelCreateCategory;
exports.onClickConfirmCreateCategory = onClickConfirmCreateCategory;
exports.onSuccessImport = onSuccessImport;
exports.default = libraryItemSaga;

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _category = __webpack_require__(1601);

var _constants = __webpack_require__(408);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _item = __webpack_require__(76);

var actItem = _interopRequireWildcard(_item);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _categories = __webpack_require__(429);

var apiCategory = _interopRequireWildcard(_categories);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _items = __webpack_require__(629);

var apiItem = _interopRequireWildcard(_items);

var _getExportedFile = __webpack_require__(92);

var actGetExportedFile = _interopRequireWildcard(_getExportedFile);

var _modifiers = __webpack_require__(631);

var apiModifier = _interopRequireWildcard(_modifiers);

var _taxes = __webpack_require__(633);

var apiTax = _interopRequireWildcard(_taxes);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _list = __webpack_require__(246);

var mpLibItem = _interopRequireWildcard(_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, fillFormDetail, fetchSummary, setFilterItem, fillSearch, onChangeOutletIds, pageRequestFlow, getItems, itemsRequest, getCategoriesWithUncategorizedFlow, getExportItem, downloadItemsTemplate, clickCreateItem, openRightColumn, closeRightColumn, clickCancel, clickItemRow, onClickBtnItemVariant, onCancelItemVariantModal, onConfirmItemVariantModal, onClickBtnItemTracking, onClickBtnCOGSTracking, onCancelItemInventoryAlertModal, onCancelCOGSModal, submitFormCreate, submitFormUpdate, onConfirmItemInventoryAlertModal, onConfirmCOGSModal, deleteItem, onClickCreateCategory, onClickCancelCreateCategory, onClickConfirmCreateCategory, onSuccessImport, libraryItemSaga].map(_regenerator2.default.mark);

/****************************************
 * API Request saga
 ****************************************/

function fillForm(item) {
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', {
            categoryId: item.categoryId,
            typeInventoryId: item.typeInventoryId,
            search: item.search
          }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillFormDetail(request) {
  var formatFormDetail;
  return _regenerator2.default.wrap(function fillFormDetail$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          formatFormDetail = request.payload.formatFormDetail;
          _context2.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('item', {
            id: formatFormDetail.id,
            name: formatFormDetail.name,
            itemVariant: formatFormDetail.itemVariant,
            itemInventory: formatFormDetail.itemInventory,
            description: formatFormDetail.description,
            modifierIds: formatFormDetail.modifierIds,
            itemInventoryIds: formatFormDetail.itemInventoryIds
          }));

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function fetchSummary(params) {
  var response;
  return _regenerator2.default.wrap(function fetchSummary$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.call)(apiItem.getSummary, params);

        case 5:
          response = _context3.sent;
          return _context3.abrupt('return', response.data);

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 13;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 13:
          return _context3.abrupt('return', false);

        case 14:
          _context3.prev = 14;
          _context3.next = 17;
          return (0, _effects.put)(act.hideProgressBar());

        case 17:
          return _context3.finish(14);

        case 18:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[2, 9, 14, 18]]);
}

function setFilterItem(request) {
  var _request$payload, categoryId, typeInventoryId, keyword;

  return _regenerator2.default.wrap(function setFilterItem$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actItem.setItems([]));

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _request$payload = request.payload, categoryId = _request$payload.categoryId, typeInventoryId = _request$payload.typeInventoryId, keyword = _request$payload.keyword;
          _context4.next = 7;
          return (0, _effects.put)(actItem.setFilterState(categoryId, typeInventoryId, keyword));

        case 7:
          _context4.next = 9;
          return (0, _effects.put)(act.showProgressBar());

        case 9:
          _context4.prev = 9;
          _context4.next = 12;
          return (0, _effects.call)(itemsRequest, { page: 1, categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword });

        case 12:
          _context4.next = 14;
          return (0, _effects.put)(actItem.itemSummaryRequest({ categoryId: categoryId, typeInventoryId: typeInventoryId, keyword: keyword }));

        case 14:
          _context4.next = 20;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4['catch'](9);
          _context4.next = 20;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 20:
          _context4.prev = 20;
          _context4.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          return _context4.finish(20);

        case 24:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[9, 16, 20, 24]]);
}

function fillSearch(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearch$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          assignedOutletIds = [];

          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context5.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function onChangeOutletIds(request) {
  var outletIds, resProfile, modifierRes, taxRes;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actItem.closeRightColumn());

        case 2:
          _context6.next = 4;
          return (0, _effects.put)(actItem.setItems([]));

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(actItem.setItemSummary([]));

        case 6:
          _context6.next = 8;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 8:
          outletIds = request.payload.outletIds;
          _context6.prev = 9;
          _context6.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context6.next = 14;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 14:
          _context6.next = 16;
          return (0, _effects.call)(apiProfile.getProfile);

        case 16:
          resProfile = _context6.sent;
          _context6.next = 19;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 19:
          _context6.next = 21;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 21:
          _context6.next = 23;
          return (0, _effects.put)(actItem.unSetFilterState());

        case 23:
          _context6.next = 25;
          return (0, _effects.call)(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });

        case 25:
          _context6.next = 27;
          return (0, _effects.call)(fillSearch, resProfile.data);

        case 27:
          _context6.next = 29;
          return (0, _effects.put)(actItem.listCategoryWithUncategorizedRequest());

        case 29:
          _context6.next = 31;
          return (0, _effects.call)(itemsRequest, { page: 1, categoryId: 0, typeInventoryId: 0, keyword: '' });

        case 31:
          _context6.next = 33;
          return (0, _effects.put)(actItem.itemSummaryRequest({}));

        case 33:
          _context6.next = 35;
          return (0, _effects.call)(apiModifier.getModifiersV1);

        case 35:
          modifierRes = _context6.sent;
          _context6.next = 38;
          return (0, _effects.put)(actItem.setModifiers(modifierRes.data));

        case 38:
          _context6.next = 40;
          return (0, _effects.call)(apiTax.getTaxes);

        case 40:
          taxRes = _context6.sent;
          _context6.next = 43;
          return (0, _effects.put)(actItem.setTaxes(taxRes.data.results));

        case 43:
          mpLibItem.libraryItemChangeFilter({
            outletIds: outletIds,
            category: 0,
            inventory: 0
          });
          _context6.next = 50;
          break;

        case 46:
          _context6.prev = 46;
          _context6.t0 = _context6['catch'](9);
          _context6.next = 50;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 50:
          _context6.prev = 50;
          _context6.next = 53;
          return (0, _effects.put)(act.hideProgressBar());

        case 53:
          _context6.next = 55;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 55:
          return _context6.finish(50);

        case 56:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[9, 46, 50, 56]]);
}

/**
 * Listen for page request of itemlibrary. This just works like wrapper
 */
function pageRequestFlow() {
  var response, resProfile, modifierRes, taxRes;
  return _regenerator2.default.wrap(function pageRequestFlow$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)(actItem.setItems([]));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(actItem.setItemSummary([]));

        case 6:
          _context7.next = 8;
          return (0, _effects.put)(actItem.setItemDetail(null));

        case 8:
          _context7.next = 10;
          return (0, _effects.put)(actItem.closeRightColumn());

        case 10:
          _context7.next = 12;
          return (0, _effects.put)((0, _reduxForm.reset)('item'));

        case 12:
          _context7.next = 14;
          return (0, _effects.put)(act.showProgressBar());

        case 14:
          _context7.prev = 14;
          _context7.next = 17;
          return (0, _effects.call)(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });

        case 17:
          _context7.next = 19;
          return (0, _effects.call)(itemsRequest, { page: 1, categoryId: 0, typeInventoryId: 0, keyword: '' });

        case 19:
          _context7.next = 21;
          return (0, _effects.call)(apiOutlets.outlets);

        case 21:
          response = _context7.sent;
          _context7.next = 24;
          return (0, _effects.put)(actItem.setOutlets(response.data));

        case 24:
          _context7.next = 26;
          return (0, _effects.call)(apiProfile.getProfile);

        case 26:
          resProfile = _context7.sent;
          _context7.next = 29;
          return (0, _effects.call)(apiModifier.getModifiersV1);

        case 29:
          modifierRes = _context7.sent;
          _context7.next = 32;
          return (0, _effects.call)(apiTax.getTaxes);

        case 32:
          taxRes = _context7.sent;
          _context7.next = 35;
          return (0, _effects.put)(actItem.setTaxes(taxRes.data.results));

        case 35:
          _context7.next = 37;
          return (0, _effects.put)(actItem.setModifiers(modifierRes.data));

        case 37:
          _context7.next = 39;
          return (0, _effects.call)(fillSearch, resProfile.data);

        case 39:
          _context7.next = 41;
          return (0, _effects.put)(actItem.listCategoryWithUncategorizedRequest());

        case 41:
          _context7.next = 43;
          return (0, _effects.put)(actItem.itemSummaryRequest({}));

        case 43:
          mpLibItem.libraryItemStart({
            outletIds: [resProfile.data.outlet_id[0]],
            category: 0,
            inventory: 0
          });
          _context7.next = 50;
          break;

        case 46:
          _context7.prev = 46;
          _context7.t0 = _context7['catch'](14);
          _context7.next = 50;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 50:
          _context7.prev = 50;
          _context7.next = 53;
          return (0, _effects.put)(act.hideProgressBar());

        case 53:
          _context7.next = 55;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 55:
          return _context7.finish(50);

        case 56:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[14, 46, 50, 56]]);
}

function getItems(params) {
  var response;
  return _regenerator2.default.wrap(function getItems$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)(act.showProgressBar());

        case 2:
          _context8.prev = 2;
          _context8.next = 5;
          return (0, _effects.call)(apiItem.getItems, params);

        case 5:
          response = _context8.sent;
          return _context8.abrupt('return', response.data);

        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8['catch'](2);
          _context8.next = 13;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 13:
          return _context8.abrupt('return', false);

        case 14:
          _context8.prev = 14;
          _context8.next = 17;
          return (0, _effects.put)(act.hideProgressBar());

        case 17:
          _context8.next = 19;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 19:
          return _context8.finish(14);

        case 20:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[2, 9, 14, 20]]);
}

function itemsRequest(request) {
  var categoryId, typeInventoryId, keyword, page, previousItems, items, requestPayload, filterState, query, itemsResponse, summary;
  return _regenerator2.default.wrap(function itemsRequest$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          categoryId = void 0, typeInventoryId = void 0, keyword = void 0, page = void 0, previousItems = void 0, items = void 0;

          if (request.payload) {
            requestPayload = request.payload.query;
            filterState = requestPayload.filterState;

            previousItems = request.payload.previousItems;
            categoryId = filterState.categoryId;
            typeInventoryId = filterState.typeInventoryId;
            keyword = filterState.keyword;
            page = requestPayload.page;
          } else {
            categoryId = request.categoryId;
            typeInventoryId = request.typeInventoryId;
            keyword = request.keyword;
            page = request.page;
          }
          query = {
            page: page,
            category_id: !parseInt(categoryId) ? '' : categoryId,
            inventory: !parseInt(typeInventoryId) ? 'all' : typeInventoryId === '1' ? 'low' : 'out',
            keyword: !keyword ? '' : keyword
          };
          _context9.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context9.prev = 5;
          _context9.next = 8;
          return (0, _effects.call)(getItems, query);

        case 8:
          itemsResponse = _context9.sent;

          if (previousItems) {
            items = previousItems.concat(itemsResponse);
          } else {
            items = itemsResponse;
          }
          _context9.next = 12;
          return (0, _effects.put)(actItem.setItems(items));

        case 12:
          if (!(page <= 1)) {
            _context9.next = 20;
            break;
          }

          _context9.next = 15;
          return (0, _effects.call)(fetchSummary, query);

        case 15:
          summary = _context9.sent;
          _context9.next = 18;
          return (0, _effects.put)(actItem.setItemSummary(summary));

        case 18:
          _context9.next = 20;
          return (0, _effects.put)(actItem.setTotalPage(summary.total_pages));

        case 20:
          _context9.next = 22;
          return (0, _effects.put)(actItem.setCurrentPage(page));

        case 22:
          _context9.next = 28;
          break;

        case 24:
          _context9.prev = 24;
          _context9.t0 = _context9['catch'](5);
          _context9.next = 28;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 28:
          _context9.prev = 28;
          _context9.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context9.finish(28);

        case 32:
          _context9.next = 34;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 34:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[5, 24, 28, 32]]);
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
function getCategoriesWithUncategorizedFlow() {
  var categories;
  return _regenerator2.default.wrap(function getCategoriesWithUncategorizedFlow$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (false) {
            _context10.next = 11;
            break;
          }

          _context10.next = 3;
          return (0, _effects.take)(_constants.LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST);

        case 3:
          _context10.next = 5;
          return (0, _effects.call)(_category.getCategoriesWithUncategorized);

        case 5:
          categories = _context10.sent;

          if (!categories) {
            _context10.next = 9;
            break;
          }

          _context10.next = 9;
          return (0, _effects.put)(actItem.setCategories(categories));

        case 9:
          _context10.next = 0;
          break;

        case 11:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function getExportItem(request) {
  var prefix, response, responseData;
  return _regenerator2.default.wrap(function getExportItem$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          prefix = request.payload.prefix;
          _context11.next = 3;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 3:
          _context11.prev = 3;
          _context11.next = 6;
          return (0, _effects.call)(apiItem.getExportItem);

        case 6:
          response = _context11.sent;
          responseData = response.data;

          if (!(responseData.message === 'ok')) {
            _context11.next = 13;
            break;
          }

          _context11.next = 11;
          return (0, _effects.put)(actGetExportedFile.getExportedWithoutOutlet(prefix));

        case 11:
          _context11.next = 15;
          break;

        case 13:
          _context11.next = 15;
          return (0, _effects.put)(actNotif.error(responseData.message));

        case 15:
          _context11.next = 21;
          break;

        case 17:
          _context11.prev = 17;
          _context11.t0 = _context11['catch'](3);
          _context11.next = 21;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 21:
          _context11.prev = 21;
          _context11.next = 24;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 24:
          return _context11.finish(21);

        case 25:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[3, 17, 21, 25]]);
}

function downloadItemsTemplate(request) {
  var prefix, response, responseData;
  return _regenerator2.default.wrap(function downloadItemsTemplate$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          prefix = request.payload.prefix;
          _context12.next = 3;
          return (0, _effects.put)(act.showLoadingSpinner(true));

        case 3:
          _context12.prev = 3;
          _context12.next = 6;
          return (0, _effects.call)(apiItem.getItemTemplate);

        case 6:
          response = _context12.sent;
          responseData = response.data;

          if (!(responseData.message === 'ok')) {
            _context12.next = 13;
            break;
          }

          _context12.next = 11;
          return (0, _effects.put)(actGetExportedFile.getExportedWithoutOutlet(prefix));

        case 11:
          _context12.next = 15;
          break;

        case 13:
          _context12.next = 15;
          return (0, _effects.put)(actNotif.error(responseData.message));

        case 15:
          _context12.next = 21;
          break;

        case 17:
          _context12.prev = 17;
          _context12.t0 = _context12['catch'](3);
          _context12.next = 21;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 21:
          _context12.prev = 21;
          _context12.next = 24;
          return (0, _effects.put)(act.showLoadingSpinner(false));

        case 24:
          return _context12.finish(21);

        case 25:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[3, 17, 21, 25]]);
}

function clickCreateItem() {
  var response, responseData;
  return _regenerator2.default.wrap(function clickCreateItem$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)(actItem.onClickCancel());

        case 2:
          _context13.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context13.prev = 4;
          _context13.next = 7;
          return (0, _effects.call)(apiItem.getNewItem);

        case 7:
          response = _context13.sent;
          responseData = response.data;

          responseData.active_modifiers = [];
          responseData.taxes = [];
          responseData.item_variants.map(function (iv) {
            iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price;
            iv.is_editable = !iv.is_saved;
            iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs);
            return iv;
          });
          if (responseData.item_variants.length < 1) {
            responseData.item_variants.push({
              name: '',
              price: null,
              sku: '',
              in_stock: 0,
              stock_alert: 0,
              cogs: null,
              saved_cogs: false,
              is_saved: false,
              is_editable: true,
              is_new: true
            });
          }
          _context13.next = 15;
          return (0, _effects.put)(actItem.setItemDetail(responseData));

        case 15:
          _context13.next = 17;
          return (0, _effects.put)(actItem.setMustScrollTop(true));

        case 17:
          _context13.next = 19;
          return (0, _effects.call)(openRightColumn);

        case 19:
          _context13.next = 21;
          return (0, _effects.put)((0, _reduxForm.initialize)('item', responseData));

        case 21:
          _context13.next = 27;
          break;

        case 23:
          _context13.prev = 23;
          _context13.t0 = _context13['catch'](4);
          _context13.next = 27;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 27:
          _context13.prev = 27;
          _context13.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          _context13.next = 32;
          return (0, _effects.put)(actItem.setMustScrollTop(false));

        case 32:
          return _context13.finish(27);

        case 33:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[4, 23, 27, 33]]);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)(actItem.openRightColumn());

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)(actItem.closeRightColumn());

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function clickCancel() {
  return _regenerator2.default.wrap(function clickCancel$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actItem.setItemDetail(null));

        case 2:
          _context16.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('item'));

        case 4:
          _context16.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function clickItemRow(request) {
  var item, itemDetailRes, itemDetail;
  return _regenerator2.default.wrap(function clickItemRow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          item = request.payload.item;
          _context17.prev = 1;
          _context17.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)('item'));

        case 4:
          _context17.next = 6;
          return (0, _effects.put)(actItem.setItemDetail(null));

        case 6:
          _context17.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context17.next = 10;
          return (0, _effects.call)(apiItem.getItemById, item.id);

        case 10:
          itemDetailRes = _context17.sent;
          itemDetail = itemDetailRes.data;
          _context17.next = 14;
          return (0, _effects.put)(actItem.setItemDetail(itemDetail));

        case 14:
          // change price to string to handle redux form isDirty
          itemDetail.item_variants.map(function (iv) {
            iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price;
            iv.is_editable = !iv.is_saved;
            iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs);
            return iv;
          });
          _context17.next = 17;
          return (0, _effects.put)((0, _reduxForm.initialize)('item', (0, _extends3.default)({}, itemDetail)));

        case 17:
          _context17.next = 19;
          return (0, _effects.put)(actItem.setMustScrollTop(true));

        case 19:
          _context17.next = 21;
          return (0, _effects.call)(openRightColumn);

        case 21:
          _context17.next = 27;
          break;

        case 23:
          _context17.prev = 23;
          _context17.t0 = _context17['catch'](1);
          _context17.next = 27;
          return (0, _effects.put)(actNotif.error(_context17.t0.message));

        case 27:
          _context17.prev = 27;
          _context17.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          _context17.next = 32;
          return (0, _effects.put)(actItem.setMustScrollTop(false));

        case 32:
          return _context17.finish(27);

        case 33:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[1, 23, 27, 33]]);
}

function onClickBtnItemVariant(request) {
  var itemForm;
  return _regenerator2.default.wrap(function onClickBtnItemVariant$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          itemForm = request.payload.itemForm;
          _context18.next = 3;
          return (0, _effects.put)(actItem.showItemVariantModal());

        case 3:
          _context18.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', itemForm));

        case 5:
          _context18.next = 7;
          return (0, _effects.put)(actItem.setPreviousItemForm(itemForm));

        case 7:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function onCancelItemVariantModal(request) {
  return _regenerator2.default.wrap(function onCancelItemVariantModal$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 2:
          _context19.next = 4;
          return (0, _effects.put)(actItem.hideItemVariantModal());

        case 4:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function onConfirmItemVariantModal(request) {
  var value, idx;
  return _regenerator2.default.wrap(function onConfirmItemVariantModal$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          value = request.payload.value;
          _context20.next = 3;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('item', 'item_variants'));

        case 3:
          idx = 0;

        case 4:
          if (!(idx < value.item_variants.length)) {
            _context20.next = 10;
            break;
          }

          _context20.next = 7;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('item', 'item_variants', value.item_variants[idx]));

        case 7:
          idx++;
          _context20.next = 4;
          break;

        case 10:
          _context20.next = 12;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 12:
          _context20.next = 14;
          return (0, _effects.put)(actItem.hideItemVariantModal());

        case 14:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function onClickBtnItemTracking(request) {
  var _request$payload2, itemForm, isTrack, thereIsNew, itemVariantsWithTracking, idx, newItem;

  return _regenerator2.default.wrap(function onClickBtnItemTracking$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _request$payload2 = request.payload, itemForm = _request$payload2.itemForm, isTrack = _request$payload2.isTrack;
          _context21.next = 3;
          return (0, _effects.put)(actItem.showItemInventoryAleryModal());

        case 3:
          _context21.next = 5;
          return (0, _effects.put)(actItem.setPreviousItemForm(itemForm));

        case 5:
          thereIsNew = false;
          itemVariantsWithTracking = itemForm.item_variants.map(function (iv) {
            if (iv.is_new || !isTrack) {
              thereIsNew = true;
              return (0, _extends3.default)({}, iv, {
                track_stock: true,
                stock_alert: iv.stock_alert ? iv.stock_alert : '0',
                alert: true,
                in_stock: iv.in_stock ? iv.in_stock : '0',
                is_new: false
              });
            } else {
              return (0, _extends3.default)({}, iv);
            }
          });
          // HACKY CODE
          // hack ini untuk mengakai hack yang dilakukan pada file yang sebelumnya pada saat solve FD-1471,
          // inti hack ini mencegah dirtyform jika tidak ada perubahan pada form item ketika confirm nanti, dan perlunya dirty pada saat ada iv baru
          // is_new akan true jika item variant baru terbentuk, dan akan false ketika ia di track

          if (!thereIsNew) {
            _context21.next = 19;
            break;
          }

          _context21.next = 10;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', (0, _extends3.default)({}, itemForm, { item_variants: [] })));

        case 10:
          idx = 0;

        case 11:
          if (!(idx < itemVariantsWithTracking.length)) {
            _context21.next = 17;
            break;
          }

          _context21.next = 14;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('modal_item_variants', 'item_variants', itemVariantsWithTracking[idx]));

        case 14:
          idx++;
          _context21.next = 11;
          break;

        case 17:
          _context21.next = 22;
          break;

        case 19:
          newItem = (0, _extends3.default)({}, itemForm, { item_variants: itemVariantsWithTracking });
          _context21.next = 22;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', newItem));

        case 22:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function onClickBtnCOGSTracking(request) {
  var _request$payload3, itemForm, isTrack, itemVariantsWithTracking, newItem;

  return _regenerator2.default.wrap(function onClickBtnCOGSTracking$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _request$payload3 = request.payload, itemForm = _request$payload3.itemForm, isTrack = _request$payload3.isTrack;
          _context22.next = 3;
          return (0, _effects.put)(actItem.showCOGSModal(isTrack));

        case 3:
          _context22.next = 5;
          return (0, _effects.put)(actItem.setPreviousItemForm(itemForm));

        case 5:
          if (isTrack) {
            _context22.next = 12;
            break;
          }

          itemVariantsWithTracking = itemForm.item_variants.map(function (iv) {
            if (!itemForm.id && iv.track_stock && iv.track_cogs === undefined) {
              return (0, _extends3.default)({}, iv, {
                track_cogs: true
              });
            } else {
              return (0, _extends3.default)({}, iv);
            }
          });
          newItem = (0, _extends3.default)({}, itemForm, { item_variants: itemVariantsWithTracking });
          _context22.next = 10;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', newItem));

        case 10:
          _context22.next = 14;
          break;

        case 12:
          _context22.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', itemForm));

        case 14:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

function onCancelItemInventoryAlertModal(request) {
  return _regenerator2.default.wrap(function onCancelItemInventoryAlertModal$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 2:
          _context23.next = 4;
          return (0, _effects.put)(actItem.hideItemInventoryAlertModal());

        case 4:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this);
}

function onCancelCOGSModal(request) {
  return _regenerator2.default.wrap(function onCancelCOGSModal$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 2:
          _context24.next = 4;
          return (0, _effects.put)(actItem.hideCOGSModal());

        case 4:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this);
}

function submitFormCreate(request) {
  var _request$payload4, values, items, allOutlet, search, postItemRes, updatedItem, createdItems, i, item, updatedItemRes, _updatedItemRes, query, summary;

  return _regenerator2.default.wrap(function submitFormCreate$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _request$payload4 = request.payload, values = _request$payload4.values, items = _request$payload4.items, allOutlet = _request$payload4.allOutlet, search = _request$payload4.search;
          _context25.prev = 1;
          _context25.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context25.next = 6;
          return (0, _effects.put)(actItem.setIsSubmittingForm(true));

        case 6:
          values.item.item_variants.forEach(function (iv, index) {
            iv.position = index;
          });
          postItemRes = void 0;
          updatedItem = void 0;

          if (!allOutlet) {
            _context25.next = 28;
            break;
          }

          _context25.next = 12;
          return (0, _effects.call)(apiItem.postCreateAllOutletItem, values);

        case 12:
          postItemRes = _context25.sent;
          createdItems = JSON.parse(postItemRes.data.items);
          i = 0;

        case 15:
          if (!(i < createdItems.length)) {
            _context25.next = 26;
            break;
          }

          item = createdItems[i];

          if (!(item.outlet_id === search.outletIds[0])) {
            _context25.next = 23;
            break;
          }

          _context25.next = 20;
          return (0, _effects.call)(apiItem.getItemById, item.id);

        case 20:
          updatedItemRes = _context25.sent;

          updatedItem = updatedItemRes.data;
          items.unshift(updatedItem);

        case 23:
          i++;
          _context25.next = 15;
          break;

        case 26:
          _context25.next = 36;
          break;

        case 28:
          _context25.next = 30;
          return (0, _effects.call)(apiItem.postItem, values);

        case 30:
          postItemRes = _context25.sent;
          _context25.next = 33;
          return (0, _effects.call)(apiItem.getItemById, postItemRes.data.id);

        case 33:
          _updatedItemRes = _context25.sent;

          updatedItem = _updatedItemRes.data;
          items.unshift(updatedItem);

        case 36:
          updatedItem.item_variants.forEach(function (iv) {
            iv.is_editable = !iv.is_saved;
            iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs);
          });
          _context25.next = 39;
          return (0, _effects.put)((0, _reduxForm.initialize)('item', updatedItem));

        case 39:
          if (allOutlet) {
            mpLibItem.libraryItemCreate({ item: updatedItem, allOutlet: true });
          } else {
            mpLibItem.libraryItemCreate({ item: updatedItem, allOutlet: false });
          }

          query = {
            page: 1,
            category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
            inventory: !parseInt(search.typeInventoryId) ? 'all' : search.typeInventoryId === '1' ? 'low' : 'out',
            keyword: !search.search ? '' : search.search
          };
          _context25.next = 43;
          return (0, _effects.call)(fetchSummary, query);

        case 43:
          summary = _context25.sent;
          _context25.next = 46;
          return (0, _effects.put)(actItem.setItemSummary(summary));

        case 46:
          _context25.next = 48;
          return (0, _effects.put)(actItem.setItems(items));

        case 48:
          _context25.next = 50;
          return (0, _effects.put)(actItem.setItemDetail(updatedItem));

        case 50:
          if (!allOutlet) {
            _context25.next = 60;
            break;
          }

          if (!postItemRes.data.is_async_perform) {
            _context25.next = 56;
            break;
          }

          _context25.next = 54;
          return (0, _effects.put)(actItem.showSaveToAllOutletsModal());

        case 54:
          _context25.next = 58;
          break;

        case 56:
          _context25.next = 58;
          return (0, _effects.put)(actNotif.success('Item was successfully created.'));

        case 58:
          _context25.next = 62;
          break;

        case 60:
          _context25.next = 62;
          return (0, _effects.put)(actNotif.success('Item was successfully created.'));

        case 62:
          _context25.next = 68;
          break;

        case 64:
          _context25.prev = 64;
          _context25.t0 = _context25['catch'](1);
          _context25.next = 68;
          return (0, _effects.put)(actNotif.error(_context25.t0.message.includes('Custom Amount') ? 'Failed to create items' : _context25.t0.message));

        case 68:
          _context25.prev = 68;
          _context25.next = 71;
          return (0, _effects.put)(actItem.setIsSubmittingForm(false));

        case 71:
          _context25.next = 73;
          return (0, _effects.put)(act.hideProgressBar());

        case 73:
          return _context25.finish(68);

        case 74:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this, [[1, 64, 68, 74]]);
}

function submitFormUpdate(request) {
  var _request$payload5, itemId, values, items, updatedItemRes, updatedItem;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _request$payload5 = request.payload, itemId = _request$payload5.itemId, values = _request$payload5.values, items = _request$payload5.items;
          _context26.prev = 1;
          _context26.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context26.next = 6;
          return (0, _effects.put)(actItem.setIsSubmittingForm(true));

        case 6:
          _context26.next = 8;
          return (0, _effects.call)(apiItem.updateImageById, itemId, {
            item: {
              remote_image_url: values.item.image.url,
              category_id: values.item.category.id
            }
          });

        case 8:
          values.item.item_variants.map(function (iv, index) {
            if (!iv.track_cogs) {
              iv.cogs = null;
            }
            iv.position = index;
          });
          _context26.next = 11;
          return (0, _effects.call)(apiItem.putItemById, itemId, values);

        case 11:
          _context26.next = 13;
          return (0, _effects.call)(apiItem.getItemById, itemId);

        case 13:
          updatedItemRes = _context26.sent;
          updatedItem = updatedItemRes.data;

          items.forEach(function (item, index) {
            if (updatedItem.id === item.id) {
              items[index] = (0, _extends3.default)({}, updatedItem);
            }
          });
          updatedItem.item_variants.forEach(function (iv) {
            iv.is_editable = !iv.is_saved;
            iv.saved_cogs = !(iv.cogs === null && !iv.track_cogs);
          });
          _context26.next = 19;
          return (0, _effects.put)((0, _reduxForm.initialize)('item', updatedItem));

        case 19:
          mpLibItem.libraryItemUpdate({ item: updatedItem });
          _context26.next = 22;
          return (0, _effects.put)(actItem.setItems(items));

        case 22:
          _context26.next = 24;
          return (0, _effects.put)(actItem.setItemDetail(updatedItem));

        case 24:
          _context26.next = 26;
          return (0, _effects.put)(actNotif.success('Item was successfully saved.'));

        case 26:
          _context26.next = 32;
          break;

        case 28:
          _context26.prev = 28;
          _context26.t0 = _context26['catch'](1);
          _context26.next = 32;
          return (0, _effects.put)(actNotif.error(_context26.t0.message));

        case 32:
          _context26.prev = 32;
          _context26.next = 35;
          return (0, _effects.put)(actItem.setIsSubmittingForm(false));

        case 35:
          _context26.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          return _context26.finish(32);

        case 38:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this, [[1, 28, 32, 38]]);
}

function onConfirmItemInventoryAlertModal(request) {
  var _request$payload6, value, itemForm, itemVarCopy, idx;

  return _regenerator2.default.wrap(function onConfirmItemInventoryAlertModal$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _request$payload6 = request.payload, value = _request$payload6.value, itemForm = _request$payload6.itemForm;
          itemVarCopy = itemForm.item_variants;
          _context27.next = 4;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('item', 'item_variants'));

        case 4:
          idx = 0;

        case 5:
          if (!(idx < value.item_variants.length)) {
            _context27.next = 12;
            break;
          }

          if (value.item_variants[idx].track_cogs) {
            value.item_variants[idx].track_cogs = value.item_variants[idx].track_stock;
            if (!value.item_variants[idx].saved_cogs && !value.item_variants[idx].track_cogs) {
              value.item_variants[idx].cogs = null;
            }
          }
          _context27.next = 9;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('item', 'item_variants', (0, _extends3.default)({}, value.item_variants[idx], { is_saved: isSaved(value.item_variants[idx], itemVarCopy[idx]) })));

        case 9:
          idx++;
          _context27.next = 5;
          break;

        case 12:
          _context27.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 14:
          _context27.next = 16;
          return (0, _effects.put)(actItem.hideItemInventoryAlertModal());

        case 16:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked[26], this);
}

function isSaved(iv, civ) {
  return civ.is_saved || iv.track_stock;
}

function onConfirmCOGSModal(request) {
  var _request$payload7, value, isTrack, idx;

  return _regenerator2.default.wrap(function onConfirmCOGSModal$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _request$payload7 = request.payload, value = _request$payload7.value, isTrack = _request$payload7.isTrack;
          _context28.next = 3;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('item', 'item_variants'));

        case 3:
          idx = 0;

        case 4:
          if (!(idx < value.item_variants.length)) {
            _context28.next = 11;
            break;
          }

          if (!value.item_variants[idx].saved_cogs && !value.item_variants[idx].track_cogs) {
            value.item_variants[idx].cogs = null;
          }
          _context28.next = 8;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('item', 'item_variants', value.item_variants[idx]));

        case 8:
          idx++;
          _context28.next = 4;
          break;

        case 11:
          mpLibItem.cogsTrackingItem({ itemVariant: value.item_variants, cogsTrack: isTrack });
          _context28.next = 14;
          return (0, _effects.put)((0, _reduxForm.initialize)('modal_item_variants', {}));

        case 14:
          _context28.next = 16;
          return (0, _effects.put)(actItem.hideCOGSModal());

        case 16:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked[27], this);
}

function deleteItem(request) {
  var _request$payload8, item, previousItems, search, deletedIndex, query, summary;

  return _regenerator2.default.wrap(function deleteItem$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _request$payload8 = request.payload, item = _request$payload8.item, previousItems = _request$payload8.previousItems, search = _request$payload8.search;
          _context29.prev = 1;
          _context29.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          // remove items
          deletedIndex = -1;

          previousItems.forEach(function (pitem, index) {
            if (pitem.id === item.id) {
              deletedIndex = index;
            }
          });
          if (deletedIndex !== -1) {
            previousItems.splice(deletedIndex, 1);
          }
          _context29.next = 9;
          return (0, _effects.call)(apiItem.deleteItemByIdV1, item.id);

        case 9:
          _context29.next = 11;
          return (0, _effects.call)(closeRightColumn);

        case 11:
          _context29.next = 13;
          return (0, _effects.put)(actItem.setItemDetail(null));

        case 13:
          _context29.next = 15;
          return (0, _effects.put)((0, _reduxForm.reset)('item'));

        case 15:
          _context29.next = 17;
          return (0, _effects.put)(actItem.hideDeleteModal());

        case 17:
          query = {
            page: 1,
            category_id: !parseInt(search.categoryId) ? '' : search.categoryId,
            inventory: !parseInt(search.typeInventoryId) ? 'all' : search.typeInventoryId === '1' ? 'low' : 'out',
            keyword: !search.search ? '' : search.search
          };
          _context29.next = 20;
          return (0, _effects.call)(fetchSummary, query);

        case 20:
          summary = _context29.sent;
          _context29.next = 23;
          return (0, _effects.put)(actItem.setItemSummary(summary));

        case 23:
          _context29.next = 25;
          return (0, _effects.put)(actNotif.success('Item was successfully removed.'));

        case 25:
          _context29.next = 31;
          break;

        case 27:
          _context29.prev = 27;
          _context29.t0 = _context29['catch'](1);
          _context29.next = 31;
          return (0, _effects.put)(actNotif.error(_context29.t0.message));

        case 31:
          _context29.prev = 31;
          _context29.next = 34;
          return (0, _effects.put)(act.hideProgressBar());

        case 34:
          return _context29.finish(31);

        case 35:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked[28], this, [[1, 27, 31, 35]]);
}

function onClickCreateCategory(request) {
  var _request$payload9, category, previousCategories, previousCategoryId, categories;

  return _regenerator2.default.wrap(function onClickCreateCategory$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          _request$payload9 = request.payload, category = _request$payload9.category, previousCategories = _request$payload9.previousCategories, previousCategoryId = _request$payload9.previousCategoryId;
          _context30.next = 3;
          return (0, _effects.put)(actItem.setNewCategory(category));

        case 3:
          _context30.next = 5;
          return (0, _effects.put)(actItem.setPreviousCategories(previousCategories));

        case 5:
          // push new category since we want to 'manipulate' the view using redux,
          // using id == 0 as 'dummy id' for category
          categories = [].concat((0, _toConsumableArray3.default)(previousCategories));

          categories.push({
            id: 0,
            name: category
          });
          _context30.next = 9;
          return (0, _effects.put)(actItem.setCategories(categories));

        case 9:
          _context30.next = 11;
          return (0, _effects.put)(actItem.setPreviousCategoryId(previousCategoryId));

        case 11:
          _context30.next = 13;
          return (0, _effects.call)(_reduxSaga.delay, 50);

        case 13:
          _context30.next = 15;
          return (0, _effects.put)((0, _reduxForm.change)('item', 'category_id', 0));

        case 15:
          if (!category) {
            _context30.next = 18;
            break;
          }

          _context30.next = 18;
          return (0, _effects.put)(actItem.showNewCategoryModal());

        case 18:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked[29], this);
}

function onClickCancelCreateCategory(request) {
  var _request$payload10, previousCategories, previousCategoryId;

  return _regenerator2.default.wrap(function onClickCancelCreateCategory$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _request$payload10 = request.payload, previousCategories = _request$payload10.previousCategories, previousCategoryId = _request$payload10.previousCategoryId;
          _context31.next = 3;
          return (0, _effects.put)(actItem.setCategories(previousCategories));

        case 3:
          _context31.next = 5;
          return (0, _effects.put)((0, _reduxForm.change)('item', 'category_id', previousCategoryId));

        case 5:
          _context31.next = 7;
          return (0, _effects.put)(actItem.hideNewCategoryModal());

        case 7:
        case 'end':
          return _context31.stop();
      }
    }
  }, _marked[30], this);
}

function onClickConfirmCreateCategory(request) {
  var category, createCategoryRes, categoriesRes;
  return _regenerator2.default.wrap(function onClickConfirmCreateCategory$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          category = request.payload.category;
          _context32.prev = 1;
          _context32.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context32.next = 6;
          return (0, _effects.call)(apiCategory.createCategory, { name: category });

        case 6:
          createCategoryRes = _context32.sent;
          _context32.next = 9;
          return (0, _effects.call)(apiCategory.getCategoriesWithUncategorizedV1);

        case 9:
          categoriesRes = _context32.sent;
          _context32.next = 12;
          return (0, _effects.put)(actItem.setCategories(categoriesRes.data));

        case 12:
          _context32.next = 14;
          return (0, _effects.put)((0, _reduxForm.change)('item', 'category_id', createCategoryRes.data.id));

        case 14:
          _context32.next = 16;
          return (0, _effects.put)(actNotif.success('Category successfully created.'));

        case 16:
          _context32.next = 22;
          break;

        case 18:
          _context32.prev = 18;
          _context32.t0 = _context32['catch'](1);
          _context32.next = 22;
          return (0, _effects.put)(actNotif.error(_context32.t0.message));

        case 22:
          _context32.prev = 22;
          _context32.next = 25;
          return (0, _effects.put)(act.hideProgressBar());

        case 25:
          _context32.next = 27;
          return (0, _effects.put)(actItem.hideNewCategoryModal());

        case 27:
          return _context32.finish(22);

        case 28:
        case 'end':
          return _context32.stop();
      }
    }
  }, _marked[31], this, [[1, 18, 22, 28]]);
}

function onSuccessImport() {
  return _regenerator2.default.wrap(function onSuccessImport$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return (0, _effects.put)(actItem.hideImportModal());

        case 2:
          _context33.next = 4;
          return (0, _effects.put)(actItem.closeRightColumn());

        case 4:
          _context33.next = 6;
          return (0, _effects.put)(actNotif.success('Item successfully imported'));

        case 6:
          _context33.next = 8;
          return (0, _effects.put)(actItem.pageRequest());

        case 8:
        case 'end':
          return _context33.stop();
      }
    }
  }, _marked[32], this);
}

function libraryItemSaga() {
  return _regenerator2.default.wrap(function libraryItemSaga$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          _context34.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_SET_FILTER_ITEM, setFilterItem);

        case 2:
          _context34.next = 4;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_PAGE_REQUEST, pageRequestFlow);

        case 4:
          _context34.next = 6;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 6:
          _context34.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_LIST_ITEM_REQUEST, itemsRequest);

        case 8:
          _context34.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ITEM_LIST_EXPORT, getExportItem);

        case 10:
          _context34.next = 12;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ITEM_LIST_TEMPLATE, downloadItemsTemplate);

        case 12:
          _context34.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_CREATE_ITEM, clickCreateItem);

        case 14:
          _context34.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_CANCEL, clickCancel);

        case 16:
          _context34.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_ROW, clickItemRow);

        case 18:
          _context34.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT, onClickBtnItemVariant);

        case 20:
          _context34.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL, onCancelItemVariantModal);

        case 22:
          _context34.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL, onConfirmItemVariantModal);

        case 24:
          _context34.next = 26;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING, onClickBtnItemTracking);

        case 26:
          _context34.next = 28;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING, onClickBtnCOGSTracking);

        case 28:
          _context34.next = 30;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, onCancelItemInventoryAlertModal);

        case 30:
          _context34.next = 32;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CANCEL_COGS_MODAL, onCancelCOGSModal);

        case 32:
          _context34.next = 34;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, onConfirmItemInventoryAlertModal);

        case 34:
          _context34.next = 36;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL, onConfirmCOGSModal);

        case 36:
          _context34.next = 38;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM, fillFormDetail);

        case 38:
          _context34.next = 40;
          return (0, _effects.fork)(getCategoriesWithUncategorizedFlow);

        case 40:
          _context34.next = 42;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_SUBMIT_FORM_CREATE, submitFormCreate);

        case 42:
          _context34.next = 44;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 44:
          _context34.next = 46;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_DELETE_ITEM, deleteItem);

        case 46:
          _context34.next = 48;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY, onClickCreateCategory);

        case 48:
          _context34.next = 50;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY, onClickConfirmCreateCategory);

        case 50:
          _context34.next = 52;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY, onClickCancelCreateCategory);

        case 52:
          _context34.next = 54;
          return (0, _effects.takeLatest)(_constants.LIBRARY_ITEM_ON_SUCCESS_IMPORT, onSuccessImport);

        case 54:
        case 'end':
          return _context34.stop();
      }
    }
  }, _marked[33], this);
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.pageRequest = pageRequest;
exports.onClickApplySetItem = onClickApplySetItem;
exports.applySetItemItemsRequest = applySetItemItemsRequest;
exports.cancelApplySetItem = cancelApplySetItem;
exports.confirmApplySetItem = confirmApplySetItem;
exports.modifiersRequest = modifiersRequest;
exports.onChangeOutletIds = onChangeOutletIds;
exports.clickModifierRow = clickModifierRow;
exports.submitFormCreate = submitFormCreate;
exports.submitFormCreateAllOutlet = submitFormCreateAllOutlet;
exports.submitFormUpdate = submitFormUpdate;
exports.deleteModifier = deleteModifier;
exports.clickCancel = clickCancel;
exports.clickCreateModifier = clickCreateModifier;
exports.askDeleteModifier = askDeleteModifier;
exports.cancelDeleteModifier = cancelDeleteModifier;
exports.onClickManageModifierOptions = onClickManageModifierOptions;
exports.onCancelManageModifierOptions = onCancelManageModifierOptions;
exports.onConfirmManageModifierOptions = onConfirmManageModifierOptions;
exports.default = saga;

var _constants = __webpack_require__(409);

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _modifier = __webpack_require__(102);

var actModifier = _interopRequireWildcard(_modifier);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _modifiers = __webpack_require__(631);

var apiModifier = _interopRequireWildcard(_modifiers);

var _items2 = __webpack_require__(239);

var apiItems = _interopRequireWildcard(_items2);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _modifier2 = __webpack_require__(297);

var mpLibraryModifier = _interopRequireWildcard(_modifier2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillSearchFormFromProfile, fillModifierFormFlow, fillApplySetItemFormFlow, emptyModifierFormFlow, openRightColumn, closeRightColumn, pageRequest, onClickApplySetItem, applySetItemItemsRequest, cancelApplySetItem, confirmApplySetItem, modifiersRequest, onChangeOutletIds, clickModifierRow, submitFormCreate, submitFormCreateAllOutlet, submitFormUpdate, deleteModifier, clickCancel, clickCreateModifier, askDeleteModifier, cancelDeleteModifier, onClickManageModifierOptions, onCancelManageModifierOptions, onConfirmManageModifierOptions, saga].map(_regenerator2.default.mark);

function fillSearchFormFromProfile(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearchFormFromProfile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          assignedOutletIds = [];


          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function fillModifierFormFlow(request) {
  var modifier, form;
  return _regenerator2.default.wrap(function fillModifierFormFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          modifier = request.payload.modifier;
          form = {
            id: modifier.id,
            name: modifier.name,
            options: modifier.active_options.map(function (modifier) {
              var id = modifier.id,
                  name = modifier.name,
                  price = modifier.price;

              price = price || price === 0 ? price.toString() : price;
              return { id: id, name: name, price: price };
            })
          };
          _context2.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('modifier', form));

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function fillApplySetItemFormFlow(request) {
  var modifier, form;
  return _regenerator2.default.wrap(function fillApplySetItemFormFlow$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          modifier = request.payload.modifier;
          form = {
            id: modifier.id,
            itemIds: modifier.active_item_modifiers.map(function (itemModifier) {
              return itemModifier.item_id;
            })
          };
          _context3.next = 4;
          return (0, _effects.put)((0, _reduxForm.initialize)('applySetItem', form));

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function emptyModifierFormFlow(request) {
  var form;
  return _regenerator2.default.wrap(function emptyModifierFormFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          form = {
            id: null,
            name: null,
            options: []
          };
          _context4.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('modifier', form));

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(actModifier.openRightColumn());

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actModifier.closeRightColumn());

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function pageRequest() {
  var response, resProfile, resModifier, modifiers;
  return _regenerator2.default.wrap(function pageRequest$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)(actModifier.setModifiers([]));

        case 2:
          _context7.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(actModifier.setModifierDetail(null));

        case 6:
          _context7.next = 8;
          return (0, _effects.put)(actModifier.setOutlets([]));

        case 8:
          _context7.next = 10;
          return (0, _effects.put)(actModifier.closeRightColumn());

        case 10:
          _context7.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context7.next = 14;
          return (0, _effects.put)(actModifier.emptyModifierForm());

        case 14:
          _context7.prev = 14;
          _context7.next = 17;
          return (0, _effects.call)(apiOutlets.outlets);

        case 17:
          response = _context7.sent;
          _context7.next = 20;
          return (0, _effects.put)(actModifier.setOutlets(response.data));

        case 20:
          _context7.next = 22;
          return (0, _effects.call)(apiProfile.getProfile);

        case 22:
          resProfile = _context7.sent;

          mpLibraryModifier.libraryModifierStart({
            current_outlet: resProfile.data.outlet_id[0]
          });

          _context7.next = 26;
          return (0, _effects.call)(fillSearchFormFromProfile, resProfile.data);

        case 26:
          _context7.next = 28;
          return (0, _effects.call)(apiModifier.getModifiers, { page: 1 });

        case 28:
          resModifier = _context7.sent;
          modifiers = resModifier.data.results;
          _context7.next = 32;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 32:
          _context7.next = 34;
          return (0, _effects.put)(actModifier.setTotalPage(resModifier.data.total_pages));

        case 34:
          _context7.next = 36;
          return (0, _effects.put)(actModifier.setCurrentPage(1));

        case 36:
          _context7.next = 42;
          break;

        case 38:
          _context7.prev = 38;
          _context7.t0 = _context7['catch'](14);
          _context7.next = 42;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 42:
          _context7.prev = 42;
          _context7.next = 45;
          return (0, _effects.put)(act.hideProgressBar());

        case 45:
          _context7.next = 47;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 47:
          return _context7.finish(42);

        case 48:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[14, 38, 42, 48]]);
}

function onClickApplySetItem(action) {
  var modifier, resItems, data;
  return _regenerator2.default.wrap(function onClickApplySetItem$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          modifier = action.payload.modifier;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context8.next = 6;
          return (0, _effects.call)(apiItems.getItems, {});

        case 6:
          resItems = _context8.sent;
          data = resItems.data;
          _context8.next = 10;
          return (0, _effects.put)(actModifier.applySetItemFillForm(modifier));

        case 10:
          _context8.next = 12;
          return (0, _effects.put)(actModifier.applySetItemSetCurrentPage(1));

        case 12:
          _context8.next = 14;
          return (0, _effects.put)(actModifier.applySetItemSetTotalPage(data.total_pages));

        case 14:
          _context8.next = 16;
          return (0, _effects.put)(actModifier.applySetItemSetItems(data.results));

        case 16:
          _context8.next = 18;
          return (0, _effects.put)(actModifier.showApplySetItem());

        case 18:
          _context8.next = 24;
          break;

        case 20:
          _context8.prev = 20;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 24;
          return (0, _effects.put)(actNotif.error(_context8.t0.message));

        case 24:
          _context8.prev = 24;
          _context8.next = 27;
          return (0, _effects.put)(act.hideProgressBar());

        case 27:
          return _context8.finish(24);

        case 28:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[1, 20, 24, 28]]);
}

function applySetItemItemsRequest(request) {
  var _request$payload, params, previousItems, resItems, data, items, _resItems, _data, _items;

  return _regenerator2.default.wrap(function applySetItemItemsRequest$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload = request.payload, params = _request$payload.params, previousItems = _request$payload.previousItems;
          _context9.prev = 1;
          _context9.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          if (!(params && params.keyword)) {
            _context9.next = 19;
            break;
          }

          // V1 API includes params with_batch to support pagination
          params.with_batch = true;
          _context9.next = 8;
          return (0, _effects.call)(apiItems.getItemsV1, params);

        case 8:
          resItems = _context9.sent;
          data = resItems.data;
          _context9.next = 12;
          return (0, _effects.put)(actModifier.applySetItemSetCurrentPage(1));

        case 12:
          _context9.next = 14;
          return (0, _effects.put)(actModifier.applySetItemSetTotalPage(1));

        case 14:
          items = data.results;
          _context9.next = 17;
          return (0, _effects.put)(actModifier.applySetItemSetItems(items));

        case 17:
          _context9.next = 30;
          break;

        case 19:
          _context9.next = 21;
          return (0, _effects.call)(apiItems.getItems, params);

        case 21:
          _resItems = _context9.sent;
          _data = _resItems.data;
          _context9.next = 25;
          return (0, _effects.put)(actModifier.applySetItemSetCurrentPage(params.page));

        case 25:
          _context9.next = 27;
          return (0, _effects.put)(actModifier.applySetItemSetTotalPage(_data.total_pages));

        case 27:
          _items = previousItems.concat(_data.results);
          _context9.next = 30;
          return (0, _effects.put)(actModifier.applySetItemSetItems(_items));

        case 30:
          _context9.next = 32;
          return (0, _effects.put)(actModifier.showApplySetItem());

        case 32:
          _context9.next = 38;
          break;

        case 34:
          _context9.prev = 34;
          _context9.t0 = _context9['catch'](1);
          _context9.next = 38;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 38:
          _context9.prev = 38;
          _context9.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          return _context9.finish(38);

        case 42:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[1, 34, 38, 42]]);
}

function cancelApplySetItem() {
  return _regenerator2.default.wrap(function cancelApplySetItem$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(actModifier.hideApplySetItemModal());

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function confirmApplySetItem(request) {
  var _request$payload2, data, modifierId, resModifier, modifiers;

  return _regenerator2.default.wrap(function confirmApplySetItem$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _request$payload2 = request.payload, data = _request$payload2.data, modifierId = _request$payload2.modifierId;
          _context11.prev = 1;
          _context11.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context11.next = 6;
          return (0, _effects.put)(actModifier.hideApplySetItemModal());

        case 6:
          _context11.next = 8;
          return (0, _effects.call)(apiModifier.postApplyToItems, modifierId, data);

        case 8:
          _context11.next = 10;
          return (0, _effects.put)(actModifier.setModifierDetail(null));

        case 10:
          _context11.next = 12;
          return (0, _effects.call)(closeRightColumn);

        case 12:
          _context11.next = 14;
          return (0, _effects.call)(apiModifier.getModifiers, { page: 1 });

        case 14:
          resModifier = _context11.sent;
          modifiers = resModifier.data.results;
          _context11.next = 18;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 18:
          _context11.next = 20;
          return (0, _effects.put)(actModifier.setTotalPage(resModifier.data.total_pages));

        case 20:
          _context11.next = 22;
          return (0, _effects.put)(actModifier.setCurrentPage(1));

        case 22:
          _context11.next = 24;
          return (0, _effects.put)(actNotif.success('Successfully applied modifier'));

        case 24:
          _context11.next = 30;
          break;

        case 26:
          _context11.prev = 26;
          _context11.t0 = _context11['catch'](1);
          _context11.next = 30;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 30:
          _context11.prev = 30;
          _context11.next = 33;
          return (0, _effects.put)(act.hideProgressBar());

        case 33:
          return _context11.finish(30);

        case 34:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[1, 26, 30, 34]]);
}

function modifiersRequest(action) {
  var _action$payload, params, previousModifiers, response, modifiers;

  return _regenerator2.default.wrap(function modifiersRequest$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _action$payload = action.payload, params = _action$payload.params, previousModifiers = _action$payload.previousModifiers;
          _context12.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context12.prev = 3;
          _context12.next = 6;
          return (0, _effects.call)(apiModifier.getModifiers, params);

        case 6:
          response = _context12.sent;
          modifiers = previousModifiers.concat(response.data.results);
          _context12.next = 10;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 10:
          _context12.next = 12;
          return (0, _effects.put)(actModifier.setTotalPage(response.data.total_pages));

        case 12:
          _context12.next = 14;
          return (0, _effects.put)(actModifier.setCurrentPage(params.page));

        case 14:
          _context12.next = 20;
          break;

        case 16:
          _context12.prev = 16;
          _context12.t0 = _context12['catch'](3);
          _context12.next = 20;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 20:
          _context12.prev = 20;
          _context12.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          return _context12.finish(20);

        case 24:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[3, 16, 20, 24]]);
}

function onChangeOutletIds(action) {
  var outletIds, res;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)(actModifier.setModifiers([]));

        case 2:
          _context13.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          outletIds = action.payload.outletIds;
          _context13.prev = 5;
          _context13.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context13.next = 10;
          return (0, _effects.call)(closeRightColumn);

        case 10:
          _context13.next = 12;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 12:
          _context13.next = 14;
          return (0, _effects.call)(apiModifier.getModifiers, { page: 1 });

        case 14:
          res = _context13.sent;
          _context13.next = 17;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 17:
          _context13.next = 19;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 19:
          _context13.next = 21;
          return (0, _effects.put)(actModifier.emptyModifierForm());

        case 21:
          _context13.next = 23;
          return (0, _effects.put)(actModifier.setModifiers(res.data.results));

        case 23:
          _context13.next = 25;
          return (0, _effects.put)(actModifier.setTotalPage(res.data.total_pages));

        case 25:
          _context13.next = 27;
          return (0, _effects.put)(actModifier.setCurrentPage(1));

        case 27:
          _context13.next = 33;
          break;

        case 29:
          _context13.prev = 29;
          _context13.t0 = _context13['catch'](5);
          _context13.next = 33;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 33:
          _context13.prev = 33;
          _context13.next = 36;
          return (0, _effects.put)(act.hideProgressBar());

        case 36:
          _context13.next = 38;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 38:
          return _context13.finish(33);

        case 39:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[5, 29, 33, 39]]);
}

function clickModifierRow(request) {
  var modifier, res;
  return _regenerator2.default.wrap(function clickModifierRow$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          modifier = request.payload.modifier;
          _context14.prev = 1;
          _context14.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context14.next = 6;
          return (0, _effects.call)(apiModifier.getModifierById, modifier.id);

        case 6:
          res = _context14.sent;
          _context14.next = 9;
          return (0, _effects.put)(actModifier.setModifierDetail(res.data));

        case 9:
          _context14.next = 11;
          return (0, _effects.put)(actModifier.fillModifierForm(res.data));

        case 11:
          _context14.next = 13;
          return (0, _effects.call)(openRightColumn);

        case 13:
          _context14.next = 19;
          break;

        case 15:
          _context14.prev = 15;
          _context14.t0 = _context14['catch'](1);
          _context14.next = 19;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 19:
          _context14.prev = 19;
          _context14.next = 22;
          return (0, _effects.put)(act.hideProgressBar());

        case 22:
          return _context14.finish(19);

        case 23:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[1, 15, 19, 23]]);
}

function submitFormCreate(request) {
  var _request$payload3, data, previousModifiers, dataPayload, response, modifier, modifiers;

  return _regenerator2.default.wrap(function submitFormCreate$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _request$payload3 = request.payload, data = _request$payload3.data, previousModifiers = _request$payload3.previousModifiers;

          if (!(data.modifier.options.length === 0)) {
            _context15.next = 6;
            break;
          }

          _context15.next = 4;
          return (0, _effects.put)(actNotif.error('Please save at least one option'));

        case 4:
          _context15.next = 39;
          break;

        case 6:
          dataPayload = data;

          dataPayload.modifier.options = data.modifier.options.map(function (datum) {
            if (datum.price) {
              return datum;
            } else {
              return (0, _extends3.default)({}, datum, { price: null });
            }
          });
          _context15.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context15.next = 12;
          return (0, _effects.put)(actModifier.isSubmittingForm(true));

        case 12:
          _context15.prev = 12;
          _context15.next = 15;
          return (0, _effects.call)(apiModifier.postModifier, dataPayload);

        case 15:
          response = _context15.sent;

          // set to reducers
          modifier = response.data;
          modifiers = [modifier];

          previousModifiers.forEach(function (g) {
            return modifiers.push(g);
          });

          _context15.next = 21;
          return (0, _effects.put)(actNotif.success('Modifier successfully created.'));

        case 21:
          _context15.next = 23;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 23:
          _context15.next = 25;
          return (0, _effects.put)(actModifier.setModifierDetail(modifier));

        case 25:
          _context15.next = 27;
          return (0, _effects.put)(actModifier.fillModifierForm(modifier));

        case 27:
          _context15.next = 33;
          break;

        case 29:
          _context15.prev = 29;
          _context15.t0 = _context15['catch'](12);
          _context15.next = 33;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 33:
          _context15.prev = 33;
          _context15.next = 36;
          return (0, _effects.put)(act.hideProgressBar());

        case 36:
          _context15.next = 38;
          return (0, _effects.put)(actModifier.isSubmittingForm(false));

        case 38:
          return _context15.finish(33);

        case 39:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[12, 29, 33, 39]]);
}

function submitFormCreateAllOutlet(request) {
  var _request$payload4, data, previousModifiers, response, modifier, modifiers;

  return _regenerator2.default.wrap(function submitFormCreateAllOutlet$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _request$payload4 = request.payload, data = _request$payload4.data, previousModifiers = _request$payload4.previousModifiers;

          if (!(data.modifier.options.length === 0)) {
            _context16.next = 6;
            break;
          }

          _context16.next = 4;
          return (0, _effects.put)(actNotif.error('Please save at least one option'));

        case 4:
          _context16.next = 37;
          break;

        case 6:
          _context16.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context16.next = 10;
          return (0, _effects.put)(actModifier.isSubmittingForm(true));

        case 10:
          _context16.prev = 10;
          _context16.next = 13;
          return (0, _effects.call)(apiModifier.postCreateAllOutlet, data);

        case 13:
          response = _context16.sent;

          // set to reducers
          modifier = response.data;
          modifiers = [modifier];

          previousModifiers.forEach(function (g) {
            return modifiers.push(g);
          });

          _context16.next = 19;
          return (0, _effects.put)(actNotif.success('Modifiers successfully created.'));

        case 19:
          _context16.next = 21;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 21:
          _context16.next = 23;
          return (0, _effects.put)(actModifier.setModifierDetail(modifier));

        case 23:
          _context16.next = 25;
          return (0, _effects.put)(actModifier.fillModifierForm(modifier));

        case 25:
          _context16.next = 31;
          break;

        case 27:
          _context16.prev = 27;
          _context16.t0 = _context16['catch'](10);
          _context16.next = 31;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 31:
          _context16.prev = 31;
          _context16.next = 34;
          return (0, _effects.put)(act.hideProgressBar());

        case 34:
          _context16.next = 36;
          return (0, _effects.put)(actModifier.isSubmittingForm(false));

        case 36:
          return _context16.finish(31);

        case 37:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[10, 27, 31, 37]]);
}

function submitFormUpdate(request) {
  var _request$payload5, data, modifierId, previousModifiers, response, modifier, modifiers;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _request$payload5 = request.payload, data = _request$payload5.data, modifierId = _request$payload5.modifierId, previousModifiers = _request$payload5.previousModifiers;

          if (!(data.modifier.options.length === 0)) {
            _context17.next = 6;
            break;
          }

          _context17.next = 4;
          return (0, _effects.put)(actNotif.error('Please save at least one option'));

        case 4:
          _context17.next = 37;
          break;

        case 6:
          _context17.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context17.next = 10;
          return (0, _effects.put)(actModifier.isSubmittingForm(true));

        case 10:
          _context17.prev = 10;
          _context17.next = 13;
          return (0, _effects.call)(apiModifier.putModifier, modifierId, data);

        case 13:
          response = _context17.sent;

          // set to reducers
          modifier = response.data;
          modifiers = [];

          previousModifiers.forEach(function (g) {
            if (g.id === modifierId) {
              modifiers.push(modifier);
            } else {
              modifiers.push(g);
            }
          });

          _context17.next = 19;
          return (0, _effects.put)(actNotif.success('Modifier successfully updated.'));

        case 19:
          _context17.next = 21;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 21:
          _context17.next = 23;
          return (0, _effects.put)(actModifier.setModifierDetail(modifier));

        case 23:
          _context17.next = 25;
          return (0, _effects.put)(actModifier.fillModifierForm(modifier));

        case 25:
          _context17.next = 31;
          break;

        case 27:
          _context17.prev = 27;
          _context17.t0 = _context17['catch'](10);
          _context17.next = 31;
          return (0, _effects.put)(actNotif.error(_context17.t0.message));

        case 31:
          _context17.prev = 31;
          _context17.next = 34;
          return (0, _effects.put)(act.hideProgressBar());

        case 34:
          _context17.next = 36;
          return (0, _effects.put)(actModifier.isSubmittingForm(false));

        case 36:
          return _context17.finish(31);

        case 37:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[10, 27, 31, 37]]);
}

function deleteModifier(request) {
  var _request$payload6, modifierId, previousModifiers, modifiers;

  return _regenerator2.default.wrap(function deleteModifier$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _request$payload6 = request.payload, modifierId = _request$payload6.modifierId, previousModifiers = _request$payload6.previousModifiers;
          _context18.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context18.prev = 3;
          _context18.next = 6;
          return (0, _effects.call)(apiModifier.deleteModifier, modifierId);

        case 6:
          // set to reducers

          modifiers = [];

          previousModifiers.forEach(function (g) {
            if (g.id !== modifierId) {
              modifiers.push(g);
            }
          });
          _context18.next = 10;
          return (0, _effects.put)(actModifier.setModifiers(modifiers));

        case 10:
          _context18.next = 12;
          return (0, _effects.put)(actModifier.setModifierDetail(null));

        case 12:
          _context18.next = 14;
          return (0, _effects.put)(actModifier.setDeletedModifier(null));

        case 14:
          _context18.next = 16;
          return (0, _effects.put)(actModifier.hideDeleteModifierModal());

        case 16:
          _context18.next = 18;
          return (0, _effects.call)(closeRightColumn);

        case 18:
          _context18.next = 20;
          return (0, _effects.put)(actModifier.fillModifierForm({ id: null, amount: null, quantity: null, active_options: [] }));

        case 20:
          _context18.next = 22;
          return (0, _effects.put)(actNotif.success('Modifier successfully deleted.'));

        case 22:
          _context18.next = 28;
          break;

        case 24:
          _context18.prev = 24;
          _context18.t0 = _context18['catch'](3);
          _context18.next = 28;
          return (0, _effects.put)(actNotif.error(_context18.t0.message));

        case 28:
          _context18.prev = 28;
          _context18.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          return _context18.finish(28);

        case 32:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this, [[3, 24, 28, 32]]);
}

function clickCancel() {
  return _regenerator2.default.wrap(function clickCancel$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)(actModifier.setModifierDetail(null));

        case 2:
          _context19.next = 4;
          return (0, _effects.put)(actModifier.emptyModifierForm());

        case 4:
          _context19.next = 6;
          return (0, _effects.call)(closeRightColumn);

        case 6:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this);
}

function clickCreateModifier() {
  return _regenerator2.default.wrap(function clickCreateModifier$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.put)(actModifier.setModifierDetail(null));

        case 2:
          _context20.next = 4;
          return (0, _effects.put)(actModifier.emptyModifierForm());

        case 4:
          _context20.next = 6;
          return (0, _effects.call)(openRightColumn);

        case 6:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function askDeleteModifier(request) {
  var deletedModifier;
  return _regenerator2.default.wrap(function askDeleteModifier$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          deletedModifier = request.payload.deletedModifier;
          _context21.next = 3;
          return (0, _effects.put)(actModifier.setDeletedModifier(deletedModifier));

        case 3:
          _context21.next = 5;
          return (0, _effects.put)(actModifier.showDeleteModifierModal());

        case 5:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this);
}

function cancelDeleteModifier() {
  return _regenerator2.default.wrap(function cancelDeleteModifier$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.put)(actModifier.setDeletedModifier(null));

        case 2:
          _context22.next = 4;
          return (0, _effects.put)(actModifier.hideDeleteModifierModal());

        case 4:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

function onClickManageModifierOptions(request) {
  var previousModifierForm;
  return _regenerator2.default.wrap(function onClickManageModifierOptions$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          previousModifierForm = request.payload.previousModifierForm;
          _context23.next = 3;
          return (0, _effects.put)(actModifier.showModifierOptionsModal());

        case 3:
          _context23.next = 5;
          return (0, _effects.put)(actModifier.setPreviousModifierForm(previousModifierForm));

        case 5:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this);
}

function onCancelManageModifierOptions(request) {
  var previousModifierForm, idx;
  return _regenerator2.default.wrap(function onCancelManageModifierOptions$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          previousModifierForm = request.payload.previousModifierForm;
          _context24.next = 3;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)('modifier', 'options'));

        case 3:
          idx = 0;

        case 4:
          if (!(idx < previousModifierForm.options.length)) {
            _context24.next = 10;
            break;
          }

          _context24.next = 7;
          return (0, _effects.put)((0, _reduxForm.arrayPush)('modifier', 'options', previousModifierForm.options[idx]));

        case 7:
          idx++;
          _context24.next = 4;
          break;

        case 10:
          _context24.next = 12;
          return (0, _effects.put)(actModifier.hideModifierOptionsModal());

        case 12:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this);
}

function onConfirmManageModifierOptions(request) {
  var options;
  return _regenerator2.default.wrap(function onConfirmManageModifierOptions$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          options = request.payload.options;

          if (!(options.length === 0)) {
            _context25.next = 4;
            break;
          }

          _context25.next = 4;
          return (0, _effects.put)(actNotif.error('Please save at least one option.'));

        case 4:
          _context25.next = 6;
          return (0, _effects.put)(actModifier.hideModifierOptionsModal());

        case 6:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked[24], this);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_PAGE_REQUEST, pageRequest);

        case 2:
          _context26.next = 4;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 4:
          _context26.next = 6;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_MODIFIERS_REQUEST, modifiersRequest);

        case 6:
          _context26.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CLICK_CANCEL, clickCancel);

        case 8:
          _context26.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CLICK_ROW, clickModifierRow);

        case 10:
          _context26.next = 12;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE, submitFormCreate);

        case 12:
          _context26.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER, clickCreateModifier);

        case 14:
          _context26.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_DELETE_MODIFIER, deleteModifier);

        case 16:
          _context26.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ASK_DELETE_MODIFIER, askDeleteModifier);

        case 18:
          _context26.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 20:
          _context26.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER, cancelDeleteModifier);

        case 22:
          _context26.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET, submitFormCreateAllOutlet);

        case 24:
          _context26.next = 26;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM, onClickApplySetItem);

        case 26:
          _context26.next = 28;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM, cancelApplySetItem);

        case 28:
          _context26.next = 30;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM, confirmApplySetItem);

        case 30:
          _context26.next = 32;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM, fillApplySetItemFormFlow);

        case 32:
          _context26.next = 34;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST, applySetItemItemsRequest);

        case 34:
          _context26.next = 36;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_FILL_MODIFIER_FORM, fillModifierFormFlow);

        case 36:
          _context26.next = 38;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM, emptyModifierFormFlow);

        case 38:
          _context26.next = 40;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS, onClickManageModifierOptions);

        case 40:
          _context26.next = 42;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS, onConfirmManageModifierOptions);

        case 42:
          _context26.next = 44;
          return (0, _effects.takeLatest)(_constants.LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS, onCancelManageModifierOptions);

        case 44:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked[25], this);
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.onClickTaxAssignToItem = onClickTaxAssignToItem;
exports.taxAssignToItemToggleOne = taxAssignToItemToggleOne;
exports.taxAssignToItemSelectAllNone = taxAssignToItemSelectAllNone;
exports.taxAssignToItemItemsRequest = taxAssignToItemItemsRequest;
exports.cancelTaxAssignToItem = cancelTaxAssignToItem;
exports.confirmTaxAssignToItem = confirmTaxAssignToItem;
exports.taxesPageRequestFlow = taxesPageRequestFlow;
exports.taxesRequestFlow = taxesRequestFlow;
exports.onChangeOutletIds = onChangeOutletIds;
exports.onClickRowFlow = onClickRowFlow;
exports.onClickCancelFlow = onClickCancelFlow;
exports.updateTaxFlow = updateTaxFlow;
exports.onClickCreateTaxFlow = onClickCreateTaxFlow;
exports.createTaxFlow = createTaxFlow;
exports.deleteTaxRequest = deleteTaxRequest;
exports.deleteTaxFlow = deleteTaxFlow;
exports.cancelDeleteTaxFlow = cancelDeleteTaxFlow;
exports.createTaxAllOutletsFlow = createTaxAllOutletsFlow;
exports.default = saga;

var _constants = __webpack_require__(410);

var _effects = __webpack_require__(22);

var _reduxForm = __webpack_require__(7);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _tax = __webpack_require__(112);

var actTax = _interopRequireWildcard(_tax);

var _outlets = __webpack_require__(50);

var apiOutlets = _interopRequireWildcard(_outlets);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _taxes = __webpack_require__(633);

var apiTax = _interopRequireWildcard(_taxes);

var _items = __webpack_require__(629);

var apiItem = _interopRequireWildcard(_items);

var _categories = __webpack_require__(429);

var apiCategory = _interopRequireWildcard(_categories);

var _settings = __webpack_require__(290);

var apiSetting = _interopRequireWildcard(_settings);

var _actionBar = __webpack_require__(80);

var _loadingSpinner = __webpack_require__(46);

var _tax2 = __webpack_require__(247);

var mpLibraryTax = _interopRequireWildcard(_tax2);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

var _reactRouter = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [onClickTaxAssignToItem, taxAssignToItemFillFormFlow, taxAssignToItemToggleOne, taxAssignToItemSelectAllNone, taxAssignToItemItemsRequest, cancelTaxAssignToItem, confirmTaxAssignToItem, fillSearchFormFromProfile, fillFormTaxDetail, openRightColumn, closeRightColumn, taxesPageRequestFlow, taxesRequestFlow, onChangeOutletIds, onClickRowFlow, onClickCancelFlow, updateTaxFlow, onClickCreateTaxFlow, createTaxFlow, deleteTaxRequest, deleteTaxFlow, cancelDeleteTaxFlow, createTaxAllOutletsFlow, saga].map(_regenerator2.default.mark);

function onClickTaxAssignToItem(action) {
  var _action$payload, tax, categoryId, resItems2, summary, data;

  return _regenerator2.default.wrap(function onClickTaxAssignToItem$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, tax = _action$payload.tax, categoryId = _action$payload.categoryId;
          // set categoryId should be '' and not 0 for All Categories

          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context.next = 6;
          return (0, _effects.call)(apiItem.getItems, { category_id: categoryId, inventory: 'all', keyword: '', page: 1 });

        case 6:
          resItems2 = _context.sent;
          _context.next = 9;
          return (0, _effects.call)(apiItem.getSummary, { category_id: categoryId, inventory: 'all', keyword: '', page: 1 });

        case 9:
          summary = _context.sent;
          data = {
            results: resItems2.data,
            total_pages: summary.data.total_pages,
            total_count: summary.data.total_items
          };

          if (categoryId === '') {
            // change it to an integer
            categoryId = 0;
          }
          _context.next = 14;
          return (0, _effects.put)((0, _reduxForm.change)('taxAssignToItem', 'category_id', categoryId));

        case 14:
          _context.next = 16;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm(tax, categoryId));

        case 16:
          _context.next = 18;
          return (0, _effects.put)(actTax.taxAssignToItemSetCurrentPage(1));

        case 18:
          _context.next = 20;
          return (0, _effects.put)(actTax.taxAssignToItemSetTotalPage(data.total_pages));

        case 20:
          _context.next = 22;
          return (0, _effects.put)(actTax.taxAssignToItemSetItems(data.results));

        case 22:
          _context.next = 24;
          return (0, _effects.put)(actTax.taxAssignToItemSetTotalCount(data.total_count));

        case 24:
          _context.next = 26;
          return (0, _effects.put)(actTax.showTaxAssignToItemModal());

        case 26:
          _context.next = 32;
          break;

        case 28:
          _context.prev = 28;
          _context.t0 = _context['catch'](1);
          _context.next = 32;
          return (0, _effects.put)(actNotif.error(_context.t0.message));

        case 32:
          _context.prev = 32;
          _context.next = 35;
          return (0, _effects.put)(act.hideProgressBar());

        case 35:
          return _context.finish(32);

        case 36:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[1, 28, 32, 36]]);
}

function taxAssignToItemFillFormFlow(request) {
  var _request$payload, tax, categoryId, taxDetail, form;

  return _regenerator2.default.wrap(function taxAssignToItemFillFormFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          // IMPORTANT - Fill Map Here
          _request$payload = request.payload, tax = _request$payload.tax, categoryId = _request$payload.categoryId;
          taxDetail = tax.taxDetail;
          form = {
            id: 0,
            itemIds: [], // item tax mapping to ids on the form...
            category_id: categoryId
          };

          if (taxDetail !== null) {
            form = {
              id: taxDetail.id,
              category_id: categoryId,
              itemIds: taxDetail.items.map(function (itemTax) {
                return itemTax.item_id;
              }) // item tax mapping to ids on the form...
            };
          }
          _context2.next = 6;
          return (0, _effects.put)((0, _reduxForm.initialize)('taxAssignToItem', form));

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function taxAssignToItemToggleOne(request) {
  var _request$payload2, taxDetail, item, add, itemId, itemName, categoryId, i;

  return _regenerator2.default.wrap(function taxAssignToItemToggleOne$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _request$payload2 = request.payload, taxDetail = _request$payload2.taxDetail, item = _request$payload2.item, add = _request$payload2.add;
          itemId = item.id;
          itemName = item.name;
          categoryId = item.category_id;

          if (!(taxDetail === null)) {
            _context3.next = 7;
            break;
          }

          _context3.next = 21;
          break;

        case 7:
          if (!(add === true)) {
            _context3.next = 11;
            break;
          }

          // add to taxDetail.items - no need to sort
          taxDetail.items.push({
            item_id: itemId,
            category_id: categoryId,
            name: itemName
          });
          _context3.next = 19;
          break;

        case 11:
          i = 0;

        case 12:
          if (!(i < taxDetail.items.length)) {
            _context3.next = 19;
            break;
          }

          if (!(taxDetail.items[i].item_id === itemId)) {
            _context3.next = 16;
            break;
          }

          taxDetail.items.splice(i, 1);
          return _context3.abrupt('break', 19);

        case 16:
          i++;
          _context3.next = 12;
          break;

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(actTax.setTaxDetail(taxDetail));

        case 21:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function taxAssignToItemSelectAllNone(request) {
  var _request$payload3, taxDetail, categoryId, keyword, selectAll, _categoryId, name, response, taxData, theItems, form;

  return _regenerator2.default.wrap(function taxAssignToItemSelectAllNone$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _request$payload3 = request.payload, taxDetail = _request$payload3.taxDetail, categoryId = _request$payload3.categoryId, keyword = _request$payload3.keyword, selectAll = _request$payload3.selectAll;
          // get IDs from backend

          _categoryId = categoryId === 0 ? '' : categoryId;
          name = keyword === undefined ? '' : keyword;
          _context4.next = 8;
          return (0, _effects.call)(apiTax.filterTaxItem, _categoryId, name);

        case 8:
          response = _context4.sent;
          taxData = response.data;
          theItems = taxData.map(function (item) {
            return { item_id: item.id, category_id: item.category_id, name: item.name };
          });
          form = { // update form also...
            category_id: categoryId,
            keyword: keyword
          };

          if (!(taxDetail === null)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 20;
          break;

        case 15:
          if (selectAll === true) {
            // Add & Merge
            taxDetail.items = _.unionBy(taxDetail.items, theItems, 'item_id');
          } else {
            // Remove
            taxDetail.items = _.xorBy(taxDetail.items, _.intersectionBy(taxDetail.items, theItems, 'item_id'), 'item_id'); // or pull all by
          }
          _context4.next = 18;
          return (0, _effects.put)(actTax.setTaxDetail(taxDetail));

        case 18:
          form.id = taxDetail.id;
          form.itemIds = taxDetail.items.map(function (itemTax) {
            return itemTax.item_id;
          });

        case 20:
          if (taxDetail.id === null) {
            mpLibraryTax.libraryTaxCreateAssignItemAssignAll(taxDetail, categoryId, keyword);
          } else {
            mpLibraryTax.libraryTaxEditAssignItemAssignAll(taxDetail, categoryId, keyword);
          }
          // yield put(initialize('taxAssignToItem', form)) // Update The Form Here
          _context4.next = 23;
          return (0, _effects.put)((0, _reduxForm.change)('taxAssignToItem', 'itemIds', form.itemIds));

        case 23:
          _context4.next = 29;
          break;

        case 25:
          _context4.prev = 25;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 29;
          return (0, _effects.put)(actNotif.error(_context4.t0.message));

        case 29:
          _context4.prev = 29;
          _context4.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context4.finish(29);

        case 33:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[0, 25, 29, 33]]);
}

function taxAssignToItemItemsRequest(request) {
  var _request$payload4, params, previousItems, categoryId, resItems2, summary, data, items, itemsAsId, intersect;

  return _regenerator2.default.wrap(function taxAssignToItemItemsRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          // applySetItemItemsRequest
          _request$payload4 = request.payload, params = _request$payload4.params, previousItems = _request$payload4.previousItems;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          categoryId = params.categoryId === 0 ? '' : params.categoryId;
          _context5.next = 7;
          return (0, _effects.call)(apiItem.getItems, { no_categories: true, category_id: categoryId, inventory: 'all', keyword: params.keyword, page: params.page });

        case 7:
          resItems2 = _context5.sent;
          _context5.next = 10;
          return (0, _effects.call)(apiItem.getSummary, { no_categories: true, category_id: categoryId, inventory: 'all', keyword: params.keyword, page: params.page });

        case 10:
          summary = _context5.sent;
          data = {
            results: resItems2.data,
            total_pages: summary.data.total_pages,
            total_count: summary.data.total_items
          };
          _context5.next = 14;
          return (0, _effects.put)(actTax.taxAssignToItemSetCurrentPage(params.page));

        case 14:
          _context5.next = 16;
          return (0, _effects.put)(actTax.taxAssignToItemSetTotalPage(data.total_pages));

        case 16:
          _context5.next = 18;
          return (0, _effects.put)(actTax.taxAssignToItemSetTotalCount(data.total_count));

        case 18:
          // for total_count
          items = previousItems.concat(data.results);
          _context5.next = 21;
          return (0, _effects.put)(actTax.taxAssignToItemSetItems(items));

        case 21:
          itemsAsId = _.without(_.map(items, 'id'), undefined);
          intersect = _.intersection(itemsAsId, params.itemIds);

          if (!(intersect.length === itemsAsId.length && itemsAsId.length !== 0)) {
            _context5.next = 28;
            break;
          }

          _context5.next = 26;
          return (0, _effects.put)(actTax.checkSelectAllTaxItems());

        case 26:
          _context5.next = 30;
          break;

        case 28:
          _context5.next = 30;
          return (0, _effects.put)(actTax.uncheckSelectAllTaxItems());

        case 30:
          _context5.next = 32;
          return (0, _effects.put)(actTax.showTaxAssignToItemModal());

        case 32:
          _context5.next = 38;
          break;

        case 34:
          _context5.prev = 34;
          _context5.t0 = _context5['catch'](1);
          _context5.next = 38;
          return (0, _effects.put)(actNotif.error(_context5.t0.message));

        case 38:
          _context5.prev = 38;
          _context5.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          return _context5.finish(38);

        case 42:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[1, 34, 38, 42]]);
}

function cancelTaxAssignToItem(request) {
  var _request$payload5, taxDetail, url, form;

  return _regenerator2.default.wrap(function cancelTaxAssignToItem$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _request$payload5 = request.payload, taxDetail = _request$payload5.taxDetail, url = _request$payload5.url;
          form = {
            category_id: '', // like initialize
            keyword: ''
          };

          if (!(taxDetail === null)) {
            _context6.next = 5;
            break;
          }

          _context6.next = 10;
          break;

        case 5:
          taxDetail.items = taxDetail.org_items.filter(function (item) {
            return true;
          });
          _context6.next = 8;
          return (0, _effects.put)(actTax.setTaxDetail(taxDetail));

        case 8:
          form.id = taxDetail.id;
          form.itemIds = taxDetail.items.map(function (itemTax) {
            return itemTax.item_id;
          }); // item tax mapping to ids on the form...

        case 10:
          _context6.next = 12;
          return (0, _effects.put)((0, _reduxForm.initialize)('taxAssignToItem', form, false));

        case 12:
          _context6.next = 14;
          return (0, _effects.put)(actTax.hideTaxAssignToItemModal());

        case 14:
          if (url) {
            // onClickCancelFlow()
            _reactRouter.browserHistory.push(url);
          }

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function confirmTaxAssignToItem(request) {
  var _request$payload6, taxDetail, tax;

  return _regenerator2.default.wrap(function confirmTaxAssignToItem$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _request$payload6 = request.payload, taxDetail = _request$payload6.taxDetail, tax = _request$payload6.tax;

          if (!(taxDetail === null)) {
            _context7.next = 4;
            break;
          }

          _context7.next = 13;
          break;

        case 4:
          taxDetail.org_items = taxDetail.items.filter(function (item) {
            return true;
          });
          _context7.next = 7;
          return (0, _effects.put)(actTax.setTaxDetail(taxDetail));

        case 7:
          // original names, but with updated items (need to do here because it involves item_id and category_id )
          taxDetail.name = tax.values.name; // save form name & amount
          taxDetail.amount = tax.values.amount;
          taxDetail.custom_amount_flag = tax.values.custom_amount_flag;
          taxDetail.custom_amount_item = tax.values.custom_amount_item;
          _context7.next = 13;
          return (0, _effects.call)(fillFormTaxDetail, taxDetail);

        case 13:
          _context7.next = 15;
          return (0, _effects.put)(actTax.hideTaxAssignToItemModal());

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function fillSearchFormFromProfile(profile) {
  var assignedOutletIds, data;
  return _regenerator2.default.wrap(function fillSearchFormFromProfile$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          assignedOutletIds = [];

          if (profile.outlet_id.length > 1) {
            assignedOutletIds = [profile.outlet_id[0]];
          } else {
            assignedOutletIds = profile.outlet_id;
          }
          data = { 'outletIds': assignedOutletIds };
          _context8.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)('search', data));

        case 5:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function fillFormTaxDetail(tax) {
  var formTaxDetail;
  return _regenerator2.default.wrap(function fillFormTaxDetail$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          formTaxDetail = {
            id: tax.id,
            name: tax.name,
            amount: tax.amount ? tax.amount.toString() : tax.amount,
            item_ids: [],
            custom_amount_flag: tax.custom_amount_flag,
            custom_amount_item: tax.custom_amount_item
          };
          _context9.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('tax', formTaxDetail));

        case 3:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.put)(actTax.openRightColumn());

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)(actTax.closeRightColumn());

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function taxesPageRequestFlow() {
  var response, resSetting, resProfile, categoriesRes, resTaxes, taxes;
  return _regenerator2.default.wrap(function taxesPageRequestFlow$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)(actTax.setListTaxes([]));

        case 2:
          _context12.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          _context12.next = 6;
          return (0, _effects.put)(actTax.setTaxDetail(null));

        case 6:
          _context12.next = 8;
          return (0, _effects.put)(actTax.setOutlets([]));

        case 8:
          _context12.next = 10;
          return (0, _effects.call)(closeRightColumn);

        case 10:
          _context12.next = 12;
          return (0, _effects.put)(act.showProgressBar());

        case 12:
          _context12.prev = 12;
          _context12.next = 15;
          return (0, _effects.call)(apiOutlets.outlets);

        case 15:
          response = _context12.sent;
          _context12.next = 18;
          return (0, _effects.put)(actTax.setOutlets(response.data));

        case 18:
          _context12.next = 20;
          return (0, _effects.call)(apiSetting.getSettings);

        case 20:
          resSetting = _context12.sent;
          _context12.next = 23;
          return (0, _effects.put)(actTax.setSetting(resSetting.data[0]));

        case 23:
          _context12.next = 25;
          return (0, _effects.call)(apiProfile.getProfile);

        case 25:
          resProfile = _context12.sent;

          mpLibraryTax.libraryTaxStart({ currOutlet: resProfile.data.outlet_id[0] });
          _context12.next = 29;
          return (0, _effects.call)(fillSearchFormFromProfile, resProfile.data);

        case 29:
          _context12.next = 31;
          return (0, _effects.call)(apiCategory.getCategoriesWithUncategorizedV1);

        case 31:
          categoriesRes = _context12.sent;
          _context12.next = 34;
          return (0, _effects.put)(actTax.setCategories(categoriesRes.data));

        case 34:
          _context12.next = 36;
          return (0, _effects.call)(apiTax.getTaxService, { page: 0 });

        case 36:
          resTaxes = _context12.sent;
          // resProfile.data.business.id, resProfile.data.outlet_id[0]
          taxes = resTaxes.data.content;
          _context12.next = 40;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 40:
          _context12.next = 42;
          return (0, _effects.put)(actTax.setTotalPage(resTaxes.data.total_pages));

        case 42:
          _context12.next = 44;
          return (0, _effects.put)(actTax.setCurrentPage(0));

        case 44:
          _context12.next = 50;
          break;

        case 46:
          _context12.prev = 46;
          _context12.t0 = _context12['catch'](12);
          _context12.next = 50;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 50:
          _context12.prev = 50;
          _context12.next = 53;
          return (0, _effects.put)(act.hideProgressBar());

        case 53:
          _context12.next = 55;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 55:
          return _context12.finish(50);

        case 56:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[12, 46, 50, 56]]);
}

function taxesRequestFlow(action) {
  var _action$payload2, params, previousTaxes, response, taxes;

  return _regenerator2.default.wrap(function taxesRequestFlow$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _action$payload2 = action.payload, params = _action$payload2.params, previousTaxes = _action$payload2.previousTaxes;
          _context13.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _context13.prev = 3;
          _context13.next = 6;
          return (0, _effects.call)(apiTax.getTaxService, params);

        case 6:
          response = _context13.sent;
          taxes = previousTaxes.concat(response.data.content);
          _context13.next = 10;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 10:
          _context13.next = 12;
          return (0, _effects.put)(actTax.setTotalPage(response.data.total_pages));

        case 12:
          _context13.next = 14;
          return (0, _effects.put)(actTax.setCurrentPage(params.page));

        case 14:
          _context13.next = 20;
          break;

        case 16:
          _context13.prev = 16;
          _context13.t0 = _context13['catch'](3);
          _context13.next = 20;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 20:
          _context13.prev = 20;
          _context13.next = 23;
          return (0, _effects.put)(act.hideProgressBar());

        case 23:
          _context13.next = 25;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 25:
          return _context13.finish(20);

        case 26:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[3, 16, 20, 26]]);
}

function onChangeOutletIds(action) {
  var outletIds, categoriesRes, res, taxes;
  return _regenerator2.default.wrap(function onChangeOutletIds$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)(actTax.setListTaxes([]));

        case 2:
          _context14.next = 4;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 4:
          outletIds = action.payload.outletIds;


          mpLibraryTax.libraryChangeOutlet({ currOutlet: outletIds });
          _context14.prev = 6;
          _context14.next = 9;
          return (0, _effects.put)(actTax.setTaxDetail(null));

        case 9:
          _context14.next = 11;
          return (0, _effects.call)(closeRightColumn);

        case 11:
          _context14.next = 13;
          return (0, _effects.call)(fillFormTaxDetail, { id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null });

        case 13:
          _context14.next = 15;
          return (0, _effects.put)(act.showProgressBar());

        case 15:
          _context14.next = 17;
          return (0, _effects.call)(apiOutlets.patchLogin, { id: outletIds });

        case 17:
          _context14.next = 19;
          return (0, _effects.put)((0, _actionBar.setSelectedOutletIds)(outletIds));

        case 19:
          _context14.next = 21;
          return (0, _effects.put)((0, _reduxForm.change)('search', 'outletIds', outletIds));

        case 21:
          _context14.next = 23;
          return (0, _effects.call)(apiCategory.getCategoriesWithUncategorizedV1);

        case 23:
          categoriesRes = _context14.sent;
          _context14.next = 26;
          return (0, _effects.put)(actTax.setCategories(categoriesRes.data));

        case 26:
          _context14.next = 28;
          return (0, _effects.call)(apiTax.getTaxService, { page: 0 });

        case 28:
          res = _context14.sent;
          taxes = res.data.content;
          _context14.next = 32;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 32:
          _context14.next = 34;
          return (0, _effects.put)(actTax.setTotalPage(res.data.total_pages));

        case 34:
          _context14.next = 36;
          return (0, _effects.put)(actTax.setCurrentPage(1));

        case 36:
          _context14.next = 42;
          break;

        case 38:
          _context14.prev = 38;
          _context14.t0 = _context14['catch'](6);
          _context14.next = 42;
          return (0, _effects.put)(actNotif.error(_context14.t0.message));

        case 42:
          _context14.prev = 42;
          _context14.next = 45;
          return (0, _effects.put)(act.hideProgressBar());

        case 45:
          _context14.next = 47;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 47:
          return _context14.finish(42);

        case 48:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[6, 38, 42, 48]]);
}

function onClickRowFlow(request) {
  var tax, taxDetail, res, res1, tmp, res2;
  return _regenerator2.default.wrap(function onClickRowFlow$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          tax = request.payload.tax;
          _context15.prev = 1;
          _context15.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context15.next = 6;
          return (0, _effects.call)(apiTax.getTaxDetail, tax.id);

        case 6:
          taxDetail = _context15.sent;
          _context15.next = 9;
          return (0, _effects.call)(apiTax.getTaxItemDetail, tax.id);

        case 9:
          res = _context15.sent;
          _context15.next = 12;
          return (0, _effects.call)(apiTax.getItemCustomAmount, {});

        case 12:
          res1 = _context15.sent;

          if (res1.data.length > 0) {
            tmp = {
              id: res1.data[0].id,
              category_id: res1.data[0].category_id
            };

            taxDetail.data.custom_amount_item = tmp;
          } else {
            taxDetail.data.custom_amount_item = null;
          }
          _context15.next = 16;
          return (0, _effects.call)(apiTax.getTaxItemDetailCustomAmount, tax.id, {});

        case 16:
          res2 = _context15.sent;
          // for custom amount - TBD
          if (res2.data.length > 0) {
            taxDetail.data.custom_amount_flag = true;
          } else {
            taxDetail.data.custom_amount_flag = false;
          }

          taxDetail.data.items = res.data.map(function (item) {
            return { item_id: item.id, category_id: item.category_id, name: item.name };
          });
          taxDetail.data.org_items = taxDetail.data.items.filter(function (item) {
            return true;
          }); // set master here... to revert if cancel button pressed on tax form
          taxDetail.data.loaded_items = taxDetail.data.items.filter(function (item) {
            return true;
          }); // untouched loaded from file...

          _context15.next = 23;
          return (0, _effects.put)(actTax.setTaxDetail(taxDetail.data));

        case 23:
          _context15.next = 25;
          return (0, _effects.call)(fillFormTaxDetail, taxDetail.data);

        case 25:
          _context15.next = 27;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm({ taxDetail: taxDetail.data }));

        case 27:
          _context15.next = 29;
          return (0, _effects.call)(openRightColumn);

        case 29:
          _context15.next = 35;
          break;

        case 31:
          _context15.prev = 31;
          _context15.t0 = _context15['catch'](1);
          _context15.next = 35;
          return (0, _effects.put)(actNotif.error(_context15.t0.message));

        case 35:
          _context15.prev = 35;
          _context15.next = 38;
          return (0, _effects.put)(act.hideProgressBar());

        case 38:
          return _context15.finish(35);

        case 39:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this, [[1, 31, 35, 39]]);
}

function onClickCancelFlow() {
  return _regenerator2.default.wrap(function onClickCancelFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.put)(actTax.setTaxDetail(null));

        case 2:
          _context16.next = 4;
          return (0, _effects.call)(fillFormTaxDetail, { id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null });

        case 4:
          _context16.next = 6;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm({ taxDetail: {
              id: null, name: null, amount: null, items: []
            } }));

        case 6:
          _context16.next = 8;
          return (0, _effects.call)(closeRightColumn);

        case 8:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function updateTaxFlow(request) {
  var _request$payload7, id, data, previousTaxes, itemIds, response, taxData, taxes;

  return _regenerator2.default.wrap(function updateTaxFlow$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _request$payload7 = request.payload, id = _request$payload7.id, data = _request$payload7.data, previousTaxes = _request$payload7.previousTaxes, itemIds = _request$payload7.itemIds;

          data.item_ids = itemIds;

          _context17.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context17.next = 6;
          return (0, _effects.put)(actTax.isSubmittingForm(true));

        case 6:
          _context17.prev = 6;

          if (data.custom_amount_flag === true) {
            data.item_ids.push(data.custom_amount_item.id);
          }

          _context17.next = 10;
          return (0, _effects.call)(apiTax.updateTax, id, data);

        case 10:
          response = _context17.sent;
          taxData = response.data;
          taxes = [];

          previousTaxes.forEach(function (tax) {
            if (tax.id === id) {
              taxes.push(taxData);
            } else {
              taxes.push(tax);
            }
          });
          _context17.next = 16;
          return (0, _effects.put)(actNotif.success('Taxes successfully saved.'));

        case 16:
          _context17.next = 18;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 18:
          taxData.items = taxData.items.map(function (item) {
            return { item_id: item.id, category_id: item.category_id };
          });
          taxData.org_items = taxData.items.filter(function (item) {
            return true;
          });
          taxData.loaded_items = taxData.items.filter(function (item) {
            return true;
          });

          taxData.custom_amount_flag = data.custom_amount_flag;
          taxData.custom_amount_item = data.custom_amount_item;

          _context17.next = 25;
          return (0, _effects.put)(actTax.setTaxDetail(taxData));

        case 25:
          _context17.next = 27;
          return (0, _effects.call)(fillFormTaxDetail, taxData);

        case 27:
          _context17.next = 29;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm({
            taxDetail: {
              id: taxData.id,
              items: taxData.items
            }
          }));

        case 29:
          _context17.next = 35;
          break;

        case 31:
          _context17.prev = 31;
          _context17.t0 = _context17['catch'](6);
          _context17.next = 35;
          return (0, _effects.put)(actNotif.error(_context17.t0.message));

        case 35:
          _context17.prev = 35;
          _context17.next = 38;
          return (0, _effects.put)(act.hideProgressBar());

        case 38:
          _context17.next = 40;
          return (0, _effects.put)(actTax.isSubmittingForm(false));

        case 40:
          return _context17.finish(35);

        case 41:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[6, 31, 35, 41]]);
}

function onClickCreateTaxFlow() {
  return _regenerator2.default.wrap(function onClickCreateTaxFlow$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)(actTax.setTaxDetail({
            id: null,
            name: null,
            amount: null,
            business_id: null,
            outlet_id: null,
            items: [],
            org_items: [],
            loaded_items: [],
            custom_amount_item: null,
            custom_amount_flag: false
          }));

        case 2:
          _context18.next = 4;
          return (0, _effects.call)(fillFormTaxDetail, { id: null, name: null, amount: null, items: [], custom_amount_flag: false, custom_amount_item: null });

        case 4:
          _context18.next = 6;
          return (0, _effects.call)(openRightColumn);

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function createTaxFlow(request) {
  var customAmountItem, _request$payload8, data, previousTaxes, itemIds, selectedOutletIds, businessId, res1, response, taxData, taxes;

  return _regenerator2.default.wrap(function createTaxFlow$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          customAmountItem = null;
          _request$payload8 = request.payload, data = _request$payload8.data, previousTaxes = _request$payload8.previousTaxes, itemIds = _request$payload8.itemIds, selectedOutletIds = _request$payload8.selectedOutletIds, businessId = _request$payload8.businessId;

          data.item_ids = itemIds;
          data.outlet_id = selectedOutletIds; // the selected out outlet (it's an array)
          data.business_id = businessId;
          data = _.pick(data, ['name', 'amount', 'item_ids', 'outlet_id', 'business_id', 'custom_amount_flag']); // pick out fields required by API
          _context19.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context19.next = 10;
          return (0, _effects.put)(actTax.isSubmittingForm(true));

        case 10:
          _context19.prev = 10;

          if (!(data.custom_amount_flag === true)) {
            _context19.next = 16;
            break;
          }

          _context19.next = 14;
          return (0, _effects.call)(apiTax.getItemCustomAmount, {});

        case 14:
          res1 = _context19.sent;

          if (res1.data.length > 0) {
            customAmountItem = {
              id: res1.data[0].id,
              category_id: res1.data[0].category_id
            };
            data.item_ids.push(res1.data[0].id);
          }

        case 16:
          _context19.next = 18;
          return (0, _effects.call)(apiTax.createTax, data, businessId);

        case 18:
          response = _context19.sent;
          taxData = response.data;
          taxes = [taxData];

          previousTaxes.forEach(function (tax) {
            taxes.push(tax);
          });
          _context19.next = 24;
          return (0, _effects.put)(actNotif.success('Taxes successfully created.'));

        case 24:
          _context19.next = 26;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 26:
          taxData.items = taxData.items.map(function (item) {
            return { item_id: item.id, category_id: item.category_id };
          });
          taxData.org_items = taxData.items.filter(function (item) {
            return true;
          });
          taxData.loaded_items = taxData.items.filter(function (item) {
            return true;
          });
          taxData.custom_amount_flag = data.custom_amount_flag;
          taxData.custom_amount_item = customAmountItem;
          _context19.next = 33;
          return (0, _effects.put)(actTax.setTaxDetail(taxData));

        case 33:
          _context19.next = 35;
          return (0, _effects.call)(fillFormTaxDetail, taxData);

        case 35:
          _context19.next = 37;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm({
            taxDetail: {
              id: taxData.id,
              items: taxData.items
            }
          }));

        case 37:
          _context19.next = 43;
          break;

        case 39:
          _context19.prev = 39;
          _context19.t0 = _context19['catch'](10);
          _context19.next = 43;
          return (0, _effects.put)(actNotif.error(_context19.t0.message));

        case 43:
          _context19.prev = 43;
          _context19.next = 46;
          return (0, _effects.put)(act.hideProgressBar());

        case 46:
          _context19.next = 48;
          return (0, _effects.put)(actTax.isSubmittingForm(false));

        case 48:
          return _context19.finish(43);

        case 49:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this, [[10, 39, 43, 49]]);
}

function deleteTaxRequest(request) {
  var deletedTax;
  return _regenerator2.default.wrap(function deleteTaxRequest$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          deletedTax = request.payload.deletedTax;
          _context20.next = 3;
          return (0, _effects.put)(actTax.setDeletedTax(deletedTax));

        case 3:
          _context20.next = 5;
          return (0, _effects.put)(actTax.showDeleteModal());

        case 5:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this);
}

function deleteTaxFlow(request) {
  var _request$payload9, id, previousTaxes, taxDetail, categories, taxes;

  return _regenerator2.default.wrap(function deleteTaxFlow$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _request$payload9 = request.payload, id = _request$payload9.id, previousTaxes = _request$payload9.previousTaxes, taxDetail = _request$payload9.taxDetail, categories = _request$payload9.categories;
          _context21.next = 3;
          return (0, _effects.put)(act.showProgressBar());

        case 3:
          _.forEach(previousTaxes, function (prevTax) {
            if (id === prevTax.id) mpLibraryTax.libraryDeleteTax({ tax: prevTax, taxDetail: taxDetail, categories: categories });
          });
          _context21.prev = 4;
          _context21.next = 7;
          return (0, _effects.call)(apiTax.deleteTax, id);

        case 7:
          taxes = [];

          previousTaxes.forEach(function (tax) {
            if (tax.id !== id) {
              taxes.push(tax);
            }
          });
          _context21.next = 11;
          return (0, _effects.put)(actTax.setListTaxes(taxes));

        case 11:
          _context21.next = 13;
          return (0, _effects.put)(actTax.setTaxDetail(null));

        case 13:
          _context21.next = 15;
          return (0, _effects.put)(actTax.setDeletedTax(null));

        case 15:
          _context21.next = 17;
          return (0, _effects.put)(actTax.hideDeleteModal());

        case 17:
          _context21.next = 19;
          return (0, _effects.call)(closeRightColumn);

        case 19:
          _context21.next = 21;
          return (0, _effects.put)(actNotif.success('Taxes successfully deleted.'));

        case 21:
          _context21.next = 27;
          break;

        case 23:
          _context21.prev = 23;
          _context21.t0 = _context21['catch'](4);
          _context21.next = 27;
          return (0, _effects.put)(actNotif.error(_context21.t0.message));

        case 27:
          _context21.prev = 27;
          _context21.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          return _context21.finish(27);

        case 31:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this, [[4, 23, 27, 31]]);
}

function cancelDeleteTaxFlow() {
  return _regenerator2.default.wrap(function cancelDeleteTaxFlow$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.put)(actTax.setDeletedTax(null));

        case 2:
          _context22.next = 4;
          return (0, _effects.put)(actTax.hideDeleteModal());

        case 4:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

function createTaxAllOutletsFlow(request) {
  var customAmountItem, _request$payload10, data, previousTaxes, itemIds, outlets, selectedOutletIds, numberOfItems, res1, response, taxData, selectedTaxData, outletMap, resultForModal;

  return _regenerator2.default.wrap(function createTaxAllOutletsFlow$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          customAmountItem = null;
          _request$payload10 = request.payload, data = _request$payload10.data, previousTaxes = _request$payload10.previousTaxes, itemIds = _request$payload10.itemIds, outlets = _request$payload10.outlets, selectedOutletIds = _request$payload10.selectedOutletIds;

          data.item_ids = itemIds;
          data.outlet_id = selectedOutletIds;
          data.other_outlet_ids = _.without(_.map(outlets, 'id'), undefined);
          _.pull(data.other_outlet_ids, selectedOutletIds);
          _context23.next = 8;
          return (0, _effects.select)(apiTax.getBusinessId);

        case 8:
          data.business_id = _context23.sent;

          data = _.pick(data, ['name', 'amount', 'item_ids', 'outlet_id', 'business_id', 'other_outlet_ids', 'custom_amount_flag']);
          numberOfItems = data.item_ids.length; // for matching

          _context23.next = 13;
          return (0, _effects.put)(act.showProgressBar());

        case 13:
          _context23.next = 15;
          return (0, _effects.put)(actTax.isSubmittingForm(true));

        case 15:
          _context23.prev = 15;

          if (!(data.custom_amount_flag === true)) {
            _context23.next = 21;
            break;
          }

          _context23.next = 19;
          return (0, _effects.call)(apiTax.getItemCustomAmount, {});

        case 19:
          res1 = _context23.sent;

          if (res1.data.length > 0) {
            customAmountItem = {
              id: res1.data[0].id,
              category_id: res1.data[0].category_id
            };
            data.item_ids.push(res1.data[0].id);
          }

        case 21:
          _context23.next = 23;
          return (0, _effects.call)(apiTax.createTaxAllOutlets, data);

        case 23:
          response = _context23.sent;
          // START
          taxData = response.data;
          selectedTaxData = null;
          outletMap = _.keyBy(outlets, 'id');
          resultForModal = {
            outlet_success: [],
            outlet_failed: []
          };

          taxData.forEach(function (tax) {
            var outletName = tax.outlet_id;
            if (outletMap[tax.outlet_id] !== undefined) {
              outletName = outletMap[tax.outlet_id].name;
            }
            if (tax.items.length === numberOfItems) {
              resultForModal.outlet_success.push({ id: tax.outlet_id, name: outletName });
            } else {
              resultForModal.outlet_failed.push({ id: tax.outlet_id, name: outletName });
            }
            if (tax.outlet_id === selectedOutletIds) {
              previousTaxes.push(tax);
              selectedTaxData = tax;
            }
          });
          _context23.next = 31;
          return (0, _effects.put)(actNotif.success('Taxes successfully created.'));

        case 31:
          _context23.next = 33;
          return (0, _effects.put)(actTax.setListTaxes(previousTaxes));

        case 33:
          selectedTaxData.items = selectedTaxData.items.map(function (item) {
            return { item_id: item.id, category_id: item.category_id };
          });
          selectedTaxData.org_items = selectedTaxData.items.filter(function (item) {
            return true;
          });
          selectedTaxData.loaded_items = selectedTaxData.items.filter(function (item) {
            return true;
          });
          selectedTaxData.custom_amount_flag = data.custom_amount_flag;
          selectedTaxData.custom_amount_item = customAmountItem;
          _context23.next = 40;
          return (0, _effects.put)(actTax.setTaxDetail(selectedTaxData));

        case 40:
          _context23.next = 42;
          return (0, _effects.call)(fillFormTaxDetail, selectedTaxData);

        case 42:
          _context23.next = 44;
          return (0, _effects.put)(actTax.taxAssignToItemFillForm({
            taxDetail: {
              id: selectedTaxData.id,
              items: selectedTaxData.items
            }
          }));

        case 44:
          if (!(resultForModal.outlet_success && resultForModal.outlet_success.length > 0)) {
            _context23.next = 47;
            break;
          }

          _context23.next = 47;
          return (0, _effects.put)(actTax.setCreatedOutlets({
            outletsFailed: resultForModal.outlet_failed,
            outletsSuccess: resultForModal.outlet_success
          }));

        case 47:
          _context23.next = 49;
          return (0, _effects.put)(actTax.showSaveToAllOutletsModal());

        case 49:
          _context23.next = 55;
          break;

        case 51:
          _context23.prev = 51;
          _context23.t0 = _context23['catch'](15);
          _context23.next = 55;
          return (0, _effects.put)(actNotif.error(_context23.t0.message));

        case 55:
          _context23.prev = 55;
          _context23.next = 58;
          return (0, _effects.put)(act.hideProgressBar());

        case 58:
          _context23.next = 60;
          return (0, _effects.put)(actTax.isSubmittingForm(false));

        case 60:
          return _context23.finish(55);

        case 61:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked[22], this, [[15, 51, 55, 61]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_PAGE_REQUEST, taxesPageRequestFlow);

        case 2:
          _context24.next = 4;
          return (0, _effects.takeEvery)(_constants.LIBRARY_TAXES_LIST_REQUEST, taxesRequestFlow);

        case 4:
          _context24.next = 6;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);

        case 6:
          _context24.next = 8;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_ON_CLICK_ROW, onClickRowFlow);

        case 8:
          _context24.next = 10;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_ON_CLICK_CANCEL, onClickCancelFlow);

        case 10:
          _context24.next = 12;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_SUBMIT_FORM_UPDATE, updateTaxFlow);

        case 12:
          _context24.next = 14;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_ON_CLICK_CREATE_TAX, onClickCreateTaxFlow);

        case 14:
          _context24.next = 16;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_SUBMIT_FORM_CREATE, createTaxFlow);

        case 16:
          _context24.next = 18;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_DELETE_TAX_REQUEST, deleteTaxRequest);

        case 18:
          _context24.next = 20;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_DELETE_TAX, deleteTaxFlow);

        case 20:
          _context24.next = 22;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_CANCEL_DELETE, cancelDeleteTaxFlow);

        case 22:
          _context24.next = 24;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS, createTaxAllOutletsFlow);

        case 24:
          _context24.next = 26;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM, onClickTaxAssignToItem);

        case 26:
          _context24.next = 28;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM, taxAssignToItemFillFormFlow);

        case 28:
          _context24.next = 30;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM, cancelTaxAssignToItem);

        case 30:
          _context24.next = 32;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM, confirmTaxAssignToItem);

        case 32:
          _context24.next = 34;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST, taxAssignToItemItemsRequest);

        case 34:
          _context24.next = 36;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE, taxAssignToItemSelectAllNone);

        case 36:
          _context24.next = 38;
          return (0, _effects.takeLatest)(_constants.LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE, taxAssignToItemToggleOne);

        case 38:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked[23], this);
}

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.setUsedAndTotalOutletSlots = setUsedAndTotalOutletSlots;
exports.getBillingsFlow = getBillingsFlow;
exports.pageRequest = pageRequest;
exports.clickCreateOutlet = clickCreateOutlet;
exports.clickAddOutlet = clickAddOutlet;
exports.clickOutletRow = clickOutletRow;
exports.clickCancel = clickCancel;
exports.submitFormCreate = submitFormCreate;
exports.submitFormUpdate = submitFormUpdate;
exports.search = search;
exports.askReactivateOutletWithoutPay = askReactivateOutletWithoutPay;
exports.askReactivateOutlet = askReactivateOutlet;
exports.confirmReactivateOutletWithoutPayFlow = confirmReactivateOutletWithoutPayFlow;
exports.confirmReactivateOutlet = confirmReactivateOutlet;
exports.cancelReactivateOutlet = cancelReactivateOutlet;
exports.outletPriceFlow = outletPriceFlow;
exports.featureSubscriptionStatusFlow = featureSubscriptionStatusFlow;
exports.verifyAddOutletFlow = verifyAddOutletFlow;
exports.default = saga;

var _effects = __webpack_require__(22);

var _reduxSaga = __webpack_require__(68);

var _constants = __webpack_require__(413);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _outlets = __webpack_require__(50);

var apiOutlet = _interopRequireWildcard(_outlets);

var _list = __webpack_require__(127);

var actOutletList = _interopRequireWildcard(_list);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _billing = __webpack_require__(428);

var apiBilling = _interopRequireWildcard(_billing);

var _billingRedirect = __webpack_require__(232);

var _billingNotification = __webpack_require__(381);

var _reduxForm = __webpack_require__(7);

var _loadingSpinner = __webpack_require__(46);

var _formatter = __webpack_require__(11);

var _lodash = __webpack_require__(32);

var _ = _interopRequireWildcard(_lodash);

var _list2 = __webpack_require__(454);

var mpOutletList = _interopRequireWildcard(_list2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, setUsedAndTotalOutletSlots, openRightColumn, closeRightColumn, getBillingsFlow, pageRequest, clickCreateOutlet, clickAddOutlet, clickOutletRow, clickCancel, submitFormCreate, submitFormUpdate, search, askReactivateOutletWithoutPay, askReactivateOutlet, confirmReactivateOutletWithoutPayFlow, confirmReactivateOutlet, cancelReactivateOutlet, outletPriceFlow, featureSubscriptionStatusFlow, verifyAddOutletFlow, saga].map(_regenerator2.default.mark);

function fillForm(outlet) {
  var form;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          form = {
            id: outlet.id,
            businessId: outlet.business_id,
            name: outlet.name,
            address: outlet.address,
            postal: outlet.postal_code,
            city: outlet.city,
            province: outlet.province,
            phone: !outlet.phone_number ? null : (0, _formatter.phoneNumberFormatter)(outlet.phone_number)
          };
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('outlet', form));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function setUsedAndTotalOutletSlots(profile, outlets) {
  var outletSlots, usedOutletSlots;
  return _regenerator2.default.wrap(function setUsedAndTotalOutletSlots$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          // count outlets
          outletSlots = profile.business.outlet_slot;
          usedOutletSlots = 0;

          _.forEach(outlets, function (outlet) {
            if (!outlet.is_deleted) usedOutletSlots++;
          });

          _context2.next = 5;
          return (0, _effects.put)(actOutletList.setOutletSlots(outletSlots));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)(actOutletList.setUsedOutletSlots(usedOutletSlots));

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function openRightColumn() {
  return _regenerator2.default.wrap(function openRightColumn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(actOutletList.openRightColumn());

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function closeRightColumn() {
  return _regenerator2.default.wrap(function closeRightColumn$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actOutletList.closeRightColumn());

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function getBillingsFlow() {
  var response, pendingPaymentMessage;
  return _regenerator2.default.wrap(function getBillingsFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(act.sendingRequest(true));

        case 2:
          _context5.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context5.prev = 4;
          _context5.next = 7;
          return (0, _effects.call)(apiBilling.getBillings);

        case 7:
          response = _context5.sent;
          pendingPaymentMessage = null;

          _.forEach(response.data, function (invoice) {
            if (invoice.status === 'pending') {
              if (invoice.payment_type === 'credit_card') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please wait 24 hours before making a new payment.';
              } else if (invoice.payment_type === 'bank_transfer' || invoice.payment_type === 'echannel') {
                pendingPaymentMessage = 'There is a pending payment for ' + invoice.invoice_number + '. Please transfer full amount of the invoice within 3 days before making a new payment.';
              }
              return false;
            }
          });

          if (!(pendingPaymentMessage !== null)) {
            _context5.next = 15;
            break;
          }

          _context5.next = 13;
          return (0, _effects.put)(actOutletList.setPendingPaymentMessage(pendingPaymentMessage));

        case 13:
          _context5.next = 15;
          return (0, _effects.put)(actOutletList.disablePayButton());

        case 15:
          _context5.next = 19;
          break;

        case 17:
          _context5.prev = 17;
          _context5.t0 = _context5['catch'](4);

        case 19:
          _context5.prev = 19;
          _context5.next = 22;
          return (0, _effects.put)(act.sendingRequest(false));

        case 22:
          _context5.next = 24;
          return (0, _effects.put)(act.hideProgressBar());

        case 24:
          return _context5.finish(19);

        case 25:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[4, 17, 19, 25]]);
}

function pageRequest(request) {
  var res, resOutlet;
  return _regenerator2.default.wrap(function pageRequest$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          mpOutletList.outletListStart();
          // reset pages
          _context6.next = 3;
          return (0, _effects.put)(actOutletList.setOutletDetail(null));

        case 3:
          _context6.next = 5;
          return (0, _effects.put)(actOutletList.setOutlets([]));

        case 5:
          _context6.next = 7;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 7:
          _context6.next = 9;
          return (0, _effects.put)(actOutletList.setUsedOutletSlots(null));

        case 9:
          _context6.next = 11;
          return (0, _effects.put)(actOutletList.setOutletSlots(null));

        case 11:
          _context6.next = 13;
          return (0, _effects.call)(closeRightColumn);

        case 13:
          _context6.prev = 13;
          _context6.next = 16;
          return (0, _effects.put)(act.sendingRequest(true));

        case 16:
          _context6.next = 18;
          return (0, _effects.put)(act.showProgressBar());

        case 18:
          _context6.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          res = _context6.sent;
          _context6.next = 23;
          return (0, _effects.put)(actOutletList.setProfile(res.data));

        case 23:
          _context6.next = 25;
          return (0, _effects.call)(apiOutlet.outlets, { with_inactive: true });

        case 25:
          resOutlet = _context6.sent;
          _context6.next = 28;
          return (0, _effects.put)(actOutletList.setOutlets(resOutlet.data));

        case 28:
          _context6.next = 30;
          return (0, _effects.put)(actOutletList.getOutletPrice());

        case 30:
          _context6.next = 32;
          return (0, _effects.put)(actOutletList.getFeatureSubscriptionStatus());

        case 32:
          _context6.next = 34;
          return (0, _effects.put)(actOutletList.getBilling());

        case 34:
          _context6.next = 36;
          return (0, _effects.put)((0, _billingNotification.showBillingNotification)(request.payload.billingNotification));

        case 36:
          _context6.next = 38;
          return (0, _effects.put)((0, _billingRedirect.setNotificationType)(null));

        case 38:
          _context6.next = 40;
          return (0, _effects.put)((0, _billingRedirect.setNotificationMessage)(null));

        case 40:
          _context6.next = 42;
          return (0, _effects.call)(setUsedAndTotalOutletSlots, res.data, resOutlet.data);

        case 42:
          _context6.next = 48;
          break;

        case 44:
          _context6.prev = 44;
          _context6.t0 = _context6['catch'](13);
          _context6.next = 48;
          return (0, _effects.put)(actNotif.error(_context6.t0.message));

        case 48:
          _context6.prev = 48;
          _context6.next = 51;
          return (0, _effects.put)(act.sendingRequest(false));

        case 51:
          _context6.next = 53;
          return (0, _effects.put)(act.hideProgressBar());

        case 53:
          _context6.next = 55;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 55:
          return _context6.finish(48);

        case 56:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[13, 44, 48, 56]]);
}

function clickCreateOutlet() {
  var res;
  return _regenerator2.default.wrap(function clickCreateOutlet$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (false) {
            _context7.next = 31;
            break;
          }

          _context7.next = 3;
          return (0, _effects.take)(_constants.OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET);

        case 3:
          _context7.prev = 3;
          _context7.next = 6;
          return (0, _effects.put)(act.sendingRequest(true));

        case 6:
          _context7.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context7.next = 10;
          return (0, _effects.call)(apiOutlet.getNew, {});

        case 10:
          res = _context7.sent;
          _context7.next = 13;
          return (0, _effects.put)(actOutletList.setOutletDetail(null));

        case 13:
          _context7.next = 15;
          return (0, _effects.call)(fillForm, res.data);

        case 15:
          _context7.next = 17;
          return (0, _effects.call)(openRightColumn);

        case 17:
          _context7.next = 23;
          break;

        case 19:
          _context7.prev = 19;
          _context7.t0 = _context7['catch'](3);
          _context7.next = 23;
          return (0, _effects.put)(actNotif.error(_context7.t0.message));

        case 23:
          _context7.prev = 23;
          _context7.next = 26;
          return (0, _effects.put)(act.sendingRequest(false));

        case 26:
          _context7.next = 28;
          return (0, _effects.put)(act.hideProgressBar());

        case 28:
          return _context7.finish(23);

        case 29:
          _context7.next = 0;
          break;

        case 31:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[3, 19, 23, 29]]);
}

function clickAddOutlet() {
  return _regenerator2.default.wrap(function clickAddOutlet$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (false) {
            _context8.next = 7;
            break;
          }

          _context8.next = 3;
          return (0, _effects.take)(_constants.OUTLET_PAGE_LIST_CLICK_ADD_OUTLET);

        case 3:
          _context8.next = 5;
          return (0, _effects.put)(actOutletList.showAddOutletModal());

        case 5:
          _context8.next = 0;
          break;

        case 7:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function clickOutletRow() {
  var _ref, outletId, res;

  return _regenerator2.default.wrap(function clickOutletRow$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (false) {
            _context9.next = 33;
            break;
          }

          _context9.next = 3;
          return (0, _effects.take)(_constants.OUTLET_PAGE_LIST_CLICK_OUTLET_ROW);

        case 3:
          _ref = _context9.sent;
          outletId = _ref.payload.outletId;
          _context9.prev = 5;
          _context9.next = 8;
          return (0, _effects.put)(act.sendingRequest(true));

        case 8:
          _context9.next = 10;
          return (0, _effects.put)(act.showProgressBar());

        case 10:
          _context9.next = 12;
          return (0, _effects.call)(apiOutlet.getOutletById, outletId);

        case 12:
          res = _context9.sent;
          _context9.next = 15;
          return (0, _effects.put)(actOutletList.setOutletDetail(res.data));

        case 15:
          _context9.next = 17;
          return (0, _effects.call)(fillForm, res.data);

        case 17:
          _context9.next = 19;
          return (0, _effects.call)(openRightColumn);

        case 19:
          _context9.next = 25;
          break;

        case 21:
          _context9.prev = 21;
          _context9.t0 = _context9['catch'](5);
          _context9.next = 25;
          return (0, _effects.put)(actNotif.error(_context9.t0.message));

        case 25:
          _context9.prev = 25;
          _context9.next = 28;
          return (0, _effects.put)(act.sendingRequest(false));

        case 28:
          _context9.next = 30;
          return (0, _effects.put)(act.hideProgressBar());

        case 30:
          return _context9.finish(25);

        case 31:
          _context9.next = 0;
          break;

        case 33:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[5, 21, 25, 31]]);
}

function clickCancel() {
  return _regenerator2.default.wrap(function clickCancel$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (false) {
            _context10.next = 11;
            break;
          }

          _context10.next = 3;
          return (0, _effects.take)(_constants.OUTLET_PAGE_LIST_CLICK_CANCEL);

        case 3:
          _context10.next = 5;
          return (0, _effects.put)(actOutletList.setOutletDetail(null));

        case 5:
          _context10.next = 7;
          return (0, _effects.call)(fillForm, {});

        case 7:
          _context10.next = 9;
          return (0, _effects.call)(closeRightColumn);

        case 9:
          _context10.next = 0;
          break;

        case 11:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function submitFormCreate(action) {
  var _action$payload, data, previousOutlets, response, outlet, resProfile, resOutlets;

  return _regenerator2.default.wrap(function submitFormCreate$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _action$payload = action.payload, data = _action$payload.data, previousOutlets = _action$payload.previousOutlets;

          mpOutletList.outletListCreate({
            outlet: data.outlet
          });
          _context11.next = 4;
          return (0, _effects.put)(actOutletList.setDisableSaveOutletButton(true));

        case 4:
          _context11.next = 6;
          return (0, _effects.put)(act.sendingRequest(true));

        case 6:
          _context11.next = 8;
          return (0, _effects.put)(act.showProgressBar());

        case 8:
          _context11.prev = 8;
          _context11.next = 11;
          return (0, _effects.call)(apiOutlet.postOutlet, data);

        case 11:
          response = _context11.sent;

          // set to reducers
          outlet = response.data;

          previousOutlets.unshift(outlet);

          _context11.next = 16;
          return (0, _effects.put)(actOutletList.setOutletDetail(outlet));

        case 16:
          _context11.next = 18;
          return (0, _effects.put)(actOutletList.setOutlets(previousOutlets));

        case 18:
          _context11.next = 20;
          return (0, _effects.call)(apiProfile.getProfile);

        case 20:
          resProfile = _context11.sent;
          _context11.next = 23;
          return (0, _effects.call)(apiOutlet.outlets);

        case 23:
          resOutlets = _context11.sent;
          _context11.next = 26;
          return (0, _effects.call)(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data);

        case 26:
          _context11.next = 28;
          return (0, _effects.call)(fillForm, outlet);

        case 28:
          _context11.next = 30;
          return (0, _effects.put)(actNotif.success('Outlet successfully created.'));

        case 30:
          _context11.next = 36;
          break;

        case 32:
          _context11.prev = 32;
          _context11.t0 = _context11['catch'](8);
          _context11.next = 36;
          return (0, _effects.put)(actNotif.error(_context11.t0.message));

        case 36:
          _context11.prev = 36;
          _context11.next = 39;
          return (0, _effects.put)(act.sendingRequest(false));

        case 39:
          _context11.next = 41;
          return (0, _effects.put)(act.hideProgressBar());

        case 41:
          _context11.next = 43;
          return (0, _effects.put)(actOutletList.setDisableSaveOutletButton(false));

        case 43:
          return _context11.finish(36);

        case 44:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[8, 32, 36, 44]]);
}

function submitFormUpdate(action) {
  var _action$payload2, data, outletId, previousOutlets, response, outlet, resProfile, resOutlets;

  return _regenerator2.default.wrap(function submitFormUpdate$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _action$payload2 = action.payload, data = _action$payload2.data, outletId = _action$payload2.outletId, previousOutlets = _action$payload2.previousOutlets;
          _context12.next = 3;
          return (0, _effects.put)(act.sendingRequest(true));

        case 3:
          _context12.next = 5;
          return (0, _effects.put)(act.showProgressBar());

        case 5:
          _context12.next = 7;
          return (0, _effects.put)(actOutletList.setDisableSaveOutletButton(true));

        case 7:
          _context12.prev = 7;
          _context12.next = 10;
          return (0, _effects.call)(apiOutlet.putOutletById, outletId, data);

        case 10:
          response = _context12.sent;

          // set to reducers
          outlet = response.data;

          previousOutlets.forEach(function (po, idx) {
            if (po.id === outlet.id) {
              previousOutlets[idx] = outlet;
            }
          });
          _context12.next = 15;
          return (0, _effects.put)(actOutletList.setOutlets(previousOutlets));

        case 15:
          _context12.next = 17;
          return (0, _effects.call)(apiProfile.getProfile);

        case 17:
          resProfile = _context12.sent;
          _context12.next = 20;
          return (0, _effects.call)(apiOutlet.outlets);

        case 20:
          resOutlets = _context12.sent;
          _context12.next = 23;
          return (0, _effects.call)(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data);

        case 23:
          _context12.next = 25;
          return (0, _effects.call)(fillForm, outlet);

        case 25:
          _context12.next = 27;
          return (0, _effects.put)(actNotif.success('Outlet was successfully updated.'));

        case 27:
          _context12.next = 33;
          break;

        case 29:
          _context12.prev = 29;
          _context12.t0 = _context12['catch'](7);
          _context12.next = 33;
          return (0, _effects.put)(actNotif.error(_context12.t0.message));

        case 33:
          _context12.prev = 33;
          _context12.next = 36;
          return (0, _effects.put)(act.sendingRequest(false));

        case 36:
          _context12.next = 38;
          return (0, _effects.put)(act.hideProgressBar());

        case 38:
          _context12.next = 40;
          return (0, _effects.put)(actOutletList.setDisableSaveOutletButton(false));

        case 40:
          return _context12.finish(33);

        case 41:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[7, 29, 33, 41]]);
}

function search(action) {
  var query, resOutlet;
  return _regenerator2.default.wrap(function search$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)('outlet', {}));

        case 2:
          _context13.next = 4;
          return (0, _effects.call)(closeRightColumn);

        case 4:
          _context13.next = 6;
          return (0, _effects.put)(actOutletList.setOutlets([]));

        case 6:
          _context13.next = 8;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(true));

        case 8:
          _context13.prev = 8;
          query = action.payload.query;
          // prevent too fast ajax call

          _context13.next = 12;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 12:
          _context13.next = 14;
          return (0, _effects.put)(act.sendingRequest(true));

        case 14:
          _context13.next = 16;
          return (0, _effects.put)(act.showProgressBar());

        case 16:
          _context13.next = 18;
          return (0, _effects.call)(apiOutlet.search, query);

        case 18:
          resOutlet = _context13.sent;
          _context13.next = 21;
          return (0, _effects.put)(actOutletList.setOutlets(resOutlet.data));

        case 21:
          _context13.next = 27;
          break;

        case 23:
          _context13.prev = 23;
          _context13.t0 = _context13['catch'](8);
          _context13.next = 27;
          return (0, _effects.put)(actNotif.error(_context13.t0.message));

        case 27:
          _context13.prev = 27;
          _context13.next = 30;
          return (0, _effects.put)(act.sendingRequest(false));

        case 30:
          _context13.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          _context13.next = 34;
          return (0, _effects.put)((0, _loadingSpinner.showPageLoadingSpinner)(false));

        case 34:
          return _context13.finish(27);

        case 35:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[8, 23, 27, 35]]);
}

function askReactivateOutletWithoutPay(action) {
  var outlet;
  return _regenerator2.default.wrap(function askReactivateOutletWithoutPay$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          outlet = action.payload.outlet;
          _context14.next = 3;
          return (0, _effects.put)(actOutletList.setReactivatedOutlet(outlet));

        case 3:
          _context14.next = 5;
          return (0, _effects.put)(actOutletList.showReactivateOutletWithoutPay());

        case 5:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function askReactivateOutlet(action) {
  var outlet;
  return _regenerator2.default.wrap(function askReactivateOutlet$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          outlet = action.payload.outlet;
          _context15.next = 3;
          return (0, _effects.put)(actOutletList.setReactivatedOutlet(outlet));

        case 3:
          _context15.next = 5;
          return (0, _effects.put)(actOutletList.showConfirmReactivateOutletModal());

        case 5:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function confirmReactivateOutletWithoutPayFlow(action) {
  var _action$payload3, outlet, previousOutlets, res, resProfile, resOutlets;

  return _regenerator2.default.wrap(function confirmReactivateOutletWithoutPayFlow$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _action$payload3 = action.payload, outlet = _action$payload3.outlet, previousOutlets = _action$payload3.previousOutlets;
          _context16.next = 3;
          return (0, _effects.put)(actOutletList.setOnLoadingReactivateOutletWithoutPay(true));

        case 3:
          _context16.next = 5;
          return (0, _effects.put)(act.sendingRequest(true));

        case 5:
          _context16.next = 7;
          return (0, _effects.put)(act.showProgressBar());

        case 7:
          _context16.prev = 7;
          _context16.next = 10;
          return (0, _effects.call)(apiOutlet.patchOutletById, outlet.id, { is_deleted: false }, {});

        case 10:
          res = _context16.sent;

          previousOutlets.forEach(function (po, idx) {
            if (po.id === res.data.id) previousOutlets[idx] = res.data;
          });
          // call outlets and profile api to get count
          _context16.next = 14;
          return (0, _effects.call)(apiProfile.getProfile);

        case 14:
          resProfile = _context16.sent;
          _context16.next = 17;
          return (0, _effects.call)(apiOutlet.outlets);

        case 17:
          resOutlets = _context16.sent;
          _context16.next = 20;
          return (0, _effects.call)(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data);

        case 20:
          _context16.next = 22;
          return (0, _effects.put)(actOutletList.setOutletDetail(res.data));

        case 22:
          _context16.next = 24;
          return (0, _effects.put)(actOutletList.setOutlets(previousOutlets));

        case 24:
          _context16.next = 26;
          return (0, _effects.put)(actNotif.success('Outlet has been reactivated'));

        case 26:
          _context16.next = 32;
          break;

        case 28:
          _context16.prev = 28;
          _context16.t0 = _context16['catch'](7);
          _context16.next = 32;
          return (0, _effects.put)(actNotif.error(_context16.t0.message));

        case 32:
          _context16.prev = 32;
          _context16.next = 35;
          return (0, _effects.put)(act.sendingRequest(false));

        case 35:
          _context16.next = 37;
          return (0, _effects.put)(act.hideProgressBar());

        case 37:
          _context16.next = 39;
          return (0, _effects.put)(actOutletList.setReactivatedOutlet(null));

        case 39:
          _context16.next = 41;
          return (0, _effects.put)(actOutletList.hideReactivateOutletWithoutPay());

        case 41:
          _context16.next = 43;
          return (0, _effects.call)(closeRightColumn);

        case 43:
          _context16.next = 45;
          return (0, _effects.put)(actOutletList.setOnLoadingReactivateOutletWithoutPay(false));

        case 45:
          return _context16.finish(32);

        case 46:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this, [[7, 28, 32, 46]]);
}

function confirmReactivateOutlet(action) {
  var billingData, response;
  return _regenerator2.default.wrap(function confirmReactivateOutlet$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          billingData = action.payload.billingData;
          _context17.next = 3;
          return (0, _effects.put)(act.sendingRequest(true));

        case 3:
          _context17.next = 5;
          return (0, _effects.put)(actOutletList.disablePayButton());

        case 5:
          _context17.next = 7;
          return (0, _effects.put)(actOutletList.setOnLoading(true));

        case 7:
          response = {};
          _context17.prev = 8;
          _context17.next = 11;
          return (0, _effects.call)(apiBilling.verifyBilling, billingData);

        case 11:
          response = _context17.sent;
          _context17.next = 26;
          break;

        case 14:
          _context17.prev = 14;
          _context17.t0 = _context17['catch'](8);
          _context17.next = 18;
          return (0, _effects.put)(actOutletList.setReactivatedOutlet(null));

        case 18:
          _context17.next = 20;
          return (0, _effects.put)(actOutletList.hideConfirmReactivateOutletModal());

        case 20:
          _context17.next = 22;
          return (0, _effects.put)(actOutletList.setOnLoading(false));

        case 22:
          _context17.next = 24;
          return (0, _effects.put)(actOutletList.enablePayButton());

        case 24:
          _context17.next = 26;
          return (0, _effects.put)(actOutletList.showPaymentGatewayError());

        case 26:
          _context17.prev = 26;
          _context17.next = 29;
          return (0, _effects.put)(act.sendingRequest(false));

        case 29:
          _context17.next = 31;
          return (0, _effects.put)(act.hideProgressBar());

        case 31:
          if (!response.data) {
            _context17.next = 35;
            break;
          }

          _context17.next = 34;
          return (0, _effects.put)(actOutletList.setPaymentButtonMessage('Redirecting to Veritrans'));

        case 34:
          window.location.replace(response.data.data.redirect_url);

        case 35:
          return _context17.finish(26);

        case 36:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this, [[8, 14, 26, 36]]);
}

function cancelReactivateOutlet() {
  return _regenerator2.default.wrap(function cancelReactivateOutlet$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.put)(actOutletList.setReactivatedOutlet(null));

        case 2:
          _context18.next = 4;
          return (0, _effects.put)(actOutletList.hideConfirmReactivateOutletModal());

        case 4:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked[17], this);
}

function outletPriceFlow() {
  var response;
  return _regenerator2.default.wrap(function outletPriceFlow$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)(act.sendingRequest(true));

        case 2:
          _context19.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context19.prev = 4;
          _context19.next = 7;
          return (0, _effects.call)(apiOutlet.getOutletPrice);

        case 7:
          response = _context19.sent;
          _context19.next = 10;
          return (0, _effects.put)(actOutletList.setOutletPrice(response.data));

        case 10:
          _context19.next = 12;
          return (0, _effects.put)((0, _reduxForm.initialize)('AddOutletModalForm', {
            countOutlet: 1
          }));

        case 12:
          _context19.next = 16;
          break;

        case 14:
          _context19.prev = 14;
          _context19.t0 = _context19['catch'](4);

        case 16:
          _context19.prev = 16;
          _context19.next = 19;
          return (0, _effects.put)(act.sendingRequest(false));

        case 19:
          _context19.next = 21;
          return (0, _effects.put)(act.hideProgressBar());

        case 21:
          return _context19.finish(16);

        case 22:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked[18], this, [[4, 14, 16, 22]]);
}

function featureSubscriptionStatusFlow() {
  var response, subscribedFeature;
  return _regenerator2.default.wrap(function featureSubscriptionStatusFlow$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.put)(act.sendingRequest(true));

        case 2:
          _context20.next = 4;
          return (0, _effects.put)(act.showProgressBar());

        case 4:
          _context20.prev = 4;
          _context20.next = 7;
          return (0, _effects.call)(apiBilling.getSubscriptionStatus);

        case 7:
          response = _context20.sent;
          subscribedFeature = [];

          _.forEach(response.data, function (feature) {
            if (feature.is_active && (feature.is_subscribing || !feature.is_subscribing)) subscribedFeature.push(feature);
          });
          _context20.next = 12;
          return (0, _effects.put)(actOutletList.setFeatureSubscriptionStatus(subscribedFeature));

        case 12:
          _context20.next = 16;
          break;

        case 14:
          _context20.prev = 14;
          _context20.t0 = _context20['catch'](4);

        case 16:
          _context20.prev = 16;
          _context20.next = 19;
          return (0, _effects.put)(act.sendingRequest(false));

        case 19:
          _context20.next = 21;
          return (0, _effects.put)(act.hideProgressBar());

        case 21:
          return _context20.finish(16);

        case 22:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked[19], this, [[4, 14, 16, 22]]);
}

function verifyAddOutletFlow(request) {
  var billingData, response;
  return _regenerator2.default.wrap(function verifyAddOutletFlow$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.put)(act.sendingRequest(true));

        case 2:
          _context21.next = 4;
          return (0, _effects.put)(actOutletList.disablePayButton());

        case 4:
          _context21.next = 6;
          return (0, _effects.put)(actOutletList.setOnLoading(true));

        case 6:
          billingData = request.payload.billingData;
          response = {};
          _context21.prev = 8;
          _context21.next = 11;
          return (0, _effects.call)(apiBilling.verifyBilling, billingData);

        case 11:
          response = _context21.sent;
          _context21.next = 29;
          break;

        case 14:
          _context21.prev = 14;
          _context21.t0 = _context21['catch'](8);
          _context21.next = 18;
          return (0, _effects.put)(actOutletList.setOnLoading(false));

        case 18:
          _context21.next = 20;
          return (0, _effects.put)(actOutletList.enablePayButton());

        case 20:
          if (!_context21.t0.data) {
            _context21.next = 25;
            break;
          }

          _context21.next = 23;
          return (0, _effects.put)(actNotif.error(_context21.t0.data.message));

        case 23:
          _context21.next = 29;
          break;

        case 25:
          _context21.next = 27;
          return (0, _effects.put)(actOutletList.hideAddOutletModal());

        case 27:
          _context21.next = 29;
          return (0, _effects.put)(actOutletList.showPaymentGatewayError());

        case 29:
          _context21.prev = 29;
          _context21.next = 32;
          return (0, _effects.put)(act.sendingRequest(false));

        case 32:
          if (!response.data) {
            _context21.next = 36;
            break;
          }

          _context21.next = 35;
          return (0, _effects.put)(actOutletList.setPaymentButtonMessage('Redirecting to Veritrans'));

        case 35:
          window.location.replace(response.data.data.redirect_url);

        case 36:
          return _context21.finish(29);

        case 37:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked[20], this, [[8, 14, 29, 37]]);
}

function saga() {
  return _regenerator2.default.wrap(function saga$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_PAGE_REQUEST, pageRequest);

        case 2:
          _context22.next = 4;
          return (0, _effects.fork)(clickOutletRow);

        case 4:
          _context22.next = 6;
          return (0, _effects.fork)(clickCancel);

        case 6:
          _context22.next = 8;
          return (0, _effects.fork)(clickCreateOutlet);

        case 8:
          _context22.next = 10;
          return (0, _effects.fork)(clickAddOutlet);

        case 10:
          _context22.next = 12;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_SEARCH, search);

        case 12:
          _context22.next = 14;
          return (0, _effects.takeEvery)(_constants.OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE, submitFormUpdate);

        case 14:
          _context22.next = 16;
          return (0, _effects.takeEvery)(_constants.OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE, submitFormCreate);

        case 16:
          _context22.next = 18;
          return (0, _effects.takeEvery)(_constants.OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET, askReactivateOutlet);

        case 18:
          _context22.next = 20;
          return (0, _effects.takeEvery)(_constants.OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET, confirmReactivateOutlet);

        case 20:
          _context22.next = 22;
          return (0, _effects.takeEvery)(_constants.OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET, cancelReactivateOutlet);

        case 22:
          _context22.next = 24;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_GET_OUTLET_PRICE, outletPriceFlow);

        case 24:
          _context22.next = 26;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS, featureSubscriptionStatusFlow);

        case 26:
          _context22.next = 28;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA, verifyAddOutletFlow);

        case 28:
          _context22.next = 30;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_LIST_GET_BILLING, getBillingsFlow);

        case 30:
          _context22.next = 32;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY, askReactivateOutletWithoutPay);

        case 32:
          _context22.next = 34;
          return (0, _effects.takeLatest)(_constants.OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY, confirmReactivateOutletWithoutPayFlow);

        case 34:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked[21], this);
}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(84);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(20);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.onCancelManageRecipients = onCancelManageRecipients;
exports.onClickManageRecipients = onClickManageRecipients;
exports.onConfirmManageRecipients = onConfirmManageRecipients;
exports.onClickDeleteIcon = onClickDeleteIcon;
exports.cancelDeleteRecipient = cancelDeleteRecipient;
exports.deleteRecipient = deleteRecipient;
exports.default = emailNotificationSaga;

var _effects = __webpack_require__(22);

var _constants = __webpack_require__(421);

var _reduxForm = __webpack_require__(7);

var _profile = __webpack_require__(48);

var apiProfile = _interopRequireWildcard(_profile);

var _actions = __webpack_require__(18);

var act = _interopRequireWildcard(_actions);

var _notifications = __webpack_require__(23);

var actNotif = _interopRequireWildcard(_notifications);

var _emailNotification = __webpack_require__(203);

var actEmailNotif = _interopRequireWildcard(_emailNotification);

var _settings = __webpack_require__(290);

var apiUpdateSetting = _interopRequireWildcard(_settings);

var _email = __webpack_require__(1214);

var mpSettingEmail = _interopRequireWildcard(_email);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fillForm, pageRequest, submitForm, changePageFlow, onCancelManageRecipients, onClickManageRecipients, onConfirmManageRecipients, onClickDeleteIcon, cancelDeleteRecipient, deleteRecipient, emailNotificationSaga].map(_regenerator2.default.mark);

var EMAIL_NOTIFICATION_FORM_NAME = 'emailNotification';
var SETTING_ALERT_RECIPIENTS_FIELD_NAME = 'settingAlertRecipients';

/**
 * @param {object} setting from profile.business.setting
 */
function fillForm(setting) {
  var data;
  return _regenerator2.default.wrap(function fillForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          data = {
            dailySalesSummary: setting.daily_sales_summary,
            inventoryAlerts: setting.inventory_alerts,
            productUpdates: setting.product_updates,
            settingAlertRecipients: setting.setting_alert_recipients
          };
          _context.next = 3;
          return (0, _effects.put)((0, _reduxForm.initialize)('emailNotification', data));

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function includeIsAdded(alertRecipients) {
  var newAlertReceipent = [].concat((0, _toConsumableArray3.default)(alertRecipients));
  newAlertReceipent.forEach(function (alrt) {
    alrt.is_added = true;
  });
  return newAlertReceipent;
}

function pageRequest() {
  var profileRes, profile, newSetting;
  return _regenerator2.default.wrap(function pageRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          mpSettingEmail.settingEmailStart();
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.put)(act.sendingRequest(true));

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(act.showProgressBar());

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(apiProfile.getProfile);

        case 8:
          profileRes = _context2.sent;
          profile = profileRes.data;
          _context2.next = 12;
          return (0, _effects.put)(actEmailNotif.setProfile(profile));

        case 12:

          // add is_added so that form won't show the row if users
          // does not press confirm while adding new email recipient
          newSetting = (0, _extends3.default)({}, profile.business.setting);

          newSetting.setting_alert_recipients = includeIsAdded(profile.business.setting.setting_alert_recipients);

          _context2.next = 16;
          return (0, _effects.call)(fillForm, newSetting);

        case 16:
          _context2.next = 22;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2['catch'](1);
          _context2.next = 22;
          return (0, _effects.put)(actNotif.error(_context2.t0.message));

        case 22:
          _context2.prev = 22;
          _context2.next = 25;
          return (0, _effects.put)(act.sendingRequest(false));

        case 25:
          _context2.next = 27;
          return (0, _effects.put)(act.hideProgressBar());

        case 27:
          return _context2.finish(22);

        case 28:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[1, 18, 22, 28]]);
}

function submitForm(request) {
  var data, profileRes, profile, newSetting;
  return _regenerator2.default.wrap(function submitForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          data = request.payload.data;

          mpSettingEmail.settingEmailUpdate({ settings: data.settings });
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.put)(act.sendingRequest(true));

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(act.showProgressBar());

        case 7:
          _context3.next = 9;
          return (0, _effects.call)(apiUpdateSetting.putUpdateSetting, data);

        case 9:
          _context3.next = 11;
          return (0, _effects.call)(apiProfile.getProfile);

        case 11:
          profileRes = _context3.sent;
          profile = profileRes.data;
          _context3.next = 15;
          return (0, _effects.put)(actEmailNotif.setProfile(profile));

        case 15:

          // add is_added so that form won't show the row if users
          // does not press confirm while adding new email recipient
          newSetting = (0, _extends3.default)({}, profile.business.setting);

          newSetting.setting_alert_recipients = includeIsAdded(profile.business.setting.setting_alert_recipients);

          _context3.next = 19;
          return (0, _effects.call)(fillForm, newSetting);

        case 19:
          _context3.next = 21;
          return (0, _effects.put)(actNotif.success('Setting has been successfully updated'));

        case 21:
          _context3.next = 27;
          break;

        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 27;
          return (0, _effects.put)(actNotif.error(_context3.t0.message));

        case 27:
          _context3.prev = 27;
          _context3.next = 30;
          return (0, _effects.put)(act.sendingRequest(false));

        case 30:
          _context3.next = 32;
          return (0, _effects.put)(act.hideProgressBar());

        case 32:
          return _context3.finish(27);

        case 33:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[2, 23, 27, 33]]);
}

function changePageFlow(request) {
  var location;
  return _regenerator2.default.wrap(function changePageFlow$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          location = request.payload.location;

          window.location.href = location;

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function onCancelManageRecipients(request) {
  var previousEmailNotificationForm, formName, fieldName, i, d;
  return _regenerator2.default.wrap(function onCancelManageRecipients$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          previousEmailNotificationForm = request.payload.previousEmailNotificationForm;
          formName = EMAIL_NOTIFICATION_FORM_NAME;
          fieldName = SETTING_ALERT_RECIPIENTS_FIELD_NAME;

          // set to previous state

          _context5.next = 5;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)(formName, fieldName));

        case 5:
          i = 0;

        case 6:
          if (!(i < previousEmailNotificationForm[fieldName].length)) {
            _context5.next = 13;
            break;
          }

          d = previousEmailNotificationForm[fieldName][i];
          _context5.next = 10;
          return (0, _effects.put)((0, _reduxForm.arrayPush)(EMAIL_NOTIFICATION_FORM_NAME, SETTING_ALERT_RECIPIENTS_FIELD_NAME, d));

        case 10:
          i++;
          _context5.next = 6;
          break;

        case 13:
          _context5.next = 15;
          return (0, _effects.put)(actEmailNotif.hideRecipientModal());

        case 15:
          _context5.next = 17;
          return (0, _effects.put)(actEmailNotif.hideSettingAlertRecipientsErrors());

        case 17:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function onClickManageRecipients(request) {
  var previousEmailNotificationForm, formName, fieldName;
  return _regenerator2.default.wrap(function onClickManageRecipients$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          previousEmailNotificationForm = request.payload.previousEmailNotificationForm;
          formName = EMAIL_NOTIFICATION_FORM_NAME;
          fieldName = SETTING_ALERT_RECIPIENTS_FIELD_NAME;
          _context6.next = 5;
          return (0, _effects.put)(actEmailNotif.setPreviousEmailNotificationForm(previousEmailNotificationForm));

        case 5:
          _context6.next = 7;
          return (0, _effects.put)((0, _reduxForm.arrayPush)(formName, fieldName, { email: '', is_added: false }));

        case 7:
          _context6.next = 9;
          return (0, _effects.put)(actEmailNotif.showRecipientModal());

        case 9:
          _context6.next = 11;
          return (0, _effects.put)(actEmailNotif.hideSettingAlertRecipientsErrors());

        case 11:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function onConfirmManageRecipients(request) {
  var _this = this;

  var _request$payload, emailNotificationForm, previousEmailNotificationForm, formName, fieldName, _loop, i;

  return _regenerator2.default.wrap(function onConfirmManageRecipients$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _request$payload = request.payload, emailNotificationForm = _request$payload.emailNotificationForm, previousEmailNotificationForm = _request$payload.previousEmailNotificationForm;
          formName = EMAIL_NOTIFICATION_FORM_NAME;
          fieldName = SETTING_ALERT_RECIPIENTS_FIELD_NAME;

          // remove all blank email

          _context9.next = 5;
          return (0, _effects.put)((0, _reduxForm.arrayRemoveAll)(formName, fieldName));

        case 5:
          _loop = _regenerator2.default.mark(function _loop(i) {
            var d, j, index;
            return _regenerator2.default.wrap(function _loop$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    d = emailNotificationForm[fieldName][i];

                    if (!d.email) {
                      _context8.next = 20;
                      break;
                    }

                    if (!(i < previousEmailNotificationForm.length)) {
                      _context8.next = 7;
                      break;
                    }

                    _context8.next = 5;
                    return (0, _effects.put)((0, _reduxForm.arrayPush)(formName, fieldName, d));

                  case 5:
                    _context8.next = 20;
                    break;

                  case 7:
                    j = previousEmailNotificationForm.length;

                  case 8:
                    if (!(j < emailNotificationForm[fieldName].length)) {
                      _context8.next = 20;
                      break;
                    }

                    index = previousEmailNotificationForm.findIndex(function (x) {
                      return x.email === d.email;
                    });

                    if (!(index < 0 && d.email)) {
                      _context8.next = 16;
                      break;
                    }

                    _context8.next = 13;
                    return (0, _effects.put)((0, _reduxForm.arrayPush)(formName, fieldName, (0, _extends3.default)({}, d, { is_added: true })));

                  case 13:
                    return _context8.abrupt('break', 20);

                  case 16:
                    return _context8.delegateYield(_regenerator2.default.mark(function _callee() {
                      var em, idx;
                      return _regenerator2.default.wrap(function _callee$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              em = emailNotificationForm[fieldName][j];
                              idx = previousEmailNotificationForm.findIndex(function (x) {
                                return x.email === em.email;
                              });

                              if (!(idx >= 0)) {
                                _context7.next = 5;
                                break;
                              }

                              _context7.next = 5;
                              return (0, _effects.put)((0, _reduxForm.arrayRemove)(formName, fieldName, j));

                            case 5:
                            case 'end':
                              return _context7.stop();
                          }
                        }
                      }, _callee, _this);
                    })(), 't0', 17);

                  case 17:
                    j++;
                    _context8.next = 8;
                    break;

                  case 20:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _loop, _this);
          });
          i = 0;

        case 7:
          if (!(i < emailNotificationForm[fieldName].length)) {
            _context9.next = 12;
            break;
          }

          return _context9.delegateYield(_loop(i), 't0', 9);

        case 9:
          i++;
          _context9.next = 7;
          break;

        case 12:
          _context9.next = 14;
          return (0, _effects.put)(actEmailNotif.hideRecipientModal());

        case 14:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[6], this);
}

function onClickDeleteIcon(request) {
  var deletedRecipient;
  return _regenerator2.default.wrap(function onClickDeleteIcon$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          deletedRecipient = request.payload.deletedRecipient;
          _context10.next = 3;
          return (0, _effects.put)(actEmailNotif.setDeletedRecipient(deletedRecipient));

        case 3:
          _context10.next = 5;
          return (0, _effects.put)(actEmailNotif.showDeleteRecipientModal());

        case 5:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[7], this);
}

function cancelDeleteRecipient() {
  return _regenerator2.default.wrap(function cancelDeleteRecipient$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)(actEmailNotif.setDeletedRecipient(null));

        case 2:
          _context11.next = 4;
          return (0, _effects.put)(actEmailNotif.hideDeleteRecipientModal());

        case 4:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[8], this);
}

function deleteRecipient(request) {
  var _request$payload2, deletedRecipient, emailNotificationForm, settingAlertRecipients, formName, fieldName, idx;

  return _regenerator2.default.wrap(function deleteRecipient$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _request$payload2 = request.payload, deletedRecipient = _request$payload2.deletedRecipient, emailNotificationForm = _request$payload2.emailNotificationForm;
          settingAlertRecipients = emailNotificationForm.settingAlertRecipients;
          formName = EMAIL_NOTIFICATION_FORM_NAME;
          fieldName = SETTING_ALERT_RECIPIENTS_FIELD_NAME;
          idx = settingAlertRecipients.indexOf(deletedRecipient);
          _context12.next = 7;
          return (0, _effects.put)((0, _reduxForm.arrayRemove)(formName, fieldName, idx));

        case 7:
          _context12.next = 9;
          return (0, _effects.put)(actEmailNotif.hideDeleteRecipientModal());

        case 9:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[9], this);
}

function emailNotificationSaga() {
  return _regenerator2.default.wrap(function emailNotificationSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_PAGE_REQUEST, pageRequest);

        case 2:
          _context13.next = 4;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_SUBMIT_FORM, submitForm);

        case 4:
          _context13.next = 6;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_CHANGE_PAGE, changePageFlow);

        case 6:
          _context13.next = 8;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_ON_CANCEL_MANAGE_RECIPIENTS, onCancelManageRecipients);

        case 8:
          _context13.next = 10;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_ON_CLICK_MANAGE_RECIPIENTS, onClickManageRecipients);

        case 10:
          _context13.next = 12;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_ON_CONFIRM_MANAGE_RECIPIENTS, onConfirmManageRecipients);

        case 12:
          _context13.next = 14;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_ON_CLICK_DELETE_ICON, onClickDeleteIcon);

        case 14:
          _context13.next = 16;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_CANCEL_DELETE_RECIPIENT, cancelDeleteRecipient);

        case 16:
          _context13.next = 18;
          return (0, _effects.takeLatest)(_constants.SETTING_EMAIL_DELETE_RECIPIENT, deleteRecipient);

        case 18:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[10], this);
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

exports.setUserContext = setUserContext;

var _ravenJs = __webpack_require__(373);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUserContext(_ref) {
  var profile = _ref.profile;

  try {
    _ravenJs2.default.setUserContext({
      id: profile.id,
      email: profile.email,
      first_name: profile.first_name,
      last_name: profile.last_name,
      selected_outlets: profile.selected_outlets
    });
  } catch (error) {
    console.log('Invalid JSON from getProfile' + (0, _stringify2.default)(profile));
  }
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1657), __esModule: true };

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1658), __esModule: true };

/***/ }),
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(681);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(309);
__webpack_require__(256);
module.exports = __webpack_require__(1693);

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(309);
__webpack_require__(256);
module.exports = __webpack_require__(1694);

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(61)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 1660 */,
/* 1661 */,
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1699);
var $Object = __webpack_require__(61).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 1663 */,
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1700);
module.exports = __webpack_require__(61).Object.getPrototypeOf;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1701);
module.exports = __webpack_require__(61).Object.keys;

/***/ }),
/* 1666 */,
/* 1667 */,
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(710);
__webpack_require__(256);
__webpack_require__(309);
__webpack_require__(1703);
module.exports = __webpack_require__(61).Promise;

/***/ }),
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(207)
  , call        = __webpack_require__(699)
  , isArrayIter = __webpack_require__(698)
  , anObject    = __webpack_require__(131)
  , toLength    = __webpack_require__(471)
  , getIterFn   = __webpack_require__(475)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(95)
  , macrotask = __webpack_require__(709).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(252)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(175);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 1688 */,
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(95)
  , core        = __webpack_require__(61)
  , dP          = __webpack_require__(132)
  , DESCRIPTORS = __webpack_require__(151)
  , SPECIES     = __webpack_require__(77)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(131)
  , aFunction = __webpack_require__(461)
  , SPECIES   = __webpack_require__(77)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 1691 */,
/* 1692 */,
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(131)
  , get      = __webpack_require__(475);
module.exports = __webpack_require__(61).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(462)
  , ITERATOR  = __webpack_require__(77)('iterator')
  , Iterators = __webpack_require__(210);
module.exports = __webpack_require__(61).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(107);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(151), 'Object', {defineProperty: __webpack_require__(132).f});

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(255)
  , $getPrototypeOf = __webpack_require__(704);

__webpack_require__(706)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(255)
  , $keys    = __webpack_require__(176);

__webpack_require__(706)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 1702 */,
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(306)
  , global             = __webpack_require__(95)
  , ctx                = __webpack_require__(207)
  , classof            = __webpack_require__(462)
  , $export            = __webpack_require__(107)
  , isObject           = __webpack_require__(209)
  , aFunction          = __webpack_require__(461)
  , anInstance         = __webpack_require__(1672)
  , forOf              = __webpack_require__(1676)
  , speciesConstructor = __webpack_require__(1690)
  , task               = __webpack_require__(709).set
  , microtask          = __webpack_require__(1683)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(77)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1687)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(307)($Promise, PROMISE);
__webpack_require__(1689)(PROMISE);
Wrapper = __webpack_require__(61)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(701)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"billing-reminder":"app-components-BillingReminder-__BillingReminder___1MJr7","notification-expire":"app-components-BillingReminder-__BillingReminder___1FIUH","text-notif":"app-components-BillingReminder-__BillingReminder___1UYVa","disable-link":"app-components-BillingReminder-__BillingReminder___2GNlE"};

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cancel-feature-subscription-wrapper":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___3-ouZ","dialog":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___3Prtf","modal-header":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___nMQgZ","modal-title":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___3Suku","mt-20px":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___M7cca","text-grey":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___2T78v","font-medium":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___2wZr4","mb-20px":"app-components-CancelFeatureSubscriptionModal-__CancelFeatureSubscriptionModal___1OOrN"};

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-ConfirmActionModal-__ConfirmActionModal___398dX","dialog":"app-components-ConfirmActionModal-__ConfirmActionModal___16QXf"};

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"splash-page":"app-components-FeatureBillingPage-__FeatureBillingPage___1R4AG","splash-content":"app-components-FeatureBillingPage-__FeatureBillingPage___3ZE5e","splash-title":"app-components-FeatureBillingPage-__FeatureBillingPage___12geQ","feature-description":"app-components-FeatureBillingPage-__FeatureBillingPage___16nb3","splash-video":"app-components-FeatureBillingPage-__FeatureBillingPage___3LHGk","feature-logo":"app-components-FeatureBillingPage-__FeatureBillingPage___22bUN","pricing-message":"app-components-FeatureBillingPage-__FeatureBillingPage___3FWx2","pricing-table":"app-components-FeatureBillingPage-__FeatureBillingPage___CQxtL","pricing-row":"app-components-FeatureBillingPage-__FeatureBillingPage___1_Ho1","no-border":"app-components-FeatureBillingPage-__FeatureBillingPage___3Dzkl","pricing-colomn":"app-components-FeatureBillingPage-__FeatureBillingPage___DjPnh","pricing-colomn-discount":"app-components-FeatureBillingPage-__FeatureBillingPage___VueX4","total-pricing-colomn":"app-components-FeatureBillingPage-__FeatureBillingPage___2sc9W","no-padding-bottom":"app-components-FeatureBillingPage-__FeatureBillingPage___1g2pI","pricing-prorated":"app-components-FeatureBillingPage-__FeatureBillingPage___1BGZa","paid-outlet-row":"app-components-FeatureBillingPage-__FeatureBillingPage___Dk424","last-row-pricing-table":"app-components-FeatureBillingPage-__FeatureBillingPage___2l6nC","add-padding-payment-detail":"app-components-FeatureBillingPage-__FeatureBillingPage___1xsUK","no-padding":"app-components-FeatureBillingPage-__FeatureBillingPage___2CmCC","btn-use-feature":"app-components-FeatureBillingPage-__FeatureBillingPage___1EbPb","pending-notification":"app-components-FeatureBillingPage-__FeatureBillingPage___3B3fx","feature-message":"app-components-FeatureBillingPage-__FeatureBillingPage___2m0yN","disabled-button":"app-components-FeatureBillingPage-__FeatureBillingPage___hCTnS"};

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"blocker-page":"app-components-FeatureBlockerPage-__FeatureBlockerPage___2kZws","padlock":"app-components-FeatureBlockerPage-__FeatureBlockerPage___2_uGv","blocker-message":"app-components-FeatureBlockerPage-__FeatureBlockerPage___3XOI_"};

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-wrapper":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___2mXlh","feature-detail-transaction":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___2B_vt","payment-container":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___1ukic","detail-wrapper":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___2MVrr","right-span":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___38_5X","close-wrapper":"app-components-FeatureDetailTransactionModal-__FeatureDetailTransactionModal___3MFB5"};

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"splash-page":"app-components-FeatureTrialPage-__FeatureTrialPage___1HHjz","splash-content":"app-components-FeatureTrialPage-__FeatureTrialPage___z4kcO","splash-title":"app-components-FeatureTrialPage-__FeatureTrialPage___3DxBJ","feature-description":"app-components-FeatureTrialPage-__FeatureTrialPage___Zz0Tz","splash-video":"app-components-FeatureTrialPage-__FeatureTrialPage___wEqOX","feature-logo":"app-components-FeatureTrialPage-__FeatureTrialPage___1KbhI","pricing-table":"app-components-FeatureTrialPage-__FeatureTrialPage___3Cuho","pricing-row":"app-components-FeatureTrialPage-__FeatureTrialPage___3moxt","no-border":"app-components-FeatureTrialPage-__FeatureTrialPage___3AP9R","pricing-colomn":"app-components-FeatureTrialPage-__FeatureTrialPage___XjTgc","pricing-colomn-discount":"app-components-FeatureTrialPage-__FeatureTrialPage___zfe6h","pricing-message":"app-components-FeatureTrialPage-__FeatureTrialPage___3jwXk","btn-use-feature":"app-components-FeatureTrialPage-__FeatureTrialPage___uVLNx","feature-due-date":"app-components-FeatureTrialPage-__FeatureTrialPage___3kkot"};

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"splash-page":"app-components-FeatureTutorialPage-__FeatureTutorialPage___37xct","splash-content":"app-components-FeatureTutorialPage-__FeatureTutorialPage___2aBtJ","splash-title":"app-components-FeatureTutorialPage-__FeatureTutorialPage___2bxuz","ingredients-description":"app-components-FeatureTutorialPage-__FeatureTutorialPage___FK3yF","splash-video":"app-components-FeatureTutorialPage-__FeatureTutorialPage___1SYKY","btn-use-ingredients":"app-components-FeatureTutorialPage-__FeatureTutorialPage___K7hK_"};

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___bjlJ_","sublabel":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___3dw5i","form-group":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___2enBS","field-right":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___dizLh"};

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"app-components-Fields-ReduxForm-DropdownButtonSelectIcon-__DropdownButtonSelectIcon___3Pw57","status":"app-components-Fields-ReduxForm-DropdownButtonSelectIcon-__DropdownButtonSelectIcon___1tN2T"};

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-ApplyBox-__ApplyBox___oFDGt","form-group":"app-components-Fields-ReduxForm-DropdownCalendar-ApplyBox-__ApplyBox___1gnHA","btn-apply":"app-components-Fields-ReduxForm-DropdownCalendar-ApplyBox-__ApplyBox___3W7mB","input":"app-components-Fields-ReduxForm-DropdownCalendar-ApplyBox-__ApplyBox___FM1Xi"};

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-DateBox-__DateBox___kVQap","table":"app-components-Fields-ReduxForm-DropdownCalendar-DateBox-__DateBox___3bHMb"};

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-__DropdownCalendar___kprW9","btn-prev-day":"app-components-Fields-ReduxForm-DropdownCalendar-__DropdownCalendar___3mN88","btn-next-day":"app-components-Fields-ReduxForm-DropdownCalendar-__DropdownCalendar___3Fsas"};

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-MonthSelectBox-__MonthSelectBox___3zJlm","table":"app-components-Fields-ReduxForm-DropdownCalendar-MonthSelectBox-__MonthSelectBox___36APQ","btn":"app-components-Fields-ReduxForm-DropdownCalendar-MonthSelectBox-__MonthSelectBox___33Ebo","month":"app-components-Fields-ReduxForm-DropdownCalendar-MonthSelectBox-__MonthSelectBox___1Fd6W","year":"app-components-Fields-ReduxForm-DropdownCalendar-MonthSelectBox-__MonthSelectBox___3hKOh"};

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-RangeBox-__RangeBox___3h6RP","row":"app-components-Fields-ReduxForm-DropdownCalendar-RangeBox-__RangeBox___XGsj1"};

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownCalendar-Toggle-__Toggle___1EKz7"};

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___3ia6b","menu-item":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___gKbIm","menu":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___2gGfL","button-toggle":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___1Xnk5","outlet-name-wrapper":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___2KUt4","outlet-icon":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___1aQOU","list-outlet-selected-icon":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___3KMH3","list-outlet-name":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___2pXZY","dropdown":"app-components-Fields-ReduxForm-DropdownOutlet-__DropdownOutlet___7X8pK"};

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Fields-ReduxForm-MultipleDropdownSelect-__MultipleDropdownSelect___Jaa9v"};

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlet-link":"app-components-Fields-ReduxForm-OutletModal-__style___114s6","outlet-link-selected":"app-components-Fields-ReduxForm-OutletModal-__style___3MWVa","outlet-icon":"app-components-Fields-ReduxForm-OutletModal-__style___1mlSP","outlet-hover":"app-components-Fields-ReduxForm-OutletModal-__style___O43jf","modal-outlet":"app-components-Fields-ReduxForm-OutletModal-__style___FDfVm","setAutoHeight":"app-components-Fields-ReduxForm-OutletModal-__style___3T3Xs","unSetHeight":"app-components-Fields-ReduxForm-OutletModal-__style___2IlAl"};

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flag":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___D7noK","input-icon":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___lAJel","input-field":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___X-rzj","has-error":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___3Z6MU","has-success":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___2J1hu","field-wrapper":"app-components-Fields-ReduxForm-PhoneNumberField-__PhoneNumberField___uKDz4"};

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rounded":"app-components-Fields-ReduxForm-SearchBar-__SearchBar___2onib","right-inner-addon":"app-components-Fields-ReduxForm-SearchBar-__SearchBar___3NSBK"};

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"option-list":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___cxzlL","grey-text":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___AKBpO","list-item":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___1ylto","search-wrapper":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___3Ky10","item-label":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___3njl0","selected":"app-components-Fields-ReduxForm-SearchModal-__SearchModal___sDFdC"};

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon-addon":"app-components-Fields-ReduxForm-SettingFieldWithIcon-__SettingFieldWithIcon___2bGcA"};

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"switch":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___Omxh-","switch-large":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___1D5Dj","slider":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___3Laho","slider-large":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___3BVIr","on":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___3fwg5","on-large":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___3ygHg","middle":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___3pxq4","middle-large":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___2i2pE","off":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___Ajx1b","off-large":"app-components-Fields-ReduxForm-SwitchField-__SwitchField___1x1M0"};

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image-container":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___1TehQ","default-image-container":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___1YPJn","custom-style":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___21YVJ","edit-button":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___2ICM9","edit-button-full":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___1h3wk","delete-button":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___2Ewfc","separator":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___37Cfy","action":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___7xtqI","confirm-delete-header":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___27_3-","confirm-delete-dialog":"app-components-Fields-ReduxForm-UploadImage-__UploadImage___jAuRu"};

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-components-Fields-ResetPasswordField-__style-form___2gf4C","field-input":"app-components-Fields-ResetPasswordField-__style-form___3gVeW","text-error-reset":"app-components-Fields-ResetPasswordField-__style-form___34lgJ"};

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-components-Fields-__style-form___29LBY","field-input":"app-components-Fields-__style-form___2wteF","submit-btn":"app-components-Fields-__style-form___2WhgJ","field-error":"app-components-Fields-__style-form___wTudX","field-success":"app-components-Fields-__style-form___19tW5"};

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___1moI-","header-delete":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___3BwLH","title-modal":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___3EHXF"};

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error-body-wrapper":"app-components-ImportModal-__ImportModal___3SxKz","dropzone-area":"app-components-ImportModal-__ImportModal___3Bc5p","description":"app-components-ImportModal-__ImportModal___keNPy","preview-import":"app-components-ImportModal-__ImportModal___BB9Je"};

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-components-ImportModal-InformationModal-__InformationModal___Ujczi","dialog":"app-components-ImportModal-InformationModal-__InformationModal___Av2Bs"};

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content-wrapper":"app-components-ItemHasRecipe-__ItemHasRecipe___1MQQB","text-has-recipe":"app-components-ItemHasRecipe-__ItemHasRecipe___2KDtL","text-manage":"app-components-ItemHasRecipe-__ItemHasRecipe___v1zD6","recipe-icon":"app-components-ItemHasRecipe-__ItemHasRecipe___dPcsK"};

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-LibraryDeleteModal-__style___1NWgA","dialog":"app-components-LibraryDeleteModal-__style___2CT7A","header-delete":"app-components-LibraryDeleteModal-__style___7FIEj"};

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading-container":"app-components-LoadingSpinner-__LoadingSpinner___2U0Wz"};

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Nav-NavLoggedIn-__NavLoggedIn___2cj1P"};

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Nav-NavMokaLogo-__NavMokaLogo___3tpRm"};

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-Nav-NavNotLoggedIn-__NavNotLoggedIn___3Gk59","list-menu":"app-components-Nav-NavNotLoggedIn-__NavNotLoggedIn___3uIps"};

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navbar-wrapper":"app-components-Nav-__style___3Gy10","navbar-moka":"app-components-Nav-__style___3ruL4","list-menu":"app-components-Nav-__style___1GDU9","container":"app-components-Nav-__style___3aBWw","logo-wrapper":"app-components-Nav-__style___3OSIW"};

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nav-outlet-link":"app-components-NavOutlet-__style___316Tq","text-block-center":"app-components-NavOutlet-__style___339a7","nav-outlet-wrapper":"app-components-NavOutlet-__style___3qYg-"};

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading-container":"app-components-NoDataAndLoading-__NoDataAndLoading___1d4cH","img":"app-components-NoDataAndLoading-__NoDataAndLoading___1QZU5","description":"app-components-NoDataAndLoading-__NoDataAndLoading___Gj6U0","no-data-container":"app-components-NoDataAndLoading-__NoDataAndLoading___2EO_c","title":"app-components-NoDataAndLoading-__NoDataAndLoading___3bJla","loading-spinner":"app-components-NoDataAndLoading-__NoDataAndLoading___b-w-r","full-height-no-data-display":"app-components-NoDataAndLoading-__NoDataAndLoading___25yRi","content-no-data-display":"app-components-NoDataAndLoading-__NoDataAndLoading___2zA2_","content-loading-spinner":"app-components-NoDataAndLoading-__NoDataAndLoading___zL5ek","parent-box-data-display":"app-components-NoDataAndLoading-__NoDataAndLoading___1kYyx"};

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"img":"app-components-NoDataDisplay-__style___3kGvK","title":"app-components-NoDataDisplay-__style___5AVnj","description":"app-components-NoDataDisplay-__style___2gghB"};

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"payment-error-modal-wrapper":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___LwOji","dialog":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1y-FY","mt-20px":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___3rlzf","text-grey":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1PdO9","font-medium":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___WSUjs","mb-20px":"app-components-PaymentGatewayErrorModal-__PaymentGatewayErrorModal___1cwi4"};

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"side-list":"app-components-SidebarReports-__style___1PI-y","box_center":"app-components-SidebarReports-__style___25K8O"};

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___1d4kI","subscription-expired":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___AzYDt","dialog":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___25-Su","footer":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___rKz-t","header-expired":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___2vmM4"};

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-components-Titles-__AuthTitle___Xuld6"};

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-UploadValidationModal-__style___uqvnF app-components-ConfirmActionModal-__ConfirmActionModal___398dX"};

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alert-orange":"app-components-WarningMessage-__WarningMessage___1ZRdC"};

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"business-logo":"app-components-receipt-commons-BrandImage-__BrandImage___3DcI0","receipt-business-info-box":"app-components-receipt-commons-BrandImage-__BrandImage___2EnyV","receipt-brand-img":"app-components-receipt-commons-BrandImage-__BrandImage____EqE1","receipt-business-name":"app-components-receipt-commons-BrandImage-__BrandImage___2DTxx","receipt-business-phone":"app-components-receipt-commons-BrandImage-__BrandImage___1CMPx"};

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"discount-table":"app-components-receipt-commons-ListItemBox-__DiscountTable___A2jNA","discount-cell":"app-components-receipt-commons-ListItemBox-__DiscountTable___3MCdB","discount":"app-components-receipt-commons-ListItemBox-__DiscountTable___3ALcx","text-center":"app-components-receipt-commons-ListItemBox-__DiscountTable___ch6rF","text-right":"app-components-receipt-commons-ListItemBox-__DiscountTable___2Xx6d","text-left":"app-components-receipt-commons-ListItemBox-__DiscountTable___39p77"};

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-loyalty-info":"app-components-receipt-commons-LoyaltyInfo-__style___3KkfU","title":"app-components-receipt-commons-LoyaltyInfo-__style___3VEh4","loyalty-info-detail":"app-components-receipt-commons-LoyaltyInfo-__style___1sR16"};

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-commons-Notes-__Notes___1nB-v","title":"app-components-receipt-commons-Notes-__Notes___2seyJ","content":"app-components-receipt-commons-Notes-__Notes___fmuAU"};

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"refunded-loyalty-info":"app-components-receipt-commons-RefundedLoyaltyInfo-__style___1m4m8","title":"app-components-receipt-commons-RefundedLoyaltyInfo-__style___3WBi4","loyalty-info-detail":"app-components-receipt-commons-RefundedLoyaltyInfo-__style___1eVlr"};

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___1Oh07","header":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3kV4s","link-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3oX-R","instagram-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___Hei3p","facebook-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___3KsuO","twitter-icon-wrapper":"app-components-receipt-commons-SocialMediaLink-__SocialMediaLink___2Wtgq"};

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-record-payment":"app-components-receipt-invoices-ButtonGroup-__style___3ncM2","resend":"app-components-receipt-invoices-ButtonGroup-__style___1pgst","mr-btn":"app-components-receipt-invoices-ButtonGroup-__style___2Ie4s"};

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"invoice-wrapper":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___2Z-_s","invoice-activity":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___2AJPY","invoice-activity-container":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___x_9VF","invoice-activity-list":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___33h2N","invoice-activity-note":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___27jbB","invoice-activity-note-value":"app-components-receipt-invoices-InvoiceActivity-__InvoiceActivity___gOwOQ"};

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-refund-reason":"app-components-receipt-invoices-RefundReason-__RefundReasonStyle___JCpx-","truncate-refund-reason":"app-components-receipt-invoices-RefundReason-__RefundReasonStyle___3qxHq"};

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-previews-InfoBox-__InfoBox___2BCc2","receipt-date":"app-components-receipt-previews-InfoBox-__InfoBox___1fb6K","receipt-number":"app-components-receipt-previews-InfoBox-__InfoBox___kGBdK","receipt-served":"app-components-receipt-previews-InfoBox-__InfoBox___2HgSu","receipt-collected":"app-components-receipt-previews-InfoBox-__InfoBox___3Utaf"};

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-previews-Total-__Total___2DLF8","receipt-total-box":"app-components-receipt-previews-Total-__Total___2aoks","receipt-cash-box":"app-components-receipt-previews-Total-__Total___aSzQA","receipt-change-box":"app-components-receipt-previews-Total-__Total___2sDpd"};

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"amount-refund":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___Iqq5B","amount-refund-label":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___X-VP8","amount-refund-input":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___ZQhPM"};

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select-reason":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___9bplN","amount-reason":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___2tzwP","reason-for-refund":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___1KQuu","reason-field":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___1BtEN"};

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"discount-price":"app-components-receipt-refunds-RefundBreakdownModal-Discount-__Discount___F8k2Y"};

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grat-price":"app-components-receipt-refunds-RefundBreakdownModal-Gratuity-__Gratuity___2ApPm"};

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selected":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___OxdLm","unselected":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___3LZOf","refund-item-price":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1v84M","refund-checkbox":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___3AWyV","select-all":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___2NpIr","cannot-be-refunded":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___X_2_8","add-qty-button":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___3y6gY","is-not-refunded":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1hovn","is-refunded":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___TsV_G","add-qty-input":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1APAk","full-height-modal":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___2vRSY","separator":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___2XZSk","qty-checkbox":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1pXem","right-checkbox":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1cT1n","padTop":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___6LzaD","padTop-mrLeft":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___2mlEQ","item-mobi":"app-components-receipt-refunds-RefundBreakdownModal-Item-__Item___1PPJa"};

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"redeem-amount":"app-components-receipt-refunds-RefundBreakdownModal-RewardRedemption-__RewardRedemption___1fwYw"};

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tax-price":"app-components-receipt-refunds-RefundBreakdownModal-Tax-__Tax___wm4EH"};

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"other-reason":"app-components-receipt-refunds-RefundReason-__RefundReason___1I5nc"};

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___3jna1","dialog":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___2QRFb","footer":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___1LbRD","quantity":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___3SLlb","header":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___2KRGv","btn-cancel":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___2Dkqi","btn-set":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___R9oPC","modal-body":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___rC-ie","btn-add":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___1X0D1","btn-add-inc":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___2XST0","btn-add-dec":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___35jH-","qty-field":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___2Rkti","modal-dialog-set-quantity":"app-components-receipt-refunds-SetQuantityModal-__SetQuantityModal___fDMi6"};

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-body":"app-components-receipt-refunds-TransactionRefundModal-__TransactionRefundModal___JUMGu"};

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"counting-box":"app-components-receipt-transactions-CountingBox-__CountingBox___2O7rk"};

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"refund-counting-box":"app-components-receipt-transactions-CountingBox-__RefundCountingBox___3v92J"};

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list-item-box":"app-components-receipt-transactions-ListItemBox-__ListItemBox___23rY2"};

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list-item-box":"app-components-receipt-transactions-ListItemBox-__RefundListItemBox___QE4rR"};

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-refund-reason":"app-components-receipt-transactions-RefundReason-__RefundReason___2gc1j","truncate-refund-reason":"app-components-receipt-transactions-RefundReason-__RefundReason___3N5tf"};

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-components-receipt-transactions-ResendEmailModal-__resendEmailModal___36wQ1","footer":"app-components-receipt-transactions-ResendEmailModal-__resendEmailModal___1vBtd"};

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"summary-data-box":"app-components-receipt-transactions-Summary-__Summary___1sn4a","title-center":"app-components-receipt-transactions-Summary-__Summary___KJ03d","amount":"app-components-receipt-transactions-Summary-__Summary___gqeYT"};

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-box":"app-components-receipt-transactions-TransactionDetail-__TransactionDetail___2v2IF","receipt-container":"app-components-receipt-transactions-TransactionDetail-__TransactionDetail___1AkGo","action-box-bottom":"app-components-receipt-transactions-TransactionDetail-__TransactionDetail___aoBV1","action-box-top":"app-components-receipt-transactions-TransactionDetail-__TransactionDetail___3_Ucb"};

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-components-receipt-transactions-TransactionDetailModal-__TransactionDetailModal___2RB5L","modal-body":"app-components-receipt-transactions-TransactionDetailModal-__TransactionDetailModal___3Gkmf"};

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"receipt-scrolled-area":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___Y4-jd","receipt-inner-box":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___2eU1U","remove-padding":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___24ixz","refund-title":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___1nwqU","reprinted-receipt":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___TRl9O","reprinted-text":"app-components-receipt-transactions-TransactionDetailReceipt-__TransactionDetailReceipt___30MY3"};

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-sections-LabelSection-__LabelSection___VScCu"};

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-ActionBarDetailWrapper-__ActionBarDetailWrapper___2csdP"};

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-ActionBarWrapper-__ActionBarWrapper___8t8Nm","row-wrapper":"app-components-wrappers-pages-ActionBarWrapper-__ActionBarWrapper___3ZooG"};

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-ContentWrapper-__ContentWrapper___vxFak"};

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-LeftColumnWrapper-__LeftColumnWrapper___2u9Wy"};

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-PageWrapper-__PageWrapper___3t6Bt"};

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-wrappers-pages-RightColumnWrapper-__RightColumnWrapper___3746M","invisible":"app-components-wrappers-pages-RightColumnWrapper-__RightColumnWrapper___1xS5T"};

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mb-20px":"app-pages-AccountSetting-Billing-ActiveOutlets-__ActiveOutlets___3RSTT","mb-10px":"app-pages-AccountSetting-Billing-ActiveOutlets-__ActiveOutlets___2Cvb1","outlet-name":"app-pages-AccountSetting-Billing-ActiveOutlets-__ActiveOutlets___1PsyZ"};

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mr-loading":"app-pages-AccountSetting-Billing-__Billing___1Uy5x","mrTop-loading":"app-pages-AccountSetting-Billing-__Billing___1Gl79"};

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"billing-history-wrapper":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___o9fGu","billing-container":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___F8Pry","billing-list":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___3zeTE","billing-history-table":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___2tC8a","billing-history":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___e99FC","pending":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___2AcjN","failed":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___2SzOh","paid":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___3s82Y","download-button":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___s0MJw","empty-table":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___3CQ3L","loading-billing-history":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___2EdkQ","load-table":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___qbEGe","load-header":"app-pages-AccountSetting-Billing-BillingHistory-__BillingHistory___21prZ"};

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading-receipt":"app-pages-AccountSetting-Billing-BillingReceipt-__BillingReceipt___XO3QV","load-billing-receipt":"app-pages-AccountSetting-Billing-BillingReceipt-__BillingReceipt___1s0oq"};

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"billing-receipt-form-wrapper":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___jOGdX","billing-receipt-slot":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3wpTN","billing-receipt-paper":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3tKYL","billing-receipt-paper-box":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___2EWF8","text-vertically-aligned":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1kFcg","mb-30px":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1Xpi-","mb-20px":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___2FU1q","mt-10px":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___2ReeK","outlet-name-elipsis":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1HuO4","mk-select-label":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___ydxk0","text-green":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3XekK","text-xs":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___249Zr","dropdown-select-subscription-rules":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___TpIbQ","mk-select":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___2ws7p","inactive":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___4Hvss","inactive-red":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3zdZS","turn-on-off":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1PFYW","not-available-button":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3_yGZ","btn-pay":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3zjny","feature-name":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1Gh8v","feature-name-elipsis":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___1zxP4","mb-0px":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___26sr5","price-mobi":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___103RE","outlet-name-mobi":"app-pages-AccountSetting-Billing-BillingReceipt-BillingReceiptForm-__style___3Ip4m"};

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mb-10px":"app-pages-AccountSetting-Billing-CurrentPlan-__CurrentPlan___23soO","is-expired":"app-pages-AccountSetting-Billing-CurrentPlan-__CurrentPlan___1h6Ru","mb-30px":"app-pages-AccountSetting-Billing-CurrentPlan-__CurrentPlan___20uRr","loading-plan":"app-pages-AccountSetting-Billing-CurrentPlan-__CurrentPlan___rnpCP"};

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mb-20px":"app-pages-AccountSetting-Billing-FeatureSubscriptions-__FeatureSubscriptions___2D2QR","feature-row":"app-pages-AccountSetting-Billing-FeatureSubscriptions-__FeatureSubscriptions___2V5if","btn-link-cancel":"app-pages-AccountSetting-Billing-FeatureSubscriptions-__FeatureSubscriptions___1LoYy","active-until-text":"app-pages-AccountSetting-Billing-FeatureSubscriptions-__FeatureSubscriptions___DOQEY"};

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Billing-Header-__Header___1j8CC"};

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___3yZdn","form-group":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___2Pm1D","switchbox":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___jU1SQ"};

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-AccountSetting-EmailNotification-__EmailNotification___tgzzq"};

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-DeleteRecipientModal-__DeleteRecipientModal___1T9M0"};

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-manage-recipients":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-__EmailNotificationForm___1cd2j"};

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"box-recipient":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___2uh7O","box-recipient-disabled":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___1lTLv","icon-verified":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___LIYyy","status-verified":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___1zeED","btn-delete":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___2pYIV","status-waiting":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___qmUdo","list-email":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___3t7w9","list-status":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ListRecipient-__ListRecipient___3eFPN"};

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ManageRecipientAlertEmail-__style___1dV5x"};

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___3BSAj","dialog":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___3TMVa","body":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___2ieTv","btn-add-email":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___15LcS","form-group":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___17syz","input-email":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___1il-2","btn-remove-email":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___1RRIw","form-control-feedback":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ReceipientModal-__RecipientModal___3gUBh"};

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-EmailNotification-Header-__Header___3kB8e"};

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-AccountSetting-Receipt-ActionBar-__ActionBar___1SQUn","action-bar":"app-pages-AccountSetting-Receipt-ActionBar-__ActionBar___3j7IH"};

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-Header-__Header___19Irv"};

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-__Receipt___ENoFG","action-bar":"app-pages-AccountSetting-Receipt-__Receipt___20xMz","container":"app-pages-AccountSetting-Receipt-__Receipt___3f1gG","receipt-info-wrapper":"app-pages-AccountSetting-Receipt-__Receipt___1w-2-","receipt-preview-wrapper":"app-pages-AccountSetting-Receipt-__Receipt___1sGtX"};

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-ReceiptForm-Header-__Header___15r1g"};

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___375xp","footer":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___G4uKO","field-wrapper":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___2ONKd"};

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"counting-box":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___zdxP1","wrapper":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___2D22H","receipt":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___JYSRZ"};

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-full-nosub":"app-pages-AccountSetting-__style___2fpeJ","container":"app-pages-AccountSetting-__style___2QnK1"};

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"customers":"app-pages-Customers-__Customer___32vIX","container":"app-pages-Customers-__Customer___3bYRr","container-full-nosub":"app-pages-Customers-__Customer___135I2"};

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Customers-CustomerList-ListLoyalty-ActionBar-__ActionBar___2FEwK","li-filter":"app-pages-Customers-CustomerList-ListLoyalty-ActionBar-__ActionBar___23HWm"};

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-pages-Customers-CustomerList-ListLoyalty-ImportingModeModal-__ImportingModeModal___1Tyl9","dialog":"app-pages-Customers-CustomerList-ListLoyalty-ImportingModeModal-__ImportingModeModal___2UboB"};

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___1dq-V","table-content-wrapper":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___iQEdG","table-content":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___3QBqY","name":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___3UUEU","customer-since":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___1ld47","member-since":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___3X1MF","points":"app-pages-Customers-CustomerList-ListLoyalty-List-__List____oM5K","lifetime":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___rLojk","selected":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___WZUYK","center":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___2bwoX","wrapper":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___30nXP","customers":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___Yeygi","length-wrapper":"app-pages-Customers-CustomerList-ListLoyalty-List-__List___JD7qm"};

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"summary":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___KRrjI","total":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___3EfPY","title":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___2ijQC"};

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-ActionBar-__ActionBar___1t3lM"};

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"customer-list":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___29Cjl","customer-row":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___25EZX","left-column":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___2W8Kl","right-column":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___26ByS","mk-customer-list":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___2E1bH","wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-__CustomerList___1tP5O"};

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-pages-Customers-CustomerList-ListNonLoyalty-ImportingModeModal-__ImportingModeModal___23LBB","dialog":"app-pages-Customers-CustomerList-ListNonLoyalty-ImportingModeModal-__ImportingModeModal___1MY_X"};

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___b3hZW","table-content-wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___20iM9","table-content":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___28J6F","name":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___3k1MT","customer-since":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2CFTS","this-month":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2BOJP","this-year":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___6lUUq","lifetime":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2_ooo","selected":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2V74s","center":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2cZ3M","wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___2Hg0Q","customers":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___1RU4x","length-wrapper":"app-pages-Customers-CustomerList-ListNonLoyalty-List-__List___3qa2V"};

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___1dQO-","header":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___1ypWN","go-back-section":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___1OXcv","left-column":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___1pZFy","scrolled-area":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___36OnC","mk-col-right-action-box-bottom":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___1jX_t","col-right-inner":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___3GnEy","receipt-trx-container":"app-pages-Customers-CustomerList-PointActivity-__PointActivity___lqdhl"};

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___2X7TX","header":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___D-YaQ","go-back-section":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___197xL","left-column":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___3bYAE","scrolled-area":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___3prmD","mk-col-right-action-box-bottom":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___WC1WT","col-right-inner":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___3eDeV","receipt-trx-container":"app-pages-Customers-CustomerList-PurchaseHistory-__PurchaseHistory___24Y9B"};

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___2-oAM","header":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___ezzKn","go-back-section":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___2AqyQ","redeem-history-row":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___2BP5U","left-column":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___1c6Ny","scrolled-area":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___3vGBf","mk-col-right-action-box-bottom":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___3gJpT","col-right-inner":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___pwDGJ","receipt-trx-container":"app-pages-Customers-CustomerList-RedeemHistory-__RedeemHistory___1NOkJ"};

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Customers-Feedback-ActionBar-__ActionBar___1pwn1"};

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"action-label":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___CqOS4","wrapped-input":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___2Ynl_","middle-equal":"app-pages-Customers-Loyalty-Components-Program-PointRule-__PointRule___2Ymxv"};

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"blur70":"app-pages-Customers-Loyalty-Components-Program-ProgramConfiguration-__ProgramConfiguration___uY1P5"};

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"active":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3JVYU","action-label":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3XUZU","disabled":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3s9Jb","program":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___2PElP"};

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subscribe":"app-pages-Customers-Loyalty-Create-__Create___24O8M","title":"app-pages-Customers-Loyalty-Create-__Create___3b0MQ","splash-page":"app-pages-Customers-Loyalty-Create-__Create___3P18N","gray-backgrond":"app-pages-Customers-Loyalty-Create-__Create___sYJXb","body-content":"app-pages-Customers-Loyalty-Create-__Create___jDZsn","start-trial-button":"app-pages-Customers-Loyalty-Create-__Create___3BOpz","free-trial-footer":"app-pages-Customers-Loyalty-Create-__Create___1TM_z","pricing-title":"app-pages-Customers-Loyalty-Create-__Create___bPu26","pricing-body":"app-pages-Customers-Loyalty-Create-__Create___1GqfN","original-price":"app-pages-Customers-Loyalty-Create-__Create___34IRV"};

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"video-content":"app-pages-Customers-Loyalty-Introduction-__Introduction___2Lj1I","title":"app-pages-Customers-Loyalty-Introduction-__Introduction___1aObq","body-content":"app-pages-Customers-Loyalty-Introduction-__Introduction___2CXce","create-button":"app-pages-Customers-Loyalty-Introduction-__Introduction___XZjua","splash-page":"app-pages-Customers-Loyalty-Introduction-__Introduction___2n5WD","gray-backgrond":"app-pages-Customers-Loyalty-Introduction-__Introduction___zj0nb","coming-soon":"app-pages-Customers-Loyalty-Introduction-__Introduction___1awYf","compatibility":"app-pages-Customers-Loyalty-Introduction-__Introduction___1Lwy0","introduction":"app-pages-Customers-Loyalty-Introduction-__Introduction___PKx8b"};

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loyalty-content":"app-pages-Customers-Loyalty-__Loyalty___2ZKWk","loyalty-container":"app-pages-Customers-Loyalty-__Loyalty___2HpKB","wrapper":"app-pages-Customers-Loyalty-__Loyalty___2VXIh","splash-content":"app-pages-Customers-Loyalty-__Loyalty___2DFTv"};

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Dashboard-ActionBar-__ActionBar___1rv74"};

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Dashboard-NoData-__NoData___1W0wx","text":"app-pages-Dashboard-NoData-__NoData___25mIn"};

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no-data":"app-pages-Dashboard-__style___3EDXO","title-section":"app-pages-Dashboard-__style___13KUN","title-no-transaction":"app-pages-Dashboard-__style___2XOYR","about-box":"app-pages-Dashboard-__style___1_XpS","title-chart-left":"app-pages-Dashboard-__style___2wMG9","sales-chart-box":"app-pages-Dashboard-__style___cEt3H","sales-chart-box-top-item":"app-pages-Dashboard-__style___3ZWUd","loading-dashboard":"app-pages-Dashboard-__style___3-kph","hide-component":"app-pages-Dashboard-__style___2URbq","bottom":"app-pages-Dashboard-__style___1sr3z","billing-reminder-dashboard":"app-pages-Dashboard-__style___10xqc"};

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-full-nosub":"app-pages-Employees-__Employee___1Jr44","container":"app-pages-Employees-__Employee___9_dBL"};

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Employees-Header-__Header___1ekGJ"};

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Employees-List-ConfirmDeleteModal-__ConfirmDeleteModal___4UMXR"};

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-dialog":"app-pages-Employees-List-InviteForm-AssignOutletModal-__AssignOutletModal___fUqj6","header":"app-pages-Employees-List-InviteForm-AssignOutletModal-__AssignOutletModal___3exY3","row":"app-pages-Employees-List-InviteForm-AssignOutletModal-__AssignOutletModal___2i1Bi","modal-body":"app-pages-Employees-List-InviteForm-AssignOutletModal-__AssignOutletModal___U6g-M"};

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Employees-List-InviteForm-__InviteForm___2CtHj"};

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Employees-List-StaffList-__StaffList___1oYsr","table":"app-pages-Employees-List-StaffList-__StaffList___3rMbg","thead":"app-pages-Employees-List-StaffList-__StaffList___il0dV","tbody":"app-pages-Employees-List-StaffList-__StaffList___ks1jh","tr":"app-pages-Employees-List-StaffList-__StaffList___3C3vB","word-break-all":"app-pages-Employees-List-StaffList-__StaffList___2--MF","email":"app-pages-Employees-List-StaffList-__StaffList___SPzD2","title":"app-pages-Employees-List-StaffList-__StaffList___117lk","permissions":"app-pages-Employees-List-StaffList-__StaffList___2hEN5","access":"app-pages-Employees-List-StaffList-__StaffList___FRDG7","resend":"app-pages-Employees-List-StaffList-__StaffList___1qm_h","delete":"app-pages-Employees-List-StaffList-__StaffList___30ebL","popover-outlet-name":"app-pages-Employees-List-StaffList-__StaffList___2LU4_"};

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Employees-Permission-__Permission___1V92e"};

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___3ZyXi","eye-button":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___h4p3Q","authorization-code-wrapper":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___2x-Nq"};

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"recaptcha":"app-pages-ForgotPassword-__Recaptcha___3ZYqZ"};

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ForgotPassword-__style___3z9RO","hr":"app-pages-ForgotPassword-__style___PaATL","title":"app-pages-ForgotPassword-__style___2VYK8","no-account":"app-pages-ForgotPassword-__style___195Mz","errorRequired":"app-pages-ForgotPassword-__style___2EWQg"};

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"action-bar":"app-pages-Ingredient-Category-ActionBar-__ActionBar___38SQ_"};

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___28dHe","row-wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___ghjfv","ingredient-image-wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___3wM_s","ingredient-name-wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___meLPm","image":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___uRZGc","padding-checkbox":"app-pages-Ingredient-Category-AssignToIngredientModal-Ingredients-__style___256a5"};

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-AssignToIngredientModal-Search-__style___1j7nx","right":"app-pages-Ingredient-Category-AssignToIngredientModal-Search-__style___1b4kJ"};

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalingredient":"app-pages-Ingredient-Category-AssignToIngredientModal-__style___1tuRc"};

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-CategoryDetail-__CategoryDetail___3UvTR"};

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-CategoryDetail-CategoryForm-__CategoryForm___dvHo0","content-wrapper":"app-pages-Ingredient-Category-CategoryDetail-CategoryForm-__CategoryForm___2cDOh"};

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selected":"app-pages-Ingredient-Category-List-__List___u8T-X","wrapper":"app-pages-Ingredient-Category-List-__List___KY10i","table-header":"app-pages-Ingredient-Category-List-__List___3oHUz","table-content-wrapper":"app-pages-Ingredient-Category-List-__List___3Bg5B","table-content":"app-pages-Ingredient-Category-List-__List___DVJZ0"};

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Ingredient-__Ingredient___2duit"};

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Library-ActionBar-__ActionBar___sKhAy","ul-filter":"app-pages-Ingredient-Library-ActionBar-__ActionBar___3W84y","ul-filter-left":"app-pages-Ingredient-Library-ActionBar-__ActionBar___3v0Ot","filter-right":"app-pages-Ingredient-Library-ActionBar-__ActionBar___2pH7m","btn-outlet":"app-pages-Ingredient-Library-ActionBar-__ActionBar___39GWN","li-filter":"app-pages-Ingredient-Library-ActionBar-__ActionBar___2MDso","li-filter-right":"app-pages-Ingredient-Library-ActionBar-__ActionBar___2_wKl","btn-total":"app-pages-Ingredient-Library-ActionBar-__ActionBar___FNd3s"};

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Library-LibraryDetail-__LibraryDetail___1bNu8","form":"app-pages-Ingredient-Library-LibraryDetail-__LibraryDetail___2iPBE"};

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label-cogs-btn":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___2AybS","info-icon":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___1XRBP","lock-icon":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___yGXTw","cogs-btn":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___26Abf","col-name-cogs":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___1tih2","label-avg-cost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___3njn5","rp-avgCost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___1HKLz","rp-avgCost-error":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___2oy1h","input-avgCost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___84AaD","cost-name":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___2Pzct","avg-cost":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryCOGS-__LibraryCOGS___1eg4N"};

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"upload-image":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___2ukTs","wrapper":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___2IQ1z","field-wrapper":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___3hT-u","footer":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___1oV4C","outlet-active":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___16UD-","outlet-inactive":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___1tKi2","label-section":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___1dho3","library-fieldset":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___yngVP","label-input":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___26ZtB","margin-top-30":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___2l7dU","btn-delete-disabled":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-__LibraryForm___3olzJ"};

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label-inner":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlert-__LibraryInventoryAlert___DA6Ks","col-name":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlert-__LibraryInventoryAlert___2AvTz","label-in-stock":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlert-__LibraryInventoryAlert___3nKI6","inv-name":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlert-__LibraryInventoryAlert___2cUPX","inv-stock":"app-pages-Ingredient-Library-LibraryDetail-LibraryForm-LibraryInventoryAlert-__LibraryInventoryAlert___39Mgu"};

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Ingredient-Library-List-__List___3hRJo","table-content-wrapper":"app-pages-Ingredient-Library-List-__List___1bdVZ","table-content":"app-pages-Ingredient-Library-List-__List___27uKh","name":"app-pages-Ingredient-Library-List-__List___2m4Y3","amount":"app-pages-Ingredient-Library-List-__List___H0pBK","selected":"app-pages-Ingredient-Library-List-__List___Ekbiv","wrapper":"app-pages-Ingredient-Library-List-__List___9Z-gL","leftcol":"app-pages-Ingredient-Library-List-__List___2HDdZ","rightcol":"app-pages-Ingredient-Library-List-__List___3Z9YI","headerName":"app-pages-Ingredient-Library-List-__List___3iKXg","headerCategory":"app-pages-Ingredient-Library-List-__List___1wU9o","headerInStock":"app-pages-Ingredient-Library-List-__List___3C2Uv","headerStockAlert":"app-pages-Ingredient-Library-List-__List___2huN8","full-height":"app-pages-Ingredient-Library-List-__List___3l9T5"};

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Ingredient-Library-SaveToAllOutletsModal-__SaveToAllOutletsModal___1wmWP","sub-title":"app-pages-Ingredient-Library-SaveToAllOutletsModal-__SaveToAllOutletsModal___2lPot","block-outlets":"app-pages-Ingredient-Library-SaveToAllOutletsModal-__SaveToAllOutletsModal___9R2nD","failed-all-outlets":"app-pages-Ingredient-Library-SaveToAllOutletsModal-__SaveToAllOutletsModal___3gNnI"};

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___3-D9d","btn-outlet":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___vXuoC","action-bar":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___Iuheu"};

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-List-__List___1EY1s","table-header":"app-pages-Ingredient-Recipes-List-__List___2iC_M","table-content-wrapper":"app-pages-Ingredient-Recipes-List-__List___3QnFI","table-content":"app-pages-Ingredient-Recipes-List-__List___3oXAZ","selected":"app-pages-Ingredient-Recipes-List-__List___1JRWH","parentRow":"app-pages-Ingredient-Recipes-List-__List___2hRlv"};

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-__Recipes___1zzoJ"};

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___1zKT6","dialog":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___2Myt6","right":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___3IdZI","table-header":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___Uah5s","name":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___dQib2","stock":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___2xKek","warning-message":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___2WFNJ","disableBtnAddItem":"app-pages-Ingredient-Recipes-RecipesDetail-AddItemsModal-__AddItemsModal___7OHQ_"};

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___QRUuc","field-wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___2GyTd","form-wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___31wsR","footer":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___2If8f","btn-done":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___3YaKn","separator-row":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___1Z72z","variant-name":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___309lW","label-total":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___uoh5l","total-adj":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___1aEYw","label-adj-detail":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___2jwOy","break-word":"app-pages-Ingredient-Recipes-RecipesDetail-__RecipesDetail___3oV60"};

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-ConfirmSubmitModal-__ConfirmSubmitModal___2l8aX","modal-dialog":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-ConfirmSubmitModal-__ConfirmSubmitModal___2VP7U"};

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlet-dropdown":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1jlY8","single":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1k2dA","multiple":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1OPj3","grey_box":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1o45I","padding_left_avg_cost":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___28ibC","is-negative-instock":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___3M4zk","recipes_header":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___35GEd","btn-delete-wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___2o1Vc","box-ingredient-recipes":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___2BCrQ","btn-addIngredients":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___YutZy","btn-addIngredients-disabled":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___2ct46","adjustment-input-margin":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1PFGU","adjustment-item-wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___2DXiZ","wrapper":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___25Arg","form-content":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1Bpqj","item-name":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1tqX6","item-variant-name":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___LqGXa","unit-name":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___1XKXb","beginning-stock":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___4oYmL","adjustment":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___3p1i3","ingredient-name":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___GtEgJ","form-footer":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___2TS2n","item-name-header":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-__RecipesForm___3UA33"};

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Ingredient-Recipes-SaveToAllOutletsModal-__SaveToAllOutletsModal___22W7m","sub-title":"app-pages-Ingredient-Recipes-SaveToAllOutletsModal-__SaveToAllOutletsModal___PdFge","block-outlets":"app-pages-Ingredient-Recipes-SaveToAllOutletsModal-__SaveToAllOutletsModal___2Uc2J","failed-all-outlets":"app-pages-Ingredient-Recipes-SaveToAllOutletsModal-__SaveToAllOutletsModal___1c_le"};

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content-wrapper":"app-pages-Inventory-Adjustment-__Adjustment___1Z7o1"};

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___2mh60","disableBtnAddItem":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___HUDgz","enableBtnAddItem":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___2QBes","dialog":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___3NMKh","right":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___19bWK","table-header":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___2z_lA","name":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___3dYiH","stock":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___1_Zgr","warning-message":"app-pages-Inventory-Adjustment-AdjustmentDetail-AddItemsModal-__AddItemsModal___3rWS9"};

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"outlet-dropdown":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1Bj4y","single":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___2WBQp","multiple":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___271_H","btn-delete-wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1pPgr","btn-addItems":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___3Q0tb","btn-addItems-disabled":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1xe9q","adjustment-input-margin":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___Tt1Im","adjustment-item-wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___FL87_","wrapper":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1tcCd","form-content":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___2UfkD","item-name":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1RHVL","item-variant-name":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1EwWP","unit-name":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___X9vTn","beginning-stock":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___12gNo","adjustment":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___1ikE8","ingredient-name":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___6vzTB","form-footer":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___36erJ","item-name-header":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-__AdjustmentForm___3OxwB"};

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-ConfirmSubmitModal-__ConfirmSubmitModal___2mD18","modal-dialog":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-ConfirmSubmitModal-__ConfirmSubmitModal___3rp6u"};

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Adjustment-List-__List___3uwVw","table-header":"app-pages-Inventory-Adjustment-List-__List___UxEvR","table-content-wrapper":"app-pages-Inventory-Adjustment-List-__List___mBsX0","table-content":"app-pages-Inventory-Adjustment-List-__List___JuPvV","selected":"app-pages-Inventory-Adjustment-List-__List___9XLGs","parentRow":"app-pages-Inventory-Adjustment-List-__List___3nwcH"};

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"summary-adjustment":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___15KHM","amount":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___2s7Ui","title":"app-pages-Inventory-Adjustment-SummaryAdjustment-__SummaryAdjustment___2qY0J"};

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Inventory-__Inventory___1CR88"};

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-PurchaseOrder-ActionBar-__ActionBar___hyH55","btn-outlet":"app-pages-Inventory-PurchaseOrder-ActionBar-__ActionBar___3J6ae","action-bar":"app-pages-Inventory-PurchaseOrder-ActionBar-__ActionBar___3FJI4"};

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-ConfirmSubmitModal-__ConfirmSubmitModal___2U8ax","modal-dialog":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-ConfirmSubmitModal-__ConfirmSubmitModal___R8LGY"};

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___2qYcv","header-item":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___fFRLJ","field-wrapper":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___taBf-","mb-0px":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___ds5Um","mb-25px":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___MXK5n","wrapper":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___3K6Gp","title":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___8_vGu","footer":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___2A_VM","btn-cancel":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___19z3N","btn-save-all":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1nZdu","btn-addItems":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1ra2W","btn-save":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___20Mga","itemDetail":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___2ToOA","itemStock":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___2Cv3R","itemDetailBeginingStock":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___7ro-H","itemDetailLeftDown":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1i0lD","itemDetailRightDown":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1AM9P","itemDetailRight":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___2Otif","itemDetailLeft":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1X5mM","item":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___R-e-B","itemHeader":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___3sg_D","remove-item":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___RzjOf","warning-style":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___3w446","dismiss-warning-button":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1LqgF","label-track-item":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1U2yr","info-icon":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___3rja9","link-library":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___1YEQy","input-field-30px":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-__FormPurchaseOrder___78Kas"};

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Inventory-PurchaseOrder-List-__List___3UnD9","table-content-wrapper":"app-pages-Inventory-PurchaseOrder-List-__List___ICG5R","table-content":"app-pages-Inventory-PurchaseOrder-List-__List___epGdd","w20":"app-pages-Inventory-PurchaseOrder-List-__List___rhfhX","w15":"app-pages-Inventory-PurchaseOrder-List-__List___3m5Ng","w10":"app-pages-Inventory-PurchaseOrder-List-__List___1wS4i","selected":"app-pages-Inventory-PurchaseOrder-List-__List___2OXc3","wrapper":"app-pages-Inventory-PurchaseOrder-List-__List___3IEkn","parentRow":"app-pages-Inventory-PurchaseOrder-List-__List___3UCKw","icon":"app-pages-Inventory-PurchaseOrder-List-__List___1SC7C","status":"app-pages-Inventory-PurchaseOrder-List-__List___CPoQx"};

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalitem":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___3KkPG","disableBtnAddItem":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___3V_KN","option-list":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2RHAH","modalBody":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2jDvA","padding0":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2MD2q","itemDetail":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___30YeP","itemStock":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___3iNCM","unitCost":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___1HpTF","rpfield":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2vrfB","middleTable":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___nMr2F","item":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___1HoWK","name":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2jW7F","unitCostContainer":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___39ySf","total":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___1pzzX","itemHeader":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___BNd1j","warning-style":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2EPg8","dismiss-warning-button":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___2Td_Y","warning-message-wrapper":"app-pages-Inventory-PurchaseOrder-ModalAddItem-__ModalAddItem___1SOR7"};

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activity":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Activities-__Activities___2l3hH","symbol":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Activities-__Activities___14w2q"};

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"padding0":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___2hxYb","itemDetail":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___1Mgac","itemDetailBeginingStock":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___1W9PU","itemDetailLeftDown":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___2s2He","itemDetailRightDown":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___1pjQU","itemDetailRight":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___1VHAv","itemDetailLeft":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___3YUSw","itemDetailUp":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___2a40J","item":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___3Cmy0","itemHeader":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___1P2J3","header":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___2fJeJ","tooltip":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-PurchaseItemList-__PurchaseItemList___2YekJ"};

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___3LOcE","content":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___3AUrK","footer":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___4IqsB","supplier-name":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___yyWWX","buttonFulfilled":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___hKJjQ","icon_cancel":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___16wuO","break":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-__PurchaseOrderDetail___3J7e1"};

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Separator-__Separator___3feq-"};

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Summary-ActionBar-__ActionBar___1TbMn","btn-outlet":"app-pages-Inventory-Summary-ActionBar-__ActionBar___d1LW0","action-bar":"app-pages-Inventory-Summary-ActionBar-__ActionBar___HEANo"};

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Summary-List-__List___2mElN","c20":"app-pages-Inventory-Summary-List-__List___121j7","c12":"app-pages-Inventory-Summary-List-__List___2_bHM","table-header":"app-pages-Inventory-Summary-List-__List___3VROi","table-content-wrapper":"app-pages-Inventory-Summary-List-__List___3ndj7","table-content":"app-pages-Inventory-Summary-List-__List___2xt-h"};

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___1saRq","c20":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___1N-4w","c12":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___2TDPf","table-header":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___3cAz5","table-content-wrapper":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___1b5Bs","table-content":"app-pages-Inventory-Summary-ListSummaryIngredients-__ListSummaryIngredients___W5UtM"};

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Supplier-ActionBar-__ActionBar___2kAJL","btn-outlet":"app-pages-Inventory-Supplier-ActionBar-__ActionBar___3oST0","action-bar":"app-pages-Inventory-Supplier-ActionBar-__ActionBar___3ixVR"};

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Supplier-List-__List___ioT8z","table-header":"app-pages-Inventory-Supplier-List-__List___kissr","table-content-wrapper":"app-pages-Inventory-Supplier-List-__List___3IwnC","table-content":"app-pages-Inventory-Supplier-List-__List___onY2t","selected":"app-pages-Inventory-Supplier-List-__List___1Dmfb"};

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Supplier-SupplierDetail-__SupplierDetail___2_mZH"};

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___3DYTx","wrapper":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___1gohe","title":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___32dzD","footer":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___3Pn6B","btn-cancel":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___YCaEa","btn-save-all":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___TR3ca","btn-save":"app-pages-Inventory-Supplier-SupplierDetail-SupplierForm-__SupplierForm___1-Apq"};

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Transfer-List-__List___1GoI3","table-header":"app-pages-Inventory-Transfer-List-__List___N21bz","table-content-wrapper":"app-pages-Inventory-Transfer-List-__List___YFC26","table-content":"app-pages-Inventory-Transfer-List-__List___1b6_7","selected":"app-pages-Inventory-Transfer-List-__List___1O7fl","parentRow":"app-pages-Inventory-Transfer-List-__List___XTMTs"};

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalitem":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___337im","disableBtnAddItem":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___NAELv","enableBtnAddItem":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___3s2nG","modalBody":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___36cAV","dialog":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___I70Mw","wrapper-search":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___2XlQj","right":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___1pU9B","table-header":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___djtvJ","name":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___gg0Ft","stock":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___1VS_S","list-item-input":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___3Xrup","list-item-input-detail":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___jVn52","warning-message-wrapper":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___pR9ii","warning-style":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___3sIpP","dismiss-warning-button":"app-pages-Inventory-Transfer-TransferDetail-AddItemsModal-__AddItemsModal___1yUPk"};

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-ConfirmSubmitModal-__ConfirmSubmitModal___qG5I4","modal-dialog":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-ConfirmSubmitModal-__ConfirmSubmitModal___eV3OO"};

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"last-input":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___xJRGi","feedback":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___3v4MW","btn-addItems":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___3LFvH","btn-delete-wrapper":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___27sSS","transfer-item-wrapper":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___2Rxfk","wrapper":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___9OKEZ","form-content":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___5DT4F","item-name":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___1q_4s","item-variant-name":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___14iW9","beginning-stock":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___3WS8n","adjustment":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___CAZiC","item-name-header":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___75_pK","ingredient-name-header":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___FuXCg","ingredient-unit-name":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___3J1ks","in-stock":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___3yr3V","transfer-quantity":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___iZoEu","form-footer":"app-pages-Inventory-Transfer-TransferDetail-TransferForm-__TransferForm___znLWB"};

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Category-ActionBar-__style___2rsI7 app-pages-Library-Gratuity-ActionBar-__ActionBar___oIYry","btn-outlet":"app-pages-Library-Category-ActionBar-__style___3cfbH app-pages-Library-Gratuity-ActionBar-__ActionBar___2SplP","btn-search":"app-pages-Library-Category-ActionBar-__style___WrC1J"};

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___3GUvc","row-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___1Xj5z","item-image-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___2eJu5","item-name-wrapper":"app-pages-Library-Category-AssignToItemModal-Items-__style___1mKq6","image":"app-pages-Library-Category-AssignToItemModal-Items-__style___1aqJS","padding-checkbox":"app-pages-Library-Category-AssignToItemModal-Items-__style___1qbPR"};

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Category-AssignToItemModal-Search-__style___3p-4P","right":"app-pages-Library-Category-AssignToItemModal-Search-__style___3NupD"};

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalitem":"app-pages-Library-Category-AssignToItemModal-__style___3iW3c"};

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Category-List-__style___3HCMV app-pages-Library-Gratuity-List-__List___27BbO","table-content-wrapper":"app-pages-Library-Category-List-__style___ckjA1 app-pages-Library-Gratuity-List-__List___1V-Ia","table-content":"app-pages-Library-Category-List-__style___2M-io app-pages-Library-Gratuity-List-__List___3hkB-","name":"app-pages-Library-Category-List-__style___2oM4j","stocks":"app-pages-Library-Category-List-__style___1QcBn","assign":"app-pages-Library-Category-List-__style___2M6Mq","selected":"app-pages-Library-Category-List-__style___3YhXu app-pages-Library-Gratuity-List-__List___2z2jj","wrapper":"app-pages-Library-Category-List-__style___2KlYk app-pages-Library-Gratuity-List-__List___34OXt","div-table":"app-pages-Library-Category-List-__style___2GJTE"};

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Discount-ActionBar-__ActionBar___lj_C_","btn-outlet":"app-pages-Library-Discount-ActionBar-__ActionBar___3Ow0v"};

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Library-Discount-ConfirmDeleteModal-__ConfirmDeleteModal___3WnAR","dialog":"app-pages-Library-Discount-ConfirmDeleteModal-__ConfirmDeleteModal___2tlud"};

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Discount-__Discount___-vUa4"};

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Discount-DiscountDetail-__DiscountDetail___1DXSm","form":"app-pages-Library-Discount-DiscountDetail-__DiscountDetail___1PVzi"};

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___vUDF3","field-wrapper":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___1mi0N","footer":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___3b4Uy","outlet-active":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___3ienk","outlet-inactive":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___2bmP-","label-section":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___pw1fB"};

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Discount-List-__List___2hj1q","table-content-wrapper":"app-pages-Library-Discount-List-__List___3miyz","table-content":"app-pages-Library-Discount-List-__List___6P6Xb","name":"app-pages-Library-Discount-List-__List___1EluM","amount":"app-pages-Library-Discount-List-__List___ZIDUi","selected":"app-pages-Library-Discount-List-__List___3cFyg","wrapper":"app-pages-Library-Discount-List-__List___P70zG","leftcol":"app-pages-Library-Discount-List-__List___30Hxi","rightcol":"app-pages-Library-Discount-List-__List___2UbL8","table-wrapper":"app-pages-Library-Discount-List-__List___9OI-K"};

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Gratuity-ActionBar-__ActionBar___oIYry","btn-outlet":"app-pages-Library-Gratuity-ActionBar-__ActionBar___2SplP"};

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Library-Gratuity-ConfirmDeleteModal-__ConfirmDeleteModal___tw0lA","dialog":"app-pages-Library-Gratuity-ConfirmDeleteModal-__ConfirmDeleteModal___2DqY6"};

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gratuity-wrapper":"app-pages-Library-Gratuity-__Gratuity___yvtXp"};

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Gratuity-GratuityDetail-__GratuityDetail___LKVru"};

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___1iCAU","wrapper":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___1SPcK","title":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___jqA1l","footer":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___1iZpb","btn-cancel":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___34C4e","btn-save-all":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___2jiGT","btn-save":"app-pages-Library-Gratuity-GratuityDetail-GratuityForm-__GratuityForm___2bi4R"};

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Gratuity-List-__List___27BbO","table-content-wrapper":"app-pages-Library-Gratuity-List-__List___1V-Ia","table-content":"app-pages-Library-Gratuity-List-__List___3hkB-","name":"app-pages-Library-Gratuity-List-__List___Op7V4","amount":"app-pages-Library-Gratuity-List-__List___cEQ4U","selected":"app-pages-Library-Gratuity-List-__List___2z2jj","wrapper":"app-pages-Library-Gratuity-List-__List___34OXt"};

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Item-ActionBar-__ActionBar___1ZtRO","ul-filter":"app-pages-Library-Item-ActionBar-__ActionBar___3qr_k","ul-filter-left":"app-pages-Library-Item-ActionBar-__ActionBar___f259N","filter-right":"app-pages-Library-Item-ActionBar-__ActionBar___314MA","btn-outlet":"app-pages-Library-Item-ActionBar-__ActionBar___3VZhQ","li-filter":"app-pages-Library-Item-ActionBar-__ActionBar___19UF9","li-filter-right":"app-pages-Library-Item-ActionBar-__ActionBar___2tDXG"};

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Item-__Item___2S--T"};

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Item-ItemDetail-__ItemDetail___BTOni","form":"app-pages-Library-Item-ItemDetail-__ItemDetail___cQCie"};

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bg-white":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___3hwbL","rp-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___3QMZ6","rp-cogs-error":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___shQ9P","input-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGS-COGSFieldArray-COGSField-__COGSField___2b-gi"};

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer-info":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___jaYb8","body":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___2wXLd","dialog":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___HCvlq","table":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-__COGSModal___33rK7"};

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rp-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-COGSModalFieldArray-__COGSModalFieldArray___28Qj_","input-cogs":"app-pages-Library-Item-ItemDetail-ItemForm-COGSModal-COGSModalFieldArray-__COGSModalFieldArray___1vZsn"};

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"app-pages-Library-Item-ItemDetail-ItemForm-CreateCategoryModal-__CreateCategoryModal___38eUI","modal-container":"app-pages-Library-Item-ItemDetail-ItemForm-CreateCategoryModal-__CreateCategoryModal___1y6d9"};

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"upload-image":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___1Vc8_","disabled-button":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___-ViYP","wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___I1nX_","field-wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___Jx8PP","footer":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___1MYMN","outlet-active":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___1aN8k","outlet-inactive":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___1dwN1","label-section":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___3idYA","item-fieldset":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___Gczle","label-input":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___3PBxB","margin-top-30":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___1CjhT","select-dropdown":"app-pages-Library-Item-ItemDetail-ItemForm-__ItemForm___2rxjp"};

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bg-white":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlert-ItemInventoryAlertFieldArray-ItemInventoryAlertField-__ItemInventoryAlertField___2R_5H"};

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer-info":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___2skxS","body":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___2Q2r-","dialog":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___mKi9l","table":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlertModal-__ItemInventoryAlertModal___1UH8H"};

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alignleft":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___Cgoxo","alignright":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___22xvg","row-wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___20Rvk","tax-name-wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___26_uW","tax-checkbox-wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___12n-D","tax-checkbox-input":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___1yoA4","tax-amount-label":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___16DNe","checkbox-moka":"app-pages-Library-Item-ItemDetail-ItemForm-ItemTax-__ItemTax___2f9B_"};

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"last-input":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___axinn","feedback":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___3ReR1","btn-delete-wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___1VE-B","btn-delete":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___2vCu0","btn-warning":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___nQA32","text-align-last-right":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-ItemVariantFieldArray-ItemVariantField-__ItemVariantField___3UH07"};

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-__ItemVariantModal___2M1QB","dialog":"app-pages-Library-Item-ItemDetail-ItemForm-ItemVariantModal-__ItemVariantModal___1JrJ3"};

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Library-Item-ItemDetail-ItemForm-SaveToAllOutletsModal-__SaveToAllOutletsModal___Z2LOc","title":"app-pages-Library-Item-ItemDetail-ItemForm-SaveToAllOutletsModal-__SaveToAllOutletsModal___3vSDz"};

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___2PTp5","circle":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___1Fp7B","lock":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___OdQFI","content":"app-pages-Library-Item-ItemDetail-ItemForm-WarningLabel-__WarningLabel___2PKdd"};

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Item-List-__List___yBs7K","table-content-wrapper":"app-pages-Library-Item-List-__List___1HDHB","table-content":"app-pages-Library-Item-List-__List___1b4UA","name":"app-pages-Library-Item-List-__List___3Q9RV","amount":"app-pages-Library-Item-List-__List___MSqp8","selected":"app-pages-Library-Item-List-__List___2Qyq1","wrapper":"app-pages-Library-Item-List-__List___iVPJm","leftcol":"app-pages-Library-Item-List-__List___1bZqI","rightcol":"app-pages-Library-Item-List-__List___1ozt4","headerName":"app-pages-Library-Item-List-__List___1nIwr","headerCategory":"app-pages-Library-Item-List-__List___3ve9y","headerPrice":"app-pages-Library-Item-List-__List___3GM8K","headerInStock":"app-pages-Library-Item-List-__List___3EwSz","headerStockAlert":"app-pages-Library-Item-List-__List___5S3vU"};

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Library-__Library___2Oah0"};

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Modifier-ApplySetItemModal-__ApplySetItemModal___1c3RT","dialog":"app-pages-Library-Modifier-ApplySetItemModal-__ApplySetItemModal___2LBl4"};

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___X4Hpb","row-wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___3SsPw","item-image-wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___19sqz","item-name-wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___RRegP","item-checkbox-wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___2vJzi","image":"app-pages-Library-Modifier-ApplySetItemModal-Items-__Items___3hR61"};

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Modifier-ApplySetItemModal-Search-__SearchForm___2gQyf"};

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Modifier-Detail-__Detail___24q9N"};

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Modifier-Detail-ModifierForm-__ModifierForm___2Az4H","content-wrapper":"app-pages-Library-Modifier-Detail-ModifierForm-__ModifierForm___7qIBc"};

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-delete":"app-pages-Library-Modifier-Detail-ModifierForm-ModifierOptionsModal-ModifierOptionsFieldArray-ModifierOptionsField-__ModifierOptionsField___3_1m5"};

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Modifier-Detail-ModifierForm-ModifierOptionsModal-__ModifierOptionsModal___1GWgl","dialog":"app-pages-Library-Modifier-Detail-ModifierForm-ModifierOptionsModal-__ModifierOptionsModal___27b2a"};

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Modifier-List-__List___-29-f","table-content-wrapper":"app-pages-Library-Modifier-List-__List___2_YEg","table-content":"app-pages-Library-Modifier-List-__List___2JuFI","name":"app-pages-Library-Modifier-List-__List___Z-eIa","option":"app-pages-Library-Modifier-List-__List___UI48y","apply":"app-pages-Library-Modifier-List-__List___1NpxL","selected":"app-pages-Library-Modifier-List-__List___ZsFat","wrapper":"app-pages-Library-Modifier-List-__List___lFJaC"};

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Tax-ActionBar-__style___c6tHl app-pages-Library-Gratuity-ActionBar-__ActionBar___oIYry","btn-outlet":"app-pages-Library-Tax-ActionBar-__style___2e1kJ app-pages-Library-Gratuity-ActionBar-__ActionBar___2SplP"};

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-header":"app-pages-Library-Tax-List-__style___2RuUQ app-pages-Library-Gratuity-List-__List___27BbO","table-content-wrapper":"app-pages-Library-Tax-List-__style___3VwdC app-pages-Library-Gratuity-List-__List___1V-Ia","table-content":"app-pages-Library-Tax-List-__style___XA7oS app-pages-Library-Gratuity-List-__List___3hkB-","name":"app-pages-Library-Tax-List-__style___1t2tW app-pages-Library-Gratuity-List-__List___Op7V4","amount":"app-pages-Library-Tax-List-__style___3L_7y app-pages-Library-Gratuity-List-__List___cEQ4U","selected":"app-pages-Library-Tax-List-__style___v98xo app-pages-Library-Gratuity-List-__List___2z2jj","wrapper":"app-pages-Library-Tax-List-__style___25et2 app-pages-Library-Gratuity-List-__List___34OXt"};

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Library-Tax-SaveToAllOutletsModal-__SaveToAllOutletsModal___7x3Q5","sub-title":"app-pages-Library-Tax-SaveToAllOutletsModal-__SaveToAllOutletsModal___3B0iw","block-outlets":"app-pages-Library-Tax-SaveToAllOutletsModal-__SaveToAllOutletsModal___xtuRh","failed-all-outlets":"app-pages-Library-Tax-SaveToAllOutletsModal-__SaveToAllOutletsModal___3ikxa"};

/***/ }),
/* 2195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___3-4t1","row-wrapper-first":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___2QDK6","row-wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___23pg8","item-image-wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___3IWd4","item-name-wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___304_M","item-checkbox-wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___183kY","item-checkbox-header":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___MKPSt","item-assign-all-result-header":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___3frfz","image":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___2jxM7","text-notif":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___20FO4","checkbox-moka":"app-pages-Library-Tax-TaxAssignToItemModal-Items-__Items___3s1b5"};

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Tax-TaxAssignToItemModal-Search-__SearchForm___2wJQh","search-select":"app-pages-Library-Tax-TaxAssignToItemModal-Search-__SearchForm___sflcH"};

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Tax-TaxAssignToItemModal-__TaxAssignToItemModal___2m9_o","dialog":"app-pages-Library-Tax-TaxAssignToItemModal-__TaxAssignToItemModal___10n4h"};

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-Login-__style___2z-qW","title":"app-pages-Login-__style___2nGvt","left":"app-pages-Login-__style___2WkBU","right":"app-pages-Login-__style___3Bp4v"};

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"login-form":"app-pages-Login-__style-form___3HYVv","field-wrapper":"app-pages-Login-__style-form___2Ojtx","field-input":"app-pages-Login-__style-form___3WVD8","submit-btn":"app-pages-Login-__style-form___2LTAX"};

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-NotFound-__style___V7akg","btn-back":"app-pages-NotFound-__style___1r53-","pageNotFound":"app-pages-NotFound-__style___17TbJ","textNotFound":"app-pages-NotFound-__style___2fvdH"};

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn-outlet":"app-pages-Outlets-List-ActionBar-__ActionBar___3Qp8C"};

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-wrapper":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___293ET","add-outlet-modal-wrapper":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___3xEOZ","spinner":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___ZMJSU","input-group-btn-vertical":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___1wrvu","add-outlet-pay-button":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___2ZgiG","disabled":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___bttkL","add-outlet-value":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___1Joo2","times-text":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___2ACS8","pricing-text":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___2UsuZ","pro-rated-period-text":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___20qnl","outlet-features":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___1P9JK","pending-message":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___1c3Zm","text-xs":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___2-Ijf","on-loading-button":"app-pages-Outlets-List-AddOutletModal-__AddOutletModal___11KjO"};

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-wrapper":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___3qQXW","reactivate-outlet-modal-wrapper":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___2EfZ1","pricing-text":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___yo33E","pro-rated-period-text":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___3zmPE","outlet-features":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___1ofBt","pending-message":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___3sTsH","text-xs":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___RUCuG","on-loading-button":"app-pages-Outlets-List-ConfirmReactivateOutletModal-__ConfirmReactivateOutletModal___1MJ3a"};

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Outlets-List-OutletDetail-__OutletDetail___2-5-O","form":"app-pages-Outlets-List-OutletDetail-__OutletDetail___K89Yq"};

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Outlets-List-OutletDetail-OutletForm-__OutletForm___2_P6o","field-wrapper":"app-pages-Outlets-List-OutletDetail-OutletForm-__OutletForm___eJKu8","footer":"app-pages-Outlets-List-OutletDetail-OutletForm-__OutletForm___1lBXK","outlet-active":"app-pages-Outlets-List-OutletDetail-OutletForm-__OutletForm___1vLom","outlet-inactive":"app-pages-Outlets-List-OutletDetail-OutletForm-__OutletForm___1pKwd"};

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Outlets-List-ReactiveOutletWithoutPayModal-__ReactivateOutletWithoutPayModal___1daWl"};

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Outlets-List-Table-__Table___sCeZs","selected":"app-pages-Outlets-List-Table-__Table___r1G0a","table-header":"app-pages-Outlets-List-Table-__Table___2uADo","table-body":"app-pages-Outlets-List-Table-__Table___2fGIh","scroll":"app-pages-Outlets-List-Table-__Table___1Q0fD","outlet-active":"app-pages-Outlets-List-Table-__Table___3_X3m","outlet-inactive":"app-pages-Outlets-List-Table-__Table___1L1F_","name":"app-pages-Outlets-List-Table-__Table___56teC","address":"app-pages-Outlets-List-Table-__Table___39Ykm","phone":"app-pages-Outlets-List-Table-__Table___3CwkP","city":"app-pages-Outlets-List-Table-__Table___QWvtS","province":"app-pages-Outlets-List-Table-__Table___3eTXr","status":"app-pages-Outlets-List-Table-__Table___2AWOk"};

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Outlets-__Outlet___3gN6K"};

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"register-form":"app-pages-Register-__style-form___kluvn","field-wrapper":"app-pages-Register-__style-form___3lh_a app-pages-Login-__style-form___2Ojtx","field-input":"app-pages-Register-__style-form___csjUL app-pages-Login-__style-form___3WVD8","submit-btn":"app-pages-Register-__style-form___1dGH5 app-pages-Login-__style-form___2LTAX"};

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Reports-Invoices-ActionBar-__ActionBar___HPqDE"};

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left-column":"app-pages-Reports-Invoices-__style___2IIDG","right-column":"app-pages-Reports-Invoices-__style___r8Zku","invoice-report":"app-pages-Reports-Invoices-__style___xW-yp","invoice-table":"app-pages-Reports-Invoices-__style___3GsFn","mk-report-invoice":"app-pages-Reports-Invoices-__style___1xYqJ","row-invoice":"app-pages-Reports-Invoices-__style___1iqCs","box-table":"app-pages-Reports-Invoices-__style___2Iteh","div-invoice-table":"app-pages-Reports-Invoices-__style___1FXvR","invoice-left-table":"app-pages-Reports-Invoices-__style___VHJD2","table-content-wrapper":"app-pages-Reports-Invoices-__style___28lW3","table-header":"app-pages-Reports-Invoices-__style___uM85l","table-content":"app-pages-Reports-Invoices-__style___3EkjA","td-one-outlet":"app-pages-Reports-Invoices-__style___hDnLS","col-outlet":"app-pages-Reports-Invoices-__style___O3gKS","col-status":"app-pages-Reports-Invoices-__style___TdwPo","hide-table":"app-pages-Reports-Invoices-__style___1WmRr"};

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Reports-Sales-ActionBar-__ActionBar___bBRMi"};

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-CategorySales-__CategorySales___1cFHn","tableWrapper":"app-pages-Reports-Sales-CategorySales-__CategorySales___31YCU","header_panel":"app-pages-Reports-Sales-CategorySales-__CategorySales___Ip5Xl","tableWrapperResponsive":"app-pages-Reports-Sales-CategorySales-__CategorySales___DmG4C","body_gross_margin":"app-pages-Reports-Sales-CategorySales-__CategorySales___2r4mJ","foot_gross_margin":"app-pages-Reports-Sales-CategorySales-__CategorySales___1edFv","thickTitle":"app-pages-Reports-Sales-CategorySales-__CategorySales___1CTMS"};

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-CollectedBy-__CollectedBy___1Iptf","tableWrapper":"app-pages-Reports-Sales-CollectedBy-__CollectedBy___2DyPb","tableWrapperResponsive":"app-pages-Reports-Sales-CollectedBy-__CollectedBy___1L8fc"};

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-Discounts-__Discounts___i42OQ","tableWrapper":"app-pages-Reports-Sales-Discounts-__Discounts___Zuq0S","tableWrapperResponsive":"app-pages-Reports-Sales-Discounts-__Discounts___23lI8"};

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-Gratuity-__Gratuity___3oD1F","tableWrapper":"app-pages-Reports-Sales-Gratuity-__Gratuity___1zNA7","tableWrapperResponsive":"app-pages-Reports-Sales-Gratuity-__Gratuity___2TIuG"};

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___3PRt1","table-wrapper":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___pexyJ","table-wrapper-responsive":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___2Z1q6","header_panel":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___1iWEF","precent_label":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___25SIN","precent_label_danger":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___181dp","precent_label_none":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___2ukSe","btn_warning":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___1Divv","thickTitle":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___391YS","tooltip-message":"app-pages-Reports-Sales-GrossProfit-__GrossProfit___3zGSY"};

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info-modal-wrapper":"app-pages-Reports-Sales-GrossProfit-InformationModal-__InformationModal___3fa1_","dialog":"app-pages-Reports-Sales-GrossProfit-InformationModal-__InformationModal___Pwi1w","no-mtop":"app-pages-Reports-Sales-GrossProfit-InformationModal-__InformationModal___tRcOF","blue-button":"app-pages-Reports-Sales-GrossProfit-InformationModal-__InformationModal___2H9uR"};

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___2_cnr","circle":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___3pP-N","content":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___2VL9i"};

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"app-pages-Reports-Sales-ItemSales-__ItemSales___sw1vw","tableWrapper_without_scroll":"app-pages-Reports-Sales-ItemSales-__ItemSales___2b5FH","tableWrapperResponsive":"app-pages-Reports-Sales-ItemSales-__ItemSales___1rSPV","header_panel":"app-pages-Reports-Sales-ItemSales-__ItemSales___7bXOl","body_gross_margin":"app-pages-Reports-Sales-ItemSales-__ItemSales___3Vzsl","foot_gross_margin":"app-pages-Reports-Sales-ItemSales-__ItemSales___2HmXN","thickTitle":"app-pages-Reports-Sales-ItemSales-__ItemSales___3pAtn"};

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"app-pages-Reports-Sales-ModifierSales-__ModifierSales___2NU4j","tableWrapperResponsive":"app-pages-Reports-Sales-ModifierSales-__ModifierSales___K5_qR"};

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-PaymentMethods-__PaymentMethods___2UUEx","tableWrapper":"app-pages-Reports-Sales-PaymentMethods-__PaymentMethods___B2cbp","tableWrapperResponsive":"app-pages-Reports-Sales-PaymentMethods-__PaymentMethods___3PD33"};

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___fhKsv","table-wrapper":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___1z2Qa","table-wrapper-responsive":"app-pages-Reports-Sales-ReportSummary-__ReportSummary___bt1IP"};

/***/ }),
/* 2225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-ServedBy-__ServedBy___1aR8e","tableWrapper":"app-pages-Reports-Sales-ServedBy-__ServedBy___2LKnY","tableWrapperResponsive":"app-pages-Reports-Sales-ServedBy-__ServedBy___eMtKb"};

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-Taxes-__Taxes___MDrtN","tableWrapper":"app-pages-Reports-Sales-Taxes-__Taxes___ypNnJ","tableWrapperResponsive":"app-pages-Reports-Sales-Taxes-__Taxes___44NSz"};

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Reports-Shift-ActionBar-__ActionBar___xzDEq"};

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-NameRow-__NameRow___2zwjh","value":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-NameRow-__NameRow___2zR4v"};

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___3Ac3C","dialog":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___3v-qG","modal-body":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailModal-__ShiftDetailModal___ggTZq"};

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"total-expense-label":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalExpense-__ShiftDetailTotalExpense___3-T6Y","total-expense-amount":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalExpense-__ShiftDetailTotalExpense___1UEc9"};

/***/ }),
/* 2231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"total-income-label":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalIncome-__ShiftDetailTotalIncome___2FNmE","total-income-amount":"app-pages-Reports-Shift-ShiftDetail-ShiftDetailTotalIncome-__ShiftDetailTotalIncome___jsURx"};

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left-column":"app-pages-Reports-Shift-__shift___3uWYk","shift-report":"app-pages-Reports-Shift-__shift___1SLPq","shift-table":"app-pages-Reports-Shift-__shift___3tx8a","mk-report-transaction":"app-pages-Reports-Shift-__shift___3Kt8U","row-shift":"app-pages-Reports-Shift-__shift___21MWr","box-table":"app-pages-Reports-Shift-__shift___iy4JU","transaction-table":"app-pages-Reports-Shift-__shift___1I696","shift-left-table-max":"app-pages-Reports-Shift-__shift___3S46C","shift-left-table":"app-pages-Reports-Shift-__shift___15DEJ","thead-shift-table":"app-pages-Reports-Shift-__shift___2SREA","tbody-shift-table":"app-pages-Reports-Shift-__shift___2GAJT","wrapper":"app-pages-Reports-Shift-__shift___Bp2Yj","table-content-wrapper":"app-pages-Reports-Shift-__shift___3ojaz","hide-table":"app-pages-Reports-Shift-__shift___1Q2x5"};

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"app-pages-Reports-Transaction-ActionBar-__ActionBar___3gCmc","mk-action-bar":"app-pages-Reports-Transaction-ActionBar-__ActionBar___2k3tA","search-receipt":"app-pages-Reports-Transaction-ActionBar-__ActionBar___1OCC_"};

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-list":"app-pages-Reports-Transaction-__Table___x2VN5","total":"app-pages-Reports-Transaction-__Table___35lNC","table":"app-pages-Reports-Transaction-__Table___DgTqR","table-head":"app-pages-Reports-Transaction-__Table___1hybp","table-row":"app-pages-Reports-Transaction-__Table___22oMy","selected":"app-pages-Reports-Transaction-__Table___3I7he"};

/***/ }),
/* 2236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left-column":"app-pages-Reports-Transaction-__Transaction___3OoCg","right-column":"app-pages-Reports-Transaction-__Transaction___30sZ_","report-transaction":"app-pages-Reports-Transaction-__Transaction___2d288","transaction-wrapper":"app-pages-Reports-Transaction-__Transaction___cM255","table-wrapper":"app-pages-Reports-Transaction-__Transaction___1sr2G"};

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-full-nosub":"app-pages-Reports-__style___3kWJg","container":"app-pages-Reports-__style___35WMN"};

/***/ }),
/* 2239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1QrPD","error":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___3sDzl","notification":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1uXpl","dialog":"app-pages-ResendVerificationEmail-NotificationModal-__NotificationModal___1y4b7"};

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-ResendVerificationEmail-__style___1d4K0","title":"app-pages-ResendVerificationEmail-__style___39wAz","left":"app-pages-ResendVerificationEmail-__style___2zu50","right":"app-pages-ResendVerificationEmail-__style___3HbYS","text-margin-resend":"app-pages-ResendVerificationEmail-__style___3jsJI"};

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hr":"app-pages-SuccessForgotPassword-__style___2WDWb","img":"app-pages-SuccessForgotPassword-__style___1hScH","text-email":"app-pages-SuccessForgotPassword-__style___3LvJe"};

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"app-pages-SuccessResetPassword-__style___E5TB-","desc-title":"app-pages-SuccessResetPassword-__style___1ovTN","btn-login":"app-pages-SuccessResetPassword-__style___3Mbsd"};

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"invalid-message":"app-pages-VerifyEmail-__VerifyEmail___2B-Vj"};

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"success-message":"app-pages-VerifyEmailAlertRecipient-__VerifyEmailAlertRecipient___vyY9o","invalid-message":"app-pages-VerifyEmailAlertRecipient-__VerifyEmailAlertRecipient___13KOW"};

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2440),
    hashDelete = __webpack_require__(2441),
    hashGet = __webpack_require__(2442),
    hashHas = __webpack_require__(2443),
    hashSet = __webpack_require__(2444);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(137);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(190),
    root = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2392 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2393 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 2394 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2421),
    isArguments = __webpack_require__(546),
    isArray = __webpack_require__(98),
    isBuffer = __webpack_require__(823),
    isIndex = __webpack_require__(543),
    isTypedArray = __webpack_require__(826);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 2396 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(809);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(538),
    arrayIncludes = __webpack_require__(805),
    arrayIncludesWith = __webpack_require__(806),
    arrayMap = __webpack_require__(188),
    baseUnary = __webpack_require__(345),
    cacheHas = __webpack_require__(542);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 2399 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(807),
    isFlattenable = __webpack_require__(2445);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2429);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(2401),
    keys = __webpack_require__(351);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(807),
    isArray = __webpack_require__(98);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 2404 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2399),
    baseIsNaN = __webpack_require__(2410),
    strictIndexOf = __webpack_require__(2476);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(538),
    arrayIncludes = __webpack_require__(805),
    arrayIncludesWith = __webpack_require__(806),
    arrayMap = __webpack_require__(188),
    baseUnary = __webpack_require__(345),
    cacheHas = __webpack_require__(542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(189),
    isObjectLike = __webpack_require__(160);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(804),
    equalArrays = __webpack_require__(815),
    equalByTag = __webpack_require__(2430),
    equalObjects = __webpack_require__(2431),
    getTag = __webpack_require__(2437),
    isArray = __webpack_require__(98),
    isBuffer = __webpack_require__(823),
    isTypedArray = __webpack_require__(826);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(804),
    baseIsEqual = __webpack_require__(539);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2410 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(824),
    isMasked = __webpack_require__(2448),
    isObject = __webpack_require__(350),
    toSource = __webpack_require__(820);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(189),
    isLength = __webpack_require__(548),
    isObjectLike = __webpack_require__(160);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(2449),
    nativeKeys = __webpack_require__(2462);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2409),
    getMatchData = __webpack_require__(2433),
    matchesStrictComparable = __webpack_require__(818);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(539),
    get = __webpack_require__(2479),
    hasIn = __webpack_require__(2480),
    isKey = __webpack_require__(544),
    isStrictComparable = __webpack_require__(817),
    matchesStrictComparable = __webpack_require__(818),
    toKey = __webpack_require__(348);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(188),
    baseIteratee = __webpack_require__(540),
    baseMap = __webpack_require__(811),
    baseSortBy = __webpack_require__(2420),
    baseUnary = __webpack_require__(345),
    compareMultiple = __webpack_require__(2426),
    identity = __webpack_require__(349);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 2417 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(810);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2478),
    defineProperty = __webpack_require__(814),
    identity = __webpack_require__(349);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2420 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 2421 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(266),
    arrayMap = __webpack_require__(188),
    isArray = __webpack_require__(98),
    isSymbol = __webpack_require__(268);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(188);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(822);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(268);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(2425);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(137);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(267);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2429 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(266),
    Uint8Array = __webpack_require__(2390),
    eq = __webpack_require__(545),
    equalArrays = __webpack_require__(815),
    mapToArray = __webpack_require__(2460),
    setToArray = __webpack_require__(2468);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2432);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2403),
    getSymbols = __webpack_require__(2436),
    keys = __webpack_require__(351);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(817),
    keys = __webpack_require__(351);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2434 */,
/* 2435 */,
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2394),
    stubArray = __webpack_require__(2485);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2386),
    Map = __webpack_require__(536),
    Promise = __webpack_require__(2388),
    Set = __webpack_require__(2389),
    WeakMap = __webpack_require__(2391),
    baseGetTag = __webpack_require__(189),
    toSource = __webpack_require__(820);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 2438 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(812),
    isArguments = __webpack_require__(546),
    isArray = __webpack_require__(98),
    isIndex = __webpack_require__(543),
    isLength = __webpack_require__(548),
    toKey = __webpack_require__(348);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(347);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2441 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(347);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(347);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(347);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(266),
    isArguments = __webpack_require__(546),
    isArray = __webpack_require__(98);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(545),
    isArrayLike = __webpack_require__(267),
    isIndex = __webpack_require__(543),
    isObject = __webpack_require__(350);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2447 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2427);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2449 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 2450 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(344);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(344);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(344);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(344);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2387),
    ListCache = __webpack_require__(343),
    Map = __webpack_require__(536);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(346);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(346);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(346);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(346);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2460 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2483);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(819);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(816);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(165)(module)))

/***/ }),
/* 2464 */,
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2392);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2466 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2467 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2468 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2419),
    shortOut = __webpack_require__(2470);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2470 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(343);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2472 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2473 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2474 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(343),
    Map = __webpack_require__(536),
    MapCache = __webpack_require__(537);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2476 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2461);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2478 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(810);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2404),
    hasPath = __webpack_require__(2439);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(188),
    baseIntersection = __webpack_require__(2406),
    baseRest = __webpack_require__(541),
    castArrayLikeObject = __webpack_require__(2424);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2482 */,
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(537);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2417),
    basePropertyDeep = __webpack_require__(2418),
    isKey = __webpack_require__(544),
    toKey = __webpack_require__(348);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2485 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 2486 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2422);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(67);

var focusNode = __webpack_require__(891);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(275);
var ExecutionEnvironment = __webpack_require__(74);
var FallbackCompositionState = __webpack_require__(2605);
var SyntheticCompositionEvent = __webpack_require__(2646);
var SyntheticInputEvent = __webpack_require__(2649);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(866);
var ExecutionEnvironment = __webpack_require__(74);
var ReactInstrumentation = __webpack_require__(111);

var camelizeStyleName = __webpack_require__(2665);
var dangerousStyleValue = __webpack_require__(2656);
var hyphenateStyleName = __webpack_require__(2672);
var memoizeStringOnly = __webpack_require__(2675);
var warning = __webpack_require__(52);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (true) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
     true ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
     true ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
     true ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
     true ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (true) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (true) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (true) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(274);
var EventPropagators = __webpack_require__(275);
var ExecutionEnvironment = __webpack_require__(74);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactUpdates = __webpack_require__(140);
var SyntheticEvent = __webpack_require__(141);

var inputValueTracking = __webpack_require__(883);
var getEventTarget = __webpack_require__(570);
var isEventSupported = __webpack_require__(571);
var isTextInputElement = __webpack_require__(885);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var DOMLazyTree = __webpack_require__(272);
var ExecutionEnvironment = __webpack_require__(74);

var createNodesFromMarkup = __webpack_require__(2668);
var emptyFunction = __webpack_require__(142);
var invariant = __webpack_require__(35);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(275);
var ReactDOMComponentTree = __webpack_require__(67);
var SyntheticMouseEvent = __webpack_require__(359);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var PooledClass = __webpack_require__(193);

var getTextContentAccessor = __webpack_require__(882);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(273);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(276);

var instantiateReactComponent = __webpack_require__(884);
var KeyEscapeUtils = __webpack_require__(561);
var shouldUpdateReactComponent = __webpack_require__(887);
var traverseAllChildren = __webpack_require__(888);
var warning = __webpack_require__(52);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "development" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (true) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = __webpack_require__(123);
    }
    if (!keyUnique) {
       true ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (true) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(557);
var ReactDOMIDOperations = __webpack_require__(2613);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var React = __webpack_require__(280);
var ReactComponentEnvironment = __webpack_require__(564);
var ReactCurrentOwner = __webpack_require__(163);
var ReactErrorUtils = __webpack_require__(565);
var ReactInstanceMap = __webpack_require__(566);
var ReactInstrumentation = __webpack_require__(111);
var ReactNodeTypes = __webpack_require__(2631);
var ReactReconciler = __webpack_require__(276);

if (true) {
  var checkReactTypeSpec = __webpack_require__(2655);
}

var emptyObject = __webpack_require__(890);
var invariant = __webpack_require__(35);
var shallowEqual = __webpack_require__(574);
var shouldUpdateReactComponent = __webpack_require__(887);
var warning = __webpack_require__(52);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (true) {
     true ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
     true ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (true) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  true ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (true) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
         true ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

       true ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (true) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
       true ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
       true ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
       true ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
       true ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
       true ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
       true ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
       true ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  true ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (true) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (true) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (true) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (true) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (true) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (true) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (true) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (true) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (true) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (true) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  true ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (true) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  true ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (true) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  true ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (true) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (true) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (true) {
       true ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (true) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (true) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (true) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (true) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (true) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (true) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if (true) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  true ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  true ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (true) {
      var componentName = component && component.getName ? component.getName() : 'a component';
       true ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var AutoFocusUtils = __webpack_require__(2598);
var CSSPropertyOperations = __webpack_require__(2600);
var DOMLazyTree = __webpack_require__(272);
var DOMNamespaces = __webpack_require__(558);
var DOMProperty = __webpack_require__(273);
var DOMPropertyOperations = __webpack_require__(868);
var EventPluginHub = __webpack_require__(274);
var EventPluginRegistry = __webpack_require__(559);
var ReactBrowserEventEmitter = __webpack_require__(563);
var ReactDOMComponentFlags = __webpack_require__(869);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactDOMInput = __webpack_require__(2614);
var ReactDOMOption = __webpack_require__(2615);
var ReactDOMSelect = __webpack_require__(870);
var ReactDOMTextarea = __webpack_require__(2619);
var ReactInstrumentation = __webpack_require__(111);
var ReactMultiChild = __webpack_require__(2630);
var ReactServerRenderingTransaction = __webpack_require__(877);

var emptyFunction = __webpack_require__(142);
var escapeTextContentForBrowser = __webpack_require__(361);
var invariant = __webpack_require__(35);
var isEventSupported = __webpack_require__(571);
var shallowEqual = __webpack_require__(574);
var inputValueTracking = __webpack_require__(883);
var validateDOMNesting = __webpack_require__(573);
var warning = __webpack_require__(52);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   true ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  true ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  true ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  true ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (true) {
     true ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
     true ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
     true ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  true ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (true) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
     true ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (true) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  true ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  true ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  true ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (true) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (true) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (true) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (true) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (true) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (true) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (true) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (true) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (true) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (true) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  true ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (true) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(573);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (true) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var DOMLazyTree = __webpack_require__(272);
var ReactDOMComponentTree = __webpack_require__(67);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(557);
var ReactDOMComponentTree = __webpack_require__(67);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var DOMPropertyOperations = __webpack_require__(868);
var LinkedValueUtils = __webpack_require__(562);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactUpdates = __webpack_require__(140);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (true) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
         true ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
         true ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
         true ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
         true ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (true) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
         true ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
         true ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  true ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var React = __webpack_require__(280);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactDOMSelect = __webpack_require__(870);

var warning = __webpack_require__(52);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       true ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (true) {
       true ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);

var getNodeForCharacterOffset = __webpack_require__(2660);
var getTextContentAccessor = __webpack_require__(882);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDefaultInjection = __webpack_require__(2621);
var ReactServerRendering = __webpack_require__(2638);
var ReactVersion = __webpack_require__(2640);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var DOMChildrenOperations = __webpack_require__(557);
var DOMLazyTree = __webpack_require__(272);
var ReactDOMComponentTree = __webpack_require__(67);

var escapeTextContentForBrowser = __webpack_require__(361);
var invariant = __webpack_require__(35);
var validateDOMNesting = __webpack_require__(573);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (true) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  true ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41),
    _assign = __webpack_require__(44);

var LinkedValueUtils = __webpack_require__(562);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactUpdates = __webpack_require__(140);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  true ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (true) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
         true ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
         true ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (true) {
           true ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  true ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  true ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  true ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  true ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  true ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(2597);
var BeforeInputEventPlugin = __webpack_require__(2599);
var ChangeEventPlugin = __webpack_require__(2601);
var DefaultEventPluginOrder = __webpack_require__(2603);
var EnterLeaveEventPlugin = __webpack_require__(2604);
var HTMLDOMPropertyConfig = __webpack_require__(2606);
var ReactComponentBrowserEnvironment = __webpack_require__(2608);
var ReactDOMComponent = __webpack_require__(2610);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactDOMEmptyComponent = __webpack_require__(2612);
var ReactDOMTreeTraversal = __webpack_require__(2620);
var ReactDOMTextComponent = __webpack_require__(2618);
var ReactDefaultBatchingStrategy = __webpack_require__(872);
var ReactEventListener = __webpack_require__(2624);
var ReactInjection = __webpack_require__(2627);
var ReactReconcileTransaction = __webpack_require__(2635);
var SVGDOMPropertyConfig = __webpack_require__(2641);
var SelectEventPlugin = __webpack_require__(2642);
var SimpleEventPlugin = __webpack_require__(2643);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(274);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var EventListener = __webpack_require__(889);
var ExecutionEnvironment = __webpack_require__(74);
var PooledClass = __webpack_require__(193);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactUpdates = __webpack_require__(140);

var getEventTarget = __webpack_require__(570);
var getUnboundedScrollPosition = __webpack_require__(2670);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var history = [];

var ReactHostOperationHistoryHook = {
  onHostOperation: function (operation) {
    history.push(operation);
  },
  clearHistory: function () {
    if (ReactHostOperationHistoryHook._preventClearing) {
      // Should only be used for tests.
      return;
    }

    history = [];
  },
  getHistory: function () {
    return history;
  }
};

module.exports = ReactHostOperationHistoryHook;

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(273);
var EventPluginHub = __webpack_require__(274);
var EventPluginUtils = __webpack_require__(560);
var ReactComponentEnvironment = __webpack_require__(564);
var ReactEmptyComponent = __webpack_require__(873);
var ReactBrowserEventEmitter = __webpack_require__(563);
var ReactHostComponent = __webpack_require__(874);
var ReactUpdates = __webpack_require__(140);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var warning = __webpack_require__(52);

if (true) {
  var processingChildContext = false;

  var warnInvalidSetState = function () {
     true ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
  };
}

var ReactInvalidSetStateWarningHook = {
  onBeginProcessingChildContext: function () {
    processingChildContext = true;
  },
  onEndProcessingChildContext: function () {
    processingChildContext = false;
  },
  onSetState: function () {
    warnInvalidSetState();
  }
};

module.exports = ReactInvalidSetStateWarningHook;

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(2654);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactComponentEnvironment = __webpack_require__(564);
var ReactInstanceMap = __webpack_require__(566);
var ReactInstrumentation = __webpack_require__(111);

var ReactCurrentOwner = __webpack_require__(163);
var ReactReconciler = __webpack_require__(276);
var ReactChildReconciler = __webpack_require__(2607);

var emptyFunction = __webpack_require__(142);
var flattenChildren = __webpack_require__(2657);
var invariant = __webpack_require__(35);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (true) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (true) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (true) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (true) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (true) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  true ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  true ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (true) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var React = __webpack_require__(280);

var invariant = __webpack_require__(35);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  true ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var invariant = __webpack_require__(35);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  true ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  true ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ReactDebugTool = __webpack_require__(871);
var lowPriorityWarning = __webpack_require__(2662);
var alreadyWarned = false;

function roundFloat(val) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var n = Math.pow(10, base);
  return Math.floor(val * n) / n;
}

// Flow type definition of console.table is too strict right now, see
// https://github.com/facebook/flow/pull/2353 for updates
function consoleTable(table) {
  console.table(table);
}

function warnInProduction() {
  if (alreadyWarned) {
    return;
  }
  alreadyWarned = true;
  if (typeof console !== 'undefined') {
    console.error('ReactPerf is not supported in the production builds of React. ' + 'To collect measurements, please use the development build of React instead.');
  }
}

function getLastMeasurements() {
  if (false) {
    warnInProduction();
    return [];
  }

  return ReactDebugTool.getFlushHistory();
}

function getExclusive() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (false) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, timerType, applyUpdate) {
    var displayName = treeSnapshot[instanceID].displayName;

    var key = displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        counts: {},
        durations: {},
        totalDuration: 0
      };
    }
    if (!stats.durations[timerType]) {
      stats.durations[timerType] = 0;
    }
    if (!stats.counts[timerType]) {
      stats.counts[timerType] = 0;
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot;

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      updateAggregatedStats(treeSnapshot, instanceID, timerType, function (stats) {
        stats.totalDuration += duration;
        stats.durations[timerType] += duration;
        stats.counts[timerType]++;
      });
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.totalDuration - a.totalDuration;
  });
}

function getInclusive() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (false) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
    var _treeSnapshot$instanc = treeSnapshot[instanceID],
        displayName = _treeSnapshot$instanc.displayName,
        ownerID = _treeSnapshot$instanc.ownerID;

    var owner = treeSnapshot[ownerID];
    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        inclusiveRenderDuration: 0,
        renderCount: 0
      };
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  var isCompositeByID = {};
  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements;

    measurements.forEach(function (measurement) {
      var instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      isCompositeByID[instanceID] = true;
    });
  });

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot;

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
        stats.renderCount++;
      });
      var nextParentID = instanceID;
      while (nextParentID) {
        // As we traverse parents, only count inclusive time towards composites.
        // We know something is a composite if its render() was called.
        if (isCompositeByID[nextParentID]) {
          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
            stats.inclusiveRenderDuration += duration;
          });
        }
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
  });
}

function getWasted() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (false) {
    warnInProduction();
    return [];
  }

  var aggregatedStats = {};
  var affectedIDs = {};

  function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
    var _treeSnapshot$instanc2 = treeSnapshot[instanceID],
        displayName = _treeSnapshot$instanc2.displayName,
        ownerID = _treeSnapshot$instanc2.ownerID;

    var owner = treeSnapshot[ownerID];
    var key = (owner ? owner.displayName + ' > ' : '') + displayName;
    var stats = aggregatedStats[key];
    if (!stats) {
      affectedIDs[key] = {};
      stats = aggregatedStats[key] = {
        key: key,
        instanceCount: 0,
        inclusiveRenderDuration: 0,
        renderCount: 0
      };
    }
    affectedIDs[key][instanceID] = true;
    applyUpdate(stats);
  }

  flushHistory.forEach(function (flush) {
    var measurements = flush.measurements,
        treeSnapshot = flush.treeSnapshot,
        operations = flush.operations;

    var isDefinitelyNotWastedByID = {};

    // Find host components associated with an operation in this batch.
    // Mark all components in their parent tree as definitely not wasted.
    operations.forEach(function (operation) {
      var instanceID = operation.instanceID;

      var nextParentID = instanceID;
      while (nextParentID) {
        isDefinitelyNotWastedByID[nextParentID] = true;
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });

    // Find composite components that rendered in this batch.
    // These are potential candidates for being wasted renders.
    var renderedCompositeIDs = {};
    measurements.forEach(function (measurement) {
      var instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }
      renderedCompositeIDs[instanceID] = true;
    });

    measurements.forEach(function (measurement) {
      var duration = measurement.duration,
          instanceID = measurement.instanceID,
          timerType = measurement.timerType;

      if (timerType !== 'render') {
        return;
      }

      // If there was a DOM update below this component, or it has just been
      // mounted, its render() is not considered wasted.
      var updateCount = treeSnapshot[instanceID].updateCount;

      if (isDefinitelyNotWastedByID[instanceID] || updateCount === 0) {
        return;
      }

      // We consider this render() wasted.
      updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
        stats.renderCount++;
      });

      var nextParentID = instanceID;
      while (nextParentID) {
        // Any parents rendered during this batch are considered wasted
        // unless we previously marked them as dirty.
        var isWasted = renderedCompositeIDs[nextParentID] && !isDefinitelyNotWastedByID[nextParentID];
        if (isWasted) {
          updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
            stats.inclusiveRenderDuration += duration;
          });
        }
        nextParentID = treeSnapshot[nextParentID].parentID;
      }
    });
  });

  return Object.keys(aggregatedStats).map(function (key) {
    return _extends({}, aggregatedStats[key], {
      instanceCount: Object.keys(affectedIDs[key]).length
    });
  }).sort(function (a, b) {
    return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
  });
}

function getOperations() {
  var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

  if (false) {
    warnInProduction();
    return [];
  }

  var stats = [];
  flushHistory.forEach(function (flush, flushIndex) {
    var operations = flush.operations,
        treeSnapshot = flush.treeSnapshot;

    operations.forEach(function (operation) {
      var instanceID = operation.instanceID,
          type = operation.type,
          payload = operation.payload;
      var _treeSnapshot$instanc3 = treeSnapshot[instanceID],
          displayName = _treeSnapshot$instanc3.displayName,
          ownerID = _treeSnapshot$instanc3.ownerID;

      var owner = treeSnapshot[ownerID];
      var key = (owner ? owner.displayName + ' > ' : '') + displayName;

      stats.push({
        flushIndex: flushIndex,
        instanceID: instanceID,
        key: key,
        type: type,
        ownerID: ownerID,
        payload: payload
      });
    });
  });
  return stats;
}

function printExclusive(flushHistory) {
  if (false) {
    warnInProduction();
    return;
  }

  var stats = getExclusive(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        totalDuration = item.totalDuration;

    var renderCount = item.counts.render || 0;
    var renderDuration = item.durations.render || 0;
    return {
      Component: key,
      'Total time (ms)': roundFloat(totalDuration),
      'Instance count': instanceCount,
      'Total render time (ms)': roundFloat(renderDuration),
      'Average render time (ms)': renderCount ? roundFloat(renderDuration / renderCount) : undefined,
      'Render count': renderCount,
      'Total lifecycle time (ms)': roundFloat(totalDuration - renderDuration)
    };
  });
  consoleTable(table);
}

function printInclusive(flushHistory) {
  if (false) {
    warnInProduction();
    return;
  }

  var stats = getInclusive(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        inclusiveRenderDuration = item.inclusiveRenderDuration,
        renderCount = item.renderCount;

    return {
      'Owner > Component': key,
      'Inclusive render time (ms)': roundFloat(inclusiveRenderDuration),
      'Instance count': instanceCount,
      'Render count': renderCount
    };
  });
  consoleTable(table);
}

function printWasted(flushHistory) {
  if (false) {
    warnInProduction();
    return;
  }

  var stats = getWasted(flushHistory);
  var table = stats.map(function (item) {
    var key = item.key,
        instanceCount = item.instanceCount,
        inclusiveRenderDuration = item.inclusiveRenderDuration,
        renderCount = item.renderCount;

    return {
      'Owner > Component': key,
      'Inclusive wasted time (ms)': roundFloat(inclusiveRenderDuration),
      'Instance count': instanceCount,
      'Render count': renderCount
    };
  });
  consoleTable(table);
}

function printOperations(flushHistory) {
  if (false) {
    warnInProduction();
    return;
  }

  var stats = getOperations(flushHistory);
  var table = stats.map(function (stat) {
    return {
      'Owner > Node': stat.key,
      Operation: stat.type,
      Payload: typeof stat.payload === 'object' ? JSON.stringify(stat.payload) : stat.payload,
      'Flush index': stat.flushIndex,
      'Owner Component ID': stat.ownerID,
      'DOM Component ID': stat.instanceID
    };
  });
  consoleTable(table);
}

var warnedAboutPrintDOM = false;
function printDOM(measurements) {
  lowPriorityWarning(warnedAboutPrintDOM, '`ReactPerf.printDOM(...)` is deprecated. Use ' + '`ReactPerf.printOperations(...)` instead.');
  warnedAboutPrintDOM = true;
  return printOperations(measurements);
}

var warnedAboutGetMeasurementsSummaryMap = false;
function getMeasurementsSummaryMap(measurements) {
  lowPriorityWarning(warnedAboutGetMeasurementsSummaryMap, '`ReactPerf.getMeasurementsSummaryMap(...)` is deprecated. Use ' + '`ReactPerf.getWasted(...)` instead.');
  warnedAboutGetMeasurementsSummaryMap = true;
  return getWasted(measurements);
}

function start() {
  if (false) {
    warnInProduction();
    return;
  }

  ReactDebugTool.beginProfiling();
}

function stop() {
  if (false) {
    warnInProduction();
    return;
  }

  ReactDebugTool.endProfiling();
}

function isRunning() {
  if (false) {
    warnInProduction();
    return false;
  }

  return ReactDebugTool.isProfiling();
}

var ReactPerfAnalysis = {
  getLastMeasurements: getLastMeasurements,
  getExclusive: getExclusive,
  getInclusive: getInclusive,
  getWasted: getWasted,
  getOperations: getOperations,
  printExclusive: printExclusive,
  printInclusive: printInclusive,
  printWasted: printWasted,
  printOperations: printOperations,
  start: start,
  stop: stop,
  isRunning: isRunning,
  // Deprecated:
  printDOM: printDOM,
  getMeasurementsSummaryMap: getMeasurementsSummaryMap
};

module.exports = ReactPerfAnalysis;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (true) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var CallbackQueue = __webpack_require__(867);
var PooledClass = __webpack_require__(193);
var ReactBrowserEventEmitter = __webpack_require__(563);
var ReactInputSelection = __webpack_require__(875);
var ReactInstrumentation = __webpack_require__(111);
var Transaction = __webpack_require__(360);
var ReactUpdateQueue = __webpack_require__(878);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (true) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(2632);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(41);

var React = __webpack_require__(280);
var ReactDOMContainerInfo = __webpack_require__(2611);
var ReactDefaultBatchingStrategy = __webpack_require__(872);
var ReactInstrumentation = __webpack_require__(111);
var ReactMarkupChecksum = __webpack_require__(2629);
var ReactReconciler = __webpack_require__(276);
var ReactServerBatchingStrategy = __webpack_require__(2637);
var ReactServerRenderingTransaction = __webpack_require__(877);
var ReactUpdates = __webpack_require__(140);

var emptyObject = __webpack_require__(890);
var instantiateReactComponent = __webpack_require__(884);
var invariant = __webpack_require__(35);

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (true) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  true ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  true ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(878);

var warning = __webpack_require__(52);

function warnNoop(publicInstance, callerName) {
  if (true) {
    var constructor = publicInstance.constructor;
     true ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(275);
var ExecutionEnvironment = __webpack_require__(74);
var ReactDOMComponentTree = __webpack_require__(67);
var ReactInputSelection = __webpack_require__(875);
var SyntheticEvent = __webpack_require__(141);

var getActiveElement = __webpack_require__(892);
var isTextInputElement = __webpack_require__(885);
var shallowEqual = __webpack_require__(574);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(41);

var EventListener = __webpack_require__(889);
var EventPropagators = __webpack_require__(275);
var ReactDOMComponentTree = __webpack_require__(67);
var SyntheticAnimationEvent = __webpack_require__(2644);
var SyntheticClipboardEvent = __webpack_require__(2645);
var SyntheticEvent = __webpack_require__(141);
var SyntheticFocusEvent = __webpack_require__(2648);
var SyntheticKeyboardEvent = __webpack_require__(2650);
var SyntheticMouseEvent = __webpack_require__(359);
var SyntheticDragEvent = __webpack_require__(2647);
var SyntheticTouchEvent = __webpack_require__(2651);
var SyntheticTransitionEvent = __webpack_require__(2652);
var SyntheticUIEvent = __webpack_require__(277);
var SyntheticWheelEvent = __webpack_require__(2653);

var emptyFunction = __webpack_require__(142);
var getEventCharCode = __webpack_require__(568);
var invariant = __webpack_require__(35);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  true ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(359);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(277);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(277);

var getEventCharCode = __webpack_require__(568);
var getEventKey = __webpack_require__(2658);
var getEventModifierState = __webpack_require__(569);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(277);

var getEventModifierState = __webpack_require__(569);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(141);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(359);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(41);

var ReactPropTypeLocationNames = __webpack_require__(2634);
var ReactPropTypesSecret = __webpack_require__(876);

var invariant = __webpack_require__(35);
var warning = __webpack_require__(52);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "development" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

var loggedTypeFailures = {};

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?object} element The React element that is being type-checked
 * @param {?number} debugID The React component instance that is being type-checked
 * @private
 */
function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
  for (var typeSpecName in typeSpecs) {
    if (typeSpecs.hasOwnProperty(typeSpecName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof typeSpecs[typeSpecName] === 'function') ?  true ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
      } catch (ex) {
        error = ex;
      }
       true ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var componentStackInfo = '';

        if (true) {
          if (!ReactComponentTreeHook) {
            ReactComponentTreeHook = __webpack_require__(123);
          }
          if (debugID !== null) {
            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
          } else if (element !== null) {
            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
          }
        }

         true ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
      }
    }
  }
}

module.exports = checkReactTypeSpec;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(866);
var warning = __webpack_require__(52);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (true) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
           true ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(561);
var traverseAllChildren = __webpack_require__(888);
var warning = __webpack_require__(52);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "development" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (true) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = __webpack_require__(123);
      }
      if (!keyUnique) {
         true ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (true) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(568);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(74);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (true) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(361);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(2664);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(2674);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(35);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  true ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  true ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  true ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  true ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(74);

var createArrayFromMixed = __webpack_require__(2667);
var getMarkupWrap = __webpack_require__(2669);
var invariant = __webpack_require__(35);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  true ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  true ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(74);

var invariant = __webpack_require__(35);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  true ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(2671);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(2673);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var ExecutionEnvironment = __webpack_require__(74);

var performance;

if (ExecutionEnvironment.canUseDOM) {
  performance = window.performance || window.msPerformance || window.webkitPerformance;
}

module.exports = performance || {};

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var performance = __webpack_require__(2676);

var performanceNow;

/**
 * Detect if we can use `window.performance.now()` and gracefully fallback to
 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
 * because of Facebook's testing infrastructure.
 */
if (performance.now) {
  performanceNow = function performanceNow() {
    return performance.now();
  };
} else {
  performanceNow = function performanceNow() {
    return Date.now();
  };
}

module.exports = performanceNow;

/***/ }),
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(223);

var invariant = __webpack_require__(195);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  true ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(2734);
var ReactElement = __webpack_require__(194);

var emptyFunction = __webpack_require__(919);
var traverseAllChildren = __webpack_require__(2745);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(194);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (true) {
  var ReactElementValidator = __webpack_require__(916);
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (true) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(194),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(840);

module.exports = factory(isValidElement);

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(223);

var ReactPropTypeLocationNames = __webpack_require__(2737);
var ReactPropTypesSecret = __webpack_require__(2739);

var invariant = __webpack_require__(195);
var warning = __webpack_require__(196);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "development" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(123);
}

var loggedTypeFailures = {};

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?object} element The React element that is being type-checked
 * @param {?number} debugID The React component instance that is being type-checked
 * @private
 */
function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
  for (var typeSpecName in typeSpecs) {
    if (typeSpecs.hasOwnProperty(typeSpecName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof typeSpecs[typeSpecName] === 'function') ?  true ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
      } catch (ex) {
        error = ex;
      }
       true ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var componentStackInfo = '';

        if (true) {
          if (!ReactComponentTreeHook) {
            ReactComponentTreeHook = __webpack_require__(123);
          }
          if (debugID !== null) {
            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
          } else if (element !== null) {
            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
          }
        }

         true ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
      }
    }
  }
}

module.exports = checkReactTypeSpec;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(914),
    Component = _require.Component;

var _require2 = __webpack_require__(194),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(917);
var factory = __webpack_require__(2746);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(223);

var ReactElement = __webpack_require__(194);

var invariant = __webpack_require__(195);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  true ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(223);

var ReactCurrentOwner = __webpack_require__(163);
var REACT_ELEMENT_TYPE = __webpack_require__(915);

var getIteratorFn = __webpack_require__(918);
var invariant = __webpack_require__(195);
var KeyEscapeUtils = __webpack_require__(2733);
var warning = __webpack_require__(196);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (true) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
           true ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (true) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  true ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(44);

var emptyObject = __webpack_require__(920);
var _invariant = __webpack_require__(195);

if (true) {
  var warning = __webpack_require__(196);
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (true) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (true) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (true) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (true) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (true) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (true) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (true) {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (true) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (true) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (true) {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (true) {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (true) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (true) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (true) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (true) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (true) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(944);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47ed0f0c93061e87750eca5b2d17fd29.png";

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e6999f994cb04982ff5b23a3b4120a7.png";

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3fb08608bd4fa8855cc146441e5a7df1.png";

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fca035a90399f89dea7deb1872f3e9ae.png";

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13e061a91df9d243cd799a7632358013.png";

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7799be18d9afb717ce2dbacb07ee915.png";

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97e13b64e67583b61d335d9d9e67b21f.png";

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d0966b54111bb6f10e80b434488a65e0.png";

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5233158ba15908ca6df29d16e791dfa2.png";

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c2b97a84f32ab43f45ff958f84c0b4c7.png";

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b0540189a143a2fd19b1b3579c68efd8.png";

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16aa5ef7c64ba706ac4052329e359194.png";

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec2c4786f3dba9acf07ceba3c1081a49.png";

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce93d7e554f0424f180ccdfa6a5d4dc7.png";

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3da2f2736652f29e97431d28712c9d8c.png";

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b765ec173cdc9fff4751fc42491aaa95.png";

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da12cd7e9e480d19466635d8a7f8505c.png";

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5b30bb88c202396692fc3aae4f86c4f.png";

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "40225832184b48ec8d8bf3960d0f0489.png";

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "693902abd044e5476f4bc089ec4f5bdd.png";

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5212766902618fa76e8056129ed2e86.svg";

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5212766902618fa76e8056129ed2e86.svg";

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef648d72fad8326f75a5a603cf6545c5.svg";

/***/ })
],[1202]);


// WEBPACK FOOTER //
// js/app-81d5d42-0f9c556efa1dfe853464.js